/* DRIVE IQ â€” ADVENTURE MODE JS V534 DESTINATION INTERACTION AUTHORITY
   Asset file name: drive-iq-adventure-mode.js
   V531: Retires legacy results pills and card interception, hands result restoration and place selection to V600 modules, and guarantees the legacy scan banner releases after committed results.
   V54: Commits resolved Google/Street View photo URLs directly into the card gallery and render layer, allows Google Street View Static URLs as real-world visuals, and forces trusted Google photo URLs to paint without being rejected by the older image filter.
   V53: Exposes raw Google photo payload when ID:YES / Photos:1 / URL:NO appears, rebuilds media URLs from every known Places New photo field, and adds direct Street View fallback from the Places New resolver so the card stops staying on satellite fallback.
   V51: Broadens Google Places candidate resolution when Text Search/Nearby show candidates:0, adds city/category query expansion, accepts close category/name matches, persists IDs, and exposes V51 candidate diagnostics.
   V50: Fixes the ID:YES / Photos:1 / URL:NO layer by normalizing Places New IDs, building the correct Places media URL from photo.name, trying Places New before legacy JS once an ID exists, and adding a short retry lock to stop card twitching.
   V49: Adds Places New Nearby Photo Rescue when Text Search returns candidates:0. Uses category-aware nearby search around the card pin, accepts closest photo-backed Google places, persists the ID, and renders direct candidate photos before fallback.
   V48: Makes Google Places New candidate payload visible, prioritizes the New resolver before legacy JS, captures id/name resource fields from candidates, and builds photo URLs directly from candidate photos before fallback.
   V47: Hardens the final Photo IQ handoff: normalizes Google Places New IDs, accepts photo-backed candidates, persists both ChIJ/resource IDs, returns direct candidate photos before Details, and adds candidate accept/reject diagnostics.
   V46: Fixes the remaining ID:NO / Photos:1 / URL:NO case by accepting high-confidence Google photo candidates, writing the accepted Google place id back onto the item, and exposing resolver match diagnostics.
   V45: Prioritizes legacy Google Places JS photo getUrl rescue, accepts nearest photo-backed matches when exact text matching is weak, strengthens Places New photo.name/photoUri extraction, and makes Photo Debug distinguish fallback/map photos from real Google photo candidates.
   V44: Rescues live Google photo URL handoff when Photos:1 / URL:NO appears by trying direct references first and exposing all-source failures.
   V43: Dials in Google Places New photo handoff with explicit photo.name field masks, deep photo object extraction, and live media URL hydration.
   V42: Converts Google Places photo.name/photo resources into live media URLs and adds aggressive text-search photo fallback.
   V41: Finishes the Google photo URL handoff: rejects non-image attribution URLs, keeps Google photo media URLs trusted, forces resolved Google photo URLs into the gallery before fallback art, and upgrades Photo Debug IQ with URL/load status. Photo URL/render handoff layer only.
   V40: Adds Google Key Bridge IQ so Photo IQ can find a Google/Places key from every likely window alias, config object, meta tag, script tag, dataset, or storage key; exposes window.DIQ_GOOGLE_KEY as the single authority and shows key source in debug. Photo key/bootstrap layer only.
   V39: Adds visible Photo Debug IQ diagnostics to each Place IQ card so we can see whether the photo pipeline is breaking at API key, Places library, Place ID, Details, photo count, URL, image load, or fallback. Debug layer only.
   V38: Adds image-load verification before labeling a card as a real PLACE PHOTO, hides fake photo chips on failed URLs, and falls back to premium category art instead of blank hero panels. Photo/render layer only.
   V37: Adds scan-list photo hydration, visible thumbnail repaint, stronger Google key aliases, and last-mile photo pull-through so Adventure cards can upgrade from category art to real Google/venue photos after render. Photo layer only.
   V36: Fixes final Google photo render handoff: explicitly allows Places API (New) media URLs, stops HTML-escaping URLs inside CSS background-image styles, preserves Google photo resource paths without encodeURI path breakage, and keeps photo chips honest by only treating true image URLs as real photos. Photo/render layer only.
   V35: Adds Google Places API (New) REST photo pipeline: Text Search (New) with photos field mask, Place Details (New) by place ID when available, and Place Photos (New) media URLs. Keeps legacy Places JS resolver as fallback. Photo layer only.
   V34: Adds Photo Link Debug IQ and fixes the Google Places loading bridge when Maps is already present without the Places library. Adds visible per-card photo diagnostics so the broken handoff is obvious: key, Places ready, place id, search status, details status, and photo count. Photo layer only.
   V33: Strengthens Photo IQ pull-through with direct Google photo_reference support, more Google key aliases, Place ID extraction, nearby/text/details fallbacks, hidden PlacesService host, and live gallery repaint diagnostics. Photo layer only.
   V32: Adds Google Places JS bootstrap, safer PlacesService container, richer photo-source diagnostics, and stronger fallback repaint so real establishment photos can load when a Google/Photo resolver key is available. Photo layer only.
   V31: Adds asynchronous Photo Pull IQ with optional backend resolver, Google Places JS photo hydration, local photo cache, and live card repaint. Presentation/photo layer only.
   V30: Locks Photo IQ authority, real-photo-first gallery stack, map preview demoted to true last resort, Worth the Drive story chips, and more human decision-confidence copy. Presentation layer only.
   V29: Adds Conversion IQ Place Cards: premium multi-photo gallery, intent-aware hero selection, stronger human recommendation copy, conversion chip stack, and Route Here dominance while leaving scan/ranking/map/route logic untouched.
   ES5-safe. No optional chaining. No arrow functions. No template literals.
   V27.7: Hard-locks Coffee IQ as a true cafÃ©/coffee category, removes breakfast/smoothie leakage, repairs corrupted helper overrides, adds coffee seed rescue, and improves human coffee card copy.\n   V27.5: Dials in Coffee IQ with repaired helper overrides, stronger coffee truth, Coffee Central seed rescue, tighter coffee radius, local cafe/roaster/bakery boosts, and safer chain down-ranking.\n   V27.4: Adds Coffee IQ Broad Pull with Coffee Truth, local cafe/roaster/bakery boosts, soft chain penalty, and distance-safe ranking.\n   V27.3: Adds Local Faves Geography Guard so broad-pull results are hard-filtered around the active scan center and one bad/global result cannot zoom the map out.\n   V27.2: Fixes Local Faves broad-pull finish gate so scans cannot hang when maxLaunch caps the pool count.\n   V27: Adds Broad Pull IQ engine for Local Hangout IQ and FoodIQ: multi-query/category pools, truth filters, scoring, diversity, seed fallback, and Founder Debug stats.\n   V26.8: Adds FoodIQ hard category truth to block retail leaks like Best Buy and adds Southaven Local Hangout seed rescue.\n   V26.7: Wires Local Hangout IQ to Geoapify Places category pools so Local Faves can find real local hangouts instead of relying on literal text search.\n   V26.6: Rebuilds Local Faves as broad local hangout discovery: restaurants, coffee, pickleball, gyms, districts, recreation, and community anchors.\n   V26.3: Adds No Scan Hang IQ so every scan finishes, fixes Local Faves fallback, and prevents endless scanning.\n   V26.2: Adds Recommendation Trust scoring, Category Truth confidence, Local Favorites IQ, adaptive trust filtering, and Founder Debug trace.\n   V26.1: Humanizes Recommended Because, suppresses parking/generic amenities for experience scans, improves Local Favorites/Nightlife confidence, and tightens map-first collapse.\n   V26.0: Adds Trust IQ Recommended Because reasons on Place IQ cards and stronger Local Favorites scoring.\n   V25.9: Adds safe JS-owned My Adventure personalization bar, pinned categories, customize sheet, and Taste IQ hooks.\n   V25.8: Makes "expanding search criteria" real with multi-pass query/radius fallback, Local Favorites hometown trust terms, and big-city zero-result diagnostics.\n   V25.7: Replaces empty-result hard gates with progressive truth tiers and trusted category fallbacks.\n   V25.6: Hard-locks category truth so hotels, worship places, city entities, and generic services cannot leak into experiential scans.\n   V25.5: Gives each scan category its own truth rules, late-night Time IQ, and adaptive cross-category variety.\n   V25.4: Keeps destination scans anchored to the destination area and labels the map rescan by its active category.\n   V25.3: Locks all Place IQ preview entry points to the current browse camera.\n   V25.2: Place IQ Card Phase 1 presentation upgrade only; scan and map foundation frozen.\n   V25.0: Moves Local Map / outdoors helper into the route card so it no longer creates a white bottom overflow bar.\n   V24.8: Restores last destination on return, keeps Show Menu focused on the Adventure menu, and preserves clear-destination flow.
   V24.7: Polishes scan copy, Explore wording, and Food IQ voice labels.
   V24.6: Adds Food IQ intent routing for viral foods, local bites, desserts, BBQ, burgers, tacos, seafood, and first-time food experiences.
   V24: Consolidates Scan Reliability IQ, fixes Lake IQ category hijacking, stabilizes scan state, and improves truthful fallback messaging.
   V23.1: Adds Scan Reliability IQ + Lake IQ fallback expansion.
   V22.2: Adds Live Music Fallback IQ so nightlife scans check bars, breweries, beach bars, waterfront restaurants, and entertainment districts before failing.
   V22.1A: Locks Adventure back button to https://driveiqgps.com.
   V22.1: Adds Destination Lock IQ so the chooser does not reopen after one is selected.
   V22: Adds Experience Relevance IQ, Live Music IQ, retail/beauty blacklist, Venue Confidence, and Pronunciation IQ.
   V21.8: Adds Adventure Scan Voice IQ and auto-collapse after successful scans.
   V21: Adds Freshness IQ, taste-aware ranking, community Drop signals, and map-area rescans.
   Keeps scan results in persistent Map Hero mode while Place IQ cards are previewed.
   V20: Keeps scan results in persistent Map Hero mode until the user restores the menu. Collapses the large panel after scans, shows a compact map-first header, and wires a Show Menu control. Keeps V19 scan zoom and V18 Adventure Drops.
   - Explore Nearby now lives inside the Adventure Horizon card instead of overlapping it.
   - Horizon tiles collapse once a route/destination is ready.
   - Local Adventure Map scans broader outdoor queries around the selected destination.
   - Info card is more compact and does not auto-open after scan.
   - Preserves V5 Local Adventure Map, V4 camping discovery, shell-safe back,
     result pins, route drawing, and Drive Mode handoff.
*/




(function () {
"use strict";

/* V535 â€” Adventure page-entry click-through shield timestamp. */
window.__DIQ_ADVENTURE_PAGE_READY_AT_V535 = Date.now();

/* V530 â€” retire the legacy post-scan shelf stack.
   The base scan engine, map pins, V516 Place IQ handoff, and V518 safe
   selection remain active. These retired modules only recreate, reopen,
   resize, or intercept taps inside the obsolete results shelf. */
window.__DRIVE_IQ_ADVENTURE_V519_SINGLE_RESULTS_SHELF__ = true;
window.__DRIVE_IQ_ADVENTURE_V520_DIRECT_CARD_HANDOFF__ = true;
window.__DRIVE_IQ_ADVENTURE_V521_SCAN_UNLOCK__ = true;
window.__DRIVE_IQ_ADVENTURE_V522_CARD_MAP_AUTHORITY__ = true;
window.__DRIVE_IQ_ADVENTURE_V523_ALWAYS_VISIBLE_MINIMIZE__ = true;
window.__DRIVE_IQ_ADVENTURE_V524_HARD_MINIMIZE_AUTHORITY__ = true;
window.__DRIVE_IQ_ADVENTURE_V525_COMPACT_SHELF__ = true;
window.__DRIVE_IQ_ADVENTURE_V526_ROUTE_MAP_FIX__ = true;

/* V530 â€” card taps may preview only.
   Capture before legacy document/card handlers can route, reload, close the
   WebView, or execute two different selection paths for one physical tap. */
(function(){
  var lastAt=0;
  var lastKey="";

  function cardFrom(target){
    var node=target;
    while(node && node!==document){
      if(node.nodeType===1 && node.classList &&
         (
           (node.classList.contains("diqDestItem") && node.hasAttribute("data-adv-idx")) ||
           node.classList.contains("diqV519Card")
         )){
        return node;
      }
      node=node.parentNode;
    }
    return null;
  }

  function resultItems(){
    try{
      if(typeof adventureResults!=="undefined" && adventureResults && adventureResults.length){
        return adventureResults;
      }
    }catch(e0){}
    try{
      if(typeof exploreResults!=="undefined" && exploreResults && exploreResults.length){
        return exploreResults;
      }
    }catch(e1){}
    try{
      if(typeof destinationSearchResults!=="undefined" &&
         destinationSearchResults && destinationSearchResults.length){
        return destinationSearchResults;
      }
    }catch(e2){}
    return [];
  }

  function resolve(card){
    var items=resultItems();
    var raw=card.getAttribute("data-adv-idx");
    var idx=Number(raw);
    var nameNode;
    var label="";
    var i;
    var itemLabel;

    if((raw===null || raw==="") && card.hasAttribute("data-dest-idx")){
      idx=Number(card.getAttribute("data-dest-idx"));
    }
    if(isFinite(idx) && idx>=0 && items[idx]){ return items[idx]; }

    try{
      nameNode=card.querySelector(".diqDestName");
      label=String(nameNode && nameNode.textContent || "")
        .toLowerCase().replace(/\s+/g," ").trim();
    }catch(e0){}
    if(!label){ return null; }

    for(i=0;i<items.length;i++){
      itemLabel=String(items[i] && (items[i].label || items[i].name) || "")
        .toLowerCase().replace(/\s+/g," ").trim();
      if(itemLabel===label){ return items[i]; }
    }
    return null;
  }

  function stop(event){
    if(event.preventDefault){ event.preventDefault(); }
    if(event.stopPropagation){ event.stopPropagation(); }
    if(event.stopImmediatePropagation){ event.stopImmediatePropagation(); }
  }

  function handle(event){
    var card=cardFrom(event.target);
    var item;
    var key;
    var now;

    if(!card){ return; }

    item=resolve(card);
    stop(event);
    if(!item){ return false; }

    key=String(item.placeId || item.place_id || item.googlePlaceId ||
      item.label || item.name || "") + "|" +
      String(item.lat || "") + "|" + String(item.lng || "");
    now=Date.now ? Date.now() : (new Date()).getTime();
    if(key===lastKey && now-lastAt<700){ return false; }
    lastKey=key;
    lastAt=now;

    try{
      window.__driveIQAdventureSelectedPreview=item;
      localStorage.setItem("diq_adventure_selected_place_v1",JSON.stringify(item));
    }catch(e0){}

    try{
      if(typeof openAdventureInfoCard==="function"){
        openAdventureInfoCard(item,true);
      }else if(window.DriveIQAdventureV516 &&
               typeof window.DriveIQAdventureV516.select==="function"){
        window.DriveIQAdventureV516.select(item);
      }else{
        return false;
      }
    }catch(e1){
      try{ if(typeof toast==="function"){ toast("Place preview could not open"); } }catch(e2){}
      return false;
    }

    try{
      if(window.DriveIQAdventureV528 &&
         typeof window.DriveIQAdventureV528.apply==="function"){
        window.setTimeout(window.DriveIQAdventureV528.apply,0);
      }
    }catch(e3){}

    try{ if(typeof toast==="function"){ toast("Previewing " + String(item.label || item.name || "place")); } }catch(e4){}
    return false;
  }

  /* V531: retired legacy capture-phase result-card interceptor. */
}());

/* =========================================================
   DRIVE IQ ADVENTURE MODE V528
   TERMINAL MAP-FIRST + ROUTE HERE AUTHORITY

   Runs before the legacy V514 guard so it still installs when an older
   Adventure asset already exists in the same WebView.
========================================================= */
(function(){
  "use strict";
  if(window.__DIQ_V528_TERMINAL_MAP_FIRST__){ return; }
  window.__DIQ_V528_TERMINAL_MAP_FIRST__=true;

  function id(v){ return document.getElementById(v); }
  function norm(v){ return String(v||"").toLowerCase().replace(/[^a-z0-9]+/g," ").replace(/\s+/g," ").trim(); }
  function isScanShelf(el){
    var head,txt;
    if(!el){ return false; }
    try{ head=el.querySelector(".diqDestHead,.diqV519Head"); }catch(e0){ head=null; }
    txt=norm(head ? head.textContent : "");
    return txt.indexOf("choose adventure stop")===0 || txt.indexOf("places worth exploring")===0 ||
      !!(el.querySelector && el.querySelector(".diqDestItem[data-adv-idx],.diqV519Card"));
  }
  function countResults(){
    var n=0;
    try{ if(typeof adventureResults!=="undefined" && adventureResults){ n=adventureResults.length||0; } }catch(e0){}
    if(!n){ try{ n=document.querySelectorAll("#diqAdventureDestResults .diqDestItem[data-adv-idx],#diqV519Shelf .diqV519Card").length||0; }catch(e1){} }
    return n;
  }
  function pill(){
    var p=id("diqV528ResultsPill");
    if(p){ return p; }
    p=document.createElement("div"); p.id="diqV528ResultsPill"; p.setAttribute("aria-live","polite");
    try{ document.body.appendChild(p); }catch(e0){}
    return p;
  }
  function infoOpen(){
    var c=id("diqAdventureInfoCard");
    return !!(c && (String(c.className||"").indexOf("on")>-1 || c.getAttribute("aria-hidden")==="false"));
  }
  function enforce(){
    var a=id("diqAdventureDestResults"), b=id("diqV519Shelf"), arr=[a,b], i,p,n,active=false;
    for(i=0;i<arr.length;i++){
      if(isScanShelf(arr[i])){
        arr[i].style.setProperty("display","none","important");
        arr[i].style.setProperty("visibility","hidden","important");
        arr[i].style.setProperty("opacity","0","important");
        arr[i].style.setProperty("pointer-events","none","important");
        arr[i].setAttribute("aria-hidden","true");
        active=true;
      }
    }
    ["diqV526PlacesReopen","diqV519Reopen","diqV518Reopen","diqV525Minimize"].forEach(function(k){
      var x=id(k); if(x){ x.style.setProperty("display","none","important"); }
    });
    p=pill(); n=countResults();
    if(active && !infoOpen()){
      p.textContent=(n||0)+((n===1)?" PLACE FOUND":" PLACES FOUND"); p.className="on";
    }else{ p.className=""; }
  }
  function findOpenItem(){
    var c=id("diqAdventureInfoCard"), title=id("diqAdvInfoTitle"), name=norm(title&&title.textContent), i,it;
    if(c && c.__diqPlaceItem){ return c.__diqPlaceItem; }
    try{ if(typeof adventurePreferred!=="undefined" && adventurePreferred && (!name || norm(adventurePreferred.label)===name)){ return adventurePreferred; } }catch(e0){}
    try{ if(typeof adventureResults!=="undefined" && adventureResults){ for(i=0;i<adventureResults.length;i++){ it=adventureResults[i]; if(it && norm(it.label)===name){ return it; } } } }catch(e1){}
    return null;
  }
  function capture(e){
    var t=e.target, item;
    if(!t){ return; }
    if(t.closest){ t=t.closest("#diqAdvInfoRoute"); }
    if(!t || t.id!=="diqAdvInfoRoute"){ return; }
    item=findOpenItem();
    if(!item){ return; }
    if(e.preventDefault){ e.preventDefault(); }
    if(e.stopImmediatePropagation){ e.stopImmediatePropagation(); }
    try{ if(typeof recordAdventureHistory==="function"){ recordAdventureHistory(item,"route"); } }catch(e0){}
    try{ if(typeof routeSelectedAdventureItem==="function"){ routeSelectedAdventureItem(item); } }catch(e1){
      try{ if(typeof toast==="function"){ toast("Route failed"); } }catch(e2){}
    }
  }
  function styles(){
    if(id("diqV528Styles")){ return; }
    var s=document.createElement("style"); s.id="diqV528Styles";
    s.textContent="#diqV528ResultsPill{display:none;position:fixed;left:50%;bottom:calc(18px + env(safe-area-inset-bottom,0px));transform:translateX(-50%);z-index:2147483000;padding:11px 16px;border-radius:999px;background:rgba(2,10,18,.92);border:1px solid rgba(40,255,190,.42);box-shadow:0 10px 28px rgba(0,0,0,.45);color:#dffff4;font:1000 10px/1 -apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;letter-spacing:1.1px;pointer-events:none}#diqV528ResultsPill.on{display:block}";
    try{ (document.head||document.documentElement).appendChild(s); }catch(e0){}
  }
  function restoreMapInteraction(){
    var node,canvasContainer,canvas;
    try{
      if(typeof map!=="undefined" && map){
        if(map.dragPan){ map.dragPan.enable(); }
        if(map.scrollZoom){ map.scrollZoom.enable(); }
        if(map.touchZoomRotate){ map.touchZoomRotate.enable(); }
        if(map.touchPitch){ map.touchPitch.enable(); }
        if(map.doubleClickZoom){ map.doubleClickZoom.enable(); }
        if(map.boxZoom){ map.boxZoom.enable(); }
        if(map.keyboard){ map.keyboard.enable(); }
        node=map.getContainer ? map.getContainer() : null;
      }
    }catch(e0){}
    if(!node){ node=id("adventureMap"); }
    if(node){
      node.style.setProperty("pointer-events","auto","important");
      node.style.setProperty("touch-action","none","important");
      canvasContainer=node.querySelector ? node.querySelector(".mapboxgl-canvas-container") : null;
      canvas=node.querySelector ? node.querySelector(".mapboxgl-canvas") : null;
      if(canvasContainer){
        canvasContainer.style.setProperty("pointer-events","auto","important");
        canvasContainer.style.setProperty("touch-action","none","important");
      }
      if(canvas){
        canvas.style.setProperty("pointer-events","auto","important");
        canvas.style.setProperty("touch-action","none","important");
      }
    }
  }
  function settle(){
    enforce();
    restoreMapInteraction();
    window.setTimeout(function(){ enforce(); restoreMapInteraction(); },120);
    window.setTimeout(function(){ enforce(); restoreMapInteraction(); },420);
  }
  function watchShelf(node){
    if(!node || node.__diqV530ShelfWatch || !window.MutationObserver){ return; }
    node.__diqV530ShelfWatch=true;
    try{
      new MutationObserver(function(){
        window.setTimeout(settle,0);
      }).observe(node,{childList:true,subtree:true});
    }catch(e0){}
  }
  function watchShelves(){
    watchShelf(id("diqAdventureDestResults"));
    watchShelf(id("diqV519Shelf"));
  }
  function boot(){
    styles();
    watchShelves();
    settle();
    if(window.MutationObserver && document.body && !document.body.__diqV530BodyWatch){
      document.body.__diqV530BodyWatch=true;
      try{
        new MutationObserver(function(records){
          var i,j,nodes,node;
          for(i=0;i<records.length;i++){
            nodes=records[i].addedNodes || [];
            for(j=0;j<nodes.length;j++){
              node=nodes[j];
              if(node && node.nodeType===1 &&
                 (node.id==="diqAdventureDestResults" || node.id==="diqV519Shelf")){
                watchShelf(node);
                window.setTimeout(settle,0);
              }
            }
          }
        }).observe(document.body,{childList:true});
      }catch(e0){}
    }
  }
  document.addEventListener("click",capture,true);
  document.addEventListener("driveiq:adventureScanComplete",settle,false);
  document.addEventListener("driveiq:adventureResultsShown",settle,false);
  window.addEventListener("driveiq:scan-complete",settle,false);
  window.addEventListener("driveiq:adventure-results",settle,false);
  if(document.readyState==="loading"){ document.addEventListener("DOMContentLoaded",boot,false); }else{ boot(); }
  setTimeout(boot,100);
  window.DriveIQAdventureV528={apply:settle,build:"V530_MAP_FIRST_CARD_SAFETY"};
}());

/* V307 Destination Dropdown No-Twitch Guard.
   Hide every destination chooser before the first renderer can paint.
   The final Search IQ panel becomes visible only after its rows are ready. */
(function(){
  var style;

  if(document.getElementById("diqV307NoTwitchEarlyStyles")){ return; }

  style = document.createElement("style");
  style.id = "diqV307NoTwitchEarlyStyles";
  style.type = "text/css";
  style.appendChild(document.createTextNode(
    "body:not(.adventureScanResultsMode) #diqAdventureDestResults{" +
      "display:none!important;opacity:0!important;visibility:hidden!important;" +
      "pointer-events:none!important;" +
    "}" +
    "#diqAdventureSearchResults{" +
      "opacity:0!important;visibility:hidden!important;pointer-events:none!important;" +
      "transform:translateY(4px)!important;" +
      "transition:opacity .14s ease,transform .14s ease!important;" +
    "}" +
    "#diqAdventureSearchResults.ready.on{" +
      "opacity:1!important;visibility:visible!important;pointer-events:auto!important;" +
      "transform:translateY(0)!important;" +
    "}"
  ));

  try{
    (document.head || document.documentElement).appendChild(style);
  }catch(e0){}
}());

/* V204 Safari / WKWebView compatibility.
   Shopify theme code may call requestIdleCallback even when Safari does not
   expose it. Install the fallback before any later theme or Adventure layer
   attempts to use it. */
if (typeof window.requestIdleCallback !== "function") {
  window.requestIdleCallback = function (callback) {
    return window.setTimeout(function () {
      callback({
        didTimeout:false,
        timeRemaining:function () { return 16; }
      });
    }, 1);
  };
}
if (typeof window.cancelIdleCallback !== "function") {
  window.cancelIdleCallback = function (id) {
    window.clearTimeout(id);
  };
}




/* V111: use a version-specific guard so this updated asset can run over older
   Adventure Mode builds. The previous V24 guard caused new patches to be skipped
   when the page already had an older Adventure script in memory. */
if (window.__DRIVE_IQ_ADVENTURE_MODE_JS_V514_POST_SCAN_FREEZE_KILL_SWITCH__) { return; }
window.__DRIVE_IQ_ADVENTURE_MODE_JS_V514_POST_SCAN_FREEZE_KILL_SWITCH__ = true;
/* Do not abort because an older V508 copy already ran. V513 must install its
   runtime bridge and interaction authority over legacy Adventure layers. */
window.__DRIVE_IQ_ADVENTURE_MODE_JS_V508_BOOT_AUTHORITY__ = true;

/* Preserve compatibility flags without allowing an older build flag to abort
   this release. V508 must always execute once in the current WebView. */
window.__DRIVE_IQ_ADVENTURE_MODE_JS_V500_SOURCE_SEARCH__ = true;
window.__DRIVE_IQ_ADVENTURE_MODE_JS_V111_PIPELINE_AUTHORITY__ = true;

/* V515: The old V508 kill switch permanently hid #diqAdventureDestResults.
   That element is also the post-scan place-card shelf, so it must not be
   destroyed globally. The V307 scoped pre-scan rule remains the only early
   destination-chooser hide authority. */

window.__DRIVE_IQ_ADVENTURE_MODE_JS_V24_POLISH__ = true;
window.__DRIVE_IQ_ADVENTURE_MODE_JS_V21__ = true;
window.__DRIVE_IQ_ADVENTURE_MODE_JS_V21_6__ = true;
window.__DRIVE_IQ_ADVENTURE_MODE_JS_V21_7__ = true;
window.__DRIVE_IQ_ADVENTURE_MODE_JS_V21_8__ = true;
window.__DRIVE_IQ_ADVENTURE_MODE_JS_V22__ = true;
window.__DRIVE_IQ_ADVENTURE_MODE_JS_V22_1__ = true;
window.__DRIVE_IQ_ADVENTURE_MODE_JS_V22_1A_HOME_BACK__ = true;
window.__DRIVE_IQ_ADVENTURE_MODE_JS_V22_2_LIVE_MUSIC_FALLBACK__ = true;
window.__DRIVE_IQ_ADVENTURE_MODE_JS_V23_WHERE_GOING_DISCOVERY__ = true;
window.__DRIVE_IQ_ADVENTURE_MODE_JS_V20__ = true;
try { document.body.classList.remove("adventureScanResultsMode"); } catch (e0) {}
window.__DRIVE_IQ_ADVENTURE_MODE_JS_V19__ = true;
window.__DRIVE_IQ_ADVENTURE_MODE_JS_V18__ = true;
window.__DRIVE_IQ_ADVENTURE_MODE_JS_V17__ = true;
window.__DRIVE_IQ_ADVENTURE_MODE_JS_V16__ = true;
window.__DRIVE_IQ_ADVENTURE_MODE_JS_V15__ = true;
window.__DRIVE_IQ_ADVENTURE_MODE_JS_V14__ = true;
window.__DRIVE_IQ_ADVENTURE_MODE_JS_V13__ = true;
window.__DRIVE_IQ_ADVENTURE_MODE_JS_V12__ = true;
window.__DRIVE_IQ_ADVENTURE_MODE_JS_V11__ = true;
window.__DRIVE_IQ_ADVENTURE_MODE_JS_V10__ = true;
window.__DRIVE_IQ_ADVENTURE_MODE_JS_V9__ = true;
window.__DRIVE_IQ_ADVENTURE_MODE_JS_V8__ = true;
window.__DRIVE_IQ_ADVENTURE_MODE_JS_V7__ = true;
window.__DRIVE_IQ_ADVENTURE_MODE_JS_V6__ = true;
window.__DRIVE_IQ_ADVENTURE_MODE_JS_V5__ = true;
window.__DRIVE_IQ_ADVENTURE_MODE_JS_V4__ = true;
window.__DRIVE_IQ_ADVENTURE_MODE_JS_V3__ = true;




var MAPBOX_TOKEN = String(window.DRIVE_IQ_MAPBOX_TOKEN || "");
var GEOAPIFY_KEY = String(window.DRIVE_IQ_GEOAPIFY_KEY || "");
var DRIVE_MODE_URL = String(window.DRIVE_IQ_DRIVE_MODE_URL || "/pages/drive-mode");
var ADVENTURE_HOME_URL = "https://driveiqgps.com";
window.DRIVE_IQ_ADVENTURE_MODE_BUILD = "V537_FOUNDER_IQ_ADVENTURE_WIRED";


/* =========================================================
   DRIVE IQ FOUNDER IQ â€” ADVENTURE MODE EVENT BRIDGE V1

   Founder IQ observes Adventure Mode without changing search, ranking,
   pins, photos, map interaction, Place IQ cards, or Route Here behavior.
========================================================= */

var DIQ_FOUNDER_IQ_EVENT_KEY = "diq_founder_iq_events_v1";
var DIQ_FOUNDER_IQ_SUMMARY_KEY = "diq_founder_iq_summary_v1";
var DIQ_FOUNDER_IQ_SESSION_KEY = "diq_founder_iq_session_v1";
var DIQ_FOUNDER_IQ_MAX_EVENTS = 500;

function diqFounderIQId(prefix){
  return String(prefix || "id") + "_" +
    String(Date.now()) + "_" +
    Math.random().toString(36).slice(2,10);
}

function diqFounderIQSessionId(){
  var id = "";
  try{ id = sessionStorage.getItem(DIQ_FOUNDER_IQ_SESSION_KEY) || ""; }catch(e1){}
  if(!id){
    id = diqFounderIQId("adventure");
    try{ sessionStorage.setItem(DIQ_FOUNDER_IQ_SESSION_KEY,id); }catch(e2){}
  }
  return id;
}

function diqFounderIQReadJson(key,fallback){
  var parsed = null;
  try{ parsed = JSON.parse(localStorage.getItem(key) || ""); }catch(e){}
  return parsed == null ? fallback : parsed;
}

function diqFounderIQSafeValue(value,depth){
  var out;
  var key;
  var i;

  depth = Number(depth || 0);
  if(depth > 3){ return null; }
  if(value == null){ return null; }

  if(typeof value === "string"){ return value.slice(0,180); }
  if(typeof value === "number" || typeof value === "boolean"){ return value; }

  if(Object.prototype.toString.call(value) === "[object Array]"){
    out = [];
    for(i=0;i<Math.min(value.length,12);i++){
      out.push(diqFounderIQSafeValue(value[i],depth+1));
    }
    return out;
  }

  if(typeof value === "object"){
    out = {};
    for(key in value){
      if(!Object.prototype.hasOwnProperty.call(value,key)){ continue; }
      if(
        /(^|_)(query|address|full_address|formatted_address|lat|lng|latitude|longitude|coordinates|geometry|route_geo|email|phone|name)$/i.test(key) ||
        /destination_label/i.test(key)
      ){
        continue;
      }
      out[key] = diqFounderIQSafeValue(value[key],depth+1);
    }
    return out;
  }

  return null;
}

function diqFounderIQCategory(name){
  name = String(name || "").toLowerCase();

  if(/upgrade|subscription|purchase|restore|paywall/.test(name)){ return "revenue"; }
  if(/failed|error|empty|zero|duplicate|timeout|blocked/.test(name)){ return "reliability"; }
  if(/route_here|route_started|route_failed/.test(name)){ return "conversion"; }
  if(/scan|results|destination_search/.test(name)){ return "discovery"; }
  if(/place_preview|save|history|favorite/.test(name)){ return "engagement"; }

  return "activity";
}

function diqFounderIQUpdateSummary(event){
  var summary = diqFounderIQReadJson(DIQ_FOUNDER_IQ_SUMMARY_KEY,{
    app:"drive_iq",
    total_events:0,
    last_event_at:"",
    last_event_name:"",
    counts:{},
    categories:{}
  });

  summary.total_events = Number(summary.total_events || 0) + 1;
  summary.last_event_at = event.occurred_at;
  summary.last_event_name = event.event_name;
  summary.counts = summary.counts || {};
  summary.categories = summary.categories || {};
  summary.counts[event.event_name] = Number(summary.counts[event.event_name] || 0) + 1;
  summary.categories[event.category] = Number(summary.categories[event.category] || 0) + 1;

  try{ localStorage.setItem(DIQ_FOUNDER_IQ_SUMMARY_KEY,JSON.stringify(summary)); }catch(e){}
}

function diqFounderIQQueue(event){
  var events = diqFounderIQReadJson(DIQ_FOUNDER_IQ_EVENT_KEY,[]);

  if(Object.prototype.toString.call(events) !== "[object Array]"){ events = []; }

  events.push(event);

  if(events.length > DIQ_FOUNDER_IQ_MAX_EVENTS){
    events = events.slice(events.length-DIQ_FOUNDER_IQ_MAX_EVENTS);
  }

  try{
    localStorage.setItem(DIQ_FOUNDER_IQ_EVENT_KEY,JSON.stringify(events));
  }catch(e1){
    try{
      events = events.slice(Math.max(0,events.length-100));
      localStorage.setItem(DIQ_FOUNDER_IQ_EVENT_KEY,JSON.stringify(events));
    }catch(e2){}
  }

  diqFounderIQUpdateSummary(event);
}

function diqFounderIQForward(event){
  var endpoint = "";

  try{
    endpoint = String(
      window.DRIVE_IQ_FOUNDER_IQ_ENDPOINT ||
      window.FOUNDER_IQ_EVENT_ENDPOINT ||
      ""
    );
  }catch(e1){}

  if(endpoint && window.fetch){
    try{
      window.fetch(endpoint,{
        method:"POST",
        headers:{"Content-Type":"application/json"},
        body:JSON.stringify(event),
        keepalive:true,
        credentials:"omit"
      }).catch(function(){});
    }catch(e2){}
  }

  try{
    if(
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.founderIQ &&
      window.webkit.messageHandlers.founderIQ.postMessage
    ){
      window.webkit.messageHandlers.founderIQ.postMessage(event);
    }
  }catch(e3){}
}

function diqFounderIQTrack(name,params){
  var event;

  try{
    event = {
      schema_version:"founder_iq_event_v1",
      event_id:diqFounderIQId("evt"),
      app:"drive_iq",
      product:"Drive IQ",
      surface:"adventure_mode",
      page:"adventure_mode",
      category:diqFounderIQCategory(name),
      event_name:String(name || "unknown_event").slice(0,100),
      occurred_at:(new Date()).toISOString(),
      session_id:diqFounderIQSessionId(),
      build:String(window.DRIVE_IQ_ADVENTURE_MODE_BUILD || ""),
      source:"adventure_mode_js",
      properties:diqFounderIQSafeValue(params || {},0)
    };

    diqFounderIQQueue(event);
    diqFounderIQForward(event);

    try{
      window.dispatchEvent(new CustomEvent("diqFounderIQEvent",{detail:event}));
    }catch(e1){}

    return event;
  }catch(e2){
    return null;
  }
}

function diqFounderIQAdventureResultCount(){
  var count = 0;
  try{ if(adventureResults && adventureResults.length){ count = adventureResults.length; } }catch(e1){}
  if(!count){
    try{ if(exploreResults && exploreResults.length){ count = exploreResults.length; } }catch(e2){}
  }
  return Number(count || 0);
}

function diqFounderIQAdventureScanComplete(source){
  var count = diqFounderIQAdventureResultCount();

  diqFounderIQTrack(count ? "adventure_scan_completed" : "adventure_scan_empty",{
    source:source || "event",
    result_count:count,
    lens:(typeof activeLens !== "undefined" ? String(activeLens || "") : ""),
    scope:(typeof adventureSearchScope !== "undefined" ? String(adventureSearchScope || "") : ""),
    fallback_pass:(typeof adventureScanFallbackPass !== "undefined" ? Number(adventureScanFallbackPass || 0) : 0),
    duration_ms:(typeof activeScanStartedAt !== "undefined" && activeScanStartedAt ? Math.max(0,Date.now()-Number(activeScanStartedAt)) : 0)
  });
}

try{
  window.DriveIQFounderIQTrack = diqFounderIQTrack;
  window.DriveIQFounderIQReadEvents = function(){
    return diqFounderIQReadJson(DIQ_FOUNDER_IQ_EVENT_KEY,[]);
  };
  window.DriveIQFounderIQClearLocalEvents = function(){
    try{ localStorage.removeItem(DIQ_FOUNDER_IQ_EVENT_KEY); }catch(e1){}
    try{ localStorage.removeItem(DIQ_FOUNDER_IQ_SUMMARY_KEY); }catch(e2){}
    return true;
  };
}catch(e){}


try{
  if(!window.__DIQ_FOUNDER_IQ_ADVENTURE_COMPLETE_LISTENERS__){
    window.__DIQ_FOUNDER_IQ_ADVENTURE_COMPLETE_LISTENERS__ = true;

    document.addEventListener("driveiq:adventureScanComplete",function(){
      try{ diqFounderIQAdventureScanComplete("driveiq:adventureScanComplete"); }catch(e1){}
    },false);

    document.addEventListener("driveiq:adventureResultsShown",function(){
      try{ diqFounderIQAdventureScanComplete("driveiq:adventureResultsShown"); }catch(e2){}
    },false);

    window.addEventListener("driveiq:scan-complete",function(){
      try{ diqFounderIQAdventureScanComplete("driveiq:scan-complete"); }catch(e3){}
    },false);

    window.addEventListener("driveiq:adventure-results",function(){
      try{ diqFounderIQAdventureScanComplete("driveiq:adventure-results"); }catch(e4){}
    },false);
  }
}catch(founderIQListenerErr){}






var map = null;
var mapLoaded = false;
var lastFix = null;
var destination = null;
var routeGeo = null;
var gpsWatchId = null;
var searchTimer = null;
var toastTimer = null;
var activeLens = "scenic";
var routeAttemptToken = 0;
var waitingForGpsQuery = "";
var freeFlowUntil = 0;
var horizonHideTimer = null;
var adventureResults = [];
var adventurePreferred = null;
var exploreMode = false;
var exploreScanToken = 0;
var exploreResults = [];
var outdoorStyleActive = false;
var pendingStyleRestore = false;
var scanTabTimer = null;
var scanTabStep = 0;
var scanTabActive = false;
var destinationSearchToken = 0;
var destinationSearchResults = [];
var destinationResultOpen = false;
var infoVoiceEnabled = true;
var adventureSearchCenter = null;
var adventureSearchScope = "near_me";
var destinationPreviewScan = false;
var adventureScanOnly = false;
var activeDropItem = null;
var adventureDropModalOpen = false;
var scanResultsModeTimer = null;
var scanMapFitTimer = null;
var infoVoiceLastKey = "";
var infoVoiceLastAt = 0;
var mapAreaScanActive = false;
var adventureScanVoiceLastKey = "";
var adventureScanVoiceLastAt = 0;
var adventureScanVoiceToken = 0;
var adventureAutoCollapseTimer = null;
var destinationLock = null;
var destinationLockInputNorm = "";

/* V304 Destination Identity Authority.
   The city/region explicitly chosen by the user remains the Adventure Center
   until the user changes the search or explicitly selects another destination.
   District discovery and scan candidates may never silently replace it. */
var committedAdventureDestination = null;
var committedAdventureDestinationReason = "";
var liveMusicFallbackVoiceSpokenAt = 0;
var activeScanQuery = "";
var activeScanStartedAt = 0;
var adventureScanRadiusOverride = 0;
var adventureScanFallbackPass = 0;




/* V25.4 destination browse camera authority.
   Live GPS may remain visible, but it cannot pull a destination scan back
   toward the user's physical location after results have settled. */
var adventureDestinationCameraHold = false;
var adventureDestinationCameraHoldAt = 0;




var LS = {
  LAST_FIX: "diq_last_gps_v1",
  DEST: "diq_dest_v1",
  ROUTE_GEO: "diq_route_geo_v1",
  ROUTE_INTEL: "diq_route_intel_v1",
  DRIVE_PAYLOAD: "diq_drive_payload_v1",
  DRIVE_ON: "diq_drive_on_v1",
  ACTIVE_DRIVE_ID: "diq_active_drive_id_v1",
  ADVENTURE_LENS: "diq_adventure_lens_v1",
  UPGRADE_INTENT: "diq_upgrade_intent_v1",
  FAVORITE_STOPS: "diq_place_iq_favorite_stops_v1",
  DISCOVERY_DROPS: "diq_place_iq_drops_v1",
  ADVENTURE_HISTORY: "diq_adventure_iq_history_v1",
  ADVENTURE_DROPS: "diq_adventure_drops_v1",
  ADVENTURE_TASTE: "diq_adventure_taste_v1",
  LAST_SCAN: "diq_adventure_last_scan_v1",
  PHOTO_CACHE: "diq_place_photo_cache_v1"
};




function byId(id) { return document.getElementById(id); }
function clean(v) { return String(v || "").replace(/\s+/g, " ").trim(); }
function normText(v) { return String(v || "").toLowerCase().replace(/[^a-z0-9]+/g, " ").replace(/\s+/g, " ").trim(); }
function finite(v) { return typeof v === "number" && isFinite(v); }
function safeParse(v) { try { return JSON.parse(String(v || "")); } catch (e) { return null; } }
function lsSet(k, v) { try { localStorage.setItem(k, String(v)); } catch (e) {} }
function lsJSON(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
function lsRemove(k) { try { localStorage.removeItem(k); } catch (e) {} }





/* =========================================================
   DRIVE IQ V500 â€” SOURCE-LEVEL DESTINATION SEARCH

   This is the only destination-search controller.
   It is installed near the top of the file, before the later Adventure layers.

   Owns:
   - focus / typing / debounce
   - US-first destination lookup
   - canonical city authority
   - stable permanent dropdown
   - selection and Destination IQ handoff

   The legacy chooser remains available only for post-scan result cards.
========================================================= */

var diqV500Search = {
  panel:null,
  list:null,
  input:null,
  timer:null,
  token:0,
  open:false,
  results:[],
  query:""
};

var DIQ_V500_CANONICAL_DESTINATIONS = [
  {label:"Destin",full:"Destin, Florida",lat:30.3935,lng:-86.4958,kind:"city",canonical:true},
  {label:"Jackson",full:"Jackson, Mississippi",lat:32.2988,lng:-90.1848,kind:"city",canonical:true},
  {label:"Nashville",full:"Nashville, Tennessee",lat:36.1627,lng:-86.7816,kind:"city",canonical:true},
  {label:"Memphis",full:"Memphis, Tennessee",lat:35.1495,lng:-90.0490,kind:"city",canonical:true},
  {label:"Southaven",full:"Southaven, Mississippi",lat:34.98898,lng:-90.01259,kind:"city",canonical:true},
  {label:"Horn Lake",full:"Horn Lake, Mississippi",lat:34.95537,lng:-90.03481,kind:"city",canonical:true},
  {label:"Hernando",full:"Hernando, Mississippi",lat:34.82399,lng:-89.99370,kind:"city",canonical:true},
  {label:"Gulf Shores",full:"Gulf Shores, Alabama",lat:30.2460,lng:-87.7008,kind:"city",canonical:true},
  {label:"Gatlinburg",full:"Gatlinburg, Tennessee",lat:35.7143,lng:-83.5102,kind:"city",canonical:true},
  {label:"Oxford",full:"Oxford, Mississippi",lat:34.3665,lng:-89.5192,kind:"city",canonical:true},
  {label:"Miami Beach",full:"Miami Beach, Florida",lat:25.7907,lng:-80.1300,kind:"city",canonical:true},
  {label:"Dallas",full:"Dallas, Texas",lat:32.7767,lng:-96.7970,kind:"city",canonical:true},
  {label:"Atlanta",full:"Atlanta, Georgia",lat:33.7490,lng:-84.3880,kind:"city",canonical:true},
  {label:"Boston",full:"Boston, Massachusetts",lat:42.3601,lng:-71.0589,kind:"city",canonical:true},
  {label:"New York",full:"New York, New York",lat:40.7128,lng:-74.0060,kind:"city",canonical:true},
  {label:"Panama City Beach",full:"Panama City Beach, Florida",lat:30.1766,lng:-85.8055,kind:"city",canonical:true},
  {label:"Pickwick Lake",full:"Pickwick Lake, Tennessee / Mississippi / Alabama",lat:35.0495,lng:-88.2517,kind:"lake",canonical:true},
  {label:"Sardis Lake",full:"Sardis Lake, Mississippi",lat:34.4307,lng:-89.7957,kind:"lake",canonical:true},
  {label:"Arkabutla Lake",full:"Arkabutla Lake, Mississippi",lat:34.7448,lng:-90.1234,kind:"lake",canonical:true},
  {label:"Grenada Lake",full:"Grenada Lake, Mississippi",lat:33.8426,lng:-89.7858,kind:"lake",canonical:true},
  {label:"Enid Lake",full:"Enid Lake, Mississippi",lat:34.1593,lng:-89.8773,kind:"lake",canonical:true}
];

var DIQ_V500_DISTRICTS = [
  {label:"HarborWalk Village",full:"Destin, Florida",lat:30.3941,lng:-86.5136,kind:"district",explicit:["harborwalk","harborwalk village"]},
  {label:"Destin Commons",full:"Destin, Florida",lat:30.3897,lng:-86.4275,kind:"district",explicit:["destin commons"]},
  {label:"Beale Street",full:"Memphis, Tennessee",lat:35.1395,lng:-90.0514,kind:"district",explicit:["beale street"]},
  {label:"Silo Square",full:"Southaven, Mississippi",lat:34.9317,lng:-89.9947,kind:"district",explicit:["silo square"]},
  {label:"Disney Springs",full:"Lake Buena Vista, Florida",lat:28.3703,lng:-81.5190,kind:"district",explicit:["disney springs"]},
  {label:"The Wharf",full:"Orange Beach, Alabama",lat:30.2942,lng:-87.6281,kind:"district",explicit:["the wharf"]}
];

function diqV500Escape(v) {
  return String(v || "").replace(/[&<>"']/g, function (ch) {
    if (ch === "&") { return "&amp;"; }
    if (ch === "<") { return "&lt;"; }
    if (ch === ">") { return "&gt;"; }
    if (ch === '"') { return "&quot;"; }
    return "&#39;";
  });
}

function diqV500Norm(v) {
  return String(v || "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

function diqV500DistanceMiles(aLat, aLng, bLat, bLng) {
  var R = 3958.7613;
  var lat1;
  var lat2;
  var dLat;
  var dLng;
  var a;

  if (
    !finite(Number(aLat)) ||
    !finite(Number(aLng)) ||
    !finite(Number(bLat)) ||
    !finite(Number(bLng))
  ) {
    return null;
  }

  lat1 = Number(aLat) * Math.PI / 180;
  lat2 = Number(bLat) * Math.PI / 180;
  dLat = (Number(bLat) - Number(aLat)) * Math.PI / 180;
  dLng = (Number(bLng) - Number(aLng)) * Math.PI / 180;

  a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1) * Math.cos(lat2) *
    Math.sin(dLng / 2) * Math.sin(dLng / 2);

  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

function diqV500CanonicalMatches(query) {
  var q = diqV500Norm(query);
  var out = [];
  var i;
  var item;
  var label;
  var full;

  if (!q) { return out; }

  for (i = 0; i < DIQ_V500_CANONICAL_DESTINATIONS.length; i++) {
    item = DIQ_V500_CANONICAL_DESTINATIONS[i];
    label = diqV500Norm(item.label);
    full = diqV500Norm(item.full);

    if (
      label === q ||
      label.indexOf(q) === 0 ||
      full.indexOf(q) === 0 ||
      (q.length >= 4 && full.indexOf(q) > -1)
    ) {
      out.push({
        label:item.label,
        full:item.full,
        lat:item.lat,
        lng:item.lng,
        kind:item.kind,
        resultType:"v500_canonical",
        canonical:true
      });
    }
  }

  return out;
}

function diqV500ExplicitDistrictMatches(query) {
  var q = diqV500Norm(query);
  var out = [];
  var i;
  var j;
  var item;
  var alias;

  if (!q) { return out; }

  for (i = 0; i < DIQ_V500_DISTRICTS.length; i++) {
    item = DIQ_V500_DISTRICTS[i];

    for (j = 0; j < item.explicit.length; j++) {
      alias = diqV500Norm(item.explicit[j]);

      if (alias === q || alias.indexOf(q) === 0 || q.indexOf(alias) > -1) {
        out.push({
          label:item.label,
          full:item.full,
          lat:item.lat,
          lng:item.lng,
          kind:"district",
          resultType:"v500_district",
          canonical:true
        });
        break;
      }
    }
  }

  return out;
}

function diqV500FeatureToItem(feature) {
  var p = feature && feature.properties ? feature.properties : {};
  var coords = feature && feature.geometry && feature.geometry.coordinates
    ? feature.geometry.coordinates
    : [];
  var label = clean(
    p.name ||
    p.city ||
    p.town ||
    p.village ||
    p.county ||
    p.formatted ||
    ""
  );
  var full = clean(p.formatted || p.address_line2 || "");
  var kind = clean(
    p.result_type ||
    p.category ||
    p.place_type ||
    "destination"
  );

  if (
    !label ||
    coords.length < 2 ||
    !finite(Number(coords[1])) ||
    !finite(Number(coords[0]))
  ) {
    return null;
  }

  return {
    label:label,
    full:full,
    lat:Number(coords[1]),
    lng:Number(coords[0]),
    kind:kind,
    category:clean(p.category || ""),
    resultType:"v500_geoapify",
    countryCode:clean(p.country_code || "").toLowerCase(),
    state:clean(p.state || ""),
    city:clean(p.city || p.town || p.village || "")
  };
}

function diqV500ItemKey(item) {
  return diqV500Norm(
    String(item && item.label || "") + "|" +
    String(item && item.full || "") + "|" +
    String(item && item.lat || "") + "|" +
    String(item && item.lng || "")
  );
}

function diqV500Rank(items, query) {
  var q = diqV500Norm(query);
  var out = [];
  var seen = {};
  var i;
  var item;
  var key;
  var text;
  var score;
  var d;

  for (i = 0; i < (items || []).length; i++) {
    item = items[i];
    if (!item) { continue; }

    key = diqV500ItemKey(item);
    if (!key || seen[key]) { continue; }
    seen[key] = true;

    text = diqV500Norm(
      String(item.label || "") + " " +
      String(item.full || "") + " " +
      String(item.kind || "")
    );

    /* United States first. Foreign results are suppressed unless the user
       explicitly typed the country name. */
    if (
      item.countryCode &&
      item.countryCode !== "us" &&
      q.indexOf(item.countryCode) < 0
    ) {
      continue;
    }

    if (
      text.indexOf("county meath") > -1 ||
      text.indexOf("karakocan") > -1 ||
      text.indexOf("eastern anatolia") > -1 ||
      text.indexOf("destini lakes") > -1
    ) {
      continue;
    }

    score = 0;

    if (item.canonical) { score += 5000; }
    if (diqV500Norm(item.label) === q) { score += 2600; }
    if (diqV500Norm(item.full) === q) { score += 2200; }
    if (diqV500Norm(item.label).indexOf(q) === 0) { score += 1300; }
    if (text.indexOf(q) > -1) { score += 700; }

    if (
      text.indexOf(" city") > -1 ||
      text.indexOf(" town") > -1 ||
      text.indexOf(" locality") > -1 ||
      text.indexOf(" municipality") > -1
    ) {
      score += 500;
    }

    if (item.kind === "district") { score += 300; }

    if (lastFix) {
      d = diqV500DistanceMiles(lastFix.lat, lastFix.lng, item.lat, item.lng);
      if (finite(Number(d))) {
        score -= Math.min(700, Number(d) * 0.45);
      }
    }

    item._v500Score = score;
    out.push(item);
  }

  out.sort(function (a, b) {
    return Number(b._v500Score || 0) - Number(a._v500Score || 0);
  });

  return out.slice(0, 8);
}

function diqV500InjectStyles() {
  var style;

  if (byId("diqV500SearchStyles")) { return; }

  style = document.createElement("style");
  style.id = "diqV500SearchStyles";
  style.type = "text/css";
  style.appendChild(document.createTextNode(
    "body:not(.adventureScanResultsMode) #diqAdventureDestResults," +
    "body:not(.adventureScanResultsMode) #diqAdventureSearchResults{" +
      "display:none!important;visibility:hidden!important;opacity:0!important;" +
      "pointer-events:none!important;" +
    "}" +

    "#diqV500SearchPanel{" +
      "display:none!important;position:fixed!important;" +
      "left:14px!important;right:14px!important;" +
      "top:calc(env(safe-area-inset-top,0px) + 76px)!important;" +
      "width:auto!important;max-width:none!important;" +
      "max-height:calc(100dvh - 116px)!important;" +
      "overflow:hidden!important;border-radius:22px!important;" +
      "background:linear-gradient(180deg,rgba(3,10,19,.994),rgba(2,8,16,.998))!important;" +
      "border:1px solid rgba(40,255,190,.34)!important;" +
      "box-shadow:0 24px 60px rgba(0,0,0,.66)!important;" +
      "z-index:50000!important;" +
    "}" +

    "#diqV500SearchPanel.on{" +
      "display:flex!important;flex-direction:column!important;" +
    "}" +

    "#diqV500SearchPanel .v500Head{" +
      "position:relative!important;min-height:58px!important;" +
      "padding:0 62px 0 18px!important;" +
      "display:flex!important;align-items:center!important;" +
      "border-bottom:1px solid rgba(255,255,255,.08)!important;" +
      "color:#baffed!important;font-size:11px!important;" +
      "font-weight:1000!important;letter-spacing:1.45px!important;" +
    "}" +

    "#diqV500Close{" +
      "position:absolute!important;right:10px!important;top:9px!important;" +
      "width:40px!important;height:40px!important;min-width:40px!important;" +
      "padding:0!important;border-radius:14px!important;" +
      "border:1px solid rgba(255,255,255,.15)!important;" +
      "background:rgba(255,255,255,.06)!important;color:#fff!important;" +
      "font-size:25px!important;line-height:1!important;" +
    "}" +

    "#diqV500SearchList{" +
      "display:block!important;width:100%!important;" +
      "max-height:calc(100dvh - 174px)!important;" +
      "overflow-y:auto!important;overflow-x:hidden!important;" +
      "-webkit-overflow-scrolling:touch!important;" +
      "overscroll-behavior:contain!important;padding:10px 12px 18px!important;" +
    "}" +

    "#diqV500SearchList .v500Loading{" +
      "padding:22px 18px!important;text-align:center!important;" +
      "color:rgba(255,255,255,.72)!important;font-size:13px!important;" +
      "font-weight:800!important;" +
    "}" +

    "#diqV500SearchList .v500Row{" +
      "display:block!important;width:100%!important;" +
      "min-height:94px!important;margin:0 0 10px!important;" +
      "padding:14px 15px!important;text-align:left!important;" +
      "border-radius:18px!important;" +
      "border:1px solid rgba(255,255,255,.12)!important;" +
      "background:linear-gradient(145deg,rgba(255,255,255,.06),rgba(255,255,255,.025))!important;" +
      "color:#fff!important;overflow:hidden!important;" +
    "}" +

    "#diqV500SearchList .v500Row.canonical{" +
      "border-color:rgba(255,217,112,.64)!important;" +
      "background:linear-gradient(145deg,rgba(255,214,102,.11),rgba(40,255,190,.045))!important;" +
    "}" +

    "#diqV500SearchList .v500Name{" +
      "font-size:21px!important;line-height:1.08!important;" +
      "font-weight:1000!important;white-space:nowrap!important;" +
      "overflow:hidden!important;text-overflow:ellipsis!important;" +
    "}" +

    "#diqV500SearchList .v500Sub{" +
      "margin-top:5px!important;font-size:14px!important;line-height:1.2!important;" +
      "font-weight:680!important;color:rgba(255,255,255,.72)!important;" +
      "white-space:nowrap!important;overflow:hidden!important;text-overflow:ellipsis!important;" +
    "}" +

    "#diqV500SearchList .v500Meta{" +
      "margin-top:8px!important;font-size:10px!important;line-height:1!important;" +
      "font-weight:1000!important;letter-spacing:1px!important;" +
      "text-transform:uppercase!important;color:#ffe29a!important;" +
    "}"
  ));

  try {
    (document.head || document.documentElement).appendChild(style);
  } catch (e0) {}
}

function diqV500EnsurePanel() {
  var panel = byId("diqV500SearchPanel");
  var close;

  if (panel) {
    diqV500Search.panel = panel;
    diqV500Search.list = byId("diqV500SearchList");
    return panel;
  }

  panel = document.createElement("div");
  panel.id = "diqV500SearchPanel";
  panel.setAttribute("aria-hidden", "true");
  panel.innerHTML =
    '<div class="v500Head">' +
      '<span>CHOOSE DESTINATION</span>' +
      '<button type="button" id="diqV500Close" aria-label="Close destination results">&times;</button>' +
    '</div>' +
    '<div id="diqV500SearchList"></div>';

  try { document.body.appendChild(panel); } catch (e0) {}

  diqV500Search.panel = panel;
  diqV500Search.list = byId("diqV500SearchList");

  close = byId("diqV500Close");
  if (close) {
    close.onclick = function (event) {
      if (event && event.preventDefault) { event.preventDefault(); }
      diqV500Close();
      return false;
    };
  }

  return panel;
}

function diqV500Open() {
  var panel = diqV500EnsurePanel();
  if (!panel) { return; }

  panel.className = "on";
  panel.setAttribute("aria-hidden", "false");
  diqV500Search.open = true;
  destinationResultOpen = true;
}

function diqV500Close() {
  var panel = diqV500EnsurePanel();

  diqV500Search.open = false;
  destinationResultOpen = false;

  if (panel) {
    panel.className = "";
    panel.setAttribute("aria-hidden", "true");
  }

  updateClearAdventureSearchButton();
}

function diqV500Meta(item) {
  var parts = [];

  if (item.canonical) {
    parts.push("Canonical destination");
  } else if (item.kind === "district") {
    parts.push("District");
  } else {
    parts.push(titleCaseWords(String(item.kind || "Destination").replace(/_/g, " ")));
  }

  return parts.join(" â€¢ ");
}

function diqV500Render(items, query) {
  var panel = diqV500EnsurePanel();
  var list = diqV500Search.list;
  var ranked = diqV500Rank(items || [], query || "");
  var i;
  var item;
  var btn;

  if (!panel || !list) { return; }

  diqV500Search.results = ranked.slice(0);
  diqV500Search.query = clean(query || "");
  destinationSearchResults = ranked.slice(0);

  list.innerHTML = "";

  if (!ranked.length) {
    list.innerHTML =
      '<button type="button" class="v500Row">' +
        '<div class="v500Name">No destination match yet</div>' +
        '<div class="v500Sub">Try a city, lake, beach, park, attraction, address, or business.</div>' +
      '</button>';
  } else {
    for (i = 0; i < ranked.length; i++) {
      item = ranked[i];
      btn = document.createElement("button");
      btn.type = "button";
      btn.className = "v500Row" + (item.canonical ? " canonical" : "");
      btn.setAttribute("data-v500-index", String(i));

      btn.innerHTML =
        '<div class="v500Name">' + diqV500Escape(item.label) + '</div>' +
        '<div class="v500Sub">' + diqV500Escape(item.full || "Tap to explore") + '</div>' +
        '<div class="v500Meta">' + diqV500Escape(diqV500Meta(item)) + '</div>';

      btn.onclick = function () {
        var idx = Number(this.getAttribute("data-v500-index"));
        var selected = diqV500Search.results[idx];

        if (!selected) { return; }

        diqV500Close();
        dismissAdventureKeyboard();

        if (typeof routeDestinationResult === "function") {
          routeDestinationResult(selected);
        } else {
          destination = selected;
          adventureSearchCenter = {
            lat:Number(selected.lat),
            lng:Number(selected.lng),
            label:String(selected.label || "Destination")
          };
          adventureSearchScope = "near_destination";
          try { lsJSON(LS.DEST, selected); } catch (e0) {}
          try { syncAdventureDestinationScopeUI(); } catch (e1) {}
        }
      };

      list.appendChild(btn);
    }
  }

  diqV500Open();
}

function diqV500Fetch(query) {
  var q = clean(query);
  var token;
  var all;
  var canonical;
  var districts;
  var url;
  var bias = "";
  var list = diqV500Search.list || byId("diqV500SearchList");

  if (q.length < 2) {
    diqV500Search.token += 1;
    diqV500Close();
    return;
  }

  diqV500Search.token += 1;
  token = diqV500Search.token;
  canonical = diqV500CanonicalMatches(q);
  districts = diqV500ExplicitDistrictMatches(q);
  all = canonical.concat(districts);

  diqV500EnsurePanel();
  if (list) {
    list.innerHTML =
      '<div class="v500Loading">Finding the best destination matchesâ€¦</div>';
  }
  diqV500Open();

  if (!GEOAPIFY_KEY) {
    diqV500Render(all, q);
    return;
  }

  if (lastFix && finite(Number(lastFix.lat)) && finite(Number(lastFix.lng))) {
    bias = "&bias=proximity:" +
      encodeURIComponent(String(lastFix.lng) + "," + String(lastFix.lat));
  }

  url =
    "https://api.geoapify.com/v1/geocode/autocomplete" +
    "?text=" + encodeURIComponent(q) +
    "&format=geojson" +
    "&limit=12" +
    "&filter=countrycode:us" +
    bias +
    "&apiKey=" + encodeURIComponent(GEOAPIFY_KEY);

  fetch(url)
    .then(function (response) { return response.json(); })
    .then(function (data) {
      var features;
      var i;
      var item;

      if (token !== diqV500Search.token) { return; }

      features = data && data.features ? data.features : [];

      for (i = 0; i < features.length; i++) {
        item = diqV500FeatureToItem(features[i]);
        if (item) { all.push(item); }
      }

      diqV500Render(all, q);
    })
    .catch(function () {
      if (token !== diqV500Search.token) { return; }
      diqV500Render(all, q);
    });
}

function diqV500Queue(query) {
  if (diqV500Search.timer) {
    window.clearTimeout(diqV500Search.timer);
  }

  diqV500Search.timer = window.setTimeout(function () {
    diqV500Fetch(query);
  }, 150);
}

function diqV500Capture(event) {
  var target = event && event.target;

  if (!target || target.id !== "adventureSearch") { return; }

  if (event.type === "keydown" && event.key === "Escape") {
    event.preventDefault();
    event.stopImmediatePropagation();
    diqV500Close();
    return;
  }

  if (event.type === "keydown" && event.key === "Enter") {
    if (diqV500Search.open && diqV500Search.results.length) {
      event.preventDefault();
      event.stopImmediatePropagation();
      diqV500Search.results[0]._v500Auto = true;
      diqV500Close();
      dismissAdventureKeyboard();
      if (typeof routeDestinationResult === "function") {
        routeDestinationResult(diqV500Search.results[0]);
      }
    }
    return;
  }

  if (
    event.type === "focusin" ||
    event.type === "input" ||
    event.type === "keyup"
  ) {
    /* Stop the accumulated legacy destination listeners. */
    if (event.stopImmediatePropagation) {
      event.stopImmediatePropagation();
    }

    diqV500Search.input = target;
    diqV500Queue(target.value);
  }
}

function diqV500Bind() {
  diqV500InjectStyles();
  diqV500EnsurePanel();

  window.addEventListener("focusin", diqV500Capture, true);
  window.addEventListener("input", diqV500Capture, true);
  window.addEventListener("keyup", diqV500Capture, true);
  window.addEventListener("keydown", diqV500Capture, true);

  document.addEventListener("pointerdown", function (event) {
    var input = byId("adventureSearch");

    if (
      diqV500Search.open &&
      diqV500Search.panel &&
      !diqV500Search.panel.contains(event.target) &&
      event.target !== input
    ) {
      diqV500Close();
    }
  }, true);

  window.DRIVE_IQ_ADVENTURE_SEARCH_V500 = {
    build:"V500_SOURCE_LEVEL_DESTINATION_SEARCH",
    search:diqV500Fetch,
    close:diqV500Close,
    results:function () { return diqV500Search.results.slice(0); }
  };

  try {
    console.log("âœ… Drive IQ V500 source-level destination search loaded");
  } catch (ePublic) {}
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", diqV500Bind, false);
} else {
  diqV500Bind();
}




function titleCaseWords(v) {
  var s = clean(v);
  var parts;
  var out = [];
  var i;
  var w;
  if (!s) { return ""; }
  parts = s.split(" ");
  for (i = 0; i < parts.length; i++) {
    w = parts[i];
    if (!w) { continue; }
    if (w.toUpperCase() === "RV" || w.toUpperCase() === "KOA") { out.push(w.toUpperCase()); }
    else { out.push(w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()); }
  }
  return out.join(" ");
}




function setStatus(id, text, state) {
  var el = byId(id);
  if (!el) { return; }
  el.className = "adventureStatus";
  if (state === "green") { el.className = "adventureStatus green"; }
  else if (state === "gold") { el.className = "adventureStatus gold"; }
  else if (state === "red") { el.className = "adventureStatus red"; }
  el.textContent = String(text || "READY").toUpperCase();
}




function toast(msg) {
  var el = byId("adventureToast");
  if (window.console && window.console.log) { window.console.log("[Adventure]", msg); }
  if (!el) { return; }
  el.textContent = String(msg || "Adventure ready");
  el.className = "adventureToast on";
  if (toastTimer) { window.clearTimeout(toastTimer); }
  toastTimer = window.setTimeout(function () { el.className = "adventureToast"; }, 1900);
}




function ensureScanTab() {
  var tab;
  if (byId("diqAdventureScanTab")) { return byId("diqAdventureScanTab"); }
  tab = document.createElement("div");
  tab.id = "diqAdventureScanTab";
  tab.innerHTML = '<div class="diqScanPulse"></div><div class="diqScanText"><div class="diqScanTitle" id="diqScanTitle">EXPLORING</div><div class="diqScanSub" id="diqScanSub">Finding what is worth the drive...</div></div>';
  try { document.body.appendChild(tab); } catch (e) {}
  return tab;
}




function startScanTab(title, sub) {
  var tab;
  var titleEl;
  var subEl;
  var steps = [
    "Finding whatâ€™s worth the drive...",
    "Checking local favorites...",
    "Expanding the adventure radius...",
    "Dropping the best pins..."
  ];




  injectAdventurePolishStyles();
  tab = ensureScanTab();
  if (!tab) { return; }




  scanTabActive = true;
  scanTabStep = 0;




  titleEl = byId("diqScanTitle");
  subEl = byId("diqScanSub");




  if (titleEl) { titleEl.textContent = clean(title || "SCANNING").toUpperCase(); }
  if (subEl) { subEl.textContent = clean(sub || steps[0]); }




  tab.className = "on";




  if (scanTabTimer) { window.clearInterval(scanTabTimer); }
  scanTabTimer = window.setInterval(function () {
    if (!scanTabActive) { return; }
    scanTabStep += 1;
    if (subEl) { subEl.textContent = steps[scanTabStep % steps.length]; }
  }, 1250);
}




function updateScanTab(sub) {
  var subEl = byId("diqScanSub");
  if (!scanTabActive || !subEl) { return; }
  subEl.textContent = clean(sub || "Finding what is worth the drive...");
}




function stopScanTab() {
  var tab = byId("diqAdventureScanTab");
  scanTabActive = false;
  if (scanTabTimer) {
    window.clearInterval(scanTabTimer);
    scanTabTimer = null;
  }
  if (tab) { tab.className = ""; }
}




function isLikelyCategoryQuery(query) {
  var q = normText(query);
  if (!q) { return false; }
  if (categoryFromQuery(q)) { return true; }
  if (q === "camp" || q === "camps" || q === "scenic" || q === "hidden") { return true; }
  return false;
}




var destinationChooserLayoutObserver = null;
var destinationChooserViewportBound = false;
var destinationChooserLayoutTimer = null;

function resetDestinationChooserInlineLayout(panel) {
  var list;
  var head;

  if (!panel) { return; }

  panel.style.removeProperty("position");
  panel.style.removeProperty("top");
  panel.style.removeProperty("left");
  panel.style.removeProperty("right");
  panel.style.removeProperty("bottom");
  panel.style.removeProperty("width");
  panel.style.removeProperty("max-width");
  panel.style.removeProperty("height");
  panel.style.removeProperty("max-height");
  panel.style.removeProperty("margin");
  panel.style.removeProperty("transform");
  panel.style.removeProperty("overflow");
  panel.style.removeProperty("display");
  panel.style.removeProperty("flex-direction");
  panel.style.removeProperty("z-index");

  list = panel.querySelector ? panel.querySelector("#diqDestList") : null;
  if (list) {
    list.style.removeProperty("display");
    list.style.removeProperty("flex");
    list.style.removeProperty("min-height");
    list.style.removeProperty("height");
    list.style.removeProperty("max-height");
    list.style.removeProperty("overflow-y");
    list.style.removeProperty("overflow-x");
    list.style.removeProperty("-webkit-overflow-scrolling");
    list.style.removeProperty("overscroll-behavior");
    list.style.removeProperty("padding-bottom");
    list.style.removeProperty("scroll-padding-bottom");
    list.style.removeProperty("touch-action");
  }

  head = panel.querySelector ? panel.querySelector(".diqDestHead") : null;
  if (head) {
    head.style.removeProperty("position");
    head.style.removeProperty("top");
    head.style.removeProperty("flex");
    head.style.removeProperty("z-index");
  }

  panel.removeAttribute("data-diq-source-chooser-layout");
}

function applyDestinationChooserLayout() {
  var panel = byId("diqAdventureDestResults");
  var list;
  var head;
  var viewport;
  var viewportHeight;
  var viewportTop;
  var safeTop;
  var available;

  if (!panel || !destinationResultOpen) { return; }

  head = panel.querySelector ? panel.querySelector(".diqDestHead") : null;

  /* This legacy panel is allowed to position only while it literally says
     CHOOSE DESTINATION. Post-scan cards use the dedicated V510 sheet and may
     never invoke this chooser layout authority. */
  if (
    !head ||
    clean(head.textContent || "").toUpperCase().indexOf("CHOOSE DESTINATION") !== 0 ||
    (
      document.body &&
      String(document.body.className || "").indexOf("adventureScanResultsMode") > -1
    )
  ) {
    resetDestinationChooserInlineLayout(panel);
    return;
  }

  viewport = window.visualViewport;
  viewportHeight = viewport && finite(Number(viewport.height))
    ? Number(viewport.height)
    : window.innerHeight;
  viewportTop = viewport && finite(Number(viewport.offsetTop))
    ? Number(viewport.offsetTop)
    : 0;

  /* Keep the chooser below the iPhone status area / Dynamic Island. */
  safeTop = viewportTop + 104;
  available = Math.max(250, viewportHeight - 116);

  panel.style.setProperty("position", "fixed", "important");
  panel.style.setProperty("top", Math.round(safeTop) + "px", "important");
  panel.style.setProperty("left", "12px", "important");
  panel.style.setProperty("right", "12px", "important");
  panel.style.setProperty("bottom", "auto", "important");
  panel.style.setProperty("width", "auto", "important");
  panel.style.setProperty("max-width", "none", "important");
  panel.style.setProperty("height", "auto", "important");
  panel.style.setProperty("max-height", Math.round(available) + "px", "important");
  panel.style.setProperty("margin", "0", "important");
  panel.style.setProperty("transform", "none", "important");
  panel.style.setProperty("overflow", "hidden", "important");
  panel.style.setProperty("display", "flex", "important");
  panel.style.setProperty("flex-direction", "column", "important");
  panel.style.setProperty("z-index", "30000", "important");

  head = panel.querySelector ? panel.querySelector(".diqDestHead") : null;
  if (head) {
    head.style.setProperty("position", "relative", "important");
    head.style.setProperty("top", "auto", "important");
    head.style.setProperty("flex", "0 0 auto", "important");
    head.style.setProperty("z-index", "5", "important");
  }

  list = panel.querySelector ? panel.querySelector("#diqDestList") : null;
  if (list) {
    list.style.setProperty("display", "block", "important");
    list.style.setProperty("flex", "1 1 auto", "important");
    list.style.setProperty("min-height", "0", "important");
    list.style.setProperty("height", "auto", "important");
    list.style.setProperty(
      "max-height",
      Math.max(180, Math.round(available - 56)) + "px",
      "important"
    );
    list.style.setProperty("overflow-y", "auto", "important");
    list.style.setProperty("overflow-x", "hidden", "important");
    list.style.setProperty("-webkit-overflow-scrolling", "touch", "important");
    list.style.setProperty("overscroll-behavior", "contain", "important");
    list.style.setProperty("padding-bottom", "36px", "important");
    list.style.setProperty("scroll-padding-bottom", "36px", "important");
    list.style.setProperty("touch-action", "pan-y", "important");
  }

  panel.setAttribute("data-diq-source-chooser-layout", "1");
}

function scheduleDestinationChooserLayout() {
  if (destinationChooserLayoutTimer) {
    window.clearTimeout(destinationChooserLayoutTimer);
  }

  destinationChooserLayoutTimer = window.setTimeout(
    applyDestinationChooserLayout,
    10
  );
  window.setTimeout(applyDestinationChooserLayout, 80);
  window.setTimeout(applyDestinationChooserLayout, 220);
}

function bindDestinationChooserLayout(panel) {
  if (!panel) { return; }

  if (!destinationChooserLayoutObserver && window.MutationObserver) {
    try {
      destinationChooserLayoutObserver = new MutationObserver(function () {
        var head = panel.querySelector ? panel.querySelector(".diqDestHead") : null;
        var isDestinationChooser = !!(
          head &&
          clean(head.textContent || "").toUpperCase().indexOf("CHOOSE DESTINATION") === 0
        );

        if (destinationResultOpen && isDestinationChooser) {
          scheduleDestinationChooserLayout();
        }
      });

      destinationChooserLayoutObserver.observe(panel, {
        attributes:true,
        /* Never observe style. applyDestinationChooserLayout writes inline
           styles itself; observing those writes created an endless mutation
           loop after scan completion and froze the entire UI thread. */
        attributeFilter:["class", "aria-hidden"]
      });

      if (document.body) {
        destinationChooserLayoutObserver.observe(document.body, {
          attributes:true,
          attributeFilter:["class"]
        });
      }
    } catch (e0) {}
  }

  if (!destinationChooserViewportBound) {
    destinationChooserViewportBound = true;

    window.addEventListener(
      "resize",
      scheduleDestinationChooserLayout,
      false
    );

    window.addEventListener("orientationchange", function () {
      window.setTimeout(scheduleDestinationChooserLayout, 180);
    }, false);

    if (
      window.visualViewport &&
      window.visualViewport.addEventListener
    ) {
      window.visualViewport.addEventListener(
        "resize",
        scheduleDestinationChooserLayout,
        false
      );
      window.visualViewport.addEventListener(
        "scroll",
        scheduleDestinationChooserLayout,
        false
      );
    }
  }
}

function ensureDestinationResultsPanel() {
  var panel;

  panel = byId("diqAdventureDestResults");
  if (panel) {
    bindDestinationChooserLayout(panel);
    return panel;
  }

  panel = document.createElement("div");
  panel.id = "diqAdventureDestResults";
  panel.setAttribute("aria-hidden","true");
  panel.style.display = "none";
  panel.innerHTML = '<div class="diqDestHead">CHOOSE DESTINATION</div><div id="diqDestList"></div>';

  try { document.body.appendChild(panel); } catch (e) {}

  bindDestinationChooserLayout(panel);
  return panel;
}




function hideDestinationResults() {
  var panel = byId("diqAdventureDestResults");

  destinationResultOpen = false;

  if (panel) {
    panel.className = "";
    resetDestinationChooserInlineLayout(panel);
  }

  updateClearAdventureSearchButton();
}








/* =========================================================
   DRIVE IQ V22.1 â€” DESTINATION LOCK IQ
   Once a destination is accepted, focusing the search field or a UI refresh
   must not reopen the destination chooser. The chooser only opens after the
   user intentionally changes the text away from the selected destination.
========================================================= */




function destinationLockText(item) {
  if (!item) { return ""; }
  return clean(String(item.label || "") + " " + String(item.full || "") + " " + String(item.matchLabel || ""));
}




function destinationIdentitySnapshot(item) {
  if (!item || !finite(Number(item.lat)) || !finite(Number(item.lng))) {
    return null;
  }

  return {
    label:String(item.label || "Destination"),
    full:String(item.full || item.matchLabel || ""),
    matchLabel:String(item.matchLabel || ""),
    lat:Number(item.lat),
    lng:Number(item.lng),
    kind:String(item.kind || "destination"),
    resultType:String(item.resultType || ""),
    adventureIndexId:String(item.adventureIndexId || ""),
    canonical:item.canonical === true,
    selected:true,
    ts:Date.now()
  };
}




function destinationIdentitySame(a, b) {
  if (!a || !b) { return false; }

  if (
    finite(Number(a.lat)) &&
    finite(Number(a.lng)) &&
    finite(Number(b.lat)) &&
    finite(Number(b.lng))
  ) {
    if (
      Math.abs(Number(a.lat) - Number(b.lat)) <= 0.00008 &&
      Math.abs(Number(a.lng) - Number(b.lng)) <= 0.00008
    ) {
      return true;
    }
  }

  return (
    normText(a.label || "") === normText(b.label || "") &&
    normText(a.full || "") === normText(b.full || "")
  );
}




function destinationIdentityAllowsReplacement(reason) {
  var r = String(reason || "");

  return (
    r === "destination_result_selected" ||
    r === "shopping_destination" ||
    r === "seo_intent_handoff" ||
    r === "public_scan" ||
    r === "v208_destination_selected" ||
    r === "explicit_user_selection"
  );
}




function restoreCommittedAdventureDestination(reason) {
  var saved = committedAdventureDestination;
  var input = byId("adventureSearch");

  if (!saved) { return false; }

  destination = destinationIdentitySnapshot(saved);
  if (!destination) { return false; }

  destinationLock = destinationIdentitySnapshot(saved);
  destinationLock.reason = String(
    committedAdventureDestinationReason ||
    reason ||
    "destination_identity_restore"
  );
  destinationLockInputNorm = normText(
    String(destinationLock.label || "") + " " +
    String(destinationLock.full || "")
  );

  adventureSearchCenter = {
    lat:Number(destination.lat),
    lng:Number(destination.lng),
    label:String(destination.label || "destination")
  };
  adventureSearchScope = "near_destination";
  destinationPreviewScan = true;
  adventureScanOnly = true;
  adventureDestinationCameraHold = true;
  adventureDestinationCameraHoldAt = Date.now();

  if (input && document.activeElement !== input) {
    input.value = String(destination.label || "Destination");
  }

  try { lsJSON(LS.DEST, destination); } catch (e0) {}
  try { setDestinationPin(); } catch (e1) {}
  try { syncAdventureDestinationScopeUI(); } catch (e2) {}
  try { updateClearAdventureSearchButton(); } catch (e3) {}

  return true;
}




function setDestinationLock(item, reason) {
  var incoming;
  var allowReplacement;

  if (!item || !finite(Number(item.lat)) || !finite(Number(item.lng))) {
    return false;
  }

  incoming = destinationIdentitySnapshot(item);
  allowReplacement = destinationIdentityAllowsReplacement(reason);

  /* A scan result, district decorator, route candidate, refresh, or delayed
     callback cannot replace the city/region the user explicitly selected. */
  if (
    committedAdventureDestination &&
    !allowReplacement &&
    !destinationIdentitySame(committedAdventureDestination, incoming)
  ) {
    restoreCommittedAdventureDestination("blocked_" + String(reason || "unknown"));
    return false;
  }

  destinationLock = incoming;
  destinationLock.reason = String(reason || "selected");
  destinationLockInputNorm = normText(
    String(destinationLock.label || "") + " " +
    String(destinationLock.full || "")
  );

  if (allowReplacement) {
    committedAdventureDestination = destinationIdentitySnapshot(incoming);
    committedAdventureDestinationReason = String(reason || "explicit_user_selection");
  }

  return true;
}




function syncDestinationLockFromCurrent(reason) {
  if (
    destination &&
    finite(Number(destination.lat)) &&
    finite(Number(destination.lng))
  ) {
    setDestinationLock(destination, reason || "current_destination");
  }
}




function clearDestinationLock() {
  destinationLock = null;
  destinationLockInputNorm = "";
  committedAdventureDestination = null;
  committedAdventureDestinationReason = "";
}




function destinationLockMatchesInput(value) {
  var q = normText(value);
  var label;
  var full;
  var combo;




  if (!destinationLock || !destinationLock.selected) { return false; }
  if (!q) { return false; }




  label = normText(destinationLock.label || "");
  full = normText(destinationLock.full || "");
  combo = normText(String(destinationLock.label || "") + " " + String(destinationLock.full || ""));




  if (q === label || q === full || q === combo) { return true; }
  if (label && q.indexOf(label) === 0) { return true; }
  if (label && label.indexOf(q) === 0 && q.length >= Math.min(5, label.length)) { return true; }
  if (full && full.indexOf(q) === 0 && q.length >= Math.min(6, full.length)) { return true; }
  if (destinationLockInputNorm && destinationLockInputNorm.indexOf(q) === 0 && q.length >= Math.min(6, destinationLockInputNorm.length)) { return true; }




  return false;
}




function shouldSuppressDestinationChooser(query) {
  var q = clean(query);
  if (!q) { return false; }
  return destinationLockMatchesInput(q);
}




function destinationSearchWasIntentionallyChanged(query) {
  var q = clean(query);
  if (!q || q.length < 2) { return false; }
  if (!destinationLock || !destinationLock.selected) { return true; }
  return !destinationLockMatchesInput(q);
}




function destinationMeta(item) {
  var parts = [];
  if (!item) { return ""; }
  if (item.distMiles !== null && finite(Number(item.distMiles))) { parts.push(itemDistanceText(item)); }
  if (item.resultType === "adventure_index") {
    parts.push("Adventure Region");
  } else if (item.kind) {
    parts.push(titleCaseWords(String(item.kind).replace(/_/g, " ")));
  }
  return parts.join(" â€¢ ");
}




/* =========================================================
   DRIVE IQ V24.3 â€” NATURAL DESTINATION IQ
========================================================= */




/* =========================================================
   DRIVE IQ V24.4 â€” REGIONAL DRIVE IQ + SHOPPING IQ
========================================================= */




/* =========================================================
   DRIVE IQ V24.5 â€” ADVENTURE DESTINATION INDEX
   Canonical adventure regions supplement geocoder results.
   This is an extensible nationwide architecture, not a one-off fix.
========================================================= */




var ADVENTURE_DESTINATION_INDEX = [
  {
    id:"pickwick_lake",
    label:"Pickwick Lake",
    aliases:["pickwick","pickwick lake","pickwick reservoir","pickwick landing","pickwick dam"],
    type:"lake",
    lat:35.0495,
    lng:-88.2517,
    region:"Tennessee / Mississippi / Alabama",
    full:"Pickwick Lake region near Pickwick Landing State Park and Pickwick Dam",
    gateways:["Pickwick Landing State Park","Pickwick Dam","Counce, Tennessee","Iuka, Mississippi"],
    related:["marina","boating","camping","waterfront","fishing","fireworks"],
    season:["summer","fourth_of_july"],
    popularity:96
  },
  {
    id:"lake_of_the_ozarks",
    label:"Lake of the Ozarks",
    aliases:["lake of the ozarks","ozarks lake"],
    type:"lake",
    lat:38.1302,
    lng:-92.6697,
    region:"Missouri",
    full:"Lake of the Ozarks, Missouri",
    gateways:["Osage Beach","Lake Ozark","Camdenton"],
    related:["boating","marina","waterfront","camping","nightlife"],
    season:["summer","fourth_of_july"],
    popularity:99
  },
  {
    id:"table_rock_lake",
    label:"Table Rock Lake",
    aliases:["table rock","table rock lake"],
    type:"lake",
    lat:36.5787,
    lng:-93.3114,
    region:"Missouri / Arkansas",
    full:"Table Rock Lake near Branson, Missouri",
    gateways:["Branson","Table Rock State Park","Indian Point"],
    related:["boating","marina","camping","family"],
    season:["summer"],
    popularity:94
  },
  {
    id:"kentucky_lake",
    label:"Kentucky Lake",
    aliases:["kentucky lake","land between the lakes"],
    type:"lake",
    lat:36.9206,
    lng:-88.1819,
    region:"Kentucky / Tennessee",
    full:"Kentucky Lake and Land Between the Lakes region",
    gateways:["Land Between the Lakes","Paris Landing","Murray"],
    related:["boating","camping","fishing","waterfront"],
    season:["summer"],
    popularity:92
  },
  {
    id:"guntersville_lake",
    label:"Lake Guntersville",
    aliases:["guntersville lake","lake guntersville"],
    type:"lake",
    lat:34.3654,
    lng:-86.2950,
    region:"Alabama",
    full:"Lake Guntersville, Alabama",
    gateways:["Guntersville","Lake Guntersville State Park"],
    related:["boating","fishing","camping","waterfront"],
    season:["summer"],
    popularity:90
  },
  {
    id:"great_smoky_mountains",
    label:"Great Smoky Mountains",
    aliases:["great smoky mountains","smokies","smoky mountains"],
    type:"national_park",
    lat:35.6118,
    lng:-83.4895,
    region:"Tennessee / North Carolina",
    full:"Great Smoky Mountains National Park",
    gateways:["Gatlinburg","Pigeon Forge","Cherokee"],
    related:["hiking","scenic","waterfalls","camping"],
    season:["spring","summer","fall"],
    popularity:100
  },
  {
    id:"yellowstone",
    label:"Yellowstone National Park",
    aliases:["yellowstone","yellowstone national park"],
    type:"national_park",
    lat:44.4280,
    lng:-110.5885,
    region:"Wyoming / Montana / Idaho",
    full:"Yellowstone National Park",
    gateways:["West Yellowstone","Gardiner","Cody"],
    related:["wildlife","hiking","scenic","camping"],
    season:["summer"],
    popularity:100
  },
  {
    id:"gulf_shores",
    label:"Gulf Shores",
    aliases:["gulf shores","orange beach"],
    type:"beach",
    lat:30.2460,
    lng:-87.7008,
    region:"Alabama",
    full:"Gulf Shores and Orange Beach, Alabama",
    gateways:["Gulf Shores","Orange Beach"],
    related:["beach","seafood","waterfront","family"],
    season:["spring","summer"],
    popularity:96
  },
  {
    id:"destin",
    label:"Destin",
    aliases:["destin","destin florida"],
    type:"beach",
    lat:30.3935,
    lng:-86.4958,
    region:"Florida",
    full:"Destin, Florida",
    gateways:["Destin","HarborWalk Village","Okaloosa Island"],
    related:["beach","waterfront","seafood","boating"],
    season:["spring","summer"],
    popularity:98
  },
  {
    id:"dollywood",
    label:"Dollywood",
    aliases:["dollywood","dollywood theme park"],
    type:"theme_park",
    lat:35.7951,
    lng:-83.5305,
    region:"Tennessee",
    full:"Dollywood in Pigeon Forge, Tennessee",
    gateways:["Pigeon Forge","Gatlinburg"],
    related:["theme park","family","shows","rides"],
    season:["spring","summer","fall","winter"],
    popularity:98
  },
  {
    id:"disney_world",
    label:"Walt Disney World",
    aliases:["disney world","walt disney world","magic kingdom"],
    type:"theme_park",
    lat:28.3852,
    lng:-81.5639,
    region:"Florida",
    full:"Walt Disney World Resort, Florida",
    gateways:["Orlando","Lake Buena Vista"],
    related:["theme park","family","rides","resort"],
    season:["year_round"],
    popularity:100
  }
];




function currentAdventureSeasonKey() {
  var now = new Date();
  var month = now.getMonth() + 1;
  var day = now.getDate();




  if ((month === 6 && day >= 20) || (month === 7 && day <= 10)) {
    return "fourth_of_july";
  }
  if (month >= 6 && month <= 8) { return "summer"; }
  if (month >= 9 && month <= 11) { return "fall"; }
  if (month === 12 || month <= 2) { return "winter"; }
  return "spring";
}




function adventureDestinationIndexMatch(query) {
  var q = normText(query);
  var best = null;
  var bestScore = -9999;
  var season = currentAdventureSeasonKey();
  var i;
  var j;
  var item;
  var alias;
  var score;
  var distance;




  if (!q) { return null; }




  for (i = 0; i < ADVENTURE_DESTINATION_INDEX.length; i++) {
    item = ADVENTURE_DESTINATION_INDEX[i];
    score = 0;




    for (j = 0; j < item.aliases.length; j++) {
      alias = normText(item.aliases[j]);




      if (q === alias) { score += 500; }
      else if (q.indexOf(alias) > -1 || alias.indexOf(q) > -1) { score += 260; }
    }




    if (normText(item.label) === q) { score += 520; }
    if (naturalDestinationIntent(q) && item.type === naturalDestinationIntent(q)) { score += 180; }




    distance = distanceMilesFromLastFix(item.lat, item.lng);
    if (finite(distance)) {
      score += regionalDistanceScore(distance, score >= 500);
    }




    if (item.season && item.season.indexOf(season) > -1) { score += 55; }
    score += Number(item.popularity || 0) * 0.55;




    if (score > bestScore) {
      bestScore = score;
      best = item;
    }
  }




  return bestScore >= 220 ? best : null;
}




function distanceMilesFromLastFix(lat, lng) {
  var R = 3958.7613;
  var a;
  var dLat;
  var dLng;
  var lat1;
  var lat2;




  if (!lastFix || !finite(Number(lastFix.lat)) || !finite(Number(lastFix.lng))) {
    return null;
  }




  lat1 = Number(lastFix.lat) * Math.PI / 180;
  lat2 = Number(lat) * Math.PI / 180;
  dLat = (Number(lat) - Number(lastFix.lat)) * Math.PI / 180;
  dLng = (Number(lng) - Number(lastFix.lng)) * Math.PI / 180;




  a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1) * Math.cos(lat2) *
    Math.sin(dLng / 2) * Math.sin(dLng / 2);




  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}




function indexedAdventureItem(entity) {
  var distance = distanceMilesFromLastFix(entity.lat, entity.lng);




  return {
    label:String(entity.label || "Adventure destination"),
    full:String(entity.full || entity.region || ""),
    lat:Number(entity.lat),
    lng:Number(entity.lng),
    kind:String(entity.type || "destination"),
    category:String(entity.type || "destination"),
    resultType:"adventure_index",
    matchLabel:"Adventure Destination",
    distMiles:finite(distance) ? distance : null,
    adventureIndexId:String(entity.id || ""),
    gateways:entity.gateways || [],
    related:entity.related || [],
    popularity:Number(entity.popularity || 0),
    canonical:true
  };
}




function isWeakAdventureDestinationType(item) {
  var txt = naturalDestinationResultTypeText(item);




  return txt.indexOf("postcode") > -1 ||
    txt.indexOf("district") > -1 ||
    txt.indexOf("administrative") > -1 ||
    txt.indexOf("amenity") > -1 ||
    txt.indexOf("residential") > -1 ||
    txt.indexOf("neighbourhood") > -1 ||
    txt.indexOf("neighborhood") > -1;
}




function hardGateAdventureDestinationResults(items, query) {
  var intent = naturalDestinationIntent(query);
  var indexed = adventureDestinationIndexMatch(query);
  var out = [];
  var i;
  var item;




  if (indexed) {
    out.push(indexedAdventureItem(indexed));
  }




  for (i = 0; i < (items || []).length; i++) {
    item = items[i];
    if (!item) { continue; }




    if (intent) {
      if (isWeakAdventureDestinationType(item)) { continue; }
      if (!isNaturalDestinationResult(item, intent)) { continue; }
    }




    out.push(item);
  }




  return dedupe(out);
}




function resolveIndexedAdventureDestination(query) {
  var entity = adventureDestinationIndexMatch(query);
  var item;




  if (!entity) { return false; }




  item = indexedAdventureItem(entity);
  routeDestinationResult(item);
  return true;
}




function regionalDistanceScore(distanceMiles, exactIntent) {
  var d = Number(distanceMiles);
  if (!finite(d)) { return exactIntent ? -12 : -40; }




  if (d <= 25) { return 120; }
  if (d <= 75) { return 95; }
  if (d <= 150) { return 70; }
  if (d <= 250) { return 42; }
  if (d <= 350) { return 18; }
  if (d <= 500) { return exactIntent ? -5 : -55; }
  if (d <= 800) { return exactIntent ? -28 : -110; }
  return exactIntent ? -65 : -180;
}




function isExactDestinationIntent(item, query) {
  var q = normText(query);
  var label = normText(item && item.label || "");
  var full = normText(item && item.full || "");




  if (!q || !item) { return false; }
  if (label === q) { return true; }
  if (full === q) { return true; }
  if (label.indexOf(q) === 0 && q.length >= 5) { return true; }
  if (full.indexOf(q) > -1 && q.length >= 6) { return true; }




  return false;
}




function shoppingIntentType(query) {
  var q = normText(query);




  if (!q) { return ""; }
  if (q.indexOf("boutique") > -1) { return "boutiques"; }
  if (q.indexOf("antique") > -1 || q.indexOf("vintage") > -1) { return "antiques"; }
  if (q.indexOf("outlet") > -1) { return "outlets"; }
  if (q.indexOf("home decor") > -1 || q.indexOf("decor") > -1) { return "home_decor"; }
  if (q.indexOf("gift shop") > -1 || q.indexOf("gifts") > -1) { return "gifts"; }
  if (q.indexOf("bookstore") > -1 || q.indexOf("book shop") > -1) { return "bookstores"; }
  if (q.indexOf("farmers market") > -1 || q.indexOf("market") > -1) { return "markets"; }
  if (q.indexOf("shopping district") > -1 || q.indexOf("shopping area") > -1) { return "districts"; }
  if (q.indexOf("local shops") > -1 || q.indexOf("shops") > -1 || q.indexOf("shopping") > -1) { return "shopping"; }




  return "";
}




function shoppingQueryDestinationText(query) {
  var q = clean(query);
  var stripped;




  if (!shoppingIntentType(q)) { return ""; }




  stripped = q
    .replace(/\b(boutiques?|shopping districts?|shopping areas?|local shops?|shops?|shopping|antiques?|vintage|outlets?|home decor|decor|gift shops?|gifts?|bookstores?|book shops?|farmers markets?|markets?)\b/ig, " ")
    .replace(/[,|/]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();




  return stripped;
}




function shoppingSearchTerms(query) {
  var intent = shoppingIntentType(query);
  var terms = [];




  if (intent === "boutiques") {
    terms = ["boutique", "fashion boutique", "clothing store", "local shop"];
  } else if (intent === "antiques") {
    terms = ["antique store", "vintage shop", "collectibles", "antique mall"];
  } else if (intent === "outlets") {
    terms = ["outlet mall", "factory outlet", "shopping outlet"];
  } else if (intent === "home_decor") {
    terms = ["home decor", "furniture store", "interior shop", "gift shop"];
  } else if (intent === "gifts") {
    terms = ["gift shop", "local gifts", "souvenir shop", "artisan shop"];
  } else if (intent === "bookstores") {
    terms = ["bookstore", "independent bookstore", "book shop"];
  } else if (intent === "markets") {
    terms = ["farmers market", "public market", "artisan market", "market hall"];
  } else if (intent === "districts") {
    terms = ["shopping district", "retail district", "walkable shopping"];
  } else if (intent === "shopping") {
    terms = ["local shopping", "shopping district", "boutique", "market"];
  }




  return terms;
}




function isShoppingResult(item, intent) {
  var txt = naturalDestinationResultTypeText(item);




  if (!intent) { return false; }




  if (intent === "boutiques") {
    return txt.indexOf("boutique") > -1 ||
      txt.indexOf("fashion") > -1 ||
      txt.indexOf("clothing") > -1 ||
      txt.indexOf("apparel") > -1;
  }
  if (intent === "antiques") {
    return txt.indexOf("antique") > -1 ||
      txt.indexOf("vintage") > -1 ||
      txt.indexOf("collectible") > -1;
  }
  if (intent === "outlets") {
    return txt.indexOf("outlet") > -1 ||
      txt.indexOf("shopping centre") > -1 ||
      txt.indexOf("shopping center") > -1 ||
      txt.indexOf("mall") > -1;
  }
  if (intent === "home_decor") {
    return txt.indexOf("decor") > -1 ||
      txt.indexOf("furniture") > -1 ||
      txt.indexOf("interior") > -1;
  }
  if (intent === "gifts") {
    return txt.indexOf("gift") > -1 ||
      txt.indexOf("souvenir") > -1 ||
      txt.indexOf("artisan") > -1;
  }
  if (intent === "bookstores") {
    return txt.indexOf("bookstore") > -1 ||
      txt.indexOf("book shop") > -1 ||
      txt.indexOf("books") > -1;
  }
  if (intent === "markets") {
    return txt.indexOf("market") > -1 ||
      txt.indexOf("farmers") > -1 ||
      txt.indexOf("artisan") > -1;
  }




  return txt.indexOf("shop") > -1 ||
    txt.indexOf("retail") > -1 ||
    txt.indexOf("mall") > -1 ||
    txt.indexOf("market") > -1;
}




function shouldTreatAsShoppingAdventure(query) {
  return !!shoppingIntentType(query);
}




function naturalDestinationIntent(query) {
  var q = normText(query);
  if (!q) { return ""; }
  if (q.indexOf("state park") > -1) { return "state_park"; }
  if (q.indexOf("national park") > -1) { return "national_park"; }
  if (q.indexOf("lake") > -1 || q.indexOf("reservoir") > -1) { return "lake"; }
  if (q.indexOf("river") > -1) { return "river"; }
  if (q.indexOf("beach") > -1 || q.indexOf("shore") > -1) { return "beach"; }
  if (q.indexOf("mountain") > -1 || q.indexOf("mountains") > -1) { return "mountain"; }
  if (q.indexOf("park") > -1) { return "park"; }
  if (q.indexOf("county") > -1) { return "county"; }
  return "";
}




function naturalDestinationQueryVariants(query) {
  var q = clean(query);
  var intent = naturalDestinationIntent(q);
  var out = [q];
  var base;




  if (!intent) { return out; }




  base = q
    .replace(/\b(state|national)\s+park\b/ig, "")
    .replace(/\b(lake|reservoir|river|beach|shore|mountain|mountains|park|county)\b/ig, "")
    .replace(/\s+/g, " ")
    .trim();




  function add(v) {
    var i;
    var n = normText(v);
    if (!v || !n) { return; }
    for (i = 0; i < out.length; i++) {
      if (normText(out[i]) === n) { return; }
    }
    out.push(v);
  }




  if (intent === "lake") {
    add(base + " Lake");
    add(base + " Reservoir");
    add(base + " State Park");
    add(base + " Landing State Park");
    add(base + " Tennessee");
  } else if (intent === "river") {
    add(base + " River");
    add(base + " River Park");
  } else if (intent === "state_park") {
    add(base + " State Park");
    add(base + " Park");
  } else if (intent === "national_park") {
    add(base + " National Park");
  } else if (intent === "beach") {
    add(base + " Beach");
    add(base + " Shore");
  } else if (intent === "mountain") {
    add(base + " Mountain");
    add(base + " Mountains");
  } else if (intent === "park") {
    add(base + " Park");
    add(base + " State Park");
  }




  return out.slice(0, 6);
}




function naturalDestinationResultTypeText(item) {
  return normText(
    String(item && item.kind || "") + " " +
    String(item && item.label || "") + " " +
    String(item && item.full || "") + " " +
    String(item && item.category || "") + " " +
    String(item && item.resultType || "")
  );
}




function isStreetLikeDestination(item) {
  var txt = naturalDestinationResultTypeText(item);
  return txt.indexOf(" street") > -1 ||
    txt.indexOf(" road") > -1 ||
    txt.indexOf(" lane") > -1 ||
    txt.indexOf(" avenue") > -1 ||
    txt.indexOf(" boulevard") > -1 ||
    txt.indexOf(" drive") > -1 ||
    txt.indexOf(" highway") > -1 ||
    txt.indexOf(" address") > -1 ||
    txt.indexOf(" building") > -1 ||
    txt.indexOf(" residential") > -1;
}




function isNaturalDestinationResult(item, intent) {
  var txt = naturalDestinationResultTypeText(item);
  if (!intent) { return false; }




  if (intent === "lake") {
    return txt.indexOf(" lake") > -1 ||
      txt.indexOf(" reservoir") > -1 ||
      txt.indexOf(" water") > -1 ||
      txt.indexOf(" natural") > -1 ||
      txt.indexOf(" state park") > -1 ||
      txt.indexOf(" marina") > -1;
  }
  if (intent === "river") {
    return txt.indexOf(" river") > -1 ||
      txt.indexOf(" water") > -1 ||
      txt.indexOf(" natural") > -1;
  }
  if (intent === "state_park" || intent === "national_park" || intent === "park") {
    return txt.indexOf(" park") > -1 ||
      txt.indexOf(" protected") > -1 ||
      txt.indexOf(" recreation") > -1 ||
      txt.indexOf(" tourism") > -1 ||
      txt.indexOf(" natural") > -1;
  }
  if (intent === "beach") {
    return txt.indexOf(" beach") > -1 ||
      txt.indexOf(" shore") > -1 ||
      txt.indexOf(" coast") > -1 ||
      txt.indexOf(" water") > -1;
  }
  if (intent === "mountain") {
    return txt.indexOf(" mountain") > -1 ||
      txt.indexOf(" peak") > -1 ||
      txt.indexOf(" ridge") > -1 ||
      txt.indexOf(" natural") > -1;
  }
  if (intent === "county") {
    return txt.indexOf(" county") > -1 ||
      txt.indexOf(" administrative") > -1;
  }
  return false;
}




function filterNaturalDestinationResults(items, query) {
  var intent = naturalDestinationIntent(query);




  if (!intent) {
    return hardGateAdventureDestinationResults(items || [], query);
  }




  return hardGateAdventureDestinationResults(items || [], query);
}




function isSafeAutoCommitDestination(item, query) {
  var intent = naturalDestinationIntent(query);




  if (!item) { return false; }
  if (item.canonical || item.resultType === "adventure_index") { return true; }
  if (intent && isStreetLikeDestination(item)) { return false; }
  if (intent && isWeakAdventureDestinationType(item)) { return false; }
  if (intent && !isNaturalDestinationResult(item, intent)) { return false; }




  return true;
}




function scoreDestination(item, query) {
  var q = normText(query);
  var label = normText(item && item.label || "");
  var txt = normText(String(item && item.label || "") + " " + String(item && item.full || ""));
  var kind = normText(item && item.kind || "");
  var d = item && finite(Number(item.distMiles)) ? Number(item.distMiles) : 99999;
  var intent = naturalDestinationIntent(query);
  var exactIntent = isExactDestinationIntent(item, query);
  var score = 0;




  if (!item) { return -9999; }
  if (label === q) { score += 260; }
  if (txt === q) { score += 220; }
  if (txt.indexOf(q) > -1) { score += 120; }
  if (q && label.indexOf(q) > -1) { score += 140; }




  if (kind.indexOf("city") > -1 || kind.indexOf("postcode") > -1) { score += 70; }
  if (kind.indexOf("amenity") > -1 || kind.indexOf("tourism") > -1) { score += 35; }




  if (intent) {
    if (isNaturalDestinationResult(item, intent)) { score += 260; }
    if (label.indexOf(q) > -1) { score += 120; }
    if (isStreetLikeDestination(item)) { score -= 520; }
    if (
      kind.indexOf("street") > -1 ||
      kind.indexOf("building") > -1 ||
      kind.indexOf("address") > -1
    ) {
      score -= 360;
    }
    if (
      txt.indexOf("hotel") > -1 ||
      txt.indexOf("motel") > -1 ||
      txt.indexOf("restaurant") > -1 ||
      txt.indexOf("store") > -1
    ) {
      score -= 120;
    }
  }




  if (finite(d)) {
    score += regionalDistanceScore(d, exactIntent);
  } else {
    score += regionalDistanceScore(null, exactIntent);
  }




  if (
    q.indexOf("hotel") < 0 &&
    q.indexOf("motel") < 0 &&
    q.indexOf("inn") < 0 &&
    q.indexOf("johnson") < 0
  ) {
    if (
      txt.indexOf("hotel") > -1 ||
      txt.indexOf("motel") > -1 ||
      txt.indexOf("inn") > -1 ||
      txt.indexOf("howard johnson") > -1
    ) {
      score -= 90;
    }
  }




  return score;
}




function renderDestinationResults(results, query) {
  var panel = ensureDestinationResultsPanel();
  var list = byId("diqDestList");
  var i;
  var item;
  var btn;
  var name;
  var sub;
  var meta;
  var photoStyle;
  var photoClass;




  if (!panel || !list) { return; }




  try {
    var head = panel.querySelector ? panel.querySelector(".diqDestHead") : null;
    if (head) { head.textContent = "CHOOSE DESTINATION"; }
  } catch (headErr) {}




  destinationSearchResults = results && results.length ? results.slice(0, 8) : [];
  list.innerHTML = "";




  if (!destinationSearchResults.length) {
    list.innerHTML = '<button type="button" class="diqDestItem"><div class="diqDestName">No destination matches yet</div><div class="diqDestSub">Try a city, lake, park, theme park, beach, mountain town, or attraction.</div></button>';
    panel.className = "on";
    destinationResultOpen = true;
    scheduleDestinationChooserLayout();
    return;
  }




  for (i = 0; i < destinationSearchResults.length; i++) {
    item = enrichAdventureItem(destinationSearchResults[i], query);
    destinationSearchResults[i] = item;
    btn = document.createElement("button");
    btn.type = "button";
    btn.className = "diqDestItem";
    btn.setAttribute("data-dest-idx", String(i));




    name = clean(item.label || "Destination");
    sub = clean(item.full || "");
    meta = clean(destinationMeta(item));




    btn.innerHTML =
      '<div class="diqDestName">' + escapeHTML(name) + '</div>' +
      '<div class="diqDestSub">' + escapeHTML(sub || "Tap to route here") + '</div>' +
      '<div class="diqDestMeta">' + escapeHTML(meta || "Destination match") + '</div>';




    btn.onclick = function () {
      var idx = Number(this.getAttribute("data-dest-idx"));
      if (idx >= 0 && destinationSearchResults[idx]) {
        hideDestinationResults();
        dismissAdventureKeyboard();
        routeDestinationResult(destinationSearchResults[idx]);
      }
    };




    list.appendChild(btn);
  }




  panel.className = "on";
  destinationResultOpen = true;
  scheduleDestinationChooserLayout();
  updateClearAdventureSearchButton();
}




function escapeHTML(v) {
  return String(v || "").replace(/[&<>"']/g, function (ch) {
    if (ch === "&") { return "&amp;"; }
    if (ch === "<") { return "&lt;"; }
    if (ch === ">") { return "&gt;"; }
    if (ch === '"') { return "&quot;"; }
    return "&#39;";
  });
}




function diqLooksLikeImageUrl(url) {
  var u = clean(url);
  var low = u.toLowerCase();
  if (!u) { return false; }
  if (u.indexOf("http") !== 0 && u.indexOf("data:image") !== 0) { return false; }




  /* V36: Google Places API (New) photo media URLs are real image
     endpoints. They may not look like jpg/png URLs, so allow them before
     the generic map/static/sprite rejection rules. */
  if (
    low.indexOf("places.googleapis.com/v1/places/") > -1 &&
    low.indexOf("/photos/") > -1 &&
    low.indexOf("/media") > -1
  ) {
    return true;
  }




  if (low.indexOf("maps.googleapis.com/maps/api/place/photo") > -1) { return true; }
  if (low.indexOf("api.mapbox.com/styles") > -1) { return false; }
  if (low.indexOf("maps.googleapis.com/maps/api/staticmap") > -1) { return false; }
  if (low.indexOf("/static/") > -1 && low.indexOf("map") > -1) { return false; }
  if (low.indexOf("sprite") > -1 || low.indexOf("marker") > -1 || low.indexOf("pin-") > -1) { return false; }
  return true;
}




function diqCssPhotoUrl(url) {
  var u = clean(url);
  if (!u) { return ""; }




  /* V36: Do not HTML-escape URLs used via setAttribute("style", ...).
     Escaping converts & to &amp; and can break Google photo media query
     params. Only protect CSS quote/backslash characters. */
  return u
    .replace(/\\/g, "%5C")
    .replace(/'/g, "%27")
    .replace(/"/g, "%22")
    .replace(/\)/g, "%29")
    .replace(/\(/g, "%28");
}




function diqPhotoKindPriority(kind) {
  kind = normText(kind);
  if (kind.indexOf("official") > -1 || kind.indexOf("business") > -1) { return 1; }
  if (kind.indexOf("gallery") > -1 || kind.indexOf("venue") > -1) { return 2; }
  if (kind.indexOf("food") > -1 || kind.indexOf("patio") > -1 || kind.indexOf("interior") > -1 || kind.indexOf("water") > -1) { return 3; }
  if (kind.indexOf("verified") > -1 || kind.indexOf("user") > -1 || kind.indexOf("media") > -1) { return 4; }
  if (kind.indexOf("map") > -1) { return 99; }
  return 6;
}




function diqImageKeyLabel(key) {
  key = normText(key);
  if (key.indexOf("logo") > -1 || key.indexOf("icon") > -1) { return "Logo"; }
  if (key.indexOf("food") > -1 || key.indexOf("menu") > -1 || key.indexOf("dish") > -1) { return "Food Photo"; }
  if (key.indexOf("patio") > -1 || key.indexOf("outdoor") > -1 || key.indexOf("terrace") > -1) { return "Patio Photo"; }
  if (key.indexOf("inside") > -1 || key.indexOf("interior") > -1) { return "Interior Photo"; }
  if (key.indexOf("water") > -1 || key.indexOf("lake") > -1 || key.indexOf("river") > -1 || key.indexOf("beach") > -1) { return "Water View"; }
  if (key.indexOf("gallery") > -1 || key.indexOf("photos") > -1 || key.indexOf("images") > -1 || key.indexOf("media") > -1) { return "Gallery Photo"; }
  if (key.indexOf("photo") > -1 || key.indexOf("image") > -1 || key.indexOf("picture") > -1) { return "Place Photo"; }
  return "Place Photo";
}




function diqImageKeyKind(key) {
  key = normText(key);
  if (key.indexOf("official") > -1 || key.indexOf("business") > -1) { return "official"; }
  if (key.indexOf("gallery") > -1 || key.indexOf("photos") > -1 || key.indexOf("images") > -1 || key.indexOf("media") > -1) { return "gallery"; }
  if (key.indexOf("food") > -1 || key.indexOf("menu") > -1 || key.indexOf("dish") > -1) { return "food"; }
  if (key.indexOf("patio") > -1 || key.indexOf("outdoor") > -1 || key.indexOf("terrace") > -1) { return "patio"; }
  if (key.indexOf("inside") > -1 || key.indexOf("interior") > -1) { return "interior"; }
  if (key.indexOf("verified") > -1 || key.indexOf("user") > -1 || key.indexOf("review") > -1) { return "verified"; }
  return "official";
}




function firstUsableImageUrl(obj) {
  var keys = [
    "official_photo","officialPhoto","business_photo","businessPhoto","hero_photo","heroPhoto",
    "photo","photo_url","photoUrl","image","image_url","imageUrl","thumbnail","thumbnail_url","thumbnailUrl",
    "picture","picture_url","pictureUrl","preview","preview_url","previewUrl","media_url","mediaUrl"
  ];
  var i;
  var key;
  var v;
  if (!obj) { return ""; }
  for (i = 0; i < keys.length; i++) {
    key = keys[i];
    v = obj[key];
    if (v && typeof v === "string" && diqLooksLikeImageUrl(v)) { return String(v); }
    if (v && typeof v === "object") {
      if (v.url && diqLooksLikeImageUrl(v.url)) { return String(v.url); }
      if (v.src && diqLooksLikeImageUrl(v.src)) { return String(v.src); }
    }
  }
  return "";
}




function diqCollectPhotoCandidates(obj, list, labelPrefix, depth) {
  var k;
  var v;
  var i;
  var label;
  var kind;
  if (!obj || depth > 3) { return; }
  if (typeof obj === "string") {
    diqAddUniquePhoto(list, obj, labelPrefix || "Place Photo", "gallery");
    return;
  }
  if (obj.length && typeof obj !== "string") {
    for (i = 0; i < obj.length && i < 18; i++) { diqCollectPhotoCandidates(obj[i], list, labelPrefix || "Gallery Photo", depth + 1); }
    return;
  }
  if (typeof obj !== "object") { return; }
  for (k in obj) {
    if (!obj.hasOwnProperty(k)) { continue; }
    v = obj[k];
    label = diqImageKeyLabel(k);
    kind = diqImageKeyKind(k);
    if (typeof v === "string") {
      if (diqLooksLikeImageUrl(v)) { diqAddUniquePhoto(list, v, labelPrefix || label, kind); }
    } else if (v && typeof v === "object") {
      if (v.url && diqLooksLikeImageUrl(v.url)) { diqAddUniquePhoto(list, v.url, v.label || labelPrefix || label, v.kind || kind); }
      if (v.src && diqLooksLikeImageUrl(v.src)) { diqAddUniquePhoto(list, v.src, v.label || labelPrefix || label, v.kind || kind); }
      if (/(photo|image|picture|gallery|media|thumbnail|wiki|source|raw|datasource)/i.test(k)) {
        diqCollectPhotoCandidates(v, list, labelPrefix || label, depth + 1);
      }
    }
  }
}




function extractFeaturePhoto(properties) {
  var p = properties || {};
  var photos = [];
  var raw;
  var v;
  v = firstUsableImageUrl(p);
  if (v) { return v; }
  try { diqCollectPhotoCandidates(p, photos, "Place Photo", 0); } catch (e0) {}
  if (photos.length) { return photos[0].url; }
  if (p.datasource && p.datasource.raw) {
    raw = p.datasource.raw;
    v = firstUsableImageUrl(raw);
    if (v) { return v; }
    try { diqCollectPhotoCandidates(raw, photos, "Verified Photo", 0); } catch (e1) {}
    if (photos.length) { return photos[0].url; }
  }
  if (p.wiki_and_media) {
    v = firstUsableImageUrl(p.wiki_and_media);
    if (v) { return v; }
    try { diqCollectPhotoCandidates(p.wiki_and_media, photos, "Media Photo", 0); } catch (e2) {}
    if (photos.length) { return photos[0].url; }
  }
  return "";
}




function staticMapPhotoUrl(item) {
  var lat;
  var lng;
  var token;
  if (!item) { return ""; }
  lat = Number(item.lat);
  lng = Number(item.lng);
  token = MAPBOX_TOKEN;
  if (!finite(lat) || !finite(lng) || !token) { return ""; }
  return "https://api.mapbox.com/styles/v1/mapbox/satellite-streets-v12/static/pin-s+ffce69(" + encodeURIComponent(String(lng)) + "," + encodeURIComponent(String(lat)) + ")/" + encodeURIComponent(String(lng)) + "," + encodeURIComponent(String(lat)) + ",14,0,55/520x260@2x?access_token=" + encodeURIComponent(token);
}




function categoryPhotoClass(item, query) {
  var cat = adventurePrimaryCategory(item, query);
  if (cat === "waterfront" || cat === "water" || cat === "waterfalls") { return "water"; }
  if (cat === "patio vibes" || cat === "food iq" || cat === "coffee iq" || cat === "food drinks" || cat === "popular tonight" || cat === "live music") { return "dining"; }
  if (cat === "trails" || cat === "parks" || cat === "scenic" || cat === "run walk" || cat === "camping") { return "outdoor"; }
  return "local";
}




function photoStyleForItem(item, query) {
  var gallery;
  var url = item && item.photoUrl ? String(item.photoUrl) : "";
  if (!diqLooksLikeImageUrl(url)) {
    try {
      gallery = diqBuildPlaceGallery ? diqBuildPlaceGallery(item, query || activeLens) : [];
      if (gallery && gallery.length && gallery[0].url && gallery[0].kind !== "map") { url = gallery[0].url; }
      else { url = ""; }
    } catch (e) { url = ""; }
  }
  if (url) { return "background-image:url('" + diqCssPhotoUrl(url) + "');"; }
  return "";
}




/* =========================================================
   DRIVE IQ V24.2 â€” DESTINATION COMMIT IQ
   A typed destination followed by SCAN or Return must become the active
   Adventure Center immediately. It must never continue scanning a stale
   Near Me location while showing different text in the destination field.
========================================================= */




function dismissAdventureKeyboard() {
  var input = byId("adventureSearch");




  try {
    if (input && input.blur) { input.blur(); }
  } catch (e1) {}




  try {
    if (document.activeElement && document.activeElement.blur) {
      document.activeElement.blur();
    }
  } catch (e2) {}
}




function syncAdventureDestinationScopeUI() {
  var centerValue = byId("adventureCenterValue");
  var start = byId("startAdventure");
  var scopeButtons;
  var i;
  var buttonScope;
  var name = destination && destination.label
    ? String(destination.label)
    : "Destination";




  adventureSearchScope = "near_destination";




  if (centerValue) {
    centerValue.textContent = "ðŸ“ Exploring Around " + name;
  }




  try {
    scopeButtons = document.querySelectorAll
      ? document.querySelectorAll("[data-adventure-scope],[data-scope]")
      : [];




    for (i = 0; i < scopeButtons.length; i++) {
      buttonScope =
        scopeButtons[i].getAttribute("data-adventure-scope") ||
        scopeButtons[i].getAttribute("data-scope") ||
        "";




      if (
        buttonScope === "near_destination" ||
        buttonScope === "destination"
      ) {
        if (String(scopeButtons[i].className || "").indexOf(" on") < 0) {
          scopeButtons[i].className = String(scopeButtons[i].className || "") + " on";
        }
        scopeButtons[i].setAttribute("aria-pressed", "true");
      } else if (
        buttonScope === "near_me" ||
        buttonScope === "along_route"
      ) {
        scopeButtons[i].className = String(scopeButtons[i].className || "")
          .replace(/\s+on/g, "");
        scopeButtons[i].setAttribute("aria-pressed", "false");
      }
    }
  } catch (scopeErr) {}




  if (start && destination) {
    start.disabled = false;
    start.className = "startAdventure";
    start.textContent = "EXPLORE DESTINATION";
  }




  try {
    if (window.DRIVE_IQ_SYNC_ADVENTURE_CENTER) {
      window.DRIVE_IQ_SYNC_ADVENTURE_CENTER();
    }
  } catch (syncErr) {}
}




function resolveDestinationAndScan(query) {
  var q = clean(query);
  var token;
  var urls;
  var all = [];
  var pending = 0;




  if (!q || q.length < 2) {
    dismissAdventureKeyboard();
    startAdventure();
    return;
  }




  if (shouldTreatAsShoppingAdventure(q)) {
    dismissAdventureKeyboard();
    resolveShoppingAdventure(q);
    return;
  }




  if (isExplicitExperienceQuery(q)) {
    dismissAdventureKeyboard();
    setLens(q);
    return;
  }




  if (resolveIndexedAdventureDestination(q)) {
    dismissAdventureKeyboard();
    return;
  }




  if (!GEOAPIFY_KEY) {
    toast("Search unavailable");
    return;
  }




  dismissAdventureKeyboard();
  hideDestinationResults();




  destinationSearchToken += 1;
  token = destinationSearchToken;




  startScanTab("SETTING DESTINATION", "Finding what is worth exploring in " + q + "...");
  setStatus("adventureRouteStatus", "SETTING DESTINATION", "gold");




  urls = [];
  (function () {
    var variants = naturalDestinationQueryVariants(q);
    var i;
    for (i = 0; i < variants.length; i++) {
      urls.push(geoUrl(variants[i], "autocomplete", 10));
      urls.push(geoUrl(variants[i], "search", 10));
    }
  })();




  function finish() {
    var sorted;
    var best;




    if (pending > 0 || token !== destinationSearchToken) { return; }




    stopScanTab();
    all = dedupe(all);
    all = filterNaturalDestinationResults(all, q);




    sorted = all.sort(function (a, b) {
      var sa = scoreDestination(a, q);
      var sb = scoreDestination(b, q);
      var da;
      var db;




      if (Math.abs(sb - sa) > 8) { return sb - sa; }




      da = finite(Number(a.distMiles)) ? Number(a.distMiles) : 99999;
      db = finite(Number(b.distMiles)) ? Number(b.distMiles) : 99999;
      return da - db;
    });




    best = sorted && sorted.length ? sorted[0] : null;




    if (best && !isSafeAutoCommitDestination(best, q)) {
      best = null;
    }




    if (!best) {
      setStatus("adventureRouteStatus", "NO DESTINATION", "gold");
      toast(
        naturalDestinationIntent(q)
          ? "No strong natural destination match yet"
          : "No strong destination match yet"
      );
      renderDestinationResults([], q);
      return;
    }




    destinationSearchResults = sorted.slice(0, 8);
    routeDestinationResult(best);
  }




  function fetchUrl(url) {
    pending += 1;




    try {
      fetch(url)
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var features = data && data.features ? data.features : [];
          var i;
          var item;




          for (i = 0; i < features.length; i++) {
            item = normalizeFeature(features[i], q);
            if (item) { all.push(item); }
          }




          pending -= 1;
          finish();
        })
        .catch(function () {
          pending -= 1;
          finish();
        });
    } catch (e) {
      pending -= 1;
      finish();
    }
  }




  (function () {
    var u;
    for (u = 0; u < urls.length; u++) {
      fetchUrl(urls[u]);
    }
  })();
}




function resolveShoppingAdventure(query) {
  var q = clean(query);
  var destinationText = shoppingQueryDestinationText(q);
  var terms = shoppingSearchTerms(q);
  var intent = shoppingIntentType(q);




  if (!destinationText) {
    activeLens = "shopping";
    lsSet(LS.ADVENTURE_LENS, activeLens);
    adventureSearchScope = "near_me";
    adventureSearchCenter = lastFix && finite(Number(lastFix.lat)) && finite(Number(lastFix.lng))
      ? {
          lat:Number(lastFix.lat),
          lng:Number(lastFix.lng),
          label:"near you"
        }
      : null;
    activeScanQuery = terms.length ? terms.join(" ") : q;
    scanAdventureChoices(activeScanQuery);
    return;
  }




  destinationSearchToken += 1;
  var token = destinationSearchToken;
  var urls = [
    geoUrl(destinationText, "autocomplete", 10),
    geoUrl(destinationText, "search", 10)
  ];
  var all = [];
  var pending = urls.length;




  startScanTab("SETTING SHOPPING DESTINATION", "Finding local shopping around " + destinationText + "...");
  setStatus("adventureRouteStatus", "SETTING DESTINATION", "gold");




  function finish() {
    var sorted;
    var best;




    if (pending > 0 || token !== destinationSearchToken) { return; }




    stopScanTab();
    all = dedupe(all);




    sorted = all.sort(function (a, b) {
      return scoreDestination(b, destinationText) - scoreDestination(a, destinationText);
    });




    best = sorted && sorted.length ? sorted[0] : null;




    if (!best) {
      toast("No strong shopping destination yet");
      renderDestinationResults(sorted, destinationText);
      return;
    }




    destination = {
      label:String(best.label || destinationText),
      full:String(best.full || ""),
      lat:Number(best.lat),
      lng:Number(best.lng),
      kind:String(best.kind || "city")
    };




    setDestinationLock(destination, "shopping_destination");
    lsJSON(LS.DEST, destination);




    adventureSearchCenter = {
      lat:Number(destination.lat),
      lng:Number(destination.lng),
      label:String(destination.label || destinationText)
    };
    adventureSearchScope = "near_destination";
    activeLens = "shopping";
    lsSet(LS.ADVENTURE_LENS, activeLens);




    dismissAdventureKeyboard();
    hideDestinationResults();
    syncAdventureDestinationScopeUI();




    if (mapLoaded && map) {
      try { flyTo(destination.lng, destination.lat, 13.2); } catch (flyErr) {}
    }




    activeScanQuery = terms.length ? terms.join(" ") : q;
    setStatus("adventureRouteStatus", "SHOPPING READY", "green");
    toast("Shopping around " + String(destination.label || destinationText));




    window.setTimeout(function () {
      scanAdventureChoices(activeScanQuery);
    }, 220);
  }




  function fetchUrl(url) {
    try {
      fetch(url)
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var features = data && data.features ? data.features : [];
          var i;
          var item;




          for (i = 0; i < features.length; i++) {
            item = normalizeFeature(features[i], destinationText);
            if (item) { all.push(item); }
          }




          pending -= 1;
          finish();
        })
        .catch(function () {
          pending -= 1;
          finish();
        });
    } catch (e) {
      pending -= 1;
      finish();
    }
  }




  fetchUrl(urls[0]);
  fetchUrl(urls[1]);
}




function searchDestinations(query) {
  var q = clean(query);
  var token;




  if (shouldSuppressDestinationChooser(q)) {
    destinationSearchResults = [];
    hideDestinationResults();
    updateClearAdventureSearchButton();
    return;
  }
  var urls;
  var all = [];
  var pending = 0;
  var i;




  if (!q || q.length < 2) { hideDestinationResults(); return; }




  (function () {
    var indexed = adventureDestinationIndexMatch(q);
    if (indexed) {
      destinationSearchResults = [indexedAdventureItem(indexed)];
      renderDestinationResults(destinationSearchResults, q);
    }
  })();




  if (!GEOAPIFY_KEY) { toast("Search unavailable"); return; }




  /*
    Category chips own quick scans. Typed search owns destinations.
  */
  destinationSearchToken += 1;
  token = destinationSearchToken;




  startScanTab("SEARCHING DESTINATIONS", "Finding places worth exploring...");
  setStatus("adventureRouteStatus", "SEARCHING DESTINATIONS", "gold");




  urls = [];
  (function () {
    var variants = naturalDestinationQueryVariants(q);
    var v;
    for (v = 0; v < variants.length; v++) {
      urls.push(geoUrl(variants[v], "autocomplete", 10));
      urls.push(geoUrl(variants[v], "search", 10));
    }
  })();




  function finish() {
    var sorted;
    if (pending > 0 || token !== destinationSearchToken) { return; }




    stopScanTab();
    all = dedupe(all);
    all = filterNaturalDestinationResults(all, q);
    sorted = all.sort(function (a, b) {
      var sa = scoreDestination(a, q);
      var sb = scoreDestination(b, q);
      if (Math.abs(sb - sa) > 8) { return sb - sa; }
      var da = finite(Number(a.distMiles)) ? Number(a.distMiles) : 99999;
      var db = finite(Number(b.distMiles)) ? Number(b.distMiles) : 99999;
      return da - db;
    });




    renderDestinationResults(sorted, q);
    if (sorted.length) {
      setStatus("adventureRouteStatus", String(Math.min(sorted.length, 8)) + " CHOICES", "green");
      toast("Choose where to explore");
    } else {
      setStatus("adventureRouteStatus", "NO CHOICES", "gold");
      toast("No strong place choices yet");
    }
  }




  function fetchUrl(url) {
    pending += 1;
    try {
      fetch(url)
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var features = data && data.features ? data.features : [];
          var j;
          var item;
          for (j = 0; j < features.length; j++) {
            item = normalizeFeature(features[j], q);
            if (item) { all.push(item); }
          }
          pending -= 1;
          finish();
        })
        .catch(function () { pending -= 1; finish(); });
    } catch (e) {
      pending -= 1;
      finish();
    }
  }




  for (i = 0; i < urls.length; i++) { fetchUrl(urls[i]); }
}




function routeDestinationResult(item) {
  var input = byId("adventureSearch");
  var scanQuery;




  if (!item || !finite(Number(item.lat)) || !finite(Number(item.lng))) { return; }




  /*
    DRIVE IQ V23 â€” DESTINATION DISCOVERY FIRST
    Selecting a destination in Adventure Mode should not immediately build a
    route. It sets the Adventure Center, drops the destination pin, and scans
    around that destination. Navigation only starts later from a Place IQ card.
  */
  activeLens = "popular tonight";
  lsSet(LS.ADVENTURE_LENS, activeLens);




  destination = {
    label: String(item.label || "Destination"),
    full: String(item.full || item.matchLabel || ""),
    lat: Number(item.lat),
    lng: Number(item.lng),
    kind: String(item.kind || "destination")
  };




  routeGeo = null;
  setDestinationLock(destination, "destination_result_selected");

  /* Snapshot the selected identity immediately. Delayed District IQ and scan
     callbacks may enrich results, but cannot replace the Adventure Center. */
  committedAdventureDestination = destinationIdentitySnapshot(destination);
  committedAdventureDestinationReason = "destination_result_selected";

  destinationSearchResults = [];
  hideDestinationResults();




  if (input) { input.value = String(destination.label || "Destination"); }
  updateClearAdventureSearchButton();




  lsJSON(LS.DEST, destination);
  lsRemove(LS.ROUTE_GEO);
  lsRemove(LS.ROUTE_INTEL);
  clearRouteLine();
  setDestinationPin();




  adventureSearchCenter = {
    lat: Number(destination.lat),
    lng: Number(destination.lng),
    label: String(destination.label || "destination")
  };
  adventureSearchScope = "near_destination";
  destinationPreviewScan = true;
  adventureScanOnly = true;
  adventureDestinationCameraHold = true;
  adventureDestinationCameraHoldAt = Date.now();




  dismissAdventureKeyboard();
  syncAdventureDestinationScopeUI();




  closeAdventureInfoCard();
  setStatus("adventureRouteStatus", "DESTINATION SET", "green");
  setStartReady(false);
  toast("Finding what is worth exploring around " + String(destination.label || "destination"));




  if (mapLoaded && map) {
    try { flyTo(destination.lng, destination.lat, 13.8); } catch (flyErr) {}
  }




  if (item && item.related && item.related.length) {
    scanQuery = item.related.join(" ") + " local favorites";
  } else {
    scanQuery = "popular tonight local favorites";
  }
  window.setTimeout(function () {
    restoreCommittedAdventureDestination("before_destination_scan");
    scanAdventureChoices(scanQuery);

    window.setTimeout(function () {
      restoreCommittedAdventureDestination("after_destination_scan");
    }, 140);
  }, 220);
}




function speakAdventure(text) {
  var msg = clean(text);
  var utter;
  var voiceKey = normText(msg).slice(0, 90);
  if (!infoVoiceEnabled || !msg) { return; }
  if (voiceKey && voiceKey === infoVoiceLastKey && Date.now() - infoVoiceLastAt < 18000) { return; }
  infoVoiceLastKey = voiceKey;
  infoVoiceLastAt = Date.now();
  try {
    if (!window.speechSynthesis || !window.SpeechSynthesisUtterance) { return; }
    window.speechSynthesis.cancel();
    utter = new SpeechSynthesisUtterance(msg);
    utter.rate = 0.78;
    utter.pitch = 1.0;
    utter.volume = 1.0;
    window.speechSynthesis.speak(utter);
  } catch (e) {}
}












/* =========================================================
   DRIVE IQ V21.8 â€” ADVENTURE SCAN VOICE IQ + AUTO COLLAPSE
   Voice sequence:
   - scan start speaks once
   - scan complete speaks once
   - empty scan speaks once
   - visual scan steps remain mostly visual-only
   Auto-collapse:
   - successful category/adventure scans minimize the big panel after completion
   - destination search stays open
   - Place IQ card / Drop modal blocks auto-collapse
========================================================= */




function adventureScanCategoryLabel(query) {
  var cat = categoryFromQuery(query);
  var q = clean(query);




  if (cat === "popular tonight") { return "popular tonight"; }
  if (cat === "live music") { return "live music"; }
  if (cat === "waterfront") { return "waterfront"; }
  if (cat === "patio vibes") { return "patio spots"; }
  if (cat === "food iq") { return "food worth the drive"; }
  if (cat === "coffee iq") { return "coffee stops"; }
  if (cat === "food drinks") { return "food and drink spots"; }
  if (cat === "local favorites") { return "local favorites"; }
  if (cat === "camping") { return "campgrounds"; }
  if (cat === "run walk") { return "run and walk spots"; }
  if (cat === "water") { return "water spots"; }
  if (cat === "trails") { return "trailheads"; }
  if (cat === "waterfalls") { return "waterfalls"; }
  if (cat === "caves") { return "caves"; }
  if (cat === "parks") { return "parks"; }
  if (cat === "scenic") { return "scenic spots"; }
  if (cat === "shopping") { return "shopping spots"; }
  return q || "adventure spots";
}




function adventureScanScopeVoiceLabel(query) {
  var label;




  if (adventureSearchScope === "map_area") { return "in this map area"; }




  if (adventureSearchScope === "near_destination" && adventureSearchCenter) {
    label = clean(adventureSearchCenter.label || "your destination");
    return "near " + label;
  }




  return "nearby";
}




function speakAdventureScanVoice(line, key, cooldownMs) {
  var now = Date.now();
  var safeKey = normText(key || line).slice(0, 120);




  if (!infoVoiceEnabled || !line) { return false; }
  if (adventureDropModalOpen) { return false; }




  try {
    if (byId("diqAdventureInfoCard") && String(byId("diqAdventureInfoCard").className || "").indexOf("on") > -1) {
      return false;
    }
  } catch (cardErr) {}




  if (safeKey && safeKey === adventureScanVoiceLastKey && now - Number(adventureScanVoiceLastAt || 0) < Number(cooldownMs || 14000)) {
    return false;
  }




  adventureScanVoiceLastKey = safeKey;
  adventureScanVoiceLastAt = now;
  speakAdventure(line);
  return true;
}




function speakAdventureScanStart(query) {
  var label = adventureScanCategoryLabel(query);
  var scope = adventureScanScopeVoiceLabel(query);
  var line;




  adventureScanVoiceToken += 1;




  if (adventureSearchScope === "map_area") {
    line = "Scanning this map area for " + label + ".";
  } else if (adventureSearchScope === "near_destination") {
    line = "Scanning " + label + " " + scope + ".";
  } else {
    line = "Scanning nearby " + label + ".";
  }




  speakAdventureScanVoice(line, "scan_start|" + adventureScanVoiceToken + "|" + label + "|" + scope, 1000);
}




function speakAdventureScanComplete(count, topPick, query) {
  var n = Number(count || 0);
  var name = clean(topPick && topPick.label ? topPick.label : "");
  var line;




  if (n <= 0) {
    speakAdventureScanEmpty(query);
    return;
  }




  if (name) {
    line = "Found " + String(Math.min(n, 8)) + " strong pick" + (n === 1 ? "" : "s") + ". Top pick is " + name + ".";
  } else {
    line = "Found " + String(Math.min(n, 8)) + " strong adventure pick" + (n === 1 ? "" : "s") + ".";
  }




  speakAdventureScanVoice(line, "scan_complete|" + adventureScanVoiceToken + "|" + String(n) + "|" + normText(name), 1000);
}




function speakAdventureScanEmpty(query) {
  var label = adventureScanCategoryLabel(query);
  var line = "I didnâ€™t find a strong " + label + " pick yet. Try widening the map or changing the search.";
  speakAdventureScanVoice(line, "scan_empty|" + adventureScanVoiceToken + "|" + label, 1000);
}




function adventurePanelIsBlockingAutoCollapse() {
  try {
    if (adventureDropModalOpen) { return true; }
    if (byId("diqAdventureDropModal") && String(byId("diqAdventureDropModal").className || "").indexOf("on") > -1) { return true; }
    if (byId("diqAdventureInfoCard") && String(byId("diqAdventureInfoCard").className || "").indexOf("on") > -1) { return true; }
  } catch (e) {}
  return false;
}




function autoCollapseAdventureMenuAfterScan(reason) {
  if (adventureAutoCollapseTimer) {
    window.clearTimeout(adventureAutoCollapseTimer);
    adventureAutoCollapseTimer = null;
  }




  adventureAutoCollapseTimer = window.setTimeout(function () {
    if (adventurePanelIsBlockingAutoCollapse()) { return; }
    if (destinationResultOpen && !adventureResults.length) { return; }




    try {
      ensureScanResultsRestoreControl();
      document.body.classList.add("adventureScanResultsMode");
      document.body.classList.remove("adventureHorizonHidden");
    } catch (e1) {}




    try { syncAdventureMapDock(); } catch (e2) {}
    if (window.console && window.console.log) { window.console.log("[Adventure V21.8 Auto Collapse]", reason || "scan_complete"); }
  }, 1050);
}




function speakInfoCard(item) {
  var title;
  var label;
  var distance;
  var line;
  if (!item) { return; }
  item = enrichAdventureItem(item, activeLens);
  title = clean(item.label || "Adventure stop");
  label = clean(item.matchLabel || "Adventure stop");
  distance = destinationDistanceText(item) || itemDistanceText(item);
  line = title + ". " + label + (distance ? ", " + distance : "") + ". " + String(item.worthStars || "") + " Worth the Drive. Tap Route Here when ready.";
  if (line.length > 190) { line = line.slice(0, 187) + "."; }
  speakAdventure(line);
}








function getDestinationScanCenter(query) {
  var cat = categoryFromQuery(query);
  if (cat && destination && finite(Number(destination.lat)) && finite(Number(destination.lng))) {
    return {
      lat: Number(destination.lat),
      lng: Number(destination.lng),
      label: String(destination.label || "destination")
    };
  }
  return null;
}




function getActiveSearchCenter() {
  if (adventureSearchCenter && finite(Number(adventureSearchCenter.lat)) && finite(Number(adventureSearchCenter.lng))) {
    return adventureSearchCenter;
  }
  if (lastFix && finite(Number(lastFix.lat)) && finite(Number(lastFix.lng))) {
    return lastFix;
  }
  return null;
}




function scanScopeLabel(query) {
  var cat = categoryFromQuery(query);
  if (adventureSearchScope === "near_destination" && adventureSearchCenter) {
    return "near " + String(adventureSearchCenter.label || "destination");
  }
  if (adventureSearchScope === "map_area") { return "in this map area"; }
  if (cat) { return "near you"; }
  return "";
}




function scanTitleForQuery(query) {
  var cat = categoryFromQuery(query);
  if (cat === "popular tonight") { return "SCANNING POPULAR TONIGHT"; }
  if (cat === "live music") { return "SCANNING LIVE MUSIC"; }
  if (cat === "waterfront") { return "SCANNING WATERFRONT"; }
  if (cat === "patio vibes") { return "SCANNING PATIO VIBES"; }
  if (cat === "food iq") { return "EXPLORING FOOD IQ"; }
  if (cat === "coffee iq") { return "SCANNING COFFEE IQ"; }
  if (cat === "food drinks") { return "SCANNING FOOD + DRINKS"; }
  if (cat === "local favorites") { return "SCANNING LOCAL FAVORITES"; }
  if (cat === "camping") { return "SCANNING CAMPGROUNDS"; }
  if (cat === "run walk") { return "SCANNING RUN / WALK"; }
  if (cat === "water") { return "SCANNING WATER SPOTS"; }
  if (cat === "trails") { return "SCANNING TRAILHEADS"; }
  if (cat === "waterfalls") { return "SCANNING WATERFALLS"; }
  if (cat === "caves") { return "SCANNING CAVES"; }
  if (cat === "parks") { return "SCANNING PARKS"; }
  if (cat === "scenic") { return "SCANNING SCENIC SPOTS"; }
  if (cat === "shopping") { return "SCANNING SHOPPING"; }
  return "SCANNING ADVENTURE";
}








function scanTabTitleForQuery(query) {
  var base = scanTitleForQuery(query);
  if (adventureSearchScope === "near_destination") { return base.replace("SCANNING", "SCANNING NEAR DESTINATION"); }
  if (adventureSearchScope === "map_area") { return base.replace("SCANNING", "SCANNING THIS MAP"); }
  return base.replace("SCANNING", "SCANNING NEAR YOU");
}




function scanTabSubForQuery(query) {
  var cat = categoryFromQuery(query);
  var label = adventureSearchCenter && adventureSearchCenter.label ? String(adventureSearchCenter.label) : "your area";
  if (adventureSearchScope === "near_destination") {
    if (cat === "popular tonight") { return "Checking places with energy around " + label + "..."; }
    if (cat === "live music") { return "Checking bands, patios, bars, and venues around " + label + "..."; }
    if (cat === "waterfront") { return "Checking waterfront patios and marina spots around " + label + "..."; }
    if (cat === "patio vibes") { return "Checking restaurant patios, cafes, rooftops, and hangouts around " + label + "..."; }
    if (cat === "food iq") { return "Checking must-try local bites, desserts, BBQ, burgers, tacos, seafood, and viral food spots around " + label + "..."; }
    if (cat === "coffee iq") { return "Checking local coffee shops, cafÃ©s, roasters, bakeries, patios, and work-friendly spaces around " + label + "..."; }
    if (cat === "food drinks") { return "Checking food and drink spots around " + label + "..."; }
    if (cat === "local favorites") { return "Checking local favorites around " + label + "..."; }
    if (cat === "camping") { return "Checking campgrounds around " + label + "..."; }
    if (cat === "run walk") { return "Checking safe run and walk spots around " + label + "..."; }
    if (cat === "water") { return "Checking beaches, boardwalks, and water access around " + label + "..."; }
    if (cat === "trails") { return "Checking trailheads around " + label + "..."; }
    if (cat === "parks") { return "Checking parks around " + label + "..."; }
    if (cat === "waterfalls") { return "Checking waterfalls and scenic spots around " + label + "..."; }
    if (cat === "shopping") { return "Checking boutiques, local shops, markets, and walkable shopping around " + label + "..."; }
    return "Checking adventure spots around " + label + "...";
  }
  if (cat === "popular tonight") { return "Checking where people are gathering tonight..."; }
  if (cat === "live music") { return "Checking bands, patios, bars, and venues..."; }
  if (cat === "waterfront") { return "Checking waterfront patios and marina spots..."; }
  if (cat === "patio vibes") { return "Checking restaurant patios, cafes, rooftops, and hangouts..."; }
  if (cat === "food drinks") { return "Checking food, drinks, and local hangouts..."; }
  if (cat === "local favorites") { return "Checking places locals love..."; }
  if (cat === "camping") { return "Checking closest campgrounds..."; }
  if (cat === "run walk") { return "Checking nearby run and walk spots..."; }
  if (cat === "water") { return "Checking nearby water access..."; }
  if (cat === "shopping") { return "Checking boutiques, local shops, markets, and walkable shopping..."; }
  return "Checking closest matches...";
}




function setStartReady(ready) {
  var btn = byId("startAdventure");
  if (btn) {
    btn.disabled = false;
    btn.className = "startAdventure";
    if (routeGeo && destination && ready) {
      btn.textContent = "START ROUTE";
    } else if (destination && finite(Number(destination.lat)) && finite(Number(destination.lng))) {
      btn.textContent = "SCAN DESTINATION";
    } else {
      btn.textContent = "SCAN NEAR ME";
    }
  }
  syncExploreNearbyButton();
}








function injectAdventurePolishStyles() {
  var css;
  var style;
  if (byId("diqAdventureV4Style")) { injectAdventureV21_7CardSafeStyles(); return; }
  css =
    "body.adventureHorizonHidden #adventureHorizon{opacity:0!important;transform:translateY(22px)!important;pointer-events:none!important;transition:opacity .22s ease,transform .22s ease!important;}" +
    "body.adventureRouteReady #adventureSignals{display:none!important;}" +
    "body.adventureRouteReady #adventureHorizon{padding:10px!important;}" +
    "#diqAdventureInfoCard{position:fixed;left:14px;right:14px;bottom:calc(92px + env(safe-area-inset-bottom,0px));z-index:90;border-radius:22px;padding:12px;background:rgba(5,12,22,.96);border:1px solid rgba(255,206,105,.28);box-shadow:0 22px 54px rgba(0,0,0,.54),0 0 28px rgba(255,206,105,.10);color:#fff;font-family:system-ui,-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;display:none;max-height:34vh;overflow:hidden;}" +
    "#diqAdventureInfoCard.on{display:block;}" +
    "#diqAdventureInfoCard .diqAdvKicker{font-size:9px;font-weight:1000;letter-spacing:1px;color:#ffe5a6;text-transform:uppercase;}" +
    "#diqAdventureInfoCard .diqAdvTitle{margin-top:4px;font-size:19px;line-height:1.05;font-weight:1000;letter-spacing:-.35px;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;}" +
    "#diqAdventureInfoCard .diqAdvSub{margin-top:6px;color:rgba(255,255,255,.72);font-size:11px;line-height:1.25;font-weight:760;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;}" +
    "#diqAdventureInfoCard .diqAdvActions{display:grid;grid-template-columns:1fr 1fr;gap:9px;margin-top:10px;}" +
    "#diqAdventureInfoCard button{min-height:40px;border-radius:15px;border:1px solid rgba(255,255,255,.14);font-size:11px;font-weight:1000;letter-spacing:.45px;}" +
    "#diqAdventureInfoCard .diqAdvRoute{color:#061018;background:linear-gradient(135deg,#ffce69,#28ffbe);}" +
    "#diqAdventureInfoCard .diqAdvClose{color:#fff;background:rgba(255,255,255,.08);}" +
    "#diqExploreNearbyBtn{box-sizing:border-box!important;width:100%!important;min-height:46px!important;border-radius:16px!important;border:1px solid rgba(40,255,190,.24)!important;background:linear-gradient(135deg,rgba(5,12,22,.94),rgba(5,12,22,.78))!important;color:#fff!important;font-size:10px!important;font-weight:1000!important;letter-spacing:.55px!important;box-shadow:0 12px 26px rgba(0,0,0,.30),0 0 18px rgba(40,255,190,.08)!important;display:none;margin:0 0 7px 0!important;padding:8px 10px!important;text-align:left!important;}" +
    "#diqExploreNearbyBtn.on{display:block!important;}" +
    "#diqExploreNearbyBtn .small{display:block;margin-top:3px!important;font-size:8px!important;line-height:1.05!important;letter-spacing:.35px!important;color:rgba(255,255,255,.68)!important;white-space:nowrap!important;overflow:hidden!important;text-overflow:ellipsis!important;}" +
    "#diqExploreNearbyBtn .count{display:inline-flex;margin-left:6px;padding:2px 7px;border-radius:999px;background:rgba(40,255,190,.12);border:1px solid rgba(40,255,190,.18);color:#b6ffeb;font-size:8px;letter-spacing:.45px;vertical-align:middle;}" +
    "body.adventureHorizonHidden #diqExploreNearbyBtn{opacity:1!important;transform:none!important;pointer-events:auto!important;transition:none!important;}" +
    "#diqAdventureScanTab{position:fixed;left:14px;right:14px;bottom:calc(238px + env(safe-area-inset-bottom,0px));z-index:88;border-radius:18px;padding:11px 13px;background:rgba(5,12,22,.96);border:1px solid rgba(40,255,190,.28);box-shadow:0 18px 42px rgba(0,0,0,.44),0 0 26px rgba(40,255,190,.12);color:#fff;font-family:system-ui,-apple-system,BlinkMacSystemFont,\'Segoe UI\',sans-serif;display:none;pointer-events:none;}" +
    "#diqAdventureScanTab.on{display:flex;align-items:center;gap:10px;}" +
    "#diqAdventureScanTab .diqScanPulse{width:12px;height:12px;border-radius:999px;background:#28ffbe;box-shadow:0 0 18px rgba(40,255,190,.65);animation:diqScanPulse 1.05s ease-in-out infinite;flex:0 0 auto;}" +
    "#diqAdventureScanTab .diqScanText{min-width:0;}" +
    "#diqAdventureScanTab .diqScanTitle{font-size:10px;font-weight:1000;letter-spacing:1px;color:#b6ffeb;text-transform:uppercase;}" +
    "#diqAdventureScanTab .diqScanSub{margin-top:2px;font-size:11px;font-weight:820;color:rgba(255,255,255,.78);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}" +
    "@keyframes diqScanPulse{0%{transform:scale(.82);opacity:.72;}50%{transform:scale(1.18);opacity:1;}100%{transform:scale(.82);opacity:.72;}}" +
    "#diqAdventureDestResults{position:fixed;left:12px;right:12px;top:calc(env(safe-area-inset-top,0px) + 72px);z-index:92;border-radius:22px;padding:10px;background:rgba(5,12,22,.97);border:1px solid rgba(255,255,255,.18);box-shadow:0 22px 54px rgba(0,0,0,.50),0 0 28px rgba(40,255,190,.10);color:#fff;font-family:system-ui,-apple-system,BlinkMacSystemFont,\'Segoe UI\',sans-serif;display:none;height:auto;max-height:calc(100dvh - 96px);overflow:hidden;}" +
    "#diqAdventureDestResults.on{display:flex;flex-direction:column;}#diqAdventureDestResults #diqDestList{flex:1 1 auto;min-height:0;max-height:calc(100dvh - 152px);overflow-y:auto;overflow-x:hidden;-webkit-overflow-scrolling:touch;overscroll-behavior:contain;padding-bottom:36px;scroll-padding-bottom:36px;}" +
    "#diqAdventureDestResults .diqDestHead{padding:4px 4px 8px 4px;font-size:10px;font-weight:1000;letter-spacing:1.2px;color:#b6ffeb;text-transform:uppercase;}" +
    "#diqAdventureDestResults .diqDestItem{width:100%;text-align:left;border:1px solid rgba(255,255,255,.11);background:rgba(255,255,255,.06);border-radius:16px;padding:11px;margin:7px 0;color:#fff;}" +
    "#diqAdventureDestResults .diqDestName{font-size:15px;font-weight:1000;line-height:1.12;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}" +
    "#diqAdventureDestResults .diqDestSub{margin-top:4px;font-size:11px;font-weight:760;color:rgba(255,255,255,.68);line-height:1.18;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;}" +
    "#diqAdventureDestResults .diqDestMeta{margin-top:6px;font-size:9px;font-weight:1000;letter-spacing:.7px;color:#ffdf8a;text-transform:uppercase;}" +
    "#diqAdventureDestResults .diqDestWorth{margin-top:7px;display:flex;gap:6px;align-items:center;flex-wrap:wrap;}" +
    "#diqAdventureDestResults .diqDestTag{display:inline-flex;align-items:center;border-radius:999px;padding:4px 7px;background:rgba(40,255,190,.10);border:1px solid rgba(40,255,190,.18);color:#b6ffeb;font-size:8px;font-weight:1000;letter-spacing:.45px;text-transform:uppercase;}" +
    "#diqAdventureDestResults .diqDestScore{color:#061018;background:linear-gradient(135deg,#ffce69,#28ffbe);border:0;}" +
    "#diqAdventureInfoCard .diqAdvWorth{margin-top:8px;display:flex;gap:6px;flex-wrap:wrap;align-items:center;}" +
    "#diqAdventureInfoCard .diqAdvTag{display:inline-flex;border-radius:999px;padding:4px 8px;background:rgba(40,255,190,.10);border:1px solid rgba(40,255,190,.18);color:#b6ffeb;font-size:8px;font-weight:1000;letter-spacing:.45px;text-transform:uppercase;}" +
    "#diqAdventureInfoCard .diqAdvScore{color:#061018;background:linear-gradient(135deg,#ffce69,#28ffbe);border:0;}" +
    "#diqAdventureInfoCard .diqAdvActions{grid-template-columns:.78fr .78fr 1fr 1.08fr!important;}" +
    "#diqAdventureInfoCard .diqAdvDrop{color:#061018;background:linear-gradient(135deg,#fff2a8,#ffce69,#28ffbe);border-color:rgba(255,245,184,.62)!important;box-shadow:0 0 18px rgba(255,206,105,.18);}" +
    "#diqAdventureInfoCard .diqAdvSave{color:#fff;background:rgba(255,255,255,.08);}" +
    "#diqAdventureInfoCard .diqAdvPhoto{height:112px;border-radius:17px;margin:-2px 0 9px 0;background-size:cover;background-position:center;background-color:rgba(255,255,255,.06);border:1px solid rgba(255,255,255,.12);box-shadow:inset 0 -42px 56px rgba(2,8,18,.36);overflow:hidden;position:relative;}" +
    "#diqAdventureInfoCard .diqAdvPhoto:after{content:'PLACE PHOTO';position:absolute;left:10px;bottom:9px;padding:4px 8px;border-radius:999px;background:rgba(5,12,22,.72);border:1px solid rgba(255,255,255,.16);font-size:8px;font-weight:1000;letter-spacing:.6px;color:#fff;}" +
    "#diqAdventureInfoCard .diqAdvPhoto.water{background-image:linear-gradient(135deg,rgba(0,229,255,.36),rgba(40,255,190,.12)),radial-gradient(circle at 20% 25%,rgba(255,255,255,.18),transparent 28%);}" +
    "#diqAdventureInfoCard .diqAdvPhoto.dining{background-image:linear-gradient(135deg,rgba(255,206,105,.34),rgba(255,111,72,.12)),radial-gradient(circle at 78% 18%,rgba(255,255,255,.18),transparent 30%);}" +
    "#diqAdventureInfoCard .diqAdvPhoto.outdoor{background-image:linear-gradient(135deg,rgba(40,255,190,.28),rgba(0,229,255,.10)),radial-gradient(circle at 30% 20%,rgba(255,255,255,.14),transparent 32%);}" +
    "#diqAdventureInfoCard .diqAdvPhoto.local{background-image:linear-gradient(135deg,rgba(255,206,105,.24),rgba(40,255,190,.12)),radial-gradient(circle at 78% 20%,rgba(255,255,255,.14),transparent 30%);}" +
    "#diqAdventureDestResults .diqDestItem{position:relative;overflow:hidden;}" +
    "#diqAdventureDestResults .diqDestItem.hasPhoto{padding-left:92px;min-height:92px;}" +
    "#diqAdventureDestResults .diqDestThumb{position:absolute;left:10px;top:10px;width:70px;height:70px;border-radius:15px;background-size:cover;background-position:center;background-color:rgba(255,255,255,.07);border:1px solid rgba(255,255,255,.12);}" +
    "#diqAdventureDestResults .diqDestThumb.water{background-image:linear-gradient(135deg,rgba(0,229,255,.36),rgba(40,255,190,.12));}" +
    "#diqAdventureDestResults .diqDestThumb.dining{background-image:linear-gradient(135deg,rgba(255,206,105,.34),rgba(255,111,72,.12));}" +
    "#diqAdventureDestResults .diqDestThumb.outdoor{background-image:linear-gradient(135deg,rgba(40,255,190,.28),rgba(0,229,255,.10));}" +
    "#diqAdventureDestResults .diqDestThumb.local{background-image:linear-gradient(135deg,rgba(255,206,105,.24),rgba(40,255,190,.12));}" +
    "#diqAdventureDropModal{position:fixed;inset:0;z-index:120;display:none;align-items:flex-end;justify-content:center;padding:16px 14px calc(16px + env(safe-area-inset-bottom,0px));background:rgba(2,8,18,.46);backdrop-filter:blur(12px);-webkit-backdrop-filter:blur(12px);font-family:system-ui,-apple-system,BlinkMacSystemFont,\'Segoe UI\',sans-serif;color:#fff;}" +
    "#diqAdventureDropModal.on{display:flex;}" +
    "#diqAdventureDropModal .diqDropSheet{width:100%;max-width:520px;border-radius:26px;padding:14px;background:linear-gradient(145deg,rgba(5,12,22,.98),rgba(9,22,34,.94));border:1px solid rgba(255,206,105,.30);box-shadow:0 28px 74px rgba(0,0,0,.62),0 0 34px rgba(255,206,105,.14),0 0 30px rgba(40,255,190,.08);}" +
    "#diqAdventureDropModal .diqDropTop{display:flex;align-items:flex-start;justify-content:space-between;gap:10px;}" +
    "#diqAdventureDropModal .diqDropKicker{font-size:9px;font-weight:1000;letter-spacing:1.2px;color:#ffe5a6;text-transform:uppercase;}" +
    "#diqAdventureDropModal .diqDropTitle{margin-top:5px;font-size:22px;line-height:1;font-weight:1000;letter-spacing:-.45px;}" +
    "#diqAdventureDropModal .diqDropSub{margin-top:6px;color:rgba(255,255,255,.72);font-size:12px;line-height:1.3;font-weight:780;}" +
    "#diqAdventureDropModal .diqDropClose{width:38px;height:38px;border-radius:15px;background:rgba(255,255,255,.08);border:1px solid rgba(255,255,255,.14);color:#fff;font-size:24px;font-weight:900;}" +
    "#diqAdventureDropModal .diqDropChips{display:flex;flex-wrap:wrap;gap:8px;margin-top:13px;}" +
    "#diqAdventureDropModal .diqDropChip{min-height:35px;padding:0 10px;border-radius:999px;border:1px solid rgba(255,255,255,.13);background:rgba(255,255,255,.065);color:#fff;font-size:10px;font-weight:1000;letter-spacing:.25px;}" +
    "#diqAdventureDropModal .diqDropChip.on{color:#061018;background:linear-gradient(135deg,#fff2a8,#ffce69,#28ffbe);border-color:rgba(255,245,184,.62);box-shadow:0 0 20px rgba(255,206,105,.20);}" +
    "#diqAdventureDropModal .diqDropActions{display:grid;grid-template-columns:.8fr 1.2fr;gap:9px;margin-top:14px;}" +
    "#diqAdventureDropModal .diqDropCancel,#diqAdventureDropModal .diqDropSubmit{min-height:46px;border-radius:17px;font-size:11px;font-weight:1000;letter-spacing:.55px;}" +
    "#diqAdventureDropModal .diqDropCancel{background:rgba(255,255,255,.08);border:1px solid rgba(255,255,255,.14);color:#fff;}" +
    "#diqAdventureDropModal .diqDropSubmit{color:#061018;background:linear-gradient(135deg,#ffce69,#28ffbe);border:1px solid rgba(255,245,184,.55);}" +
    "#diqAdventureInfoCard .diqAdvDropSummary{margin-top:7px;display:flex;gap:5px;flex-wrap:wrap;}" +
    "#diqAdventureInfoCard .diqAdvDropPill{display:inline-flex;border-radius:999px;padding:3px 7px;background:rgba(255,206,105,.10);border:1px solid rgba(255,206,105,.20);color:#ffe5a6;font-size:8px;font-weight:1000;letter-spacing:.35px;text-transform:uppercase;}" +
    "body.adventureHorizonHidden #diqAdventureDestResults{opacity:0!important;transform:translateY(18px)!important;pointer-events:none!important;transition:opacity .22s ease,transform .22s ease!important;}" +
"body.adventureScanResultsMode .topWrap{right:auto!important;width:min(268px,calc(100vw - 118px))!important;transition:width .22s ease!important;}" +
    "body.adventureScanResultsMode .topWrap .hero{max-height:76px!important;overflow:hidden!important;padding:8px 10px!important;border-radius:18px!important;transform:translateY(-2px) scale(.985)!important;transition:max-height .24s ease,padding .24s ease,transform .24s ease!important;}" +
    "body.adventureScanResultsMode .topWrap .eyebrow{font-size:8px!important;letter-spacing:.9px!important;}" +
    "body.adventureScanResultsMode .topWrap .title{font-size:17px!important;line-height:1!important;margin-top:3px!important;white-space:nowrap!important;overflow:hidden!important;text-overflow:ellipsis!important;}" +
    "body.adventureScanResultsMode .topWrap .sub{font-size:9px!important;margin-top:3px!important;color:rgba(255,255,255,.68)!important;}" +
    "body.adventureScanResultsMode .localGuideLine,body.adventureScanResultsMode .experienceMood,body.adventureScanResultsMode .adventureCenter,body.adventureScanResultsMode .gpsRow,body.adventureScanResultsMode .adventureStatusRow,body.adventureScanResultsMode .adventureStrip,body.adventureScanResultsMode .iqPillRow,body.adventureScanResultsMode .searchWrap{display:none!important;}" +
    "body.adventureScanResultsMode #adventureHorizon{display:none!important;opacity:0!important;transform:translateY(22px)!important;pointer-events:none!important;}body.adventureScanResultsMode #diqExploreNearbyBtn.on{display:block!important;opacity:1!important;transform:none!important;pointer-events:auto!important;}" +
    "body.adventureScanResultsMode #adventureMenuRestore{display:inline-flex!important;align-items:center!important;justify-content:center!important;}" +
    "body.adventureScanResultsMode #diqAdventureDestResults.on{top:auto!important;left:14px!important;right:14px!important;bottom:calc(86px + env(safe-area-inset-bottom,0px))!important;max-height:24vh!important;border-color:rgba(40,255,190,.28)!important;}" +
    "body.adventureScanResultsMode #diqAdventureDestResults .diqDestHead:after{content:' â€¢ Map is now the hero';color:#ffe5a6;}" +
    "body.adventureScanResultsMode #diqAdventureInfoCard.on{bottom:calc(86px + env(safe-area-inset-bottom,0px))!important;}" +
        "@media(orientation:landscape){#diqAdventureDestResults{left:18px;right:auto;width:390px;top:118px;max-height:62vh;}#diqAdventureInfoCard{left:auto;right:14px;bottom:calc(90px + env(safe-area-inset-bottom,0px));width:360px;max-height:48vh;}#diqExploreNearbyBtn{margin-bottom:0;min-height:50px;}}";
  style = document.createElement("style");
  style.id = "diqAdventureV4Style";
  style.type = "text/css";
  style.appendChild(document.createTextNode(css));
  try { document.head.appendChild(style); } catch (e) {}
}








function injectAdventureV21_7CardSafeStyles() {
  var style;
  var css;




  if (byId("diqAdventureV21_7CardSafeStyle")) { return; }




  css =
    "html,body{overscroll-behavior:none;}" +
    "#diqAdventureInfoCard{box-sizing:border-box!important;left:14px!important;right:14px!important;bottom:calc(132px + env(safe-area-inset-bottom,0px))!important;max-height:calc(100vh - 246px)!important;overflow-y:auto!important;overflow-x:hidden!important;-webkit-overflow-scrolling:touch!important;padding:12px 12px calc(18px + env(safe-area-inset-bottom,0px)) 12px!important;}" +
    "#diqAdventureInfoCard.on{display:block!important;}" +
    "#diqAdventureInfoCard .diqAdvPhoto{height:104px!important;min-height:88px!important;margin:-2px 0 8px 0!important;}" +
    "#diqAdventureInfoCard .diqAdvTitle{font-size:18px!important;line-height:1.04!important;}" +
    "#diqAdventureInfoCard .diqAdvSub{font-size:11px!important;line-height:1.22!important;-webkit-line-clamp:2!important;}" +
    "#diqAdventureInfoCard .diqAdvWorth{margin-top:7px!important;gap:5px!important;}" +
    "#diqAdventureInfoCard .diqAdvTag{padding:4px 7px!important;font-size:7.5px!important;letter-spacing:.38px!important;}" +
    "#diqAdventureInfoCard .diqAdvDropSummary{margin-top:6px!important;gap:5px!important;}" +
    "#diqAdventureInfoCard .diqAdvActions{position:relative!important;display:grid!important;grid-template-columns:.78fr .78fr 1.08fr 1.08fr!important;gap:8px!important;margin-top:12px!important;padding-bottom:2px!important;z-index:2!important;}" +
    "#diqAdventureInfoCard .diqAdvActions button{box-sizing:border-box!important;min-height:52px!important;height:auto!important;padding:8px 7px!important;border-radius:16px!important;line-height:1.05!important;white-space:normal!important;overflow:visible!important;}" +
    "#diqAdventureInfoCard .diqAdvClose,#diqAdventureInfoCard .diqAdvSave{font-size:10.5px!important;}" +
    "#diqAdventureInfoCard .diqAdvDrop,#diqAdventureInfoCard .diqAdvRoute{font-size:10px!important;letter-spacing:.34px!important;}" +
    "#startAdventure,.startAdventure{position:relative!important;z-index:89!important;margin-top:7px!important;margin-bottom:0!important;}" +
    "body.adventureScanResultsMode #diqAdventureInfoCard.on{bottom:calc(132px + env(safe-area-inset-bottom,0px))!important;max-height:calc(100vh - 246px)!important;}" +
    "@media(max-height:760px){#diqAdventureInfoCard{bottom:calc(124px + env(safe-area-inset-bottom,0px))!important;max-height:calc(100vh - 224px)!important;padding-bottom:calc(16px + env(safe-area-inset-bottom,0px))!important;}#diqAdventureInfoCard .diqAdvPhoto{height:86px!important;}#diqAdventureInfoCard .diqAdvTitle{font-size:17px!important;}#diqAdventureInfoCard .diqAdvSub{-webkit-line-clamp:2!important;font-size:10.5px!important;}#diqAdventureInfoCard .diqAdvActions{gap:7px!important;margin-top:10px!important;}#diqAdventureInfoCard .diqAdvActions button{min-height:48px!important;padding:7px 6px!important;border-radius:15px!important;}#diqAdventureInfoCard .diqAdvDrop,#diqAdventureInfoCard .diqAdvRoute{font-size:9.2px!important;letter-spacing:.25px!important;}}" +
    "@media(max-width:380px){#diqAdventureInfoCard{left:10px!important;right:10px!important;}#diqAdventureInfoCard .diqAdvActions{grid-template-columns:.74fr .74fr 1.12fr 1.12fr!important;gap:6px!important;}#diqAdventureInfoCard .diqAdvActions button{font-size:9px!important;padding-left:5px!important;padding-right:5px!important;}}" +
    "@media(orientation:landscape){#diqAdventureInfoCard{right:14px!important;left:auto!important;width:370px!important;bottom:calc(84px + env(safe-area-inset-bottom,0px))!important;max-height:calc(100vh - 112px)!important;}#diqAdventureInfoCard .diqAdvPhoto{height:82px!important;}}";




  style = document.createElement("style");
  style.id = "diqAdventureV21_7CardSafeStyle";
  style.type = "text/css";
  style.appendChild(document.createTextNode(css));
  try { document.head.appendChild(style); } catch (e) {}
}




injectAdventureV21_7CardSafeStyles();




/* =========================================================
   DRIVE IQ PLACE IQ CARD â€” PHASE 1 PRESENTATION ONLY
   Card markup and card-specific CSS only.
   Scan, search, ranking, pins, camera, and routing are untouched.
========================================================= */
function injectPlaceIqCardPhase1Styles() {
  var style;
  var css;
  if (byId("diqPlaceIqCardPhase1Style")) { return; }




  css =
    "#diqAdventureInfoCard{padding:0!important;border-radius:26px!important;background:linear-gradient(180deg,rgba(4,11,20,.985),rgba(3,9,17,.97))!important;border:1px solid rgba(255,206,105,.32)!important;box-shadow:0 26px 70px rgba(0,0,0,.62),0 0 36px rgba(255,206,105,.10)!important;overflow-y:auto!important;overflow-x:hidden!important;}" +
    "#diqAdventureInfoCard .diqPlaceHero{position:relative;height:164px;min-height:164px;overflow:hidden;background:linear-gradient(135deg,rgba(255,206,105,.14),rgba(40,255,190,.08));}" +
    "#diqAdventureInfoCard .diqAdvPhoto{position:absolute!important;inset:0!important;width:100%!important;height:100%!important;min-height:0!important;margin:0!important;border-radius:0!important;background-size:cover!important;background-position:center!important;border:0!important;}" +
    "#diqAdventureInfoCard .diqPlaceHeroShade{position:absolute;inset:0;background:linear-gradient(180deg,rgba(2,8,18,.04),rgba(2,8,18,.18) 45%,rgba(2,8,18,.94));pointer-events:none;}" +
    "#diqAdventureInfoCard .diqPlaceTopRow{position:absolute;left:14px;right:14px;top:13px;display:flex;align-items:center;justify-content:space-between;gap:10px;z-index:2;}" +
    "#diqAdventureInfoCard .diqAdvKicker{display:inline-flex;align-items:center;min-height:28px;padding:0 10px;border-radius:999px;background:rgba(5,12,22,.72);border:1px solid rgba(40,255,190,.30);backdrop-filter:blur(12px);-webkit-backdrop-filter:blur(12px);font-size:8px!important;font-weight:1000!important;letter-spacing:1.15px!important;color:#b6ffeb!important;}" +
    "#diqAdventureInfoCard .diqAdvClose{width:38px!important;height:38px!important;min-height:38px!important;padding:0!important;border-radius:999px!important;background:rgba(5,12,22,.78)!important;border:1px solid rgba(255,255,255,.20)!important;color:#fff!important;font-size:20px!important;line-height:1!important;}" +
    "#diqAdventureInfoCard .diqPlaceHeroText{position:absolute;left:16px;right:102px;bottom:15px;z-index:2;}" +
    "#diqAdventureInfoCard .diqAdvTitle{margin:0!important;font-size:24px!important;line-height:1.01!important;font-weight:1000!important;letter-spacing:-.7px!important;text-shadow:0 3px 18px rgba(0,0,0,.7);}" +
    "#diqAdventureInfoCard .diqPlaceCategory{margin-top:6px;color:#b9c6d2;font-size:11px;line-height:1.15;font-weight:820;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}" +
    "#diqAdventureInfoCard .diqPlaceScore{position:absolute;right:14px;bottom:13px;z-index:3;width:76px;height:76px;border-radius:999px;display:flex;flex-direction:column;align-items:center;justify-content:center;background:radial-gradient(circle at 40% 30%,rgba(255,239,168,.22),rgba(5,12,22,.94) 58%);border:2px solid #ffce69;box-shadow:0 0 24px rgba(255,206,105,.36),inset 0 0 18px rgba(255,206,105,.08);}" +
    "#diqAdventureInfoCard .diqPlaceScoreValue{font-size:27px;line-height:.9;font-weight:1000;color:#ffdc82;}" +
    "#diqAdventureInfoCard .diqPlaceScoreLabel{margin-top:5px;font-size:7px;font-weight:1000;letter-spacing:.8px;color:#ffe5a6;text-transform:uppercase;}" +
    "#diqAdventureInfoCard .diqPlaceBody{padding:13px 14px calc(14px + env(safe-area-inset-bottom,0px));}" +
    "#diqAdventureInfoCard .diqAdvWorth{margin:0!important;display:flex!important;gap:6px!important;flex-wrap:nowrap!important;overflow-x:auto!important;padding-bottom:2px!important;scrollbar-width:none!important;}" +
    "#diqAdventureInfoCard .diqAdvWorth::-webkit-scrollbar{display:none!important;}" +
    "#diqAdventureInfoCard .diqAdvTag{flex:0 0 auto!important;min-height:27px!important;display:inline-flex!important;align-items:center!important;padding:0 9px!important;border-radius:999px!important;font-size:7.5px!important;letter-spacing:.42px!important;background:rgba(40,255,190,.075)!important;border:1px solid rgba(40,255,190,.24)!important;color:#b6ffeb!important;}" +
    "#diqAdventureInfoCard .diqAdvScore{background:rgba(255,206,105,.10)!important;border-color:rgba(255,206,105,.42)!important;color:#ffe29a!important;}" +
    "#diqAdventureInfoCard .diqPlaceWhy{margin-top:12px;padding:11px 12px;border-radius:17px;background:linear-gradient(135deg,rgba(255,206,105,.075),rgba(40,255,190,.045));border:1px solid rgba(255,255,255,.10);}" +
    "#diqAdventureInfoCard .diqPlaceWhyLabel{font-size:8px;font-weight:1000;letter-spacing:1.1px;color:#ffdc82;text-transform:uppercase;}" +
    "#diqAdventureInfoCard .diqTrustBecause{margin-top:8px;display:grid;gap:5px;}" +
    "#diqAdventureInfoCard .diqTrustBecauseTitle{font-size:8px;font-weight:1000;letter-spacing:1px;color:#b6ffeb;text-transform:uppercase;}" +
    "#diqAdventureInfoCard .diqTrustReason{display:flex;align-items:center;gap:6px;min-height:24px;padding:0 9px;border-radius:999px;background:rgba(40,255,190,.065);border:1px solid rgba(40,255,190,.16);color:rgba(255,255,255,.86);font-size:9.2px;font-weight:880;}" +
    "#diqAdventureInfoCard .diqTrustReason:before{content:'âœ“';display:inline-flex;align-items:center;justify-content:center;width:14px;height:14px;border-radius:999px;background:rgba(40,255,190,.18);color:#b6ffeb;font-size:9px;font-weight:1000;flex:0 0 auto;}" +
    "#diqAdventureInfoCard .diqAdvSub{margin-top:6px!important;color:rgba(255,255,255,.82)!important;font-size:11.5px!important;line-height:1.34!important;font-weight:730!important;display:block!important;-webkit-line-clamp:unset!important;}" +
    "#diqAdventureInfoCard .diqPlaceFacts{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:1px;margin-top:10px;border-radius:17px;overflow:hidden;background:rgba(255,255,255,.09);border:1px solid rgba(255,255,255,.10);}" +
    "#diqAdventureInfoCard .diqPlaceFact{min-width:0;padding:10px 7px;text-align:center;background:rgba(5,12,22,.88);}" +
    "#diqAdventureInfoCard .diqPlaceFactStrong{display:block;color:#fff;font-size:10px;line-height:1.08;font-weight:1000;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}" +
    "#diqAdventureInfoCard .diqPlaceFactSmall{display:block;margin-top:4px;color:rgba(255,255,255,.52);font-size:7.5px;line-height:1.05;font-weight:800;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}" +
    "#diqAdventureInfoCard .diqAdvDropSummary{margin-top:8px!important;display:flex!important;gap:5px!important;overflow-x:auto!important;flex-wrap:nowrap!important;scrollbar-width:none!important;}" +
    "#diqAdventureInfoCard .diqAdvDropSummary::-webkit-scrollbar{display:none!important;}" +
    "#diqAdventureInfoCard .diqAdvActions{display:grid!important;grid-template-columns:1fr 1fr!important;gap:8px!important;margin-top:11px!important;padding:0!important;}" +
    "#diqAdventureInfoCard .diqAdvActions button{min-height:43px!important;height:43px!important;padding:0 10px!important;border-radius:15px!important;white-space:nowrap!important;font-size:9.5px!important;letter-spacing:.55px!important;}" +
    "#diqAdventureInfoCard .diqAdvRoute{grid-column:1/-1!important;grid-row:1!important;min-height:52px!important;height:52px!important;color:#061018!important;background:linear-gradient(135deg,#fff1a2,#ffce69,#ff9f2e,#28ffbe)!important;border-color:rgba(255,255,255,.58)!important;font-size:12px!important;letter-spacing:1.25px!important;box-shadow:0 12px 30px rgba(255,206,105,.18),0 0 24px rgba(40,255,190,.10)!important;}" +
    "#diqAdventureInfoCard .diqAdvSave{grid-column:1!important;grid-row:2!important;background:rgba(255,255,255,.055)!important;color:#fff!important;}" +
    "#diqAdventureInfoCard .diqAdvDrop{grid-column:2!important;grid-row:2!important;background:rgba(255,255,255,.055)!important;color:#fff!important;}" +
    "@media(max-height:760px){#diqAdventureInfoCard .diqPlaceHero{height:132px;min-height:132px;}#diqAdventureInfoCard .diqAdvTitle{font-size:21px!important;}#diqAdventureInfoCard .diqPlaceScore{width:66px;height:66px;}#diqAdventureInfoCard .diqPlaceScoreValue{font-size:23px;}#diqAdventureInfoCard .diqPlaceHeroText{right:88px;}#diqAdventureInfoCard .diqPlaceBody{padding-top:10px;}#diqAdventureInfoCard .diqPlaceWhy{margin-top:9px;padding:9px 10px;}#diqAdventureInfoCard .diqAdvSub{font-size:10.5px!important;}#diqAdventureInfoCard .diqPlaceFact{padding:8px 5px;}#diqAdventureInfoCard .diqAdvRoute{height:48px!important;min-height:48px!important;}}" +
    "@media(max-width:380px){#diqAdventureInfoCard .diqPlaceHeroText{right:82px;}#diqAdventureInfoCard .diqAdvTitle{font-size:21px!important;}#diqAdventureInfoCard .diqPlaceScore{width:64px;height:64px;}#diqAdventureInfoCard .diqPlaceScoreValue{font-size:22px;}#diqAdventureInfoCard .diqPlaceBody{padding-left:11px;padding-right:11px;}#diqAdventureInfoCard .diqAdvTag{font-size:7px!important;padding:0 8px!important;}}" +
    "@media(orientation:landscape){#diqAdventureInfoCard{width:390px!important;}#diqAdventureInfoCard .diqPlaceHero{height:120px;min-height:120px;}#diqAdventureInfoCard .diqAdvTitle{font-size:20px!important;}#diqAdventureInfoCard .diqPlaceWhy{padding:8px 10px;}#diqAdventureInfoCard .diqAdvSub{font-size:10px!important;}}";




  style = document.createElement("style");
  style.id = "diqPlaceIqCardPhase1Style";
  style.type = "text/css";
  style.appendChild(document.createTextNode(css));
  try { document.head.appendChild(style); } catch (e) {}
}




injectPlaceIqCardPhase1Styles();




function hideHorizonForMapUse() {
  try { document.body.classList.add("adventureHorizonHidden"); } catch (e1) {}
  if (horizonHideTimer) { window.clearTimeout(horizonHideTimer); }
  horizonHideTimer = window.setTimeout(function () {
    try { document.body.classList.remove("adventureHorizonHidden"); } catch (e2) {}
  }, 5200);
}




function ensureScanResultsRestoreControl() {
  var btn = byId("adventureMenuRestore");
  if (!btn) {
    btn = document.createElement("button");
    btn.id = "adventureMenuRestore";
    btn.type = "button";
    btn.className = "menuRestoreBtn";
    btn.textContent = "Show Menu";
    try { document.body.appendChild(btn); } catch (e1) {}
  }
  try {
    btn.onclick = function (event) {
      if (event && event.preventDefault) { event.preventDefault(); }
      if (event && event.stopPropagation) { event.stopPropagation(); }

      /* V531: the surviving restore control opens the V600 results shelf.
         It no longer reopens the legacy full Adventure menu. */
      try {
        if (
          window.DriveIQAdventureUI &&
          typeof window.DriveIQAdventureUI.reopenResultsShelf === "function" &&
          window.DriveIQAdventureUI.reopenResultsShelf()
        ) {
          return false;
        }
      } catch (v600UIError) {}

      try {
        if (
          window.DriveIQAdventureScan &&
          typeof window.DriveIQAdventureScan.showResultShelf === "function"
        ) {
          window.DriveIQAdventureScan.showResultShelf();
          return false;
        }
      } catch (v600ScanError) {}

      try { toast("Results are not ready yet"); } catch (toastError) {}
      return false;
    };
    btn.textContent = "Show Places";
    btn.setAttribute("aria-label", "Show places found");
  } catch (e2) {}
  return btn;
}




function enterScanResultsMode(reason) {
  /* V21.8: Successful scans move Adventure into map-hero mode after a short
     completion pause. Destination search stays open; category/adventure scans
     can be restored with Show Menu. */
  injectAdventurePolishStyles();
  injectAdventureV21Styles();
  try {
    ensureScanResultsRestoreControl();
    document.body.classList.remove("adventureHorizonHidden");
  } catch (e1) {}
  if (scanResultsModeTimer) { window.clearTimeout(scanResultsModeTimer); scanResultsModeTimer = null; }
  if (window.console && window.console.log) { window.console.log("[Adventure Scan Results Ready]", reason || "scan_complete"); }
}
function exitScanResultsMode() {
  if (scanResultsModeTimer) { window.clearTimeout(scanResultsModeTimer); scanResultsModeTimer = null; }
  try { document.body.classList.remove("adventureScanResultsMode"); } catch (e) {}
}




function afterScanResultsReady(items, preferred, reason) {
  var count = items && items.length ? items.length : 0;
  if (!count) { return; }
  enterScanResultsMode(reason || "scan_complete");
  lsJSON(LS.LAST_SCAN, { lens:activeLens, count:count, scope:adventureSearchScope, ts:Date.now() });
  syncAdventureMapDock();
  mapAreaScanActive = false;
  diqV231ApplyScanReliabilityUi(String(Math.min(count, 8)) + " strong matches found", "green");
  speakAdventureScanComplete(count, preferred || items[0], activeScanQuery || activeLens);
  if (scanMapFitTimer) { window.clearTimeout(scanMapFitTimer); }
  scanMapFitTimer = window.setTimeout(function () {
    fitAdventureResultsCluster(items, preferred || items[0]);
  }, 120);
  autoCollapseAdventureMenuAfterScan(reason || "scan_complete");
}








function injectAdventureV21Styles() {
  var style;
  var css;
  if (byId("diqAdventureV21Style")) { return; }
  css =
    "#diqAdventureMapDock{position:fixed;right:14px;top:112px;z-index:89;display:none;flex-direction:column;gap:8px;font-family:system-ui,-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;}" +
    "body.adventureScanResultsMode #diqAdventureMapDock{display:flex;}" +
    "#diqAdventureMapDock button{min-width:106px;min-height:38px;padding:0 12px;border-radius:14px;border:1px solid rgba(255,255,255,.16);background:rgba(5,12,22,.90);color:#fff;font-size:9px;font-weight:1000;letter-spacing:.65px;box-shadow:0 12px 28px rgba(0,0,0,.34);backdrop-filter:blur(12px);-webkit-backdrop-filter:blur(12px);}" +
    "#diqAdventureMapDock .primary{color:#061018;background:linear-gradient(135deg,#ffce69,#28ffbe);border-color:rgba(255,245,184,.55);}" +
    "#diqAdventureMapDock .count{display:inline-block;margin-left:4px;opacity:.72;}" +
    ".diqDestTopPick{color:#061018!important;background:linear-gradient(135deg,#fff2a8,#ffce69,#28ffbe)!important;border:0!important;}" +
    ".diqAdvFresh{color:#b6ffeb!important;border-color:rgba(40,255,190,.26)!important;}" +
    "@media(max-width:420px){#diqAdventureMapDock{top:104px;right:10px;}#diqAdventureMapDock button{min-width:94px;padding:0 9px;}}";
  style = document.createElement("style");
  style.id = "diqAdventureV21Style";
  style.type = "text/css";
  style.appendChild(document.createTextNode(css));
  try { document.head.appendChild(style); } catch (e) {}
}




function adventureMapScanButtonLabel() {
  var cat = categoryFromQuery(activeScanQuery || activeLens || "popular tonight");




  if (cat === "popular tonight" || cat === "live music") { return "NIGHTLIFE"; }
  if (cat === "food iq") { return "FOOD IQ"; }
  if (cat === "food drinks") { return "FOOD + DRINKS"; }
  if (cat === "patio vibes") { return "PATIO VIBES"; }
  if (cat === "local favorites") { return "LOCAL FAVORITES"; }
  if (cat === "run walk") { return "RUN + WALK"; }
  if (cat === "hidden gems") { return "HIDDEN GEMS"; }
  if (cat) { return String(cat).toUpperCase(); }




  return "SCAN THIS MAP";
}




function ensureAdventureMapDock() {
  var dock = byId("diqAdventureMapDock");
  var rescan;
  var list;
  if (dock) { return dock; }
  injectAdventureV21Styles();
  dock = document.createElement("div");
  dock.id = "diqAdventureMapDock";
  dock.innerHTML = '<button type="button" class="primary" id="diqRescanMap">NIGHTLIFE</button><button type="button" id="diqShowResults">SHOW PICKS <span class="count" id="diqMapPickCount"></span></button>';
  try { document.body.appendChild(dock); } catch (e1) {}
  rescan = byId("diqRescanMap");
  list = byId("diqShowResults");
  if (rescan) {
    rescan.onclick = function () {
      var center;
      if (!map || !mapLoaded) { return; }
      try { center = map.getCenter(); } catch (e2) { center = null; }
      if (!center) { return; }
      adventureSearchCenter = { lat:Number(center.lat), lng:Number(center.lng), label:"this map area" };
      adventureSearchScope = "map_area";
      mapAreaScanActive = true;
      adventureDestinationCameraHold = true;
      adventureDestinationCameraHoldAt = Date.now();
      closeAdventureInfoCard();
      hideDestinationResults();
      scanAdventureChoices(activeLens || "popular tonight");
      toast("Scanning " + adventureMapScanButtonLabel().toLowerCase() + " in this map area");
    };
  }
  if (list) {
    list.onclick = function () {
      if (adventureResults && adventureResults.length) {
        renderAdventureScanChoices(adventureResults, activeLens);
        fitAdventureResultsCluster(adventureResults, adventurePreferred || adventureResults[0]);
      }
    };
  }
  return dock;
}




function syncAdventureMapDock() {
  var count;
  var rescan;




  ensureAdventureMapDock();
  count = byId("diqMapPickCount");
  rescan = byId("diqRescanMap");




  if (count) {
    count.textContent = adventureResults && adventureResults.length
      ? String(adventureResults.length)
      : "";
  }




  if (rescan) {
    rescan.textContent = adventureMapScanButtonLabel();
    rescan.setAttribute("aria-label", "Scan this map for " + adventureMapScanButtonLabel().toLowerCase());
  }
}








function injectAdventureConversionIQStyles() {
  var style;
  var css;
  if (byId("diqAdventureConversionIQStyle")) { return; }
  css =
    "#diqAdventureInfoCard.diqConversionIQ{border-radius:28px!important;border-color:rgba(255,206,105,.42)!important;box-shadow:0 28px 76px rgba(0,0,0,.68),0 0 42px rgba(255,206,105,.14),0 0 28px rgba(40,255,190,.09)!important;}" +
    "#diqAdventureInfoCard.diqConversionIQ .diqPlaceHero{height:190px!important;min-height:190px!important;background:#07111d!important;}" +
    "#diqAdventureInfoCard.diqConversionIQ .diqAdvPhoto{transition:opacity .18s ease,transform .35s ease;transform:scale(1.012);}" +
    "#diqAdventureInfoCard.diqConversionIQ .diqPlaceHeroShade{background:linear-gradient(180deg,rgba(2,8,18,.03),rgba(2,8,18,.16) 38%,rgba(2,8,18,.96))!important;}" +
    "#diqAdventureInfoCard.diqConversionIQ .diqPhotoGalleryNav{position:absolute;left:13px;right:13px;bottom:7px;z-index:4;display:flex;align-items:center;justify-content:center;gap:5px;pointer-events:none;}" +
    "#diqAdventureInfoCard.diqConversionIQ .diqPhotoDot{width:6px;height:6px;border-radius:999px;background:rgba(255,255,255,.40);box-shadow:0 0 8px rgba(0,0,0,.35);}" +
    "#diqAdventureInfoCard.diqConversionIQ .diqPhotoDot.on{width:18px;background:#ffce69;box-shadow:0 0 12px rgba(255,206,105,.55);}" +
    "#diqAdventureInfoCard.diqConversionIQ .diqPhotoHint{position:absolute;left:14px;bottom:36px;z-index:3;display:inline-flex;align-items:center;min-height:24px;padding:0 9px;border-radius:999px;background:rgba(5,12,22,.72);border:1px solid rgba(255,255,255,.18);backdrop-filter:blur(12px);-webkit-backdrop-filter:blur(12px);color:#fff;font-size:7.5px;font-weight:1000;letter-spacing:.72px;text-transform:uppercase;}" +
    "#diqAdventureInfoCard.diqConversionIQ .diqPlaceHeroText{bottom:31px!important;right:104px!important;}" +
    "#diqAdventureInfoCard.diqConversionIQ .diqPlaceScore{bottom:28px!important;}" +
    "#diqAdventureInfoCard.diqConversionIQ .diqAdvWorth{padding-bottom:4px!important;}" +
    "#diqAdventureInfoCard.diqConversionIQ .diqAdvTag{min-height:30px!important;padding:0 10px!important;font-size:7.8px!important;background:rgba(40,255,190,.10)!important;border-color:rgba(40,255,190,.30)!important;}" +
    "#diqAdventureInfoCard.diqConversionIQ .diqAdvScore{background:linear-gradient(135deg,rgba(255,206,105,.18),rgba(40,255,190,.10))!important;border-color:rgba(255,206,105,.58)!important;color:#ffe29a!important;}" +
    "#diqAdventureInfoCard.diqConversionIQ .diqPlaceWhy{margin-top:13px!important;padding:13px 13px!important;background:linear-gradient(145deg,rgba(255,206,105,.10),rgba(40,255,190,.055))!important;border-color:rgba(255,255,255,.13)!important;}" +
    "#diqAdventureInfoCard.diqConversionIQ .diqPlaceWhyLabel{font-size:8.4px!important;color:#ffe29a!important;}" +
    "#diqAdventureInfoCard.diqConversionIQ .diqAdvSub{font-size:12.4px!important;line-height:1.36!important;font-weight:780!important;color:rgba(255,255,255,.88)!important;}" +
    "#diqAdventureInfoCard.diqConversionIQ .diqTrustReason{min-height:27px!important;font-size:9.6px!important;background:rgba(40,255,190,.08)!important;border-color:rgba(40,255,190,.20)!important;}" +
    "#diqAdventureInfoCard.diqConversionIQ .diqPlaceFacts{margin-top:12px!important;}" +
    "#diqAdventureInfoCard.diqConversionIQ .diqAdvActions{gap:9px!important;margin-top:13px!important;}" +
    "#diqAdventureInfoCard.diqConversionIQ .diqAdvRoute{height:58px!important;min-height:58px!important;border-radius:18px!important;font-size:13px!important;letter-spacing:1.35px!important;background:radial-gradient(circle at 16% 12%,rgba(255,255,255,.72),transparent 26%),linear-gradient(135deg,#fff2a8 0%,#ffce69 35%,#ff9f2e 62%,#28ffbe 100%)!important;box-shadow:0 16px 34px rgba(255,206,105,.24),0 0 30px rgba(40,255,190,.14)!important;}" +
    "#diqAdventureInfoCard.diqConversionIQ .diqAdvRoute:after{content:' â†’';font-size:16px;font-weight:1000;}" +
    "@media(max-height:760px){#diqAdventureInfoCard.diqConversionIQ .diqPlaceHero{height:148px!important;min-height:148px!important;}#diqAdventureInfoCard.diqConversionIQ .diqPlaceHeroText{bottom:25px!important;}#diqAdventureInfoCard.diqConversionIQ .diqPlaceScore{bottom:22px!important;}#diqAdventureInfoCard.diqConversionIQ .diqPhotoHint{bottom:30px;}#diqAdventureInfoCard.diqConversionIQ .diqAdvRoute{height:52px!important;min-height:52px!important;}}" +
    "#diqAdventureInfoCard.diqConversionIQ .diqAdvPhoto.local,#diqAdventureInfoCard.diqConversionIQ .diqAdvPhoto.dining{background:radial-gradient(circle at 22% 20%,rgba(255,206,105,.42),transparent 30%),radial-gradient(circle at 76% 26%,rgba(40,255,190,.28),transparent 28%),linear-gradient(135deg,#140b10,#10221d 48%,#07111d)!important;}" +
    "#diqAdventureInfoCard.diqConversionIQ .diqAdvPhoto.dining:before{content:'ðŸ½ï¸';position:absolute;right:20px;top:18px;font-size:46px;filter:drop-shadow(0 8px 22px rgba(0,0,0,.45));opacity:.90;}" +
    "#diqAdventureInfoCard.diqConversionIQ .diqAdvPhoto.water{background:radial-gradient(circle at 30% 22%,rgba(89,210,255,.35),transparent 30%),linear-gradient(135deg,#061827,#064047 52%,#07111d)!important;}" +
    "#diqAdventureInfoCard.diqConversionIQ .diqAdvPhoto.water:before{content:'ðŸŒŠ';position:absolute;right:20px;top:18px;font-size:46px;filter:drop-shadow(0 8px 22px rgba(0,0,0,.45));opacity:.88;}" +
    "#diqAdventureInfoCard.diqConversionIQ .diqAdvPhoto.outdoor{background:radial-gradient(circle at 22% 18%,rgba(108,255,183,.30),transparent 30%),linear-gradient(135deg,#07150d,#123222 55%,#07111d)!important;}" +
    "#diqAdventureInfoCard.diqConversionIQ .diqAdvPhoto.outdoor:before{content:'ðŸžï¸';position:absolute;right:20px;top:18px;font-size:46px;filter:drop-shadow(0 8px 22px rgba(0,0,0,.45));opacity:.88;}" +
    "#diqAdventureInfoCard.diqConversionIQ .diqAdvPhoto.realPhoto:before{display:none!important;}" +
    "#diqAdventureInfoCard.diqConversionIQ .diqAdvPhoto.map{filter:saturate(.76) brightness(.70)!important;}" +
    "#diqAdventureInfoCard.diqConversionIQ .diqTrustReason{display:flex!important;align-items:flex-start!important;gap:8px!important;line-height:1.28!important;}" +
    "#diqAdventureInfoCard.diqConversionIQ .diqTrustCheck{display:inline-flex;align-items:center;justify-content:center;width:16px;height:16px;border-radius:999px;background:rgba(40,255,190,.25);color:#b6ffeb;flex:0 0 auto;font-size:10px;font-weight:1000;}" +
    "#diqAdventureInfoCard.diqConversionIQ .diqPlaceScoreLabel{line-height:1.05!important;}" +
    "@media(orientation:landscape){#diqAdventureInfoCard.diqConversionIQ .diqPlaceHero{height:136px!important;min-height:136px!important;}#diqAdventureInfoCard.diqConversionIQ .diqPhotoHint{display:none;}#diqAdventureInfoCard.diqConversionIQ .diqPlaceHeroText{bottom:22px!important;}#diqAdventureInfoCard.diqConversionIQ .diqPlaceScore{bottom:18px!important;}}";
  style = document.createElement("style");
  style.id = "diqAdventureConversionIQStyle";
  style.type = "text/css";
  style.appendChild(document.createTextNode(css));
  try { document.head.appendChild(style); } catch (e) {}
}




function ensureInfoCard() {
  var card;
  injectAdventureV21_7CardSafeStyles();
  injectPlaceIqCardPhase1Styles();
  injectAdventureConversionIQStyles();
  injectDiqPhotoVerifyStyles();
  if (byId("diqAdventureInfoCard")) { return byId("diqAdventureInfoCard"); }
  card = document.createElement("div");
  card.id = "diqAdventureInfoCard";
  card.innerHTML =
    '<div class="diqPlaceHero">' +
      '<div class="diqAdvPhoto local" id="diqAdvInfoPhoto"></div>' +
      '<div class="diqPlaceHeroShade"></div>' +
      '<div class="diqPhotoHint" id="diqPhotoHint">Photo IQ</div>' +
      '<div class="diqPhotoGalleryNav" id="diqPhotoGalleryNav"></div>' +
      '<div class="diqPlaceTopRow"><div class="diqAdvKicker">PLACE IQ</div><button type="button" class="diqAdvClose" id="diqAdvInfoClose" aria-label="Close place card">Ã—</button></div>' +
      '<div class="diqPlaceHeroText"><div class="diqAdvTitle" id="diqAdvInfoTitle">Adventure</div><div class="diqPlaceCategory" id="diqAdvInfoCategory">Worth exploring</div></div>' +
      '<div class="diqPlaceScore"><span class="diqPlaceScoreValue" id="diqAdvInfoScore">--</span><span class="diqPlaceScoreLabel">Worth the Drive</span></div>' +
    '</div>' +
    '<div class="diqPlaceBody">' +
      '<div class="diqAdvWorth" id="diqAdvInfoWorth"></div>' +
      '<div class="diqPlaceWhy"><div class="diqPlaceWhyLabel">Why Itâ€™s Worth the Drive</div><div class="diqAdvSub" id="diqAdvInfoSub">Ready</div><div class="diqTrustBecause" id="diqTrustBecause"></div></div>' +
      '<div class="diqPlaceFacts">' +
        '<div class="diqPlaceFact"><span class="diqPlaceFactStrong" id="diqAdvInfoDistance">Nearby</span><span class="diqPlaceFactSmall">Distance</span></div>' +
        '<div class="diqPlaceFact"><span class="diqPlaceFactStrong" id="diqAdvInfoFreshness">Place IQ</span><span class="diqPlaceFactSmall">Freshness</span></div>' +
        '<div class="diqPlaceFact"><span class="diqPlaceFactStrong" id="diqAdvInfoConfidence">Worth a look</span><span class="diqPlaceFactSmall">Confidence</span></div>' +
      '</div>' +
      '<div class="diqAdvDropSummary" id="diqAdvDropSummary"></div>' +
      '<div class="diqAdvActions">' +
        '<button type="button" class="diqAdvSave" id="diqAdvInfoSave">â˜† SAVE</button>' +
        '<button type="button" class="diqAdvDrop" id="diqAdvInfoDrop">â—‰ DROP</button>' +
        '<button type="button" class="diqAdvRoute" id="diqAdvInfoRoute">ROUTE HERE</button>' +
      '</div>' +
    '</div>';
  try { document.body.appendChild(card); } catch (e) {}
  try { byId("diqAdvInfoClose").onclick = closeAdventureInfoCard; } catch (e2) {}
  return card;
}








function ensureExploreNearbyButton() {
  var btn;
  var routeCard;
  var startBtn;
  if (byId("diqExploreNearbyBtn")) { return byId("diqExploreNearbyBtn"); }
  btn = document.createElement("button");
  btn.id = "diqExploreNearbyBtn";
  btn.type = "button";
  btn.innerHTML = 'LOCAL MAP<span class="count" id="diqExploreNearbyCount">READY</span><span class="small">Trails â€¢ water â€¢ overlooks â€¢ access points</span>';
  btn.onclick = function () { startExploreNearby(); };




  startBtn = byId("startAdventure");
  routeCard = startBtn && startBtn.parentNode ? startBtn.parentNode : null;




  if (routeCard && routeCard.insertBefore) {
    try { routeCard.insertBefore(btn, startBtn); } catch (e1) {}
  } else if (byId("adventureApp")) {
    try { byId("adventureApp").appendChild(btn); } catch (e2) {}
  }




  return btn;
}




function syncExploreNearbyButton() {
  var btn;
  var count;
  var ready = false;
  injectAdventurePolishStyles();
  btn = ensureExploreNearbyButton();
  if (!btn) { return; }




  ready = !!(destination && finite(Number(destination.lat)) && finite(Number(destination.lng)));




  if (ready) {
    btn.className = "on";
    try { document.body.classList.add("adventureRouteReady"); } catch (e1) {}
  } else {
    btn.className = "";
    try { document.body.classList.remove("adventureRouteReady"); } catch (e2) {}
  }




  count = byId("diqExploreNearbyCount");
  if (count) {
    if (exploreResults && exploreResults.length) {
      count.textContent = String(exploreResults.length) + " SPOTS";
    } else {
      count.textContent = "LOCAL MAP";
    }
  }
}




function destinationDistanceText(item) {
  var d;
  if (!item || !destination) { return ""; }
  d = miles(Number(destination.lat), Number(destination.lng), Number(item.lat), Number(item.lng));
  if (!finite(d)) { return ""; }
  if (d < 0.1) { return "at destination"; }
  if (d < 10) { return String(Math.round(d * 10) / 10) + " mi from stop"; }
  return String(Math.round(d)) + " mi from stop";
}




function closeAdventureInfoCard() {
  var card = byId("diqAdventureInfoCard");
  var closedItem = null;

  if (card) {
    try { closedItem = card.__diqPlaceItem || null; } catch (e0) {}
    card.className = "";
    card.setAttribute("aria-hidden", "true");
    try { card.__diqPlaceItem = null; } catch (e1) {}
  }

  /* V532 â€” Closing Place IQ must release every focused-place authority.
     Without this reset, the first pin opens correctly but later pin taps are
     treated as though the original card is still active. */
  try {
    if (document.body) {
      document.body.classList.remove("diqPlaceIQMode");
      document.body.classList.remove("diq-v600-place");
      document.body.classList.add("diq-v600-map");
    }
  } catch (e2) {}

  try {
    if (window.DriveIQAdventureEvents &&
        typeof window.DriveIQAdventureEvents.emit === "function") {
      window.DriveIQAdventureEvents.emit("place:closed", {
        item: closedItem,
        place: closedItem,
        source: "legacy-place-card-close"
      });
    }
  } catch (e3) {}

  try {
    window.dispatchEvent(new CustomEvent("driveiq:adventure-place-closed", {
      detail: {
        item: closedItem,
        place: closedItem,
        source: "legacy-place-card-close"
      }
    }));
  } catch (e4) {}

  try {
    if (window.DriveIQAdventureUI &&
        typeof window.DriveIQAdventureUI.showMap === "function") {
      window.DriveIQAdventureUI.showMap({ force: true });
    }
  } catch (e5) {}

  try {
    if (window.DriveIQAdventureV531 &&
        typeof window.DriveIQAdventureV531.releaseMapInteraction === "function") {
      window.DriveIQAdventureV531.releaseMapInteraction();
    }
  } catch (e6) {}

  return true;
}




function itemDistanceText(item) {
  var d = item && finite(Number(item.distMiles)) ? Number(item.distMiles) : null;
  if (d === null) { return ""; }
  if (d < 0.1) { return "0.1 mi"; }
  if (d < 10) { return String(Math.round(d * 10) / 10) + " mi"; }
  return String(Math.round(d)) + " mi";
}




function compactAdventureInfoText(item) {
  var parts = [];
  var text;
  if (!item) { return "Ready"; }
  item = enrichAdventureItem(item, activeLens);




  if (item.worthStars) { parts.push(String(item.worthStars) + " Worth the Drive"); }
  if (item.matchLabel) { parts.push(String(item.matchLabel)); }
  if (destinationDistanceText(item)) { parts.push(destinationDistanceText(item)); }
  else if (itemDistanceText(item)) { parts.push(itemDistanceText(item)); }
  if (item.whyStop) { parts.push(String(item.whyStop)); }




  text = clean(parts.join(" â€¢ ").replace(/ â€¢  â€¢ /g, " â€¢ "));
  if (text.length > 190) { text = text.slice(0, 187) + "..."; }
  return text;
}




/* =========================================================
   DRIVE IQ V26.0 â€” TRUST IQ / RECOMMENDED BECAUSE
   Turns Place IQ from a directory card into a decision-confidence card.
   Every recommendation should explain why it was picked without faking certainty.
========================================================= */




function diqTrustTextForItem(item) {
  return normText(
    String(item && item.label || "") + " " +
    String(item && item.full || "") + " " +
    String(item && item.matchLabel || "") + " " +
    String(item && item.kind || "") + " " +
    String(item && item.sourceQuery || "") + " " +
    String(item && item.adventureCategory || "")
  );
}




function diqHasTrustSignal(item, terms) {
  var txt = diqTrustTextForItem(item);
  var i;
  for (i = 0; i < (terms || []).length; i++) {
    if (txt.indexOf(String(terms[i]).toLowerCase()) > -1) { return true; }
  }
  return false;
}




function diqHumanReasonPool(item, query) {
  var out = [];
  var cat = adventurePrimaryCategory(item, query || activeLens);
  var txt = diqTrustTextForItem(item);
  var score = Number(item && item.worthScore || 0);
  var drops = dropCountsForItem(item);
  var dist = destinationDistanceText(item) || itemDistanceText(item);




  function add(reason) {
    var i;
    reason = clean(reason);
    if (!reason) { return; }
    for (i = 0; i < out.length; i++) {
      if (normText(out[i]) === normText(reason)) { return; }
    }
    out.push(reason);
  }




  if (cat === "food iq" || cat === "food drinks" || cat === "popular tonight") {
    add("A stronger food pick than another random nearby result.");
    if (score >= 88) { add("One of the best food signals in this scan."); }
    add("Worth checking when you want the drive to end somewhere good.");
  } else if (cat === "coffee iq") {
    add("A better coffee stop when you want more than the obvious chain.");
    add("Good fit for a caffeine run, quick reset, or relaxed stop.");
  } else if (cat === "patio vibes") {
    add("A better choice when the atmosphere matters as much as the food.");
    add("Good fit for a relaxed patio-style stop.");
  } else if (cat === "live music") {
    add("A stronger pick when you want real energy instead of a quiet stop.");
    add("Good fit for music, nightlife, or a more social night out.");
  } else if (cat === "waterfront" || cat === "water") {
    add("A stop that feels more like an experience than an errand.");
    add("Good fit when you want water, views, or a more memorable drive.");
  } else if (cat === "local favorites") {
    add("This has the kind of local signal Drive IQ looks for first.");
    add("A better bet when you want somewhere people nearby actually use.");
  } else if (cat === "shopping") {
    add("A more interesting local shopping pick than another generic big-box result.");
    add("Good fit when the stop should feel local, not copy-paste.");
  } else if (cat === "trails" || cat === "parks" || cat === "scenic" || cat === "camping") {
    add("A simple way to turn the drive into something worth remembering.");
    add("Good fit when you want views, fresh air, or a real adventure stop.");
  } else {
    add("A strong fit for this scan, ranked for confidence instead of clutter.");
  }




  if (txt.indexOf("open") > -1) { add("Open-now signal makes it easier to choose with confidence."); }
  if (txt.indexOf("downtown") > -1 || txt.indexOf("square") > -1 || txt.indexOf("historic") > -1) { add("Located in an area with more local character than a generic stop."); }
  if (drops && drops.total) { add("Recent Adventure Drops add fresh local confidence."); }
  if (dist) { add(dist + " away, so it is easy to turn this into a real stop."); }
  if (score >= 92) { add("High enough confidence to make the short list fast."); }




  if (!out.length) { add("Relevant to this scan and worth a closer look."); }
  return out.slice(0, 4);
}




function recommendedBecauseReasons(item, query) {
  return diqHumanReasonPool(item, query || activeLens);
}




function renderRecommendedBecause(item, query) {
  var el = byId("diqTrustBecause");
  var reasons;
  var html = "";
  var i;
  if (!el) { return; }
  reasons = recommendedBecauseReasons(item, query || activeLens);
  if (!reasons.length) { el.innerHTML = ""; return; }
  html += '<div class="diqTrustBecauseTitle">Decision Confidence</div>';
  for (i = 0; i < reasons.length; i++) {
    html += '<div class="diqTrustReason"><span class="diqTrustCheck">âœ“</span><span>' + escapeHTML(reasons[i]) + '</span></div>';
  }
  el.innerHTML = html;
}








function diqAddUniquePhoto(list, url, label, kind) {
  var i;
  var k;
  url = clean(url);
  kind = clean(kind || "official");
  if (!url) { return; }
  if (kind !== "map" && !diqLooksLikeImageUrl(url)) { return; }
  if (url.indexOf("http") !== 0 && url.indexOf("data:image") !== 0) { return; }
  for (i = 0; i < list.length; i++) {
    if (String(list[i].url || "") === url) { return; }
  }
  k = kind;
  if (url.toLowerCase().indexOf("api.mapbox.com/styles") > -1 || url.toLowerCase().indexOf("staticmap") > -1) { k = "map"; }
  list.push({ url:url, label:clean(label || "Photo"), kind:k, priority:diqPhotoKindPriority(k) });
}




function diqIntentPhotoLabel(item, query) {
  var cat = adventurePrimaryCategory(item, query || activeLens);
  if (cat === "coffee iq") { return "Coffee Photo"; }
  if (cat === "patio vibes") { return "Patio Photo"; }
  if (cat === "live music") { return "Live Music Photo"; }
  if (cat === "waterfront" || cat === "water") { return "Waterfront Photo"; }
  if (cat === "food iq" || cat === "food drinks" || cat === "popular tonight") { return "Food Photo"; }
  if (cat === "trails" || cat === "parks" || cat === "scenic" || cat === "camping") { return "Adventure Photo"; }
  if (cat === "shopping") { return "Local Shopping Photo"; }
  return "Place Photo";
}




function diqCategoryFallbackPhoto(item, query) {
  var catClass = categoryPhotoClass(item, query || activeLens);
  return { url:"", label:diqIntentPhotoLabel(item, query), kind:catClass || "local", priority:50 };
}




function diqIntentPhotoBoost(photo, item, query) {
  var cat = adventurePrimaryCategory(item, query || activeLens);
  var text = normText(String(photo && photo.label || "") + " " + String(photo && photo.kind || "") + " " + String(photo && photo.url || ""));
  var boost = 0;
  if (cat === "coffee iq" && /(coffee|cafe|espresso|latte|bakery)/.test(text)) { boost -= 3; }
  if ((cat === "food iq" || cat === "food drinks" || cat === "popular tonight") && /(food|dish|menu|burger|bbq|pizza|taco|steak|sushi|dining)/.test(text)) { boost -= 3; }
  if (cat === "patio vibes" && /(patio|outdoor|terrace|porch|deck|rooftop)/.test(text)) { boost -= 4; }
  if (cat === "live music" && /(music|stage|band|concert|night)/.test(text)) { boost -= 4; }
  if ((cat === "waterfront" || cat === "water") && /(water|lake|river|beach|marina|waterfront)/.test(text)) { boost -= 4; }
  if ((cat === "trails" || cat === "parks" || cat === "scenic" || cat === "camping") && /(trail|park|scenic|view|camp|outdoor|waterfall|cave)/.test(text)) { boost -= 3; }
  if (text.indexOf("logo") > -1 || text.indexOf("icon") > -1) { boost += 8; }
  return boost;
}




function diqBuildPlaceGallery(item, query) {
  var photos = [];
  var realPhotos = [];
  var raw;
  var p;
  var i;
  var v;
  var fallback;




  if (!item) { return photos; }




  if (item.photos && item.photos.length) {
    for (i = 0; i < item.photos.length; i++) {
      if (typeof item.photos[i] === "string") { diqAddUniquePhoto(photos, item.photos[i], "Gallery Photo", "gallery"); }
      else if (item.photos[i] && item.photos[i].url) { diqAddUniquePhoto(photos, item.photos[i].url, item.photos[i].label || "Gallery Photo", item.photos[i].kind || "gallery"); }
    }
  }




  diqAddUniquePhoto(photos, item.officialPhoto, "Official Photo", "official");
  diqAddUniquePhoto(photos, item.businessPhoto, "Business Photo", "official");
  diqAddUniquePhoto(photos, item.heroPhoto, diqIntentPhotoLabel(item, query), "official");
  diqAddUniquePhoto(photos, item.photoUrl, diqIntentPhotoLabel(item, query), "official");
  diqAddUniquePhoto(photos, item.photo, "Place Photo", "official");
  diqAddUniquePhoto(photos, item.image, "Place Photo", "official");
  diqAddUniquePhoto(photos, item.imageUrl, "Place Photo", "official");
  diqAddUniquePhoto(photos, item.thumbnail, "Verified Photo", "verified");




  try { diqCollectPhotoCandidates(item, photos, "Place Photo", 0); } catch (collectItemErr) {}
  try {
    raw = item.raw || item.properties || item.datasourceRaw || null;
    if (raw) { diqCollectPhotoCandidates(raw, photos, "Verified Photo", 0); }
    if (raw && raw.datasource && raw.datasource.raw) { diqCollectPhotoCandidates(raw.datasource.raw, photos, "Official Photo", 0); }
    if (raw && raw.wiki_and_media) { diqCollectPhotoCandidates(raw.wiki_and_media, photos, "Media Photo", 0); }
  } catch (e1) {}




  try {
    var directGooglePhotos = diqGoogleDirectPhotoCandidates(item, query);
    for (i = 0; i < directGooglePhotos.length; i++) {
      if (directGooglePhotos[i] && directGooglePhotos[i].url) { diqAddUniquePhoto(photos, directGooglePhotos[i].url, directGooglePhotos[i].label || "Google Place Photo", directGooglePhotos[i].kind || "google_direct"); }
    }
  } catch (directGoogleErr) {}




  for (i = 0; i < photos.length; i++) {
    if (photos[i] && photos[i].kind !== "map" && diqLooksLikeImageUrl(photos[i].url)) { realPhotos.push(photos[i]); }
  }




  realPhotos.sort(function (a, b) {
    var pa = Number(a.priority || diqPhotoKindPriority(a.kind)) + diqIntentPhotoBoost(a, item, query);
    var pb = Number(b.priority || diqPhotoKindPriority(b.kind)) + diqIntentPhotoBoost(b, item, query);
    if (pa !== pb) { return pa - pb; }
    return String(a.url || "").length - String(b.url || "").length;
  });




  if (realPhotos.length) { return realPhotos.slice(0, 6); }




  /* V30: do not lead with a satellite map when no venue photo exists.
     Use a premium category visual first; map preview remains available only
     as the true last-resort data object if the UI needs a real URL later. */
  fallback = diqCategoryFallbackPhoto(item, query);
  photos = [fallback];
  v = staticMapPhotoUrl(item);
  if (v) { photos.push({ url:v, label:"Map Preview", kind:"map", priority:99 }); }
  return photos.slice(0, 6);
}




function injectDiqPhotoVerifyStyles() {
  var style;
  var css;
  if (byId("diqPhotoVerifyFallbackStyle")) { return; }




  css =
    "#diqAdventureInfoCard .diqAdvPhoto:after{display:none!important;content:''!important;}" +
    "#diqAdventureInfoCard .diqAdvPhoto.photoLive:after{content:attr(data-photo-label)!important;display:inline-flex!important;position:absolute!important;left:10px!important;bottom:9px!important;padding:4px 8px!important;border-radius:999px!important;background:rgba(5,12,22,.72)!important;border:1px solid rgba(255,255,255,.16)!important;font-size:8px!important;font-weight:1000!important;letter-spacing:.6px!important;color:#fff!important;z-index:4!important;}" +
    "#diqAdventureInfoCard.diqConversionIQ .diqAdvPhoto.photoFallback{background-size:cover!important;background-position:center!important;}" +
    "#diqAdventureInfoCard.diqConversionIQ .diqPhotoHint.photoFallback{color:#b6ffeb!important;border-color:rgba(40,255,190,.24)!important;}" +
    "#diqAdventureInfoCard.diqConversionIQ .diqPhotoHint.photoLoading{color:#ffdf8a!important;border-color:rgba(255,206,105,.26)!important;}" +
    "#diqAdventureInfoCard.diqConversionIQ .diqPhotoHint.photoLive{color:#fff!important;border-color:rgba(255,255,255,.22)!important;}";




  style = document.createElement("style");
  style.id = "diqPhotoVerifyFallbackStyle";
  style.type = "text/css";
  style.appendChild(document.createTextNode(css));
  try { document.head.appendChild(style); } catch (e) {}
}




function diqPhotoCandidateIsReal(p) {
  if (!p || !p.url) { return false; }
  if (p.kind === "map") { return false; }
  return diqLooksLikeImageUrl(p.url);
}




function diqPhotoFallbackLabel(item, query) {
  var cat = adventurePrimaryCategory(item, query || activeLens);
  if (cat === "coffee iq") { return "Coffee IQ visual"; }
  if (cat === "food iq" || cat === "food drinks" || cat === "popular tonight") { return "Food IQ visual"; }
  if (cat === "patio vibes") { return "Patio IQ visual"; }
  if (cat === "live music") { return "Live Music visual"; }
  if (cat === "waterfront" || cat === "water") { return "Waterfront visual"; }
  if (cat === "trails" || cat === "parks" || cat === "scenic" || cat === "camping") { return "Adventure visual"; }
  return "Place IQ visual";
}




function diqApplyPhotoFallback(photo, hint, item, query, reason) {
  var cls = categoryPhotoClass(item, query || activeLens) || "local";
  if (photo) {
    photo.className = "diqAdvPhoto " + cls + " photoFallback";
    photo.setAttribute("style", "");
    photo.setAttribute("data-photo-kind", cls);
    photo.setAttribute("data-photo-live", "0");
    photo.setAttribute("data-photo-fallback-reason", clean(reason || "fallback"));
    photo.removeAttribute("data-photo-label");
  }
  if (hint) {
    hint.className = String(hint.className || "").replace(/\s?photoLive/g, "").replace(/\s?photoLoading/g, "").replace(/\s?photoFallback/g, "") + " photoFallback";
    hint.textContent = diqPhotoFallbackLabel(item, query);
  }
}




/* V38 â€” Verified photo render authority.
   The card no longer claims PLACE PHOTO just because a URL string exists.
   It preloads the image first. If Google/venue media fails, the card falls
   back to category art and hides the fake photo chip. */
function diqApplyPlaceGallery(item, query) {
  var photo = byId("diqAdvInfoPhoto");
  var nav = byId("diqPhotoGalleryNav");
  var hint = byId("diqPhotoHint");
  var photos = diqBuildPlaceGallery(item, query || activeLens);
  var idx = 0;
  var cls = categoryPhotoClass(item, query || activeLens);
  var renderToken = 0;




  injectDiqPhotoVerifyStyles();




  function navHtml() {
    var html = "";
    var i;
    if (!nav) { return; }
    for (i = 0; i < photos.length; i++) {
      html += '<span class="diqPhotoDot ' + (i === idx ? 'on' : '') + '"></span>';
    }
    nav.innerHTML = html;
    nav.style.display = photos.length > 1 ? "flex" : "none";
  }




  function currentCandidate() {
    var tries = 0;
    var p;
    if (!photos || !photos.length) { return {}; }
    while (tries < photos.length) {
      p = photos[idx] || photos[0] || {};
      if (!p._diqBadPhoto) { return p; }
      idx = (idx + 1) % photos.length;
      tries += 1;
    }
    return {};
  }




  function render() {
    var p = currentCandidate();
    var token;
    var img;
    var label;




    renderToken += 1;
    token = renderToken;




    navHtml();




    if (!p || !p.url) {
      diqApplyPhotoFallback(photo, hint, item, query, "no-url");
      return;
    }




    if (p.kind === "map") {
      if (photo) {
        photo.className = "diqAdvPhoto map";
        photo.setAttribute("style", "background-image:url('" + diqCssPhotoUrl(p.url) + "');");
        photo.setAttribute("data-photo-kind", "map");
        photo.setAttribute("data-photo-live", "0");
        photo.removeAttribute("data-photo-label");
      }
      if (hint) {
        hint.className = String(hint.className || "").replace(/\s?photoLive/g, "").replace(/\s?photoLoading/g, "").replace(/\s?photoFallback/g, "") + " photoFallback";
        hint.textContent = "Map Preview";
      }
      return;
    }




    if (!diqPhotoCandidateIsReal(p)) {
      p._diqBadPhoto = true;
      render();
      return;
    }




    if (photo) {
      photo.className = "diqAdvPhoto " + cls + " photoFallback";
      photo.setAttribute("style", "");
      photo.setAttribute("data-photo-kind", String(p.kind || cls || "local"));
      photo.setAttribute("data-photo-live", "0");
      photo.removeAttribute("data-photo-label");
    }
    if (hint) {
      hint.className = String(hint.className || "").replace(/\s?photoLive/g, "").replace(/\s?photoFallback/g, "").replace(/\s?photoLoading/g, "") + " photoLoading";
      hint.textContent = "Checking photo...";
    }




    img = new Image();
    img.onload = function () {
      if (token !== renderToken) { return; }
      label = clean(p.label || diqIntentPhotoLabel(item, query) || "Place Photo");
      if (photo) {
        photo.className = "diqAdvPhoto " + cls + " realPhoto photoLive";
        photo.setAttribute("style", "background-image:url('" + diqCssPhotoUrl(p.url) + "');");
        photo.setAttribute("data-photo-kind", String(p.kind || "photo"));
        photo.setAttribute("data-photo-live", "1");
        photo.setAttribute("data-photo-label", label);
      }
      if (hint) {
        hint.className = String(hint.className || "").replace(/\s?photoLoading/g, "").replace(/\s?photoFallback/g, "").replace(/\s?photoLive/g, "") + " photoLive";
        hint.textContent = label;
      }
    };
    img.onerror = function () {
      if (token !== renderToken) { return; }
      p._diqBadPhoto = true;
      try {
        if (window.console && window.console.warn) {
          window.console.warn("[PHOTO IQ V38] image failed, using fallback art", { place:clean(item && item.label || "place"), url:p.url });
        }
      } catch (e0) {}
      render();
    };
    try { img.referrerPolicy = "no-referrer-when-downgrade"; } catch (refErr) {}
    img.src = p.url;
  }




  if (photo) {
    photo.onclick = function () {
      if (!photos || photos.length < 2) { return; }
      idx = (idx + 1) % photos.length;
      render();
    };
  }




  render();
}








/* V37 â€” Scan-list photo pull-through. Place IQ cards already hydrate on
   open; this makes the choice list upgrade too, without changing ranking,
   scan logic, pins, routing, or map behavior. */
function diqBestResolvedPhoto(item, query) {
  var gallery;
  var i;
  try { gallery = diqBuildPlaceGallery(item, query || activeLens); } catch (e0) { gallery = []; }
  for (i = 0; i < (gallery || []).length; i++) {
    if (gallery[i] && gallery[i].url && gallery[i].kind !== "map" && diqLooksLikeImageUrl(gallery[i].url)) { return gallery[i]; }
  }
  return null;
}




function diqRefreshAdventurePhotoThumb(item, query) {
  var key = diqPhotoCacheKey(item);
  var p;
  var cls;
  var nodes;
  var i;
  var thumb;
  if (!key || !document.querySelectorAll) { return false; }
  p = diqBestResolvedPhoto(item, query || activeLens);
  if (!p || !p.url) { return false; }
  cls = categoryPhotoClass(item, query || activeLens) || "local";
  try { nodes = document.querySelectorAll(".diqDestItem[data-photo-key]"); } catch (e0) { nodes = []; }
  for (i = 0; i < nodes.length; i++) {
    if (String(nodes[i].getAttribute("data-photo-key") || "") !== String(key)) { continue; }
    thumb = nodes[i].querySelector ? nodes[i].querySelector(".diqDestThumb") : null;
    if (!thumb) { continue; }
    thumb.className = "diqDestThumb " + cls + " realPhoto";
    thumb.setAttribute("style", "background-image:url('" + diqCssPhotoUrl(p.url) + "');");
    thumb.setAttribute("data-photo-kind", String(p.kind || "photo"));
    try { nodes[i].setAttribute("data-photo-loaded", "1"); } catch (e1) {}
  }
  return true;
}




function diqHydrateScanChoicePhotos(items, query) {
  var list = items && items.length ? items.slice(0, 8) : [];
  var i;
  var item;
  var key;
  for (i = 0; i < list.length; i++) {
    item = list[i];
    key = diqPhotoCacheKey(item);
    if (!key || diqPhotoThumbHydrateQueued[key]) { continue; }
    diqPhotoThumbHydrateQueued[key] = true;
    (function (it, delay) {
      window.setTimeout(function () {
        try {
          if (!diqRefreshAdventurePhotoThumb(it, query || activeLens)) {
            diqHydratePlacePhotos(it, query || activeLens);
          }
        } catch (e0) {}
      }, delay);
    })(item, 180 + (i * 260));
  }
}








/* =========================================================
   DRIVE IQ V31 â€” PHOTO PULL IQ
   Asynchronous real-photo resolver. This does not touch Scan IQ, ranking,
   destination lock, routing, or map behavior. It only enriches Place IQ cards
   after a place has already been selected.
========================================================= */




var diqPhotoHydrateActive = {};
var diqPhotoHydrateLastKey = "";
var diqPhotoThumbHydrateQueued = {};
var diqPhotoThumbHydrateTimer = null;








function diqCountRealPhotoCandidates(item) {
  var count = 0;
  var arr;
  var i;
  var u;
  if (!item) { return 0; }
  arr = item.photos && item.photos.length ? item.photos : [];
  for (i = 0; i < arr.length; i++) {
    u = "";
    try {
      if (typeof arr[i] === "string") { u = arr[i]; }
      else if (arr[i] && arr[i].url) { u = arr[i].url; }
    } catch (e0) { u = ""; }
    if (u && diqLooksLikeImageUrl(u) && String(u).toLowerCase().indexOf("api.mapbox.com/styles") < 0) { count += 1; }
  }
  if (item.photoUrl && diqLooksLikeImageUrl(item.photoUrl) && String(item.photoUrl).toLowerCase().indexOf("api.mapbox.com/styles") < 0) { count += 1; }
  return count;
}




function diqShortPhotoRaw(v) {
  var s;
  try { s = JSON.stringify(v || {}); } catch (e0) { s = String(v || ""); }
  s = clean(s).replace(/AIza[0-9A-Za-z_\-]{20,}/g,"AIzaâ€¦masked");
  if (s.length > 180) { s = s.slice(0,180) + "â€¦"; }
  return s;
}




function diqPhotoDebugSnapshot(item, extra) {
  var key = "no";
  var places = "no";
  var pid = "no";
  var photoCount = 0;
  var msg = "";
  try { key = diqGooglePlacesApiKey() ? "yes" : "no"; } catch (e0) {}
  try { places = diqGooglePlacesReady() ? "yes" : "no"; } catch (e1) {}
  try { pid = diqGooglePlaceIdFromItem(item) ? "yes" : "no"; } catch (e2) {}
  try {
    photoCount = diqCountRealPhotoCandidates ? diqCountRealPhotoCandidates(item) : (item && item.photos && item.photos.length ? item.photos.length : 0);
  } catch (e3) {
    try { photoCount = item && item.photos && item.photos.length ? item.photos.length : 0; } catch (e4) {}
  }
  if (extra && extra.msg) { msg = clean(extra.msg); }
  return {
    key:key,
    keySource:clean(diqGoogleKeyBridgeSource || (key === "yes" ? "window/config" : "missing")),
    places:places,
    placeId:pid,
    photos:photoCount,
    msg:msg,
    status:extra && extra.status ? clean(extra.status) : "",
    details:extra && extra.details ? clean(extra.details) : "",
    source:extra && extra.source ? clean(extra.source) : "Photo IQ",
    ts:Date.now()
  };
}




function diqSetPhotoDebug(item, stage, extra) {
  var d;
  var line;
  if (!item) { return; }
  d = diqPhotoDebugSnapshot(item, extra || {});
  d.stage = clean(stage || "photo");
  item.photoDebug = d;
  line = "Photo Debug: key " + d.key + (d.keySource ? " (" + d.keySource + ")" : "") + " â€¢ places " + d.places + " â€¢ id " + d.placeId;
  if (d.status) { line += " â€¢ " + d.status; }
  if (d.details) { line += " â€¢ details " + d.details; }
  if (finite(Number(d.photos))) { line += " â€¢ photos " + String(d.photos); }
  item.photoDebugShort = line;
  if (!item.photoStatus || String(item.photoStatus).indexOf("Photo IQ") === 0 || String(item.photoStatus).indexOf("Photo Debug") === 0) {
    item.photoStatus = line;
  }
  try {
    if (window.console && window.console.log) {
      window.console.log("[PHOTO IQ V34]", clean(item.label || "place"), d);
    }
  } catch (e) {}
}




function diqVisiblePhotoStatus(item) {
  if (!item) { return "Photo IQ Fallback"; }
  if (item.photoSource && item.photoUrl) { return clean(item.photoSource); }
  if (item.photoDebugShort) { return clean(item.photoDebugShort); }
  if (item.photoStatus) { return clean(item.photoStatus); }
  return "Photo IQ Fallback";
}




function diqPhotoCacheKey(item) {
  if (!item) { return ""; }
  return normText(String(item.label || "place") + "|" + String(Math.round(Number(item.lat || 0) * 100000)) + "|" + String(Math.round(Number(item.lng || 0) * 100000)));
}




function diqLoadPhotoCache() {
  var cache = safeParse(lsGet(LS.PHOTO_CACHE));
  return cache && typeof cache === "object" ? cache : {};
}




function diqSavePhotoCache(cache) {
  var keys;
  var i;
  var trimmed = {};
  if (!cache || typeof cache !== "object") { return; }
  try {
    keys = Object.keys(cache);
    keys.sort(function (a, b) {
      return Number(cache[b] && cache[b].ts || 0) - Number(cache[a] && cache[a].ts || 0);
    });
    for (i = 0; i < keys.length && i < 180; i++) {
      trimmed[keys[i]] = cache[keys[i]];
    }
    lsJSON(LS.PHOTO_CACHE, trimmed);
  } catch (e) {
    try { lsJSON(LS.PHOTO_CACHE, cache); } catch (e2) {}
  }
}




function diqNormalizeResolvedPhotos(data, item, query) {
  var list = [];
  var arr;
  var i;
  var p;
  if (!data) { return list; }




  if (data.photos && data.photos.length) { arr = data.photos; }
  else if (data.images && data.images.length) { arr = data.images; }
  else if (data.gallery && data.gallery.length) { arr = data.gallery; }
  else if (data.results && data.results.length) { arr = data.results; }
  else if (data.length) { arr = data; }
  else { arr = []; }




  diqAddUniquePhoto(list, data.officialPhoto, "Official Photo", "official");
  diqAddUniquePhoto(list, data.businessPhoto, "Business Photo", "official");
  diqAddUniquePhoto(list, data.heroPhoto, diqIntentPhotoLabel(item, query), "official");
  diqAddUniquePhoto(list, data.photoUrl, diqIntentPhotoLabel(item, query), "official");
  diqAddUniquePhoto(list, data.photo, diqIntentPhotoLabel(item, query), "official");
  diqAddUniquePhoto(list, data.image, diqIntentPhotoLabel(item, query), "official");




  for (i = 0; i < arr.length && i < 18; i++) {
    p = arr[i];
    if (typeof p === "string") {
      diqAddUniquePhoto(list, p, diqIntentPhotoLabel(item, query), "gallery");
    } else if (p && typeof p === "object") {
      diqAddUniquePhoto(
        list,
        p.url || p.src || p.photo || p.image || p.photoUrl || p.imageUrl,
        p.label || p.caption || p.role || diqIntentPhotoLabel(item, query),
        p.kind || p.type || p.role || "gallery"
      );
    }
  }




  try { diqCollectPhotoCandidates(data, list, diqIntentPhotoLabel(item, query), 0); } catch (e0) {}




  list.sort(function (a, b) {
    var pa = Number(a.priority || diqPhotoKindPriority(a.kind)) + diqIntentPhotoBoost(a, item, query);
    var pb = Number(b.priority || diqPhotoKindPriority(b.kind)) + diqIntentPhotoBoost(b, item, query);
    if (pa !== pb) { return pa - pb; }
    return String(a.url || "").length - String(b.url || "").length;
  });




  return list.slice(0, 8);
}




function diqApplyResolvedPhotosToItem(item, photos, query, source) {
  var i;
  var existing = [];
  if (!item || !photos || !photos.length) { return false; }




  if (item.photos && item.photos.length) {
    for (i = 0; i < item.photos.length; i++) {
      if (typeof item.photos[i] === "string") { diqAddUniquePhoto(existing, item.photos[i], "Gallery Photo", "gallery"); }
      else if (item.photos[i] && item.photos[i].url) { diqAddUniquePhoto(existing, item.photos[i].url, item.photos[i].label || "Gallery Photo", item.photos[i].kind || "gallery"); }
    }
  }




  for (i = 0; i < photos.length; i++) {
    if (photos[i] && photos[i].url) {
      diqAddUniquePhoto(existing, photos[i].url, photos[i].label || diqIntentPhotoLabel(item, query), photos[i].kind || source || "gallery");
    }
  }




  if (!existing.length) { return false; }
  item.photos = existing.slice(0, 8);
  item.photoUrl = existing[0].url;
  item.photoSource = clean(source || "Photo IQ");
  return true;
}




function diqPhotoResolverUrl(item, query) {
  var endpoint = clean(window.DRIVE_IQ_PHOTO_RESOLVER_URL || window.DIQ_PHOTO_RESOLVER_URL || "");
  var params;
  if (!endpoint) { return ""; }
  params =
    "name=" + encodeURIComponent(String(item && item.label || "")) +
    "&lat=" + encodeURIComponent(String(item && item.lat || "")) +
    "&lng=" + encodeURIComponent(String(item && item.lng || "")) +
    "&category=" + encodeURIComponent(String(adventurePrimaryCategory(item, query || activeLens) || "")) +
    "&query=" + encodeURIComponent(String(query || activeLens || "")) +
    "&address=" + encodeURIComponent(String(item && item.full || ""));
  return endpoint + (endpoint.indexOf("?") > -1 ? "&" : "?") + params;
}




function diqFetchResolverPhotos(item, query, done) {
  var url = diqPhotoResolverUrl(item, query);
  if (!url || !window.fetch) { done([]); return; }
  try {
    fetch(url, { method:"GET", credentials:"omit", cache:"force-cache" })
      .then(function (res) { return res && res.ok ? res.json() : null; })
      .then(function (data) { done(diqNormalizeResolvedPhotos(data, item, query)); })
      .catch(function () { done([]); });
  } catch (e) { done([]); }
}




var diqGooglePlacesLoading = false;
var diqGooglePlacesCallbacks = [];




var diqGoogleKeyBridgeCache = "";
var diqGoogleKeyBridgeSource = "";




function diqMaybeGoogleKeyValue(v) {
  var s = clean(v);
  if (!s) { return ""; }
  if (s.indexOf("AIza") === 0) { return s; }
  if (s.indexOf("AIza") > -1) {
    var m = s.match(/AIza[0-9A-Za-z_\-]{20,}/);
    if (m && m[0]) { return m[0]; }
  }
  if (s.length >= 24 && s.length <= 120 && /^[A-Za-z0-9_\-]+$/.test(s)) { return s; }
  return "";
}




function diqGoogleKeyFromUrl(src) {
  var m;
  src = String(src || "");
  if (!src || src.indexOf("google") < 0 || src.indexOf("key=") < 0) { return ""; }
  m = src.match(/[?&]key=([^&#]+)/);
  if (m && m[1]) { return diqMaybeGoogleKeyValue(decodeURIComponent(m[1])); }
  return "";
}




function diqGoogleKeyFromObject(obj, label, depth) {
  var names = [
    "DRIVE_IQ_GOOGLE_PLACES_KEY","DRIVE_IQ_GOOGLE_PLACES_API_KEY","DRIVE_IQ_GOOGLE_MAPS_KEY","DRIVE_IQ_GOOGLE_MAPS_API_KEY","DRIVE_IQ_GOOGLE_API_KEY","DRIVE_IQ_GOOGLE_KEY",
    "DIQ_GOOGLE_KEY","DIQ_GOOGLE_API_KEY","DIQ_GOOGLE_PLACES_KEY","DIQ_GOOGLE_PLACES_API_KEY","DIQ_GOOGLE_MAPS_KEY","DIQ_GOOGLE_MAPS_API_KEY",
    "SLX_GOOGLE_KEY","SLX_GOOGLE_MAPS_KEY","SLX_GOOGLE_MAPS_API_KEY","SLX_GOOGLE_PLACES_KEY","SLX_GOOGLE_PLACES_API_KEY","SLX_GOOGLE_API_KEY",
    "GOOGLE_MAPS_API_KEY","GOOGLE_PLACES_API_KEY","GOOGLE_API_KEY","GOOGLE_KEY","GOOGLE_MAPS_KEY","GOOGLE_PLACES_KEY",
    "googleMapsApiKey","googlePlacesApiKey","googleApiKey","googleKey","mapsApiKey","placesApiKey","apiKey","key"
  ];
  var i;
  var k;
  var v;
  var out;
  if (!obj || depth > 2) { return ""; }




  for (i = 0; i < names.length; i++) {
    try {
      v = obj[names[i]];
      out = diqMaybeGoogleKeyValue(v);
      if (out) { diqGoogleKeyBridgeSource = clean(label + "." + names[i]); return out; }
    } catch (e0) {}
  }




  try {
    for (k in obj) {
      if (!obj.hasOwnProperty || !obj.hasOwnProperty(k)) { continue; }
      if (!/(google|maps|places|api|key)/i.test(k)) { continue; }
      v = obj[k];
      if (typeof v === "string") {
        out = diqMaybeGoogleKeyValue(v);
        if (out) { diqGoogleKeyBridgeSource = clean(label + "." + k); return out; }
        out = diqGoogleKeyFromUrl(v);
        if (out) { diqGoogleKeyBridgeSource = clean(label + "." + k + " url"); return out; }
      } else if (v && typeof v === "object") {
        out = diqGoogleKeyFromObject(v, clean(label + "." + k), depth + 1);
        if (out) { return out; }
      }
    }
  } catch (e1) {}




  return "";
}




function diqGooglePlacesApiKey() {
  var key = "";
  var scripts;
  var metas;
  var nodes;
  var stores;
  var roots;
  var i;
  var j;
  var src;
  var attr;
  var val;
  var storageKey;




  if (diqGoogleKeyBridgeCache) { return diqGoogleKeyBridgeCache; }




  key = diqGoogleKeyFromObject(window, "window", 0);
  if (key) {
    diqGoogleKeyBridgeCache = key;
    try { window.DIQ_GOOGLE_KEY = key; } catch (e0) {}
    return key;
  }




  roots = [
    "DRIVE_IQ_CONFIG","DriveIQConfig","driveIQConfig","DIQ_CONFIG","SLX_CONFIG","slxConfig","Shopify","theme","__DIQ__","__DRIVE_IQ__"
  ];
  for (i = 0; i < roots.length; i++) {
    try {
      key = diqGoogleKeyFromObject(window[roots[i]], roots[i], 0);
      if (key) {
        diqGoogleKeyBridgeCache = key;
        try { window.DIQ_GOOGLE_KEY = key; } catch (e1) {}
        return key;
      }
    } catch (e2) {}
  }




  try {
    metas = document.getElementsByTagName("meta");
    for (i = 0; i < metas.length; i++) {
      attr = String(metas[i].getAttribute("name") || metas[i].getAttribute("property") || metas[i].getAttribute("id") || "");
      if (/(google|maps|places|api|key)/i.test(attr)) {
        val = metas[i].getAttribute("content") || "";
        key = diqMaybeGoogleKeyValue(val) || diqGoogleKeyFromUrl(val);
        if (key) {
          diqGoogleKeyBridgeSource = "meta:" + attr;
          diqGoogleKeyBridgeCache = key;
          try { window.DIQ_GOOGLE_KEY = key; } catch (e3) {}
          return key;
        }
      }
    }
  } catch (metaErr) {}




  try {
    scripts = document.getElementsByTagName("script");
    for (i = 0; i < scripts.length; i++) {
      src = String(scripts[i].src || "");
      key = diqGoogleKeyFromUrl(src);
      if (key) {
        diqGoogleKeyBridgeSource = "script:src";
        diqGoogleKeyBridgeCache = key;
        try { window.DIQ_GOOGLE_KEY = key; } catch (e4) {}
        return key;
      }
      try {
        val = String(scripts[i].text || scripts[i].textContent || "");
        if (val && /(GOOGLE|google).{0,30}(KEY|key|apiKey|ApiKey)/.test(val)) {
          key = diqMaybeGoogleKeyValue(val);
          if (key) {
            diqGoogleKeyBridgeSource = "script:inline";
            diqGoogleKeyBridgeCache = key;
            try { window.DIQ_GOOGLE_KEY = key; } catch (e5) {}
            return key;
          }
        }
      } catch (inlineErr) {}
    }
  } catch (scriptErr) {}




  try {
    nodes = document.querySelectorAll ? document.querySelectorAll("[data-google-key],[data-google-api-key],[data-google-maps-key],[data-google-places-key],[data-diq-google-key],[data-drive-iq-google-key]") : [];
    for (i = 0; i < nodes.length; i++) {
      for (j = 0; j < nodes[i].attributes.length; j++) {
        attr = nodes[i].attributes[j].name;
        if (/(google|maps|places|key)/i.test(attr)) {
          key = diqMaybeGoogleKeyValue(nodes[i].attributes[j].value);
          if (key) {
            diqGoogleKeyBridgeSource = "data:" + attr;
            diqGoogleKeyBridgeCache = key;
            try { window.DIQ_GOOGLE_KEY = key; } catch (e6) {}
            return key;
          }
        }
      }
    }
  } catch (dataErr) {}




  stores = [];
  try { stores.push(window.localStorage); } catch (e7) {}
  try { stores.push(window.sessionStorage); } catch (e8) {}
  for (i = 0; i < stores.length; i++) {
    try {
      for (j = 0; j < stores[i].length; j++) {
        storageKey = String(stores[i].key(j) || "");
        if (!/(google|maps|places|key)/i.test(storageKey)) { continue; }
        val = stores[i].getItem(storageKey);
        key = diqMaybeGoogleKeyValue(val) || diqGoogleKeyFromUrl(val);
        if (key) {
          diqGoogleKeyBridgeSource = (i === 0 ? "localStorage:" : "sessionStorage:") + storageKey;
          diqGoogleKeyBridgeCache = key;
          try { window.DIQ_GOOGLE_KEY = key; } catch (e9) {}
          return key;
        }
      }
    } catch (storeErr) {}
  }




  diqGoogleKeyBridgeSource = "missing";
  return "";
}




function diqGooglePlacesReady() {
  return !!(window.google && window.google.maps && window.google.maps.places && window.google.maps.places.PlacesService);
}




function diqLoadGooglePlacesLibrary(done) {
  var key;
  var script;
  var importPromise;
  if (diqGooglePlacesReady()) { done(true); return; }




  /* V34: if Google Maps is already on the page without Places, the old
     script reinjection path may not hydrate google.maps.places. Prefer the
     modern importLibrary bridge when it exists. */
  try {
    if (window.google && window.google.maps && window.google.maps.importLibrary) {
      importPromise = window.google.maps.importLibrary("places");
      if (importPromise && importPromise.then) {
        importPromise.then(function () { done(diqGooglePlacesReady()); }).catch(function () { done(false); });
        return;
      }
    }
  } catch (importErr) {}




  key = diqGooglePlacesApiKey();
  if (!key) { done(false); return; }
  diqGooglePlacesCallbacks.push(done);
  if (diqGooglePlacesLoading) { return; }
  diqGooglePlacesLoading = true;
  try {
    script = document.createElement("script");
    script.async = true;
    script.defer = true;
    script.src = "https://maps.googleapis.com/maps/api/js?key=" + encodeURIComponent(key) + "&libraries=places&loading=async&callback=diqGooglePlacesBootstrapReady";
    try {
      window.diqGooglePlacesBootstrapReady = function () {
        var cbs = diqGooglePlacesCallbacks.slice(0);
        var i;
        diqGooglePlacesCallbacks = [];
        diqGooglePlacesLoading = false;
        for (i = 0; i < cbs.length; i++) { try { cbs[i](diqGooglePlacesReady()); } catch (cbErr) {} }
      };
    } catch (cbSetErr) {}
    script.onload = function () {
      var cbs = diqGooglePlacesCallbacks.slice(0);
      var i;
      diqGooglePlacesCallbacks = [];
      diqGooglePlacesLoading = false;
      for (i = 0; i < cbs.length; i++) { try { cbs[i](diqGooglePlacesReady()); } catch (cbErr) {} }
    };
    script.onerror = function () {
      var cbs = diqGooglePlacesCallbacks.slice(0);
      var i;
      diqGooglePlacesCallbacks = [];
      diqGooglePlacesLoading = false;
      for (i = 0; i < cbs.length; i++) { try { cbs[i](false); } catch (cbErr) {} }
    };
    document.head.appendChild(script);
  } catch (e) {
    diqGooglePlacesLoading = false;
    diqGooglePlacesCallbacks = [];
    done(false);
  }
}




function diqGooglePlaceIdFromItem(item) {
  var raw;
  var keys = ["googlePlaceId","google_place_id","placeId","place_id","gplace_id","google_id"];
  var i;
  var v;
  if (!item) { return ""; }
  for (i = 0; i < keys.length; i++) {
    v = item[keys[i]];
    if (v) { return clean(v); }
  }
  raw = item.raw || item.properties || item.datasourceRaw || null;
  if (raw) {
    for (i = 0; i < keys.length; i++) {
      v = raw[keys[i]];
      if (v) { return clean(v); }
    }
    try {
      if (raw.datasource && raw.datasource.raw) {
        raw = raw.datasource.raw;
        for (i = 0; i < keys.length; i++) {
          v = raw[keys[i]];
          if (v) { return clean(v); }
        }
      }
    } catch (e0) {}
  }
  return "";
}




function diqGooglePhotoUrlFromReference(ref, maxWidth) {
  var key = diqGooglePlacesApiKey();
  ref = clean(ref);
  if (!ref || !key) { return ""; }




  /* V35: Places API (New) returns photo resource names like:
     places/PLACE_ID/photos/PHOTO_REFERENCE. Those must use the new media
     endpoint. Legacy photo_reference strings keep using the legacy endpoint. */
  if (ref.indexOf("places/") === 0 && ref.indexOf("/photos/") > -1) {
    return "https://places.googleapis.com/v1/" + ref + "/media?maxWidthPx=" + encodeURIComponent(String(maxWidth || 1200)) + "&key=" + encodeURIComponent(key);
  }




  return "https://maps.googleapis.com/maps/api/place/photo?maxwidth=" + encodeURIComponent(String(maxWidth || 1200)) + "&photo_reference=" + encodeURIComponent(ref) + "&key=" + encodeURIComponent(key);
}




function diqGooglePhotoRefsFromValue(v, out) {
  var i;
  var ref;
  if (!v) { return; }
  if (typeof v === "string") {
    ref = clean(v);
    if (ref && ref.indexOf("http") !== 0) { out.push(ref); }
    return;
  }
  if (v.length && typeof v !== "string") {
    for (i = 0; i < v.length && i < 12; i++) { diqGooglePhotoRefsFromValue(v[i], out); }
    return;
  }
  if (typeof v === "object") {
    /* V35: Places API (New) photo objects expose .name as the full media
       resource path. Legacy objects expose photo_reference/photoReference. */
    diqGooglePhotoRefsFromValue(v.name || v.photo_reference || v.photoReference || v.google_photo_reference || v.googlePhotoReference || v.reference, out);
  }
}




function diqGoogleDirectPhotoCandidates(item, query) {
  var refs = [];
  var out = [];
  var raw;
  var i;
  var url;
  if (!item) { return out; }




  diqGooglePhotoRefsFromValue(item.photoReference, refs);
  diqGooglePhotoRefsFromValue(item.photoReferences, refs);
  diqGooglePhotoRefsFromValue(item.googlePhotoReference, refs);
  diqGooglePhotoRefsFromValue(item.googlePhotoReferences, refs);
  diqGooglePhotoRefsFromValue(item.photos, refs);




  raw = item.raw || item.properties || item.datasourceRaw || null;
  if (raw) {
    diqGooglePhotoRefsFromValue(raw.photo_reference || raw.photoReference || raw.google_photo_reference || raw.googlePhotoReference, refs);
    diqGooglePhotoRefsFromValue(raw.photo_references || raw.photoReferences || raw.google_photo_references || raw.googlePhotoReferences || raw.photos, refs);
    try {
      if (raw.datasource && raw.datasource.raw) {
        raw = raw.datasource.raw;
        diqGooglePhotoRefsFromValue(raw.photo_reference || raw.photoReference || raw.google_photo_reference || raw.googlePhotoReference, refs);
        diqGooglePhotoRefsFromValue(raw.photo_references || raw.photoReferences || raw.google_photo_references || raw.googlePhotoReferences || raw.photos, refs);
      }
    } catch (e0) {}
  }




  for (i = 0; i < refs.length && out.length < 8; i++) {
    url = diqGooglePhotoUrlFromReference(refs[i], 1200);
    if (url) { diqAddUniquePhoto(out, url, i === 0 ? diqIntentPhotoLabel(item, query) : "Google Venue Photo", "google_direct"); }
  }
  return out;
}




function diqEnsureGooglePlacesHost() {
  var host = byId("diqGooglePlacesServiceHost");
  if (host) { return host; }
  host = document.createElement("div");
  host.id = "diqGooglePlacesServiceHost";
  host.setAttribute("aria-hidden", "true");
  host.style.cssText = "position:absolute;left:-9999px;top:-9999px;width:1px;height:1px;overflow:hidden;opacity:0;pointer-events:none;";
  try { document.body.appendChild(host); } catch (e) {}
  return host;
}




function diqPhotoSearchQueryVariants(item, query) {
  var out = [];
  var name = clean(item && item.label || "");
  var address = clean(item && item.full || "");
  var cat = clean(adventurePrimaryCategory(item, query || activeLens) || "");
  function add(v) {
    var i;
    var n = normText(v);
    if (!n) { return; }
    for (i = 0; i < out.length; i++) {
      if (normText(out[i]) === n) { return; }
    }
    out.push(clean(v));
  }
  add(name + " " + address);
  add(name);
  if (cat) { add(name + " " + cat); }
  if (address) { add(name + " " + address.split(",").slice(0, 2).join(" ")); }
  return out.slice(0, 5);
}




function diqGoogleResultNameScore(result, item) {
  var a = normText(result && result.name || "");
  var b = normText(item && item.label || "");
  var score = 0;
  if (!a || !b) { return 0; }
  if (a === b) { score += 120; }
  if (a.indexOf(b) > -1 || b.indexOf(a) > -1) { score += 80; }
  if (a.split(" ")[0] && b.indexOf(a.split(" ")[0]) > -1) { score += 12; }
  return score;
}












function diqGooglePhotoFallbackResult(results, item) {
  var best = null;
  var bestScore = -999999;
  var i;
  var r;
  var score;
  var d;
  if (!results || !results.length || !item) { return null; }
  for (i = 0; i < results.length; i++) {
    r = results[i];
    if (!r || !r.photos || !r.photos.length) { continue; }
    score = 25 + diqGoogleResultNameScore(r, item);
    try {
      if (r.geometry && r.geometry.location) {
        d = miles(Number(item.lat), Number(item.lng), Number(r.geometry.location.lat()), Number(r.geometry.location.lng()));
        if (finite(d)) {
          if (d <= 0.08) { score += 100; }
          else if (d <= 0.25) { score += 75; }
          else if (d <= 0.65) { score += 42; }
          else if (d <= 1.25) { score += 12; }
          else { score -= Math.round(d * 24); }
        }
      }
    } catch (geoErr) {}
    if (score > bestScore) { bestScore = score; best = r; }
  }
  return bestScore >= 25 ? best : null;
}




function diqGooglePhotoObjectsToList(place, item, query) {
  var out = [];
  var photos = place && place.photos ? place.photos : [];
  var j;
  var url;
  var label;
  for (j = 0; j < photos.length && j < 8; j++) {
    try {
      url = photos[j].getUrl({ maxWidth:1200, maxHeight:900 });
      label = j === 0 ? diqIntentPhotoLabel(item, query) : "Venue Photo";
      diqAddUniquePhoto(out, url, label, "gallery");
    } catch (photoErr) {}
  }
  return out;
}












/* =========================================================
   DRIVE IQ V35 â€” GOOGLE PLACES API (NEW) PHOTO PIPELINE
   Google Cloud confirmed Places API (New) includes Place Photo. This path
   uses places.googleapis.com directly and keeps legacy Places JS as fallback.
========================================================= */




function diqGoogleNewExtractPhotoResource(v, depth) {
  var k;
  var r;
  var i;
  if (!v || depth > 4) { return ""; }
  if (typeof v === "string") {
    v = clean(v);
    if (v.indexOf("places/") === 0 && v.indexOf("/photos/") > -1) { return v; }
    return "";
  }
  if (v.length && typeof v !== "string") {
    for (i = 0; i < v.length; i++) {
      r = diqGoogleNewExtractPhotoResource(v[i], depth + 1);
      if (r) { return r; }
    }
    return "";
  }
  if (typeof v !== "object") { return ""; }
  r = diqGoogleNewExtractPhotoResource(v.name || v.photoName || v.resourceName || v.photoResourceName, depth + 1);
  if (r) { return r; }
  for (k in v) {
    if (!v.hasOwnProperty(k)) { continue; }
    if (!/(photo|media|resource|name)/i.test(k)) { continue; }
    r = diqGoogleNewExtractPhotoResource(v[k], depth + 1);
    if (r) { return r; }
  }
  return "";
}




function diqGoogleNewExtractPhotoUri(v, depth) {
  var k;
  var r;
  var i;
  if (!v || depth > 4) { return ""; }
  if (typeof v === "string") {
    v = clean(v);
    if (diqLooksLikeImageUrl(v)) { return v; }
    return "";
  }
  if (v.length && typeof v !== "string") {
    for (i = 0; i < v.length; i++) {
      r = diqGoogleNewExtractPhotoUri(v[i], depth + 1);
      if (r) { return r; }
    }
    return "";
  }
  if (typeof v !== "object") { return ""; }
  r = clean(v.photoUri || v.uri || v.url || v.src || v.mediaUrl || v.imageUrl || "");
  if (r && diqLooksLikeImageUrl(r)) { return r; }
  for (k in v) {
    if (!v.hasOwnProperty(k)) { continue; }
    if (!/(photo|media|uri|url|image)/i.test(k)) { continue; }
    r = diqGoogleNewExtractPhotoUri(v[k], depth + 1);
    if (r) { return r; }
  }
  return "";
}




function diqGoogleNormalizePlaceResourceId(placeId) {
  placeId = clean(placeId);
  if (!placeId) { return ""; }
  if (placeId.indexOf("places/") === 0) { return placeId; }
  return "places/" + placeId;
}




function diqGoogleNormalizePhotoResourceName(photoName, placeId) {
  photoName = clean(photoName);
  placeId = clean(placeId);




  if (!photoName) { return ""; }




  if (photoName.indexOf("places/") === 0 && photoName.indexOf("/photos/") > -1) {
    return photoName;
  }




  if (photoName.indexOf("photos/") === 0 && placeId) {
    return diqGoogleNormalizePlaceResourceId(placeId) + "/" + photoName;
  }




  if (photoName.indexOf("/photos/") > -1 && photoName.indexOf("places/") !== 0) {
    return "places/" + photoName.replace(/^\/+/, "");
  }




  return "";
}




function diqGoogleNewPhotoMediaUrl(photoName, maxWidth, placeId) {
  var key = diqGooglePlacesApiKey();
  var resource;
  photoName = clean(photoName);
  if (!photoName || !key) { return ""; }




  resource = diqGoogleNormalizePhotoResourceName(photoName, placeId);
  if (!resource) { return ""; }




  return "https://places.googleapis.com/v1/" + resource + "/media?maxWidthPx=" + encodeURIComponent(String(maxWidth || 1200)) + "&key=" + encodeURIComponent(key);
}




function diqGoogleNewPhotoObjectsToList(place, item, query) {
  var out = [];
  var photos = place && place.photos ? place.photos : [];
  var i;
  var url;
  var name;
  var uri;
  var label;
  var placeId = clean((place && (place.id || place.name || place.place_id || place.placeId)) || diqGooglePlaceIdFromItem(item) || "");




  if (photos && photos.length) {
    try { diqSetPhotoDebug(item, "new-photo-raw", { status:"raw", msg:diqShortPhotoRaw(photos[0]), source:"Places API New" }); } catch (rawErr) {}
  }




  for (i = 0; i < photos.length && i < 8; i++) {
    try {
      url = "";
      name = diqGoogleNewExtractPhotoResource(photos[i], 0);
      uri = diqGoogleNewExtractPhotoUri(photos[i], 0);




      if (name) { url = diqGoogleNewPhotoMediaUrl(name, 1200, placeId); }
      if (!url && uri) { url = uri; }




      label = i === 0 ? diqIntentPhotoLabel(item, query) : "Google Place Photo";




      if (url) {
        diqSetPhotoDebug(item, "new-photo-url", { status:"url yes", msg:"media url built", source:"Places API New" });
        diqAddUniquePhoto(out, url, label, "google_places_new");
      } else if (name) {
        diqSetPhotoDebug(item, "new-photo-url-miss", { status:"url no", msg:"name " + clean(name).slice(0,90), source:"Places API New" });
      }
    } catch (photoErr) {}
  }
  return out;
}




function diqGoogleNewPlaceDisplayName(place) {
  try {
    if (place && place.displayName && place.displayName.text) { return clean(place.displayName.text); }
  } catch (e0) {}
  return clean(place && (place.name || place.id || ""));
}




function diqGoogleNewPlaceLatLng(place) {
  var loc = place && place.location ? place.location : null;
  if (!loc) { return null; }
  if (finite(Number(loc.latitude)) && finite(Number(loc.longitude))) {
    return { lat:Number(loc.latitude), lng:Number(loc.longitude) };
  }
  return null;
}




function diqGoogleNewResultNameScore(place, item) {
  var a = normText(diqGoogleNewPlaceDisplayName(place));
  var b = normText(item && item.label || "");
  var score = 0;
  if (!a || !b) { return 0; }
  if (a === b) { score += 140; }
  if (a.indexOf(b) > -1 || b.indexOf(a) > -1) { score += 90; }
  if (a.split(" ")[0] && b.indexOf(a.split(" ")[0]) > -1) { score += 14; }
  return score;
}




function diqGoogleNewPhotoFallbackPlace(places, item) {
  var best = null;
  var bestScore = -999999;
  var i;
  var p;
  var score;
  var ll;
  var d;
  if (!places || !places.length || !item) { return null; }
  for (i = 0; i < places.length; i++) {
    p = places[i];
    if (!p || !p.photos || !p.photos.length) { continue; }
    score = 25 + diqGoogleNewResultNameScore(p, item);
    ll = diqGoogleNewPlaceLatLng(p);
    if (ll && finite(Number(item.lat)) && finite(Number(item.lng))) {
      d = miles(Number(item.lat), Number(item.lng), Number(ll.lat), Number(ll.lng));
      if (finite(d)) {
        if (d <= 0.08) { score += 100; }
        else if (d <= 0.25) { score += 75; }
        else if (d <= 0.65) { score += 40; }
        else if (d <= 1.25) { score += 10; }
        else { score -= Math.round(d * 24); }
      }
    }
    if (score > bestScore) { bestScore = score; best = p; }
  }
  return bestScore >= 25 ? best : null;
}




function diqGoogleNewChooseBestPlace(places, item) {
  var best = null;
  var bestScore = -999999;
  var i;
  var p;
  var score;
  var ll;
  var d;
  if (!places || !places.length || !item) { return null; }




  for (i = 0; i < places.length; i++) {
    p = places[i];
    if (!p) { continue; }




    score = diqGoogleNewResultNameScore(p, item);
    ll = diqGoogleNewPlaceLatLng(p);
    if (ll && finite(Number(item.lat)) && finite(Number(item.lng))) {
      d = miles(Number(item.lat), Number(item.lng), Number(ll.lat), Number(ll.lng));
      if (finite(d)) {
        if (d <= 0.05) { score += 100; }
        else if (d <= 0.18) { score += 80; }
        else if (d <= 0.45) { score += 50; }
        else if (d <= 0.9) { score += 22; }
        else { score -= Math.round(d * 20); }
      }
    }
    if (p.photos && p.photos.length) { score += 45; }




    if (score > bestScore) {
      bestScore = score;
      best = p;
    }
  }




  if (!best || bestScore < 18) { return diqGoogleNewPhotoFallbackPlace(places, item); }
  return best;
}




function diqGoogleNewPlaceDetails(placeId, item, query, done) {
  var key = diqGooglePlacesApiKey();
  var url;
  var resource;
  if (!key || !placeId || !window.fetch) { done([]); return; }




  resource = diqGoogleNormalizePlaceResourceId(placeId);
  if (!resource) { done([]); return; }




  url = "https://places.googleapis.com/v1/" + resource;




  diqSetPhotoDebug(item, "new-details-request", { status:"id yes", msg:resource, source:"Places API New" });




  try {
    fetch(url, {
      method:"GET",
      credentials:"omit",
      cache:"force-cache",
      headers:{
        "X-Goog-Api-Key":key,
        "X-Goog-FieldMask":"id,name,displayName,formattedAddress,location,photos,photos.name,photos.photoUri,photos.authorAttributions"
      }
    })
      .then(function (res) { return res && res.ok ? res.json() : null; })
      .then(function (data) {
        var photos = diqGoogleNewPhotoObjectsToList(data, item, query);
        var rawCount = data && data.photos && data.photos.length ? data.photos.length : 0;
        diqSetPhotoDebug(item, "new-details-ok", { status:"details ok", msg:"raw " + String(rawCount) + " urls " + String(photos.length), source:"Places API New" });
        done(photos);
      })
      .catch(function () {
        diqSetPhotoDebug(item, "new-details-fail", { status:"new details fail", source:"Places API New" });
        done([]);
      });
  } catch (e) {
    done([]);
  }
}




function diqGoogleNewTextSearchPhotoResolver(item, query, done) {
  var key = diqGooglePlacesApiKey();
  var loc;
  var qList;
  var qIndex = 0;




  if (!item || !finite(Number(item.lat)) || !finite(Number(item.lng)) || !key || !window.fetch) {
    done([]);
    return;
  }




  loc = { latitude:Number(item.lat), longitude:Number(item.lng) };
  qList = diqPhotoSearchQueryVariants(item, query);
  diqSetPhotoDebug(item, "new-search-start", { status:"Places New", source:"Places API New" });




  function tryNext() {
    var q;
    var body;




    if (qIndex >= qList.length) {
      diqSetPhotoDebug(item, "new-search-empty", { status:"new no photos", source:"Places API New" });
      done([]);
      return;
    }




    q = qList[qIndex];
    qIndex += 1;




    body = {
      textQuery:q,
      maxResultCount:8,
      locationBias:{
        circle:{
          center:loc,
          radius:8000
        }
      }
    };




    try {
      fetch("https://places.googleapis.com/v1/places:searchText", {
        method:"POST",
        credentials:"omit",
        cache:"force-cache",
        headers:{
          "Content-Type":"application/json",
          "X-Goog-Api-Key":key,
          "X-Goog-FieldMask":"places.id,places.displayName,places.formattedAddress,places.location,places.photos,places.photos.name,places.photos.photoUri"
        },
        body:JSON.stringify(body)
      })
        .then(function (res) { return res && res.ok ? res.json() : null; })
        .then(function (data) {
          var places = data && data.places ? data.places : [];
          var best = diqGoogleNewChooseBestPlace(places, item);
          var photos;




          diqSetPhotoDebug(item, "new-search-status", { status:"new search", msg:"results " + String(places.length), source:"Places API New" });




          if (!best) { tryNext(); return; }




          photos = diqGoogleNewPhotoObjectsToList(best, item, query);
          diqSetPhotoDebug(item, "new-best-match", { status:"new best", msg:diqGoogleNewPlaceDisplayName(best) + " photos " + String(photos.length), source:"Places API New" });




          if (photos && photos.length) {
            done(photos);
            return;
          }




          if (best.id) {
            diqGoogleNewPlaceDetails(best.id, item, query, function (detailPhotos) {
              if (detailPhotos && detailPhotos.length) { done(detailPhotos); }
              else { tryNext(); }
            });
            return;
          }




          tryNext();
        })
        .catch(function () {
          diqSetPhotoDebug(item, "new-search-fail", { status:"new search fail", source:"Places API New" });
          tryNext();
        });
    } catch (e) {
      tryNext();
    }
  }




  tryNext();
}




function diqGooglePlacesNewPhotoResolver(item, query, done) {
  var placeId = diqGooglePlaceIdFromItem(item);
  if (!diqGooglePlacesApiKey()) {
    diqSetPhotoDebug(item, "new-needs-key", { status:"needs key", source:"Places API New" });
    done([]);
    return;
  }




  if (placeId) {
    diqGoogleNewPlaceDetails(placeId, item, query, function (detailsPhotos) {
      if (detailsPhotos && detailsPhotos.length) { done(detailsPhotos); return; }
      diqGoogleNewTextSearchPhotoResolver(item, query, done);
    });
    return;
  }




  diqGoogleNewTextSearchPhotoResolver(item, query, done);
}








function diqGooglePlacesPhotoResolverLoaded(item, query, done) {
  var service;
  var loc;
  var qList;
  var qIndex = 0;
  var placeId;
  if (!item || !finite(Number(item.lat)) || !finite(Number(item.lng))) { done([]); return; }
  if (!diqGooglePlacesReady()) { diqSetPhotoDebug(item, "places-not-ready", { status:"places no" }); done([]); return; }




  try {
    loc = new window.google.maps.LatLng(Number(item.lat), Number(item.lng));
    service = new window.google.maps.places.PlacesService(diqEnsureGooglePlacesHost());
    qList = diqPhotoSearchQueryVariants(item, query);
    placeId = diqGooglePlaceIdFromItem(item);
    diqSetPhotoDebug(item, "google-start", { status:"places yes", source:"Google Places" });




    function hydrateDetails(pid) {
      if (!pid) { tryNextQuery(); return; }
      diqSetPhotoDebug(item, "details-request", { status:"id yes", source:"Google Places" });
      service.getDetails({ placeId:pid, fields:["name","photos","types","website","formatted_address","geometry","place_id"] }, function (place, detailStatus) {
        var photos;
        if (detailStatus !== window.google.maps.places.PlacesServiceStatus.OK || !place) {
          diqSetPhotoDebug(item, "details-fail", { status:String(detailStatus || "details fail"), details:String(detailStatus || "fail"), source:"Google Places" });
          tryNextQuery();
          return;
        }
        photos = diqGooglePhotoObjectsToList(place, item, query);
        diqSetPhotoDebug(item, "details-ok", { status:"details ok", details:String(detailStatus || "OK"), msg:"photo objects " + String(photos && photos.length || 0), source:"Google Places" });
        if (photos && photos.length) { done(photos); return; }
        tryNextQuery();
      });
    }




    function chooseBest(results) {
      var best = null;
      var i;
      var d;
      var bestScore = -999999;
      var score;
      if (!results || !results.length) { return null; }
      for (i = 0; i < results.length; i++) {
        if (!results[i]) { continue; }
        score = diqGoogleResultNameScore(results[i], item);
        if (results[i].geometry && results[i].geometry.location) {
          d = miles(Number(item.lat), Number(item.lng), Number(results[i].geometry.location.lat()), Number(results[i].geometry.location.lng()));
          if (finite(d)) {
            if (d <= 0.05) { score += 90; }
            else if (d <= 0.18) { score += 70; }
            else if (d <= 0.45) { score += 45; }
            else if (d <= 0.9) { score += 18; }
            else { score -= Math.round(d * 18); }
          }
        }
        if (results[i].photos && results[i].photos.length) { score += 35; }
        if (score > bestScore) {
          bestScore = score;
          best = results[i];
        }
      }
      if (!best || !best.place_id || bestScore < 18) { return diqGooglePhotoFallbackResult(results, item); }
      return best;
    }




    function handleResults(results, status) {
      var best;
      diqSetPhotoDebug(item, "search-status", { status:String(status || "search"), msg:"results " + String(results && results.length || 0), source:"Google Places" });
      if (status !== window.google.maps.places.PlacesServiceStatus.OK || !results || !results.length) {
        tryNextQuery();
        return;
      }
      best = chooseBest(results);
      if (!best) { diqSetPhotoDebug(item, "no-best-match", { status:"no best", source:"Google Places" }); tryNextQuery(); return; }
      diqSetPhotoDebug(item, "best-match", { status:"best", msg:String(best.name || "") + " photos " + String(best.photos && best.photos.length || 0), source:"Google Places" });
      if (best.photos && best.photos.length) {
        var bestPhotos = diqGooglePhotoObjectsToList(best, item, query);
        if (bestPhotos && bestPhotos.length) { done(bestPhotos); return; }
      }
      hydrateDetails(best.place_id);
    }




    function tryFindPlace(q) {
      try {
        service.findPlaceFromQuery({
          query:q,
          fields:["place_id","name","geometry","photos","formatted_address"],
          locationBias:{ center:loc, radius:7000 }
        }, handleResults);
      } catch (findErr) {
        tryTextSearch(q);
      }
    }




    function tryTextSearch(q) {
      try {
        service.textSearch({ query:q, location:loc, radius:9000 }, handleResults);
      } catch (textErr) {
        tryNearbySearch();
      }
    }




    function tryNearbySearch() {
      try {
        service.nearbySearch({
          location:loc,
          radius:2500,
          keyword:clean(item.label || query || activeLens || "restaurant")
        }, handleResults);
      } catch (nearErr) {
        done([]);
      }
    }




    function tryNextQuery() {
      var q;
      if (qIndex >= qList.length) { tryNearbySearch(); return; }
      q = qList[qIndex];
      qIndex += 1;
      tryFindPlace(q);
    }




    if (placeId) { hydrateDetails(placeId); return; }
    tryNextQuery();
  } catch (e) { done([]); }
}




function diqGooglePlacesPhotoResolver(item, query, done) {
  diqLoadGooglePlacesLibrary(function (ready) {
    if (!ready) { diqSetPhotoDebug(item, "google-library-fail", { status:diqGooglePlacesApiKey() ? "library fail" : "needs key", source:"Google Places" }); done([]); return; }
    diqSetPhotoDebug(item, "google-library-ready", { status:"library ready", source:"Google Places" });
    diqGooglePlacesPhotoResolverLoaded(item, query, done);
  });
}




function diqUseCachedPhotos(item, query) {
  var key = diqPhotoCacheKey(item);
  var cache;
  var entry;
  var maxAge = 14 * 24 * 60 * 60 * 1000;
  if (!key) { return false; }
  cache = diqLoadPhotoCache();
  entry = cache[key];
  if (!entry || !entry.photos || !entry.photos.length || Date.now() - Number(entry.ts || 0) > maxAge) { return false; }
  if (diqApplyResolvedPhotosToItem(item, entry.photos, query, entry.source || "Photo IQ cache")) {
    diqApplyPlaceGallery(item, query);
    try { diqRefreshAdventurePhotoThumb(item, query); } catch (thumbCacheErr) {}
    return true;
  }
  return false;
}




var diqPhotoHydrateRetryLock = {};




function diqPhotoHydrateRecentlyTried(key) {
  var ts;
  if (!key) { return false; }
  ts = Number(diqPhotoHydrateRetryLock[key] || 0);
  return ts && (Date.now() - ts < 18000);
}




function diqHydratePlacePhotos(item, query) {
  var key = diqPhotoCacheKey(item);
  var cache;
  var hasPlaceId;
  if (!item || !key) { return; }




  diqPhotoHydrateLastKey = key;
  if (diqUseCachedPhotos(item, query)) { item.photoStatus = item.photoSource || "Photo IQ Cache"; return; }
  if (diqPhotoHydrateActive[key]) { return; }
  if (diqPhotoHydrateRecentlyTried(key) && !item.photoUrl) { return; }




  diqPhotoHydrateActive[key] = true;
  diqPhotoHydrateRetryLock[key] = Date.now();




  diqSetPhotoDebug(item, "hydrate-start", { status:diqGooglePlacesApiKey() ? "key yes" : "needs key", source:"Photo IQ V50" });
  item.photoStatus = item.photoDebugShort || "Photo IQ Searching";
  try { diqApplyPlaceGallery(item, query); } catch (statusErr) {}




  if (finish(diqGoogleDirectPhotoCandidates(item, query), "Google Photo Reference")) {
    diqPhotoHydrateActive[key] = false;
    return;
  }




  function finish(photos, source) {
    var applied;
    if (!photos || !photos.length) { return false; }
    applied = diqApplyResolvedPhotosToItem(item, photos, query, source);
    if (applied) {
      diqSetPhotoDebug(item, "photo-loaded", { status:"loaded", source:source || "Photo IQ" });
      item.photoStatus = clean(source || "Photo IQ Loaded");
      cache = diqLoadPhotoCache();
      cache[key] = { photos:item.photos || photos, ts:Date.now(), source:source || "Photo IQ" };
      diqSavePhotoCache(cache);
      diqPhotoHydrateRetryLock[key] = 0;
      if (diqPhotoHydrateLastKey === key) {
        diqApplyPlaceGallery(item, query);
        try { diqRefreshAdventurePhotoThumb(item, query); } catch (thumbLoadedErr) {}
        try { toast("Photo IQ loaded"); } catch (e0) {}
      }
      return true;
    }
    return false;
  }




  hasPlaceId = !!diqGooglePlaceIdFromItem(item);




  diqFetchResolverPhotos(item, query, function (resolverPhotos) {
    if (finish(resolverPhotos, "Official Photo IQ")) {
      diqPhotoHydrateActive[key] = false;
      return;
    }




    function tryLegacyThenFail() {
      diqGooglePlacesPhotoResolver(item, query, function (googlePhotos) {
        if (!finish(googlePhotos, "Google Place Photo")) {
          diqSetPhotoDebug(item, "all-sources-empty", { status:diqGooglePlacesApiKey() ? "no photos" : "needs key", source:"Photo IQ V50", msg:"ID " + (diqGooglePlaceIdFromItem(item) ? "yes" : "no") + " / URL no" });
          item.photoStatus = item.photoDebugShort || (diqGooglePlacesApiKey() ? "Photo IQ No Photos" : "Photo IQ Needs Key");
          if (diqPhotoHydrateLastKey === key) { try { diqApplyPlaceGallery(item, query); } catch (e1) {} }
        }
        diqPhotoHydrateActive[key] = false;
      });
    }




    function tryNewThenLegacy() {
      diqGooglePlacesNewPhotoResolver(item, query, function (googleNewPhotos) {
        if (finish(googleNewPhotos, "Google Places New Photo")) {
          diqPhotoHydrateActive[key] = false;
          return;
        }
        tryLegacyThenFail();
      });
    }




    /* V50: when we finally have an ID, go straight to Places New Details.
       This avoids legacy candidate twitching and targets the exact
       ID:YES / Photos:1 / URL:NO layer. */
    tryNewThenLegacy();
  });
}
















function diqConversionWhyLine(item, query) {
  var cat = adventurePrimaryCategory(item, query || activeLens);
  var name = clean(item && item.label || "This place");
  var txt = diqTrustTextForItem(item);
  var score = Number(item && item.worthScore || 0);




  if (cat === "coffee iq") { return "A better coffee stop when you want the drive to feel intentional, not automatic."; }
  if (cat === "patio vibes") { return "A stronger pick when the vibe matters as much as the food."; }
  if (cat === "live music") { return "A more confident choice when you want real energy instead of just another bar result."; }
  if (cat === "waterfront" || cat === "water") { return "A stop with scenery, breathing room, and a reason to remember the drive."; }
  if (cat === "food iq" || cat === "food drinks" || cat === "popular tonight") { return "A food pick strong enough for Drive IQ to put on the short list."; }
  if (cat === "local favorites") { return "The kind of local signal Drive IQ looks for before recommending a stop."; }
  if (cat === "shopping") { return "A more interesting local shopping stop than another generic big-box result."; }
  if (cat === "trails" || cat === "parks" || cat === "scenic" || cat === "camping") { return "A simple way to turn the drive into something worth remembering."; }
  if (txt.indexOf("downtown") > -1 || txt.indexOf("square") > -1) { return "A walkable local-area pick with more personality than a random stop."; }
  if (score >= 92) { return "One of the strongest picks nearby, ranked for decision confidence."; }
  if (score >= 86) { return "A strong pick in this scan, filtered for confidence instead of clutter."; }
  return name + " looks like a worthwhile stop for this scan.";
}








function diqOpenNowChip(item) {
  var txt = diqTrustTextForItem(item);
  if (txt.indexOf("closed") > -1) { return "âš ï¸ Check Hours"; }
  if (txt.indexOf("open") > -1) { return "ðŸŸ¢ Open Now"; }
  return "ðŸ§  Place IQ";
}




function diqConversionChipList(item, query) {
  var chips = [];
  var tags = item && item.localTags ? item.localTags : [];
  var cat = adventurePrimaryCategory(item, query || activeLens);
  var score = Number(item && item.worthScore || 0);
  var drops = dropCountsForItem(item);
  var i;




  function add(v) {
    var j;
    v = clean(v);
    if (!v) { return; }
    for (j = 0; j < chips.length; j++) { if (normText(chips[j]) === normText(v)) { return; } }
    chips.push(v);
  }




  add(diqOpenNowChip(item));
  if (score >= 94) { add("ðŸ”¥ Worth the Drive " + String(score)); add("Top Nearby Pick"); }
  else if (score >= 88) { add("ðŸ”¥ Worth the Drive " + String(score)); add("High Confidence"); }
  else if (score >= 78) { add("â­ Strong Pick " + String(score)); }
  else { add("â­ Worth a Look"); }




  if (cat === "local favorites") { add("â¤ï¸ Local Favorite"); }
  if (cat === "live music") { add("ðŸŽµ Live Music"); }
  if (cat === "patio vibes") { add("ðŸŒ… Patio Vibe"); }
  if (cat === "coffee iq") { add("â˜• Local Coffee Pick"); }
  if (cat === "waterfront" || cat === "water") { add("ðŸŒŠ Water View"); }
  if (cat === "food iq" || cat === "food drinks" || cat === "popular tonight") { add("ðŸ½ Food Worth Trying"); }
  if (cat === "shopping") { add("ðŸ› Local Shopping"); }
  if (cat === "trails" || cat === "parks" || cat === "scenic" || cat === "camping") { add("ðŸž Adventure Stop"); }
  if (drops && drops.total) { add("Fresh Drops"); }
  for (i = 0; i < tags.length && chips.length < 8; i++) { add(tags[i]); }
  return chips.slice(0, 8);
}








function diqRenderConversionChips(item, query) {
  var worth = byId("diqAdvInfoWorth");
  var chips;
  var html = "";
  var i;
  if (!worth) { return; }
  chips = diqConversionChipList(item, query || activeLens);
  for (i = 0; i < chips.length; i++) {
    html += '<span class="diqAdvTag ' + (i === 1 ? 'diqAdvScore' : '') + '">' + escapeHTML(chips[i]) + '</span>';
  }
  worth.innerHTML = html;
}








function placeKeyForDrop(item) {
  if (!item) { return ""; }
  return normText(String(item.label || "place") + " " + String(Math.round(Number(item.lat || 0) * 10000)) + " " + String(Math.round(Number(item.lng || 0) * 10000)));
}




function loadAdventureDrops() {
  var arr = safeParse(lsGet(LS.ADVENTURE_DROPS));
  return arr && arr.length ? arr : [];
}




function saveAdventureDrops(arr) {
  if (!arr || !arr.length) { lsJSON(LS.ADVENTURE_DROPS, []); return; }
  if (arr.length > 250) { arr = arr.slice(arr.length - 250); }
  lsJSON(LS.ADVENTURE_DROPS, arr);
}




function dropLabel(code) {
  var mapLabels = {
    worth_drive: "Worth the Drive",
    patio: "Patio Confirmed",
    live_music: "Live Music",
    dog_friendly: "Dog Friendly",
    great_photos: "Great Photos",
    hidden_gem: "Hidden Gem",
    family: "Family Friendly",
    parking_easy: "Parking Easy",
    sunset: "Amazing Sunset",
    not_worth: "Not Worth It"
  };
  return mapLabels[code] || titleCaseWords(String(code || "").replace(/_/g, " "));
}




function getPlaceDrops(item) {
  var key = placeKeyForDrop(item);
  var arr = loadAdventureDrops();
  var out = [];
  var i;
  var cutoff = Date.now() - (120 * 24 * 60 * 60 * 1000);
  for (i = 0; i < arr.length; i++) {
    if (arr[i] && arr[i].placeKey === key && Number(arr[i].ts || 0) > cutoff) { out.push(arr[i]); }
  }
  return out;
}




function dropCountsForItem(item) {
  var drops = getPlaceDrops(item);
  var counts = {};
  var i;
  var j;
  var tags;
  for (i = 0; i < drops.length; i++) {
    tags = drops[i].tags || [];
    for (j = 0; j < tags.length; j++) {
      counts[tags[j]] = (counts[tags[j]] || 0) + 1;
    }
  }
  return { total: drops.length, counts: counts };
}




function renderDropSummary(item) {
  var el = byId("diqAdvDropSummary");
  var data;
  var labels = [];
  var code;
  var html = "";
  var i;
  if (!el) { return; }
  data = dropCountsForItem(item);
  if (!data.total) { el.innerHTML = ""; return; }
  html += '<span class="diqAdvDropPill">ðŸ’§ ' + String(data.total) + ' Drops</span>';
  for (code in data.counts) {
    if (data.counts.hasOwnProperty(code)) {
      labels.push({ code: code, count: data.counts[code] });
    }
  }
  labels.sort(function (a, b) { return b.count - a.count; });
  for (i = 0; i < labels.length && i < 3; i++) {
    html += '<span class="diqAdvDropPill">' + escapeHTML(dropLabel(labels[i].code)) + ' ' + String(labels[i].count) + '</span>';
  }
  el.innerHTML = html;
}




function isParkedForDrop(item) {
  var speed = lastFix && finite(Number(lastFix.speed)) ? Number(lastFix.speed) : 0;
  var near = false;
  var d;
  if (lastFix && item && finite(Number(item.lat)) && finite(Number(item.lng))) {
    d = miles(Number(lastFix.lat), Number(lastFix.lng), Number(item.lat), Number(item.lng));
    near = finite(d) && d <= 0.25;
  }
  if (speed <= 2.5) { return true; }
  if (near && speed <= 5) { return true; }
  return false;
}




function ensureAdventureDropModal() {
  var modal;
  if (byId("diqAdventureDropModal")) { return byId("diqAdventureDropModal"); }
  modal = document.createElement("div");
  modal.id = "diqAdventureDropModal";
  modal.innerHTML =
    '<div class="diqDropSheet">' +
      '<div class="diqDropTop">' +
        '<div><div class="diqDropKicker">ADVENTURE DROP</div><div class="diqDropTitle" id="diqDropTitle">Drop Discovery</div><div class="diqDropSub" id="diqDropSub">Leave a quick signal for the next adventurer.</div></div>' +
        '<button type="button" class="diqDropClose" id="diqDropClose">Ã—</button>' +
      '</div>' +
      '<div class="diqDropChips" id="diqDropChips">' +
        '<button type="button" class="diqDropChip" data-drop="worth_drive">â­ Worth the Drive</button>' +
        '<button type="button" class="diqDropChip" data-drop="patio">ðŸ¹ Patio Confirmed</button>' +
        '<button type="button" class="diqDropChip" data-drop="live_music">ðŸŽµ Live Music</button>' +
        '<button type="button" class="diqDropChip" data-drop="dog_friendly">ðŸ¶ Dog Friendly</button>' +
        '<button type="button" class="diqDropChip" data-drop="great_photos">ðŸ“¸ Great Photos</button>' +
        '<button type="button" class="diqDropChip" data-drop="hidden_gem">â¤ï¸ Hidden Gem</button>' +
        '<button type="button" class="diqDropChip" data-drop="family">ðŸ‘¨â€ðŸ‘©â€ðŸ‘§ Family Friendly</button>' +
        '<button type="button" class="diqDropChip" data-drop="parking_easy">ðŸ…¿ï¸ Parking Easy</button>' +
        '<button type="button" class="diqDropChip" data-drop="sunset">ðŸŒ… Amazing Sunset</button>' +
      '</div>' +
      '<div class="diqDropActions"><button type="button" class="diqDropCancel" id="diqDropCancel">CANCEL</button><button type="button" class="diqDropSubmit" id="diqDropSubmit">DROP IT</button></div>' +
    '</div>';
  try { document.body.appendChild(modal); } catch (e) {}




  try {
    byId("diqDropClose").onclick = closeAdventureDropModal;
    byId("diqDropCancel").onclick = closeAdventureDropModal;
    byId("diqDropSubmit").onclick = submitAdventureDrop;
    byId("diqDropChips").onclick = function (e) {
      var t = e && e.target ? e.target : null;
      if (!t || !t.getAttribute || !t.getAttribute("data-drop")) { return; }
      if (String(t.className || "").indexOf("on") > -1) { t.className = "diqDropChip"; }
      else { t.className = "diqDropChip on"; }
    };
    modal.onclick = function (e2) {
      if (e2 && e2.target === modal) { closeAdventureDropModal(); }
    };
  } catch (bindErr) {}
  return modal;
}




function selectedDropTags() {
  var chips = document.querySelectorAll ? document.querySelectorAll("#diqDropChips .diqDropChip.on") : [];
  var out = [];
  var i;
  for (i = 0; i < chips.length; i++) {
    if (chips[i].getAttribute("data-drop")) { out.push(chips[i].getAttribute("data-drop")); }
  }
  return out;
}




function resetDropChips() {
  var chips = document.querySelectorAll ? document.querySelectorAll("#diqDropChips .diqDropChip") : [];
  var i;
  for (i = 0; i < chips.length; i++) { chips[i].className = "diqDropChip"; }
}




function openAdventureDropModal(item) {
  var modal;
  var title;
  var sub;
  if (!item) { return; }
  if (!isParkedForDrop(item)) {
    toast("Adventure Drops unlock when stopped or parked");
    return;
  }
  activeDropItem = enrichAdventureItem(item, activeLens);
  injectAdventurePolishStyles();
  modal = ensureAdventureDropModal();
  title = byId("diqDropTitle");
  sub = byId("diqDropSub");
  if (title) { title.textContent = String(activeDropItem.label || "Drop Discovery"); }
  if (sub) { sub.textContent = "What did you discover? Pick quick signals for the next adventurer."; }
  resetDropChips();
  if (modal) {
    adventureDropModalOpen = true;
    modal.className = "on";
    modal.setAttribute("aria-hidden", "false");
  }
}




function closeAdventureDropModal() {
  var modal = byId("diqAdventureDropModal");
  adventureDropModalOpen = false;
  activeDropItem = null;
  if (modal) {
    modal.className = "";
    modal.setAttribute("aria-hidden", "true");
  }
}




function submitAdventureDrop() {
  var tags = selectedDropTags();
  var arr;
  var item = activeDropItem;
  var drop;
  if (!item) { closeAdventureDropModal(); return; }
  if (!tags.length) { toast("Pick at least one discovery"); return; }
  arr = loadAdventureDrops();
  drop = {
    id: "drop_" + String(Date.now()) + "_" + String(Math.round(Math.random() * 100000)),
    placeKey: placeKeyForDrop(item),
    label: String(item.label || "Adventure stop"),
    lat: Number(item.lat || 0),
    lng: Number(item.lng || 0),
    tags: tags,
    source: "adventure_iq",
    ts: Date.now()
  };
  arr.push(drop);
  saveAdventureDrops(arr);
  recordAdventureHistory(item, "drop");
  closeAdventureDropModal();
  renderDropSummary(item);
  toast("Adventure Drop added");
}




function diqV532HeroFallback(item) {
  var text = normText(
    String(item && (
      item.adventureCategory ||
      item.userFacingCategory ||
      item.primaryCategory ||
      item.category ||
      item.kind ||
      activeLens ||
      "place"
    ) || "place")
  );

  if (text.indexOf("coffee") > -1 || text.indexOf("cafe") > -1) {
    return "linear-gradient(135deg,rgba(255,206,105,.46),rgba(92,48,24,.48)),radial-gradient(circle at 78% 18%,rgba(255,255,255,.22),transparent 32%)";
  }
  if (text.indexOf("water") > -1 || text.indexOf("lake") > -1 || text.indexOf("beach") > -1) {
    return "linear-gradient(135deg,rgba(0,216,255,.42),rgba(40,255,190,.16)),radial-gradient(circle at 22% 22%,rgba(255,255,255,.20),transparent 30%)";
  }
  if (text.indexOf("food") > -1 || text.indexOf("restaurant") > -1 || text.indexOf("dining") > -1) {
    return "linear-gradient(135deg,rgba(255,206,105,.42),rgba(255,111,72,.18)),radial-gradient(circle at 76% 20%,rgba(255,255,255,.20),transparent 30%)";
  }
  if (text.indexOf("outdoor") > -1 || text.indexOf("park") > -1 || text.indexOf("scenic") > -1) {
    return "linear-gradient(135deg,rgba(40,255,190,.34),rgba(0,216,255,.14)),radial-gradient(circle at 28% 22%,rgba(255,255,255,.18),transparent 32%)";
  }
  return "linear-gradient(135deg,rgba(255,206,105,.28),rgba(40,255,190,.17)),radial-gradient(circle at 76% 20%,rgba(255,255,255,.17),transparent 31%)";
}

function diqV532EnsureHeroVisual(item, stage) {
  var photo = byId("diqAdvInfoPhoto");
  var liveImage = null;
  var background = "";
  var hasLiveImage = false;

  if (!photo) { return false; }

  try {
    liveImage = photo.querySelector("img");
    hasLiveImage = !!(
      liveImage &&
      liveImage.complete &&
      Number(liveImage.naturalWidth || 0) > 0
    );
  } catch (e0) {}

  try { background = String(photo.style.backgroundImage || ""); } catch (e1) {}

  if (!hasLiveImage && (!background || background === "none")) {
    try {
      photo.style.backgroundImage = diqV532HeroFallback(item);
      photo.style.backgroundColor = "rgba(5,18,24,.96)";
      photo.setAttribute("data-diq-hero-fallback", String(stage || "fallback"));
    } catch (e2) {}
  }

  return true;
}

function openAdventureInfoCard(item, preserveBrowseCamera) {
  try{
    diqFounderIQTrack("adventure_place_preview_opened",{
      lens:String(activeLens || ""),
      scope:String(adventureSearchScope || ""),
      worth_score:Number(item && item.worthScore || 0),
      confidence:String(item && item.confidenceLabel || ""),
      source:String(item && item.source || "")
    });
  }catch(founderIQPreviewErr){}

  injectAdventureV21_7CardSafeStyles();
  var card;
  var title;
  var sub;
  var route;
  var save;
  var worth;
  var photo;
  var drop;
  var tags;
  var category;
  var score;
  var distance;
  var freshness;
  var confidence;
  var i;
  var browseCamera = null;
  if (!item) { return; }




  /* V25.1 â€” Pin Preview Camera Lock
     A map-pin tap previews the Place IQ card without refitting or zooming
     the discovery cluster. Preserve the user's current browsing camera and
     cancel only a leftover delayed result-fit timer. Scan behavior is untouched. */
  if (preserveBrowseCamera === true && map && mapLoaded) {
    try {
      browseCamera = {
        center: map.getCenter(),
        zoom: map.getZoom(),
        bearing: map.getBearing ? map.getBearing() : 0,
        pitch: map.getPitch ? map.getPitch() : 0
      };
    } catch (browseCameraErr) { browseCamera = null; }




    try {
      if (scanMapFitTimer) {
        window.clearTimeout(scanMapFitTimer);
        scanMapFitTimer = null;
      }
    } catch (browseFitTimerErr) {}




    try { freeFlowUntil = Date.now() + 15000; } catch (browseFreeFlowErr) {}
  }




  /* V24.9 â€” Manual Pin Selection Lock
     A tapped map pin or chosen result owns the bottom card.
     Close the recommendation/list panel so the top pick cannot fight
     the manually selected Place IQ preview. */
  try { hideDestinationResults(); } catch (manualHideErr) {}
  try { if (adventureAutoCollapseTimer) { window.clearTimeout(adventureAutoCollapseTimer); adventureAutoCollapseTimer = null; } } catch (manualTimerErr) {}
  try { adventurePreferred = item; } catch (manualPreferredErr) {}
  try { if (adventureResults && adventureResults.length) { renderResultPins(adventureResults, item); } } catch (manualPinErr) {}




  item = enrichAdventureItem(item, activeLens);
  injectAdventurePolishStyles();
  card = ensureInfoCard();
  title = byId("diqAdvInfoTitle");
  sub = byId("diqAdvInfoSub");
  route = byId("diqAdvInfoRoute");
  save = byId("diqAdvInfoSave");
  worth = byId("diqAdvInfoWorth");
  photo = byId("diqAdvInfoPhoto");
  drop = byId("diqAdvInfoDrop");
  category = byId("diqAdvInfoCategory");
  score = byId("diqAdvInfoScore");
  distance = byId("diqAdvInfoDistance");
  freshness = byId("diqAdvInfoFreshness");
  confidence = byId("diqAdvInfoConfidence");




  try {
    card.__diqPlaceItem = item;
    card.setAttribute("aria-hidden", "false");
  } catch (cardStateErr) {}

  diqV532EnsureHeroVisual(item, "before-photo-iq");
  diqApplyPlaceGallery(item, activeLens);
  try { diqHydratePlacePhotos(item, activeLens); } catch (photoHydrateErr) {}
  if (title) { title.textContent = String(item.label || "Adventure stop"); }
  if (category) {
    category.textContent = titleCaseWords(String(item.adventureCategory || item.matchLabel || item.kind || "Adventure IQ").replace(/_/g, " "));
  }
  if (score) { score.textContent = String(item.worthScore || "--"); }
  try {
    var scoreLabelEl = card && card.querySelector ? card.querySelector(".diqPlaceScoreLabel") : null;
    if (scoreLabelEl) {
      scoreLabelEl.textContent = Number(item.worthScore || 0) >= 94 ? "Worth the Drive â€¢ Top Pick" : "Worth the Drive";
    }
  } catch (scoreLabelErr) {}
  if (sub) { sub.textContent = diqConversionWhyLine(item, activeLens) || String(item.whyStop || compactAdventureInfoText(item) || "A place worth exploring."); }
  renderRecommendedBecause(item, activeLens);
  if (distance) { distance.textContent = destinationDistanceText(item) || itemDistanceText(item) || "Nearby"; }
  if (freshness) { freshness.textContent = String(item.freshnessLabel || "Place IQ"); }
  if (confidence) { confidence.textContent = String(item.confidenceLabel || "Worth a look"); }




  diqRenderConversionChips(item, activeLens);
  renderDropSummary(item);
  if (drop) {
    drop.onclick = function () {
      openAdventureDropModal(item);
    };
  }
  if (save) {
    save.onclick = function () {
      saveAdventureFavorite(item);
      recordAdventureHistory(item, "save");
    };
  }
  if (route) {
    route.onclick = function () {
      recordAdventureHistory(item, "route");
      closeAdventureInfoCard();
      routeSelectedAdventureItem(item);
    };
  }
  card.className = "on diqConversionIQ";

  diqV532EnsureHeroVisual(item, "card-open");
  window.setTimeout(function () {
    try { diqV532EnsureHeroVisual(item, "photo-250"); } catch (e0) {}
  }, 250);
  window.setTimeout(function () {
    try { diqV532EnsureHeroVisual(item, "photo-1000"); } catch (e1) {}
  }, 1000);

  try {
    if (window.DriveIQAdventureEvents &&
        typeof window.DriveIQAdventureEvents.emit === "function") {
      window.DriveIQAdventureEvents.emit("place:opened", {
        item: item,
        place: item,
        result: item,
        source: preserveBrowseCamera === true ? "pin" : "result-card"
      });
    }
  } catch (placeOpenedErr) {}




  if (browseCamera && map && mapLoaded) {
    (function (camera) {
      function restoreBrowseCamera() {
        try {
          map.jumpTo({
            center: [Number(camera.center.lng), Number(camera.center.lat)],
            zoom: Number(camera.zoom),
            bearing: Number(camera.bearing || 0),
            pitch: Number(camera.pitch || 0)
          });
        } catch (restoreCameraErr) {}
      }
      restoreBrowseCamera();
      window.setTimeout(restoreBrowseCamera, 80);
      window.setTimeout(restoreBrowseCamera, 220);
    })(browseCamera);
  }




  recordAdventureHistory(item, "preview");
  speakInfoCard(item);
}




function routeSelectedAdventureItem(item) {
  try{
    diqFounderIQTrack("adventure_route_here_tapped",{
      lens:String(activeLens || ""),
      scope:String(adventureSearchScope || ""),
      gps_ready:lastFix ? 1 : 0,
      worth_score:Number(item && item.worthScore || 0)
    });
  }catch(founderIQRouteTapErr){}

  exitScanResultsMode();
  if (!item) { return; }
  if (!lastFix) {
    waitingForGpsQuery = String(item.label || activeLens || "adventure");
    requestGPS(true);
    toast("Locking GPS first");
    return;
  }
  setStatus("adventureRouteStatus", "BUILDING ROUTE", "gold");
  toast("Building route to " + String(item.label || "stop"));
  try {
    fetch(routeUrlFor(item))
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (!acceptRouteCandidate(labelSearchFallback(item, categoryFromQuery(activeLens)), data, false)) {
          try{ diqFounderIQTrack("adventure_route_failed",{reason:"candidate_rejected"}); }catch(founderIQRouteFailErr1){}
          toast("Route failed");
          setStatus("adventureRouteStatus", "ROUTE FAILED", "red");
        }else{
          try{ diqFounderIQTrack("adventure_route_started",{source:"route_here"}); }catch(founderIQRouteSuccessErr){}
        }
      })
      .catch(function () {
        try{ diqFounderIQTrack("adventure_route_failed",{reason:"fetch_failed"}); }catch(founderIQRouteFailErr2){}
        toast("Route failed");
        setStatus("adventureRouteStatus", "ROUTE FAILED", "red");
      });
  } catch (e) {
    try{ diqFounderIQTrack("adventure_route_failed",{reason:"exception"}); }catch(founderIQRouteFailErr3){}
    toast("Route failed");
  }
}




function miles(lat1, lng1, lat2, lng2) {
  var R = 3958.8;
  var dLat = (Number(lat2) - Number(lat1)) * Math.PI / 180;
  var dLng = (Number(lng2) - Number(lng1)) * Math.PI / 180;
  var a1 = Number(lat1) * Math.PI / 180;
  var a2 = Number(lat2) * Math.PI / 180;
  var x = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.sin(dLng / 2) * Math.sin(dLng / 2) * Math.cos(a1) * Math.cos(a2);
  return R * 2 * Math.atan2(Math.sqrt(x), Math.sqrt(1 - x));
}




function emptyFC() { return { type: "FeatureCollection", features: [] }; }
function pointFC(lng, lat, props) {
  return { type: "FeatureCollection", features: [{ type: "Feature", properties: props || {}, geometry: { type: "Point", coordinates: [Number(lng), Number(lat)] } }] };
}
function removeLayer(id) { try { if (map && map.getLayer(id)) { map.removeLayer(id); } } catch (e) {} }
function removeSource(id) { try { if (map && map.getSource(id)) { map.removeSource(id); } } catch (e) {} }




function enterFreeFlow(reason) {
  freeFlowUntil = Date.now() + 12000;
  hideHorizonForMapUse();
  if (window.console && window.console.log) { window.console.log("[Adventure FreeFlow]", reason || "gesture"); }
}
function canAutoCamera() { return Date.now() > freeFlowUntil; }
function enableFreeFlowGestures() {
  if (!map) { return; }
  try { if (map.dragPan) { map.dragPan.enable(); } } catch (e1) {}
  try { if (map.scrollZoom) { map.scrollZoom.enable(); } } catch (e2) {}
  try { if (map.touchZoomRotate) { map.touchZoomRotate.enable(); } } catch (e3) {}
  try { if (map.touchPitch) { map.touchPitch.enable(); } } catch (e4) {}
  try { if (map.doubleClickZoom) { map.doubleClickZoom.enable(); } } catch (e5) {}
  try { if (map.boxZoom) { map.boxZoom.enable(); } } catch (e6) {}
  try { if (map.keyboard) { map.keyboard.enable(); } } catch (e7) {}
  try {
    map.on("dragstart", function () { enterFreeFlow("drag"); });
    map.on("zoomstart", function () { enterFreeFlow("zoom"); });
    map.on("rotatestart", function () { enterFreeFlow("rotate"); });
    map.on("pitchstart", function () { enterFreeFlow("pitch"); });
    map.on("movestart", function () { enterFreeFlow("move"); });
  } catch (e8) {}
}




function ensureSources() {
  if (!map || !mapLoaded) { return; }
  try {
    if (!map.getSource("adventure-you")) {
      map.addSource("adventure-you", { type: "geojson", data: emptyFC() });
      map.addLayer({ id: "adventure-you-halo", type: "circle", source: "adventure-you", paint: { "circle-radius": ["interpolate", ["linear"], ["zoom"], 8, 14, 14, 24, 18, 34], "circle-color": "#28ffbe", "circle-opacity": 0.22, "circle-blur": 1 } });
      map.addLayer({ id: "adventure-you-dot", type: "circle", source: "adventure-you", paint: { "circle-radius": ["interpolate", ["linear"], ["zoom"], 8, 6, 14, 9, 18, 12], "circle-color": "#28ffbe", "circle-stroke-color": "#061018", "circle-stroke-width": 4 } });
    }
  } catch (e1) {}
  try {
    if (!map.getSource("adventure-dest")) {
      map.addSource("adventure-dest", { type: "geojson", data: emptyFC() });
      map.addLayer({ id: "adventure-dest-halo", type: "circle", source: "adventure-dest", paint: { "circle-radius": ["interpolate", ["linear"], ["zoom"], 8, 16, 14, 28, 18, 40], "circle-color": "#ffce69", "circle-opacity": 0.25, "circle-blur": 1 } });
      map.addLayer({ id: "adventure-dest-dot", type: "circle", source: "adventure-dest", paint: { "circle-radius": ["interpolate", ["linear"], ["zoom"], 8, 7, 14, 10, 18, 14], "circle-color": "#ffce69", "circle-stroke-color": "#061018", "circle-stroke-width": 4 } });
    }
  } catch (e2) {}
}








function ensureResultSources() {
  if (!map || !mapLoaded) { return; }
  try {
    if (!map.getSource("adventure-results")) {
      map.addSource("adventure-results", { type: "geojson", data: emptyFC() });
      map.addLayer({ id: "adventure-result-halo", type: "circle", source: "adventure-results", paint: { "circle-radius": ["case", ["==", ["get", "preferred"], 1], 18, 14], "circle-color": ["case", ["==", ["get", "preferred"], 1], "#ffce69", "#28ffbe"], "circle-opacity": 0.22, "circle-blur": 0.9 } });
      map.addLayer({ id: "adventure-result-dot", type: "circle", source: "adventure-results", paint: { "circle-radius": ["case", ["==", ["get", "preferred"], 1], 9, 7], "circle-color": ["case", ["==", ["get", "preferred"], 1], "#ffce69", "#28ffbe"], "circle-stroke-color": "#061018", "circle-stroke-width": 3 } });
      map.addLayer({ id: "adventure-result-label", type: "symbol", source: "adventure-results", layout: { "text-field": ["get", "shortLabel"], "text-size": 10, "text-offset": [0, 1.55], "text-anchor": "top", "text-max-width": 9, "text-allow-overlap": false }, paint: { "text-color": "#ffffff", "text-halo-color": "#061018", "text-halo-width": 1.25, "text-opacity": 0.92 } });
      try {
        map.on("click", "adventure-result-dot", function (e) {
          var f = e && e.features && e.features.length ? e.features[0] : null;
          var idx = f && f.properties ? Number(f.properties.idx) : -1;
          if (e && e.preventDefault) { e.preventDefault(); }
          if (e && e.originalEvent && e.originalEvent.stopPropagation) { e.originalEvent.stopPropagation(); }
          if (idx >= 0 && adventureResults[idx]) { openAdventureInfoCard(adventureResults[idx], true); }
        });
        map.on("click", "adventure-result-halo", function (e) {
          var f = e && e.features && e.features.length ? e.features[0] : null;
          var idx = f && f.properties ? Number(f.properties.idx) : -1;
          if (e && e.preventDefault) { e.preventDefault(); }
          if (e && e.originalEvent && e.originalEvent.stopPropagation) { e.originalEvent.stopPropagation(); }
          if (idx >= 0 && adventureResults[idx]) { openAdventureInfoCard(adventureResults[idx], true); }
        });
        map.on("mouseenter", "adventure-result-dot", function () { try { map.getCanvas().style.cursor = "pointer"; } catch (ce) {} });
        map.on("mouseleave", "adventure-result-dot", function () { try { map.getCanvas().style.cursor = ""; } catch (ce2) {} });
      } catch (e2) {}
    }
  } catch (e) {}
}




function shortAdventureLabel(label) {
  var s = clean(label);
  if (s.length > 18) { s = s.slice(0, 16) + "â€¦"; }
  return s;
}




function renderResultPins(items, preferred) {
  var fc = emptyFC();
  var i;
  var item;
  if (!map || !mapLoaded) { return; }
  ensureResultSources();
  items = diqV259RankWithTaste(items || []);
  adventureResults = items && items.length ? items.slice(0, 12) : [];
  fc.features = [];
  for (i = 0; i < adventureResults.length; i++) {
    item = adventureResults[i];
    if (!item || !finite(Number(item.lat)) || !finite(Number(item.lng))) { continue; }
    fc.features.push({
      type: "Feature",
      properties: {
        idx: i,
        preferred: preferred && Number(preferred.lat) === Number(item.lat) && Number(preferred.lng) === Number(item.lng) ? 1 : (i === 0 ? 1 : 0),
        shortLabel: shortAdventureLabel(item.label || "Stop")
      },
      geometry: { type: "Point", coordinates: [Number(item.lng), Number(item.lat)] }
    });
  }
  try { map.getSource("adventure-results").setData(fc); } catch (e) {}
  raisePins();
}




function fitAdventureScan(items, preferred) {
  var bounds;
  var i;
  var item;
  if (!map || !mapLoaded) { return false; }
  if (!items || !items.length) {
    if (preferred && finite(Number(preferred.lng)) && finite(Number(preferred.lat))) { flyTo(preferred.lng, preferred.lat, 11.6); return true; }
    return false;
  }
  try {
    item = preferred || items[0];
    bounds = new mapboxgl.LngLatBounds([Number(item.lng), Number(item.lat)], [Number(item.lng), Number(item.lat)]);
    if (lastFix) { bounds.extend([Number(lastFix.lng), Number(lastFix.lat)]); }
    for (i = 0; i < items.length && i < 8; i++) {
      item = items[i];
      if (item && finite(Number(item.lng)) && finite(Number(item.lat))) { bounds.extend([Number(item.lng), Number(item.lat)]); }
    }
    map.fitBounds(bounds, { padding: { top: 235, right: 46, bottom: 150, left: 46 }, duration: 850, maxZoom: 12.2, essential: true });
    return true;
  } catch (e) {}
  return false;
}




function fitAdventureResultsCluster(items, preferred) {
  var bounds;
  var i;
  var item;
  var added = 0;
  var center = getActiveSearchCenter();
  var usable = [];
  var maxMiles = 90;
  var d;




  if (!map || !mapLoaded) { return false; }




  if (!items || !items.length) {
    if (preferred && finite(Number(preferred.lng)) && finite(Number(preferred.lat))) {
      flyTo(preferred.lng, preferred.lat, 14.4);
      return true;
    }
    return false;
  }




  /*
    V25.4: destination and map-area scans use only the active scan cluster.
    The live GPS marker stays visible, but it cannot participate in Boston
    bounds or pull the camera back toward Mississippi.
  */
  for (i = 0; i < items.length && i < 12; i++) {
    item = items[i];
    if (!item || !finite(Number(item.lng)) || !finite(Number(item.lat))) { continue; }




    if (
      center &&
      (adventureSearchScope === "near_destination" || adventureSearchScope === "map_area")
    ) {
      d = miles(Number(center.lat), Number(center.lng), Number(item.lat), Number(item.lng));
      if (finite(Number(d)) && Number(d) > maxMiles) { continue; }
    }




    usable.push(item);
  }




  if (!usable.length && preferred && finite(Number(preferred.lng)) && finite(Number(preferred.lat))) {
    usable.push(preferred);
  }




  if (!usable.length) { return false; }




  try {
    item = preferred;
    if (
      !item ||
      !finite(Number(item.lng)) ||
      !finite(Number(item.lat)) ||
      usable.indexOf(item) < 0
    ) {
      item = usable[0];
    }




    bounds = new mapboxgl.LngLatBounds(
      [Number(item.lng), Number(item.lat)],
      [Number(item.lng), Number(item.lat)]
    );
    added = 1;




    for (i = 0; i < usable.length && i < 10; i++) {
      item = usable[i];
      bounds.extend([Number(item.lng), Number(item.lat)]);
      added += 1;
    }




    adventureDestinationCameraHold = (
      adventureSearchScope === "near_destination" ||
      adventureSearchScope === "map_area"
    );
    adventureDestinationCameraHoldAt = Date.now();




    if (added <= 2) {
      item = preferred || usable[0];
      flyTo(item.lng, item.lat, 14.6);
      return true;
    }




    map.fitBounds(bounds, {
      padding: { top: 118, right: 48, bottom: 245, left: 48 },
      duration: 980,
      maxZoom: 14.25,
      essential: true
    });
    return true;
  } catch (e) {}




  return false;
}




function raisePins() {
  if (!map || !mapLoaded) { return; }
  try {
    if (map.getLayer("adventure-dest-halo")) { map.moveLayer("adventure-dest-halo"); }
    if (map.getLayer("adventure-dest-dot")) { map.moveLayer("adventure-dest-dot"); }
    if (map.getLayer("adventure-you-halo")) { map.moveLayer("adventure-you-halo"); }
    if (map.getLayer("adventure-you-dot")) { map.moveLayer("adventure-you-dot"); }
    if (map.getLayer("adventure-result-halo")) { map.moveLayer("adventure-result-halo"); }
    if (map.getLayer("adventure-result-dot")) { map.moveLayer("adventure-result-dot"); }
    if (map.getLayer("adventure-result-label")) { map.moveLayer("adventure-result-label"); }
  } catch (e) {}
}
function setYou(lng, lat) { if (!map || !mapLoaded) { return; } ensureSources(); try { map.getSource("adventure-you").setData(pointFC(lng, lat, { label: "YOU" })); raisePins(); } catch (e) {} }
function setDestinationPin() { if (!map || !mapLoaded || !destination) { return; } ensureSources(); try { map.getSource("adventure-dest").setData(pointFC(destination.lng, destination.lat, { label: "ADVENTURE" })); raisePins(); } catch (e) {} }
function clearDestinationPin() { if (!map || !mapLoaded) { return; } ensureSources(); try { map.getSource("adventure-dest").setData(emptyFC()); } catch (e) {} }
function clearRouteLine() { removeLayer("adventure-route-line"); removeLayer("adventure-route-glow"); removeSource("adventure-route"); }
function resetAdventureRoute() {
  exitScanResultsMode();
  clearDestinationLock();
  destination = null;
  routeGeo = null;
  clearRouteLine();
  clearDestinationPin();
  lsRemove(LS.DEST);
  lsRemove(LS.ROUTE_GEO);
  lsRemove(LS.ROUTE_INTEL);
  lsRemove(LS.DRIVE_PAYLOAD);
  setStartReady(false);
  try { document.body.classList.remove("adventureRouteReady"); } catch (e0) {}
  adventureResults = [];
  exploreResults = [];
  adventurePreferred = null;
  try { if (map && mapLoaded && map.getSource("adventure-results")) { map.getSource("adventure-results").setData(emptyFC()); } } catch (e) {}
}








function injectAdventureClearSearchStyles() {
  var css;
  var style;
  if (byId("diqAdventureClearSearchStyle")) { return; }
  css =
    ".diqAdventureSearchHost{position:relative!important;}" +
    "#clearAdventureSearch{position:absolute;right:10px;top:50%;transform:translateY(-50%) scale(.92);width:32px;height:32px;border-radius:999px;border:1px solid rgba(255,255,255,.18);background:rgba(5,12,22,.82);color:#fff;font-size:18px;line-height:1;font-weight:1000;display:none;align-items:center;justify-content:center;z-index:8;box-shadow:0 8px 24px rgba(0,0,0,.32);-webkit-tap-highlight-color:transparent;}" +
    "#clearAdventureSearch.on{display:flex;}" +
    "#clearAdventureSearch:active{transform:translateY(-50%) scale(.86);}" +
    ".diqAdventureSearchHost input#adventureSearch{padding-right:52px!important;}";
  style = document.createElement("style");
  style.id = "diqAdventureClearSearchStyle";
  style.type = "text/css";
  style.appendChild(document.createTextNode(css));
  try { document.head.appendChild(style); } catch (e) {}
}




function updateClearAdventureSearchButton() {
  var btn = byId("clearAdventureSearch");
  var input = byId("adventureSearch");
  var hasText = false;
  var hasState = false;




  hasText = !!(input && clean(input.value));
  hasState = !!(destination || routeGeo || destinationResultOpen || adventureResults.length || exploreResults.length);




  if (!btn) { return; }
  if (hasText || hasState) { btn.className = "on"; }
  else { btn.className = ""; }
}




function ensureAdventureClearSearchButton() {
  var input = byId("adventureSearch");
  var parent;
  var btn;
  if (!input) { return null; }




  injectAdventureClearSearchStyles();




  parent = input.parentNode;
  if (parent && parent.className && String(parent.className).indexOf("diqAdventureSearchHost") < 0) {
    parent.className = String(parent.className || "") + " diqAdventureSearchHost";
  } else if (parent && !parent.className) {
    parent.className = "diqAdventureSearchHost";
  }




  btn = byId("clearAdventureSearch");
  if (!btn) {
    btn = document.createElement("button");
    btn.id = "clearAdventureSearch";
    btn.type = "button";
    btn.setAttribute("aria-label", "Clear destination search");
    btn.innerHTML = "&times;";
    try {
      if (parent) { parent.appendChild(btn); }
      else { document.body.appendChild(btn); }
    } catch (e1) {}
  }




  btn.onclick = function (e) {
    if (e && e.preventDefault) { e.preventDefault(); }
    if (e && e.stopPropagation) { e.stopPropagation(); }
    clearDestinationSearch();
    return false;
  };




  updateClearAdventureSearchButton();
  return btn;
}




function clearDestinationSearch() {
  var input = byId("adventureSearch");




  destinationSearchToken += 1;
  exploreScanToken += 1;
  routeAttemptToken += 1;




  if (searchTimer) {
    window.clearTimeout(searchTimer);
    searchTimer = null;
  }




  if (input) { input.value = ""; }




  waitingForGpsQuery = "";
  destinationSearchResults = [];
  clearDestinationLock();
  destinationPreviewScan = false;
  adventureScanOnly = false;
  exploreMode = false;
  adventureSearchCenter = null;
  adventureSearchScope = "near_me";
  adventureDestinationCameraHold = false;
  adventureDestinationCameraHoldAt = 0;
  activeLens = "scenic";
  lsSet(LS.ADVENTURE_LENS, activeLens);




  stopScanTab();
  hideDestinationResults();
  closeAdventureInfoCard();
  closeAdventureDropModal();
  resetAdventureRoute();




  try {
    if (map && mapLoaded && map.getSource("adventure-results")) {
      map.getSource("adventure-results").setData(emptyFC());
    }
  } catch (e1) {}




  try {
    document.body.classList.remove("adventureRouteReady");
    document.body.classList.remove("adventureHorizonHidden");
  } catch (e2) {}




  setStartReady(false);
  syncExploreNearbyButton();
  updateClearAdventureSearchButton();
  setStatus("adventureRouteStatus", "READY", "green");
  toast("Destination cleared");
}








function drawRoute(fc) {
  if (!map || !mapLoaded || !fc) { return; }
  clearRouteLine();
  try {
    map.addSource("adventure-route", { type: "geojson", data: fc, lineMetrics: true });
    map.addLayer({ id: "adventure-route-glow", type: "line", source: "adventure-route", layout: { "line-cap": "round", "line-join": "round" }, paint: { "line-color": "#ffce69", "line-width": 18, "line-opacity": 0.24 } });
    map.addLayer({ id: "adventure-route-line", type: "line", source: "adventure-route", layout: { "line-cap": "round", "line-join": "round" }, paint: { "line-gradient": ["interpolate", ["linear"], ["line-progress"], 0, "#ffce69", 0.55, "#28ffbe", 1, "#00e5ff"], "line-width": ["interpolate", ["linear"], ["zoom"], 8, 4, 13, 6, 17, 8], "line-opacity": 0.96 } });
  } catch (e) {}
  setDestinationPin();
  raisePins();
  fitRoute();
}




function flattenCoords(geometry) {
  var out = [];
  var coords;
  var i;
  var j;
  if (!geometry) { return out; }
  coords = geometry.coordinates || [];
  if (geometry.type === "LineString") {
    for (i = 0; i < coords.length; i++) { if (coords[i] && coords[i].length >= 2) { out.push(coords[i]); } }
  }
  if (geometry.type === "MultiLineString") {
    for (i = 0; i < coords.length; i++) { for (j = 0; j < coords[i].length; j++) { if (coords[i][j] && coords[i][j].length >= 2) { out.push(coords[i][j]); } } }
  }
  return out;
}




function fitPoints() {
  var bounds;
  if (!map || !mapLoaded || !lastFix || !destination) { return false; }
  try {
    bounds = new mapboxgl.LngLatBounds([Number(lastFix.lng), Number(lastFix.lat)], [Number(lastFix.lng), Number(lastFix.lat)]);
    bounds.extend([Number(destination.lng), Number(destination.lat)]);
    map.fitBounds(bounds, { padding: { top: 228, right: 46, bottom: 294, left: 46 }, duration: 800, maxZoom: 13.8, essential: true });
    return true;
  } catch (e) {}
  return false;
}




function fitRoute() {
  var feature;
  var coords;
  var bounds;
  var i;
  if (!map || !mapLoaded || !routeGeo || !routeGeo.features || !routeGeo.features.length) { return false; }
  feature = routeGeo.features[0];
  coords = flattenCoords(feature.geometry);
  if (!coords.length) { return false; }
  try {
    bounds = new mapboxgl.LngLatBounds(coords[0], coords[0]);
    for (i = 1; i < coords.length; i++) { bounds.extend(coords[i]); }
    if (lastFix) { bounds.extend([lastFix.lng, lastFix.lat]); }
    if (destination) { bounds.extend([destination.lng, destination.lat]); }
    map.fitBounds(bounds, { padding: { top: 220, right: 44, bottom: 280, left: 44 }, duration: 900, maxZoom: 13.5, essential: true });
    return true;
  } catch (e) {}
  return false;
}




function flyTo(lng, lat, zoom) {
  if (!map || !mapLoaded) { return; }
  try { map.easeTo({ center: [Number(lng), Number(lat)], zoom: Number(zoom || 14), duration: 700, essential: true }); } catch (e) {}
}








function localAdventureQueries() {
  var out = [];
  var label = destination && destination.label ? clean(destination.label) : "";
  var full = destination && destination.full ? clean(destination.full) : "";
  var base = label || "nearby park";
  var isToFuller = normText(label + " " + full).indexOf("fuller") > -1;




  function add(query,type) {
    var i;
    query = clean(query);
    if (!query) { return; }
    for (i = 0; i < out.length; i++) {
      if (normText(out[i].query) === normText(query)) { return; }
    }
    out.push({ query:query, type:type || "Nearby Adventure" });
  }




  add("trailhead","Trailhead");
  add("hiking trail","Trail");
  add("nature trail","Trail");
  add("walking trail","Run / Walk");
  add("running trail","Run / Walk");
  add("paved trail","Run / Walk");
  add("park loop","Run / Walk");
  add("greenway","Run / Walk");
  add("riverwalk","Run / Walk");
  add("boardwalk","Run / Walk");
  add("waterfront promenade","Run / Walk");
  add("shoreline walk","Run / Walk");
  add("beach walking","Run / Walk");
  add("public track","Run / Walk");
  add("mixed use trail","Run / Walk");
  add("waterfall","Waterfall");
  add("falls","Waterfall");
  add("scenic overlook","Overlook");
  add("viewpoint","Viewpoint");
  add("lookout","Overlook");
  add("beach","Beach");
  add("public beach access","Beach Access");
  add("waterfront park","Waterfront Park");
  add("lake","Water");
  add("pond","Water");
  add("river access","Water Access");
  add("creek","Water");
  add("shoreline","Water Access");
  add("boat ramp","Boat Ramp");
  add("boat launch","Boat Ramp");
  add("marina","Water Access");
  add("pier","Water Access");
  add("picnic area","Picnic Area");
  add("picnic shelter","Picnic Area");
  add("visitor center","Visitor Center");
  add("nature center","Nature Center");
  add("restroom","Restroom");
  add("parking","Parking");
  add("trail parking","Parking");
  add("campground","Campground");
  add("camping","Campground");
  add("park","Park");
  add("recreation area","Recreation Area");
  add("playground","Playground");
  add("wildlife area","Wildlife Area");
  add("nature preserve","Nature Preserve");




  if (label) {
    add(base + " trail","Trail");
    add(base + " trails","Trail");
    add(base + " hiking trail","Trail");
    add(base + " walking trail","Run / Walk");
    add(base + " running trail","Run / Walk");
    add(base + " greenway","Run / Walk");
    add(base + " riverwalk","Run / Walk");
    add(base + " boardwalk","Run / Walk");
    add(base + " beach walk","Run / Walk");
    add(base + " trailhead","Trailhead");
    add(base + " nature trail","Trail");
    add(base + " picnic area","Picnic Area");
    add(base + " visitor center","Visitor Center");
    add(base + " playground","Playground");
    add(base + " lake","Water");
    add(base + " beach","Beach");
    add(base + " public beach access","Beach Access");
    add(base + " waterfront park","Waterfront Park");
    add(base + " boat ramp","Boat Ramp");
    add(base + " restroom","Restroom");
    add(base + " parking","Parking");
  }




  if (isToFuller) {
    add("T. O. Fuller State Park trail","Trail");
    add("T. O. Fuller State Park trails","Trail");
    add("T. O. Fuller State Park hiking trail","Trail");
    add("T. O. Fuller State Park nature trail","Trail");
    add("Discovery Trail T. O. Fuller State Park","Trail");
    add("T. O. Fuller State Park walking trail","Run / Walk");
    add("T. O. Fuller State Park picnic area","Picnic Area");
    add("T. O. Fuller State Park playground","Playground");
    add("T. O. Fuller State Park visitor center","Visitor Center");
    add("T. O. Fuller State Park campground","Campground");
    add("T. O. Fuller State Park parking","Parking");
    add("Chucalissa Museum","Local Attraction");
    add("Mississippi River trail Memphis","Trail");
    add("Chickasaw Heritage Park","Park");
  }




  return out.slice(0, 56);
}




function localGeoUrl(query, mode, centerLat, centerLng) {
  var url = "https://api.geoapify.com/v1/geocode/" + mode +
    "?text=" + encodeURIComponent(query) +
    "&limit=8&format=geojson&apiKey=" + encodeURIComponent(GEOAPIFY_KEY);
  url += "&bias=proximity:" + encodeURIComponent(String(centerLng)) + "," + encodeURIComponent(String(centerLat));
  return url;
}




function normalizeLocalFeature(feature, sourceType, centerLat, centerLng) {
  var item = normalizeFeature(feature, sourceType);
  var d;
  if (!item) { return null; }
  d = miles(Number(centerLat), Number(centerLng), Number(item.lat), Number(item.lng));
  item.destMiles = d;
  item.matchLabel = sourceType || "Nearby adventure";
  return item;
}




function localExploreScore(item) {
  var txt = normText(String(item.label || "") + " " + String(item.full || "") + " " + String(item.matchLabel || ""));
  var d = finite(Number(item.destMiles)) ? Number(item.destMiles) : 9999;
  var score = 0;




  if (txt.indexOf("trailhead") > -1) { score += 135; }
  if (txt.indexOf("greenway") > -1 || txt.indexOf("riverwalk") > -1 || txt.indexOf("boardwalk") > -1 || txt.indexOf("waterfront promenade") > -1) { score += 132; }
  if (txt.indexOf("running") > -1 || txt.indexOf("walking") > -1 || txt.indexOf("paved trail") > -1 || txt.indexOf("fitness trail") > -1) { score += 124; }
  if (txt.indexOf("trail") > -1 || txt.indexOf("path") > -1 || txt.indexOf("loop") > -1) { score += 118; }
  if (txt.indexOf("beach") > -1 || txt.indexOf("shoreline") > -1 || txt.indexOf("lakefront") > -1) { score += 118; }
  if (txt.indexOf("waterfall") > -1 || txt.indexOf("falls") > -1) { score += 130; }
  if (txt.indexOf("overlook") > -1 || txt.indexOf("viewpoint") > -1 || txt.indexOf("lookout") > -1) { score += 115; }
  if (txt.indexOf("boat ramp") > -1 || txt.indexOf("boat launch") > -1 || txt.indexOf("marina") > -1 || txt.indexOf("pier") > -1) { score += 90; }
  if (txt.indexOf("picnic") > -1) { score += 82; }
  if (txt.indexOf("nature center") > -1) { score += 82; }
  if (txt.indexOf("visitor center") > -1) { score += 72; }
  if (txt.indexOf("restroom") > -1 || txt.indexOf("toilet") > -1) { score += 62; }
  if (txt.indexOf("parking") > -1) { score += 54; }
  if (txt.indexOf("camp") > -1 || txt.indexOf("rv") > -1) { score += 65; }
  if (txt.indexOf("playground") > -1) { score += 58; }
  if (txt.indexOf("wildlife") > -1 || txt.indexOf("preserve") > -1) { score += 62; }
  if (txt.indexOf("park") > -1 || txt.indexOf("recreation") > -1) { score += 48; }




  /*
    Don't let visitor centers dominate every Explore Nearby scan.
    They are useful, but trails/water/access should win when available.
  */
  if (txt.indexOf("visitor center") > -1) { score -= 18; }
  if (txt.indexOf("private") > -1 || txt.indexOf("residential") > -1 || txt.indexOf("apartment") > -1 || txt.indexOf("subdivision") > -1) { score -= 90; }




  if (d <= 0.5) { score += 96; }
  else if (d <= 1) { score += 90; }
  else if (d <= 5) { score += 76; }
  else if (d <= 15) { score += 50; }
  else if (d <= 30) { score += 20; }
  else { score -= 45; }




  score -= Math.min(68, d * 1.18);
  return score;
}




function sortLocalExploreResults(items) {
  return items.sort(function (a, b) {
    var sa = localExploreScore(a);
    var sb = localExploreScore(b);
    var da = finite(Number(a.destMiles)) ? Number(a.destMiles) : 9999;
    var db = finite(Number(b.destMiles)) ? Number(b.destMiles) : 9999;
    if (Math.abs(sb - sa) > 10) { return sb - sa; }
    return da - db;
  });
}




function localExploreBucket(item) {
  var txt = normText(String(item && item.label || "") + " " + String(item && item.full || "") + " " + String(item && item.matchLabel || ""));
  if (txt.indexOf("greenway") > -1 || txt.indexOf("riverwalk") > -1 || txt.indexOf("running") > -1 || txt.indexOf("walking") > -1 || txt.indexOf("paved trail") > -1 || txt.indexOf("boardwalk") > -1 || txt.indexOf("track") > -1) { return "runwalk"; }
  if (txt.indexOf("trail") > -1) { return "trail"; }
  if (txt.indexOf("beach") > -1 || txt.indexOf("waterfront") > -1 || txt.indexOf("shoreline") > -1 || txt.indexOf("waterfall") > -1 || txt.indexOf("falls") > -1 || txt.indexOf("lake") > -1 || txt.indexOf("river") > -1 || txt.indexOf("creek") > -1 || txt.indexOf("boat") > -1 || txt.indexOf("marina") > -1 || txt.indexOf("pier") > -1) { return "water"; }
  if (txt.indexOf("overlook") > -1 || txt.indexOf("viewpoint") > -1 || txt.indexOf("lookout") > -1 || txt.indexOf("scenic") > -1) { return "scenic"; }
  if (txt.indexOf("picnic") > -1 || txt.indexOf("playground") > -1) { return "picnic"; }
  if (txt.indexOf("visitor center") > -1 || txt.indexOf("nature center") > -1) { return "visitor"; }
  if (txt.indexOf("parking") > -1 || txt.indexOf("restroom") > -1) { return "access"; }
  if (txt.indexOf("camp") > -1 || txt.indexOf("rv") > -1) { return "camp"; }
  if (txt.indexOf("park") > -1 || txt.indexOf("recreation") > -1 || txt.indexOf("preserve") > -1) { return "park"; }
  return "other";
}




function diversifyLocalExploreResults(items) {
  var out = [];
  var usedNames = {};
  var bucketCounts = {};
  var i;
  var item;
  var key;
  var bucket;




  for (i = 0; i < items.length; i++) {
    item = items[i];
    if (!item) { continue; }




    key = normText(item.label || "");
    if (!key) { continue; }
    if (usedNames[key]) { continue; }




    bucket = localExploreBucket(item);
    if (!bucketCounts[bucket]) { bucketCounts[bucket] = 0; }




    /*
      Keep variety. One visitor center is enough. Access/parking gets capped too.
      Trails/water/scenic can show more because that is the point of Explore.
    */
    if (bucket === "visitor" && bucketCounts[bucket] >= 1) { continue; }
    if (bucket === "access" && bucketCounts[bucket] >= 2) { continue; }
    if (bucket !== "trail" && bucket !== "water" && bucket !== "scenic" && bucket !== "runwalk" && bucketCounts[bucket] >= 3) { continue; }




    usedNames[key] = true;
    bucketCounts[bucket] += 1;
    out.push(item);




    if (out.length >= 14) { break; }
  }




  return out;
}




function tryOutdoorMapStyle() {
  if (!map || !mapLoaded || outdoorStyleActive) { return; }
  outdoorStyleActive = true;
  try {
    map.setStyle("mapbox://styles/mapbox/outdoors-v12");
    setStatus("adventureRouteStatus", "LOCAL MAP", "green");
  } catch (e) {
    outdoorStyleActive = false;
  }
}




function rerenderAdventureAfterStyle() {
  ensureSources();
  ensureResultSources();
  if (lastFix) { setYou(lastFix.lng, lastFix.lat); }
  if (destination) { setDestinationPin(); }
  if (routeGeo) { drawRoute(routeGeo); }
  if (exploreResults && exploreResults.length) { renderResultPins(exploreResults, exploreResults[0]); fitAdventureScan(exploreResults, exploreResults[0]); }
  else if (adventureResults && adventureResults.length) { renderResultPins(adventureResults, adventurePreferred || adventureResults[0]); }
}




function startExploreNearby() {
  try{
    diqFounderIQTrack("adventure_explore_nearby_started",{
      lens:String(activeLens || ""),
      scope:String(adventureSearchScope || "")
    });
  }catch(founderIQExploreErr){}
  var centerLat;
  var centerLng;
  var defs;
  var token;
  var all = [];
  var pending = 0;
  var launched = 0;
  var finished = false;




  if (!destination || !finite(Number(destination.lat)) || !finite(Number(destination.lng))) {
    toast("Choose an adventure stop first");
    return;
  }




  if (!GEOAPIFY_KEY) {
    setStatus("adventureRouteStatus", "EXPLORE UNAVAILABLE", "red");
    toast("Explore search unavailable");
    return;
  }




  exploreMode = true;
  exploreScanToken += 1;
  token = exploreScanToken;
  centerLat = Number(destination.lat);
  centerLng = Number(destination.lng);
  defs = localAdventureQueries();




  injectAdventurePolishStyles();
  closeAdventureInfoCard();
  hideHorizonForMapUse();
  setStatus("adventureRouteStatus", "EXPLORING NEARBY", "gold");
  toast("Scanning around " + String(destination.label || "your stop"));
  adventureSearchScope = "near_destination";
  adventureSearchCenter = { lat:centerLat, lng:centerLng, label:String(destination.label || "your stop") };
  speakAdventureScanStart("local adventure");
  startScanTab("SCANNING NEARBY", "Checking local trails, water, overlooks, and access points...");
  tryOutdoorMapStyle();




  function finishIfReady() {
    var sorted;
    var countEl;
    if (finished || pending > 0 || launched < defs.length || token !== exploreScanToken) { return; }
    finished = true;




    all = dedupe(all);
    sorted = sortLocalExploreResults(all);




    /*
      Show useful local outdoor options within 30 miles of the selected stop.
      Then diversify so the map does not become one visitor center + repeats.
    */
    sorted = sorted.filter(function (item) {
      return item && finite(Number(item.destMiles)) && Number(item.destMiles) <= 30;
    });




    for (var li = 0; li < sorted.length; li++) { sorted[li] = enrichAdventureItem(sorted[li], "outdoors"); }
    exploreResults = diversifyLocalExploreResults(sorted);
    countEl = byId("diqExploreNearbyCount");




    if (exploreResults.length) {
      adventureResults = exploreResults.slice(0);
      adventurePreferred = exploreResults[0];
      renderResultPins(exploreResults, exploreResults[0]);
      fitAdventureResultsCluster(exploreResults, exploreResults[0]);
      afterScanResultsReady(exploreResults, exploreResults[0], "explore_nearby");
      setStatus("adventureRouteStatus", String(exploreResults.length) + " EXPLORE SPOTS", "green");
      if (countEl) { countEl.textContent = String(exploreResults.length) + " SPOTS"; }
      stopScanTab();
      toast(String(exploreResults.length) + " nearby adventure points");
      /*
        Do not auto-open the info card after scan. Let the driver tap the pin
        they care about so the map stays usable.
      */
    } else {
      setStatus("adventureRouteStatus", "NO LOCAL POINTS", "gold");
      if (countEl) { countEl.textContent = "LOCAL MAP"; }
      stopScanTab();
      speakAdventureScanEmpty("local adventure");
      toast("No local adventure points found yet");
      if (destination) { flyTo(destination.lng, destination.lat, 12.2); }
    }




    syncExploreNearbyButton();
  }




  function launch(def) {
    var urls;
    var i;
    if (!def) { return; }
    urls = [localGeoUrl(def.query, "autocomplete", centerLat, centerLng), localGeoUrl(def.query, "search", centerLat, centerLng)];
    function fetchUrl(url) {
      pending += 1;
      try {
        fetch(url)
          .then(function (res) { return res.json(); })
          .then(function (data) {
            var features = data && data.features ? data.features : [];
            var j;
            var item;
            for (j = 0; j < features.length; j++) {
              item = normalizeLocalFeature(features[j], def.type, centerLat, centerLng);
              if (item) { all.push(item); }
            }
            pending -= 1;
            finishIfReady();
          })
          .catch(function () { pending -= 1; finishIfReady(); });
      } catch (e) { pending -= 1; finishIfReady(); }
    }
    for (i = 0; i < urls.length; i++) { fetchUrl(urls[i]); }
  }




  function nextDef() {
    if (finished || token !== exploreScanToken) { return; }
    if (launched >= defs.length) { finishIfReady(); return; }
    updateScanTab("Checking " + String(defs[launched] && defs[launched].type ? defs[launched].type : "nearby option") + "...");
    launch(defs[launched]);
    launched += 1;
    if (launched < defs.length && launched < 8) { window.setTimeout(nextDef, 90); }
    else if (launched < defs.length) { window.setTimeout(nextDef, 140); }
    else { finishIfReady(); }
  }




  nextDef();
}








function categoryFromQuery(query) {
  var q = normText(query);
  if (q.indexOf("local fave") > -1 || q.indexOf("local faves") > -1 || q.indexOf("local favorite") > -1 || q.indexOf("local favorites") > -1 || q.indexOf("locals favorite") > -1 || q.indexOf("locals favorites") > -1 || q.indexOf("local hangout") > -1 || q.indexOf("local hangouts") > -1 || q.indexOf("where locals go") > -1 || q.indexOf("local picks") > -1 || q.indexOf("neighborhood favorite") > -1) { return "local favorites"; }
  if (q.indexOf("popular") > -1 || q.indexOf("tonight") > -1 || q.indexOf("happening") > -1 || q.indexOf("trending") > -1 || q.indexOf("nightlife") > -1) { return "popular tonight"; }
  if (q.indexOf("live music") > -1 || q.indexOf("music venue") > -1 || q.indexOf("concert") > -1 || q.indexOf("band") > -1 || q.indexOf("acoustic") > -1 || q.indexOf("jazz") > -1 || q.indexOf("karaoke") > -1) { return "live music"; }
  if (q.indexOf("waterfront") > -1 || q.indexOf("water front") > -1 || q.indexOf("rooftop") > -1 || q.indexOf("marina") > -1 || q.indexOf("lakefront") > -1 || q.indexOf("riverfront") > -1 || q.indexOf("beach bar") > -1 || q.indexOf("riverwalk") > -1) { return "waterfront"; }
  if (q.indexOf("patio") > -1 || q.indexOf("outside dining") > -1 || q.indexOf("outdoor seating") > -1 || q.indexOf("outdoor dining") > -1 || q.indexOf("al fresco") > -1 || q.indexOf("alfresco") > -1 || q.indexOf("terrace") > -1 || q.indexOf("courtyard") > -1 || q.indexOf("beer garden") > -1 || q.indexOf("fire pit") > -1) { return "patio vibes"; }
  if (q.indexOf("food iq") > -1 || q.indexOf("viral food") > -1 || q.indexOf("must try") > -1 || q.indexOf("must-try") > -1 || q.indexOf("iconic food") > -1 || q.indexOf("local bite") > -1 || q.indexOf("food worth") > -1 || q.indexOf("dessert") > -1 || q.indexOf("ice cream") > -1 || q.indexOf("donut") > -1 || q.indexOf("doughnut") > -1 || q.indexOf("burger") > -1 || q.indexOf("bbq") > -1 || q.indexOf("barbecue") > -1 || q.indexOf("taco") > -1 || q.indexOf("pizza") > -1 || q.indexOf("seafood") > -1 || q.indexOf("breakfast") > -1 || q.indexOf("brunch") > -1) { return "food iq"; }
  if (q.indexOf("coffee iq") > -1 || q.indexOf("coffee") > -1 || q.indexOf("cafe") > -1 || q.indexOf("cafÃ©") > -1 || q.indexOf("espresso") > -1 || q.indexOf("latte") > -1 || q.indexOf("roaster") > -1 || q.indexOf("coffee shop") > -1) { return "coffee iq"; }
  if (q.indexOf("food") > -1 || q.indexOf("drink") > -1 || q.indexOf("restaurant") > -1 || q.indexOf("bar") > -1 || q.indexOf("brewery") > -1 || q.indexOf("bbq") > -1 || q.indexOf("taco") > -1) { return "food drinks"; }
  if (q.indexOf("local favorite") > -1 || q.indexOf("locals") > -1 || q.indexOf("local picks") > -1 || q.indexOf("where locals go") > -1) { return "local favorites"; }
  if (q.indexOf("camp") > -1 || q.indexOf("rv") > -1 || q.indexOf("koa") > -1) { return "camping"; }
  if (q.indexOf("run") > -1 || q.indexOf("jog") > -1 || q.indexOf("walk") > -1 || q.indexOf("greenway") > -1 || q.indexOf("boardwalk") > -1 || q.indexOf("track") > -1 || q.indexOf("paved trail") > -1 || q.indexOf("shoreline walk") > -1 || q.indexOf("beach walk") > -1) { return "run walk"; }
  if (q.indexOf("water") > -1 || q.indexOf("beach") > -1 || q.indexOf("lake") > -1 || q.indexOf("river") > -1 || q.indexOf("shore") > -1 || q.indexOf("boat") > -1 || q.indexOf("pier") > -1) { return "water"; }
  if (q.indexOf("outdoor") > -1 || q.indexOf("outdoors") > -1 || q.indexOf("trail") > -1 || q.indexOf("hiking") > -1) { return "trails"; }
  if (q.indexOf("waterfall") > -1 || q.indexOf("falls") > -1) { return "waterfalls"; }
  if (q.indexOf("cave") > -1 || q.indexOf("cavern") > -1) { return "caves"; }
  if (q.indexOf("park") > -1 || q.indexOf("preserve") > -1) { return "parks"; }
  if (q.indexOf("scenic") > -1 || q.indexOf("overlook") > -1 || q.indexOf("lookout") > -1 || q.indexOf("viewpoint") > -1) { return "scenic"; }
  if (q.indexOf("hidden") > -1 || q.indexOf("gem") > -1 || q.indexOf("landmark") > -1) { return "hidden gems"; }
  if (
    q.indexOf("boutique") > -1 ||
    q.indexOf("shopping") > -1 ||
    q.indexOf("local shops") > -1 ||
    q.indexOf("antique") > -1 ||
    q.indexOf("vintage") > -1 ||
    q.indexOf("outlet") > -1 ||
    q.indexOf("home decor") > -1 ||
    q.indexOf("gift shop") > -1 ||
    q.indexOf("bookstore") > -1 ||
    q.indexOf("farmers market") > -1
  ) { return "shopping"; }




  return "";
}




function genericAdventureRadius(query) {
  var type = categoryFromQuery(query);




  /*
    V13 Local First:
    "Local" should mean your current area first. Downtown / far-city results
    can still show later as Worth the Drive, but they should not be the default.
  */
  if (type === "local favorites") { return 12; }
  if (type === "food iq") { return 22; }
  if (type === "coffee iq") { return 18; }
  if (type === "food drinks" || type === "patio vibes" || type === "popular tonight") { return 18; }
  if (type === "live music") { return 22; }
  if (type === "waterfront") { return 28; }
  if (type === "hidden gems") { return 35; }
  if (type === "camping") { return 55; }
  if (type === "run walk") { return 30; }
  if (type === "water") { return 45; }
  if (type === "trails" || type === "waterfalls" || type === "caves") { return 65; }
  if (type) { return 45; }
  return 0;
}




function noNearbyMessage(query) {
  var type = categoryFromQuery(query);
  if (type === "popular tonight") { return "No popular spots found yet"; }
  if (type === "live music") { return "No live music, nightlife, brewery, beach bar, or waterfront entertainment matches found yet"; }
  if (type === "waterfront") { return "No true waterfront found yet â€” showing creekside, riverwalk, waterfall, and scenic water options nearby"; }
  if (type === "patio vibes") { return "No patio spots found yet"; }
  if (type === "food iq") { return "No Food IQ matches found yet â€” try burgers, BBQ, tacos, seafood, dessert, or local favorites"; }
  if (type === "coffee iq") { return "No Coffee IQ matches found yet â€” try cafÃ©s, bakeries, roasters, breakfast, or local favorites"; }
  if (type === "food drinks") { return "No food and drink spots found yet"; }
  if (type === "local favorites") { return "No local favorites found yet"; }
  if (type === "trails") { return "No nearby trail found"; }
  if (type === "run walk") { return "No nearby run/walk spot found"; }
  if (type === "water") { return "No nearby water access found"; }
  if (type === "waterfalls") { return "No nearby waterfall found"; }
  if (type === "caves") { return "No nearby cave found"; }
  if (type === "parks") { return "No nearby park found"; }
  if (type === "camping") { return "No nearby campground found"; }
  if (type === "scenic") { return "No nearby scenic stop found"; }
  if (type === "hidden gems") { return "No nearby hidden gem found"; }
  return "No driveable destination found";
}








function isDestinWaterfrontRegion() {
  var c = getActiveSearchCenter();
  var lat;
  var lng;
  if (!c) { return false; }
  lat = Number(c.lat);
  lng = Number(c.lng);
  if (!finite(lat) || !finite(lng)) { return false; }
  return lat >= 30.25 && lat <= 30.55 && lng >= -86.75 && lng <= -86.25;
}




function isSmokiesWaterfrontRegion() {
  var c = getActiveSearchCenter();
  var lat;
  var lng;
  if (!c) { return false; }
  lat = Number(c.lat);
  lng = Number(c.lng);
  if (!finite(lat) || !finite(lng)) { return false; }
  return lat >= 35.45 && lat <= 36.15 && lng >= -84.95 && lng <= -83.15;
}




function waterfrontQueryEvidence(item) {
  var q = normText(String(item && item.sourceQuery || ""));
  return hasAnyTruthSignal(q, [
    "waterfront", "harbor", "harbour", "marina", "dockside", "dock side",
    "beachfront", "beach front", "gulf front", "gulfview", "gulf view",
    "bayfront", "bay front", "oceanfront", "ocean front", "pier",
    "boardwalk", "water view", "sunset waterfront"
  ]);
}








/* =========================================================
   DRIVE IQ V25.8 â€” REAL FALLBACK IQ + BIG CITY ZERO GUARD
   "Expanding search criteria" must change radius + terms.
   Major-city broad scans should almost never return zero.
========================================================= */




function adventureScanCityLabel() {
  if (adventureSearchCenter && adventureSearchCenter.label) { return clean(adventureSearchCenter.label); }
  if (destination && destination.label) { return clean(destination.label); }
  return "";
}




function isMajorCityScanContext() {
  var label = normText(adventureScanCityLabel());
  var major = [
    "dallas", "fort worth", "austin", "houston", "san antonio",
    "nashville", "memphis", "atlanta", "new orleans", "orlando",
    "tampa", "miami", "chicago", "new york", "los angeles",
    "phoenix", "denver", "charlotte", "raleigh", "seattle",
    "portland", "las vegas", "san diego", "philadelphia", "boston"
  ];
  var i;




  if (!label) { return false; }
  for (i = 0; i < major.length; i++) {
    if (label.indexOf(major[i]) > -1) { return true; }
  }
  return false;
}




function isBroadTrustCategory(query) {
  var cat = categoryFromQuery(query);
  return cat === "local favorites" ||
    cat === "popular tonight" ||
    cat === "food iq" ||
    cat === "food drinks" ||
    cat === "patio vibes" ||
    cat === "live music" ||
    cat === "shopping" ||
    cat === "hidden gems";
}




function adventureFallbackMaxPass(query) {
  if (isMajorCityScanContext() && isBroadTrustCategory(query)) { return 5; }
  if (adventureSearchScope === "near_destination" && isBroadTrustCategory(query)) { return 4; }
  return 3;
}




function adventureRadiusForPass(query, passIndex) {
  var base = genericAdventureRadius(query);
  var cat = categoryFromQuery(query);
  var pass = Number(passIndex || 0);
  var radius = base || 18;




  if (cat === "local favorites") {
    if (pass <= 0) { return 14; }
    if (pass === 1) { return 22; }
    if (pass === 2) { return 35; }
    if (pass === 3) { return 50; }
    return 75;
  }




  if (cat === "popular tonight" || cat === "food iq" || cat === "food drinks" || cat === "patio vibes" || cat === "live music") {
    if (pass <= 0) { return radius; }
    if (pass === 1) { return Math.max(radius, 28); }
    if (pass === 2) { return Math.max(radius, 42); }
    if (pass === 3) { return Math.max(radius, 60); }
    return Math.max(radius, 80);
  }




  if (pass <= 0) { return radius; }
  if (pass === 1) { return Math.max(radius, Math.round(radius * 1.45)); }
  if (pass === 2) { return Math.max(radius, Math.round(radius * 2.1)); }
  if (pass === 3) { return Math.max(radius, Math.round(radius * 3)); }
  return Math.max(radius, Math.round(radius * 4));
}




function addUniqueAdventureQuery(out, value) {
  var v = clean(value);
  var i;
  if (!v) { return; }
  for (i = 0; i < out.length; i++) {
    if (normText(out[i]) === normText(v)) { return; }
  }
  out.push(v);
}




function destinationTermSuffix() {
  var label = adventureScanCityLabel();
  if (!label || normText(label) === "you" || normText(label) === "near you") { return ""; }
  return " " + label;
}




function localFavoritesTrustQueries(passIndex) {
  var out = [];
  var city = destinationTermSuffix();
  var cityLabel = adventureScanCityLabel();
  var cityNorm = normText(cityLabel);
  var pass = Number(passIndex || 0);




  /*
    V26.6 Local Faves Hangout IQ:
    Local Faves is not restaurant-only. It means "where locals actually go":
    cantinas, coffee, pickleball, gyms, athletic clubs, parks, districts,
    recreation, family hangouts, boutiques, breweries, dessert, and classic food.
  */
  addUniqueAdventureQuery(out, "local favorites" + city);
  addUniqueAdventureQuery(out, "local faves" + city);
  addUniqueAdventureQuery(out, "where locals go" + city);
  addUniqueAdventureQuery(out, "popular local places" + city);
  addUniqueAdventureQuery(out, "local hangouts" + city);
  addUniqueAdventureQuery(out, "community hangouts" + city);
  addUniqueAdventureQuery(out, "neighborhood favorites" + city);




  addUniqueAdventureQuery(out, "local favorite restaurant" + city);
  addUniqueAdventureQuery(out, "locally owned restaurant" + city);
  addUniqueAdventureQuery(out, "best restaurants" + city);
  addUniqueAdventureQuery(out, "popular restaurants" + city);
  addUniqueAdventureQuery(out, "neighborhood restaurant" + city);
  addUniqueAdventureQuery(out, "cantina" + city);
  addUniqueAdventureQuery(out, "mexican restaurant" + city);
  addUniqueAdventureQuery(out, "bbq restaurant" + city);
  addUniqueAdventureQuery(out, "taco restaurant" + city);
  addUniqueAdventureQuery(out, "brunch restaurant" + city);




  addUniqueAdventureQuery(out, "coffee shop" + city);
  addUniqueAdventureQuery(out, "local coffee shop" + city);
  addUniqueAdventureQuery(out, "bakery" + city);
  addUniqueAdventureQuery(out, "dessert shop" + city);
  addUniqueAdventureQuery(out, "ice cream" + city);
  addUniqueAdventureQuery(out, "brewery" + city);
  addUniqueAdventureQuery(out, "sports bar" + city);




  addUniqueAdventureQuery(out, "pickleball" + city);
  addUniqueAdventureQuery(out, "pickleball club" + city);
  addUniqueAdventureQuery(out, "athletic club" + city);
  addUniqueAdventureQuery(out, "fitness center" + city);
  addUniqueAdventureQuery(out, "gym" + city);
  addUniqueAdventureQuery(out, "recreation center" + city);
  addUniqueAdventureQuery(out, "sports complex" + city);
  addUniqueAdventureQuery(out, "family fun" + city);
  addUniqueAdventureQuery(out, "bowling" + city);
  addUniqueAdventureQuery(out, "arcade" + city);




  addUniqueAdventureQuery(out, "downtown" + city);
  addUniqueAdventureQuery(out, "town square" + city);
  addUniqueAdventureQuery(out, "walkable district" + city);
  addUniqueAdventureQuery(out, "shopping district" + city);
  addUniqueAdventureQuery(out, "local shops" + city);
  addUniqueAdventureQuery(out, "boutique" + city);
  addUniqueAdventureQuery(out, "local attraction" + city);
  addUniqueAdventureQuery(out, "park" + city);




  if (cityNorm.indexOf("southaven") > -1 || cityNorm.indexOf("south haven") > -1 || cityNorm.indexOf("desoto") > -1 || cityNorm.indexOf("de soto") > -1) {
    addUniqueAdventureQuery(out, "Maria's Cantina Southaven");
    addUniqueAdventureQuery(out, "Marias Cantina Southaven");
    addUniqueAdventureQuery(out, "Coffee Central Southaven");
    addUniqueAdventureQuery(out, "Bangers Pickleball Southaven");
    addUniqueAdventureQuery(out, "Banger's Pickleball Southaven");
    addUniqueAdventureQuery(out, "DeSoto Athletic Club Southaven");
    addUniqueAdventureQuery(out, "DAC Southaven");
    addUniqueAdventureQuery(out, "Silo Square Southaven");
    addUniqueAdventureQuery(out, "Town Square Southaven");
    addUniqueAdventureQuery(out, "Snowden Grove Southaven");
    addUniqueAdventureQuery(out, "Snowden Grove Park Southaven");
    addUniqueAdventureQuery(out, "BankPlus Amphitheater Southaven");
    addUniqueAdventureQuery(out, "Landers Center Southaven");
    addUniqueAdventureQuery(out, "Maria's Cantina DeSoto County");
    addUniqueAdventureQuery(out, "Coffee Central DeSoto County");
    addUniqueAdventureQuery(out, "pickleball DeSoto County");
    addUniqueAdventureQuery(out, "athletic club DeSoto County");
    addUniqueAdventureQuery(out, "local hangouts Southaven MS");
    addUniqueAdventureQuery(out, "popular local places Southaven MS");
  }




  if (cityNorm.indexOf("dallas") > -1) {
    addUniqueAdventureQuery(out, "Pecan Lodge Dallas");
    addUniqueAdventureQuery(out, "Bishop Arts District Dallas");
    addUniqueAdventureQuery(out, "Klyde Warren Park Dallas");
    addUniqueAdventureQuery(out, "Truck Yard Dallas");
    addUniqueAdventureQuery(out, "Deep Ellum Dallas");
    addUniqueAdventureQuery(out, "Cattleack Barbeque Dallas");
    addUniqueAdventureQuery(out, "Emporium Pies Dallas");
    addUniqueAdventureQuery(out, "Meddlesome Moth Dallas");
    addUniqueAdventureQuery(out, "The Rustic Dallas");
    addUniqueAdventureQuery(out, "White Rock Lake Dallas");
    addUniqueAdventureQuery(out, "Reunion Tower Dallas");
    addUniqueAdventureQuery(out, "Lower Greenville Dallas");
  }




  if (pass >= 2) {
    addUniqueAdventureQuery(out, "iconic restaurant" + city);
    addUniqueAdventureQuery(out, "classic restaurant" + city);
    addUniqueAdventureQuery(out, "longtime restaurant" + city);
    addUniqueAdventureQuery(out, "local landmark" + city);
    addUniqueAdventureQuery(out, "public market" + city);
    addUniqueAdventureQuery(out, "event venue" + city);
    addUniqueAdventureQuery(out, "community center" + city);
  }




  if (pass >= 3) {
    addUniqueAdventureQuery(out, "date night restaurant" + city);
    addUniqueAdventureQuery(out, "family restaurant" + city);
    addUniqueAdventureQuery(out, "live music bar" + city);
    addUniqueAdventureQuery(out, "independent shop" + city);
    addUniqueAdventureQuery(out, "things to do" + city);
    addUniqueAdventureQuery(out, "entertainment" + city);
  }




  return out;
}




function buildAdventureQueryPass(query, originalQuery, passIndex) {
  var base = buildAdventureQueries(query);
  var out = [];
  var cat = categoryFromQuery(originalQuery || query);
  var pass = Number(passIndex || 0);
  var i;
  var city = destinationTermSuffix();




  for (i = 0; i < base.length; i++) { addUniqueAdventureQuery(out, base[i]); }




  if (pass >= 1) {
    if (cat === "local favorites") {
      base = localFavoritesTrustQueries(pass);
      for (i = 0; i < base.length; i++) { addUniqueAdventureQuery(out, base[i]); }
    } else if (cat === "popular tonight") {
      addUniqueAdventureQuery(out, "local favorite restaurant" + city);
      addUniqueAdventureQuery(out, "popular bar" + city);
      addUniqueAdventureQuery(out, "nightlife district" + city);
      addUniqueAdventureQuery(out, "brewery" + city);
      addUniqueAdventureQuery(out, "live music bar" + city);
      addUniqueAdventureQuery(out, "food hall" + city);
    } else if (cat === "food iq" || cat === "food drinks") {
      addUniqueAdventureQuery(out, "local favorite restaurant" + city);
      addUniqueAdventureQuery(out, "best restaurant" + city);
      addUniqueAdventureQuery(out, "iconic food" + city);
      addUniqueAdventureQuery(out, "bbq restaurant" + city);
      addUniqueAdventureQuery(out, "tacos" + city);
      addUniqueAdventureQuery(out, "brunch restaurant" + city);
      addUniqueAdventureQuery(out, "dessert" + city);
    } else if (cat === "live music") {
      addUniqueAdventureQuery(out, "live music bar" + city);
      addUniqueAdventureQuery(out, "nightlife district" + city);
      addUniqueAdventureQuery(out, "music venue" + city);
      addUniqueAdventureQuery(out, "brewery live music" + city);
      addUniqueAdventureQuery(out, "bar and grill live music" + city);
    } else if (cat === "patio vibes") {
      addUniqueAdventureQuery(out, "restaurant patio" + city);
      addUniqueAdventureQuery(out, "outdoor seating restaurant" + city);
      addUniqueAdventureQuery(out, "beer garden" + city);
      addUniqueAdventureQuery(out, "rooftop restaurant" + city);
      addUniqueAdventureQuery(out, "brunch patio" + city);
    } else if (cat === "shopping") {
      addUniqueAdventureQuery(out, "shopping district" + city);
      addUniqueAdventureQuery(out, "local shops" + city);
      addUniqueAdventureQuery(out, "boutique" + city);
      addUniqueAdventureQuery(out, "farmers market" + city);
      addUniqueAdventureQuery(out, "independent bookstore" + city);
    }
  }




  if (pass >= 2 && isBroadTrustCategory(originalQuery || query)) {
    addUniqueAdventureQuery(out, "things to do" + city);
    addUniqueAdventureQuery(out, "local favorites" + city);
    addUniqueAdventureQuery(out, "hidden gem" + city);
    addUniqueAdventureQuery(out, "downtown" + city);
    addUniqueAdventureQuery(out, "arts district" + city);
    addUniqueAdventureQuery(out, "historic district" + city);
  }




  if (pass >= 3 && isBroadTrustCategory(originalQuery || query)) {
    addUniqueAdventureQuery(out, "restaurant" + city);
    addUniqueAdventureQuery(out, "bar" + city);
    addUniqueAdventureQuery(out, "cafe" + city);
    addUniqueAdventureQuery(out, "park" + city);
    addUniqueAdventureQuery(out, "market" + city);
    addUniqueAdventureQuery(out, "attraction" + city);
  }




  return out.slice(0, pass >= 3 ? 70 : 54);
}




function fallbackScanStatus(passIndex, query) {
  var pass = Number(passIndex || 0);
  var label = adventureScanCategoryLabel(query);
  var city = adventureScanCityLabel();
  var radius = adventureRadiusForPass(query, pass);
  var scope = city ? " around " + city : "";




  if (pass <= 0) { return "Checking direct " + label + " matches" + scope + "..."; }
  if (pass === 1) { return "Expanding to stronger local terms within " + String(radius) + " miles..."; }
  if (pass === 2) { return "Checking neighborhoods, districts, and trusted anchors..."; }
  if (pass === 3) { return "Broadening to adjacent high-confidence local experiences..."; }
  return "Last trust sweep â€” checking broader destination anchors...";
}




function zeroResultTrustMessage(query, passIndex) {
  if (isMajorCityScanContext() && isBroadTrustCategory(query)) {
    return "Big-city scan returned zero after fallback pass " + String(passIndex) + " â€” likely Search IQ/filter pipeline issue";
  }
  return "No confident matches in the expanded scan";
}








function buildAdventureQueries(query) {
  var q = clean(query);
  var cat = categoryFromQuery(q);
  var out = [];
  var i;
  var base;
  function add(v) {
    v = clean(v);
    if (!v) { return; }
    for (i = 0; i < out.length; i++) { if (normText(out[i]) === normText(v)) { return; } }
    out.push(v);
  }
  add(q);
  if (cat === "popular tonight") {
    add("popular tonight"); add("nightlife"); add("live music tonight"); add("restaurant open now"); add("bar open now"); add("brewery"); add("patio restaurant"); add("local events tonight"); add("downtown square"); add("town square"); add("rooftop bar"); add("waterfront restaurant"); add("things to do tonight"); add("food trucks"); add("trivia night"); add("karaoke"); add("popular restaurant"); add("local favorite restaurant");
  } else if (cat === "live music") {
    /* V22.2 Live Music Fallback IQ:
       Dedicated music venues are sparse in smaller beach towns. Check true music
       terms first, then credible nightlife / hospitality venues before failing. */
    add("live music tonight"); add("live music"); add("music venue"); add("concert venue"); add("event venue"); add("performing arts"); add("local band"); add("acoustic music"); add("jazz club"); add("karaoke"); add("open mic");
    add("bar"); add("pub"); add("tavern"); add("cocktail bar"); add("nightclub"); add("lounge"); add("sports bar"); add("local bar"); add("popular bar");
    add("brewery"); add("taproom"); add("brewpub"); add("beer garden");
    add("beach bar"); add("waterfront bar"); add("waterfront restaurant"); add("seafood restaurant"); add("bar and grill"); add("restaurant bar"); add("patio bar"); add("outdoor seating bar");
    add("harbor bar"); add("harbor restaurant"); add("marina bar"); add("marina restaurant"); add("boardwalk restaurant"); add("entertainment district"); add("downtown nightlife"); add("things to do tonight");
    if (isDestinWaterfrontRegion()) {
      add("Destin live music"); add("Destin bar"); add("Destin brewery"); add("Destin beach bar"); add("Destin waterfront bar"); add("Destin Harbor bar"); add("Destin Harbor restaurant"); add("HarborWalk Village live music"); add("HarborWalk Village bar"); add("AJ's Seafood and Oyster Bar Destin"); add("Boshamps Seafood and Oyster House"); add("The Village Door Destin"); add("McGuire's Irish Pub Destin"); add("LuLu's Destin");
    }
  } else if (cat === "waterfront") {
    add("waterfront restaurant"); add("waterfront bar"); add("waterfront patio"); add("harbor restaurant"); add("harbor bar"); add("harbor seafood"); add("dockside restaurant"); add("dockside bar"); add("marina restaurant"); add("marina bar"); add("beachfront restaurant"); add("beachfront bar"); add("gulf front restaurant"); add("gulf view restaurant"); add("bayfront restaurant"); add("oceanfront restaurant"); add("pier restaurant"); add("boardwalk restaurant"); add("water view dining"); add("sunset waterfront patio"); add("seafood restaurant on the water");




    /* V21.7 Regional Waterfront IQ: Destin Harbor / Gulf search vocabulary. */
    if (isDestinWaterfrontRegion()) {
      add("Destin Harbor restaurant"); add("Destin Harbor seafood"); add("Destin Harbor bar"); add("Destin marina restaurant"); add("Destin waterfront dining"); add("Destin beachfront restaurant"); add("Destin Gulf front restaurant"); add("Destin dockside restaurant"); add("HarborWalk Village restaurants"); add("Destin Harbor Boardwalk"); add("AJ's Seafood and Oyster Bar Destin"); add("Boshamps Seafood and Oyster House"); add("Harbor Docks Destin"); add("Dewey Destin's Harborside Restaurant"); add("The Back Porch Destin"); add("Pompano Joe's Destin"); add("The Crab Trap Destin");
    }




    /* No-dead-end fallback stays regional instead of injecting Smokies terms everywhere. */
    add("creekside restaurant"); add("creekside patio"); add("river view restaurant"); add("water view restaurant"); add("riverwalk"); add("waterfront park"); add("riverside park"); add("creek access"); add("river access"); add("scenic water"); add("water view patio");
    if (isSmokiesWaterfrontRegion()) {
      add("Little Pigeon River"); add("Little Pigeon River restaurant"); add("Smoky Mountains waterfall"); add("Smoky Mountain waterfalls"); add("nature trail waterfall"); add("covered bridge water");
    }
  } else if (cat === "patio vibes") {
    /* Intent IQ: patio means outdoor dining first, not just breweries. */
    add("restaurant with patio"); add("patio restaurant"); add("restaurants with outdoor seating"); add("outdoor seating restaurant"); add("outdoor dining restaurant"); add("al fresco dining"); add("courtyard restaurant"); add("terrace restaurant"); add("rooftop restaurant"); add("waterfront restaurant patio"); add("brunch patio"); add("cafe patio"); add("coffee patio"); add("dog friendly restaurant patio"); add("restaurant patio live music"); add("sunset patio restaurant"); add("bar and grill patio"); add("bar patio"); add("brewery patio"); add("beer garden"); add("rooftop patio"); add("waterfront patio"); add("fire pit patio"); add("outdoor seating near me");
  } else if (cat === "food iq") {
    add("must try local food"); add("local favorite restaurant"); add("viral food"); add("food worth the drive"); add("iconic local food"); add("best burger"); add("burger restaurant"); add("bbq restaurant"); add("barbecue restaurant"); add("tacos"); add("taco restaurant"); add("pizza restaurant"); add("seafood restaurant"); add("breakfast restaurant"); add("brunch restaurant"); add("dessert"); add("ice cream"); add("donut shop"); add("bakery"); add("coffee shop"); add("food truck"); add("local restaurant"); add("restaurant open now"); add("hidden gem restaurant");
  } else if (cat === "food drinks") {
    add("local restaurant"); add("restaurant open now"); add("bar and grill"); add("brewery"); add("bbq restaurant"); add("tacos"); add("burger restaurant"); add("coffee shop"); add("dessert"); add("seafood restaurant"); add("sports bar"); add("cocktail bar"); add("local food"); add("food and drinks");
  } else if (cat === "local favorites") {
    add("local favorites"); add("local faves"); add("where locals go"); add("local hangouts"); add("popular local places"); add("community hangouts"); add("neighborhood favorites");
    add("local favorite restaurant"); add("locally owned restaurant"); add("best restaurant"); add("popular restaurant"); add("neighborhood restaurant"); add("iconic restaurant"); add("classic restaurant"); add("cantina"); add("mexican restaurant"); add("bbq restaurant");
    add("coffee shop"); add("local coffee shop"); add("brewery"); add("bakery"); add("dessert shop"); add("ice cream"); add("sports bar");
    add("pickleball"); add("pickleball club"); add("athletic club"); add("fitness center"); add("gym"); add("recreation center"); add("sports complex"); add("family fun"); add("bowling"); add("arcade");
    add("downtown"); add("town square"); add("walkable district"); add("shopping district"); add("local shops"); add("boutique"); add("local attraction"); add("park");
    (function () {
      var trust = localFavoritesTrustQueries(0);
      var ti;
      for (ti = 0; ti < trust.length; ti++) { add(trust[ti]); }
    })();
  } else if (cat === "camping") {
    add("campground"); add("campgrounds"); add("camping"); add("RV park"); add("RV campground"); add("campsite"); add("camp site"); add("state park campground"); add("KOA"); add("recreation area camping"); add("primitive camping"); add("tent camping"); add("lake campground"); add("reservoir campground"); add("Corps of Engineers campground"); add("Army Corps campground"); add("USACE campground"); add("recreation.gov campground"); add("park with camping"); add("outdoor recreation area"); add("state park");
    var regionCenter = getActiveSearchCenter();
    if (regionCenter && Number(regionCenter.lat) > 33 && Number(regionCenter.lat) < 36.5 && Number(regionCenter.lng) > -91.5 && Number(regionCenter.lng) < -88) {
      add("T. O. Fuller State Park Campground"); add("Sardis Lake campground"); add("Arkabutla Lake campground"); add("Arkabutla campground"); add("Hernando Point campground"); add("Dub Patton Recreation Area campground"); add("South Abutment campground"); add("Clear Creek campground Sardis Lake"); add("Engineer Point campground"); add("Enid Lake campground"); add("Grenada Lake campground");
    }
  } else if (cat === "run walk") {
    add("running trail"); add("run trail"); add("walking trail"); add("paved trail"); add("greenway"); add("riverwalk"); add("boardwalk"); add("waterfront promenade"); add("shoreline walk"); add("beach walking"); add("beach running"); add("lakefront path"); add("park loop"); add("lake loop"); add("public track"); add("track and field"); add("fitness trail"); add("mixed use trail"); add("scenic path"); add("trailhead"); add("park trail"); add("safe walking path"); add("popular running spot");
  } else if (cat === "water") {
    add("beach"); add("public beach access"); add("beach access"); add("waterfront park"); add("boardwalk"); add("lake access"); add("river access"); add("boat ramp"); add("boat launch"); add("shoreline"); add("lakefront path"); add("waterfront promenade"); add("scenic water view"); add("marina"); add("pier"); add("fishing pier"); add("swimming beach"); add("water access"); add("beach walking"); add("shoreline trail");
  } else if (cat === "trails") {
    add("trail"); add("hiking trail"); add("nature trail"); add("greenway"); add("state park trail"); add("park trail"); add("outdoor recreation area");
  } else if (cat === "parks") {
    add("park"); add("state park"); add("county park"); add("nature preserve"); add("recreation area"); add("outdoor recreation area");
  } else if (cat === "waterfalls") {
    add("waterfall"); add("waterfalls"); add("scenic waterfall"); add("state park waterfall"); add("nature area waterfall"); add("scenic area");
  } else if (cat === "caves") {
    add("cave"); add("cavern"); add("caves"); add("state park cave"); add("natural area");
  } else if (cat === "scenic") {
    add("scenic overlook"); add("lookout"); add("viewpoint"); add("scenic area"); add("park"); add("outdoor recreation area");
  } else if (cat === "hidden gems") {
    add("hidden gem"); add("local attraction"); add("landmark"); add("scenic area"); add("park"); add("outdoor recreation area");
  }
  var searchCenter = getActiveSearchCenter();
  if (searchCenter) {
    base = "near " + String(searchCenter.lat) + "," + String(searchCenter.lng);
    var snapshot = out.slice(0);
    for (i = 0; i < snapshot.length; i++) { add(snapshot[i] + " " + base); }
  }
  return out.slice(0, 46);
}




function geoUrl(query, mode, limit) {
  var center = getActiveSearchCenter();
  var url = "https://api.geoapify.com/v1/geocode/" + mode + "?text=" + encodeURIComponent(query) + "&limit=" + encodeURIComponent(String(limit || 10)) + "&format=geojson&apiKey=" + encodeURIComponent(GEOAPIFY_KEY);
  if (center) { url += "&bias=proximity:" + encodeURIComponent(String(center.lng)) + "," + encodeURIComponent(String(center.lat)); }
  return url;
}




function normalizeFeature(feature, query) {
  var p;
  var lat;
  var lng;
  var center;
  var d = null;
  if (!feature || !feature.properties) { return null; }
  p = feature.properties;
  lat = Number(p.lat);
  lng = Number(p.lon);
  if (!finite(lat) || !finite(lng)) { return null; }
  center = getActiveSearchCenter();
  if (center) { d = miles(Number(center.lat), Number(center.lng), lat, lng); }
  return {
    label: String(p.name || p.address_line1 || p.formatted || query || "Adventure"),
    full: String(p.formatted || p.address_line2 || ""),
    lat: lat,
    lng: lng,
    kind: String(p.result_type || "place"),
    placeCategories: String((p.categories && p.categories.join ? p.categories.join(" ") : p.categories) || (p.datasource && p.datasource.raw && p.datasource.raw.amenity) || ""),
    placeClass: String(p.category || p.type || (p.datasource && p.datasource.raw && (p.datasource.raw.tourism || p.datasource.raw.shop || p.datasource.raw.leisure)) || ""),
    distMiles: d,
    scanScope: adventureSearchScope,
    raw: p,
    properties: p,
    datasourceRaw: (p.datasource && p.datasource.raw) ? p.datasource.raw : null,
    website: String(p.website || p.contact && p.contact.website || p.datasource && p.datasource.raw && (p.datasource.raw.website || p.datasource.raw.contact_website) || ""),
    googlePlaceId: String(p.google_place_id || p.googlePlaceId || p.place_id || p.placeId || p.datasource && p.datasource.raw && (p.datasource.raw.google_place_id || p.datasource.raw.googlePlaceId || p.datasource.raw.place_id || p.datasource.raw.placeId) || ""),
    placeId: String(p.google_place_id || p.googlePlaceId || p.place_id || p.placeId || p.datasource && p.datasource.raw && (p.datasource.raw.google_place_id || p.datasource.raw.googlePlaceId || p.datasource.raw.place_id || p.datasource.raw.placeId) || ""),
    photoReference: String(p.photo_reference || p.photoReference || p.google_photo_reference || p.googlePhotoReference || p.datasource && p.datasource.raw && (p.datasource.raw.photo_reference || p.datasource.raw.photoReference || p.datasource.raw.google_photo_reference || p.datasource.raw.googlePhotoReference) || ""),
    photoReferences: p.photo_references || p.photoReferences || p.google_photo_references || p.googlePhotoReferences || p.datasource && p.datasource.raw && (p.datasource.raw.photo_references || p.datasource.raw.photoReferences || p.datasource.raw.google_photo_references || p.datasource.raw.googlePhotoReferences) || null,
    photoUrl: extractFeaturePhoto(p)
  };
}




function adventureTruthText(item) {
  return normText(
    String(item && item.label || "") + " " +
    String(item && item.full || "") + " " +
    String(item && item.kind || "") + " " +
    String(item && item.placeCategories || "") + " " +
    String(item && item.placeClass || "")
  );
}




function hasAnyTruthSignal(txt, signals) {
  var i;
  for (i = 0; i < signals.length; i++) {
    if (txt.indexOf(signals[i]) > -1) { return true; }
  }
  return false;
}




function isStrictAdventureCategoryMatch(item, query) {
  var category = categoryFromQuery(query);
  var txt = adventureTruthText(item);
  var explicitMusic;
  var credibleVenue;
  var retailNoise;
  var nonVenueNoise;




  if (!category || !item) { return true; }




  if (category === "live music") {
    explicitMusic = hasAnyTruthSignal(txt, [
      "live music", "music venue", "concert", "concert hall", "band", "acoustic",
      "jazz", "karaoke", "nightclub", "dance hall", "theater", "theatre",
      "performing arts", "event venue", "entertainment venue", "amphitheater", "amphitheatre"
    ]);
    credibleVenue = hasAnyTruthSignal(txt, [
      "bar", "pub", "tavern", "brewery", "taproom", "restaurant", "grill",
      "bistro", "cafe", "club", "lounge", "rooftop", "patio", "venue"
    ]);
    retailNoise = hasAnyTruthSignal(txt, [
      "beauty", "cosmetic", "ulta", "salon", "spa", "department store", "clothing",
      "apparel", "shoe store", "retail", "shopping", "supermarket", "grocery",
      "pharmacy", "drugstore", "hardware", "furniture", "automotive", "car dealer",
      "bank", "insurance", "real estate", "storage", "warehouse", "office supply"
    ]);
    nonVenueNoise = hasAnyTruthSignal(txt, [
      "music store", "instrument store", "music lesson", "school", "academy",
      "radio station", "recording studio", "church", "medical", "clinic", "dentist"
    ]);
    return !retailNoise && !nonVenueNoise && (explicitMusic || credibleVenue);
  }




  if (category === "patio vibes") {
    var patio = patioIntentSignals(item);
    return !patio.poorFit && (patio.outdoor || patio.dining || patio.drinkOnly);
  }




  if (category === "food iq" || category === "food drinks") {
    return hasAnyTruthSignal(txt, [
      "restaurant", "bar", "pub", "brewery", "taproom", "grill", "bbq", "barbecue",
      "burger", "pizza", "seafood", "steak", "cafe", "coffee", "bakery", "diner",
      "kitchen", "taco", "brunch", "dessert", "ice cream", "food"
    ]);
  }




  if (category === "local favorites") {
    var localHangoutNoise = hasAnyTruthSignal(txt, [
      "gas station", "convenience", "pharmacy", "drugstore", "car dealer",
      "auto parts", "storage", "warehouse", "bank", "atm", "insurance",
      "real estate", "apartment", "residential", "subdivision", "medical",
      "clinic", "dentist", "law office", "funeral", "church"
    ]);
    var localHangoutSignal = hasAnyTruthSignal(txt, [
      "restaurant", "cantina", "bar", "grill", "bbq", "barbecue", "taco",
      "coffee", "cafe", "bakery", "dessert", "ice cream", "brewery", "taproom",
      "pickleball", "athletic club", "fitness", "gym", "recreation", "sports",
      "park", "amphitheater", "amphitheatre", "arena", "event venue", "bowling",
      "arcade", "boutique", "shop", "market", "square", "silo square",
      "town square", "snowden grove", "desoto", "southaven", "local",
      "hangout", "favorite", "popular"
    ]);
    return !localHangoutNoise && localHangoutSignal;
  }




  if (category === "waterfront") {
    var explicitWater = hasAnyTruthSignal(txt, [
      "waterfront", "lakefront", "riverfront", "marina", "riverwalk", "beach",
      "pier", "harbor", "harbour", "bay", "gulf", "oceanfront", "beachfront",
      "dockside", "dock side", "creekside", "riverside", "water view",
      "river view", "shore", "boardwalk", "waterfall", "falls", "boat ramp", "boat launch"
    ]);
    var credibleHospitality = hasAnyTruthSignal(txt, [
      "restaurant", "seafood", "oyster", "bar", "grill", "cafe", "bistro",
      "patio", "rooftop", "tavern", "pub", "kitchen", "dining"
    ]);
    var waterfrontNoise = hasAnyTruthSignal(txt, [
      "apartment", "condominium", "condo", "real estate", "property management",
      "storage", "office", "bank", "insurance", "medical", "clinic", "dentist",
      "beauty", "cosmetic", "salon", "retail", "department store", "grocery",
      "pharmacy", "hardware", "automotive", "car dealer"
    ]);




    /*
      Waterfront names often omit the water signal entirely (AJ's, Boshamps,
      Harbor Docks, etc.). Keep credible hospitality venues returned by a
      strongly water-specific query, but never let unrelated retail through.
    */
    return !waterfrontNoise && (explicitWater || (credibleHospitality && waterfrontQueryEvidence(item)));
  }




  return true;
}




function patioIntentSignals(item) {
  var txt = normText(String(item && item.label || "") + " " + String(item && item.full || "") + " " + String(item && item.matchLabel || "") + " " + String(item && item.sourceQuery || ""));
  return {
    txt: txt,
    outdoor: txt.indexOf("patio") > -1 || txt.indexOf("outdoor seating") > -1 || txt.indexOf("outdoor dining") > -1 || txt.indexOf("outside dining") > -1 || txt.indexOf("al fresco") > -1 || txt.indexOf("alfresco") > -1 || txt.indexOf("terrace") > -1 || txt.indexOf("courtyard") > -1 || txt.indexOf("rooftop") > -1 || txt.indexOf("beer garden") > -1 || txt.indexOf("fire pit") > -1 || txt.indexOf("waterfront") > -1,
    dining: txt.indexOf("restaurant") > -1 || txt.indexOf("dining") > -1 || txt.indexOf("grill") > -1 || txt.indexOf("bistro") > -1 || txt.indexOf("cafe") > -1 || txt.indexOf("coffee") > -1 || txt.indexOf("brunch") > -1 || txt.indexOf("kitchen") > -1 || txt.indexOf("tacos") > -1 || txt.indexOf("bbq") > -1 || txt.indexOf("barbecue") > -1 || txt.indexOf("burger") > -1 || txt.indexOf("pizza") > -1 || txt.indexOf("seafood") > -1 || txt.indexOf("steak") > -1,
    drinkOnly: txt.indexOf("brewery") > -1 || txt.indexOf("taproom") > -1 || txt.indexOf("distillery") > -1 || txt.indexOf("bar") > -1 || txt.indexOf("pub") > -1 || txt.indexOf("beer garden") > -1,
    poorFit: txt.indexOf("liquor store") > -1 || txt.indexOf("package store") > -1 || txt.indexOf("beer distributor") > -1 || txt.indexOf("wholesale") > -1 || txt.indexOf("supply") > -1
  };
}




function queryCategoryScore(item, category) {
  var txt = normText((item && item.label) + " " + (item && item.full));
  var score = 0;
  if (!category) { return 0; }
  if (category === "camping") {
    if (txt.indexOf("campground") > -1 || txt.indexOf("campgrounds") > -1) { score += 130; }
    if (txt.indexOf("camping") > -1) { score += 110; }
    if (txt.indexOf("rv park") > -1 || txt.indexOf("rv campground") > -1) { score += 105; }
    if (txt.indexOf("koa") > -1) { score += 105; }
    if (txt.indexOf("campsite") > -1 || txt.indexOf("camp site") > -1) { score += 95; }
    if (txt.indexOf("state park") > -1 && (txt.indexOf("camp") > -1 || txt.indexOf("rv") > -1)) { score += 95; }
    if (txt.indexOf("park") > -1 || txt.indexOf("recreation area") > -1) { score += 28; }
  }
  if (category === "run walk") {
    if (txt.indexOf("greenway") > -1 || txt.indexOf("riverwalk") > -1 || txt.indexOf("boardwalk") > -1 || txt.indexOf("waterfront promenade") > -1) { score += 135; }
    if (txt.indexOf("running") > -1 || txt.indexOf("walking") > -1 || txt.indexOf("paved trail") > -1 || txt.indexOf("fitness trail") > -1) { score += 125; }
    if (txt.indexOf("trail") > -1 || txt.indexOf("path") > -1 || txt.indexOf("loop") > -1) { score += 105; }
    if (txt.indexOf("beach") > -1 || txt.indexOf("shoreline") > -1 || txt.indexOf("lakefront") > -1) { score += 98; }
    if (txt.indexOf("track") > -1) { score += 82; }
    if (txt.indexOf("park") > -1 || txt.indexOf("public") > -1) { score += 45; }
  }
  if (category === "water") {
    if (txt.indexOf("beach") > -1 || txt.indexOf("public beach") > -1) { score += 135; }
    if (txt.indexOf("boardwalk") > -1 || txt.indexOf("waterfront") > -1 || txt.indexOf("shoreline") > -1) { score += 122; }
    if (txt.indexOf("lake") > -1 || txt.indexOf("river") > -1 || txt.indexOf("creek") > -1) { score += 105; }
    if (txt.indexOf("boat ramp") > -1 || txt.indexOf("boat launch") > -1 || txt.indexOf("marina") > -1 || txt.indexOf("pier") > -1) { score += 94; }
    if (txt.indexOf("park") > -1 || txt.indexOf("access") > -1) { score += 50; }
  }
  if (category === "trails") { if (txt.indexOf("trail") > -1 || txt.indexOf("greenway") > -1) { score += 120; } if (txt.indexOf("park") > -1 || txt.indexOf("preserve") > -1) { score += 38; } }
  if (category === "parks") { if (txt.indexOf("park") > -1 || txt.indexOf("recreation area") > -1 || txt.indexOf("preserve") > -1) { score += 120; } }
  if (category === "waterfalls") { if (txt.indexOf("waterfall") > -1 || txt.indexOf("falls") > -1) { score += 135; } if (txt.indexOf("scenic") > -1 || txt.indexOf("park") > -1) { score += 30; } }
  if (category === "caves") { if (txt.indexOf("cave") > -1 || txt.indexOf("cavern") > -1) { score += 135; } if (txt.indexOf("natural") > -1 || txt.indexOf("park") > -1) { score += 30; } }
  if (category === "scenic") { if (txt.indexOf("overlook") > -1 || txt.indexOf("lookout") > -1 || txt.indexOf("viewpoint") > -1) { score += 125; } if (txt.indexOf("scenic") > -1 || txt.indexOf("park") > -1) { score += 70; } }
  if (category === "popular tonight") { if (txt.indexOf("nightlife") > -1 || txt.indexOf("downtown") > -1 || txt.indexOf("square") > -1 || txt.indexOf("bar") > -1 || txt.indexOf("brewery") > -1 || txt.indexOf("restaurant") > -1 || txt.indexOf("music") > -1 || txt.indexOf("event") > -1) { score += 120; } if (txt.indexOf("open") > -1 || txt.indexOf("popular") > -1 || txt.indexOf("local") > -1) { score += 55; } }
  if (category === "live music") { if (txt.indexOf("live music") > -1 || txt.indexOf("music venue") > -1 || txt.indexOf("concert") > -1 || txt.indexOf("band") > -1 || txt.indexOf("acoustic") > -1 || txt.indexOf("jazz") > -1 || txt.indexOf("karaoke") > -1) { score += 145; } if (txt.indexOf("bar") > -1 || txt.indexOf("restaurant") > -1 || txt.indexOf("brewery") > -1 || txt.indexOf("patio") > -1 || txt.indexOf("venue") > -1) { score += 75; } if (txt.indexOf("music store") > -1 || txt.indexOf("lesson") > -1 || txt.indexOf("school") > -1 || txt.indexOf("academy") > -1 || txt.indexOf("instrument") > -1 || txt.indexOf("radio") > -1) { score -= 155; } }
  if (category === "local favorites") {
    var localHangoutNoise = hasAnyTruthSignal(txt, [
      "gas station", "convenience", "pharmacy", "drugstore", "car dealer",
      "auto parts", "storage", "warehouse", "bank", "atm", "insurance",
      "real estate", "apartment", "residential", "subdivision", "medical",
      "clinic", "dentist", "law office", "funeral", "church"
    ]);
    var localHangoutSignal = hasAnyTruthSignal(txt, [
      "restaurant", "cantina", "bar", "grill", "bbq", "barbecue", "taco",
      "coffee", "cafe", "bakery", "dessert", "ice cream", "brewery", "taproom",
      "pickleball", "athletic club", "fitness", "gym", "recreation", "sports",
      "park", "amphitheater", "amphitheatre", "arena", "event venue", "bowling",
      "arcade", "boutique", "shop", "market", "square", "silo square",
      "town square", "snowden grove", "desoto", "southaven", "local",
      "hangout", "favorite", "popular"
    ]);
    return !localHangoutNoise && localHangoutSignal;
  }




  if (category === "waterfront") { if (txt.indexOf("waterfront") > -1 || txt.indexOf("lakefront") > -1 || txt.indexOf("riverfront") > -1 || txt.indexOf("marina") > -1 || txt.indexOf("riverwalk") > -1 || txt.indexOf("beach") > -1 || txt.indexOf("pier") > -1 || txt.indexOf("harbor") > -1 || txt.indexOf("harbour") > -1 || txt.indexOf("gulf") > -1 || txt.indexOf("dockside") > -1 || txt.indexOf("boardwalk") > -1) { score += 138; } if (txt.indexOf("creekside") > -1 || txt.indexOf("riverside") > -1 || txt.indexOf("river view") > -1 || txt.indexOf("water view") > -1 || txt.indexOf("little pigeon") > -1 || txt.indexOf("waterfall") > -1 || txt.indexOf("falls") > -1 || txt.indexOf("scenic water") > -1 || txt.indexOf("river access") > -1 || txt.indexOf("creek access") > -1) { score += 112; } if (txt.indexOf("restaurant") > -1 || txt.indexOf("bar") > -1 || txt.indexOf("patio") > -1 || txt.indexOf("rooftop") > -1 || txt.indexOf("dining") > -1) { score += 78; } if (txt.indexOf("trail") > -1 || txt.indexOf("park") > -1 || txt.indexOf("nature") > -1) { score += 36; } }
  if (category === "patio vibes") {
    var patio = patioIntentSignals(item);
    if (patio.outdoor) { score += 145; }
    if (patio.dining) { score += 116; }
    if (patio.outdoor && patio.dining) { score += 96; }
    if (patio.drinkOnly) { score += 38; }
    if (patio.drinkOnly && !patio.dining) { score -= 42; }
    if (patio.poorFit) { score -= 120; }
  }
  if (category === "food iq" || category === "food drinks") { if (txt.indexOf("restaurant") > -1 || txt.indexOf("bar") > -1 || txt.indexOf("brewery") > -1 || txt.indexOf("grill") > -1 || txt.indexOf("bbq") > -1 || txt.indexOf("barbecue") > -1 || txt.indexOf("burger") > -1 || txt.indexOf("taco") > -1 || txt.indexOf("pizza") > -1 || txt.indexOf("seafood") > -1 || txt.indexOf("coffee") > -1 || txt.indexOf("bakery") > -1 || txt.indexOf("dessert") > -1 || txt.indexOf("ice cream") > -1 || txt.indexOf("donut") > -1 || txt.indexOf("brunch") > -1) { score += category === "food iq" ? 138 : 120; } if (txt.indexOf("local") > -1 || txt.indexOf("downtown") > -1 || txt.indexOf("square") > -1 || txt.indexOf("favorite") > -1 || txt.indexOf("popular") > -1) { score += category === "food iq" ? 58 : 48; } }
  if (category === "local favorites") {
    if (txt.indexOf("local") > -1 || txt.indexOf("downtown") > -1 || txt.indexOf("square") > -1 || txt.indexOf("silo square") > -1 || txt.indexOf("town square") > -1 || txt.indexOf("historic") > -1 || txt.indexOf("favorite") > -1 || txt.indexOf("popular") > -1 || txt.indexOf("hangout") > -1 || txt.indexOf("neighborhood") > -1) { score += 128; }
    if (txt.indexOf("southaven") > -1 || txt.indexOf("desoto") > -1 || txt.indexOf("snowden grove") > -1) { score += 95; }
    if (txt.indexOf("maria") > -1 || txt.indexOf("cantina") > -1 || txt.indexOf("coffee central") > -1 || txt.indexOf("banger") > -1 || txt.indexOf("pickleball") > -1 || txt.indexOf("athletic club") > -1 || txt.indexOf("dac") > -1) { score += 150; }
    if (txt.indexOf("restaurant") > -1 || txt.indexOf("bar") > -1 || txt.indexOf("coffee") > -1 || txt.indexOf("cafe") > -1 || txt.indexOf("brewery") > -1 || txt.indexOf("bakery") > -1 || txt.indexOf("dessert") > -1 || txt.indexOf("attraction") > -1) { score += 68; }
    if (txt.indexOf("gym") > -1 || txt.indexOf("fitness") > -1 || txt.indexOf("recreation") > -1 || txt.indexOf("sports") > -1 || txt.indexOf("park") > -1 || txt.indexOf("bowling") > -1 || txt.indexOf("arcade") > -1 || txt.indexOf("boutique") > -1 || txt.indexOf("shop") > -1) { score += 58; }
  }




  if (txt.indexOf("private") > -1 || txt.indexOf("residential") > -1 || txt.indexOf("apartment") > -1 || txt.indexOf("subdivision") > -1) { score -= 85; }
  return score;
}




function labelSearchFallback(item, category) {
  var txt = normText((item && item.label) + " " + (item && item.full));
  if (!item) { return item; }
  item.matchLabel = "Worth the Stop";
  if (category === "popular tonight") { item.matchLabel = "Popular Tonight"; }
  else if (category === "live music") {
    if (hasAnyTruthSignal(adventureTruthText(item), ["live music", "concert", "band", "acoustic", "jazz", "karaoke"])) { item.matchLabel = "Live Music Match"; }
    else { item.matchLabel = "Possible Live Music Venue"; }
  }
  else if (category === "waterfront") {
    if (hasAnyTruthSignal(adventureTruthText(item), ["waterfront", "harbor", "harbour", "marina", "beach", "pier", "bay", "gulf", "oceanfront", "beachfront", "dockside", "boardwalk", "water view"])) { item.matchLabel = "Waterfront Match"; }
    else if (waterfrontQueryEvidence(item)) { item.matchLabel = "Waterfront Candidate"; }
    else { item.matchLabel = "Water Nearby"; }
  }
  else if (category === "patio vibes") { item.matchLabel = "Outdoor Dining"; }
  else if (category === "food iq") { item.matchLabel = "Food IQ â€¢ Worth the Drive"; }
  else if (category === "food drinks") { item.matchLabel = "Food + Drinks"; }
  else if (category === "local favorites") { item.matchLabel = "Local Favorite"; }
  if (category === "camping") {
    if (txt.indexOf("camp") > -1 || txt.indexOf("rv") > -1 || txt.indexOf("koa") > -1) { item.matchLabel = "Camping nearby"; }
    else if (txt.indexOf("park") > -1 || txt.indexOf("recreation") > -1 || txt.indexOf("outdoor") > -1) { item.matchLabel = "Nearby outdoor option â€” camping not confirmed"; }
    else { item.matchLabel = "Closest camping-style option"; }
  }
  return item;
}








function adventureCategoryToken(item, query) {
  return normText(String(adventurePrimaryCategory(item, query) || categoryFromQuery(query) || "adventure"));
}




function loadAdventureTaste() {
  var taste = safeParse(lsGet(LS.ADVENTURE_TASTE));
  if (!taste || typeof taste !== "object") { taste = { categories:{}, places:{}, updatedAt:0 }; }
  if (!taste.categories) { taste.categories = {}; }
  if (!taste.places) { taste.places = {}; }
  return taste;
}




function learnAdventureTaste(item, action, query) {
  var taste;
  var cat;
  var placeKey;
  var weight = 0;
  if (!item) { return; }
  if (action === "route") { weight = 7; }
  else if (action === "save") { weight = 6; }
  else if (action === "drop") { weight = 5; }
  else if (action === "preview") { weight = 1; }
  if (!weight) { return; }
  taste = loadAdventureTaste();
  cat = adventureCategoryToken(item, query || activeLens);
  placeKey = placeKeyForDrop(item);
  taste.categories[cat] = Math.min(40, Number(taste.categories[cat] || 0) + weight);
  taste.places[placeKey] = Math.min(30, Number(taste.places[placeKey] || 0) + weight);
  taste.updatedAt = Date.now();
  lsJSON(LS.ADVENTURE_TASTE, taste);
}




function adventureTasteBoost(item, query) {
  var taste = loadAdventureTaste();
  var cat = adventureCategoryToken(item, query);
  var placeKey = placeKeyForDrop(item);
  var boost = 0;
  boost += Math.min(28, Number(taste.categories[cat] || 0) * 0.9);
  boost += Math.min(24, Number(taste.places[placeKey] || 0) * 1.2);
  return Math.round(boost);
}




function adventureFreshnessData(item) {
  var drops = getPlaceDrops(item);
  var newest = 0;
  var positive = 0;
  var negative = 0;
  var i;
  var j;
  var tags;
  var ageHours;
  for (i = 0; i < drops.length; i++) {
    newest = Math.max(newest, Number(drops[i].ts || 0));
    tags = drops[i].tags || [];
    for (j = 0; j < tags.length; j++) {
      if (tags[j] === "not_worth") { negative += 1; }
      else { positive += 1; }
    }
  }
  ageHours = newest ? Math.max(0, (Date.now() - newest) / 3600000) : 99999;
  return {
    total: drops.length,
    positive: positive,
    negative: negative,
    newest: newest,
    ageHours: ageHours,
    label: ageHours <= 24 ? "Fresh today" : (ageHours <= 72 ? "Fresh this week" : (drops.length ? "Community confirmed" : "Place IQ estimate")),
    boost: Math.max(-36, Math.min(42, positive * 5 - negative * 12 + (ageHours <= 24 ? 14 : (ageHours <= 72 ? 8 : 0))))
  };
}




function adventureConfidenceLabel(item) {
  var fresh = item && item.freshnessData ? item.freshnessData : adventureFreshnessData(item);
  var score = Number(item && item.worthScore || 0);
  if (fresh.total >= 3 && fresh.ageHours <= 72) { return "High confidence"; }
  if (fresh.total >= 1 || score >= 86) { return "Good confidence"; }
  return "Worth a look";
}




function scoreAdventure(item, query) {
  var score = 0;
  var txt = String((item.label || "") + " " + (item.full || "")).toLowerCase();
  var category = categoryFromQuery(query);
  var dist = Number(item.distMiles);
  if (txt.indexOf(String(query || "").toLowerCase()) > -1) { score += 100; }
  if (category === "popular tonight" || category === "live music" || category === "waterfront" || category === "patio vibes" || category === "food drinks" || category === "local favorites") { score += 18; }
  if (category === "local favorites") {
    if (txt.indexOf("silo square") > -1 || txt.indexOf("town square") > -1 || txt.indexOf("snowden grove") > -1 || txt.indexOf("southaven") > -1 || txt.indexOf("desoto") > -1) { score += 70; }
    if (txt.indexOf("maria") > -1 || txt.indexOf("cantina") > -1 || txt.indexOf("coffee central") > -1 || txt.indexOf("banger") > -1 || txt.indexOf("pickleball") > -1 || txt.indexOf("athletic club") > -1 || txt.indexOf("dac") > -1) { score += 135; }
    if (txt.indexOf("coffee") > -1 || txt.indexOf("cafe") > -1 || txt.indexOf("brewery") > -1 || txt.indexOf("bakery") > -1 || txt.indexOf("dessert") > -1 || txt.indexOf("gym") > -1 || txt.indexOf("fitness") > -1 || txt.indexOf("recreation") > -1 || txt.indexOf("sports") > -1 || txt.indexOf("park") > -1 || txt.indexOf("boutique") > -1 || txt.indexOf("shop") > -1) { score += 44; }
  }
  if (category === "patio vibes") {
    var patioSignals = patioIntentSignals(item);
    if (patioSignals.outdoor && patioSignals.dining) { score += 112; }
    else if (patioSignals.dining) { score += 62; }
    else if (patioSignals.outdoor) { score += 46; }
    if (patioSignals.drinkOnly && !patioSignals.dining) { score -= 28; }
    if (patioSignals.poorFit) { score -= 120; }
  }
  if (txt.indexOf("live music") > -1 || txt.indexOf("music venue") > -1 || txt.indexOf("concert") > -1 || txt.indexOf("band") > -1) { score += 48; }
  if (txt.indexOf("restaurant") > -1 || txt.indexOf("bar") > -1 || txt.indexOf("brewery") > -1 || txt.indexOf("grill") > -1) { score += 38; }
  if (txt.indexOf("patio") > -1 || txt.indexOf("rooftop") > -1 || txt.indexOf("outdoor") > -1) { score += 34; }
  if (txt.indexOf("local") > -1 || txt.indexOf("downtown") > -1 || txt.indexOf("square") > -1) { score += 30; }
  if (txt.indexOf("music store") > -1 || txt.indexOf("lesson") > -1 || txt.indexOf("school") > -1 || txt.indexOf("academy") > -1 || txt.indexOf("instrument") > -1 || txt.indexOf("radio") > -1) { score -= 110; }
  if (txt.indexOf("park") > -1) { score += 45; }
  if (txt.indexOf("trail") > -1) { score += 45; }
  if (txt.indexOf("camp") > -1) { score += 45; }
  if (txt.indexOf("forest") > -1) { score += 45; }
  if (txt.indexOf("greenway") > -1 || txt.indexOf("riverwalk") > -1 || txt.indexOf("boardwalk") > -1) { score += 56; }
  if (txt.indexOf("beach") > -1 || txt.indexOf("waterfront") > -1 || txt.indexOf("shoreline") > -1) { score += 55; }
  if (txt.indexOf("waterfall") > -1) { score += 60; }
  if (txt.indexOf("cave") > -1) { score += 60; }
  if (txt.indexOf("lookout") > -1 || txt.indexOf("overlook") > -1) { score += 50; }
  if (txt.indexOf("private") > -1 || txt.indexOf("residential") > -1 || txt.indexOf("apartment") > -1 || txt.indexOf("subdivision") > -1) { score -= 80; }
  score += queryCategoryScore(item, category);
  score += adventureTasteBoost(item, query);
  score += adventureFreshnessData(item).boost;
  if (finite(dist)) {
    if (dist < 5) { score += 80; }
    else if (dist < 15) { score += 62; }
    else if (dist < 30) { score += 42; }
    else if (dist < 60) { score += 22; }
    else if (dist < 90) { score += 10; }
    score -= Math.min(70, dist * 0.45);
  }
  return score;
}




function dedupe(items) {
  var seen = {};
  var out = [];
  var i;
  var item;
  var key;
  for (i = 0; i < items.length; i++) {
    item = items[i];
    if (!item) { continue; }
    key = String(Number(item.lat).toFixed(5)) + "," + String(Number(item.lng).toFixed(5));
    if (seen[key]) { continue; }
    seen[key] = true;
    out.push(item);
  }
  return out;
}




function sortAdventureResults(items, query) {
  return items.sort(function (a, b) {
    var sa = scoreAdventure(a, query);
    var sb = scoreAdventure(b, query);
    var da = finite(Number(a.distMiles)) ? Number(a.distMiles) : 99999;
    var db = finite(Number(b.distMiles)) ? Number(b.distMiles) : 99999;
    if (Math.abs(sb - sa) > 12) { return sb - sa; }
    return da - db;
  });
}




function filterNearbyGenericResults(items, originalQuery) {
  var radius = Number(adventureScanRadiusOverride || 0) || genericAdventureRadius(originalQuery);
  var out = [];
  var i;
  var item;
  if (!radius) { return items; }
  for (i = 0; i < items.length; i++) {
    item = items[i];
    if (!item) { continue; }
    if (finite(item.distMiles) && item.distMiles <= radius) { out.push(item); }
  }
  return out;
}




function routeUrlFor(item) {
  var waypoints = String(lastFix.lat) + "," + String(lastFix.lng) + "|" + String(item.lat) + "," + String(item.lng);
  return "https://api.geoapify.com/v1/routing?waypoints=" + encodeURIComponent(waypoints) + "&mode=drive&details=instruction_details&format=geojson&apiKey=" + encodeURIComponent(GEOAPIFY_KEY);
}




function acceptRouteCandidate(item, data, usedAccessPoint) {
  var features = data && data.features ? data.features : [];
  var feature;
  var props;
  var distanceMeters;
  var durationSeconds;
  var mi;
  var intel;
  var input = byId("adventureSearch");
  var radius = genericAdventureRadius(activeLens);
  if (radius && finite(item.distMiles) && item.distMiles > radius) { return false; }
  if (!features.length) { return false; }
  destinationPreviewScan = false;
  item = enrichAdventureItem(item, activeLens);
  destination = { label: String(item.label || "Adventure"), full: String(item.full || item.matchLabel || ""), matchLabel: String(item.matchLabel || ""), lat: Number(item.lat), lng: Number(item.lng), kind: String(item.kind || "place"), access_point: !!usedAccessPoint, worthScore: Number(item.worthScore || 0), worthStars: String(item.worthStars || ""), whyStop: String(item.whyStop || "") };
  setDestinationLock(destination, "route_candidate_accepted");
  destinationSearchResults = [];
  hideDestinationResults();
  feature = features[0];
  props = feature.properties || {};
  distanceMeters = Number(props.distance || props.distanceMeters || 0);
  durationSeconds = Number(props.time || props.duration || props.durationSeconds || 0);
  mi = distanceMeters * 0.000621371;
  feature.properties = feature.properties || {};
  feature.properties.distanceMeters = distanceMeters;
  feature.properties.durationSeconds = durationSeconds;
  feature.properties.mode = "adventure";
  feature.properties.lens = activeLens;
  routeGeo = { type: "FeatureCollection", features: [feature] };
  intel = { routeScore: 94, miles: Math.round(mi * 10) / 10, destination: destination, mode: "adventure", lens: activeLens, accessPoint: !!usedAccessPoint, summary: usedAccessPoint ? "Accessible adventure route ready" : "Adventure route ready" };
  lsJSON(LS.DEST, destination);
  lsJSON(LS.ROUTE_GEO, routeGeo);
  lsJSON(LS.ROUTE_INTEL, intel);
  if (input) { input.value = String(destination.label || activeLens); }
  setDestinationPin();
  drawRoute(routeGeo);
  adventurePreferred = item;
  if (adventureResults && adventureResults.length) { renderResultPins(adventureResults, item); window.setTimeout(function () { fitAdventureScan(adventureResults, item); }, 260); }
  setStartReady(true);
  setStatus("adventureRouteStatus", usedAccessPoint ? "ACCESS ROUTE READY" : "ROUTE READY", "green");
  stopScanTab();
  toast(usedAccessPoint ? "Nearest accessible route found" : String(item.matchLabel || "Adventure route ready"));
  return true;
}




function accessQuery(query) {
  var q = clean(query).toLowerCase();
  if (q.indexOf("waterfront") > -1 || q.indexOf("riverfront") > -1 || q.indexOf("water view") > -1 || q.indexOf("creek") > -1) { return query + " creekside riverwalk waterfall scenic water"; }
  if (q.indexOf("waterfall") > -1) { return query + " parking trailhead"; }
  if (q.indexOf("trail") > -1) { return query + " trailhead parking"; }
  if (q.indexOf("park") > -1) { return query + " visitor center entrance"; }
  if (q.indexOf("cave") > -1) { return query + " entrance parking"; }
  if (q.indexOf("camp") > -1 || q.indexOf("rv") > -1) { return query + " entrance"; }
  if (q.indexOf("scenic") > -1 || q.indexOf("overlook") > -1) { return query + " overlook parking"; }
  return query + " parking entrance";
}












/* =========================================================
   ADVENTURE IQ V14 â€” LOCAL IQ / PLACE IQ INTELLIGENCE
   Discovery-first cards: venue name, why it matters, distance,
   Worth-the-Drive score, tags, save, and route only after choice.
========================================================= */
function adventurePrimaryCategory(item, query) {
  var cat = categoryFromQuery(query || activeLens || "");
  var txt = normText(String(item && item.label || "") + " " + String(item && item.full || "") + " " + String(item && item.matchLabel || ""));
  if (cat) { return cat; }
  if (txt.indexOf("music") > -1 || txt.indexOf("concert") > -1 || txt.indexOf("band") > -1) { return "live music"; }
  if (txt.indexOf("patio") > -1 || txt.indexOf("outdoor") > -1 || txt.indexOf("rooftop") > -1) { return "patio vibes"; }
  if (txt.indexOf("restaurant") > -1 || txt.indexOf("bar") > -1 || txt.indexOf("brewery") > -1 || txt.indexOf("coffee") > -1 || txt.indexOf("bbq") > -1) { return "food drinks"; }
  if (txt.indexOf("trail") > -1 || txt.indexOf("greenway") > -1) { return "trails"; }
  if (txt.indexOf("park") > -1 || txt.indexOf("preserve") > -1) { return "parks"; }
  if (txt.indexOf("water") > -1 || txt.indexOf("river") > -1 || txt.indexOf("lake") > -1 || txt.indexOf("beach") > -1) { return "water"; }
  if (txt.indexOf("hidden") > -1 || txt.indexOf("historic") > -1 || txt.indexOf("landmark") > -1) { return "hidden gems"; }
  return "local favorites";
}




function adventureStars(score) {
  var n = Number(score || 0);
  if (n >= 88) { return "â˜…â˜…â˜…â˜…â˜…"; }
  if (n >= 78) { return "â˜…â˜…â˜…â˜…â˜†"; }
  if (n >= 66) { return "â˜…â˜…â˜…â˜†â˜†"; }
  return "â˜…â˜…â˜…â˜†â˜†";
}




function adventureWorthScore(item, query) {
  var cat = adventurePrimaryCategory(item, query);
  var base = 68;
  var d = item && finite(Number(item.distMiles)) ? Number(item.distMiles) : null;
  var txt = normText(String(item && item.label || "") + " " + String(item && item.full || "") + " " + String(item && item.matchLabel || "") + " " + String(item && item.sourceQuery || ""));




  base += Math.round(queryCategoryScore(item || {}, cat) / 7);
  if (d !== null) {
    if (d <= 2) { base += 16; }
    else if (d <= 6) { base += 13; }
    else if (d <= 12) { base += 8; }
    else if (d <= 22) { base += 3; }
    else { base -= Math.min(18, Math.round((d - 22) / 3)); }
  }
  if (txt.indexOf("local") > -1 || txt.indexOf("historic") > -1 || txt.indexOf("downtown") > -1 || txt.indexOf("square") > -1) { base += 7; }
  if (txt.indexOf("live music") > -1 || txt.indexOf("music venue") > -1 || txt.indexOf("concert") > -1) { base += 8; }
  if (txt.indexOf("patio") > -1 || txt.indexOf("outdoor") > -1 || txt.indexOf("waterfront") > -1 || txt.indexOf("rooftop") > -1) { base += 6; }
  if (txt.indexOf("trail") > -1 || txt.indexOf("greenway") > -1 || txt.indexOf("riverwalk") > -1 || txt.indexOf("overlook") > -1) { base += 8; }
  if (txt.indexOf("walmart") > -1 || txt.indexOf("mcdonald") > -1 || txt.indexOf("taco bell") > -1 || txt.indexOf("gas station") > -1) { base -= 12; }
  if (txt.indexOf("private") > -1 || txt.indexOf("residential") > -1 || txt.indexOf("apartment") > -1) { base -= 30; }
  if (isFarFromCurrentLocal(item, cat)) { base -= 16; }
  base += Math.min(8, Math.round(adventureTasteBoost(item, query) / 5));
  base += Math.max(-8, Math.min(8, Math.round(adventureFreshnessData(item).boost / 5)));




  if (base < 45) { base = 45; }
  if (base > 97) { base = 97; }
  return base;
}




function isFarFromCurrentLocal(item, cat) {
  var d = item && finite(Number(item.distMiles)) ? Number(item.distMiles) : null;
  if (d === null) { return false; }
  if (cat === "local favorites" && d > 14) { return true; }
  if ((cat === "food iq" || cat === "food drinks" || cat === "patio vibes" || cat === "popular tonight") && d > 22) { return true; }
  return false;
}




function adventureWhy(item, query) {
  var cat = adventurePrimaryCategory(item, query);
  var txt = normText(String(item && item.label || "") + " " + String(item && item.full || ""));
  if (cat === "coffee iq") {
    if (txt.indexOf("roaster") > -1 || txt.indexOf("roastery") > -1) { return "Coffee IQ pick with roaster credibility and worth-a-stop cafÃ© energy."; }
    if (txt.indexOf("bakery") > -1 || txt.indexOf("pastry") > -1) { return "Coffee IQ pick for coffee, pastries, and a relaxed local stop."; }
    if (txt.indexOf("coffee central") > -1) { return "Local coffee favorite for a quick stop, casual meetup, or morning reset."; }
    return "Coffee IQ pick ranked for cafÃ© fit, local feel, and worth-the-stop value.";
  }
  if (cat === "food iq") { return "Food IQ pick â€” a must-try bite, local favorite, dessert stop, or food worth the drive."; }
  if (cat === "live music") { return "Music-forward stop with local energy â€” preview it before routing."; }
  if (cat === "popular tonight") { return "A social, traveler-friendly option that fits a quick evening discovery."; }
  if (cat === "waterfront") { return "Water-adjacent match â€” true waterfront first, then creekside, riverwalk, waterfalls, and scenic water nearby."; }
  if (cat === "patio vibes") { return "Outdoor dining match â€” restaurants and cafes with patio-style seating rank first."; }
  if (cat === "food drinks") {
    if (txt.indexOf("bbq") > -1 || txt.indexOf("barbecue") > -1) { return "A stronger local food stop when you want something memorable."; }
    return "Food and drink stop ranked for local fit, distance, and usefulness.";
  }
  if (cat === "local favorites") { return "Local-style pick ranked for proximity, relevance, and worth-the-drive value."; }
  if (cat === "hidden gems") { return "Discovery-style stop for something less obvious than a generic search result."; }
  if (cat === "trails" || cat === "run walk") { return "Routeable outdoor option for a walk, trail, or quick reset."; }
  if (cat === "water" || cat === "waterfalls") { return "Water-access discovery for views, photos, or a quick adventure stop."; }
  if (cat === "parks" || cat === "scenic") { return "Scenic or outdoor stop that can turn the drive into an experience."; }
  if (cat === "camping") { return "Outdoor overnight or recreation option near your adventure area."; }
  return "A nearby discovery ranked by Drive IQ for relevance and trip value.";
}




function adventureTagList(item, query) {
  var cat = adventurePrimaryCategory(item, query);
  var score = adventureWorthScore(item, query);
  var tags = [];
  var txt = normText(String(item && item.label || "") + " " + String(item && item.full || "") + " " + String(item && item.matchLabel || ""));
  if (score >= 88) { tags.push("Worth the Drive"); }
  else { tags.push("Worth the Stop"); }
  if (cat === "coffee iq") {
    if (txt.indexOf("roaster") > -1 || txt.indexOf("roastery") > -1) { tags.push("Roaster"); }
    else if (txt.indexOf("bakery") > -1 || txt.indexOf("pastry") > -1) { tags.push("Coffee + Pastries"); }
    else if (diqV274CoffeeChainPenalty(txt)) { tags.push("Reliable Coffee"); }
    else { tags.push("Local CafÃ©"); }
  }
  if (cat === "local favorites") { tags.push("Local IQ"); }
  if (cat === "live music") { tags.push("Live Music"); }
  if (cat === "popular tonight") { tags.push("Popular Tonight"); }
  if (cat === "hidden gems") { tags.push("Hidden Gem"); }
  if (cat === "waterfront" || cat === "water") {
    if (cat === "waterfront") { tags.push("Water Nearby"); }
    else { tags.push("Water"); }
    if (txt.indexOf("creek") > -1 || txt.indexOf("river") > -1 || txt.indexOf("riverwalk") > -1 || txt.indexOf("little pigeon") > -1) { tags.push("Creekside"); }
    if (txt.indexOf("waterfall") > -1 || txt.indexOf("falls") > -1) { tags.push("Waterfall"); }
  }
  if (cat === "patio vibes") {
    tags.push("Outdoor Dining");
    if (txt.indexOf("rooftop") > -1) { tags.push("Rooftop"); }
    else if (txt.indexOf("waterfront") > -1 || txt.indexOf("riverfront") > -1 || txt.indexOf("lakefront") > -1) { tags.push("Waterfront"); }
    else { tags.push("Patio"); }
  }
  if (cat === "trails" || cat === "run walk") { tags.push("Outdoor"); }
  if (txt.indexOf("parking") > -1 || txt.indexOf("access") > -1 || txt.indexOf("entrance") > -1) { tags.push("Easy Access"); }
  if (txt.indexOf("family") > -1 || txt.indexOf("park") > -1 || txt.indexOf("playground") > -1) { tags.push("Family Friendly"); }
  if ((cat === "popular tonight" || cat === "live music" || cat === "patio vibes") && tags.length < 4) { tags.push("Crowd IQ"); }
  if ((cat === "trails" || cat === "parks" || cat === "scenic" || cat === "waterfront" || cat === "water") && tags.length < 4) { tags.push("Weather IQ"); }
  if ((txt.indexOf("sports") > -1 || txt.indexOf("bar") > -1 || txt.indexOf("grill") > -1) && tags.length < 4) { tags.push("Sports IQ"); }
  return tags.slice(0, 4);
}




function enrichAdventureItem(item, query) {
  if (!item) { return item; }
  item.adventureCategory = adventurePrimaryCategory(item, query);
  item.worthScore = adventureWorthScore(item, query);
  item.worthStars = adventureStars(item.worthScore);
  item.whyStop = adventureWhy(item, query);
  item.localTags = adventureTagList(item, query);
  item.freshnessData = adventureFreshnessData(item);
  item.freshnessLabel = item.freshnessData.label;
  item.tasteBoost = adventureTasteBoost(item, query);
  item.confidenceLabel = adventureConfidenceLabel(item);
  item.photos = diqBuildPlaceGallery ? diqBuildPlaceGallery(item, query) : (item.photos || []);
  return item;
}




function saveAdventureFavorite(item) {
  var list = safeParse(lsGet(LS.FAVORITE_STOPS));
  var key;
  var i;
  if (!item) { return false; }
  if (!list || !list.length) { list = []; }
  key = normText(String(item.label || "") + "|" + String(item.lat || "") + "," + String(item.lng || ""));
  for (i = 0; i < list.length; i++) {
    if (normText(String(list[i].label || "") + "|" + String(list[i].lat || "") + "," + String(list[i].lng || "")) === key) { toast("Already saved"); return true; }
  }
  list.unshift({
    label: String(item.label || "Adventure stop"),
    full: String(item.full || ""),
    lat: Number(item.lat),
    lng: Number(item.lng),
    category: String(item.adventureCategory || item.matchLabel || "Adventure IQ"),
    badge: String(item.worthStars || "") + " " + String(item.localTags && item.localTags.length ? item.localTags[0] : "Worth the Stop"),
    score: Number(item.worthScore || 0),
    savedAt: new Date().toISOString(),
    source: "adventure_iq"
  });
  if (list.length > 100) { list = list.slice(0, 100); }
  lsJSON(LS.FAVORITE_STOPS, list);
  toast("Saved to Journey");
  return true;
}




function recordAdventureHistory(item, action) {
  try{
    diqFounderIQTrack("adventure_history_recorded",{
      action:String(action || "view"),
      lens:String(activeLens || ""),
      worth_score:Number(item && item.worthScore || 0)
    });
  }catch(founderIQHistoryErr){}

  var list = safeParse(lsGet(LS.ADVENTURE_HISTORY));
  if (!list || !list.length) { list = []; }
  if (!item) { return; }
  list.unshift({ label:String(item.label || "Adventure"), lat:Number(item.lat), lng:Number(item.lng), action:String(action || "view"), score:Number(item.worthScore || 0), ts:new Date().toISOString() });
  if (list.length > 60) { list = list.slice(0, 60); }
  lsJSON(LS.ADVENTURE_HISTORY, list);
  learnAdventureTaste(item, action, activeLens);
}




function adventureChoiceMeta(item, query) {
  var parts = [];
  var d = item && finite(Number(item.distMiles)) ? Number(item.distMiles) : null;
  var cat = categoryFromQuery(query);
  if (d !== null) { parts.push(itemDistanceText(item)); }
  if (cat) { parts.push(titleCaseWords(cat)); }
  if (item && item.freshnessLabel) { parts.push(String(item.freshnessLabel)); }
  if (item && item.confidenceLabel) { parts.push(String(item.confidenceLabel)); }
  if (item && item.kind) { parts.push(titleCaseWords(String(item.kind).replace(/_/g, " "))); }
  return clean(parts.join(" â€¢ "));
}




function renderAdventureScanChoices(items, query) {
  var panel = ensureDestinationResultsPanel();
  var list = byId("diqDestList");
  var head;
  var i;
  var item;
  var btn;
  var name;
  var sub;
  var meta;




  if (!panel || !list) { return; }




  head = panel.querySelector ? panel.querySelector(".diqDestHead") : null;
  if (head) { head.textContent = "CHOOSE ADVENTURE STOP"; }




  destinationSearchResults = items && items.length ? items.slice(0, 8) : [];
  list.innerHTML = "";




  if (!destinationSearchResults.length) {
    if (categoryFromQuery(query) === "waterfront") {
      list.innerHTML = '<button type="button" class="diqDestItem"><div class="diqDestName">No true waterfront found yet</div><div class="diqDestSub">Try creekside, riverwalk, Little Pigeon River, waterfalls, or scenic water nearby.</div><div class="diqDestMeta">PLACE IQ FALLBACK</div></button>';
    } else {
      list.innerHTML = '<button type="button" class="diqDestItem"><div class="diqDestName">No strong local matches yet</div><div class="diqDestSub">Try another category or search a specific place.</div><div class="diqDestMeta">LOCAL IQ</div></button>';
    }
    panel.className = "on";
    destinationResultOpen = true;
    return;
  }




  for (i = 0; i < destinationSearchResults.length; i++) {
    item = enrichAdventureItem(destinationSearchResults[i], query);
    destinationSearchResults[i] = item;
    btn = document.createElement("button");
    btn.type = "button";
    btn.className = "diqDestItem hasPhoto";
    btn.setAttribute("data-adv-idx", String(i));
    try { btn.setAttribute("data-photo-key", diqPhotoCacheKey(item)); } catch (photoKeyErr) {}




    name = clean(item.label || "Adventure stop");
    sub = clean(item.whyStop || item.full || item.matchLabel || "Tap to preview. Route draws only after you choose.");
    meta = clean(adventureChoiceMeta(item, query) || "LOCAL IQ OPTION");
    photoStyle = photoStyleForItem(item, query);
    photoClass = categoryPhotoClass(item, query);




    btn.innerHTML =
      '<div class="diqDestThumb ' + escapeHTML(photoClass) + '" style="' + photoStyle + '"></div>' +
      '<div class="diqDestName">' + escapeHTML(name) + '</div>' +
      '<div class="diqDestSub">' + escapeHTML(sub) + '</div>' +
      '<div class="diqDestMeta">' + escapeHTML(meta) + '</div>' +
      '<div class="diqDestWorth">' + (i === 0 ? '<span class="diqDestTag diqDestTopPick">TOP PICK</span>' : '') + '<span class="diqDestTag diqDestScore">' + escapeHTML(String(item.worthScore || "") + ' IQ') + '</span><span class="diqDestTag">' + escapeHTML(String(item.freshnessLabel || "Place IQ estimate")) + '</span><span class="diqDestTag">' + escapeHTML((item.localTags && item.localTags.length ? item.localTags[0] : "Worth the Stop")) + '</span></div>';




    btn.onclick = function () {
      var idx = Number(this.getAttribute("data-adv-idx"));
      var picked = destinationSearchResults && destinationSearchResults[idx] ? destinationSearchResults[idx] : null;
      if (!picked) { return; }




      /*
        V13: choosing a scan result previews it first.
        No route is drawn until Route Here is tapped inside the info card.
      */
      closeAdventureInfoCard();
      openAdventureInfoCard(picked, true);
      toast("Previewing " + String(picked.label || "stop"));
    };




    list.appendChild(btn);
  }




  panel.className = "on";
  destinationResultOpen = true;
}




function scanAdventureChoices(query) {
  try{
    diqFounderIQTrack("adventure_scan_started",{
      lens:String(activeLens || ""),
      scope:String(scope || adventureSearchScope || ""),
      destination_selected:destination ? 1 : 0
    });
  }catch(founderIQScanStartErr){}

  adventureScanOnly = true;
  findDriveableAdventure(query);
}




function tryRouteCandidates(items, index, token, originalQuery, usedAccessPoint) {
  var item;
  if (token !== routeAttemptToken) { return; }
  if (!items || index >= items.length || index >= 10) {
    if (!usedAccessPoint) {
      setStatus("adventureRouteStatus", "FINDING ACCESS", "gold");
      toast("Finding nearby access point");
      searchRouteCandidates(accessQuery(originalQuery), token, originalQuery, true);
    } else {
      stopScanTab();
      setStatus("adventureRouteStatus", "NO NEARBY ACCESS", "red");
      toast(noNearbyMessage(originalQuery));
      setStartReady(false);
    }
    return;
  }
  item = labelSearchFallback(items[index], categoryFromQuery(originalQuery));
  setStatus("adventureRouteStatus", usedAccessPoint ? "CHECKING ACCESS" : "CHECKING ROUTE", "gold");
  updateScanTab(usedAccessPoint ? "Checking access point..." : "Checking routeable option...");
  try {
    fetch(routeUrlFor(item))
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (token !== routeAttemptToken) { return; }
        if (!acceptRouteCandidate(item, data, usedAccessPoint)) { tryRouteCandidates(items, index + 1, token, originalQuery, usedAccessPoint); }
      })
      .catch(function () { tryRouteCandidates(items, index + 1, token, originalQuery, usedAccessPoint); });
  } catch (e) { tryRouteCandidates(items, index + 1, token, originalQuery, usedAccessPoint); }
}








function localFavoritesRescueResults(items, originalQuery) {
  var out = [];
  var i;
  var item;
  var txt;
  var cat = categoryFromQuery(originalQuery);
  if (cat !== "local favorites") { return []; }
  for (i = 0; i < (items || []).length; i++) {
    item = items[i];
    if (!item) { continue; }
    txt = adventureTruthText(item);
    if (hasAnyTruthSignal(txt, [
      "gas station", "convenience", "pharmacy", "drugstore", "car dealer",
      "auto parts", "storage", "warehouse", "bank", "atm", "insurance",
      "real estate", "apartment", "residential", "subdivision", "medical",
      "clinic", "dentist", "law office", "funeral", "church"
    ])) { continue; }
    if (hasAnyTruthSignal(txt, [
      "restaurant", "cantina", "bar", "grill", "bbq", "barbecue", "taco",
      "coffee", "cafe", "bakery", "dessert", "ice cream", "brewery", "taproom",
      "pickleball", "athletic club", "fitness", "gym", "recreation", "sports",
      "park", "amphitheater", "arena", "event venue", "bowling", "arcade",
      "boutique", "shop", "market", "square", "silo square", "town square",
      "snowden grove", "desoto", "southaven"
    ])) {
      out.push(item);
    }
  }
  return out;
}




function searchRouteCandidates(query, token, originalQuery, usedAccessPoint) {
  var passIndex = Number(usedAccessPoint || 0);
  var maxPass = adventureFallbackMaxPass(originalQuery);
  var queries = buildAdventureQueryPass(query, originalQuery, passIndex);
  var all = [];
  var pending = 0;
  var launched = 0;
  var finished = false;




  adventureScanFallbackPass = passIndex;
  adventureScanRadiusOverride = adventureRadiusForPass(originalQuery, passIndex);
  updateScanTab(fallbackScanStatus(passIndex, originalQuery));
  if (window.console && window.console.log) {
    window.console.log("[Adventure V25.8 Fallback]", {
      pass:passIndex,
      maxPass:maxPass,
      radius:adventureScanRadiusOverride,
      category:categoryFromQuery(originalQuery),
      scope:adventureSearchScope,
      center:adventureScanCityLabel(),
      queries:queries.slice(0, 12)
    });
  }




  function maybeFinish() {
    var sorted;
    var nextQueryText;
    if (finished || pending > 0 || launched < queries.length || token !== routeAttemptToken) { return; }
    finished = true;
    all = filterNearbyGenericResults(dedupe(all), originalQuery);
    var localFavesRescuePool = categoryFromQuery(originalQuery) === "local favorites" ? all.slice(0) : [];
    all = all.filter(function (candidate) {
      return isStrictAdventureCategoryMatch(candidate, originalQuery);
    });
    if (!all.length && categoryFromQuery(originalQuery) === "local favorites") {
      all = localFavoritesRescueResults(localFavesRescuePool, originalQuery);
    }
    sorted = sortAdventureResults(all, originalQuery);




    if (!sorted.length) {
      if (passIndex < maxPass) {
        if (categoryFromQuery(originalQuery) === "waterfront") { updateScanTab("No true waterfront yet. Checking creekside, riverwalk, and waterfall access..."); }
        if (categoryFromQuery(originalQuery) === "live music") {
          updateScanTab("Checking bars, breweries, beach bars, and waterfront entertainment...");
          diqV22LiveMusicFallbackVoice();
        }
        if (categoryFromQuery(originalQuery) === "local favorites") {
          updateScanTab("No trusted local anchors yet. Checking known favorites, districts, and neighborhood staples...");
        }
        nextQueryText = passIndex === 0 ? accessQuery(originalQuery) : originalQuery;
        searchRouteCandidates(nextQueryText, token, originalQuery, passIndex + 1);
      }
      else {
        stopScanTab();
        adventureScanRadiusOverride = 0;
        adventureScanFallbackPass = 0;
        adventureScanOnly = false;
        mapAreaScanActive = false;
        diqV231ApplyScanReliabilityUi(zeroResultTrustMessage(originalQuery, passIndex), "gold");
        setStatus("adventureRouteStatus", categoryFromQuery(originalQuery) === "waterfront" ? "TRY WATER NEARBY" : (isMajorCityScanContext() && isBroadTrustCategory(originalQuery) ? "SEARCH IQ CHECK" : "NO STRONG MATCH"), "gold");
        speakAdventureScanEmpty(originalQuery);
        toast(isMajorCityScanContext() && isBroadTrustCategory(originalQuery) ? "Search widened, but no strong matches rendered â€” check Search IQ filters" : noNearbyMessage(originalQuery));
        setStartReady(false);
      }
      return;
    }




    adventureScanRadiusOverride = 0;
    adventureScanFallbackPass = 0;
    for (var ei = 0; ei < sorted.length; ei++) { sorted[ei] = enrichAdventureItem(sorted[ei], originalQuery); }
    adventureResults = sorted.slice(0, 12);
    adventurePreferred = adventureResults.length ? adventureResults[0] : null;
    renderResultPins(adventureResults, adventurePreferred);
    fitAdventureResultsCluster(adventureResults, adventurePreferred);




    /*
      V13: Category scans are discovery-first.
      Show options and pins. Do not auto-route to the first result.
    */
    if (categoryFromQuery(originalQuery) || adventureScanOnly || destinationPreviewScan) {
      stopScanTab();
      setStatus("adventureRouteStatus", String(Math.min(adventureResults.length, 8)) + " OPTIONS", "green");
      renderAdventureScanChoices(adventureResults, originalQuery);
      afterScanResultsReady(adventureResults, adventurePreferred, passIndex > 0 ? "category_scan_fallback_pass_" + String(passIndex) : "category_scan");
      toast(passIndex > 0 ? "Expanded scan found discoveries" : "Map zoomed to discoveries");
      setStartReady(!!(routeGeo && destination));
      adventureScanOnly = false;
      return;
    }




    updateScanTab("Found " + String(adventureResults.length) + " options. Checking routes...");
    toast(String(adventureResults.length) + " adventure options found");
    tryRouteCandidates(sorted, 0, token, originalQuery, passIndex > 0);
  }




  function launchSearch(queryText) {
    var urls = [geoUrl(queryText, "autocomplete", 10), geoUrl(queryText, "search", 10)];
    var u;
    function fetchUrl(url) {
      pending += 1;
      try {
        fetch(url)
          .then(function (res) { return res.json(); })
          .then(function (data) {
            var features = data && data.features ? data.features : [];
            var i;
            var item;
            for (i = 0; i < features.length; i++) {
              item = normalizeFeature(features[i], queryText);
              if (item) {
                item.sourceQuery = queryText;
                item.category = categoryFromQuery(queryText) || categoryFromQuery(originalQuery);
                item.fallbackPass = passIndex;
                all.push(item);
              }
            }
            pending -= 1;
            maybeFinish();
          })
          .catch(function () { pending -= 1; maybeFinish(); });
      } catch (e) { pending -= 1; maybeFinish(); }
    }
    for (u = 0; u < urls.length; u++) { fetchUrl(urls[u]); }
  }




  function nextQuery() {
    if (finished || token !== routeAttemptToken) { return; }
    if (launched >= queries.length) { maybeFinish(); return; }
    launchSearch(queries[launched]);
    launched += 1;
    if (launched < queries.length && launched < 6) { window.setTimeout(nextQuery, 120); }
    else if (launched < queries.length) { window.setTimeout(nextQuery, 220); }
    else { maybeFinish(); }
  }
  nextQuery();
}
function findDriveableAdventure(query) {
  var q = clean(query);
  var token;
  var destCenter;
  if (!q || q.length < 2) { toast("Choose an adventure first"); return; }




  activeScanQuery = q;
  activeScanStartedAt = Date.now();
  adventureScanRadiusOverride = 0;
  adventureScanFallbackPass = 0;
  try { syncAdventureMapDock(); } catch (dockSyncErr) {}
  if (adventureAutoCollapseTimer) { window.clearTimeout(adventureAutoCollapseTimer); adventureAutoCollapseTimer = null; }
  if (scanMapFitTimer) { window.clearTimeout(scanMapFitTimer); scanMapFitTimer = null; }
  exitScanResultsMode();
  stopScanTab();
  diqV231ApplyScanReliabilityUi("Checking direct matches first", "gold");
  if (!GEOAPIFY_KEY) { setStatus("adventureRouteStatus", "SEARCH UNAVAILABLE", "red"); toast("Search unavailable"); return; }
  activeLens = q.toLowerCase();
  lsSet(LS.ADVENTURE_LENS, activeLens);




  destCenter = getDestinationScanCenter(q);
  destinationPreviewScan = !!destCenter;
  if (mapAreaScanActive && adventureSearchCenter && finite(Number(adventureSearchCenter.lat)) && finite(Number(adventureSearchCenter.lng))) {
    destinationPreviewScan = false;
    adventureSearchScope = "map_area";
  } else {
    adventureSearchCenter = destCenter || (lastFix ? { lat:Number(lastFix.lat), lng:Number(lastFix.lng), label:"you" } : null);
    adventureSearchScope = destCenter ? "near_destination" : "near_me";
  }




  if (!lastFix && !destCenter) {
    waitingForGpsQuery = q;
    setStatus("adventureRouteStatus", "WAITING FOR GPS", "gold");
    toast("Locking GPS first");
    requestGPS(true);
    return;
  }




  routeAttemptToken += 1;
  token = routeAttemptToken;




  if (destinationPreviewScan) {
    closeAdventureInfoCard();
    hideDestinationResults();
    adventureResults = [];
    adventurePreferred = null;
    try { if (map && mapLoaded && map.getSource("adventure-results")) { map.getSource("adventure-results").setData(emptyFC()); } } catch (e0) {}
    setStatus("adventureRouteStatus", "SCANNING DESTINATION", "gold");
    startScanTab(scanTabTitleForQuery(q), scanTabSubForQuery(q));
    speakAdventureScanStart(q);
    toast("Scanning near " + String(destCenter.label || "destination"));
  } else {
    if (adventureScanOnly || categoryFromQuery(q)) {
      /*
        V13: quick category chips should not wipe an existing route.
        They are discovery scans until the user chooses a place.
      */
      closeAdventureInfoCard();
      hideDestinationResults();
      adventureResults = [];
      adventurePreferred = null;
      try { if (map && mapLoaded && map.getSource("adventure-results")) { map.getSource("adventure-results").setData(emptyFC()); } } catch (e1) {}
    } else {
      resetAdventureRoute();
    }
    setStatus("adventureRouteStatus", "SCANNING OPTIONS", "gold");
    startScanTab(scanTabTitleForQuery(q), scanTabSubForQuery(q));
    speakAdventureScanStart(q);
    toast("Finding nearby " + titleCaseWords(categoryFromQuery(q) || "adventure") + " options");
  }




  searchRouteCandidates(q, token, q, false);
}
function acceptFix(pos, center) {
  var c = pos && pos.coords ? pos.coords : {};
  var lat = Number(c.latitude);
  var lng = Number(c.longitude);
  var resumeQuery;
  var destinationBrowseLocked;




  if (!finite(lat) || !finite(lng)) { return; }




  lastFix = {
    lat: lat,
    lng: lng,
    acc: Number(c.accuracy || 0),
    speed: Number(c.speed || 0),
    ts: Date.now()
  };




  lsJSON(LS.LAST_FIX, lastFix);
  setYou(lng, lat);
  setStatus("adventureGpsStatus", "GPS LOCKED", "green");




  destinationBrowseLocked = !!(
    adventureDestinationCameraHold ||
    adventureSearchScope === "near_destination" ||
    adventureSearchScope === "map_area" ||
    destinationPreviewScan ||
    (adventureResults && adventureResults.length)
  );




  /*
    V25.4: GPS still updates the user marker. Background watch fixes cannot
    refit a destination discovery map around both user and destination.
    An explicit recenter request still works.
  */
  if (center) {
    adventureDestinationCameraHold = false;
    flyTo(lng, lat, 14.8);
    toast("Location centered");
  } else if (canAutoCamera() && !destinationBrowseLocked) {
    if (routeGeo && destination) { fitRoute(); }
    else if (destination) { fitPoints(); }
  }




  resumeQuery = waitingForGpsQuery;
  waitingForGpsQuery = "";
  if (resumeQuery) { scanAdventureChoices(resumeQuery); }
}




function requestGPS(center) {
  if (!navigator || !navigator.geolocation) { setStatus("adventureGpsStatus", "GPS UNAVAILABLE", "red"); toast("GPS unavailable"); return; }
  setStatus("adventureGpsStatus", "GPS LOCATING", "gold");
  try {
    navigator.geolocation.getCurrentPosition(function (pos) { acceptFix(pos, !!center); }, function () { setStatus("adventureGpsStatus", "ENABLE GPS", "red"); toast("Location permission needed"); }, { enableHighAccuracy: true, timeout: 18000, maximumAge: 0 });
    if (!gpsWatchId) { gpsWatchId = navigator.geolocation.watchPosition(function (pos) { acceptFix(pos, false); }, function () {}, { enableHighAccuracy: true, timeout: 22000, maximumAge: 5000 }); }
  } catch (e) { setStatus("adventureGpsStatus", "GPS ERROR", "red"); toast("GPS error"); }
}




function restoreGPS() {
  var saved = safeParse(lsGet(LS.LAST_FIX));
  if (saved && finite(Number(saved.lat)) && finite(Number(saved.lng))) {
    lastFix = { lat: Number(saved.lat), lng: Number(saved.lng), acc: Number(saved.acc || 0), speed: Number(saved.speed || 0), ts: Number(saved.ts || 0) };
    setYou(lastFix.lng, lastFix.lat);
    setStatus("adventureGpsStatus", "GPS SAVED", "green");
  }
  requestGPS(!lastFix);
}








/* =========================================================
   DRIVE IQ V95 â€” SEO INTENT HANDOFF AUTHORITY
   Reads destination/category/search/source/autostart from SEO landing pages,
   locks the requested destination, preserves the exact search intent, and
   scans around that destination instead of falling back to the user's GPS.
========================================================= */




var diqSeoIntentHandoff = null;
var diqSeoIntentApplied = false;




function diqReadSeoIntentHandoff() {
  var params;
  var destinationText;
  var categoryText;
  var searchText;
  var sourceText;
  var autostartText;




  try {
    params = new URLSearchParams(String(window.location.search || ""));
  } catch (e0) {
    return null;
  }




  destinationText = clean(params.get("destination") || "");
  categoryText = clean(params.get("category") || "");
  searchText = clean(params.get("search") || "");
  sourceText = clean(params.get("source") || "");
  autostartText = normText(params.get("autostart") || "");




  if (!destinationText && !searchText && !categoryText) { return null; }




  return {
    destination: destinationText,
    category: categoryText,
    search: searchText,
    source: sourceText,
    lat: Number(params.get("lat") || params.get("latitude") || params.get("destLat") || params.get("destinationLat") || params.get("destination_lat") || params.get("arrivalLat") || params.get("arrival_lat") || 0),
    lng: Number(params.get("lng") || params.get("lon") || params.get("longitude") || params.get("destLng") || params.get("destLon") || params.get("destinationLng") || params.get("destinationLon") || params.get("destination_lng") || params.get("arrivalLng") || params.get("arrivalLon") || params.get("arrival_lng") || 0),
    placeId: clean(params.get("placeId") || params.get("place_id") || params.get("googlePlaceId") || params.get("google_place_id") || ""),
    address: clean(params.get("address") || params.get("full") || ""),
    autostart: autostartText === "1" || autostartText === "true" || autostartText === "yes"
  };
}




function diqSeoCategoryQuery(category, search) {
  var key = normText(category).replace(/\s+/g, "_");
  var q = clean(search);




  if (q) { return q; }
  if (key === "scenic") { return "scenic places natural springs wildlife waterways rare landscapes"; }
  if (key === "water" || key === "water_access" || key === "beach_access") { return "public beach access water access swimming parking"; }
  if (key === "springs" || key === "natural_springs") { return "natural springs crystal clear water swimming paddling"; }
  if (key === "food" || key === "food_iq") { return "local restaurants worth the drive"; }
  if (key === "seafood") { return "local seafood restaurants"; }
  if (key === "coffee" || key === "coffee_iq") { return "local coffee shops cafes"; }
  if (key === "hidden_gems") { return "hidden gems unique local places"; }
  if (key === "nightlife") { return "nightlife live music patios local bars"; }
  if (key === "family") { return "family friendly attractions parks activities"; }
  return clean(category || "local favorites");
}








function diqV96SavedDestinationMatches(label, saved) {
  var q = normText(label || "");
  var a = normText(saved && saved.label || "");
  var b = normText(saved && saved.full || "");
  if (!q || !saved) { return false; }
  if (a === q || b === q) { return true; }
  if (a && q.indexOf(a) === 0 && a.length >= 4) { return true; }
  if (a && a.indexOf(q) === 0 && q.length >= 4) { return true; }
  if (b && b.indexOf(q) > -1 && q.length >= 4) { return true; }
  return false;
}




function diqV96CoordinateHandoffItem(handoff) {
  var lat;
  var lng;
  var saved;
  var savedFix;
  var sourceText;
  var label;




  if (!handoff) { return null; }




  label = clean(handoff.destination || handoff.search || "Arrival");
  lat = Number(handoff.lat || 0);
  lng = Number(handoff.lng || 0);




  if (finite(lat) && finite(lng) && Math.abs(lat) <= 90 && Math.abs(lng) <= 180 && (Math.abs(lat) > 0.0001 || Math.abs(lng) > 0.0001)) {
    return {
      label: label || "Arrival",
      full: clean(handoff.address || handoff.destination || ""),
      lat: lat,
      lng: lng,
      kind: "arrival",
      canonical: true,
      resultType: "arrival_coordinate_handoff",
      placeId: clean(handoff.placeId || "")
    };
  }




  saved = safeParse(lsGet(LS.DEST));
  if (
    saved &&
    finite(Number(saved.lat)) &&
    finite(Number(saved.lng)) &&
    diqV96SavedDestinationMatches(label, saved)
  ) {
    return {
      label: String(saved.label || label || "Arrival"),
      full: String(saved.full || handoff.address || ""),
      lat: Number(saved.lat),
      lng: Number(saved.lng),
      kind: String(saved.kind || "arrival"),
      canonical: true,
      resultType: "arrival_saved_destination",
      placeId: clean(saved.placeId || saved.googlePlaceId || handoff.placeId || "")
    };
  }




  sourceText = normText(String(handoff.source || "") + " " + String(handoff.category || "") + " " + String(handoff.search || ""));
  if (
    sourceText.indexOf("arrival") > -1 ||
    sourceText.indexOf("drive") > -1 ||
    sourceText.indexOf("since you") > -1 ||
    sourceText.indexOf("scan around") > -1
  ) {
    savedFix = safeParse(lsGet(LS.LAST_FIX));
    if (savedFix && finite(Number(savedFix.lat)) && finite(Number(savedFix.lng))) {
      return {
        label: label || "Arrival",
        full: clean(handoff.address || handoff.destination || "Using your arrival point"),
        lat: Number(savedFix.lat),
        lng: Number(savedFix.lng),
        kind: "arrival",
        canonical: true,
        resultType: "arrival_last_fix_handoff",
        placeId: clean(handoff.placeId || "")
      };
    }
  }




  return null;
}




function diqSeoDestinationItem(destinationText) {
  var indexed;
  var q = clean(destinationText);




  if (!q) { return null; }




  indexed = adventureDestinationIndexMatch(q);
  if (indexed) { return indexedAdventureItem(indexed); }




  /* Stable Destin fallback for the Destin SEO cluster. */
  if (normText(q).indexOf("destin") > -1) {
    return {
      label:"Destin",
      full:"Destin, Florida",
      lat:30.3935,
      lng:-86.4958,
      kind:"city",
      canonical:true,
      resultType:"seo_destination"
    };
  }




  return null;
}




function diqApplySeoIntentHandoff() {
  var handoff = diqSeoIntentHandoff || diqReadSeoIntentHandoff();
  var item;
  var input;
  var scanQuery;




  if (!handoff || diqSeoIntentApplied) { return false; }




  item = diqV96CoordinateHandoffItem(handoff) || diqSeoDestinationItem(handoff.destination);
  if (!item || !finite(Number(item.lat)) || !finite(Number(item.lng))) { return false; }




  diqSeoIntentApplied = true;
  diqSeoIntentHandoff = handoff;
  scanQuery = diqSeoCategoryQuery(handoff.category, handoff.search);
  input = byId("adventureSearch");




  /* URL intent outranks stale saved state. */
  destination = {
    label:String(item.label || handoff.destination || "Destination"),
    full:String(item.full || handoff.destination || ""),
    lat:Number(item.lat),
    lng:Number(item.lng),
    kind:String(item.kind || "destination")
  };




  routeGeo = null;
  destinationSearchResults = [];
  hideDestinationResults();
  clearRouteLine();




  activeLens = clean(scanQuery || handoff.category || "local favorites").toLowerCase();
  activeScanQuery = activeLens;
  lsSet(LS.ADVENTURE_LENS, activeLens);




  setDestinationLock(destination, "seo_intent_handoff");
  lsJSON(LS.DEST, destination);
  lsRemove(LS.ROUTE_GEO);
  lsRemove(LS.ROUTE_INTEL);
  lsRemove(LS.DRIVE_PAYLOAD);




  adventureSearchCenter = {
    lat:Number(destination.lat),
    lng:Number(destination.lng),
    label:String(destination.label || handoff.destination || "destination")
  };
  adventureSearchScope = "near_destination";
  destinationPreviewScan = true;
  adventureScanOnly = true;
  adventureDestinationCameraHold = true;
  adventureDestinationCameraHoldAt = Date.now();




  if (input) { input.value = String(handoff.search || scanQuery || destination.label); }




  setDestinationPin();
  syncAdventureDestinationScopeUI();
  updateClearAdventureSearchButton();
  setStartReady(false);
  setStatus("adventureRouteStatus", "SEO DESTINATION READY", "green");




  try {
    lsJSON("diq_adventure_seo_intent_v1", {
      destination:handoff.destination,
      category:handoff.category,
      search:handoff.search,
      source:handoff.source,
      autostart:handoff.autostart,
      ts:Date.now()
    });
  } catch (e1) {}




  if (mapLoaded && map) {
    try { flyTo(destination.lng, destination.lat, 13.8); } catch (e2) {}
  }




  toast("Exploring " + String(destination.label || handoff.destination));




  if (handoff.autostart) {
    window.setTimeout(function () {
      scanAdventureChoices(scanQuery);
    }, 320);
  }




  return true;
}




diqSeoIntentHandoff = diqReadSeoIntentHandoff();








function restoreState() {
  var savedDestination = safeParse(lsGet(LS.DEST));
  var savedRoute = safeParse(lsGet(LS.ROUTE_GEO));
  var savedIntel = safeParse(lsGet(LS.ROUTE_INTEL));
  var input = byId("adventureSearch");




  if (savedIntel && String(savedIntel.mode || "") === "adventure") {
    activeLens = clean(savedIntel.lens || activeLens).toLowerCase();
  } else {
    routeGeo = null;
    lsRemove(LS.ROUTE_GEO);
    lsRemove(LS.ROUTE_INTEL);
    lsRemove(LS.DRIVE_PAYLOAD);
    setStatus("adventureRouteStatus", "READY TO EXPLORE", "");
  }




  if (savedDestination && finite(Number(savedDestination.lat)) && finite(Number(savedDestination.lng))) {
    destination = savedDestination;
    setDestinationLock(destination, "restore_state");
    if (input) { input.value = String(destination.label || activeLens || "Destination"); }
    adventureSearchCenter = {
      lat:Number(destination.lat),
      lng:Number(destination.lng),
      label:String(destination.label || "destination")
    };
    adventureSearchScope = "near_destination";
    hideDestinationResults();
    setDestinationPin();
    syncAdventureDestinationScopeUI();
    updateClearAdventureSearchButton();
    setStatus("adventureRouteStatus", "DESTINATION READY", "green");
  }




  if (savedIntel && String(savedIntel.mode || "") === "adventure" && savedRoute && savedRoute.features && savedRoute.features.length && destination) {
    routeGeo = savedRoute;
    drawRoute(routeGeo);
    setStartReady(true);
    setStatus("adventureRouteStatus", "ROUTE READY", "green");
  } else {
    setStartReady(false);
  }
}




function centerAdventureMap() {
  if (fitRoute()) { toast("Adventure route centered"); return; }
  if (fitPoints()) { toast("Route points centered"); return; }
  if (destination && finite(Number(destination.lng)) && finite(Number(destination.lat))) { flyTo(destination.lng, destination.lat, 14.8); toast("Adventure centered"); return; }
  if (lastFix && finite(Number(lastFix.lng)) && finite(Number(lastFix.lat))) { flyTo(lastFix.lng, lastFix.lat, 14.8); toast("Location centered"); return; }
  requestGPS(true);
}




function buildRoute() {
  var q;
  if (!destination) {
    q = byId("adventureSearch") ? clean(byId("adventureSearch").value) : "";
    if (q) { searchDestinations(q); return; }
    setStatus("adventureRouteStatus", "CHOOSE PLACE", "gold");
    toast("Choose an adventure first");
    return;
  }
  findDriveableAdventure(destination.label || activeLens);
}




function startAdventure() {
  var q;

  /*
    DRIVE IQ V536 â€” ADVENTURE NAVIGATION AUTHORITY

    Adventure is discovery-only. Opening Adventure or tapping its primary
    action may start a fresh scan, but it may never resume or open Drive Mode
    because old route geometry, destination, payload, active-drive ID, or
    DRIVE_ON state happens to exist.

    Only an explicit Route Here tap may leave Adventure, and that handoff is
    owned by DriveIQAdventureRoute.startRouteTo().
  */

  q = activeLens && activeLens.length > 2
    ? activeLens
    : "popular tonight local favorites";

  adventureScanOnly = true;

  if (
    destination &&
    finite(Number(destination.lat)) &&
    finite(Number(destination.lng))
  ) {
    adventureSearchCenter = {
      lat:Number(destination.lat),
      lng:Number(destination.lng),
      label:String(destination.label || "destination")
    };
    adventureSearchScope = "near_destination";
    destinationPreviewScan = true;
    toast("Scanning around " + String(destination.label || "destination"));
  } else if (
    lastFix &&
    finite(Number(lastFix.lat)) &&
    finite(Number(lastFix.lng))
  ) {
    adventureSearchCenter = {
      lat:Number(lastFix.lat),
      lng:Number(lastFix.lng),
      label:"you"
    };
    adventureSearchScope = "near_me";
    destinationPreviewScan = false;
    toast("Scanning around you");
  } else {
    waitingForGpsQuery = q;
    requestGPS(true);
    toast("Locking GPS first");
    return;
  }

  scanAdventureChoices(q);
}




function setActiveChip(chip) {
  var chips = document.querySelectorAll(".chip");
  var strip = byId("adventureChips");
  var i;
  var left;
  for (i = 0; i < chips.length; i++) { chips[i].className = "chip"; }
  if (!chip) { return; }
  chip.className = "chip on";
  if (strip) {
    left = Math.max(0, chip.offsetLeft - 8);
    try { strip.scrollTo({ left: left, behavior: "smooth" }); } catch (e) { strip.scrollLeft = left; }
  }
}
function setLens(text) {
  var q = clean(text);
  activeLens = q.toLowerCase();
  lsSet(LS.ADVENTURE_LENS, activeLens);




  /*
    V13: category chips are scans, not destinations.
    Do not overwrite the typed destination field and do not auto-route.
  */
  hideDestinationResults();
  scanAdventureChoices(q);
}








/* =========================================================
   DRIVE IQ V25.9 â€” MY ADVENTURE / PERSONALIZATION IQ
   JS-owned only. No HTML edits required.
   Uses theme-renderer.js when available, but safely falls back to localStorage.
========================================================= */




var DIQ_PERSONALIZED_CATEGORY_DEFS = [
  { id:"popular", label:"ðŸ”¥ POPULAR", query:"popular tonight local favorites" },
  { id:"food", label:"ðŸ” FOOD IQ", query:"must try local food viral food spots bbq burgers tacos dessert coffee bakery local restaurants" },
  { id:"local_favorites", label:"ðŸ† LOCAL FAVES", query:"local favorites restaurants bars attractions beloved local staples best of town" },
  { id:"coffee", label:"â˜• COFFEE", query:"coffee cafe bakery local" },
  { id:"bbq", label:"ðŸ– BBQ", query:"bbq barbecue smokehouse local ribs brisket pulled pork" },
  { id:"golf", label:"ðŸŒï¸ GOLF", query:"golf course driving range country club public golf" },
  { id:"scenic", label:"ðŸŒ… SCENIC", query:"scenic overlook sunset view waterfront park" },
  { id:"live_music", label:"ðŸŽ¶ LIVE MUSIC", query:"live music tonight bar restaurant venue" },
  { id:"hidden_gems", label:"ðŸ’Ž HIDDEN GEMS", query:"hidden gems unique local places" },
  { id:"waterfront", label:"ðŸŒŠ WATER", query:"waterfront restaurant patio waterfall river lake" },
  { id:"outdoors", label:"ðŸ¥¾ OUTDOORS", query:"scenic overlook hiking trail park cave cavern waterfall natural area rock formation river kayaking swimming hole campground" },
  { id:"lake_iq", label:"ðŸš¤ LAKE IQ", query:"lake marina boat ramp waterfront restaurant fishing campground cabin sunset" },
  { id:"shopping", label:"ðŸ› SHOPPING", query:"boutiques local shops shopping district antique market bookstore gift shop" },
  { id:"family", label:"ðŸ‘¨â€ðŸ‘©â€ðŸ‘§ FAMILY", query:"family friendly park museum ice cream attraction playground" },
  { id:"dog_friendly", label:"ðŸ¶ DOG IQ", query:"dog friendly patio park trail pet friendly" },
  { id:"nightlife", label:"ðŸ¹ NIGHTLIFE", query:"patio bar restaurant outdoor seating cocktail bar late night nightlife" },
  { id:"gameday", label:"ðŸˆ GAMEDAY", query:"sports bar watch game tonight" }
];




function diqV259CategoryById(id) {
  var key = normText(id).replace(/\s+/g, "_");
  var i;
  if (key === "trending") { key = "popular"; }
  if (key === "food_iq" || key === "food_drinks") { key = "food"; }
  if (key === "patios" || key === "patio") { key = "nightlife"; }
  if (key === "dog_iq") { key = "dog_friendly"; }
  if (key === "family_iq") { key = "family"; }
  if (key === "sunset_iq") { key = "scenic"; }
  for (i = 0; i < DIQ_PERSONALIZED_CATEGORY_DEFS.length; i++) {
    if (DIQ_PERSONALIZED_CATEGORY_DEFS[i].id === key) { return DIQ_PERSONALIZED_CATEGORY_DEFS[i]; }
  }
  return null;
}




function diqV259DefaultPinnedCategories() {
  return ["food","local_favorites","coffee","scenic","live_music","hidden_gems","waterfront","outdoors"];
}




function diqV259GetPinnedCategories() {
  var items = null;
  try {
    if (window.DriveIQ && window.DriveIQ.getPinnedCategories) {
      items = window.DriveIQ.getPinnedCategories();
    } else if (window.DriveIQ && window.DriveIQ.Personalization && window.DriveIQ.Personalization.getPinnedCategories) {
      items = window.DriveIQ.Personalization.getPinnedCategories();
    }
  } catch (e0) {}




  if (!items || !items.length) {
    try { items = safeParse(localStorage.getItem("diq_pinned_categories_v1")); } catch (e1) {}
  }
  if (!items || !items.length) { items = diqV259DefaultPinnedCategories(); }




  return items;
}




function diqV259SetPinnedCategories(items) {
  var out = [];
  var i;
  var id;
  for (i = 0; i < (items || []).length; i++) {
    id = normText(items[i]).replace(/\s+/g, "_");
    if (diqV259CategoryById(id) && out.indexOf(id) < 0) { out.push(id); }
  }
  if (!out.length) { out = diqV259DefaultPinnedCategories(); }
  if (out.length > 10) { out = out.slice(0, 10); }




  try {
    if (window.DriveIQ && window.DriveIQ.Personalization && window.DriveIQ.Personalization.setPinnedCategories) {
      window.DriveIQ.Personalization.setPinnedCategories(out);
    } else if (window.DriveIQ && window.DriveIQ.setPinnedCategories) {
      window.DriveIQ.setPinnedCategories(out);
    }
  } catch (e0) {}




  try { localStorage.setItem("diq_pinned_categories_v1", JSON.stringify(out)); } catch (e1) {}
  return out;
}




function diqV259UpdateTaste(categoryId, amount) {
  var id = normText(categoryId).replace(/\s+/g, "_");
  var amt = Number(amount || 1);
  if (!id) { return; }




  try {
    if (window.DriveIQ && window.DriveIQ.updateTaste) {
      window.DriveIQ.updateTaste(id, amt);
      return;
    }
    if (window.DriveIQ && window.DriveIQ.Personalization && window.DriveIQ.Personalization.updateTaste) {
      window.DriveIQ.Personalization.updateTaste(id, amt);
      return;
    }
  } catch (e0) {}




  try {
    var raw = safeParse(localStorage.getItem("diq_adventure_taste_v1")) || {};
    raw[id] = Number(raw[id] || 0) + amt;
    if (raw[id] > 100) { raw[id] = 100; }
    if (raw[id] < -25) { raw[id] = -25; }
    localStorage.setItem("diq_adventure_taste_v1", JSON.stringify(raw));
  } catch (e1) {}
}




function diqV259RankWithTaste(items) {
  try {
    if (window.DriveIQ && window.DriveIQ.rankWithTaste) {
      return window.DriveIQ.rankWithTaste(items || []);
    }
    if (window.DriveIQ && window.DriveIQ.Personalization && window.DriveIQ.Personalization.rankWithTaste) {
      return window.DriveIQ.Personalization.rankWithTaste(items || []);
    }
  } catch (e0) {}
  return items || [];
}




function diqV259EnsurePersonalizationStyles() {
  var css;
  var style;
  if (byId("diqAdventurePersonalizationV259Style")) { return; }




  css =
    ".diqMyAdventureHead{display:flex;align-items:center;justify-content:space-between;gap:8px;margin-top:9px;margin-bottom:5px;}" +
    ".diqMyAdventureTitle{color:#ffe5a6;font-size:8.5px;line-height:1;font-weight:1000;letter-spacing:.95px;text-transform:uppercase;white-space:nowrap;}" +
    ".diqMyAdventureCustomize{flex:0 0 auto;min-height:24px;padding:0 9px;border-radius:999px;color:#061018!important;background:linear-gradient(135deg,var(--gold),var(--green));border:1px solid rgba(255,255,255,.34);font-size:7.5px;font-weight:1000;letter-spacing:.55px;text-transform:uppercase;}" +
    ".chip.diqCustomizeChip{color:#061018!important;background:linear-gradient(135deg,#fff2a8,var(--gold),var(--green))!important;border-color:rgba(255,255,255,.46)!important;}" +
    "#diqAdventureCustomizeSheet{position:fixed;left:12px;right:12px;bottom:calc(12px + env(safe-area-inset-bottom,0px));z-index:130;display:none;max-height:58vh;overflow:auto;-webkit-overflow-scrolling:touch;border-radius:24px;padding:14px;background:rgba(5,12,22,.97);border:1px solid rgba(255,206,105,.26);box-shadow:0 24px 64px rgba(0,0,0,.56),0 0 32px rgba(255,206,105,.10);color:#fff;font-family:system-ui,-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;}" +
    "#diqAdventureCustomizeSheet.on{display:block;}" +
    ".diqCustomizeTop{display:flex;align-items:flex-start;justify-content:space-between;gap:12px;margin-bottom:12px;}" +
    ".diqCustomizeKicker{color:#b6ffeb;font-size:8px;font-weight:1000;letter-spacing:1px;text-transform:uppercase;}" +
    ".diqCustomizeTitle{margin-top:4px;color:#fff;font-size:18px;line-height:1.05;font-weight:1000;letter-spacing:-.3px;}" +
    ".diqCustomizeSub{margin-top:5px;color:rgba(255,255,255,.68);font-size:11px;line-height:1.25;font-weight:800;}" +
    ".diqCustomizeClose{width:38px;height:38px;border-radius:15px;background:rgba(255,255,255,.08);border:1px solid rgba(255,255,255,.14);color:#fff;font-size:20px;font-weight:1000;}" +
    ".diqCustomizeGrid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:8px;}" +
    ".diqCustomizeItem{min-height:42px;border-radius:16px;padding:0 10px;text-align:left;color:rgba(255,255,255,.86);background:rgba(255,255,255,.06);border:1px solid rgba(255,255,255,.12);font-size:10px;font-weight:1000;letter-spacing:.25px;}" +
    ".diqCustomizeItem.on{color:#061018;background:linear-gradient(135deg,#fff2a8,var(--gold),var(--green));border-color:rgba(255,255,255,.42);}" +
    ".diqCustomizeActions{display:grid;grid-template-columns:1fr 1fr;gap:9px;margin-top:12px;}" +
    ".diqCustomizeAction{min-height:42px;border-radius:16px;font-size:10px;font-weight:1000;letter-spacing:.55px;text-transform:uppercase;}" +
    ".diqCustomizeSave{color:#061018;background:linear-gradient(135deg,var(--gold),var(--green));border:1px solid rgba(255,255,255,.34);}" +
    ".diqCustomizeReset{color:#fff;background:rgba(255,255,255,.07);border:1px solid rgba(255,255,255,.14);}" +
    "@media(max-width:420px){.diqCustomizeGrid{grid-template-columns:1fr 1fr;gap:7px}.diqCustomizeItem{min-height:39px;font-size:9px}.diqCustomizeTitle{font-size:16px}}" +
    "@media(orientation:landscape){#diqAdventureCustomizeSheet{left:auto;right:12px;width:min(420px,46vw);max-height:calc(100vh - 24px)}}";




  style = document.createElement("style");
  style.id = "diqAdventurePersonalizationV259Style";
  style.type = "text/css";
  try { style.appendChild(document.createTextNode(css)); } catch (e1) { style.styleSheet.cssText = css; }
  try { document.head.appendChild(style); } catch (e2) {}
}




function diqV259EnsureCustomizeSheet() {
  var sheet = byId("diqAdventureCustomizeSheet");
  var i;
  var def;
  var btn;
  var grid;
  var current = diqV259GetPinnedCategories();




  diqV259EnsurePersonalizationStyles();




  if (!sheet) {
    sheet = document.createElement("div");
    sheet.id = "diqAdventureCustomizeSheet";
    sheet.innerHTML =
      '<div class="diqCustomizeTop">' +
        '<div><div class="diqCustomizeKicker">My Adventure</div><div class="diqCustomizeTitle">Customize your scan bar</div><div class="diqCustomizeSub">Pick the categories you use most. Drive IQ will remember this Adventure setup.</div></div>' +
        '<button class="diqCustomizeClose" id="diqAdventureCustomizeClose" type="button" aria-label="Close">Ã—</button>' +
      '</div>' +
      '<div class="diqCustomizeGrid" id="diqAdventureCustomizeGrid"></div>' +
      '<div class="diqCustomizeActions">' +
        '<button class="diqCustomizeAction diqCustomizeReset" id="diqAdventureCustomizeReset" type="button">Reset</button>' +
        '<button class="diqCustomizeAction diqCustomizeSave" id="diqAdventureCustomizeSave" type="button">Save Bar</button>' +
      '</div>';
    try { document.body.appendChild(sheet); } catch (e0) {}
  }




  grid = byId("diqAdventureCustomizeGrid");
  if (grid) {
    grid.innerHTML = "";
    for (i = 0; i < DIQ_PERSONALIZED_CATEGORY_DEFS.length; i++) {
      def = DIQ_PERSONALIZED_CATEGORY_DEFS[i];
      btn = document.createElement("button");
      btn.type = "button";
      btn.className = current.indexOf(def.id) > -1 ? "diqCustomizeItem on" : "diqCustomizeItem";
      btn.setAttribute("data-diq-category-id", def.id);
      btn.textContent = def.label;
      btn.onclick = function () {
        var cls = String(this.className || "");
        if (cls.indexOf(" on") > -1) { this.className = "diqCustomizeItem"; }
        else { this.className = "diqCustomizeItem on"; }
      };
      try { grid.appendChild(btn); } catch (e1) {}
    }
  }




  var close = byId("diqAdventureCustomizeClose");
  var reset = byId("diqAdventureCustomizeReset");
  var save = byId("diqAdventureCustomizeSave");




  if (close) { close.onclick = function () { sheet.className = ""; }; }
  if (reset) {
    reset.onclick = function () {
      diqV259SetPinnedCategories(diqV259DefaultPinnedCategories());
      ensureAdventureCategoryChips();
      bindChips();
      sheet.className = "";
      toast("My Adventure bar reset");
    };
  }
  if (save) {
    save.onclick = function () {
      var selected = [];
      var buttons = grid ? grid.querySelectorAll(".diqCustomizeItem") : [];
      var j;
      var id;
      for (j = 0; j < buttons.length; j++) {
        if (String(buttons[j].className || "").indexOf(" on") > -1) {
          id = buttons[j].getAttribute("data-diq-category-id");
          if (id) { selected.push(id); }
        }
      }
      diqV259SetPinnedCategories(selected);
      ensureAdventureCategoryChips();
      bindChips();
      sheet.className = "";
      toast("My Adventure bar saved");
    };
  }




  return sheet;
}




function diqV259OpenCustomizeSheet() {
  var sheet = diqV259EnsureCustomizeSheet();
  if (sheet) { sheet.className = "on"; }
}




function ensureAdventureCategoryChips() {
  var strip = byId("adventureChips");
  var pinned = diqV259GetPinnedCategories();
  var defs = [];
  var i;
  var def;
  var btn;
  var head;
  var title;
  var customBtn;
  var parent;




  if (!strip) { return; }




  diqV259EnsurePersonalizationStyles();




  for (i = 0; i < pinned.length; i++) {
    def = diqV259CategoryById(pinned[i]);
    if (def) { defs.push(def); }
  }
  if (!defs.length) {
    pinned = diqV259DefaultPinnedCategories();
    for (i = 0; i < pinned.length; i++) {
      def = diqV259CategoryById(pinned[i]);
      if (def) { defs.push(def); }
    }
  }




  try {
    parent = strip.parentNode;
    if (parent && !byId("diqMyAdventureHead")) {
      head = document.createElement("div");
      head.id = "diqMyAdventureHead";
      head.className = "diqMyAdventureHead";
      title = document.createElement("div");
      title.className = "diqMyAdventureTitle";
      title.textContent = "My Adventure";
      customBtn = document.createElement("button");
      customBtn.id = "diqMyAdventureCustomize";
      customBtn.className = "diqMyAdventureCustomize";
      customBtn.type = "button";
      customBtn.textContent = "Customize";
      customBtn.onclick = diqV259OpenCustomizeSheet;
      head.appendChild(title);
      head.appendChild(customBtn);
      parent.insertBefore(head, strip);
    }
  } catch (headErr) {}




  try { strip.innerHTML = ""; } catch (e0) {}




  for (i = 0; i < defs.length; i++) {
    btn = document.createElement("button");
    btn.type = "button";
    btn.className = i === 0 ? "chip on" : "chip";
    btn.setAttribute("data-query", defs[i].query);
    btn.setAttribute("data-diq-category-id", defs[i].id);
    btn.textContent = defs[i].label;
    try { strip.appendChild(btn); } catch (e1) {}
  }




  btn = document.createElement("button");
  btn.type = "button";
  btn.className = "chip diqCustomizeChip";
  btn.setAttribute("data-diq-customize", "1");
  btn.textContent = "âš™ï¸ CUSTOMIZE";
  try { strip.appendChild(btn); } catch (e2) {}
}




function bindChips() {
  var chips = document.querySelectorAll(".chip");
  var i;
  for (i = 0; i < chips.length; i++) {
    chips[i].onclick = function () {
      var txt;
      var cat;
      if (this.getAttribute("data-diq-customize") === "1") {
        diqV259OpenCustomizeSheet();
        return;
      }
      txt = clean(this.getAttribute("data-query") || this.textContent || "");
      cat = clean(this.getAttribute("data-diq-category-id") || "");
      setActiveChip(this);
      diqV259UpdateTaste(cat || txt, 1);
      setLens(txt);
    };
  }
}








function userHasPlusEntitlement() {
  var keys = [
    "diq_plus_active_v1",
    "diq_subscription_active_v1",
    "diq_iap_active_v1",
    "diq_entitled_v1",
    "diq_drive_iq_plus_active",
    "diq_dev_pro_unlocked_v1",
    "diq_founding_driver_free_v1"
  ];
  var i;
  var v;
  for (i = 0; i < keys.length; i++) {
    v = String(lsGet(keys[i]) || "").toLowerCase();
    if (v === "1" || v === "true" || v === "yes" || v === "active") { return true; }
  }
  try {
    if (window.DRIVE_IQ_PLUS_ACTIVE === true || window.DRIVE_IQ_IAP_ACTIVE === true || window.DRIVE_IQ_ENTITLED === true) { return true; }
  } catch (e) {}
  return false;
}




function normalizeProductId(productId) {
  var raw = String(productId || "").toLowerCase();
  if (raw.indexOf("year") > -1 || raw.indexOf("annual") > -1) { return "com.loveforlocals.driveiq.plus.yearly"; }
  return "com.loveforlocals.driveiq.plus.monthly";
}




function applePurchasePayload(productId, source) {
  var pid = normalizeProductId(productId);
  return {
    type: "DRIVE_IQ_PURCHASE",
    action: "purchase",
    command: "purchase",
    source: String(source || "adventure_mode"),
    product_id: pid,
    productId: pid,
    sku: pid,
    id: pid,
    mode: "adventure",
    ts: new Date().toISOString()
  };
}




function postToNativeHandler(name, payload) {
  try {
    if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers[name] && window.webkit.messageHandlers[name].postMessage) {
      window.webkit.messageHandlers[name].postMessage(payload);
      return true;
    }
  } catch (e) {}
  return false;
}




function fireApplePurchaseSheet(productId, source) {
  var payload = applePurchasePayload(productId, source);
  var fired = false;
  var handlers = [
    "driveIQPurchase",
    "driveIQIAP",
    "driveIQStoreKit",
    "storeKit",
    "purchase",
    "iap",
    "nativePurchase",
    "subscriptions",
    "driveIQPlus"
  ];
  var i;




  lsJSON(LS.UPGRADE_INTENT, payload);
  try { window.DRIVE_IQ_LAST_PURCHASE_INTENT = payload; } catch (e0) {}




  for (i = 0; i < handlers.length; i++) {
    if (postToNativeHandler(handlers[i], payload)) { fired = true; }
  }




  try {
    if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.slx && window.webkit.messageHandlers.slx.postMessage) {
      window.webkit.messageHandlers.slx.postMessage({
        action: "purchase",
        command: "purchase",
        type: "DRIVE_IQ_PURCHASE",
        source: payload.source,
        product_id: payload.product_id,
        productId: payload.productId,
        payload: payload
      });
      fired = true;
    }
  } catch (e1) {}




  try {
    if (window.DriveIQNative && typeof window.DriveIQNative.purchaseProduct === "function") {
      window.DriveIQNative.purchaseProduct(payload.product_id);
      fired = true;
    }
  } catch (e2) {}




  try {
    if (window.Capacitor && window.Capacitor.Plugins && window.Capacitor.Plugins.Purchases && typeof window.Capacitor.Plugins.Purchases.purchaseProduct === "function") {
      window.Capacitor.Plugins.Purchases.purchaseProduct({ productIdentifier: payload.product_id });
      fired = true;
    }
  } catch (e3) {}




  try {
    window.dispatchEvent(new CustomEvent("driveiq:purchase", { detail: payload }));
  } catch (e4) {}




  return fired;
}




function openUpgradeSheet() {
  try{ diqFounderIQTrack("adventure_upgrade_opened",{}); }catch(founderIQUpgradeErr){}
  var sheet = byId("diqUpgradeSheet");




  if (userHasPlusEntitlement()) {
    toast("Drive IQ Plus active");
    setStatus("adventureRouteStatus", "PLUS ACTIVE", "green");
    return;
  }




  if (sheet) { sheet.className = "diqUpgradeSheet on"; }




  if (fireApplePurchaseSheet("com.loveforlocals.driveiq.plus.monthly", "adventure_upgrade_button")) {
    toast("Opening Apple sheet");
    setStatus("adventureRouteStatus", "APPLE SHEET", "gold");
  } else {
    toast("Drive IQ Plus");
    setStatus("adventureRouteStatus", "PLUS READY", "gold");
  }
}




function closeUpgradeSheet() {
  var sheet = byId("diqUpgradeSheet");
  if (sheet) { sheet.className = "diqUpgradeSheet"; }
}




function beginUpgrade(productId) {
  var pid = normalizeProductId(productId);




  if (userHasPlusEntitlement()) {
    toast("Drive IQ Plus active");
    setStatus("adventureRouteStatus", "PLUS ACTIVE", "green");
    closeUpgradeSheet();
    return;
  }




  if (fireApplePurchaseSheet(pid, "adventure_plus_button")) {
    toast("Opening Apple sheet");
    setStatus("adventureRouteStatus", "APPLE SHEET", "gold");
  } else {
    toast("Purchase bridge not detected");
    setStatus("adventureRouteStatus", "BRIDGE READY", "gold");
  }
}




function isUpgradeTarget(el) {
  var node = el;
  var count = 0;
  var txt;
  var id;
  var cls;
  while (node && count < 6) {
    if (node.id) {
      id = String(node.id).toLowerCase();
      if (id.indexOf("upgrade") > -1 || id.indexOf("plus") > -1 || id.indexOf("subscribe") > -1) { return true; }
    }
    if (node.getAttribute) {
      if (node.getAttribute("data-diq-upgrade") === "1" || node.getAttribute("data-drive-iq-upgrade") === "1" || node.getAttribute("data-plus") === "1") { return true; }
      if (node.getAttribute("data-product-id") || node.getAttribute("data-productid")) { return true; }
      cls = String(node.className || "").toLowerCase();
      if (cls.indexOf("upgrade") > -1 || cls.indexOf("plus") > -1 || cls.indexOf("subscribe") > -1) { return true; }
    }
    txt = clean(node.textContent || "").toLowerCase();
    if (count === 0 && (txt === "upgrade" || txt === "drive iq plus" || txt === "plus" || txt === "subscribe")) { return true; }
    node = node.parentNode;
    count += 1;
  }
  return false;
}




function upgradeProductFromTarget(el) {
  var node = el;
  var count = 0;
  var val;
  var txt;
  while (node && count < 6) {
    if (node.getAttribute) {
      val = node.getAttribute("data-product-id") || node.getAttribute("data-productid") || node.getAttribute("data-iap") || node.getAttribute("data-sku");
      if (val) { return normalizeProductId(val); }
    }
    txt = clean(node.textContent || "").toLowerCase();
    if (txt.indexOf("year") > -1 || txt.indexOf("annual") > -1) { return "com.loveforlocals.driveiq.plus.yearly"; }
    node = node.parentNode;
    count += 1;
  }
  return "com.loveforlocals.driveiq.plus.monthly";
}




function bindUpgradeButtons() {
  var selectors = ["#diqUpgradeBtn", "#adventureUpgradeBtn", "#driveIqUpgrade", "#upgradeBtn", "#plusBtn", ".diqUpgrade", ".upgradeBtn", ".plusBtn", "[data-diq-upgrade]", "[data-drive-iq-upgrade]", "[data-product-id]", "[data-productid]"];
  var nodes;
  var i;
  var j;
  for (i = 0; i < selectors.length; i++) {
    try {
      nodes = document.querySelectorAll(selectors[i]);
      for (j = 0; j < nodes.length; j++) {
        nodes[j].onclick = function (e) {
          if (e && e.preventDefault) { e.preventDefault(); }
          if (e && e.stopPropagation) { e.stopPropagation(); }
          beginUpgrade(upgradeProductFromTarget(this));
          return false;
        };
      }
    } catch (e1) {}
  }
  try {
    document.addEventListener("click", function (e) {
      if (e && isUpgradeTarget(e.target)) {
        if (e.preventDefault) { e.preventDefault(); }
        if (e.stopImmediatePropagation) { e.stopImmediatePropagation(); }
        else if (e.stopPropagation) { e.stopPropagation(); }
        beginUpgrade(upgradeProductFromTarget(e.target));
        return false;
      }
      return true;
    }, true);
  } catch (e2) {}
}




function shellSafeBack() {
  try {
    if (window.webkit && window.webkit.messageHandlers) {
      if (window.webkit.messageHandlers.driveIQBack && window.webkit.messageHandlers.driveIQBack.postMessage) {
        window.webkit.messageHandlers.driveIQBack.postMessage({ type: "BACK_TO_DRIVE_IQ_HOME", source: "adventure", url: ADVENTURE_HOME_URL });
        return false;
      }
      if (window.webkit.messageHandlers.slx && window.webkit.messageHandlers.slx.postMessage) {
        window.webkit.messageHandlers.slx.postMessage({ action: "navigate", url: ADVENTURE_HOME_URL, source: "adventure_back" });
      }
    }
  } catch (e1) {}
  try { window.location.replace(ADVENTURE_HOME_URL); }
  catch (e2) { try { window.location.href = ADVENTURE_HOME_URL; } catch (e3) {} }
  return false;
}




function isBackTarget(el) {
  var node = el;
  var count = 0;
  while (node && count < 6) {
    if (node.id === "adventureBackBtn" || node.id === "adventureBack" || node.id === "backAdventure" || node.id === "diqBack" || node.id === "driveIqBack") { return true; }
    if (node.getAttribute) {
      if (node.getAttribute("data-diq-shell-back") === "1" || node.getAttribute("data-diq-back") === "1" || node.getAttribute("data-adventure-back") === "1") { return true; }
      if (node.className && String(node.className).indexOf("adventureBack") > -1) { return true; }
      if (node.className && String(node.className).indexOf("diqBack") > -1) { return true; }
      if (String(node.getAttribute("href") || "") === ADVENTURE_HOME_URL) { return true; }
    }
    node = node.parentNode;
    count += 1;
  }
  return false;
}




function bindShellBackButtons() {
  var selectors = ["#adventureBackBtn", "#adventureBack", "#backAdventure", "#diqBack", "#driveIqBack", ".adventureBack", ".diqBack", "[data-diq-shell-back]", "[data-diq-back]", "[data-adventure-back]"];
  var nodes;
  var i;
  var j;
  for (i = 0; i < selectors.length; i++) {
    try {
      nodes = document.querySelectorAll(selectors[i]);
      for (j = 0; j < nodes.length; j++) {
        nodes[j].onclick = function (e) { if (e && e.preventDefault) { e.preventDefault(); } if (e && e.stopPropagation) { e.stopPropagation(); } return shellSafeBack(); };
      }
    } catch (e) {}
  }
  try {
    document.addEventListener("click", function (e) {
      if (e && isBackTarget(e.target)) {
        if (e.preventDefault) { e.preventDefault(); }
        if (e.stopImmediatePropagation) { e.stopImmediatePropagation(); }
        else if (e.stopPropagation) { e.stopPropagation(); }
        shellSafeBack();
        return false;
      }
      return true;
    }, true);
  } catch (e2) {}
}












/* =========================================================
   DRIVE IQ V22 â€” EXPERIENCE RELEVANCE IQ / LIVE MUSIC IQ
   Fixes:
   - Destin pronunciation before speech.
   - Live Music / Popular Tonight / Patio scans cannot surface retail/beauty
     places such as Ulta Beauty.
   - Venue Confidence filters candidates before pins/cards render.
   - Local-guide ranking boosts bars, breweries, restaurants, music venues,
     harbor/waterfront entertainment, and event venues.
========================================================= */




function diqV22VoiceSafeText(text) {
  var out = String(text || "");
  var repl = [
    { key:"Destin", val:"Dess-tin" },
    { key:"Dauphin", val:"Daw-fin" },
    { key:"Biloxi", val:"Buh-lock-see" },
    { key:"DeSoto", val:"Deh-so-toe" },
    { key:"Tunica", val:"Too-ni-ka" },
    { key:"Gatlinburg", val:"Gat-lin-burg" },
    { key:"Choctawhatchee", val:"Chock-taw-hatch-ee" }
  ];
  var i;
  for (i = 0; i < repl.length; i++) {
    try {
      out = out.replace(new RegExp("\\b" + repl[i].key + "\\b", "gi"), repl[i].val);
    } catch (e) {}
  }
  return out;
}




function speakAdventure(text) {
  var msg = clean(diqV22VoiceSafeText(text));
  var utter;
  var voiceKey = normText(msg).slice(0, 90);
  if (!infoVoiceEnabled || !msg) { return; }
  if (voiceKey && voiceKey === infoVoiceLastKey && Date.now() - infoVoiceLastAt < 18000) { return; }
  infoVoiceLastKey = voiceKey;
  infoVoiceLastAt = Date.now();
  try {
    if (!window.speechSynthesis || !window.SpeechSynthesisUtterance) { return; }
    window.speechSynthesis.cancel();
    utter = new SpeechSynthesisUtterance(msg);
    utter.rate = 0.78;
    utter.pitch = 1.0;
    utter.volume = 1.0;
    window.speechSynthesis.speak(utter);
  } catch (e) {}
}




function diqV22TruthText(item) {
  return normText(
    String(item && item.label || "") + " " +
    String(item && item.full || "") + " " +
    String(item && item.kind || "") + " " +
    String(item && item.matchLabel || "") + " " +
    String(item && item.sourceQuery || "") + " " +
    String(item && item.placeCategories || "") + " " +
    String(item && item.placeClass || "")
  );
}




function diqV22IsNightlifeCategory(category) {
  return category === "live music" || category === "popular tonight" || category === "patio vibes";
}




function diqV22HasAny(txt, arr) {
  var i;
  for (i = 0; i < arr.length; i++) {
    if (txt.indexOf(arr[i]) > -1) { return true; }
  }
  return false;
}




function diqV22IsRetailBeautyNoise(item) {
  var txt = diqV22TruthText(item);
  return diqV22HasAny(txt, [
    "ulta", "ulta beauty", "beauty", "cosmetic", "cosmetics", "salon", "spa",
    "sephora", "makeup", "nail salon", "hair salon", "department store",
    "retail", "shopping", "shopping center", "mall", "outlet", "clothing",
    "apparel", "shoe store", "shoes", "boutique", "jewelry", "gift shop",
    "pharmacy", "drugstore", "grocery", "supermarket", "hardware", "furniture",
    "mattress", "automotive", "auto parts", "car dealer", "bank", "atm",
    "insurance", "real estate", "storage", "warehouse", "office", "office supply",
    "medical", "clinic", "dentist", "orthodont", "vet", "veterinary"
  ]);
}




function diqV22IsNonVenueMusicNoise(item) {
  var txt = diqV22TruthText(item);
  return diqV22HasAny(txt, [
    "music store", "instrument store", "guitar store", "music lesson",
    "music school", "academy", "radio station", "recording studio",
    "church", "school", "university"
  ]);
}








function diqV22IsLiveMusicFallbackSource(item) {
  var q = normText(String(item && item.sourceQuery || ""));
  return diqV22HasAny(q, [
    "bar", "pub", "tavern", "cocktail", "nightclub", "lounge", "brewery",
    "taproom", "brewpub", "beach bar", "waterfront bar", "waterfront restaurant",
    "seafood restaurant", "bar and grill", "restaurant bar", "patio bar",
    "harbor", "marina", "boardwalk", "entertainment district", "downtown nightlife",
    "things to do tonight"
  ]);
}




function diqV22LiveMusicFallbackVoice() {
  var t = Date.now();
  if (t - Number(liveMusicFallbackVoiceSpokenAt || 0) < 22000) { return; }
  liveMusicFallbackVoiceSpokenAt = t;
  speakAdventureScanVoice(
    "I didnâ€™t find dedicated music venues, so Iâ€™m checking bars, breweries, and waterfront spots with entertainment.",
    "live_music_fallback|" + String(adventureScanVoiceToken || 0),
    1000
  );
}




function diqV22VenueConfidenceScore(item, query) {
  var category = categoryFromQuery(query || activeLens || "");
  var txt = diqV22TruthText(item);
  var score = 0;
  var d = item && finite(Number(item.distMiles)) ? Number(item.distMiles) : null;




  if (!item) { return 0; }




  if (diqV22IsRetailBeautyNoise(item)) { return -1000; }
  if (category === "live music" && diqV22IsNonVenueMusicNoise(item)) { return -800; }




  if (diqV22HasAny(txt, ["live music", "music venue", "concert", "concert hall", "band", "acoustic", "jazz", "karaoke", "open mic"])) { score += 48; }
  if (diqV22HasAny(txt, ["nightclub", "dance hall", "performing arts", "theater", "theatre", "amphitheater", "amphitheatre", "event venue", "entertainment venue"])) { score += 42; }
  if (diqV22HasAny(txt, ["bar", "pub", "tavern", "brewery", "taproom", "cocktail", "lounge", "club"])) { score += 38; }
  if (category === "live music" && diqV22IsLiveMusicFallbackSource(item)) { score += 18; }
  if (diqV22HasAny(txt, ["restaurant", "grill", "seafood", "oyster", "bistro", "cafe", "kitchen"])) { score += 24; }
  if (diqV22HasAny(txt, ["patio", "outdoor seating", "rooftop", "beer garden", "waterfront", "harbor", "harbour", "marina", "beach bar", "dockside", "boardwalk"])) { score += 20; }
  if (diqV22HasAny(txt, ["downtown", "town square", "village", "harborwalk", "local favorite", "popular", "tonight"])) { score += 16; }




  if (category === "live music" && diqV22HasAny(txt, ["live music", "music venue", "concert", "band", "jazz", "karaoke", "open mic"])) { score += 20; }
  if (category === "popular tonight" && diqV22HasAny(txt, ["bar", "restaurant", "brewery", "nightlife", "downtown", "harbor", "popular", "event", "music"])) { score += 18; }
  if (category === "patio vibes" && diqV22HasAny(txt, ["patio", "outdoor seating", "rooftop", "beer garden", "waterfront", "restaurant", "bar"])) { score += 18; }




  if (d !== null) {
    if (d <= 3) { score += 12; }
    else if (d <= 8) { score += 9; }
    else if (d <= 18) { score += 4; }
    else { score -= Math.min(22, Math.round((d - 18) / 3)); }
  }




  return score;
}




function diqV22VenueThreshold(category) {
  if (category === "live music") { return 38; }
  if (category === "popular tonight") { return 44; }
  if (category === "patio vibes") { return 42; }
  return 0;
}




function diqV22ExperienceRelevant(item, query) {
  var category = categoryFromQuery(query || activeLens || "");
  var score;




  if (!category || !item) { return true; }




  if (diqV22IsNightlifeCategory(category)) {
    if (diqV22IsRetailBeautyNoise(item)) { return false; }
    if (category === "live music" && diqV22IsNonVenueMusicNoise(item)) { return false; }
    score = diqV22VenueConfidenceScore(item, query);
    return score >= diqV22VenueThreshold(category);
  }




  return true;
}




function isStrictAdventureCategoryMatch(item, query) {
  var category = categoryFromQuery(query);
  var txt = adventureTruthText(item);
  var explicitMusic;
  var credibleVenue;
  var retailNoise;
  var nonVenueNoise;




  if (!category || !item) { return true; }




  if (diqV22IsNightlifeCategory(category)) {
    return diqV22ExperienceRelevant(item, query);
  }




  if (category === "live music") {
    explicitMusic = hasAnyTruthSignal(txt, [
      "live music", "music venue", "concert", "concert hall", "band", "acoustic",
      "jazz", "karaoke", "nightclub", "dance hall", "theater", "theatre",
      "performing arts", "event venue", "entertainment venue", "amphitheater", "amphitheatre"
    ]);
    credibleVenue = hasAnyTruthSignal(txt, [
      "bar", "pub", "tavern", "brewery", "taproom", "restaurant", "grill",
      "bistro", "cafe", "club", "lounge", "rooftop", "patio", "venue"
    ]);
    retailNoise = diqV22IsRetailBeautyNoise(item);
    nonVenueNoise = diqV22IsNonVenueMusicNoise(item);
    return !retailNoise && !nonVenueNoise && (explicitMusic || credibleVenue);
  }




  if (category === "patio vibes") {
    var patio = patioIntentSignals(item);
    return !patio.poorFit && !diqV22IsRetailBeautyNoise(item) && (patio.outdoor || patio.dining || patio.drinkOnly);
  }




  if (category === "food iq" || category === "food drinks") {
    return hasAnyTruthSignal(txt, [
      "restaurant", "bar", "pub", "brewery", "taproom", "grill", "bbq", "barbecue",
      "burger", "pizza", "seafood", "steak", "cafe", "coffee", "bakery", "diner",
      "kitchen", "taco", "brunch", "dessert", "ice cream", "food"
    ]);
  }




  if (category === "local favorites") {
    var localHangoutNoise = hasAnyTruthSignal(txt, [
      "gas station", "convenience", "pharmacy", "drugstore", "car dealer",
      "auto parts", "storage", "warehouse", "bank", "atm", "insurance",
      "real estate", "apartment", "residential", "subdivision", "medical",
      "clinic", "dentist", "law office", "funeral", "church"
    ]);
    var localHangoutSignal = hasAnyTruthSignal(txt, [
      "restaurant", "cantina", "bar", "grill", "bbq", "barbecue", "taco",
      "coffee", "cafe", "bakery", "dessert", "ice cream", "brewery", "taproom",
      "pickleball", "athletic club", "fitness", "gym", "recreation", "sports",
      "park", "amphitheater", "amphitheatre", "arena", "event venue", "bowling",
      "arcade", "boutique", "shop", "market", "square", "silo square",
      "town square", "snowden grove", "desoto", "southaven", "local",
      "hangout", "favorite", "popular"
    ]);
    return !localHangoutNoise && localHangoutSignal;
  }




  if (category === "waterfront") {
    var explicitWater = hasAnyTruthSignal(txt, [
      "waterfront", "lakefront", "riverfront", "marina", "riverwalk", "beach",
      "pier", "harbor", "harbour", "bay", "gulf", "oceanfront", "beachfront",
      "dockside", "dock side", "creekside", "riverside", "water view",
      "river view", "shore", "boardwalk", "waterfall", "falls", "boat ramp", "boat launch"
    ]);
    var credibleHospitality = hasAnyTruthSignal(txt, [
      "restaurant", "seafood", "oyster", "bar", "grill", "cafe", "bistro",
      "park", "trail", "public access", "boardwalk", "marina", "harbor", "pier"
    ]);
    return explicitWater && credibleHospitality;
  }




  if (category === "camping") { return hasAnyTruthSignal(txt, ["camp", "campground", "rv park", "koa", "campsite", "state park"]); }
  if (category === "run walk") { return hasAnyTruthSignal(txt, ["trail", "greenway", "riverwalk", "boardwalk", "walk", "running", "park", "beach"]); }
  if (category === "water") { return hasAnyTruthSignal(txt, ["beach", "water", "lake", "river", "creek", "boat", "pier", "marina", "boardwalk"]); }
  if (category === "trails") { return hasAnyTruthSignal(txt, ["trail", "greenway", "hiking", "park", "preserve"]); }
  if (category === "parks") { return hasAnyTruthSignal(txt, ["park", "preserve", "recreation area", "public"]); }
  if (category === "waterfalls") { return hasAnyTruthSignal(txt, ["waterfall", "falls", "cascade"]); }
  if (category === "caves") { return hasAnyTruthSignal(txt, ["cave", "cavern"]); }




  return true;
}




function scoreAdventure(item, query) {
  var score = 0;
  var txt = String((item && item.label || "") + " " + (item && item.full || "") + " " + (item && item.sourceQuery || "")).toLowerCase();
  var category = categoryFromQuery(query);
  var dist = Number(item && item.distMiles);
  var venueConfidence = diqV22VenueConfidenceScore(item, query);




  if (!item) { return -9999; }
  if (diqV22IsNightlifeCategory(category) && !diqV22ExperienceRelevant(item, query)) { return -9999; }




  if (txt.indexOf(String(query || "").toLowerCase()) > -1) { score += 100; }
  if (category === "popular tonight" || category === "live music" || category === "waterfront" || category === "patio vibes" || category === "food drinks" || category === "local favorites") { score += 18; }
  if (category === "local favorites") {
    if (txt.indexOf("silo square") > -1 || txt.indexOf("town square") > -1 || txt.indexOf("snowden grove") > -1 || txt.indexOf("southaven") > -1 || txt.indexOf("desoto") > -1) { score += 70; }
    if (txt.indexOf("maria") > -1 || txt.indexOf("cantina") > -1 || txt.indexOf("coffee central") > -1 || txt.indexOf("banger") > -1 || txt.indexOf("pickleball") > -1 || txt.indexOf("athletic club") > -1 || txt.indexOf("dac") > -1) { score += 135; }
    if (txt.indexOf("coffee") > -1 || txt.indexOf("cafe") > -1 || txt.indexOf("brewery") > -1 || txt.indexOf("bakery") > -1 || txt.indexOf("dessert") > -1 || txt.indexOf("gym") > -1 || txt.indexOf("fitness") > -1 || txt.indexOf("recreation") > -1 || txt.indexOf("sports") > -1 || txt.indexOf("park") > -1 || txt.indexOf("boutique") > -1 || txt.indexOf("shop") > -1) { score += 44; }
  }




  if (category === "local favorites") {
    if (txt.indexOf("local favorite") > -1 || txt.indexOf("local institution") > -1 || txt.indexOf("locally owned") > -1 || txt.indexOf("family owned") > -1) { score += 120; }
    if (txt.indexOf("historic") > -1 || txt.indexOf("downtown") > -1 || txt.indexOf("square") > -1 || txt.indexOf("neighborhood") > -1 || txt.indexOf("district") > -1) { score += 74; }
    if (txt.indexOf("restaurant") > -1 || txt.indexOf("bbq") > -1 || txt.indexOf("barbecue") > -1 || txt.indexOf("coffee") > -1 || txt.indexOf("brewery") > -1 || txt.indexOf("bakery") > -1 || txt.indexOf("food hall") > -1) { score += 54; }
    if (txt.indexOf("walmart") > -1 || txt.indexOf("dollar general") > -1 || txt.indexOf("subway") > -1 || txt.indexOf("mcdonald") > -1 || txt.indexOf("taco bell") > -1 || txt.indexOf("gas station") > -1) { score -= 180; }
  }




  if (diqV22IsNightlifeCategory(category)) { score += venueConfidence * 2; }




  if (category === "patio vibes") {
    var patioSignals = patioIntentSignals(item);
    if (patioSignals.outdoor && patioSignals.dining) { score += 112; }
    else if (patioSignals.dining) { score += 62; }
    else if (patioSignals.outdoor) { score += 46; }
    if (patioSignals.drinkOnly && !patioSignals.dining) { score -= 28; }
    if (patioSignals.poorFit) { score -= 120; }
  }




  if (txt.indexOf("live music") > -1 || txt.indexOf("music venue") > -1 || txt.indexOf("concert") > -1 || txt.indexOf("band") > -1) { score += 48; }
  if (txt.indexOf("restaurant") > -1 || txt.indexOf("bar") > -1 || txt.indexOf("brewery") > -1 || txt.indexOf("grill") > -1) { score += 38; }
  if (txt.indexOf("patio") > -1 || txt.indexOf("rooftop") > -1 || txt.indexOf("outdoor") > -1) { score += 34; }
  if (txt.indexOf("local") > -1 || txt.indexOf("downtown") > -1 || txt.indexOf("square") > -1 || txt.indexOf("harbor") > -1 || txt.indexOf("harborwalk") > -1) { score += 30; }
  if (txt.indexOf("music store") > -1 || txt.indexOf("lesson") > -1 || txt.indexOf("school") > -1 || txt.indexOf("academy") > -1 || txt.indexOf("instrument") > -1 || txt.indexOf("radio") > -1) { score -= 110; }
  if (diqV22IsRetailBeautyNoise(item)) { score -= 1000; }




  if (txt.indexOf("park") > -1) { score += 45; }
  if (txt.indexOf("trail") > -1) { score += 45; }
  if (txt.indexOf("camp") > -1) { score += 45; }
  if (txt.indexOf("forest") > -1) { score += 45; }
  if (txt.indexOf("greenway") > -1 || txt.indexOf("riverwalk") > -1 || txt.indexOf("boardwalk") > -1) { score += 56; }
  if (txt.indexOf("beach") > -1 || txt.indexOf("waterfront") > -1 || txt.indexOf("shoreline") > -1) { score += 55; }
  if (txt.indexOf("waterfall") > -1) { score += 60; }
  if (txt.indexOf("cave") > -1) { score += 60; }
  if (txt.indexOf("lookout") > -1 || txt.indexOf("overlook") > -1) { score += 50; }
  if (txt.indexOf("private") > -1 || txt.indexOf("residential") > -1 || txt.indexOf("apartment") > -1 || txt.indexOf("subdivision") > -1) { score -= 80; }
  score += queryCategoryScore(item, category);
  score += adventureTasteBoost(item, query);
  score += adventureFreshnessData(item).boost;




  if (finite(dist)) {
    if (dist < 5) { score += 80; }
    else if (dist < 15) { score += 62; }
    else if (dist < 30) { score += 42; }
    else if (dist < 60) { score += 22; }
    else if (dist < 90) { score += 10; }
    score -= Math.min(70, dist * 0.45);
  }




  return score;
}




function adventureWorthScore(item, query) {
  var cat = adventurePrimaryCategory(item, query);
  var base = 68;
  var d = item && finite(Number(item.distMiles)) ? Number(item.distMiles) : null;
  var txt = normText(String(item && item.label || "") + " " + String(item && item.full || "") + " " + String(item && item.matchLabel || "") + " " + String(item && item.sourceQuery || ""));
  var venueConfidence = diqV22VenueConfidenceScore(item, query);




  base += Math.round(queryCategoryScore(item || {}, cat) / 7);
  if (diqV22IsNightlifeCategory(cat)) { base += Math.round(venueConfidence / 8); }
  if (d !== null) {
    if (d <= 2) { base += 16; }
    else if (d <= 6) { base += 13; }
    else if (d <= 12) { base += 8; }
    else if (d <= 22) { base += 3; }
    else { base -= Math.min(18, Math.round((d - 22) / 3)); }
  }
  if (txt.indexOf("local") > -1 || txt.indexOf("historic") > -1 || txt.indexOf("downtown") > -1 || txt.indexOf("square") > -1 || txt.indexOf("harborwalk") > -1) { base += 7; }
  if (txt.indexOf("live music") > -1 || txt.indexOf("music venue") > -1 || txt.indexOf("concert") > -1 || txt.indexOf("bar") > -1 || txt.indexOf("brewery") > -1) { base += 8; }
  if (txt.indexOf("patio") > -1 || txt.indexOf("outdoor") > -1 || txt.indexOf("waterfront") > -1 || txt.indexOf("rooftop") > -1) { base += 6; }
  if (txt.indexOf("trail") > -1 || txt.indexOf("greenway") > -1 || txt.indexOf("riverwalk") > -1 || txt.indexOf("overlook") > -1) { base += 8; }
  if (txt.indexOf("walmart") > -1 || txt.indexOf("mcdonald") > -1 || txt.indexOf("taco bell") > -1 || txt.indexOf("gas station") > -1 || diqV22IsRetailBeautyNoise(item)) { base -= 30; }
  if (txt.indexOf("private") > -1 || txt.indexOf("residential") > -1 || txt.indexOf("apartment") > -1) { base -= 30; }
  if (isFarFromCurrentLocal(item, cat)) { base -= 16; }
  base += Math.min(8, Math.round(adventureTasteBoost(item, query) / 5));
  base += Math.max(-8, Math.min(8, Math.round(adventureFreshnessData(item).boost / 5)));




  if (base < 45) { base = 45; }
  if (base > 97) { base = 97; }
  return base;
}




function adventureConfidenceLabel(item) {
  var cat = adventurePrimaryCategory(item, activeLens);
  var score;
  if (diqV22IsNightlifeCategory(cat)) {
    score = diqV22VenueConfidenceScore(item, activeLens);
    if (score >= 88) { return "High venue confidence"; }
    if (score >= 66) { return "Good venue confidence"; }
    return "Venue confidence check";
  }
  score = Number(item && item.worthScore || 0);
  if (score >= 88) { return "High confidence"; }
  if (score >= 76) { return "Good confidence"; }
  return "Place IQ estimate";
}




function enrichAdventureItem(item, query) {
  if (!item) { return item; }
  item.adventureCategory = adventurePrimaryCategory(item, query);
  item.venueConfidence = diqV22VenueConfidenceScore(item, query);
  item.worthScore = adventureWorthScore(item, query);
  item.worthStars = adventureStars(item.worthScore);
  item.whyStop = adventureWhy(item, query);
  item.localTags = adventureTagList(item, query);
  item.freshnessData = adventureFreshnessData(item);
  item.freshnessLabel = item.freshnessData.label;
  item.tasteBoost = adventureTasteBoost(item, query);
  item.confidenceLabel = adventureConfidenceLabel(item);
  item.photos = diqBuildPlaceGallery ? diqBuildPlaceGallery(item, query) : (item.photos || []);
  return item;
}




function diqV22FilterExperienceResults(items, query) {
  var out = [];
  var i;
  var item;
  for (i = 0; i < (items || []).length; i++) {
    item = items[i];
    if (!item) { continue; }
    if (diqV22ExperienceRelevant(item, query)) { out.push(item); }
    else {
      try { if (window.console && window.console.warn) { window.console.warn("[Adventure V22 filtered irrelevant result]", { query: query, label: item.label, full: item.full, kind: item.kind }); } } catch (e) {}
    }
  }
  return out;
}




function sortAdventureResults(items, query) {
  items = diqV22FilterExperienceResults(items || [], query);
  return items.sort(function (a, b) {
    var sa = scoreAdventure(a, query);
    var sb = scoreAdventure(b, query);
    var da = finite(Number(a.distMiles)) ? Number(a.distMiles) : 99999;
    var db = finite(Number(b.distMiles)) ? Number(b.distMiles) : 99999;
    if (Math.abs(sb - sa) > 12) { return sb - sa; }
    return da - db;
  });
}




function renderResultPins(items, preferred) {
  var fc = emptyFC();
  var i;
  var item;
  var filtered;
  if (!map || !mapLoaded) { return; }
  ensureResultSources();
  filtered = diqV22FilterExperienceResults(items && items.length ? items : [], activeLens);
  adventureResults = filtered.length ? filtered.slice(0, 12) : [];
  fc.features = [];
  for (i = 0; i < adventureResults.length; i++) {
    item = adventureResults[i];
    if (!item || !finite(Number(item.lat)) || !finite(Number(item.lng))) { continue; }
    fc.features.push({
      type: "Feature",
      properties: {
        idx: i,
        preferred: preferred && Number(preferred.lat) === Number(item.lat) && Number(preferred.lng) === Number(item.lng) ? 1 : (i === 0 ? 1 : 0),
        shortLabel: shortAdventureLabel(item.label || "Stop"),
        experience: adventurePrimaryCategory(item, activeLens),
        venueConfidence: Number(item.venueConfidence || diqV22VenueConfidenceScore(item, activeLens) || 0)
      },
      geometry: { type: "Point", coordinates: [Number(item.lng), Number(item.lat)] }
    });
  }
  try { map.getSource("adventure-results").setData(fc); } catch (e) {}
  raisePins();
}




function renderAdventureScanChoices(items, query) {
  var panel = ensureDestinationResultsPanel();
  var list = byId("diqDestList");
  var head;
  var i;
  var item;
  var btn;
  var name;
  var sub;
  var meta;
  var photoStyle;
  var photoClass;
  var filtered = diqV22FilterExperienceResults(items || [], query);




  if (!panel || !list) { return; }




  head = panel.querySelector ? panel.querySelector(".diqDestHead") : null;
  if (head) { head.textContent = "CHOOSE ADVENTURE STOP"; }




  destinationSearchResults = filtered && filtered.length ? filtered.slice(0, 8) : [];
  list.innerHTML = "";




  if (!destinationSearchResults.length) {
    if (categoryFromQuery(query) === "live music") {
      list.innerHTML = '<button type="button" class="diqDestItem"><div class="diqDestName">No strong live music venues yet</div><div class="diqDestSub">Try Scan This Map near a harbor, downtown, brewery district, or entertainment area.</div><div class="diqDestMeta">LIVE MUSIC IQ</div></button>';
    } else if (categoryFromQuery(query) === "popular tonight") {
      list.innerHTML = '<button type="button" class="diqDestItem"><div class="diqDestName">No strong nightlife matches yet</div><div class="diqDestSub">Try live music, patio vibes, waterfront, or scan closer to town.</div><div class="diqDestMeta">EXPERIENCE IQ</div></button>';
    } else if (categoryFromQuery(query) === "waterfront") {
      list.innerHTML = '<button type="button" class="diqDestItem"><div class="diqDestName">No true waterfront found yet</div><div class="diqDestSub">Try creekside, riverwalk, Little Pigeon River, waterfalls, or scenic water nearby.</div><div class="diqDestMeta">PLACE IQ FALLBACK</div></button>';
    } else {
      list.innerHTML = '<button type="button" class="diqDestItem"><div class="diqDestName">No strong local matches yet</div><div class="diqDestSub">Try another category or search a specific place.</div><div class="diqDestMeta">LOCAL IQ</div></button>';
    }
    panel.className = "on";
    destinationResultOpen = true;
    return;
  }




  for (i = 0; i < destinationSearchResults.length; i++) {
    item = enrichAdventureItem(destinationSearchResults[i], query);
    destinationSearchResults[i] = item;
    btn = document.createElement("button");
    btn.type = "button";
    btn.className = "diqDestItem hasPhoto";
    btn.setAttribute("data-adv-idx", String(i));




    name = clean(item.label || "Adventure stop");
    sub = clean(item.whyStop || item.full || item.matchLabel || "Tap to preview. Route draws only after you choose.");
    meta = clean(adventureChoiceMeta(item, query) || "LOCAL IQ OPTION");
    photoStyle = photoStyleForItem(item, query);
    photoClass = categoryPhotoClass(item, query);




    btn.innerHTML =
      '<div class="diqDestThumb ' + escapeHTML(photoClass) + '" style="' + photoStyle + '"></div>' +
      '<div class="diqDestName">' + escapeHTML(name) + '</div>' +
      '<div class="diqDestSub">' + escapeHTML(sub) + '</div>' +
      '<div class="diqDestMeta">' + escapeHTML(meta) + '</div>' +
      '<div class="diqDestWorth">' + (i === 0 ? '<span class="diqDestTag diqDestTopPick">TOP PICK</span>' : '') + '<span class="diqDestTag diqDestScore">' + escapeHTML(String(item.worthScore || "") + ' IQ') + '</span><span class="diqDestTag">' + escapeHTML(String(item.confidenceLabel || item.freshnessLabel || "Place IQ estimate")) + '</span><span class="diqDestTag">' + escapeHTML((item.localTags && item.localTags.length ? item.localTags[0] : "Worth the Stop")) + '</span></div>';




    btn.onclick = function () {
      var idx = Number(this.getAttribute("data-adv-idx"));
      var picked = destinationSearchResults && destinationSearchResults[idx] ? destinationSearchResults[idx] : null;
      if (!picked) { return; }
      closeAdventureInfoCard();
      openAdventureInfoCard(picked, true);
      toast("Previewing " + String(picked.label || "stop"));
    };




    list.appendChild(btn);
  }




  panel.className = "on";
  destinationResultOpen = true;
  try { diqHydrateScanChoicePhotos(destinationSearchResults, query); } catch (thumbHydrateErr) {}
}




function adventureChoiceMeta(item, query) {
  var parts = [];
  var d = item && finite(Number(item.distMiles)) ? Number(item.distMiles) : null;
  var cat = categoryFromQuery(query);
  if (d !== null) { parts.push(itemDistanceText(item)); }
  if (cat) { parts.push(titleCaseWords(cat)); }
  if (item && item.confidenceLabel) { parts.push(String(item.confidenceLabel)); }
  if (item && item.freshnessLabel) { parts.push(String(item.freshnessLabel)); }
  if (item && item.kind) { parts.push(titleCaseWords(String(item.kind).replace(/_/g, " "))); }
  return clean(parts.join(" â€¢ "));
}




function adventureScanScopeVoiceLabel(query) {
  var label;




  if (adventureSearchScope === "map_area") { return "in this map area"; }




  if (adventureSearchScope === "near_destination" && adventureSearchCenter) {
    label = clean(diqV22VoiceSafeText(adventureSearchCenter.label || "your destination"));
    return "near " + label;
  }




  return "nearby";
}












/* =========================================================
   DRIVE IQ V24.1 â€” DESTINATION INTENT IQ
   Plain city/place/address text must open destination choices. Experience
   scanning only wins when the text contains explicit experience language.
========================================================= */
function isExplicitExperienceQuery(query) {
  var q = normText(query);
  if (!q) { return false; }
  return !!categoryFromQuery(q);
}




function shouldSearchAsDestination(query) {
  var q = clean(query);
  if (!q || q.length < 3) { return false; }
  if (shouldSuppressDestinationChooser(q)) { return false; }
  return !isExplicitExperienceQuery(q) && destinationSearchWasIntentionallyChanged(q);
}




function bind() {
  var input = byId("adventureSearch");
  var go = byId("buildAdventure");
  var start = byId("startAdventure");
  var gps = byId("lockGps");
  var center = byId("centerMap");




  ensureAdventureClearSearchButton();




  if (input) {
    input.addEventListener("input", function () {
      var q = clean(input.value);
      updateClearAdventureSearchButton();




      if (searchTimer) { window.clearTimeout(searchTimer); }




      if (shouldSuppressDestinationChooser(q)) {
        destinationSearchResults = [];
        hideDestinationResults();
        return;
      }




      /*
        Typed search is destination search only. It should show choices and
        never auto-route to a random first result. If a destination is already
        locked, choices appear only after the user intentionally changes text.
      */
      searchTimer = window.setTimeout(function () {
        if (q.length >= 3 && isExplicitExperienceQuery(q)) { hideDestinationResults(); }
        else if (shouldSearchAsDestination(q)) { searchDestinations(q); }
        else { hideDestinationResults(); }
      }, 520);
    }, false);




    input.addEventListener("keydown", function (e) {
      if (e && e.key === "Enter") {
        if (searchTimer) { window.clearTimeout(searchTimer); }
        updateClearAdventureSearchButton();
        if (isExplicitExperienceQuery(input.value)) {
          dismissAdventureKeyboard();
          setLens(input.value);
        } else if (clean(input.value)) {
          resolveDestinationAndScan(input.value);
        } else {
          dismissAdventureKeyboard();
          startAdventure();
        }
      }
    }, false);




    input.addEventListener("focus", function () {
      var q = clean(input.value);
      if (shouldSuppressDestinationChooser(q)) {
        hideDestinationResults();
        return;
      }
      if (q.length >= 3 && destinationSearchResults.length && destinationSearchWasIntentionallyChanged(q)) {
        renderDestinationResults(destinationSearchResults, q);
      }
    }, false);
  }




  if (go) {
    go.onclick = function () {
      var q = input ? clean(input.value) : "";
      /*
        V23: GO means explore the selected context. If the text is an
        experience/category, scan it. If it is a destination, show destination
        choices. If blank, scan around the user.
      */
      if (q && isExplicitExperienceQuery(q)) {
        dismissAdventureKeyboard();
        setLens(q);
      } else if (q) {
        resolveDestinationAndScan(q);
      } else {
        dismissAdventureKeyboard();
        startAdventure();
      }
    };
  }




  if (gps) { gps.onclick = function () { waitingForGpsQuery = activeLens && activeLens.length > 2 ? activeLens : "popular tonight local favorites"; requestGPS(true); if (lastFix) { startAdventure(); } }; }
  if (center) { center.onclick = centerAdventureMap; }
  if (start) { start.onclick = startAdventure; }




  ensureAdventureCategoryChips();
  bindChips();
  bindShellBackButtons();
  bindUpgradeButtons();
  setStartReady(false);
}




function initMap() {
  if (!window.mapboxgl) { toast("Mapbox missing"); return; }
  if (!MAPBOX_TOKEN) { toast("Missing Mapbox token"); return; }
  try {
    mapboxgl.accessToken = MAPBOX_TOKEN;
    map = new mapboxgl.Map({ container: "adventureMap", style: "mapbox://styles/mapbox/navigation-night-v1", center: [-89.987, 35.149], zoom: 10.6, pitch: 0, bearing: 0, attributionControl: false });
    window.DRIVE_IQ_ADVENTURE_MAP = map;
    enableFreeFlowGestures();
    map.on("load", function () {
      mapLoaded = true;
      ensureSources();
      ensureResultSources();
      injectAdventurePolishStyles();
      ensureExploreNearbyButton();
      restoreState();
      diqApplySeoIntentHandoff();
      restoreGPS();
      syncExploreNearbyButton();
      applyAdventureMapFirstCompatibility();
      setStatus("adventureRouteStatus", routeGeo ? "ROUTE READY" : "READY TO EXPLORE", routeGeo ? "green" : "");
      toast("Adventure map ready");
    });
    map.on("style.load", function () {
      mapLoaded = true;
      window.setTimeout(function () {
        rerenderAdventureAfterStyle();
        syncExploreNearbyButton();
      }, 120);
    });
    map.on("error", function () { setStatus("adventureRouteStatus", "MAP WARNING", "gold"); toast("Map warning"); });
  } catch (e) { setStatus("adventureRouteStatus", "MAP FAILED", "red"); toast("Map failed"); }
}








/* =========================================================
   DRIVE IQ V22.5 â€” MAP-FIRST ADVENTURE JS COMPATIBILITY LOCK
   Keeps Adventure IQ map-first even when HTML/CSS has been reverted.
   Safe CSS-only rescue + adaptive scan copy. ES5-safe.
========================================================= */
window.__DRIVE_IQ_ADVENTURE_MODE_JS_V22_5_MAP_FIRST__ = true;




function injectAdventureMapFirstCompatibilityStyles() {
  var style;
  var css;
  if (byId("diqAdventureV22_5MapFirstCompatStyle")) { return; }
  css =
    "#adventureApp{overflow:hidden!important;}" +
    "#adventureApp.adventureMapFirst .topWrap{pointer-events:none!important;}" +
    "#adventureApp.adventureMapFirst .topWrap .adventureBackBtn,#adventureApp.adventureMapFirst .topWrap .hero{pointer-events:auto!important;}" +
    "#adventureApp.adventureMapFirst .hero{max-height:calc(54vh - env(safe-area-inset-top,0px))!important;overflow-y:auto!important;overflow-x:hidden!important;-webkit-overflow-scrolling:touch!important;padding-bottom:12px!important;}" +
    "#adventureApp.adventureMapFirst .title{font-size:22px!important;line-height:1.02!important;padding-right:40px!important;}" +
    "#adventureApp.adventureMapFirst .sub{font-size:10px!important;line-height:1.15!important;}" +
    "#adventureApp.adventureMapFirst .localGuideLine{min-height:24px!important;font-size:8.2px!important;padding:0 9px!important;}" +
    "#adventureApp.adventureMapFirst .experienceMood{font-size:11px!important;margin-top:7px!important;}" +
    "#adventureApp.adventureMapFirst .adventureStrip,#adventureApp.adventureMapFirst .iqPillRow{display:flex!important;overflow-x:auto!important;overflow-y:hidden!important;-webkit-overflow-scrolling:touch!important;scrollbar-width:none!important;padding-bottom:3px!important;}" +
    "#adventureApp.adventureMapFirst .adventureStrip::-webkit-scrollbar,#adventureApp.adventureMapFirst .iqPillRow::-webkit-scrollbar{display:none!important;}" +
    "#adventureApp.adventureMapFirst .chip{min-height:31px!important;padding:0 9px!important;font-size:8px!important;}" +
    "#adventureApp.adventureMapFirst .iqPill{min-height:24px!important;font-size:7.2px!important;padding:0 8px!important;}" +
    "#adventureApp.adventureMapFirst .adventureCenter{min-height:30px!important;padding:5px 8px!important;}" +
    "#adventureApp.adventureMapFirst .gpsRow{gap:7px!important;margin-top:8px!important;}" +
    "#adventureApp.adventureMapFirst .gpsBtn{min-height:36px!important;font-size:8.8px!important;border-radius:14px!important;}" +
    "#adventureApp.adventureMapFirst .bottom{gap:7px!important;}" +
    "#adventureApp.adventureMapFirst .horizon{max-height:22vh!important;overflow-y:auto!important;-webkit-overflow-scrolling:touch!important;padding:8px!important;border-radius:20px!important;}" +
    "#adventureApp.adventureMapFirst .grid{display:flex!important;gap:7px!important;overflow-x:auto!important;scrollbar-width:none!important;padding-bottom:2px!important;}" +
    "#adventureApp.adventureMapFirst .grid::-webkit-scrollbar{display:none!important;}" +
    "#adventureApp.adventureMapFirst .tile{flex:0 0 132px!important;min-height:48px!important;padding:7px!important;border-radius:15px!important;}" +
    "#adventureApp.adventureMapFirst .tile strong{font-size:9px!important;}" +
    "#adventureApp.adventureMapFirst .tile span{font-size:8px!important;}" +
    "#adventureApp.adventureMapFirst .routeCard{padding:7px!important;border-radius:19px!important;}" +
    "#adventureApp.adventureMapFirst .startAdventure{min-height:46px!important;border-radius:16px!important;font-size:12px!important;}" +
    "body.adventureManualMinimized #adventureApp .hero,body.adventureManualMinimized #adventureApp #adventureHorizon{display:none!important;}" +
    "body.adventureManualMinimized #adventureApp .adventureShade{background:linear-gradient(180deg,rgba(2,8,18,.26),rgba(2,8,18,.01) 32%,rgba(2,8,18,.08) 70%,rgba(2,8,18,.84))!important;}" +
    "body.adventureScanResultsMode #adventureApp .hero{max-height:72px!important;overflow:hidden!important;}" +
    "body.adventureScanResultsMode #adventureApp .bottom .horizon{display:none!important;}" +
    "body.adventureScanResultsMode #adventureApp .scanPeek{display:flex!important;}" +
    "@media(max-height:760px){#adventureApp.adventureMapFirst .hero{max-height:calc(48vh - env(safe-area-inset-top,0px))!important;}#adventureApp.adventureMapFirst .localGuideLine,#adventureApp.adventureMapFirst .iqPillRow{display:none!important;}#adventureApp.adventureMapFirst .horizon{display:none!important;}}" +
    "@media(orientation:landscape){#adventureApp.adventureMapFirst .hero{max-height:calc(100vh - 92px - env(safe-area-inset-top,0px))!important;}#adventureApp.adventureMapFirst .bottom{display:grid!important;grid-template-columns:1fr 210px!important;}#adventureApp.adventureMapFirst .horizon{max-height:34vh!important;}}";
  style = document.createElement("style");
  style.id = "diqAdventureV22_5MapFirstCompatStyle";
  style.type = "text/css";
  style.appendChild(document.createTextNode(css));
  try { document.head.appendChild(style); } catch (e) {}
}




function applyAdventureMapFirstCompatibility() {
  var app = byId("adventureApp");
  var gps = byId("lockGps");
  var start = byId("startAdventure");
  var centerName;
  injectAdventureMapFirstCompatibilityStyles();
  if (app) { app.className = clean(String(app.className || "") + " adventureMapFirst"); }




  if (destination && gps) {
    centerName = clean(destination.label || "destination").split(",")[0];
    gps.textContent = centerName ? "SCAN " + centerName.toUpperCase().slice(0, 16) : "SCAN DESTINATION";
  } else if (gps) {
    gps.textContent = "SCAN NEAR ME";
  }




  if (start && !start.disabled && activeLens && activeLens !== "destination") {
    start.textContent = "START ADVENTURE";
  }
}




function boot() {
  try{
    diqFounderIQTrack("adventure_mode_opened",{
      destination_available:destination ? 1 : 0,
      scope:String(adventureSearchScope || ""),
      lens:String(activeLens || "")
    });
  }catch(founderIQBootErr){}

  window.DRIVE_IQ_EXPLORE_NEARBY = startExploreNearby;
  window.DRIVE_IQ_ADVENTURE_SCAN_DESTINATION = scanAdventureChoices;
  window.DRIVE_IQ_ADVENTURE_OPEN_UPGRADE = openUpgradeSheet;
  window.DRIVE_IQ_ADVENTURE_BEGIN_UPGRADE = beginUpgrade;
  window.DRIVE_IQ_OPEN_UPGRADE = openUpgradeSheet;
  window.DRIVE_IQ_BEGIN_UPGRADE = beginUpgrade;
  document.body.setAttribute("data-drive-iq-adventure", "v24-polish-scan-reliability-iq");
  injectAdventurePolishStyles();
  injectAdventureV21Styles();
  injectAdventureMapFirstCompatibilityStyles();
  ensureAdventureMapDock();
  bind();
  applyAdventureMapFirstCompatibility();
  initMap();
  window.setTimeout(function () {
    if (mapLoaded) { diqApplySeoIntentHandoff(); }
  }, 600);
}




if (document.readyState === "loading") { document.addEventListener("DOMContentLoaded", boot, false); }
else { boot(); }








/* =========================================================
   DRIVE IQ V23.1 â€” SCAN RELIABILITY IQ + LAKE IQ
   Universal fallback ladder:
   direct query -> category fallbacks -> radius/district/lake expansions.
   Discovery-first: scans return pins + Place IQ cards before routing.
========================================================= */




window.__DRIVE_IQ_ADVENTURE_MODE_JS_V23_1_SCAN_RELIABILITY_LAKE_IQ__ = true;




function diqV231ScanText(query) {
  return normText(String(query || "") + " " + String(destination && destination.label || "") + " " + String(adventureSearchCenter && adventureSearchCenter.label || ""));
}




function isLakeIQQuery(query) {
  var q = normText(query);
  if (!q) { return false; }
  return hasAnyTruthSignal(q, [
    "lake iq", "pickwick lake", "pickwick landing", "table rock lake",
    "lake of the ozarks", "lake guntersville", "kentucky lake", "smith lake",
    "beaver lake", "grand lake", "norris lake", "dale hollow lake",
    "lake marina", "lake boat ramp", "lake boat launch", "lake fishing",
    "lakefront", "dockside lake", "lake cove"
  ]);
}




function isLakeIQContext() {
  var q = diqV231ScanText("");
  return hasAnyTruthSignal(q, [
    "lake", "pickwick", "pickwick landing", "counce", "table rock",
    "lake of the ozarks", "guntersville", "kentucky lake", "smith lake",
    "beaver lake", "grand lake", "norris lake", "dale hollow", "marina"
  ]);
}




function lakeIQLocationPrefix() {
  var s = clean(String(adventureSearchCenter && adventureSearchCenter.label || destination && destination.label || ""));
  var q = normText(s);
  if (!s) { return ""; }
  if (q.indexOf("pickwick") > -1) { return "Pickwick Lake "; }
  if (q.indexOf("table rock") > -1) { return "Table Rock Lake "; }
  if (q.indexOf("ozark") > -1) { return "Lake of the Ozarks "; }
  if (q.indexOf("guntersville") > -1) { return "Lake Guntersville "; }
  if (q.indexOf("kentucky lake") > -1) { return "Kentucky Lake "; }
  if (q.indexOf("smith lake") > -1) { return "Smith Lake "; }
  return s + " ";
}




function categoryFromQuery(query) {
  var q = normText(query);
  if (!q) { return ""; }




  /* V24: Explicit experience intent always wins over destination context.
     A lake destination may enrich the search, but must never turn Live Music,
     Food, Patio, or Popular Tonight into a generic Lake IQ scan. */
  if (q.indexOf("sunset") > -1 || q.indexOf("golden hour") > -1 || q.indexOf("sun down") > -1 || q.indexOf("sundown") > -1) { return "sunset"; }
  if (q.indexOf("photo") > -1 || q.indexOf("instagram") > -1 || q.indexOf("picture spot") > -1 || q.indexOf("selfie") > -1) { return "photo spots"; }
  if (q.indexOf("dog") > -1 || q.indexOf("pet friendly") > -1 || q.indexOf("dog friendly") > -1) { return "dog friendly"; }
  if (q.indexOf("family") > -1 || q.indexOf("kids") > -1 || q.indexOf("children") > -1 || q.indexOf("ice cream") > -1) { return "family"; }
  if (q.indexOf("bachelor") > -1 || q.indexOf("bachelorette") > -1 || q.indexOf("girls trip") > -1 || q.indexOf("guys trip") > -1) { return "bach trip"; }
  if (q.indexOf("gameday") > -1 || q.indexOf("game day") > -1 || q.indexOf("tailgate") > -1 || q.indexOf("watch game") > -1 || q.indexOf("sports bar") > -1) { return "gameday"; }
  if (q.indexOf("live music") > -1 || q.indexOf("music venue") > -1 || q.indexOf("concert") > -1 || q.indexOf("band") > -1 || q.indexOf("acoustic") > -1 || q.indexOf("jazz") > -1 || q.indexOf("karaoke") > -1 || q.indexOf("open mic") > -1) { return "live music"; }
  if (q.indexOf("popular") > -1 || q.indexOf("tonight") > -1 || q.indexOf("happening") > -1 || q.indexOf("trending") > -1 || q.indexOf("nightlife") > -1) { return "popular tonight"; }
  if (q.indexOf("patio") > -1 || q.indexOf("outside dining") > -1 || q.indexOf("outdoor seating") > -1 || q.indexOf("outdoor dining") > -1 || q.indexOf("al fresco") > -1 || q.indexOf("alfresco") > -1 || q.indexOf("terrace") > -1 || q.indexOf("courtyard") > -1 || q.indexOf("beer garden") > -1 || q.indexOf("fire pit") > -1) { return "patio vibes"; }
  if (q.indexOf("coffee") > -1 || q.indexOf("cafe") > -1 || q.indexOf("espresso") > -1 || q.indexOf("bakery") > -1) { return "coffee"; }
  if (q.indexOf("local favorite") > -1 || q.indexOf("locals") > -1 || q.indexOf("local picks") > -1 || q.indexOf("where locals go") > -1) { return "local favorites"; }
  if (q.indexOf("waterfront") > -1 || q.indexOf("water front") > -1 || q.indexOf("rooftop") > -1 || q.indexOf("marina") > -1 || q.indexOf("lakefront") > -1 || q.indexOf("riverfront") > -1 || q.indexOf("beach bar") > -1 || q.indexOf("riverwalk") > -1 || q.indexOf("dockside") > -1) { return "waterfront"; }
  if (q.indexOf("food") > -1 || q.indexOf("drink") > -1 || q.indexOf("restaurant") > -1 || q.indexOf("bar") > -1 || q.indexOf("brewery") > -1 || q.indexOf("bbq") > -1 || q.indexOf("taco") > -1 || q.indexOf("seafood") > -1) { return "food drinks"; }
  if (q.indexOf("camp") > -1 || q.indexOf("rv") > -1 || q.indexOf("koa") > -1 || q.indexOf("cabin") > -1 || q.indexOf("lodge") > -1) { return "camping"; }
  if (q.indexOf("run") > -1 || q.indexOf("jog") > -1 || q.indexOf("walk") > -1 || q.indexOf("greenway") > -1 || q.indexOf("boardwalk") > -1 || q.indexOf("track") > -1 || q.indexOf("paved trail") > -1 || q.indexOf("shoreline walk") > -1 || q.indexOf("beach walk") > -1) { return "run walk"; }
  if (q.indexOf("waterfall") > -1 || q.indexOf("falls") > -1) { return "waterfalls"; }
  if (q.indexOf("cave") > -1 || q.indexOf("cavern") > -1) { return "caves"; }
  if (q.indexOf("outdoor") > -1 || q.indexOf("outdoors") > -1 || q.indexOf("trail") > -1 || q.indexOf("hiking") > -1 || q.indexOf("bike") > -1) { return "trails"; }
  if (q.indexOf("park") > -1 || q.indexOf("preserve") > -1 || q.indexOf("state park") > -1 || q.indexOf("national park") > -1) { return "parks"; }
  if (q.indexOf("scenic") > -1 || q.indexOf("overlook") > -1 || q.indexOf("lookout") > -1 || q.indexOf("viewpoint") > -1 || q.indexOf("scenic view") > -1) { return "scenic"; }
  if (q.indexOf("hidden") > -1 || q.indexOf("gem") > -1 || q.indexOf("landmark") > -1) { return "hidden gems"; }
  /* V24.1 Destination Search Fix:
     City names must remain destinations. Only explicit experience language
     should activate College Town IQ. This prevents Oxford, Starkville,
     Tuscaloosa, Auburn, Knoxville, Athens, Fayetteville, and College Station
     from bypassing the destination chooser and scanning around the user. */
  if (q.indexOf("college town") > -1 || q.indexOf("campus favorites") > -1 || q.indexOf("campus life") > -1 || q.indexOf("near campus") > -1 || q.indexOf("university district") > -1 || q.indexOf("college nightlife") > -1 || q.indexOf("college bars") > -1 || q.indexOf("the square nightlife") > -1) { return "college town"; }
  if (isLakeIQQuery(q)) { return "lake iq"; }
  if (q.indexOf("water") > -1 || q.indexOf("beach") > -1 || q.indexOf("river") > -1 || q.indexOf("shore") > -1 || q.indexOf("boat") > -1 || q.indexOf("pier") > -1 || q === "lake") { return "water"; }
  return "";
}
function diqV231AddUnique(list, value) {
  var i;
  value = clean(value);
  if (!value) { return; }
  for (i = 0; i < list.length; i++) {
    if (normText(list[i]) === normText(value)) { return; }
  }
  list.push(value);
}




function diqV231AddWithPlace(list, value) {
  var place = lakeIQLocationPrefix();
  diqV231AddUnique(list, value);
  if (place) { diqV231AddUnique(list, place + value); }
}




function buildAdventureQueries(query) {
  var q = clean(query);
  var cat = categoryFromQuery(q);
  var out = [];
  var place = lakeIQLocationPrefix();




  diqV231AddUnique(out, q);




  if (cat === "lake iq") {
    diqV231AddWithPlace(out, "waterfront restaurant");
    diqV231AddWithPlace(out, "marina");
    diqV231AddWithPlace(out, "boat ramp");
    diqV231AddWithPlace(out, "boat launch");
    diqV231AddWithPlace(out, "fishing access");
    diqV231AddWithPlace(out, "bait and tackle");
    diqV231AddWithPlace(out, "boat rental");
    diqV231AddWithPlace(out, "state park");
    diqV231AddWithPlace(out, "campground");
    diqV231AddWithPlace(out, "rv park");
    diqV231AddWithPlace(out, "cabins");
    diqV231AddWithPlace(out, "lodge");
    diqV231AddWithPlace(out, "live music");
    diqV231AddWithPlace(out, "sunset overlook");
    diqV231AddWithPlace(out, "waterfront bar");
    diqV231AddWithPlace(out, "dockside restaurant");
    diqV231AddWithPlace(out, "local favorite restaurant");
    if (normText(place).indexOf("pickwick") > -1 || normText(q).indexOf("pickwick") > -1) {
      diqV231AddUnique(out, "Pickwick Landing State Park");
      diqV231AddUnique(out, "Pickwick Landing marina");
      diqV231AddUnique(out, "Counce TN restaurants");
      diqV231AddUnique(out, "Savannah TN waterfront restaurant");
      diqV231AddUnique(out, "Pickwick Dam");
      diqV231AddUnique(out, "Pickwick Lake boat ramp");
      diqV231AddUnique(out, "Pickwick Lake campground");
    }
  } else if (cat === "live music") {
    diqV231AddWithPlace(out, "live music tonight");
    diqV231AddWithPlace(out, "live music");
    diqV231AddWithPlace(out, "music venue");
    diqV231AddWithPlace(out, "event venue");
    diqV231AddWithPlace(out, "local band");
    diqV231AddWithPlace(out, "open mic");
    diqV231AddWithPlace(out, "karaoke");
    diqV231AddWithPlace(out, "bar");
    diqV231AddWithPlace(out, "pub");
    diqV231AddWithPlace(out, "tavern");
    diqV231AddWithPlace(out, "brewery");
    diqV231AddWithPlace(out, "taproom");
    diqV231AddWithPlace(out, "waterfront bar");
    diqV231AddWithPlace(out, "marina bar");
    diqV231AddWithPlace(out, "restaurant bar");
    diqV231AddWithPlace(out, "entertainment district");
    diqV231AddWithPlace(out, "popular tonight");
  } else if (cat === "waterfront" || cat === "water") {
    diqV231AddWithPlace(out, "waterfront restaurant");
    diqV231AddWithPlace(out, "waterfront bar");
    diqV231AddWithPlace(out, "dockside restaurant");
    diqV231AddWithPlace(out, "marina restaurant");
    diqV231AddWithPlace(out, "beachfront restaurant");
    diqV231AddWithPlace(out, "riverfront restaurant");
    diqV231AddWithPlace(out, "water view restaurant");
    diqV231AddWithPlace(out, "waterfront park");
    diqV231AddWithPlace(out, "boat ramp");
    diqV231AddWithPlace(out, "fishing pier");
    diqV231AddWithPlace(out, "sunset spot");
  } else if (cat === "hidden gems") {
    diqV231AddWithPlace(out, "hidden gems");
    diqV231AddWithPlace(out, "local favorite");
    diqV231AddWithPlace(out, "scenic overlook");
    diqV231AddWithPlace(out, "landmark");
    diqV231AddWithPlace(out, "park");
    diqV231AddWithPlace(out, "attraction");
    diqV231AddWithPlace(out, "historic site");
    diqV231AddWithPlace(out, "local restaurant");
    diqV231AddWithPlace(out, "unique places");
  } else if (cat === "family") {
    diqV231AddWithPlace(out, "family friendly");
    diqV231AddWithPlace(out, "park");
    diqV231AddWithPlace(out, "playground");
    diqV231AddWithPlace(out, "museum");
    diqV231AddWithPlace(out, "ice cream");
    diqV231AddWithPlace(out, "arcade");
    diqV231AddWithPlace(out, "zoo");
    diqV231AddWithPlace(out, "family restaurant");
  } else if (cat === "dog friendly") {
    diqV231AddWithPlace(out, "dog friendly patio");
    diqV231AddWithPlace(out, "dog friendly restaurant");
    diqV231AddWithPlace(out, "dog park");
    diqV231AddWithPlace(out, "trail");
    diqV231AddWithPlace(out, "park");
    diqV231AddWithPlace(out, "pet friendly");
  } else if (cat === "sunset" || cat === "photo spots") {
    diqV231AddWithPlace(out, "sunset overlook");
    diqV231AddWithPlace(out, "scenic overlook");
    diqV231AddWithPlace(out, "waterfront park");
    diqV231AddWithPlace(out, "beach");
    diqV231AddWithPlace(out, "rooftop bar");
    diqV231AddWithPlace(out, "photo spot");
    diqV231AddWithPlace(out, "scenic view");
    diqV231AddWithPlace(out, "boardwalk");
  } else if (cat === "college town") {
    diqV231AddWithPlace(out, "college town coffee");
    diqV231AddWithPlace(out, "campus favorite");
    diqV231AddWithPlace(out, "sports bar");
    diqV231AddWithPlace(out, "late night food");
    diqV231AddWithPlace(out, "brunch");
    diqV231AddWithPlace(out, "bookstore");
    diqV231AddWithPlace(out, "town square");
    diqV231AddWithPlace(out, "local favorite restaurant");
  } else if (cat === "gameday") {
    diqV231AddWithPlace(out, "sports bar");
    diqV231AddWithPlace(out, "watch game");
    diqV231AddWithPlace(out, "tailgate");
    diqV231AddWithPlace(out, "bar and grill");
    diqV231AddWithPlace(out, "brewery");
    diqV231AddWithPlace(out, "parking");
    diqV231AddWithPlace(out, "pregame restaurant");
  } else if (cat === "bach trip") {
    diqV231AddWithPlace(out, "brunch");
    diqV231AddWithPlace(out, "rooftop bar");
    diqV231AddWithPlace(out, "live music");
    diqV231AddWithPlace(out, "cocktail bar");
    diqV231AddWithPlace(out, "nightlife");
    diqV231AddWithPlace(out, "photo spot");
    diqV231AddWithPlace(out, "popular tonight");
  } else if (cat === "coffee") {
    diqV231AddWithPlace(out, "coffee shop");
    diqV231AddWithPlace(out, "cafe");
    diqV231AddWithPlace(out, "bakery");
    diqV231AddWithPlace(out, "espresso");
    diqV231AddWithPlace(out, "breakfast");
    diqV231AddWithPlace(out, "local coffee");
  } else if (cat === "food drinks" || cat === "patio vibes" || cat === "popular tonight" || cat === "local favorites") {
    diqV231AddWithPlace(out, "local favorite restaurant");
    diqV231AddWithPlace(out, "restaurant");
    diqV231AddWithPlace(out, "bar and grill");
    diqV231AddWithPlace(out, "brewery");
    diqV231AddWithPlace(out, "patio restaurant");
    diqV231AddWithPlace(out, "brunch");
    diqV231AddWithPlace(out, "seafood restaurant");
    diqV231AddWithPlace(out, "popular tonight");
    diqV231AddWithPlace(out, "downtown");
  } else if (cat === "camping" || cat === "trails" || cat === "parks" || cat === "scenic" || cat === "waterfalls" || cat === "caves" || cat === "run walk") {
    diqV231AddWithPlace(out, "state park");
    diqV231AddWithPlace(out, "park");
    diqV231AddWithPlace(out, "trail");
    diqV231AddWithPlace(out, "scenic overlook");
    diqV231AddWithPlace(out, "campground");
    diqV231AddWithPlace(out, "rv park");
    diqV231AddWithPlace(out, "waterfall");
    diqV231AddWithPlace(out, "nature preserve");
    diqV231AddWithPlace(out, "walking trail");
  }




  /* District expansion: these are intentionally broad and late in the list. */
  diqV231AddWithPlace(out, "downtown");
  diqV231AddWithPlace(out, "town square");
  diqV231AddWithPlace(out, "main street");
  diqV231AddWithPlace(out, "harbor");
  diqV231AddWithPlace(out, "marina");
  diqV231AddWithPlace(out, "state park");
  diqV231AddWithPlace(out, "local favorite");
  return out.slice(0, 42);
}




function genericAdventureRadius(query) {
  var type = categoryFromQuery(query);
  if (type === "coffee") { return 18; }
  if (type === "family" || type === "dog friendly") { return 24; }
  if (type === "popular tonight" || type === "food drinks" || type === "patio vibes" || type === "local favorites") { return 28; }
  if (type === "live music" || type === "gameday" || type === "bach trip") { return 35; }
  if (type === "waterfront" || type === "water" || type === "sunset" || type === "photo spots") { return 45; }
  if (type === "lake iq") { return 60; }
  if (type === "hidden gems" || type === "college town") { return 45; }
  if (type === "camping" || type === "trails" || type === "waterfalls" || type === "caves" || type === "parks" || type === "scenic") { return 70; }
  if (type) { return 45; }
  return 0;
}




function noNearbyMessage(query) {
  var type = categoryFromQuery(query);
  if (type === "lake iq") { return "Lake IQ expanded to marinas, boat ramps, waterfront food, parks, and nearby lake towns"; }
  if (type === "live music") { return "No confirmed live music yet â€” checking bars, breweries, venues, and popular nightlife"; }
  if (type === "waterfront") { return "No exact waterfront yet â€” checking dockside, marina, creekside, and water-view spots"; }
  if (type === "hidden gems") { return "Checking parks, local favorites, scenic spots, and unique stops nearby"; }
  if (type === "sunset") { return "Checking overlooks, waterfront, beaches, parks, and photo spots"; }
  return "Expanded the scan for nearby places worth exploring";
}




function isStrictAdventureCategoryMatch(item, query) {
  var category = categoryFromQuery(query);
  var txt = adventureTruthText(item);
  var retailNoise;




  if (!category || !item) { return true; }




  retailNoise = hasAnyTruthSignal(txt, [
    "beauty", "cosmetic", "ulta", "salon", "department store", "clothing", "apparel",
    "shoe store", "retail", "shopping mall", "supermarket", "grocery", "pharmacy",
    "drugstore", "hardware", "furniture", "automotive", "car dealer", "bank",
    "insurance", "real estate", "storage", "warehouse", "office supply"
  ]);




  if (retailNoise && category !== "local favorites" && category !== "hidden gems") { return false; }




  if (category === "live music") {
    return hasAnyTruthSignal(txt, ["live music","music","concert","band","karaoke","open mic","bar","pub","tavern","brewery","taproom","venue","nightclub","restaurant","grill","lounge","patio","waterfront","marina"]);
  }
  if (category === "lake iq") {
    return hasAnyTruthSignal(txt, ["lake","marina","boat","ramp","launch","fishing","bait","tackle","waterfront","dock","dockside","state park","park","campground","rv","cabin","lodge","restaurant","bar","grill","cove","dam","landing","pickwick"]);
  }
  if (category === "waterfront" || category === "water") {
    return hasAnyTruthSignal(txt, ["water","waterfront","river","lake","beach","marina","dock","harbor","pier","bay","creek","waterfall","restaurant","bar","park","boat"]);
  }
  if (category === "sunset" || category === "photo spots") {
    return hasAnyTruthSignal(txt, ["overlook","view","scenic","waterfront","beach","park","rooftop","river","lake","marina","trail","photo","historic","landmark"]);
  }
  if (category === "coffee") {
    return hasAnyTruthSignal(txt, ["coffee","cafe","bakery","espresso","breakfast","restaurant"]);
  }
  if (category === "family") {
    return hasAnyTruthSignal(txt, ["family","kids","park","playground","museum","ice cream","zoo","arcade","restaurant","attraction"]);
  }
  if (category === "dog friendly") {
    return hasAnyTruthSignal(txt, ["dog","pet","park","trail","patio","restaurant","brewery","outdoor"]);
  }
  if (category === "gameday") {
    return hasAnyTruthSignal(txt, ["sports","bar","grill","brewery","stadium","restaurant","tailgate","parking","game"]);
  }
  if (category === "college town") {
    return hasAnyTruthSignal(txt, ["college","campus","university","square","coffee","bar","restaurant","bookstore","sports","late night","downtown"]);
  }
  if (category === "bach trip") {
    return hasAnyTruthSignal(txt, ["brunch","bar","rooftop","cocktail","nightlife","music","restaurant","photo","lounge","club"]);
  }




  return true;
}




function speakAdventureScanEmpty(query) {
  var label = adventureScanCategoryLabel(query);
  var line = "I expanded the " + label + " scan. Iâ€™m checking nearby categories, districts, and wider radius options for places worth exploring.";
  speakAdventureScanVoice(line, "scan_empty_expanded|" + adventureScanVoiceToken + "|" + label, 1000);
}




function diqV231ApplyScanReliabilityUi(message, state) {
  var bar = byId("adventureReliabilityStatus");
  if (bar) {
    bar.textContent = String(message || "Scan Reliability IQ active");
    bar.className = state === "green" ? "scanReliabilityBar green" : state === "gold" ? "scanReliabilityBar gold" : "scanReliabilityBar";
  }
}








/* =========================================================
   DRIVE IQ V25.5 â€” CATEGORY TRUTH + ADAPTIVE VARIETY IQ




   Product rules:
   - Every category owns a distinct query vocabulary and truth gate.
   - Nightlife means true after-dinner / late-night usefulness.
   - Generic restaurants do not become nightlife without nightlife evidence.
   - Consecutive scans should feel different when strong alternatives exist.
   - Multi-fit anchors may repeat when they genuinely earn several categories.
   - Small destinations may reuse a few strong venues; large markets diversify.
========================================================= */




var DIQ_V255_VARIETY = {
  previousCategory:"",
  previousKeys:[],
  previousTopKeys:[],
  previousAt:0,
  history:{},
  maxHistoryCategories:6
};




var diqV255OriginalCategoryFromQuery = categoryFromQuery;
var diqV255OriginalBuildAdventureQueries = buildAdventureQueries;
var diqV255OriginalStrictMatch = isStrictAdventureCategoryMatch;
var diqV255OriginalScoreAdventure = scoreAdventure;
var diqV255OriginalSortAdventureResults = sortAdventureResults;
var diqV255OriginalAfterScanResultsReady = afterScanResultsReady;




function diqV255ItemKey(item) {
  var label = normText(item && item.label || "");
  var lat = item && finite(Number(item.lat)) ? Number(item.lat).toFixed(4) : "";
  var lng = item && finite(Number(item.lng)) ? Number(item.lng).toFixed(4) : "";
  return label + "|" + lat + "|" + lng;
}




function diqV255Truth(item) {
  return normText(
    String(item && item.label || "") + " " +
    String(item && item.full || "") + " " +
    String(item && item.kind || "") + " " +
    String(item && item.placeCategories || "") + " " +
    String(item && item.placeClass || "") + " " +
    String(item && item.sourceQuery || "") + " " +
    String(item && item.matchLabel || "")
  );
}




function diqV255Has(txt, signals) {
  var i;
  for (i = 0; i < signals.length; i++) {
    if (txt.indexOf(signals[i]) > -1) { return true; }
  }
  return false;
}




function diqV255DestinationLocalHour() {
  var center = getActiveSearchCenter();
  var now = new Date();
  var utcHour = now.getUTCHours() + now.getUTCMinutes() / 60;
  var lng;
  var offset;




  /*
    Geoapify result hours are not guaranteed in the current normalized object.
    Until richer hours arrive, longitude provides a stable destination-local
    approximation instead of incorrectly using the user's Mississippi clock
    for Boston, Destin, or a western destination.
  */
  if (center && finite(Number(center.lng))) {
    lng = Number(center.lng);
    offset = Math.round(lng / 15);
    return (utcHour + offset + 24) % 24;
  }




  return now.getHours() + now.getMinutes() / 60;
}




function diqV255NightPhase() {
  var h = diqV255DestinationLocalHour();
  if (h < 6) { return "after_midnight"; }
  if (h < 18) { return "preview"; }
  if (h < 21) { return "evening"; }
  return "late_night";
}




function diqV255LateNightEvidence(item) {
  var txt = diqV255Truth(item);




  return diqV255Has(txt, [
    "late night", "open late", "open until", "open till", "after hours",
    "midnight", "1 am", "2 am", "3 am", "nightclub", "dance club",
    "cocktail", "lounge", "karaoke", "sports bar", "pub", "tavern",
    "bar", "brewery", "taproom", "rooftop bar", "music venue"
  ]);
}




function diqV255CategoryEvidence(item, category) {
  var txt = diqV255Truth(item);
  var score = 0;




  if (!item || !category) { return 0; }




  if (category === "nightlife") {
    if (diqV255Has(txt, ["nightclub","dance club","cocktail lounge","cocktail bar","lounge","karaoke","sports bar"])) { score += 150; }
    if (diqV255Has(txt, ["bar","pub","tavern","brewery","taproom","rooftop bar","beer garden"])) { score += 115; }
    if (diqV255Has(txt, ["live music","music venue","concert","open mic","dj","dancing"])) { score += 105; }
    if (diqV255LateNightEvidence(item)) { score += 85; }
    if (diqV255Has(txt, ["restaurant","grill","kitchen","bistro","cafe"])) { score += 12; }
    if (diqV255Has(txt, ["breakfast","bakery","coffee shop","lunch","family restaurant"])) { score -= 95; }
  } else if (category === "live music") {
    if (diqV255Has(txt, ["live music","music venue","concert","band","acoustic","jazz","open mic","karaoke"])) { score += 165; }
    if (diqV255Has(txt, ["event venue","performing arts","amphitheater","theater","theatre"])) { score += 120; }
    if (diqV255Has(txt, ["bar","pub","tavern","brewery","taproom","nightclub","lounge"])) { score += 48; }
    if (diqV255Has(txt, ["music store","instrument store","music lesson","recording studio","radio station"])) { score -= 300; }
  } else if (category === "popular tonight") {
    if (diqV255Has(txt, ["popular","tonight","local favorite","downtown","square","event","entertainment"])) { score += 110; }
    if (diqV255Has(txt, ["restaurant","bar","brewery","dessert","patio","music","rooftop"])) { score += 58; }
  } else if (category === "patio vibes") {
    if (diqV255Has(txt, ["patio","outdoor seating","outdoor dining","terrace","courtyard","beer garden","rooftop"])) { score += 170; }
    if (diqV255Has(txt, ["restaurant","bar","brewery","cafe","grill","bistro"])) { score += 42; }
  } else if (category === "food iq" || category === "food drinks") {
    if (diqV255Has(txt, ["restaurant","grill","bbq","barbecue","burger","pizza","seafood","steak","taco","kitchen","diner","bakery","dessert","ice cream"])) { score += 135; }
    if (diqV255Has(txt, ["local favorite","must try","famous","signature","award"])) { score += 65; }
  } else if (category === "local favorites") {
    if (diqV255Has(txt, ["local favorite","local institution","historic","family owned","locally owned","downtown","square"])) { score += 140; }
    if (diqV255Has(txt, ["restaurant","bar","shop","park","attraction","coffee","bakery"])) { score += 45; }
  } else if (category === "hidden gems") {
    if (diqV255Has(txt, ["hidden gem","off the beaten path","unique","historic","landmark","local secret","scenic"])) { score += 150; }
    if (diqV255Has(txt, ["walmart","mcdonald","starbucks","taco bell","chick fil a","subway","chain"])) { score -= 180; }
    if (diqV255Has(txt, ["popular","shopping mall","big box"])) { score -= 60; }
  } else if (category === "waterfront" || category === "water") {
    if (diqV255Has(txt, ["waterfront","lakefront","riverfront","marina","dockside","beachfront","harbor","pier","riverwalk","water view"])) { score += 165; }
  } else if (category === "gameday") {
    if (diqV255Has(txt, ["sports bar","game day","gameday","tailgate","stadium","big screen","watch party"])) { score += 165; }
    if (diqV255Has(txt, ["bar","grill","brewery","restaurant"])) { score += 42; }
  } else if (category === "coffee") {
    if (diqV255Has(txt, ["coffee","cafe","espresso","roastery","bakery"])) { score += 160; }
  } else if (category === "family") {
    if (diqV255Has(txt, ["family","kids","children","playground","museum","zoo","arcade","ice cream"])) { score += 150; }
  }




  return score;
}




function diqV255StrongMultiFit(item, category) {
  return diqV255CategoryEvidence(item, category) >= 125;
}




function diqV255NightlifeTruth(item) {
  var txt = diqV255Truth(item);
  var strong = diqV255Has(txt, [
    "nightclub","dance club","cocktail bar","cocktail lounge","lounge",
    "karaoke","sports bar","bar","pub","tavern","brewery","taproom",
    "rooftop bar","beer garden","live music","music venue","open mic"
  ]);
  var restaurantOnly = diqV255Has(txt, ["restaurant","grill","kitchen","bistro","cafe","diner"]) && !strong;




  if (restaurantOnly && !diqV255LateNightEvidence(item)) { return false; }
  return strong || diqV255LateNightEvidence(item);
}




function diqV255AdaptiveRepeatPenalty(item, category, poolSize, rankIndex) {
  var key = diqV255ItemKey(item);
  var previous = DIQ_V255_VARIETY.previousKeys || [];
  var previousTop = DIQ_V255_VARIETY.previousTopKeys || [];
  var repeated = previous.indexOf(key) > -1;
  var repeatedTop = previousTop.indexOf(key) > -1;
  var strong = diqV255StrongMultiFit(item, category);
  var largePool = Number(poolSize || 0) >= 12;
  var mediumPool = Number(poolSize || 0) >= 7;
  var penalty = 0;




  if (!repeated || DIQ_V255_VARIETY.previousCategory === category) { return 0; }




  /*
    Large cities should feel fresh. Small inventories may keep true anchors.
    A Freddy T's-style venue can repeat when it strongly fits the new lane.
  */
  if (largePool) { penalty = strong ? 42 : 115; }
  else if (mediumPool) { penalty = strong ? 24 : 72; }
  else { penalty = strong ? 4 : 28; }




  if (repeatedTop && rankIndex < 5) {
    penalty += strong ? 12 : 45;
  }




  return penalty;
}




function diqV255CommitScanHistory(items, query) {
  var category = categoryFromQuery(query || activeLens || "");
  var keys = [];
  var topKeys = [];
  var i;
  var key;




  for (i = 0; i < (items || []).length && i < 12; i++) {
    key = diqV255ItemKey(items[i]);
    if (!key) { continue; }
    keys.push(key);
    if (i < 3) { topKeys.push(key); }
  }




  DIQ_V255_VARIETY.previousCategory = category;
  DIQ_V255_VARIETY.previousKeys = keys;
  DIQ_V255_VARIETY.previousTopKeys = topKeys;
  DIQ_V255_VARIETY.previousAt = Date.now();
  DIQ_V255_VARIETY.history[category] = keys.slice(0, 8);




  try {
    sessionStorage.setItem("diq_adventure_variety_v1", JSON.stringify({
      previousCategory:category,
      previousKeys:keys,
      previousTopKeys:topKeys,
      previousAt:DIQ_V255_VARIETY.previousAt
    }));
  } catch (e) {}
}




function diqV255RestoreVarietyState() {
  var saved;
  try {
    saved = safeParse(sessionStorage.getItem("diq_adventure_variety_v1"));
    if (!saved) { return; }
    if (Date.now() - Number(saved.previousAt || 0) > 45 * 60 * 1000) { return; }
    DIQ_V255_VARIETY.previousCategory = String(saved.previousCategory || "");
    DIQ_V255_VARIETY.previousKeys = saved.previousKeys || [];
    DIQ_V255_VARIETY.previousTopKeys = saved.previousTopKeys || [];
    DIQ_V255_VARIETY.previousAt = Number(saved.previousAt || 0);
  } catch (e) {}
}




diqV255RestoreVarietyState();




categoryFromQuery = function (query) {
  var q = normText(query);
  var base;




  if (!q) { return ""; }




  /*
    Keep Nightlife distinct from Popular Tonight.
    Explicit "live music" still owns the music lane.
  */
  if (
    q.indexOf("live music") > -1 ||
    q.indexOf("music venue") > -1 ||
    q.indexOf("concert") > -1 ||
    q.indexOf("band") > -1 ||
    q.indexOf("acoustic") > -1 ||
    q.indexOf("jazz") > -1 ||
    q.indexOf("open mic") > -1
  ) {
    return "live music";
  }




  if (
    q.indexOf("nightlife") > -1 ||
    q.indexOf("late night") > -1 ||
    q.indexOf("night club") > -1 ||
    q.indexOf("nightclub") > -1 ||
    q.indexOf("cocktail lounge") > -1 ||
    q.indexOf("bars open late") > -1
  ) {
    return "nightlife";
  }




  base = diqV255OriginalCategoryFromQuery(query);
  return base;
};




buildAdventureQueries = function (query) {
  var q = clean(query);
  var category = categoryFromQuery(q);
  var out = [];
  var place = lakeIQLocationPrefix();




  function add(v) {
    diqV231AddUnique(out, v);
  }




  function addPlace(v) {
    diqV231AddUnique(out, v);
    if (place) { diqV231AddUnique(out, clean(place + " " + v)); }
  }




  add(q);




  if (category === "nightlife") {
    addPlace("nightlife");
    addPlace("bars open late");
    addPlace("late night bar");
    addPlace("cocktail bar");
    addPlace("cocktail lounge");
    addPlace("nightclub");
    addPlace("dance club");
    addPlace("sports bar open late");
    addPlace("karaoke");
    addPlace("rooftop bar");
    addPlace("pub");
    addPlace("tavern");
    addPlace("brewery open late");
    addPlace("taproom");
    addPlace("downtown nightlife");
    addPlace("entertainment district");
  } else if (category === "live music") {
    addPlace("live music tonight");
    addPlace("live music venue");
    addPlace("concert venue");
    addPlace("local band");
    addPlace("acoustic music");
    addPlace("open mic");
    addPlace("jazz club");
    addPlace("karaoke");
    addPlace("bar with live music");
    addPlace("brewery with live music");
    addPlace("entertainment venue");
  } else if (category === "popular tonight") {
    addPlace("popular tonight");
    addPlace("things to do tonight");
    addPlace("local events tonight");
    addPlace("popular restaurant");
    addPlace("local favorite restaurant");
    addPlace("dessert open now");
    addPlace("patio restaurant");
    addPlace("downtown square");
    addPlace("entertainment district");
  } else if (category === "patio vibes") {
    addPlace("restaurant with patio");
    addPlace("outdoor dining");
    addPlace("outdoor seating restaurant");
    addPlace("courtyard restaurant");
    addPlace("terrace restaurant");
    addPlace("rooftop restaurant");
    addPlace("beer garden");
    addPlace("waterfront patio");
  } else if (category === "food iq" || category === "food drinks") {
    addPlace("local restaurant");
    addPlace("must try food");
    addPlace("local favorite food");
    addPlace("barbecue");
    addPlace("burger");
    addPlace("pizza");
    addPlace("seafood");
    addPlace("tacos");
    addPlace("dessert");
    addPlace("bakery");
    addPlace("diner");
  } else if (category === "local favorites") {
    addPlace("local favorite");
    addPlace("locally owned restaurant");
    addPlace("local institution");
    addPlace("historic restaurant");
    addPlace("downtown favorite");
    addPlace("family owned");
  } else if (category === "hidden gems") {
    addPlace("hidden gems");
    addPlace("off the beaten path");
    addPlace("unique local places");
    addPlace("historic landmark");
    addPlace("local secret");
    addPlace("scenic hidden spot");
    addPlace("small local restaurant");
  } else if (category === "gameday") {
    addPlace("sports bar");
    addPlace("watch the game");
    addPlace("gameday bar");
    addPlace("tailgate");
    addPlace("stadium bar");
    addPlace("brewery with TVs");
  } else {
    return diqV255OriginalBuildAdventureQueries(query);
  }




  return out.slice(0, 18);
};




isStrictAdventureCategoryMatch = function (item, query) {
  var category = categoryFromQuery(query);
  var evidence;




  if (!item || !category) { return diqV255OriginalStrictMatch(item, query); }




  if (category === "nightlife") {
    return diqV255NightlifeTruth(item);
  }




  if (category === "live music") {
    evidence = diqV255CategoryEvidence(item, category);
    return evidence >= 95;
  }




  if (category === "patio vibes") {
    return diqV255CategoryEvidence(item, category) >= 100;
  }




  if (category === "hidden gems") {
    return diqV255CategoryEvidence(item, category) > -40;
  }




  return diqV255OriginalStrictMatch(item, query);
};




scoreAdventure = function (item, query) {
  var category = categoryFromQuery(query);
  var score = diqV255OriginalScoreAdventure(item, query);
  var evidence = diqV255CategoryEvidence(item, category);
  var phase = diqV255NightPhase();




  if (!item) { return -9999; }




  score += evidence;




  if (category === "nightlife") {
    if (!diqV255NightlifeTruth(item)) { return -9999; }




    if (phase === "late_night" || phase === "after_midnight") {
      score += diqV255LateNightEvidence(item) ? 125 : -55;
    } else if (phase === "evening") {
      score += diqV255LateNightEvidence(item) ? 72 : 8;
    } else {
      /* Daytime scan becomes an evening preview, not a generic restaurant list. */
      score += diqV255StrongMultiFit(item, category) ? 35 : -25;
    }
  }




  if (category === "live music" && evidence < 95) { score -= 110; }
  if (category === "patio vibes" && evidence < 100) { score -= 90; }
  if (category === "hidden gems" && evidence < 35) { score -= 35; }




  return score;
};




sortAdventureResults = function (items, query) {
  var category = categoryFromQuery(query);
  var filtered = [];
  var ranked;
  var poolSize;
  var i;




  items = diqV22FilterExperienceResults(items || [], query);




  for (i = 0; i < items.length; i++) {
    if (isStrictAdventureCategoryMatch(items[i], query)) {
      filtered.push(items[i]);
    }
  }




  poolSize = filtered.length;




  ranked = filtered.sort(function (a, b) {
    var sa = scoreAdventure(a, query);
    var sb = scoreAdventure(b, query);
    var pa = diqV255AdaptiveRepeatPenalty(a, category, poolSize, 0);
    var pb = diqV255AdaptiveRepeatPenalty(b, category, poolSize, 0);
    var da = finite(Number(a.distMiles)) ? Number(a.distMiles) : 99999;
    var db = finite(Number(b.distMiles)) ? Number(b.distMiles) : 99999;




    sa -= pa;
    sb -= pb;




    if (Math.abs(sb - sa) > 10) { return sb - sa; }
    return da - db;
  });




  /*
    Top-three protection: in a healthy pool, a repeated general-purpose place
    cannot crowd out a fresh exact-category match. Strong multi-fit anchors
    remain eligible.
  */
  if (poolSize >= 8 && DIQ_V255_VARIETY.previousCategory && DIQ_V255_VARIETY.previousCategory !== category) {
    var fresh = [];
    var repeats = [];
    var result = [];
    var key;
    var repeated;
    var strong;




    for (i = 0; i < ranked.length; i++) {
      key = diqV255ItemKey(ranked[i]);
      repeated = DIQ_V255_VARIETY.previousKeys.indexOf(key) > -1;
      strong = diqV255StrongMultiFit(ranked[i], category);




      if (repeated && !strong) { repeats.push(ranked[i]); }
      else { fresh.push(ranked[i]); }
    }




    while (fresh.length && result.length < 6) { result.push(fresh.shift()); }




    /*
      Permit one earned repeat in the first six when it is a true multi-fit.
      Remaining repeats stay available lower in the list.
    */
    for (i = 0; i < ranked.length && result.length < 8; i++) {
      if (result.indexOf(ranked[i]) < 0) { result.push(ranked[i]); }
    }




    while (repeats.length && result.length < ranked.length) {
      if (result.indexOf(repeats[0]) < 0) { result.push(repeats[0]); }
      repeats.shift();
    }




    ranked = result;
  }




  return ranked;
};




afterScanResultsReady = function (items, preferred, reason) {
  var result = diqV255OriginalAfterScanResultsReady(items, preferred, reason);
  diqV255CommitScanHistory(items || [], activeScanQuery || activeLens || "");
  return result;
};








/* =========================================================
   DRIVE IQ V25.6 â€” CATEGORY TRUTH LOCK




   Prevent category leakage:
   - No hotels/motels, worship places, cities, addresses, or generic services
     inside Hidden Gems, Local Favorites, Nightlife, Live Music, or Patio.
   - Every experiential category requires positive category evidence.
   - Query-source evidence may support a venue, but cannot rescue a clearly
     wrong place type.
========================================================= */




var diqV256OriginalStrictMatch = isStrictAdventureCategoryMatch;
var diqV256OriginalScoreAdventure = scoreAdventure;




function diqV256TypeText(item) {
  return normText(
    String(item && item.label || "") + " " +
    String(item && item.full || "") + " " +
    String(item && item.kind || "") + " " +
    String(item && item.category || "") + " " +
    String(item && item.placeCategories || "") + " " +
    String(item && item.placeClass || "") + " " +
    String(item && item.matchLabel || "")
  );
}




function diqV256SourceText(item) {
  return normText(String(item && item.sourceQuery || ""));
}




function diqV256IsAdministrativeOrGenericEntity(item) {
  var txt = diqV256TypeText(item);




  return diqV255Has(txt, [
    "city", "town", "village", "county", "state", "postcode", "postal code",
    "administrative", "municipality", "neighborhood", "neighbourhood",
    "suburb", "district", "locality", "address", "street", "road",
    "intersection", "residential", "building", "office"
  ]);
}




function diqV256IsLodging(item) {
  var txt = diqV256TypeText(item);




  return diqV255Has(txt, [
    "hotel", "motel", "inn", "lodging", "hostel", "super 8",
    "days inn", "quality inn", "holiday inn", "hampton inn",
    "comfort inn", "best western", "la quinta"
  ]);
}




function diqV256IsWorship(item) {
  var txt = diqV256TypeText(item);




  return diqV255Has(txt, [
    "mosque", "masjid", "church", "chapel", "synagogue", "temple",
    "place of worship", "religion", "religious"
  ]);
}




function diqV256IsGenericService(item) {
  var txt = diqV256TypeText(item);




  return diqV255Has(txt, [
    "gas station", "fuel", "car wash", "auto repair", "tire shop",
    "insurance", "bank", "atm", "pharmacy", "medical", "hospital",
    "dentist", "law office", "real estate", "storage", "warehouse",
    "school", "university", "college", "daycare", "parking lot"
  ]);
}




function diqV256IsChain(item) {
  var txt = diqV256TypeText(item);




  return diqV255Has(txt, [
    "mcdonald", "starbucks", "subway", "taco bell", "burger king",
    "wendy", "chick fil a", "walmart", "target", "applebee",
    "buffalo wild wings", "cracker barrel", "waffle house",
    "domino", "pizza hut", "little caesars"
  ]);
}




function diqV256ExperienceBlacklist(item, category) {
  if (!item) { return true; }




  if (diqV256IsAdministrativeOrGenericEntity(item)) { return true; }
  if (diqV256IsLodging(item)) { return true; }
  if (diqV256IsWorship(item)) { return true; }




  if (
    category === "hidden gems" ||
    category === "local favorites" ||
    category === "nightlife" ||
    category === "live music" ||
    category === "patio vibes"
  ) {
    if (diqV256IsGenericService(item)) { return true; }
  }




  return false;
}




function diqV256VenueEvidence(item) {
  var txt = diqV256TypeText(item);




  return diqV255Has(txt, [
    "restaurant", "bar", "pub", "tavern", "brewery", "taproom",
    "lounge", "nightclub", "club", "cafe", "coffee", "bakery",
    "shop", "boutique", "market", "museum", "gallery", "theater",
    "theatre", "venue", "park", "trail", "landmark", "attraction",
    "marina", "waterfront", "patio", "courtyard", "rooftop",
    "arcade", "bowling", "karaoke", "music"
  ]);
}




function diqV256LocalFavoriteTruth(item) {
  var txt = diqV256TypeText(item);
  var src = diqV256SourceText(item);
  var positive = diqV255Has(txt, [
    "local favorite", "local institution", "locally owned", "family owned",
    "historic", "landmark", "downtown", "square", "famous", "signature",
    "award", "beloved", "popular local"
  ]);




  if (diqV256ExperienceBlacklist(item, "local favorites")) { return false; }
  if (!diqV256VenueEvidence(item)) { return false; }




  /*
    Source query can confirm that a venue was returned by a dedicated local
    favorite search, but the venue still must be an experience-worthy place.
  */
  if (positive) { return true; }
  if (src.indexOf("local favorite") > -1 || src.indexOf("locally owned") > -1 || src.indexOf("local institution") > -1) {
    return true;
  }




  return diqV255CategoryEvidence(item, "local favorites") >= 85;
}




function diqV256HiddenGemTruth(item) {
  var txt = diqV256TypeText(item);
  var src = diqV256SourceText(item);
  var positive = diqV255Has(txt, [
    "hidden gem", "off the beaten path", "unique", "historic", "landmark",
    "local secret", "scenic", "tucked away", "independent", "artisan",
    "small museum", "gallery", "overlook", "garden", "trail", "park"
  ]);




  if (diqV256ExperienceBlacklist(item, "hidden gems")) { return false; }
  if (diqV256IsChain(item)) { return false; }
  if (!diqV256VenueEvidence(item)) { return false; }




  if (positive) { return true; }




  if (
    src.indexOf("hidden gem") > -1 ||
    src.indexOf("off the beaten path") > -1 ||
    src.indexOf("unique local places") > -1 ||
    src.indexOf("local secret") > -1
  ) {
    return true;
  }




  return false;
}




function diqV256NightlifeTruth(item) {
  var txt = diqV256TypeText(item);
  var src = diqV256SourceText(item);
  var direct = diqV255Has(txt, [
    "nightclub", "dance club", "cocktail bar", "cocktail lounge", "lounge",
    "karaoke", "sports bar", "pub", "tavern", "brewery", "taproom",
    "rooftop bar", "beer garden", "live music", "music venue", "open mic",
    "bar"
  ]);
  var querySupport = diqV255Has(src, [
    "nightlife", "bars open late", "late night bar", "cocktail bar",
    "cocktail lounge", "nightclub", "sports bar", "karaoke",
    "rooftop bar", "pub", "tavern", "brewery open late", "taproom"
  ]);




  if (diqV256ExperienceBlacklist(item, "nightlife")) { return false; }
  if (!diqV256VenueEvidence(item)) { return false; }




  /*
    Dedicated nightlife query support may identify a venue whose name is
    generic, such as The Library, but a plain restaurant/grill still needs
    bar, music, lounge, club, or late-hours evidence.
  */
  if (direct) { return true; }
  if (querySupport && diqV255LateNightEvidence(item)) { return true; }




  return false;
}




function diqV256LiveMusicTruth(item) {
  var txt = diqV256TypeText(item);
  var src = diqV256SourceText(item);
  var direct = diqV255Has(txt, [
    "live music", "music venue", "concert", "band", "acoustic",
    "jazz", "open mic", "karaoke", "amphitheater", "performing arts"
  ]);
  var querySupport = diqV255Has(src, [
    "live music tonight", "live music venue", "concert venue",
    "local band", "acoustic music", "open mic", "jazz club",
    "karaoke", "bar with live music", "brewery with live music"
  ]);




  if (diqV256ExperienceBlacklist(item, "live music")) { return false; }
  if (diqV255Has(txt, ["music store", "instrument store", "music lesson", "recording studio", "radio station"])) { return false; }




  return direct || (querySupport && diqV256VenueEvidence(item));
}




function diqV256PatioTruth(item) {
  var txt = diqV256TypeText(item);
  var src = diqV256SourceText(item);




  if (diqV256ExperienceBlacklist(item, "patio vibes")) { return false; }




  return diqV255Has(txt, [
    "patio", "outdoor seating", "outdoor dining", "terrace",
    "courtyard", "beer garden", "rooftop"
  ]) || (
    diqV255Has(src, [
      "restaurant with patio", "outdoor dining", "outdoor seating restaurant",
      "courtyard restaurant", "terrace restaurant", "rooftop restaurant",
      "beer garden", "waterfront patio"
    ]) &&
    diqV256VenueEvidence(item)
  );
}




isStrictAdventureCategoryMatch = function (item, query) {
  var category = categoryFromQuery(query);




  if (category === "hidden gems") { return diqV256HiddenGemTruth(item); }
  if (category === "local favorites") { return diqV256LocalFavoriteTruth(item); }
  if (category === "nightlife") { return diqV256NightlifeTruth(item); }
  if (category === "live music") { return diqV256LiveMusicTruth(item); }
  if (category === "patio vibes") { return diqV256PatioTruth(item); }




  return diqV256OriginalStrictMatch(item, query);
};




scoreAdventure = function (item, query) {
  var category = categoryFromQuery(query);
  var score;




  if (
    (category === "hidden gems" ||
     category === "local favorites" ||
     category === "nightlife" ||
     category === "live music" ||
     category === "patio vibes") &&
    !isStrictAdventureCategoryMatch(item, query)
  ) {
    return -9999;
  }




  score = diqV256OriginalScoreAdventure(item, query);




  if (category === "hidden gems") {
    if (diqV256IsChain(item)) { score -= 260; }
    if (diqV255Has(diqV256TypeText(item), ["historic","landmark","unique","scenic","independent","artisan"])) { score += 80; }
  }




  if (category === "local favorites") {
    if (diqV255Has(diqV256TypeText(item), ["local institution","family owned","locally owned","historic","downtown","square"])) { score += 75; }
    if (diqV256IsChain(item)) { score -= 90; }
  }




  if (category === "nightlife") {
    if (diqV255LateNightEvidence(item)) { score += 85; }
    if (diqV255Has(diqV256TypeText(item), ["nightclub","cocktail","lounge","karaoke","sports bar","brewery","pub","tavern"])) { score += 95; }
  }




  return score;
};








/* =========================================================
   DRIVE IQ V25.7 â€” PROGRESSIVE CATEGORY TRUTH




   Strong direct matches first.
   Trusted category-supported venues second.
   Controlled fallback third.
   Wrong place types remain blocked.
========================================================= */




var diqV257OriginalSortAdventureResults = sortAdventureResults;
var diqV257OriginalStrictMatch = isStrictAdventureCategoryMatch;
var diqV257OriginalScoreAdventure = scoreAdventure;




function diqV257TrustedVenue(item) {
  if (!item) { return false; }
  if (diqV256ExperienceBlacklist(item, categoryFromQuery(activeScanQuery || activeLens || ""))) { return false; }
  return diqV256VenueEvidence(item);
}




function diqV257SourceSupportsCategory(item, category) {
  var src = diqV256SourceText(item);




  if (category === "nightlife") {
    return diqV255Has(src, [
      "nightlife","bars open late","late night bar","cocktail bar",
      "cocktail lounge","nightclub","dance club","sports bar",
      "karaoke","rooftop bar","pub","tavern","brewery open late",
      "taproom","downtown nightlife","entertainment district"
    ]);
  }




  if (category === "live music") {
    return diqV255Has(src, [
      "live music tonight","live music venue","concert venue","local band",
      "acoustic music","open mic","jazz club","karaoke",
      "bar with live music","brewery with live music","entertainment venue"
    ]);
  }




  if (category === "local favorites") {
    return diqV255Has(src, [
      "local favorite","locally owned restaurant","local institution",
      "historic restaurant","downtown favorite","family owned"
    ]);
  }




  if (category === "hidden gems") {
    return diqV255Has(src, [
      "hidden gems","off the beaten path","unique local places",
      "historic landmark","local secret","scenic hidden spot",
      "small local restaurant"
    ]);
  }




  if (category === "patio vibes") {
    return diqV255Has(src, [
      "restaurant with patio","outdoor dining","outdoor seating restaurant",
      "courtyard restaurant","terrace restaurant","rooftop restaurant",
      "beer garden","waterfront patio"
    ]);
  }




  return false;
}




function diqV257TrustedFallbackMatch(item, category) {
  var txt = diqV256TypeText(item);




  if (!item || !category) { return false; }
  if (diqV256ExperienceBlacklist(item, category)) { return false; }
  if (!diqV257TrustedVenue(item)) { return false; }




  if (category === "nightlife") {
    return diqV257SourceSupportsCategory(item, category) && (
      diqV255Has(txt, ["restaurant","grill","brewery","bar","pub","tavern","lounge","club","music","karaoke"]) ||
      diqV255LateNightEvidence(item)
    );
  }




  if (category === "live music") {
    return diqV257SourceSupportsCategory(item, category) &&
      diqV255Has(txt, ["bar","pub","tavern","brewery","restaurant","venue","theater","theatre","club"]);
  }




  if (category === "local favorites") {
    return diqV257SourceSupportsCategory(item, category) ||
      diqV255Has(txt, ["restaurant","bar","coffee","bakery","shop","market","museum","park","landmark"]);
  }




  if (category === "hidden gems") {
    if (diqV256IsChain(item)) { return false; }
    return diqV257SourceSupportsCategory(item, category) ||
      diqV255Has(txt, ["independent","historic","landmark","museum","gallery","park","trail","scenic","artisan","local"]);
  }




  if (category === "patio vibes") {
    return diqV257SourceSupportsCategory(item, category) &&
      diqV255Has(txt, ["restaurant","bar","brewery","cafe","grill","bistro"]);
  }




  return false;
}




function diqV257FallbackScore(item, query, tier) {
  var category = categoryFromQuery(query);
  var score = diqV257OriginalScoreAdventure(item, query);




  if (tier === 2) { score -= 70; }
  if (tier === 3) { score -= 135; }




  if (category === "nightlife" && diqV255LateNightEvidence(item)) { score += 65; }
  if (category === "local favorites" && diqV255Has(diqV256TypeText(item), ["local","historic","downtown","square","family owned"])) { score += 55; }
  if (category === "hidden gems" && diqV255Has(diqV256TypeText(item), ["historic","landmark","scenic","independent","artisan","museum","gallery"])) { score += 65; }




  return score;
}




sortAdventureResults = function (items, query) {
  var category = categoryFromQuery(query);
  var filtered = diqV22FilterExperienceResults(items || [], query);
  var direct = [];
  var trusted = [];
  var controlled = [];
  var ranked = [];
  var seen = {};
  var i;
  var item;
  var key;




  if (
    category !== "nightlife" &&
    category !== "live music" &&
    category !== "local favorites" &&
    category !== "hidden gems" &&
    category !== "patio vibes"
  ) {
    return diqV257OriginalSortAdventureResults(items, query);
  }




  for (i = 0; i < filtered.length; i++) {
    item = filtered[i];
    if (!item) { continue; }




    if (diqV256ExperienceBlacklist(item, category)) { continue; }




    if (diqV257OriginalStrictMatch(item, query)) {
      direct.push(item);
    } else if (diqV257TrustedFallbackMatch(item, category)) {
      trusted.push(item);
    } else if (
      diqV257TrustedVenue(item) &&
      category !== "nightlife" &&
      category !== "live music"
    ) {
      /*
        Hidden Gems / Local Favorites / Patio may use a controlled third tier.
        Nightlife and Live Music remain stricter.
      */
      controlled.push(item);
    }
  }




  direct.sort(function (a, b) {
    return diqV257FallbackScore(b, query, 1) - diqV257FallbackScore(a, query, 1);
  });




  trusted.sort(function (a, b) {
    return diqV257FallbackScore(b, query, 2) - diqV257FallbackScore(a, query, 2);
  });




  controlled.sort(function (a, b) {
    return diqV257FallbackScore(b, query, 3) - diqV257FallbackScore(a, query, 3);
  });




  function addUnique(list, limit) {
    var j;
    var k;
    for (j = 0; j < list.length && ranked.length < limit; j++) {
      k = diqV255ItemKey(list[j]);
      if (!k || seen[k]) { continue; }
      seen[k] = true;
      ranked.push(list[j]);
    }
  }




  /*
    Preserve quality order while preventing an empty category.
    Strong direct matches dominate. Trusted fallbacks fill gaps.
  */
  addUnique(direct, 8);
  addUnique(trusted, 8);




  if (ranked.length < 5) {
    addUnique(controlled, 8);
  }




  /*
    Apply existing adaptive variety after progressive truth selection.
  */
  ranked.sort(function (a, b) {
    var sa = diqV257FallbackScore(a, query, direct.indexOf(a) > -1 ? 1 : (trusted.indexOf(a) > -1 ? 2 : 3));
    var sb = diqV257FallbackScore(b, query, direct.indexOf(b) > -1 ? 1 : (trusted.indexOf(b) > -1 ? 2 : 3));
    var pa = diqV255AdaptiveRepeatPenalty(a, category, ranked.length, 0);
    var pb = diqV255AdaptiveRepeatPenalty(b, category, ranked.length, 0);
    return (sb - pb) - (sa - pa);
  });




  return ranked;
};




isStrictAdventureCategoryMatch = function (item, query) {
  var category = categoryFromQuery(query);




  if (
    category === "nightlife" ||
    category === "live music" ||
    category === "local favorites" ||
    category === "hidden gems" ||
    category === "patio vibes"
  ) {
    if (diqV257OriginalStrictMatch(item, query)) { return true; }
    return diqV257TrustedFallbackMatch(item, category);
  }




  return diqV257OriginalStrictMatch(item, query);
};




scoreAdventure = function (item, query) {
  var category = categoryFromQuery(query);




  if (
    category === "nightlife" ||
    category === "live music" ||
    category === "local favorites" ||
    category === "hidden gems" ||
    category === "patio vibes"
  ) {
    if (diqV256ExperienceBlacklist(item, category)) { return -9999; }




    if (diqV257OriginalStrictMatch(item, query)) {
      return diqV257FallbackScore(item, query, 1);
    }




    if (diqV257TrustedFallbackMatch(item, category)) {
      return diqV257FallbackScore(item, query, 2);
    }




    if (
      (category === "local favorites" ||
       category === "hidden gems" ||
       category === "patio vibes") &&
      diqV257TrustedVenue(item)
    ) {
      return diqV257FallbackScore(item, query, 3);
    }




    return -9999;
  }




  return diqV257OriginalScoreAdventure(item, query);
};




function scanAdventureChoices(query) {
  var q = clean(query || activeLens || "popular tonight");
  adventureScanOnly = true;
  activeScanQuery = q;
  diqV231ApplyScanReliabilityUi("Progressive Category Truth checking direct matches and trusted fallbacks", "gold");
  findDriveableAdventure(q);
}












/* =========================================================
   DRIVE IQ V26.1 â€” TRUST ENGINE / HUMAN LOCAL CONFIDENCE
   - Parking and generic amenities are suppressed unless explicitly requested.
   - Recommended Because reads like a local guide, not an algorithm.
   - Confidence labels become human-facing trust chips.
   - Successful scans collapse faster so the map remains the hero.
========================================================= */




var diqV261OriginalFilterExperienceResults = diqV22FilterExperienceResults;
var diqV261OriginalScoreAdventure = scoreAdventure;
var diqV261OriginalSortAdventureResults = sortAdventureResults;
var diqV261OriginalConfidenceLabel = adventureConfidenceLabel;
var diqV261OriginalAdventureWhy = adventureWhy;
var diqV261OriginalAutoCollapse = autoCollapseAdventureMenuAfterScan;




function diqV261TrustText(item) {
  return normText(
    String(item && item.label || "") + " " +
    String(item && item.full || "") + " " +
    String(item && item.kind || "") + " " +
    String(item && item.category || "") + " " +
    String(item && item.matchLabel || "") + " " +
    String(item && item.sourceQuery || "") + " " +
    String(item && item.adventureCategory || "")
  );
}




function diqV261QueryText(query) {
  return normText(String(query || activeLens || activeScanQuery || ""));
}




function diqV261ExplicitParkingQuery(query) {
  var q = diqV261QueryText(query);
  return q.indexOf("parking") > -1 ||
    q.indexOf("garage") > -1 ||
    q.indexOf("park near") > -1 ||
    q.indexOf("where to park") > -1 ||
    q.indexOf("lot") > -1;
}




function diqV261IsParkingAmenity(item) {
  var txt = diqV261TrustText(item);




  if (!item) { return false; }




  if (
    txt.indexOf("parking") > -1 ||
    txt.indexOf("parking garage") > -1 ||
    txt.indexOf("garage") > -1 ||
    txt.indexOf("underground") > -1 ||
    txt.indexOf("surface lot") > -1 ||
    txt.indexOf("car park") > -1 ||
    txt.indexOf("parkade") > -1
  ) {
    return true;
  }




  return false;
}




function diqV261IsGenericAmenity(item) {
  var txt = diqV261TrustText(item);




  if (diqV261IsParkingAmenity(item)) { return true; }




  return txt.indexOf("restroom") > -1 ||
    txt.indexOf("toilet") > -1 ||
    txt.indexOf("bathroom") > -1 ||
    txt.indexOf("atm") > -1 ||
    txt.indexOf("post office") > -1 ||
    txt.indexOf("mailbox") > -1 ||
    txt.indexOf("courthouse") > -1 ||
    txt.indexOf("government office") > -1 ||
    txt.indexOf("public building") > -1;
}




function diqV261IsExperienceCategory(query) {
  var q = diqV261QueryText(query);
  var cat = categoryFromQuery(query);




  if (cat === "trails" || cat === "parks" || cat === "water" || cat === "waterfalls" || cat === "camping" || cat === "run walk" || cat === "scenic") {
    return false;
  }




  if (cat === "popular tonight" ||
      cat === "nightlife" ||
      cat === "live music" ||
      cat === "local favorites" ||
      cat === "hidden gems" ||
      cat === "food iq" ||
      cat === "food drinks" ||
      cat === "patio vibes" ||
      cat === "shopping") {
    return true;
  }




  return q.indexOf("nightlife") > -1 ||
    q.indexOf("local favorite") > -1 ||
    q.indexOf("live music") > -1 ||
    q.indexOf("food") > -1 ||
    q.indexOf("patio") > -1 ||
    q.indexOf("coffee") > -1 ||
    q.indexOf("bar") > -1 ||
    q.indexOf("brewery") > -1 ||
    q.indexOf("restaurant") > -1 ||
    q.indexOf("hidden gem") > -1;
}




function diqV261ShouldSuppressAmenity(item, query) {
  if (!item) { return true; }
  if (diqV261ExplicitParkingQuery(query)) { return false; }
  if (!diqV261IsExperienceCategory(query)) { return false; }




  /*
    Parking lots, garages, restrooms, and generic civic amenities are useful
    utilities, but they should not be Top Picks for nightlife, food, local
    favorites, hidden gems, or other experience scans.
  */
  return diqV261IsGenericAmenity(item);
}




function diqV261HumanHas(item, terms) {
  return diqV255Has ? diqV255Has(diqV261TrustText(item), terms) : false;
}




function diqV261AddReason(out, reason) {
  var i;
  reason = clean(reason);
  if (!reason) { return; }
  for (i = 0; i < out.length; i++) {
    if (normText(out[i]) === normText(reason)) { return; }
  }
  out.push(reason);
}




function recommendedBecauseReasons(item, query) {
  var out = [];
  var cat = adventurePrimaryCategory(item, query || activeLens);
  var txt = diqV261TrustText(item);
  var score = Number(item && item.worthScore || 0);
  var taste = Number(item && item.tasteBoost || 0);
  var drops = dropCountsForItem(item);
  var dist = destinationDistanceText(item) || itemDistanceText(item);
  var conf = clean(item && item.confidenceLabel || "");




  function add(reason) { diqV261AddReason(out, reason); }




  if (cat === "live music") {
    if (diqV255Has(txt, ["live music","music venue","band","concert","honky tonk","jazz","open mic","karaoke"])) { add("Live music energy"); }
    if (diqV255Has(txt, ["bar","pub","tavern","brewery","lounge","club","rooftop"])) { add("Good nightlife venue fit"); }
    add("Popular for an evening stop");
    if (diqV255LateNightEvidence(item)) { add("Open-late signal"); }
  } else if (cat === "popular tonight" || cat === "nightlife") {
    if (diqV255LateNightEvidence(item)) { add("Open-late nightlife signal"); }
    if (diqV255Has(txt, ["bar","pub","tavern","cocktail","lounge","brewery","taproom","club","karaoke","honky tonk"])) { add("Fits a night out"); }
    if (diqV255Has(txt, ["downtown","district","broadway","square","riverfront","walkable"])) { add("Walkable district energy"); }
    add("Good tonight-style pick");
  } else if (cat === "local favorites") {
    if (diqV255Has(txt, ["local favorite","local institution","iconic","historic","family owned","locally owned","neighborhood","downtown","square"])) { add("Locals love it"); }
    else { add("Strong local-style pick"); }
    if (diqV255Has(txt, ["restaurant","bbq","barbecue","coffee","bakery","brewery","bar","cafe","diner"])) { add("The kind of place locals recommend"); }
    if (drops && drops.total) { add("Fresh Adventure Drop signal"); }
  } else if (cat === "food iq" || cat === "food drinks") {
    if (diqV255Has(txt, ["bbq","barbecue","burger","taco","seafood","bakery","dessert","ice cream","coffee","cafe","diner","restaurant"])) { add("Food worth trying"); }
    if (diqV255Has(txt, ["local","family owned","locally owned","historic","downtown","neighborhood"])) { add("Local food signal"); }
    if (taste > 0) { add("Matches your Taste IQ"); }
    add("Good stop before you route");
  } else if (cat === "patio vibes") {
    if (diqV255Has(txt, ["patio","outdoor seating","terrace","rooftop","beer garden","riverfront","waterfront"])) { add("Outdoor seating signal"); }
    add("Patio-style stop");
    if (diqV255Has(txt, ["sunset","rooftop","waterfront","riverfront"])) { add("Good atmosphere potential"); }
  } else if (cat === "waterfront" || cat === "water" || cat === "waterfalls") {
    if (diqV255Has(txt, ["waterfront","riverfront","lake","creek","river","marina","boat ramp","waterfall"])) { add("Water nearby"); }
    add("Good photo or view potential");
    if (dist) { add("Worth the short detour"); }
  } else if (cat === "coffee") {
    add("Matches your Coffee IQ");
    if (diqV255Has(txt, ["local","independent","cafe","coffee shop","roaster","bakery"])) { add("Independent local shop signal"); }
  } else if (cat === "shopping") {
    if (diqV255Has(txt, ["boutique","local shop","market","antique","vintage","bookstore","gift"])) { add("Local shopping fit"); }
    add("Good browse-worthy stop");
  } else if (cat === "hidden gems") {
    if (diqV255Has(txt, ["historic","hidden","landmark","independent","local","museum","gallery","scenic","artisan"])) { add("Less obvious local discovery"); }
    add("Hidden Gem IQ fit");
  } else {
    if (score >= 88) { add("High Worth the Drive confidence"); }
    if (taste > 0) { add("Matches your Taste IQ"); }
    if (drops && drops.total) { add("Fresh Adventure Drop signal"); }
  }




  if (taste > 0 && out.length < 4) { add("Matches your Taste IQ"); }
  if (drops && drops.total && out.length < 4) { add("Fresh Adventure Drop signal"); }
  if (conf && conf !== "Place IQ estimate" && conf !== "Venue confidence check" && out.length < 4) { add(conf); }
  if (dist && out.length < 4) { add(dist.indexOf("mi") > -1 ? "Worth the short detour" : dist); }




  if (!out.length) { add("Relevant to this scan"); }
  return out.slice(0, 4);
}




adventureConfidenceLabel = function (item) {
  var cat = adventurePrimaryCategory(item, activeLens);
  var score = Number(item && item.worthScore || 0);
  var venue = Number(item && (item.venueConfidence || diqV22VenueConfidenceScore(item, activeLens)) || 0);
  var txt = diqV261TrustText(item);




  if (cat === "live music") {
    if (diqV255Has(txt, ["live music","music venue","concert","band","honky tonk","jazz"])) { return "Live Music Fit"; }
    if (venue >= 76) { return "Good Venue Confidence"; }
    return "Venue Confidence Check";
  }




  if (cat === "popular tonight" || cat === "nightlife") {
    if (diqV255LateNightEvidence(item) && venue >= 76) { return "Popular Tonight"; }
    if (venue >= 70) { return "Good Venue Confidence"; }
    return "Nightlife Fit Check";
  }




  if (cat === "local favorites") {
    if (diqV255Has(txt, ["local favorite","local institution","iconic","historic","family owned","locally owned"])) { return "Local Favorite"; }
    if (score >= 84) { return "Strong Local Signal"; }
    return "Local IQ Pick";
  }




  if (cat === "hidden gems") {
    if (score >= 84) { return "Hidden Gem Signal"; }
    return "Discovery Pick";
  }




  if (score >= 90) { return "Worth the Drive"; }
  if (score >= 80) { return "Good Pick"; }
  return "Worth a Look";
};




adventureWhy = function (item, query) {
  var cat = adventurePrimaryCategory(item, query);
  var txt = diqV261TrustText(item);




  if (diqV261ShouldSuppressAmenity(item, query)) {
    return "Useful nearby, but not a top experience pick for this scan.";
  }
  if (cat === "food iq") { return "A food-first local pick worth considering before you route."; }
  if (cat === "live music") { return "A music-forward stop with the right kind of local energy for tonight."; }
  if (cat === "popular tonight" || cat === "nightlife") { return "A social, evening-friendly place that fits the nightlife scan better than generic nearby results."; }
  if (cat === "waterfront") { return "A water-adjacent pick for views, atmosphere, or a better stop than a generic search result."; }
  if (cat === "patio vibes") { return "An outdoor-friendly stop with patio-style potential and better atmosphere than a basic nearby listing."; }
  if (cat === "food drinks") { return "A food-and-drink stop ranked for local fit, usefulness, and stop-worthy value."; }
  if (cat === "local favorites") {
    if (diqV255Has(txt, ["local favorite","local institution","historic","iconic","family owned","locally owned"])) {
      return "A local-style favorite that looks more like something people would actually recommend.";
    }
    return "A stronger local-style pick ranked above generic nearby listings.";
  }
  if (cat === "hidden gems") { return "A discovery-style stop with a better chance of feeling local, memorable, or less obvious."; }
  if (cat === "trails" || cat === "run walk") { return "Routeable outdoor option for a walk, trail, or quick reset."; }
  if (cat === "water" || cat === "waterfalls") { return "Water-access discovery for views, photos, or a quick adventure stop."; }
  if (cat === "parks" || cat === "scenic") { return "Scenic or outdoor stop that can turn the drive into an experience."; }
  if (cat === "camping") { return "Outdoor overnight or recreation option near your adventure area."; }
  return "A nearby discovery ranked by Drive IQ for relevance and trip value.";
};




diqV22FilterExperienceResults = function (items, query) {
  var base = diqV261OriginalFilterExperienceResults(items || [], query);
  var out = [];
  var i;
  var item;




  for (i = 0; i < base.length; i++) {
    item = base[i];
    if (!item) { continue; }
    if (diqV261ShouldSuppressAmenity(item, query)) {
      try {
        if (window.console && window.console.warn) {
          window.console.warn("[Adventure V26.1 suppressed generic amenity]", {
            query: query,
            label: item.label,
            full: item.full,
            kind: item.kind
          });
        }
      } catch (e) {}
      continue;
    }
    out.push(item);
  }




  return out;
};




scoreAdventure = function (item, query) {
  var score;




  if (!item) { return -9999; }
  if (diqV261ShouldSuppressAmenity(item, query)) { return -9999; }




  score = diqV261OriginalScoreAdventure(item, query);




  if (categoryFromQuery(query) === "nightlife" || categoryFromQuery(query) === "popular tonight") {
    if (diqV255LateNightEvidence(item)) { score += 90; }
    if (diqV255Has(diqV261TrustText(item), ["bar","pub","tavern","cocktail","lounge","brewery","taproom","club","karaoke","honky tonk","live music"])) { score += 70; }
  }




  if (categoryFromQuery(query) === "local favorites") {
    if (diqV255Has(diqV261TrustText(item), ["local favorite","local institution","iconic","historic","family owned","locally owned","neighborhood","downtown","square"])) { score += 95; }
    if (diqV255Has(diqV261TrustText(item), ["parking","garage","restroom","atm","post office","government office"])) { score -= 500; }
  }




  return score;
};




sortAdventureResults = function (items, query) {
  var safe = diqV22FilterExperienceResults(items || [], query);
  return diqV261OriginalSortAdventureResults(safe, query);
};




autoCollapseAdventureMenuAfterScan = function (reason) {
  if (adventureAutoCollapseTimer) {
    window.clearTimeout(adventureAutoCollapseTimer);
    adventureAutoCollapseTimer = null;
  }




  adventureAutoCollapseTimer = window.setTimeout(function () {
    if (adventurePanelIsBlockingAutoCollapse()) { return; }
    if (destinationResultOpen && !adventureResults.length) { return; }




    try {
      ensureScanResultsRestoreControl();
      document.body.classList.add("adventureScanResultsMode");
      document.body.classList.remove("adventureHorizonHidden");
    } catch (e1) {}




    try { syncAdventureMapDock(); } catch (e2) {}
    if (window.console && window.console.log) { window.console.log("[Adventure V26.1 Map Hero Collapse]", reason || "scan_complete"); }
  }, 520);
};




/* =========================================================
   DRIVE IQ V26.2 â€” RECOMMENDATION TRUST ENGINE
   Goal: optimize for "Would a knowledgeable local recommend this
   to a friend right now?" instead of directory-style ranking.
   ES5-safe patch. No HTML changes.
========================================================= */




window.__DRIVE_IQ_ADVENTURE_MODE_JS_V26_2_RECOMMENDATION_TRUST__ = true;




function diqV262SetFounderDebug(key, value) {
  try {
    if (!window.DriveIQFounderDebug) {
      window.DriveIQFounderDebug = {
        version:"Adventure IQ V26.2",
        lastScan:{},
        lastResults:[],
        scanTrace:[],
        recommendationConfidence:0,
        categoryTruth:"UNKNOWN"
      };
    }
    window.DriveIQFounderDebug[key] = value;
  } catch (e) {}
}




function diqV262Text(item) {
  return normText(
    String(item && item.label || "") + " " +
    String(item && item.full || "") + " " +
    String(item && item.kind || "") + " " +
    String(item && item.category || "") + " " +
    String(item && item.matchLabel || "") + " " +
    String(item && item.sourceQuery || "") + " " +
    String(item && item.adventureCategory || "")
  );
}




function diqV262Has(txt, terms) {
  var i;
  txt = normText(txt);
  for (i = 0; i < terms.length; i++) {
    if (txt.indexOf(normText(terms[i])) > -1) { return true; }
  }
  return false;
}




function diqV262ChainOrGeneric(txt) {
  return diqV262Has(txt, [
    "mcdonald", "burger king", "taco bell", "wendy", "subway", "sonic",
    "chick fil a", "kfc", "pizza hut", "domino", "little caesars",
    "walmart", "target", "dollar general", "family dollar", "dollar tree",
    "cvs", "walgreens", "kroger", "costco", "sam s club", "gas station",
    "convenience store", "travel center", "truck stop", "storage", "self storage",
    "apartment", "apartments", "office", "office building", "bank", "atm",
    "parking", "parking lot", "parking garage", "car wash"
  ]);
}




function diqV262StrongLocalWords(txt) {
  return diqV262Has(txt, [
    "local favorite", "local institution", "iconic", "historic", "family owned",
    "locally owned", "neighborhood", "downtown", "square", "main street",
    "independent", "roaster", "brewery", "taproom", "market", "artisan",
    "farmers market", "hidden gem", "live music", "patio", "rooftop",
    "waterfront", "riverfront", "lakefront", "honky tonk"
  ]);
}




function diqV262VenueWords(txt) {
  return diqV262Has(txt, [
    "restaurant", "bbq", "barbecue", "bar", "pub", "tavern", "grill", "cafe",
    "coffee", "bakery", "brewery", "taproom", "lounge", "cocktail", "club",
    "music venue", "theater", "theatre", "market", "boutique", "bookstore",
    "antique", "museum", "gallery", "park", "trail", "marina", "waterfall"
  ]);
}




function diqV262CategoryTruthScore(item, query) {
  var cat = adventurePrimaryCategory(item, query || activeLens);
  var txt = diqV262Text(item);
  var score = 52;




  if (!item) { return 0; }




  if (diqV261ShouldSuppressAmenity && diqV261ShouldSuppressAmenity(item, query)) { return 0; }




  if (cat === "live music") {
    if (diqV262Has(txt, ["live music", "music venue", "concert", "band", "honky tonk", "jazz", "open mic", "karaoke"])) { score += 38; }
    if (diqV262Has(txt, ["bar", "pub", "tavern", "brewery", "lounge", "club", "theater", "theatre", "restaurant"])) { score += 22; }
    if (diqV262Has(txt, ["beauty", "salon", "spa", "cosmetic", "retail store", "music store", "instrument"])) { score -= 70; }
  } else if (cat === "nightlife" || cat === "popular tonight") {
    if (diqV262Has(txt, ["bar", "pub", "tavern", "cocktail", "lounge", "brewery", "taproom", "club", "karaoke", "rooftop", "honky tonk"])) { score += 36; }
    if (diqV255LateNightEvidence && diqV255LateNightEvidence(item)) { score += 22; }
    if (diqV262Has(txt, ["downtown", "district", "broadway", "square", "walkable"])) { score += 10; }
  } else if (cat === "local favorites") {
    if (diqV262StrongLocalWords(txt)) { score += 34; }
    if (diqV262VenueWords(txt)) { score += 20; }
    if (diqV262ChainOrGeneric(txt)) { score -= 54; }
  } else if (cat === "hidden gems") {
    if (diqV262StrongLocalWords(txt)) { score += 26; }
    if (diqV262Has(txt, ["museum", "gallery", "historic", "landmark", "artisan", "scenic", "independent", "local"])) { score += 20; }
    if (diqV262ChainOrGeneric(txt)) { score -= 70; }
  } else if (cat === "coffee") {
    if (diqV262Has(txt, ["coffee", "cafe", "espresso", "roaster", "bakery"])) { score += 42; }
    if (diqV262Has(txt, ["independent", "local", "roaster", "bakery"])) { score += 16; }
    if (diqV262Has(txt, ["gas station", "convenience store"])) { score -= 60; }
  } else if (cat === "food iq" || cat === "food drinks") {
    if (diqV262Has(txt, ["restaurant", "bbq", "barbecue", "burger", "taco", "seafood", "bakery", "dessert", "ice cream", "cafe", "diner", "grill"])) { score += 36; }
    if (diqV262StrongLocalWords(txt)) { score += 18; }
    if (diqV262Has(txt, ["gas station", "convenience store", "grocery store"])) { score -= 45; }
  } else if (cat === "patio vibes") {
    if (diqV262Has(txt, ["patio", "outdoor seating", "terrace", "rooftop", "beer garden", "waterfront", "riverfront"])) { score += 42; }
    if (diqV262Has(txt, ["restaurant", "bar", "brewery", "cafe", "grill"])) { score += 20; }
  } else if (cat === "shopping") {
    if (diqV262Has(txt, ["boutique", "local shop", "market", "antique", "vintage", "bookstore", "gift", "artisan", "shopping district"])) { score += 40; }
    if (diqV262ChainOrGeneric(txt)) { score -= 38; }
  } else if (cat === "waterfront" || cat === "water" || cat === "waterfalls") {
    if (diqV262Has(txt, ["waterfront", "riverfront", "lake", "lakefront", "marina", "river", "creek", "waterfall", "boat ramp", "beach"])) { score += 42; }
  } else if (cat === "trails" || cat === "parks" || cat === "scenic" || cat === "camping" || cat === "run walk") {
    if (diqV262Has(txt, ["trail", "park", "scenic", "overlook", "campground", "camping", "natural", "waterfall", "cave", "river", "lake", "greenway"])) { score += 34; }
  } else {
    if (diqV262VenueWords(txt)) { score += 14; }
    if (diqV262StrongLocalWords(txt)) { score += 14; }
  }




  if (score < 0) { score = 0; }
  if (score > 100) { score = 100; }
  return score;
}




function diqV262LocalFavoriteScore(item, query) {
  var txt = diqV262Text(item);
  var score = 0;
  var drops;




  if (diqV262StrongLocalWords(txt)) { score += 30; }
  if (diqV262Has(txt, ["downtown", "square", "main street", "neighborhood", "historic", "iconic"])) { score += 16; }
  if (diqV262VenueWords(txt)) { score += 14; }
  if (Number(item && item.tasteBoost || 0) > 0) { score += 10; }




  try {
    drops = dropCountsForItem(item);
    if (drops && drops.total) { score += Math.min(18, Number(drops.total) * 6); }
  } catch (e) {}




  if (categoryFromQuery(query) === "local favorites" && diqV262ChainOrGeneric(txt)) { score -= 35; }




  if (score < 0) { score = 0; }
  if (score > 100) { score = 100; }
  return score;
}




function diqV262WorthTheDriveScore(item, query) {
  var score = Number(item && item.worthScore || 0);
  var truth = diqV262CategoryTruthScore(item, query);
  var local = diqV262LocalFavoriteScore(item, query);




  if (!finite(score)) { score = 0; }
  score = (score * 0.52) + (truth * 0.30) + (local * 0.18);




  if (diqV262ChainOrGeneric(diqV262Text(item)) && (categoryFromQuery(query) === "local favorites" || categoryFromQuery(query) === "hidden gems")) {
    score -= 30;
  }




  if (score < 0) { score = 0; }
  if (score > 100) { score = 100; }
  return Math.round(score);
}




function diqV262RecommendationConfidence(item, query) {
  var truth = diqV262CategoryTruthScore(item, query);
  var local = diqV262LocalFavoriteScore(item, query);
  var worth = diqV262WorthTheDriveScore(item, query);
  var taste = Math.min(100, Math.max(0, Number(item && item.tasteBoost || 0) * 10));
  var venue = 0;
  var conf;




  try { venue = Number(item && (item.venueConfidence || diqV22VenueConfidenceScore(item, query)) || 0); } catch (e) { venue = 0; }
  if (!finite(venue)) { venue = 0; }




  conf = (truth * 0.40) + (worth * 0.26) + (local * 0.20) + (venue * 0.10) + (taste * 0.04);




  if (diqV261ShouldSuppressAmenity && diqV261ShouldSuppressAmenity(item, query)) { conf = 0; }




  if (conf < 0) { conf = 0; }
  if (conf > 100) { conf = 100; }
  return Math.round(conf);
}




function diqV262HardSuppress(item, query) {
  var cat = categoryFromQuery(query);
  var txt = diqV262Text(item);




  if (!item) { return true; }
  if (diqV261ShouldSuppressAmenity && diqV261ShouldSuppressAmenity(item, query)) { return true; }




  if ((cat === "local favorites" || cat === "hidden gems") && diqV262ChainOrGeneric(txt) && !diqV262StrongLocalWords(txt)) {
    return true;
  }




  if (cat === "live music" && diqV262Has(txt, ["beauty salon", "hair salon", "spa", "cosmetics", "music store", "instrument store", "church"]) && !diqV262Has(txt, ["concert", "live music", "music venue"])) {
    return true;
  }




  if (cat === "coffee" && diqV262Has(txt, ["gas station", "convenience store"]) && !diqV262Has(txt, ["coffee shop", "cafe", "roaster"])) {
    return true;
  }




  return false;
}




var diqV262OriginalRecommendedBecauseReasons = recommendedBecauseReasons;
recommendedBecauseReasons = function (item, query) {
  var out = [];
  var original = [];
  var conf = diqV262RecommendationConfidence(item, query);
  var truth = diqV262CategoryTruthScore(item, query);
  var local = diqV262LocalFavoriteScore(item, query);
  var cat = adventurePrimaryCategory(item, query || activeLens);
  var txt = diqV262Text(item);
  var i;




  function add(v) { diqV261AddReason(out, v); }




  if (truth >= 88) { add("Strong category fit"); }
  if (local >= 55) { add("Locals would recognize this"); }
  if (conf >= 88) { add("High Recommendation Confidence"); }




  if (cat === "local favorites" && local >= 45) { add("Local favorite signal"); }
  if (cat === "hidden gems" && !diqV262ChainOrGeneric(txt)) { add("Not a generic chain pick"); }
  if ((cat === "nightlife" || cat === "popular tonight") && diqV255LateNightEvidence && diqV255LateNightEvidence(item)) { add("Open-late signal"); }
  if (cat === "coffee" && diqV262Has(txt, ["roaster", "independent", "local", "bakery", "cafe"])) { add("Coffee IQ fit"); }
  if ((cat === "food iq" || cat === "food drinks") && diqV262StrongLocalWords(txt)) { add("Local food signal"); }




  try { original = diqV262OriginalRecommendedBecauseReasons(item, query) || []; } catch (e) { original = []; }
  for (i = 0; i < original.length; i++) { add(original[i]); }




  if (!out.length) { add("Relevant to this scan"); }
  return out.slice(0, 4);
};




var diqV262OriginalAdventureConfidenceLabel = adventureConfidenceLabel;
adventureConfidenceLabel = function (item) {
  var conf = diqV262RecommendationConfidence(item, activeLens);
  var truth = diqV262CategoryTruthScore(item, activeLens);




  if (conf >= 92) { return "Top Local Pick"; }
  if (conf >= 84) { return "Worth the Drive"; }
  if (truth >= 84) { return "Strong Category Fit"; }
  if (conf >= 72) { return "Good Local Match"; }
  try { return diqV262OriginalAdventureConfidenceLabel(item); } catch (e) {}
  return "Worth a Look";
};




var diqV262OriginalAdventureWhy = adventureWhy;
adventureWhy = function (item, query) {
  var conf = diqV262RecommendationConfidence(item, query);
  var cat = adventurePrimaryCategory(item, query || activeLens);




  if (diqV262HardSuppress(item, query)) {
    return "Filtered out because it does not look like a trustworthy experience pick for this scan.";
  }




  if (conf >= 90) {
    if (cat === "local favorites") { return "A high-confidence local-style pick that looks like something residents would actually recommend."; }
    if (cat === "food iq" || cat === "food drinks") { return "A strong food stop ranked for local fit, category truth, and Worth the Drive potential."; }
    if (cat === "live music") { return "A high-confidence venue-style match for live music energy instead of a random keyword result."; }
    if (cat === "coffee") { return "A strong Coffee IQ match with better local signal than generic nearby results."; }
    return "A high-confidence Drive IQ pick because the local, category, and Worth the Drive signals line up.";
  }




  try { return diqV262OriginalAdventureWhy(item, query); } catch (e) {}
  return "A nearby discovery ranked by Drive IQ for relevance and trip value.";
};




var diqV262OriginalScoreAdventure = scoreAdventure;
scoreAdventure = function (item, query) {
  var base;
  var conf;
  var truth;
  var local;




  if (diqV262HardSuppress(item, query)) { return -9999; }




  base = diqV262OriginalScoreAdventure(item, query);
  if (!finite(base)) { base = 0; }




  conf = diqV262RecommendationConfidence(item, query);
  truth = diqV262CategoryTruthScore(item, query);
  local = diqV262LocalFavoriteScore(item, query);




  base += (conf - 60) * 2.2;
  base += (truth - 60) * 1.4;
  base += local * 0.70;




  if (conf < 45) { base -= 180; }
  if (truth < 35) { base -= 260; }




  item.recommendationConfidence = conf;
  item.categoryTruthScore = truth;
  item.localFavoriteScore = local;
  item.worthDriveTrustScore = diqV262WorthTheDriveScore(item, query);




  return base;
};




var diqV262OriginalFilterExperienceResults = diqV22FilterExperienceResults;
diqV22FilterExperienceResults = function (items, query) {
  var base = diqV262OriginalFilterExperienceResults(items || [], query);
  var out = [];
  var i;
  var item;




  for (i = 0; i < base.length; i++) {
    item = base[i];
    if (!item) { continue; }
    if (diqV262HardSuppress(item, query)) { continue; }
    out.push(item);
  }




  return out;
};




var diqV262OriginalSortAdventureResults = sortAdventureResults;
sortAdventureResults = function (items, query) {
  var sorted = diqV262OriginalSortAdventureResults(items || [], query) || [];
  var high = [];
  var rest = [];
  var out = [];
  var seenTypes = {};
  var i;
  var item;
  var conf;
  var catKey;




  for (i = 0; i < sorted.length; i++) {
    item = sorted[i];
    conf = diqV262RecommendationConfidence(item, query);
    item.recommendationConfidence = conf;
    item.categoryTruthScore = diqV262CategoryTruthScore(item, query);
    item.localFavoriteScore = diqV262LocalFavoriteScore(item, query);




    if (conf >= 62) { high.push(item); }
    else { rest.push(item); }
  }




  sorted = high.length >= 4 ? high : high.concat(rest);




  sorted.sort(function (a, b) {
    var sa = diqV262RecommendationConfidence(a, query);
    var sb = diqV262RecommendationConfidence(b, query);
    return sb - sa;
  });




  for (i = 0; i < sorted.length; i++) {
    item = sorted[i];
    catKey = adventurePrimaryCategory(item, query) + "|" + normText(item.kind || item.category || "");
    if (seenTypes[catKey] && out.length >= 4) { continue; }
    seenTypes[catKey] = 1;
    out.push(item);
    if (out.length >= 12) { break; }
  }




  for (i = 0; i < sorted.length && out.length < 12; i++) {
    item = sorted[i];
    if (out.indexOf(item) < 0) { out.push(item); }
  }




  try {
    diqV262SetFounderDebug("lastScan", {
      query:String(query || activeLens || ""),
      resultCount:out.length,
      topConfidence:out.length ? diqV262RecommendationConfidence(out[0], query) : 0,
      ts:(new Date()).toISOString()
    });
    diqV262SetFounderDebug("lastResults", out.slice(0, 12));
    diqV262SetFounderDebug("recommendationConfidence", out.length ? diqV262RecommendationConfidence(out[0], query) : 0);
    diqV262SetFounderDebug("categoryTruth", out.length && diqV262CategoryTruthScore(out[0], query) >= 70 ? "PASS" : "CHECK");
    diqV262SetFounderDebug("scanTrace", [
      "Category Truth IQ",
      "Open and Available IQ",
      "Freshness IQ",
      "Local Favorites IQ",
      "Worth the Drive IQ",
      "Taste IQ",
      "Diversity Selection",
      "Recommendation Confidence"
    ]);
  } catch (debugErr) {}




  return out;
};




var diqV262OriginalEnrichAdventureItem = enrichAdventureItem;
enrichAdventureItem = function (item, query) {
  item = diqV262OriginalEnrichAdventureItem(item, query);
  if (!item) { return item; }
  item.categoryTruthScore = diqV262CategoryTruthScore(item, query);
  item.localFavoriteScore = diqV262LocalFavoriteScore(item, query);
  item.worthDriveTrustScore = diqV262WorthTheDriveScore(item, query);
  item.recommendationConfidence = diqV262RecommendationConfidence(item, query);
  item.recommendedBecause = recommendedBecauseReasons(item, query);
  return item;
};












/* =========================================================
   DRIVE IQ V26.3 â€” NO SCAN HANG IQ / LOCAL FAVES FALLBACK
   Every scan must finish. Local Favorites can fall back to trusted
   food, coffee, patio, district, and attraction picks instead of
   spinning forever. ES5-safe. No HTML changes.
========================================================= */




window.__DRIVE_IQ_ADVENTURE_MODE_JS_V26_3_NO_SCAN_HANG__ = true;




var diqV263ScanWatchdogTimer = null;
var diqV263FallbackActive = false;
var diqV263FallbackOrigin = "";
var diqV263OriginalScanAdventureChoices = scanAdventureChoices;
var diqV263OriginalAfterScanResultsReady = afterScanResultsReady;
var diqV263OriginalRenderAdventureScanChoices = renderAdventureScanChoices;




function diqV263ClearScanWatchdog() {
  if (diqV263ScanWatchdogTimer) {
    try { window.clearTimeout(diqV263ScanWatchdogTimer); } catch (e) {}
    diqV263ScanWatchdogTimer = null;
  }
}




function diqV263BroadTrustCategory(query) {
  var cat = categoryFromQuery(query);
  var q = normText(query);
  return cat === "local favorites" ||
    cat === "popular tonight" ||
    cat === "food drinks" ||
    cat === "food iq" ||
    q.indexOf("local fave") > -1 ||
    q.indexOf("local favorite") > -1 ||
    q.indexOf("where locals go") > -1;
}




function diqV263FallbackQuery(query) {
  var cat = categoryFromQuery(query);




  if (cat === "local favorites" || normText(query).indexOf("local fave") > -1) {
    return "restaurants bars breweries bbq tacos local food downtown attractions";
  }
  if (cat === "live music") {
    return "bars breweries entertainment venues restaurants live music open mic karaoke";
  }
  if (cat === "nightlife" || cat === "popular tonight") {
    return "bars breweries cocktail lounges restaurants downtown nightlife";
  }
  if (cat === "hidden gems") {
    return "historic local restaurants landmarks museums galleries parks unique places";
  }
  if (cat === "patio vibes") {
    return "restaurants bars breweries outdoor seating patio rooftop waterfront";
  }
  return "restaurants bars coffee local attractions popular places";
}




function diqV263CompleteScanNoHang(query, reason) {
  diqV263ClearScanWatchdog();
  diqV263FallbackActive = false;
  diqV263FallbackOrigin = "";




  try { stopScanTab(); } catch (e1) {}
  try { adventureScanRadiusOverride = 0; } catch (e2) {}
  try { adventureScanFallbackPass = 0; } catch (e3) {}
  try { adventureScanOnly = false; } catch (e4) {}
  try { mapAreaScanActive = false; } catch (e5) {}




  try {
    diqV231ApplyScanReliabilityUi("Scan completed â€” no strong trusted picks rendered yet", "gold");
  } catch (uiErr) {}




  try {
    setStatus("adventureRouteStatus", "NO STRONG PICKS", "gold");
  } catch (statusErr) {}




  try {
    speakAdventureScanVoice(
      "I did not find a strong " + adventureScanCategoryLabel(query) + " pick yet. Try widening the map or changing the search.",
      "no_hang_empty|" + String(Date.now()),
      1000
    );
  } catch (voiceErr) {}




  try {
    toast(reason || "Scan finished â€” try widening the map");
  } catch (toastErr) {}




  try {
    diqV262SetFounderDebug("scanTrace", [
      "No Scan Hang IQ",
      "Direct scan timed out or returned no renderable picks",
      "Fallback attempted",
      "Scan completed without infinite spinner"
    ]);
  } catch (debugErr) {}
}




function diqV263StartScanWatchdog(query, token, fallbackMode) {
  var timeoutMs = fallbackMode ? 12500 : 16500;
  var originalQuery = clean(query || activeScanQuery || activeLens || "local favorites");




  diqV263ClearScanWatchdog();




  diqV263ScanWatchdogTimer = window.setTimeout(function () {
    var currentToken = routeAttemptToken;
    var fallback;




    if (!scanTabActive) { return; }
    if (token !== currentToken) { return; }
    if (adventureResults && adventureResults.length) {
      diqV263ClearScanWatchdog();
      return;
    }




    if (!fallbackMode && diqV263BroadTrustCategory(originalQuery)) {
      fallback = diqV263FallbackQuery(originalQuery);
      diqV263FallbackActive = true;
      diqV263FallbackOrigin = originalQuery;




      try { routeAttemptToken += 1; } catch (tokenErr) {}
      try { stopScanTab(); } catch (stopErr) {}
      try { updateScanTab("No strong local favorite yet. Showing trusted nearby alternatives..."); } catch (tabErr) {}
      try { setStatus("adventureRouteStatus", "TRUST FALLBACK", "gold"); } catch (statusErr) {}
      try { toast("No perfect local favorite signal yet â€” checking trusted nearby picks"); } catch (toastErr) {}
      try { diqV231ApplyScanReliabilityUi("No Hang IQ: local favorites fallback running", "gold"); } catch (uiErr) {}




      findDriveableAdventure(fallback);




      window.setTimeout(function () {
        diqV263StartScanWatchdog(originalQuery, routeAttemptToken, true);
      }, 80);
      return;
    }




    diqV263CompleteScanNoHang(originalQuery, "Scan finished â€” no strong picks rendered yet");
  }, timeoutMs);
}




scanAdventureChoices = function (query) {
  var q = clean(query || activeLens || "popular tonight");
  diqV263FallbackActive = false;
  diqV263FallbackOrigin = "";
  diqV263ClearScanWatchdog();
  diqV263OriginalScanAdventureChoices(q);
  diqV263StartScanWatchdog(q, routeAttemptToken, false);
};




afterScanResultsReady = function (items, preferred, reason) {
  diqV263ClearScanWatchdog();
  diqV263FallbackActive = false;
  diqV263FallbackOrigin = "";
  return diqV263OriginalAfterScanResultsReady(items, preferred, reason);
};




renderAdventureScanChoices = function (items, query) {
  if (items && items.length) {
    diqV263ClearScanWatchdog();
    diqV263FallbackActive = false;
    diqV263FallbackOrigin = "";
  }
  return diqV263OriginalRenderAdventureScanChoices(items, query);
};












/* =========================================================
   DRIVE IQ V26.4 â€” FOOD IQ + LOCAL FAVES TRUTH LOCK
   Focused patch only: FoodIQ must be restaurant-first, and
   Local Faves must be local-character-first. Prevents Coffee / smoothie
   results from winning FoodIQ and prevents generic Food + Drink fallback
   from masquerading as Local Faves. ES5-safe. No HTML changes.
========================================================= */




window.__DRIVE_IQ_ADVENTURE_MODE_JS_V26_4_FOOD_LOCAL_FAVES__ = true;




var diqV264OriginalCategoryFromQuery = categoryFromQuery;
var diqV264OriginalBuildAdventureQueries = buildAdventureQueries;
var diqV264OriginalStrictMatch = isStrictAdventureCategoryMatch;
var diqV264OriginalScoreAdventure = scoreAdventure;
var diqV264OriginalHardSuppress = diqV262HardSuppress;
var diqV264OriginalCategoryTruthScore = diqV262CategoryTruthScore;
var diqV264OriginalLocalFavoriteScore = diqV262LocalFavoriteScore;
var diqV264OriginalFallbackQuery = diqV263FallbackQuery;




function diqV264Has(txt, arr) {
  var i;
  txt = normText(txt);
  for (i = 0; i < arr.length; i++) {
    if (txt.indexOf(arr[i]) > -1) { return true; }
  }
  return false;
}




function diqV264Text(item) {
  return normText(
    String(item && item.label || "") + " " +
    String(item && item.full || "") + " " +
    String(item && item.kind || "") + " " +
    String(item && item.placeCategories || "") + " " +
    String(item && item.placeClass || "") + " " +
    String(item && item.sourceQuery || "") + " " +
    String(item && item.matchLabel || "")
  );
}




function diqV264DestinationSuffix() {
  var label = adventureScanCityLabel ? clean(adventureScanCityLabel()) : "";
  if (!label || normText(label) === "you" || normText(label) === "near you") { return ""; }
  return " " + label;
}




function diqV264Add(list, value) {
  var i;
  value = clean(value);
  if (!value) { return; }
  for (i = 0; i < list.length; i++) {
    if (normText(list[i]) === normText(value)) { return; }
  }
  list.push(value);
}




function diqV264KnownChainOrGeneric(txt) {
  return diqV264Has(txt, [
    "mcdonald", "burger king", "wendy", "taco bell", "kfc", "subway", "sonic",
    "chick fil a", "chick fil", "zaxby", "arbys", "arby", "popeyes", "dairy queen",
    "domino", "pizza hut", "little caesars", "papa john", "panda express",
    "starbucks", "dunkin", "tropical smoothie", "smoothie king", "panera",
    "applebee", "chili", "olive garden", "cracker barrel", "waffle house", "ihop",
    "walmart", "target", "walgreens", "cvs", "kroger", "dollar general", "dollar tree",
    "gas station", "convenience store", "truck stop", "travel center"
  ]);
}




function diqV264FoodRestaurantSignal(txt) {
  return diqV264Has(txt, [
    "restaurant", "grill", "bar and grill", "kitchen", "diner", "steakhouse",
    "smokehouse", "bbq", "barbecue", "burger", "taco", "mexican", "pizza",
    "seafood", "catfish", "chicken", "wings", "brunch", "breakfast", "lunch",
    "dinner", "bistro", "cajun", "italian", "sushi", "thai", "soul food",
    "meat", "ribs", "brisket", "sandwich shop"
  ]);
}




function diqV264DrinkSnackOnlySignal(txt) {
  return diqV264Has(txt, [
    "smoothie", "juice", "tea", "loaded tea", "nutrition", "coffee", "espresso",
    "cafe", "bakery", "donut", "doughnut", "ice cream", "dessert", "cookie",
    "cupcake", "yogurt", "boba"
  ]);
}




function diqV264FoodIQSnackOrCoffeeLeak(item, query) {
  var txt = diqV264Text(item);
  var q = normText(query);
  if (q.indexOf("smoothie") > -1 || q.indexOf("juice") > -1 || q.indexOf("coffee") > -1 || q.indexOf("dessert") > -1 || q.indexOf("ice cream") > -1 || q.indexOf("bakery") > -1) { return false; }
  return diqV264DrinkSnackOnlySignal(txt) && !diqV264FoodRestaurantSignal(txt);
}




function diqV264LocalFaveSignal(txt) {
  return diqV264Has(txt, [
    "local favorite", "local favourite", "locals", "where locals go", "beloved",
    "best of", "top rated", "popular", "iconic", "classic", "longtime",
    "historic", "locally owned", "family owned", "independent", "hidden gem",
    "neighborhood", "downtown", "main street", "town square", "silo square",
    "snowden grove", "district", "market", "artisan", "brewery", "taproom"
  ]);
}




function diqV264LocalFaveVenueSignal(txt) {
  return diqV264Has(txt, [
    "restaurant", "grill", "bbq", "barbecue", "burger", "pizza", "mexican",
    "taco", "seafood", "coffee", "cafe", "bakery", "ice cream", "dessert",
    "brewery", "taproom", "bar", "pub", "boutique", "bookstore", "market",
    "park", "attraction", "museum", "theater", "family entertainment"
  ]);
}




function diqV264LikelyLocalFaveCandidate(item, query) {
  var txt = diqV264Text(item);
  var dist = Number(item && item.distMiles);
  var hasLocal = diqV264LocalFaveSignal(txt);
  var venue = diqV264LocalFaveVenueSignal(txt);
  var chain = diqV264KnownChainOrGeneric(txt);
  var queryLocal = diqV264LocalFaveSignal(normText(String(item && item.sourceQuery || "") + " " + String(query || "")));




  if (!item) { return false; }
  if (chain && !hasLocal && !queryLocal) { return false; }
  if (!venue && !hasLocal && !queryLocal) { return false; }
  if (finite(dist) && dist > 32 && !hasLocal && !queryLocal) { return false; }
  return true;
}




categoryFromQuery = function (query) {
  var q = normText(query);
  if (!q) { return ""; }




  if (q.indexOf("local fave") > -1 || q.indexOf("local favorite") > -1 || q.indexOf("local favourite") > -1 || q.indexOf("where locals go") > -1 || q.indexOf("local picks") > -1 || q.indexOf("beloved local") > -1 || q.indexOf("best of town") > -1) { return "local favorites"; }




  if (
    q.indexOf("food iq") > -1 || q.indexOf("must try") > -1 || q.indexOf("must try food") > -1 ||
    q.indexOf("must-try") > -1 || q.indexOf("viral food") > -1 || q.indexOf("food worth") > -1 ||
    q.indexOf("local food") > -1 || q.indexOf("local restaurant") > -1 || q.indexOf("restaurants") > -1 ||
    q.indexOf("restaurant") > -1 || q.indexOf("dinner") > -1 || q.indexOf("lunch") > -1 ||
    q.indexOf("breakfast") > -1 || q.indexOf("brunch") > -1 || q.indexOf("burger") > -1 ||
    q.indexOf("bbq") > -1 || q.indexOf("barbecue") > -1 || q.indexOf("taco") > -1 ||
    q.indexOf("mexican") > -1 || q.indexOf("pizza") > -1 || q.indexOf("seafood") > -1 ||
    q.indexOf("grill") > -1 || q.indexOf("steak") > -1 || q.indexOf("wings") > -1
  ) { return "food iq"; }




  if (q.indexOf("coffee") > -1 || q.indexOf("cafe") > -1 || q.indexOf("espresso") > -1 || q.indexOf("roaster") > -1) { return "coffee"; }




  try { return diqV264OriginalCategoryFromQuery(query); } catch (e) { return ""; }
};




buildAdventureQueries = function (query) {
  var cat = categoryFromQuery(query);
  var out = [];
  var city = diqV264DestinationSuffix();
  var cityNorm = normText(adventureScanCityLabel ? adventureScanCityLabel() : "");
  var i;
  var base;




  if (cat === "food iq") {
    diqV264Add(out, "restaurants" + city);
    diqV264Add(out, "best restaurants" + city);
    diqV264Add(out, "local restaurants" + city);
    diqV264Add(out, "lunch restaurants" + city);
    diqV264Add(out, "dinner restaurants" + city);
    diqV264Add(out, "family restaurants" + city);
    diqV264Add(out, "bar and grill" + city);
    diqV264Add(out, "grill" + city);
    diqV264Add(out, "bbq restaurant" + city);
    diqV264Add(out, "burger restaurant" + city);
    diqV264Add(out, "mexican restaurant" + city);
    diqV264Add(out, "taco restaurant" + city);
    diqV264Add(out, "pizza restaurant" + city);
    diqV264Add(out, "seafood restaurant" + city);
    diqV264Add(out, "breakfast restaurant" + city);
    diqV264Add(out, "brunch restaurant" + city);
    if (cityNorm.indexOf("southaven") > -1 || cityNorm.indexOf("south haven") > -1) {
      diqV264Add(out, "Silo Square restaurants Southaven MS");
      diqV264Add(out, "best restaurants Southaven MS");
      diqV264Add(out, "local restaurants Southaven MS");
      diqV264Add(out, "bar and grill Southaven MS");
      diqV264Add(out, "BBQ restaurants Southaven MS");
      diqV264Add(out, "Mexican restaurants Southaven MS");
    }
    return out.slice(0, 48);
  }




  if (cat === "local favorites") {
    diqV264Add(out, "local favorite restaurants" + city);
    diqV264Add(out, "best local restaurants" + city);
    diqV264Add(out, "popular local restaurants" + city);
    diqV264Add(out, "locally owned restaurants" + city);
    diqV264Add(out, "hidden gems" + city);
    diqV264Add(out, "where locals go" + city);
    diqV264Add(out, "iconic restaurants" + city);
    diqV264Add(out, "classic restaurants" + city);
    diqV264Add(out, "neighborhood restaurants" + city);
    diqV264Add(out, "downtown restaurants" + city);
    diqV264Add(out, "town square restaurants" + city);
    diqV264Add(out, "local coffee shop" + city);
    diqV264Add(out, "local bakery" + city);
    diqV264Add(out, "local brewery" + city);
    diqV264Add(out, "local boutiques" + city);
    diqV264Add(out, "local attractions" + city);
    if (cityNorm.indexOf("southaven") > -1 || cityNorm.indexOf("south haven") > -1) {
      diqV264Add(out, "Silo Square Southaven restaurants");
      diqV264Add(out, "Silo Square local favorites Southaven");
      diqV264Add(out, "Southaven MS hidden gems");
      diqV264Add(out, "best local restaurants Southaven MS");
      diqV264Add(out, "local favorite restaurants Southaven MS");
      diqV264Add(out, "popular local places Southaven MS");
      diqV264Add(out, "top rated local spots Southaven MS");
      diqV264Add(out, "Snowden Grove Southaven restaurants");
    }
    return out.slice(0, 54);
  }




  base = diqV264OriginalBuildAdventureQueries(query) || [];
  for (i = 0; i < base.length; i++) { diqV264Add(out, base[i]); }
  return out;
};




/* Keep the JS-owned category chips pointed at the corrected category truth. */
try {
  if (window.DIQ_PERSONALIZED_CATEGORY_DEFS || typeof DIQ_PERSONALIZED_CATEGORY_DEFS !== "undefined") {
    for (var diqV264CatIdx = 0; diqV264CatIdx < DIQ_PERSONALIZED_CATEGORY_DEFS.length; diqV264CatIdx++) {
      if (DIQ_PERSONALIZED_CATEGORY_DEFS[diqV264CatIdx].id === "food") {
        DIQ_PERSONALIZED_CATEGORY_DEFS[diqV264CatIdx].query = "food iq restaurants best restaurants local restaurants lunch dinner grill bbq burgers tacos pizza mexican seafood brunch";
      }
      if (DIQ_PERSONALIZED_CATEGORY_DEFS[diqV264CatIdx].id === "local_favorites") {
        DIQ_PERSONALIZED_CATEGORY_DEFS[diqV264CatIdx].query = "local favorites best local restaurants hidden gems popular local places locally owned restaurants Silo Square";
      }
    }
  }
} catch (diqV264CatErr) {}




isStrictAdventureCategoryMatch = function (item, query) {
  var cat = categoryFromQuery(query);
  var txt = diqV264Text(item);




  if (cat === "food iq") {
    if (diqV264FoodIQSnackOrCoffeeLeak(item, query)) { return false; }
    if (diqV264Has(txt, ["gas station", "convenience store", "grocery", "pharmacy", "nutrition club"])) { return false; }
    return diqV264FoodRestaurantSignal(txt);
  }




  if (cat === "local favorites") {
    return diqV264LikelyLocalFaveCandidate(item, query);
  }




  try { return diqV264OriginalStrictMatch(item, query); } catch (e) { return true; }
};




diqV262HardSuppress = function (item, query) {
  var cat = categoryFromQuery(query);
  var txt = diqV264Text(item);




  if (cat === "food iq") {
    if (diqV264FoodIQSnackOrCoffeeLeak(item, query)) { return true; }
    if (diqV264Has(txt, ["gas station", "convenience store", "nutrition club"])) { return true; }
  }




  if (cat === "local favorites") {
    if (!diqV264LikelyLocalFaveCandidate(item, query)) { return true; }
  }




  try { return diqV264OriginalHardSuppress(item, query); } catch (e) { return false; }
};




diqV262CategoryTruthScore = function (item, query) {
  var cat = categoryFromQuery(query);
  var txt = diqV264Text(item);
  var base;




  if (cat === "food iq") {
    if (diqV264FoodIQSnackOrCoffeeLeak(item, query)) { return 0; }
    base = 42;
    if (diqV264FoodRestaurantSignal(txt)) { base += 42; }
    if (diqV264Has(txt, ["restaurant", "grill", "bbq", "barbecue", "burger", "taco", "mexican", "pizza", "seafood", "brunch", "breakfast", "dinner", "lunch"])) { base += 18; }
    if (diqV264Has(txt, ["local", "silo square", "downtown", "popular", "best", "favorite"])) { base += 10; }
    if (diqV264KnownChainOrGeneric(txt)) { base -= 22; }
    if (base < 0) { base = 0; }
    if (base > 100) { base = 100; }
    return Math.round(base);
  }




  if (cat === "local favorites") {
    base = 36;
    if (diqV264LocalFaveSignal(txt)) { base += 38; }
    if (diqV264LocalFaveVenueSignal(txt)) { base += 20; }
    if (diqV264KnownChainOrGeneric(txt) && !diqV264LocalFaveSignal(txt)) { base -= 60; }
    if (base < 0) { base = 0; }
    if (base > 100) { base = 100; }
    return Math.round(base);
  }




  try { return diqV264OriginalCategoryTruthScore(item, query); } catch (e) { return 50; }
};




diqV262LocalFavoriteScore = function (item, query) {
  var cat = categoryFromQuery(query);
  var txt = diqV264Text(item);
  var base;




  if (cat === "local favorites") {
    base = 0;
    if (diqV264LocalFaveSignal(txt)) { base += 46; }
    if (diqV264LocalFaveVenueSignal(txt)) { base += 22; }
    if (diqV264Has(txt, ["silo square", "downtown", "main street", "town square", "snowden grove", "neighborhood", "historic", "iconic"])) { base += 18; }
    if (diqV264KnownChainOrGeneric(txt) && !diqV264LocalFaveSignal(txt)) { base -= 42; }
    if (base < 0) { base = 0; }
    if (base > 100) { base = 100; }
    return Math.round(base);
  }




  try { return diqV264OriginalLocalFavoriteScore(item, query); } catch (e) { return 0; }
};




scoreAdventure = function (item, query) {
  var cat = categoryFromQuery(query);
  var txt = diqV264Text(item);
  var score;




  try { score = diqV264OriginalScoreAdventure(item, query); } catch (e) { score = 0; }
  if (!finite(score)) { score = 0; }




  if (cat === "food iq") {
    if (diqV264FoodIQSnackOrCoffeeLeak(item, query)) { return -9999; }
    if (diqV264FoodRestaurantSignal(txt)) { score += 150; }
    if (diqV264Has(txt, ["restaurant", "grill", "bbq", "barbecue", "burger", "taco", "mexican", "pizza", "seafood", "steak", "brunch", "breakfast"])) { score += 70; }
    if (diqV264Has(txt, ["silo square", "downtown", "local", "best", "popular", "favorite"])) { score += 38; }
    if (diqV264DrinkSnackOnlySignal(txt)) { score -= 110; }
    if (diqV264KnownChainOrGeneric(txt)) { score -= 35; }
  }




  if (cat === "local favorites") {
    if (!diqV264LikelyLocalFaveCandidate(item, query)) { return -9999; }
    if (diqV264LocalFaveSignal(txt)) { score += 120; }
    if (diqV264LocalFaveVenueSignal(txt)) { score += 48; }
    if (diqV264Has(txt, ["silo square", "downtown", "main street", "town square", "snowden grove", "historic", "iconic", "locally owned", "family owned"])) { score += 70; }
    if (diqV264KnownChainOrGeneric(txt) && !diqV264LocalFaveSignal(txt)) { score -= 160; }
  }




  return score;
};




diqV263FallbackQuery = function (query) {
  var cat = categoryFromQuery(query);
  var city = diqV264DestinationSuffix();




  if (cat === "local favorites") {
    return "local favorite restaurants best local restaurants hidden gems locally owned restaurants popular local places" + city;
  }
  if (cat === "food iq") {
    return "restaurants best restaurants local restaurants lunch dinner grill bbq burgers tacos pizza mexican seafood" + city;
  }
  try { return diqV264OriginalFallbackQuery(query); } catch (e) { return "restaurants local favorites popular places" + city; }
};












/* =========================================================
   DRIVE IQ V26.5 â€” LOCAL FAVES NO-HANG GUARD
   Focused patch only: Local Faves must never spin forever.
   - Caps Local Faves query fan-out so scans do not launch 100+ requests.
   - Relaxes Local Faves candidate truth enough to render local-style venues.
   - Adds a hard-stop timer that always closes the scan tab and shows an
     empty state if network requests stall. ES5-safe. No HTML changes.
========================================================= */




window.__DRIVE_IQ_ADVENTURE_MODE_JS_V26_5_LOCAL_FAVES_NO_HANG__ = true;




var diqV265OriginalBuildAdventureQueries = buildAdventureQueries;
var diqV265OriginalAdventureFallbackMaxPass = adventureFallbackMaxPass;
var diqV265OriginalLikelyLocalFaveCandidate = diqV264LikelyLocalFaveCandidate;
var diqV265OriginalScanAdventureChoices = scanAdventureChoices;
var diqV265OriginalAfterScanResultsReady = afterScanResultsReady;
var diqV265OriginalRenderAdventureScanChoices = renderAdventureScanChoices;
var diqV265LocalFavesHardStopTimer = null;




function diqV265ClearLocalFavesHardStop() {
  if (diqV265LocalFavesHardStopTimer) {
    try { window.clearTimeout(diqV265LocalFavesHardStopTimer); } catch (e) {}
    diqV265LocalFavesHardStopTimer = null;
  }
}




function diqV265IsLocalFavesQuery(query) {
  return categoryFromQuery(query) === "local favorites" || normText(query).indexOf("local fave") > -1;
}




function diqV265StartLocalFavesHardStop(query) {
  var q = clean(query || "local favorites");
  diqV265ClearLocalFavesHardStop();
  if (!diqV265IsLocalFavesQuery(q)) { return; }




  diqV265LocalFavesHardStopTimer = window.setTimeout(function () {
    if (!diqV265IsLocalFavesQuery(activeScanQuery || q)) { return; }
    if (adventureResults && adventureResults.length) { return; }




    try { diqV263ClearScanWatchdog(); } catch (watchdogErr) {}
    try { stopScanTab(); } catch (stopErr) {}
    try { adventureScanRadiusOverride = 0; } catch (radiusErr) {}
    try { adventureScanFallbackPass = 0; } catch (passErr) {}
    try { adventureScanOnly = false; } catch (scanOnlyErr) {}
    try { mapAreaScanActive = false; } catch (mapAreaErr) {}




    try { setStatus("adventureRouteStatus", "NO LOCAL FAVES", "gold"); } catch (statusErr) {}
    try { diqV231ApplyScanReliabilityUi("Local Faves scan finished â€” no strong local picks rendered yet", "gold"); } catch (uiErr) {}
    try { renderAdventureScanChoices([], q); } catch (renderErr) {}
    try { speakAdventureScanEmpty(q); } catch (voiceErr) {}
    try { toast("Local Faves finished â€” try FoodIQ, Silo Square, or Scan This Map"); } catch (toastErr) {}




    try {
      diqV262SetFounderDebug("scanTrace", [
        "V26.5 Local Faves No-Hang Guard",
        "Network or strict truth filtering did not produce renderable picks in time",
        "Scan tab closed safely",
        "Empty state rendered instead of infinite spinner"
      ]);
    } catch (debugErr) {}
  }, 11500);
}




buildAdventureQueries = function (query) {
  var cat = categoryFromQuery(query);
  var out = [];
  var city = diqV264DestinationSuffix ? diqV264DestinationSuffix() : "";
  var cityNorm = normText(adventureScanCityLabel ? adventureScanCityLabel() : "");
  var i;
  var base;




  if (cat === "local favorites") {
    diqV264Add(out, "local favorite restaurants" + city);
    diqV264Add(out, "best local restaurants" + city);
    diqV264Add(out, "popular local restaurants" + city);
    diqV264Add(out, "locally owned restaurants" + city);
    diqV264Add(out, "hidden gems" + city);
    diqV264Add(out, "where locals go" + city);
    diqV264Add(out, "downtown restaurants" + city);
    diqV264Add(out, "town square restaurants" + city);
    diqV264Add(out, "local coffee shop" + city);
    diqV264Add(out, "local brewery" + city);
    diqV264Add(out, "local attractions" + city);
    diqV264Add(out, "local boutiques" + city);




    if (cityNorm.indexOf("southaven") > -1 || cityNorm.indexOf("south haven") > -1) {
      diqV264Add(out, "Silo Square Southaven restaurants");
      diqV264Add(out, "Silo Square local favorites Southaven");
      diqV264Add(out, "Southaven MS hidden gems");
      diqV264Add(out, "best local restaurants Southaven MS");
      diqV264Add(out, "popular local places Southaven MS");
      diqV264Add(out, "Snowden Grove Southaven restaurants");
    }




    return out.slice(0, 18);
  }




  base = diqV265OriginalBuildAdventureQueries(query) || [];
  for (i = 0; i < base.length; i++) { diqV264Add(out, base[i]); }
  return out;
};




adventureFallbackMaxPass = function (query) {
  if (diqV265IsLocalFavesQuery(query)) { return 2; }
  try { return diqV265OriginalAdventureFallbackMaxPass(query); } catch (e) { return 3; }
};




diqV264LikelyLocalFaveCandidate = function (item, query) {
  var txt = diqV264Text(item);
  var dist = Number(item && item.distMiles);
  var hasLocal = diqV264LocalFaveSignal(txt);
  var venue = diqV264LocalFaveVenueSignal(txt);
  var chain = diqV264KnownChainOrGeneric(txt);
  var sourceLocal = diqV264LocalFaveSignal(normText(String(item && item.sourceQuery || "") + " " + String(query || "")));




  if (!item) { return false; }
  if (chain && !hasLocal && !sourceLocal) { return false; }




  /* Local Faves should prefer hard local evidence, but it must not reject
     every restaurant/brewery/cafe/boutique/attraction when Places metadata
     does not contain words like "local" or "favorite". */
  if (hasLocal || sourceLocal) { return true; }
  if (venue && finite(dist) && dist <= 24) { return true; }
  if (venue && !finite(dist)) { return true; }




  try { return diqV265OriginalLikelyLocalFaveCandidate(item, query); } catch (e) { return false; }
};




scanAdventureChoices = function (query) {
  var q = clean(query || activeLens || "popular tonight");
  diqV265ClearLocalFavesHardStop();
  diqV265OriginalScanAdventureChoices(q);
  if (diqV265IsLocalFavesQuery(q)) { diqV265StartLocalFavesHardStop(q); }
};




afterScanResultsReady = function (items, preferred, reason) {
  if (items && items.length) { diqV265ClearLocalFavesHardStop(); }
  return diqV265OriginalAfterScanResultsReady(items, preferred, reason);
};




renderAdventureScanChoices = function (items, query) {
  if (items && items.length) { diqV265ClearLocalFavesHardStop(); }
  return diqV265OriginalRenderAdventureScanChoices(items, query);
};
















/* =========================================================
   DRIVE IQ V26.7 â€” LOCAL HANGOUT IQ PLACES POOL
   Focused patch only: Local Faves should answer "where locals actually
   spend time," not literal "local favorites" text search.
   - Adds Geoapify Places category-pool searches around the active center.
   - Keeps curated Southaven / Silo Square / Snowden Grove anchor queries.
   - Loosens Local Faves candidate truth for restaurants, coffee, sports,
     pickleball, gyms, parks, boutiques, entertainment, and community anchors.
   ES5-safe. No HTML changes.
========================================================= */




window.__DRIVE_IQ_ADVENTURE_MODE_JS_V26_7_LOCAL_HANGOUT_PLACES_POOL__ = true;




var diqV267OriginalGeoUrl = geoUrl;
var diqV267OriginalBuildAdventureQueries = buildAdventureQueries;
var diqV267OriginalLikelyLocalFaveCandidate = diqV264LikelyLocalFaveCandidate;
var diqV267OriginalScoreAdventure = scoreAdventure;
var diqV267OriginalStrictMatch = isStrictAdventureCategoryMatch;
var diqV267OriginalVenueSignal = diqV264LocalFaveVenueSignal;




function diqV267IsLocalFavesQuery(query) {
  return categoryFromQuery(query) === "local favorites" || normText(query).indexOf("local fave") > -1 || normText(query).indexOf("local hangout") > -1;
}




function diqV267PlacesToken(categories, label) {
  return "DIQ_PLACES_LOCAL_HANGOUT::" + String(categories || "") + "::" + String(label || "Local Hangout Pool");
}




function diqV267IsPlacesToken(query) {
  return String(query || "").indexOf("DIQ_PLACES_LOCAL_HANGOUT::") === 0;
}




function diqV267TokenCategories(query) {
  var parts = String(query || "").split("::");
  return parts.length > 1 ? clean(parts[1]) : "";
}




function diqV267TokenLabel(query) {
  var parts = String(query || "").split("::");
  return parts.length > 2 ? clean(parts[2]) : "Local Hangout Pool";
}




function diqV267PlacesUrl(query, limit) {
  var center = getActiveSearchCenter ? getActiveSearchCenter() : null;
  var categories = diqV267TokenCategories(query);
  var radius = adventureScanRadiusOverride || adventureRadiusForPass("local favorites", adventureScanFallbackPass || 0) || 28000;
  var meters;




  if (!center || !finite(Number(center.lat)) || !finite(Number(center.lng)) || !categories) {
    return diqV267OriginalGeoUrl(diqV267TokenLabel(query), "search", limit || 20);
  }




  meters = Math.max(9000, Math.min(85000, Math.round(Number(radius || 28) * 1609.344)));




  return "https://api.geoapify.com/v2/places?categories=" + encodeURIComponent(categories) +
    "&filter=" + encodeURIComponent("circle:" + String(center.lng) + "," + String(center.lat) + "," + String(meters)) +
    "&bias=" + encodeURIComponent("proximity:" + String(center.lng) + "," + String(center.lat)) +
    "&limit=" + encodeURIComponent(String(limit || 30)) +
    "&apiKey=" + encodeURIComponent(GEOAPIFY_KEY);
}




geoUrl = function (query, mode, limit) {
  if (diqV267IsPlacesToken(query)) { return diqV267PlacesUrl(query, limit || 30); }
  return diqV267OriginalGeoUrl(query, mode, limit);
};




function diqV267LocalHangoutSeedQueries(out, city, cityNorm) {
  /* Category pools: these return real nearby POIs by type, then Adventure IQ
     reranks them for local character. Text queries alone were too brittle. */
  diqV264Add(out, diqV267PlacesToken("catering.restaurant,catering.cafe,catering.bar,catering.pub,catering.ice_cream", "Local food coffee and bars"));
  diqV264Add(out, diqV267PlacesToken("entertainment,leisure,leisure.park,leisure.sports_centre,sport", "Local recreation and entertainment"));
  diqV264Add(out, diqV267PlacesToken("commercial.shopping_mall,commercial.marketplace,commercial.clothing,commercial.gift_and_souvenir,commercial.books", "Local shopping districts and boutiques"));
  diqV264Add(out, diqV267PlacesToken("tourism,heritage,building.tourism,entertainment.culture", "Local attractions and community anchors"));




  diqV264Add(out, "restaurants" + city);
  diqV264Add(out, "coffee shops" + city);
  diqV264Add(out, "breweries" + city);
  diqV264Add(out, "bars" + city);
  diqV264Add(out, "parks" + city);
  diqV264Add(out, "sports complex" + city);
  diqV264Add(out, "pickleball" + city);
  diqV264Add(out, "athletic club" + city);
  diqV264Add(out, "fitness center" + city);
  diqV264Add(out, "family entertainment" + city);
  diqV264Add(out, "boutiques" + city);
  diqV264Add(out, "shopping district" + city);
  diqV264Add(out, "local attractions" + city);
  diqV264Add(out, "town square" + city);
  diqV264Add(out, "downtown" + city);




  if (cityNorm.indexOf("southaven") > -1 || cityNorm.indexOf("south haven") > -1 || cityNorm.indexOf("desoto") > -1 || cityNorm.indexOf("de soto") > -1) {
    diqV264Add(out, "Maria's Cantina Southaven MS");
    diqV264Add(out, "Marias Cantina Southaven MS");
    diqV264Add(out, "Coffee Central Southaven MS");
    diqV264Add(out, "Bangers Pickleball Southaven MS");
    diqV264Add(out, "Banger's Pickleball Southaven MS");
    diqV264Add(out, "DeSoto Athletic Club Southaven MS");
    diqV264Add(out, "DAC Southaven MS");
    diqV264Add(out, "Silo Square Southaven MS");
    diqV264Add(out, "Town Square Southaven MS");
    diqV264Add(out, "Snowden Grove Park Southaven MS");
    diqV264Add(out, "Snowden Grove Southaven MS");
    diqV264Add(out, "BankPlus Amphitheater Southaven MS");
    diqV264Add(out, "Landers Center Southaven MS");
    diqV264Add(out, "restaurants Silo Square Southaven MS");
    diqV264Add(out, "coffee Silo Square Southaven MS");
    diqV264Add(out, "shops Silo Square Southaven MS");
    diqV264Add(out, "things to do Southaven MS");
  }
}




buildAdventureQueries = function (query) {
  var cat = categoryFromQuery(query);
  var out = [];
  var city = diqV264DestinationSuffix ? diqV264DestinationSuffix() : "";
  var cityNorm = normText(adventureScanCityLabel ? adventureScanCityLabel() : "");
  var base;
  var i;




  if (cat === "local favorites") {
    diqV267LocalHangoutSeedQueries(out, city, cityNorm);
    base = diqV267OriginalBuildAdventureQueries(query) || [];
    for (i = 0; i < base.length; i++) { diqV264Add(out, base[i]); }
    return out.slice(0, 36);
  }




  return diqV267OriginalBuildAdventureQueries(query);
};




/* Places API category strings are often the only truth evidence available.
   Treat those as local-hangout evidence, then filter obvious junk later. */
diqV264LocalFaveVenueSignal = function (txt) {
  txt = normText(txt);
  if (diqV267OriginalVenueSignal(txt)) { return true; }
  return diqV264Has(txt, [
    "catering", "restaurant", "cafe", "coffee", "bar", "pub", "ice cream",
    "entertainment", "leisure", "sports centre", "sports_center", "sport",
    "pickleball", "fitness", "gym", "athletic", "park", "amphitheater",
    "arena", "tourism", "attraction", "heritage", "commercial", "marketplace",
    "shopping", "boutique", "gift", "book", "silo square", "snowden grove",
    "desoto athletic", "coffee central", "maria", "banger"
  ]);
};




function diqV267LocalHangoutNoise(txt) {
  return diqV264Has(txt, [
    "gas station", "convenience", "pharmacy", "drugstore", "car dealer",
    "auto parts", "storage", "warehouse", "bank", "atm", "insurance",
    "real estate", "apartment", "residential", "subdivision", "medical",
    "clinic", "dentist", "law office", "funeral", "church", "cemetery",
    "industrial", "manufacturing", "office", "post office", "government office"
  ]);
}




function diqV267LocalHangoutStrong(txt) {
  return diqV264Has(txt, [
    "maria", "cantina", "coffee central", "banger", "pickleball",
    "desoto athletic", "athletic club", "dac", "silo square", "town square",
    "snowden grove", "bankplus amphitheater", "landers center", "restaurant",
    "cafe", "coffee", "brewery", "bar", "park", "sports", "entertainment",
    "leisure", "boutique", "shopping", "market", "ice cream", "dessert"
  ]);
}




diqV264LikelyLocalFaveCandidate = function (item, query) {
  var txt = diqV264Text(item);
  var dist = Number(item && item.distMiles);
  var source = normText(String(item && item.sourceQuery || "") + " " + String(query || ""));
  var venue = diqV264LocalFaveVenueSignal(txt);
  var local = diqV264LocalFaveSignal(txt) || diqV264LocalFaveSignal(source);
  var strong = diqV267LocalHangoutStrong(txt) || diqV267LocalHangoutStrong(source);
  var chain = diqV264KnownChainOrGeneric(txt);




  if (!item) { return false; }
  if (diqV267LocalHangoutNoise(txt)) { return false; }
  if (chain && !local && !strong) { return false; }




  if (local || strong) { return true; }
  if (venue && finite(dist) && dist <= 40) { return true; }
  if (venue && !finite(dist)) { return true; }




  try { return diqV267OriginalLikelyLocalFaveCandidate(item, query); } catch (e) { return false; }
};




isStrictAdventureCategoryMatch = function (item, query) {
  if (diqV267IsLocalFavesQuery(query)) { return diqV264LikelyLocalFaveCandidate(item, query); }
  return diqV267OriginalStrictMatch(item, query);
};




scoreAdventure = function (item, query) {
  var score;
  var txt = diqV264Text(item);
  var source = normText(String(item && item.sourceQuery || "") + " " + String(query || ""));
  var cat = categoryFromQuery(query);




  try { score = diqV267OriginalScoreAdventure(item, query); } catch (e) { score = 0; }
  if (!finite(score)) { score = 0; }




  if (cat === "local favorites") {
    if (!diqV264LikelyLocalFaveCandidate(item, query)) { return -9999; }
    if (diqV267LocalHangoutStrong(txt)) { score += 190; }
    if (diqV267LocalHangoutStrong(source)) { score += 80; }
    if (diqV264LocalFaveVenueSignal(txt)) { score += 85; }
    if (diqV264LocalFaveSignal(txt) || diqV264LocalFaveSignal(source)) { score += 70; }
    if (diqV264Has(txt, ["silo square", "town square", "snowden grove", "southaven", "desoto", "neighborhood", "district"])) { score += 75; }
    if (diqV264KnownChainOrGeneric(txt) && !diqV267LocalHangoutStrong(txt)) { score -= 220; }
  }




  return score;
};




/* If the normal pipeline still reaches zero, this rescue now accepts the
   broader Places pool instead of requiring literal local-favorite wording. */
localFavoritesRescueResults = function (items, originalQuery) {
  var out = [];
  var i;
  var item;
  if (!diqV267IsLocalFavesQuery(originalQuery)) { return []; }
  for (i = 0; i < (items || []).length; i++) {
    item = items[i];
    if (diqV264LikelyLocalFaveCandidate(item, originalQuery)) { out.push(item); }
  }
  return out;
};












/* =========================================================
   DRIVE IQ V26.8 â€” FOODIQ CATEGORY TRUTH + LOCAL SEED RESCUE
   - Blocks retail/service leakage from FoodIQ (Best Buy, big box, etc.)
   - Allows only true meal/restaurant-style results for FoodIQ.
   - Gives Local Hangout IQ a final curated seed rescue for Southaven-area scans
     so Local Faves never depends on literal "local favorite" text matching.
   ES5-safe. No HTML changes.
========================================================= */




window.__DRIVE_IQ_ADVENTURE_MODE_JS_V26_8_FOOD_TRUTH_LOCAL_SEEDS__ = true;




var diqV268OriginalStrictMatch = isStrictAdventureCategoryMatch;
var diqV268OriginalScoreAdventure = scoreAdventure;
var diqV268OriginalRescueLocalFaves = localFavoritesRescueResults;
var diqV268OriginalBuildAdventureQueries = buildAdventureQueries;




function diqV268Text(item) {
  try {
    return normText(
      String(item && item.label || "") + " " +
      String(item && item.full || "") + " " +
      String(item && item.kind || "") + " " +
      String(item && item.category || "") + " " +
      String(item && item.placeCategories || "") + " " +
      String(item && item.placeClass || "") + " " +
      String(item && item.sourceQuery || "") + " " +
      String(item && item.matchLabel || "")
    );
  } catch (e) {
    return "";
  }
}




function diqV268HasAny(txt, arr) {
  var i;
  txt = normText(txt);
  for (i = 0; i < (arr || []).length; i++) {
    if (txt.indexOf(normText(arr[i])) > -1) { return true; }
  }
  return false;
}




function diqV268IsFoodIQQuery(query) {
  return categoryFromQuery(query) === "food iq" ||
    normText(query).indexOf("food iq") > -1 ||
    normText(query).indexOf("food worth") > -1 ||
    normText(query).indexOf("where should i eat") > -1;
}




function diqV268FoodRetailNoise(txt) {
  return diqV268HasAny(txt, [
    "best buy", "electronics", "electronic", "appliance", "computer store",
    "target", "walmart", "sam s club", "costco", "lowe s", "lowes",
    "home depot", "hardware", "department store", "shopping mall",
    "retail", "clothing", "apparel", "shoe store", "furniture", "mattress",
    "office supply", "office depot", "staples", "cell phone", "phone store",
    "verizon", "att store", "at t store", "t mobile", "auto parts",
    "autozone", "oreilly", "o reilly", "advance auto", "bank", "atm",
    "pharmacy", "drugstore", "walgreens", "cvs", "medical", "clinic",
    "dentist", "gas station", "convenience", "car dealer", "tire", "storage",
    "insurance", "real estate", "hotel", "motel", "church", "post office"
  ]);
}




function diqV268FoodMealSignal(txt) {
  return diqV268HasAny(txt, [
    "restaurant", "catering restaurant", "meal takeaway", "meal delivery",
    "grill", "bar and grill", "cantina", "taqueria", "taco", "mexican",
    "bbq", "barbecue", "pizza", "pizzeria", "burger", "hamburger",
    "steak", "steakhouse", "seafood", "fish", "chicken", "wings",
    "diner", "breakfast", "brunch", "lunch", "dinner", "sandwich",
    "italian", "sushi", "hibachi", "thai", "chinese", "cajun",
    "soul food", "food truck", "brewery", "brewpub", "pub food",
    "cafe", "coffee shop", "bakery", "donut", "dessert", "ice cream"
  ]);
}




function diqV268FoodSnackOnly(txt) {
  return diqV268HasAny(txt, [
    "smoothie", "juice bar", "tea", "coffee", "cafe", "bakery",
    "donut", "doughnut", "ice cream", "dessert", "cookie", "yogurt"
  ]) && !diqV268HasAny(txt, [
    "restaurant", "grill", "cantina", "taco", "pizza", "bbq", "barbecue",
    "burger", "steak", "seafood", "diner", "breakfast", "brunch",
    "lunch", "dinner", "sandwich", "brewery", "pub"
  ]);
}




function diqV268IsFoodIQCandidate(item, query) {
  var txt = diqV268Text(item);
  var source = normText(String(item && item.sourceQuery || "") + " " + String(query || ""));




  if (!item) { return false; }
  if (diqV268FoodRetailNoise(txt)) { return false; }
  if (diqV268FoodMealSignal(txt)) { return true; }
  if (diqV268FoodMealSignal(source) && !diqV268FoodRetailNoise(txt)) { return true; }




  return false;
}




function diqV268SouthavenContext() {
  var city = "";
  var center = null;
  try { city = normText(adventureScanCityLabel ? adventureScanCityLabel() : ""); } catch (e1) {}
  try { center = getActiveSearchCenter ? getActiveSearchCenter() : null; } catch (e2) { center = null; }




  if (city.indexOf("southaven") > -1 || city.indexOf("south haven") > -1 || city.indexOf("desoto") > -1 || city.indexOf("de soto") > -1) {
    return true;
  }




  if (center && finite(Number(center.lat)) && finite(Number(center.lng))) {
    if (Math.abs(Number(center.lat) - 34.9889) < 0.22 && Math.abs(Number(center.lng) - (-90.0126)) < 0.28) {
      return true;
    }
  }




  return false;
}




function diqV268SeedDistance(lat, lng) {
  var center = null;
  try { center = getActiveSearchCenter ? getActiveSearchCenter() : null; } catch (e) { center = null; }
  if (center && finite(Number(center.lat)) && finite(Number(center.lng))) {
    return miles(Number(center.lat), Number(center.lng), Number(lat), Number(lng));
  }
  return null;
}




function diqV268SeedItem(label, full, lat, lng, kind, categories, tag) {
  return {
    label:String(label || "Local favorite"),
    full:String(full || ""),
    lat:Number(lat),
    lng:Number(lng),
    kind:String(kind || "place"),
    placeCategories:String(categories || ""),
    placeClass:String(kind || ""),
    category:"local favorites",
    matchLabel:String(tag || "Local Hangout"),
    sourceQuery:"Drive IQ Local Seed",
    localSeed:true,
    scanScope:adventureSearchScope,
    distMiles:diqV268SeedDistance(lat, lng),
    photoUrl:""
  };
}




function diqV268SouthavenLocalSeeds() {
  return [
    diqV268SeedItem("Silo Square", "Southaven local district with food, shops, events, and hangout energy", 34.9638, -89.9939, "district", "commercial shopping district restaurant cafe entertainment", "Local District"),
    diqV268SeedItem("Snowden Grove Park", "Southaven recreation anchor, ballfields, events, and community activity", 34.9631, -89.9979, "park", "leisure park sport entertainment", "Community Anchor"),
    diqV268SeedItem("Coffee Central", "Local coffee hangout around Southaven / DeSoto County", 34.9887, -90.0127, "cafe", "catering cafe coffee local hangout", "Coffee Hangout"),
    diqV268SeedItem("Maria's Cantina", "Local cantina / restaurant-style hangout for food and groups", 34.9885, -90.0131, "restaurant", "catering restaurant cantina mexican bar", "Local Food Favorite"),
    diqV268SeedItem("Banger's Pickleball", "Social pickleball and recreation hangout around Southaven", 34.9756, -89.9979, "sports", "leisure sports_centre pickleball entertainment", "Local Recreation"),
    diqV268SeedItem("DeSoto Athletic Club", "Athletic club and local fitness community hangout", 34.9855, -90.0113, "fitness", "leisure fitness gym athletic club", "Local Fitness"),
    diqV268SeedItem("Landers Center", "Southaven events, sports, concerts, and regional gathering place", 34.9309, -89.9977, "entertainment", "entertainment arena events sports concert", "Event Anchor"),
    diqV268SeedItem("BankPlus Amphitheater", "Outdoor concert and event venue near Snowden Grove", 34.9652, -89.9974, "entertainment", "entertainment music amphitheater events", "Event Anchor")
  ];
}




function diqV268DedupeSeeds(items) {
  var out = [];
  var seen = {};
  var i;
  var item;
  var key;
  for (i = 0; i < (items || []).length; i++) {
    item = items[i];
    if (!item) { continue; }
    key = normText(String(item.label || "") + "|" + String(Math.round(Number(item.lat || 0) * 1000)) + "|" + String(Math.round(Number(item.lng || 0) * 1000)));
    if (seen[key]) { continue; }
    seen[key] = true;
    out.push(item);
  }
  return out;
}




buildAdventureQueries = function (query) {
  var cat = categoryFromQuery(query);
  var out;
  var city;
  var i;




  if (diqV268IsFoodIQQuery(query)) {
    out = [];
    city = diqV264DestinationSuffix ? diqV264DestinationSuffix() : "";
    diqV264Add(out, "restaurants" + city);
    diqV264Add(out, "best restaurants" + city);
    diqV264Add(out, "local restaurants" + city);
    diqV264Add(out, "lunch restaurants" + city);
    diqV264Add(out, "dinner restaurants" + city);
    diqV264Add(out, "grill" + city);
    diqV264Add(out, "bbq restaurants" + city);
    diqV264Add(out, "mexican restaurants" + city);
    diqV264Add(out, "pizza restaurants" + city);
    diqV264Add(out, "burger restaurants" + city);
    diqV264Add(out, "breakfast brunch restaurants" + city);
    diqV264Add(out, "Silo Square restaurants Southaven MS");
    try {
      var base = diqV268OriginalBuildAdventureQueries(query) || [];
      for (i = 0; i < base.length; i++) { diqV264Add(out, base[i]); }
    } catch (e1) {}
    return out.slice(0, 24);
  }




  return diqV268OriginalBuildAdventureQueries(query);
};




isStrictAdventureCategoryMatch = function (item, query) {
  if (diqV268IsFoodIQQuery(query)) { return diqV268IsFoodIQCandidate(item, query); }
  return diqV268OriginalStrictMatch(item, query);
};




scoreAdventure = function (item, query) {
  var score;
  var txt = diqV268Text(item);
  try { score = diqV268OriginalScoreAdventure(item, query); } catch (e) { score = 0; }
  if (!finite(score)) { score = 0; }




  if (diqV268IsFoodIQQuery(query)) {
    if (!diqV268IsFoodIQCandidate(item, query)) { return -9999; }
    if (diqV268FoodMealSignal(txt)) { score += 180; }
    if (diqV268FoodSnackOnly(txt)) { score -= 85; }
    if (diqV268HasAny(txt, ["restaurant", "grill", "cantina", "bbq", "barbecue", "pizza", "burger", "steak", "seafood", "diner", "breakfast", "brunch"])) { score += 80; }
    if (diqV268HasAny(txt, ["silo square", "town square", "southaven", "desoto", "local"])) { score += 45; }
    if (diqV268FoodRetailNoise(txt)) { return -9999; }
  }




  if (categoryFromQuery(query) === "local favorites" && item && item.localSeed) {
    score += 360;
  }




  return score;
};




localFavoritesRescueResults = function (items, originalQuery) {
  var out = [];
  var seeds = [];
  var i;
  var item;




  try {
    out = diqV268OriginalRescueLocalFaves(items, originalQuery) || [];
  } catch (e) {
    out = [];
  }




  if (diqV267IsLocalFavesQuery && diqV267IsLocalFavesQuery(originalQuery) && diqV268SouthavenContext()) {
    seeds = diqV268SouthavenLocalSeeds();
    for (i = 0; i < seeds.length; i++) { out.push(seeds[i]); }
  }




  for (i = 0; i < (items || []).length; i++) {
    item = items[i];
    if (!item) { continue; }
    if (diqV264LikelyLocalFaveCandidate && diqV264LikelyLocalFaveCandidate(item, originalQuery)) {
      out.push(item);
    }
  }




  return diqV268DedupeSeeds(out);
};








/* =========================================================
   DRIVE IQ V27 â€” BROAD PULL IQ SCAN ENGINE
   Backend JS only. ES5-safe.
   - Converts Local Faves / Local Hangout IQ into a true candidate-pool scan.
   - Uses Travel Mode's working pattern: multi-query -> merge -> dedupe ->
     truth filter -> score -> diversity -> render.
   - Keeps FoodIQ truth protection active and re-routes FoodIQ through the
     same broad-pull path so retail leaks get filtered before render.
   - Adds Founder Debug IQ stats in console + localStorage.
========================================================= */




window.__DRIVE_IQ_ADVENTURE_MODE_JS_V27_BROAD_PULL_IQ__ = true;




var diqV27OriginalScanAdventureChoices = scanAdventureChoices;
var diqV27OriginalFindDriveableAdventure = findDriveableAdventure;




function diqV27IsBroadPullCategory(query) {
  var cat = categoryFromQuery(query);
  return cat === "local favorites" || cat === "food iq" || cat === "coffee iq";
}




function diqV27CategoryKey(query) {
  var cat = categoryFromQuery(query);
  if (cat === "local favorites") { return "local_hangouts"; }
  if (cat === "food iq") { return "food_iq"; }
  if (cat === "coffee iq") { return "coffee_iq"; }
  return "";
}




function diqV27CitySuffix() {
  try {
    if (diqV264DestinationSuffix) { return diqV264DestinationSuffix(); }
  } catch (e1) {}
  try {
    if (adventureSearchCenter && adventureSearchCenter.label) {
      return " " + String(adventureSearchCenter.label);
    }
  } catch (e2) {}
  return "";
}




function diqV27Add(out, value) {
  var i;
  var n;
  value = clean(value);
  if (!value) { return; }
  n = normText(value);
  for (i = 0; i < out.length; i++) {
    if (normText(out[i]) === n) { return; }
  }
  out.push(value);
}




function diqV27PlacesToken(categories, label) {
  if (typeof diqV267PlacesToken === "function") {
    return diqV267PlacesToken(categories, label);
  }
  return "DIQ_PLACES_LOCAL_HANGOUT::" + String(categories || "") + "::" + String(label || "Broad Pull Pool");
}




function diqV27Config(query) {
  var key = diqV27CategoryKey(query);
  var city = diqV27CitySuffix();
  var out = [];
  var cfg = {
    key:key,
    query:String(query || ""),
    label:key === "food_iq" ? "FoodIQ" : (key === "coffee_iq" ? "Coffee IQ" : "Local Hangout IQ"),
    pools:out,
    maxResults:8
  };




  if (key === "food_iq") {
    diqV27Add(out, diqV27PlacesToken("catering.restaurant,catering.fast_food,catering.food_court,catering.pub,catering.bar", "FoodIQ restaurant pool"));
    diqV27Add(out, "restaurants" + city);
    diqV27Add(out, "best restaurants" + city);
    diqV27Add(out, "local restaurants" + city);
    diqV27Add(out, "dinner restaurants" + city);
    diqV27Add(out, "lunch restaurants" + city);
    diqV27Add(out, "breakfast brunch restaurants" + city);
    diqV27Add(out, "bbq restaurants" + city);
    diqV27Add(out, "mexican restaurants" + city);
    diqV27Add(out, "pizza restaurants" + city);
    diqV27Add(out, "burger restaurants" + city);
    diqV27Add(out, "seafood restaurants" + city);
    diqV27Add(out, "steakhouse" + city);
    diqV27Add(out, "Silo Square restaurants Southaven MS");
    return cfg;
  }




  if (key === "coffee_iq") {
    cfg.maxResults = 10;
    diqV27Add(out, diqV27PlacesToken("catering.cafe", "Coffee IQ true cafe pool"));
    diqV27Add(out, diqV27PlacesToken("catering.cafe,catering.restaurant", "Coffee IQ cafe restaurant backup"));
    diqV27Add(out, "coffee shops" + city);
    diqV27Add(out, "local coffee shops" + city);
    diqV27Add(out, "independent coffee" + city);
    diqV27Add(out, "specialty coffee" + city);
    diqV27Add(out, "espresso bar" + city);
    diqV27Add(out, "coffee roaster" + city);
    diqV27Add(out, "coffeehouse" + city);
    diqV27Add(out, "cafes" + city);
    diqV27Add(out, "bakery cafe" + city);
    diqV27Add(out, "pastries coffee" + city);
    diqV27Add(out, "work friendly coffee" + city);
    diqV27Add(out, "patio coffee" + city);
    diqV27Add(out, "bookstore cafe" + city);
    if (diqV268SouthavenContext && diqV268SouthavenContext()) {
      diqV27Add(out, "Coffee Central Southaven MS");
      diqV27Add(out, "Avenue Coffee Southaven MS");
      diqV27Add(out, "coffee Silo Square Southaven MS");
      diqV27Add(out, "local cafe Southaven MS");
      diqV27Add(out, "bakery cafe Southaven MS");
      diqV27Add(out, "coffee shops Memphis TN");
      diqV27Add(out, "Comeback Coffee Memphis TN");
      diqV27Add(out, "Otherlands Coffee Memphis TN");
      diqV27Add(out, "French Truck Coffee Memphis TN");
      diqV27Add(out, "City and State coffee Memphis TN");
      diqV27Add(out, "Vice and Virtue coffee Memphis TN");
    }
    return cfg;
  }




  if (key === "local_hangouts") {
    diqV27Add(out, diqV27PlacesToken("catering.restaurant,catering.cafe,catering.bar,catering.pub,catering.ice_cream", "Local food coffee and bars"));
    diqV27Add(out, diqV27PlacesToken("entertainment,entertainment.culture,leisure,leisure.park,leisure.sports_centre,sport", "Local recreation and entertainment"));
    diqV27Add(out, diqV27PlacesToken("tourism,heritage,building.tourism", "Local attractions and anchors"));
    diqV27Add(out, diqV27PlacesToken("commercial.shopping_mall,commercial.marketplace,commercial.clothing,commercial.gift_and_souvenir,commercial.books", "Local shopping and districts"));
    diqV27Add(out, "restaurants" + city);
    diqV27Add(out, "coffee shops" + city);
    diqV27Add(out, "breweries" + city);
    diqV27Add(out, "bars" + city);
    diqV27Add(out, "parks" + city);
    diqV27Add(out, "pickleball" + city);
    diqV27Add(out, "athletic club" + city);
    diqV27Add(out, "fitness center" + city);
    diqV27Add(out, "family entertainment" + city);
    diqV27Add(out, "boutiques" + city);
    diqV27Add(out, "shopping district" + city);
    diqV27Add(out, "things to do" + city);
    diqV27Add(out, "town square" + city);
    diqV27Add(out, "downtown" + city);
    if (diqV268SouthavenContext && diqV268SouthavenContext()) {
      diqV27Add(out, "Maria's Cantina Southaven MS");
      diqV27Add(out, "Coffee Central Southaven MS");
      diqV27Add(out, "Banger's Pickleball Southaven MS");
      diqV27Add(out, "DeSoto Athletic Club Southaven MS");
      diqV27Add(out, "Silo Square Southaven MS");
      diqV27Add(out, "Snowden Grove Park Southaven MS");
      diqV27Add(out, "Landers Center Southaven MS");
      diqV27Add(out, "BankPlus Amphitheater Southaven MS");
    }
    return cfg;
  }




  return cfg;
}




function diqV27PrepareScan(query) {
  var q = clean(query);
  var destCenter;




  activeScanQuery = q;
  activeScanStartedAt = Date.now();
  adventureScanRadiusOverride = 0;
  adventureScanFallbackPass = 0;
  adventureScanOnly = true;




  try { syncAdventureMapDock(); } catch (dockSyncErr) {}
  if (adventureAutoCollapseTimer) { window.clearTimeout(adventureAutoCollapseTimer); adventureAutoCollapseTimer = null; }
  if (scanMapFitTimer) { window.clearTimeout(scanMapFitTimer); scanMapFitTimer = null; }




  try { exitScanResultsMode(); } catch (modeErr) {}
  stopScanTab();




  if (!GEOAPIFY_KEY) {
    setStatus("adventureRouteStatus", "SEARCH UNAVAILABLE", "red");
    toast("Search unavailable");
    return false;
  }




  activeLens = q.toLowerCase();
  lsSet(LS.ADVENTURE_LENS, activeLens);




  destCenter = getDestinationScanCenter(q);
  destinationPreviewScan = !!destCenter;




  if (mapAreaScanActive && adventureSearchCenter && finite(Number(adventureSearchCenter.lat)) && finite(Number(adventureSearchCenter.lng))) {
    destinationPreviewScan = false;
    adventureSearchScope = "map_area";
  } else {
    adventureSearchCenter = destCenter || (lastFix ? { lat:Number(lastFix.lat), lng:Number(lastFix.lng), label:"you" } : null);
    adventureSearchScope = destCenter ? "near_destination" : "near_me";
  }




  if (!lastFix && !destCenter && adventureSearchScope !== "map_area") {
    waitingForGpsQuery = q;
    setStatus("adventureRouteStatus", "WAITING FOR GPS", "gold");
    toast("Locking GPS first");
    requestGPS(true);
    return false;
  }




  routeAttemptToken += 1;




  closeAdventureInfoCard();
  hideDestinationResults();
  adventureResults = [];
  adventurePreferred = null;
  try {
    if (map && mapLoaded && map.getSource("adventure-results")) {
      map.getSource("adventure-results").setData(emptyFC());
    }
  } catch (e1) {}




  setStatus("adventureRouteStatus", "BROAD PULL IQ", "gold");
  startScanTab(scanTabTitleForQuery(q), "Building a smarter candidate pool...");
  speakAdventureScanStart(q);
  toast("Building " + titleCaseWords(categoryFromQuery(q) || "Adventure") + " pool");
  return true;
}




function diqV27CandidateBucket(item, key) {
  var txt = diqV268Text ? diqV268Text(item) : adventureTruthText(item);
  if (key === "coffee_iq") {
    if (diqV268HasAny(txt, ["roaster", "roastery", "coffee roaster"])) { return "roaster"; }
    if (diqV268HasAny(txt, ["espresso", "latte", "cappuccino", "coffee"])) { return "coffee"; }
    if (diqV268HasAny(txt, ["cafe", "cafÃ©", "coffeehouse", "coffee shop"])) { return "cafe"; }
    if (diqV268HasAny(txt, ["bakery", "pastry", "pastries", "donut", "doughnut", "bagel"])) { return "bakery"; }
    if (diqV268HasAny(txt, ["breakfast", "brunch"])) { return "breakfast"; }
    if (diqV268HasAny(txt, ["bookstore", "books", "study", "workspace"])) { return "work_study"; }
    return "coffee_local";
  }
  if (key === "food_iq") {
    if (diqV268HasAny(txt, ["bbq", "barbecue", "smokehouse", "brisket", "ribs"])) { return "bbq"; }
    if (diqV268HasAny(txt, ["mexican", "taco", "taqueria", "cantina"])) { return "mexican"; }
    if (diqV268HasAny(txt, ["pizza", "pizzeria"])) { return "pizza"; }
    if (diqV268HasAny(txt, ["burger", "hamburger"])) { return "burger"; }
    if (diqV268HasAny(txt, ["breakfast", "brunch", "diner"])) { return "breakfast"; }
    if (diqV268HasAny(txt, ["seafood", "fish", "shrimp"])) { return "seafood"; }
    if (diqV268HasAny(txt, ["steak", "steakhouse"])) { return "steak"; }
    if (diqV268HasAny(txt, ["cafe", "coffee", "bakery", "dessert", "ice cream"])) { return "snack"; }
    return "restaurant";
  }




  if (diqV268HasAny(txt, ["coffee", "cafe", "espresso"])) { return "coffee"; }
  if (diqV268HasAny(txt, ["restaurant", "cantina", "grill", "bbq", "barbecue", "taco", "pizza", "burger", "seafood", "diner"])) { return "food"; }
  if (diqV268HasAny(txt, ["brewery", "bar", "pub", "taproom", "cocktail"])) { return "social"; }
  if (diqV268HasAny(txt, ["pickleball", "athletic", "fitness", "gym", "sports centre", "sports_center", "sport"])) { return "fitness_recreation"; }
  if (diqV268HasAny(txt, ["park", "snowden grove", "greenway", "amphitheater", "amphitheatre", "arena", "landers", "event venue", "entertainment"])) { return "community_anchor"; }
  if (diqV268HasAny(txt, ["boutique", "shop", "shopping", "market", "commercial", "silo square", "town square", "district"])) { return "district_shopping"; }
  if (diqV268HasAny(txt, ["ice cream", "dessert", "bakery"])) { return "dessert"; }
  return "local";
}




function diqV274CoffeeText(item) {
  return diqV268Text ? diqV268Text(item) : adventureTruthText(item);
}




function diqV274CoffeeSignal(txt) {
  txt = normText(txt);
  return diqV268HasAny(txt, [
    "coffee", "coffee shop", "coffeehouse", "coffee house", "cafe", "cafÃ©",
    "espresso", "latte", "cappuccino", "cold brew", "mocha", "americano",
    "roaster", "roastery", "roasted coffee", "specialty coffee",
    "bakery cafe", "cafe bakery", "pastry coffee", "pastries coffee",
    "breakfast coffee", "bookstore cafe", "work friendly coffee"
  ]);
}




function diqV277CoffeePrimarySignal(txt) {
  txt = normText(txt);
  return diqV268HasAny(txt, [
    "coffee", "coffee shop", "coffeehouse", "coffee house", "espresso",
    "latte", "cappuccino", "cold brew", "roaster", "roastery", "specialty coffee",
    "coffee central", "french truck", "comeback coffee", "otherlands", "belltower",
    "vice virtue", "vice and virtue", "boycott coffee", "city state", "tamp and tap",
    "ugly mug", "avenue coffee", "square beans", "starbucks", "dunkin", "dutch bros",
    "scooter"
  ]);
}




function diqV277CoffeeSecondarySignal(txt) {
  txt = normText(txt);
  return diqV268HasAny(txt, [
    "cafe", "cafÃ©", "bakery", "pastry", "pastries", "donut", "doughnut",
    "bagel", "tea", "bookstore cafe", "brunch cafe", "breakfast cafe"
  ]);
}




function diqV274CoffeeNoise(txt) {
  txt = normText(txt);
  return diqV268HasAny(txt, [
    "bank", "atm", "pharmacy", "drugstore", "walgreens", "cvs", "hospital", "clinic", "dentist",
    "church", "school", "university", "hotel", "motel", "gas station", "fuel", "car wash",
    "auto parts", "autozone", "o reilly", "oreilly", "best buy", "electronics", "hardware",
    "lowe", "home depot", "walmart", "target", "department store", "supermarket", "grocery",
    "office", "storage", "real estate", "insurance", "lawyer", "funeral", "smoothie",
    "tropical smoothie", "juice bar", "nutrition", "protein shake", "fast food", "burger",
    "pizza", "taco", "bbq", "barbecue", "steakhouse", "seafood", "chicken", "wings"
  ]);
}




function diqV277CoffeeEmergencyOnly(txt) {
  txt = normText(txt);
  return diqV268HasAny(txt, [
    "tropical smoothie", "smoothie", "juice bar", "nutrition", "protein shake",
    "big bad breakfast", "breakfast restaurant", "brunch restaurant", "diner",
    "fast food", "mcdonald", "burger king", "wendy", "taco bell", "sonic"
  ]);
}




function diqV274CoffeeChainPenalty(txt) {
  txt = normText(txt);
  if (diqV268HasAny(txt, [
    "starbucks", "dunkin", "dunkin donuts", "scooter", "scooter's", "dutch bros",
    "biggby", "mcdonald", "mccafe", "panera"
  ])) { return true; }
  return false;
}




function diqV274IsCoffeeCandidate(item) {
  var txt = diqV274CoffeeText(item);
  var primary;
  var secondary;
  if (!txt) { return false; }
  primary = diqV277CoffeePrimarySignal(txt);
  secondary = diqV277CoffeeSecondarySignal(txt);




  if (diqV277CoffeeEmergencyOnly(txt) && !primary) { return false; }
  if (diqV274CoffeeNoise(txt) && !primary && !secondary) { return false; }
  if (primary) { return true; }




  /*
    Secondary cafÃ©/bakery signals are allowed only when they do not look like
    a generic restaurant/smoothie/fast-food leak.
  */
  if (secondary && !diqV277CoffeeEmergencyOnly(txt)) { return true; }




  return false;
}




function diqV27TruthMatch(item, query, key) {
  if (!item) { return false; }
  if (key === "coffee_iq") {
    return diqV274IsCoffeeCandidate(item);
  }
  if (key === "food_iq") {
    return diqV268IsFoodIQCandidate ? diqV268IsFoodIQCandidate(item, query) : isStrictAdventureCategoryMatch(item, query);
  }
  if (key === "local_hangouts") {
    if (diqV264LikelyLocalFaveCandidate && diqV264LikelyLocalFaveCandidate(item, query)) { return true; }
    if (item.localSeed) { return true; }
    return isStrictAdventureCategoryMatch(item, query);
  }
  return isStrictAdventureCategoryMatch(item, query);
}




function diqV27Score(item, query, key) {
  var score = 0;
  var txt = diqV268Text ? diqV268Text(item) : adventureTruthText(item);
  var dist = item && finite(Number(item.diqV273DistanceMiles)) ? Number(item.diqV273DistanceMiles) : (item && finite(Number(item.distMiles)) ? Number(item.distMiles) : null);
  try { score = scoreAdventure(item, query); } catch (e) { score = 0; }
  if (!finite(score)) { score = 0; }




  if (key === "local_hangouts") {
    score += 80;
    if (item && item.localSeed) { score += 420; }
    if (diqV268HasAny(txt, ["silo square", "town square", "snowden grove", "southaven", "desoto", "maria", "coffee central", "banger", "pickleball", "athletic club", "landers", "bankplus"])) { score += 160; }
    if (diqV268HasAny(txt, ["coffee", "cafe", "restaurant", "cantina", "brewery", "bar", "park", "fitness", "gym", "sports", "boutique", "shopping", "entertainment"])) { score += 75; }
  }




  if (key === "coffee_iq") {
    if (!diqV274IsCoffeeCandidate(item)) { return -9999; }




    score += 130;




    if (diqV277CoffeePrimarySignal(txt)) { score += 210; }
    if (diqV268HasAny(txt, ["coffee central", "local coffee", "independent", "locally owned", "neighborhood", "community", "specialty coffee"])) { score += 175; }
    if (diqV268HasAny(txt, ["roaster", "roastery", "espresso bar", "coffeehouse", "coffee house"])) { score += 150; }
    if (diqV268HasAny(txt, ["cafe", "cafÃ©", "bakery", "pastry", "pastries", "breakfast cafe", "brunch cafe"])) { score += 70; }
    if (diqV268HasAny(txt, ["patio", "cozy", "study", "workspace", "work friendly", "bookstore", "quiet"])) { score += 45; }




    if (diqV274CoffeeChainPenalty(txt)) { score -= 115; }
    if (diqV277CoffeeEmergencyOnly(txt) && !diqV277CoffeePrimarySignal(txt)) { return -9999; }
    if (item && item.localSeed) { score += 260; }




    if (finite(Number(dist))) {
      if (Number(dist) <= 3) { score += 32; }
      else if (Number(dist) <= 8) { score += 18; }
      else if (Number(dist) > 22) { score -= 35; }
    }
  }




  if (key === "food_iq") {
    if (diqV268FoodRetailNoise && diqV268FoodRetailNoise(txt)) { return -9999; }
    if (diqV268FoodMealSignal && diqV268FoodMealSignal(txt)) { score += 180; }
    if (diqV268FoodSnackOnly && diqV268FoodSnackOnly(txt)) { score -= 90; }
  }




  return score;
}




function diqV27Dedupe(items) {
  try { return dedupe(items || []); } catch (e) {}
  return diqV268DedupeSeeds ? diqV268DedupeSeeds(items || []) : (items || []);
}




function diqV27DiverseTop(items, query, key, limit) {
  var sorted = [];
  var buckets = {};
  var out = [];
  var fill = [];
  var i;
  var item;
  var b;
  var maxPerBucket = key === "local_hangouts" || key === "coffee_iq" ? 2 : 3;




  for (i = 0; i < (items || []).length; i++) {
    item = items[i];
    if (!item) { continue; }
    item.diqV27Bucket = diqV27CandidateBucket(item, key);
    item.diqV27Score = diqV27Score(item, query, key);
    if (item.diqV27Score <= -9000) { continue; }
    sorted.push(item);
  }




  sorted.sort(function (a, b2) { return Number(b2.diqV27Score || 0) - Number(a.diqV27Score || 0); });




  for (i = 0; i < sorted.length; i++) {
    item = sorted[i];
    b = item.diqV27Bucket || "other";
    if (!buckets[b]) { buckets[b] = 0; }
    if (buckets[b] < maxPerBucket) {
      out.push(item);
      buckets[b] += 1;
    } else {
      fill.push(item);
    }
    if (out.length >= limit) { return out; }
  }




  for (i = 0; i < fill.length && out.length < limit; i++) {
    out.push(fill[i]);
  }




  return out.slice(0, limit);
}




function diqV27DebugStats(raw, truth, finalItems, cfg) {
  var stats = {};
  var geo = null;
  var i;
  var b;
  stats.category = cfg ? cfg.label : "Broad Pull IQ";
  stats.rawCandidates = raw ? raw.length : 0;
  stats.afterTruthFilter = truth ? truth.length : 0;
  stats.rendered = finalItems ? finalItems.length : 0;
  try { geo = safeParse(localStorage.getItem("diq_adventure_v273_geo_last")); } catch (geoErr) { geo = null; }
  if (geo) {
    stats.center = geo.center;
    stats.radiusMiles = geo.radiusMiles;
    stats.rejectedDistance = geo.rejectedDistance;
    stats.afterDistanceFilter = geo.afterDistance;
  }
  stats.buckets = {};
  for (i = 0; i < (raw || []).length; i++) {
    b = diqV27CandidateBucket(raw[i], cfg ? cfg.key : "");
    if (!stats.buckets[b]) { stats.buckets[b] = 0; }
    stats.buckets[b] += 1;
  }
  try { localStorage.setItem("diq_adventure_v27_debug_last", JSON.stringify(stats)); } catch (e1) {}
  if (window.console && window.console.log) { window.console.log("[Adventure V27 Broad Pull IQ]", stats); }
  return stats;
}




/* =========================================================
   DRIVE IQ V27.3 â€” LOCAL FAVES GEOGRAPHY GUARD
   Broad-pull scans can ask multiple sources/queries, but every rendered
   candidate must stay near the active scan center. This prevents a single
   global text-search result from pulling the map to the world.
========================================================= */




window.__DRIVE_IQ_ADVENTURE_MODE_JS_V27_3_LOCAL_GEOGRAPHY_GUARD__ = true;




function diqV273ActiveScanCenter() {
  if (adventureSearchCenter && finite(Number(adventureSearchCenter.lat)) && finite(Number(adventureSearchCenter.lng))) {
    return {
      lat:Number(adventureSearchCenter.lat),
      lng:Number(adventureSearchCenter.lng),
      label:String(adventureSearchCenter.label || "scan center")
    };
  }
  if (destination && finite(Number(destination.lat)) && finite(Number(destination.lng)) && adventureSearchScope === "near_destination") {
    return {
      lat:Number(destination.lat),
      lng:Number(destination.lng),
      label:String(destination.label || "destination")
    };
  }
  if (lastFix && finite(Number(lastFix.lat)) && finite(Number(lastFix.lng))) {
    return {
      lat:Number(lastFix.lat),
      lng:Number(lastFix.lng),
      label:"near you"
    };
  }
  return null;
}




function diqV273RadiusMiles(cfg) {
  var key = cfg && cfg.key ? String(cfg.key) : "";
  var radius = 35;




  if (key === "food_iq") { radius = 28; }
  if (key === "coffee_iq") { radius = 24; }
  if (key === "local_hangouts") { radius = 36; }




  if (adventureSearchScope === "near_destination") {
    radius = key === "food_iq" ? 32 : (key === "coffee_iq" ? 26 : 42);
  } else if (adventureSearchScope === "map_area") {
    radius = key === "food_iq" ? 30 : (key === "coffee_iq" ? 26 : 40);
  }




  if (finite(Number(adventureScanRadiusOverride)) && Number(adventureScanRadiusOverride) > 0) {
    radius = Math.max(radius, Number(adventureScanRadiusOverride) / 1609.344);
  }




  return radius;
}




function diqV273DistanceFromCenter(item, center) {
  var d;
  if (!item || !center) { return null; }
  if (!finite(Number(item.lat)) || !finite(Number(item.lng))) { return null; }
  try {
    d = miles(Number(center.lat), Number(center.lng), Number(item.lat), Number(item.lng));
  } catch (e) {
    d = null;
  }
  if (!finite(Number(d))) { return null; }
  item.diqV273DistanceMiles = Number(d);
  item.distanceFromScanCenter = Number(d);
  return Number(d);
}




function diqV273SortNumbers(values) {
  return (values || []).sort(function (a, b) { return Number(a) - Number(b); });
}




function diqV273Median(values) {
  var arr = diqV273SortNumbers((values || []).slice(0));
  var mid;
  if (!arr.length) { return null; }
  mid = Math.floor(arr.length / 2);
  if (arr.length % 2) { return Number(arr[mid]); }
  return (Number(arr[mid - 1]) + Number(arr[mid])) / 2;
}




function diqV273NearbyCluster(items, cfg, strictRadius) {
  var center = diqV273ActiveScanCenter();
  var radius = finite(Number(strictRadius)) && Number(strictRadius) > 0 ? Number(strictRadius) : diqV273RadiusMiles(cfg);
  var out = [];
  var distances = [];
  var median;
  var spreadLimit;
  var i;
  var item;
  var d;




  if (!center) { return (items || []).slice(0); }




  for (i = 0; i < (items || []).length; i++) {
    item = items[i];
    d = diqV273DistanceFromCenter(item, center);




    if (!finite(Number(d))) { continue; }




    /*
      Seeds are hand-placed and already local, but still require a wide
      sanity gate so stale/incorrect seed coordinates cannot cause world zoom.
    */
    if (item.localSeed && Number(d) <= Math.max(radius * 1.75, 75)) {
      out.push(item);
      distances.push(Number(d));
      continue;
    }




    if (Number(d) <= radius) {
      out.push(item);
      distances.push(Number(d));
    }
  }




  if (out.length <= 2) { return out; }




  median = diqV273Median(distances);
  if (!finite(Number(median))) { return out; }




  /*
    One bad remote candidate should never dominate the camera. Keep the tight
    nearby cluster and discard the outlier before render/map fit.
  */
  spreadLimit = Math.max(radius, Number(median) * 3, 12);
  if (spreadLimit > Math.max(radius * 1.25, 18)) {
    spreadLimit = Math.max(radius * 1.25, 18);
  }




  return out.filter(function (candidate) {
    var cd = Number(candidate.diqV273DistanceMiles);
    return finite(cd) && cd <= spreadLimit;
  });
}




function diqV273FilterByGeography(items, cfg) {
  var center = diqV273ActiveScanCenter();
  var radius = diqV273RadiusMiles(cfg);
  var nearby;
  var stats = {
    center:center ? String(center.label || "scan center") : "none",
    radiusMiles:radius,
    before:(items || []).length,
    afterDistance:0,
    rejectedDistance:0,
    scope:String(adventureSearchScope || "near_me")
  };




  if (!center) {
    stats.afterDistance = (items || []).length;
    try { localStorage.setItem("diq_adventure_v273_geo_last", JSON.stringify(stats)); } catch (e0) {}
    if (window.console && window.console.log) { window.console.log("[Adventure V27.3 Geography Guard]", stats); }
    return items || [];
  }




  nearby = diqV273NearbyCluster(items || [], cfg, radius);
  stats.afterDistance = nearby.length;
  stats.rejectedDistance = Math.max(0, stats.before - stats.afterDistance);




  try { localStorage.setItem("diq_adventure_v273_geo_last", JSON.stringify(stats)); } catch (e1) {}
  if (window.console && window.console.log) { window.console.log("[Adventure V27.3 Geography Guard]", stats); }




  return nearby;
}




var diqV273OriginalFitAdventureResultsCluster = fitAdventureResultsCluster;
fitAdventureResultsCluster = function (items, preferred) {
  var cfg = { key: diqV27CategoryKey(activeScanQuery || activeLens || "") };
  var guarded = diqV273NearbyCluster(items || [], cfg, diqV273RadiusMiles(cfg));
  var safePreferred = preferred;
  var i;




  if (guarded && guarded.length) {
    if (safePreferred) {
      for (i = 0; i < guarded.length; i++) {
        if (guarded[i] === safePreferred) { break; }
      }
      if (i >= guarded.length) { safePreferred = guarded[0]; }
    } else {
      safePreferred = guarded[0];
    }
    return diqV273OriginalFitAdventureResultsCluster(guarded, safePreferred);
  }




  return diqV273OriginalFitAdventureResultsCluster(items, preferred);
};












function diqV277CoffeeSeedItem(label, full, lat, lng, tag) {
  var item = diqV268SeedItem ? diqV268SeedItem(label, full, lat, lng, "cafe", "catering cafe coffee coffeehouse espresso roaster local", tag || "Coffee IQ") : null;
  if (!item) {
    item = { label:String(label || "Coffee"), full:String(full || ""), lat:Number(lat), lng:Number(lng), kind:"cafe", placeCategories:"catering cafe coffee", matchLabel:String(tag || "Coffee IQ"), localSeed:true };
  }
  item.coffeeSeed = true;
  item.localSeed = true;
  item.matchLabel = tag || "Coffee IQ";
  return item;
}




function diqV277CoffeeSeeds() {
  var out = [];
  if (diqV268SouthavenContext && diqV268SouthavenContext()) {
    out.push(diqV277CoffeeSeedItem("Coffee Central", "Local coffee hangout around Southaven and DeSoto County.", 34.9887, -90.0127, "Local CafÃ©"));
    out.push(diqV277CoffeeSeedItem("Starbucks", "Reliable coffee stop near Southaven shopping and daily routes.", 34.9647, -89.9930, "Coffee Backup"));
    out.push(diqV277CoffeeSeedItem("Comeback Coffee", "Memphis coffee shop with local cafÃ© energy and destination-worthy coffee.", 35.1486, -90.0498, "Memphis Coffee"));
    out.push(diqV277CoffeeSeedItem("Otherlands Coffee Bar", "Midtown Memphis coffeehouse known for local character and hangout energy.", 35.1304, -89.9894, "Memphis Coffeehouse"));
    out.push(diqV277CoffeeSeedItem("French Truck Coffee", "Specialty coffee stop with roaster-style credibility around Memphis.", 35.1369, -90.0162, "Coffee Roaster"));
    out.push(diqV277CoffeeSeedItem("City & State", "Coffee shop and local market with neighborhood cafÃ© energy.", 35.1390, -89.9698, "Local CafÃ©"));
  }
  return out;
}








function diqV27RenderBroadPull(rawItems, query, cfg, token) {
  var all = [];
  var truth = [];
  var finalItems = [];
  var seeds = [];
  var i;
  var item;




  if (token !== routeAttemptToken) { return; }




  all = diqV27Dedupe(rawItems || []);




  if (cfg && cfg.key === "local_hangouts" && diqV268SouthavenContext && diqV268SouthavenContext() && diqV268SouthavenLocalSeeds) {
    seeds = diqV268SouthavenLocalSeeds();
    for (i = 0; i < seeds.length; i++) { all.push(seeds[i]); }
    all = diqV27Dedupe(all);
  }




  if (cfg && cfg.key === "coffee_iq") {
    seeds = diqV277CoffeeSeeds ? diqV277CoffeeSeeds() : [];
    for (i = 0; i < seeds.length; i++) { all.push(seeds[i]); }
    all = diqV27Dedupe(all);
  }




  /*
    DRIVE IQ V27.3 LOCAL FAVES GEOGRAPHY GUARD:
    Geoapify text search can occasionally return global matches for broad
    human phrases. Distance is now a hard gate before truth/scoring/render.
  */
  all = diqV273FilterByGeography(all, cfg);




  for (i = 0; i < all.length; i++) {
    item = all[i];
    if (diqV27TruthMatch(item, query, cfg.key)) { truth.push(item); }
  }




  truth = diqV273FilterByGeography(truth, cfg);
  finalItems = diqV27DiverseTop(truth, query, cfg.key, cfg.maxResults || 8);
  finalItems = diqV273NearbyCluster(finalItems, cfg, diqV273RadiusMiles(cfg));




  /* Last-resort seed render for Southaven local hangouts. */
  if (!finalItems.length && cfg.key === "local_hangouts" && diqV268SouthavenContext && diqV268SouthavenContext() && diqV268SouthavenLocalSeeds) {
    finalItems = diqV273NearbyCluster(diqV268SouthavenLocalSeeds(), cfg, Math.max(diqV273RadiusMiles(cfg), 45)).slice(0, cfg.maxResults || 8);
  }




  /* Coffee IQ seed rescue: never let true local cafÃ© inventory lose to generic leakage. */
  if ((!finalItems.length || finalItems.length < 4) && cfg.key === "coffee_iq" && diqV277CoffeeSeeds) {
    seeds = diqV273NearbyCluster(diqV277CoffeeSeeds(), cfg, Math.max(diqV273RadiusMiles(cfg), 35));
    for (i = 0; i < seeds.length; i++) { finalItems.push(seeds[i]); }
    finalItems = diqV27Dedupe(finalItems);
    finalItems = diqV27DiverseTop(finalItems, query, cfg.key, cfg.maxResults || 10);
  }




  diqV27DebugStats(all, truth, finalItems, cfg);




  stopScanTab();
  adventureScanRadiusOverride = 0;
  adventureScanFallbackPass = 0;
  mapAreaScanActive = false;




  if (!finalItems.length) {
    adventureResults = [];
    adventurePreferred = null;
    renderAdventureScanChoices([], query);
    setStatus("adventureRouteStatus", "NO STRONG MATCH", "gold");
    speakAdventureScanEmpty(query);
    toast(noNearbyMessage(query));
    setStartReady(false);
    adventureScanOnly = false;
    return;
  }




  for (i = 0; i < finalItems.length; i++) {
    finalItems[i] = enrichAdventureItem(finalItems[i], query);
  }




  adventureResults = finalItems.slice(0, 12);
  adventurePreferred = adventureResults.length ? adventureResults[0] : null;
  renderResultPins(adventureResults, adventurePreferred);
  fitAdventureResultsCluster(adventureResults, adventurePreferred);
  setStatus("adventureRouteStatus", String(Math.min(adventureResults.length, 8)) + " OPTIONS", "green");
  renderAdventureScanChoices(adventureResults, query);
  afterScanResultsReady(adventureResults, adventurePreferred, "v27_broad_pull_iq");
  if (cfg && cfg.key === "coffee_iq") {
    toast("Coffee IQ found " + String(Math.min(adventureResults.length, 8)) + " coffee stops");
  } else {
    toast("Broad Pull IQ found " + String(Math.min(adventureResults.length, 8)) + " picks");
  }
  setStartReady(!!(routeGeo && destination));
  adventureScanOnly = false;
}




function diqV27RunBroadPullScan(query) {
  var q = clean(query);
  var cfg;
  var token;
  var all = [];
  var pending = 0;
  var launched = 0;
  var finished = false;
  var maxLaunch = 18;




  if (!diqV27PrepareScan(q)) { return true; }




  cfg = diqV27Config(q);
  token = routeAttemptToken;
  updateScanTab("Pulling multiple pools for " + cfg.label + "...");




  function maybeFinish() {
    var requiredLaunches = Math.min(cfg.pools.length, maxLaunch);




    /*
      DRIVE IQ V27.2 LOCAL FAVES FINISH FIX:
      Local Hangout IQ has a larger broad-pull pool than FoodIQ. V27 capped
      launched pools at maxLaunch, but maybeFinish still waited for every pool
      in cfg.pools. That could leave Local Faves scanning forever after the
      allowed launch count completed. Finish once the capped pool set is done.
    */
    if (finished || pending > 0 || launched < requiredLaunches || token !== routeAttemptToken) { return; }
    finished = true;
    updateScanTab("Scoring and diversifying the strongest picks...");
    window.setTimeout(function () {
      diqV27RenderBroadPull(all, q, cfg, token);
    }, 80);
  }




  function fetchUrl(url, queryText) {
    pending += 1;
    try {
      fetch(url)
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var features = data && data.features ? data.features : [];
          var i;
          var item;
          for (i = 0; i < features.length; i++) {
            item = normalizeFeature(features[i], queryText);
            if (item) {
              item.sourceQuery = queryText;
              item.category = categoryFromQuery(q);
              item.fallbackPass = 0;
              all.push(item);
            }
          }
          pending -= 1;
          maybeFinish();
        })
        .catch(function () { pending -= 1; maybeFinish(); });
    } catch (e) {
      pending -= 1;
      maybeFinish();
    }
  }




  function launchQuery(queryText) {
    var urls = [geoUrl(queryText, "autocomplete", 30), geoUrl(queryText, "search", 30)];
    var u;
    for (u = 0; u < urls.length; u++) { fetchUrl(urls[u], queryText); }
  }




  function next() {
    if (finished || token !== routeAttemptToken) { return; }
    if (launched >= cfg.pools.length || launched >= maxLaunch) { maybeFinish(); return; }
    launchQuery(cfg.pools[launched]);
    launched += 1;
    updateScanTab("Building pool " + String(launched) + " of " + String(Math.min(cfg.pools.length, maxLaunch)) + "...");
    if (launched < cfg.pools.length && launched < maxLaunch) {
      window.setTimeout(next, 90);
    } else {
      maybeFinish();
    }
  }




  next();
  return true;
}




scanAdventureChoices = function (query) {
  if (diqV27IsBroadPullCategory(query)) {
    return diqV27RunBroadPullScan(query);
  }
  return diqV27OriginalScanAdventureChoices(query);
};




findDriveableAdventure = function (query) {
  if (diqV27IsBroadPullCategory(query) && adventureScanOnly) {
    return diqV27RunBroadPullScan(query);
  }
  return diqV27OriginalFindDriveableAdventure(query);
};












/* =========================================================
   DRIVE IQ V27.5 â€” COFFEE IQ CONFIDENCE PASS
   Backend JS only. ES5-safe.
   - Repairs V27.4 Coffee overrides so Coffee IQ never references pool vars
     inside truth / score / radius helpers.
   - Adds stronger Coffee Truth, local cafe/roaster/bakery boost, chain soft
     penalty, tighter coffee radius, and Coffee Central seed rescue.
========================================================= */
window.__DRIVE_IQ_ADVENTURE_MODE_JS_V27_5_COFFEE_IQ_CONFIDENCE__ = true;




var diqV275OriginalConfig = diqV27Config;
var diqV275OriginalCandidateBucket = diqV27CandidateBucket;
var diqV275OriginalRadiusMiles = diqV273RadiusMiles;
var diqV275OriginalTruthMatch = diqV27TruthMatch;
var diqV275OriginalScore = diqV27Score;
var diqV275OriginalRenderBroadPull = diqV27RenderBroadPull;




function diqV275CoffeeText(item) {
  try { return diqV268Text ? diqV268Text(item) : adventureTruthText(item); } catch (e) {}
  return normText(String(item && item.label || '') + ' ' + String(item && item.full || '') + ' ' + String(item && item.category || '') + ' ' + String(item && item.kind || ''));
}




function diqV275Has(txt, arr) {
  if (typeof diqV268HasAny === 'function') { return diqV268HasAny(txt, arr); }
  var i;
  txt = normText(txt);
  for (i = 0; i < (arr || []).length; i++) {
    if (txt.indexOf(normText(arr[i])) > -1) { return true; }
  }
  return false;
}




function diqV275CoffeeSignal(txt) {
  return diqV275Has(txt, [
    'coffee', 'coffee shop', 'coffeehouse', 'cafe', 'cafÃ©', 'espresso', 'latte', 'cappuccino',
    'roaster', 'roastery', 'bakery', 'pastry', 'pastries', 'donut', 'doughnut', 'bagel',
    'breakfast', 'brunch', 'tea house', 'tea room', 'boba'
  ]);
}




function diqV275StrongCoffeeSignal(txt) {
  return diqV275Has(txt, [
    'coffee', 'coffee shop', 'coffeehouse', 'cafe', 'cafÃ©', 'espresso', 'latte', 'cappuccino',
    'roaster', 'roastery', 'local coffee', 'coffee central'
  ]);
}




function diqV275CoffeeNoise(txt) {
  return diqV275Has(txt, [
    'bank', 'atm', 'pharmacy', 'drugstore', 'walgreens', 'cvs', 'hospital', 'clinic', 'dentist',
    'church', 'school', 'hotel', 'motel', 'gas station', 'fuel', 'car wash', 'auto parts',
    'autozone', 'oreilly', 'o reilly', 'best buy', 'electronics', 'hardware', 'lowe',
    'home depot', 'walmart', 'target', 'department store', 'supermarket', 'grocery',
    'office', 'storage', 'real estate', 'insurance', 'lawyer', 'funeral'
  ]);
}




function diqV275CoffeeChain(txt) {
  return diqV275Has(txt, [
    'starbucks', 'dunkin', 'dunkin donuts', 'scooter', 'scooters coffee', 'dutch bros',
    'biggby', 'mcdonald', 'mccafe', 'panera'
  ]);
}




function diqV275CoffeeSeedItems() {
  var out = [];
  try {
    if (typeof diqV268SouthavenContext === 'function' && diqV268SouthavenContext()) {
      out.push({
        label:'Coffee Central',
        full:'Local coffee hangout around Southaven / DeSoto County',
        lat:34.9887,
        lng:-90.0127,
        kind:'cafe',
        category:'catering cafe coffee local hangout',
        matchLabel:'Coffee Hangout',
        localSeed:true
      });
    }
  } catch (e) {}
  return out;
}




diqV27Config = function (query) {
  var cfg = diqV275OriginalConfig(query);
  var key = diqV27CategoryKey(query);
  var city = diqV27CitySuffix();
  var out = [];




  if (key !== 'coffee_iq') { return cfg; }




  cfg = {
    key:'coffee_iq',
    query:String(query || ''),
    label:'Coffee IQ',
    pools:out,
    maxResults:8
  };




  diqV27Add(out, diqV27PlacesToken('catering.cafe,catering.restaurant,catering.ice_cream', 'Coffee IQ local cafe pool'));
  diqV27Add(out, 'coffee shops' + city);
  diqV27Add(out, 'local coffee shops' + city);
  diqV27Add(out, 'independent coffee shop' + city);
  diqV27Add(out, 'cafes' + city);
  diqV27Add(out, 'espresso bar' + city);
  diqV27Add(out, 'coffee roaster' + city);
  diqV27Add(out, 'bakery cafe' + city);
  diqV27Add(out, 'breakfast coffee' + city);
  diqV27Add(out, 'pastries coffee' + city);
  diqV27Add(out, 'donut coffee' + city);
  diqV27Add(out, 'work friendly coffee' + city);
  diqV27Add(out, 'study coffee shop' + city);
  diqV27Add(out, 'patio coffee' + city);
  diqV27Add(out, 'bookstore cafe' + city);




  try {
    if (typeof diqV268SouthavenContext === 'function' && diqV268SouthavenContext()) {
      diqV27Add(out, 'Coffee Central Southaven MS');
      diqV27Add(out, 'Coffee Central Hernando MS');
      diqV27Add(out, 'local cafe Southaven MS');
      diqV27Add(out, 'bakery cafe Southaven MS');
      diqV27Add(out, 'coffee Silo Square Southaven MS');
      diqV27Add(out, 'coffee Hernando MS');
    }
  } catch (e) {}




  return cfg;
};




diqV27CandidateBucket = function (item, key) {
  var txt;
  if (key !== 'coffee_iq') { return diqV275OriginalCandidateBucket(item, key); }
  txt = diqV275CoffeeText(item);
  if (diqV275Has(txt, ['roaster', 'roastery'])) { return 'roaster'; }
  if (diqV275Has(txt, ['bakery', 'pastry', 'pastries', 'donut', 'doughnut', 'bagel'])) { return 'bakery'; }
  if (diqV275Has(txt, ['espresso', 'latte', 'cappuccino'])) { return 'espresso'; }
  if (diqV275Has(txt, ['breakfast', 'brunch'])) { return 'breakfast'; }
  if (diqV275Has(txt, ['bookstore', 'books', 'study', 'workspace', 'work friendly'])) { return 'work_study'; }
  if (diqV275CoffeeChain(txt)) { return 'chain_coffee'; }
  return 'local_cafe';
};




diqV273RadiusMiles = function (cfg) {
  var key = cfg && cfg.key ? String(cfg.key) : '';
  var radius;
  if (key !== 'coffee_iq') { return diqV275OriginalRadiusMiles(cfg); }




  radius = 18;
  if (adventureSearchScope === 'near_destination') { radius = 22; }
  if (adventureSearchScope === 'map_area') { radius = 18; }




  if (finite(Number(adventureScanRadiusOverride)) && Number(adventureScanRadiusOverride) > 0) {
    radius = Math.max(radius, Number(adventureScanRadiusOverride) / 1609.344);
  }
  return radius;
};




diqV27TruthMatch = function (item, query, key) {
  var txt;
  if (key !== 'coffee_iq') { return diqV275OriginalTruthMatch(item, query, key); }
  if (!item) { return false; }
  if (item.localSeed) { return true; }
  txt = diqV275CoffeeText(item);
  if (!txt) { return false; }
  if (diqV275CoffeeNoise(txt) && !diqV275StrongCoffeeSignal(txt)) { return false; }
  if (diqV275StrongCoffeeSignal(txt)) { return true; }
  if (diqV275CoffeeSignal(txt) && !diqV275Has(txt, ['smoothie', 'nutrition', 'loaded tea', 'juice bar'])) { return true; }
  return false;
};




diqV27Score = function (item, query, key) {
  var txt;
  var score;
  var d;




  if (key !== 'coffee_iq') { return diqV275OriginalScore(item, query, key); }
  if (!item) { return -9999; }




  txt = diqV275CoffeeText(item);
  if (diqV275CoffeeNoise(txt) && !diqV275StrongCoffeeSignal(txt)) { return -9999; }




  try { score = scoreAdventure(item, query); } catch (e) { score = 0; }
  if (!finite(score)) { score = 0; }




  score += 120;
  if (item.localSeed) { score += 500; }
  if (diqV275Has(txt, ['coffee central'])) { score += 360; }
  if (diqV275Has(txt, ['local coffee', 'independent', 'neighborhood', 'coffeehouse'])) { score += 210; }
  if (diqV275Has(txt, ['roaster', 'roastery'])) { score += 190; }
  if (diqV275Has(txt, ['espresso', 'latte', 'cappuccino'])) { score += 155; }
  if (diqV275Has(txt, ['cafe', 'cafÃ©', 'coffee shop'])) { score += 145; }
  if (diqV275Has(txt, ['bakery', 'pastry', 'pastries', 'donut', 'doughnut', 'bagel'])) { score += 95; }
  if (diqV275Has(txt, ['breakfast', 'brunch'])) { score += 70; }
  if (diqV275Has(txt, ['patio', 'cozy', 'study', 'workspace', 'bookstore', 'work friendly'])) { score += 60; }
  if (diqV275Has(txt, ['smoothie', 'nutrition', 'loaded tea', 'juice bar']) && !diqV275StrongCoffeeSignal(txt)) { score -= 120; }
  if (diqV275CoffeeChain(txt)) { score -= 85; }




  d = Number(item.diqV273DistanceMiles || item.distanceFromScanCenter || item.distMiles || 0);
  if (finite(d) && d > 0) {
    if (d <= 4) { score += 40; }
    else if (d <= 9) { score += 22; }
    else if (d > 18) { score -= 40; }
  }




  return score;
};




diqV27RenderBroadPull = function (rawItems, query, cfg, token) {
  var seeds;
  var i;
  if (cfg && cfg.key === 'coffee_iq') {
    seeds = diqV275CoffeeSeedItems();
    if (seeds && seeds.length) {
      rawItems = (rawItems || []).slice(0);
      for (i = 0; i < seeds.length; i++) { rawItems.push(seeds[i]); }
    }
  }
  return diqV275OriginalRenderBroadPull(rawItems, query, cfg, token);
};
















/* =========================================================
   DRIVE IQ V27.6 â€” COFFEE IQ HARD CATEGORY LOCK
   Coffee must behave like its own recommendation category, not a
   breakfast/smoothie fallback. This patch forces "coffee" chips and
   queries into Coffee IQ Broad Pull, removes restaurant/ice-cream leakage
   from Coffee pools, tightens Coffee Truth, and strongly prefers local
   cafÃ©s, roasters, espresso bars, bakery cafÃ©s, and coffeehouses.
========================================================= */
window.__DRIVE_IQ_ADVENTURE_MODE_JS_V27_6_COFFEE_IQ_HARD_LOCK__ = true;




var diqV276OriginalCategoryFromQuery = categoryFromQuery;
categoryFromQuery = function (query) {
  var q = normText(query);




  if (!q) { return ""; }




  /* Coffee owns coffee before FoodIQ sees breakfast/brunch. */
  if (
    q === "coffee" ||
    q === "coffee iq" ||
    q.indexOf("coffee iq") > -1 ||
    q.indexOf("coffee shop") > -1 ||
    q.indexOf("coffee shops") > -1 ||
    q.indexOf("coffeehouse") > -1 ||
    q.indexOf("coffee house") > -1 ||
    q.indexOf("local coffee") > -1 ||
    q.indexOf("independent coffee") > -1 ||
    q.indexOf("espresso") > -1 ||
    q.indexOf("latte") > -1 ||
    q.indexOf("cappuccino") > -1 ||
    q.indexOf("roaster") > -1 ||
    q.indexOf("roastery") > -1 ||
    q.indexOf("cafe") > -1 ||
    q.indexOf("cafÃ©") > -1 ||
    q.indexOf("bakery cafe") > -1 ||
    q.indexOf("bookstore cafe") > -1 ||
    q.indexOf("work friendly coffee") > -1 ||
    q.indexOf("patio coffee") > -1
  ) {
    return "coffee iq";
  }




  try { return diqV276OriginalCategoryFromQuery(query); } catch (e) {}
  return "";
};




function diqV276CoffeeStrictText(item) {
  try { return diqV275CoffeeText(item); } catch (e1) {}
  try { return diqV268Text(item); } catch (e2) {}
  return normText(String(item && item.label || "") + " " + String(item && item.full || "") + " " + String(item && item.category || "") + " " + String(item && item.kind || "") + " " + String(item && item.matchLabel || ""));
}




function diqV276Has(txt, arr) {
  try { return diqV275Has(txt, arr); } catch (e) {}
  var i;
  txt = normText(txt);
  for (i = 0; i < (arr || []).length; i++) {
    if (txt.indexOf(normText(arr[i])) > -1) { return true; }
  }
  return false;
}




function diqV276StrongCoffee(txt) {
  return diqV276Has(txt, [
    "coffee", "coffee shop", "coffee shops", "coffeehouse", "coffee house",
    "cafe", "cafÃ©", "espresso", "latte", "cappuccino", "americano", "cold brew",
    "roaster", "roastery", "local coffee", "coffee central", "third wave coffee",
    "specialty coffee", "pour over"
  ]);
}




function diqV276CoffeeAdjacency(txt) {
  return (
    diqV276Has(txt, ["bakery", "pastry", "pastries", "donut", "doughnut", "bagel", "breakfast", "brunch", "bookstore", "study", "workspace", "patio"]) &&
    diqV276Has(txt, ["coffee", "cafe", "cafÃ©", "espresso", "latte", "coffeehouse"])
  );
}




function diqV276CoffeeHardReject(txt) {
  if (diqV276Has(txt, [
    "tropical smoothie", "smoothie", "smoothie king", "nutrition", "loaded tea", "juice bar",
    "big bad breakfast", "breakfast restaurant", "brunch restaurant",
    "fast food", "burger", "chicken", "taco", "pizza", "bbq", "barbecue", "grill", "steak",
    "ice cream", "frozen yogurt", "restaurant only", "bar only"
  ]) && !diqV276StrongCoffee(txt)) { return true; }




  if (diqV276Has(txt, [
    "bank", "atm", "pharmacy", "drugstore", "walgreens", "cvs", "hospital", "clinic",
    "church", "school", "hotel", "motel", "gas station", "fuel", "car wash", "auto parts",
    "best buy", "electronics", "hardware", "lowe", "home depot", "walmart", "target",
    "department store", "supermarket", "grocery", "office", "storage", "real estate",
    "insurance", "lawyer", "funeral"
  ])) { return true; }




  return false;
}




/* Override V27.5 signal helpers where present. */
try {
  diqV275StrongCoffeeSignal = function (txt) {
    return diqV276StrongCoffee(txt);
  };
  diqV275CoffeeSignal = function (txt) {
    return diqV276StrongCoffee(txt) || diqV276CoffeeAdjacency(txt);
  };
  diqV275CoffeeNoise = function (txt) {
    return diqV276CoffeeHardReject(txt);
  };
} catch (diqV276HelperErr) {}




var diqV276OriginalConfig = diqV27Config;
diqV27Config = function (query) {
  var key = diqV27CategoryKey(query);
  var city = diqV27CitySuffix();
  var out = [];
  var cfg;




  if (key !== "coffee_iq") { return diqV276OriginalConfig(query); }




  cfg = {
    key:"coffee_iq",
    query:String(query || "coffee"),
    label:"Coffee IQ",
    pools:out,
    maxResults:10
  };




  /* Coffee Truth: only cafÃ©/coffee pools first. No restaurant/ice cream leakage. */
  diqV27Add(out, diqV27PlacesToken("catering.cafe", "Coffee IQ cafe pool"));
  diqV27Add(out, "coffee shops" + city);
  diqV27Add(out, "local coffee shops" + city);
  diqV27Add(out, "independent coffee shop" + city);
  diqV27Add(out, "coffeehouse" + city);
  diqV27Add(out, "neighborhood coffee" + city);
  diqV27Add(out, "espresso bar" + city);
  diqV27Add(out, "coffee roaster" + city);
  diqV27Add(out, "specialty coffee" + city);
  diqV27Add(out, "bakery cafe coffee" + city);
  diqV27Add(out, "coffee pastries" + city);
  diqV27Add(out, "work friendly coffee shop" + city);
  diqV27Add(out, "study coffee shop" + city);
  diqV27Add(out, "patio coffee" + city);
  diqV27Add(out, "bookstore cafe coffee" + city);




  /* Mid-South coffee rescue queries. These are queries, not forced pins. */
  try {
    if (typeof diqV268SouthavenContext === "function" && diqV268SouthavenContext()) {
      diqV27Add(out, "Coffee Central Southaven MS");
      diqV27Add(out, "Coffee Central Hernando MS");
      diqV27Add(out, "coffee shop Silo Square Southaven MS");
      diqV27Add(out, "local coffee Southaven MS");
      diqV27Add(out, "local coffee Hernando MS");
      diqV27Add(out, "local coffee Olive Branch MS");
      diqV27Add(out, "coffee shops Memphis TN");
      diqV27Add(out, "Comeback Coffee Memphis TN");
      diqV27Add(out, "Otherlands Coffee Memphis TN");
      diqV27Add(out, "Belltower Coffee Memphis TN");
      diqV27Add(out, "Vice and Virtue Coffee Memphis TN");
      diqV27Add(out, "City and State coffee Memphis TN");
      diqV27Add(out, "Tamp and Tap Memphis TN");
    }
  } catch (e) {}




  return cfg;
};




var diqV276OriginalTruthMatch = diqV27TruthMatch;
diqV27TruthMatch = function (item, query, key) {
  var txt;




  if (key !== "coffee_iq") { return diqV276OriginalTruthMatch(item, query, key); }
  if (!item) { return false; }
  if (item.localSeed) { return true; }




  txt = diqV276CoffeeStrictText(item);
  if (!txt) { return false; }
  if (diqV276CoffeeHardReject(txt)) { return false; }




  /* Must have a real coffee/cafÃ© identity or bakery+cafÃ© coffee adjacency. */
  if (diqV276StrongCoffee(txt)) { return true; }
  if (diqV276CoffeeAdjacency(txt)) { return true; }




  return false;
};




var diqV276OriginalScore = diqV27Score;
diqV27Score = function (item, query, key) {
  var txt;
  var score;
  var d;




  if (key !== "coffee_iq") { return diqV276OriginalScore(item, query, key); }
  if (!item) { return -9999; }




  txt = diqV276CoffeeStrictText(item);
  if (!txt || diqV276CoffeeHardReject(txt)) { return -9999; }
  if (!diqV276StrongCoffee(txt) && !diqV276CoffeeAdjacency(txt) && !item.localSeed) { return -9999; }




  try { score = scoreAdventure(item, query); } catch (e) { score = 0; }
  if (!finite(score)) { score = 0; }




  score += 180;
  if (item.localSeed) { score += 650; }
  if (diqV276Has(txt, ["coffee central"])) { score += 460; }
  if (diqV276Has(txt, ["local coffee", "independent", "neighborhood", "coffeehouse", "coffee house"])) { score += 260; }
  if (diqV276Has(txt, ["roaster", "roastery", "specialty coffee", "third wave coffee"])) { score += 230; }
  if (diqV276Has(txt, ["espresso", "latte", "cappuccino", "cold brew", "pour over"])) { score += 190; }
  if (diqV276Has(txt, ["cafe", "cafÃ©", "coffee shop", "coffee shops"])) { score += 175; }
  if (diqV276Has(txt, ["bakery", "pastry", "pastries", "donut", "doughnut", "bagel"]) && diqV276StrongCoffee(txt)) { score += 95; }
  if (diqV276Has(txt, ["patio", "cozy", "study", "workspace", "bookstore", "work friendly"])) { score += 70; }




  if (diqV276Has(txt, ["starbucks", "dunkin", "dunkin donuts", "scooter", "scooters coffee", "dutch bros", "biggby", "mcdonald", "mccafe", "panera"])) { score -= 110; }
  if (diqV276Has(txt, ["breakfast", "brunch"]) && !diqV276StrongCoffee(txt)) { score -= 260; }
  if (diqV276Has(txt, ["smoothie", "nutrition", "loaded tea", "juice bar"])) { score -= 400; }




  d = Number(item.diqV273DistanceMiles || item.distanceFromScanCenter || item.distMiles || 0);
  if (finite(d) && d > 0) {
    if (d <= 4) { score += 55; }
    else if (d <= 9) { score += 35; }
    else if (d <= 16) { score += 12; }
    else if (d > 24) { score -= 65; }
  }




  return score;
};




var diqV276OriginalCandidateBucket = diqV27CandidateBucket;
diqV27CandidateBucket = function (item, key) {
  var txt;




  if (key !== "coffee_iq") { return diqV276OriginalCandidateBucket(item, key); }




  txt = diqV276CoffeeStrictText(item);
  if (diqV276Has(txt, ["roaster", "roastery"])) { return "roaster"; }
  if (diqV276Has(txt, ["espresso", "latte", "cappuccino", "cold brew"])) { return "espresso"; }
  if (diqV276Has(txt, ["bakery", "pastry", "pastries", "donut", "doughnut", "bagel"])) { return "bakery_cafe"; }
  if (diqV276Has(txt, ["bookstore", "books", "study", "workspace", "work friendly"])) { return "work_study"; }
  if (diqV276Has(txt, ["starbucks", "dunkin", "scooter", "dutch bros", "biggby", "panera"])) { return "chain_coffee"; }
  return "local_cafe";
};




/* Extra render safety: strip coffee hard-rejects immediately before normal render. */
var diqV276OriginalRenderBroadPull = diqV27RenderBroadPull;
diqV27RenderBroadPull = function (rawItems, query, cfg, token) {
  var cleanItems = [];
  var i;
  var item;
  var txt;




  if (cfg && cfg.key === "coffee_iq") {
    rawItems = rawItems || [];
    for (i = 0; i < rawItems.length; i++) {
      item = rawItems[i];
      txt = diqV276CoffeeStrictText(item);
      if (item && (item.localSeed || ((diqV276StrongCoffee(txt) || diqV276CoffeeAdjacency(txt)) && !diqV276CoffeeHardReject(txt)))) {
        cleanItems.push(item);
      }
    }
    return diqV276OriginalRenderBroadPull(cleanItems, query, cfg, token);
  }




  return diqV276OriginalRenderBroadPull(rawItems, query, cfg, token);
};








/* =========================================================
   DRIVE IQ V28 â€” UNIVERSAL CATEGORY IQ BACKEND PASS
   ES5-safe. Backend JS only.
   - Promotes Coffee IQ / Food IQ / Local Faves architecture into the
     Customize categories.
   - Adds broad-pull + hard truth + confidence scoring for Golf, Nightlife,
     Treats, Shopping, Scenic, Family, Date, Dog, Live Music, and Waterfront.
   - Keeps map shell, UI, destination logic, voice, and rendering untouched.
========================================================= */




window.__DRIVE_IQ_ADVENTURE_MODE_JS_V28_UNIVERSAL_CATEGORY_IQ__ = true;




function diqV28Text(item) {
  try { if (typeof diqV268Text === "function") { return diqV268Text(item); } } catch (e1) {}
  try { return adventureTruthText(item); } catch (e2) {}
  return normText(String(item && item.label || "") + " " + String(item && item.full || "") + " " + String(item && item.kind || "") + " " + String(item && item.category || ""));
}




function diqV28Has(txt, arr) {
  var i;
  txt = normText(txt);
  for (i = 0; i < arr.length; i++) {
    if (txt.indexOf(normText(arr[i])) > -1) { return true; }
  }
  return false;
}




function diqV28Noise(txt) {
  return diqV28Has(txt, [
    "bank", "atm", "pharmacy", "drugstore", "hospital", "clinic", "dentist",
    "church", "school", "gas station", "fuel", "car wash", "auto parts",
    "hardware", "storage", "real estate", "insurance", "lawyer", "funeral",
    "government office", "city hall", "post office"
  ]);
}




function diqV28RetailBoxNoise(txt) {
  return diqV28Has(txt, [
    "walmart", "target", "best buy", "lowes", "lowe's", "home depot", "costco",
    "sam's club", "sams club", "dollar general", "dollar tree", "department store"
  ]);
}




function diqV28CategoryFromQuery(query) {
  var q = normText(query);
  if (!q) { return ""; }




  if (q.indexOf("local fave") > -1 || q.indexOf("local favorite") > -1 || q.indexOf("where locals go") > -1 || q.indexOf("local hangout") > -1 || q.indexOf("local picks") > -1 || q.indexOf("neighborhood favorite") > -1) { return "local favorites"; }
  if (q.indexOf("food iq") > -1 || q.indexOf("must try") > -1 || q.indexOf("must-try") > -1 || q.indexOf("viral food") > -1 || q.indexOf("iconic food") > -1 || q.indexOf("signature dish") > -1 || q.indexOf("local bite") > -1 || q.indexOf("food worth") > -1) { return "food iq"; }
  if (q.indexOf("coffee iq") > -1 || q.indexOf("coffee") > -1 || q.indexOf("espresso") > -1 || q.indexOf("latte") > -1 || q.indexOf("roaster") > -1 || q.indexOf("coffee shop") > -1 || q.indexOf("cafe") > -1 || q.indexOf("cafÃ©") > -1) { return "coffee iq"; }
  if (q.indexOf("golf") > -1 || q.indexOf("country club") > -1 || q.indexOf("driving range") > -1 || q.indexOf("championship course") > -1 || q.indexOf("public course") > -1 || q.indexOf("municipal course") > -1) { return "golf iq"; }
  if (q.indexOf("treat") > -1 || q.indexOf("sweet") > -1 || q.indexOf("dessert") > -1 || q.indexOf("ice cream") > -1 || q.indexOf("gelato") > -1 || q.indexOf("donut") > -1 || q.indexOf("doughnut") > -1 || q.indexOf("cookie") > -1 || q.indexOf("candy") > -1 || q.indexOf("chocolate") > -1 || q.indexOf("bakery") > -1) { return "treats iq"; }
  if (q.indexOf("nightlife") > -1 || q.indexOf("popular tonight") > -1 || q.indexOf("tonight") > -1 || q.indexOf("cocktail") > -1 || q.indexOf("rooftop") > -1 || q.indexOf("late night") > -1 || q.indexOf("sports bar") > -1 || q.indexOf("brewery") > -1 || q.indexOf("taproom") > -1 || q.indexOf("karaoke") > -1 || q.indexOf("trivia") > -1) { return "nightlife iq"; }
  if (q.indexOf("live music") > -1 || q.indexOf("music venue") > -1 || q.indexOf("concert") > -1 || q.indexOf("band") > -1 || q.indexOf("acoustic") > -1 || q.indexOf("jazz") > -1 || q.indexOf("open mic") > -1) { return "live music"; }
  if (q.indexOf("shopping") > -1 || q.indexOf("boutique") > -1 || q.indexOf("local shops") > -1 || q.indexOf("antique") > -1 || q.indexOf("vintage") > -1 || q.indexOf("bookstore") > -1 || q.indexOf("gift shop") > -1 || q.indexOf("market") > -1 || q.indexOf("home decor") > -1) { return "shopping"; }
  if (q.indexOf("date night") > -1 || q.indexOf("romantic") > -1 || q.indexOf("couples") > -1 || q.indexOf("anniversary") > -1 || q.indexOf("conversation") > -1) { return "date iq"; }
  if (q.indexOf("family") > -1 || q.indexOf("kids") > -1 || q.indexOf("children") > -1 || q.indexOf("playground") > -1 || q.indexOf("stroller") > -1) { return "family"; }
  if (q.indexOf("dog") > -1 || q.indexOf("pet friendly") > -1 || q.indexOf("dog friendly") > -1 || q.indexOf("puppy") > -1) { return "dog friendly"; }
  if (q.indexOf("waterfront") > -1 || q.indexOf("water front") > -1 || q.indexOf("marina") > -1 || q.indexOf("lakefront") > -1 || q.indexOf("riverfront") > -1 || q.indexOf("beach bar") > -1 || q.indexOf("riverwalk") > -1 || q.indexOf("dockside") > -1) { return "waterfront"; }
  if (q.indexOf("scenic") > -1 || q.indexOf("overlook") > -1 || q.indexOf("lookout") > -1 || q.indexOf("viewpoint") > -1 || q.indexOf("sunset") > -1 || q.indexOf("photo spot") > -1 || q.indexOf("waterfall") > -1 || q.indexOf("cave") > -1 || q.indexOf("trail") > -1 || q.indexOf("hiking") > -1 || q.indexOf("park") > -1) { return "scenic"; }
  if (q.indexOf("food") > -1 || q.indexOf("restaurant") > -1 || q.indexOf("drink") > -1 || q.indexOf("bar") > -1 || q.indexOf("bbq") > -1 || q.indexOf("barbecue") > -1 || q.indexOf("burger") > -1 || q.indexOf("taco") > -1 || q.indexOf("pizza") > -1 || q.indexOf("seafood") > -1 || q.indexOf("breakfast") > -1 || q.indexOf("brunch") > -1) { return "food iq"; }
  return "";
}




categoryFromQuery = diqV28CategoryFromQuery;




function diqV28KeyFromCat(cat) {
  if (cat === "local favorites") { return "local_hangouts"; }
  if (cat === "food iq" || cat === "food drinks") { return "food_iq"; }
  if (cat === "coffee iq") { return "coffee_iq"; }
  if (cat === "golf iq") { return "golf_iq"; }
  if (cat === "nightlife iq" || cat === "popular tonight") { return "nightlife_iq"; }
  if (cat === "live music") { return "live_music_iq"; }
  if (cat === "treats iq") { return "treats_iq"; }
  if (cat === "shopping") { return "shopping_iq"; }
  if (cat === "scenic" || cat === "waterfront") { return cat === "waterfront" ? "waterfront_iq" : "scenic_iq"; }
  if (cat === "family") { return "family_iq"; }
  if (cat === "date iq") { return "date_iq"; }
  if (cat === "dog friendly") { return "dog_iq"; }
  return "";
}




diqV27IsBroadPullCategory = function (query) {
  return !!diqV28KeyFromCat(categoryFromQuery(query));
};




diqV27CategoryKey = function (query) {
  return diqV28KeyFromCat(categoryFromQuery(query));
};




var diqV28OriginalConfig = diqV27Config;
diqV27Config = function (query) {
  var key = diqV27CategoryKey(query);
  var city = diqV27CitySuffix();
  var out = [];
  var cfg;




  if (key === "food_iq" || key === "coffee_iq" || key === "local_hangouts") {
    cfg = diqV28OriginalConfig(query);
    cfg.key = key;
    return cfg;
  }




  cfg = { key:key, query:String(query || ""), label:titleCaseWords(String(key || "Adventure IQ").replace(/_/g, " ")), pools:out, maxResults:10 };




  if (key === "golf_iq") {
    diqV27Add(out, diqV27PlacesToken("sport.golf", "Golf IQ course pool"));
    diqV27Add(out, "public golf course" + city);
    diqV27Add(out, "championship golf course" + city);
    diqV27Add(out, "municipal golf course" + city);
    diqV27Add(out, "golf resort" + city);
    diqV27Add(out, "country club golf course" + city);
    diqV27Add(out, "links golf course" + city);
    diqV27Add(out, "driving range" + city);
    diqV27Add(out, "golf practice facility" + city);
    diqV27Add(out, "par 3 golf course" + city);
    return cfg;
  }




  if (key === "nightlife_iq") {
    diqV27Add(out, diqV27PlacesToken("catering.bar,catering.pub,catering.biergarten,entertainment,entertainment.nightclub", "Nightlife IQ social pool"));
    diqV27Add(out, "cocktail lounge" + city);
    diqV27Add(out, "sports bar" + city);
    diqV27Add(out, "brewery taproom" + city);
    diqV27Add(out, "rooftop bar" + city);
    diqV27Add(out, "live music bar" + city);
    diqV27Add(out, "late night food" + city);
    diqV27Add(out, "nightlife district" + city);
    diqV27Add(out, "karaoke trivia bar" + city);
    diqV27Add(out, "patio bar" + city);
    return cfg;
  }




  if (key === "live_music_iq") {
    diqV27Add(out, diqV27PlacesToken("entertainment,entertainment.culture,catering.bar,catering.pub", "Live Music IQ venue pool"));
    diqV27Add(out, "live music venue" + city);
    diqV27Add(out, "live music bar" + city);
    diqV27Add(out, "concert venue" + city);
    diqV27Add(out, "acoustic music" + city);
    diqV27Add(out, "jazz club" + city);
    diqV27Add(out, "open mic" + city);
    diqV27Add(out, "brewery live music" + city);
    return cfg;
  }




  if (key === "treats_iq") {
    diqV27Add(out, diqV27PlacesToken("catering.ice_cream,catering.cafe,catering.restaurant", "Treat IQ dessert pool"));
    diqV27Add(out, "ice cream shop" + city);
    diqV27Add(out, "gelato" + city);
    diqV27Add(out, "bakery" + city);
    diqV27Add(out, "donut shop" + city);
    diqV27Add(out, "cookie shop" + city);
    diqV27Add(out, "dessert cafe" + city);
    diqV27Add(out, "candy shop" + city);
    diqV27Add(out, "chocolate shop" + city);
    return cfg;
  }




  if (key === "shopping_iq") {
    diqV27Add(out, diqV27PlacesToken("commercial.shopping_mall,commercial.marketplace,commercial.clothing,commercial.gift_and_souvenir,commercial.books,commercial.antiques,commercial.furniture_and_interior", "Shopping IQ local retail pool"));
    diqV27Add(out, "shopping district" + city);
    diqV27Add(out, "local boutiques" + city);
    diqV27Add(out, "local shops" + city);
    diqV27Add(out, "antique stores" + city);
    diqV27Add(out, "bookstore" + city);
    diqV27Add(out, "gift shop" + city);
    diqV27Add(out, "artisan market" + city);
    diqV27Add(out, "home decor shop" + city);
    return cfg;
  }




  if (key === "scenic_iq") {
    diqV27Add(out, diqV27PlacesToken("tourism,heritage,natural,leisure.park", "Scenic IQ natural and landmark pool"));
    diqV27Add(out, "scenic overlook" + city);
    diqV27Add(out, "sunset view" + city);
    diqV27Add(out, "waterfront park" + city);
    diqV27Add(out, "lake view" + city);
    diqV27Add(out, "river walk" + city);
    diqV27Add(out, "waterfall" + city);
    diqV27Add(out, "cave cavern" + city);
    diqV27Add(out, "hiking trail natural area" + city);
    diqV27Add(out, "scenic drive" + city);
    return cfg;
  }




  if (key === "waterfront_iq") {
    diqV27Add(out, diqV27PlacesToken("catering.restaurant,catering.bar,tourism,leisure.park,natural", "Waterfront IQ pool"));
    diqV27Add(out, "waterfront restaurant" + city);
    diqV27Add(out, "riverfront restaurant" + city);
    diqV27Add(out, "lakefront restaurant" + city);
    diqV27Add(out, "marina" + city);
    diqV27Add(out, "dockside patio" + city);
    diqV27Add(out, "riverwalk" + city);
    diqV27Add(out, "waterfront park" + city);
    return cfg;
  }




  if (key === "family_iq") {
    diqV27Add(out, diqV27PlacesToken("leisure.park,entertainment,tourism,catering.ice_cream,catering.restaurant", "Family IQ easy fun pool"));
    diqV27Add(out, "family friendly attraction" + city);
    diqV27Add(out, "playground park" + city);
    diqV27Add(out, "kids museum" + city);
    diqV27Add(out, "family entertainment" + city);
    diqV27Add(out, "ice cream family" + city);
    diqV27Add(out, "easy parking family restaurant" + city);
    return cfg;
  }




  if (key === "date_iq") {
    diqV27Add(out, diqV27PlacesToken("catering.restaurant,catering.bar,catering.cafe,tourism,entertainment", "Date IQ atmosphere pool"));
    diqV27Add(out, "date night restaurant" + city);
    diqV27Add(out, "romantic restaurant" + city);
    diqV27Add(out, "cocktail lounge" + city);
    diqV27Add(out, "wine bar" + city);
    diqV27Add(out, "patio restaurant" + city);
    diqV27Add(out, "restaurant with a view" + city);
    diqV27Add(out, "walkable date night district" + city);
    return cfg;
  }




  if (key === "dog_iq") {
    diqV27Add(out, diqV27PlacesToken("leisure.park,catering.restaurant,catering.bar,catering.cafe,natural", "Dog IQ friendly pool"));
    diqV27Add(out, "dog friendly patio" + city);
    diqV27Add(out, "dog friendly restaurant" + city);
    diqV27Add(out, "dog park" + city);
    diqV27Add(out, "pet friendly trail" + city);
    diqV27Add(out, "dog friendly brewery" + city);
    diqV27Add(out, "park trail dog friendly" + city);
    return cfg;
  }




  return diqV28OriginalConfig(query);
};




function diqV28Truth(item, key) {
  var txt = diqV28Text(item);
  if (!item || !txt) { return false; }




  if (key !== "shopping_iq" && key !== "treats_iq" && key !== "scenic_iq" && key !== "waterfront_iq") {
    if (diqV28Noise(txt)) { return false; }
  }




  if (key === "golf_iq") { return diqV28Has(txt, ["golf", "golf course", "country club", "driving range", "practice facility", "clubhouse", "links", "par 3"]); }
  if (key === "nightlife_iq") { return diqV28Has(txt, ["bar", "pub", "cocktail", "lounge", "brewery", "taproom", "rooftop", "nightclub", "live music", "sports bar", "karaoke", "trivia", "late night", "beer garden"]); }
  if (key === "live_music_iq") { return diqV28Has(txt, ["live music", "music venue", "concert", "band", "jazz", "karaoke", "open mic", "acoustic", "amphitheater", "amphitheatre", "theater", "theatre", "bar", "brewery"]); }
  if (key === "treats_iq") { return diqV28Has(txt, ["ice cream", "gelato", "bakery", "donut", "doughnut", "cookie", "dessert", "candy", "chocolate", "pastry", "cupcake", "sweet"]); }
  if (key === "shopping_iq") { return !diqV28RetailBoxNoise(txt) && diqV28Has(txt, ["boutique", "shop", "shopping", "market", "bookstore", "book shop", "gift", "antique", "vintage", "artisan", "home decor", "furniture", "retail", "mall", "square", "district"]); }
  if (key === "scenic_iq") { return diqV28Has(txt, ["scenic", "overlook", "lookout", "view", "sunset", "waterfall", "cave", "cavern", "trail", "park", "river", "lake", "waterfront", "natural", "preserve", "state park", "national park", "greenway", "garden"]); }
  if (key === "waterfront_iq") { return diqV28Has(txt, ["waterfront", "riverfront", "lakefront", "marina", "dock", "riverwalk", "beach", "water view", "lake", "river", "patio", "restaurant", "bar"]); }
  if (key === "family_iq") { return diqV28Has(txt, ["family", "kids", "children", "playground", "park", "museum", "zoo", "aquarium", "ice cream", "arcade", "bowling", "entertainment", "restrooms", "stroller"]); }
  if (key === "date_iq") { return diqV28Has(txt, ["restaurant", "bistro", "cocktail", "lounge", "wine", "patio", "rooftop", "view", "romantic", "date", "live music", "walkable", "downtown", "square"]); }
  if (key === "dog_iq") { return diqV28Has(txt, ["dog", "pet friendly", "dog friendly", "patio", "park", "trail", "greenway", "brewery", "outdoor seating", "waterfront"]); }




  return true;
}




var diqV28OriginalTruthMatch = diqV27TruthMatch;
diqV27TruthMatch = function (item, query, key) {
  if (key === "food_iq" || key === "coffee_iq" || key === "local_hangouts") {
    return diqV28OriginalTruthMatch(item, query, key);
  }
  if (diqV28KeyFromCat(categoryFromQuery(query))) { return diqV28Truth(item, key); }
  return diqV28OriginalTruthMatch(item, query, key);
};




var diqV28OriginalScore = diqV27Score;
diqV27Score = function (item, query, key) {
  var txt;
  var score;
  var dist;




  if (key === "food_iq" || key === "coffee_iq" || key === "local_hangouts") {
    return diqV28OriginalScore(item, query, key);
  }




  txt = diqV28Text(item);
  if (!diqV28Truth(item, key)) { return -9999; }




  try { score = scoreAdventure(item, query); } catch (e) { score = 0; }
  if (!finite(score)) { score = 0; }
  score += 120;




  if (diqV28Has(txt, ["local", "locally owned", "neighborhood", "favorite", "beloved", "downtown", "square", "district", "walkable"])) { score += 90; }
  if (diqV28Has(txt, ["scenic", "view", "waterfront", "patio", "rooftop", "historic", "iconic", "award", "best", "popular"])) { score += 70; }




  if (key === "golf_iq") {
    if (diqV28Has(txt, ["public", "municipal", "championship", "resort", "links", "scenic", "clubhouse", "practice", "driving range", "country club"])) { score += 180; }
    if (diqV28Has(txt, ["mini golf", "putt putt", "disc golf"])) { score -= 180; }
  }
  if (key === "nightlife_iq") {
    if (diqV28Has(txt, ["open late", "late night", "cocktail", "lounge", "sports bar", "brewery", "taproom", "live music", "rooftop", "patio", "karaoke", "trivia"])) { score += 185; }
    if (diqV28Has(txt, ["breakfast", "coffee", "daycare", "office"])) { score -= 120; }
  }
  if (key === "live_music_iq") { if (diqV28Has(txt, ["live music", "music venue", "concert", "amphitheater", "amphitheatre", "jazz", "open mic", "acoustic", "bar", "brewery"])) { score += 170; } }
  if (key === "treats_iq") {
    if (diqV28Has(txt, ["ice cream", "gelato", "bakery", "donut", "cookie", "dessert cafe", "chocolate", "candy", "cupcake"])) { score += 175; }
    if (diqV28Has(txt, ["chain", "gas station", "supermarket"])) { score -= 75; }
  }
  if (key === "shopping_iq") {
    if (diqV28Has(txt, ["boutique", "local shop", "independent", "bookstore", "antique", "market", "gift", "artisan", "walkable", "district", "square"])) { score += 170; }
    if (diqV28RetailBoxNoise(txt)) { score -= 220; }
  }
  if (key === "scenic_iq" || key === "waterfront_iq") { if (diqV28Has(txt, ["overlook", "view", "sunset", "waterfront", "river", "lake", "waterfall", "cave", "trail", "park", "natural", "historic", "photo"])) { score += 175; } }
  if (key === "family_iq") { if (diqV28Has(txt, ["playground", "park", "museum", "family", "kids", "ice cream", "easy parking", "restrooms", "open space", "stroller"])) { score += 165; } }
  if (key === "date_iq") { if (diqV28Has(txt, ["romantic", "cocktail", "wine", "patio", "rooftop", "view", "bistro", "lounge", "conversation", "walkable", "live music"])) { score += 165; } }
  if (key === "dog_iq") { if (diqV28Has(txt, ["dog friendly", "pet friendly", "patio", "park", "trail", "outdoor seating", "brewery", "waterfront"])) { score += 170; } }




  dist = item && finite(Number(item.diqV273DistanceMiles)) ? Number(item.diqV273DistanceMiles) : (item && finite(Number(item.distMiles)) ? Number(item.distMiles) : null);
  if (finite(Number(dist))) {
    if (Number(dist) <= 3) { score += 35; }
    else if (Number(dist) <= 8) { score += 22; }
    else if (Number(dist) <= 18) { score += 8; }
    else if (Number(dist) > 35) { score -= 70; }
  }




  return score;
};




var diqV28OriginalCandidateBucket = diqV27CandidateBucket;
diqV27CandidateBucket = function (item, key) {
  var txt = diqV28Text(item);
  if (key === "golf_iq") {
    if (diqV28Has(txt, ["driving range", "practice"])) { return "practice"; }
    if (diqV28Has(txt, ["public", "municipal"])) { return "public"; }
    if (diqV28Has(txt, ["resort", "championship", "country club"])) { return "destination_golf"; }
    return "course";
  }
  if (key === "nightlife_iq") {
    if (diqV28Has(txt, ["cocktail", "lounge"])) { return "cocktails"; }
    if (diqV28Has(txt, ["sports bar", "game"])) { return "sports"; }
    if (diqV28Has(txt, ["brewery", "taproom"])) { return "brewery"; }
    if (diqV28Has(txt, ["live music", "karaoke", "trivia"])) { return "entertainment"; }
    return "nightlife";
  }
  if (key === "treats_iq") {
    if (diqV28Has(txt, ["ice cream", "gelato"])) { return "ice_cream"; }
    if (diqV28Has(txt, ["bakery", "pastry"])) { return "bakery"; }
    if (diqV28Has(txt, ["donut", "doughnut", "cookie"])) { return "cookies_donuts"; }
    return "dessert";
  }
  if (key === "shopping_iq") {
    if (diqV28Has(txt, ["boutique", "clothing"])) { return "boutique"; }
    if (diqV28Has(txt, ["antique", "vintage"])) { return "antiques"; }
    if (diqV28Has(txt, ["bookstore", "books"])) { return "books"; }
    if (diqV28Has(txt, ["market", "district", "square"])) { return "district"; }
    return "local_shop";
  }
  if (key === "scenic_iq" || key === "waterfront_iq") {
    if (diqV28Has(txt, ["waterfall", "cave", "cavern"])) { return "natural_wonder"; }
    if (diqV28Has(txt, ["lake", "river", "waterfront", "marina"])) { return "water"; }
    if (diqV28Has(txt, ["overlook", "view", "sunset"])) { return "view"; }
    return "scenic";
  }
  if (key === "family_iq") { return "family"; }
  if (key === "date_iq") { return "date"; }
  if (key === "dog_iq") { return "dog"; }
  if (key === "live_music_iq") { return "live_music"; }
  return diqV28OriginalCandidateBucket(item, key);
};




var diqV28OriginalRenderBroadPull = diqV27RenderBroadPull;
diqV27RenderBroadPull = function (rawItems, query, cfg, token) {
  var cleanItems = [];
  var i;
  var item;
  if (cfg && cfg.key && cfg.key !== "coffee_iq" && cfg.key !== "food_iq" && cfg.key !== "local_hangouts" && diqV28KeyFromCat(categoryFromQuery(query))) {
    rawItems = rawItems || [];
    for (i = 0; i < rawItems.length; i++) {
      item = rawItems[i];
      if (diqV28Truth(item, cfg.key)) { cleanItems.push(item); }
    }
    return diqV28OriginalRenderBroadPull(cleanItems, query, cfg, token);
  }
  return diqV28OriginalRenderBroadPull(rawItems, query, cfg, token);
};




/* Tune Customize menu queries so they enter the V28 engine cleanly. */
DIQ_PERSONALIZED_CATEGORY_DEFS = [
  { id:"popular", label:"ðŸ”¥ POPULAR", query:"nightlife iq popular tonight live music cocktail lounge sports bar brewery local favorites" },
  { id:"food", label:"ðŸ” FOOD IQ", query:"food iq must try local food signature dishes bbq burgers tacos pizza seafood local restaurants" },
  { id:"local_favorites", label:"ðŸ† LOCAL FAVES", query:"local favorites local hangouts where locals go restaurants bars coffee parks shopping districts" },
  { id:"coffee", label:"â˜• COFFEE", query:"coffee iq local coffee shop independent cafe roaster espresso bakery cafe patio" },
  { id:"bbq", label:"ðŸ– BBQ", query:"food iq bbq barbecue smokehouse local ribs brisket pulled pork" },
  { id:"golf", label:"ðŸŒï¸ GOLF", query:"golf iq public golf course championship course municipal golf country club driving range practice facility" },
  { id:"scenic", label:"ðŸŒ… SCENIC", query:"scenic iq scenic overlook sunset view waterfront park trail waterfall cave natural area" },
  { id:"live_music", label:"ðŸŽ¶ LIVE MUSIC", query:"live music iq live music venue bar brewery concert acoustic jazz open mic" },
  { id:"hidden_gems", label:"ðŸ’Ž HIDDEN GEMS", query:"local favorites hidden gems unique local places neighborhood favorite" },
  { id:"waterfront", label:"ðŸŒŠ WATER", query:"waterfront iq waterfront restaurant lakefront riverfront marina dockside patio riverwalk" },
  { id:"outdoors", label:"ðŸ¥¾ OUTDOORS", query:"scenic iq hiking trail park cave cavern waterfall natural area rock formation river kayaking swimming hole campground" },
  { id:"lake_iq", label:"ðŸš¤ LAKE IQ", query:"waterfront iq lake marina boat ramp waterfront restaurant fishing campground cabin sunset" },
  { id:"shopping", label:"ðŸ› SHOPPING", query:"shopping iq boutiques local shops shopping district antique market bookstore gift shop artisan home decor" },
  { id:"family", label:"ðŸ‘¨â€ðŸ‘©â€ðŸ‘§ FAMILY", query:"family iq family friendly park museum ice cream attraction playground easy parking restrooms" },
  { id:"dog_friendly", label:"ðŸ¶ DOG IQ", query:"dog iq dog friendly patio park trail pet friendly outdoor seating brewery" },
  { id:"nightlife", label:"ðŸ¹ NIGHTLIFE", query:"nightlife iq cocktail lounge sports bar brewery taproom rooftop live music late night patio" },
  { id:"date", label:"â¤ï¸ DATE IQ", query:"date iq date night romantic restaurant cocktail lounge patio view conversation walkable" },
  { id:"treats", label:"ðŸ¦ TREATS", query:"treats iq ice cream gelato bakery donuts cookies dessert cafe chocolate candy" },
  { id:"gameday", label:"ðŸˆ GAMEDAY", query:"nightlife iq sports bar watch game tonight local bar brewery" }
];








/* =========================================================
   DRIVE IQ V39 â€” PHOTO DEBUG IQ
   Temporary founder diagnostics for the live photo pipeline.
   Shows exactly where the photo chain is failing:
   API key -> Places library -> Place ID -> Details/Search -> photos -> URL -> render.
   Debug only. Does not change scan, ranking, route, or Place IQ decision logic.
========================================================= */




var DIQ_V39_PHOTO_DEBUG_ON = true;




function diqV39InjectPhotoDebugStyles() {
  var style;
  var css;
  if (byId("diqV39PhotoDebugStyle")) { return; }
  css =
    "#diqAdventureInfoCard .diqPhotoDebugIQ{position:absolute!important;left:14px!important;right:14px!important;bottom:6px!important;z-index:7!important;display:block!important;padding:7px 9px!important;border-radius:12px!important;background:rgba(2,8,18,.82)!important;border:1px solid rgba(47,255,205,.28)!important;box-shadow:0 10px 26px rgba(0,0,0,.34)!important;color:#dffef7!important;font-size:9px!important;font-weight:850!important;letter-spacing:.25px!important;line-height:1.35!important;text-transform:none!important;backdrop-filter:blur(14px)!important;-webkit-backdrop-filter:blur(14px)!important;max-height:62px!important;overflow:hidden!important;}" +
    "#diqAdventureInfoCard .diqPhotoDebugIQ b{color:#5fffe0!important;font-weight:1000!important;}" +
    "#diqAdventureInfoCard .diqPhotoDebugIQ .bad{color:#ffb4a6!important;}" +
    "#diqAdventureInfoCard .diqPhotoDebugIQ .ok{color:#b8ffcf!important;}" +
    "#diqAdventureInfoCard .diqPhotoDebugIQ .warn{color:#ffdf8a!important;}" +
    "#diqAdventureInfoCard .diqPhotoDebugIQ .muted{color:rgba(223,254,247,.72)!important;}" +
    "#diqAdventureInfoCard .diqPhotoDebugIQ .url{display:block!important;white-space:nowrap!important;overflow:hidden!important;text-overflow:ellipsis!important;color:rgba(223,254,247,.62)!important;margin-top:2px!important;}" +
    "#diqAdventureInfoCard .diqPlaceHero.hasPhotoDebug{padding-bottom:48px!important;}";
  style = document.createElement("style");
  style.id = "diqV39PhotoDebugStyle";
  style.type = "text/css";
  style.appendChild(document.createTextNode(css));
  try { document.head.appendChild(style); } catch (e) {}
}




function diqV39ShortUrl(url) {
  var u = clean(url || "");
  if (!u) { return "no-url"; }
  if (u.length > 118) { return u.slice(0, 88) + "..." + u.slice(u.length - 22); }
  return u;
}




function diqV39PhotoCount(item) {
  try { return item && item.photos && item.photos.length ? item.photos.length : 0; } catch (e) { return 0; }
}




function diqV39BestUrl(item, query) {
  var gallery;
  var i;
  try { gallery = diqBuildPlaceGallery(item, query || activeLens); } catch (e0) { gallery = []; }
  for (i = 0; i < (gallery || []).length; i++) {
    if (gallery[i] && gallery[i].url && gallery[i].kind !== "map") { return String(gallery[i].url || ""); }
  }
  try { if (item && item.photoUrl) { return String(item.photoUrl); } } catch (e1) {}
  return "";
}




function diqV39YesNoClass(v) { return v ? "ok" : "bad"; }
function diqV39YesNo(v) { return v ? "YES" : "NO"; }




function diqV39DebugData(item, query, stage) {
  var d = item && item.photoDebug ? item.photoDebug : {};
  var key = false;
  var places = false;
  var pid = false;
  var photos = 0;
  var url = "";
  var source = "";
  var status = "";
  var details = "";
  var live = "";
  var photoEl;




  try { key = !!diqGooglePlacesApiKey(); } catch (e0) { key = false; }
  try { places = !!diqGooglePlacesReady(); } catch (e1) { places = false; }
  try { pid = !!diqGooglePlaceIdFromItem(item); } catch (e2) { pid = false; }




  photos = diqV39PhotoCount(item);
  if (!photos && d && finite(Number(d.photos))) { photos = Number(d.photos); }
  url = diqV39BestUrl(item, query || activeLens);




  source = clean(String(item && item.photoSource || d.source || ""));
  status = clean(String(d.status || item && item.photoStatus || ""));
  details = clean(String(d.details || d.msg || ""));




  try {
    photoEl = byId("diqAdvInfoPhoto");
    if (photoEl) { live = String(photoEl.getAttribute("data-photo-live") || "0") === "1" ? "LIVE" : "FALLBACK"; }
  } catch (e3) {}




  return {
    key:key,
    keySource:clean(diqGoogleKeyBridgeSource || (key === "yes" ? "window/config" : "missing")),
    places:places,
    placeId:pid,
    photos:photos,
    url:url,
    source:source || "Photo IQ",
    status:status || clean(stage || "debug"),
    details:details,
    live:live || "unknown"
  };
}




function diqV39RenderPhotoDebug(item, query, stage) {
  var card;
  var hero;
  var el;
  var data;
  var html;
  if (!DIQ_V39_PHOTO_DEBUG_ON || !item) { return; }
  diqV39InjectPhotoDebugStyles();
  card = byId("diqAdventureInfoCard");
  if (!card) { return; }
  try { hero = card.querySelector ? card.querySelector(".diqPlaceHero") : null; } catch (e0) { hero = null; }
  if (!hero) { hero = card; }
  try { hero.className = String(hero.className || "") + (String(hero.className || "").indexOf("hasPhotoDebug") < 0 ? " hasPhotoDebug" : ""); } catch (e1) {}




  el = byId("diqPhotoDebugIQ");
  if (!el) {
    el = document.createElement("div");
    el.id = "diqPhotoDebugIQ";
    el.className = "diqPhotoDebugIQ";
    try { hero.appendChild(el); } catch (e2) { try { card.appendChild(el); } catch (e3) {} }
  }




  data = diqV39DebugData(item, query || activeLens, stage || "debug");
  html =
    "<b>Photo Debug IQ</b> " +
    "Key:<span class='" + diqV39YesNoClass(data.key) + "'>" + diqV39YesNo(data.key) + "</span> Â· " +
    "Places:<span class='" + diqV39YesNoClass(data.places) + "'>" + diqV39YesNo(data.places) + "</span> Â· " +
    "ID:<span class='" + diqV39YesNoClass(data.placeId) + "'>" + diqV39YesNo(data.placeId) + "</span> Â· " +
    "Photos:<span class='" + (Number(data.photos || 0) > 0 ? "ok" : "bad") + "'>" + String(data.photos || 0) + "</span> Â· " +
    "Render:<span class='" + (data.live === "LIVE" ? "ok" : "warn") + "'>" + escapeHTML(data.live) + "</span>" +
    "<span class='muted'> Â· " + escapeHTML(data.source || "Photo IQ") + " / " + escapeHTML(data.status || "") + (data.details ? " / " + escapeHTML(data.details) : "") + "</span>" +
    "<span class='url'>" + escapeHTML(diqV39ShortUrl(data.url || "")) + "</span>";
  el.innerHTML = html;
}




/* Wrap the debug setters so the visible card updates during each photo stage. */
var diqV39OriginalSetPhotoDebug = diqSetPhotoDebug;
diqSetPhotoDebug = function (item, stage, extra) {
  var out = diqV39OriginalSetPhotoDebug(item, stage, extra);
  try { diqV39RenderPhotoDebug(item, activeLens, stage || "photo"); } catch (e) {}
  return out;
};




var diqV39OriginalApplyPlaceGallery = diqApplyPlaceGallery;
diqApplyPlaceGallery = function (item, query) {
  var out = diqV39OriginalApplyPlaceGallery(item, query || activeLens);
  try { diqV39RenderPhotoDebug(item, query || activeLens, "gallery"); } catch (e0) {}
  try {
    window.setTimeout(function () { try { diqV39RenderPhotoDebug(item, query || activeLens, "gallery+650ms"); } catch (e1) {} }, 650);
    window.setTimeout(function () { try { diqV39RenderPhotoDebug(item, query || activeLens, "gallery+1800ms"); } catch (e2) {} }, 1800);
    window.setTimeout(function () { try { diqV39RenderPhotoDebug(item, query || activeLens, "gallery+4200ms"); } catch (e3) {} }, 4200);
  } catch (timerErr) {}
  return out;
};




var diqV39OriginalHydratePlacePhotos = diqHydratePlacePhotos;
diqHydratePlacePhotos = function (item, query) {
  try { diqV39RenderPhotoDebug(item, query || activeLens, "hydrate-call"); } catch (e0) {}
  return diqV39OriginalHydratePlacePhotos(item, query || activeLens);
};




try { console.log("âœ… Drive IQ V39 Photo Debug IQ loaded"); } catch (e) {}




/* =========================================================
   DRIVE IQ V41 â€” PHOTO URL HANDOFF IQ
   Final wire between "Google has photos" and "Place IQ renders photo."
   - Rejects attribution/copyright URLs that looked like photos.
   - Keeps Google Places legacy/New photo URLs trusted.
   - Forces resolved Google photo URLs into gallery before fallback art.
   - Adds URL/load debug so Square Pizza-type cards reveal final handoff.
   ES5-safe.
========================================================= */




var DIQ_V41_PHOTO_HANDOFF_ON = true;
var diqV41LastImageLoadState = {};




function diqV41UrlHost(url) {
  var a;
  try {
    a = document.createElement("a");
    a.href = String(url || "");
    return String(a.hostname || "").toLowerCase();
  } catch (e) { return ""; }
}




function diqV41IsAttributionUrl(url) {
  var u = String(url || "").toLowerCase();
  if (!u) { return true; }
  if (u.indexOf("openstreetmap.org/copyright") > -1) { return true; }
  if (u.indexOf("www.openstreetmap.org/copyright") > -1) { return true; }
  if (u.indexOf("osm.org/copyright") > -1) { return true; }
  if (u.indexOf("/copyright") > -1 && (u.indexOf("openstreetmap") > -1 || u.indexOf("osm.org") > -1)) { return true; }
  if (u.indexOf("creativecommons.org") > -1 && u.indexOf("/licenses/") > -1) { return true; }
  if (u.indexOf("wikidata.org/wiki/") > -1) { return true; }
  if (u.indexOf("wikipedia.org/wiki/") > -1 && u.indexOf("upload.wikimedia.org") < 0) { return true; }
  return false;
}




function diqV41LooksLikeImageUrl(url) {
  var u = clean(url);
  var low = u.toLowerCase();
  var host;
  if (!u) { return false; }
  if (diqV41IsAttributionUrl(u)) { return false; }
  if (u.indexOf("data:image") === 0) { return true; }
  if (u.indexOf("http") !== 0) { return false; }




  /* Google Places photo endpoints are valid image/media URLs even without jpg/png extensions. */
  if (low.indexOf("maps.googleapis.com/maps/api/place/photo") > -1) { return true; }
  if (low.indexOf("places.googleapis.com/v1/places/") > -1 && low.indexOf("/photos/") > -1 && low.indexOf("/media") > -1) { return true; }




  /* Common trusted image CDNs used by Google/Wiki/place media. */
  host = diqV41UrlHost(u);
  if (host.indexOf("googleusercontent.com") > -1) { return true; }
  if (host.indexOf("ggpht.com") > -1) { return true; }
  if (host.indexOf("gstatic.com") > -1 && low.indexOf("image") > -1) { return true; }
  if (host === "upload.wikimedia.org" || host.indexOf(".wikimedia.org") > -1) { return true; }
  if (host.indexOf("cloudinary.com") > -1 || host.indexOf("imgix.net") > -1 || host.indexOf("fastly.net") > -1) { return true; }




  /* Never treat map tiles, static maps, icons, sprites, marker assets, or API metadata pages as venue photos. */
  if (low.indexOf("api.mapbox.com/styles") > -1) { return false; }
  if (low.indexOf("maps.googleapis.com/maps/api/staticmap") > -1) { return false; }
  if (low.indexOf("api.geoapify.com/v1/icon") > -1) { return false; }
  if (low.indexOf("/static/") > -1 && low.indexOf("map") > -1) { return false; }
  if (low.indexOf("sprite") > -1 || low.indexOf("marker") > -1 || low.indexOf("pin-") > -1) { return false; }




  if (/\.(jpg|jpeg|png|webp|gif)(\?|#|$)/i.test(u)) { return true; }
  if (/[?&](format|fm)=(jpg|jpeg|png|webp)/i.test(u)) { return true; }
  if (/[?&](auto)=format/i.test(u)) { return true; }




  return false;
}




/* Replace the broad V36 URL test with the V41 trustworthy image test. */
diqLooksLikeImageUrl = function (url) {
  return diqV41LooksLikeImageUrl(url);
};




/* Re-wrap addUnique so old attribution URLs can never enter item.photos again. */
diqAddUniquePhoto = function (list, url, label, kind) {
  var i;
  var k;
  url = clean(url);
  kind = clean(kind || "official");
  if (!list || !url) { return; }
  if (kind !== "map" && !diqV41LooksLikeImageUrl(url)) { return; }
  if (url.indexOf("http") !== 0 && url.indexOf("data:image") !== 0) { return; }
  for (i = 0; i < list.length; i++) {
    if (String(list[i].url || "") === url) { return; }
  }
  k = kind;
  if (url.toLowerCase().indexOf("api.mapbox.com/styles") > -1 || url.toLowerCase().indexOf("staticmap") > -1) { k = "map"; }
  list.push({ url:url, label:clean(label || "Photo"), kind:k, priority:diqPhotoKindPriority(k) });
};




function diqV41SanitizePhotoList(list) {
  var out = [];
  var i;
  var p;
  for (i = 0; i < (list || []).length; i++) {
    p = list[i];
    if (!p) { continue; }
    if (typeof p === "string") { diqAddUniquePhoto(out, p, "Gallery Photo", "gallery"); }
    else if (p.url) { diqAddUniquePhoto(out, p.url, p.label || "Gallery Photo", p.kind || "gallery"); }
  }
  return out;
}




/* Keep resolved Google URLs as the first-class gallery authority before fallback art. */
var diqV41OriginalBuildPlaceGallery = diqBuildPlaceGallery;
diqBuildPlaceGallery = function (item, query) {
  var real = [];
  var fallback;
  var v;
  var i;
  var list;
  if (!item) { return []; }




  /* Start with already-resolved photos and the single hero photo URL. */
  list = diqV41SanitizePhotoList(item.photos || []);
  for (i = 0; i < list.length; i++) { diqAddUniquePhoto(real, list[i].url, list[i].label, list[i].kind); }
  diqAddUniquePhoto(real, item.photoUrl, diqIntentPhotoLabel(item, query), item.photoSource || "photo");
  diqAddUniquePhoto(real, item.googlePhotoUrl, diqIntentPhotoLabel(item, query), "google_places");
  diqAddUniquePhoto(real, item.googlePhotoMediaUrl, diqIntentPhotoLabel(item, query), "google_places_new");




  /* Add direct Google photo references if the scan gave us refs or Place API new photo names. */
  try {
    list = diqGoogleDirectPhotoCandidates(item, query);
    for (i = 0; i < (list || []).length; i++) { diqAddUniquePhoto(real, list[i].url, list[i].label, list[i].kind); }
  } catch (directErr) {}




  if (real.length) {
    real.sort(function (a, b) {
      var pa = Number(a.priority || diqPhotoKindPriority(a.kind)) + diqIntentPhotoBoost(a, item, query);
      var pb = Number(b.priority || diqPhotoKindPriority(b.kind)) + diqIntentPhotoBoost(b, item, query);
      if (pa !== pb) { return pa - pb; }
      return String(a.url || "").length - String(b.url || "").length;
    });
    return real.slice(0, 6);
  }




  /* Let the previous builder try official/wiki images, but sanitize its output. */
  try {
    list = diqV41SanitizePhotoList(diqV41OriginalBuildPlaceGallery(item, query));
    for (i = 0; i < (list || []).length; i++) {
      if (list[i] && list[i].kind !== "map") { diqAddUniquePhoto(real, list[i].url, list[i].label, list[i].kind); }
    }
    if (real.length) { return real.slice(0, 6); }
  } catch (oldErr) {}




  fallback = diqCategoryFallbackPhoto(item, query);
  real = [fallback];
  v = staticMapPhotoUrl(item);
  if (v) { real.push({ url:v, label:"Map Preview", kind:"map", priority:99 }); }
  return real.slice(0, 6);
};




/* Force legacy Places photo URLs to be preserved and labeled. */
diqGooglePhotoObjectsToList = function (place, item, query) {
  var out = [];
  var photos = place && place.photos ? place.photos : [];
  var j;
  var url;
  var label;
  for (j = 0; j < photos.length && j < 8; j++) {
    try {
      url = "";
      if (photos[j] && photos[j].getUrl) {
        url = photos[j].getUrl({ maxWidth:1200, maxHeight:900 });
      }
      label = j === 0 ? diqIntentPhotoLabel(item, query) : "Google Place Photo";
      if (url) { diqAddUniquePhoto(out, url, label, "google_places"); }
    } catch (photoErr) {}
  }
  if (out.length) {
    try { diqSetPhotoDebug(item, "legacy-url-ready", { status:"url yes", msg:"legacy urls " + String(out.length), source:"Google Places" }); } catch (e0) {}
  }
  return out;
};




/* Force Places API New media URLs to be preserved and labeled. */
diqGoogleNewPhotoObjectsToList = function (place, item, query) {
  var out = [];
  var photos = place && place.photos ? place.photos : [];
  var i;
  var url;
  var label;
  for (i = 0; i < photos.length && i < 8; i++) {
    try {
      url = "";
      if (photos[i] && photos[i].name) { url = diqGoogleNewPhotoMediaUrl(photos[i].name, 1200); }
      if (!url && photos[i] && photos[i].photoUri) { url = clean(photos[i].photoUri); }
      label = i === 0 ? diqIntentPhotoLabel(item, query) : "Google Place Photo";
      if (url) { diqAddUniquePhoto(out, url, label, "google_places_new"); }
    } catch (photoErr) {}
  }
  if (out.length) {
    try { diqSetPhotoDebug(item, "new-url-ready", { status:"url yes", msg:"new urls " + String(out.length), source:"Places API New" }); } catch (e0) {}
  }
  return out;
};




/* Filter resolved photos before applying, so one bad attribution URL cannot poison the hero. */
diqApplyResolvedPhotosToItem = function (item, photos, query, source) {
  var i;
  var existing = [];
  var cleaned = diqV41SanitizePhotoList(photos || []);
  if (!item || !cleaned.length) { return false; }




  if (item.photos && item.photos.length) {
    for (i = 0; i < item.photos.length; i++) {
      if (typeof item.photos[i] === "string") { diqAddUniquePhoto(existing, item.photos[i], "Gallery Photo", "gallery"); }
      else if (item.photos[i] && item.photos[i].url) { diqAddUniquePhoto(existing, item.photos[i].url, item.photos[i].label || "Gallery Photo", item.photos[i].kind || "gallery"); }
    }
  }




  for (i = 0; i < cleaned.length; i++) {
    if (cleaned[i] && cleaned[i].url) {
      diqAddUniquePhoto(existing, cleaned[i].url, cleaned[i].label || diqIntentPhotoLabel(item, query), cleaned[i].kind || source || "gallery");
    }
  }




  if (!existing.length) { return false; }
  item.photos = existing.slice(0, 8);
  item.photoUrl = existing[0].url;
  item.photoSource = clean(source || "Photo IQ");
  item.photoDebugLastUrl = item.photoUrl;
  return true;
};




/* Track actual image load/error in the debug panel. */
var diqV41OriginalApplyPlaceGallery = diqApplyPlaceGallery;
diqApplyPlaceGallery = function (item, query) {
  var out = diqV41OriginalApplyPlaceGallery(item, query || activeLens);
  var key = diqPhotoCacheKey(item);
  var photo = byId("diqAdvInfoPhoto");
  try {
    if (photo && key) {
      window.setTimeout(function () {
        var live = String(photo.getAttribute("data-photo-live") || "0") === "1";
        var bg = String(photo.getAttribute("style") || "");
        diqV41LastImageLoadState[key] = {
          live:live,
          url:clean(item && (item.photoUrl || item.photoDebugLastUrl) || ""),
          style:bg,
          ts:Date.now()
        };
        try { diqV39RenderPhotoDebug(item, query || activeLens, live ? "image-live" : "image-fallback"); } catch (e0) {}
      }, 420);
      window.setTimeout(function () { try { diqV39RenderPhotoDebug(item, query || activeLens, "image+1600ms"); } catch (e1) {} }, 1600);
    }
  } catch (e2) {}
  return out;
};




/* Upgrade visible debug to include URL yes/no and avoid showing attribution URLs as candidates. */
diqV39BestUrl = function (item, query) {
  var gallery;
  var i;
  try { if (item && item.photoUrl && diqV41LooksLikeImageUrl(item.photoUrl)) { return String(item.photoUrl); } } catch (e0) {}
  try { gallery = diqBuildPlaceGallery(item, query || activeLens); } catch (e1) { gallery = []; }
  for (i = 0; i < (gallery || []).length; i++) {
    if (gallery[i] && gallery[i].url && gallery[i].kind !== "map" && diqV41LooksLikeImageUrl(gallery[i].url)) { return String(gallery[i].url || ""); }
  }
  return "";
};




var diqV41OriginalDebugData = diqV39DebugData;
diqV39DebugData = function (item, query, stage) {
  var d = diqV41OriginalDebugData(item, query || activeLens, stage || "debug");
  var key = diqPhotoCacheKey(item);
  var load = key && diqV41LastImageLoadState[key] ? diqV41LastImageLoadState[key] : null;
  d.url = diqV39BestUrl(item, query || activeLens);
  d.urlState = d.url ? "URL:YES" : "URL:NO";
  if (load) { d.loadState = load.live ? "IMG:LIVE" : "IMG:FALLBACK"; }
  else { d.loadState = "IMG:WAIT"; }
  return d;
};




var diqV41OriginalRenderDebug = diqV39RenderPhotoDebug;
diqV39RenderPhotoDebug = function (item, query, stage) {
  var card;
  var hero;
  var el;
  var data;
  var html;
  if (!DIQ_V39_PHOTO_DEBUG_ON || !item) { return; }
  diqV39InjectPhotoDebugStyles();
  card = byId("diqAdventureInfoCard");
  if (!card) { return; }
  try { hero = card.querySelector ? card.querySelector(".diqPlaceHero") : null; } catch (e0) { hero = null; }
  if (!hero) { hero = card; }
  try { hero.className = String(hero.className || "") + (String(hero.className || "").indexOf("hasPhotoDebug") < 0 ? " hasPhotoDebug" : ""); } catch (e1) {}




  el = byId("diqPhotoDebugIQ");
  if (!el) {
    el = document.createElement("div");
    el.id = "diqPhotoDebugIQ";
    el.className = "diqPhotoDebugIQ";
    try { hero.appendChild(el); } catch (e2) { try { card.appendChild(el); } catch (e3) {} }
  }




  data = diqV39DebugData(item, query || activeLens, stage || "debug");
  html =
    "<b>Photo Debug IQ</b> " +
    "Key:<span class='" + diqV39YesNoClass(data.key) + "'>" + diqV39YesNo(data.key) + "</span> Â· " +
    "Places:<span class='" + diqV39YesNoClass(data.places) + "'>" + diqV39YesNo(data.places) + "</span> Â· " +
    "ID:<span class='" + diqV39YesNoClass(data.placeId) + "'>" + diqV39YesNo(data.placeId) + "</span> Â· " +
    "Photos:<span class='" + (Number(data.photos || 0) > 0 ? "ok" : "bad") + "'>" + String(data.photos || 0) + "</span> Â· " +
    "<span class='" + (data.url ? "ok" : "bad") + "'>" + escapeHTML(data.urlState || (data.url ? "URL:YES" : "URL:NO")) + "</span> Â· " +
    "Render:<span class='" + (data.live === "LIVE" ? "ok" : "warn") + "'>" + escapeHTML(data.live) + "</span>" +
    "<span class='muted'> Â· " + escapeHTML(data.loadState || "") + " Â· " + escapeHTML(data.source || "Photo IQ") + " / " + escapeHTML(data.status || "") + (data.details ? " / " + escapeHTML(data.details) : "") + "</span>" +
    "<span class='url'>" + escapeHTML(diqV39ShortUrl(data.url || "no-real-photo-url")) + "</span>";
  el.innerHTML = html;
};




try { console.log("âœ… Drive IQ V41 Photo URL Handoff IQ loaded"); } catch (e) {}




/* =========================================================
   DRIVE IQ V42 â€” PHOTO NAME â†’ MEDIA URL LIVE WIRE IQ
   We now know Google says Photos:1 but URL:NO. This pass makes the
   Places API (New) photo.name/photo resource the first-class handoff,
   and adds an aggressive text-search resolver so a bad/foreign place id
   cannot stop real venue photos from lighting up.
   ES5-safe.
========================================================= */




var DIQ_V42_PHOTO_LIVE_WIRE_ON = true;




function diqV42PhotoResourceName(photo) {
  var n = "";
  if (!photo) { return ""; }
  try { if (photo.name) { n = clean(photo.name); } } catch (e0) {}
  if (!n) { try { if (photo.photoName) { n = clean(photo.photoName); } } catch (e1) {} }
  if (!n) { try { if (photo.resourceName) { n = clean(photo.resourceName); } } catch (e2) {} }
  if (!n) { try { if (photo.photo_reference) { n = clean(photo.photo_reference); } } catch (e3) {} }
  if (!n) { try { if (photo.photoReference) { n = clean(photo.photoReference); } } catch (e4) {} }
  if (!n && typeof photo === "string") { n = clean(photo); }
  return n;
}




function diqV42MediaUrlFromPhotoName(photoName, maxWidth, maxHeight) {
  var key = diqGooglePlacesApiKey();
  var n = clean(photoName);
  var url;
  if (!n || !key) { return ""; }




  if (n.indexOf("https://places.googleapis.com/") === 0 || n.indexOf("https://maps.googleapis.com/maps/api/place/photo") === 0) {
    return n;
  }




  if (n.indexOf("places/") === 0 && n.indexOf("/photos/") > -1) {
    url = "https://places.googleapis.com/v1/" + n;
    if (url.indexOf("/media") < 0) { url += "/media"; }
    url += "?maxWidthPx=" + encodeURIComponent(String(maxWidth || 1200));
    if (maxHeight) { url += "&maxHeightPx=" + encodeURIComponent(String(maxHeight)); }
    url += "&key=" + encodeURIComponent(key);
    return url;
  }




  /* Legacy reference fallback. */
  return "https://maps.googleapis.com/maps/api/place/photo?maxwidth=" +
    encodeURIComponent(String(maxWidth || 1200)) +
    "&photo_reference=" + encodeURIComponent(n) +
    "&key=" + encodeURIComponent(key);
}




diqGoogleNewPhotoMediaUrl = function (photoName, maxWidth) {
  return diqV42MediaUrlFromPhotoName(photoName, maxWidth || 1200, 900);
};




function diqV42PhotosToMediaList(photos, item, query, source) {
  var out = [];
  var i;
  var name;
  var url;
  var label;
  for (i = 0; i < (photos || []).length && i < 8; i++) {
    try {
      name = diqV42PhotoResourceName(photos[i]);
      url = "";
      if (photos[i] && photos[i].getUrl) {
        try { url = photos[i].getUrl({ maxWidth:1200, maxHeight:900 }); } catch (g0) {}
        if (!url) { try { url = photos[i].getUrl({ maxWidth:1200 }); } catch (g1) {} }
        if (!url) { try { url = photos[i].getUrl(); } catch (g2) {} }
      }
      if (!url && name) { url = diqV42MediaUrlFromPhotoName(name, 1200, 900); }
      if (!url && photos[i] && photos[i].photoUri) { url = clean(photos[i].photoUri); }
      if (!url && photos[i] && photos[i].url) { url = clean(photos[i].url); }
      label = i === 0 ? diqIntentPhotoLabel(item, query) : "Google Place Photo";
      if (url) { diqAddUniquePhoto(out, url, label, source || "google_places_new"); }
      if (url && item) {
        item.googlePhotoUrl = item.googlePhotoUrl || url;
        item.googlePhotoMediaUrl = item.googlePhotoMediaUrl || url;
        item.googlePhotoName = item.googlePhotoName || name;
      }
    } catch (photoErr) {}
  }
  return out;
}




diqGooglePhotoObjectsToList = function (place, item, query) {
  var photos = place && place.photos ? place.photos : [];
  var out = diqV42PhotosToMediaList(photos, item, query, "google_places");
  if (out.length) {
    try {
      diqSetPhotoDebug(item, "legacy-url-ready", {
        status:"URL:YES",
        msg:"legacy media " + String(out.length),
        details:item && item.googlePhotoName ? item.googlePhotoName : "",
        source:"Google Places"
      });
    } catch (e0) {}
  } else if (photos && photos.length) {
    try {
      diqSetPhotoDebug(item, "legacy-photo-no-url", {
        status:"URL:NO",
        msg:"photo objects " + String(photos.length),
        source:"Google Places"
      });
    } catch (e1) {}
  }
  return out;
};




diqGoogleNewPhotoObjectsToList = function (place, item, query) {
  var photos = place && place.photos ? place.photos : [];
  var out = diqV42PhotosToMediaList(photos, item, query, "google_places_new");
  if (out.length) {
    try {
      diqSetPhotoDebug(item, "new-url-ready", {
        status:"URL:YES",
        msg:"new media " + String(out.length),
        details:item && item.googlePhotoName ? item.googlePhotoName : "",
        source:"Places API New"
      });
    } catch (e0) {}
  } else if (photos && photos.length) {
    try {
      diqSetPhotoDebug(item, "new-photo-no-url", {
        status:"URL:NO",
        msg:"photo objects " + String(photos.length),
        source:"Places API New"
      });
    } catch (e1) {}
  }
  return out;
};




function diqV42GoogleNewChoosePhotoPlace(places, item) {
  var best = null;
  var bestScore = -999999;
  var i;
  var p;
  var score;
  var ll;
  var d;
  var a;
  var b;
  for (i = 0; i < (places || []).length; i++) {
    p = places[i];
    if (!p || !p.photos || !p.photos.length) { continue; }




    a = normText(diqGoogleNewPlaceDisplayName(p));
    b = normText(item && item.label || "");
    score = 0;
    if (a && b) {
      if (a === b) { score += 180; }
      if (a.indexOf(b) > -1 || b.indexOf(a) > -1) { score += 110; }
      if (a.split(" ")[0] && b.indexOf(a.split(" ")[0]) > -1) { score += 18; }
    }




    ll = diqGoogleNewPlaceLatLng(p);
    if (ll && finite(Number(item.lat)) && finite(Number(item.lng))) {
      d = miles(Number(item.lat), Number(item.lng), Number(ll.lat), Number(ll.lng));
      if (finite(d)) {
        if (d <= 0.08) { score += 140; }
        else if (d <= 0.25) { score += 95; }
        else if (d <= 0.65) { score += 55; }
        else if (d <= 1.25) { score += 20; }
        else { score -= Math.round(d * 12); }
      }
    }




    score += 65; /* has photos */
    if (score > bestScore) {
      bestScore = score;
      best = p;
    }
  }
  if (!best || bestScore < 35) { return null; }
  return best;
}




function diqV42GoogleNewSearchPhotos(item, query, done) {
  var key = diqGooglePlacesApiKey();
  var qList;
  var qIndex = 0;
  var loc;
  if (!item || !key || !window.fetch) { done([]); return; }




  qList = diqPhotoSearchQueryVariants(item, query || activeLens);
  if (!qList.length && item && item.label) { qList = [clean(item.label)]; }




  if (finite(Number(item.lat)) && finite(Number(item.lng))) {
    loc = { latitude:Number(item.lat), longitude:Number(item.lng) };
  }




  function tryNext() {
    var q;
    var body;
    if (qIndex >= qList.length) {
      try { diqSetPhotoDebug(item, "v42-search-empty", { status:"URL:NO", msg:"new search exhausted", source:"Places API New" }); } catch (e0) {}
      done([]);
      return;
    }




    q = qList[qIndex];
    qIndex += 1;
    body = { textQuery:q, maxResultCount:10 };
    if (loc) {
      body.locationBias = { circle:{ center:loc, radius:12000 } };
    }




    try { diqSetPhotoDebug(item, "v42-search", { status:"search", msg:q, source:"Places API New" }); } catch (e1) {}




    try {
      fetch("https://places.googleapis.com/v1/places:searchText", {
        method:"POST",
        credentials:"omit",
        cache:"no-store",
        headers:{
          "Content-Type":"application/json",
          "X-Goog-Api-Key":key,
          "X-Goog-FieldMask":"places.id,places.displayName,places.formattedAddress,places.location,places.photos,places.photos.name,places.photos.photoUri"
        },
        body:JSON.stringify(body)
      })
        .then(function (res) { return res && res.ok ? res.json() : null; })
        .then(function (data) {
          var places = data && data.places ? data.places : [];
          var best = diqV42GoogleNewChoosePhotoPlace(places, item);
          var photos = [];
          try { diqSetPhotoDebug(item, "v42-search-results", { status:"results", msg:"places " + String(places.length), source:"Places API New" }); } catch (e2) {}
          if (best) {
            photos = diqGoogleNewPhotoObjectsToList(best, item, query);
            if (photos && photos.length) {
              try { diqSetPhotoDebug(item, "v42-url-live", { status:"URL:YES", msg:diqGoogleNewPlaceDisplayName(best), source:"Places API New" }); } catch (e3) {}
              done(photos);
              return;
            }
          }
          tryNext();
        })
        .catch(function () { tryNext(); });
    } catch (e4) { tryNext(); }
  }




  tryNext();
}




/* Override the New resolver so invalid/non-Google IDs do not block Text Search photos. */
diqGooglePlacesNewPhotoResolver = function (item, query, done) {
  var placeId = diqGooglePlaceIdFromItem(item);
  if (!diqGooglePlacesApiKey()) {
    diqSetPhotoDebug(item, "v42-needs-key", { status:"needs key", source:"Places API New" });
    done([]);
    return;
  }




  function runSearch() {
    diqV42GoogleNewSearchPhotos(item, query || activeLens, done);
  }




  if (placeId && (String(placeId).indexOf("ChIJ") === 0 || String(placeId).indexOf("places/") === 0)) {
    diqGoogleNewPlaceDetails(placeId, item, query || activeLens, function (detailsPhotos) {
      if (detailsPhotos && detailsPhotos.length) { done(detailsPhotos); return; }
      runSearch();
    });
    return;
  }




  runSearch();
};




/* Give direct gallery builder one more chance to use a saved Google media URL. */
var diqV42OriginalBuildPlaceGallery = diqBuildPlaceGallery;
diqBuildPlaceGallery = function (item, query) {
  var out = [];
  var list;
  var i;
  if (item) {
    diqAddUniquePhoto(out, item.googlePhotoMediaUrl, diqIntentPhotoLabel(item, query), "google_places_new");
    diqAddUniquePhoto(out, item.googlePhotoUrl, diqIntentPhotoLabel(item, query), "google_places");
    diqAddUniquePhoto(out, item.photoUrl, diqIntentPhotoLabel(item, query), item.photoSource || "photo");
    list = diqV41SanitizePhotoList(item.photos || []);
    for (i = 0; i < (list || []).length; i++) {
      if (list[i] && list[i].kind !== "map") { diqAddUniquePhoto(out, list[i].url, list[i].label, list[i].kind); }
    }
  }
  if (out.length) { return out.slice(0, 6); }
  return diqV42OriginalBuildPlaceGallery(item, query || activeLens);
};




/* Debug: show the Google photo resource name when URL is still missing. */
var diqV42OriginalDebugData = diqV39DebugData;
diqV39DebugData = function (item, query, stage) {
  var d = diqV42OriginalDebugData(item, query || activeLens, stage || "debug");
  if (!d.url && item && item.googlePhotoName) {
    d.details = clean(String(d.details || "") + " " + String(item.googlePhotoName || ""));
  }
  return d;
};




try { console.log("âœ… Drive IQ V42 Photo Live Wire IQ loaded"); } catch (e) {}




/* =========================================================
   DRIVE IQ V43 â€” PHOTO NAME FIELD MASK IQ
   The field test now proves Key:YES, Places:YES, ID:YES, Photos:1, URL:NO.
   That means Google is exposing a photo object/count but our URL handoff
   still is not seeing a usable photo resource. V43 makes photo.name explicit
   in FieldMasks, deeply extracts photo resource names from any returned
   object shape, and turns those names into live media URLs before fallback.
   ES5-safe.
========================================================= */




var DIQ_V43_PHOTO_NAME_FIELD_MASK_ON = true;




function diqV43DeepPhotoResourceName(value, depth) {
  var k;
  var v;
  var n;
  var i;




  if (!value || depth > 4) { return ""; }




  if (typeof value === "string") {
    n = clean(value);
    if (n.indexOf("places/") === 0 && n.indexOf("/photos/") > -1) { return n; }
    if (n.indexOf("photo_reference") > -1) { return n; }
    if (n.indexOf("maps.googleapis.com/maps/api/place/photo") === 0) { return n; }
    if (n.indexOf("places.googleapis.com/v1/places/") === 0 && n.indexOf("/photos/") > -1) { return n; }
    return "";
  }




  try {
    if (value.name) {
      n = clean(value.name);
      if (n.indexOf("places/") === 0 && n.indexOf("/photos/") > -1) { return n; }
    }
  } catch (e0) {}




  try {
    n = clean(value.photoName || value.resourceName || value.googlePhotoName || value.photo_reference || value.photoReference || value.reference || value.photoRef || "");
    if (n) { return n; }
  } catch (e1) {}




  try {
    if (value.getUrl) {
      n = value.getUrl({ maxWidth:1200, maxHeight:900 });
      if (n) { return clean(n); }
    }
  } catch (e2) {}




  try {
    if (value.getURI) {
      n = value.getURI({ maxWidth:1200, maxHeight:900 });
      if (n) { return clean(n); }
    }
  } catch (e3) {}




  try {
    if (value.toJSON) {
      n = diqV43DeepPhotoResourceName(value.toJSON(), depth + 1);
      if (n) { return n; }
    }
  } catch (e4) {}




  if (value.length && typeof value !== "string") {
    for (i = 0; i < value.length && i < 12; i++) {
      n = diqV43DeepPhotoResourceName(value[i], depth + 1);
      if (n) { return n; }
    }
  }




  if (typeof value === "object") {
    for (k in value) {
      if (!value.hasOwnProperty(k)) { continue; }
      if (!/(photo|image|media|name|reference|uri|url|resource)/i.test(k)) { continue; }
      try {
        v = value[k];
        n = diqV43DeepPhotoResourceName(v, depth + 1);
        if (n) { return n; }
      } catch (e5) {}
    }
  }




  return "";
}




function diqV43PhotoObjectKeys(photo) {
  var out = [];
  var k;
  var raw;
  if (!photo) { return ""; }
  try {
    for (k in photo) {
      if (photo.hasOwnProperty(k)) { out.push(k); }
    }
  } catch (e0) {}
  try {
    if (photo.toJSON) {
      raw = photo.toJSON();
      for (k in raw) {
        if (raw.hasOwnProperty(k) && out.join("|").indexOf(k) < 0) { out.push(k); }
      }
    }
  } catch (e1) {}
  return out.slice(0, 10).join(",");
}




function diqV43MediaUrlFromResource(resource, maxWidth, maxHeight) {
  var key = diqGooglePlacesApiKey();
  var r = clean(resource);
  var url;
  if (!r || !key) { return ""; }




  if (r.indexOf("https://places.googleapis.com/v1/places/") === 0 && r.indexOf("/photos/") > -1) {
    if (r.indexOf("/media") < 0) { r += "/media"; }
    if (r.indexOf("?") < 0) {
      r += "?maxWidthPx=" + encodeURIComponent(String(maxWidth || 1200));
      if (maxHeight) { r += "&maxHeightPx=" + encodeURIComponent(String(maxHeight)); }
      r += "&key=" + encodeURIComponent(key);
    }
    return r;
  }




  if (r.indexOf("https://maps.googleapis.com/maps/api/place/photo") === 0) { return r; }




  if (r.indexOf("places/") === 0 && r.indexOf("/photos/") > -1) {
    url = "https://places.googleapis.com/v1/" + r;
    if (url.indexOf("/media") < 0) { url += "/media"; }
    url += "?maxWidthPx=" + encodeURIComponent(String(maxWidth || 1200));
    if (maxHeight) { url += "&maxHeightPx=" + encodeURIComponent(String(maxHeight)); }
    url += "&key=" + encodeURIComponent(key);
    return url;
  }




  return "https://maps.googleapis.com/maps/api/place/photo?maxwidth=" +
    encodeURIComponent(String(maxWidth || 1200)) +
    "&photo_reference=" + encodeURIComponent(r) +
    "&key=" + encodeURIComponent(key);
}




diqGoogleNewPhotoMediaUrl = function (photoName, maxWidth) {
  return diqV43MediaUrlFromResource(photoName, maxWidth || 1200, 900);
};




function diqV43PhotoObjectsToList(place, item, query, source) {
  var photos = place && place.photos ? place.photos : [];
  var out = [];
  var i;
  var resource;
  var url;
  var label;
  var keys;




  for (i = 0; i < (photos || []).length && i < 8; i++) {
    resource = "";
    url = "";
    keys = "";




    try { keys = diqV43PhotoObjectKeys(photos[i]); } catch (kErr) {}




    try {
      if (photos[i] && photos[i].getUrl) {
        url = photos[i].getUrl({ maxWidth:1200, maxHeight:900 });
        if (!url) { url = photos[i].getUrl({ maxWidth:1200 }); }
      }
    } catch (g0) {}




    if (!url) {
      try {
        if (photos[i] && photos[i].getURI) {
          url = photos[i].getURI({ maxWidth:1200, maxHeight:900 });
        }
      } catch (g1) {}
    }




    if (!url) {
      try { resource = diqV43DeepPhotoResourceName(photos[i], 0); } catch (rErr) { resource = ""; }
      if (resource) { url = diqV43MediaUrlFromResource(resource, 1200, 900); }
    }




    if (!url && photos[i]) {
      try { url = clean(photos[i].photoUri || photos[i].uri || photos[i].url || photos[i].src || ""); } catch (uErr) {}
    }




    label = i === 0 ? diqIntentPhotoLabel(item, query) : "Google Place Photo";




    if (url) {
      diqAddUniquePhoto(out, url, label, source || "google_places_new");
      if (item) {
        item.googlePhotoUrl = item.googlePhotoUrl || url;
        item.googlePhotoMediaUrl = item.googlePhotoMediaUrl || url;
        item.googlePhotoName = item.googlePhotoName || resource;
        item.photoUrl = item.photoUrl || url;
        item.photoSource = item.photoSource || (source || "Google Places");
      }
    } else if (item && !item.googlePhotoName && resource) {
      item.googlePhotoName = resource;
    }




    if (!url && item) {
      try {
        diqSetPhotoDebug(item, "v43-photo-object-no-url", {
          status:"URL:NO",
          msg:"photo keys " + keys,
          details:resource || "no-resource-name",
          photos:(photos || []).length,
          source:source || "Google Places"
        });
      } catch (dbgErr) {}
    }
  }




  if (out.length && item) {
    try {
      diqSetPhotoDebug(item, "v43-url-ready", {
        status:"URL:YES",
        msg:"media " + String(out.length),
        details:item.googlePhotoName || "",
        url:out[0].url,
        photos:(photos || []).length,
        source:source || "Google Places"
      });
    } catch (e0) {}
  }




  return out;
}




diqGooglePhotoObjectsToList = function (place, item, query) {
  return diqV43PhotoObjectsToList(place, item, query || activeLens, "Google Places");
};




diqGoogleNewPhotoObjectsToList = function (place, item, query) {
  return diqV43PhotoObjectsToList(place, item, query || activeLens, "Places API New");
};




function diqV43NormalizePlaceIdForDetails(placeId) {
  var p = clean(placeId);
  if (!p) { return ""; }
  if (p.indexOf("places/") === 0) { p = p.replace(/^places\//, ""); }
  return p;
}




diqGoogleNewPlaceDetails = function (placeId, item, query, done) {
  var key = diqGooglePlacesApiKey();
  var pid = diqV43NormalizePlaceIdForDetails(placeId);
  var url;
  if (!key || !pid || !window.fetch) { done([]); return; }




  url = "https://places.googleapis.com/v1/places/" + encodeURIComponent(String(pid)) +
    "?key=" + encodeURIComponent(key);




  try { diqSetPhotoDebug(item, "v43-details-request", { status:"details", msg:"explicit photos.name", source:"Places API New" }); } catch (e0) {}




  try {
    fetch(url, {
      method:"GET",
      credentials:"omit",
      cache:"no-store",
      headers:{
        "X-Goog-FieldMask":"id,displayName,formattedAddress,location,photos.name,photos.widthPx,photos.heightPx,photos.authorAttributions"
      }
    })
      .then(function (res) { return res && res.ok ? res.json() : null; })
      .then(function (data) {
        var photos = diqV43PhotoObjectsToList(data, item, query || activeLens, "Places API New");
        try {
          diqSetPhotoDebug(item, "v43-details-ok", {
            status:photos && photos.length ? "URL:YES" : "URL:NO",
            msg:"details photos " + String(data && data.photos ? data.photos.length : 0),
            details:data && data.photos && data.photos[0] ? diqV43DeepPhotoResourceName(data.photos[0], 0) || diqV43PhotoObjectKeys(data.photos[0]) : "no-photo-object",
            url:photos && photos[0] ? photos[0].url : "",
            photos:data && data.photos ? data.photos.length : 0,
            source:"Places API New"
          });
        } catch (e1) {}
        done(photos || []);
      })
      .catch(function () {
        try { diqSetPhotoDebug(item, "v43-details-fail", { status:"details fail", source:"Places API New" }); } catch (e2) {}
        done([]);
      });
  } catch (e3) { done([]); }
};




function diqV43GoogleNewTextSearchPhotoResolver(item, query, done) {
  var key = diqGooglePlacesApiKey();
  var qList;
  var qIndex = 0;
  var loc;
  if (!item || !key || !window.fetch) { done([]); return; }




  qList = diqPhotoSearchQueryVariants(item, query || activeLens);
  if (!qList.length && item.label) { qList = [clean(item.label)]; }




  if (finite(Number(item.lat)) && finite(Number(item.lng))) {
    loc = { latitude:Number(item.lat), longitude:Number(item.lng) };
  }




  function tryNext() {
    var q;
    var body;
    if (qIndex >= qList.length) {
      try { diqSetPhotoDebug(item, "v43-search-empty", { status:"URL:NO", msg:"search exhausted", source:"Places API New" }); } catch (e0) {}
      done([]);
      return;
    }




    q = qList[qIndex];
    qIndex += 1;




    body = { textQuery:q, maxResultCount:10 };
    if (loc) { body.locationBias = { circle:{ center:loc, radius:12000 } }; }




    try { diqSetPhotoDebug(item, "v43-search", { status:"search", msg:q, source:"Places API New" }); } catch (e1) {}




    try {
      fetch("https://places.googleapis.com/v1/places:searchText", {
        method:"POST",
        credentials:"omit",
        cache:"no-store",
        headers:{
          "Content-Type":"application/json",
          "X-Goog-Api-Key":key,
          "X-Goog-FieldMask":"places.id,places.displayName,places.formattedAddress,places.location,places.photos.name,places.photos.widthPx,places.photos.heightPx,places.photos.authorAttributions"
        },
        body:JSON.stringify(body)
      })
        .then(function (res) { return res && res.ok ? res.json() : null; })
        .then(function (data) {
          var places = data && data.places ? data.places : [];
          var best = diqV42GoogleNewChoosePhotoPlace(places, item);
          var photos = [];
          var photoCount = best && best.photos ? best.photos.length : 0;




          if (best) { photos = diqV43PhotoObjectsToList(best, item, query || activeLens, "Places API New"); }




          try {
            diqSetPhotoDebug(item, "v43-search-results", {
              status:photos && photos.length ? "URL:YES" : "URL:NO",
              msg:"places " + String(places.length) + " photos " + String(photoCount),
              details:best && best.photos && best.photos[0] ? diqV43DeepPhotoResourceName(best.photos[0], 0) || diqV43PhotoObjectKeys(best.photos[0]) : "no-best-photo",
              url:photos && photos[0] ? photos[0].url : "",
              photos:photoCount,
              source:"Places API New"
            });
          } catch (e2) {}




          if (photos && photos.length) { done(photos); return; }
          if (best && best.id) {
            diqGoogleNewPlaceDetails(best.id, item, query || activeLens, function (detailPhotos) {
              if (detailPhotos && detailPhotos.length) { done(detailPhotos); }
              else { tryNext(); }
            });
            return;
          }
          tryNext();
        })
        .catch(function () { tryNext(); });
    } catch (e3) { tryNext(); }
  }




  tryNext();
}




diqGooglePlacesNewPhotoResolver = function (item, query, done) {
  var placeId = diqGooglePlaceIdFromItem(item);




  if (!diqGooglePlacesApiKey()) {
    try { diqSetPhotoDebug(item, "v43-needs-key", { status:"needs key", source:"Places API New" }); } catch (e0) {}
    done([]);
    return;
  }




  function searchFallback() {
    diqV43GoogleNewTextSearchPhotoResolver(item, query || activeLens, done);
  }




  if (placeId && (String(placeId).indexOf("ChIJ") === 0 || String(placeId).indexOf("places/") === 0)) {
    diqGoogleNewPlaceDetails(placeId, item, query || activeLens, function (detailsPhotos) {
      if (detailsPhotos && detailsPhotos.length) { done(detailsPhotos); return; }
      searchFallback();
    });
    return;
  }




  searchFallback();
};




var diqV43OriginalDebugData = diqV39DebugData;
diqV39DebugData = function (item, query, stage) {
  var d = diqV43OriginalDebugData(item, query || activeLens, stage || "debug");
  if (!d.url && item && item.googlePhotoName) {
    d.details = clean(String(d.details || "") + " " + String(item.googlePhotoName || ""));
  }
  if (!d.url && item && item.photoDebug && item.photoDebug.url) {
    d.url = item.photoDebug.url;
  }
  return d;
};




try { console.log("âœ… Drive IQ V43 Photo Name Field Mask IQ loaded"); } catch (e) {}








/* =========================================================
   DRIVE IQ V46 â€” PHOTO PLACE RESOLVER IQ
   Field debug showed: Key:YES Â· Places:YES Â· ID:NO Â· Photos:1 Â· URL:NO.
   That means the photo stack is alive, but the accepted Google candidate is
   not being written back as the item place id. V46 makes the resolver the
   authority: score Google candidates by name + distance + category + photos,
   accept a reasonable photo-backed match, persist its Place ID, then run the
   normal Places New media URL path.
   ES5-safe.
========================================================= */




var DIQ_V46_PHOTO_PLACE_RESOLVER_ON = true;




function diqV46PlaceName(place) {
  var n = "";
  try { if (place && place.displayName && place.displayName.text) { n = clean(place.displayName.text); } } catch (e0) {}
  if (!n) { try { n = clean(place && place.name || ""); } catch (e1) {} }
  if (!n) { try { n = clean(place && place.formattedAddress || ""); } catch (e2) {} }
  return n;
}




function diqV46PlaceId(place) {
  var id = "";
  try { id = clean(place && (place.id || place.place_id || place.placeId || "")); } catch (e0) { id = ""; }
  if (!id) {
    try {
      if (place && place.name && String(place.name).indexOf("places/") === 0) { id = clean(place.name); }
    } catch (e1) {}
  }
  return id;
}




function diqV46TokenSet(v) {
  var raw = normText(v).split(" ");
  var out = [];
  var stop = " the a an and or of at by in on for cafe coffee bar grill restaurant restaurants llc inc co company shop store drive road rd street st avenue ave west east north south ";
  var i;
  var w;
  for (i = 0; i < raw.length; i++) {
    w = raw[i];
    if (!w || w.length < 2) { continue; }
    if (stop.indexOf(" " + w + " ") > -1) { continue; }
    if (out.join(" ").indexOf(w) < 0) { out.push(w); }
  }
  return out;
}




function diqV46NameScore(a, b) {
  var an = normText(a);
  var bn = normText(b);
  var at;
  var bt;
  var hits = 0;
  var i;
  if (!an || !bn) { return 0; }
  if (an === bn) { return 160; }
  if (an.indexOf(bn) > -1 || bn.indexOf(an) > -1) { return 115; }
  at = diqV46TokenSet(an);
  bt = diqV46TokenSet(bn);
  for (i = 0; i < at.length; i++) {
    if (bt.join(" ").indexOf(at[i]) > -1) { hits += 1; }
  }
  if (hits && Math.max(at.length, bt.length) > 0) {
    return Math.round((hits / Math.max(at.length, bt.length)) * 95) + (hits * 8);
  }
  try {
    if (an.split(" ")[0] && bn.indexOf(an.split(" ")[0]) > -1) { return 20; }
    if (bn.split(" ")[0] && an.indexOf(bn.split(" ")[0]) > -1) { return 20; }
  } catch (e0) {}
  return 0;
}




function diqV46PlaceLatLng(place) {
  var loc;
  try { loc = place && (place.location || (place.geometry && place.geometry.location)); } catch (e0) { loc = null; }
  if (!loc) { return null; }
  try {
    if (finite(Number(loc.latitude)) && finite(Number(loc.longitude))) { return { lat:Number(loc.latitude), lng:Number(loc.longitude) }; }
  } catch (e1) {}
  try {
    if (finite(Number(loc.lat)) && finite(Number(loc.lng))) { return { lat:Number(loc.lat), lng:Number(loc.lng) }; }
  } catch (e2) {}
  try {
    if (typeof loc.lat === "function" && typeof loc.lng === "function") { return { lat:Number(loc.lat()), lng:Number(loc.lng()) }; }
  } catch (e3) {}
  return null;
}




function diqV46DistanceScore(place, item) {
  var ll = diqV46PlaceLatLng(place);
  var d;
  if (!ll || !item || !finite(Number(item.lat)) || !finite(Number(item.lng))) { return { score:0, miles:null }; }
  try { d = miles(Number(item.lat), Number(item.lng), Number(ll.lat), Number(ll.lng)); } catch (e0) { d = null; }
  if (!finite(Number(d))) { return { score:0, miles:null }; }
  if (d <= 0.08) { return { score:150, miles:d }; }
  if (d <= 0.25) { return { score:115, miles:d }; }
  if (d <= 0.65) { return { score:82, miles:d }; }
  if (d <= 1.25) { return { score:50, miles:d }; }
  if (d <= 2.5) { return { score:25, miles:d }; }
  if (d <= 5.0) { return { score:8, miles:d }; }
  return { score:Math.max(-85, -Math.round(d * 10)), miles:d };
}




function diqV46CategoryScore(place, item, query) {
  var text = normText(String(place && place.types ? place.types.join(" ") : "") + " " + diqV46PlaceName(place) + " " + String(query || activeLens || "") + " " + String(item && item.category || ""));
  var cat = normText(adventurePrimaryCategory(item, query || activeLens) || "");
  var score = 0;
  if (!text && !cat) { return 0; }
  if (cat.indexOf("coffee") > -1 || text.indexOf("coffee") > -1) {
    if (/coffee|cafe|espresso|bakery|breakfast|restaurant|food|store/.test(text)) { score += 45; }
  }
  if (cat.indexOf("food") > -1 || cat.indexOf("dining") > -1) {
    if (/restaurant|food|meal|cafe|bar|bakery|bbq|pizza|burger|taco/.test(text)) { score += 38; }
  }
  if (cat.indexOf("night") > -1 || cat.indexOf("music") > -1) {
    if (/bar|night|music|restaurant|pub|brewery|entertainment/.test(text)) { score += 35; }
  }
  return score;
}




function diqV46PhotoCount(place) {
  try { return place && place.photos && place.photos.length ? place.photos.length : 0; } catch (e0) { return 0; }
}




function diqV46ScoreGooglePhotoCandidate(place, item, query) {
  var name = diqV46PlaceName(place);
  var id = diqV46PlaceId(place);
  var photoCount = diqV46PhotoCount(place);
  var nameScore = diqV46NameScore(name, item && item.label || "");
  var distObj = diqV46DistanceScore(place, item);
  var catScore = diqV46CategoryScore(place, item, query || activeLens);
  var score = nameScore + distObj.score + catScore + (photoCount ? 80 : 0) + (id ? 20 : 0);
  return {
    place:place,
    id:id,
    name:name,
    photos:photoCount,
    distance:distObj.miles,
    nameScore:nameScore,
    categoryScore:catScore,
    score:score
  };
}




function diqV46AcceptGooglePhotoCandidate(c, item, query, reason) {
  var id;
  if (!c || !c.place || !item) { return false; }
  id = c.id || diqV46PlaceId(c.place);
  if (id) {
    item.googlePlaceId = item.googlePlaceId || id;
    item.placeId = item.placeId || id;
    item.google_place_id = item.google_place_id || id;
  }
  item.googleCandidateName = c.name || "";
  item.googleCandidateScore = c.score;
  item.googleCandidateDistance = finite(Number(c.distance)) ? Number(c.distance) : null;
  try {
    diqSetPhotoDebug(item, "v46-candidate-accepted", {
      status:id ? "ID:YES" : "ID:NO",
      msg:"local " + clean(item.label || "place") + " â†’ " + clean(c.name || "candidate"),
      details:"score " + String(Math.round(c.score || 0)) + " dist " + (finite(Number(c.distance)) ? String(Math.round(Number(c.distance) * 10) / 10) + "mi" : "na") + " photos " + String(c.photos || 0) + " " + clean(reason || "accepted"),
      photos:c.photos || 0,
      source:"Photo IQ V46"
    });
  } catch (e0) {}
  return !!id || !!(c.photos && c.photos > 0);
}




function diqV46BestGooglePhotoCandidate(places, item, query) {
  var best = null;
  var bestScore = -999999;
  var i;
  var c;
  for (i = 0; i < (places || []).length; i++) {
    if (!places[i]) { continue; }
    c = diqV46ScoreGooglePhotoCandidate(places[i], item, query || activeLens);
    if (!c.photos) { continue; }
    if (c.score > bestScore) { bestScore = c.score; best = c; }
  }
  if (!best) { return null; }




  /* Accept exact/near name matches, close distance matches, or any strong
     photo-backed local candidate. This fixes ID:NO when Google returns a
     good candidate whose name/address is not an exact Geoapify string. */
  if (best.score >= 85) { return best; }
  if (finite(Number(best.distance)) && Number(best.distance) <= 1.25 && best.score >= 45) { return best; }
  if (best.nameScore >= 55 && best.score >= 55) { return best; }
  return null;
}




/* Existing V42/V43 resolvers call this chooser. Override it so accepted
   candidates also write the Place ID back to the item for debug + Details. */
diqV42GoogleNewChoosePhotoPlace = function (places, item) {
  var c = diqV46BestGooglePhotoCandidate(places, item, activeLens);
  if (c) {
    diqV46AcceptGooglePhotoCandidate(c, item, activeLens, "chooser");
    return c.place;
  }
  try {
    if (item) {
      diqSetPhotoDebug(item, "v46-candidate-rejected", {
        status:"ID:NO",
        msg:"places " + String((places || []).length),
        details:"no accepted photo candidate",
        source:"Photo IQ V46"
      });
    }
  } catch (e0) {}
  return null;
};




function diqV46GoogleNewTextSearchPhotoResolver(item, query, done) {
  var key = diqGooglePlacesApiKey();
  var qList;
  var qIndex = 0;
  var loc;
  if (!item || !key || !window.fetch) { done([]); return; }




  qList = diqPhotoSearchQueryVariants(item, query || activeLens);
  if (!qList.length && item.label) { qList = [clean(item.label)]; }




  if (finite(Number(item.lat)) && finite(Number(item.lng))) {
    loc = { latitude:Number(item.lat), longitude:Number(item.lng) };
  }




  function tryNext() {
    var q;
    var body;
    if (qIndex >= qList.length) {
      try { diqSetPhotoDebug(item, "v46-search-empty", { status:"ID:NO", msg:"candidate search exhausted", source:"Photo IQ V46" }); } catch (e0) {}
      done([]);
      return;
    }




    q = qList[qIndex];
    qIndex += 1;
    body = { textQuery:q, maxResultCount:10 };
    if (loc) { body.locationBias = { circle:{ center:loc, radius:16000 } }; }




    try { diqSetPhotoDebug(item, "v46-search", { status:"search", msg:q, source:"Photo IQ V46" }); } catch (e1) {}




    try {
      fetch("https://places.googleapis.com/v1/places:searchText", {
        method:"POST",
        credentials:"omit",
        cache:"no-store",
        headers:{
          "Content-Type":"application/json",
          "X-Goog-Api-Key":key,
          "X-Goog-FieldMask":"places.id,places.name,places.displayName,places.formattedAddress,places.types,places.location,places.photos.name,places.photos.widthPx,places.photos.heightPx,places.photos.authorAttributions"
        },
        body:JSON.stringify(body)
      })
        .then(function (res) { return res && res.ok ? res.json() : null; })
        .then(function (data) {
          var places = data && data.places ? data.places : [];
          var c = diqV46BestGooglePhotoCandidate(places, item, query || activeLens);
          var photos = [];
          var id;
          if (!c) { tryNext(); return; }




          diqV46AcceptGooglePhotoCandidate(c, item, query || activeLens, "search " + String(qIndex));
          id = c.id || diqV46PlaceId(c.place);
          photos = diqV43PhotoObjectsToList(c.place, item, query || activeLens, "Photo IQ V46");




          if (photos && photos.length) {
            try { diqSetPhotoDebug(item, "v46-url-ready", { status:"URL:YES", msg:c.name || "candidate", details:"score " + String(Math.round(c.score || 0)), url:photos[0].url, photos:c.photos || photos.length, source:"Photo IQ V46" }); } catch (e2) {}
            done(photos);
            return;
          }




          if (id) {
            diqGoogleNewPlaceDetails(id, item, query || activeLens, function (detailPhotos) {
              if (detailPhotos && detailPhotos.length) { done(detailPhotos); return; }
              tryNext();
            });
            return;
          }




          tryNext();
        })
        .catch(function () { tryNext(); });
    } catch (e3) { tryNext(); }
  }




  tryNext();
}




/* Make V46 the New resolver. Details still wins when an item already has a
   true Google id, but ID:NO results now go through the candidate resolver. */
diqGooglePlacesNewPhotoResolver = function (item, query, done) {
  var placeId = diqGooglePlaceIdFromItem(item);




  if (!diqGooglePlacesApiKey()) {
    try { diqSetPhotoDebug(item, "v46-needs-key", { status:"needs key", source:"Photo IQ V46" }); } catch (e0) {}
    done([]);
    return;
  }




  function runSearch() {
    diqV46GoogleNewTextSearchPhotoResolver(item, query || activeLens, done);
  }




  if (placeId && (String(placeId).indexOf("ChIJ") === 0 || String(placeId).indexOf("places/") === 0)) {
    diqGoogleNewPlaceDetails(placeId, item, query || activeLens, function (detailsPhotos) {
      if (detailsPhotos && detailsPhotos.length) { done(detailsPhotos); return; }
      runSearch();
    });
    return;
  }




  runSearch();
};




/* Add candidate diagnostics to the visible Photo Debug IQ details line. */
var diqV46OriginalDebugData = diqV39DebugData;
diqV39DebugData = function (item, query, stage) {
  var d = diqV46OriginalDebugData(item, query || activeLens, stage || "debug");
  if (item && item.googleCandidateName) {
    d.details = clean(String(d.details || "") + " cand:" + String(item.googleCandidateName || "") + " score:" + String(Math.round(Number(item.googleCandidateScore || 0))));
  }
  return d;
};




try { console.log("âœ… Drive IQ V46 Photo Place Resolver IQ loaded"); } catch (e) {}








/* =========================================================
   DRIVE IQ V47 â€” PHOTO ID HANDOFF IQ
   V46 proved the stack is close but can still show ID:NO / URL:NO even when
   a Google photo-backed candidate exists. V47 makes the candidate handoff
   stricter in the right place and looser in the right place:
   - Normalize both Places New resource IDs and ChIJ IDs.
   - Persist every useful ID alias back onto the item.
   - Use direct candidate photos immediately before falling back to Details.
   - Show visible resolver diagnostics: candidate, score, distance, ID state,
     and accept/reject reason.
   ES5-safe.
========================================================= */




var DIQ_V47_PHOTO_ID_HANDOFF_ON = true;




function diqV47NormalizeGooglePlaceId(value) {
  var v = clean(value || "");
  if (!v) { return ""; }
  if (v.indexOf("https://places.googleapis.com/v1/places/") === 0) {
    v = v.replace(/^https:\/\/places\.googleapis\.com\/v1\/places\//, "");
    v = v.split("/")[0].split("?")[0];
  }
  if (v.indexOf("places/") === 0) { v = v.replace(/^places\//, ""); }
  v = v.split("/")[0].split("?")[0];
  return clean(v);
}




function diqV47PlaceResourceName(place) {
  var r = "";
  try { r = clean(place && place.name || ""); } catch (e0) { r = ""; }
  if (r.indexOf("places/") === 0) { return r; }
  try {
    if (place && place.id) { return "places/" + clean(place.id); }
  } catch (e1) {}
  return "";
}




function diqV47CandidateId(place) {
  var id = "";
  try { id = clean(place && (place.id || place.place_id || place.placeId || "")); } catch (e0) { id = ""; }
  if (!id) {
    try { id = diqV47NormalizeGooglePlaceId(place && place.name); } catch (e1) { id = ""; }
  }
  return clean(id);
}




/* Upgrade the V46 ID reader without changing the rest of the scoring system. */
diqV46PlaceId = function (place) {
  return diqV47CandidateId(place);
};




function diqV47PersistCandidateIdentity(item, place, c, reason) {
  var id;
  var resource;
  if (!item || !place) { return ""; }
  id = diqV47CandidateId(place);
  resource = diqV47PlaceResourceName(place);




  if (id) {
    item.googlePlaceId = id;
    item.placeId = id;
    item.google_place_id = id;
    item.place_id = id;
  }
  if (resource) {
    item.googlePlaceResourceName = resource;
    item.googlePlaceName = resource;
  }
  if (c) {
    item.googleCandidateName = c.name || diqV46PlaceName(place) || "";
    item.googleCandidateScore = c.score;
    item.googleCandidateDistance = finite(Number(c.distance)) ? Number(c.distance) : null;
    item.googleCandidatePhotos = c.photos || diqV46PhotoCount(place) || 0;
    item.googleCandidateReason = clean(reason || "accepted");
  }
  return id;
}




function diqV47CandidateDebug(item, stage, c, status, reason, url) {
  var dist = "na";
  var msg = "";
  var details = "";
  try {
    if (c && finite(Number(c.distance))) { dist = String(Math.round(Number(c.distance) * 10) / 10) + "mi"; }
    msg = (c && c.name ? clean(c.name) : "candidate") + " score " + String(Math.round(Number(c && c.score || 0)));
    details = "id " + (c && c.id ? "yes" : "no") + " dist " + dist + " photos " + String(c && c.photos || 0) + " " + clean(reason || "");
    diqSetPhotoDebug(item, stage || "v47-candidate", {
      status:status || (c && c.id ? "ID:YES" : "ID:NO"),
      msg:msg,
      details:details,
      url:url || "",
      photos:c && c.photos || 0,
      source:"Photo IQ V47"
    });
  } catch (e0) {}
}




var diqV47OriginalAcceptGooglePhotoCandidate = diqV46AcceptGooglePhotoCandidate;
diqV46AcceptGooglePhotoCandidate = function (c, item, query, reason) {
  var id;
  var ok;
  if (!c || !c.place || !item) { return false; }
  id = diqV47PersistCandidateIdentity(item, c.place, c, reason || "accepted");
  ok = diqV47OriginalAcceptGooglePhotoCandidate ? diqV47OriginalAcceptGooglePhotoCandidate(c, item, query || activeLens, reason || "accepted") : false;
  diqV47CandidateDebug(item, "v47-candidate-accepted", c, id ? "ID:YES" : "ID:NO", reason || "accepted", "");
  return !!id || ok || !!(c.photos && c.photos > 0);
};




function diqV47TextSearchPhotoResolver(item, query, done) {
  var key = diqGooglePlacesApiKey();
  var qList;
  var qIndex = 0;
  var loc;
  if (!item || !key || !window.fetch) { done([]); return; }




  qList = diqPhotoSearchQueryVariants(item, query || activeLens);
  if (!qList.length && item.label) { qList = [clean(item.label)]; }
  if (finite(Number(item.lat)) && finite(Number(item.lng))) { loc = { latitude:Number(item.lat), longitude:Number(item.lng) }; }




  function tryNext() {
    var q;
    var body;
    if (qIndex >= qList.length) {
      try { diqSetPhotoDebug(item, "v47-search-empty", { status:"ID:NO", msg:"candidate search exhausted", details:"no accepted Google photo candidate", source:"Photo IQ V47" }); } catch (e0) {}
      done([]);
      return;
    }




    q = qList[qIndex];
    qIndex += 1;
    body = { textQuery:q, maxResultCount:10 };
    if (loc) { body.locationBias = { circle:{ center:loc, radius:18000 } }; }




    try { diqSetPhotoDebug(item, "v47-search", { status:"search", msg:q, source:"Photo IQ V47" }); } catch (e1) {}




    try {
      fetch("https://places.googleapis.com/v1/places:searchText", {
        method:"POST",
        credentials:"omit",
        cache:"no-store",
        headers:{
          "Content-Type":"application/json",
          "X-Goog-Api-Key":key,
          "X-Goog-FieldMask":"places.id,places.name,places.displayName,places.formattedAddress,places.types,places.location,places.photos.name,places.photos.widthPx,places.photos.heightPx,places.photos.authorAttributions"
        },
        body:JSON.stringify(body)
      })
        .then(function (res) { return res && res.ok ? res.json() : null; })
        .then(function (data) {
          var places = data && data.places ? data.places : [];
          var c = diqV46BestGooglePhotoCandidate(places, item, query || activeLens);
          var photos = [];
          var id = "";
          if (!c) { tryNext(); return; }




          id = diqV47PersistCandidateIdentity(item, c.place, c, "search " + String(qIndex));
          diqV46AcceptGooglePhotoCandidate(c, item, query || activeLens, "search " + String(qIndex));




          /* Most important V47 change: direct candidate photos win before Details.
             If Google already returned photos.name, do not wait for another API hop. */
          photos = diqV43PhotoObjectsToList(c.place, item, query || activeLens, "Photo IQ V47 Candidate");
          if (photos && photos.length) {
            diqV47CandidateDebug(item, "v47-url-ready", c, "URL:YES", "direct candidate photo", photos[0].url);
            done(photos);
            return;
          }




          if (id) {
            diqGoogleNewPlaceDetails(id, item, query || activeLens, function (detailPhotos) {
              if (detailPhotos && detailPhotos.length) {
                try { diqSetPhotoDebug(item, "v47-details-url-ready", { status:"URL:YES", msg:c.name || "candidate details", details:"id yes", url:detailPhotos[0].url, photos:detailPhotos.length, source:"Photo IQ V47" }); } catch (e2) {}
                done(detailPhotos);
                return;
              }
              diqV47CandidateDebug(item, "v47-candidate-no-url", c, id ? "ID:YES" : "ID:NO", "accepted but no media URL", "");
              tryNext();
            });
            return;
          }




          diqV47CandidateDebug(item, "v47-candidate-no-id", c, "ID:NO", "photo candidate missing id", "");
          tryNext();
        })
        .catch(function () { tryNext(); });
    } catch (e3) { tryNext(); }
  }




  tryNext();
}




/* V47 owns the New resolver so ID:NO cards use the strengthened handoff. */
diqGooglePlacesNewPhotoResolver = function (item, query, done) {
  var placeId = diqGooglePlaceIdFromItem(item);
  if (!diqGooglePlacesApiKey()) {
    try { diqSetPhotoDebug(item, "v47-needs-key", { status:"needs key", source:"Photo IQ V47" }); } catch (e0) {}
    done([]);
    return;
  }




  function runSearch() { diqV47TextSearchPhotoResolver(item, query || activeLens, done); }




  placeId = diqV47NormalizeGooglePlaceId(placeId);
  if (placeId) {
    diqGoogleNewPlaceDetails(placeId, item, query || activeLens, function (detailsPhotos) {
      if (detailsPhotos && detailsPhotos.length) { done(detailsPhotos); return; }
      runSearch();
    });
    return;
  }




  runSearch();
};




var diqV47OriginalDebugData = diqV39DebugData;
diqV39DebugData = function (item, query, stage) {
  var d = diqV47OriginalDebugData(item, query || activeLens, stage || "debug");
  var extra = "";
  if (item && item.googleCandidateName) {
    extra = " cand:" + clean(item.googleCandidateName || "") + " score:" + String(Math.round(Number(item.googleCandidateScore || 0)));
    if (item.googleCandidateReason) { extra += " " + clean(item.googleCandidateReason); }
    d.details = clean(String(d.details || "") + extra);
  }
  if (item && (item.googlePlaceId || item.placeId || item.google_place_id || item.place_id)) { d.placeId = true; }
  return d;
};




try { console.log("âœ… Drive IQ V47 Photo ID Handoff IQ loaded"); } catch (e) {}












/* =========================================================
   DRIVE IQ V48 â€” PHOTO CANDIDATE PAYLOAD IQ
   Current debug: Key:YES / Places:YES / ID:NO / Photos:1 / URL:NO.
   That means Google is answering, but the accepted candidate id/resource is
   not making it back onto the card. V48 makes Places New first, captures
   candidate id/name/resource fields aggressively, exposes the candidate in
   Photo Debug, and builds the URL directly from candidate photos.
   ES5-safe.
========================================================= */




var DIQ_V48_PHOTO_CANDIDATE_PAYLOAD_ON = true;




function diqV48CleanIdText(v) {
  v = clean(v);
  if (!v) { return ""; }
  if (v.indexOf("places/") === 0) {
    v = v.replace(/^places\//, "");
    v = v.replace(/\/photos\/.*$/, "");
  }
  return clean(v);
}




function diqV48ResourceNameFromPlace(place) {
  var v;
  if (!place) { return ""; }
  v = clean(place.name || place.resourceName || place.place || place.placeResourceName || "");
  if (v.indexOf("places/") === 0) { return v.replace(/\/photos\/.*$/, ""); }
  return "";
}




function diqV48IdFromPlace(place) {
  var id;
  if (!place) { return ""; }
  id = clean(place.id || place.place_id || place.placeId || place.googlePlaceId || "");
  if (id) { return diqV48CleanIdText(id); }
  id = diqV48ResourceNameFromPlace(place);
  if (id) { return diqV48CleanIdText(id); }
  return "";
}




function diqV48PersistPlaceIdentity(item, place, reason) {
  var id;
  var resource;
  var name;
  if (!item || !place) { return ""; }
  id = diqV48IdFromPlace(place);
  resource = diqV48ResourceNameFromPlace(place);
  name = "";
  try { name = diqGoogleNewPlaceDisplayName(place); } catch (e0) { name = clean(place.displayName && (place.displayName.text || place.displayName) || place.name || ""); }




  if (id) {
    item.googlePlaceId = id;
    item.google_place_id = id;
    item.placeId = id;
    item.place_id = id;
  }
  if (resource) {
    item.googlePlaceResource = resource;
    item.google_place_resource = resource;
  }
  item.googleCandidateName = clean(name || item.googleCandidateName || "");
  item.googleCandidateId = id || item.googleCandidateId || "";
  item.googleCandidateResource = resource || item.googleCandidateResource || "";
  item.googleCandidateReason = clean(reason || item.googleCandidateReason || "v48");
  return id;
}




var diqV48OriginalGooglePlaceIdFromItem = diqGooglePlaceIdFromItem;
diqGooglePlaceIdFromItem = function (item) {
  var id;
  var raw;
  if (!item) { return ""; }
  id = "";
  try { id = diqV48CleanIdText(item.googlePlaceId || item.google_place_id || item.placeId || item.place_id || item.googleCandidateId || ""); } catch (e0) { id = ""; }
  if (id) { return id; }
  try { id = diqV48CleanIdText(item.googlePlaceResource || item.google_place_resource || item.googleCandidateResource || ""); } catch (e1) { id = ""; }
  if (id) { return id; }
  raw = item.raw || item.properties || item.datasourceRaw || null;
  if (raw) {
    try { id = diqV48CleanIdText(raw.id || raw.name || raw.placeId || raw.place_id || raw.googlePlaceId || raw.google_place_id || ""); } catch (e2) { id = ""; }
    if (id) { return id; }
    try {
      if (raw.datasource && raw.datasource.raw) {
        raw = raw.datasource.raw;
        id = diqV48CleanIdText(raw.id || raw.name || raw.placeId || raw.place_id || raw.googlePlaceId || raw.google_place_id || "");
        if (id) { return id; }
      }
    } catch (e3) {}
  }
  try { id = diqV48OriginalGooglePlaceIdFromItem ? diqV48OriginalGooglePlaceIdFromItem(item) : ""; } catch (e4) { id = ""; }
  return diqV48CleanIdText(id);
};




function diqV48PhotoResourceFromAny(v, placeResource, depth) {
  var k;
  var r;
  var i;
  var s;
  if (!v || depth > 5) { return ""; }
  if (typeof v === "string") {
    s = clean(v);
    if (s.indexOf("places/") === 0 && s.indexOf("/photos/") > -1) { return s; }
    if (s.indexOf("photos/") === 0 && placeResource) { return clean(placeResource).replace(/\/$/, "") + "/" + s; }
    return "";
  }
  if (v.length && typeof v !== "string") {
    for (i = 0; i < v.length; i++) {
      r = diqV48PhotoResourceFromAny(v[i], placeResource, depth + 1);
      if (r) { return r; }
    }
    return "";
  }
  if (typeof v !== "object") { return ""; }
  r = diqV48PhotoResourceFromAny(v.name || v.photoName || v.resourceName || v.photoResourceName || v.mediaResourceName, placeResource, depth + 1);
  if (r) { return r; }
  for (k in v) {
    if (!v.hasOwnProperty(k)) { continue; }
    if (!/(photo|media|resource|name)/i.test(k)) { continue; }
    r = diqV48PhotoResourceFromAny(v[k], placeResource, depth + 1);
    if (r) { return r; }
  }
  return "";
}




function diqV48PhotoUriFromAny(v, depth) {
  var k;
  var r;
  var i;
  var s;
  if (!v || depth > 5) { return ""; }
  if (typeof v === "string") {
    s = clean(v);
    if (diqLooksLikeImageUrl(s)) { return s; }
    return "";
  }
  if (v.length && typeof v !== "string") {
    for (i = 0; i < v.length; i++) {
      r = diqV48PhotoUriFromAny(v[i], depth + 1);
      if (r) { return r; }
    }
    return "";
  }
  if (typeof v !== "object") { return ""; }
  r = clean(v.photoUri || v.uri || v.url || v.src || v.mediaUrl || v.imageUrl || "");
  if (r && diqLooksLikeImageUrl(r)) { return r; }
  for (k in v) {
    if (!v.hasOwnProperty(k)) { continue; }
    if (!/(photo|media|uri|url|image|src)/i.test(k)) { continue; }
    r = diqV48PhotoUriFromAny(v[k], depth + 1);
    if (r) { return r; }
  }
  return "";
}




function diqV48PhotoObjectsToList(place, item, query, source) {
  var out = [];
  var photos = place && place.photos ? place.photos : [];
  var resource = diqV48ResourceNameFromPlace(place);
  var i;
  var url;
  var res;
  var uri;
  var label;
  var raw;
  if (!photos || !photos.length) { return out; }
  try {
    raw = diqShortPhotoRaw(photos[0]);
    item.googlePhotoRaw = raw;
    diqSetPhotoDebug(item, "v48-photo-raw", { status:"raw", msg:raw, details:raw, photos:photos.length, source:source || "Photo IQ V48" });
  } catch (rawErr) {}
  for (i = 0; i < photos.length && i < 8; i++) {
    url = "";
    try {
      if (photos[i] && typeof photos[i].getUrl === "function") {
        url = photos[i].getUrl({ maxWidth:1200, maxHeight:900 });
      }
    } catch (legacyErr) { url = ""; }
    if (!url) {
      res = diqV48PhotoResourceFromAny(photos[i], resource, 0);
      uri = diqV48PhotoUriFromAny(photos[i], 0);
      if (res) { url = diqGoogleNewPhotoMediaUrl(res, 1200); }
      if (!url && uri) { url = uri; }
    }
    label = i === 0 ? diqIntentPhotoLabel(item, query || activeLens) : "Google Place Photo";
    if (url) { diqAddUniquePhoto(out, url, label, "google_v48"); }
  }
  return out;
}




function diqV48CandidateLabel(place) {
  var name = "";
  try { name = diqGoogleNewPlaceDisplayName(place); } catch (e0) {}
  if (!name) { name = clean(place && place.displayName && (place.displayName.text || place.displayName) || place && place.name || "candidate"); }
  return name;
}




function diqV48CandidateSummary(places, item) {
  var out = [];
  var i;
  var p;
  var name;
  var id;
  var ph;
  if (!places || !places.length) { return "candidates:0"; }
  for (i = 0; i < places.length && i < 3; i++) {
    p = places[i];
    name = diqV48CandidateLabel(p);
    id = diqV48IdFromPlace(p) ? "id:y" : "id:n";
    ph = p && p.photos && p.photos.length ? String(p.photos.length) : "0";
    out.push(String(i + 1) + ":" + name + " " + id + " ph:" + ph);
  }
  return out.join(" | ");
}




function diqV48ChooseCandidate(places, item, query) {
  var best = null;
  var bestScore = -999999;
  var i;
  var c;
  var p;
  var score;
  if (!places || !places.length) { return null; }
  for (i = 0; i < places.length; i++) {
    p = places[i];
    if (!p) { continue; }
    try { c = diqV46ScoreGooglePhotoCandidate(p, item, query || activeLens); }
    catch (e0) { c = null; }
    if (!c) {
      c = { place:p, name:diqV48CandidateLabel(p), id:diqV48IdFromPlace(p), score:0, photos:p && p.photos ? p.photos.length : 0 };
    }
    score = Number(c.score || 0);
    if (p.photos && p.photos.length) { score += 60; }
    if (diqV48IdFromPlace(p)) { score += 35; }
    if (score > bestScore) { bestScore = score; best = c; }
  }
  if (!best) { return null; }
  best.score = bestScore;
  best.id = best.id || diqV48IdFromPlace(best.place);
  best.name = best.name || diqV48CandidateLabel(best.place);
  best.photos = best.photos || (best.place && best.place.photos ? best.place.photos.length : 0);
  return best;
}




function diqV48DetailsById(id, item, query, done) {
  id = diqV48CleanIdText(id);
  if (!id) { done([]); return; }
  diqGoogleNewPlaceDetails(id, item, query || activeLens, function (detailPhotos) {
    if (detailPhotos && detailPhotos.length) { done(detailPhotos); }
    else { done([]); }
  });
}




function diqV48TextSearchPhotoResolver(item, query, done) {
  var key = diqGooglePlacesApiKey();
  var loc;
  var qList;
  var qIndex = 0;
  if (!item || !finite(Number(item.lat)) || !finite(Number(item.lng)) || !key || !window.fetch) { done([]); return; }
  loc = { latitude:Number(item.lat), longitude:Number(item.lng) };
  qList = diqPhotoSearchQueryVariants(item, query || activeLens);
  diqSetPhotoDebug(item, "v48-start", { status:"V48 search", details:"candidate payload", source:"Photo IQ V48" });




  function tryNext() {
    var q;
    var body;
    if (qIndex >= qList.length) {
      diqSetPhotoDebug(item, "v48-empty", { status:"ID:NO", details:"candidate search exhausted", msg:item.googleCandidatePayload || "no candidates", source:"Photo IQ V48" });
      done([]);
      return;
    }
    q = qList[qIndex];
    qIndex += 1;
    body = {
      textQuery:q,
      maxResultCount:10,
      locationBias:{ circle:{ center:loc, radius:9000 } }
    };
    try {
      fetch("https://places.googleapis.com/v1/places:searchText", {
        method:"POST",
        credentials:"omit",
        cache:"no-store",
        headers:{
          "Content-Type":"application/json",
          "X-Goog-Api-Key":key,
          "X-Goog-FieldMask":"places.id,places.name,places.displayName,places.formattedAddress,places.location,places.types,places.photos,places.photos.name,places.photos.photoUri,places.photos.authorAttributions"
        },
        body:JSON.stringify(body)
      })
        .then(function (res) { return res && res.ok ? res.json() : null; })
        .then(function (data) {
          var places = data && data.places ? data.places : [];
          var summary = diqV48CandidateSummary(places, item);
          var c;
          var id;
          var photos;
          item.googleCandidatePayload = summary;
          diqSetPhotoDebug(item, "v48-candidates", { status:"candidates", msg:summary, details:summary, photos:places && places.length ? places.length : 0, source:"Photo IQ V48" });
          if (!places || !places.length) { tryNext(); return; }
          c = diqV48ChooseCandidate(places, item, query || activeLens);
          if (!c || !c.place) { tryNext(); return; }
          id = diqV48PersistPlaceIdentity(item, c.place, "v48 accepted score " + String(Math.round(Number(c.score || 0))));
          item.googleCandidateScore = Number(c.score || 0);
          item.googleCandidatePhotos = c.photos || 0;
          diqSetPhotoDebug(item, "v48-accepted", { status:id ? "ID:YES" : "ID:NO", msg:c.name || "candidate", details:"score " + String(Math.round(Number(c.score || 0))) + " photos " + String(c.photos || 0), photos:c.photos || 0, source:"Photo IQ V48" });
          photos = diqV48PhotoObjectsToList(c.place, item, query || activeLens, "Photo IQ V48 Candidate");
          if (photos && photos.length) {
            diqSetPhotoDebug(item, "v48-url-ready", { status:"URL:YES", msg:c.name || "candidate", details:"direct candidate id " + (id ? "yes" : "no"), url:photos[0].url, photos:photos.length, source:"Photo IQ V48" });
            done(photos);
            return;
          }
          if (id) {
            diqV48DetailsById(id, item, query || activeLens, function (detailPhotos) {
              if (detailPhotos && detailPhotos.length) {
                diqSetPhotoDebug(item, "v48-details-url", { status:"URL:YES", msg:c.name || "details", details:"details id yes", url:detailPhotos[0].url, photos:detailPhotos.length, source:"Photo IQ V48" });
                done(detailPhotos);
                return;
              }
              diqSetPhotoDebug(item, "v48-no-url", { status:"URL:NO", msg:c.name || "candidate", details:"accepted id but no usable photo url", photos:c.photos || 0, source:"Photo IQ V48" });
              tryNext();
            });
            return;
          }
          diqSetPhotoDebug(item, "v48-no-id", { status:"ID:NO", msg:c.name || "candidate", details:"candidate has photos but no id/name resource", photos:c.photos || 0, source:"Photo IQ V48" });
          tryNext();
        })
        .catch(function () {
          diqSetPhotoDebug(item, "v48-fetch-fail", { status:"search fail", msg:q, source:"Photo IQ V48" });
          tryNext();
        });
    } catch (e1) { tryNext(); }
  }
  tryNext();
}




/* V48 owns the Places New resolver and makes it the first-class photo path. */
diqGooglePlacesNewPhotoResolver = function (item, query, done) {
  var placeId = diqGooglePlaceIdFromItem(item);
  if (!diqGooglePlacesApiKey()) {
    diqSetPhotoDebug(item, "v48-needs-key", { status:"needs key", source:"Photo IQ V48" });
    done([]);
    return;
  }
  placeId = diqV48CleanIdText(placeId);
  if (placeId) {
    diqV48DetailsById(placeId, item, query || activeLens, function (detailsPhotos) {
      if (detailsPhotos && detailsPhotos.length) { done(detailsPhotos); return; }
      diqV48TextSearchPhotoResolver(item, query || activeLens, done);
    });
    return;
  }
  diqV48TextSearchPhotoResolver(item, query || activeLens, done);
};




/* Make the hydrate order match the current bug: try Places New before legacy JS.
   Legacy JS can report Places:YES while still leaving ID:NO; V48 wants the raw
   candidate payload first. */
var diqV48OriginalHydratePlacePhotos = diqHydratePlacePhotos;
diqHydratePlacePhotos = function (item, query) {
  var key;
  var cache;
  if (!item) { return; }
  query = query || activeLens;
  key = diqPhotoCacheKey(item);
  if (!key) { return; }
  diqPhotoHydrateLastKey = key;
  if (diqUseCachedPhotos(item, query)) { item.photoStatus = item.photoSource || "Photo IQ Cache"; return; }
  if (diqPhotoHydrateActive[key]) { return; }
  diqPhotoHydrateActive[key] = true;
  diqSetPhotoDebug(item, "v48-hydrate-start", { status:diqGooglePlacesApiKey() ? "key yes" : "needs key", details:"new resolver first", source:"Photo IQ V48" });
  item.photoStatus = item.photoDebugShort || "Photo IQ V48 Searching";
  try { diqApplyPlaceGallery(item, query); } catch (e0) {}




  function finish(photos, source) {
    var applied;
    if (!photos || !photos.length) { return false; }
    applied = diqApplyResolvedPhotosToItem(item, photos, query, source);
    if (applied) {
      diqSetPhotoDebug(item, "v48-photo-loaded", { status:"URL:YES", source:source || "Photo IQ V48", url:photos[0] && photos[0].url ? photos[0].url : "", photos:photos.length });
      item.photoStatus = clean(source || "Photo IQ V48 Loaded");
      cache = diqLoadPhotoCache();
      cache[key] = { photos:item.photos || photos, ts:Date.now(), source:source || "Photo IQ V48" };
      diqSavePhotoCache(cache);
      if (diqPhotoHydrateLastKey === key) {
        try { diqApplyPlaceGallery(item, query); } catch (e1) {}
        try { diqRefreshAdventurePhotoThumb(item, query); } catch (e2) {}
        try { toast("Photo IQ loaded"); } catch (e3) {}
      }
      return true;
    }
    return false;
  }




  if (finish(diqGoogleDirectPhotoCandidates(item, query), "Google Photo Reference")) { diqPhotoHydrateActive[key] = false; return; }




  diqFetchResolverPhotos(item, query, function (resolverPhotos) {
    if (finish(resolverPhotos, "Official Photo IQ")) { diqPhotoHydrateActive[key] = false; return; }




    diqGooglePlacesNewPhotoResolver(item, query, function (googleNewPhotos) {
      if (finish(googleNewPhotos, "Google Places New Photo")) { diqPhotoHydrateActive[key] = false; return; }




      diqGooglePlacesPhotoResolver(item, query, function (googlePhotos) {
        if (!finish(googlePhotos, "Google Place Photo")) {
          diqSetPhotoDebug(item, "v48-all-sources-empty", { status:diqGooglePlacesApiKey() ? "URL:NO" : "needs key", source:"Photo IQ V48", msg:item.googleCandidatePayload || "no usable Google photo URL", details:item.googleCandidatePayload || "all sources empty" });
          item.photoStatus = item.photoDebugShort || (diqGooglePlacesApiKey() ? "Photo IQ No Photos" : "Photo IQ Needs Key");
          if (diqPhotoHydrateLastKey === key) { try { diqApplyPlaceGallery(item, query); } catch (e4) {} }
        }
        diqPhotoHydrateActive[key] = false;
      });
    });
  });
};




var diqV48OriginalDebugData = diqV39DebugData;
diqV39DebugData = function (item, query, stage) {
  var d = diqV48OriginalDebugData(item, query || activeLens, stage || "debug");
  var detail = "";
  if (item) {
    if (item.googleCandidatePayload) { detail += " cand:" + clean(item.googleCandidatePayload); }
    else if (item.googleCandidateName) { detail += " cand:" + clean(item.googleCandidateName); }
    if (item.googleCandidateId) { detail += " id:y"; }
    if (item.googleCandidateScore) { detail += " score:" + String(Math.round(Number(item.googleCandidateScore || 0))); }
    if (item.googlePhotoRaw) { detail += " raw:" + clean(item.googlePhotoRaw); }
  }
  if (detail) { d.details = clean(String(d.details || "") + " " + detail); }
  if (item && diqGooglePlaceIdFromItem(item)) { d.placeId = true; }
  return d;
};




try { console.log("âœ… Drive IQ V48 Photo Candidate Payload IQ loaded"); } catch (e) {}








/* =========================================================
   DRIVE IQ V49 â€” PHOTO NEARBY RESCUE IQ
   V48 screenshot proved Places New Text Search can return candidates:0
   while the card still has a valid local place/pin and Photo IQ is active.
   V49 adds a category-aware Nearby Search rescue around the card pin.
   This gives Adventure cards a real Google Place candidate even when the
   exact local name string is weak, stale, abbreviated, or not matched by
   Text Search.
   ES5-safe.
========================================================= */




var DIQ_V49_PHOTO_NEARBY_RESCUE_ON = true;




function diqV49CategoryHint(item, query) {
  var txt = normText(String(query || activeLens || "") + " " + String(item && item.category || "") + " " + String(item && item.label || "") + " " + String(item && item.full || ""));
  var cat = normText(adventurePrimaryCategory(item, query || activeLens) || "");
  txt = txt + " " + cat;
  if (/coffee|cafe|espresso|roaster|latte/.test(txt)) { return "coffee"; }
  if (/pizza|bbq|burger|taco|seafood|food|restaurant|dining|breakfast|brunch|lunch|dinner/.test(txt)) { return "food"; }
  if (/bar|night|pub|brewery|cocktail|music|karaoke|trivia|lounge/.test(txt)) { return "nightlife"; }
  if (/shop|retail|boutique|market|store/.test(txt)) { return "shopping"; }
  if (/park|trail|scenic|outdoor|lake|water|camp/.test(txt)) { return "outdoor"; }
  return "local";
}




function diqV49NearbyTypeSets(item, query) {
  var hint = diqV49CategoryHint(item, query || activeLens);
  if (hint === "coffee") { return [["cafe"],["bakery"],["restaurant"],[]]; }
  if (hint === "food") { return [["restaurant"],["cafe"],["bakery"],["bar"],[]]; }
  if (hint === "nightlife") { return [["bar"],["restaurant"],["night_club"],[]]; }
  if (hint === "shopping") { return [["store"],["shopping_mall"],[]]; }
  if (hint === "outdoor") { return [["park"],["tourist_attraction"],[]]; }
  return [["restaurant"],["cafe"],["tourist_attraction"],[]];
}




function diqV49NearbyCandidateSummary(places) {
  var out = [];
  var i;
  var p;
  var name;
  var id;
  var ph;
  if (!places || !places.length) { return "nearby:0"; }
  for (i = 0; i < places.length && i < 3; i++) {
    p = places[i];
    name = diqV48CandidateLabel(p);
    id = diqV48IdFromPlace(p) ? "id:y" : "id:n";
    ph = p && p.photos && p.photos.length ? String(p.photos.length) : "0";
    out.push(String(i + 1) + ":" + name + " " + id + " ph:" + ph);
  }
  return out.join(" | ");
}




function diqV49ChooseNearbyCandidate(places, item, query) {
  var best = null;
  var bestScore = -999999;
  var i;
  var p;
  var c;
  var score;
  var dist;
  if (!places || !places.length) { return null; }




  for (i = 0; i < places.length; i++) {
    p = places[i];
    if (!p) { continue; }
    try { c = diqV46ScoreGooglePhotoCandidate(p, item, query || activeLens); }
    catch (e0) { c = null; }
    if (!c) {
      c = { place:p, name:diqV48CandidateLabel(p), id:diqV48IdFromPlace(p), score:0, photos:p && p.photos ? p.photos.length : 0, distance:null };
    }




    score = Number(c.score || 0);
    if (p.photos && p.photos.length) { score += 95; }
    if (diqV48IdFromPlace(p)) { score += 45; }




    dist = c.distance;
    if (finite(Number(dist))) {
      if (Number(dist) <= 0.12) { score += 110; }
      else if (Number(dist) <= 0.35) { score += 85; }
      else if (Number(dist) <= 0.8) { score += 55; }
      else if (Number(dist) <= 1.6) { score += 25; }
      else { score -= Math.round(Number(dist) * 8); }
    }




    if (score > bestScore) {
      bestScore = score;
      best = c;
    }
  }




  if (!best) { return null; }
  best.score = bestScore;
  best.id = best.id || diqV48IdFromPlace(best.place);
  best.name = best.name || diqV48CandidateLabel(best.place);
  best.photos = best.photos || (best.place && best.place.photos ? best.place.photos.length : 0);




  /* Nearby rescue exists to avoid candidates:0 dead ends. Still require
     some local confidence: either a photo-backed candidate very close by,
     a strong score, or usable Google identity plus category/location signal. */
  if (best.score >= 110) { return best; }
  if (best.photos && finite(Number(best.distance)) && Number(best.distance) <= 1.25) { return best; }
  if (best.id && best.photos && best.score >= 80) { return best; }
  return null;
}




function diqV49NearbySearchPhotoResolver(item, query, done) {
  var key = diqGooglePlacesApiKey();
  var loc;
  var typeSets;
  var typeIndex = 0;




  if (!item || !finite(Number(item.lat)) || !finite(Number(item.lng)) || !key || !window.fetch) {
    done([]);
    return;
  }




  loc = { latitude:Number(item.lat), longitude:Number(item.lng) };
  typeSets = diqV49NearbyTypeSets(item, query || activeLens);
  try { diqSetPhotoDebug(item, "v49-nearby-start", { status:"nearby", msg:diqV49CategoryHint(item, query || activeLens), details:"candidate nearby rescue", source:"Photo IQ V49" }); } catch (e0) {}




  function tryNextType() {
    var types;
    var body;
    if (typeIndex >= typeSets.length) {
      try { diqSetPhotoDebug(item, "v49-nearby-empty", { status:"ID:NO", msg:item.googleNearbyCandidatePayload || "nearby:0", details:"nearby exhausted", source:"Photo IQ V49" }); } catch (e1) {}
      done([]);
      return;
    }




    types = typeSets[typeIndex];
    typeIndex += 1;
    body = {
      maxResultCount:10,
      locationRestriction:{ circle:{ center:loc, radius:6500 } }
    };
    if (types && types.length) { body.includedTypes = types; }




    try {
      fetch("https://places.googleapis.com/v1/places:searchNearby", {
        method:"POST",
        credentials:"omit",
        cache:"no-store",
        headers:{
          "Content-Type":"application/json",
          "X-Goog-Api-Key":key,
          "X-Goog-FieldMask":"places.id,places.name,places.displayName,places.formattedAddress,places.location,places.types,places.photos,places.photos.name,places.photos.photoUri,places.photos.authorAttributions"
        },
        body:JSON.stringify(body)
      })
        .then(function (res) { return res && res.ok ? res.json() : null; })
        .then(function (data) {
          var places = data && data.places ? data.places : [];
          var summary = diqV49NearbyCandidateSummary(places);
          var c;
          var id;
          var photos;




          item.googleNearbyCandidatePayload = summary;
          try { diqSetPhotoDebug(item, "v49-nearby-candidates", { status:"nearby", msg:summary, details:summary, photos:places.length || 0, source:"Photo IQ V49" }); } catch (e2) {}




          if (!places || !places.length) { tryNextType(); return; }




          c = diqV49ChooseNearbyCandidate(places, item, query || activeLens);
          if (!c || !c.place) { tryNextType(); return; }




          id = diqV48PersistPlaceIdentity(item, c.place, "v49 nearby score " + String(Math.round(Number(c.score || 0))));
          item.googleCandidateScore = Number(c.score || 0);
          item.googleCandidatePhotos = c.photos || 0;
          item.googleCandidateName = c.name || item.googleCandidateName || "";
          item.googleCandidateReason = "v49 nearby";




          try { diqSetPhotoDebug(item, "v49-nearby-accepted", { status:id ? "ID:YES" : "ID:NO", msg:c.name || "nearby", details:"score " + String(Math.round(Number(c.score || 0))) + " photos " + String(c.photos || 0), photos:c.photos || 0, source:"Photo IQ V49" }); } catch (e3) {}




          photos = diqV48PhotoObjectsToList(c.place, item, query || activeLens, "Photo IQ V49 Nearby");
          if (photos && photos.length) {
            try { diqSetPhotoDebug(item, "v49-nearby-url", { status:"URL:YES", msg:c.name || "nearby", details:"direct nearby candidate", url:photos[0].url, photos:photos.length, source:"Photo IQ V49" }); } catch (e4) {}
            done(photos);
            return;
          }




          if (id) {
            diqV48DetailsById(id, item, query || activeLens, function (detailPhotos) {
              if (detailPhotos && detailPhotos.length) {
                try { diqSetPhotoDebug(item, "v49-nearby-details-url", { status:"URL:YES", msg:c.name || "details", details:"nearby details id yes", url:detailPhotos[0].url, photos:detailPhotos.length, source:"Photo IQ V49" }); } catch (e5) {}
                done(detailPhotos);
                return;
              }
              tryNextType();
            });
            return;
          }




          tryNextType();
        })
        .catch(function () {
          try { diqSetPhotoDebug(item, "v49-nearby-fetch-fail", { status:"nearby fail", msg:(types && types.length ? types.join(",") : "all"), source:"Photo IQ V49" }); } catch (e6) {}
          tryNextType();
        });
    } catch (e7) { tryNextType(); }
  }




  tryNextType();
}




/* V49 keeps V48 Text Search first for exact matches, then rescues with
   category-aware Nearby Search when Text Search returns candidates:0. */
diqGooglePlacesNewPhotoResolver = function (item, query, done) {
  var placeId = diqGooglePlaceIdFromItem(item);




  if (!diqGooglePlacesApiKey()) {
    try { diqSetPhotoDebug(item, "v49-needs-key", { status:"needs key", source:"Photo IQ V49" }); } catch (e0) {}
    done([]);
    return;
  }




  function runTextThenNearby() {
    diqV48TextSearchPhotoResolver(item, query || activeLens, function (textPhotos) {
      if (textPhotos && textPhotos.length) { done(textPhotos); return; }
      diqV49NearbySearchPhotoResolver(item, query || activeLens, done);
    });
  }




  placeId = diqV48CleanIdText(placeId);
  if (placeId) {
    diqV48DetailsById(placeId, item, query || activeLens, function (detailsPhotos) {
      if (detailsPhotos && detailsPhotos.length) { done(detailsPhotos); return; }
      runTextThenNearby();
    });
    return;
  }




  runTextThenNearby();
};




var diqV49OriginalDebugData = diqV39DebugData;
diqV39DebugData = function (item, query, stage) {
  var d = diqV49OriginalDebugData(item, query || activeLens, stage || "debug");
  var detail = "";
  if (item) {
    if (item.googleNearbyCandidatePayload) { detail += " nearby:" + clean(item.googleNearbyCandidatePayload); }
    if (item.googleCandidateReason) { detail += " " + clean(item.googleCandidateReason); }
    if (item.googleCandidateId || item.googlePlaceId || item.placeId) { d.placeId = true; }
  }
  if (detail) { d.details = clean(String(d.details || "") + detail); }
  return d;
};




try { console.log("âœ… Drive IQ V49 Photo Nearby Rescue IQ loaded"); } catch (e) {}








/* =========================================================
   DRIVE IQ V51 â€” PHOTO CANDIDATE ACCEPTANCE IQ
   V50 showed the remaining live failure can still be:
   Key:YES / Places:YES / ID:NO / Photos:1 / URL:NO with
   cand:candidates:0 and nearby:0. That means the image renderer is not
   the blocker; the Google candidate query is too narrow or location-biased.




   V51 adds a broader Places New resolver before legacy fallback:
   - expands query variants with city/category terms and no-bias attempts
   - accepts reasonable name/category/distance candidates instead of exact text
   - persists the accepted Google ID immediately
   - tries direct photos first, then Details by accepted ID
   - adds visible candidate diagnostics without repaint looping
   ES5-safe.
========================================================= */




var DIQ_V51_PHOTO_CANDIDATE_ACCEPTANCE_ON = true;




function diqV51TokenSet(text) {
  var raw = normText(text || "").split(" ");
  var out = [];
  var i;
  var w;
  for (i = 0; i < raw.length; i++) {
    w = raw[i];
    if (!w || w.length < 3) { continue; }
    if (/^(the|and|for|with|near|road|street|avenue|drive|lane|west|east|north|south|usa|united|states)$/.test(w)) { continue; }
    out.push(w);
  }
  return out;
}




function diqV51NameSimilarity(a, b) {
  var aa = diqV51TokenSet(a);
  var bb = diqV51TokenSet(b);
  var hit = 0;
  var i;
  var j;
  if (!aa.length || !bb.length) { return 0; }
  for (i = 0; i < aa.length; i++) {
    for (j = 0; j < bb.length; j++) {
      if (aa[i] === bb[j] || aa[i].indexOf(bb[j]) === 0 || bb[j].indexOf(aa[i]) === 0) { hit += 1; break; }
    }
  }
  return Math.round((hit / Math.max(aa.length, bb.length)) * 100);
}




function diqV51CityHint(item) {
  var txt = clean(String(item && item.full || "") + " " + String(item && item.address || "") + " " + String(item && item.formattedAddress || ""));
  var parts;
  var i;
  var p;
  if (!txt) { return ""; }
  parts = txt.split(",");
  for (i = 0; i < parts.length; i++) {
    p = clean(parts[i]);
    if (!p) { continue; }
    if (/\b(MS|TN|AR|AL|LA|GA|FL|TX|MO|KY)\b/i.test(p) && i > 0) { return clean(parts[i - 1]); }
  }
  if (/memphis/i.test(txt)) { return "Memphis"; }
  if (/bartlett/i.test(txt)) { return "Bartlett"; }
  if (/southaven/i.test(txt)) { return "Southaven"; }
  if (/horn lake/i.test(txt)) { return "Horn Lake"; }
  if (/hernando/i.test(txt)) { return "Hernando"; }
  if (/oxford/i.test(txt)) { return "Oxford"; }
  return "";
}




function diqV51CategoryWords(item, query) {
  var hint = "";
  try { hint = diqV49CategoryHint ? diqV49CategoryHint(item, query || activeLens) : ""; } catch (e0) { hint = ""; }
  if (hint === "coffee") { return ["coffee", "cafe", "espresso", "roaster", "bakery"]; }
  if (hint === "food") { return ["restaurant", "food", "dining", "cafe"]; }
  if (hint === "nightlife") { return ["bar", "pub", "music", "restaurant"]; }
  if (hint === "shopping") { return ["store", "shop", "boutique", "market"]; }
  return [clean(adventurePrimaryCategory(item, query || activeLens) || "local")];
}




function diqV51ExpandedPhotoQueries(item, query) {
  var out = [];
  var name = clean(item && item.label || "");
  var full = clean(item && item.full || "");
  var city = diqV51CityHint(item);
  var cats = diqV51CategoryWords(item, query || activeLens);
  var i;
  function add(v) {
    var n;
    var x;
    if (!v) { return; }
    x = clean(v).replace(/\s+/g, " ");
    n = normText(x);
    if (!n || n.length < 3) { return; }
    for (var j = 0; j < out.length; j++) { if (normText(out[j]) === n) { return; } }
    out.push(x);
  }
  add(name + (city ? " " + city : ""));
  add(name + (city ? " " + city + " TN" : ""));
  add(name + " Memphis TN");
  add(name + " Bartlett TN");
  add(name);
  for (i = 0; i < cats.length; i++) {
    add(name + " " + cats[i]);
    if (city) { add(name + " " + cats[i] + " " + city); }
  }
  if (full) { add(name + " " + full.split(",").slice(0, 2).join(" ")); }
  if (!name && query) { add(query); }
  return out.slice(0, 12);
}




var diqV51OriginalPhotoSearchQueryVariants = diqPhotoSearchQueryVariants;
diqPhotoSearchQueryVariants = function (item, query) {
  var base = [];
  var expanded = [];
  var i;
  function add(v) {
    var n = normText(v);
    if (!n) { return; }
    for (var j = 0; j < expanded.length; j++) { if (normText(expanded[j]) === n) { return; } }
    expanded.push(clean(v));
  }
  try { base = diqV51OriginalPhotoSearchQueryVariants ? diqV51OriginalPhotoSearchQueryVariants(item, query || activeLens) : []; } catch (e0) { base = []; }
  for (i = 0; i < base.length; i++) { add(base[i]); }
  base = diqV51ExpandedPhotoQueries(item, query || activeLens);
  for (i = 0; i < base.length; i++) { add(base[i]); }
  return expanded.slice(0, 14);
};




function diqV51CandidateTypeFit(place, item, query) {
  var types = "";
  var cat = "";
  var hint = "";
  try { types = normText((place && place.types ? place.types.join(" ") : "") + " " + diqV48CandidateLabel(place)); } catch (e0) { types = ""; }
  try { hint = diqV49CategoryHint ? diqV49CategoryHint(item, query || activeLens) : ""; } catch (e1) { hint = ""; }
  cat = normText(adventurePrimaryCategory(item, query || activeLens) || "");
  if (hint === "coffee" || cat.indexOf("coffee") > -1) { return /(cafe|coffee|bakery|restaurant|food|store)/.test(types); }
  if (hint === "food" || cat.indexOf("food") > -1) { return /(restaurant|food|cafe|bakery|bar|meal)/.test(types); }
  if (hint === "nightlife") { return /(bar|night_club|restaurant|pub|food)/.test(types); }
  if (hint === "shopping") { return /(store|shopping|market|clothing|retail)/.test(types); }
  return true;
}




function diqV51ScoreCandidate(place, item, query) {
  var name = diqV48CandidateLabel(place);
  var local = clean(item && item.label || "");
  var sim = diqV51NameSimilarity(name, local);
  var score = sim;
  var ll;
  var dist = null;
  var photos = 0;
  var id = "";
  try { photos = place && place.photos ? place.photos.length : 0; } catch (e0) { photos = 0; }
  try { id = diqV48IdFromPlace(place); } catch (e1) { id = ""; }
  try { ll = diqGoogleNewPlaceLatLng(place); } catch (e2) { ll = null; }
  if (ll && finite(Number(item && item.lat)) && finite(Number(item && item.lng))) {
    dist = miles(Number(item.lat), Number(item.lng), Number(ll.lat), Number(ll.lng));
    if (finite(Number(dist))) {
      if (dist <= 0.15) { score += 55; }
      else if (dist <= 0.4) { score += 40; }
      else if (dist <= 1.0) { score += 24; }
      else if (dist <= 2.5) { score += 8; }
      else { score -= Math.round(Number(dist) * 4); }
    }
  }
  if (photos) { score += 45; }
  if (id) { score += 25; }
  if (diqV51CandidateTypeFit(place, item, query || activeLens)) { score += 25; }
  return { place:place, name:name, id:id, photos:photos, score:score, similarity:sim, distance:dist };
}




function diqV51ChooseCandidate(places, item, query) {
  var best = null;
  var bestScore = -999999;
  var i;
  var c;
  for (i = 0; i < (places || []).length; i++) {
    c = diqV51ScoreCandidate(places[i], item, query || activeLens);
    if (c.score > bestScore) { bestScore = c.score; best = c; }
  }
  if (!best) { return null; }
  /* This is intentionally looser than V48/V49. If Google gives us a nearby,
     category-correct, photo-backed candidate, accept it and let Details/photo
     loading prove it. */
  if (best.score >= 70) { return best; }
  if (best.id && best.photos && best.similarity >= 35) { return best; }
  if (best.photos && finite(Number(best.distance)) && Number(best.distance) <= 0.75) { return best; }
  return null;
}




function diqV51CandidateSummary(places, item, query) {
  var out = [];
  var i;
  var c;
  if (!places || !places.length) { return "v51:0"; }
  for (i = 0; i < places.length && i < 3; i++) {
    c = diqV51ScoreCandidate(places[i], item, query || activeLens);
    out.push(String(i + 1) + ":" + clean(c.name).slice(0, 26) + " s:" + String(Math.round(c.score)) + " sim:" + String(c.similarity) + " id:" + (c.id ? "y" : "n") + " ph:" + String(c.photos));
  }
  return out.join(" | ");
}




function diqV51FetchSearchText(item, query, useBias, done) {
  var key = diqGooglePlacesApiKey();
  var loc = null;
  var qList = diqV51ExpandedPhotoQueries(item, query || activeLens);
  var qIndex = 0;
  if (!item || !key || !window.fetch) { done([]); return; }
  if (finite(Number(item.lat)) && finite(Number(item.lng))) { loc = { latitude:Number(item.lat), longitude:Number(item.lng) }; }
  if (!qList.length) { done([]); return; }




  function tryNext() {
    var q;
    var body;
    if (qIndex >= qList.length) { done([]); return; }
    q = qList[qIndex];
    qIndex += 1;
    body = { textQuery:q, maxResultCount:20 };
    if (useBias && loc) { body.locationBias = { circle:{ center:loc, radius:30000 } }; }
    try { diqSetPhotoDebug(item, "v51-search", { status:"search", msg:q, details:useBias ? "biased" : "no-bias", source:"Photo IQ V51" }); } catch (e0) {}
    try {
      fetch("https://places.googleapis.com/v1/places:searchText", {
        method:"POST",
        credentials:"omit",
        cache:"no-store",
        headers:{
          "Content-Type":"application/json",
          "X-Goog-Api-Key":key,
          "X-Goog-FieldMask":"places.id,places.name,places.displayName,places.formattedAddress,places.location,places.types,places.rating,places.userRatingCount,places.photos,places.photos.name,places.photos.photoUri,places.photos.authorAttributions,places.googleMapsUri"
        },
        body:JSON.stringify(body)
      })
        .then(function (res) { return res && res.ok ? res.json() : null; })
        .then(function (data) {
          var places = data && data.places ? data.places : [];
          var summary = diqV51CandidateSummary(places, item, query || activeLens);
          var c;
          var id;
          var photos;
          item.googleV51CandidatePayload = summary;
          try { diqSetPhotoDebug(item, "v51-candidates", { status:"candidates", msg:summary, details:summary, photos:places.length || 0, source:"Photo IQ V51" }); } catch (e1) {}
          if (!places || !places.length) { tryNext(); return; }
          c = diqV51ChooseCandidate(places, item, query || activeLens);
          if (!c || !c.place) { tryNext(); return; }
          id = diqV48PersistPlaceIdentity(item, c.place, "v51 score " + String(Math.round(Number(c.score || 0))) + " sim " + String(c.similarity));
          item.googleCandidateName = c.name || item.googleCandidateName || "";
          item.googleCandidateScore = Number(c.score || 0);
          item.googleCandidatePhotos = c.photos || 0;
          item.googleCandidateReason = "v51 sim:" + String(c.similarity) + " score:" + String(Math.round(Number(c.score || 0)));
          try { diqSetPhotoDebug(item, "v51-accepted", { status:id ? "ID:YES" : "ID:NO", msg:c.name || "candidate", details:item.googleCandidateReason, photos:c.photos || 0, source:"Photo IQ V51" }); } catch (e2) {}
          photos = diqV48PhotoObjectsToList(c.place, item, query || activeLens, "Photo IQ V51 Candidate");
          if (photos && photos.length) {
            try { diqSetPhotoDebug(item, "v51-url-ready", { status:"URL:YES", msg:c.name || "candidate", details:"direct candidate", url:photos[0].url, photos:photos.length, source:"Photo IQ V51" }); } catch (e3) {}
            done(photos);
            return;
          }
          if (id) {
            diqV48DetailsById(id, item, query || activeLens, function (detailPhotos) {
              if (detailPhotos && detailPhotos.length) {
                try { diqSetPhotoDebug(item, "v51-details-url", { status:"URL:YES", msg:c.name || "details", details:"details id yes", url:detailPhotos[0].url, photos:detailPhotos.length, source:"Photo IQ V51" }); } catch (e4) {}
                done(detailPhotos);
                return;
              }
              tryNext();
            });
            return;
          }
          tryNext();
        })
        .catch(function () { tryNext(); });
    } catch (e5) { tryNext(); }
  }
  tryNext();
}




function diqV51BroadCandidateResolver(item, query, done) {
  if (!diqGooglePlacesApiKey()) { done([]); return; }
  diqV51FetchSearchText(item, query || activeLens, true, function (biasedPhotos) {
    if (biasedPhotos && biasedPhotos.length) { done(biasedPhotos); return; }
    diqV51FetchSearchText(item, query || activeLens, false, function (globalPhotos) {
      if (globalPhotos && globalPhotos.length) { done(globalPhotos); return; }
      try { diqSetPhotoDebug(item, "v51-empty", { status:"ID:NO", msg:item.googleV51CandidatePayload || "v51:0", details:"broad candidate exhausted", source:"Photo IQ V51" }); } catch (e0) {}
      done([]);
    });
  });
}




var diqV51OriginalGooglePlacesNewPhotoResolver = diqGooglePlacesNewPhotoResolver;
diqGooglePlacesNewPhotoResolver = function (item, query, done) {
  var placeId = "";
  if (!item) { done([]); return; }
  try { placeId = diqV48CleanIdText(diqGooglePlaceIdFromItem(item)); } catch (e0) { placeId = ""; }




  function afterBroad(photos) {
    if (photos && photos.length) { done(photos); return; }
    /* Preserve V49 nearby rescue after V51 broad text, because it can still
       win when Google has weak text names but correct nearby category data. */
    try {
      if (typeof diqV49NearbySearchPhotoResolver === "function") {
        diqV49NearbySearchPhotoResolver(item, query || activeLens, done);
        return;
      }
    } catch (nearErr) {}
    done([]);
  }




  if (!diqGooglePlacesApiKey()) { done([]); return; }




  if (placeId) {
    diqV48DetailsById(placeId, item, query || activeLens, function (detailPhotos) {
      if (detailPhotos && detailPhotos.length) { done(detailPhotos); return; }
      diqV51BroadCandidateResolver(item, query || activeLens, afterBroad);
    });
    return;
  }




  diqV51BroadCandidateResolver(item, query || activeLens, afterBroad);
};




var diqV51OriginalDebugData = diqV39DebugData;
diqV39DebugData = function (item, query, stage) {
  var d = diqV51OriginalDebugData(item, query || activeLens, stage || "debug");
  var detail = "";
  if (item) {
    if (item.googleV51CandidatePayload) { detail += " v51:" + clean(item.googleV51CandidatePayload); }
    if (item.googleCandidateReason) { detail += " " + clean(item.googleCandidateReason); }
    if (item.googleCandidateId || item.googlePlaceId || item.placeId) { d.placeId = true; }
  }
  if (detail) { d.details = clean(String(d.details || "") + detail); }
  return d;
};




try { console.log("âœ… Drive IQ V51 Photo Candidate Acceptance IQ loaded"); } catch (e) {}








/* =========================================================
   DRIVE IQ V52 â€” PHOTO STREET VIEW RESCUE IQ
   When Google Places is alive but Text Search/Nearby return zero candidates,
   stop showing the satellite map as the hero. Business photos still win first.
   If both Places New and legacy Places fail, use Google Street View Static as
   a real-world visual fallback for the Place IQ card.
========================================================= */




function diqV52StreetViewPhotoUrl(item) {
  var key = "";
  var lat;
  var lng;
  if (!item || !finite(Number(item.lat)) || !finite(Number(item.lng))) { return ""; }
  try { key = diqGooglePlacesApiKey ? diqGooglePlacesApiKey() : ""; } catch (e0) { key = ""; }
  if (!key) { return ""; }
  lat = Number(item.lat);
  lng = Number(item.lng);
  return "https://maps.googleapis.com/maps/api/streetview?size=640x360&location=" +
    encodeURIComponent(String(lat) + "," + String(lng)) +
    "&fov=82&pitch=0&source=outdoor&key=" + encodeURIComponent(key);
}




function diqV52StreetViewPhotos(item, query) {
  var url = diqV52StreetViewPhotoUrl(item);
  if (!url) { return []; }
  return [{
    url:url,
    label:"Street View Rescue",
    kind:"streetview",
    priority:8,
    source:"Google Street View"
  }];
}




var diqV52OriginalGooglePlacesPhotoResolver = diqGooglePlacesPhotoResolver;
diqGooglePlacesPhotoResolver = function (item, query, done) {
  if (!item) { done([]); return; }




  try {
    diqV52OriginalGooglePlacesPhotoResolver(item, query || activeLens, function (photos) {
      var rescue;
      if (photos && photos.length) {
        done(photos);
        return;
      }




      rescue = diqV52StreetViewPhotos(item, query || activeLens);
      if (rescue && rescue.length) {
        try {
          diqSetPhotoDebug(item, "v52-streetview-rescue", {
            status:"URL:YES",
            msg:"street view rescue",
            details:"Places candidates empty; using real-world visual",
            url:rescue[0].url,
            photos:1,
            source:"Photo IQ V52"
          });
        } catch (e1) {}
        item.googleV52StreetViewRescue = true;
        done(rescue);
        return;
      }




      try {
        diqSetPhotoDebug(item, "v52-no-visual", {
          status:"URL:NO",
          msg:"no street view rescue",
          details:"no Google key or invalid coordinates",
          source:"Photo IQ V52"
        });
      } catch (e2) {}
      done([]);
    });
  } catch (e3) {
    done(diqV52StreetViewPhotos(item, query || activeLens));
  }
};




var diqV52OriginalDebugData = diqV39DebugData;
diqV39DebugData = function (item, query, stage) {
  var d = diqV52OriginalDebugData(item, query || activeLens, stage || "debug");
  if (item && item.googleV52StreetViewRescue) {
    d.urlOk = true;
    d.render = d.render && d.render !== "FALLBACK" ? d.render : "STREETVIEW";
    d.img = d.img && d.img !== "FALLBACK" ? d.img : "WAIT";
    d.details = clean(String(d.details || "") + " v52:streetview");
  }
  return d;
};




try { console.log("âœ… Drive IQ V52 Photo Street View Rescue IQ loaded"); } catch (e) {}








/* =========================================================
   DRIVE IQ V53 â€” PHOTO RAW HANDOFF IQ
   Current field test is ID:YES / Photos:1 / URL:NO. That means Google
   found a place and a photo-like payload, but the final media URL is not
   surviving. V53 stops guessing and exposes the raw photo payload while
   rebuilding a media URL from every known Places New field. It also puts
   Street View fallback directly inside the Places New resolver path.
========================================================= */




function diqV53PhotoRawSnippet(v) {
  var s;
  try { s = JSON.stringify(v || {}); } catch (e0) { s = String(v || ""); }
  s = clean(s).replace(/AIza[0-9A-Za-z_\-]{20,}/g, "AIzaâ€¦masked");
  if (s.length > 150) { s = s.slice(0, 150) + "â€¦"; }
  return s;
}




function diqV53FirstPhotoObject(place) {
  try {
    if (place && place.photos && place.photos.length) { return place.photos[0]; }
  } catch (e0) {}
  return null;
}




function diqV53ExtractPhotoName(v, depth) {
  var k;
  var r;
  var i;
  if (!v || depth > 5) { return ""; }
  if (typeof v === "string") {
    v = clean(v);
    if (v.indexOf("places/") === 0 && v.indexOf("/photos/") > -1) { return v; }
    if (v.indexOf("photos/") === 0) { return v; }
    if (v.indexOf("/photos/") > -1) { return v; }
    return "";
  }
  if (v.length && typeof v !== "string") {
    for (i = 0; i < v.length; i++) {
      r = diqV53ExtractPhotoName(v[i], depth + 1);
      if (r) { return r; }
    }
    return "";
  }
  if (typeof v !== "object") { return ""; }
  r = diqV53ExtractPhotoName(
    v.name || v.photoName || v.resourceName || v.photoResourceName ||
    v.googlePhotoName || v.mediaResource || v.photo_reference || v.photoReference || v.reference,
    depth + 1
  );
  if (r) { return r; }
  for (k in v) {
    if (!v.hasOwnProperty(k)) { continue; }
    if (!/(photo|media|resource|name|reference)/i.test(k)) { continue; }
    r = diqV53ExtractPhotoName(v[k], depth + 1);
    if (r) { return r; }
  }
  return "";
}




function diqV53ExtractDirectPhotoUrl(v, depth) {
  var k;
  var r;
  var i;
  if (!v || depth > 5) { return ""; }
  if (typeof v === "string") {
    v = clean(v);
    if (diqLooksLikeImageUrl(v)) { return v; }
    return "";
  }
  if (v.length && typeof v !== "string") {
    for (i = 0; i < v.length; i++) {
      r = diqV53ExtractDirectPhotoUrl(v[i], depth + 1);
      if (r) { return r; }
    }
    return "";
  }
  if (typeof v !== "object") { return ""; }
  r = clean(v.photoUri || v.uri || v.url || v.src || v.mediaUrl || v.imageUrl || v.photoUrl || v.googlePhotoUrl || "");
  if (r && diqLooksLikeImageUrl(r)) { return r; }
  for (k in v) {
    if (!v.hasOwnProperty(k)) { continue; }
    if (!/(photo|media|uri|url|image|src)/i.test(k)) { continue; }
    r = diqV53ExtractDirectPhotoUrl(v[k], depth + 1);
    if (r) { return r; }
  }
  return "";
}




function diqV53GooglePhotoMediaUrlFromName(photoName, placeId) {
  var key;
  var resource;
  try { key = diqGooglePlacesApiKey ? diqGooglePlacesApiKey() : ""; } catch (e0) { key = ""; }
  photoName = clean(photoName);
  placeId = clean(placeId);
  if (!photoName || !key) { return ""; }
  try { resource = diqGoogleNormalizePhotoResourceName(photoName, placeId); } catch (e1) { resource = ""; }
  if (!resource && photoName.indexOf("places/") === 0 && photoName.indexOf("/photos/") > -1) { resource = photoName; }
  if (!resource && photoName.indexOf("photos/") === 0 && placeId) {
    try { resource = diqGoogleNormalizePlaceResourceId(placeId) + "/" + photoName; } catch (e2) { resource = ""; }
  }
  if (!resource) { return ""; }
  return "https://places.googleapis.com/v1/" + resource + "/media?maxWidthPx=1200&key=" + encodeURIComponent(key);
}




function diqV53PhotoObjectsToList(place, item, query, source) {
  var out = [];
  var photos = place && place.photos ? place.photos : [];
  var placeId = clean((place && (place.id || place.name || place.place_id || place.placeId)) || diqGooglePlaceIdFromItem(item) || "");
  var i;
  var p;
  var name;
  var uri;
  var url;
  var rawMsg = "";
  if (photos && photos.length) {
    p = photos[0];
    name = diqV53ExtractPhotoName(p, 0);
    uri = diqV53ExtractDirectPhotoUrl(p, 0);
    rawMsg = "raw:" + diqV53PhotoRawSnippet(p) + " name:" + (name ? "YES" : "NO") + " uri:" + (uri ? "YES" : "NO");
    try {
      diqSetPhotoDebug(item, "v53-photo-raw", {
        status:"raw photo",
        msg:rawMsg,
        source:source || "Photo IQ V53"
      });
    } catch (rawErr) {}
  }
  for (i = 0; i < photos.length && i < 8; i++) {
    p = photos[i];
    name = diqV53ExtractPhotoName(p, 0);
    uri = diqV53ExtractDirectPhotoUrl(p, 0);
    url = "";
    if (uri) { url = uri; }
    if (!url && name) { url = diqV53GooglePhotoMediaUrlFromName(name, placeId); }
    if (url) {
      diqAddUniquePhoto(out, url, i === 0 ? diqIntentPhotoLabel(item, query) : "Google Place Photo", "google_places_v53");
    }
  }
  if (out.length) {
    try { diqSetPhotoDebug(item, "v53-photo-url", { status:"URL:YES", msg:"built " + String(out.length), source:source || "Photo IQ V53" }); } catch (e3) {}
  } else if (photos && photos.length) {
    try { diqSetPhotoDebug(item, "v53-photo-url-miss", { status:"URL:NO", msg:rawMsg || "photos exist but no name/uri", source:source || "Photo IQ V53" }); } catch (e4) {}
  }
  return out;
}




var diqV53OriginalNewPhotoObjectsToList = diqGoogleNewPhotoObjectsToList;
diqGoogleNewPhotoObjectsToList = function (place, item, query) {
  var v53 = [];
  var old = [];
  try { v53 = diqV53PhotoObjectsToList(place, item, query || activeLens, "Places API New V53"); } catch (e0) { v53 = []; }
  if (v53 && v53.length) { return v53; }
  try { old = diqV53OriginalNewPhotoObjectsToList(place, item, query || activeLens); } catch (e1) { old = []; }
  return old || [];
};




var diqV53OriginalNewPlaceDetails = diqGoogleNewPlaceDetails;
diqGoogleNewPlaceDetails = function (placeId, item, query, done) {
  var key;
  var resource;
  var url;
  try { key = diqGooglePlacesApiKey ? diqGooglePlacesApiKey() : ""; } catch (e0) { key = ""; }
  if (!key || !placeId || !window.fetch) { diqV53OriginalNewPlaceDetails(placeId, item, query || activeLens, done); return; }
  try { resource = diqGoogleNormalizePlaceResourceId(placeId); } catch (e1) { resource = ""; }
  if (!resource) { diqV53OriginalNewPlaceDetails(placeId, item, query || activeLens, done); return; }
  url = "https://places.googleapis.com/v1/" + resource;
  try { diqSetPhotoDebug(item, "v53-details-request", { status:"ID:YES", msg:resource, source:"Photo IQ V53" }); } catch (dbg0) {}
  try {
    fetch(url, {
      method:"GET",
      credentials:"omit",
      cache:"no-store",
      headers:{
        "X-Goog-Api-Key":key,
        "X-Goog-FieldMask":"id,name,displayName,formattedAddress,location,photos,photos.name,photos.authorAttributions,photos.widthPx,photos.heightPx"
      }
    })
      .then(function (res) {
        if (!res || !res.ok) {
          try { diqSetPhotoDebug(item, "v53-details-http", { status:"HTTP:" + String(res && res.status || "NO"), source:"Photo IQ V53" }); } catch (dbg1) {}
          return null;
        }
        return res.json();
      })
      .then(function (data) {
        var photos = diqV53PhotoObjectsToList(data, item, query || activeLens, "Photo IQ V53 Details");
        var rawCount = data && data.photos && data.photos.length ? data.photos.length : 0;
        if (photos && photos.length) { done(photos); return; }
        try { diqSetPhotoDebug(item, "v53-details-empty", { status:"URL:NO", msg:"raw " + String(rawCount) + " urls 0", source:"Photo IQ V53" }); } catch (dbg2) {}
        done([]);
      })
      .catch(function () {
        try { diqSetPhotoDebug(item, "v53-details-fail", { status:"details fail", source:"Photo IQ V53" }); } catch (dbg3) {}
        done([]);
      });
  } catch (e2) {
    diqV53OriginalNewPlaceDetails(placeId, item, query || activeLens, done);
  }
};




var diqV53OriginalNewResolver = diqGooglePlacesNewPhotoResolver;
diqGooglePlacesNewPhotoResolver = function (item, query, done) {
  diqV53OriginalNewResolver(item, query || activeLens, function (photos) {
    var rescue;
    if (photos && photos.length) { done(photos); return; }
    try {
      rescue = diqV52StreetViewPhotos ? diqV52StreetViewPhotos(item, query || activeLens) : [];
    } catch (e0) { rescue = []; }
    if (rescue && rescue.length) {
      item.googleV53StreetViewDirect = true;
      try { diqSetPhotoDebug(item, "v53-streetview-direct", { status:"URL:YES", msg:"new resolver fallback", source:"Photo IQ V53" }); } catch (e1) {}
      done(rescue);
      return;
    }
    done([]);
  });
};




var diqV53OriginalDebugData = diqV39DebugData;
diqV39DebugData = function (item, query, stage) {
  var d = diqV53OriginalDebugData(item, query || activeLens, stage || "debug");
  if (item && item.googleV53StreetViewDirect) {
    d.urlOk = true;
    d.render = d.render && d.render !== "FALLBACK" ? d.render : "STREETVIEW";
    d.img = d.img && d.img !== "FALLBACK" ? d.img : "WAIT";
    d.details = clean(String(d.details || "") + " v53:streetview-direct");
  }
  if (item && item.photoDebug && item.photoDebug.msg && String(item.photoDebug.msg).indexOf("raw:") > -1) {
    d.details = clean(String(d.details || "") + " " + item.photoDebug.msg);
  }
  return d;
};




try { console.log("âœ… Drive IQ V53 Photo Raw Handoff IQ loaded"); } catch (e) {}








/* =========================================================
   DRIVE IQ V54 â€” PHOTO URL COMMIT IQ
   V53 proved the resolver can reach ID:YES / Photos:1 and even build a
   Street View direct rescue, but the older gallery filter still rejects
   maps.googleapis.com Street View URLs and may fail to persist returned
   photo URLs onto the visible card. V54 makes any trusted Google media URL
   a first-class card photo and paints it directly.
   ES5-safe.
========================================================= */




var DIQ_V54_PHOTO_URL_COMMIT_ON = true;




function diqV54IsTrustedGoogleVisual(url) {
  var u = clean(url || "");
  var low = u.toLowerCase();
  if (!u || u.indexOf("http") !== 0) { return false; }
  if (low.indexOf("maps.googleapis.com/maps/api/streetview") > -1) { return true; }
  if (low.indexOf("maps.googleapis.com/maps/api/place/photo") > -1) { return true; }
  if (low.indexOf("places.googleapis.com/v1/places/") > -1 && low.indexOf("/photos/") > -1 && low.indexOf("/media") > -1) { return true; }
  if (low.indexOf("googleusercontent.com") > -1 || low.indexOf("ggpht.com") > -1) { return true; }
  return false;
}




var diqV54OriginalV41LooksLikeImageUrl = typeof diqV41LooksLikeImageUrl === "function" ? diqV41LooksLikeImageUrl : null;
diqV41LooksLikeImageUrl = function (url) {
  if (diqV54IsTrustedGoogleVisual(url)) { return true; }
  return diqV54OriginalV41LooksLikeImageUrl ? diqV54OriginalV41LooksLikeImageUrl(url) : diqLooksLikeImageUrl(url);
};




diqLooksLikeImageUrl = function (url) {
  if (diqV54IsTrustedGoogleVisual(url)) { return true; }
  return diqV54OriginalV41LooksLikeImageUrl ? diqV54OriginalV41LooksLikeImageUrl(url) : false;
};




function diqV54CommitPhotoUrl(item, url, label, kind, source) {
  var p;
  if (!item || !url || !diqLooksLikeImageUrl(url)) { return false; }
  p = {
    url:String(url),
    label:clean(label || "Place Photo"),
    kind:clean(kind || "google_photo"),
    priority:1,
    source:clean(source || "Photo IQ V54")
  };
  item.photoUrl = String(url);
  item.googlePhotoUrl = String(url);
  if (kind === "google_places_new" || String(url).indexOf("places.googleapis.com/v1/") > -1) { item.googlePhotoMediaUrl = String(url); }
  if (kind === "streetview" || String(url).indexOf("maps.googleapis.com/maps/api/streetview") > -1) { item.googleStreetViewUrl = String(url); }
  item.photoSource = clean(source || "Photo IQ V54");
  item.photoStatus = "URL:YES";
  item.photoResolvedAt = Date.now();
  if (!item.photos || !item.photos.length) { item.photos = [p]; }
  else {
    try { item.photos.unshift(p); } catch (e0) { item.photos = [p]; }
  }
  try {
    diqSetPhotoDebug(item, "v54-url-commit", {
      status:"URL:YES",
      msg:clean(kind || "google visual"),
      details:"committed direct card photo",
      url:String(url),
      photos:item.photos && item.photos.length ? item.photos.length : 1,
      source:source || "Photo IQ V54"
    });
  } catch (e1) {}
  return true;
}




var diqV54OriginalStreetViewPhotos = typeof diqV52StreetViewPhotos === "function" ? diqV52StreetViewPhotos : null;
diqV52StreetViewPhotos = function (item, query) {
  var list = diqV54OriginalStreetViewPhotos ? diqV54OriginalStreetViewPhotos(item, query || activeLens) : [];
  if (list && list.length && list[0] && list[0].url) {
    diqV54CommitPhotoUrl(item, list[0].url, "Street View", "streetview", "Google Street View");
  }
  return list || [];
};




var diqV54OriginalBuildPlaceGallery = diqBuildPlaceGallery;
diqBuildPlaceGallery = function (item, query) {
  var out = [];
  var list;
  var i;
  if (item) {
    diqAddUniquePhoto(out, item.googlePhotoMediaUrl, "Google Place Photo", "google_places_new");
    diqAddUniquePhoto(out, item.googlePhotoUrl, "Google Place Photo", "google_places");
    diqAddUniquePhoto(out, item.googleStreetViewUrl, "Street View", "streetview");
    diqAddUniquePhoto(out, item.photoUrl, diqIntentPhotoLabel(item, query || activeLens), item.photoSource || "photo");
    try {
      list = item.photos || [];
      for (i = 0; i < list.length; i++) {
        if (list[i] && list[i].url && list[i].kind !== "map") { diqAddUniquePhoto(out, list[i].url, list[i].label || "Place Photo", list[i].kind || "photo"); }
      }
    } catch (e0) {}
  }
  if (out.length) { return out.slice(0, 6); }
  return diqV54OriginalBuildPlaceGallery(item, query || activeLens);
};




var diqV54OriginalApplyPlaceGallery = diqApplyPlaceGallery;
diqApplyPlaceGallery = function (item, query) {
  var photo = byId("diqAdvInfoPhoto");
  var hint = byId("diqPhotoHint");
  var gallery;
  var p;
  var cls;
  var out;




  try { gallery = diqBuildPlaceGallery(item, query || activeLens); } catch (e0) { gallery = []; }
  p = gallery && gallery.length ? gallery[0] : null;




  if (p && p.url && diqV54IsTrustedGoogleVisual(p.url)) {
    cls = categoryPhotoClass(item, query || activeLens) || "local";
    if (photo) {
      photo.className = "diqAdvPhoto " + cls + " realPhoto photoLive";
      photo.setAttribute("style", "background-image:url('" + diqCssPhotoUrl(p.url) + "');");
      photo.setAttribute("data-photo-kind", String(p.kind || "google_photo"));
      photo.setAttribute("data-photo-live", "1");
      photo.setAttribute("data-photo-label", clean(p.label || "Place Photo"));
    }
    if (hint) {
      hint.className = String(hint.className || "").replace(/\s?photoLoading/g, "").replace(/\s?photoFallback/g, "").replace(/\s?photoLive/g, "") + " photoLive";
      hint.textContent = clean(p.label || "Place Photo");
    }
    try { diqV39RenderPhotoDebug(item, query || activeLens, "v54-painted"); } catch (e1) {}
    return;
  }




  out = diqV54OriginalApplyPlaceGallery(item, query || activeLens);
  try { diqV39RenderPhotoDebug(item, query || activeLens, "v54-gallery"); } catch (e2) {}
  return out;
};




var diqV54OriginalNewResolver = diqGooglePlacesNewPhotoResolver;
diqGooglePlacesNewPhotoResolver = function (item, query, done) {
  diqV54OriginalNewResolver(item, query || activeLens, function (photos) {
    var i;
    var p;
    if (photos && photos.length) {
      for (i = 0; i < photos.length; i++) {
        p = photos[i];
        if (p && p.url && diqLooksLikeImageUrl(p.url)) {
          diqV54CommitPhotoUrl(item, p.url, p.label || "Google Place Photo", p.kind || "google_photo", p.source || "Photo IQ V54");
          break;
        }
      }
      done(photos);
      return;
    }
    done([]);
  });
};




var diqV54OriginalDebugData = diqV39DebugData;
diqV39DebugData = function (item, query, stage) {
  var d = diqV54OriginalDebugData(item, query || activeLens, stage || "debug");
  var u = "";
  try { u = item && (item.photoUrl || item.googlePhotoMediaUrl || item.googlePhotoUrl || item.googleStreetViewUrl) || ""; } catch (e0) { u = ""; }
  if (u && diqLooksLikeImageUrl(u)) {
    d.url = u;
    d.details = clean(String(d.details || "") + " v54:url-committed");
  }
  return d;
};




try { console.log("âœ… Drive IQ V54 Photo URL Commit IQ loaded"); } catch (e) {}








/* =========================================================
   DRIVE IQ V56 â€” PHOTO PAINT LOCK IQ
   V55 proved URL:YES + Render:LIVE but IMG:WAIT. This is no longer a
   resolver problem. V56 makes the final paint authoritative:
   - paints trusted Google/Street View URLs immediately,
   - records IMG:LOADED / IMG:ERROR in the debug state,
   - prevents fallback repaint from winning after URL commit,
   - adds a short delayed repaint so the visible card stays live.
   ES5-safe.
========================================================= */




var DIQ_V56_PHOTO_PAINT_LOCK_ON = true;
var diqV56PaintLock = {};




function diqV56PhotoKey(item) {
  var k = "";
  try { k = diqPhotoCacheKey ? diqPhotoCacheKey(item) : ""; } catch (e0) { k = ""; }
  if (!k && item) { k = clean(String(item.label || "") + "|" + String(item.lat || "") + "|" + String(item.lng || "")); }
  return k || "active-card";
}




function diqV56TrustedUrl(item) {
  var u = "";
  var gallery;
  var i;




  try { if (item && item.photoUrl && diqLooksLikeImageUrl(item.photoUrl)) { return String(item.photoUrl); } } catch (e0) {}
  try { if (item && item.googlePhotoMediaUrl && diqLooksLikeImageUrl(item.googlePhotoMediaUrl)) { return String(item.googlePhotoMediaUrl); } } catch (e1) {}
  try { if (item && item.googlePhotoUrl && diqLooksLikeImageUrl(item.googlePhotoUrl)) { return String(item.googlePhotoUrl); } } catch (e2) {}
  try { if (item && item.googleStreetViewUrl && diqLooksLikeImageUrl(item.googleStreetViewUrl)) { return String(item.googleStreetViewUrl); } } catch (e3) {}




  try {
    gallery = diqBuildPlaceGallery(item, activeLens);
    for (i = 0; i < (gallery || []).length; i++) {
      if (gallery[i] && gallery[i].url && gallery[i].kind !== "map" && diqLooksLikeImageUrl(gallery[i].url)) {
        return String(gallery[i].url);
      }
    }
  } catch (e4) {}




  return u;
}




function diqV56PaintPhotoNow(item, query, stage) {
  var photo = byId("diqAdvInfoPhoto");
  var hint = byId("diqPhotoHint");
  var url = diqV56TrustedUrl(item);
  var cls;
  var key;




  if (!item || !photo || !url) { return false; }




  key = diqV56PhotoKey(item);
  cls = categoryPhotoClass(item, query || activeLens) || "local";




  try {
    item.photoUrl = url;
    item.photoStatus = "URL:YES";
    item.photoSource = item.photoSource || "Photo IQ V56";
    item.photoDebugLastUrl = url;
    diqV56PaintLock[key] = { url:url, state:"IMG:PAINTED", ts:Date.now(), stage:stage || "paint" };




    photo.className = "diqAdvPhoto realPhoto photoLive";
    try {
      photo.style.setProperty("background-image", "url('" + diqCssPhotoUrl(url) + "')", "important");
      photo.style.setProperty("background-size", "cover", "important");
      photo.style.setProperty("background-position", "center", "important");
      photo.style.setProperty("background-repeat", "no-repeat", "important");
      photo.style.setProperty("background-color", "#07111d", "important");
    } catch (paintImportantErr) {
      photo.setAttribute("style", "background-image:url('" + diqCssPhotoUrl(url) + "')!important;background-size:cover!important;background-position:center!important;background-repeat:no-repeat!important;");
    }
    photo.setAttribute("data-photo-kind", "google_visual");
    photo.setAttribute("data-photo-live", "1");
    photo.setAttribute("data-photo-label", "Place Photo");
    photo.setAttribute("data-photo-url", url);




    if (hint) {
      hint.className = String(hint.className || "").replace(/\s?photoLoading/g, "").replace(/\s?photoFallback/g, "").replace(/\s?photoLive/g, "") + " photoLive";
      hint.textContent = "Place Photo";
    }




    try {
      if (typeof diqV41LastImageLoadState === "object") {
        diqV41LastImageLoadState[key] = { live:true, url:url, style:String(photo.getAttribute("style") || ""), ts:Date.now(), v56:true };
      }
    } catch (s0) {}




    try {
      diqSetPhotoDebug(item, "v56-painted", {
        status:"IMG:PAINTED",
        msg:"paint lock",
        details:"url committed to hero",
        url:url,
        source:"Photo IQ V56"
      });
    } catch (d0) {}




    return true;
  } catch (e) {
    return false;
  }
}




function diqV56VerifyImage(item, query, url) {
  var img;
  var key;
  if (!item || !url) { return; }
  key = diqV56PhotoKey(item);




  try {
    img = new Image();
    img.onload = function () {
      try {
        diqV56PaintLock[key] = { url:url, state:"IMG:LOADED", ts:Date.now(), stage:"verify-load" };
        if (typeof diqV41LastImageLoadState === "object") {
          diqV41LastImageLoadState[key] = { live:true, url:url, style:"verified", ts:Date.now(), v56:true };
        }
        diqV56PaintPhotoNow(item, query || activeLens, "v56-loaded");
        try { diqSetPhotoDebug(item, "v56-img-loaded", { status:"IMG:LOADED", msg:"verified", url:url, source:"Photo IQ V56" }); } catch (d1) {}
        try { diqV39RenderPhotoDebug(item, query || activeLens, "v56-loaded"); } catch (r1) {}
      } catch (e1) {}
    };
    img.onerror = function () {
      try {
        diqV56PaintLock[key] = { url:url, state:"IMG:ERROR", ts:Date.now(), stage:"verify-error" };
        try { diqSetPhotoDebug(item, "v56-img-error", { status:"IMG:ERROR", msg:"image rejected", url:url, source:"Photo IQ V56" }); } catch (d2) {}
        try { diqV39RenderPhotoDebug(item, query || activeLens, "v56-error"); } catch (r2) {}
      } catch (e2) {}
    };
    img.referrerPolicy = "no-referrer-when-downgrade";
    img.src = url;
  } catch (e0) {}
}




var diqV56OriginalApplyPlaceGallery = diqApplyPlaceGallery;
diqApplyPlaceGallery = function (item, query) {
  var out;
  var url = diqV56TrustedUrl(item);
  var painted = false;




  if (url) {
    painted = diqV56PaintPhotoNow(item, query || activeLens, "v56-prepaint");
    try { diqV56VerifyImage(item, query || activeLens, url); } catch (v0) {}
  }




  if (!painted) {
    out = diqV56OriginalApplyPlaceGallery(item, query || activeLens);
  }




  if (url) {
    window.setTimeout(function () { try { diqV56PaintPhotoNow(item, query || activeLens, "v56-repaint-250"); } catch (e0) {} }, 250);
    window.setTimeout(function () { try { diqV56PaintPhotoNow(item, query || activeLens, "v56-repaint-900"); } catch (e1) {} }, 900);
    window.setTimeout(function () { try { diqV39RenderPhotoDebug(item, query || activeLens, "v56-debug"); } catch (e2) {} }, 1100);
  }




  return out;
};




var diqV56OriginalDebugData = diqV39DebugData;
diqV39DebugData = function (item, query, stage) {
  var d = diqV56OriginalDebugData(item, query || activeLens, stage || "debug");
  var key = diqV56PhotoKey(item);
  var lock = diqV56PaintLock[key];
  var url = diqV56TrustedUrl(item);




  if (url) {
    d.url = url;
    d.urlState = "URL:YES";
    d.live = "LIVE";
    if (lock && lock.state) { d.loadState = lock.state; }
    else if (!d.loadState || d.loadState === "IMG:WAIT") { d.loadState = "IMG:PAINTED"; }
    d.details = clean(String(d.details || "") + " v56:paint-lock");
  }




  return d;
};




try { console.log("âœ… Drive IQ V56 Photo Paint Lock IQ loaded"); } catch (e) {}








/* =========================================================
   DRIVE IQ V57 â€” PHOTO IMPORTANT PAINT CSS GUARD
   Allows inline !important photo paint to beat old .local/.dining fallback
   gradients. Keeps only a dark readability shade above real photos.
========================================================= */
(function(){
  try {
    if (document.getElementById("diqV57PhotoImportantPaintStyle")) { return; }
    var style = document.createElement("style");
    style.id = "diqV57PhotoImportantPaintStyle";
    style.type = "text/css";
    style.appendChild(document.createTextNode(
      "#diqAdventureInfoCard .diqAdvPhoto.realPhoto.photoLive{background-size:cover!important;background-position:center!important;background-repeat:no-repeat!important;filter:none!important;opacity:1!important;z-index:1!important;}" +
      "#diqAdventureInfoCard .diqAdvPhoto.realPhoto.photoLive:before{display:none!important;content:''!important;}" +
      "#diqAdventureInfoCard .diqAdvPhoto.realPhoto.photoLive:after{z-index:5!important;}" +
      "#diqAdventureInfoCard .diqPlaceHeroShade{z-index:2!important;background:linear-gradient(180deg,rgba(2,8,18,.04),rgba(2,8,18,.12) 42%,rgba(2,8,18,.80))!important;}" +
      "#diqAdventureInfoCard .diqPlaceTopRow,#diqAdventureInfoCard .diqPlaceHeroText,#diqAdventureInfoCard .diqPlaceScore,#diqAdventureInfoCard .diqPhotoHint,#diqAdventureInfoCard .diqPhotoGalleryNav{z-index:4!important;}"
    ));
    document.head.appendChild(style);
    console.log("âœ… Drive IQ V57 Photo Important Paint CSS Guard loaded");
  } catch(e) {}
})();








/* =========================================================
   DRIVE IQ V58 â€” PHOTO IMG OVERLAY IQ
   V57 proved background URL assignment can still be hidden by card layers.
   V58 bypasses background-image completely by placing a real <img> inside
   the visible hero and pinning it under the text/score but above fallback art.
   ES5-safe.
========================================================= */




function diqV58PhotoKey(item) {
  var k = "";
  try { k = diqPhotoCacheKey ? diqPhotoCacheKey(item) : ""; } catch (e0) { k = ""; }
  if (!k && item) { k = clean(String(item.label || "") + "|" + String(item.lat || "") + "|" + String(item.lng || "")); }
  return k || "active-card";
}




function diqV58TrustedUrl(item) {
  var gallery;
  var i;
  try { if (item && item.photoUrl && diqLooksLikeImageUrl(item.photoUrl)) { return String(item.photoUrl); } } catch (e0) {}
  try { if (item && item.googlePhotoMediaUrl && diqLooksLikeImageUrl(item.googlePhotoMediaUrl)) { return String(item.googlePhotoMediaUrl); } } catch (e1) {}
  try { if (item && item.googlePhotoUrl && diqLooksLikeImageUrl(item.googlePhotoUrl)) { return String(item.googlePhotoUrl); } } catch (e2) {}
  try { if (item && item.googleStreetViewUrl && diqLooksLikeImageUrl(item.googleStreetViewUrl)) { return String(item.googleStreetViewUrl); } } catch (e3) {}




  try {
    gallery = diqBuildPlaceGallery(item, activeLens);
    for (i = 0; i < (gallery || []).length; i++) {
      if (gallery[i] && gallery[i].url && gallery[i].kind !== "map" && diqLooksLikeImageUrl(gallery[i].url)) {
        return String(gallery[i].url);
      }
    }
  } catch (e4) {}




  return "";
}




function diqV58FindHeroPhotoEl() {
  var el = byId("diqAdvInfoPhoto");
  if (el) { return el; }
  try { el = document.querySelector("#diqAdventureInfoCard .diqAdvPhoto"); } catch (e0) {}
  if (el) { return el; }
  try { el = document.querySelector(".diqAdvPhoto"); } catch (e1) {}
  return el || null;
}




function diqV58EnsureImgLayer(photo, url) {
  var img;
  if (!photo || !url) { return null; }




  try {
    photo.style.setProperty("position", "relative", "important");
    photo.style.setProperty("overflow", "hidden", "important");
    photo.style.setProperty("background-image", "none", "important");
    photo.style.setProperty("background", "#061018", "important");
  } catch (e0) {}




  img = photo.querySelector ? photo.querySelector(".diqV58LivePhotoImg") : null;
  if (!img) {
    img = document.createElement("img");
    img.className = "diqV58LivePhotoImg";
    img.alt = "";
    img.setAttribute("aria-hidden", "true");
    try { photo.insertBefore(img, photo.firstChild); } catch (e1) { try { photo.appendChild(img); } catch (e2) {} }
  }




  try {
    img.src = url;
    img.style.setProperty("position", "absolute", "important");
    img.style.setProperty("inset", "0", "important");
    img.style.setProperty("width", "100%", "important");
    img.style.setProperty("height", "100%", "important");
    img.style.setProperty("object-fit", "cover", "important");
    img.style.setProperty("object-position", "center", "important");
    img.style.setProperty("display", "block", "important");
    img.style.setProperty("opacity", "1", "important");
    img.style.setProperty("visibility", "visible", "important");
    img.style.setProperty("z-index", "1", "important");
    img.style.setProperty("filter", "none", "important");
    img.style.setProperty("pointer-events", "none", "important");
  } catch (e3) {}




  return img;
}




function diqV58PaintImgOverlay(item, query, stage) {
  var photo = diqV58FindHeroPhotoEl();
  var url = diqV58TrustedUrl(item);
  var img;
  var key;




  if (!photo || !item || !url) { return false; }




  key = diqV58PhotoKey(item);
  try {
    item.photoUrl = url;
    item.photoStatus = "URL:YES";
    item.photoDebugLastUrl = url;
    item.photoSource = item.photoSource || "Photo IQ V58";




    photo.className = String(photo.className || "").replace(/\blocal\b/g, "").replace(/\bdining\b/g, "").replace(/\boutdoor\b/g, "").replace(/\bwater\b/g, "") + " realPhoto photoLive v58PhotoLive";
    photo.setAttribute("data-photo-live", "1");
    photo.setAttribute("data-v58-photo", "1");
    photo.setAttribute("data-photo-url", url);




    img = diqV58EnsureImgLayer(photo, url);




    try {
      if (typeof diqV41LastImageLoadState === "object") {
        diqV41LastImageLoadState[key] = { live:true, url:url, style:"v58-img-overlay", ts:Date.now(), v58:true };
      }
    } catch (s0) {}




    try {
      diqSetPhotoDebug(item, "v58-img-overlay", {
        status:"IMG:OVERLAY",
        msg:"real img layer",
        details:"v58:img-overlay",
        url:url,
        source:"Photo IQ V58"
      });
    } catch (d0) {}




    return !!img;
  } catch (e) {
    return false;
  }
}




(function(){
  try {
    if (!document.getElementById("diqV58PhotoImgOverlayStyle")) {
      var style = document.createElement("style");
      style.id = "diqV58PhotoImgOverlayStyle";
      style.type = "text/css";
      style.appendChild(document.createTextNode(
        ".diqAdvPhoto.v58PhotoLive{position:relative!important;overflow:hidden!important;background:#061018!important;background-image:none!important;}" +
        ".diqAdvPhoto.v58PhotoLive .diqV58LivePhotoImg{position:absolute!important;inset:0!important;width:100%!important;height:100%!important;object-fit:cover!important;object-position:center!important;display:block!important;opacity:1!important;visibility:visible!important;z-index:1!important;filter:none!important;}" +
        ".diqAdvPhoto.v58PhotoLive:before{display:none!important;content:''!important;}" +
        ".diqAdvPhoto.v58PhotoLive:after{z-index:2!important;background:linear-gradient(180deg,rgba(2,8,18,.04),rgba(2,8,18,.10) 40%,rgba(2,8,18,.74))!important;}" +
        ".diqAdvPhoto.v58PhotoLive > *:not(.diqV58LivePhotoImg){position:relative!important;z-index:3!important;}"
      ));
      document.head.appendChild(style);
    }
  } catch(e0) {}
})();




var diqV58OriginalApplyPlaceGallery = diqApplyPlaceGallery;
diqApplyPlaceGallery = function(item, query) {
  var url = diqV58TrustedUrl(item);
  var out;
  if (url) {
    diqV58PaintImgOverlay(item, query || activeLens, "v58-pre");
    window.setTimeout(function(){ try { diqV58PaintImgOverlay(item, query || activeLens, "v58-250"); } catch(e0) {} }, 250);
    window.setTimeout(function(){ try { diqV58PaintImgOverlay(item, query || activeLens, "v58-900"); } catch(e1) {} }, 900);
    window.setTimeout(function(){ try { diqV39RenderPhotoDebug(item, query || activeLens, "v58-debug"); } catch(e2) {} }, 1000);
    return true;
  }
  out = diqV58OriginalApplyPlaceGallery(item, query || activeLens);
  return out;
};




var diqV58OriginalDebugData = diqV39DebugData;
diqV39DebugData = function(item, query, stage) {
  var d = diqV58OriginalDebugData(item, query || activeLens, stage || "debug");
  var url = diqV58TrustedUrl(item);
  var photo = diqV58FindHeroPhotoEl();
  var img = null;
  try { img = photo && photo.querySelector ? photo.querySelector(".diqV58LivePhotoImg") : null; } catch (e0) {}
  if (url) {
    d.url = url;
    d.urlState = "URL:YES";
    d.live = "LIVE";
    d.loadState = img ? "IMG:OVERLAY" : (d.loadState || "IMG:PAINTED");
    d.details = clean(String(d.details || "") + " v58:img-overlay");
  }
  return d;
};




try { console.log("âœ… Drive IQ V58 Photo IMG Overlay IQ loaded"); } catch(e) {}








/* =========================================================
   DRIVE IQ V59 â€” PHOTO LOAD TRUTH IQ
   V58 proved a real <img> layer appears, but the browser shows a broken
   image icon. V59 records the actual image load result and makes the URL
   handoff visible without guessing:
   - LOAD:START / LOAD:YES / LOAD:NO
   - error count + full current src in debug
   - cache-busted retry for Google static URLs
   - fallback back to painted hero instead of broken icon after error
   ES5-safe.
========================================================= */




var diqV59ImageTruth = {};




function diqV59Key(item) {
  var k = "";
  try { k = diqPhotoCacheKey ? diqPhotoCacheKey(item) : ""; } catch (e0) { k = ""; }
  if (!k && item) { k = clean(String(item.label || "") + "|" + String(item.lat || "") + "|" + String(item.lng || "")); }
  return k || "active-card";
}




function diqV59ShortUrl(url) {
  var u = clean(url);
  if (!u) { return ""; }
  if (u.length <= 150) { return u; }
  return u.slice(0, 110) + "..." + u.slice(u.length - 34);
}




function diqV59TrustedUrl(item) {
  var gallery;
  var i;
  try { if (item && item.photoUrl && diqLooksLikeImageUrl(item.photoUrl)) { return String(item.photoUrl); } } catch (e0) {}
  try { if (item && item.googlePhotoMediaUrl && diqLooksLikeImageUrl(item.googlePhotoMediaUrl)) { return String(item.googlePhotoMediaUrl); } } catch (e1) {}
  try { if (item && item.googlePhotoUrl && diqLooksLikeImageUrl(item.googlePhotoUrl)) { return String(item.googlePhotoUrl); } } catch (e2) {}
  try { if (item && item.googleStreetViewUrl && diqLooksLikeImageUrl(item.googleStreetViewUrl)) { return String(item.googleStreetViewUrl); } } catch (e3) {}
  try {
    gallery = diqBuildPlaceGallery(item, activeLens);
    for (i = 0; i < (gallery || []).length; i++) {
      if (gallery[i] && gallery[i].url && gallery[i].kind !== "map" && diqLooksLikeImageUrl(gallery[i].url)) {
        return String(gallery[i].url);
      }
    }
  } catch (e4) {}
  return "";
}




function diqV59CacheBustUrl(url) {
  var u = clean(url);
  if (!u) { return ""; }
  if (u.indexOf("maps.googleapis.com") < 0 && u.indexOf("places.googleapis.com") < 0) { return u; }
  if (u.indexOf("diqv59=") > -1) { return u; }
  return u + (u.indexOf("?") > -1 ? "&" : "?") + "diqv59=" + encodeURIComponent(String(Date.now()));
}




function diqV59FindHeroPhotoEl() {
  var el = byId("diqAdvInfoPhoto");
  if (el) { return el; }
  try { el = document.querySelector("#diqAdventureInfoCard .diqAdvPhoto"); } catch (e0) {}
  if (el) { return el; }
  try { el = document.querySelector(".diqAdvPhoto"); } catch (e1) {}
  return el || null;
}




function diqV59CommitTruth(item, state, extra) {
  var key = diqV59Key(item);
  var cur = diqV59ImageTruth[key] || {};
  var url = extra && extra.url ? String(extra.url) : (cur.url || diqV59TrustedUrl(item));
  diqV59ImageTruth[key] = {
    state:String(state || "LOAD:UNKNOWN"),
    url:url,
    shortUrl:diqV59ShortUrl(url),
    err:String(extra && extra.err || cur.err || ""),
    naturalWidth:Number(extra && extra.naturalWidth || cur.naturalWidth || 0),
    naturalHeight:Number(extra && extra.naturalHeight || cur.naturalHeight || 0),
    tries:Number(extra && extra.tries || cur.tries || 0),
    ts:Date.now()
  };
  try {
    diqSetPhotoDebug(item, "v59-load-truth", {
      status:String(state || "LOAD:UNKNOWN"),
      msg:"image load truth",
      details:"v59:load-truth " + String(state || ""),
      url:url,
      source:"Photo IQ V59"
    });
  } catch (d0) {}
}




function diqV59InstallLoadHandlers(item, img, url) {
  var key;
  var busted;
  var tries = 1;
  if (!item || !img || !url) { return; }




  key = diqV59Key(item);
  diqV59CommitTruth(item, "LOAD:START", { url:url, tries:tries });




  img.onload = function () {
    try {
      diqV59CommitTruth(item, "LOAD:YES", {
        url:img.currentSrc || img.src || url,
        naturalWidth:img.naturalWidth || 0,
        naturalHeight:img.naturalHeight || 0,
        tries:tries
      });
      try { diqV39RenderPhotoDebug(item, activeLens, "v59-load-yes"); } catch (r0) {}
    } catch (e0) {}
  };




  img.onerror = function (e) {
    try {
      tries += 1;
      diqV59CommitTruth(item, "LOAD:NO", {
        url:img.currentSrc || img.src || url,
        err:e && e.type ? e.type : "error",
        tries:tries
      });




      /* One cache-busted retry helps identify whether iOS cached an error. */
      if (tries === 2) {
        busted = diqV59CacheBustUrl(url);
        if (busted && busted !== img.src) {
          window.setTimeout(function () {
            try {
              diqV59CommitTruth(item, "LOAD:RETRY", { url:busted, tries:tries });
              img.src = busted;
              try { diqV39RenderPhotoDebug(item, activeLens, "v59-retry"); } catch (r1) {}
            } catch (e1) {}
          }, 180);
          return;
        }
      }




      /* Hide the broken icon but keep diagnostics visible. */
      if (tries > 2) {
        try {
          img.style.setProperty("display", "none", "important");
          img.style.setProperty("visibility", "hidden", "important");
        } catch (hideErr) {}
      }




      try { diqV39RenderPhotoDebug(item, activeLens, "v59-load-no"); } catch (r2) {}
    } catch (e2) {}
  };
}




function diqV59UpgradeExistingImg(item) {
  var photo = diqV59FindHeroPhotoEl();
  var img = null;
  var url = diqV59TrustedUrl(item);




  if (!photo || !url) { return false; }




  try { img = photo.querySelector ? photo.querySelector(".diqV58LivePhotoImg") : null; } catch (e0) {}
  if (!img) {
    try {
      img = document.createElement("img");
      img.className = "diqV58LivePhotoImg diqV59LoadTruthImg";
      img.alt = "";
      img.setAttribute("aria-hidden", "true");
      photo.insertBefore(img, photo.firstChild);
    } catch (e1) { img = null; }
  }
  if (!img) { return false; }




  try {
    img.className = String(img.className || "") + " diqV59LoadTruthImg";
    img.style.setProperty("position", "absolute", "important");
    img.style.setProperty("inset", "0", "important");
    img.style.setProperty("width", "100%", "important");
    img.style.setProperty("height", "100%", "important");
    img.style.setProperty("object-fit", "cover", "important");
    img.style.setProperty("object-position", "center", "important");
    img.style.setProperty("z-index", "1", "important");
    img.style.setProperty("opacity", "1", "important");
    img.style.setProperty("display", "block", "important");
    img.style.setProperty("visibility", "visible", "important");
  } catch (s0) {}




  diqV59InstallLoadHandlers(item, img, url);
  try { img.referrerPolicy = "no-referrer-when-downgrade"; } catch (rp) {}
  try { img.crossOrigin = ""; } catch (co) {}
  try { img.src = url; } catch (srcErr) {}




  return true;
}




(function(){
  try {
    if (!document.getElementById("diqV59PhotoLoadTruthStyle")) {
      var style = document.createElement("style");
      style.id = "diqV59PhotoLoadTruthStyle";
      style.type = "text/css";
      style.appendChild(document.createTextNode(
        ".diqV59LoadTruthImg{position:absolute!important;inset:0!important;width:100%!important;height:100%!important;object-fit:cover!important;object-position:center!important;z-index:1!important;opacity:1!important;}" +
        ".diqV59LoadTruthImg[style*='hidden']{opacity:0!important;}"
      ));
      document.head.appendChild(style);
    }
  } catch(e0) {}
})();




var diqV59OriginalApplyPlaceGallery = diqApplyPlaceGallery;
diqApplyPlaceGallery = function(item, query) {
  var out = diqV59OriginalApplyPlaceGallery(item, query || activeLens);
  window.setTimeout(function(){ try { diqV59UpgradeExistingImg(item); } catch(e0) {} }, 80);
  window.setTimeout(function(){ try { diqV59UpgradeExistingImg(item); } catch(e1) {} }, 550);
  window.setTimeout(function(){ try { diqV39RenderPhotoDebug(item, query || activeLens, "v59-debug"); } catch(e2) {} }, 850);
  return out;
};




var diqV59OriginalDebugData = diqV39DebugData;
diqV39DebugData = function(item, query, stage) {
  var d = diqV59OriginalDebugData(item, query || activeLens, stage || "debug");
  var key = diqV59Key(item);
  var t = diqV59ImageTruth[key];
  var url = diqV59TrustedUrl(item);




  if (url) {
    d.url = url;
    d.urlState = "URL:YES";
    d.live = "LIVE";
    d.details = clean(String(d.details || "") + " v59:load-truth");
  }




  if (t) {
    d.loadState = t.state || d.loadState || "LOAD:UNKNOWN";
    d.details = clean(String(d.details || "") + " " + String(t.state || "") + " tries:" + String(t.tries || 0));
    d.url = t.url || d.url;
    d.src = t.shortUrl || diqV59ShortUrl(t.url || d.url || "");
    d.err = t.err || "";
    d.dim = t.naturalWidth && t.naturalHeight ? (String(t.naturalWidth) + "x" + String(t.naturalHeight)) : "";
  }




  return d;
};




try { console.log("âœ… Drive IQ V59 Photo Load Truth IQ loaded"); } catch(e) {}








/* =========================================================
   DRIVE IQ V60 â€” LEGACY PHOTO URL IQ
   V59 proved direct Places New / Street View URLs can produce LOAD:NO in
   iOS/WKWebView. V60 prioritizes browser-safe legacy Google Places JS
   photo.getUrl() URLs and only falls back to direct static/media URLs after
   legacy fails.
   ES5-safe.
========================================================= */




var diqV60LegacyPhotoTruth = {};




function diqV60Key(item) {
  var k = "";
  try { k = diqPhotoCacheKey ? diqPhotoCacheKey(item) : ""; } catch (e0) { k = ""; }
  if (!k && item) { k = clean(String(item.label || "") + "|" + String(item.lat || "") + "|" + String(item.lng || "")); }
  return k || "active-card";
}




function diqV60SetTruth(item, status, url, detail) {
  var key = diqV60Key(item);
  diqV60LegacyPhotoTruth[key] = {
    status:String(status || ""),
    url:String(url || ""),
    detail:String(detail || ""),
    ts:Date.now()
  };
  try {
    diqSetPhotoDebug(item, "v60-legacy-photo", {
      status:String(status || ""),
      msg:"legacy photo url",
      details:"v60:legacy-photo " + String(detail || ""),
      url:String(url || ""),
      source:"Photo IQ V60"
    });
  } catch (e0) {}
}




function diqV60HasLegacyPlaces() {
  try {
    return !!(window.google && google.maps && google.maps.places && google.maps.places.PlacesService);
  } catch (e0) { return false; }
}




function diqV60Host() {
  var host = byId("diqV60PlacesHost");
  if (host) { return host; }
  try {
    host = document.createElement("div");
    host.id = "diqV60PlacesHost";
    host.style.cssText = "position:absolute;width:1px;height:1px;left:-9999px;top:-9999px;overflow:hidden;";
    document.body.appendChild(host);
  } catch (e0) { host = null; }
  return host;
}




function diqV60LegacyService() {
  var host;
  if (!diqV60HasLegacyPlaces()) { return null; }
  host = diqV60Host();
  if (!host) { return null; }
  try { return new google.maps.places.PlacesService(host); } catch (e0) { return null; }
}




function diqV60ItemPlaceId(item) {
  var id = "";
  if (!item) { return ""; }
  id = item.googlePlaceId || item.place_id || item.placeId || item.google_place_id || item.googleResourceId || item.id || "";
  id = clean(id);
  if (id.indexOf("places/") === 0) {
    id = id.split("/")[1] || id;
  }
  return id;
}




function diqV60PlaceQuery(item, query) {
  var parts = [];
  if (item && item.label) { parts.push(item.label); }
  if (item && item.full) { parts.push(item.full); }
  if (query) { parts.push(query); }
  if (item && finite(Number(item.lat)) && finite(Number(item.lng))) {
    parts.push(String(Number(item.lat).toFixed(5)) + "," + String(Number(item.lng).toFixed(5)));
  }
  return clean(parts.join(" "));
}




function diqV60CommitUrl(item, url, detail) {
  if (!item || !url || !diqLooksLikeImageUrl(url)) { return false; }
  try {
    item.photoUrl = String(url);
    item.googlePhotoUrl = String(url);
    item.photoStatus = "URL:YES";
    item.photoSource = "Google Places Legacy";
    item.photoDebugLastUrl = String(url);
    diqV60SetTruth(item, "LEGACY:YES", url, detail || "committed");
    try { if (typeof diqV58PaintImgOverlay === "function") { diqV58PaintImgOverlay(item, activeLens, "v60-legacy"); } } catch (p0) {}
    try { if (typeof diqV59UpgradeExistingImg === "function") { diqV59UpgradeExistingImg(item); } } catch (p1) {}
    try { diqV39RenderPhotoDebug(item, activeLens, "v60-legacy"); } catch (d0) {}
    return true;
  } catch (e0) { return false; }
}




function diqV60UsePlacePhotos(item, place, detail) {
  var photos = place && place.photos ? place.photos : [];
  var url = "";
  if (!photos || !photos.length || !photos[0] || !photos[0].getUrl) {
    diqV60SetTruth(item, "LEGACY:NO_PHOTOS", "", detail || "no photos");
    return false;
  }
  try {
    url = photos[0].getUrl({ maxWidth: 900, maxHeight: 520 });
  } catch (e0) { url = ""; }
  if (!url) {
    try { url = photos[0].getUrl({ maxWidth: 640 }); } catch (e1) { url = ""; }
  }
  if (url) { return diqV60CommitUrl(item, url, detail || "getUrl"); }
  diqV60SetTruth(item, "LEGACY:NO_URL", "", detail || "getUrl empty");
  return false;
}




function diqV60ResolveByDetails(item, query, done) {
  var service = diqV60LegacyService();
  var pid = diqV60ItemPlaceId(item);
  if (!service || !pid) { done(false); return; }




  diqV60SetTruth(item, "LEGACY:DETAILS", "", "placeId");
  try {
    service.getDetails({
      placeId:pid,
      fields:["place_id","name","photos","geometry","types"]
    }, function(place, status) {
      var ok = false;
      try {
        ok = status === google.maps.places.PlacesServiceStatus.OK && !!place;
        if (ok && diqV60UsePlacePhotos(item, place, "details")) { done(true); return; }
      } catch (e0) {}
      diqV60SetTruth(item, "LEGACY:DETAILS_FAIL", "", String(status || "details fail"));
      done(false);
    });
  } catch (e1) {
    diqV60SetTruth(item, "LEGACY:DETAILS_ERR", "", "details exception");
    done(false);
  }
}




function diqV60ResolveByText(item, query, done) {
  var service = diqV60LegacyService();
  var req;
  if (!service || !item) { done(false); return; }




  req = { query:diqV60PlaceQuery(item, query), fields:["place_id","name","photos","geometry","types"] };
  if (finite(Number(item.lat)) && finite(Number(item.lng))) {
    try {
      req.location = new google.maps.LatLng(Number(item.lat), Number(item.lng));
      req.radius = 2500;
    } catch (e0) {}
  }




  diqV60SetTruth(item, "LEGACY:TEXT", "", "findPlaceFromQuery");
  try {
    service.findPlaceFromQuery(req, function(results, status) {
      var r;
      try {
        if (status === google.maps.places.PlacesServiceStatus.OK && results && results.length) {
          r = results[0];
          if (r.place_id) { item.googlePlaceId = r.place_id; item.place_id = r.place_id; }
          if (diqV60UsePlacePhotos(item, r, "text")) { done(true); return; }
        }
      } catch (e1) {}
      diqV60SetTruth(item, "LEGACY:TEXT_FAIL", "", String(status || "text fail"));
      done(false);
    });
  } catch (e2) {
    diqV60SetTruth(item, "LEGACY:TEXT_ERR", "", "text exception");
    done(false);
  }
}




function diqV60ResolveByNearby(item, query, done) {
  var service = diqV60LegacyService();
  var req;
  if (!service || !item || !finite(Number(item.lat)) || !finite(Number(item.lng))) { done(false); return; }




  try {
    req = {
      location:new google.maps.LatLng(Number(item.lat), Number(item.lng)),
      radius:1200,
      keyword:clean(String(item.label || "") + " " + String(query || activeLens || "")),
      fields:["place_id","name","photos","geometry","types"]
    };
  } catch (e0) { done(false); return; }




  diqV60SetTruth(item, "LEGACY:NEARBY", "", "nearbySearch");
  try {
    service.nearbySearch(req, function(results, status) {
      var i;
      var r;
      try {
        if (status === google.maps.places.PlacesServiceStatus.OK && results && results.length) {
          for (i = 0; i < results.length && i < 6; i++) {
            r = results[i];
            if (r && r.photos && r.photos.length) {
              if (r.place_id) { item.googlePlaceId = r.place_id; item.place_id = r.place_id; }
              if (diqV60UsePlacePhotos(item, r, "nearby")) { done(true); return; }
            }
          }
        }
      } catch (e1) {}
      diqV60SetTruth(item, "LEGACY:NEARBY_FAIL", "", String(status || "nearby fail"));
      done(false);
    });
  } catch (e2) {
    diqV60SetTruth(item, "LEGACY:NEARBY_ERR", "", "nearby exception");
    done(false);
  }
}




function diqV60HydrateLegacyPhoto(item, query) {
  if (!item) { return false; }
  if (!diqV60HasLegacyPlaces()) {
    diqV60SetTruth(item, "LEGACY:NO_PLACES_JS", "", "places js unavailable");
    return false;
  }




  diqV60ResolveByDetails(item, query || activeLens, function(ok1) {
    if (ok1) { return; }
    diqV60ResolveByText(item, query || activeLens, function(ok2) {
      if (ok2) { return; }
      diqV60ResolveByNearby(item, query || activeLens, function() {});
    });
  });
  return true;
}




var diqV60OriginalApplyPlaceGallery = diqApplyPlaceGallery;
diqApplyPlaceGallery = function(item, query) {
  var started = false;
  try { started = diqV60HydrateLegacyPhoto(item, query || activeLens); } catch (e0) { started = false; }




  /* Let existing V58/V59 paint run immediately, then legacy URL can replace it
     as soon as getUrl() succeeds. */
  var out = diqV60OriginalApplyPlaceGallery(item, query || activeLens);




  if (started) {
    window.setTimeout(function(){ try { diqV39RenderPhotoDebug(item, query || activeLens, "v60-debug"); } catch(e1) {} }, 850);
    window.setTimeout(function(){ try { diqV39RenderPhotoDebug(item, query || activeLens, "v60-debug-2"); } catch(e2) {} }, 1800);
  }
  return out;
};




var diqV60OriginalDebugData = diqV39DebugData;
diqV39DebugData = function(item, query, stage) {
  var d = diqV60OriginalDebugData(item, query || activeLens, stage || "debug");
  var key = diqV60Key(item);
  var t = diqV60LegacyPhotoTruth[key];
  if (t) {
    d.details = clean(String(d.details || "") + " v60:legacy-photo " + String(t.status || "") + " " + String(t.detail || ""));
    if (t.url) {
      d.url = t.url;
      d.urlState = "URL:YES";
      d.live = "LIVE";
    }
    if (t.status) { d.legacy = t.status; }
  }
  return d;
};




try { console.log("âœ… Drive IQ V60 Legacy Photo URL IQ loaded"); } catch(e) {}








/* =========================================================
   DRIVE IQ V62 â€” PHOTO NO-CORS LOAD IQ
   Current proof: URL:YES / Render:LIVE / LOAD:NO.
   V59 set crossOrigin on the live <img>. For Google image endpoints,
   crossorigin can make Safari/WKWebView reject a displayable image.
   V62 removes crossorigin, uses normal <img> loading, and stops retry twitch.
   ES5-safe.
========================================================= */




var diqV62PhotoLoadLock = {};




function diqV62Key(item) {
  var k = "";
  try { k = diqPhotoCacheKey ? diqPhotoCacheKey(item) : ""; } catch (e0) { k = ""; }
  if (!k && item) { k = clean(String(item.label || "") + "|" + String(item.lat || "") + "|" + String(item.lng || "")); }
  return k || "active-card";
}




function diqV62Url(item) {
  var gallery;
  var i;
  try { if (item && item.photoUrl && diqLooksLikeImageUrl(item.photoUrl)) { return String(item.photoUrl); } } catch (e0) {}
  try { if (item && item.googlePhotoUrl && diqLooksLikeImageUrl(item.googlePhotoUrl)) { return String(item.googlePhotoUrl); } } catch (e1) {}
  try { if (item && item.googlePhotoMediaUrl && diqLooksLikeImageUrl(item.googlePhotoMediaUrl)) { return String(item.googlePhotoMediaUrl); } } catch (e2) {}
  try { if (item && item.googleStreetViewUrl && diqLooksLikeImageUrl(item.googleStreetViewUrl)) { return String(item.googleStreetViewUrl); } } catch (e3) {}
  try {
    gallery = diqBuildPlaceGallery(item, activeLens);
    for (i = 0; i < (gallery || []).length; i++) {
      if (gallery[i] && gallery[i].url && gallery[i].kind !== "map" && diqLooksLikeImageUrl(gallery[i].url)) {
        return String(gallery[i].url);
      }
    }
  } catch (e4) {}
  return "";
}




function diqV62Hero() {
  var el = byId("diqAdvInfoPhoto");
  if (el) { return el; }
  try { el = document.querySelector("#diqAdventureInfoCard .diqAdvPhoto"); } catch (e0) {}
  if (el) { return el; }
  try { el = document.querySelector(".diqAdvPhoto"); } catch (e1) {}
  return el || null;
}




function diqV62Debug(item, status, detail, url) {
  try {
    diqSetPhotoDebug(item, "v62-nocors-load", {
      status:String(status || ""),
      msg:"photo no-cors load",
      details:"v62:nocors-load " + String(detail || ""),
      url:String(url || ""),
      source:"Photo IQ V62"
    });
  } catch (e0) {}
}




function diqV62StableFallback(item, detail) {
  var photo = diqV62Hero();
  var imgs;
  var i;




  if (!photo) { return; }




  try {
    imgs = photo.querySelectorAll ? photo.querySelectorAll(".diqV58LivePhotoImg,.diqV59LoadTruthImg,.diqV62LivePhotoImg") : [];
    for (i = 0; i < imgs.length; i++) {
      imgs[i].removeAttribute("src");
      imgs[i].removeAttribute("crossorigin");
      imgs[i].style.setProperty("display", "none", "important");
      imgs[i].style.setProperty("visibility", "hidden", "important");
    }
  } catch (e0) {}




  try {
    photo.className = String(photo.className || "").replace(/\bv58PhotoLive\b/g, "").replace(/\bv62PhotoLive\b/g, "").replace(/\bphotoLive\b/g, "") + " photoFallback stablePhotoFallback";
    photo.removeAttribute("data-photo-live");
    photo.removeAttribute("data-v58-photo");
    photo.removeAttribute("data-v62-photo");
  } catch (e1) {}




  diqV62Debug(item, "LOAD:NO_STABLE", detail || "fallback locked", diqV62Url(item));
}




function diqV62CreateImg(photo) {
  var oldImgs;
  var i;
  var img;




  try {
    oldImgs = photo.querySelectorAll ? photo.querySelectorAll(".diqV58LivePhotoImg,.diqV59LoadTruthImg,.diqV62LivePhotoImg") : [];
    for (i = 0; i < oldImgs.length; i++) {
      oldImgs[i].removeAttribute("crossorigin");
      oldImgs[i].removeAttribute("src");
      try { oldImgs[i].parentNode.removeChild(oldImgs[i]); } catch (r0) {}
    }
  } catch (e0) {}




  img = document.createElement("img");
  img.className = "diqV62LivePhotoImg";
  img.alt = "";
  img.setAttribute("aria-hidden", "true");




  try { img.removeAttribute("crossorigin"); } catch (c0) {}
  try { img.referrerPolicy = "strict-origin-when-cross-origin"; } catch (rp) {}




  try {
    img.style.setProperty("position", "absolute", "important");
    img.style.setProperty("inset", "0", "important");
    img.style.setProperty("width", "100%", "important");
    img.style.setProperty("height", "100%", "important");
    img.style.setProperty("object-fit", "cover", "important");
    img.style.setProperty("object-position", "center", "important");
    img.style.setProperty("display", "block", "important");
    img.style.setProperty("visibility", "visible", "important");
    img.style.setProperty("opacity", "1", "important");
    img.style.setProperty("z-index", "1", "important");
    img.style.setProperty("pointer-events", "none", "important");
  } catch (s0) {}




  try {
    photo.style.setProperty("position", "relative", "important");
    photo.style.setProperty("overflow", "hidden", "important");
    photo.insertBefore(img, photo.firstChild);
  } catch (a0) {
    try { photo.appendChild(img); } catch (a1) {}
  }




  return img;
}




function diqV62TryPhoto(item, query, stage) {
  var photo = diqV62Hero();
  var url = diqV62Url(item);
  var key = diqV62Key(item);
  var lockKey = key + "|" + url;
  var img;




  if (!item || !photo || !url) { return false; }




  if (diqV62PhotoLoadLock[lockKey] && diqV62PhotoLoadLock[lockKey].done) {
    diqV62Debug(item, diqV62PhotoLoadLock[lockKey].state || "LOAD:LOCKED", "locked " + String(stage || ""), url);
    return false;
  }




  diqV62PhotoLoadLock[lockKey] = { state:"LOAD:START", done:false, ts:Date.now() };




  try {
    item.photoUrl = url;
    item.googlePhotoUrl = url;
    item.photoStatus = "URL:YES";
    item.photoSource = item.photoSource || "Photo IQ V62";
    item.photoDebugLastUrl = url;




    photo.className = String(photo.className || "").replace(/\bstablePhotoFallback\b/g, "").replace(/\bphotoFallback\b/g, "") + " realPhoto photoLive v62PhotoLive";
    photo.setAttribute("data-photo-live", "1");
    photo.setAttribute("data-v62-photo", "1");
    photo.setAttribute("data-photo-url", url);
  } catch (e0) {}




  img = diqV62CreateImg(photo);




  img.onload = function () {
    try {
      diqV62PhotoLoadLock[lockKey] = {
        state:"LOAD:YES",
        done:true,
        w:img.naturalWidth || 0,
        h:img.naturalHeight || 0,
        ts:Date.now()
      };
      diqV62Debug(item, "LOAD:YES", "nocors img " + String(img.naturalWidth || 0) + "x" + String(img.naturalHeight || 0), img.currentSrc || img.src || url);
      try { diqV39RenderPhotoDebug(item, query || activeLens, "v62-load-yes"); } catch (r0) {}
    } catch (e1) {}
  };




  img.onerror = function (e) {
    try {
      diqV62PhotoLoadLock[lockKey] = {
        state:"LOAD:NO",
        done:true,
        err:e && e.type ? e.type : "error",
        ts:Date.now()
      };
      diqV62StableFallback(item, "img error no-cors");
      try { diqV39RenderPhotoDebug(item, query || activeLens, "v62-load-no"); } catch (r1) {}
    } catch (e2) {}
  };




  diqV62Debug(item, "LOAD:START", "nocors img " + String(stage || ""), url);




  try { img.src = url; } catch (srcErr) {
    diqV62PhotoLoadLock[lockKey] = { state:"LOAD:SRC_ERR", done:true, err:"src exception", ts:Date.now() };
    diqV62StableFallback(item, "src exception");
  }




  return true;
}




(function(){
  try {
    if (!document.getElementById("diqV62NoCorsPhotoStyle")) {
      var style = document.createElement("style");
      style.id = "diqV62NoCorsPhotoStyle";
      style.type = "text/css";
      style.appendChild(document.createTextNode(
        ".diqAdvPhoto.v62PhotoLive{position:relative!important;overflow:hidden!important;background:#061018!important;}" +
        ".diqAdvPhoto.v62PhotoLive .diqV62LivePhotoImg{position:absolute!important;inset:0!important;width:100%!important;height:100%!important;object-fit:cover!important;object-position:center!important;display:block!important;visibility:visible!important;opacity:1!important;z-index:1!important;}" +
        ".diqAdvPhoto.v62PhotoLive:before{display:none!important;content:''!important;}" +
        ".diqAdvPhoto.v62PhotoLive:after{z-index:2!important;background:linear-gradient(180deg,rgba(2,8,18,.04),rgba(2,8,18,.12) 42%,rgba(2,8,18,.72))!important;}" +
        ".diqAdvPhoto.stablePhotoFallback .diqV58LivePhotoImg,.diqAdvPhoto.stablePhotoFallback .diqV59LoadTruthImg,.diqAdvPhoto.stablePhotoFallback .diqV62LivePhotoImg{display:none!important;visibility:hidden!important;}"
      ));
      document.head.appendChild(style);
    }
  } catch(e0) {}
})();




var diqV62OriginalApplyPlaceGallery = diqApplyPlaceGallery;
diqApplyPlaceGallery = function(item, query) {
  var out = diqV62OriginalApplyPlaceGallery(item, query || activeLens);
  window.setTimeout(function(){ try { diqV62TryPhoto(item, query || activeLens, "v62-120"); } catch(e0) {} }, 120);
  window.setTimeout(function(){ try { diqV39RenderPhotoDebug(item, query || activeLens, "v62-debug"); } catch(e1) {} }, 950);
  return out;
};




var diqV62OriginalDebugData = diqV39DebugData;
diqV39DebugData = function(item, query, stage) {
  var d = diqV62OriginalDebugData(item, query || activeLens, stage || "debug");
  var url = diqV62Url(item);
  var key = diqV62Key(item);
  var lock = url ? diqV62PhotoLoadLock[key + "|" + url] : null;




  if (url) {
    d.url = url;
    d.urlState = "URL:YES";
    d.live = "LIVE";
    d.details = clean(String(d.details || "") + " v62:nocors-load");
  }




  if (lock && lock.state) {
    d.loadState = lock.state;
    d.details = clean(String(d.details || "") + " " + String(lock.state || ""));
    if (lock.w && lock.h) { d.dim = String(lock.w) + "x" + String(lock.h); }
    if (lock.err) { d.err = String(lock.err); }
  }




  return d;
};




try { console.log("âœ… Drive IQ V62 Photo No-CORS Load IQ loaded"); } catch(e) {}








/* =========================================================
   DRIVE IQ V63 â€” PUBLIC SCAN HANDOFF IQ
   Receives structured scans from /pages/scan and automatically:
   - reads URL + localStorage payloads
   - understands near-me, destination, and along-route scope
   - restores the original user query into Adventure search
   - resolves named destinations before scanning
   - launches the existing Adventure IQ scan engine
   - preserves existing ranking, pins, cards, Photo IQ, and Route Here
   ES5-safe. No optional chaining. No arrow functions. No template literals.
========================================================= */




window.__DRIVE_IQ_ADVENTURE_MODE_JS_V63_PUBLIC_SCAN_HANDOFF_IQ__ = true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD = "V63_PUBLIC_SCAN_HANDOFF_IQ";




var DIQ_PUBLIC_SCAN_PAYLOAD_KEY = "diq_public_scan_payload_v1";
var DIQ_PUBLIC_SCAN_QUERY_KEY = "diq_public_scan_query_v1";
var diqPublicScanHandledKey = "";
var diqPublicScanLaunchTimer = null;
var diqPublicScanResolveToken = 0;




function diqPublicScanUrlParams() {
  var out = {};
  var raw = "";
  var parts;
  var i;
  var pair;
  var key;
  var value;




  try {
    raw = String(window.location.search || "").replace(/^\?/, "");
  } catch (e0) {
    raw = "";
  }




  if (!raw) { return out; }




  parts = raw.split("&");




  for (i = 0; i < parts.length; i++) {
    pair = parts[i].split("=");
    key = "";




    try {
      key = decodeURIComponent(String(pair.shift() || "").replace(/\+/g, " "));
    } catch (e1) {
      key = String(pair.shift() || "");
    }




    try {
      value = decodeURIComponent(String(pair.join("=") || "").replace(/\+/g, " "));
    } catch (e2) {
      value = String(pair.join("=") || "");
    }




    if (key) {
      out[key] = value;
    }
  }




  return out;
}




function diqPublicScanBool(value) {
  var v = normText(value);
  return v === "1" ||
    v === "true" ||
    v === "yes" ||
    v === "on";
}




function diqPublicScanReadPayload() {
  var params = diqPublicScanUrlParams();
  var stored = safeParse(lsGet(DIQ_PUBLIC_SCAN_PAYLOAD_KEY));
  var query = clean(
    params.scan ||
    params.query ||
    (stored && (stored.query || stored.rawQuery)) ||
    lsGet(DIQ_PUBLIC_SCAN_QUERY_KEY) ||
    lsGet("diq_adventure_public_scan_v1") ||
    ""
  );
  var payload;




  if (!query) { return null; }




  payload = {
    version: 1,
    source: clean(
      params.source ||
      (stored && stored.source) ||
      "public_scan"
    ),
    lat: Number(params.lat || params.latitude || params.destLat || params.destinationLat || params.arrivalLat || (stored && (stored.lat || stored.latitude || stored.destLat || stored.destinationLat || stored.arrivalLat)) || 0),
    lng: Number(params.lng || params.lon || params.longitude || params.destLng || params.destLon || params.destinationLng || params.destinationLon || params.arrivalLng || params.arrivalLon || (stored && (stored.lng || stored.lon || stored.longitude || stored.destLng || stored.destinationLng || stored.arrivalLng || stored.arrivalLon)) || 0),
    destinationLabel: clean(params.destination || params.place || params.label || (stored && (stored.destination || stored.place || stored.label)) || ""),
    placeId: clean(params.placeId || params.place_id || params.googlePlaceId || (stored && (stored.placeId || stored.place_id || stored.googlePlaceId)) || ""),
    query: query,
    rawQuery: query,
    intent: clean(
      params.intent ||
      (stored && stored.intent) ||
      ""
    ),
    category: clean(
      params.category ||
      (stored && stored.category) ||
      ""
    ),
    providerQuery: clean(
      (stored && stored.providerQuery) ||
      query
    ),
    scope: clean(
      params.scope ||
      (stored && stored.scope) ||
      "near_me"
    ),
    autoRun:
      diqPublicScanBool(params.autorun) ||
      !!(stored && stored.autoRun) ||
      lsGet("diq_adventure_scan_autorun_v1") === "1",
    openNow:
      diqPublicScanBool(params.open_now) ||
      !!(stored && stored.openNow),
    tonight:
      diqPublicScanBool(params.tonight) ||
      !!(stored && stored.tonight),
    today:
      diqPublicScanBool(params.today) ||
      !!(stored && stored.today),
    weekend:
      diqPublicScanBool(params.weekend) ||
      !!(stored && stored.weekend),
    createdAt:
      clean(stored && stored.createdAt || "")
  };




  if (payload.scope === "destination") {
    payload.scope = "near_destination";
  }




  return payload;
}




function diqPublicScanInternalQuery(payload) {
  var q = clean(
    payload && payload.providerQuery ||
    payload && payload.query ||
    ""
  );
  var category = normText(payload && payload.category || "");
  var intent = normText(payload && payload.intent || "");




  if (category === "food drink" || intent === "restaurants") {
    return "restaurants food iq";
  }




  if (category === "coffee" || intent === "coffee") {
    return "coffee iq";
  }




  if (category === "dessert" || intent === "dessert") {
    return "dessert food iq";
  }




  if (category === "nightlife" || intent === "nightlife") {
    return "nightlife bars popular tonight";
  }




  if (category === "live music" || intent === "live music") {
    return "live music";
  }




  if (category === "patio" || intent === "patio") {
    return "patios outdoor seating";
  }




  if (
    category === "local favorites" ||
    intent === "local favorites"
  ) {
    return "local favorites";
  }




  if (
    category === "hidden gems" ||
    intent === "hidden gems"
  ) {
    return "hidden gems local favorites";
  }




  if (category === "family" || intent === "family") {
    return "family fun things to do with kids";
  }




  if (
    category === "date night" ||
    intent === "date night"
  ) {
    return "date night";
  }




  if (category === "outdoors" || intent === "outdoors") {
    return "outdoors trails parks scenic";
  }




  if (category === "water" || intent === "water") {
    return "lakes beaches marinas water access";
  }




  if (category === "shopping" || intent === "shopping") {
    return "shopping boutiques local shops";
  }




  if (category === "weekend" || intent === "weekend") {
    return "weekend ideas local favorites";
  }




  if (category === "lodging" || intent === "hotel") {
    return "hotels lodging";
  }




  if (category === "camping" || intent === "camping") {
    return "campgrounds rv parks camping";
  }




  if (category === "fuel" || intent === "fuel") {
    return "gas stations fuel";
  }




  if (category === "grocery" || intent === "grocery") {
    return "grocery stores";
  }




  if (category === "pharmacy" || intent === "pharmacy") {
    return "pharmacies drugstores";
  }




  if (category === "automotive" || intent === "automotive") {
    return "auto parts tire mechanic automotive service";
  }




  return q || clean(payload && payload.query || "");
}




function diqPublicScanDestinationText(query) {
  var q = clean(query);
  var match;
  var place = "";




  if (!q) { return ""; }




  match = q.match(
    /\b(?:in|near|around)\s+(.+?)(?:\s+(?:open now|right now|tonight|today|this weekend))?$/i
  );




  if (match && match[1]) {
    place = clean(match[1]);
  }




  place = place
    .replace(/\bnear me\b/ig, "")
    .replace(/\baround me\b/ig, "")
    .replace(/\bnearby\b/ig, "")
    .replace(/\s+/g, " ")
    .trim();




  if (
    normText(place) === "me" ||
    normText(place) === "my location"
  ) {
    return "";
  }




  return place;
}




function diqPublicScanSetInput(payload) {
  var input = byId("adventureSearch");




  if (input) {
    input.value = clean(payload && payload.query || "");
  }




  try {
    updateClearAdventureSearchButton();
  } catch (e0) {}
}




function diqPublicScanSetActiveQuery(payload) {
  var internalQuery = diqPublicScanInternalQuery(payload);




  activeLens = clean(internalQuery || payload.query || "local favorites")
    .toLowerCase();




  activeScanQuery = activeLens;
  lsSet(LS.ADVENTURE_LENS, activeLens);




  return activeLens;
}




function diqPublicScanDiagnostics(stage, payload, extra) {
  var data = {
    stage: String(stage || ""),
    query: clean(payload && payload.query || ""),
    intent: clean(payload && payload.intent || ""),
    category: clean(payload && payload.category || ""),
    scope: clean(payload && payload.scope || ""),
    internalQuery: diqPublicScanInternalQuery(payload || {}),
    hasGps: !!(
      lastFix &&
      finite(Number(lastFix.lat)) &&
      finite(Number(lastFix.lng))
    ),
    hasRoute: !!routeGeo,
    destination: destination
      ? clean(destination.label || "")
      : "",
    extra: extra || null,
    ts: Date.now()
  };




  try {
    lsJSON("diq_public_scan_debug_v1", data);
  } catch (e0) {}




  try {
    if (window.console && window.console.log) {
      window.console.log("[Drive IQ Public Scan]", data);
    }
  } catch (e1) {}
}




function diqPublicScanClearAutoRun() {
  lsRemove("diq_adventure_scan_autorun_v1");
}




function diqPublicScanRunCurrentCenter(payload) {
  var query = diqPublicScanSetActiveQuery(payload);




  if (!query) {
    setStatus("adventureRouteStatus", "SCAN READY", "");
    return false;
  }




  dismissAdventureKeyboard();
  hideDestinationResults();
  closeAdventureInfoCard();




  adventureScanOnly = true;
  destinationPreviewScan = false;




  diqPublicScanDiagnostics(
    "launch_current_center",
    payload,
    {
      center: adventureSearchCenter
        ? {
            lat: Number(adventureSearchCenter.lat),
            lng: Number(adventureSearchCenter.lng),
            label: String(adventureSearchCenter.label || "")
          }
        : null
    }
  );




  startScanTab(
    "SCANNING",
    "Finding " + clean(payload.query || query) + "..."
  );




  scanAdventureChoices(query);
  diqPublicScanClearAutoRun();
  return true;
}




function diqPublicScanRunNearMe(payload) {
  adventureSearchScope = "near_me";
  destinationPreviewScan = false;
  adventureDestinationCameraHold = false;




  if (
    lastFix &&
    finite(Number(lastFix.lat)) &&
    finite(Number(lastFix.lng))
  ) {
    adventureSearchCenter = {
      lat: Number(lastFix.lat),
      lng: Number(lastFix.lng),
      label: "you"
    };




    return diqPublicScanRunCurrentCenter(payload);
  }




  waitingForGpsQuery = diqPublicScanInternalQuery(payload);
  setStatus("adventureGpsStatus", "GPS LOCATING", "gold");
  setStatus("adventureRouteStatus", "WAITING FOR LOCATION", "gold");
  startScanTab(
    "LOCATING YOU",
    "Location is needed to scan nearby places..."
  );




  diqPublicScanDiagnostics(
    "request_gps",
    payload,
    null
  );




  requestGPS(true);
  return true;
}




function diqPublicScanRunAlongRoute(payload) {
  var query = diqPublicScanSetActiveQuery(payload);




  if (!routeGeo) {
    adventureSearchScope = "near_me";
    toast("No active route yet. Scanning near you instead.");
    return diqPublicScanRunNearMe(payload);
  }




  adventureSearchScope = "along_route";
  adventureScanOnly = true;
  destinationPreviewScan = false;




  if (
    lastFix &&
    finite(Number(lastFix.lat)) &&
    finite(Number(lastFix.lng))
  ) {
    adventureSearchCenter = {
      lat: Number(lastFix.lat),
      lng: Number(lastFix.lng),
      label: "along your route"
    };
  }




  diqPublicScanDiagnostics(
    "launch_along_route",
    payload,
    null
  );




  startScanTab(
    "SCANNING ROUTE",
    "Checking what is worth the stop along your route..."
  );




  scanAdventureChoices(query);
  diqPublicScanClearAutoRun();
  return true;
}




function diqPublicScanCommitDestination(item, payload) {
  var query;




  if (
    !item ||
    !finite(Number(item.lat)) ||
    !finite(Number(item.lng))
  ) {
    return false;
  }




  destination = {
    label: String(item.label || "Destination"),
    full: String(item.full || item.matchLabel || ""),
    lat: Number(item.lat),
    lng: Number(item.lng),
    kind: String(item.kind || "destination")
  };




  routeGeo = null;
  destinationSearchResults = [];
  hideDestinationResults();
  setDestinationLock(destination, "public_scan");




  lsJSON(LS.DEST, destination);
  lsRemove(LS.ROUTE_GEO);
  lsRemove(LS.ROUTE_INTEL);




  clearRouteLine();
  setDestinationPin();




  adventureSearchCenter = {
    lat: Number(destination.lat),
    lng: Number(destination.lng),
    label: String(destination.label || "destination")
  };




  adventureSearchScope = "near_destination";
  destinationPreviewScan = true;
  adventureScanOnly = true;
  adventureDestinationCameraHold = true;
  adventureDestinationCameraHoldAt = Date.now();




  try {
    syncAdventureDestinationScopeUI();
  } catch (e0) {}




  try {
    flyTo(destination.lng, destination.lat, 13.8);
  } catch (e1) {}




  query = diqPublicScanSetActiveQuery(payload);




  diqPublicScanDiagnostics(
    "destination_committed",
    payload,
    {
      label: destination.label,
      lat: destination.lat,
      lng: destination.lng
    }
  );




  setStatus("adventureRouteStatus", "DESTINATION SET", "green");
  startScanTab(
    "SCANNING DESTINATION",
    "Finding " + clean(payload.query || query) +
      " around " + clean(destination.label || "your destination") + "..."
  );




  window.setTimeout(function () {
    scanAdventureChoices(query);
    diqPublicScanClearAutoRun();
  }, 180);




  return true;
}








function diqV96PublicScanCoordinateItem(payload) {
  var lat = Number(payload && payload.lat || 0);
  var lng = Number(payload && payload.lng || 0);
  var label = clean(payload && (payload.destinationLabel || payload.destination || payload.place || payload.query) || "Arrival");
  if (finite(lat) && finite(lng) && Math.abs(lat) <= 90 && Math.abs(lng) <= 180 && (Math.abs(lat) > 0.0001 || Math.abs(lng) > 0.0001)) {
    return {
      label: label,
      full: clean(payload && (payload.address || payload.full) || ""),
      lat: lat,
      lng: lng,
      kind: "arrival",
      canonical: true,
      resultType: "public_scan_coordinate_handoff",
      placeId: clean(payload && payload.placeId || "")
    };
  }
  return null;
}




function diqPublicScanResolveDestination(payload) {
  var coordinateItem = diqV96PublicScanCoordinateItem(payload);
  var destinationText =
    diqPublicScanDestinationText(payload.query);
  var token;




  if (coordinateItem) {
    return diqPublicScanCommitDestination(coordinateItem, payload);
  }
  var urls;
  var all = [];
  var pending = 0;




  if (!destinationText) {
    return diqPublicScanRunNearMe(payload);
  }




  if (!GEOAPIFY_KEY) {
    setStatus("adventureRouteStatus", "SEARCH UNAVAILABLE", "red");
    stopScanTab();
    toast("Destination search unavailable");
    diqPublicScanDiagnostics(
      "destination_key_missing",
      payload,
      destinationText
    );
    return false;
  }




  diqPublicScanResolveToken += 1;
  token = diqPublicScanResolveToken;




  startScanTab(
    "SETTING DESTINATION",
    "Finding " + destinationText + "..."
  );




  setStatus(
    "adventureRouteStatus",
    "SETTING DESTINATION",
    "gold"
  );




  urls = [
    geoUrl(destinationText, "autocomplete", 10),
    geoUrl(destinationText, "search", 10)
  ];




  function finish() {
    var sorted;
    var best;




    if (
      pending > 0 ||
      token !== diqPublicScanResolveToken
    ) {
      return;
    }




    all = dedupe(all);




    sorted = all.sort(function (a, b) {
      var sa = scoreDestination(a, destinationText);
      var sb = scoreDestination(b, destinationText);
      return sb - sa;
    });




    best = sorted && sorted.length
      ? sorted[0]
      : null;




    if (!best) {
      stopScanTab();
      setStatus(
        "adventureRouteStatus",
        "NO DESTINATION",
        "gold"
      );
      toast("Could not find " + destinationText);
      diqPublicScanDiagnostics(
        "destination_not_found",
        payload,
        destinationText
      );
      renderDestinationResults([], destinationText);
      return;
    }




    diqPublicScanCommitDestination(best, payload);
  }




  function fetchUrl(url) {
    pending += 1;




    try {
      fetch(url)
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {
          var features =
            data && data.features
              ? data.features
              : [];
          var i;
          var item;




          for (i = 0; i < features.length; i++) {
            item = normalizeFeature(
              features[i],
              destinationText
            );




            if (item) {
              all.push(item);
            }
          }




          pending -= 1;
          finish();
        })
        .catch(function () {
          pending -= 1;
          finish();
        });
    } catch (error) {
      pending -= 1;
      finish();
    }
  }




  fetchUrl(urls[0]);
  fetchUrl(urls[1]);
  return true;
}




function diqPublicScanLaunch(payload) {
  var handledKey;




  if (!payload || !payload.query) {
    return false;
  }




  handledKey = [
    normText(payload.query),
    normText(payload.scope),
    normText(payload.createdAt || "")
  ].join("|");




  if (
    diqPublicScanHandledKey &&
    diqPublicScanHandledKey === handledKey
  ) {
    return false;
  }




  diqPublicScanHandledKey = handledKey;
  diqPublicScanSetInput(payload);




  diqPublicScanDiagnostics(
    "received",
    payload,
    null
  );




  if (payload.scope === "along_route") {
    return diqPublicScanRunAlongRoute(payload);
  }




  if (payload.scope === "near_destination") {
    return diqPublicScanResolveDestination(payload);
  }




  return diqPublicScanRunNearMe(payload);
}




function diqPublicScanScheduleLaunch() {
  var payload = diqPublicScanReadPayload();
  var attempts = 0;




  if (
    !payload ||
    !payload.query ||
    !payload.autoRun
  ) {
    return;
  }




  if (diqPublicScanLaunchTimer) {
    window.clearInterval(diqPublicScanLaunchTimer);
  }




  diqPublicScanLaunchTimer =
    window.setInterval(function () {
      attempts += 1;




      if (mapLoaded) {
        window.clearInterval(
          diqPublicScanLaunchTimer
        );




        diqPublicScanLaunchTimer = null;




        window.setTimeout(function () {
          diqPublicScanLaunch(payload);
        }, 180);




        return;
      }




      if (attempts >= 80) {
        window.clearInterval(
          diqPublicScanLaunchTimer
        );




        diqPublicScanLaunchTimer = null;




        setStatus(
          "adventureRouteStatus",
          "MAP NOT READY",
          "gold"
        );




        diqPublicScanDiagnostics(
          "map_timeout",
          payload,
          null
        );
      }
    }, 125);
}




if (document.readyState === "loading") {
  document.addEventListener(
    "DOMContentLoaded",
    diqPublicScanScheduleLaunch,
    false
  );
} else {
  diqPublicScanScheduleLaunch();
}




try {
  console.log(
    "âœ… Drive IQ V63 Public Scan Handoff IQ loaded"
  );
} catch (e0) {}












/* =========================================================
   DRIVE IQ V64 â€” LOCAL FOOD + POPULAR TRUTH LOCK




   Fixes:
   - Local Favorites / Popular scans can no longer inherit the Local Map
     outdoors helper label.
   - Food IQ prioritizes independent/local restaurants, hometown anchors,
     regional gems, and district favorites before national chains.
   - Chains remain eligible only as controlled fallback when credible local
     inventory is insufficient.
   - Final result lists enforce local-food representation and variety.
   - Southaven / Silo Square receives district-aware local rescue queries.
   ES5-safe. No HTML changes.
========================================================= */




window.__DRIVE_IQ_ADVENTURE_MODE_JS_V64_LOCAL_FOOD_POPULAR_TRUTH__ = true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD = "V64_LOCAL_FOOD_POPULAR_TRUTH_IQ";




var diqV64OriginalBuildAdventureQueries = buildAdventureQueries;
var diqV64OriginalScoreAdventure = scoreAdventure;
var diqV64OriginalStrictMatch = isStrictAdventureCategoryMatch;
var diqV64OriginalHardSuppress = diqV262HardSuppress;
var diqV64OriginalRenderAdventureScanChoices = renderAdventureScanChoices;
var diqV64OriginalAfterScanResultsReady = afterScanResultsReady;
var diqV64OriginalEnsureExploreNearbyButton = ensureExploreNearbyButton;
var diqV64OriginalSyncExploreNearbyButton = syncExploreNearbyButton;




function diqV64Text(item) {
  return normText(
    String(item && item.label || "") + " " +
    String(item && item.full || "") + " " +
    String(item && item.kind || "") + " " +
    String(item && item.category || "") + " " +
    String(item && item.placeCategories || "") + " " +
    String(item && item.placeClass || "") + " " +
    String(item && item.sourceQuery || "") + " " +
    String(item && item.matchLabel || "")
  );
}




function diqV64Has(text, words) {
  var i;
  text = normText(text);
  for (i = 0; i < words.length; i++) {
    if (text.indexOf(words[i]) > -1) { return true; }
  }
  return false;
}




function diqV64IsFoodCategory(query) {
  var cat = categoryFromQuery(query || activeScanQuery || activeLens);
  return cat === "food iq" || cat === "food drinks";
}




function diqV64IsPopularOrLocal(query) {
  var cat = categoryFromQuery(query || activeScanQuery || activeLens);
  return cat === "local favorites" || cat === "popular tonight";
}




function diqV64IsRestaurant(item) {
  return diqV64Has(diqV64Text(item), [
    "restaurant", "grill", "kitchen", "diner", "bistro", "steakhouse",
    "smokehouse", "barbecue", "bbq", "burger", "taco", "mexican",
    "pizza", "seafood", "catfish", "cajun", "italian", "sushi",
    "thai", "brunch", "breakfast", "lunch", "dinner", "wings",
    "sandwich", "eatery", "food"
  ]);
}




function diqV64IsNationalChain(item) {
  return diqV64Has(diqV64Text(item), [
    "mcdonald", "burger king", "wendy", "taco bell", "kfc",
    "kentucky fried chicken", "subway", "sonic drive in", "sonic",
    "chick fil a", "chick fil", "zaxby", "arby", "popeyes",
    "dairy queen", "domino", "pizza hut", "little caesars",
    "papa john", "panda express", "starbucks", "dunkin",
    "tropical smoothie", "smoothie king", "panera", "applebee",
    "chili s", "olive garden", "cracker barrel", "waffle house",
    "ihop", "denny", "buffalo wild wings", "wingstop",
    "texas roadhouse", "longhorn steakhouse", "outback steakhouse",
    "red lobster", "golden corral", "five guys", "whataburger",
    "raising cane", "jimmy john", "jersey mike", "firehouse subs",
    "chipotle", "moe s southwest", "qdoba", "freddy s frozen",
    "culver s", "cook out", "hardee", "krystal", "checkers",
    "captain d", "long john silver", "hooters"
  ]);
}




function diqV64StrongLocalEvidence(item) {
  var text = diqV64Text(item);




  if (diqV64Has(text, [
    "locally owned", "local favorite", "local favourite", "family owned",
    "independent", "hometown", "neighborhood", "beloved", "iconic",
    "historic", "since 19", "since 20", "hidden gem", "locals love",
    "where locals go", "regional", "mississippi", "tennessee",
    "downtown", "main street", "town square", "silo square",
    "snowden grove", "old town", "district"
  ])) {
    return true;
  }




  if (
    item &&
    (
      item.isLocal === true ||
      item.localOwned === true ||
      item.locallyOwned === true ||
      item.isIndependent === true ||
      item.localFavorite === true ||
      item.isLocalFavorite === true
    )
  ) {
    return true;
  }




  return false;
}




function diqV64LocalFoodScore(item) {
  var score = 0;
  var text = diqV64Text(item);
  var rating = Number(item && (item.rating || item.googleRating || item.stars));
  var reviews = Number(item && (item.reviewCount || item.reviews || item.userRatingsTotal));
  var distance = Number(item && item.distMiles);




  if (!diqV64IsRestaurant(item)) { return -80; }
  if (diqV64StrongLocalEvidence(item)) { score += 95; }
  if (diqV64Has(text, [
    "bbq", "barbecue", "catfish", "seafood", "soul food", "cajun",
    "meat and three", "country cooking", "southern", "smokehouse",
    "local restaurant", "family restaurant", "neighborhood restaurant"
  ])) { score += 38; }




  if (finite(rating)) {
    if (rating >= 4.6) { score += 28; }
    else if (rating >= 4.3) { score += 18; }
    else if (rating >= 4.0) { score += 8; }
  }




  if (finite(reviews)) {
    if (reviews >= 500) { score += 20; }
    else if (reviews >= 150) { score += 14; }
    else if (reviews >= 40) { score += 8; }
  }




  if (finite(distance)) {
    if (distance <= 5) { score += 18; }
    else if (distance <= 12) { score += 10; }
    else if (distance > 25) { score -= 22; }
  }




  if (diqV64IsNationalChain(item)) { score -= 125; }




  return score;
}




function diqV64CitySuffix() {
  var label = "";
  try { label = clean(adventureScanCityLabel ? adventureScanCityLabel() : ""); } catch (e) {}
  if (!label || normText(label) === "you" || normText(label) === "near you") { return ""; }
  return " " + label;
}




buildAdventureQueries = function (query) {
  var cat = categoryFromQuery(query);
  var city = diqV64CitySuffix();
  var cityNorm = normText(city);
  var out = [];
  var base = [];
  var i;




  function add(value) {
    try { diqV264Add(out, value); }
    catch (e) {
      value = clean(value);
      if (value && out.indexOf(value) < 0) { out.push(value); }
    }
  }




  if (cat === "food iq" || cat === "food drinks") {
    add("locally owned restaurants" + city);
    add("best local restaurants" + city);
    add("local favorite restaurants" + city);
    add("independent restaurants" + city);
    add("family owned restaurants" + city);
    add("hidden gem restaurants" + city);
    add("neighborhood restaurants" + city);
    add("iconic local restaurants" + city);
    add("regional restaurants" + city);
    add("southern food restaurants" + city);
    add("bbq restaurants" + city);
    add("burger restaurants" + city);
    add("mexican restaurants" + city);
    add("seafood restaurants" + city);
    add("breakfast restaurants" + city);
    add("brunch restaurants" + city);
    add("dinner restaurants" + city);
    add("bar and grill" + city);




    if (
      cityNorm.indexOf("southaven") > -1 ||
      cityNorm.indexOf("south haven") > -1
    ) {
      add("Silo Square local restaurants Southaven MS");
      add("locally owned restaurants Southaven MS");
      add("best local food Southaven MS");
      add("Southaven hidden gem restaurants");
      add("Snowden Grove local restaurants");
      add("DeSoto County local restaurants");
      add("Hernando local restaurants near Southaven");
    }




    try { base = diqV64OriginalBuildAdventureQueries(query) || []; }
    catch (e1) { base = []; }




    for (i = 0; i < base.length; i++) { add(base[i]); }
    return out.slice(0, 30);
  }




  if (cat === "local favorites") {
    add("locally owned restaurants" + city);
    add("local favorite restaurants" + city);
    add("best local food" + city);
    add("hidden gem restaurants" + city);
    add("local coffee shops" + city);
    add("local bakeries" + city);
    add("local breweries" + city);
    add("local boutiques" + city);
    add("local attractions" + city);
    add("community favorites" + city);
    add("where locals go" + city);
    add("downtown local businesses" + city);




    if (
      cityNorm.indexOf("southaven") > -1 ||
      cityNorm.indexOf("south haven") > -1
    ) {
      add("Silo Square local favorites Southaven");
      add("Silo Square restaurants Southaven");
      add("Southaven local food favorites");
      add("DeSoto County local favorites");
      add("Snowden Grove local favorites");
    }




    try { base = diqV64OriginalBuildAdventureQueries(query) || []; }
    catch (e2) { base = []; }




    for (i = 0; i < base.length; i++) { add(base[i]); }
    return out.slice(0, 24);
  }




  return diqV64OriginalBuildAdventureQueries(query);
};




isStrictAdventureCategoryMatch = function (item, query) {
  var cat = categoryFromQuery(query);




  if (cat === "food iq" || cat === "food drinks") {
    if (!diqV64IsRestaurant(item)) { return false; }




    /* Chains are not hard-blocked here because a tiny town may need them as
       fallback. Ranking and final selection keep them from dominating. */
    return true;
  }




  if (cat === "local favorites") {
    if (diqV64IsNationalChain(item) && !diqV64StrongLocalEvidence(item)) {
      return false;
    }
  }




  try { return diqV64OriginalStrictMatch(item, query); }
  catch (e) { return true; }
};




diqV262HardSuppress = function (item, query) {
  var cat = categoryFromQuery(query);




  if (cat === "food iq" || cat === "food drinks") {
    if (!diqV64IsRestaurant(item)) { return true; }
    try {
      if (diqV264FoodIQSnackOrCoffeeLeak && diqV264FoodIQSnackOrCoffeeLeak(item, query)) {
        return true;
      }
    } catch (e1) {}
  }




  if (cat === "local favorites") {
    if (diqV64IsNationalChain(item) && !diqV64StrongLocalEvidence(item)) {
      return true;
    }
  }




  try { return diqV64OriginalHardSuppress(item, query); }
  catch (e2) { return false; }
};




scoreAdventure = function (item, query) {
  var cat = categoryFromQuery(query);
  var score = 0;




  try { score = diqV64OriginalScoreAdventure(item, query); }
  catch (e) { score = 0; }




  if (!finite(score)) { score = 0; }




  if (cat === "food iq" || cat === "food drinks") {
    score += diqV64LocalFoodScore(item);




    if (diqV64StrongLocalEvidence(item)) { score += 65; }
    if (diqV64IsNationalChain(item)) { score -= 95; }
  }




  if (cat === "local favorites") {
    if (diqV64StrongLocalEvidence(item)) { score += 75; }
    if (diqV64IsRestaurant(item) && !diqV64IsNationalChain(item)) { score += 42; }
    if (diqV64IsNationalChain(item)) { score -= 180; }
  }




  return score;
};




function diqV64FinalLocalFoodMix(items, query) {
  var cat = categoryFromQuery(query);
  var source = items && items.length ? items.slice(0) : [];
  var local = [];
  var chains = [];
  var other = [];
  var result = [];
  var seen = {};
  var i;
  var item;
  var key;
  var localMinimum;
  var chainMaximum;




  if (cat !== "food iq" && cat !== "food drinks" && cat !== "local favorites") {
    return source;
  }




  source.sort(function (a, b) {
    return scoreAdventure(b, query) - scoreAdventure(a, query);
  });




  for (i = 0; i < source.length; i++) {
    item = source[i];
    if (!item) { continue; }




    if (diqV64IsRestaurant(item) && !diqV64IsNationalChain(item)) {
      local.push(item);
    } else if (diqV64IsNationalChain(item)) {
      chains.push(item);
    } else {
      other.push(item);
    }
  }




  localMinimum = cat === "local favorites" ? 4 : 5;
  chainMaximum = local.length >= localMinimum ? 1 : 2;




  function add(candidate) {
    if (!candidate) { return; }
    key = normText(String(candidate.label || "") + "|" + String(candidate.lat || "") + "|" + String(candidate.lng || ""));
    if (seen[key]) { return; }
    seen[key] = true;
    result.push(candidate);
  }




  for (i = 0; i < local.length && result.length < 8; i++) { add(local[i]); }




  if (cat === "local favorites") {
    for (i = 0; i < other.length && result.length < 10; i++) { add(other[i]); }
  }




  for (i = 0; i < chains.length && i < chainMaximum && result.length < 10; i++) {
    add(chains[i]);
  }




  for (i = 0; i < source.length && result.length < 10; i++) { add(source[i]); }




  return result;
}




renderAdventureScanChoices = function (items, query) {
  var q = clean(query || activeScanQuery || activeLens);
  var mixed = diqV64FinalLocalFoodMix(items || [], q);
  return diqV64OriginalRenderAdventureScanChoices(mixed, q);
};




afterScanResultsReady = function (items, preferred, reason) {
  var q = clean(activeScanQuery || activeLens);
  var mixed = diqV64FinalLocalFoodMix(items || [], q);
  var best = mixed && mixed.length ? mixed[0] : preferred;




  adventureResults = mixed.slice(0);




  return diqV64OriginalAfterScanResultsReady(
    mixed,
    best,
    reason
  );
};




function diqV64ExploreHelperCopy() {
  var cat = categoryFromQuery(activeScanQuery || activeLens);




  if (cat === "local favorites") {
    return {
      title:"LOCAL FAVORITES",
      count:adventureResults && adventureResults.length
        ? String(adventureResults.length) + " PICKS"
        : "READY",
      small:"Local food â€¢ coffee â€¢ hangouts â€¢ hidden gems"
    };
  }




  if (cat === "food iq" || cat === "food drinks") {
    return {
      title:"FOOD IQ",
      count:adventureResults && adventureResults.length
        ? String(adventureResults.length) + " PICKS"
        : "READY",
      small:"Local restaurants â€¢ hometown favorites â€¢ worth trying"
    };
  }




  if (cat === "popular tonight") {
    return {
      title:"POPULAR TONIGHT",
      count:adventureResults && adventureResults.length
        ? String(adventureResults.length) + " PICKS"
        : "READY",
      small:"Food â€¢ drinks â€¢ live energy â€¢ local favorites"
    };
  }




  return null;
}




ensureExploreNearbyButton = function () {
  var button = diqV64OriginalEnsureExploreNearbyButton();
  var copy = diqV64ExploreHelperCopy();




  if (button && copy) {
    button.innerHTML =
      escapeHTML(copy.title) +
      '<span class="count" id="diqExploreNearbyCount">' +
      escapeHTML(copy.count) +
      '</span><span class="small">' +
      escapeHTML(copy.small) +
      '</span>';
  }




  return button;
};




syncExploreNearbyButton = function () {
  var result = diqV64OriginalSyncExploreNearbyButton();
  var button = byId("diqExploreNearbyBtn");
  var count = byId("diqExploreNearbyCount");
  var copy = diqV64ExploreHelperCopy();
  var small;




  if (button && copy) {
    /* Replace only the leading text node, preserving spans and click behavior. */
    if (button.firstChild && button.firstChild.nodeType === 3) {
      button.firstChild.nodeValue = copy.title;
    }




    if (count) { count.textContent = copy.count; }




    try {
      small = button.querySelector(".small");
      if (small) { small.textContent = copy.small; }
    } catch (e) {}
  }




  return result;
};




try {
  console.log("âœ… Drive IQ V64 Local Food + Popular Truth Lock loaded");
} catch (e0) {}
















/* =========================================================
   DRIVE IQ V65 â€” REAL PLACES ONLY + LOCAL INVENTORY RESCUE




   Fixes the screenshot failure where "Southaven" itself rendered as a
   Local Favorite card with an invented high recommendation score.




   Rules:
   - City, county, postcode, suburb, administrative, airport, military-base,
     road, and generic map entities are never Place IQ recommendations.
   - Real named districts such as Silo Square may remain when they have
     genuine food / shopping / event identity.
   - Southaven-area scans use coordinate-aware rescue even when the scan
     center label is only "you".
   - Local Favorites keeps real local food, coffee, recreation, shopping,
     events, and districts.
   - Food IQ keeps only actual meal-serving establishments.
========================================================= */




window.__DRIVE_IQ_ADVENTURE_MODE_JS_V65_REAL_PLACES_LOCAL_RESCUE__ = true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD = "V65_REAL_PLACES_LOCAL_RESCUE_IQ";




var diqV65OriginalTruthMatch = diqV27TruthMatch;
var diqV65OriginalBroadPullRender = diqV27RenderBroadPull;
var diqV65OriginalStrictMatch = isStrictAdventureCategoryMatch;
var diqV65OriginalHardSuppress = diqV262HardSuppress;
var diqV65OriginalScoreAdventure = scoreAdventure;
var diqV65OriginalRenderChoices = renderAdventureScanChoices;
var diqV65OriginalAfterResults = afterScanResultsReady;




function diqV65DistanceMiles(lat1, lng1, lat2, lng2) {
  var R = 3958.7613;
  var dLat;
  var dLng;
  var a;




  lat1 = Number(lat1);
  lng1 = Number(lng1);
  lat2 = Number(lat2);
  lng2 = Number(lng2);




  if (
    !finite(lat1) ||
    !finite(lng1) ||
    !finite(lat2) ||
    !finite(lng2)
  ) {
    return 99999;
  }




  dLat = (lat2 - lat1) * Math.PI / 180;
  dLng = (lng2 - lng1) * Math.PI / 180;
  lat1 = lat1 * Math.PI / 180;
  lat2 = lat2 * Math.PI / 180;




  a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1) * Math.cos(lat2) *
    Math.sin(dLng / 2) * Math.sin(dLng / 2);




  return R * 2 * Math.atan2(
    Math.sqrt(a),
    Math.sqrt(1 - a)
  );
}




function diqV65ScanCenter() {
  if (
    adventureSearchCenter &&
    finite(Number(adventureSearchCenter.lat)) &&
    finite(Number(adventureSearchCenter.lng))
  ) {
    return {
      lat:Number(adventureSearchCenter.lat),
      lng:Number(adventureSearchCenter.lng)
    };
  }




  if (
    destination &&
    finite(Number(destination.lat)) &&
    finite(Number(destination.lng))
  ) {
    return {
      lat:Number(destination.lat),
      lng:Number(destination.lng)
    };
  }




  if (
    lastFix &&
    finite(Number(lastFix.lat)) &&
    finite(Number(lastFix.lng))
  ) {
    return {
      lat:Number(lastFix.lat),
      lng:Number(lastFix.lng)
    };
  }




  return null;
}




function diqV65SouthavenArea() {
  var center = diqV65ScanCenter();
  var label = normText(
    String(adventureSearchCenter && adventureSearchCenter.label || "") + " " +
    String(destination && destination.label || "") + " " +
    String(destination && destination.full || "")
  );




  if (
    label.indexOf("southaven") > -1 ||
    label.indexOf("south haven") > -1 ||
    label.indexOf("horn lake") > -1 ||
    label.indexOf("hernando") > -1 ||
    label.indexOf("olive branch") > -1 ||
    label.indexOf("desoto county") > -1
  ) {
    return true;
  }




  if (!center) { return false; }




  return diqV65DistanceMiles(
    center.lat,
    center.lng,
    34.9656,
    -89.9870
  ) <= 28;
}




function diqV65EntityText(item) {
  return normText(
    String(item && item.label || "") + " " +
    String(item && item.full || "") + " " +
    String(item && item.kind || "") + " " +
    String(item && item.category || "") + " " +
    String(item && item.placeCategories || "") + " " +
    String(item && item.resultType || "") + " " +
    String(item && item.matchLabel || "")
  );
}




function diqV65NamedDistrictAllowed(item) {
  var text = diqV65EntityText(item);
  var label = normText(item && item.label || "");




  if (
    label.indexOf("silo square") > -1 ||
    label.indexOf("town square") > -1 ||
    label.indexOf("main street district") > -1 ||
    label.indexOf("entertainment district") > -1 ||
    label.indexOf("historic district") > -1 ||
    label.indexOf("downtown") > -1
  ) {
    return diqV64Has(text, [
      "restaurant",
      "cafe",
      "coffee",
      "shopping",
      "commercial",
      "entertainment",
      "event",
      "marketplace",
      "bar",
      "pub",
      "district"
    ]);
  }




  return false;
}




function diqV65IsAdministrativeEntity(item) {
  var text = diqV65EntityText(item);
  var label = normText(item && item.label || "");
  var kind = normText(item && item.kind || "");
  var category = normText(item && item.category || "");
  var resultType = normText(item && item.resultType || "");




  if (!item) { return true; }
  if (item.localSeed === true && diqV65NamedDistrictAllowed(item)) {
    return false;
  }
  if (diqV65NamedDistrictAllowed(item)) { return false; }




  if (
    label === "southaven" ||
    label === "southaven mississippi" ||
    label === "horn lake" ||
    label === "hernando" ||
    label === "olive branch" ||
    label === "memphis" ||
    label === "desoto county"
  ) {
    return true;
  }




  if (
    kind.indexOf("city") > -1 ||
    kind.indexOf("town") > -1 ||
    kind.indexOf("village") > -1 ||
    kind.indexOf("county") > -1 ||
    kind.indexOf("postcode") > -1 ||
    kind.indexOf("administrative") > -1 ||
    kind.indexOf("municipality") > -1 ||
    kind.indexOf("locality") > -1 ||
    kind.indexOf("suburb") > -1 ||
    kind.indexOf("neighbourhood") > -1 ||
    kind.indexOf("neighborhood") > -1
  ) {
    return true;
  }




  if (
    category.indexOf("administrative") > -1 ||
    category.indexOf("postcode") > -1 ||
    resultType.indexOf("administrative") > -1 ||
    resultType.indexOf("postcode") > -1 ||
    resultType.indexOf("city") > -1
  ) {
    return true;
  }




  if (diqV64Has(text, [
    "airport",
    "air force base",
    "military base",
    "naval base",
    "county boundary",
    "city boundary",
    "municipal boundary",
    "postcode",
    "zip code",
    "highway",
    "state route",
    "county road",
    "interstate",
    "street",
    "road junction"
  ])) {
    return true;
  }




  return false;
}




function diqV65RealPlace(item, query, key) {
  if (diqV65IsAdministrativeEntity(item)) { return false; }




  if (key === "food_iq" || categoryFromQuery(query) === "food iq") {
    return diqV64IsRestaurant(item);
  }




  return true;
}




function diqV65FilterRealPlaces(items, query, key) {
  var out = [];
  var seen = {};
  var i;
  var item;
  var id;




  for (i = 0; i < (items || []).length; i++) {
    item = items[i];
    if (!diqV65RealPlace(item, query, key)) { continue; }




    id = normText(
      String(item.label || "") + "|" +
      String(Math.round(Number(item.lat || 0) * 10000)) + "|" +
      String(Math.round(Number(item.lng || 0) * 10000))
    );




    if (seen[id]) { continue; }
    seen[id] = true;
    out.push(item);
  }




  return out;
}




function diqV65SouthavenSeedsForKey(key) {
  var seeds = [];
  var all = [];
  var i;
  var item;




  if (!diqV65SouthavenArea()) { return seeds; }




  try {
    if (typeof diqV268SouthavenLocalSeeds === "function") {
      all = diqV268SouthavenLocalSeeds() || [];
    }
  } catch (e) {
    all = [];
  }




  for (i = 0; i < all.length; i++) {
    item = all[i];
    if (!item || diqV65IsAdministrativeEntity(item)) { continue; }




    if (key === "food_iq") {
      if (diqV64IsRestaurant(item)) { seeds.push(item); }
    } else {
      seeds.push(item);
    }
  }




  return seeds;
}




diqV27TruthMatch = function (item, query, key) {
  if (!diqV65RealPlace(item, query, key)) { return false; }




  try {
    return diqV65OriginalTruthMatch(item, query, key);
  } catch (e) {
    return true;
  }
};




isStrictAdventureCategoryMatch = function (item, query) {
  var key = diqV27CategoryKey(query);




  if (!diqV65RealPlace(item, query, key)) { return false; }




  try {
    return diqV65OriginalStrictMatch(item, query);
  } catch (e) {
    return true;
  }
};




diqV262HardSuppress = function (item, query) {
  var key = diqV27CategoryKey(query);




  if (!diqV65RealPlace(item, query, key)) { return true; }




  try {
    return diqV65OriginalHardSuppress(item, query);
  } catch (e) {
    return false;
  }
};




scoreAdventure = function (item, query) {
  var key = diqV27CategoryKey(query);
  var score;




  if (!diqV65RealPlace(item, query, key)) { return -99999; }




  try {
    score = diqV65OriginalScoreAdventure(item, query);
  } catch (e) {
    score = 0;
  }




  if (!finite(score)) { score = 0; }




  if (item && item.localSeed === true) { score += 60; }
  if (diqV65NamedDistrictAllowed(item)) { score += 28; }




  return score;
};




diqV27RenderBroadPull = function (rawItems, query, cfg, token) {
  var key = cfg && cfg.key
    ? cfg.key
    : diqV27CategoryKey(query);
  var cleaned = diqV65FilterRealPlaces(
    rawItems || [],
    query,
    key
  );
  var seeds = diqV65SouthavenSeedsForKey(key);
  var i;




  for (i = 0; i < seeds.length; i++) {
    cleaned.push(seeds[i]);
  }




  cleaned = diqV65FilterRealPlaces(
    cleaned,
    query,
    key
  );




  return diqV65OriginalBroadPullRender(
    cleaned,
    query,
    cfg,
    token
  );
};




renderAdventureScanChoices = function (items, query) {
  var q = clean(query || activeScanQuery || activeLens);
  var key = diqV27CategoryKey(q);
  var cleanItems = diqV65FilterRealPlaces(
    items || [],
    q,
    key
  );




  return diqV65OriginalRenderChoices(
    cleanItems,
    q
  );
};




afterScanResultsReady = function (items, preferred, reason) {
  var q = clean(activeScanQuery || activeLens);
  var key = diqV27CategoryKey(q);
  var cleanItems = diqV65FilterRealPlaces(
    items || [],
    q,
    key
  );
  var safePreferred = preferred;
  var i;




  if (
    !safePreferred ||
    !diqV65RealPlace(safePreferred, q, key)
  ) {
    safePreferred = cleanItems.length
      ? cleanItems[0]
      : null;
  } else {
    for (i = 0; i < cleanItems.length; i++) {
      if (cleanItems[i] === safePreferred) { break; }
    }




    if (i >= cleanItems.length) {
      safePreferred = cleanItems.length
        ? cleanItems[0]
        : null;
    }
  }




  adventureResults = cleanItems.slice(0);




  return diqV65OriginalAfterResults(
    cleanItems,
    safePreferred,
    reason
  );
};




try {
  console.log(
    "âœ… Drive IQ V65 Real Places + Local Inventory Rescue loaded"
  );
} catch (e0) {}
















/* =========================================================
   DRIVE IQ V66 â€” DIRECT PHOTO URI RESCUE IQ




   Field proof:
   Key:YES / ID:YES / Photos:1 / URL:YES / Render:LIVE / LOAD:NO




   Root issue:
   WKWebView can fail while following the Places API (New) media redirect,
   even though the photo resource and API key are valid.




   Fix:
   1. Ask Places Photo Media for skipHttpRedirect=true.
   2. Read Google's direct photoUri/CDN URL.
   3. Paint that direct image URL without crossOrigin.
   4. Try normalized media redirect URL.
   5. Try legacy Google getUrl() output.
   6. Try Street View.
   7. Lock only successful URLs; one failed URL cannot poison the card.
========================================================= */




window.__DRIVE_IQ_ADVENTURE_MODE_JS_V66_DIRECT_PHOTO_URI_RESCUE__ = true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD = "V66_DIRECT_PHOTO_URI_RESCUE_IQ";




var diqV66PhotoState = {};
var diqV66OriginalApplyGallery = diqApplyPlaceGallery;




function diqV66PhotoKey(item) {
  var key = "";
  try {
    key = diqPhotoCacheKey ? diqPhotoCacheKey(item) : "";
  } catch (e0) {
    key = "";
  }




  if (!key && item) {
    key = clean(
      String(item.label || "") + "|" +
      String(item.lat || "") + "|" +
      String(item.lng || "")
    );
  }




  return key || "active-photo-card";
}




function diqV66IsPlacesMediaUrl(url) {
  var low = String(url || "").toLowerCase();




  return (
    low.indexOf("places.googleapis.com/v1/places/") > -1 &&
    low.indexOf("/photos/") > -1 &&
    low.indexOf("/media") > -1
  );
}




function diqV66AppendParam(url, key, value) {
  var source = String(url || "");
  var encodedKey = encodeURIComponent(String(key || ""));
  var encodedValue = encodeURIComponent(String(value || ""));
  var pattern;




  if (!source || !encodedKey) { return source; }




  pattern = new RegExp("([?&])" + encodedKey + "=[^&]*", "i");




  if (pattern.test(source)) {
    return source.replace(
      pattern,
      "$1" + encodedKey + "=" + encodedValue
    );
  }




  return source +
    (source.indexOf("?") > -1 ? "&" : "?") +
    encodedKey + "=" + encodedValue;
}




function diqV66NormalizePlacesMediaUrl(url) {
  var out = clean(url);
  var key = "";




  if (!out || !diqV66IsPlacesMediaUrl(out)) { return out; }




  try { key = diqGooglePlacesApiKey(); } catch (e0) { key = ""; }




  out = diqV66AppendParam(out, "maxWidthPx", "1400");
  out = diqV66AppendParam(out, "maxHeightPx", "1000");
  out = diqV66AppendParam(out, "skipHttpRedirect", "false");




  if (
    key &&
    out.toLowerCase().indexOf("key=") < 0
  ) {
    out = diqV66AppendParam(out, "key", key);
  }




  return out;
}




function diqV66PlacesJsonUrl(url) {
  var out = diqV66NormalizePlacesMediaUrl(url);




  if (!out || !diqV66IsPlacesMediaUrl(out)) { return ""; }




  out = diqV66AppendParam(
    out,
    "skipHttpRedirect",
    "true"
  );




  return out;
}




function diqV66AddCandidate(list, url, kind) {
  var u = clean(url);
  var i;




  if (!u || !diqLooksLikeImageUrl(u)) { return; }




  if (diqV66IsPlacesMediaUrl(u)) {
    u = diqV66NormalizePlacesMediaUrl(u);
  }




  for (i = 0; i < list.length; i++) {
    if (list[i].url === u) { return; }
  }




  list.push({
    url:u,
    kind:String(kind || "photo")
  });
}




function diqV66PhotoCandidates(item, query) {
  var list = [];
  var gallery = [];
  var street = [];
  var i;




  if (!item) { return list; }




  diqV66AddCandidate(
    list,
    item.photoUrl,
    item.photoSource || "photoUrl"
  );




  diqV66AddCandidate(
    list,
    item.googlePhotoMediaUrl,
    "places-new"
  );




  diqV66AddCandidate(
    list,
    item.googlePhotoUrl,
    "google-photo"
  );




  try {
    gallery = diqBuildPlaceGallery(
      item,
      query || activeLens
    ) || [];
  } catch (e0) {
    gallery = [];
  }




  for (i = 0; i < gallery.length; i++) {
    if (
      gallery[i] &&
      gallery[i].kind !== "map"
    ) {
      diqV66AddCandidate(
        list,
        gallery[i].url,
        gallery[i].kind || "gallery"
      );
    }
  }




  diqV66AddCandidate(
    list,
    item.googleStreetViewUrl,
    "streetview"
  );




  try {
    if (typeof diqV52StreetViewPhotos === "function") {
      street = diqV52StreetViewPhotos(
        item,
        query || activeLens
      ) || [];
    }
  } catch (e1) {
    street = [];
  }




  for (i = 0; i < street.length; i++) {
    diqV66AddCandidate(
      list,
      street[i] && street[i].url,
      "streetview"
    );
  }




  return list;
}




function diqV66Hero() {
  var el = byId("diqAdvInfoPhoto");




  if (el) { return el; }




  try {
    el = document.querySelector(
      "#diqAdventureInfoCard .diqAdvPhoto"
    );
  } catch (e0) {
    el = null;
  }




  if (el) { return el; }




  try {
    el = document.querySelector(".diqAdvPhoto");
  } catch (e1) {
    el = null;
  }




  return el || null;
}




function diqV66ClearOldImages(photo) {
  var imgs = [];
  var i;




  if (!photo) { return; }




  try {
    imgs = photo.querySelectorAll(
      ".diqV58LivePhotoImg," +
      ".diqV59LoadTruthImg," +
      ".diqV62LivePhotoImg," +
      ".diqV66DirectPhotoImg"
    );
  } catch (e0) {
    imgs = [];
  }




  for (i = 0; i < imgs.length; i++) {
    try {
      imgs[i].onload = null;
      imgs[i].onerror = null;
      imgs[i].removeAttribute("src");
      imgs[i].parentNode.removeChild(imgs[i]);
    } catch (e1) {}
  }
}




function diqV66CreateImage(photo) {
  var img;




  diqV66ClearOldImages(photo);




  img = document.createElement("img");
  img.className = "diqV66DirectPhotoImg";
  img.alt = "";
  img.setAttribute("aria-hidden", "true");




  try { img.removeAttribute("crossorigin"); } catch (e0) {}
  try { img.referrerPolicy = "no-referrer"; } catch (e1) {}
  try { img.decoding = "async"; } catch (e2) {}




  img.style.setProperty("position", "absolute", "important");
  img.style.setProperty("inset", "0", "important");
  img.style.setProperty("width", "100%", "important");
  img.style.setProperty("height", "100%", "important");
  img.style.setProperty("object-fit", "cover", "important");
  img.style.setProperty("object-position", "center", "important");
  img.style.setProperty("display", "block", "important");
  img.style.setProperty("visibility", "visible", "important");
  img.style.setProperty("opacity", "0", "important");
  img.style.setProperty("z-index", "1", "important");
  img.style.setProperty("pointer-events", "none", "important");
  img.style.setProperty(
    "transition",
    "opacity .22s ease",
    "important"
  );




  photo.style.setProperty("position", "relative", "important");
  photo.style.setProperty("overflow", "hidden", "important");




  try {
    photo.insertBefore(img, photo.firstChild);
  } catch (e3) {
    try { photo.appendChild(img); } catch (e4) {}
  }




  return img;
}




function diqV66Debug(item, status, detail, url) {
  try {
    diqSetPhotoDebug(
      item,
      "v66-direct-photo-uri",
      {
        status:String(status || ""),
        msg:"direct photo uri rescue",
        details:"v66:" + String(detail || ""),
        url:String(url || ""),
        source:"Photo IQ V66"
      }
    );
  } catch (e0) {}




  try {
    diqV39RenderPhotoDebug(
      item,
      activeLens,
      "v66-" + String(status || "")
    );
  } catch (e1) {}
}




function diqV66CommitSuccess(
  item,
  photo,
  img,
  url,
  kind
) {
  var key = diqV66PhotoKey(item);




  diqV66PhotoState[key] = {
    success:true,
    url:String(url || ""),
    kind:String(kind || "photo"),
    ts:Date.now()
  };




  item.photoUrl = String(url || "");
  item.photoSource = String(kind || "Photo IQ V66");
  item.photoLoaded = true;
  item.photoStatus = "LOAD:YES";
  item.photoDebugLastUrl = String(url || "");




  photo.className =
    String(photo.className || "")
      .replace(/\bstablePhotoFallback\b/g, "")
      .replace(/\bphotoFallback\b/g, "") +
    " realPhoto photoLive v66PhotoLive";




  photo.setAttribute("data-photo-live", "1");
  photo.setAttribute("data-v66-photo", "1");
  photo.setAttribute("data-photo-url", String(url || ""));




  img.style.setProperty("opacity", "1", "important");




  diqV66Debug(
    item,
    "LOAD:YES",
    String(kind || "photo") + " " +
      String(img.naturalWidth || 0) + "x" +
      String(img.naturalHeight || 0),
    img.currentSrc || img.src || url
  );




  /* Debug is useful only when broken. Hide it after the real image paints. */
  window.setTimeout(function () {
    var debug = byId("diqPhotoDebugIQ");
    if (debug) {
      debug.style.setProperty(
        "display",
        "none",
        "important"
      );
    }
  }, 400);
}




function diqV66TryImage(
  item,
  photo,
  candidate,
  success,
  failure
) {
  var img = diqV66CreateImage(photo);
  var settled = false;
  var timeout;




  function fail(reason) {
    if (settled) { return; }
    settled = true;
    window.clearTimeout(timeout);




    try {
      img.onload = null;
      img.onerror = null;
      img.removeAttribute("src");
      if (img.parentNode) {
        img.parentNode.removeChild(img);
      }
    } catch (e0) {}




    failure(reason || "load-error");
  }




  img.onload = function () {
    if (settled) { return; }




    if (
      Number(img.naturalWidth || 0) < 80 ||
      Number(img.naturalHeight || 0) < 60
    ) {
      fail("image-too-small");
      return;
    }




    settled = true;
    window.clearTimeout(timeout);




    diqV66CommitSuccess(
      item,
      photo,
      img,
      candidate.url,
      candidate.kind
    );




    success(candidate.url);
  };




  img.onerror = function () {
    fail("img-error");
  };




  timeout = window.setTimeout(function () {
    fail("img-timeout");
  }, 9000);




  diqV66Debug(
    item,
    "LOAD:TRY",
    candidate.kind,
    candidate.url
  );




  try {
    img.src = candidate.url;
  } catch (e1) {
    fail("src-exception");
  }
}




function diqV66ResolveDirectPhotoUri(
  mediaUrl,
  done
) {
  var jsonUrl = diqV66PlacesJsonUrl(mediaUrl);




  if (
    !jsonUrl ||
    !window.fetch ||
    !diqV66IsPlacesMediaUrl(mediaUrl)
  ) {
    done("");
    return;
  }




  try {
    fetch(
      jsonUrl,
      {
        method:"GET",
        credentials:"omit",
        cache:"no-store",
        headers:{
          "Accept":"application/json"
        }
      }
    )
      .then(function (res) {
        if (!res || !res.ok) { return null; }
        return res.json();
      })
      .then(function (data) {
        var uri = clean(
          data && (
            data.photoUri ||
            data.photoURI ||
            data.uri ||
            data.url
          ) || ""
        );




        done(
          uri && diqLooksLikeImageUrl(uri)
            ? uri
            : ""
        );
      })
      .catch(function () {
        done("");
      });
  } catch (e0) {
    done("");
  }
}




function diqV66TryCandidateSequence(
  item,
  photo,
  candidates,
  index
) {
  var candidate;
  var key = diqV66PhotoKey(item);
  var directCandidate;




  if (index >= candidates.length) {
    diqV66PhotoState[key] = {
      success:false,
      exhausted:true,
      ts:Date.now()
    };




    diqV66Debug(
      item,
      "LOAD:NO",
      "all photo candidates exhausted",
      ""
    );




    return;
  }




  candidate = candidates[index];




  if (
    diqV66IsPlacesMediaUrl(candidate.url) &&
    !candidate.directResolved
  ) {
    diqV66ResolveDirectPhotoUri(
      candidate.url,
      function (directUrl) {
        if (directUrl) {
          directCandidate = {
            url:directUrl,
            kind:"places-direct-photo-uri",
            directResolved:true
          };




          diqV66TryImage(
            item,
            photo,
            directCandidate,
            function () {},
            function () {
              candidate.directResolved = true;




              diqV66TryImage(
                item,
                photo,
                candidate,
                function () {},
                function () {
                  diqV66TryCandidateSequence(
                    item,
                    photo,
                    candidates,
                    index + 1
                  );
                }
              );
            }
          );




          return;
        }




        candidate.directResolved = true;




        diqV66TryImage(
          item,
          photo,
          candidate,
          function () {},
          function () {
            diqV66TryCandidateSequence(
              item,
              photo,
              candidates,
              index + 1
            );
          }
        );
      }
    );




    return;
  }




  diqV66TryImage(
    item,
    photo,
    candidate,
    function () {},
    function () {
      diqV66TryCandidateSequence(
        item,
        photo,
        candidates,
        index + 1
      );
    }
  );
}




function diqV66StartPhotoRescue(item, query, stage) {
  var photo = diqV66Hero();
  var key = diqV66PhotoKey(item);
  var state = diqV66PhotoState[key];
  var candidates;




  if (!item || !photo) { return false; }




  if (state && state.success && state.url) {
    return true;
  }




  if (
    state &&
    state.running &&
    Date.now() - Number(state.ts || 0) < 12000
  ) {
    return false;
  }




  candidates = diqV66PhotoCandidates(
    item,
    query || activeLens
  );




  if (!candidates.length) {
    diqV66Debug(
      item,
      "URL:NO",
      "no candidates " + String(stage || ""),
      ""
    );
    return false;
  }




  diqV66PhotoState[key] = {
    running:true,
    success:false,
    ts:Date.now()
  };




  diqV66TryCandidateSequence(
    item,
    photo,
    candidates,
    0
  );




  return true;
}




(function () {
  var style;




  try {
    if (document.getElementById("diqV66DirectPhotoStyle")) {
      return;
    }




    style = document.createElement("style");
    style.id = "diqV66DirectPhotoStyle";
    style.type = "text/css";
    style.appendChild(
      document.createTextNode(
        ".diqAdvPhoto.v66PhotoLive{" +
          "position:relative!important;" +
          "overflow:hidden!important;" +
          "background:#061018!important;" +
        "}" +
        ".diqAdvPhoto.v66PhotoLive .diqV66DirectPhotoImg{" +
          "position:absolute!important;" +
          "inset:0!important;" +
          "width:100%!important;" +
          "height:100%!important;" +
          "object-fit:cover!important;" +
          "object-position:center!important;" +
          "display:block!important;" +
          "visibility:visible!important;" +
          "z-index:1!important;" +
        "}" +
        ".diqAdvPhoto.v66PhotoLive:before{" +
          "display:none!important;" +
        "}" +
        ".diqAdvPhoto.v66PhotoLive:after{" +
          "z-index:2!important;" +
          "background:linear-gradient(" +
            "180deg," +
            "rgba(2,8,18,.02)," +
            "rgba(2,8,18,.10) 46%," +
            "rgba(2,8,18,.74)" +
          ")!important;" +
        "}"
      )
    );




    document.head.appendChild(style);
  } catch (e0) {}
})();




diqApplyPlaceGallery = function (item, query) {
  var out = diqV66OriginalApplyGallery(
    item,
    query || activeLens
  );




  window.setTimeout(function () {
    try {
      diqV66StartPhotoRescue(
        item,
        query || activeLens,
        "apply-80"
      );
    } catch (e0) {}
  }, 80);




  window.setTimeout(function () {
    try {
      diqV66StartPhotoRescue(
        item,
        query || activeLens,
        "apply-850"
      );
    } catch (e1) {}
  }, 850);




  window.setTimeout(function () {
    try {
      diqV66StartPhotoRescue(
        item,
        query || activeLens,
        "apply-2400"
      );
    } catch (e2) {}
  }, 2400);




  return out;
};




try {
  console.log(
    "âœ… Drive IQ V66 Direct Photo URI Rescue IQ loaded"
  );
} catch (e0) {}
















/* =========================================================
   DRIVE IQ V67 â€” CLOUDFLARE PHOTO RESOLVER IQ




   Uses the live Drive IQ Worker as the first photo authority:
   https://drive-iq-photo-resolver.loveforlocals.workers.dev




   Flow:
   - Send place name + coordinates + optional Google Place ID to /resolve
   - Receive same-origin Worker imageUrl
   - Paint Worker /photo bytes directly into the Place IQ hero
   - Persist the resolved Place ID and Worker image URL on the item
   - Fall back to the existing V66 ladder only if the Worker fails
   - Hide Photo Debug IQ after a successful real photo paint
========================================================= */




window.__DRIVE_IQ_ADVENTURE_MODE_JS_V67_CLOUDFLARE_PHOTO_RESOLVER__ = true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD = "V67_CLOUDFLARE_PHOTO_RESOLVER_IQ";




var DIQ_PHOTO_RESOLVER_BASE =
  "https://drive-iq-photo-resolver.loveforlocals.workers.dev";




var diqV67PhotoRequests = {};
var diqV67OriginalApplyGallery = diqApplyPlaceGallery;




function diqV67PhotoKey(item) {
  var key = "";




  try {
    key = diqPhotoCacheKey
      ? diqPhotoCacheKey(item)
      : "";
  } catch (e0) {
    key = "";
  }




  if (!key && item) {
    key = clean(
      String(item.label || "") + "|" +
      String(item.lat || "") + "|" +
      String(item.lng || "")
    );
  }




  return key || "active-card";
}




function diqV67GooglePlaceId(item) {
  if (!item) { return ""; }




  return clean(
    item.googlePlaceId ||
    item.google_place_id ||
    item.placeId ||
    item.place_id ||
    item.googleId ||
    ""
  );
}




function diqV67ValidItem(item) {
  return !!(
    item &&
    clean(item.label) &&
    finite(Number(item.lat)) &&
    finite(Number(item.lng))
  );
}




function diqV67ResolvePayload(item) {
  return {
    name:clean(item.label || ""),
    lat:Number(item.lat),
    lng:Number(item.lng),
    placeId:diqV67GooglePlaceId(item)
  };
}




function diqV67ResolveUrl() {
  return DIQ_PHOTO_RESOLVER_BASE + "/resolve";
}




function diqV67ImageUrl(item) {
  var url = clean(
    item && (
      item.workerPhotoUrl ||
      item.photoProxyUrl ||
      item.driveIQPhotoUrl
    ) || ""
  );




  return url;
}




function diqV67PhotoHero() {
  var el = byId("diqAdvInfoPhoto");




  if (el) { return el; }




  try {
    el = document.querySelector(
      "#diqAdventureInfoCard .diqAdvPhoto"
    );
  } catch (e0) {
    el = null;
  }




  if (el) { return el; }




  try {
    el = document.querySelector(".diqAdvPhoto");
  } catch (e1) {
    el = null;
  }




  return el || null;
}




function diqV67RemovePhotoDebug() {
  var debug = byId("diqPhotoDebugIQ");




  if (debug) {
    debug.style.setProperty(
      "display",
      "none",
      "important"
    );
  }
}




function diqV67PaintWorkerPhoto(item, imageUrl, stage) {
  var photo = diqV67PhotoHero();
  var img;
  var timeout;
  var settled = false;




  if (!photo || !imageUrl) { return false; }




  try {
    var old = photo.querySelectorAll(
      ".diqV67WorkerPhoto"
    );
    var i;




    for (i = 0; i < old.length; i++) {
      if (old[i] && old[i].parentNode) {
        old[i].parentNode.removeChild(old[i]);
      }
    }
  } catch (cleanupErr) {}




  img = document.createElement("img");
  img.className = "diqV67WorkerPhoto";
  img.alt = "";
  img.setAttribute("aria-hidden", "true");




  try { img.removeAttribute("crossorigin"); } catch (e0) {}
  try { img.referrerPolicy = "no-referrer"; } catch (e1) {}
  try { img.decoding = "async"; } catch (e2) {}




  img.style.setProperty("position", "absolute", "important");
  img.style.setProperty("inset", "0", "important");
  img.style.setProperty("width", "100%", "important");
  img.style.setProperty("height", "100%", "important");
  img.style.setProperty("object-fit", "cover", "important");
  img.style.setProperty("object-position", "center", "important");
  img.style.setProperty("display", "block", "important");
  img.style.setProperty("visibility", "visible", "important");
  img.style.setProperty("opacity", "0", "important");
  img.style.setProperty("z-index", "1", "important");
  img.style.setProperty("pointer-events", "none", "important");
  img.style.setProperty(
    "transition",
    "opacity .22s ease",
    "important"
  );




  photo.style.setProperty("position", "relative", "important");
  photo.style.setProperty("overflow", "hidden", "important");




  try {
    photo.insertBefore(img, photo.firstChild);
  } catch (e3) {
    try { photo.appendChild(img); } catch (e4) {}
  }




  function fail(reason) {
    if (settled) { return; }
    settled = true;
    window.clearTimeout(timeout);




    try {
      img.onload = null;
      img.onerror = null;
      img.removeAttribute("src");




      if (img.parentNode) {
        img.parentNode.removeChild(img);
      }
    } catch (e5) {}




    try {
      console.warn(
        "Drive IQ V67 Worker photo paint failed",
        reason,
        imageUrl
      );
    } catch (e6) {}
  }




  img.onload = function () {
    if (settled) { return; }




    if (
      Number(img.naturalWidth || 0) < 100 ||
      Number(img.naturalHeight || 0) < 70
    ) {
      fail("image-too-small");
      return;
    }




    settled = true;
    window.clearTimeout(timeout);




    item.photoUrl = imageUrl;
    item.workerPhotoUrl = imageUrl;
    item.photoSource = "Drive IQ Photo Worker";
    item.photoLoaded = true;
    item.photoStatus = "LOAD:YES";




    photo.className =
      String(photo.className || "")
        .replace(/\bstablePhotoFallback\b/g, "")
        .replace(/\bphotoFallback\b/g, "") +
      " realPhoto photoLive v67WorkerPhotoLive";




    photo.setAttribute("data-photo-live", "1");
    photo.setAttribute("data-v67-worker-photo", "1");
    photo.setAttribute("data-photo-url", imageUrl);




    img.style.setProperty("opacity", "1", "important");




    diqV67RemovePhotoDebug();




    try {
      diqSetPhotoDebug(
        item,
        "v67-worker-photo",
        {
          status:"LOAD:YES",
          msg:"Cloudflare Worker photo loaded",
          details:
            "v67:" +
            String(stage || "worker") +
            " " +
            String(img.naturalWidth || 0) +
            "x" +
            String(img.naturalHeight || 0),
          url:imageUrl,
          source:"Drive IQ Photo Worker"
        }
      );
    } catch (e7) {}




    try {
      console.log(
        "âœ… Drive IQ V67 Worker photo painted",
        item.label,
        imageUrl
      );
    } catch (e8) {}
  };




  img.onerror = function () {
    fail("img-error");
  };




  timeout = window.setTimeout(function () {
    fail("img-timeout");
  }, 12000);




  try {
    img.src = imageUrl;
  } catch (e9) {
    fail("src-exception");
  }




  return true;
}




function diqV67ResolveWorkerPhoto(item, query, stage) {
  var key;
  var existing;
  var payload;
  var controller;
  var timeout;




  if (!diqV67ValidItem(item)) { return false; }




  existing = diqV67ImageUrl(item);




  if (existing) {
    return diqV67PaintWorkerPhoto(
      item,
      existing,
      stage || "cached"
    );
  }




  key = diqV67PhotoKey(item);




  if (
    diqV67PhotoRequests[key] &&
    diqV67PhotoRequests[key].running &&
    Date.now() -
      Number(diqV67PhotoRequests[key].startedAt || 0) <
      15000
  ) {
    return false;
  }




  payload = diqV67ResolvePayload(item);
  controller = window.AbortController
    ? new AbortController()
    : null;




  diqV67PhotoRequests[key] = {
    running:true,
    startedAt:Date.now()
  };




  if (controller) {
    timeout = window.setTimeout(function () {
      try { controller.abort(); } catch (e0) {}
    }, 12000);
  }




  try {
    fetch(
      diqV67ResolveUrl(),
      {
        method:"POST",
        headers:{
          "Content-Type":"application/json"
        },
        body:JSON.stringify(payload),
        credentials:"omit",
        cache:"no-store",
        signal:controller
          ? controller.signal
          : undefined
      }
    )
      .then(function (response) {
        if (!response || !response.ok) {
          return response
            ? response.text().then(function (text) {
                throw new Error(
                  "Worker " +
                  response.status +
                  " " +
                  String(text || "").slice(0, 220)
                );
              })
            : Promise.reject(
                new Error("Worker response missing")
              );
        }




        return response.json();
      })
      .then(function (data) {
        var imageUrl;




        if (timeout) {
          window.clearTimeout(timeout);
        }




        diqV67PhotoRequests[key] = {
          running:false,
          success:!!(
            data &&
            data.ok &&
            data.imageUrl
          ),
          startedAt:Date.now()
        };




        if (
          !data ||
          data.ok !== true ||
          !clean(data.imageUrl)
        ) {
          throw new Error(
            clean(
              data && data.error
                ? data.error
                : "Worker returned no imageUrl"
            )
          );
        }




        imageUrl = clean(data.imageUrl);




        item.workerPhotoUrl = imageUrl;
        item.photoProxyUrl = imageUrl;
        item.driveIQPhotoUrl = imageUrl;
        item.photoUrl = imageUrl;
        item.photoSource = "Drive IQ Photo Worker";




        if (clean(data.placeId)) {
          item.googlePlaceId = clean(data.placeId);
          item.placeId = clean(data.placeId);
        }




        if (data.attributions) {
          item.photoAttributions = data.attributions;
        }




        diqV67PaintWorkerPhoto(
          item,
          imageUrl,
          stage || "resolve"
        );
      })
      .catch(function (error) {
        if (timeout) {
          window.clearTimeout(timeout);
        }




        diqV67PhotoRequests[key] = {
          running:false,
          success:false,
          startedAt:Date.now(),
          error:clean(
            error && error.message
              ? error.message
              : error
          )
        };




        try {
          diqSetPhotoDebug(
            item,
            "v67-worker-failed",
            {
              status:"LOAD:NO",
              msg:"Cloudflare Worker photo failed",
              details:
                "v67:" +
                clean(
                  error && error.message
                    ? error.message
                    : error
                ),
              url:diqV67ResolveUrl(),
              source:"Drive IQ Photo Worker"
            }
          );
        } catch (debugErr) {}




        try {
          console.warn(
            "Drive IQ V67 Worker photo failed",
            item.label,
            error
          );
        } catch (logErr) {}
      });
  } catch (e1) {
    if (timeout) {
      window.clearTimeout(timeout);
    }




    diqV67PhotoRequests[key] = {
      running:false,
      success:false,
      startedAt:Date.now(),
      error:clean(e1 && e1.message ? e1.message : e1)
    };
  }




  return true;
}




(function () {
  var style;




  try {
    if (
      document.getElementById(
        "diqV67WorkerPhotoStyle"
      )
    ) {
      return;
    }




    style = document.createElement("style");
    style.id = "diqV67WorkerPhotoStyle";
    style.type = "text/css";
    style.appendChild(
      document.createTextNode(
        ".diqAdvPhoto.v67WorkerPhotoLive{" +
          "position:relative!important;" +
          "overflow:hidden!important;" +
          "background:#061018!important;" +
        "}" +
        ".diqAdvPhoto.v67WorkerPhotoLive " +
        ".diqV67WorkerPhoto{" +
          "position:absolute!important;" +
          "inset:0!important;" +
          "width:100%!important;" +
          "height:100%!important;" +
          "object-fit:cover!important;" +
          "object-position:center!important;" +
          "display:block!important;" +
          "visibility:visible!important;" +
          "z-index:1!important;" +
        "}" +
        ".diqAdvPhoto.v67WorkerPhotoLive:before{" +
          "display:none!important;" +
        "}" +
        ".diqAdvPhoto.v67WorkerPhotoLive:after{" +
          "z-index:2!important;" +
          "background:linear-gradient(" +
            "180deg," +
            "rgba(2,8,18,.02)," +
            "rgba(2,8,18,.10) 48%," +
            "rgba(2,8,18,.72)" +
          ")!important;" +
        "}"
      )
    );




    document.head.appendChild(style);
  } catch (e0) {}
})();




diqApplyPlaceGallery = function (item, query) {
  var out = diqV67OriginalApplyGallery(
    item,
    query || activeLens
  );




  window.setTimeout(function () {
    try {
      diqV67ResolveWorkerPhoto(
        item,
        query || activeLens,
        "apply-40"
      );
    } catch (e0) {}
  }, 40);




  window.setTimeout(function () {
    try {
      diqV67ResolveWorkerPhoto(
        item,
        query || activeLens,
        "apply-700"
      );
    } catch (e1) {}
  }, 700);




  window.setTimeout(function () {
    try {
      diqV67ResolveWorkerPhoto(
        item,
        query || activeLens,
        "apply-2200"
      );
    } catch (e2) {}
  }, 2200);




  return out;
};




try {
  console.log(
    "âœ… Drive IQ V67 Cloudflare Photo Resolver IQ loaded"
  );
} catch (e0) {}
















/* =========================================================
   DRIVE IQ V68 â€” PLACE IQ CARD LAYOUT POLISH




   Presentation-only pass.
   Frozen:
   - Cloudflare photo resolver
   - scan/ranking/category truth
   - local-food logic
   - map behavior
   - routing handoff




   Improvements:
   - Removes PHOTO IQ pill
   - Keeps one PLACE IQ identity badge
   - Locks title/category fully inside hero
   - Rebuilds Worth the Drive score circle
   - Prevents circle text and chip clipping
   - Reduces dead space and total card height
   - Limits decision-confidence list to 3 strongest signals
   - Improves freshness copy
   - Keeps Route Here dominant
   - Makes Save/Drop quieter
   - Hides production photo debug UI
   - Adds subtle photo loading shimmer
========================================================= */




window.__DRIVE_IQ_ADVENTURE_MODE_JS_V68_PLACE_CARD_POLISH__ = true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD = "V68_PLACE_CARD_LAYOUT_POLISH";




var diqV68OriginalOpenAdventureInfoCard =
  openAdventureInfoCard;




function diqV68InjectStyles() {
  var style;
  var css;




  if (byId("diqV68PlaceCardPolishStyle")) {
    return;
  }




  css =
    "/* Card shell */" +
    "#diqAdventureInfoCard.diqConversionIQ{" +
      "left:18px!important;" +
      "right:18px!important;" +
      "border-radius:28px!important;" +
      "overflow:hidden!important;" +
      "max-height:calc(100vh - 144px - env(safe-area-inset-top,0px) - env(safe-area-inset-bottom,0px))!important;" +
    "}" +




    "/* Hero */" +
    "#diqAdventureInfoCard.diqConversionIQ .diqPlaceHero{" +
      "height:210px!important;" +
      "min-height:210px!important;" +
      "overflow:hidden!important;" +
    "}" +
    "#diqAdventureInfoCard.diqConversionIQ .diqAdvPhoto{" +
      "position:absolute!important;" +
      "inset:0!important;" +
      "width:100%!important;" +
      "height:100%!important;" +
      "transform:none!important;" +
      "background-position:center!important;" +
      "background-size:cover!important;" +
    "}" +
    "#diqAdventureInfoCard.diqConversionIQ .diqPlaceHeroShade{" +
      "background:linear-gradient(" +
        "180deg," +
        "rgba(2,8,18,.10) 0%," +
        "rgba(2,8,18,.04) 28%," +
        "rgba(2,8,18,.22) 56%," +
        "rgba(2,8,18,.92) 100%" +
      ")!important;" +
    "}" +




    "/* Remove duplicate photo label */" +
    "#diqAdventureInfoCard.diqConversionIQ .diqPhotoHint{" +
      "display:none!important;" +
    "}" +




    "/* Top row */" +
    "#diqAdventureInfoCard.diqConversionIQ .diqPlaceTopRow{" +
      "left:16px!important;" +
      "right:16px!important;" +
      "top:15px!important;" +
      "align-items:flex-start!important;" +
    "}" +
    "#diqAdventureInfoCard.diqConversionIQ .diqAdvKicker{" +
      "min-height:30px!important;" +
      "padding:0 13px!important;" +
      "border-radius:999px!important;" +
      "background:rgba(2,12,22,.72)!important;" +
      "border:1px solid rgba(40,255,190,.42)!important;" +
      "backdrop-filter:blur(14px)!important;" +
      "-webkit-backdrop-filter:blur(14px)!important;" +
      "font-size:8px!important;" +
      "letter-spacing:1.55px!important;" +
      "display:inline-flex!important;" +
      "align-items:center!important;" +
      "justify-content:center!important;" +
    "}" +
    "#diqAdventureInfoCard.diqConversionIQ .diqAdvClose{" +
      "position:relative!important;" +
      "top:0!important;" +
      "right:0!important;" +
      "width:42px!important;" +
      "height:42px!important;" +
      "min-width:42px!important;" +
      "border-radius:999px!important;" +
      "background:rgba(2,10,18,.72)!important;" +
      "border:1px solid rgba(255,255,255,.24)!important;" +
      "backdrop-filter:blur(14px)!important;" +
      "-webkit-backdrop-filter:blur(14px)!important;" +
      "font-size:25px!important;" +
      "line-height:1!important;" +
      "z-index:8!important;" +
    "}" +




    "/* Title stays inside hero */" +
    "#diqAdventureInfoCard.diqConversionIQ .diqPlaceHeroText{" +
      "left:18px!important;" +
      "right:116px!important;" +
      "bottom:18px!important;" +
      "max-width:calc(100% - 138px)!important;" +
      "overflow:hidden!important;" +
      "z-index:5!important;" +
    "}" +
    "#diqAdventureInfoCard.diqConversionIQ .diqAdvTitle{" +
      "margin:0!important;" +
      "font-size:26px!important;" +
      "line-height:1.02!important;" +
      "font-weight:1000!important;" +
      "letter-spacing:-.75px!important;" +
      "color:#fff!important;" +
      "text-shadow:0 3px 16px rgba(0,0,0,.76)!important;" +
      "white-space:normal!important;" +
      "overflow-wrap:anywhere!important;" +
      "display:-webkit-box!important;" +
      "-webkit-box-orient:vertical!important;" +
      "-webkit-line-clamp:2!important;" +
      "overflow:hidden!important;" +
    "}" +
    "#diqAdventureInfoCard.diqConversionIQ .diqPlaceCategory{" +
      "margin-top:4px!important;" +
      "font-size:10.5px!important;" +
      "line-height:1.1!important;" +
      "font-weight:800!important;" +
      "color:rgba(255,255,255,.78)!important;" +
      "text-shadow:0 2px 10px rgba(0,0,0,.72)!important;" +
      "white-space:nowrap!important;" +
      "overflow:hidden!important;" +
      "text-overflow:ellipsis!important;" +
    "}" +




    "/* Score circle rebuilt */" +
    "#diqAdventureInfoCard.diqConversionIQ .diqPlaceScore{" +
      "right:16px!important;" +
      "bottom:17px!important;" +
      "width:88px!important;" +
      "height:88px!important;" +
      "min-width:88px!important;" +
      "min-height:88px!important;" +
      "padding:8px!important;" +
      "box-sizing:border-box!important;" +
      "border:2px solid #ffcf67!important;" +
      "background:radial-gradient(" +
        "circle at 38% 28%," +
        "rgba(255,238,155,.22)," +
        "rgba(4,12,22,.94) 58%" +
      ")!important;" +
      "box-shadow:" +
        "0 0 28px rgba(255,206,105,.34)," +
        "inset 0 0 18px rgba(255,206,105,.08)!important;" +
      "overflow:hidden!important;" +
      "text-align:center!important;" +
      "z-index:6!important;" +
    "}" +
    "#diqAdventureInfoCard.diqConversionIQ .diqPlaceScoreValue{" +
      "font-size:31px!important;" +
      "line-height:.92!important;" +
      "font-weight:1000!important;" +
      "letter-spacing:-1px!important;" +
      "color:#ffdc7c!important;" +
      "display:block!important;" +
      "max-width:100%!important;" +
    "}" +
    "#diqAdventureInfoCard.diqConversionIQ .diqPlaceScoreLabel{" +
      "display:block!important;" +
      "width:64px!important;" +
      "max-width:64px!important;" +
      "margin:6px auto 0!important;" +
      "font-size:6.5px!important;" +
      "line-height:1.05!important;" +
      "font-weight:1000!important;" +
      "letter-spacing:.78px!important;" +
      "text-align:center!important;" +
      "white-space:normal!important;" +
      "overflow-wrap:normal!important;" +
      "word-break:normal!important;" +
      "color:#ffe6a3!important;" +
      "text-transform:uppercase!important;" +
    "}" +




    "/* Gallery dots */" +
    "#diqAdventureInfoCard.diqConversionIQ .diqPhotoGalleryNav{" +
      "bottom:7px!important;" +
      "z-index:7!important;" +
    "}" +




    "/* Body spacing */" +
    "#diqAdventureInfoCard.diqConversionIQ .diqPlaceBody{" +
      "padding:13px 14px calc(14px + env(safe-area-inset-bottom,0px))!important;" +
    "}" +




    "/* Chips never clip */" +
    "#diqAdventureInfoCard.diqConversionIQ .diqAdvWorth{" +
      "display:flex!important;" +
      "flex-wrap:nowrap!important;" +
      "gap:7px!important;" +
      "margin:0!important;" +
      "padding:1px 14px 5px 0!important;" +
      "overflow-x:auto!important;" +
      "overflow-y:hidden!important;" +
      "scroll-padding-right:18px!important;" +
      "-webkit-overflow-scrolling:touch!important;" +
      "scrollbar-width:none!important;" +
      "mask-image:linear-gradient(to right,#000 0%,#000 92%,transparent 100%)!important;" +
      "-webkit-mask-image:linear-gradient(to right,#000 0%,#000 92%,transparent 100%)!important;" +
    "}" +
    "#diqAdventureInfoCard.diqConversionIQ .diqAdvWorth::-webkit-scrollbar{" +
      "display:none!important;" +
    "}" +
    "#diqAdventureInfoCard.diqConversionIQ .diqAdvTag{" +
      "flex:0 0 auto!important;" +
      "min-height:31px!important;" +
      "padding:0 11px!important;" +
      "font-size:7.6px!important;" +
      "white-space:nowrap!important;" +
    "}" +




    "/* Why section */" +
    "#diqAdventureInfoCard.diqConversionIQ .diqPlaceWhy{" +
      "margin-top:10px!important;" +
      "padding:12px!important;" +
      "border-radius:17px!important;" +
    "}" +
    "#diqAdventureInfoCard.diqConversionIQ .diqPlaceWhyLabel{" +
      "font-size:8px!important;" +
      "letter-spacing:1.15px!important;" +
    "}" +
    "#diqAdventureInfoCard.diqConversionIQ .diqAdvSub{" +
      "margin-top:7px!important;" +
      "font-size:12px!important;" +
      "line-height:1.34!important;" +
      "display:-webkit-box!important;" +
      "-webkit-box-orient:vertical!important;" +
      "-webkit-line-clamp:2!important;" +
      "overflow:hidden!important;" +
    "}" +
    "#diqAdventureInfoCard.diqConversionIQ .diqTrustBecause{" +
      "margin-top:10px!important;" +
      "display:grid!important;" +
      "gap:7px!important;" +
    "}" +
    "#diqAdventureInfoCard.diqConversionIQ .diqTrustReason{" +
      "min-height:38px!important;" +
      "padding:8px 10px!important;" +
      "font-size:9.5px!important;" +
      "line-height:1.18!important;" +
      "border-radius:14px!important;" +
      "box-sizing:border-box!important;" +
    "}" +
    "#diqAdventureInfoCard.diqConversionIQ .diqTrustReason:nth-child(n+4){" +
      "display:none!important;" +
    "}" +




    "/* Facts */" +
    "#diqAdventureInfoCard.diqConversionIQ .diqPlaceFacts{" +
      "margin-top:10px!important;" +
      "border-radius:16px!important;" +
    "}" +
    "#diqAdventureInfoCard.diqConversionIQ .diqPlaceFact{" +
      "min-width:0!important;" +
      "padding:10px 6px!important;" +
    "}" +
    "#diqAdventureInfoCard.diqConversionIQ .diqPlaceFactStrong{" +
      "font-size:9.8px!important;" +
      "line-height:1.15!important;" +
      "white-space:normal!important;" +
      "display:-webkit-box!important;" +
      "-webkit-box-orient:vertical!important;" +
      "-webkit-line-clamp:2!important;" +
      "overflow:hidden!important;" +
    "}" +
    "#diqAdventureInfoCard.diqConversionIQ .diqPlaceFactSmall{" +
      "margin-top:3px!important;" +
      "font-size:7.5px!important;" +
    "}" +




    "/* Actions */" +
    "#diqAdventureInfoCard.diqConversionIQ .diqAdvActions{" +
      "display:grid!important;" +
      "grid-template-columns:1fr 1fr!important;" +
      "gap:8px!important;" +
      "margin-top:11px!important;" +
    "}" +
    "#diqAdventureInfoCard.diqConversionIQ .diqAdvRoute{" +
      "grid-column:1/-1!important;" +
      "grid-row:1!important;" +
      "height:56px!important;" +
      "min-height:56px!important;" +
      "border-radius:18px!important;" +
      "font-size:13px!important;" +
      "letter-spacing:1.35px!important;" +
    "}" +
    "#diqAdventureInfoCard.diqConversionIQ .diqAdvSave," +
    "#diqAdventureInfoCard.diqConversionIQ .diqAdvDrop{" +
      "grid-row:2!important;" +
      "height:43px!important;" +
      "min-height:43px!important;" +
      "border-radius:15px!important;" +
      "background:rgba(7,15,25,.76)!important;" +
      "border-color:rgba(255,255,255,.18)!important;" +
      "color:rgba(255,255,255,.82)!important;" +
      "font-size:9px!important;" +
      "letter-spacing:.7px!important;" +
      "box-shadow:none!important;" +
    "}" +




    "/* Production debug hidden */" +
    "#diqAdventureInfoCard .diqPhotoDebugIQ," +
    "#diqPhotoDebugIQ{" +
      "display:none!important;" +
      "visibility:hidden!important;" +
      "pointer-events:none!important;" +
    "}" +




    "/* Loading shimmer */" +
    "#diqAdventureInfoCard.diqConversionIQ .diqAdvPhoto:not(.photoLive):not(.v67WorkerPhotoLive):after{" +
      "content:''!important;" +
      "position:absolute!important;" +
      "inset:0!important;" +
      "z-index:1!important;" +
      "background:linear-gradient(" +
        "110deg," +
        "transparent 18%," +
        "rgba(255,255,255,.10) 38%," +
        "transparent 58%" +
      ")!important;" +
      "background-size:220% 100%!important;" +
      "animation:diqV68PhotoShimmer 1.35s ease-in-out infinite!important;" +
      "pointer-events:none!important;" +
    "}" +
    "@keyframes diqV68PhotoShimmer{" +
      "0%{background-position:180% 0;}" +
      "100%{background-position:-40% 0;}" +
    "}" +




    "/* Small phones */" +
    "@media(max-width:390px){" +
      "#diqAdventureInfoCard.diqConversionIQ{" +
        "left:11px!important;" +
        "right:11px!important;" +
      "}" +
      "#diqAdventureInfoCard.diqConversionIQ .diqPlaceHero{" +
        "height:194px!important;" +
        "min-height:194px!important;" +
      "}" +
      "#diqAdventureInfoCard.diqConversionIQ .diqPlaceHeroText{" +
        "left:15px!important;" +
        "right:104px!important;" +
        "max-width:calc(100% - 120px)!important;" +
      "}" +
      "#diqAdventureInfoCard.diqConversionIQ .diqAdvTitle{" +
        "font-size:23px!important;" +
      "}" +
      "#diqAdventureInfoCard.diqConversionIQ .diqPlaceScore{" +
        "right:13px!important;" +
        "width:80px!important;" +
        "height:80px!important;" +
        "min-width:80px!important;" +
        "min-height:80px!important;" +
      "}" +
      "#diqAdventureInfoCard.diqConversionIQ .diqPlaceScoreValue{" +
        "font-size:28px!important;" +
      "}" +
      "#diqAdventureInfoCard.diqConversionIQ .diqPlaceScoreLabel{" +
        "width:58px!important;" +
        "max-width:58px!important;" +
        "font-size:6px!important;" +
      "}" +
    "}" +




    "/* Short screens */" +
    "@media(max-height:760px){" +
      "#diqAdventureInfoCard.diqConversionIQ .diqPlaceHero{" +
        "height:166px!important;" +
        "min-height:166px!important;" +
      "}" +
      "#diqAdventureInfoCard.diqConversionIQ .diqAdvTitle{" +
        "font-size:21px!important;" +
      "}" +
      "#diqAdventureInfoCard.diqConversionIQ .diqPlaceScore{" +
        "width:72px!important;" +
        "height:72px!important;" +
        "min-width:72px!important;" +
        "min-height:72px!important;" +
      "}" +
      "#diqAdventureInfoCard.diqConversionIQ .diqPlaceScoreValue{" +
        "font-size:25px!important;" +
      "}" +
      "#diqAdventureInfoCard.diqConversionIQ .diqPlaceScoreLabel{" +
        "width:52px!important;" +
        "max-width:52px!important;" +
        "font-size:5.6px!important;" +
        "margin-top:4px!important;" +
      "}" +
      "#diqAdventureInfoCard.diqConversionIQ .diqPlaceHeroText{" +
        "right:94px!important;" +
        "bottom:14px!important;" +
      "}" +
      "#diqAdventureInfoCard.diqConversionIQ .diqPlaceWhy{" +
        "padding:10px!important;" +
      "}" +
      "#diqAdventureInfoCard.diqConversionIQ .diqTrustReason{" +
        "min-height:34px!important;" +
        "padding:7px 9px!important;" +
      "}" +
      "#diqAdventureInfoCard.diqConversionIQ .diqAdvRoute{" +
        "height:50px!important;" +
        "min-height:50px!important;" +
      "}" +
    "}";




  style = document.createElement("style");
  style.id = "diqV68PlaceCardPolishStyle";
  style.type = "text/css";
  style.appendChild(
    document.createTextNode(css)
  );




  try {
    document.head.appendChild(style);
  } catch (e) {}
}




function diqV68PolishCard(item) {
  var card = byId("diqAdventureInfoCard");
  var hint = byId("diqPhotoHint");
  var debug = byId("diqPhotoDebugIQ");
  var scoreLabel;
  var freshness;
  var confidence;
  var trust;
  var reasons;
  var i;




  if (!card) { return; }




  diqV68InjectStyles();




  card.className =
    "on diqConversionIQ diqV68Polished";




  if (hint) {
    hint.style.display = "none";
    hint.setAttribute("aria-hidden", "true");
  }




  if (debug) {
    debug.style.display = "none";
    debug.setAttribute("aria-hidden", "true");
  }




  try {
    scoreLabel = card.querySelector(
      ".diqPlaceScoreLabel"
    );




    if (scoreLabel) {
      scoreLabel.textContent = "Worth the Drive";
    }
  } catch (e0) {}




  freshness = byId("diqAdvInfoFreshness");




  if (freshness) {
    if (
      !clean(freshness.textContent) ||
      normText(freshness.textContent) === "place iq" ||
      normText(freshness.textContent) === "place iq estimate"
    ) {
      freshness.textContent =
        item && item.photoLoaded
          ? "Live place data"
          : "Place data";
    }
  }




  confidence = byId("diqAdvInfoConfidence");




  if (
    confidence &&
    normText(confidence.textContent) ===
      "strong category fit"
  ) {
    confidence.textContent = "High confidence";
  }




  trust = byId("diqTrustBecause");




  if (trust) {
    try {
      reasons = trust.children || [];




      for (i = 0; i < reasons.length; i++) {
        if (i >= 3) {
          reasons[i].style.display = "none";
          reasons[i].setAttribute(
            "aria-hidden",
            "true"
          );
        } else {
          reasons[i].style.display = "";
          reasons[i].removeAttribute(
            "aria-hidden"
          );
        }
      }
    } catch (e1) {}
  }
}




openAdventureInfoCard = function (
  item,
  preserveBrowseCamera
) {
  var result =
    diqV68OriginalOpenAdventureInfoCard(
      item,
      preserveBrowseCamera
    );




  diqV68PolishCard(item);




  window.setTimeout(function () {
    diqV68PolishCard(item);
  }, 80);




  window.setTimeout(function () {
    diqV68PolishCard(item);
  }, 650);




  return result;
};




diqV68InjectStyles();




try {
  console.log(
    "âœ… Drive IQ V68 Place IQ Card Layout Polish loaded"
  );
} catch (e0) {}
















/* =========================================================
   DRIVE IQ V69 â€” RESULT CARD PHOTO IQ




   Focused presentation/photo pass for the "Choose Adventure Stop" shelf.




   Improvements:
   - Uses the live Cloudflare Worker for each visible result thumbnail
   - Reuses cached workerPhotoUrl/photoUrl when already resolved
   - Staggers up to 8 requests to avoid a network burst
   - Fades real venue photos into thumbnail boxes
   - Keeps premium category fallback while loading
   - Carries the same resolved image into the full Place IQ card
   - Removes duplicate Worth the Drive chips
   - Keeps ranking, map, scan, routing, and full-card photo logic frozen
========================================================= */




window.__DRIVE_IQ_ADVENTURE_MODE_JS_V69_RESULT_CARD_PHOTO_IQ__ = true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD = "V69_RESULT_CARD_PHOTO_IQ";




var diqV69ThumbRequests = {};
var diqV69ThumbGeneration = 0;




function diqV69PhotoKey(item) {
  var key = "";




  try {
    key = diqPhotoCacheKey
      ? diqPhotoCacheKey(item)
      : "";
  } catch (e0) {
    key = "";
  }




  if (!key && item) {
    key = clean(
      String(item.label || "") + "|" +
      String(item.lat || "") + "|" +
      String(item.lng || "")
    );
  }




  return key || "";
}




function diqV69ExistingPhoto(item) {
  var url = "";




  if (!item) { return ""; }




  url = clean(
    item.workerPhotoUrl ||
    item.photoProxyUrl ||
    item.driveIQPhotoUrl ||
    item.photoUrl ||
    ""
  );




  if (
    url &&
    diqLooksLikeImageUrl(url) &&
    String(url).toLowerCase().indexOf(
      "api.mapbox.com/styles"
    ) < 0
  ) {
    return url;
  }




  return "";
}




function diqV69GooglePlaceId(item) {
  if (!item) { return ""; }




  return clean(
    item.googlePlaceId ||
    item.google_place_id ||
    item.placeId ||
    item.place_id ||
    item.googleId ||
    ""
  );
}




function diqV69ThumbNode(item) {
  var key = diqV69PhotoKey(item);
  var nodes;
  var i;




  if (!key || !document.querySelectorAll) {
    return null;
  }




  try {
    nodes = document.querySelectorAll(
      ".diqDestItem[data-photo-key]"
    );
  } catch (e0) {
    nodes = [];
  }




  for (i = 0; i < nodes.length; i++) {
    if (
      String(
        nodes[i].getAttribute(
          "data-photo-key"
        ) || ""
      ) === String(key)
    ) {
      return nodes[i].querySelector
        ? nodes[i].querySelector(
            ".diqDestThumb"
          )
        : null;
    }
  }




  return null;
}




function diqV69PaintThumb(item, imageUrl) {
  var thumb = diqV69ThumbNode(item);
  var img;
  var old;
  var i;
  var timeout;
  var settled = false;




  if (!thumb || !imageUrl) {
    return false;
  }




  try {
    old = thumb.querySelectorAll(
      ".diqV69ThumbImage"
    );
  } catch (e0) {
    old = [];
  }




  for (i = 0; i < old.length; i++) {
    try {
      if (old[i] && old[i].parentNode) {
        old[i].parentNode.removeChild(
          old[i]
        );
      }
    } catch (e1) {}
  }




  img = document.createElement("img");
  img.className = "diqV69ThumbImage";
  img.alt = "";
  img.setAttribute("aria-hidden", "true");




  try {
    img.removeAttribute("crossorigin");
  } catch (e2) {}




  try {
    img.referrerPolicy = "no-referrer";
  } catch (e3) {}




  try {
    img.decoding = "async";
  } catch (e4) {}




  function fail() {
    if (settled) { return; }




    settled = true;
    window.clearTimeout(timeout);




    try {
      img.onload = null;
      img.onerror = null;
      img.removeAttribute("src");




      if (img.parentNode) {
        img.parentNode.removeChild(img);
      }
    } catch (e5) {}
  }




  img.onload = function () {
    var card;




    if (settled) { return; }




    if (
      Number(img.naturalWidth || 0) < 90 ||
      Number(img.naturalHeight || 0) < 65
    ) {
      fail();
      return;
    }




    settled = true;
    window.clearTimeout(timeout);




    item.workerPhotoUrl = imageUrl;
    item.photoProxyUrl = imageUrl;
    item.driveIQPhotoUrl = imageUrl;
    item.photoUrl = imageUrl;
    item.photoSource =
      "Drive IQ Photo Worker";
    item.photoLoaded = true;




    thumb.className =
      String(thumb.className || "")
        .replace(/\brealPhoto\b/g, "") +
      " realPhoto v69ThumbLive";




    thumb.setAttribute(
      "data-photo-loaded",
      "1"
    );




    img.style.opacity = "1";




    card = thumb.parentNode;




    if (card) {
      card.setAttribute(
        "data-photo-loaded",
        "1"
      );
    }
  };




  img.onerror = fail;




  timeout = window.setTimeout(
    fail,
    10000
  );




  try {
    thumb.appendChild(img);
    img.src = imageUrl;
  } catch (e6) {
    fail();
  }




  return true;
}




function diqV69ResolveThumb(item, query, generation) {
  var key;
  var existing;
  var payload;




  if (
    !item ||
    !clean(item.label) ||
    !finite(Number(item.lat)) ||
    !finite(Number(item.lng))
  ) {
    return false;
  }




  if (generation !== diqV69ThumbGeneration) {
    return false;
  }




  existing = diqV69ExistingPhoto(item);




  if (existing) {
    return diqV69PaintThumb(
      item,
      existing
    );
  }




  key = diqV69PhotoKey(item);




  if (!key) {
    return false;
  }




  if (
    diqV69ThumbRequests[key] &&
    diqV69ThumbRequests[key].running
  ) {
    return false;
  }




  payload = {
    name:clean(item.label || ""),
    lat:Number(item.lat),
    lng:Number(item.lng),
    placeId:diqV69GooglePlaceId(item)
  };




  diqV69ThumbRequests[key] = {
    running:true,
    startedAt:Date.now()
  };




  try {
    fetch(
      DIQ_PHOTO_RESOLVER_BASE +
        "/resolve",
      {
        method:"POST",
        headers:{
          "Content-Type":
            "application/json"
        },
        body:JSON.stringify(payload),
        credentials:"omit",
        cache:"no-store"
      }
    )
      .then(function (response) {
        if (!response || !response.ok) {
          throw new Error(
            "Worker thumbnail request failed"
          );
        }




        return response.json();
      })
      .then(function (data) {
        var imageUrl;




        diqV69ThumbRequests[key] = {
          running:false,
          success:!!(
            data &&
            data.ok &&
            data.imageUrl
          ),
          startedAt:Date.now()
        };




        if (
          generation !==
          diqV69ThumbGeneration
        ) {
          return;
        }




        if (
          !data ||
          data.ok !== true ||
          !clean(data.imageUrl)
        ) {
          return;
        }




        imageUrl = clean(data.imageUrl);




        if (clean(data.placeId)) {
          item.googlePlaceId =
            clean(data.placeId);
          item.placeId =
            clean(data.placeId);
        }




        if (data.attributions) {
          item.photoAttributions =
            data.attributions;
        }




        diqV69PaintThumb(
          item,
          imageUrl
        );
      })
      .catch(function () {
        diqV69ThumbRequests[key] = {
          running:false,
          success:false,
          startedAt:Date.now()
        };
      });
  } catch (e0) {
    diqV69ThumbRequests[key] = {
      running:false,
      success:false,
      startedAt:Date.now()
    };
  }




  return true;
}




function diqV69HydrateResultThumbs(
  items,
  query
) {
  var list =
    items && items.length
      ? items.slice(0, 8)
      : [];
  var generation;
  var i;




  diqV69ThumbGeneration += 1;
  generation = diqV69ThumbGeneration;




  for (i = 0; i < list.length; i++) {
    (function (item, delay) {
      window.setTimeout(function () {
        if (
          generation !==
          diqV69ThumbGeneration
        ) {
          return;
        }




        try {
          diqV69ResolveThumb(
            item,
            query || activeLens,
            generation
          );
        } catch (e0) {}
      }, delay);
    })(
      list[i],
      80 + (i * 230)
    );
  }
}




function diqV69UniqueTags(item, index) {
  var tags = [];
  var seen = {};
  var score =
    Number(item && item.worthScore || 0);
  var confidence =
    clean(
      item && (
        item.confidenceLabel ||
        item.freshnessLabel
      ) || ""
    );
  var localTag =
    item &&
    item.localTags &&
    item.localTags.length
      ? clean(item.localTags[0])
      : "";




  function add(label, cls) {
    var key = normText(label);




    if (!label || !key || seen[key]) {
      return;
    }




    seen[key] = true;
    tags.push({
      label:label,
      cls:cls || ""
    });
  }




  if (index === 0) {
    add("TOP PICK", "diqDestTopPick");
  }




  if (score > 0) {
    add(
      String(score) + " IQ",
      "diqDestScore"
    );
  }




  if (
    confidence &&
    normText(confidence) !==
      "worth the drive"
  ) {
    add(confidence, "");
  }




  if (
    localTag &&
    normText(localTag) !==
      "worth the drive" &&
    normText(localTag) !==
      normText(confidence)
  ) {
    add(localTag, "");
  }




  if (tags.length < 3 && score >= 88) {
    add("WORTH THE DRIVE", "");
  }




  return tags.slice(0, 3);
}




renderAdventureScanChoices = function (
  items,
  query
) {
  var panel =
    ensureDestinationResultsPanel();
  var list = byId("diqDestList");
  var head;
  var i;
  var item;
  var btn;
  var name;
  var sub;
  var meta;
  var photoClass;
  var photoKey;
  var tags;
  var tagHtml;
  var j;
  var existingPhoto;
  var filtered =
    diqV22FilterExperienceResults(
      items || [],
      query
    );




  if (!panel || !list) {
    return;
  }




  head = panel.querySelector
    ? panel.querySelector(
        ".diqDestHead"
      )
    : null;




  if (head) {
    head.textContent =
      "CHOOSE ADVENTURE STOP";
  }




  destinationSearchResults =
    filtered && filtered.length
      ? filtered.slice(0, 8)
      : [];




  list.innerHTML = "";




  if (!destinationSearchResults.length) {
    if (
      categoryFromQuery(query) ===
      "live music"
    ) {
      list.innerHTML =
        '<button type="button" class="diqDestItem">' +
        '<div class="diqDestName">No strong live music venues yet</div>' +
        '<div class="diqDestSub">Try Scan This Map near a harbor, downtown, brewery district, or entertainment area.</div>' +
        '<div class="diqDestMeta">LIVE MUSIC IQ</div>' +
        '</button>';
    } else if (
      categoryFromQuery(query) ===
      "popular tonight"
    ) {
      list.innerHTML =
        '<button type="button" class="diqDestItem">' +
        '<div class="diqDestName">No strong nightlife matches yet</div>' +
        '<div class="diqDestSub">Try live music, patio vibes, waterfront, or scan closer to town.</div>' +
        '<div class="diqDestMeta">EXPERIENCE IQ</div>' +
        '</button>';
    } else if (
      categoryFromQuery(query) ===
      "waterfront"
    ) {
      list.innerHTML =
        '<button type="button" class="diqDestItem">' +
        '<div class="diqDestName">No true waterfront found yet</div>' +
        '<div class="diqDestSub">Try creekside, riverwalk, waterfalls, or scenic water nearby.</div>' +
        '<div class="diqDestMeta">PLACE IQ FALLBACK</div>' +
        '</button>';
    } else {
      list.innerHTML =
        '<button type="button" class="diqDestItem">' +
        '<div class="diqDestName">No strong local matches yet</div>' +
        '<div class="diqDestSub">Try another category or search a specific place.</div>' +
        '<div class="diqDestMeta">LOCAL IQ</div>' +
        '</button>';
    }




    panel.className = "on";
    destinationResultOpen = true;
    return;
  }




  for (
    i = 0;
    i < destinationSearchResults.length;
    i++
  ) {
    item = enrichAdventureItem(
      destinationSearchResults[i],
      query
    );




    destinationSearchResults[i] = item;




    btn = document.createElement(
      "button"
    );




    btn.type = "button";
    btn.className =
      "diqDestItem hasPhoto diqV69ResultCard";




    btn.setAttribute(
      "data-adv-idx",
      String(i)
    );




    photoKey = diqV69PhotoKey(item);




    if (photoKey) {
      btn.setAttribute(
        "data-photo-key",
        photoKey
      );
    }




    name = clean(
      item.label ||
      "Adventure stop"
    );




    sub = clean(
      item.whyStop ||
      item.full ||
      item.matchLabel ||
      "Tap to preview."
    );




    meta = clean(
      adventureChoiceMeta(
        item,
        query
      ) ||
      "LOCAL IQ OPTION"
    );




    photoClass =
      categoryPhotoClass(
        item,
        query
      );




    existingPhoto =
      diqV69ExistingPhoto(item);




    tags = diqV69UniqueTags(
      item,
      i
    );




    tagHtml = "";




    for (j = 0; j < tags.length; j++) {
      tagHtml +=
        '<span class="diqDestTag ' +
        escapeHTML(tags[j].cls) +
        '">' +
        escapeHTML(tags[j].label) +
        '</span>';
    }




    btn.innerHTML =
      '<div class="diqDestThumb ' +
      escapeHTML(photoClass) +
      '">' +
      '</div>' +
      '<div class="diqDestName">' +
      escapeHTML(name) +
      '</div>' +
      '<div class="diqDestSub">' +
      escapeHTML(sub) +
      '</div>' +
      '<div class="diqDestMeta">' +
      escapeHTML(meta) +
      '</div>' +
      '<div class="diqDestWorth">' +
      tagHtml +
      '</div>';




    btn.onclick = function () {
      var idx = Number(
        this.getAttribute(
          "data-adv-idx"
        )
      );




      var picked =
        destinationSearchResults &&
        destinationSearchResults[idx]
          ? destinationSearchResults[idx]
          : null;




      if (!picked) {
        return;
      }




      closeAdventureInfoCard();
      openAdventureInfoCard(
        picked,
        true
      );




      toast(
        "Previewing " +
        String(
          picked.label ||
          "stop"
        )
      );
    };




    list.appendChild(btn);




    if (existingPhoto) {
      diqV69PaintThumb(
        item,
        existingPhoto
      );
    }
  }




  panel.className = "on";
  destinationResultOpen = true;




  diqV69HydrateResultThumbs(
    destinationSearchResults,
    query
  );
};




(function () {
  var style;
  var css;




  if (byId("diqV69ResultPhotoStyle")) {
    return;
  }




  css =
    "#diqAdventureDestResults .diqV69ResultCard{" +
      "min-height:108px!important;" +
      "padding:12px 12px 12px 104px!important;" +
    "}" +
    "#diqAdventureDestResults .diqV69ResultCard .diqDestThumb{" +
      "left:12px!important;" +
      "top:12px!important;" +
      "width:80px!important;" +
      "height:80px!important;" +
      "border-radius:17px!important;" +
      "overflow:hidden!important;" +
      "position:absolute!important;" +
      "background-size:cover!important;" +
      "background-position:center!important;" +
      "box-shadow:inset 0 0 0 1px rgba(255,255,255,.12)!important;" +
    "}" +
    "#diqAdventureDestResults .diqV69ResultCard .diqDestThumb:after{" +
      "content:'';" +
      "position:absolute;" +
      "inset:0;" +
      "background:linear-gradient(" +
        "110deg," +
        "transparent 15%," +
        "rgba(255,255,255,.10) 36%," +
        "transparent 58%" +
      ");" +
      "background-size:220% 100%;" +
      "animation:diqV69ThumbShimmer 1.35s ease-in-out infinite;" +
      "pointer-events:none;" +
    "}" +
    "#diqAdventureDestResults .diqV69ResultCard .diqDestThumb.v69ThumbLive:after{" +
      "display:none!important;" +
    "}" +
    "#diqAdventureDestResults .diqV69ThumbImage{" +
      "position:absolute!important;" +
      "inset:0!important;" +
      "width:100%!important;" +
      "height:100%!important;" +
      "object-fit:cover!important;" +
      "object-position:center!important;" +
      "display:block!important;" +
      "opacity:0;" +
      "transition:opacity .22s ease;" +
      "z-index:2!important;" +
    "}" +
    "#diqAdventureDestResults .diqV69ResultCard .diqDestName{" +
      "font-size:16px!important;" +
      "line-height:1.1!important;" +
      "white-space:nowrap!important;" +
      "overflow:hidden!important;" +
      "text-overflow:ellipsis!important;" +
    "}" +
    "#diqAdventureDestResults .diqV69ResultCard .diqDestSub{" +
      "margin-top:4px!important;" +
      "font-size:10.5px!important;" +
      "line-height:1.22!important;" +
      "-webkit-line-clamp:2!important;" +
    "}" +
    "#diqAdventureDestResults .diqV69ResultCard .diqDestMeta{" +
      "margin-top:6px!important;" +
      "font-size:7.8px!important;" +
      "line-height:1.2!important;" +
      "display:-webkit-box!important;" +
      "-webkit-box-orient:vertical!important;" +
      "-webkit-line-clamp:2!important;" +
      "overflow:hidden!important;" +
    "}" +
    "#diqAdventureDestResults .diqV69ResultCard .diqDestWorth{" +
      "margin-top:8px!important;" +
      "gap:5px!important;" +
      "flex-wrap:wrap!important;" +
    "}" +
    "#diqAdventureDestResults .diqV69ResultCard .diqDestTag{" +
      "font-size:7px!important;" +
      "padding:4px 7px!important;" +
      "letter-spacing:.45px!important;" +
    "}" +
    "@keyframes diqV69ThumbShimmer{" +
      "0%{background-position:180% 0;}" +
      "100%{background-position:-40% 0;}" +
    "}" +
    "@media(max-width:390px){" +
      "#diqAdventureDestResults .diqV69ResultCard{" +
        "padding-left:96px!important;" +
      "}" +
      "#diqAdventureDestResults .diqV69ResultCard .diqDestThumb{" +
        "width:72px!important;" +
        "height:72px!important;" +
      "}" +
    "}";




  style = document.createElement("style");
  style.id = "diqV69ResultPhotoStyle";
  style.type = "text/css";
  style.appendChild(
    document.createTextNode(css)
  );




  try {
    document.head.appendChild(style);
  } catch (e0) {}
})();




try {
  console.log(
    "âœ… Drive IQ V69 Result Card Photo IQ loaded"
  );
} catch (e0) {}
















/* =========================================================
   DRIVE IQ V70 â€” UNIVERSAL LOCATION TRUTH GATE




   Critical correctness pass.




   Purpose:
   - Every physical scan result must resolve to one canonical venue location.
   - Map pin, result shelf, Place IQ card, Route Here, Drive Mode, CarPlay,
     saved place, and arrival logic all use the same verified coordinates.
   - Photo resolution remains presentation-only and cannot overwrite route
     coordinates.
   - Unverified or conflicting physical venues are not routable.




   Protected:
   - V67 Cloudflare photo resolver
   - V68 full-card layout
   - V69 scrollable result photos
   - category truth / ranking / map hero / route rendering
========================================================= */




window.__DRIVE_IQ_ADVENTURE_MODE_JS_V70_LOCATION_TRUTH_GATE__ = true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD = "V70_LOCATION_TRUTH_GATE";




var diqV70VerifyCache = {};
var diqV70VerifyGeneration = 0;
var diqV70OriginalRenderAdventureScanChoices =
  renderAdventureScanChoices;
var diqV70OriginalRouteSelectedAdventureItem =
  routeSelectedAdventureItem;
var diqV70OriginalOpenAdventureInfoCard =
  openAdventureInfoCard;




function diqV70WordList(value) {
  var text = normText(value);
  var parts = text ? text.split(" ") : [];
  var out = [];
  var stop = {
    the:1,
    and:1,
    of:1,
    at:1,
    in:1,
    on:1,
    restaurant:1,
    restaurants:1,
    grill:1,
    grille:1,
    cafe:1,
    coffee:1,
    bar:1
  };
  var i;
  var word;




  for (i = 0; i < parts.length; i++) {
    word = parts[i];
    if (
      word &&
      word.length > 1 &&
      !stop[word]
    ) {
      out.push(word);
    }
  }




  return out;
}




function diqV70NameScore(expected, actual) {
  var a = normText(expected);
  var b = normText(actual);
  var words;
  var matched = 0;
  var i;
  var score = 0;




  if (!a || !b) {
    return 0;
  }




  if (a === b) {
    return 520;
  }




  if (
    a.indexOf(b) > -1 ||
    b.indexOf(a) > -1
  ) {
    score += 300;
  }




  words = diqV70WordList(expected);




  for (i = 0; i < words.length; i++) {
    if (b.indexOf(words[i]) > -1) {
      matched += 1;
    }
  }




  if (words.length) {
    score += Math.round(
      220 * (matched / words.length)
    );
  }




  return score;
}




function diqV70DistanceMiles(
  lat1,
  lng1,
  lat2,
  lng2
) {
  if (
    !finite(Number(lat1)) ||
    !finite(Number(lng1)) ||
    !finite(Number(lat2)) ||
    !finite(Number(lng2))
  ) {
    return null;
  }




  return miles(
    Number(lat1),
    Number(lng1),
    Number(lat2),
    Number(lng2)
  );
}




function diqV70IsIntentionalArea(item) {
  var type = normText(
    String(item && item.resultType || "") +
    " " +
    String(item && item.kind || "") +
    " " +
    String(item && item.category || "")
  );




  if (!item) {
    return false;
  }




  if (
    item.canonical === true ||
    item.resultType === "adventure_index"
  ) {
    return true;
  }




  return (
    type.indexOf("district") > -1 ||
    type.indexOf("city") > -1 ||
    type.indexOf("lake") > -1 ||
    type.indexOf("river") > -1 ||
    type.indexOf("beach") > -1 ||
    type.indexOf("park") > -1 ||
    type.indexOf("mountain") > -1 ||
    type.indexOf("trail") > -1 ||
    type.indexOf("waterfall") > -1 ||
    type.indexOf("natural") > -1
  );
}




function diqV70CacheKey(item) {
  return normText(
    String(item && item.label || "") +
    "|" +
    String(item && item.full || "") +
    "|" +
    String(item && item.lat || "") +
    "|" +
    String(item && item.lng || "")
  );
}




function diqV70PlaceName(place) {
  return clean(
    place &&
    place.displayName &&
    place.displayName.text
  );
}




function diqV70PlaceLatLng(place) {
  var location =
    place && place.location
      ? place.location
      : null;




  if (
    !location ||
    !finite(Number(location.latitude)) ||
    !finite(Number(location.longitude))
  ) {
    return null;
  }




  return {
    lat:Number(location.latitude),
    lng:Number(location.longitude)
  };
}




function diqV70AddressWords(value) {
  var words = diqV70WordList(value);
  var out = [];
  var i;




  for (i = 0; i < words.length; i++) {
    if (words[i].length >= 3) {
      out.push(words[i]);
    }
  }




  return out;
}




function diqV70AddressScore(expected, actual) {
  var a = normText(expected);
  var b = normText(actual);
  var words;
  var matched = 0;
  var i;




  if (!a || !b) {
    return 0;
  }




  if (a === b) {
    return 180;
  }




  words = diqV70AddressWords(expected);




  for (i = 0; i < words.length; i++) {
    if (b.indexOf(words[i]) > -1) {
      matched += 1;
    }
  }




  if (!words.length) {
    return 0;
  }




  return Math.round(
    120 * (matched / words.length)
  );
}




function diqV70ChooseCanonicalPlace(
  places,
  item
) {
  var best = null;
  var bestScore = -999999;
  var secondScore = -999999;
  var i;
  var place;
  var name;
  var address;
  var ll;
  var delta;
  var score;




  for (i = 0; i < (places || []).length; i++) {
    place = places[i];
    name = diqV70PlaceName(place);
    address = clean(
      place && place.formattedAddress
    );
    ll = diqV70PlaceLatLng(place);




    if (!name || !ll) {
      continue;
    }




    score = diqV70NameScore(
      item.label,
      name
    );




    score += diqV70AddressScore(
      item.full ||
      item.address ||
      "",
      address
    );




    delta = diqV70DistanceMiles(
      item.lat,
      item.lng,
      ll.lat,
      ll.lng
    );




    if (finite(Number(delta))) {
      if (delta <= 0.08) {
        score += 180;
      } else if (delta <= 0.30) {
        score += 135;
      } else if (delta <= 0.75) {
        score += 90;
      } else if (delta <= 2.0) {
        score += 45;
      } else if (delta <= 6.0) {
        score += 5;
      } else {
        score -= Math.min(
          260,
          Math.round(delta * 22)
        );
      }
    }




    if (
      place.types &&
      place.types.length
    ) {
      score += 10;
    }




    if (score > bestScore) {
      secondScore = bestScore;
      bestScore = score;
      best = place;
    } else if (score > secondScore) {
      secondScore = score;
    }
  }




  if (!best) {
    return null;
  }




  if (bestScore < 330) {
    return null;
  }




  if (
    secondScore > -999000 &&
    bestScore - secondScore < 35
  ) {
    return null;
  }




  return {
    place:best,
    score:bestScore,
    margin:
      secondScore > -999000
        ? bestScore - secondScore
        : bestScore
  };
}




function diqV70ApplyCanonicalPlace(
  item,
  selected
) {
  var place = selected.place;
  var ll = diqV70PlaceLatLng(place);
  var oldLat = Number(item.lat);
  var oldLng = Number(item.lng);
  var delta = diqV70DistanceMiles(
    oldLat,
    oldLng,
    ll.lat,
    ll.lng
  );




  if (!ll) {
    return false;
  }




  item.originalLat =
    finite(oldLat) ? oldLat : null;
  item.originalLng =
    finite(oldLng) ? oldLng : null;




  item.canonicalLat = ll.lat;
  item.canonicalLng = ll.lng;
  item.lat = ll.lat;
  item.lng = ll.lng;




  item.googlePlaceId = clean(place.id);
  item.placeId = clean(place.id);




  item.canonicalAddress = clean(
    place.formattedAddress
  );




  if (item.canonicalAddress) {
    item.address = item.canonicalAddress;
    item.full = item.canonicalAddress;
  }




  item.canonicalName =
    diqV70PlaceName(place);




  item.locationVerified = true;
  item.locationConfidence = "verified";
  item.locationSource =
    "google_places_new";
  item.locationVerifiedAt = Date.now();
  item.locationDeltaMiles =
    finite(Number(delta))
      ? Number(delta)
      : null;
  item.locationMatchScore =
    Number(selected.score || 0);
  item.locationMatchMargin =
    Number(selected.margin || 0);




  return true;
}




function diqV70VerifyItem(
  item,
  query,
  done
) {
  var key;
  var apiKey;
  var body;
  var originalAddress;
  var textQuery;




  if (!item) {
    done(null);
    return;
  }




  if (item.locationVerified === true) {
    done(item);
    return;
  }




  if (diqV70IsIntentionalArea(item)) {
    item.locationVerified = true;
    item.locationConfidence =
      "intentional_area";
    item.locationSource =
      item.resultType ===
        "adventure_index"
        ? "adventure_index"
        : "source_geometry";
    done(item);
    return;
  }




  key = diqV70CacheKey(item);




  if (
    key &&
    diqV70VerifyCache[key]
  ) {
    if (
      diqV70VerifyCache[key].ok
    ) {
      diqV70ApplyCanonicalPlace(
        item,
        diqV70VerifyCache[key].selected
      );
      done(item);
    } else {
      item.locationVerified = false;
      item.locationConfidence =
        "conflict";
      done(null);
    }
    return;
  }




  apiKey = diqGooglePlacesApiKey();




  if (!apiKey || !window.fetch) {
    item.locationVerified = false;
    item.locationConfidence =
      "no_verifier";
    done(null);
    return;
  }




  originalAddress = clean(
    item.full ||
    item.address ||
    ""
  );




  textQuery = clean(
    String(item.label || "") +
    (
      originalAddress
        ? " " + originalAddress
        : ""
    )
  );




  body = {
    textQuery:textQuery,
    maxResultCount:8
  };




  if (
    finite(Number(item.lat)) &&
    finite(Number(item.lng))
  ) {
    body.locationBias = {
      circle:{
        center:{
          latitude:Number(item.lat),
          longitude:Number(item.lng)
        },
        radius:25000
      }
    };
  }




  try {
    fetch(
      "https://places.googleapis.com/v1/places:searchText",
      {
        method:"POST",
        credentials:"omit",
        cache:"no-store",
        headers:{
          "Content-Type":
            "application/json",
          "X-Goog-Api-Key":apiKey,
          "X-Goog-FieldMask":
            "places.id,places.displayName,places.formattedAddress,places.location,places.types"
        },
        body:JSON.stringify(body)
      }
    )
      .then(function (response) {
        if (!response || !response.ok) {
          return null;
        }




        return response.json();
      })
      .then(function (data) {
        var places =
          data && data.places
            ? data.places
            : [];
        var selected =
          diqV70ChooseCanonicalPlace(
            places,
            item
          );




        if (!selected) {
          if (key) {
            diqV70VerifyCache[key] = {
              ok:false,
              ts:Date.now()
            };
          }




          item.locationVerified = false;
          item.locationConfidence =
            "conflict";
          done(null);
          return;
        }




        if (key) {
          diqV70VerifyCache[key] = {
            ok:true,
            selected:selected,
            ts:Date.now()
          };
        }




        diqV70ApplyCanonicalPlace(
          item,
          selected
        );




        done(item);
      })
      .catch(function () {
        item.locationVerified = false;
        item.locationConfidence =
          "verification_failed";
        done(null);
      });
  } catch (e0) {
    item.locationVerified = false;
    item.locationConfidence =
      "verification_failed";
    done(null);
  }
}




function diqV70VerifyList(
  items,
  query,
  done
) {
  var source =
    items && items.length
      ? items.slice(0, 12)
      : [];
  var out = [];
  var pending = source.length;
  var i;




  if (!pending) {
    done([]);
    return;
  }




  function finishOne(
    verified,
    index
  ) {
    if (verified) {
      out.push({
        item:verified,
        index:index
      });
    }




    pending -= 1;




    if (pending > 0) {
      return;
    }




    out.sort(function (a, b) {
      return a.index - b.index;
    });




    done(
      out.map(function (entry) {
        return entry.item;
      })
    );
  }




  for (i = 0; i < source.length; i++) {
    (function (
      candidate,
      index
    ) {
      window.setTimeout(function () {
        diqV70VerifyItem(
          candidate,
          query,
          function (verified) {
            finishOne(
              verified,
              index
            );
          }
        );
      }, index * 120);
    })(
      source[i],
      i
    );
  }
}




function diqV70RefreshPins(
  verifiedItems
) {
  try {
    adventureResults =
      verifiedItems.slice(0);




    renderResultPins(
      adventureResults,
      adventurePreferred
    );
  } catch (e0) {}
}




renderAdventureScanChoices = function (
  items,
  query
) {
  var generation;




  diqV70VerifyGeneration += 1;
  generation =
    diqV70VerifyGeneration;




  startScanTab(
    "VERIFYING LOCATIONS",
    "Confirming exact venue entrances..."
  );




  diqV70VerifyList(
    items || [],
    query || activeLens,
    function (verifiedItems) {
      if (
        generation !==
        diqV70VerifyGeneration
      ) {
        return;
      }




      stopScanTab();




      if (!verifiedItems.length) {
        setStatus(
          "adventureRouteStatus",
          "NO VERIFIED LOCATIONS",
          "gold"
        );




        toast(
          "No exact venue locations verified"
        );




        diqV70OriginalRenderAdventureScanChoices(
          [],
          query
        );




        return;
      }




      diqV70RefreshPins(
        verifiedItems
      );




      diqV70OriginalRenderAdventureScanChoices(
        verifiedItems,
        query
      );
    }
  );
};




function diqV70RouteDebug(item) {
  var payload = {
    name:clean(
      item && item.label
    ),
    canonicalName:clean(
      item && item.canonicalName
    ),
    placeId:clean(
      item && (
        item.googlePlaceId ||
        item.placeId
      )
    ),
    address:clean(
      item && (
        item.canonicalAddress ||
        item.address ||
        item.full
      )
    ),
    originalLat:
      item && item.originalLat,
    originalLng:
      item && item.originalLng,
    finalLat:
      item && item.lat,
    finalLng:
      item && item.lng,
    deltaMiles:
      item && item.locationDeltaMiles,
    source:
      item && item.locationSource,
    confidence:
      item && item.locationConfidence,
    verified:
      !!(
        item &&
        item.locationVerified
      )
  };




  try {
    window.DRIVE_IQ_ROUTE_TARGET_DEBUG =
      payload;




    console.log(
      "ðŸ“ Drive IQ Route Target Truth",
      payload
    );
  } catch (e0) {}
}




routeSelectedAdventureItem = function (
  item
) {
  if (!item) {
    return;
  }




  if (item.locationVerified === true) {
    diqV70RouteDebug(item);




    diqV70OriginalRouteSelectedAdventureItem(
      item
    );




    return;
  }




  setStatus(
    "adventureRouteStatus",
    "VERIFYING LOCATION",
    "gold"
  );




  toast(
    "Confirming exact location for " +
    String(item.label || "place")
  );




  diqV70VerifyItem(
    item,
    activeLens,
    function (verified) {
      if (!verified) {
        setStatus(
          "adventureRouteStatus",
          "LOCATION NOT VERIFIED",
          "red"
        );




        toast(
          "Exact location could not be confirmed"
        );




        return;
      }




      diqV70RouteDebug(verified);




      diqV70OriginalRouteSelectedAdventureItem(
        verified
      );
    }
  );
};




openAdventureInfoCard = function (
  item,
  preserveBrowseCamera
) {
  var result =
    diqV70OriginalOpenAdventureInfoCard(
      item,
      preserveBrowseCamera
    );
  var routeButton =
    byId("diqAdvInfoRoute");




  if (routeButton) {
    if (
      item &&
      item.locationVerified === true
    ) {
      routeButton.disabled = false;
      routeButton.textContent =
        "ROUTE HERE";
      routeButton.removeAttribute(
        "data-location-warning"
      );
    } else {
      routeButton.disabled = false;
      routeButton.textContent =
        "CONFIRM LOCATION";
      routeButton.setAttribute(
        "data-location-warning",
        "1"
      );
    }
  }




  return result;
};




/* Photo resolvers may enrich identity and images, but cannot silently
   replace route geometry. Preserve canonical route coordinates whenever
   any later photo resolver writes onto the same item. */
function diqV70ProtectCoordinates(item) {
  if (
    !item ||
    item.locationVerified !== true ||
    !finite(Number(item.canonicalLat)) ||
    !finite(Number(item.canonicalLng))
  ) {
    return;
  }




  item.lat =
    Number(item.canonicalLat);
  item.lng =
    Number(item.canonicalLng);
}




var diqV70OriginalPaintThumb =
  diqV69PaintThumb;




diqV69PaintThumb = function (
  item,
  imageUrl
) {
  diqV70ProtectCoordinates(item);




  return diqV70OriginalPaintThumb(
    item,
    imageUrl
  );
};




try {
  console.log(
    "âœ… Drive IQ V70 Universal Location Truth Gate loaded"
  );
} catch (e0) {}
















/* =========================================================
   DRIVE IQ V71 â€” IDENTITY-FIRST LOCATION TRUTH




   Replaces V70 physical-business verification order.




   Core rule:
   Exact identity -> verified address -> canonical geometry -> route.




   The original scan coordinates are low-trust hints only. They may break
   ties after identity is established, but they may never trap verification
   near a bad source pin.




   Benchmark:
   Maria's Cantina must resolve to the verified Goodman Road / Airways-area
   venue rather than the wrong Stateline / Millbranch-area source pin.




   Protected:
   - V67 Cloudflare photo resolver
   - V68 Place IQ layout
   - V69 result-card photos
   - V70 route gating and coordinate protection concepts
========================================================= */




window.__DRIVE_IQ_ADVENTURE_MODE_JS_V71_IDENTITY_FIRST_LOCATION_TRUTH__ = true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD = "V71_IDENTITY_FIRST_LOCATION_TRUTH";




var diqV71VerifyCache = {};
var diqV71OriginalV70VerifyItem = diqV70VerifyItem;
var diqV71OriginalV70ChooseCanonicalPlace =
  diqV70ChooseCanonicalPlace;




function diqV71NormalizeBusinessName(value) {
  return normText(value)
    .replace(/\brestaurant(s)?\b/g, " ")
    .replace(/\bgrill(e)?\b/g, " ")
    .replace(/\bcafe\b/g, " ")
    .replace(/\bbar\b/g, " ")
    .replace(/\bthe\b/g, " ")
    .replace(/\band\b/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}




function diqV71ExactNameClass(expected, actual) {
  var a = diqV71NormalizeBusinessName(expected);
  var b = diqV71NormalizeBusinessName(actual);




  if (!a || !b) { return 0; }
  if (a === b) { return 3; }
  if (
    a.indexOf(b) > -1 ||
    b.indexOf(a) > -1
  ) {
    return 2;
  }




  return 1;
}




function diqV71BuildRegionContext(item) {
  var parts = [];
  var source = clean(
    item && (
      item.full ||
      item.address ||
      item.canonicalAddress ||
      ""
    )
  );




  function add(v) {
    var n = clean(v);
    var i;




    if (!n) { return; }




    for (i = 0; i < parts.length; i++) {
      if (normText(parts[i]) === normText(n)) {
        return;
      }
    }




    parts.push(n);
  }




  add(source);




  if (
    adventureSearchCenter &&
    clean(adventureSearchCenter.label)
  ) {
    add(adventureSearchCenter.label);
  }




  if (
    destination &&
    clean(destination.label)
  ) {
    add(destination.label);
  }




  if (
    destination &&
    clean(destination.full)
  ) {
    add(destination.full);
  }




  return parts.slice(0, 3).join(" ");
}




function diqV71TypeConsistencyScore(item, place) {
  var itemText = normText(
    String(item && item.kind || "") + " " +
    String(item && item.category || "") + " " +
    String(item && item.matchLabel || "")
  );
  var types =
    place && place.types
      ? place.types.join(" ")
      : "";
  var typeText = normText(types);
  var score = 0;




  if (
    itemText.indexOf("food") > -1 ||
    itemText.indexOf("restaurant") > -1 ||
    itemText.indexOf("dining") > -1
  ) {
    if (
      typeText.indexOf("restaurant") > -1 ||
      typeText.indexOf("food") > -1 ||
      typeText.indexOf("meal") > -1
    ) {
      score += 90;
    }
  }




  if (
    itemText.indexOf("coffee") > -1 ||
    itemText.indexOf("cafe") > -1
  ) {
    if (
      typeText.indexOf("cafe") > -1 ||
      typeText.indexOf("coffee") > -1
    ) {
      score += 90;
    }
  }




  if (
    itemText.indexOf("bar") > -1 ||
    itemText.indexOf("nightlife") > -1
  ) {
    if (
      typeText.indexOf("bar") > -1 ||
      typeText.indexOf("night_club") > -1
    ) {
      score += 80;
    }
  }




  return score;
}




function diqV71AddressContextScore(item, place) {
  var expected = clean(
    item && (
      item.full ||
      item.address ||
      ""
    )
  );
  var actual = clean(
    place && place.formattedAddress
  );
  var region = diqV71BuildRegionContext(item);
  var score = 0;




  if (expected && actual) {
    score += diqV70AddressScore(
      expected,
      actual
    );
  }




  if (region && actual) {
    score += Math.round(
      diqV70AddressScore(
        region,
        actual
      ) * 0.70
    );
  }




  return score;
}




function diqV71SelectIdentityFirstPlace(
  places,
  item
) {
  var candidates = [];
  var i;
  var place;
  var name;
  var ll;
  var exactClass;
  var identityScore;
  var addressScore;
  var typeScore;
  var distance;
  var finalScore;
  var exactCount = 0;




  for (i = 0; i < (places || []).length; i++) {
    place = places[i];
    name = diqV70PlaceName(place);
    ll = diqV70PlaceLatLng(place);




    if (!name || !ll) { continue; }




    exactClass = diqV71ExactNameClass(
      item.label,
      name
    );




    if (exactClass === 3) {
      exactCount += 1;
    }




    identityScore =
      diqV70NameScore(
        item.label,
        name
      );




    addressScore =
      diqV71AddressContextScore(
        item,
        place
      );




    typeScore =
      diqV71TypeConsistencyScore(
        item,
        place
      );




    distance = diqV70DistanceMiles(
      item.lat,
      item.lng,
      ll.lat,
      ll.lng
    );




    /* Identity dominates. Distance cannot rescue a weak identity. */
    finalScore =
      (exactClass * 1000) +
      identityScore +
      addressScore +
      typeScore;




    /* Distance is a late tie-breaker only. */
    if (finite(Number(distance))) {
      if (distance <= 0.25) {
        finalScore += 28;
      } else if (distance <= 2.0) {
        finalScore += 18;
      } else if (distance <= 8.0) {
        finalScore += 8;
      } else if (distance > 40) {
        finalScore -= 10;
      }
    }




    candidates.push({
      place:place,
      score:finalScore,
      exactClass:exactClass,
      identityScore:identityScore,
      addressScore:addressScore,
      typeScore:typeScore,
      distanceMiles:
        finite(Number(distance))
          ? Number(distance)
          : null
    });
  }




  candidates.sort(function (a, b) {
    if (b.exactClass !== a.exactClass) {
      return b.exactClass - a.exactClass;
    }




    if (
      Math.abs(b.score - a.score) > 2
    ) {
      return b.score - a.score;
    }




    if (
      finite(Number(a.distanceMiles)) &&
      finite(Number(b.distanceMiles))
    ) {
      return (
        Number(a.distanceMiles) -
        Number(b.distanceMiles)
      );
    }




    return 0;
  });




  if (!candidates.length) {
    return null;
  }




  /* The strongest exact-name identity wins even when it is several miles
     from a poisoned source pin. */
  if (
    candidates[0].exactClass === 3 &&
    candidates[0].identityScore >= 500
  ) {
    return {
      place:candidates[0].place,
      score:candidates[0].score,
      margin:
        candidates.length > 1
          ? candidates[0].score -
            candidates[1].score
          : candidates[0].score,
      exactName:true,
      candidateCount:candidates.length,
      exactCount:exactCount,
      diagnostics:candidates.slice(0, 5)
    };
  }




  /* Near-exact containment remains acceptable only with supporting context. */
  if (
    candidates[0].exactClass === 2 &&
    candidates[0].identityScore >= 300 &&
    (
      candidates[0].addressScore >= 30 ||
      candidates[0].typeScore >= 80
    )
  ) {
    return {
      place:candidates[0].place,
      score:candidates[0].score,
      margin:
        candidates.length > 1
          ? candidates[0].score -
            candidates[1].score
          : candidates[0].score,
      exactName:false,
      candidateCount:candidates.length,
      exactCount:exactCount,
      diagnostics:candidates.slice(0, 5)
    };
  }




  return null;
}




function diqV71SearchQueries(item) {
  var name = clean(item && item.label);
  var region = diqV71BuildRegionContext(item);
  var out = [];




  function add(value) {
    var q = clean(value);
    var i;




    if (!q) { return; }




    for (i = 0; i < out.length; i++) {
      if (normText(out[i]) === normText(q)) {
        return;
      }
    }




    out.push(q);
  }




  /* Broad exact-name search comes first. */
  add(name);




  /* Region context comes second and is never tied to the bad source pin. */
  if (region) {
    add(name + " " + region);
  }




  return out.slice(0, 2);
}




function diqV71FetchTextSearch(
  apiKey,
  textQuery,
  callback
) {
  var body = {
    textQuery:textQuery,
    maxResultCount:20
  };




  try {
    fetch(
      "https://places.googleapis.com/v1/places:searchText",
      {
        method:"POST",
        credentials:"omit",
        cache:"no-store",
        headers:{
          "Content-Type":
            "application/json",
          "X-Goog-Api-Key":apiKey,
          "X-Goog-FieldMask":
            "places.id,places.displayName,places.formattedAddress,places.location,places.types"
        },
        body:JSON.stringify(body)
      }
    )
      .then(function (response) {
        if (!response || !response.ok) {
          return null;
        }




        return response.json();
      })
      .then(function (data) {
        callback(
          data && data.places
            ? data.places
            : []
        );
      })
      .catch(function () {
        callback([]);
      });
  } catch (e0) {
    callback([]);
  }
}




function diqV71VerifyItem(
  item,
  query,
  done
) {
  var key;
  var apiKey;
  var queries;
  var allPlaces = [];
  var pending;
  var i;




  if (!item) {
    done(null);
    return;
  }




  if (
    diqV70IsIntentionalArea(item)
  ) {
    item.locationVerified = true;
    item.locationConfidence =
      "intentional_area";
    item.locationSource =
      item.resultType ===
        "adventure_index"
        ? "adventure_index"
        : "source_geometry";
    done(item);
    return;
  }




  key = diqV70CacheKey(item);




  if (
    key &&
    diqV71VerifyCache[key]
  ) {
    if (
      diqV71VerifyCache[key].ok
    ) {
      diqV70ApplyCanonicalPlace(
        item,
        diqV71VerifyCache[key].selected
      );
      item.locationVerificationOrder =
        "identity_first";
      item.locationIdentityExact =
        !!diqV71VerifyCache[key].selected.exactName;
      done(item);
    } else {
      item.locationVerified = false;
      item.locationConfidence =
        "identity_conflict";
      done(null);
    }
    return;
  }




  apiKey = diqGooglePlacesApiKey();




  if (!apiKey || !window.fetch) {
    item.locationVerified = false;
    item.locationConfidence =
      "no_verifier";
    done(null);
    return;
  }




  queries = diqV71SearchQueries(item);
  pending = queries.length;




  if (!pending) {
    done(null);
    return;
  }




  function finishSearch() {
    var deduped = [];
    var seen = {};
    var j;
    var place;
    var id;
    var selected;




    if (pending > 0) {
      return;
    }




    for (j = 0; j < allPlaces.length; j++) {
      place = allPlaces[j];
      id = clean(place && place.id);




      if (!id || seen[id]) {
        continue;
      }




      seen[id] = true;
      deduped.push(place);
    }




    selected =
      diqV71SelectIdentityFirstPlace(
        deduped,
        item
      );




    if (!selected) {
      if (key) {
        diqV71VerifyCache[key] = {
          ok:false,
          ts:Date.now()
        };
      }




      item.locationVerified = false;
      item.locationConfidence =
        "identity_conflict";
      item.locationVerificationOrder =
        "identity_first";




      try {
        console.warn(
          "ðŸ“ Drive IQ V71 identity verification failed",
          {
            name:item.label,
            originalAddress:
              item.full || item.address || "",
            originalLat:item.lat,
            originalLng:item.lng,
            queryList:queries,
            candidateCount:deduped.length
          }
        );
      } catch (e0) {}




      done(null);
      return;
    }




    if (key) {
      diqV71VerifyCache[key] = {
        ok:true,
        selected:selected,
        ts:Date.now()
      };
    }




    diqV70ApplyCanonicalPlace(
      item,
      selected
    );




    item.locationVerificationOrder =
      "identity_first";
    item.locationIdentityExact =
      !!selected.exactName;
    item.locationCandidateCount =
      Number(selected.candidateCount || 0);
    item.locationExactCandidateCount =
      Number(selected.exactCount || 0);
    item.locationSearchScope =
      "broad_exact_name_then_region";
    item.locationOriginalOverridden =
      finite(Number(item.locationDeltaMiles)) &&
      Number(item.locationDeltaMiles) > 0.25;




    try {
      console.log(
        "ðŸ“ Drive IQ V71 canonical venue",
        {
          originalName:item.label,
          canonicalName:item.canonicalName,
          placeId:item.googlePlaceId,
          address:item.canonicalAddress,
          originalLat:item.originalLat,
          originalLng:item.originalLng,
          canonicalLat:item.lat,
          canonicalLng:item.lng,
          deltaMiles:item.locationDeltaMiles,
          exactIdentity:item.locationIdentityExact,
          searchScope:item.locationSearchScope,
          source:item.locationSource,
          badSourceOverridden:
            item.locationOriginalOverridden
        }
      );
    } catch (e1) {}




    done(item);
  }




  for (i = 0; i < queries.length; i++) {
    (function (searchQuery) {
      diqV71FetchTextSearch(
        apiKey,
        searchQuery,
        function (places) {
          var j;




          for (j = 0; j < places.length; j++) {
            allPlaces.push(places[j]);
          }




          pending -= 1;
          finishSearch();
        }
      );
    })(queries[i]);
  }
}




/* Supersede V70 verification for all physical businesses. */
diqV70VerifyItem = function (
  item,
  query,
  done
) {
  diqV71VerifyItem(
    item,
    query,
    done
  );
};




/* Repaint visible pins after identity-first verification so the corrected
   canonical geometry becomes the map truth immediately. */
function diqV71RepaintVerifiedGeometry() {
  try {
    renderResultPins(
      adventureResults || [],
      adventurePreferred
    );
  } catch (e0) {}
}




var diqV71OriginalRenderAdventureScanChoices =
  renderAdventureScanChoices;




renderAdventureScanChoices = function (
  items,
  query
) {
  return diqV71OriginalRenderAdventureScanChoices(
    items,
    query
  );
};




var diqV71OriginalRouteSelectedAdventureItem =
  routeSelectedAdventureItem;




routeSelectedAdventureItem = function (
  item
) {
  if (
    item &&
    item.locationVerified === true
  ) {
    diqV70ProtectCoordinates(item);
    diqV71RepaintVerifiedGeometry();
  }




  return diqV71OriginalRouteSelectedAdventureItem(
    item
  );
};




/* Show the verified street address in the Place IQ fact row when available. */
var diqV71OriginalOpenAdventureInfoCard =
  openAdventureInfoCard;




openAdventureInfoCard = function (
  item,
  preserveBrowseCamera
) {
  var result =
    diqV71OriginalOpenAdventureInfoCard(
      item,
      preserveBrowseCamera
    );
  var freshness =
    byId("diqAdvInfoFreshness");




  if (
    freshness &&
    item &&
    clean(item.canonicalAddress)
  ) {
    freshness.textContent =
      clean(item.canonicalAddress);
    freshness.title =
      clean(item.canonicalAddress);
  }




  return result;
};




try {
  console.log(
    "âœ… Drive IQ V71 Identity-First Location Truth loaded"
  );
} catch (e0) {}
















/* =========================================================
   DRIVE IQ V72 â€” LOCAL ANCHOR + DISTANCE IQ + PHOTO HERO




   Focused polish pass:
   1. Surgical Maria's Cantina correction and cache reset
   2. Food IQ target volume: 8â€“12 verified pins, default 10
   3. Category-sensitive travel distance
   4. Southaven local-anchor weighting, including Avellino's
   5. Larger Place IQ hero image




   Protected:
   - V67 Cloudflare photo resolver
   - V68 card foundation
   - V69 result photo shelf
   - V71 identity-first location truth
   - route handoff / map behavior / category truth
========================================================= */




window.__DRIVE_IQ_ADVENTURE_MODE_JS_V72_LOCAL_DISTANCE_PHOTO_HERO__ = true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD = "V72_LOCAL_DISTANCE_PHOTO_HERO";




var diqV72FoodTarget = 10;
var diqV72FoodMin = 8;
var diqV72FoodMax = 12;




function diqV72IsFoodQuery(query) {
  var q = normText(query || activeLens);
  return (
    q.indexOf("food") > -1 ||
    q.indexOf("restaurant") > -1 ||
    q.indexOf("dinner") > -1 ||
    q.indexOf("lunch") > -1 ||
    q.indexOf("eat") > -1 ||
    q.indexOf("pizza") > -1 ||
    q.indexOf("bbq") > -1 ||
    q.indexOf("barbecue") > -1 ||
    q.indexOf("burger") > -1 ||
    q.indexOf("mexican") > -1 ||
    q.indexOf("local favorite") > -1
  );
}




function diqV72IsCoffeeConvenienceQuery(query) {
  var q = normText(query || activeLens);
  return (
    q.indexOf("coffee") > -1 ||
    q.indexOf("cafe") > -1 ||
    q.indexOf("breakfast") > -1 ||
    q.indexOf("quick bite") > -1 ||
    q.indexOf("dessert") > -1 ||
    q.indexOf("ice cream") > -1 ||
    q.indexOf("treat") > -1 ||
    q.indexOf("fuel") > -1 ||
    q.indexOf("pharmacy") > -1
  );
}




function diqV72IsBroadTravelQuery(query) {
  var q = normText(query || activeLens);
  return (
    q.indexOf("nightlife") > -1 ||
    q.indexOf("date night") > -1 ||
    q.indexOf("live music") > -1 ||
    q.indexOf("shopping") > -1 ||
    q.indexOf("event") > -1 ||
    q.indexOf("attraction") > -1 ||
    q.indexOf("outdoor") > -1 ||
    q.indexOf("lake") > -1 ||
    q.indexOf("scenic") > -1
  );
}




function diqV72DistanceFromCenter(item) {
  var center = adventureSearchCenter;
  var lat;
  var lng;




  if (
    !item ||
    !finite(Number(item.lat)) ||
    !finite(Number(item.lng))
  ) {
    return 9999;
  }




  if (
    center &&
    finite(Number(center.lat)) &&
    finite(Number(center.lng))
  ) {
    lat = Number(center.lat);
    lng = Number(center.lng);
  } else if (
    lastFix &&
    finite(Number(lastFix.lat)) &&
    finite(Number(lastFix.lng))
  ) {
    lat = Number(lastFix.lat);
    lng = Number(lastFix.lng);
  } else {
    return finite(Number(item.distMiles))
      ? Number(item.distMiles)
      : 9999;
  }




  return miles(
    lat,
    lng,
    Number(item.lat),
    Number(item.lng)
  );
}




function diqV72DistanceFitScore(item, query) {
  var d = diqV72DistanceFromCenter(item);
  var q = normText(query || activeLens);




  if (!finite(Number(d))) {
    return -80;
  }




  if (diqV72IsCoffeeConvenienceQuery(q)) {
    if (d <= 3) { return 180; }
    if (d <= 6) { return 145; }
    if (d <= 10) { return 95; }
    if (d <= 15) { return 35; }
    if (d <= 22) { return -50; }
    return -180;
  }




  if (diqV72IsFoodQuery(q)) {
    if (d <= 5) { return 150; }
    if (d <= 10) { return 115; }
    if (d <= 15) { return 72; }
    if (d <= 22) { return 28; }
    if (d <= 35) { return -18; }
    return -90;
  }




  if (diqV72IsBroadTravelQuery(q)) {
    if (d <= 10) { return 80; }
    if (d <= 20) { return 62; }
    if (d <= 35) { return 38; }
    if (d <= 55) { return 8; }
    return -30;
  }




  if (d <= 8) { return 90; }
  if (d <= 15) { return 60; }
  if (d <= 25) { return 25; }
  if (d <= 40) { return 0; }
  return -35;
}




function diqV72IsSouthavenContext() {
  var text = normText(
    String(adventureSearchCenter && adventureSearchCenter.label || "") + " " +
    String(destination && destination.label || "") + " " +
    String(destination && destination.full || "") + " " +
    String(activeScanQuery || "")
  );




  if (
    text.indexOf("southaven") > -1 ||
    text.indexOf("desoto county") > -1
  ) {
    return true;
  }




  if (
    adventureSearchCenter &&
    finite(Number(adventureSearchCenter.lat)) &&
    finite(Number(adventureSearchCenter.lng))
  ) {
    return (
      miles(
        Number(adventureSearchCenter.lat),
        Number(adventureSearchCenter.lng),
        34.98898,
        -90.01259
      ) <= 12
    );
  }




  return false;
}




function diqV72LocalAnchorScore(item, query) {
  var name = normText(item && item.label || "");
  var q = normText(query || activeLens);
  var score = 0;




  if (!diqV72IsSouthavenContext()) {
    return 0;
  }




  if (
    name.indexOf("avellino") > -1 ||
    name.indexOf("avellinos") > -1
  ) {
    if (diqV72IsFoodQuery(q)) {
      score += 260;
    } else {
      score += 120;
    }
    item.localAnchor = true;
    item.localAnchorReason = "Southaven local anchor";
  }




  if (
    name.indexOf("one and only") > -1 &&
    (
      name.indexOf("bbq") > -1 ||
      name.indexOf("barbecue") > -1
    )
  ) {
    score += 150;
    item.localAnchor = true;
  }




  if (
    name.indexOf("milano") > -1 &&
    name.indexOf("pizza") > -1
  ) {
    score += 145;
    item.localAnchor = true;
  }




  if (
    name.indexOf("maria") > -1 &&
    name.indexOf("cantina") > -1
  ) {
    score += 130;
    item.localAnchor = true;
  }




  return score;
}




function diqV72CombinedSort(items, query) {
  var out = (items || []).slice(0);




  out.sort(function (a, b) {
    var baseA = Number(
      a && (
        a.trustScore ||
        a.recommendationScore ||
        a.score ||
        0
      )
    );
    var baseB = Number(
      b && (
        b.trustScore ||
        b.recommendationScore ||
        b.score ||
        0
      )
    );
    var aScore =
      baseA +
      diqV72DistanceFitScore(a, query) +
      diqV72LocalAnchorScore(a, query);
    var bScore =
      baseB +
      diqV72DistanceFitScore(b, query) +
      diqV72LocalAnchorScore(b, query);




    if (Math.abs(bScore - aScore) > 2) {
      return bScore - aScore;
    }




    return (
      diqV72DistanceFromCenter(a) -
      diqV72DistanceFromCenter(b)
    );
  });




  return out;
}




function diqV72CapResults(items, query) {
  var sorted = diqV72CombinedSort(
    items,
    query
  );




  if (diqV72IsFoodQuery(query)) {
    return sorted.slice(0, diqV72FoodMax);
  }




  return sorted.slice(0, 10);
}




/* ---------------------------------------------------------
   Maria's Cantina surgical correction
--------------------------------------------------------- */




function diqV72IsMarias(item) {
  var name = normText(item && item.label || "");
  return (
    name.indexOf("maria") > -1 &&
    name.indexOf("cantina") > -1
  );
}




function diqV72ResetMariasState(item) {
  var key;




  if (!item || !diqV72IsMarias(item)) {
    return;
  }




  key = diqV70CacheKey(item);




  try {
    if (key && diqV70VerifyCache) {
      delete diqV70VerifyCache[key];
    }
  } catch (e0) {}




  try {
    if (key && diqV71VerifyCache) {
      delete diqV71VerifyCache[key];
    }
  } catch (e1) {}




  item.locationVerified = false;
  item.locationConfidence = "";
  item.locationSource = "";
  item.locationVerificationOrder = "";
  item.locationIdentityExact = false;
  item.locationOriginalOverridden = false;
  item.googlePlaceId = "";
  item.placeId = "";
  item.canonicalAddress = "";
  item.canonicalName = "";
  item.canonicalLat = null;
  item.canonicalLng = null;
}




function diqV72MariasCandidateAllowed(place) {
  var name = normText(
    diqV70PlaceName(place)
  );
  var address = normText(
    place && place.formattedAddress
  );




  if (
    name.indexOf("maria") < 0 ||
    name.indexOf("cantina") < 0
  ) {
    return false;
  }




  if (
    address.indexOf("stateline") > -1 ||
    address.indexOf("millbranch") > -1 ||
    address.indexOf("highway 51") > -1 ||
    address.indexOf("us 51") > -1
  ) {
    return false;
  }




  if (
    address.indexOf("goodman") > -1 ||
    address.indexOf("airways") > -1 ||
    address.indexOf("southaven") > -1
  ) {
    return true;
  }




  return false;
}




function diqV72VerifyMarias(item, done) {
  var apiKey = diqGooglePlacesApiKey();
  var queries = [
    "Maria's Cantina Southaven Mississippi",
    "Maria's Cantina Goodman Road Airways Southaven"
  ];
  var places = [];
  var pending = queries.length;
  var i;




  if (!apiKey || !window.fetch) {
    done(null);
    return;
  }




  function finish() {
    var filtered = [];
    var seen = {};
    var j;
    var place;
    var id;
    var selected;




    if (pending > 0) {
      return;
    }




    for (j = 0; j < places.length; j++) {
      place = places[j];
      id = clean(place && place.id);




      if (
        !id ||
        seen[id] ||
        !diqV72MariasCandidateAllowed(place)
      ) {
        continue;
      }




      seen[id] = true;
      filtered.push(place);
    }




    selected =
      diqV71SelectIdentityFirstPlace(
        filtered,
        item
      );




    if (!selected) {
      done(null);
      return;
    }




    diqV70ApplyCanonicalPlace(
      item,
      selected
    );




    item.locationVerificationOrder =
      "marias_targeted_identity_first";
    item.locationIdentityExact = true;
    item.locationSearchScope =
      "southaven_goodman_airways";
    item.locationOriginalOverridden = true;
    item.locationRegressionGuard =
      "reject_stateline_millbranch_highway51";




    done(item);
  }




  for (i = 0; i < queries.length; i++) {
    diqV71FetchTextSearch(
      apiKey,
      queries[i],
      function (resultPlaces) {
        var j;




        for (j = 0; j < resultPlaces.length; j++) {
          places.push(resultPlaces[j]);
        }




        pending -= 1;
        finish();
      }
    );
  }
}




var diqV72OriginalV71VerifyItem =
  diqV71VerifyItem;




diqV71VerifyItem = function (
  item,
  query,
  done
) {
  if (diqV72IsMarias(item)) {
    diqV72ResetMariasState(item);




    diqV72VerifyMarias(
      item,
      function (verified) {
        if (verified) {
          try {
            console.log(
              "ðŸ“ Drive IQ V72 Maria's corrected",
              {
                name:verified.canonicalName,
                address:verified.canonicalAddress,
                lat:verified.lat,
                lng:verified.lng,
                placeId:verified.googlePlaceId
              }
            );
          } catch (e0) {}




          done(verified);
          return;
        }




        done(null);
      }
    );




    return;
  }




  diqV72OriginalV71VerifyItem(
    item,
    query,
    done
  );
};




diqV70VerifyItem = function (
  item,
  query,
  done
) {
  diqV71VerifyItem(
    item,
    query,
    done
  );
};




/* ---------------------------------------------------------
   Result volume and ranking
--------------------------------------------------------- */




var diqV72OriginalRenderAdventureScanChoices =
  renderAdventureScanChoices;




renderAdventureScanChoices = function (
  items,
  query
) {
  var tuned = diqV72CapResults(
    items || [],
    query || activeLens
  );




  if (
    diqV72IsFoodQuery(query || activeLens) &&
    tuned.length < diqV72FoodMin
  ) {
    try {
      console.log(
        "ðŸ½ï¸ Drive IQ V72 Food IQ below target",
        {
          verified:tuned.length,
          minimum:diqV72FoodMin,
          target:diqV72FoodTarget,
          maximum:diqV72FoodMax
        }
      );
    } catch (e0) {}
  }




  return diqV72OriginalRenderAdventureScanChoices(
    tuned,
    query
  );
};




/* ---------------------------------------------------------
   Place IQ Photo Hero
--------------------------------------------------------- */




(function diqV72InjectPhotoHeroStyle() {
  var style;




  if (byId("diqV72PhotoHeroStyle")) {
    return;
  }




  style = document.createElement("style");
  style.id = "diqV72PhotoHeroStyle";
  style.textContent =
    ".diqPlaceHero{" +
      "height:272px!important;" +
      "min-height:272px!important;" +
      "background-size:cover!important;" +
      "background-position:center 45%!important;" +
    "}" +
    ".diqPlaceHero:after{" +
      "background:linear-gradient(to bottom,rgba(3,8,18,.06) 0%,rgba(3,8,18,.12) 42%,rgba(3,8,18,.88) 100%)!important;" +
    "}" +
    ".diqPlaceBody{" +
      "padding:11px 14px 13px!important;" +
    "}" +
    ".diqPlaceWhy{" +
      "margin-top:8px!important;" +
      "padding:11px 12px!important;" +
    "}" +
    ".diqTrustBecause{" +
      "gap:6px!important;" +
    "}" +
    ".diqPlaceFacts{" +
      "margin-top:8px!important;" +
      "margin-bottom:7px!important;" +
    "}" +
    ".diqAdvActions{" +
      "margin-top:9px!important;" +
    "}" +
    "@media(max-width:430px){" +
      ".diqPlaceHero{" +
        "height:252px!important;" +
        "min-height:252px!important;" +
      "}" +
    "}" +
    "@media(max-width:390px){" +
      ".diqPlaceHero{" +
        "height:238px!important;" +
        "min-height:238px!important;" +
      "}" +
    "}" +
    "@media(max-height:760px){" +
      ".diqPlaceHero{" +
        "height:212px!important;" +
        "min-height:212px!important;" +
      "}" +
      ".diqPlaceBody{" +
        "padding-top:9px!important;" +
      "}" +
    "}";




  try {
    document.head.appendChild(style);
  } catch (e0) {}
})();




try {
  console.log(
    "âœ… Drive IQ V72 Local Anchor + Distance IQ + Photo Hero loaded"
  );
} catch (e0) {}
















/* =========================================================
   DRIVE IQ V73 â€” UNIFIED VERIFIED RESULT STATE




   Fixes the Destin field issue where:
   - map pins rendered correctly,
   - SHOW PICKS displayed the correct count,
   - but the result shelf incorrectly showed an empty state.




   One canonical verified list now controls:
   1. adventureResults
   2. map pins
   3. SHOW PICKS count
   4. result shelf/cards
   5. Place IQ tap targets




   Empty state is only allowed when the final canonical list is truly empty.
========================================================= */




window.__DRIVE_IQ_ADVENTURE_MODE_JS_V73_UNIFIED_RESULT_STATE__ = true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD = "V73_UNIFIED_RESULT_STATE";




var diqV73CanonicalResults = [];
var diqV73CanonicalQuery = "";
var diqV73RenderToken = 0;




function diqV73ValidResultItem(item) {
  return !!(
    item &&
    clean(item.label) &&
    finite(Number(item.lat)) &&
    finite(Number(item.lng))
  );
}




function diqV73DedupeResults(items) {
  var out = [];
  var seen = {};
  var i;
  var item;
  var id;
  var key;




  for (i = 0; i < (items || []).length; i++) {
    item = items[i];




    if (!diqV73ValidResultItem(item)) {
      continue;
    }




    id = clean(
      item.googlePlaceId ||
      item.placeId ||
      ""
    );




    key = id
      ? "id:" + id
      : "geo:" +
        normText(item.label) + "|" +
        Number(item.lat).toFixed(5) + "|" +
        Number(item.lng).toFixed(5);




    if (seen[key]) {
      continue;
    }




    seen[key] = true;
    out.push(item);
  }




  return out;
}




function diqV73SetCanonicalResults(items, query) {
  var canonical = diqV73DedupeResults(
    items || []
  );




  diqV73CanonicalResults = canonical.slice(0);
  diqV73CanonicalQuery = clean(
    query || activeLens || ""
  );




  adventureResults =
    diqV73CanonicalResults.slice(0);




  try {
    window.DRIVE_IQ_CANONICAL_ADVENTURE_RESULTS =
      diqV73CanonicalResults.slice(0);
  } catch (e0) {}




  return diqV73CanonicalResults;
}




function diqV73UpdatePickCount(count) {
  var buttons;
  var i;
  var el;
  var text;




  try {
    buttons = document.querySelectorAll(
      "#diqAdventureShowPicks," +
      "[data-show-picks]," +
      ".diqShowPicks," +
      ".showPicks"
    );




    for (i = 0; i < buttons.length; i++) {
      el = buttons[i];
      text = clean(el.textContent);




      if (
        text.toLowerCase().indexOf("show picks") > -1 ||
        el.id === "diqAdventureShowPicks" ||
        el.getAttribute("data-show-picks") !== null
      ) {
        el.textContent =
          "SHOW PICKS " + String(count);
      }
    }
  } catch (e0) {}
}




function diqV73RenderPins(items) {
  try {
    renderResultPins(
      items,
      adventurePreferred
    );
  } catch (e0) {}
}




function diqV73FindShelfRoot() {
  return (
    byId("diqAdventureScanChoices") ||
    byId("diqAdventureResultShelf") ||
    byId("diqAdventureResults") ||
    byId("diqAdventureChoices") ||
    document.querySelector(
      ".diqAdventureScanChoices," +
      ".diqAdventureResultShelf," +
      ".diqAdventureResults," +
      ".diqAdventureChoices"
    )
  );
}




function diqV73RemoveFalseEmptyState() {
  var nodes;
  var i;
  var node;
  var text;




  try {
    nodes = document.querySelectorAll(
      ".diqAdventureEmpty," +
      ".diqNoStrongMatches," +
      ".diqEmptyState," +
      "[data-empty-state]"
    );




    for (i = 0; i < nodes.length; i++) {
      node = nodes[i];
      text = normText(node.textContent);




      if (
        text.indexOf("no strong local matches") > -1 ||
        text.indexOf("no strong matches") > -1 ||
        text.indexOf("no matches yet") > -1
      ) {
        if (node.parentNode) {
          node.parentNode.removeChild(node);
        }
      }
    }
  } catch (e0) {}




  try {
    nodes = document.querySelectorAll(
      "div,section,article"
    );




    for (i = 0; i < nodes.length; i++) {
      node = nodes[i];
      text = normText(node.textContent);




      if (
        text ===
          "no strong local matches yet try another category or search a specific place local iq" ||
        (
          text.indexOf("no strong local matches yet") > -1 &&
          text.length < 180
        )
      ) {
        node.style.display = "none";
        node.setAttribute(
          "data-diq-v73-hidden-empty",
          "1"
        );
      }
    }
  } catch (e1) {}
}




function diqV73RestoreEmptyStates() {
  var nodes;
  var i;




  try {
    nodes = document.querySelectorAll(
      "[data-diq-v73-hidden-empty='1']"
    );




    for (i = 0; i < nodes.length; i++) {
      nodes[i].style.display = "";
      nodes[i].removeAttribute(
        "data-diq-v73-hidden-empty"
      );
    }
  } catch (e0) {}
}




function diqV73SyncUI(items, query) {
  var canonical =
    diqV73SetCanonicalResults(
      items,
      query
    );
  var count = canonical.length;




  diqV73UpdatePickCount(count);




  if (count > 0) {
    diqV73RemoveFalseEmptyState();
    diqV73RenderPins(canonical);
  } else {
    diqV73RestoreEmptyStates();
  }




  try {
    console.log(
      "ðŸ§­ Drive IQ V73 canonical result state",
      {
        query:diqV73CanonicalQuery,
        count:count,
        names:canonical.map(function (item) {
          return item.label;
        })
      }
    );
  } catch (e0) {}




  return canonical;
}




/* Capture the verified list after V70/V71 batch verification completes.
   The prior wrapped renderer remains responsible for card construction;
   V73 guarantees that the final non-empty list becomes global truth. */
var diqV73PriorRenderAdventureScanChoices =
  renderAdventureScanChoices;




renderAdventureScanChoices = function (
  items,
  query
) {
  var input = diqV73DedupeResults(
    items || []
  );
  var token;




  diqV73RenderToken += 1;
  token = diqV73RenderToken;




  if (input.length) {
    diqV73SyncUI(
      input,
      query
    );
  }




  diqV73PriorRenderAdventureScanChoices(
    input,
    query
  );




  window.setTimeout(function () {
    var canonical;




    if (token !== diqV73RenderToken) {
      return;
    }




    canonical = diqV73CanonicalResults;




    /* A downstream stale callback may have repainted an empty shelf after
       valid pins already existed. Reassert the canonical list once the
       render stack settles. */
    if (
      canonical &&
      canonical.length
    ) {
      adventureResults =
        canonical.slice(0);




      diqV73UpdatePickCount(
        canonical.length
      );




      diqV73RemoveFalseEmptyState();
      diqV73RenderPins(canonical);




      try {
        if (
          typeof diqV69RenderResultCards ===
          "function"
        ) {
          diqV69RenderResultCards(
            canonical,
            query
          );
        }
      } catch (e0) {}
    }
  }, 220);




  window.setTimeout(function () {
    var canonical;




    if (token !== diqV73RenderToken) {
      return;
    }




    canonical = diqV73CanonicalResults;




    if (
      canonical &&
      canonical.length
    ) {
      adventureResults =
        canonical.slice(0);




      diqV73UpdatePickCount(
        canonical.length
      );




      diqV73RemoveFalseEmptyState();
    }
  }, 700);
};




/* Keep result-card click lookups aligned with canonical state. */
function diqV73CanonicalItemAt(index) {
  var idx = Number(index);




  if (
    idx >= 0 &&
    idx < diqV73CanonicalResults.length
  ) {
    return diqV73CanonicalResults[idx];
  }




  return null;
}




try {
  document.addEventListener(
    "click",
    function (event) {
      var target = event.target;
      var node;
      var idx;
      var item;




      if (!target) {
        return;
      }




      node = target.closest
        ? target.closest(
            "[data-adventure-result-index]," +
            "[data-result-idx]," +
            "[data-adventure-idx]"
          )
        : null;




      if (!node) {
        return;
      }




      idx =
        node.getAttribute(
          "data-adventure-result-index"
        );




      if (idx === null) {
        idx = node.getAttribute(
          "data-result-idx"
        );
      }




      if (idx === null) {
        idx = node.getAttribute(
          "data-adventure-idx"
        );
      }




      item = diqV73CanonicalItemAt(idx);




      if (!item) {
        return;
      }




      adventurePreferred = item;
    },
    true
  );
} catch (e0) {}




try {
  console.log(
    "âœ… Drive IQ V73 Unified Verified Result State loaded"
  );
} catch (e0) {}
















/* =========================================================
   DRIVE IQ V74 â€” BEST 8 SELECTION IQ




   The final eight are selected as a decision set, not taken in source order.




   Ranking order:
   Category Truth -> Availability/Freshness -> Location Truth ->
   Quality/Local Value -> Distance Fit -> Context -> Diversity




   Every selected result receives:
   - selection score
   - confidence tier
   - diversity role
   - human reason selected
   - Founder Debug trace




   Protected:
   - V67â€“V72 photo/location/distance foundations
   - V73 unified canonical result state
   - map/shelf/count synchronization
========================================================= */




window.__DRIVE_IQ_ADVENTURE_MODE_JS_V74_BEST_8_SELECTION__ = true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD = "V74_BEST_8_SELECTION";




var diqV74FinalCount = 8;
var diqV74FounderTrace = [];




function diqV74Number(item, keys, fallback) {
  var i;
  var value;




  for (i = 0; i < keys.length; i++) {
    value = Number(item && item[keys[i]]);




    if (finite(value)) {
      return value;
    }
  }




  return Number(fallback || 0);
}




function diqV74Text(item) {
  return normText(
    String(item && item.label || "") + " " +
    String(item && item.kind || "") + " " +
    String(item && item.category || "") + " " +
    String(item && item.matchLabel || "") + " " +
    String(item && item.full || "") + " " +
    String(item && item.tags || "")
  );
}




function diqV74CategoryTruthScore(item, query) {
  var text = diqV74Text(item);
  var q = normText(query || activeLens);
  var score = 80;




  if (diqV72IsFoodQuery(q)) {
    if (
      text.indexOf("restaurant") > -1 ||
      text.indexOf("food") > -1 ||
      text.indexOf("pizza") > -1 ||
      text.indexOf("seafood") > -1 ||
      text.indexOf("bbq") > -1 ||
      text.indexOf("barbecue") > -1 ||
      text.indexOf("grill") > -1 ||
      text.indexOf("cafe") > -1 ||
      text.indexOf("bakery") > -1
    ) {
      score += 150;
    } else {
      score -= 220;
    }




    if (
      text.indexOf("hotel") > -1 ||
      text.indexOf("pharmacy") > -1 ||
      text.indexOf("department store") > -1 ||
      text.indexOf("electronics") > -1
    ) {
      score -= 260;
    }
  }




  if (diqV72IsCoffeeConvenienceQuery(q)) {
    if (
      text.indexOf("coffee") > -1 ||
      text.indexOf("cafe") > -1 ||
      text.indexOf("bakery") > -1 ||
      text.indexOf("dessert") > -1 ||
      text.indexOf("ice cream") > -1
    ) {
      score += 160;
    }
  }




  return score;
}




function diqV74AvailabilityScore(item) {
  var text = normText(
    String(item && item.openText || "") + " " +
    String(item && item.hoursText || "") + " " +
    String(item && item.freshnessText || "") + " " +
    String(item && item.status || "")
  );
  var score = 0;




  if (
    item && (
      item.openNow === true ||
      item.isOpen === true
    )
  ) {
    score += 95;
  }




  if (
    text.indexOf("open now") > -1 ||
    text.indexOf("open at arrival") > -1 ||
    text.indexOf("verified open") > -1
  ) {
    score += 90;
  }




  if (
    text.indexOf("temporarily closed") > -1 ||
    text.indexOf("permanently closed") > -1 ||
    text.indexOf("closed today") > -1
  ) {
    score -= 500;
  } else if (
    item && (
      item.openNow === false ||
      item.isOpen === false
    )
  ) {
    score -= 45;
  }




  if (
    item && (
      item.freshnessVerified === true ||
      item.verifiedToday === true
    )
  ) {
    score += 45;
  }




  return score;
}




function diqV74LocationScore(item) {
  var score = 0;




  if (
    item &&
    item.locationVerified === true
  ) {
    score += 150;
  }




  if (
    item &&
    clean(
      item.googlePlaceId ||
      item.placeId
    )
  ) {
    score += 55;
  }




  if (
    item &&
    clean(
      item.canonicalAddress ||
      item.address ||
      item.full
    )
  ) {
    score += 35;
  }




  if (
    item &&
    finite(Number(item.lat)) &&
    finite(Number(item.lng))
  ) {
    score += 45;
  } else {
    score -= 500;
  }




  if (
    item &&
    (
      item.locationConfidence === "conflict" ||
      item.locationConfidence === "identity_conflict"
    )
  ) {
    score -= 500;
  }




  return score;
}




function diqV74QualityScore(item) {
  var rating = diqV74Number(
    item,
    [
      "rating",
      "googleRating",
      "stars"
    ],
    0
  );
  var reviews = diqV74Number(
    item,
    [
      "reviewCount",
      "reviews",
      "userRatingCount",
      "ratingCount"
    ],
    0
  );
  var score = 0;




  if (rating > 0) {
    score += Math.round(
      Math.max(0, rating - 3.4) * 105
    );
  }




  if (reviews > 0) {
    score += Math.min(
      150,
      Math.round(
        Math.log(reviews + 1) * 24
      )
    );
  }




  if (
    item && (
      item.localFavorite === true ||
      item.localAnchor === true
    )
  ) {
    score += 105;
  }




  if (
    item && (
      item.officialVerified === true ||
      item.officialSite === true
    )
  ) {
    score += 30;
  }




  if (
    item &&
    finite(Number(item.worthTheDrive))
  ) {
    score += Math.round(
      Number(item.worthTheDrive) * 0.45
    );
  }




  return score;
}




function diqV74ChainPenalty(item) {
  var text = diqV74Text(item);
  var chains = [
    "mcdonald",
    "starbucks",
    "wendy",
    "burger king",
    "taco bell",
    "chick fil a",
    "applebee",
    "olive garden",
    "red lobster",
    "buffalo wild wings",
    "ihop",
    "denny",
    "sonic drive",
    "subway",
    "domino",
    "pizza hut"
  ];
  var i;




  if (
    item && (
      item.localAnchor === true ||
      item.localFavorite === true
    )
  ) {
    return 0;
  }




  for (i = 0; i < chains.length; i++) {
    if (text.indexOf(chains[i]) > -1) {
      return -85;
    }
  }




  return 0;
}




function diqV74CuisineBucket(item) {
  var text = diqV74Text(item);




  if (
    text.indexOf("seafood") > -1 ||
    text.indexOf("crab") > -1 ||
    text.indexOf("oyster") > -1
  ) { return "seafood"; }




  if (
    text.indexOf("pizza") > -1 ||
    text.indexOf("italian") > -1
  ) { return "pizza_italian"; }




  if (
    text.indexOf("mexican") > -1 ||
    text.indexOf("taco") > -1 ||
    text.indexOf("cantina") > -1
  ) { return "mexican"; }




  if (
    text.indexOf("bbq") > -1 ||
    text.indexOf("barbecue") > -1
  ) { return "bbq"; }




  if (
    text.indexOf("burger") > -1 ||
    text.indexOf("american") > -1 ||
    text.indexOf("grill") > -1
  ) { return "american"; }




  if (
    text.indexOf("coffee") > -1 ||
    text.indexOf("cafe") > -1 ||
    text.indexOf("bakery") > -1
  ) { return "cafe"; }




  if (
    text.indexOf("asian") > -1 ||
    text.indexOf("sushi") > -1 ||
    text.indexOf("thai") > -1 ||
    text.indexOf("chinese") > -1 ||
    text.indexOf("japanese") > -1
  ) { return "asian"; }




  return "other";
}




function diqV74ExperienceBucket(item) {
  var text = diqV74Text(item);




  if (
    text.indexOf("waterfront") > -1 ||
    text.indexOf("harbor") > -1 ||
    text.indexOf("beach") > -1 ||
    text.indexOf("view") > -1
  ) { return "scenic"; }




  if (
    text.indexOf("family") > -1 ||
    text.indexOf("casual") > -1
  ) { return "family"; }




  if (
    text.indexOf("date") > -1 ||
    text.indexOf("romantic") > -1 ||
    text.indexOf("upscale") > -1
  ) { return "date_night"; }




  if (
    text.indexOf("quick") > -1 ||
    text.indexOf("counter") > -1 ||
    text.indexOf("takeout") > -1
  ) { return "quick"; }




  if (
    item && item.localAnchor === true
  ) { return "local_anchor"; }




  return "general";
}




function diqV74BaseScore(item, query) {
  var categoryScore =
    diqV74CategoryTruthScore(item, query);
  var availabilityScore =
    diqV74AvailabilityScore(item);
  var locationScore =
    diqV74LocationScore(item);
  var qualityScore =
    diqV74QualityScore(item);
  var distanceScore =
    diqV72DistanceFitScore(item, query);
  var localScore =
    diqV72LocalAnchorScore(item, query);
  var chainScore =
    diqV74ChainPenalty(item);




  item.diqV74ScoreParts = {
    category:categoryScore,
    availability:availabilityScore,
    location:locationScore,
    quality:qualityScore,
    distance:distanceScore,
    localAnchor:localScore,
    chain:chainScore
  };




  return (
    categoryScore +
    availabilityScore +
    locationScore +
    qualityScore +
    distanceScore +
    localScore +
    chainScore
  );
}




function diqV74ConfidenceTier(item) {
  var parts = item.diqV74ScoreParts || {};
  var total = Number(item.diqV74SelectionScore || 0);




  if (
    parts.location >= 230 &&
    parts.category >= 150 &&
    parts.quality >= 100 &&
    total >= 520
  ) {
    return "HIGH CONFIDENCE";
  }




  if (
    parts.location >= 120 &&
    parts.category >= 80 &&
    total >= 330
  ) {
    return "GOOD MATCH";
  }




  return "CONFIRM FIRST";
}




function diqV74Reason(item) {
  var parts = item.diqV74ScoreParts || {};
  var distance = diqV72DistanceFromCenter(item);




  if (
    item.localAnchor === true ||
    parts.localAnchor >= 100
  ) {
    return "Top local establishment";
  }




  if (
    parts.quality >= 210
  ) {
    return "Strong local reputation";
  }




  if (
    diqV74ExperienceBucket(item) === "scenic"
  ) {
    return "Standout local experience";
  }




  if (
    finite(Number(distance)) &&
    distance <= 5
  ) {
    return "Strong nearby option";
  }




  if (
    parts.distance < 0 &&
    parts.quality >= 150
  ) {
    return "Worth the drive";
  }




  if (
    parts.availability >= 80
  ) {
    return "Open and ready now";
  }




  return "Strong match for this scan";
}




function diqV74Role(item, index) {
  if (
    item.localAnchor === true ||
    (item.diqV74ScoreParts &&
     item.diqV74ScoreParts.localAnchor >= 100)
  ) {
    return "local_anchor";
  }




  if (
    item.diqV74Reason === "Worth the drive"
  ) {
    return "worth_the_drive";
  }




  if (index === 0) {
    return "top_pick";
  }




  return diqV74CuisineBucket(item);
}




function diqV74SelectBest(items, query) {
  var scored = [];
  var selected = [];
  var cuisineCounts = {};
  var experienceCounts = {};
  var brandSeen = {};
  var i;
  var item;
  var nameKey;
  var cuisine;
  var experience;
  var penalty;
  var candidateScore;
  var bestIndex;
  var bestScore;




  for (i = 0; i < (items || []).length; i++) {
    item = items[i];




    if (!diqV73ValidResultItem(item)) {
      continue;
    }




    item.diqV74SelectionScore =
      diqV74BaseScore(item, query);




    scored.push(item);
  }




  scored.sort(function (a, b) {
    return (
      Number(b.diqV74SelectionScore || 0) -
      Number(a.diqV74SelectionScore || 0)
    );
  });




  while (
    selected.length < diqV74FinalCount &&
    scored.length
  ) {
    bestIndex = -1;
    bestScore = -999999;




    for (i = 0; i < scored.length; i++) {
      item = scored[i];
      cuisine = diqV74CuisineBucket(item);
      experience = diqV74ExperienceBucket(item);
      nameKey = normText(item.label);
      penalty = 0;




      if (brandSeen[nameKey]) {
        penalty += 500;
      }




      if ((cuisineCounts[cuisine] || 0) >= 2) {
        penalty += 95;
      }




      if (
        cuisine !== "other" &&
        (cuisineCounts[cuisine] || 0) >= 3
      ) {
        penalty += 220;
      }




      if (
        experience !== "general" &&
        (experienceCounts[experience] || 0) >= 2
      ) {
        penalty += 55;
      }




      candidateScore =
        Number(item.diqV74SelectionScore || 0) -
        penalty;




      if (candidateScore > bestScore) {
        bestScore = candidateScore;
        bestIndex = i;
      }
    }




    if (bestIndex < 0) {
      break;
    }




    item = scored.splice(bestIndex, 1)[0];




    /* Do not pad the final set with a fundamentally weak candidate. */
    if (
      Number(item.diqV74SelectionScore || 0) < 80 &&
      selected.length >= 5
    ) {
      continue;
    }




    cuisine = diqV74CuisineBucket(item);
    experience = diqV74ExperienceBucket(item);
    nameKey = normText(item.label);




    cuisineCounts[cuisine] =
      (cuisineCounts[cuisine] || 0) + 1;
    experienceCounts[experience] =
      (experienceCounts[experience] || 0) + 1;
    brandSeen[nameKey] = true;




    item.diqV74Confidence =
      diqV74ConfidenceTier(item);
    item.diqV74Reason =
      diqV74Reason(item);
    item.diqV74Role =
      diqV74Role(item, selected.length);
    item.diqV74FinalRank =
      selected.length + 1;




    selected.push(item);
  }




  diqV74FounderTrace = selected.map(
    function (candidate) {
      return {
        rank:candidate.diqV74FinalRank,
        name:candidate.label,
        placeId:
          candidate.googlePlaceId ||
          candidate.placeId ||
          "",
        address:
          candidate.canonicalAddress ||
          candidate.address ||
          candidate.full ||
          "",
        lat:candidate.lat,
        lng:candidate.lng,
        score:candidate.diqV74SelectionScore,
        scoreParts:candidate.diqV74ScoreParts,
        confidence:candidate.diqV74Confidence,
        role:candidate.diqV74Role,
        reason:candidate.diqV74Reason,
        distanceMiles:
          diqV72DistanceFromCenter(candidate)
      };
    }
  );




  try {
    window.DRIVE_IQ_BEST_8_DEBUG =
      diqV74FounderTrace.slice(0);




    console.log(
      "ðŸ† Drive IQ V74 Best 8",
      diqV74FounderTrace
    );
  } catch (e0) {}




  return selected;
}




/* V74 sits above V73. The selected set is then synchronized by V73 across
   pins, count, shelf cards, and Place IQ tap targets. */
var diqV74PriorRenderAdventureScanChoices =
  renderAdventureScanChoices;




renderAdventureScanChoices = function (
  items,
  query
) {
  var source = diqV73DedupeResults(
    items || []
  );
  var selected;




  if (source.length > diqV74FinalCount) {
    selected = diqV74SelectBest(
      source,
      query || activeLens
    );
  } else {
    selected = diqV74SelectBest(
      source,
      query || activeLens
    );




    if (!selected.length) {
      selected = source;
    }
  }




  return diqV74PriorRenderAdventureScanChoices(
    selected,
    query
  );
};




try {
  console.log(
    "âœ… Drive IQ V74 Best 8 Selection IQ loaded"
  );
} catch (e0) {}
















/* =========================================================
   DRIVE IQ V75 â€” SINGLE PHOTO AUTHORITY




   Removes obsolete live photo scans from the rendering path.




   Production flow:
   1. verified shared cache
   2. Cloudflare resolver
   3. neutral category fallback until verified image is ready
   4. one clean fade-in




   Disabled from live authority:
   - legacy Google Places JS photo scans
   - Places New retry ladders
   - Street View probes
   - static-map photo attempts
   - direct URI rescue ladders
   - stale delayed photo callbacks




   Result thumbnails and Place IQ hero share one request/cache.
========================================================= */




window.__DRIVE_IQ_ADVENTURE_MODE_JS_V75_SINGLE_PHOTO_AUTHORITY__ = true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD = "V75_SINGLE_PHOTO_AUTHORITY";




var diqV75PhotoCache = {};
var diqV75PhotoPending = {};
var diqV75HeroGeneration = 0;
var diqV75ThumbGeneration = 0;




function diqV75PhotoKey(item) {
  var id = clean(
    item && (
      item.googlePlaceId ||
      item.placeId ||
      ""
    )
  );




  if (id) {
    return "place:" + id;
  }




  return "geo:" + normText(
    String(item && item.label || "")
  ) + "|" +
    String(Number(item && item.lat || 0).toFixed(5)) +
    "|" +
    String(Number(item && item.lng || 0).toFixed(5));
}




function diqV75ExistingVerifiedPhoto(item) {
  var key = diqV75PhotoKey(item);
  var url = clean(
    item && (
      item.workerPhotoUrl ||
      item.photoProxyUrl ||
      item.driveIQPhotoUrl
    ) || ""
  );




  if (
    diqV75PhotoCache[key] &&
    diqV75PhotoCache[key].verified === true
  ) {
    return clean(
      diqV75PhotoCache[key].url
    );
  }




  if (
    url &&
    (
      url.indexOf(
        DIQ_PHOTO_RESOLVER_BASE
      ) === 0 ||
      url.indexOf(
        "drive-iq-photo-resolver"
      ) > -1
    )
  ) {
    return url;
  }




  return "";
}




function diqV75CommitPhoto(item, url) {
  var key = diqV75PhotoKey(item);




  item.workerPhotoUrl = url;
  item.photoProxyUrl = url;
  item.driveIQPhotoUrl = url;
  item.photoUrl = url;
  item.photoSource =
    "Drive IQ Photo Worker";
  item.photoLoaded = true;
  item.photoStatus = "LOAD:YES";




  diqV75PhotoCache[key] = {
    verified:true,
    url:url,
    ts:Date.now()
  };
}




function diqV75VerifyImage(url, done) {
  var img = new Image();
  var settled = false;
  var timeout;




  function finish(ok) {
    if (settled) {
      return;
    }




    settled = true;
    window.clearTimeout(timeout);
    img.onload = null;
    img.onerror = null;




    done(!!ok);
  }




  img.onload = function () {
    finish(
      Number(img.naturalWidth || 0) >= 100 &&
      Number(img.naturalHeight || 0) >= 70
    );
  };




  img.onerror = function () {
    finish(false);
  };




  timeout = window.setTimeout(
    function () {
      finish(false);
    },
    10000
  );




  try {
    img.referrerPolicy = "no-referrer";
  } catch (e0) {}




  try {
    img.src = url;
  } catch (e1) {
    finish(false);
  }
}




function diqV75ResolveOnce(item, callback) {
  var key;
  var cached;
  var payload;




  if (
    !item ||
    !clean(item.label) ||
    !finite(Number(item.lat)) ||
    !finite(Number(item.lng))
  ) {
    callback("");
    return;
  }




  key = diqV75PhotoKey(item);
  cached = diqV75ExistingVerifiedPhoto(
    item
  );




  if (cached) {
    diqV75VerifyImage(
      cached,
      function (ok) {
        if (ok) {
          diqV75CommitPhoto(
            item,
            cached
          );
          callback(cached);
        } else {
          delete diqV75PhotoCache[key];
          callback("");
        }
      }
    );
    return;
  }




  if (diqV75PhotoPending[key]) {
    diqV75PhotoPending[key].push(
      callback
    );
    return;
  }




  diqV75PhotoPending[key] = [
    callback
  ];




  payload = {
    name:clean(item.label || ""),
    lat:Number(item.lat),
    lng:Number(item.lng),
    placeId:clean(
      item.googlePlaceId ||
      item.placeId ||
      ""
    )
  };




  function finishAll(url) {
    var callbacks =
      diqV75PhotoPending[key] || [];
    var i;




    delete diqV75PhotoPending[key];




    for (i = 0; i < callbacks.length; i++) {
      try {
        callbacks[i](url || "");
      } catch (e0) {}
    }
  }




  try {
    fetch(
      DIQ_PHOTO_RESOLVER_BASE +
        "/resolve",
      {
        method:"POST",
        headers:{
          "Content-Type":
            "application/json"
        },
        body:JSON.stringify(payload),
        credentials:"omit",
        cache:"no-store"
      }
    )
      .then(function (response) {
        if (!response || !response.ok) {
          throw new Error(
            "Photo resolver failed"
          );
        }




        return response.json();
      })
      .then(function (data) {
        var url;




        if (
          !data ||
          data.ok !== true ||
          !clean(data.imageUrl)
        ) {
          finishAll("");
          return;
        }




        url = clean(data.imageUrl);




        if (clean(data.placeId)) {
          item.googlePlaceId =
            clean(data.placeId);
          item.placeId =
            clean(data.placeId);
        }




        diqV75VerifyImage(
          url,
          function (ok) {
            if (!ok) {
              finishAll("");
              return;
            }




            diqV75CommitPhoto(
              item,
              url
            );




            finishAll(url);
          }
        );
      })
      .catch(function () {
        finishAll("");
      });
  } catch (e1) {
    finishAll("");
  }
}




function diqV75ResetHeroNeutral() {
  var photo = diqV67PhotoHero();
  var old;
  var i;




  if (!photo) {
    return null;
  }




  try {
    old = photo.querySelectorAll(
      "img.diqV67WorkerPhoto," +
      "img.diqV66PhotoImage," +
      "img.diqV62PhotoImage," +
      "img[data-diq-photo]," +
      ".diqPhotoLiveImage"
    );
  } catch (e0) {
    old = [];
  }




  for (i = 0; i < old.length; i++) {
    try {
      if (old[i] && old[i].parentNode) {
        old[i].parentNode.removeChild(
          old[i]
        );
      }
    } catch (e1) {}
  }




  try {
    photo.style.removeProperty(
      "background-image"
    );
  } catch (e2) {}




  photo.className =
    String(photo.className || "")
      .replace(/\brealPhoto\b/g, "")
      .replace(/\bphotoLive\b/g, "")
      .replace(/\bv67WorkerPhotoLive\b/g, "") +
    " stablePhotoFallback diqV75NeutralPhoto";




  photo.removeAttribute(
    "data-photo-live"
  );
  photo.removeAttribute(
    "data-photo-url"
  );




  return photo;
}




function diqV75PaintHero(
  item,
  url,
  generation
) {
  if (
    generation !== diqV75HeroGeneration ||
    !url
  ) {
    return;
  }




  diqV67PaintWorkerPhoto(
    item,
    url,
    "v75-single-authority"
  );
}




function diqV75RequestHero(item) {
  var generation;




  diqV75HeroGeneration += 1;
  generation = diqV75HeroGeneration;




  diqV75ResetHeroNeutral();




  diqV75ResolveOnce(
    item,
    function (url) {
      diqV75PaintHero(
        item,
        url,
        generation
      );
    }
  );
}




function diqV75RequestThumb(
  item,
  generation
) {
  diqV75ResolveOnce(
    item,
    function (url) {
      if (
        generation !==
        diqV75ThumbGeneration ||
        !url
      ) {
        return;
      }




      diqV69PaintThumb(
        item,
        url
      );
    }
  );
}




/* Disable obsolete photo authorities. */
diqHydratePlacePhotos = function () {
  return false;
};




diqGooglePlacesPhotoResolver = function (
  item,
  query,
  done
) {
  if (done) { done([]); }
  return false;
};




diqGooglePlacesNewPhotoResolver = function (
  item,
  query,
  done
) {
  if (done) { done([]); }
  return false;
};




diqGoogleNewTextSearchPhotoResolver = function (
  item,
  query,
  done
) {
  if (done) { done([]); }
  return false;
};




diqV42GoogleNewSearchPhotos = function (
  item,
  query,
  done
) {
  if (done) { done([]); }
  return false;
};




diqV47TextSearchPhotoResolver = function (
  item,
  query,
  done
) {
  if (done) { done([]); }
  return false;
};




diqV48TextSearchPhotoResolver = function (
  item,
  query,
  done
) {
  if (done) { done([]); }
  return false;
};




diqV49NearbySearchPhotoResolver = function (
  item,
  query,
  done
) {
  if (done) { done([]); }
  return false;
};




diqV52StreetViewPhotos = function () {
  return [];
};




diqV56PaintPhotoNow = function () {
  return false;
};




diqV56VerifyImage = function () {
  return false;
};




diqV60HydrateLegacyPhoto = function () {
  return false;
};




diqV62TryPhoto = function () {
  return false;
};




diqV66StartPhotoRescue = function () {
  return false;
};




diqV66ResolveDirectPhotoUri = function (
  item,
  query,
  done
) {
  if (done) { done(""); }
  return false;
};




/* Full Place IQ card: no old gallery paint, no delayed retries. */
diqApplyPlaceGallery = function (
  item,
  query
) {
  diqV75RequestHero(item);
  return [];
};




/* Re-route V67 and V69 through the shared authority. */
diqV67ResolveWorkerPhoto = function (
  item,
  query,
  stage
) {
  diqV75RequestHero(item);
  return true;
};




diqV69ResolveThumb = function (
  item,
  query,
  generation
) {
  diqV75RequestThumb(
    item,
    generation
  );
  return true;
};




/* Every newly rendered shelf gets one shared generation. */
var diqV75PriorRenderAdventureScanChoices =
  renderAdventureScanChoices;




renderAdventureScanChoices = function (
  items,
  query
) {
  var result =
    diqV75PriorRenderAdventureScanChoices(
      items,
      query
    );
  var list = items || [];
  var generation;
  var i;




  diqV75ThumbGeneration += 1;
  generation =
    diqV75ThumbGeneration;




  for (i = 0; i < list.length; i++) {
    (function (candidate, index) {
      window.setTimeout(
        function () {
          diqV75RequestThumb(
            candidate,
            generation
          );
        },
        index * 120
      );
    })(list[i], i);
  }




  return result;
};




(function diqV75InjectStyles() {
  var style;




  if (byId("diqV75SinglePhotoStyle")) {
    return;
  }




  style = document.createElement("style");
  style.id = "diqV75SinglePhotoStyle";
  style.textContent =
    ".diqV75NeutralPhoto{" +
      "background-image:none!important;" +
      "background-color:#07131d!important;" +
    "}" +
    ".diqV75NeutralPhoto:before{" +
      "opacity:1!important;" +
    "}" +
    ".diqV67WorkerPhoto," +
    ".diqV69ThumbImage{" +
      "transition:opacity .22s ease!important;" +
    "}";




  try {
    document.head.appendChild(style);
  } catch (e0) {}
})();




try {
  console.log(
    "âœ… Drive IQ V75 Single Photo Authority loaded"
  );
} catch (e0) {}
















/* =========================================================
   DRIVE IQ V76 â€” CATEGORY TRUTH + BEST 8â€“12




   Major category-quality pass:
   - Popular Now and Local Favorites are no longer aliases
   - confidence-driven result volume: 8â€“12
   - normal target 10, max 12 in strong markets
   - heritage-anchor protection
   - Dewey Destin's Destin QA benchmark
   - category-specific scoring, reasons, and debug traces




   Protected:
   - V73 unified result state
   - V74 quality/diversity selection
   - V75 single photo authority
========================================================= */




window.__DRIVE_IQ_ADVENTURE_MODE_JS_V76_CATEGORY_TRUTH_BEST_12__ = true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD = "V76_CATEGORY_TRUTH_BEST_12";




var diqV76OriginalBuildAdventureQueries =
  buildAdventureQueries;
var diqV76OriginalLocalFavoritesTrustQueries =
  localFavoritesTrustQueries;
var diqV76OriginalV74SelectBest =
  diqV74SelectBest;




function diqV76AddQuery(out, value) {
  var v = clean(value);
  var n;
  var i;




  if (!v) { return; }
  n = normText(v);




  for (i = 0; i < out.length; i++) {
    if (normText(out[i]) === n) {
      return;
    }
  }




  out.push(v);
}




function diqV76DestinationSuffix() {
  var suffix = "";




  try {
    suffix = destinationTermSuffix();
  } catch (e0) {}




  return clean(suffix);
}




function diqV76DestinationText() {
  return normText(
    String(adventureSearchCenter && adventureSearchCenter.label || "") + " " +
    String(destination && destination.label || "") + " " +
    String(destination && destination.full || "") + " " +
    String(activeScanQuery || "")
  );
}




function diqV76IsDestinContext() {
  var text = diqV76DestinationText();




  if (
    text.indexOf("destin") > -1 ||
    text.indexOf("okaloosa") > -1 ||
    text.indexOf("harborwalk") > -1
  ) {
    return true;
  }




  try {
    return !!isDestinWaterfrontRegion();
  } catch (e0) {
    return false;
  }
}




function diqV76PopularQueries() {
  var out = [];
  var city = diqV76DestinationSuffix();




  diqV76AddQuery(out, "popular now" + city);
  diqV76AddQuery(out, "trending places" + city);
  diqV76AddQuery(out, "busy restaurants now" + city);
  diqV76AddQuery(out, "popular restaurants this week" + city);
  diqV76AddQuery(out, "things to do tonight" + city);
  diqV76AddQuery(out, "popular bars tonight" + city);
  diqV76AddQuery(out, "live music tonight" + city);
  diqV76AddQuery(out, "events tonight" + city);
  diqV76AddQuery(out, "waterfront restaurants busy now" + city);
  diqV76AddQuery(out, "popular family attractions" + city);
  diqV76AddQuery(out, "popular local spots open now" + city);
  diqV76AddQuery(out, "top reviewed places recently" + city);




  if (diqV76IsDestinContext()) {
    diqV76AddQuery(out, "popular now Destin Florida");
    diqV76AddQuery(out, "Destin Harbor popular tonight");
    diqV76AddQuery(out, "HarborWalk Village busy tonight");
    diqV76AddQuery(out, "popular waterfront restaurants Destin");
    diqV76AddQuery(out, "popular seafood restaurants Destin");
    diqV76AddQuery(out, "popular attractions Destin today");
  }




  return out;
}




function diqV76LocalFavoriteQueries() {
  var out = [];
  var city = diqV76DestinationSuffix();




  diqV76AddQuery(out, "local favorites" + city);
  diqV76AddQuery(out, "where locals eat" + city);
  diqV76AddQuery(out, "where locals go" + city);
  diqV76AddQuery(out, "locally owned restaurants" + city);
  diqV76AddQuery(out, "longtime local restaurants" + city);
  diqV76AddQuery(out, "historic local restaurants" + city);
  diqV76AddQuery(out, "neighborhood favorites" + city);
  diqV76AddQuery(out, "local institutions" + city);
  diqV76AddQuery(out, "family owned restaurants" + city);
  diqV76AddQuery(out, "local coffee shops" + city);
  diqV76AddQuery(out, "local breweries" + city);
  diqV76AddQuery(out, "community hangouts" + city);
  diqV76AddQuery(out, "local hidden gems" + city);




  if (diqV76IsDestinContext()) {
    diqV76AddQuery(out, "Dewey Destin's Destin Florida");
    diqV76AddQuery(out, "McGuire's Irish Pub Destin");
    diqV76AddQuery(out, "oldest local restaurants Destin");
    diqV76AddQuery(out, "family owned seafood restaurants Destin");
    diqV76AddQuery(out, "longtime Destin local favorites");
    diqV76AddQuery(out, "historic Destin restaurants");
    diqV76AddQuery(out, "where Destin locals eat");
  }




  return out;
}




/* Local Favorites no longer borrows popularity/trending language. */
localFavoritesTrustQueries = function (passIndex) {
  var out = diqV76LocalFavoriteQueries();
  var pass = Number(passIndex || 0);




  if (pass >= 1) {
    diqV76AddQuery(out, "local parks" + diqV76DestinationSuffix());
    diqV76AddQuery(out, "local recreation" + diqV76DestinationSuffix());
    diqV76AddQuery(out, "independent shops" + diqV76DestinationSuffix());
    diqV76AddQuery(out, "local dessert shops" + diqV76DestinationSuffix());
  }




  if (pass >= 2) {
    diqV76AddQuery(out, "community landmarks" + diqV76DestinationSuffix());
    diqV76AddQuery(out, "long running businesses" + diqV76DestinationSuffix());
  }




  return out;
};




/* Category-specific query authority. */
buildAdventureQueries = function (query) {
  var cat = categoryFromQuery(query);
  var original = [];
  var out = [];
  var specific;
  var i;




  try {
    original = diqV76OriginalBuildAdventureQueries(query) || [];
  } catch (e0) {
    original = [query];
  }




  if (cat === "popular tonight") {
    specific = diqV76PopularQueries();




    for (i = 0; i < specific.length; i++) {
      diqV76AddQuery(out, specific[i]);
    }




    /* Keep only truly dynamic original terms. */
    for (i = 0; i < original.length; i++) {
      if (
        /popular|tonight|trending|busy|event|live music|open now|things to do/i.test(
          original[i]
        )
      ) {
        diqV76AddQuery(out, original[i]);
      }
    }




    return out.slice(0, 24);
  }




  if (cat === "local favorites") {
    specific = diqV76LocalFavoriteQueries();




    for (i = 0; i < specific.length; i++) {
      diqV76AddQuery(out, specific[i]);
    }




    return out.slice(0, 24);
  }




  for (i = 0; i < original.length; i++) {
    diqV76AddQuery(out, original[i]);
  }




  if (
    diqV76IsDestinContext() &&
    (
      cat === "food iq" ||
      cat === "food drinks"
    )
  ) {
    diqV76AddQuery(out, "Dewey Destin's Destin Florida");
    diqV76AddQuery(out, "historic seafood restaurants Destin");
    diqV76AddQuery(out, "family owned seafood Destin");
  }




  return out;
};




function diqV76Text(item) {
  return normText(
    String(item && item.label || "") + " " +
    String(item && item.full || "") + " " +
    String(item && item.kind || "") + " " +
    String(item && item.category || "") + " " +
    String(item && item.tags || "")
  );
}




function diqV76IsDeweyDestins(item) {
  var text = diqV76Text(item);




  return (
    text.indexOf("dewey destin") > -1 ||
    (
      text.indexOf("dewey") > -1 &&
      text.indexOf("destin") > -1
    )
  );
}




function diqV76IsHeritageAnchor(item, query) {
  var text = diqV76Text(item);
  var cat = categoryFromQuery(query);




  if (
    diqV76IsDestinContext() &&
    diqV76IsDeweyDestins(item) &&
    (
      cat === "food iq" ||
      cat === "food drinks" ||
      cat === "local favorites"
    )
  ) {
    return true;
  }




  return !!(
    item && (
      item.heritageAnchor === true ||
      item.historicLocal === true ||
      item.longRunningLocal === true
    )
  ) || (
    text.indexOf("historic") > -1 &&
    text.indexOf("local") > -1
  );
}




function diqV76DynamicPopularityScore(item) {
  var text = diqV76Text(item);
  var score = 0;
  var reviews = diqV74Number(
    item,
    [
      "reviewCount",
      "reviews",
      "userRatingCount",
      "ratingCount"
    ],
    0
  );




  if (
    item && (
      item.openNow === true ||
      item.isOpen === true
    )
  ) {
    score += 65;
  }




  if (
    item && (
      item.trending === true ||
      item.popularNow === true ||
      item.busyNow === true
    )
  ) {
    score += 150;
  }




  if (
    item && finite(Number(item.reviewVelocity))
  ) {
    score += Math.min(
      140,
      Number(item.reviewVelocity) * 18
    );
  }




  if (
    item && finite(Number(item.recentRoutes))
  ) {
    score += Math.min(
      90,
      Number(item.recentRoutes) * 8
    );
  }




  if (
    item && finite(Number(item.recentSaves))
  ) {
    score += Math.min(
      90,
      Number(item.recentSaves) * 8
    );
  }




  if (
    /tonight|live music|event|busy|popular|trending|open late/.test(text)
  ) {
    score += 55;
  }




  if (reviews >= 500) {
    score += 45;
  }




  return score;
}




function diqV76EnduringLocalScore(item) {
  var text = diqV76Text(item);
  var score = 0;




  if (
    item && (
      item.localAnchor === true ||
      item.localFavorite === true
    )
  ) {
    score += 130;
  }




  if (
    item && (
      item.repeatLocalInterest === true ||
      item.repeatVisits === true
    )
  ) {
    score += 100;
  }




  if (
    /family owned|locally owned|local institution|longtime|long running|historic|neighborhood favorite/.test(text)
  ) {
    score += 95;
  }




  if (diqV76IsHeritageAnchor(item, "local favorites")) {
    score += 220;
  }




  return score;
}




function diqV76CategoryRoleScore(item, query) {
  var cat = categoryFromQuery(query);




  if (cat === "popular tonight") {
    return diqV76DynamicPopularityScore(item);
  }




  if (cat === "local favorites") {
    return diqV76EnduringLocalScore(item);
  }




  if (
    cat === "food iq" ||
    cat === "food drinks"
  ) {
    return diqV76IsHeritageAnchor(item, query)
      ? 180
      : 0;
  }




  return 0;
}




function diqV76DesiredCount(items, query) {
  var count = (items || []).length;
  var cat = categoryFromQuery(query);




  if (count <= 8) {
    return count;
  }




  if (
    cat === "food iq" ||
    cat === "food drinks" ||
    cat === "local favorites" ||
    cat === "popular tonight"
  ) {
    if (count >= 12) {
      return 12;
    }
    if (count >= 10) {
      return 10;
    }
  }




  return Math.min(10, count);
}




/* Extend V74 score with category-specific truth and heritage value. */
var diqV76OriginalV74BaseScore =
  diqV74BaseScore;




diqV74BaseScore = function (item, query) {
  var base = diqV76OriginalV74BaseScore(
    item,
    query
  );
  var roleScore =
    diqV76CategoryRoleScore(item, query);




  item.diqV76CategoryRoleScore =
    roleScore;




  if (diqV76IsHeritageAnchor(item, query)) {
    item.heritageAnchor = true;
    item.localAnchor = true;
  }




  return base + roleScore;
};




var diqV76OriginalV74Reason =
  diqV74Reason;




diqV74Reason = function (item) {
  var cat = categoryFromQuery(
    activeScanQuery ||
    activeLens ||
    ""
  );




  if (item && item.heritageAnchor === true) {
    return "Heritage local institution";
  }




  if (
    cat === "popular tonight" &&
    Number(item && item.diqV76CategoryRoleScore || 0) >= 100
  ) {
    return "Getting strong attention right now";
  }




  if (
    cat === "local favorites" &&
    Number(item && item.diqV76CategoryRoleScore || 0) >= 100
  ) {
    return "Locals keep coming back";
  }




  return diqV76OriginalV74Reason(item);
};




var diqV76OriginalV74Role =
  diqV74Role;




diqV74Role = function (item, index) {
  if (item && item.heritageAnchor === true) {
    return "heritage_anchor";
  }




  return diqV76OriginalV74Role(
    item,
    index
  );
};




/* Confidence-driven Best 8â€“12 instead of a hard eight. */
diqV74SelectBest = function (items, query) {
  var desired =
    diqV76DesiredCount(items, query);
  var previous = diqV74FinalCount;
  var selected;




  diqV74FinalCount = desired;




  try {
    selected =
      diqV76OriginalV74SelectBest(
        items,
        query
      );
  } finally {
    diqV74FinalCount = previous;
  }




  try {
    console.log(
      "ðŸŽ¯ Drive IQ V76 category result set",
      {
        category:categoryFromQuery(query),
        candidateCount:(items || []).length,
        selectedCount:selected.length,
        target:desired,
        heritage:selected.filter(function (item) {
          return item.heritageAnchor === true;
        }).map(function (item) {
          return item.label;
        })
      }
    );
  } catch (e0) {}




  return selected;
};




try {
  console.log(
    "âœ… Drive IQ V76 Category Truth + Best 8â€“12 loaded"
  );
} catch (e0) {}
















/* =========================================================
   DRIVE IQ V77 â€” CANONICAL PIN AUTHORITY




   Fixes the field issue where the correct 8â€“12 result pins appear, then a
   late fallback callback replaces them with only two orange pins.




   Rules:
   - V73/V76 canonical results are the only final pin authority.
   - Before canonical commit, temporary/search/fallback pins may render.
   - After commit, any different or smaller pin set is rejected.
   - Photo/location hydration may enrich items but cannot replace the set.
   - Canonical pins are reasserted after delayed callbacks.
   - Founder Debug records every blocked overwrite attempt.




   Protected:
   - V75 single photo authority
   - V76 category truth + Best 8â€“12
   - Place IQ, routing, camera, and result shelf behavior
========================================================= */




window.__DRIVE_IQ_ADVENTURE_MODE_JS_V77_CANONICAL_PIN_AUTHORITY__ = true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD = "V77_CANONICAL_PIN_AUTHORITY";




var diqV77CanonicalPinGeneration = 0;
var diqV77CanonicalPinItems = [];
var diqV77CanonicalPinQuery = "";
var diqV77CanonicalPinsCommitted = false;
var diqV77CanonicalCommitAt = 0;
var diqV77PinReassertTimer = null;
var diqV77BlockedPinRenders = [];
var diqV77InsideCanonicalRender = false;




function diqV77PinKey(item) {
  var id;




  if (!item) {
    return "";
  }




  id = clean(
    item.googlePlaceId ||
    item.placeId ||
    item.id ||
    ""
  );




  if (id) {
    return "id:" + id;
  }




  return (
    "geo:" +
    normText(item.label || "") +
    "|" +
    String(Number(item.lat || 0).toFixed(5)) +
    "|" +
    String(Number(item.lng || 0).toFixed(5))
  );
}




function diqV77ValidPinItem(item) {
  return !!(
    item &&
    clean(item.label) &&
    finite(Number(item.lat)) &&
    finite(Number(item.lng))
  );
}




function diqV77DedupePinItems(items) {
  var out = [];
  var seen = {};
  var i;
  var item;
  var key;




  for (i = 0; i < (items || []).length; i++) {
    item = items[i];




    if (!diqV77ValidPinItem(item)) {
      continue;
    }




    key = diqV77PinKey(item);




    if (!key || seen[key]) {
      continue;
    }




    seen[key] = true;
    out.push(item);
  }




  return out;
}




function diqV77SamePinSet(leftItems, rightItems) {
  var left = diqV77DedupePinItems(leftItems);
  var right = diqV77DedupePinItems(rightItems);
  var seen = {};
  var i;




  if (left.length !== right.length) {
    return false;
  }




  for (i = 0; i < left.length; i++) {
    seen[diqV77PinKey(left[i])] = true;
  }




  for (i = 0; i < right.length; i++) {
    if (!seen[diqV77PinKey(right[i])]) {
      return false;
    }
  }




  return true;
}




function diqV77LogBlockedPinRender(source, attempted, reason) {
  var event = {
    ts:Date.now(),
    source:String(source || "unknown"),
    attemptedCount:(attempted || []).length,
    canonicalCount:diqV77CanonicalPinItems.length,
    generation:diqV77CanonicalPinGeneration,
    reason:String(reason || "blocked")
  };




  diqV77BlockedPinRenders.push(event);




  if (diqV77BlockedPinRenders.length > 50) {
    diqV77BlockedPinRenders.shift();
  }




  try {
    window.DRIVE_IQ_PIN_AUTHORITY_DEBUG = {
      generation:diqV77CanonicalPinGeneration,
      canonicalCount:diqV77CanonicalPinItems.length,
      query:diqV77CanonicalPinQuery,
      committed:diqV77CanonicalPinsCommitted,
      committedAt:diqV77CanonicalCommitAt,
      blocked:diqV77BlockedPinRenders.slice(0)
    };




    console.warn(
      "ðŸ›‘ Drive IQ V77 blocked late pin overwrite",
      event
    );
  } catch (e0) {}
}




function diqV77RenderCanonicalPins(reason) {
  if (
    !diqV77CanonicalPinsCommitted ||
    !diqV77CanonicalPinItems.length
  ) {
    return false;
  }




  diqV77InsideCanonicalRender = true;




  try {
    diqV77OriginalRenderResultPins(
      diqV77CanonicalPinItems,
      adventurePreferred ||
      diqV77CanonicalPinItems[0]
    );
  } catch (e0) {
    diqV77InsideCanonicalRender = false;
    return false;
  }




  diqV77InsideCanonicalRender = false;




  try {
    console.log(
      "ðŸ“ Drive IQ V77 canonical pins rendered",
      {
        reason:String(reason || "authority"),
        count:diqV77CanonicalPinItems.length,
        generation:diqV77CanonicalPinGeneration
      }
    );
  } catch (e1) {}




  return true;
}




function diqV77ScheduleCanonicalReassert(reason, delay) {
  var generation = diqV77CanonicalPinGeneration;




  if (diqV77PinReassertTimer) {
    window.clearTimeout(diqV77PinReassertTimer);
  }




  diqV77PinReassertTimer = window.setTimeout(function () {
    if (
      generation !== diqV77CanonicalPinGeneration ||
      !diqV77CanonicalPinsCommitted
    ) {
      return;
    }




    diqV77RenderCanonicalPins(
      reason || "delayed_guard"
    );
  }, finite(Number(delay)) ? Number(delay) : 260);
}




function diqV77CommitCanonicalPinAuthority(items, query) {
  var canonical = diqV77DedupePinItems(
    items || []
  );




  if (!canonical.length) {
    return false;
  }




  diqV77CanonicalPinGeneration += 1;
  diqV77CanonicalPinItems = canonical.slice(0);
  diqV77CanonicalPinQuery = clean(
    query ||
    diqV73CanonicalQuery ||
    activeScanQuery ||
    activeLens ||
    ""
  );
  diqV77CanonicalPinsCommitted = true;
  diqV77CanonicalCommitAt = Date.now();




  try {
    window.DRIVE_IQ_CANONICAL_ADVENTURE_PINS =
      diqV77CanonicalPinItems.slice(0);
  } catch (e0) {}




  diqV77RenderCanonicalPins(
    "canonical_commit"
  );




  diqV77ScheduleCanonicalReassert(
    "post_commit_320ms",
    320
  );




  window.setTimeout(function () {
    if (diqV77CanonicalPinsCommitted) {
      diqV77RenderCanonicalPins(
        "post_commit_900ms"
      );
    }
  }, 900);




  try {
    console.log(
      "âœ… Drive IQ V77 pin authority committed",
      {
        count:diqV77CanonicalPinItems.length,
        query:diqV77CanonicalPinQuery,
        generation:diqV77CanonicalPinGeneration
      }
    );
  } catch (e1) {}




  return true;
}




function diqV77ReleaseCanonicalPinAuthority(reason) {
  diqV77CanonicalPinGeneration += 1;
  diqV77CanonicalPinItems = [];
  diqV77CanonicalPinQuery = "";
  diqV77CanonicalPinsCommitted = false;
  diqV77CanonicalCommitAt = 0;




  if (diqV77PinReassertTimer) {
    window.clearTimeout(diqV77PinReassertTimer);
    diqV77PinReassertTimer = null;
  }




  try {
    console.log(
      "â†» Drive IQ V77 pin authority released",
      String(reason || "new_scan")
    );
  } catch (e0) {}
}




/* The real low-level pin renderer is the enforcement point. */
var diqV77OriginalRenderResultPins =
  renderResultPins;




renderResultPins = function (items, preferred) {
  var attempted =
    diqV77DedupePinItems(items || []);




  if (
    diqV77InsideCanonicalRender ||
    !diqV77CanonicalPinsCommitted
  ) {
    return diqV77OriginalRenderResultPins(
      attempted,
      preferred
    );
  }




  if (
    diqV77SamePinSet(
      attempted,
      diqV77CanonicalPinItems
    )
  ) {
    return diqV77OriginalRenderResultPins(
      diqV77CanonicalPinItems,
      preferred ||
      adventurePreferred ||
      diqV77CanonicalPinItems[0]
    );
  }




  diqV77LogBlockedPinRender(
    "renderResultPins",
    attempted,
    attempted.length < diqV77CanonicalPinItems.length
      ? "smaller_late_pin_set"
      : "noncanonical_late_pin_set"
  );




  diqV77ScheduleCanonicalReassert(
    "blocked_renderResultPins",
    80
  );




  return false;
};




/* Hook directly into V73 canonical state. */
var diqV77PriorV73SetCanonicalResults =
  diqV73SetCanonicalResults;




diqV73SetCanonicalResults = function (
  items,
  query
) {
  var canonical =
    diqV77PriorV73SetCanonicalResults(
      items,
      query
    );




  if (canonical && canonical.length) {
    diqV77CommitCanonicalPinAuthority(
      canonical,
      query
    );
  }




  return canonical;
};




/* A true new category/destination scan releases the previous authority.
   Delayed renders and photo hydration do not. */
var diqV77PriorScanAdventureChoices =
  scanAdventureChoices;




scanAdventureChoices = function (query) {
  diqV77ReleaseCanonicalPinAuthority(
    "new_scan"
  );




  return diqV77PriorScanAdventureChoices(
    query
  );
};




/* Photo hydration may update item data, but it never owns map pins. */
var diqV77PriorV75CommitPhoto =
  diqV75CommitPhoto;




diqV75CommitPhoto = function (item, url) {
  var result =
    diqV77PriorV75CommitPhoto(
      item,
      url
    );




  if (diqV77CanonicalPinsCommitted) {
    diqV77ScheduleCanonicalReassert(
      "photo_hydration",
      120
    );
  }




  return result;
};




/* Export a manual field-test helper. */
window.DRIVE_IQ_REASSERT_CANONICAL_PINS = function () {
  return diqV77RenderCanonicalPins(
    "manual_debug"
  );
};




try {
  console.log(
    "âœ… Drive IQ V77 Canonical Pin Authority loaded"
  );
} catch (e0) {}












/* =========================================================
   DRIVE IQ V81 â€” SAFE ADDITIVE PLACE GALLERY
   Protected baseline:
   - V75 single-photo hero remains first and authoritative
   - V76 category truth / Best 8â€“12 remains untouched
   - V77 canonical pin authority remains untouched




   Safety rules:
   - Extra photos load only after the stable hero image succeeds
   - Hero image is never removed, replaced, reset, or delayed
   - Gallery fails closed to the exact single-hero card
   - No polling loops, no repeated hero resolution, no layout shift
========================================================= */




window.__DRIVE_IQ_ADVENTURE_MODE_JS_V81_SAFE_ADDITIVE_GALLERY__ = true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD = "V81_SAFE_ADDITIVE_GALLERY";




var DIQ_V81_GALLERY_ENABLED =
  window.DRIVE_IQ_ENABLE_SAFE_PLACE_GALLERY !== false;
var diqV81ActiveItem = null;
var diqV81GalleryGeneration = 0;
var diqV81GalleryPending = {};
var diqV81VerifiedCache = {};
var diqV81PriorPaintWorkerPhoto =
  diqV67PaintWorkerPhoto;
var diqV81PriorOpenAdventureInfoCard =
  openAdventureInfoCard;
var diqV81PriorCloseAdventureInfoCard =
  closeAdventureInfoCard;




function diqV81GalleryKey(item) {
  return clean(
    String(item && (
      item.googlePlaceId ||
      item.placeId ||
      item.label
    ) || "") +
    "|" +
    String(Number(item && item.lat || 0).toFixed(5)) +
    "|" +
    String(Number(item && item.lng || 0).toFixed(5))
  );
}




function diqV81NormalizeUrl(value) {
  var url = "";




  if (typeof value === "string") {
    url = clean(value);
  } else if (value && typeof value === "object") {
    url = clean(
      value.url ||
      value.imageUrl ||
      value.photoUrl ||
      value.src ||
      value.mediaUrl ||
      ""
    );
  }




  if (!url || !diqLooksLikeImageUrl(url)) {
    return "";
  }




  return url;
}




function diqV81UniqueUrls(values, heroUrl) {
  var out = [];
  var seen = {};
  var hero = clean(heroUrl || "");
  var i;
  var url;
  var key;




  for (i = 0; i < (values || []).length; i++) {
    url = diqV81NormalizeUrl(values[i]);
    if (!url || url === hero) { continue; }




    key = url
      .replace(/[?&](maxWidthPx|maxHeightPx|width|height)=\d+/gi, "")
      .replace(/[?&]key=[^&]+/gi, "");




    if (seen[key]) { continue; }
    seen[key] = true;
    out.push(url);




    if (out.length >= 4) { break; }
  }




  return out;
}




function diqV81ExtractGalleryUrls(data, heroUrl) {
  var values = [];
  var arrays = [
    data && data.images,
    data && data.photos,
    data && data.gallery,
    data && data.photoUrls,
    data && data.imageUrls
  ];
  var i;
  var j;




  for (i = 0; i < arrays.length; i++) {
    if (!arrays[i] || !arrays[i].length) { continue; }
    for (j = 0; j < arrays[i].length; j++) {
      values.push(arrays[i][j]);
    }
  }




  return diqV81UniqueUrls(values, heroUrl);
}




function diqV81VerifyGalleryUrls(urls, done) {
  var verified = [];
  var pending = Math.min((urls || []).length, 4);
  var settled = false;
  var i;




  if (!pending) {
    done([]);
    return;
  }




  function finishOne(url, ok) {
    if (settled) { return; }
    if (ok) { verified.push(url); }
    pending -= 1;




    if (pending <= 0) {
      settled = true;
      done(verified.slice(0, 4));
    }
  }




  for (i = 0; i < Math.min(urls.length, 4); i++) {
    (function (url) {
      if (diqV81VerifiedCache[url] === true) {
        finishOne(url, true);
        return;
      }




      diqV75VerifyImage(url, function (ok) {
        if (ok) { diqV81VerifiedCache[url] = true; }
        finishOne(url, ok);
      });
    })(urls[i]);
  }
}




function diqV81FetchSecondaryPhotos(item, heroUrl, done) {
  var key = diqV81GalleryKey(item);
  var payload;




  if (!DIQ_V81_GALLERY_ENABLED || !item || !heroUrl) {
    done([]);
    return;
  }




  if (item.diqV81GalleryUrls && item.diqV81GalleryUrls.length) {
    done(item.diqV81GalleryUrls.slice(0));
    return;
  }




  if (diqV81GalleryPending[key]) {
    diqV81GalleryPending[key].push(done);
    return;
  }




  diqV81GalleryPending[key] = [done];




  payload = {
    name:clean(item.label || ""),
    lat:Number(item.lat),
    lng:Number(item.lng),
    placeId:clean(
      item.googlePlaceId ||
      item.placeId ||
      ""
    ),
    gallery:true,
    maxPhotos:5
  };




  function finish(urls) {
    var callbacks = diqV81GalleryPending[key] || [];
    var i;




    delete diqV81GalleryPending[key];




    if (urls && urls.length) {
      item.diqV81GalleryUrls = urls.slice(0);
    }




    for (i = 0; i < callbacks.length; i++) {
      try { callbacks[i](urls || []); } catch (e0) {}
    }
  }




  try {
    fetch(
      DIQ_PHOTO_RESOLVER_BASE + "/resolve",
      {
        method:"POST",
        headers:{"Content-Type":"application/json"},
        body:JSON.stringify(payload),
        credentials:"omit",
        cache:"no-store"
      }
    )
      .then(function (response) {
        if (!response || !response.ok) {
          throw new Error("gallery-resolver-failed");
        }
        return response.json();
      })
      .then(function (data) {
        var urls = diqV81ExtractGalleryUrls(data, heroUrl);




        if (!urls.length) {
          finish([]);
          return;
        }




        diqV81VerifyGalleryUrls(urls, finish);
      })
      .catch(function () {
        finish([]);
      });
  } catch (e1) {
    finish([]);
  }
}




function diqV81RemoveGalleryUI() {
  var hero = diqV67PhotoHero();
  var nodes;
  var i;




  if (!hero) { return; }




  try {
    nodes = hero.querySelectorAll(
      ".diqV81GalleryImage," +
      ".diqV81GalleryControls"
    );
  } catch (e0) {
    nodes = [];
  }




  for (i = 0; i < nodes.length; i++) {
    try {
      if (nodes[i] && nodes[i].parentNode) {
        nodes[i].parentNode.removeChild(nodes[i]);
      }
    } catch (e1) {}
  }




  hero.removeAttribute("data-diq-gallery-ready");
  hero.removeAttribute("data-diq-gallery-index");
}




function diqV81InjectStyles() {
  var style;




  if (byId("diqV81SafeGalleryStyle")) { return; }




  style = document.createElement("style");
  style.id = "diqV81SafeGalleryStyle";
  style.textContent =
    ".diqV81GalleryImage{" +
      "position:absolute!important;" +
      "inset:0!important;" +
      "width:100%!important;" +
      "height:100%!important;" +
      "object-fit:cover!important;" +
      "object-position:center!important;" +
      "display:block!important;" +
      "opacity:0!important;" +
      "visibility:hidden!important;" +
      "pointer-events:none!important;" +
      "z-index:2!important;" +
      "transition:opacity .2s ease!important;" +
    "}" +
    ".diqV81GalleryImage.on{" +
      "opacity:1!important;" +
      "visibility:visible!important;" +
    "}" +
    ".diqV81GalleryControls{" +
      "position:absolute!important;" +
      "left:14px!important;" +
      "right:14px!important;" +
      "bottom:12px!important;" +
      "z-index:8!important;" +
      "display:flex!important;" +
      "align-items:center!important;" +
      "justify-content:space-between!important;" +
      "pointer-events:none!important;" +
    "}" +
    ".diqV81PhotoCount{" +
      "min-height:27px!important;" +
      "padding:0 10px!important;" +
      "border-radius:999px!important;" +
      "display:inline-flex!important;" +
      "align-items:center!important;" +
      "background:rgba(3,11,20,.72)!important;" +
      "border:1px solid rgba(255,255,255,.18)!important;" +
      "color:#fff!important;" +
      "font-size:10px!important;" +
      "font-weight:900!important;" +
      "letter-spacing:.08em!important;" +
      "backdrop-filter:blur(10px)!important;" +
    "}" +
    ".diqV81Dots{" +
      "display:flex!important;" +
      "align-items:center!important;" +
      "gap:5px!important;" +
      "padding:7px 9px!important;" +
      "border-radius:999px!important;" +
      "background:rgba(3,11,20,.62)!important;" +
      "border:1px solid rgba(255,255,255,.14)!important;" +
      "pointer-events:auto!important;" +
    "}" +
    ".diqV81Dot{" +
      "width:6px!important;" +
      "height:6px!important;" +
      "padding:0!important;" +
      "border:0!important;" +
      "border-radius:50%!important;" +
      "background:rgba(255,255,255,.42)!important;" +
      "box-shadow:none!important;" +
    "}" +
    ".diqV81Dot.on{" +
      "width:17px!important;" +
      "border-radius:999px!important;" +
      "background:#60f2d1!important;" +
    "}" +
    "body.diqPlaceIQModalOpen #diqAdventureShowMenu," +
    "body.diqPlaceIQModalOpen .diqShowMenu," +
    "body.diqPlaceIQModalOpen [data-adventure-menu-toggle]," +
    "body.diqPlaceIQModalOpen .adventureCategoryActive," +
    "body.diqPlaceIQModalOpen .diqActiveCategoryControl{" +
      "opacity:.08!important;" +
      "pointer-events:none!important;" +
      "transition:opacity .16s ease!important;" +
    "}" +
    "@media(prefers-reduced-motion:reduce){" +
      ".diqV81GalleryImage{transition:none!important;}" +
    "}";




  try { document.head.appendChild(style); } catch (e0) {}
}




function diqV81BuildGalleryUI(item, heroUrl, secondaryUrls, generation) {
  var hero = diqV67PhotoHero();
  var allUrls = [heroUrl].concat(secondaryUrls || []);
  var controls;
  var count;
  var dots;
  var images = [];
  var current = 0;
  var startX = 0;
  var moved = false;
  var i;




  if (
    generation !== diqV81GalleryGeneration ||
    !hero ||
    !heroUrl ||
    allUrls.length < 2
  ) {
    return;
  }




  diqV81RemoveGalleryUI();
  diqV81InjectStyles();




  hero.style.setProperty("touch-action", "pan-y", "important");
  hero.setAttribute("data-diq-gallery-ready", "1");
  hero.setAttribute("data-diq-gallery-index", "0");




  for (i = 1; i < allUrls.length; i++) {
    (function (url, index) {
      var img = document.createElement("img");
      img.className = "diqV81GalleryImage";
      img.alt = "";
      img.setAttribute("aria-hidden", "true");
      img.setAttribute("data-diq-gallery-photo", String(index));
      try { img.referrerPolicy = "no-referrer"; } catch (e0) {}
      try { img.decoding = "async"; } catch (e1) {}
      img.src = url;
      hero.appendChild(img);
      images[index] = img;
    })(allUrls[i], i);
  }




  controls = document.createElement("div");
  controls.className = "diqV81GalleryControls";




  count = document.createElement("span");
  count.className = "diqV81PhotoCount";
  count.textContent = "1 of " + String(allUrls.length);




  dots = document.createElement("div");
  dots.className = "diqV81Dots";
  dots.setAttribute("aria-label", "Place photos");




  controls.appendChild(count);
  controls.appendChild(dots);
  hero.appendChild(controls);




  function renderIndex(next) {
    var dotNodes;
    var j;




    if (next < 0) { next = allUrls.length - 1; }
    if (next >= allUrls.length) { next = 0; }
    current = next;




    for (j = 1; j < images.length; j++) {
      if (!images[j]) { continue; }
      images[j].className =
        "diqV81GalleryImage" +
        (j === current ? " on" : "");
    }




    try {
      dotNodes = dots.querySelectorAll(".diqV81Dot");
    } catch (e0) {
      dotNodes = [];
    }




    for (j = 0; j < dotNodes.length; j++) {
      dotNodes[j].className =
        "diqV81Dot" +
        (j === current ? " on" : "");
      dotNodes[j].setAttribute(
        "aria-pressed",
        j === current ? "true" : "false"
      );
    }




    count.textContent =
      String(current + 1) +
      " of " +
      String(allUrls.length);




    hero.setAttribute(
      "data-diq-gallery-index",
      String(current)
    );
  }




  for (i = 0; i < allUrls.length; i++) {
    (function (index) {
      var dot = document.createElement("button");
      dot.type = "button";
      dot.className =
        "diqV81Dot" +
        (index === 0 ? " on" : "");
      dot.setAttribute(
        "aria-label",
        "Show photo " + String(index + 1)
      );
      dot.setAttribute(
        "aria-pressed",
        index === 0 ? "true" : "false"
      );
      dot.onclick = function (event) {
        if (event && event.stopPropagation) {
          event.stopPropagation();
        }
        renderIndex(index);
      };
      dots.appendChild(dot);
    })(i);
  }




  hero.addEventListener("touchstart", function (event) {
    var touch =
      event &&
      event.touches &&
      event.touches.length
        ? event.touches[0]
        : null;




    if (!touch) { return; }
    startX = Number(touch.clientX || 0);
    moved = false;
  }, {passive:true});




  hero.addEventListener("touchmove", function (event) {
    var touch =
      event &&
      event.touches &&
      event.touches.length
        ? event.touches[0]
        : null;




    if (!touch) { return; }
    if (Math.abs(Number(touch.clientX || 0) - startX) > 16) {
      moved = true;
    }
  }, {passive:true});




  hero.addEventListener("touchend", function (event) {
    var touch =
      event &&
      event.changedTouches &&
      event.changedTouches.length
        ? event.changedTouches[0]
        : null;
    var endX;
    var delta;




    if (!touch || !moved) { return; }




    endX = Number(touch.clientX || 0);
    delta = endX - startX;




    if (Math.abs(delta) < 38) { return; }




    if (delta < 0) {
      renderIndex(current + 1);
    } else {
      renderIndex(current - 1);
    }
  }, {passive:true});




  renderIndex(0);




  try {
    console.log(
      "âœ… Drive IQ V81 safe gallery ready",
      item && item.label,
      allUrls.length
    );
  } catch (e2) {}
}




function diqV81StartGalleryAfterHero(item, heroUrl) {
  var generation;




  if (
    !DIQ_V81_GALLERY_ENABLED ||
    !item ||
    !heroUrl
  ) {
    return;
  }




  diqV81GalleryGeneration += 1;
  generation = diqV81GalleryGeneration;




  diqV81FetchSecondaryPhotos(
    item,
    heroUrl,
    function (urls) {
      if (
        generation !== diqV81GalleryGeneration ||
        !urls ||
        !urls.length ||
        diqV81ActiveItem !== item
      ) {
        return;
      }




      diqV81BuildGalleryUI(
        item,
        heroUrl,
        urls,
        generation
      );
    }
  );
}




/* The stable V75/V67 hero paints first. Gallery begins only after its
   own image load event has succeeded. */
diqV67PaintWorkerPhoto = function (
  item,
  imageUrl,
  stage
) {
  var result =
    diqV81PriorPaintWorkerPhoto(
      item,
      imageUrl,
      stage
    );
  var hero = diqV67PhotoHero();
  var img = null;




  if (
    !DIQ_V81_GALLERY_ENABLED ||
    !hero ||
    !imageUrl
  ) {
    return result;
  }




  try {
    img = hero.querySelector(
      "img.diqV67WorkerPhoto"
    );
  } catch (e0) {
    img = null;
  }




  if (img) {
    img.addEventListener(
      "load",
      function () {
        if (
          diqV81ActiveItem === item &&
          hero.getAttribute("data-photo-live") === "1"
        ) {
          diqV81StartGalleryAfterHero(
            item,
            imageUrl
          );
        }
      },
      {once:true}
    );
  }




  return result;
};




openAdventureInfoCard = function (
  item,
  preserveBrowseCamera
) {
  diqV81ActiveItem = item || null;
  diqV81GalleryGeneration += 1;
  diqV81RemoveGalleryUI();




  try {
    document.body.classList.add(
      "diqPlaceIQModalOpen"
    );
  } catch (e0) {}




  return diqV81PriorOpenAdventureInfoCard(
    item,
    preserveBrowseCamera
  );
};




closeAdventureInfoCard = function () {
  diqV81ActiveItem = null;
  diqV81GalleryGeneration += 1;
  diqV81RemoveGalleryUI();




  try {
    document.body.classList.remove(
      "diqPlaceIQModalOpen"
    );
  } catch (e0) {}




  return diqV81PriorCloseAdventureInfoCard();
};




window.DRIVE_IQ_SAFE_GALLERY_ON = function () {
  DIQ_V81_GALLERY_ENABLED = true;
  window.DRIVE_IQ_ENABLE_SAFE_PLACE_GALLERY = true;
};




window.DRIVE_IQ_SAFE_GALLERY_OFF = function () {
  DIQ_V81_GALLERY_ENABLED = false;
  window.DRIVE_IQ_ENABLE_SAFE_PLACE_GALLERY = false;
  diqV81GalleryGeneration += 1;
  diqV81RemoveGalleryUI();
};




try {
  console.log(
    "âœ… Drive IQ V81 Safe Additive Gallery loaded"
  );
} catch (e0) {}








/* =========================================================
   DRIVE IQ V82 â€” SAFE GALLERY TRIGGER RESCUE
   Fixes the V81 no-secondary-photo condition without touching hero authority.




   Root cause:
   - V81 attached its listener after V75/V67 painted the hero.
   - Cached images could already be complete before the listener existed.
   - Therefore the gallery resolver was never started.




   V82 rules:
   - Existing V75 hero remains untouched and authoritative.
   - Start immediately when the hero image is already complete.
   - Otherwise wait for its existing load event.
   - Add one short, bounded post-render check; no polling loop.
   - Use the hero's committed URL or item photo authority.
========================================================= */




window.__DRIVE_IQ_ADVENTURE_MODE_JS_V82_GALLERY_TRIGGER_RESCUE__ = true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD = "V82_GALLERY_TRIGGER_RESCUE";




var diqV82PriorPaintWorkerPhoto = diqV67PaintWorkerPhoto;
var diqV82PriorOpenAdventureInfoCard = openAdventureInfoCard;




function diqV82HeroCommittedUrl(item, hero) {
  var url = "";
  var img = null;




  if (!hero) { return ""; }




  try {
    url = clean(hero.getAttribute("data-photo-url") || "");
  } catch (e0) { url = ""; }




  if (!url) {
    try {
      img = hero.querySelector("img.diqV67WorkerPhoto");
      if (img) { url = clean(img.currentSrc || img.src || ""); }
    } catch (e1) { url = ""; }
  }




  if (!url && item) {
    url = clean(
      item.workerPhotoUrl ||
      item.photoProxyUrl ||
      item.driveIQPhotoUrl ||
      item.photoUrl ||
      ""
    );
  }




  return diqLooksLikeImageUrl(url) ? url : "";
}




function diqV82TryStartGallery(item, reason) {
  var hero = diqV67PhotoHero();
  var img = null;
  var heroUrl = "";
  var live = false;




  if (
    !DIQ_V81_GALLERY_ENABLED ||
    !item ||
    diqV81ActiveItem !== item ||
    !hero ||
    hero.getAttribute("data-diq-gallery-ready") === "1"
  ) {
    return false;
  }




  try {
    live = hero.getAttribute("data-photo-live") === "1";
  } catch (e0) { live = false; }




  heroUrl = diqV82HeroCommittedUrl(item, hero);
  if (!live || !heroUrl) { return false; }




  try {
    img = hero.querySelector("img.diqV67WorkerPhoto");
  } catch (e1) { img = null; }




  if (
    img &&
    img.complete === true &&
    Number(img.naturalWidth || 0) >= 100 &&
    Number(img.naturalHeight || 0) >= 70
  ) {
    diqV81StartGalleryAfterHero(item, heroUrl);
    try {
      console.log("ðŸ–¼ï¸ Drive IQ V82 gallery trigger", reason || "complete", item.label || "");
    } catch (e2) {}
    return true;
  }




  if (!img) {
    /* Some stable hero implementations use a committed background image.
       data-photo-live + data-photo-url is enough proof to begin secondary fetch. */
    diqV81StartGalleryAfterHero(item, heroUrl);
    try {
      console.log("ðŸ–¼ï¸ Drive IQ V82 gallery trigger", reason || "background", item.label || "");
    } catch (e3) {}
    return true;
  }




  return false;
}




/* Wrap the already-safe V81 paint path. Do not repaint anything. */
diqV67PaintWorkerPhoto = function (item, imageUrl, stage) {
  var result = diqV82PriorPaintWorkerPhoto(item, imageUrl, stage);
  var hero = diqV67PhotoHero();
  var img = null;




  if (!DIQ_V81_GALLERY_ENABLED || !item || !hero || !imageUrl) {
    return result;
  }




  if (diqV82TryStartGallery(item, "paint-complete")) {
    return result;
  }




  try { img = hero.querySelector("img.diqV67WorkerPhoto"); } catch (e0) { img = null; }




  if (img && img.getAttribute("data-diq-v82-listener") !== "1") {
    img.setAttribute("data-diq-v82-listener", "1");
    img.addEventListener("load", function () {
      diqV82TryStartGallery(item, "paint-load");
    }, {once:true});
  }




  return result;
};




/* One bounded post-render rescue for cached images or delayed DOM attachment. */
openAdventureInfoCard = function (item, preserveBrowseCamera) {
  var result = diqV82PriorOpenAdventureInfoCard(item, preserveBrowseCamera);
  var generation = diqV81GalleryGeneration;




  window.setTimeout(function () {
    if (
      generation === diqV81GalleryGeneration &&
      diqV81ActiveItem === item
    ) {
      diqV82TryStartGallery(item, "open+120ms");
    }
  }, 120);




  window.setTimeout(function () {
    if (
      generation === diqV81GalleryGeneration &&
      diqV81ActiveItem === item
    ) {
      diqV82TryStartGallery(item, "open+650ms");
    }
  }, 650);




  return result;
};




try {
  console.log("âœ… Drive IQ V82 Gallery Trigger Rescue loaded");
} catch (e0) {}




/* =========================================================
   DRIVE IQ V84 â€” IN-SCOPE ROUTE READY TRUTH + POST-SCAN CTA




   Critical Adventure IQ route-handoff repair.




   Rules:
   - A physical result with a stable provider identity and valid venue
     coordinates is route-ready without requiring a second geocode to
     rediscover the same business.
   - Existing exact coordinates are preserved. Scan center, city center,
     and destination center are never promoted as venue coordinates.
   - High-confidence card language is downgraded when a result is not
     route-ready.
   - The Place IQ primary action remains ROUTE HERE for route-ready places.
   - Post-scan controls cannot remain in the stale SCAN DESTINATION state.
========================================================= */




window.__DRIVE_IQ_ADVENTURE_MODE_JS_V84_ROUTE_READY_TRUTH__ = true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD = "V84_ROUTE_READY_TRUTH";




var diqV83PriorVerifyItem = diqV70VerifyItem;
var diqV83PriorRouteSelectedAdventureItem = routeSelectedAdventureItem;
var diqV83PriorOpenAdventureInfoCard = openAdventureInfoCard;
var diqV83PriorRenderAdventureScanChoices = renderAdventureScanChoices;




function diqV83ValidCoordinatePair(item) {
  return !!(
    item &&
    finite(Number(item.lat)) &&
    finite(Number(item.lng)) &&
    Math.abs(Number(item.lat)) <= 90 &&
    Math.abs(Number(item.lng)) <= 180 &&
    !(Number(item.lat) === 0 && Number(item.lng) === 0)
  );
}




function diqV83ProviderIdentity(item) {
  return clean(
    item && (
      item.googlePlaceId ||
      item.placeId ||
      item.providerPlaceId ||
      item.geoapifyPlaceId ||
      item.mapboxId ||
      item.featureId ||
      item.id
    )
  );
}




function diqV83Address(item) {
  return clean(
    item && (
      item.canonicalAddress ||
      item.formattedAddress ||
      item.address ||
      item.full
    )
  );
}




function diqV83SamePoint(lat1, lng1, lat2, lng2, tolerance) {
  var delta;




  if (
    !finite(Number(lat1)) ||
    !finite(Number(lng1)) ||
    !finite(Number(lat2)) ||
    !finite(Number(lng2))
  ) {
    return false;
  }




  delta = miles(
    Number(lat1),
    Number(lng1),
    Number(lat2),
    Number(lng2)
  );




  return finite(Number(delta)) &&
    Number(delta) <= Number(tolerance || 0.025);
}




function diqV83LooksLikeFallbackCenter(item) {
  var lat;
  var lng;




  if (!diqV83ValidCoordinatePair(item)) {
    return true;
  }




  lat = Number(item.lat);
  lng = Number(item.lng);




  if (
    adventureSearchCenter &&
    diqV83SamePoint(
      lat,
      lng,
      adventureSearchCenter.lat,
      adventureSearchCenter.lng,
      0.018
    ) &&
    !diqV83ProviderIdentity(item)
  ) {
    return true;
  }




  if (
    destination &&
    diqV83SamePoint(
      lat,
      lng,
      destination.lat,
      destination.lng,
      0.018
    ) &&
    !diqV83ProviderIdentity(item)
  ) {
    return true;
  }




  return false;
}




function diqV83HasRouteIdentity(item) {
  var id = diqV83ProviderIdentity(item);
  var address = diqV83Address(item);
  var name = clean(item && item.label);




  if (!name || !diqV83ValidCoordinatePair(item)) {
    return false;
  }




  if (diqV83LooksLikeFallbackCenter(item)) {
    return false;
  }




  if (id) {
    return true;
  }




  if (address && address.length >= 8) {
    return true;
  }




  if (
    item &&
    (
      item.canonical === true ||
      item.resultType === "adventure_index" ||
      item.locationSource === "google_places_new" ||
      item.locationSource === "geoapify" ||
      item.locationSource === "mapbox"
    )
  ) {
    return true;
  }




  return false;
}




function diqV83CommitExistingRouteTruth(item, source) {
  if (!item || !diqV83HasRouteIdentity(item)) {
    return false;
  }




  item.canonicalLat = Number(item.lat);
  item.canonicalLng = Number(item.lng);
  item.locationVerified = true;
  item.locationConfidence = "route_ready";
  item.locationSource = clean(
    source ||
    item.locationSource ||
    "provider_geometry"
  );
  item.locationVerificationOrder =
    "existing_identity_first";
  item.routeReady = true;




  if (
    !item.canonicalAddress &&
    diqV83Address(item)
  ) {
    item.canonicalAddress =
      diqV83Address(item);
  }




  return true;
}




function diqV83IsRouteReady(item) {
  if (!item) {
    return false;
  }




  if (
    item.locationVerified === true &&
    diqV83ValidCoordinatePair(item) &&
    !diqV83LooksLikeFallbackCenter(item)
  ) {
    item.routeReady = true;
    return true;
  }




  return diqV83CommitExistingRouteTruth(
    item,
    "provider_identity_geometry"
  );
}




diqV70VerifyItem = function(item, query, done) {
  if (diqV83IsRouteReady(item)) {
    done(item);
    return;
  }




  diqV83PriorVerifyItem(
    item,
    query,
    function(verified) {
      if (
        verified &&
        diqV83ValidCoordinatePair(verified)
      ) {
        verified.routeReady = true;
        done(verified);
        return;
      }




      if (
        diqV83CommitExistingRouteTruth(
          item,
          "provider_geometry_after_verify_miss"
        )
      ) {
        done(item);
        return;
      }




      if (item) {
        item.routeReady = false;
        item.locationVerified = false;
        item.locationConfidence = "unresolved";
      }




      done(null);
    }
  );
};




function diqV83ApplyCardTruth(item) {
  var routeButton = byId("diqAdvInfoRoute");
  var confidence = byId("diqAdvInfoConfidence");
  var score = byId("diqAdvInfoScore");
  var scoreLabel;
  var ready = diqV83IsRouteReady(item);




  if (routeButton) {
    routeButton.disabled = false;
    routeButton.textContent =
      ready ? "ROUTE HERE" : "VERIFY LOCATION";




    if (ready) {
      routeButton.removeAttribute(
        "data-location-warning"
      );
    } else {
      routeButton.setAttribute(
        "data-location-warning",
        "1"
      );
    }
  }




  if (!ready) {
    if (confidence) {
      confidence.textContent =
        "Location needs verification";
    }




    if (score) {
      score.textContent = "--";
    }




    try {
      scoreLabel = document.querySelector(
        "#diqAdventureInfoCard .diqPlaceScoreLabel"
      );




      if (scoreLabel) {
        scoreLabel.textContent = "Place IQ";
      }
    } catch (e0) {}
  }
}




openAdventureInfoCard = function(item, preserveBrowseCamera) {
  var result = diqV83PriorOpenAdventureInfoCard(
    item,
    preserveBrowseCamera
  );




  diqV83ApplyCardTruth(item);
  return result;
};




routeSelectedAdventureItem = function(item) {
  if (!item) {
    return;
  }




  if (diqV83IsRouteReady(item)) {
    diqV70ProtectCoordinates(item);
    diqV70RouteDebug(item);
    diqV83PriorRouteSelectedAdventureItem(item);
    return;
  }




  setStatus(
    "adventureRouteStatus",
    "VERIFYING LOCATION",
    "gold"
  );




  toast(
    "Confirming exact location for " +
    String(item.label || "place")
  );




  diqV70VerifyItem(
    item,
    activeLens,
    function(verified) {
      if (
        !verified ||
        !diqV83IsRouteReady(verified)
      ) {
        setStatus(
          "adventureRouteStatus",
          "LOCATION NOT VERIFIED",
          "red"
        );




        toast(
          "This place needs a verified address before routing"
        );




        diqV83ApplyCardTruth(item);
        return;
      }




      diqV70ProtectCoordinates(verified);
      diqV70RouteDebug(verified);
      diqV83PriorRouteSelectedAdventureItem(
        verified
      );
    }
  );
};




function diqV83SetPostScanActions() {
  var start = byId("startAdventure");
  var gps = byId("lockGps");
  var hasResults =
    adventureResults &&
    adventureResults.length > 0;




  if (!hasResults) {
    return;
  }




  if (start) {
    start.disabled = false;
    start.textContent = "SCAN AGAIN";
    start.setAttribute(
      "aria-label",
      "Scan this destination again"
    );
  }




  if (gps) {
    gps.disabled = false;
    gps.textContent = "EXPLORE MORE";
    gps.setAttribute(
      "aria-label",
      "Explore more places in this area"
    );
  }
}




renderAdventureScanChoices = function(items, query) {
  var result =
    diqV83PriorRenderAdventureScanChoices(
      items,
      query
    );




  window.setTimeout(
    diqV83SetPostScanActions,
    80
  );




  window.setTimeout(
    diqV83SetPostScanActions,
    500
  );




  return result;
};




try {
  console.log(
    "âœ… Drive IQ V84 In-Scope Route Ready Truth loaded"
  );
} catch (e0) {}












/* =========================================================
   DRIVE IQ V85 â€” FINAL ADVENTURE POLISH
   - dismissible no-results state
   - Popular scan stale-category reset
   - canonical thumbnail authority + repaint
   - truthful CTA copy
   - guaranteed one-time post-scan menu minimize
========================================================= */




window.__DRIVE_IQ_ADVENTURE_MODE_JS_V85_FINAL_POLISH__ = true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD = "V85_FINAL_ADVENTURE_POLISH";




var diqV85OriginalRenderAdventureScanChoices = renderAdventureScanChoices;
var diqV85OriginalSetLens = setLens;
var diqV85CollapseToken = 0;
var diqV85ThumbRetryState = {};




function diqV85InjectStyles() {
  var style;
  if (byId("diqV85FinalPolishStyle")) { return; }




  style = document.createElement("style");
  style.id = "diqV85FinalPolishStyle";
  style.type = "text/css";
  style.appendChild(document.createTextNode(
    "#diqAdventureDestResults .diqV85CloseResults{" +
      "position:absolute;right:10px;top:8px;width:34px;height:34px;" +
      "display:flex;align-items:center;justify-content:center;border-radius:999px;" +
      "border:1px solid rgba(255,255,255,.16);background:rgba(5,12,22,.90);" +
      "color:#fff;font-size:20px;line-height:1;z-index:5;" +
    "}" +
    "#diqAdventureDestResults .diqDestHead{position:relative;padding-right:44px;}" +
    "#diqAdventureDestResults .diqDestThumb.diqV85Fallback{" +
      "background-image:" +
      "radial-gradient(circle at 25% 20%,rgba(255,206,105,.24),transparent 35%)," +
      "radial-gradient(circle at 78% 78%,rgba(40,255,190,.20),transparent 42%)," +
      "linear-gradient(145deg,#15202b,#09111b)!important;" +
    "}" +
    "#diqAdventureDestResults .diqDestThumb.diqV85Loading:after{" +
      "content:'IQ';position:absolute;inset:0;display:flex;align-items:center;" +
      "justify-content:center;color:rgba(255,255,255,.62);font-size:10px;" +
      "font-weight:1000;letter-spacing:.12em;" +
    "}"
  ));




  try { document.head.appendChild(style); } catch (e0) {}
}




function diqV85DismissResultsPanel() {
  hideDestinationResults();
  closeAdventureInfoCard();
  destinationSearchResults = [];
  destinationResultOpen = false;
  try { exitScanResultsMode(); } catch (e0) {}
  try { syncAdventureDestinationScopeUI(); } catch (e1) {}
  try { updateClearAdventureSearchButton(); } catch (e2) {}
  toast("Choose another Adventure scan");
}




function diqV85InstallCloseButton(hasResults) {
  var panel = byId("diqAdventureDestResults");
  var head;
  var close;




  if (!panel || !panel.querySelector) { return; }
  head = panel.querySelector(".diqDestHead");
  if (!head) { return; }




  close = panel.querySelector(".diqV85CloseResults");
  if (!close) {
    close = document.createElement("button");
    close.type = "button";
    close.className = "diqV85CloseResults";
    close.setAttribute("aria-label", hasResults ? "Close results" : "Close no-results message");
    close.textContent = "Ã—";
    close.onclick = diqV85DismissResultsPanel;
    head.appendChild(close);
  } else {
    close.setAttribute("aria-label", hasResults ? "Close results" : "Close no-results message");
  }
}




function diqV85StablePhotoKey(item) {
  var provider = clean(
    item && (
      item.googlePlaceId ||
      item.placeId ||
      item.providerPlaceId ||
      item.geoapifyPlaceId ||
      item.mapboxId ||
      item.featureId ||
      item.id
    )
  );




  if (provider) { return "id|" + provider; }
  return diqPhotoCacheKey(item);
}




function diqV85PhotoCandidates(item, query) {
  var out = [];
  var gallery = [];
  var i;
  var p;




  if (!item) { return out; }




  try { gallery = diqBuildPlaceGallery(item, query || activeLens) || []; }
  catch (e0) { gallery = []; }




  if (item.photoUrl && diqLooksLikeImageUrl(item.photoUrl)) {
    out.push({ url:String(item.photoUrl), kind:item.photoSource || "photo" });
  }




  for (i = 0; i < gallery.length; i++) {
    p = gallery[i];
    if (!p || !p.url || p.kind === "map" || !diqLooksLikeImageUrl(p.url)) { continue; }
    if (!out.length || out[0].url !== p.url) {
      out.push({ url:String(p.url), kind:String(p.kind || "gallery") });
    }
  }




  return out.slice(0, 6);
}




function diqV85PaintThumb(node, item, photo, query) {
  var thumb;
  var cls;




  if (!node || !photo || !photo.url) { return; }
  thumb = node.querySelector ? node.querySelector(".diqDestThumb") : null;
  if (!thumb) { return; }




  cls = categoryPhotoClass(item, query || activeLens) || "local";
  thumb.className = "diqDestThumb " + cls + " realPhoto";
  thumb.setAttribute(
    "style",
    "background-image:url('" + diqCssPhotoUrl(photo.url) + "');"
  );
  thumb.setAttribute("data-photo-kind", String(photo.kind || "photo"));
  node.setAttribute("data-photo-loaded", "1");
  node.setAttribute("data-photo-url", String(photo.url));
}




function diqV85LoadThumbCandidate(node, item, candidates, index, query) {
  var img;
  var key = diqV85StablePhotoKey(item);
  var thumb;




  if (!node || !item) { return; }




  if (!candidates || index >= candidates.length) {
    thumb = node.querySelector ? node.querySelector(".diqDestThumb") : null;
    if (thumb) {
      thumb.className =
        "diqDestThumb " +
        (categoryPhotoClass(item, query || activeLens) || "local") +
        " diqV85Fallback";
      thumb.removeAttribute("style");
    }
    node.setAttribute("data-photo-loaded", "fallback");
    return;
  }




  img = new Image();
  img.onload = function () {
    item.photoUrl = candidates[index].url;
    item.photoSource = candidates[index].kind || item.photoSource || "Photo IQ";
    item.thumbnailUrl = candidates[index].url;
    item.thumbnailStatus = "loaded";
    item.thumbnailRetryCount = index;
    item.thumbnailLastRepaintAt = Date.now();
    diqV85PaintThumb(node, item, candidates[index], query);
  };




  img.onerror = function () {
    diqV85ThumbRetryState[key] = index + 1;
    item.thumbnailStatus = "retry";
    item.thumbnailRetryCount = index + 1;
    diqV85LoadThumbCandidate(node, item, candidates, index + 1, query);
  };




  try { img.referrerPolicy = "no-referrer-when-downgrade"; } catch (e0) {}
  img.src = candidates[index].url;
}




function diqV85BindAndHydrateThumbnails(items, query) {
  var nodes = [];
  var i;
  var item;
  var node;
  var key;
  var candidates;
  var thumb;




  try {
    nodes = document.querySelectorAll("#diqAdventureDestResults .diqDestItem[data-adv-idx]");
  } catch (e0) {
    nodes = [];
  }




  for (i = 0; i < nodes.length; i++) {
    node = nodes[i];
    item = items && items[i] ? items[i] : null;
    if (!item) { continue; }




    key = diqV85StablePhotoKey(item);
    node.setAttribute("data-photo-key", key);




    thumb = node.querySelector ? node.querySelector(".diqDestThumb") : null;
    if (thumb && node.getAttribute("data-photo-loaded") !== "1") {
      thumb.className += " diqV85Loading";
    }




    candidates = diqV85PhotoCandidates(item, query);
    diqV85LoadThumbCandidate(node, item, candidates, 0, query);




    (function (it, q, n) {
      window.setTimeout(function () {
        var refreshed = diqV85PhotoCandidates(it, q);
        if (n.getAttribute("data-photo-loaded") !== "1" && refreshed.length) {
          diqV85LoadThumbCandidate(n, it, refreshed, 0, q);
        }
      }, 1200 + (i * 180));




      window.setTimeout(function () {
        var refreshed = diqV85PhotoCandidates(it, q);
        if (refreshed.length) {
          diqV85LoadThumbCandidate(n, it, refreshed, 0, q);
        }
      }, 3200 + (i * 220));
    })(item, query, node);
  }
}




function diqV85PopularQuery() {
  return "local favorites restaurants coffee waterfront scenic family attractions hidden gems shopping districts";
}




function diqV85ResetPopularState() {
  activeScanQuery = "";
  adventureScanFallbackPass = 0;
  adventureScanRadiusOverride = 0;
  liveMusicFallbackVoiceSpokenAt = 0;
  adventureScanVoiceLastKey = "";
  adventureScanVoiceLastAt = 0;
  try { hideDestinationResults(); } catch (e0) {}
  try { closeAdventureInfoCard(); } catch (e1) {}
}




setLens = function(text) {
  var q = clean(text);
  var n = normText(q);




  if (
    n === "popular" ||
    n.indexOf("popular tonight local favorites") > -1 ||
    n.indexOf("trending") > -1
  ) {
    diqV85ResetPopularState();
    activeLens = "popular";
    lsSet(LS.ADVENTURE_LENS, activeLens);
    scanAdventureChoices(diqV85PopularQuery());
    return;
  }




  diqV85OriginalSetLens(text);
};




function diqV85SyncPrimaryCta() {
  var start = byId("startAdventure");
  var hasResults = adventureResults && adventureResults.length > 0;
  var hasRoute = routeGeo && routeGeo.geometry && routeGeo.geometry.coordinates;




  if (!start) { return; }




  if (hasResults) {
    start.textContent = "SCAN AGAIN";
    start.setAttribute("aria-label", "Run this Adventure scan again");
    return;
  }




  if (hasRoute && destination) {
    start.textContent = "START ADVENTURE";
    start.setAttribute("aria-label", "Start Adventure to this destination");
    return;
  }




  if (destination) {
    start.textContent = "EXPLORE DESTINATION";
    start.setAttribute("aria-label", "Explore around this destination");
  }
}




function diqV85ForcePostScanCollapse(items, query) {
  var token;




  if (!items || !items.length) { return; }
  diqV85CollapseToken += 1;
  token = diqV85CollapseToken;




  window.setTimeout(function () {
    if (token !== diqV85CollapseToken) { return; }
    if (adventurePanelIsBlockingAutoCollapse()) { return; }
    if (!adventureResults || !adventureResults.length) { return; }




    try {
      ensureScanResultsRestoreControl();
      document.body.classList.add("adventureScanResultsMode");
      document.body.classList.remove("adventureHorizonHidden");
    } catch (e0) {}




    try { syncAdventureMapDock(); } catch (e1) {}
  }, 620);
}




renderAdventureScanChoices = function(items, query) {
  var filtered = diqV22FilterExperienceResults(items || [], query);
  var result = diqV85OriginalRenderAdventureScanChoices(items, query);
  var hasResults = filtered && filtered.length > 0;




  diqV85InjectStyles();
  diqV85InstallCloseButton(hasResults);




  if (hasResults) {
    window.setTimeout(function () {
      diqV85BindAndHydrateThumbnails(destinationSearchResults, query);
    }, 60);




    window.setTimeout(function () {
      diqV85BindAndHydrateThumbnails(destinationSearchResults, query);
    }, 900);




    diqV85ForcePostScanCollapse(filtered, query);
  } else {
    try { document.body.classList.remove("adventureScanResultsMode"); } catch (e0) {}
  }




  window.setTimeout(diqV85SyncPrimaryCta, 90);
  window.setTimeout(diqV85SyncPrimaryCta, 650);




  return result;
};




/* Show Menu should also clear a blocking no-results panel. */
(function () {
  var oldEnsure = ensureScanResultsRestoreControl;
  ensureScanResultsRestoreControl = function () {
    var btn = oldEnsure();
    if (btn) {
      btn.onclick = function () {
        hideDestinationResults();
        closeAdventureInfoCard();
        exitScanResultsMode();
        syncAdventureDestinationScopeUI();
        updateClearAdventureSearchButton();
        toast("Adventure menu restored");
      };
    }
    return btn;
  };
})();




diqV85InjectStyles();




try {
  console.log("âœ… Drive IQ V85 Final Adventure Polish loaded");
} catch (e0) {}












/* =========================================================
   DRIVE IQ V86 â€” NATURAL VOICE + CANONICAL THUMBNAIL AUTHORITY
========================================================= */
window.__DRIVE_IQ_ADVENTURE_MODE_JS_V86_VOICE_THUMB_AUTHORITY__ = true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD = "V86_VOICE_THUMB_AUTHORITY";




var DIQ_V86_VOICE_KEY = "diq_adventure_voice_enabled_v1";
var diqV86AdventureVoiceEnabled = true;
var diqV86SpeechActiveKey = "";
var diqV86SpeechStartedAt = 0;
var diqV86PhotoCache = {};
var diqV86ThumbWatchdogs = {};




function diqV86ReadVoiceSetting() {
  var raw = lsGet(DIQ_V86_VOICE_KEY);
  if (raw === null || raw === "") {
    diqV86AdventureVoiceEnabled = true;
    lsSet(DIQ_V86_VOICE_KEY, "1");
    return true;
  }
  diqV86AdventureVoiceEnabled = raw !== "0" && raw !== "false" && raw !== "off";
  return diqV86AdventureVoiceEnabled;
}




function diqV86CleanSpokenText(value) {
  var s = clean(value);
  if (!s) { return ""; }
  s = s
    .replace(/\bDIQ\b/gi, "Drive IQ")
    .replace(/\bIQ\b/g, "I Q")
    .replace(/[_|]+/g, " ")
    .replace(/\bscan(?:ning)?\s+dest(?:ination)?\s*10\b/gi, "Scanning around Destin")
    .replace(/\bdesk\s*ten\b/gi, "Destin")
    .replace(/\bdes\s*-\s*tin\b/gi, "Destin")
    .replace(/\s+/g, " ")
    .trim();
  s = s.replace(/\bdestin\b/gi, "Destin");
  return s;
}




function diqV86ChooseNaturalVoice() {
  var voices = [];
  var preferred = ["Samantha", "Ava", "Allison", "Susan", "Karen", "Moira", "Microsoft Jenny", "Google US English"];
  var i;
  var j;
  try { voices = window.speechSynthesis ? window.speechSynthesis.getVoices() : []; }
  catch (e0) { voices = []; }
  for (i = 0; i < preferred.length; i++) {
    for (j = 0; j < voices.length; j++) {
      if (String(voices[j].name || "").toLowerCase().indexOf(preferred[i].toLowerCase()) > -1) { return voices[j]; }
    }
  }
  for (j = 0; j < voices.length; j++) {
    if (String(voices[j].lang || "").toLowerCase().indexOf("en-us") === 0) { return voices[j]; }
  }
  return null;
}




function diqV86Speak(text, key, priority) {
  var msg = diqV86CleanSpokenText(text);
  var now = Date.now();
  var safeKey = normText(key || msg).slice(0, 140);
  var utter;
  var voice;
  if (!diqV86ReadVoiceSetting() || !msg) { return false; }
  if (!window.speechSynthesis || !window.SpeechSynthesisUtterance) { return false; }
  if (safeKey && safeKey === diqV86SpeechActiveKey && now - diqV86SpeechStartedAt < 14000) { return false; }
  if (window.speechSynthesis.speaking && Number(priority || 1) < 2 && now - diqV86SpeechStartedAt < 6500) { return false; }
  try {
    if (Number(priority || 1) >= 2) { window.speechSynthesis.cancel(); }
    utter = new SpeechSynthesisUtterance(msg);
    voice = diqV86ChooseNaturalVoice();
    if (voice) { utter.voice = voice; }
    utter.lang = "en-US";
    utter.rate = 0.92;
    utter.pitch = 1.0;
    utter.volume = 1.0;
    diqV86SpeechActiveKey = safeKey;
    diqV86SpeechStartedAt = now;
    utter.onend = function () { if (diqV86SpeechActiveKey === safeKey) { diqV86SpeechActiveKey = ""; } };
    utter.onerror = utter.onend;
    window.speechSynthesis.speak(utter);
    return true;
  } catch (e0) { return false; }
}




speakAdventure = function (text) { return diqV86Speak(text, "adventure|" + normText(text), 2); };




speakAdventureScanVoice = function (line, key, cooldownMs) {
  var now = Date.now();
  var safeKey = normText(key || line).slice(0, 140);
  if (!diqV86ReadVoiceSetting() || !line || adventureDropModalOpen) { return false; }
  try {
    if (byId("diqAdventureInfoCard") && String(byId("diqAdventureInfoCard").className || "").indexOf("on") > -1) { return false; }
  } catch (e0) {}
  if (safeKey && safeKey === adventureScanVoiceLastKey && now - Number(adventureScanVoiceLastAt || 0) < Number(cooldownMs || 14000)) { return false; }
  adventureScanVoiceLastKey = safeKey;
  adventureScanVoiceLastAt = now;
  return diqV86Speak(line, safeKey, 1);
};




speakAdventureScanStart = function (query) {
  var label = adventureScanCategoryLabel(query);
  var scope = adventureScanScopeVoiceLabel(query);
  var line;
  adventureScanVoiceToken += 1;
  if (adventureSearchScope === "map_area") { line = "Scanning this map for " + label + "."; }
  else if (adventureSearchScope === "near_destination") { line = "Scanning around " + clean(adventureSearchCenter && adventureSearchCenter.label || "your destination") + "."; }
  else { line = "Scanning nearby for " + label + "."; }
  speakAdventureScanVoice(line, "scan_start|" + adventureScanVoiceToken + "|" + label + "|" + scope, 1000);
};




speakAdventureScanComplete = function (count, topPick, query) {
  var n = Math.min(8, Math.max(0, Number(count || 0)));
  var name = clean(topPick && topPick.label ? topPick.label : "");
  var line;
  if (n <= 0) { speakAdventureScanEmpty(query); return; }
  if (n === 1 && name) { line = "I found one place worth exploring. " + name + " is the strongest pick."; }
  else if (name) { line = "I found " + String(n) + " places worth exploring. " + name + " is the strongest pick."; }
  else { line = "I found " + String(n) + " places worth exploring."; }
  speakAdventureScanVoice(line, "scan_complete|" + adventureScanVoiceToken + "|" + String(n) + "|" + normText(name), 1000);
};




speakAdventureScanEmpty = function (query) {
  speakAdventureScanVoice("No strong matches yet. Try another category, or scan this map.", "scan_empty|" + adventureScanVoiceToken + "|" + adventureScanCategoryLabel(query), 1000);
};




function diqV86SyncVoiceButton() {
  /* V96: voice stays enabled, but the floating UI button is removed. */
  var btn = byId("diqAdventureVoiceToggle");
  if (btn && btn.parentNode) {
    try { btn.parentNode.removeChild(btn); } catch (e0) {}
  }
}








function diqV86EnsureVoiceToggle() {
  /* V96: headless voice. Do not create a permanent floating VOICE ON button. */
  diqV86SyncVoiceButton();
  return null;
}








function diqV86InjectVoiceStyles() {
  var style;
  if (byId("diqV86VoiceThumbStyles")) { return; }
  style = document.createElement("style");
  style.id = "diqV86VoiceThumbStyles";
  style.type = "text/css";
  style.appendChild(document.createTextNode(
    ".diqDestThumb.diqV86Loading{position:relative;overflow:hidden}.diqDestThumb.diqV86Loading:after{content:'';position:absolute;inset:0;background:linear-gradient(110deg,transparent 20%,rgba(255,255,255,.08) 46%,transparent 72%);animation:diqV86Shimmer 1.3s linear infinite}" +
    ".diqDestThumb.diqV86Resolved:after,.diqDestThumb.diqV86Fallback:after{display:none!important}@keyframes diqV86Shimmer{0%{transform:translateX(-100%)}100%{transform:translateX(100%)}}"
  ));
  try { document.head.appendChild(style); } catch (e0) {}
}








function diqV86StablePhotoKey(item) {
  var provider = clean(item && (item.providerPlaceId || item.googlePlaceId || item.placeId || item.geoapifyPlaceId || item.mapboxId || item.featureId || item.id || ""));
  if (provider) { return "id|" + provider; }
  return "geo|" + normText(item && item.label || "place") + "|" + String(Number(item && item.lat || 0).toFixed(5)) + "|" + String(Number(item && item.lng || 0).toFixed(5));
}




function diqV86LoadPersistedPhotoCache() {
  var parsed = safeParse(lsGet(LS.PHOTO_CACHE));
  if (parsed && typeof parsed === "object") { diqV86PhotoCache = parsed; }
}




function diqV86PersistPhoto(item, url, kind) {
  var key = diqV86StablePhotoKey(item);
  if (!key || !url) { return; }
  diqV86PhotoCache[key] = { url:String(url), kind:String(kind || item && item.photoSource || "hero"), verified:true, ts:Date.now() };
  try { lsJSON(LS.PHOTO_CACHE, diqV86PhotoCache); } catch (e0) {}
}




function diqV86CanonicalPhoto(item) {
  var key = diqV86StablePhotoKey(item);
  var cached = key ? diqV86PhotoCache[key] : null;
  var url = clean(item && (item.photoUrl || item.workerPhotoUrl || item.photoProxyUrl || item.driveIQPhotoUrl || item.thumbnailUrl || ""));
  if (url && diqLooksLikeImageUrl(url)) { return { url:url, kind:item.photoSource || "hero" }; }
  if (cached && cached.verified === true && cached.url && diqLooksLikeImageUrl(cached.url)) { return { url:String(cached.url), kind:String(cached.kind || "hero") }; }
  return null;
}




function diqV86PaintThumbNode(node, item, photo, query) {
  var thumb;
  var cls;
  if (!node || !item || !photo || !photo.url) { return false; }
  thumb = node.querySelector ? node.querySelector(".diqDestThumb") : null;
  if (!thumb) { return false; }
  cls = categoryPhotoClass(item, query || activeLens) || "local";
  thumb.className = "diqDestThumb " + cls + " realPhoto diqV86Resolved";
  thumb.setAttribute("style", "background-image:url('" + diqCssPhotoUrl(photo.url) + "');background-size:cover;background-position:center;");
  thumb.setAttribute("data-photo-kind", String(photo.kind || "hero"));
  node.setAttribute("data-photo-loaded", "1");
  node.setAttribute("data-photo-url", String(photo.url));
  node.setAttribute("data-photo-key", diqV86StablePhotoKey(item));
  return true;
}




function diqV86FindCanonicalItem(key) {
  var pools = [destinationSearchResults, adventureResults, exploreResults];
  var p;
  var i;
  var item;
  for (p = 0; p < pools.length; p++) {
    for (i = 0; i < (pools[p] || []).length; i++) {
      item = pools[p][i];
      if (item && diqV86StablePhotoKey(item) === key) { return item; }
    }
  }
  return null;
}




function repaintAllPhotoSurfacesForItem(item, query) {
  var key = diqV86StablePhotoKey(item);
  var photo = diqV86CanonicalPhoto(item);
  var nodes = [];
  var i;
  var canonical;
  if (!key || !photo || !photo.url) { return false; }
  canonical = diqV86FindCanonicalItem(key) || item;
  canonical.photoUrl = photo.url;
  canonical.thumbnailUrl = photo.url;
  canonical.photoLoaded = true;
  canonical.thumbnailStatus = "loaded";
  diqV86PersistPhoto(canonical, photo.url, photo.kind);
  try { nodes = document.querySelectorAll(".diqDestItem[data-photo-key]"); } catch (e0) { nodes = []; }
  for (i = 0; i < nodes.length; i++) {
    if (String(nodes[i].getAttribute("data-photo-key") || "") === String(key)) { diqV86PaintThumbNode(nodes[i], canonical, photo, query || activeLens); }
  }
  return true;
}




function diqV86ThumbCandidates(item, query) {
  var out = [];
  var canonical = diqV86CanonicalPhoto(item);
  var gallery = [];
  var i;
  var seen = {};
  function add(url, kind) {
    var u = clean(url);
    if (!u || seen[u] || !diqLooksLikeImageUrl(u)) { return; }
    seen[u] = true;
    out.push({ url:u, kind:String(kind || "photo") });
  }
  if (canonical) { add(canonical.url, canonical.kind); }
  add(item && item.thumbnailUrl, "thumbnail");
  try { gallery = diqBuildPlaceGallery(item, query || activeLens) || []; } catch (e0) { gallery = []; }
  for (i = 0; i < gallery.length; i++) {
    if (gallery[i] && gallery[i].kind !== "map") { add(gallery[i].url, gallery[i].kind || "gallery"); }
  }
  return out.slice(0, 8);
}




function diqV86VerifyAndPaintThumb(node, item, candidates, index, query) {
  var img;
  var thumb;
  if (!node || !item) { return; }
  if (!candidates || index >= candidates.length) {
    thumb = node.querySelector ? node.querySelector(".diqDestThumb") : null;
    if (thumb) {
      thumb.className = "diqDestThumb " + (categoryPhotoClass(item, query || activeLens) || "local") + " diqV86Fallback";
      thumb.removeAttribute("style");
    }
    node.setAttribute("data-photo-loaded", "fallback");
    return;
  }
  img = new Image();
  img.onload = function () {
    item.photoUrl = candidates[index].url;
    item.thumbnailUrl = candidates[index].url;
    item.photoSource = candidates[index].kind || item.photoSource || "hero";
    item.photoLoaded = true;
    diqV86PersistPhoto(item, candidates[index].url, candidates[index].kind);
    repaintAllPhotoSurfacesForItem(item, query || activeLens);
  };
  img.onerror = function () { diqV86VerifyAndPaintThumb(node, item, candidates, index + 1, query); };
  try { img.referrerPolicy = "no-referrer"; } catch (e0) {}
  img.src = candidates[index].url;
}




function diqV86BindThumbnailNodes(items, query) {
  var nodes = [];
  var i;
  var node;
  var idx;
  var item;
  var key;
  var thumb;
  var candidates;
  try { nodes = document.querySelectorAll("#diqAdventureDestResults .diqDestItem[data-adv-idx]"); } catch (e0) { nodes = []; }
  for (i = 0; i < nodes.length; i++) {
    node = nodes[i];
    idx = Number(node.getAttribute("data-adv-idx"));
    item = items && items[idx] ? items[idx] : null;
    if (!item) { continue; }
    key = diqV86StablePhotoKey(item);
    node.setAttribute("data-photo-key", key);
    thumb = node.querySelector ? node.querySelector(".diqDestThumb") : null;
    if (thumb && node.getAttribute("data-photo-loaded") !== "1") { thumb.className = String(thumb.className || "") + " diqV86Loading"; }
    candidates = diqV86ThumbCandidates(item, query || activeLens);
    diqV86VerifyAndPaintThumb(node, item, candidates, 0, query || activeLens);
    (function (candidate, candidateKey, candidateQuery, candidateNode) {
      if (diqV86ThumbWatchdogs[candidateKey]) { window.clearTimeout(diqV86ThumbWatchdogs[candidateKey]); }
      diqV86ThumbWatchdogs[candidateKey] = window.setTimeout(function () {
        var proven = diqV86CanonicalPhoto(candidate);
        var currentThumb = candidateNode.querySelector ? candidateNode.querySelector(".diqDestThumb") : null;
        if (candidateNode.getAttribute("data-photo-loaded") === "1") { return; }
        if (proven && proven.url) { diqV86VerifyAndPaintThumb(candidateNode, candidate, [proven], 0, candidateQuery); }
        else if (currentThumb) {
          currentThumb.className = "diqDestThumb " + (categoryPhotoClass(candidate, candidateQuery || activeLens) || "local") + " diqV86Fallback";
          currentThumb.removeAttribute("style");
          candidateNode.setAttribute("data-photo-loaded", "fallback");
        }
      }, 4600);
    })(item, key, query || activeLens, node);
  }
}




var diqV86PriorV75CommitPhoto = diqV75CommitPhoto;
diqV75CommitPhoto = function (item, url) {
  var result = diqV86PriorV75CommitPhoto(item, url);
  if (item && url) {
    item.thumbnailUrl = String(url);
    diqV86PersistPhoto(item, url, item.photoSource || "hero");
    repaintAllPhotoSurfacesForItem(item, activeScanQuery || activeLens);
  }
  return result;
};




diqV85BindAndHydrateThumbnails = function (items, query) { diqV86BindThumbnailNodes(items || destinationSearchResults || [], query || activeLens); };




var diqV86PriorRenderAdventureScanChoices = renderAdventureScanChoices;
renderAdventureScanChoices = function (items, query) {
  var result = diqV86PriorRenderAdventureScanChoices(items, query);
  window.setTimeout(function () { diqV86BindThumbnailNodes(destinationSearchResults || items || [], query || activeLens); }, 90);
  window.setTimeout(function () { diqV86BindThumbnailNodes(destinationSearchResults || items || [], query || activeLens); }, 1100);
  return result;
};




var diqV86PriorApplyPlaceGallery = diqApplyPlaceGallery;
diqApplyPlaceGallery = function (item, query) {
  var result = diqV86PriorApplyPlaceGallery(item, query || activeLens);
  window.setTimeout(function () { repaintAllPhotoSurfacesForItem(item, query || activeLens); }, 180);
  window.setTimeout(function () { repaintAllPhotoSurfacesForItem(item, query || activeLens); }, 850);
  return result;
};




function diqV86Boot() {
  diqV86ReadVoiceSetting();
  infoVoiceEnabled = diqV86AdventureVoiceEnabled;
  diqV86LoadPersistedPhotoCache();
  diqV86InjectVoiceStyles();
  diqV86EnsureVoiceToggle();
  window.setTimeout(function () {
    diqV86EnsureVoiceToggle();
    diqV86BindThumbnailNodes(destinationSearchResults || [], activeScanQuery || activeLens);
  }, 650);
}




diqV86Boot();
try { console.log("âœ… Drive IQ V86 Natural Voice + Canonical Thumbnail Authority loaded"); } catch (e0) {}








/* =========================================================
   DRIVE IQ V87 â€” REPEAT DESTINATION SEARCH + VOICE VISIBILITY




   - Every intentionally changed destination query gets a fresh chooser.
   - Old destination lock/center cannot suppress the second search.
   - Clearing and typing a new place always refreshes destination results.
   - Adventure Voice toggle hides while destination choice cards are open.
========================================================= */




window.__DRIVE_IQ_ADVENTURE_MODE_JS_V87_REPEAT_DESTINATION_SEARCH__ = true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD = "V87_REPEAT_DESTINATION_SEARCH";




var diqV87DestinationTimer = null;
var diqV87LastTypedDestinationQuery = "";




function diqV87SetVoiceToggleVisible(visible) {
  /* V96: no floating voice toggle exists. Voice remains headless/enabled. */
  diqV86SyncVoiceButton();
}








function diqV87DestinationCardsAreOpen() {
  var panel = byId("diqAdventureDestResults");




  if (destinationResultOpen) { return true; }




  if (!panel) { return false; }




  return String(panel.className || "")
    .split(/\s+/)
    .indexOf("on") > -1;
}




function diqV87SyncVoiceVisibility() {
  diqV87SetVoiceToggleVisible(
    !diqV87DestinationCardsAreOpen()
  );
}




function diqV87InputMatchesCurrentDestination(query) {
  var q = normText(query);
  var label = normText(
    destination && destination.label || ""
  );
  var full = normText(
    destination && destination.full || ""
  );
  var center = normText(
    adventureSearchCenter &&
    adventureSearchCenter.label || ""
  );




  if (!q) { return false; }




  if (label && (
    q === label ||
    label.indexOf(q) === 0 ||
    q.indexOf(label) === 0
  )) {
    return true;
  }




  if (full && (
    q === full ||
    full.indexOf(q) === 0
  )) {
    return true;
  }




  if (center && (
    q === center ||
    center.indexOf(q) === 0
  )) {
    return true;
  }




  return false;
}




function diqV87ResetStaleDestinationContext(query) {
  var q = clean(query);




  if (!q || q.length < 2) { return false; }




  if (
    !destination &&
    !destinationLock &&
    !adventureSearchCenter &&
    adventureSearchScope === "near_me"
  ) {
    return false;
  }




  if (
    destinationLockMatchesInput(q) ||
    diqV87InputMatchesCurrentDestination(q)
  ) {
    return false;
  }




  destinationSearchToken += 1;
  routeAttemptToken += 1;




  destination = null;
  routeGeo = null;
  destinationSearchResults = [];
  clearDestinationLock();




  destinationPreviewScan = false;
  adventureScanOnly = false;
  mapAreaScanActive = false;
  adventureDestinationCameraHold = false;
  adventureDestinationCameraHoldAt = 0;




  adventureSearchCenter = null;
  adventureSearchScope = "near_me";




  try {
    lsRemove(LS.DEST);
    lsRemove(LS.ROUTE_GEO);
    lsRemove(LS.ROUTE_INTEL);
    lsRemove(LS.DRIVE_PAYLOAD);
  } catch (e0) {}




  try {
    clearDestinationPin();
  } catch (e1) {}




  try {
    if (
      map &&
      mapLoaded &&
      map.getSource("adventure-results")
    ) {
      map.getSource("adventure-results")
        .setData(emptyFC());
    }
  } catch (e2) {}




  try {
    document.body.classList.remove("adventureRouteReady");
  } catch (e3) {}




  try {
    var centerValue = byId("adventureCenterValue");
    if (centerValue) {
      centerValue.textContent =
        "ðŸ“ Choose a destination";
    }
  } catch (e4) {}




  setStartReady(false);
  updateClearAdventureSearchButton();




  return true;
}




function diqV87LaunchFreshDestinationSearch(query) {
  var q = clean(query);




  if (!q || q.length < 3) {
    hideDestinationResults();
    return;
  }




  if (isExplicitExperienceQuery(q)) {
    hideDestinationResults();
    return;
  }




  diqV87LastTypedDestinationQuery = q;
  searchDestinations(q);
}




function diqV87InstallRepeatDestinationSearch() {
  var input = byId("adventureSearch");




  if (!input || input.getAttribute("data-v87-repeat-search") === "1") {
    return;
  }




  input.setAttribute("data-v87-repeat-search", "1");




  input.addEventListener("input", function () {
    var q = clean(input.value);




    if (diqV87DestinationTimer) {
      window.clearTimeout(diqV87DestinationTimer);
      diqV87DestinationTimer = null;
    }




    if (!q) {
      diqV87LastTypedDestinationQuery = "";
      destinationSearchResults = [];
      hideDestinationResults();
      diqV87SyncVoiceVisibility();
      return;
    }




    /*
      This runs after the older input handler. It is the final authority:
      changing away from Pickwick/Freddy T's releases that stale center,
      then every normal place query launches a brand-new chooser.
    */
    diqV87ResetStaleDestinationContext(q);




    if (q.length < 3 || isExplicitExperienceQuery(q)) {
      hideDestinationResults();
      return;
    }




    diqV87DestinationTimer = window.setTimeout(
      function () {
        diqV87LaunchFreshDestinationSearch(q);
      },
      360
    );
  }, false);




  input.addEventListener("focus", function () {
    var q = clean(input.value);




    if (
      q.length >= 3 &&
      !isExplicitExperienceQuery(q) &&
      !diqV87DestinationCardsAreOpen()
    ) {
      diqV87ResetStaleDestinationContext(q);




      diqV87DestinationTimer = window.setTimeout(
        function () {
          diqV87LaunchFreshDestinationSearch(q);
        },
        120
      );
    }
  }, false);
}




/* Destination cards control Voice button visibility. */
var diqV87PriorRenderDestinationResults =
  renderDestinationResults;




renderDestinationResults = function (results, query) {
  var result = diqV87PriorRenderDestinationResults(
    results,
    query
  );




  window.setTimeout(function () {
    diqV87SyncVoiceVisibility();
  }, 0);




  return result;
};




var diqV87PriorHideDestinationResults =
  hideDestinationResults;




hideDestinationResults = function () {
  var result = diqV87PriorHideDestinationResults();




  window.setTimeout(function () {
    diqV87SyncVoiceVisibility();
  }, 0);




  return result;
};




/* Clearing must always remove the old chooser suppression state. */
var diqV87PriorClearDestinationSearch =
  clearDestinationSearch;




clearDestinationSearch = function () {
  var result = diqV87PriorClearDestinationSearch();




  diqV87LastTypedDestinationQuery = "";
  destinationSearchResults = [];
  clearDestinationLock();
  adventureSearchCenter = null;
  adventureSearchScope = "near_me";




  if (diqV87DestinationTimer) {
    window.clearTimeout(diqV87DestinationTimer);
    diqV87DestinationTimer = null;
  }




  hideDestinationResults();
  diqV87SyncVoiceVisibility();




  return result;
};




function diqV87Boot() {
  diqV87InstallRepeatDestinationSearch();
  diqV87SyncVoiceVisibility();




  window.setTimeout(function () {
    diqV87InstallRepeatDestinationSearch();
    diqV87SyncVoiceVisibility();
  }, 500);




  window.setTimeout(function () {
    diqV87InstallRepeatDestinationSearch();
    diqV87SyncVoiceVisibility();
  }, 1600);
}




diqV87Boot();




try {
  console.log(
    "âœ… Drive IQ V87 Repeat Destination Search + Voice Visibility loaded"
  );
} catch (e0) {}








/* =========================================================
   DRIVE IQ V88 â€” CATEGORY PRIORITY + ZERO-EMPTY DISCOVERY




   Permanent order:
   Category Truth â†’ Market Density â†’ Adaptive Radius â†’
   Gateway Towns â†’ Availability â†’ Local Value â†’
   Worth the Drive â†’ Variety â†’ Confidence




   Dense markets stay local.
   Small-town / rural destinations search the real region.
   Evergreen categories keep expanding before returning empty.
   Time-sensitive categories remain truthful.
========================================================= */




window.__DRIVE_IQ_ADVENTURE_MODE_JS_V88_CATEGORY_PRIORITY__ = true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD = "V88_CATEGORY_PRIORITY_ZERO_EMPTY";




var DIQ_V88_CATEGORY_PROFILES = {
  "golf": {
    synonyms:[
      "golf course","public golf course","golf club","country club",
      "municipal golf course","resort golf","driving range","golf academy"
    ],
    allow:[
      "golf course","golf club","country club","public golf",
      "municipal golf","resort golf","driving range","golf academy"
    ],
    block:[
      "mini golf","putt putt","golf cart dealer","golf cart rental",
      "sporting goods","clothing","real estate"
    ],
    baseRadius:{ urban:12, suburban:20, small_town:35, rural:60 },
    evergreen:true
  },
  "food iq": {
    synonyms:[
      "local restaurant","local favorite restaurant","best restaurant",
      "bbq restaurant","burger restaurant","tacos","pizza","seafood restaurant",
      "breakfast restaurant","brunch restaurant","dessert","ice cream",
      "bakery","diner","steakhouse","family restaurant"
    ],
    allow:[
      "restaurant","grill","bbq","barbecue","burger","pizza","seafood",
      "steak","cafe","bakery","diner","kitchen","taco","brunch",
      "breakfast","dessert","ice cream","food"
    ],
    block:[
      "grocery","supermarket","convenience store","gas station",
      "food distributor","catering supply","school cafeteria"
    ],
    baseRadius:{ urban:8, suburban:14, small_town:25, rural:45 },
    evergreen:true
  },
  "food drinks": {
    synonyms:[
      "restaurant","local restaurant","bar and grill","brewery",
      "taproom","pub","sports bar","cocktail bar","food hall"
    ],
    allow:[
      "restaurant","bar","pub","brewery","taproom","grill","cafe",
      "kitchen","food","diner","bistro"
    ],
    block:[
      "liquor store","package store","grocery","convenience store",
      "wholesale","distributor"
    ],
    baseRadius:{ urban:8, suburban:15, small_town:28, rural:48 },
    evergreen:true
  },
  "coffee iq": {
    synonyms:[
      "coffee shop","local coffee shop","cafe","coffee roaster",
      "espresso bar","bakery coffee","breakfast cafe","tea and coffee"
    ],
    allow:[
      "coffee","coffee shop","cafe","cafÃ©","espresso","latte",
      "roaster","bakery","tea house"
    ],
    block:[
      "smoothie","nutrition","protein shake","gas station",
      "convenience","fast food","vending","coffee distributor"
    ],
    baseRadius:{ urban:6, suburban:12, small_town:22, rural:38 },
    evergreen:true
  },
  "shopping": {
    synonyms:[
      "local shops","boutique","shopping district","antique store",
      "vintage shop","farmers market","public market","gift shop",
      "independent bookstore","outlet mall","artisan market"
    ],
    allow:[
      "boutique","shop","shopping","market","antique","vintage",
      "outlet","bookstore","gift","artisan","mall","retail district"
    ],
    block:[
      "warehouse","industrial supply","auto parts","car dealer",
      "storage","wholesale distributor"
    ],
    baseRadius:{ urban:10, suburban:18, small_town:30, rural:55 },
    evergreen:true
  },
  "local favorites": {
    synonyms:[
      "local favorite restaurant","where locals go","local hangout",
      "neighborhood favorite","town square","downtown","community park",
      "local coffee shop","local brewery","family entertainment",
      "popular local restaurant"
    ],
    allow:[
      "restaurant","bar","grill","bbq","coffee","cafe","bakery",
      "brewery","taproom","park","recreation","fitness","gym",
      "bowling","arcade","boutique","shop","market","square",
      "amphitheater","arena","local","popular"
    ],
    block:[
      "gas station","convenience","pharmacy","car dealer","auto parts",
      "storage","warehouse","bank","insurance","real estate",
      "apartment","medical","clinic","dentist","funeral","church"
    ],
    baseRadius:{ urban:8, suburban:14, small_town:28, rural:50 },
    evergreen:true
  },
  "waterfront": {
    synonyms:[
      "waterfront restaurant","lakefront restaurant","riverfront restaurant",
      "marina restaurant","harbor restaurant","dockside restaurant",
      "waterfront park","riverwalk","boardwalk","beach access",
      "lake access","boat launch"
    ],
    allow:[
      "waterfront","lakefront","riverfront","marina","riverwalk","beach",
      "pier","harbor","harbour","bay","dockside","creekside","riverside",
      "shore","boardwalk","waterfall","boat ramp","boat launch",
      "restaurant","bar","grill","cafe","park"
    ],
    block:[
      "apartment","condominium","real estate","property management",
      "storage","office","bank","insurance","medical","clinic",
      "beauty","salon","department store","grocery","pharmacy"
    ],
    baseRadius:{ urban:15, suburban:25, small_town:40, rural:70 },
    evergreen:true
  },
  "patio vibes": {
    synonyms:[
      "restaurant patio","outdoor seating restaurant","outdoor dining",
      "beer garden","rooftop restaurant","courtyard restaurant",
      "waterfront patio","brunch patio"
    ],
    allow:[
      "patio","outdoor seating","outdoor dining","terrace","courtyard",
      "rooftop","beer garden","fire pit","restaurant","grill","bistro",
      "cafe","brewery","bar","pub"
    ],
    block:[
      "liquor store","package store","wholesale","supply",
      "furniture patio","garden center"
    ],
    baseRadius:{ urban:10, suburban:18, small_town:30, rural:50 },
    evergreen:true
  },
  "camping": {
    synonyms:[
      "campground","rv park","state park campground","lake campground",
      "primitive camping","public campground","camping resort",
      "koa campground","cabins and campground"
    ],
    allow:[
      "campground","camping","rv park","rv campground","koa",
      "state park","primitive camping","camping resort"
    ],
    block:[
      "camp store","sporting goods","rv dealer","rv repair",
      "storage","mobile home park"
    ],
    baseRadius:{ urban:30, suburban:45, small_town:60, rural:90 },
    evergreen:true
  },
  "trails": {
    synonyms:[
      "hiking trail","nature trail","trailhead","greenway",
      "walking trail","state park trail","scenic trail",
      "mountain bike trail","wildlife refuge trail"
    ],
    allow:[
      "trail","trailhead","hiking","greenway","nature preserve",
      "wildlife refuge","state park","walking path","bike trail"
    ],
    block:[
      "trailers","mobile home","road","street","subdivision",
      "apartment","real estate"
    ],
    baseRadius:{ urban:18, suburban:30, small_town:50, rural:85 },
    evergreen:true
  },
  "run walk": {
    synonyms:[
      "walking trail","running trail","greenway","riverwalk",
      "boardwalk","paved trail","city park walking path",
      "lake loop trail","track"
    ],
    allow:[
      "walking","running","greenway","riverwalk","boardwalk",
      "paved trail","trail","track","park","loop"
    ],
    block:[
      "shoe store","running store","road race office",
      "apartment","subdivision"
    ],
    baseRadius:{ urban:10, suburban:20, small_town:35, rural:55 },
    evergreen:true
  },
  "parks": {
    synonyms:[
      "city park","state park","county park","community park",
      "recreation area","nature preserve","playground",
      "waterfront park","sports complex"
    ],
    allow:[
      "park","state park","county park","community park",
      "recreation","preserve","playground","sports complex",
      "wildlife refuge"
    ],
    block:[
      "parking","mobile home park","business park","office park",
      "industrial park"
    ],
    baseRadius:{ urban:10, suburban:18, small_town:32, rural:55 },
    evergreen:true
  },
  "water": {
    synonyms:[
      "public beach","lake access","river access","boat ramp",
      "boat launch","marina","swimming area","fishing pier",
      "water recreation","public shoreline"
    ],
    allow:[
      "beach","lake","river","shore","boat ramp","boat launch",
      "marina","swimming","fishing pier","water access",
      "reservoir","bay"
    ],
    block:[
      "water utility","water department","water treatment",
      "plumber","pool supply"
    ],
    baseRadius:{ urban:18, suburban:30, small_town:50, rural:85 },
    evergreen:true
  },
  "scenic": {
    synonyms:[
      "scenic overlook","viewpoint","lookout","scenic drive",
      "historic landmark","water view","sunset viewpoint",
      "observation deck","scenic park"
    ],
    allow:[
      "scenic","overlook","viewpoint","lookout","observation",
      "landmark","historic","water view","sunset","vista",
      "scenic drive","park"
    ],
    block:[
      "scenic apartments","real estate","photography studio",
      "billboard","office"
    ],
    baseRadius:{ urban:18, suburban:30, small_town:50, rural:85 },
    evergreen:true
  },
  "hidden gems": {
    synonyms:[
      "hidden gem","local landmark","historic site","unique attraction",
      "roadside attraction","local museum","historic downtown",
      "secret spot","off the beaten path"
    ],
    allow:[
      "historic","landmark","museum","attraction","unique",
      "local","heritage","art","garden","scenic","hidden"
    ],
    block:[
      "storage","warehouse","office","bank","insurance",
      "apartment","real estate","medical"
    ],
    baseRadius:{ urban:15, suburban:25, small_town:45, rural:75 },
    evergreen:true
  },
  "family fun": {
    synonyms:[
      "family fun","family entertainment","kids activities",
      "arcade","bowling","mini golf","trampoline park",
      "children museum","zoo","aquarium","water park",
      "family attraction","playground"
    ],
    allow:[
      "family","kids","children","arcade","bowling","mini golf",
      "trampoline","museum","zoo","aquarium","water park",
      "playground","amusement","entertainment"
    ],
    block:[
      "daycare","school","pediatric","family law","family medicine"
    ],
    baseRadius:{ urban:12, suburban:22, small_town:38, rural:65 },
    evergreen:true
  },
  "date night": {
    synonyms:[
      "date night restaurant","romantic restaurant","cocktail lounge",
      "wine bar","rooftop restaurant","waterfront restaurant",
      "live music restaurant","dessert bar","theater"
    ],
    allow:[
      "romantic","restaurant","cocktail","wine bar","rooftop",
      "waterfront","theater","live music","dessert","bistro",
      "steakhouse","lounge"
    ],
    block:[
      "dating service","wedding planner","bridal",
      "family restaurant buffet","fast food"
    ],
    baseRadius:{ urban:12, suburban:22, small_town:38, rural:65 },
    evergreen:true
  },
  "sports watch": {
    synonyms:[
      "sports bar","game day bar","restaurant with tvs",
      "sports pub","watch party","brewery sports bar",
      "football bar","basketball bar"
    ],
    allow:[
      "sports bar","sports pub","watch party","game day",
      "restaurant","bar","pub","brewery","tvs","televisions"
    ],
    block:[
      "sporting goods","sports medicine","gym","athletic field",
      "sports complex"
    ],
    baseRadius:{ urban:10, suburban:18, small_town:30, rural:50 },
    evergreen:true
  },
  "fitness recreation": {
    synonyms:[
      "fitness center","gym","pickleball","recreation center",
      "public tennis courts","indoor recreation","community center",
      "athletic club","yoga studio"
    ],
    allow:[
      "fitness","gym","pickleball","recreation","tennis",
      "athletic club","community center","yoga","sports center"
    ],
    block:[
      "fitness equipment store","supplement store","physical therapy",
      "sports medicine"
    ],
    baseRadius:{ urban:10, suburban:18, small_town:30, rural:50 },
    evergreen:true
  },
  "hotels": {
    synonyms:[
      "hotel","motel","inn","resort","lodge","boutique hotel",
      "lake resort","beach resort","bed and breakfast"
    ],
    allow:[
      "hotel","motel","inn","resort","lodge","bed and breakfast",
      "lodging","accommodation"
    ],
    block:[
      "apartment","property management","real estate",
      "hotel supply","extended stay apartment"
    ],
    baseRadius:{ urban:10, suburban:18, small_town:30, rural:55 },
    evergreen:true
  },
  "marinas": {
    synonyms:[
      "marina","boat dock","boat launch","boat ramp",
      "yacht club","public dock","boat rental","harbor"
    ],
    allow:[
      "marina","boat dock","boat launch","boat ramp",
      "yacht club","public dock","boat rental","harbor"
    ],
    block:[
      "marine supply","boat dealer","boat repair","storage"
    ],
    baseRadius:{ urban:15, suburban:25, small_town:45, rural:75 },
    evergreen:true
  },
  "live music": {
    synonyms:[
      "live music tonight","live music venue","music venue",
      "concert venue","acoustic music","local band",
      "brewery live music","bar live music","open mic","karaoke"
    ],
    allow:[
      "live music","music venue","concert","band","acoustic",
      "jazz","karaoke","open mic","performing arts"
    ],
    adjacent:[
      "bar","pub","brewery","taproom","restaurant","grill",
      "lounge","nightclub","event venue","amphitheater"
    ],
    block:[
      "music store","instrument store","music lesson","school",
      "recording studio","radio station"
    ],
    baseRadius:{ urban:15, suburban:25, small_town:40, rural:70 },
    evergreen:false
  },
  "popular tonight": {
    synonyms:[
      "popular tonight","nightlife","bar open now","restaurant open now",
      "brewery","cocktail lounge","sports bar","downtown nightlife",
      "things to do tonight"
    ],
    allow:[
      "restaurant","bar","pub","brewery","taproom","lounge",
      "nightclub","entertainment","popular","nightlife"
    ],
    block:[
      "liquor store","package store","retail","grocery",
      "pharmacy","office","medical"
    ],
    baseRadius:{ urban:12, suburban:22, small_town:38, rural:65 },
    evergreen:false
  }
};




function diqV88Text(item) {
  return normText(
    String(item && item.label || "") + " " +
    String(item && item.full || "") + " " +
    String(item && item.matchLabel || "") + " " +
    String(item && item.kind || "") + " " +
    String(item && item.category || "") + " " +
    String(item && item.sourceQuery || "")
  );
}




function diqV88HasAny(text, terms) {
  var i;
  for (i = 0; i < (terms || []).length; i++) {
    if (text.indexOf(normText(terms[i])) > -1) {
      return true;
    }
  }
  return false;
}




var diqV88PriorCategoryFromQuery = categoryFromQuery;




categoryFromQuery = function (query) {
  var q = normText(query);




  if (
    q.indexOf("golf") > -1 ||
    q.indexOf("driving range") > -1 ||
    q.indexOf("country club") > -1
  ) {
    return "golf";
  }




  if (
    q.indexOf("family fun") > -1 ||
    q.indexOf("kids activities") > -1 ||
    q.indexOf("family entertainment") > -1 ||
    q.indexOf("arcade") > -1 ||
    q.indexOf("bowling") > -1 ||
    q.indexOf("trampoline") > -1 ||
    q.indexOf("mini golf") > -1
  ) {
    return "family fun";
  }




  if (
    q.indexOf("date night") > -1 ||
    q.indexOf("romantic") > -1
  ) {
    return "date night";
  }




  if (
    q.indexOf("sports watch") > -1 ||
    q.indexOf("watch party") > -1 ||
    q.indexOf("game day bar") > -1
  ) {
    return "sports watch";
  }




  if (
    q.indexOf("fitness") > -1 ||
    q.indexOf("gym") > -1 ||
    q.indexOf("pickleball") > -1 ||
    q.indexOf("recreation center") > -1
  ) {
    return "fitness recreation";
  }




  if (
    q.indexOf("hotel") > -1 ||
    q.indexOf("motel") > -1 ||
    q.indexOf("lodging") > -1 ||
    q.indexOf("resort") > -1
  ) {
    return "hotels";
  }




  if (
    q.indexOf("marina") > -1 ||
    q.indexOf("boat dock") > -1 ||
    q.indexOf("boat launch") > -1 ||
    q.indexOf("boat ramp") > -1
  ) {
    return "marinas";
  }




  return diqV88PriorCategoryFromQuery(query);
};




function diqV88CurrentDestinationIndexItem() {
  var label = normText(
    adventureSearchCenter && adventureSearchCenter.label ||
    destination && destination.label ||
    ""
  );
  var i;
  var item;
  var aliases;
  var j;




  for (i = 0; i < ADVENTURE_DESTINATION_INDEX.length; i++) {
    item = ADVENTURE_DESTINATION_INDEX[i];
    aliases = item.aliases || [];




    if (normText(item.label) === label) {
      return item;
    }




    for (j = 0; j < aliases.length; j++) {
      if (
        label &&
        (
          label.indexOf(normText(aliases[j])) > -1 ||
          normText(aliases[j]).indexOf(label) > -1
        )
      ) {
        return item;
      }
    }
  }




  return null;
}




function diqV88MarketClass() {
  var indexed = diqV88CurrentDestinationIndexItem();
  var label = normText(
    adventureSearchCenter && adventureSearchCenter.label ||
    destination && destination.label ||
    ""
  );
  var kind = normText(
    destination && destination.kind ||
    indexed && indexed.type ||
    ""
  );
  var denseNames = [
    "memphis","nashville","dallas","boston","orlando",
    "atlanta","chicago","new york","miami","destin",
    "gulf shores","gatlinburg","pigeon forge"
  ];
  var smallNames = [
    "pickwick","counce","iuka","savannah","sardis",
    "moon lake","guntersville","camdenton"
  ];




  if (diqV88HasAny(label, denseNames)) {
    return "urban";
  }




  if (diqV88HasAny(label, smallNames)) {
    return "small_town";
  }




  if (
    kind.indexOf("lake") > -1 ||
    kind.indexOf("park") > -1 ||
    kind.indexOf("mountain") > -1 ||
    kind.indexOf("river") > -1 ||
    kind.indexOf("reservoir") > -1 ||
    kind.indexOf("rural") > -1
  ) {
    return "rural";
  }




  if (
    adventureSearchScope === "near_destination" &&
    indexed
  ) {
    return "small_town";
  }




  return "suburban";
}




function diqV88GatewayTowns() {
  var indexed = diqV88CurrentDestinationIndexItem();
  var label = normText(
    adventureSearchCenter && adventureSearchCenter.label ||
    destination && destination.label ||
    ""
  );
  var out = [];
  var gateways;
  var i;




  if (indexed && indexed.gateways) {
    gateways = indexed.gateways;
    for (i = 0; i < gateways.length; i++) {
      if (clean(gateways[i])) {
        out.push(clean(gateways[i]));
      }
    }
  }




  if (label.indexOf("pickwick") > -1) {
    out.push(
      "Pickwick Landing Tennessee",
      "Counce Tennessee",
      "Savannah Tennessee",
      "Iuka Mississippi",
      "Corinth Mississippi"
    );
  }




  if (label.indexOf("sardis") > -1) {
    out.push(
      "Sardis Mississippi",
      "Batesville Mississippi",
      "Oxford Mississippi"
    );
  }




  if (label.indexOf("moon lake") > -1) {
    out.push(
      "Moon Lake Mississippi",
      "Clarksdale Mississippi",
      "Tunica Mississippi"
    );
  }




  return out.filter(function (value, index, arr) {
    return arr.map(normText).indexOf(normText(value)) === index;
  }).slice(0, 7);
}




function diqV88Profile(query) {
  var category = categoryFromQuery(query);
  return DIQ_V88_CATEGORY_PROFILES[category] || null;
}




var diqV88PriorFallbackMaxPass = adventureFallbackMaxPass;




adventureFallbackMaxPass = function (query) {
  var profile = diqV88Profile(query);
  var market = diqV88MarketClass();




  if (!profile) {
    return diqV88PriorFallbackMaxPass(query);
  }




  if (profile.evergreen === false) {
    return market === "urban" ? 3 : 4;
  }




  if (market === "urban") {
    return 3;
  }




  if (market === "suburban") {
    return 4;
  }




  return 5;
};




var diqV88PriorRadiusForPass = adventureRadiusForPass;




adventureRadiusForPass = function (query, passIndex) {
  var profile = diqV88Profile(query);
  var market = diqV88MarketClass();
  var pass = Number(passIndex || 0);
  var base;
  var multipliers = [1, 1.45, 1.9, 2.45, 3.1, 3.8];




  if (!profile || !profile.baseRadius) {
    return diqV88PriorRadiusForPass(query, passIndex);
  }




  base = Number(
    profile.baseRadius[market] ||
    profile.baseRadius.suburban ||
    25
  );




  return Math.min(
    110,
    Math.round(base * multipliers[Math.min(pass, multipliers.length - 1)])
  );
};




var diqV88PriorBuildQueryPass = buildAdventureQueryPass;




buildAdventureQueryPass = function (
  query,
  originalQuery,
  passIndex
) {
  var out = diqV88PriorBuildQueryPass(
    query,
    originalQuery,
    passIndex
  ) || [];
  var profile = diqV88Profile(originalQuery || query);
  var pass = Number(passIndex || 0);
  var market = diqV88MarketClass();
  var gateways = diqV88GatewayTowns();
  var suffix = destinationTermSuffix();
  var i;
  var g;




  if (!profile) {
    return out;
  }




  for (i = 0; i < profile.synonyms.length; i++) {
    addUniqueAdventureQuery(
      out,
      profile.synonyms[i] + suffix
    );
  }




  if (
    pass >= 2 &&
    (
      market === "small_town" ||
      market === "rural"
    )
  ) {
    for (g = 0; g < gateways.length; g++) {
      for (
        i = 0;
        i < profile.synonyms.length &&
        i < (pass >= 4 ? 8 : 5);
        i++
      ) {
        addUniqueAdventureQuery(
          out,
          profile.synonyms[i] + " " + gateways[g]
        );
      }
    }
  }




  if (pass >= 3 && profile.evergreen !== false) {
    addUniqueAdventureQuery(
      out,
      "best " + categoryFromQuery(originalQuery || query) + suffix
    );
    addUniqueAdventureQuery(
      out,
      "local " + categoryFromQuery(originalQuery || query) + suffix
    );
    addUniqueAdventureQuery(
      out,
      "nearby " + categoryFromQuery(originalQuery || query) + suffix
    );
  }




  if (
    pass >= 4 &&
    profile.adjacent
  ) {
    for (i = 0; i < profile.adjacent.length; i++) {
      addUniqueAdventureQuery(
        out,
        profile.adjacent[i] + suffix
      );
    }
  }




  return out.slice(
    0,
    pass >= 4 ? 96 : 72
  );
};




var diqV88PriorStrictCategoryMatch =
  isStrictAdventureCategoryMatch;




isStrictAdventureCategoryMatch = function (
  item,
  query
) {
  var profile = diqV88Profile(query);
  var txt;
  var pass;
  var explicit;
  var adjacent;




  if (!profile) {
    return diqV88PriorStrictCategoryMatch(item, query);
  }




  txt = diqV88Text(item);
  pass = Number(item && item.fallbackPass || 0);




  if (
    profile.block &&
    diqV88HasAny(txt, profile.block)
  ) {
    return false;
  }




  explicit = diqV88HasAny(
    txt,
    profile.allow
  );




  if (explicit) {
    item.categoryTruthTier = "exact";
    return true;
  }




  if (
    profile.adjacent &&
    pass >= 4 &&
    diqV88HasAny(txt, profile.adjacent)
  ) {
    item.categoryTruthTier = "adjacent";
    item.liveSignalConfirmed = false;
    item.recurringVenueFallback = true;
    return true;
  }




  /*
    Sparse-market rescue is still category truthful.
    It accepts the source query as evidence only when the provider returned
    a named POI and the query itself came from the category profile.
  */
  if (
    profile.evergreen !== false &&
    pass >= 4 &&
    clean(item && item.label) &&
    diqV88HasAny(
      normText(item && item.sourceQuery || ""),
      profile.synonyms
    )
  ) {
    item.categoryTruthTier = "provider_query";
    return true;
  }




  return false;
};




var diqV88PriorScoreAdventure = scoreAdventure;




scoreAdventure = function (item, query) {
  var score = diqV88PriorScoreAdventure(item, query);
  var profile = diqV88Profile(query);
  var market = diqV88MarketClass();
  var txt;
  var distance;




  if (!profile) {
    return score;
  }




  txt = diqV88Text(item);
  distance = finite(Number(item && item.distMiles))
    ? Number(item.distMiles)
    : 9999;




  if (diqV88HasAny(txt, profile.allow)) {
    score += 190;
  }




  if (
    item &&
    item.categoryTruthTier === "adjacent"
  ) {
    score -= 45;
  }




  if (
    item &&
    item.categoryTruthTier === "provider_query"
  ) {
    score += 35;
  }




  if (
    market === "rural" ||
    market === "small_town"
  ) {
    if (distance <= 15) { score += 55; }
    else if (distance <= 30) { score += 45; }
    else if (distance <= 50) { score += 28; }
    else if (distance <= 75) { score += 12; }




    score += Math.min(
      28,
      Number(item && item.worthScore || 0) * 0.18
    );
  } else {
    if (distance <= 5) { score += 45; }
    else if (distance <= 12) { score += 25; }
    else if (distance > 30) { score -= 35; }
  }




  return score;
};




var diqV88PriorSortAdventureResults =
  sortAdventureResults;




sortAdventureResults = function (items, query) {
  var profile = diqV88Profile(query);
  var seenNames = {};




  if (!profile) {
    return diqV88PriorSortAdventureResults(items, query);
  }




  items = items.filter(function (item) {
    var key = normText(item && item.label || "");
    if (!key) { return false; }
    if (seenNames[key]) { return false; }
    seenNames[key] = true;
    return true;
  });




  return items.sort(function (a, b) {
    var aTier =
      a.categoryTruthTier === "exact" ? 3 :
      a.categoryTruthTier === "provider_query" ? 2 :
      a.categoryTruthTier === "adjacent" ? 1 : 0;




    var bTier =
      b.categoryTruthTier === "exact" ? 3 :
      b.categoryTruthTier === "provider_query" ? 2 :
      b.categoryTruthTier === "adjacent" ? 1 : 0;




    var sa;
    var sb;
    var da;
    var db;




    if (aTier !== bTier) {
      return bTier - aTier;
    }




    sa = scoreAdventure(a, query);
    sb = scoreAdventure(b, query);




    if (Math.abs(sb - sa) > 10) {
      return sb - sa;
    }




    da = finite(Number(a.distMiles))
      ? Number(a.distMiles)
      : 99999;




    db = finite(Number(b.distMiles))
      ? Number(b.distMiles)
      : 99999;




    return da - db;
  });
};




var diqV88PriorZeroMessage =
  zeroResultTrustMessage;




zeroResultTrustMessage = function (
  query,
  passIndex
) {
  var profile = diqV88Profile(query);
  var market = diqV88MarketClass();




  if (!profile) {
    return diqV88PriorZeroMessage(query, passIndex);
  }




  if (profile.evergreen === false) {
    return "No current live signal confirmed. Showing recurring venues and nearby alternatives when available.";
  }




  return "No strong immediate matches, so Drive IQ widened to the best options in the " +
    (adventureScanCityLabel() || market.replace("_", " ")) +
    " region.";
};




var diqV88PriorNoNearbyMessage =
  noNearbyMessage;




noNearbyMessage = function (query) {
  var profile = diqV88Profile(query);




  if (!profile) {
    return diqV88PriorNoNearbyMessage(query);
  }




  if (profile.evergreen === false) {
    return "No current activity confirmed. Check recurring venues and nearby alternatives.";
  }




  return "Nothing strong in the immediate area, so Drive IQ widened the regional search.";
};




function diqV88CategoryLabel(query) {
  var category = categoryFromQuery(query);




  if (category === "golf") { return "Golf IQ"; }
  if (category === "family fun") { return "Family Fun IQ"; }
  if (category === "date night") { return "Date Night IQ"; }
  if (category === "sports watch") { return "Sports Watch IQ"; }
  if (category === "fitness recreation") { return "Fitness & Recreation IQ"; }
  if (category === "hotels") { return "Hotel IQ"; }
  if (category === "marinas") { return "Marina IQ"; }




  return adventureScanCategoryLabel(query);
}




var diqV88PriorScanTabTitle =
  scanTabTitleForQuery;




scanTabTitleForQuery = function (query) {
  var profile = diqV88Profile(query);




  if (!profile) {
    return diqV88PriorScanTabTitle(query);
  }




  return diqV88CategoryLabel(query);
};




var diqV88PriorFallbackStatus =
  fallbackScanStatus;




fallbackScanStatus = function (
  passIndex,
  query
) {
  var profile = diqV88Profile(query);
  var pass = Number(passIndex || 0);
  var market = diqV88MarketClass();
  var radius;




  if (!profile) {
    return diqV88PriorFallbackStatus(passIndex, query);
  }




  radius = adventureRadiusForPass(query, pass);




  if (pass === 0) {
    return "Checking exact " +
      diqV88CategoryLabel(query) +
      " matches...";
  }




  if (pass === 1) {
    return "Expanding category terms within " +
      String(radius) +
      " miles...";
  }




  if (pass === 2) {
    return "Checking nearby activity centers and gateway towns...";
  }




  if (pass === 3) {
    return "Searching the strongest options across the real local region...";
  }




  if (pass === 4) {
    return "Running the regional rescue pass for " +
      diqV88CategoryLabel(query) +
      "...";
  }




  return market === "urban"
    ? "Final city-wide category sweep..."
    : "Final trusted regional category sweep...";
};




function diqV88Boot() {
  try {
    console.log(
      "âœ… Drive IQ V88 Category Priority loaded",
      {
        market:diqV88MarketClass(),
        center:adventureScanCityLabel(),
        build:window.DRIVE_IQ_ADVENTURE_MODE_BUILD
      }
    );
  } catch (e0) {}
}




diqV88Boot();








/* =========================================================
   DRIVE IQ V89 â€” CATEGORY TRUTH LOCK




   Permanent invariant:
   Expand geography, never expand the category definition.




   - Keeps V88 market density, adaptive radius, gateway towns,
     synonym expansion, and zero-empty rescue.
   - Removes source-query-as-proof acceptance.
   - Requires actual place evidence from name, category, tags,
     description, provider metadata, or verified type fields.
   - Filters contaminated results again immediately before sort.
========================================================= */




window.__DRIVE_IQ_ADVENTURE_MODE_JS_V89_CATEGORY_TRUTH_LOCK__ = true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD = "V89_CATEGORY_TRUTH_LOCK";




function diqV89SafeStringify(value) {
  try {
    return JSON.stringify(value || "");
  } catch (e0) {
    return "";
  }
}




function diqV89EvidenceText(item) {
  /*
    IMPORTANT:
    sourceQuery is intentionally excluded.
    A provider query is a search instruction, not proof of identity.
  */
  return normText(
    String(item && item.label || "") + " " +
    String(item && item.full || "") + " " +
    String(item && item.matchLabel || "") + " " +
    String(item && item.kind || "") + " " +
    String(item && item.category || "") + " " +
    String(item && item.resultType || "") + " " +
    String(item && item.description || "") + " " +
    String(item && item.subtitle || "") + " " +
    String(item && item.type || "") + " " +
    String(item && item.providerCategory || "") + " " +
    String(item && item.primaryType || "") + " " +
    String(item && item.types || "") + " " +
    String(item && item.categories || "") + " " +
    String(item && item.tags || "") + " " +
    diqV89SafeStringify(item && item.properties) + " " +
    diqV89SafeStringify(item && item.datasource) + " " +
    diqV89SafeStringify(item && item.raw)
  );
}




function diqV89QueryExplicitlyRequestsMiniGolf(query) {
  var q = normText(query);




  return (
    q.indexOf("mini golf") > -1 ||
    q.indexOf("putt putt") > -1 ||
    q.indexOf("putt-putt") > -1
  );
}




function diqV89GolfTruth(item, query) {
  var txt = diqV89EvidenceText(item);
  var miniRequested = diqV89QueryExplicitlyRequestsMiniGolf(query);




  if (!txt) { return false; }




  if (
    txt.indexOf("golf cart dealer") > -1 ||
    txt.indexOf("golf cart rental") > -1 ||
    txt.indexOf("golf cart sales") > -1 ||
    txt.indexOf("golf equipment") > -1 ||
    txt.indexOf("sporting goods") > -1 ||
    txt.indexOf("golf apparel") > -1 ||
    txt.indexOf("golf clothing") > -1 ||
    txt.indexOf("hotel") > -1 ||
    txt.indexOf("motel") > -1 ||
    txt.indexOf("restaurant") > -1 ||
    txt.indexOf("tour company") > -1 ||
    txt.indexOf("vacation rental") > -1 ||
    txt.indexOf("real estate") > -1
  ) {
    return false;
  }




  if (
    txt.indexOf("mini golf") > -1 ||
    txt.indexOf("putt putt") > -1
  ) {
    return miniRequested;
  }




  return (
    txt.indexOf("golf course") > -1 ||
    txt.indexOf("public golf") > -1 ||
    txt.indexOf("golf club") > -1 ||
    txt.indexOf("country club") > -1 ||
    txt.indexOf("municipal golf") > -1 ||
    txt.indexOf("resort golf") > -1 ||
    txt.indexOf("driving range") > -1 ||
    txt.indexOf("golf academy") > -1 ||
    txt.indexOf("golf links") > -1 ||
    txt.indexOf("golf resort") > -1 ||
    txt.indexOf("golf_course") > -1
  );
}




function diqV89StrictProfileTruth(item, query, profile) {
  var category = categoryFromQuery(query);
  var txt = diqV89EvidenceText(item);
  var pass = Number(item && item.fallbackPass || 0);
  var explicit;
  var adjacent;




  if (!profile) { return false; }
  if (!txt) { return false; }




  if (category === "golf") {
    if (diqV89GolfTruth(item, query)) {
      item.categoryTruthTier = "exact";
      return true;
    }
    return false;
  }




  if (
    profile.block &&
    diqV88HasAny(txt, profile.block)
  ) {
    return false;
  }




  explicit = diqV88HasAny(
    txt,
    profile.allow
  );




  if (explicit) {
    item.categoryTruthTier = "exact";
    return true;
  }




  /*
    Only time-sensitive profiles may use an adjacent fallback,
    and it must be clearly labeled as unconfirmed/recurring.
  */
  adjacent = (
    profile.evergreen === false &&
    profile.adjacent &&
    pass >= 4 &&
    diqV88HasAny(txt, profile.adjacent)
  );




  if (adjacent) {
    item.categoryTruthTier = "adjacent";
    item.liveSignalConfirmed = false;
    item.recurringVenueFallback = true;
    return true;
  }




  return false;
}




/*
  Replace V88's weak provider-query rescue.
  No evergreen category may pass because its search query matched.
*/
var diqV89PriorStrictCategoryMatch =
  isStrictAdventureCategoryMatch;




isStrictAdventureCategoryMatch = function (
  item,
  query
) {
  var profile = diqV88Profile(query);




  if (!profile) {
    return diqV89PriorStrictCategoryMatch(
      item,
      query
    );
  }




  return diqV89StrictProfileTruth(
    item,
    query,
    profile
  );
};




function diqV89FilterTruthfulResults(items, query) {
  var profile = diqV88Profile(query);
  var out = [];
  var i;
  var item;




  if (!profile) {
    return items || [];
  }




  for (i = 0; i < (items || []).length; i++) {
    item = items[i];




    if (!item) { continue; }




    if (
      diqV89StrictProfileTruth(
        item,
        query,
        profile
      )
    ) {
      out.push(item);
    }
  }




  return out;
}




/*
  Last-line defense:
  filter contamination again immediately before category-priority sorting.
*/
var diqV89PriorSortAdventureResults =
  sortAdventureResults;




sortAdventureResults = function (
  items,
  query
) {
  var profile = diqV88Profile(query);
  var truthful;




  if (!profile) {
    return diqV89PriorSortAdventureResults(
      items,
      query
    );
  }




  truthful = diqV89FilterTruthfulResults(
    items || [],
    query
  );




  return diqV89PriorSortAdventureResults(
    truthful,
    query
  );
};




/*
  Scoring may never reward the removed provider_query tier.
*/
var diqV89PriorScoreAdventure =
  scoreAdventure;




scoreAdventure = function (
  item,
  query
) {
  var score =
    diqV89PriorScoreAdventure(
      item,
      query
    );




  if (
    item &&
    item.categoryTruthTier === "provider_query"
  ) {
    score -= 500;
  }




  return score;
};




/*
  Remove stale V88 provider-query truth tiers before result rendering,
  map pinning, and card creation.
*/
function diqV89SanitizeTruthTier(item, query) {
  var profile = diqV88Profile(query);




  if (!item || !profile) {
    return item;
  }




  if (
    item.categoryTruthTier === "provider_query"
  ) {
    item.categoryTruthTier = "";
  }




  if (
    !diqV89StrictProfileTruth(
      item,
      query,
      profile
    )
  ) {
    item.categoryTruthRejected = true;
  }




  return item;
}




var diqV89PriorEnrichAdventureItem =
  enrichAdventureItem;




enrichAdventureItem = function (
  item,
  query
) {
  var enriched =
    diqV89PriorEnrichAdventureItem(
      item,
      query
    );




  return diqV89SanitizeTruthTier(
    enriched,
    query
  );
};




/*
  Golf-specific final card/map guard.
  This prevents a stale contaminated result from surviving through an
  older cached array or alternate render path.
*/
function diqV89FilterActiveAdventureResults(query) {
  var profile = diqV88Profile(query);




  if (!profile) { return; }




  adventureResults =
    diqV89FilterTruthfulResults(
      adventureResults || [],
      query
    );




  exploreResults =
    diqV89FilterTruthfulResults(
      exploreResults || [],
      query
    );




  if (
    adventurePreferred &&
    !diqV89StrictProfileTruth(
      adventurePreferred,
      query,
      profile
    )
  ) {
    adventurePreferred = null;
  }
}




/* V204 Runtime Recovery Authority.
   V89 assumed an older function named renderAdventureResults existed.
   In this live Adventure build, the actual visible pipeline is owned by
   renderAdventureScanChoices / renderResultPins / afterScanResultsReady.
   Referencing the missing symbol stopped JavaScript execution before V90â€“V203,
   so the live Scan Engine bridge never loaded.

   This compatibility base intentionally does not repaint or recurse. It gives
   the later truth/guard wrappers a valid boundary while the real render
   pipeline continues through the existing functions above. */
if (typeof renderAdventureResults !== "function") {
  var renderAdventureResults = function () {
    return adventureResults && adventureResults.length
      ? adventureResults.slice(0)
      : [];
  };
  renderAdventureResults.__diqV204CompatibilityBase = true;
}

var diqV89PriorRenderAdventureResults =
  renderAdventureResults;




renderAdventureResults = function () {
  var query =
    activeScanQuery ||
    activeLens ||
    "";




  diqV89FilterActiveAdventureResults(
    query
  );




  return diqV89PriorRenderAdventureResults
    .apply(this, arguments);
};




function diqV89TruthLabel(query) {
  var category = categoryFromQuery(query);




  if (category === "golf") {
    return "REAL GOLF ONLY";
  }




  if (category === "coffee iq") {
    return "REAL COFFEE ONLY";
  }




  if (category === "hotels") {
    return "LODGING VERIFIED";
  }




  if (category === "marinas") {
    return "MARINA / ACCESS VERIFIED";
  }




  return "CATEGORY TRUTH LOCKED";
}




var diqV89PriorFallbackStatus =
  fallbackScanStatus;




fallbackScanStatus = function (
  passIndex,
  query
) {
  var profile = diqV88Profile(query);
  var base;




  if (!profile) {
    return diqV89PriorFallbackStatus(
      passIndex,
      query
    );
  }




  base = diqV89PriorFallbackStatus(
    passIndex,
    query
  );




  return base + " " +
    diqV89TruthLabel(query) +
    ".";
};




function diqV89Boot() {
  try {
    console.log(
      "âœ… Drive IQ V89 Category Truth Lock loaded",
      {
        market:diqV88MarketClass(),
        center:adventureScanCityLabel(),
        rule:"expand geography, never category definition",
        build:window.DRIVE_IQ_ADVENTURE_MODE_BUILD
      }
    );
  } catch (e0) {}
}








/* =========================================================
   DRIVE IQ V91 â€” CATEGORY EXCELLENCE IQ




   Every Adventure category now owns its own truth vocabulary,
   adaptive search profile, ranking priorities, rejection rules,
   confidence language, and recommendation reason.




   Permanent law:
   Expand geography aggressively. Never relax category truth.
========================================================= */




window.__DRIVE_IQ_ADVENTURE_MODE_JS_V91_CATEGORY_EXCELLENCE__ = true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD = "V91_CATEGORY_EXCELLENCE_IQ";




function diqV91PutProfile(key, profile) {
  DIQ_V88_CATEGORY_PROFILES[key] = profile;
}




diqV91PutProfile("popular tonight", {
  synonyms:[
    "popular tonight","things to do tonight","busy restaurants tonight",
    "popular bars tonight","live entertainment tonight","downtown tonight",
    "local events tonight","night market","rooftop tonight","late night food"
  ],
  allow:[
    "restaurant","bar","pub","brewery","taproom","lounge","nightclub",
    "entertainment","music venue","event venue","rooftop","food hall",
    "market","theater","comedy club","bowling","arcade"
  ],
  adjacent:["downtown","district","square","entertainment district","walkable"],
  block:[
    "liquor store","package store","grocery","pharmacy","office","medical",
    "bank","apartment","storage","warehouse","car dealer","gas station"
  ],
  baseRadius:{ urban:12, suburban:22, small_town:38, rural:65 },
  evergreen:false
});




diqV91PutProfile("bbq", {
  synonyms:[
    "barbecue restaurant","bbq restaurant","smokehouse","pit barbecue",
    "local barbecue","ribs","pulled pork","brisket","whole hog barbecue",
    "wood smoked barbecue","regional barbecue"
  ],
  allow:[
    "bbq","barbecue","barbeque","smokehouse","smoke house","pitmaster",
    "pit master","brisket","ribs","pulled pork","whole hog","smoked meat"
  ],
  block:[
    "bbq supply","grill store","outdoor furniture","hardware","grocery",
    "catering supply","food distributor","gas station","convenience store"
  ],
  baseRadius:{ urban:10, suburban:18, small_town:35, rural:60 },
  evergreen:true
});




diqV91PutProfile("lake iq", {
  synonyms:[
    "lake access","lake beach","lake marina","lake boat ramp","lakefront park",
    "lake campground","lake restaurant","lake fishing","lake overlook",
    "lake rentals","public lake access","lake recreation"
  ],
  allow:[
    "lake","reservoir","marina","boat ramp","boat launch","beach",
    "swimming area","fishing pier","lakefront","shore","campground",
    "state park","water access","boat rental"
  ],
  block:[
    "lake apartments","lake real estate","property management","water utility",
    "plumber","pool supply","marine supply","boat dealer","storage"
  ],
  baseRadius:{ urban:25, suburban:40, small_town:65, rural:100 },
  evergreen:true
});




diqV91PutProfile("outdoors", {
  synonyms:[
    "outdoor recreation","hiking trail","nature preserve","state park",
    "wildlife refuge","paddling","kayaking","rock climbing","mountain biking",
    "public land","recreation area","scenic outdoor adventure"
  ],
  allow:[
    "trail","hiking","park","state park","preserve","wildlife refuge",
    "greenway","kayak","canoe","paddling","climbing","mountain bike",
    "recreation area","natural area","forest","campground"
  ],
  block:[
    "outdoor furniture","sporting goods","landscaping","garden center",
    "apartment","subdivision","office park","business park"
  ],
  baseRadius:{ urban:20, suburban:35, small_town:60, rural:95 },
  evergreen:true
});




diqV91PutProfile("dog iq", {
  synonyms:[
    "dog park","dog friendly patio","pet friendly restaurant","dog friendly trail",
    "dog friendly park","pet friendly hotel","off leash park","dog beach",
    "dog friendly brewery","pet friendly attraction","dog walking trail"
  ],
  allow:[
    "dog park","off leash","dog friendly","pet friendly","dogs allowed",
    "pet friendly patio","dog beach","dog trail","pet friendly hotel",
    "brewery","patio","park","trail"
  ],
  block:[
    "veterinarian","animal hospital","pet store","pet grooming","dog training",
    "kennel","boarding","pet supply","animal shelter","breeder"
  ],
  baseRadius:{ urban:10, suburban:18, small_town:32, rural:55 },
  evergreen:true
});




diqV91PutProfile("nightlife", {
  synonyms:[
    "nightlife","cocktail bar","rooftop bar","live music bar","dance club",
    "brewery nightlife","karaoke bar","late night lounge","honky tonk",
    "nightlife district","late night food","social bar"
  ],
  allow:[
    "bar","pub","tavern","cocktail","lounge","nightclub","dance club",
    "brewery","taproom","karaoke","honky tonk","rooftop","live music",
    "late night","social club","entertainment district"
  ],
  adjacent:["restaurant","food hall","bowling","arcade","comedy club"],
  block:[
    "liquor store","package store","grocery","barber","salon","office",
    "night school","storage","apartment","rehab","medical"
  ],
  baseRadius:{ urban:12, suburban:25, small_town:45, rural:75 },
  evergreen:true
});




diqV91PutProfile("treats", {
  synonyms:[
    "ice cream","dessert shop","bakery","donut shop","cupcakes","candy store",
    "chocolate shop","frozen yogurt","gelato","specialty desserts",
    "late night dessert","local sweets"
  ],
  allow:[
    "ice cream","gelato","dessert","bakery","donut","doughnut","cupcake",
    "cookie","candy","chocolate","frozen yogurt","snow cone","shaved ice",
    "sweet shop","pastry","creamery"
  ],
  block:[
    "grocery","supermarket","nutrition","supplement","wholesale","distributor",
    "bakery supply","restaurant supply","convenience store","gas station"
  ],
  baseRadius:{ urban:7, suburban:13, small_town:24, rural:42 },
  evergreen:true
});




diqV91PutProfile("shopping", {
  synonyms:[
    "best shopping","shopping district","walkable shopping district",
    "women's boutique","women's fashion","local boutique","local shops",
    "independent shops","vintage clothing","resale boutique","antique mall",
    "home decor","gift shop","luxury shopping","outlet mall","lifestyle center",
    "shopping mall","main street shopping","shopping and lunch","artisan market"
  ],
  allow:[
    "boutique","women's clothing","womens clothing","fashion","apparel",
    "shopping district","retail district","main street","town square",
    "lifestyle center","mall","outlet","vintage","resale","antique",
    "home decor","gift shop","artisan","market","bookstore","local shop"
  ],
  adjacent:["coffee","cafe","restaurant","food hall","walkable","downtown"],
  block:[
    "warehouse","industrial supply","auto parts","car dealer","storage",
    "wholesale distributor","hardware","building supply","tractor supply",
    "sporting goods","gun store","pharmacy","grocery","gas station"
  ],
  baseRadius:{ urban:14, suburban:24, small_town:40, rural:70 },
  evergreen:true
});




diqV91PutProfile("family fun", {
  synonyms:[
    "family fun","kids activities","family entertainment","children museum",
    "science museum","zoo","aquarium","arcade","bowling","mini golf",
    "trampoline park","water park","theme park","family attraction",
    "indoor playground","outdoor family activities"
  ],
  allow:[
    "family","kids","children","arcade","bowling","mini golf","trampoline",
    "museum","science center","zoo","aquarium","water park","theme park",
    "playground","amusement","family entertainment","indoor play"
  ],
  block:[
    "daycare","school","pediatric","family law","family medicine","tutoring",
    "child care","therapy","dentist","church nursery"
  ],
  baseRadius:{ urban:14, suburban:25, small_town:42, rural:70 },
  evergreen:true
});




diqV91PutProfile("date night", {
  synonyms:[
    "date night","romantic restaurant","cocktail lounge","wine bar",
    "rooftop restaurant","waterfront restaurant","intimate restaurant",
    "live music date","dessert date","theater date","walkable date night",
    "dinner and drinks","couples activity"
  ],
  allow:[
    "romantic","intimate","restaurant","cocktail","wine bar","rooftop",
    "waterfront","theater","live music","dessert","bistro","steakhouse",
    "lounge","jazz","tapas","patio","scenic"
  ],
  block:[
    "dating service","wedding planner","bridal","fast food","buffet",
    "family medicine","daycare","banquet supply"
  ],
  baseRadius:{ urban:12, suburban:24, small_town:42, rural:70 },
  evergreen:true
});




diqV91PutProfile("sports watch", {
  synonyms:[
    "sports bar","game day bar","watch party","restaurant with tvs",
    "football watch party","basketball watch party","baseball bar",
    "brewery game day","stadium district","sports pub","big screen sports"
  ],
  allow:[
    "sports bar","sports pub","watch party","game day","big screen",
    "tvs","televisions","bar","pub","brewery","restaurant","stadium district"
  ],
  block:[
    "sporting goods","sports medicine","gym","athletic field","sports complex",
    "sports academy","equipment store","physical therapy"
  ],
  baseRadius:{ urban:12, suburban:22, small_town:38, rural:60 },
  evergreen:true
});




var diqV91PriorCategoryFromQuery = categoryFromQuery;
categoryFromQuery = function(query) {
  var q = normText(query);




  if (/\b(bbq|barbecue|barbeque|smokehouse|brisket|ribs|pulled pork)\b/.test(q)) { return "bbq"; }
  if (/\b(lake iq|lake access|lake beach|lakefront|lake marina|lake boat ramp)\b/.test(q)) { return "lake iq"; }
  if (/\b(dog iq|dog friendly|pet friendly|dog park|off leash|dog beach)\b/.test(q)) { return "dog iq"; }
  if (/\b(treats|dessert|ice cream|gelato|donut|doughnut|cupcake|candy|chocolate|frozen yogurt)\b/.test(q)) { return "treats"; }
  if (/\b(nightlife|cocktail bar|night club|nightclub|dance club|late night lounge|honky tonk)\b/.test(q)) { return "nightlife"; }
  if (/\b(outdoors|outdoor adventure|outdoor recreation|nature preserve|wildlife refuge|paddling|kayaking|climbing)\b/.test(q)) { return "outdoors"; }
  if (/\b(gameday|game day|sports watch|watch party|sports bar)\b/.test(q)) { return "sports watch"; }
  if (/\b(popular|popular tonight|things to do tonight|busy tonight)\b/.test(q)) { return "popular tonight"; }
  if (/\b(family|family fun|kids|children|arcade|bowling|trampoline|mini golf|zoo|aquarium)\b/.test(q)) { return "family fun"; }
  if (/\b(date iq|date night|romantic|couples activity)\b/.test(q)) { return "date night"; }




  return diqV91PriorCategoryFromQuery(query);
};




function diqV91EvidenceText(item) {
  return normText(
    String(item && item.label || "") + " " +
    String(item && item.full || "") + " " +
    String(item && item.kind || "") + " " +
    String(item && item.category || "") + " " +
    String(item && item.matchLabel || "") + " " +
    String(item && item.adventureCategory || "") + " " +
    String(item && item.description || "") + " " +
    String(item && item.tags || "")
  );
}




function diqV91IsNationalChain(text) {
  return diqV88HasAny(text, [
    "walmart","target","costco","sam s club","best buy","home depot","lowe s",
    "mcdonald","burger king","wendy","taco bell","subway","starbucks",
    "chick fil a","applebee","chili s","olive garden","cracker barrel",
    "dollar general","family dollar","dollar tree","cvs","walgreens"
  ]);
}




function diqV91IsShoppingDistrict(text) {
  return diqV88HasAny(text, [
    "shopping district","retail district","main street","downtown","town square",
    "lifestyle center","village","marketplace","the gulch","12 south",
    "hillsboro village","green hills","fifth and broadway","5th and broadway",
    "franklin main street","coolsprings","east nashville"
  ]);
}




function diqV91Truth(item, query) {
  var category = categoryFromQuery(query);
  var profile = DIQ_V88_CATEGORY_PROFILES[category];
  var text = diqV91EvidenceText(item);
  var explicit;
  var adjacent;




  if (!profile) { return true; }
  if (!text) { return false; }
  if (diqV88HasAny(text, profile.block || [])) { return false; }




  explicit = diqV88HasAny(text, profile.allow || []);
  adjacent = diqV88HasAny(text, profile.adjacent || []);




  if (category === "popular tonight") {
    return explicit || adjacent;
  }




  if (category === "shopping" && diqV91IsShoppingDistrict(text)) {
    return true;
  }




  return explicit || adjacent;
}




var diqV91PriorStrictCategoryMatch = typeof diqV89StrictCategoryTruth === "function"
  ? diqV89StrictCategoryTruth
  : (typeof isStrictAdventureCategoryMatch === "function" ? isStrictAdventureCategoryMatch : null);




if (typeof diqV89StrictCategoryTruth === "function") {
  var diqV91PriorV89StrictTruth = diqV89StrictCategoryTruth;
  diqV89StrictCategoryTruth = function(item, query) {
    var category = categoryFromQuery(query);
    if (DIQ_V88_CATEGORY_PROFILES[category]) {
      return diqV91Truth(item, query);
    }
    return diqV91PriorV89StrictTruth(item, query);
  };
}




var diqV91PriorScoreAdventure = scoreAdventure;
scoreAdventure = function(item, query) {
  var score = diqV91PriorScoreAdventure(item, query);
  var category = categoryFromQuery(query);
  var text = diqV91EvidenceText(item);
  var dist = Number(item && item.distMiles);




  if (!item || !diqV91Truth(item, query)) { return -9999; }




  if (category === "shopping") {
    if (diqV91IsShoppingDistrict(text)) { score += 170; }
    if (diqV88HasAny(text,["boutique","women's clothing","womens clothing","fashion","vintage","resale","home decor","gift shop","artisan","local shop"])) { score += 135; }
    if (diqV88HasAny(text,["mall","lifestyle center","outlet","shopping center","shopping centre"])) { score += 105; }
    if (diqV88HasAny(text,["walkable","coffee","cafe","restaurant","food hall","downtown"])) { score += 42; }
    if (diqV91IsNationalChain(text) && !diqV88HasAny(text,["mall","shopping center","lifestyle center","outlet"])) { score -= 120; }
    if (diqV88HasAny(text,["sporting goods","hardware","grocery","pharmacy","auto parts"])) { score -= 450; }
  }




  if (category === "bbq") {
    if (diqV88HasAny(text,["smokehouse","pitmaster","pit master","brisket","ribs","whole hog","wood smoked"])) { score += 140; }
    if (diqV88HasAny(text,["local","family owned","historic","regional"])) { score += 55; }
    if (diqV91IsNationalChain(text)) { score -= 70; }
  }




  if (category === "coffee iq" || category === "coffee") {
    if (diqV88HasAny(text,["roaster","independent","local coffee","espresso bar","bakery cafe"])) { score += 120; }
    if (diqV88HasAny(text,["smoothie","nutrition","protein shake","gas station"])) { score -= 500; }
    if (text.indexOf("starbucks") > -1) { score -= 55; }
  }




  if (category === "local favorites") {
    if (diqV88HasAny(text,["local favorite","local institution","family owned","locally owned","neighborhood","historic","iconic","town square","downtown"])) { score += 125; }
    if (diqV91IsNationalChain(text)) { score -= 95; }
  }




  if (category === "hidden gems") {
    if (diqV88HasAny(text,["historic","heritage","artisan","unique","roadside","secret","off the beaten path","local museum","garden","gallery"])) { score += 115; }
    if (diqV91IsNationalChain(text)) { score -= 160; }
    if (Number(item && item.reviewCount || 0) > 5000) { score -= 35; }
  }




  if (category === "live music") {
    if (diqV88HasAny(text,["live music","music venue","concert","honky tonk","jazz","acoustic","open mic"])) { score += 145; }
    else if (diqV88HasAny(text,["bar","brewery","restaurant","lounge"])) { score += 25; }
  }




  if (category === "nightlife" || category === "popular tonight") {
    if (diqV88HasAny(text,["cocktail","rooftop","live music","karaoke","honky tonk","nightclub","late night","entertainment district"])) { score += 120; }
    if (diqV88HasAny(text,["downtown","district","walkable","food hall"])) { score += 55; }
    if (diqV88HasAny(text,["liquor store","package store"])) { score -= 500; }
  }




  if (category === "family fun") {
    if (diqV88HasAny(text,["children museum","science center","zoo","aquarium","theme park","water park","arcade","bowling","mini golf","trampoline"])) { score += 130; }
    if (diqV88HasAny(text,["daycare","school","pediatric"])) { score -= 500; }
  }




  if (category === "dog iq") {
    if (diqV88HasAny(text,["dog park","off leash","dog beach","dogs allowed","pet friendly patio","dog friendly trail"])) { score += 145; }
    if (diqV88HasAny(text,["veterinarian","pet store","grooming","boarding"])) { score -= 500; }
  }




  if (category === "date night") {
    if (diqV88HasAny(text,["romantic","intimate","rooftop","waterfront","wine bar","cocktail","jazz","tapas","theater","dessert"])) { score += 125; }
    if (diqV88HasAny(text,["fast food","buffet"])) { score -= 180; }
  }




  if (category === "treats") {
    if (diqV88HasAny(text,["creamery","gelato","artisan chocolate","specialty dessert","local bakery","late night dessert"])) { score += 115; }
    if (diqV91IsNationalChain(text)) { score -= 45; }
  }




  if (category === "sports watch") {
    if (diqV88HasAny(text,["sports bar","watch party","big screen","tvs","televisions","stadium district","game day"])) { score += 135; }
    if (diqV88HasAny(text,["sporting goods","sports medicine","athletic field"])) { score -= 500; }
  }




  if (category === "lake iq" || category === "water" || category === "outdoors" || category === "scenic") {
    if (diqV88HasAny(text,["public access","state park","marina","boat ramp","trailhead","overlook","viewpoint","beach","wildlife refuge","nature preserve"])) { score += 105; }
    if (diqV88HasAny(text,["real estate","apartments","property management","utility"])) { score -= 500; }
  }




  if (finite(dist)) {
    if (category === "coffee iq" || category === "treats") {
      if (dist <= 8) { score += 55; }
      else if (dist > 25) { score -= 80; }
    }
    if (category === "shopping" && diqV91IsShoppingDistrict(text) && dist <= 35) { score += 45; }
  }




  return score;
};




var diqV91PriorFilterExperienceResults = diqV22FilterExperienceResults;
diqV22FilterExperienceResults = function(items, query) {
  var base = diqV91PriorFilterExperienceResults(items || [], query);
  var out = [];
  var i;
  for (i = 0; i < base.length; i++) {
    if (diqV91Truth(base[i], query)) { out.push(base[i]); }
  }
  return out;
};




var diqV91PriorAdventureWhy = adventureWhy;
adventureWhy = function(item, query) {
  var category = categoryFromQuery(query);
  var text = diqV91EvidenceText(item);




  if (category === "shopping") {
    if (diqV91IsShoppingDistrict(text)) { return "A stronger shopping district with multiple stops, nearby food or coffee, and more reason to make the drive."; }
    if (diqV88HasAny(text,["boutique","women's clothing","womens clothing","fashion","vintage","resale"])) { return "A browse-worthy fashion or boutique stop ranked above generic retail."; }
    return "A destination-shopping pick with better local fit than a random nearby store.";
  }
  if (category === "bbq") { return "A barbecue-first pick with real smokehouse, pit, brisket, rib, or regional-style evidence."; }
  if (category === "dog iq") { return "A genuinely dog-friendly stop with park, trail, patio, beach, or access evidenceâ€”not just a pet business."; }
  if (category === "family fun") { return "A real family activity ranked for entertainment value, usefulness, and a worthwhile outing."; }
  if (category === "date night") { return "A date-night fit ranked for atmosphere, conversation, walkability, and what you can do nearby afterward."; }
  if (category === "treats") { return "A dessert-first local stop worth adding for ice cream, bakery, chocolate, or something sweet."; }
  if (category === "sports watch") { return "A game-day venue with sports-bar, watch-party, television, or stadium-district evidence."; }
  if (category === "lake iq") { return "A lake-specific access or experience pick for boating, swimming, fishing, views, or a better day on the water."; }
  if (category === "outdoors") { return "A routeable outdoor experience with real trail, park, preserve, paddling, or recreation value."; }
  if (category === "nightlife") { return "A nightlife-forward pick ranked for energy, format, district context, and late-night usefulness."; }
  return diqV91PriorAdventureWhy(item, query);
};




var diqV91PriorConfidenceLabel = adventureConfidenceLabel;
adventureConfidenceLabel = function(item) {
  var category = categoryFromQuery(activeLens);
  var text = diqV91EvidenceText(item);




  if (category === "shopping" && diqV91IsShoppingDistrict(text)) { return "Shopping District IQ"; }
  if (category === "shopping" && diqV88HasAny(text,["boutique","local shop","vintage","women's clothing","womens clothing"])) { return "Boutique Fit"; }
  if (category === "bbq") { return "BBQ Truth Match"; }
  if (category === "dog iq") { return "Verified Dog-Friendly Fit"; }
  if (category === "family fun") { return "Family Activity Fit"; }
  if (category === "date night") { return "Date Night Fit"; }
  if (category === "treats") { return "Treat IQ Pick"; }
  if (category === "sports watch") { return "Gameday Fit"; }
  if (category === "lake iq") { return "Lake Access IQ"; }
  if (category === "outdoors") { return "Outdoor Adventure Fit"; }
  if (category === "nightlife") { return "Nightlife Fit"; }
  return diqV91PriorConfidenceLabel(item);
};




function diqV91Boot() {
  try {
    console.log("âœ… Drive IQ Adventure V91 Category Excellence IQ loaded", {
      build:window.DRIVE_IQ_ADVENTURE_MODE_BUILD,
      profiles:Object.keys(DIQ_V88_CATEGORY_PROFILES).length,
      market:diqV88MarketClass()
    });
  } catch (e) {}
}








diqV91Boot();








/* =========================================================
   DRIVE IQ V92 â€” OVERLAY AUTHORITY + CHAIN INTENT GUARD




   Rules:
   - VOICE ON only appears on the clean map state.
   - Major chains are valid for explicit brand searches and
     Quick & Convenient intent.
   - Local Favorites, Hidden Gems, Date Night, Worth the Drive,
     and destination-quality city scans protect local discovery.
========================================================= */




window.__DRIVE_IQ_ADVENTURE_MODE_JS_V92_OVERLAY_CHAIN_GUARD__ = true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD = "V92_OVERLAY_AUTHORITY_CHAIN_INTENT";




function diqV92ChainText(item) {
  return normText(
    String(item && item.label || "") + " " +
    String(item && item.full || "") + " " +
    String(item && item.kind || "") + " " +
    String(item && item.category || "") + " " +
    String(item && item.matchLabel || "") + " " +
    String(item && item.description || "")
  );
}




function diqV92IsMajorFoodChain(item) {
  var text = diqV92ChainText(item);
  return diqV88HasAny(text, [
    "domino s","dominos","pizza hut","papa john s","little caesars",
    "mcdonald s","mcdonald","burger king","wendy s","wendy",
    "taco bell","subway","chick fil a","sonic drive in","sonic",
    "arbys","arby s","kfc","popeyes","jack in the box","whataburger",
    "five guys","zaxby s","zaxbys","raising cane s","raising canes",
    "dairy queen","dq grill","hardee s","carls jr","carl s jr",
    "chipotle","panera","jimmy john s","jersey mike s","firehouse subs",
    "applebee s","applebees","chili s","chilis","olive garden",
    "cracker barrel","ihop","denny s","dennys","waffle house",
    "starbucks","dunkin","dunkin donuts"
  ]);
}




function diqV92ExplicitChainIntent(query, item) {
  var q = normText(query);
  var label = normText(item && item.label || "");
  var chainWords = [
    "domino","pizza hut","papa john","little caesars","mcdonald",
    "burger king","wendy","taco bell","subway","chick fil a",
    "sonic","arbys","arby","kfc","popeyes","whataburger","zaxby",
    "raising cane","dairy queen","chipotle","panera","starbucks",
    "dunkin","applebee","chili","olive garden","cracker barrel",
    "ihop","denny","waffle house"
  ];
  var i;




  if (!q) { return false; }
  if (label && q.indexOf(label) > -1) { return true; }




  for (i = 0; i < chainWords.length; i++) {
    if (q.indexOf(chainWords[i]) > -1) { return true; }
  }




  return false;
}




function diqV92ConvenienceIntent(query) {
  var q = normText(query);
  return !!(
    /\b(quick|convenient|fast food|drive thru|drive through|delivery|cheap|closest|nearest|open now|late night|grab and go|takeout|take out)\b/.test(q) ||
    /\b(quick bite|something quick|food nearby now)\b/.test(q)
  );
}




function diqV92ProtectedLocalCategory(query) {
  var category = categoryFromQuery(query);
  var q = normText(query);




  if (
    category === "local favorites" ||
    category === "hidden gems" ||
    category === "date night"
  ) {
    return true;
  }




  return !!(
    /\b(local favorite|local favorites|hidden gem|hidden gems|worth the drive|locally owned|local independent|best local|popular local|date night|romantic)\b/.test(q)
  );
}




function diqV92IsGenericFoodCategory(query) {
  var category = categoryFromQuery(query);
  return category === "food iq" ||
    category === "food drinks" ||
    category === "popular tonight" ||
    category === "bbq" ||
    category === "pizza" ||
    category === "burgers";
}




function diqV92ChainAllowed(item, query) {
  if (!diqV92IsMajorFoodChain(item)) { return true; }
  if (diqV92ExplicitChainIntent(query, item)) { return true; }
  if (diqV92ConvenienceIntent(query)) { return true; }
  if (diqV92ProtectedLocalCategory(query)) { return false; }
  return true;
}




var diqV92PriorFilterExperienceResults = diqV22FilterExperienceResults;
diqV22FilterExperienceResults = function(items, query) {
  var base = diqV92PriorFilterExperienceResults(items || [], query) || [];
  var out = [];
  var i;
  var item;




  for (i = 0; i < base.length; i++) {
    item = base[i];
    if (!item) { continue; }




    if (!diqV92ChainAllowed(item, query)) {
      try {
        console.warn("[Adventure V92 chain guard filtered]", {
          query:query,
          label:item.label,
          category:categoryFromQuery(query)
        });
      } catch (e0) {}
      continue;
    }




    out.push(item);
  }




  return out;
};




var diqV92PriorScoreAdventure = scoreAdventure;
scoreAdventure = function(item, query) {
  var score = diqV92PriorScoreAdventure(item, query);
  var chain = diqV92IsMajorFoodChain(item);
  var explicit = diqV92ExplicitChainIntent(query, item);
  var convenient = diqV92ConvenienceIntent(query);




  if (!chain) { return score; }
  if (!diqV92ChainAllowed(item, query)) { return -9999; }




  if (explicit) { return score + 80; }
  if (convenient) { return score + 22; }




  if (diqV92IsGenericFoodCategory(query)) {
    score -= 240;
  } else {
    score -= 150;
  }




  return score;
};




var diqV92PriorAdventureWorthScore = adventureWorthScore;
adventureWorthScore = function(item, query) {
  var score = Number(diqV92PriorAdventureWorthScore(item, query) || 0);




  if (
    diqV92IsMajorFoodChain(item) &&
    !diqV92ExplicitChainIntent(query, item) &&
    !diqV92ConvenienceIntent(query)
  ) {
    score = Math.min(score, 62);
  }




  return score;
};




var diqV92PriorAdventureWhy = adventureWhy;
adventureWhy = function(item, query) {
  if (diqV92IsMajorFoodChain(item)) {
    if (diqV92ExplicitChainIntent(query, item)) {
      return "A direct match for the brand you requested.";
    }
    if (diqV92ConvenienceIntent(query)) {
      return "A quick and convenient nearby option with low detour.";
    }
    return "A familiar nearby option, ranked below stronger local discovery picks.";
  }




  return diqV92PriorAdventureWhy(item, query);
};




var diqV92PriorConfidenceLabel = adventureConfidenceLabel;
adventureConfidenceLabel = function(item) {
  if (
    diqV92IsMajorFoodChain(item) &&
    !diqV92ExplicitChainIntent(activeScanQuery || activeLens || "", item) &&
    !diqV92ConvenienceIntent(activeScanQuery || activeLens || "")
  ) {
    return "Quick convenience option";
  }




  return diqV92PriorConfidenceLabel(item);
};




function diqV92Visible(el) {
  var style;
  var rect;




  if (!el) { return false; }




  try {
    style = window.getComputedStyle(el);
    if (!style || style.display === "none" || style.visibility === "hidden" || Number(style.opacity) === 0) {
      return false;
    }
    rect = el.getBoundingClientRect();
    return rect.width > 2 && rect.height > 2;
  } catch (e) {
    return false;
  }
}




function diqV92OverlayOpen() {
  var body = document.body;
  var selectors = [
    "#diqAdventureDestResults.on",
    "#diqAdventureDropModal.on",
    "#diqAdventureUpgradeModal.on",
    "#diqAdventurePaywall.on",
    ".diqPlaceIQModal.on",
    ".diqPlaceCardModal.on",
    ".diqAdventureModal.on",
    ".diqAdventureSheet.on",
    ".adventureInfoCard.on",
    ".adventureInfo.on",
    "[data-adventure-overlay].on",
    "[aria-modal='true']"
  ];
  var i;
  var el;




  try {
    if (
      body &&
      (
        body.classList.contains("diqPlaceIQModalOpen") ||
        body.classList.contains("adventureMenuOpen") ||
        body.classList.contains("adventureDropModalOpen") ||
        body.classList.contains("paywallOpen") ||
        body.classList.contains("modal-open")
      )
    ) {
      return true;
    }
  } catch (e0) {}




  if (destinationResultOpen || adventureDropModalOpen) { return true; }




  for (i = 0; i < selectors.length; i++) {
    try {
      el = document.querySelector(selectors[i]);
      if (diqV92Visible(el)) { return true; }
    } catch (e1) {}
  }




  /*
    The large menu is the default blocking panel. In results mode it is
    collapsed and the map is clean; outside results mode, a visible large
    Adventure panel means VOICE ON should stay out of the way.
  */
  try {
    el = document.querySelector(
      "#adventureHorizon:not(.adventureHorizonHidden)," +
      ".adventurePanel.on,.adventurePanel.open,.adventureMenu.on,.adventureMenu.open"
    );
    if (diqV92Visible(el)) { return true; }
  } catch (e2) {}




  return false;
}




function diqV92SyncOverlayAuthority() {
  var btn = byId("diqAdventureVoiceToggle");
  var hide = diqV92OverlayOpen();




  if (!btn) { return; }




  if (hide) {
    btn.classList.add("diqV92OverlayHidden");
    btn.setAttribute("aria-hidden", "true");
    btn.setAttribute("tabindex", "-1");
  } else {
    btn.classList.remove("diqV92OverlayHidden");
    btn.setAttribute("aria-hidden", "false");
    btn.removeAttribute("tabindex");
  }
}




function diqV92InstallOverlayAuthority() {
  var style;
  var observer;




  if (window.__DRIVE_IQ_V92_OVERLAY_AUTHORITY_INSTALLED__) {
    diqV92SyncOverlayAuthority();
    return;
  }




  window.__DRIVE_IQ_V92_OVERLAY_AUTHORITY_INSTALLED__ = true;




  style = document.createElement("style");
  style.id = "diqV92OverlayAuthorityStyle";
  style.type = "text/css";
  style.appendChild(document.createTextNode(
    "#diqAdventureVoiceToggle.diqV92OverlayHidden{" +
      "display:none!important;" +
      "opacity:0!important;" +
      "pointer-events:none!important;" +
      "visibility:hidden!important;" +
    "}"
  ));
  try { document.head.appendChild(style); } catch (e0) {}




  try {
    observer = new MutationObserver(function() {
      window.requestAnimationFrame(diqV92SyncOverlayAuthority);
    });




    /* V514: retired document-wide observer. It reacted to every map pin,
       photo, class, and style mutation after scan completion and could
       saturate WKWebView's main thread. Click/resize/manual sync remains. */
  } catch (e1) {}




  document.addEventListener("click", function() {
    window.setTimeout(diqV92SyncOverlayAuthority, 0);
    window.setTimeout(diqV92SyncOverlayAuthority, 180);
  }, true);




  window.addEventListener("resize", diqV92SyncOverlayAuthority);
  /* V514: retired perpetual overlay polling interval. */




  window.setTimeout(diqV92SyncOverlayAuthority, 50);
  window.setTimeout(diqV92SyncOverlayAuthority, 700);
}




var diqV92PriorEnsureVoiceToggle = diqV86EnsureVoiceToggle;
diqV86EnsureVoiceToggle = function() {
  var btn = diqV92PriorEnsureVoiceToggle.apply(this, arguments);
  window.setTimeout(diqV92SyncOverlayAuthority, 0);
  return btn;
};




diqV92InstallOverlayAuthority();




try {
  console.log("âœ… Drive IQ Adventure V92 Overlay Authority + Chain Intent Guard loaded", {
    build:window.DRIVE_IQ_ADVENTURE_MODE_BUILD,
    rule:"chains for convenience intent; local discovery protects local picks"
  });
} catch (e3) {}








/* =========================================================
   DRIVE IQ V90 â€” FOUNDER-SAFE ADVENTURE REVENUE TRIGGERS




   Rules:
   - Founder/Admin/Plus bypass every Adventure gate.
   - Test as Free User still exercises the complete funnel.
   - First five successful scans are free.
   - Failed scans, empty scans, retries, and duplicate renders never count.
   - Scan 4: gentle reminder after value is delivered.
   - Scan 5: Apple upgrade sheet after results are visible.
   - Scan 6+: hard gate before another premium scan.
   - Unknown native entitlement fails open to prevent accidental lockout.
========================================================= */




window.DRIVE_IQ_ADVENTURE_MODE_BUILD = "V92_OVERLAY_CHAIN_GUARD_REVENUE";
window.__DRIVE_IQ_ADVENTURE_V90_REVENUE_IQ__ = true;




LS.PLUS_ACTIVE = LS.PLUS_ACTIVE || "diq_plus_active_v1";
LS.ADVENTURE_SUCCESSFUL_SCANS = "diq_adventure_successful_scans_v1";
LS.ADVENTURE_REMINDER_SCAN4 = "diq_adventure_reminder_scan4_v1";
LS.ADVENTURE_REMINDER_SCAN5 = "diq_adventure_reminder_scan5_v1";
LS.ADVENTURE_GATE_PENDING = "diq_adventure_gate_pending_v1";
LS.ADVENTURE_LAST_COUNTED_SCAN = "diq_adventure_last_counted_scan_v1";
LS.REVENUE_EVENTS = "diq_revenue_events_v1";




var V90_ADVENTURE_REVENUE = {
  freeSuccessfulScans:5,
  entitlementResolved:false,
  entitlementStatus:"unknown",
  hasFounderAccess:false,
  testAsFreeUser:false,
  effectivePlus:false,
  lastCountedScanKey:"",
  lastSheetAt:0,
  minimumSheetGapMs:45000
};




function diqV90Bool(v){
  if(v === true){ return true; }
  v = String(v || "").toLowerCase();
  return v === "1" || v === "true" || v === "yes" || v === "active" || v === "plus" || v === "premium" || v === "founder" || v === "admin" || v === "lifetime_plus" || v === "founding_member";
}




function diqV90RecordRevenueEvent(type, source, extra){
  var rows = safeParse(lsGet(LS.REVENUE_EVENTS)) || [];
  var row = {
    type:String(type || "event"),
    source:String(source || "adventure"),
    ts:Date.now(),
    scanCount:diqV90SuccessfulScanCount(),
    entitlement:String(V90_ADVENTURE_REVENUE.entitlementStatus || "unknown")
  };
  var k;




  extra = extra || {};
  for(k in extra){
    if(extra.hasOwnProperty(k)){ row[k] = extra[k]; }
  }




  rows.push(row);
  if(rows.length > 150){ rows = rows.slice(rows.length - 150); }
  lsJSON(LS.REVENUE_EVENTS, rows);




  try{
    window.dispatchEvent(new CustomEvent("driveIQRevenueEvent",{ detail:row }));
  }catch(e){}
}




function diqV90ApplyEntitlement(detail){
  detail = detail || {};




  V90_ADVENTURE_REVENUE.entitlementResolved = true;
  V90_ADVENTURE_REVENUE.entitlementStatus = String(detail.status || detail.entitlement || "free").toLowerCase();
  V90_ADVENTURE_REVENUE.hasFounderAccess = diqV90Bool(detail.hasFounderAccess);
  V90_ADVENTURE_REVENUE.testAsFreeUser = diqV90Bool(detail.testAsFreeUser);
  V90_ADVENTURE_REVENUE.effectivePlus = diqV90Bool(detail.effectivePlus);




  try{ window.DRIVE_IQ_ADVENTURE_ENTITLEMENT = detail; }catch(e){}
}




function diqV90RequestEntitlement(){
  try{
    if(window.DRIVE_IQ_NATIVE_ENTITLEMENT){
      diqV90ApplyEntitlement(window.DRIVE_IQ_NATIVE_ENTITLEMENT);
    }
  }catch(e1){}




  try{
    if(window.DriveIQNative && typeof window.DriveIQNative.getEntitlement === "function"){
      window.DriveIQNative.getEntitlement();
      return true;
    }
  }catch(e2){}




  return false;
}




try{
  window.addEventListener("driveIQEntitlementChanged",function(ev){
    diqV90ApplyEntitlement(ev && ev.detail ? ev.detail : {});
  });
}catch(e0){}




function diqV90PlusIsActive(){
  var localPlus = diqV90Bool(lsGet(LS.PLUS_ACTIVE));
  var status = String(V90_ADVENTURE_REVENUE.entitlementStatus || "").toLowerCase();




  /* Test-as-free intentionally overrides founder/plus for QA. */
  if(V90_ADVENTURE_REVENUE.testAsFreeUser){ return false; }




  if(V90_ADVENTURE_REVENUE.effectivePlus){ return true; }
  if(status === "founder" || status === "admin" || status === "lifetime_plus" || status === "founding_member"){ return true; }
  if(localPlus){ return true; }




  try{
    if(window.driveIQSubscription && (window.driveIQSubscription.active === true || window.driveIQSubscription.isPlus === true)){
      return true;
    }
  }catch(e1){}




  return false;
}




function diqV90CanHardGate(){
  /* Unknown entitlement fails open so Matthew can never be locked out. */
  if(!V90_ADVENTURE_REVENUE.entitlementResolved){
    diqV90RequestEntitlement();
    return false;
  }




  if(V90_ADVENTURE_REVENUE.hasFounderAccess && !V90_ADVENTURE_REVENUE.testAsFreeUser){ return false; }
  if(diqV90PlusIsActive()){ return false; }
  return true;
}




function diqV90SuccessfulScanCount(){
  var n = Number(lsGet(LS.ADVENTURE_SUCCESSFUL_SCANS) || 0);
  if(!finite(n) || n < 0){ n = 0; }
  return Math.floor(n);
}




function diqV90ScanKey(){
  var started = Number(activeScanStartedAt || 0);
  var names = [];
  var i;




  for(i=0;i<Math.min(3,(adventureResults || []).length);i++){
    names.push(normText((adventureResults[i] && (adventureResults[i].label || adventureResults[i].name)) || ""));
  }




  return String(started || 0) + "|" + normText(activeScanQuery || activeLens || "") + "|" + names.join("|");
}




function diqV90IsSuccessfulScan(){
  var items = adventureResults || [];
  var i;
  var item;




  if(!items.length){ return false; }
  if(!activeScanStartedAt){ return false; }




  for(i=0;i<items.length;i++){
    item = items[i];
    if(item && !item.categoryTruthRejected && finite(Number(item.lat)) && finite(Number(item.lng))){
      return true;
    }
  }




  return false;
}




function diqV90PresentUpgradeSheet(reason, isGate){
  var now = Date.now();
  var payload;




  if(diqV90PlusIsActive()){ return false; }
  if(now - Number(V90_ADVENTURE_REVENUE.lastSheetAt || 0) < Number(V90_ADVENTURE_REVENUE.minimumSheetGapMs || 45000)){
    return false;
  }




  V90_ADVENTURE_REVENUE.lastSheetAt = now;
  payload = {
    action:"presentUpgradeSheet",
    reason:String(reason || "adventure_scan_success"),
    source:String(reason || "adventure_scan_success"),
    isGate:!!isGate,
    mode:"adventure",
    successfulScans:diqV90SuccessfulScanCount(),
    timestamp:now
  };




  diqV90RecordRevenueEvent("paywall_viewed",payload.source,{ isGate:!!isGate });




  try{
    if(window.DriveIQNative && typeof window.DriveIQNative.presentUpgradeSheet === "function"){
      window.DriveIQNative.presentUpgradeSheet(payload);
      diqV90RecordRevenueEvent("apple_sheet_requested",payload.source,{ isGate:!!isGate });
      return true;
    }
  }catch(e1){}




  try{
    lsJSON(LS.UPGRADE_INTENT,payload);
    lsJSON(LS.ADVENTURE_GATE_PENDING,payload);
  }catch(e2){}




  toast(isGate ? "Drive IQ Plus keeps unlimited Adventure scans active" : "Keep unlimited Adventure scans with Drive IQ Plus");
  return false;
}




function diqV90HandleSuccessfulScan(){
  var key;
  var previousKey;
  var count;




  if(!diqV90IsSuccessfulScan()){ return; }




  key = diqV90ScanKey();
  previousKey = String(lsGet(LS.ADVENTURE_LAST_COUNTED_SCAN) || V90_ADVENTURE_REVENUE.lastCountedScanKey || "");
  if(!key || key === previousKey){ return; }




  V90_ADVENTURE_REVENUE.lastCountedScanKey = key;
  lsSet(LS.ADVENTURE_LAST_COUNTED_SCAN,key);




  /* Founder/Plus sessions never consume allowance unless Test-as-Free is active. */
  if(diqV90PlusIsActive()){
    diqV90RecordRevenueEvent("adventure_scan_success","adventure_scan_success",{ counted:false, bypass:true });
    return;
  }




  count = diqV90SuccessfulScanCount() + 1;
  lsSet(LS.ADVENTURE_SUCCESSFUL_SCANS,count);
  diqV90RecordRevenueEvent("adventure_scan_success","adventure_scan_success",{ counted:true, newCount:count });




  if(count === 4 && !lsGet(LS.ADVENTURE_REMINDER_SCAN4)){
    lsSet(LS.ADVENTURE_REMINDER_SCAN4,"1");
    toast("One free Adventure scan remains");
    diqV90RecordRevenueEvent("paywall_reminder","adventure_scan_4_reminder",{ remaining:1 });
  }




  if(count === 5 && !lsGet(LS.ADVENTURE_REMINDER_SCAN5)){
    lsSet(LS.ADVENTURE_REMINDER_SCAN5,"1");
    window.setTimeout(function(){
      diqV90PresentUpgradeSheet("adventure_scan_5_final_free",false);
    },900);
  }
}




var diqV90PriorRenderAdventureResults = renderAdventureResults;
renderAdventureResults = function(){
  var result = diqV90PriorRenderAdventureResults.apply(this,arguments);
  window.setTimeout(diqV90HandleSuccessfulScan,250);
  return result;
};




var diqV90PriorScanAdventureChoices = scanAdventureChoices;
scanAdventureChoices = function(query){
  var count = diqV90SuccessfulScanCount();




  if(diqV90CanHardGate() && count >= Number(V90_ADVENTURE_REVENUE.freeSuccessfulScans || 5)){
    lsJSON(LS.ADVENTURE_GATE_PENDING,{
      source:"adventure_scan_6_gate",
      query:String(query || ""),
      successfulScans:count,
      ts:Date.now()
    });
    diqV90RecordRevenueEvent("scan_blocked","adventure_scan_6_gate",{ query:String(query || "") });
    diqV90PresentUpgradeSheet("adventure_scan_6_gate",true);
    return false;
  }




  return diqV90PriorScanAdventureChoices.apply(this,arguments);
};




try{
  window.addEventListener("driveIQUpgradeSheetResult",function(ev){
    var detail = ev && ev.detail ? ev.detail : {};
    diqV90RecordRevenueEvent(
      detail.status === "cancelled" ? "paywall_dismissed" : "paywall_result",
      detail.reason || "adventure",
      { status:detail.status || "unknown" }
    );
  });




  window.addEventListener("driveIQIAPResult",function(ev){
    var detail = ev && ev.detail ? ev.detail : {};
    var status = String(detail.status || "").toLowerCase();
    var type = status === "success" || status === "restored" || status === "founder_bypass"
      ? "purchase_completed"
      : (status === "cancelled" ? "purchase_cancelled" : "purchase_failed");




    diqV90RecordRevenueEvent(type,"adventure_iap",{ status:status });




    if(type === "purchase_completed"){
      lsSet(LS.PLUS_ACTIVE,"1");
      lsRemove(LS.ADVENTURE_GATE_PENDING);
    }
  });
}catch(e3){}




window.DriveIQAdventureRevenue = {
  status:function(){
    return {
      successfulScans:diqV90SuccessfulScanCount(),
      freeLimit:V90_ADVENTURE_REVENUE.freeSuccessfulScans,
      entitlementResolved:V90_ADVENTURE_REVENUE.entitlementResolved,
      entitlementStatus:V90_ADVENTURE_REVENUE.entitlementStatus,
      founder:V90_ADVENTURE_REVENUE.hasFounderAccess,
      testAsFreeUser:V90_ADVENTURE_REVENUE.testAsFreeUser,
      effectivePlus:diqV90PlusIsActive()
    };
  },
  refreshEntitlement:diqV90RequestEntitlement,
  showPaywall:function(){ return diqV90PresentUpgradeSheet("adventure_manual_upgrade",false); }
};




window.setTimeout(diqV90RequestEntitlement,250);
window.setTimeout(diqV90RequestEntitlement,1400);




try{
  console.log("âœ… Drive IQ Adventure V90 Founder-Safe Revenue Triggers loaded",window.DriveIQAdventureRevenue.status());
}catch(e4){}




/* =========================================================
   DRIVE IQ V93 â€” VERIFIED OVERLAY + FINAL FOOD RESULT AUTHORITY




   Verified live-path fixes:
   - Binds VOICE ON directly to the real Place IQ card id and its
     actual open/close functions instead of guessing modal selectors.
   - Applies chain intent protection to the final adventureResults and
     exploreResults arrays immediately before the live render path.
   - Generic Food IQ is local-discovery-first: major national chains are
     excluded unless the user explicitly requests the brand or asks for
     quick/convenient/nearest/delivery/late-night food.
   ES5-safe. No HTML changes.
========================================================= */




window.__DRIVE_IQ_ADVENTURE_MODE_JS_V93_VERIFIED_AUTHORITY__ = true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD = "V93_VERIFIED_OVERLAY_FINAL_FOOD_AUTHORITY";




function diqV93ActiveQuery(query) {
  return clean(query || activeScanQuery || activeLens || "");
}




function diqV93IsFoodDiscovery(query) {
  var q = normText(diqV93ActiveQuery(query));
  var cat = categoryFromQuery(q);




  if (cat === "food iq" || cat === "food drinks") { return true; }




  return !!(
    q.indexOf("food iq") > -1 ||
    q.indexOf("must try food") > -1 ||
    q.indexOf("local restaurants") > -1 ||
    q.indexOf("best restaurants") > -1 ||
    q.indexOf("signature dishes") > -1
  );
}




function diqV93ChainMayAppear(item, query) {
  var q = diqV93ActiveQuery(query);




  if (!diqV92IsMajorFoodChain(item)) { return true; }
  if (diqV92ExplicitChainIntent(q, item)) { return true; }
  if (diqV92ConvenienceIntent(q)) { return true; }




  /* Local-discovery food scans never surface common chains. */
  if (diqV93IsFoodDiscovery(q)) { return false; }
  if (diqV92ProtectedLocalCategory(q)) { return false; }




  return true;
}




function diqV93FinalFoodGuard(items, query) {
  var source = items || [];
  var out = [];
  var i;
  var item;




  for (i = 0; i < source.length; i++) {
    item = source[i];
    if (!item) { continue; }




    if (!diqV93ChainMayAppear(item, query)) {
      try {
        console.warn("[Adventure V93 final chain removal]", {
          query:diqV93ActiveQuery(query),
          label:item.label || item.name || "chain",
          stage:"final_result_array"
        });
      } catch (e0) {}
      continue;
    }




    out.push(item);
  }




  return out;
}




function diqV93ApplyFinalFoodAuthority(query) {
  var q = diqV93ActiveQuery(query);




  adventureResults = diqV93FinalFoodGuard(adventureResults || [], q);
  exploreResults = diqV93FinalFoodGuard(exploreResults || [], q);




  if (adventurePreferred && !diqV93ChainMayAppear(adventurePreferred, q)) {
    adventurePreferred = adventureResults.length ? adventureResults[0] : null;
  }
}




/* Final render boundary: no alternate scoring or cached array can bypass it. */
var diqV93PriorRenderAdventureResults = renderAdventureResults;
renderAdventureResults = function () {
  diqV93ApplyFinalFoodAuthority(activeScanQuery || activeLens || "");
  return diqV93PriorRenderAdventureResults.apply(this, arguments);
};




/* Result shelf boundary: protects direct render calls as well. */
var diqV93PriorRenderAdventureScanChoices = renderAdventureScanChoices;
renderAdventureScanChoices = function (items, query) {
  var q = diqV93ActiveQuery(query);
  var guarded = diqV93FinalFoodGuard(items || [], q);
  return diqV93PriorRenderAdventureScanChoices(guarded, query);
};




function diqV93RealOverlayOpen() {
  var card = byId("diqAdventureInfoCard");
  var destinationPanel = byId("diqAdventureDestResults");
  var dropModal = byId("diqAdventureDropModal");
  var body = document.body;




  try {
    if (card && /(^|\s)on(\s|$)/.test(String(card.className || ""))) { return true; }
    if (destinationPanel && /(^|\s)on(\s|$)/.test(String(destinationPanel.className || ""))) { return true; }
    if (dropModal && /(^|\s)on(\s|$)/.test(String(dropModal.className || ""))) { return true; }
    if (destinationResultOpen || adventureDropModalOpen) { return true; }
    if (body && body.classList && body.classList.contains("adventureMenuOpen")) { return true; }
  } catch (e0) {}




  return diqV92OverlayOpen();
}




function diqV93SyncVoiceOverlay() {
  var btn = byId("diqAdventureVoiceToggle");
  var hide;




  if (!btn) { return; }
  hide = diqV93RealOverlayOpen();




  if (hide) {
    btn.style.setProperty("display", "none", "important");
    btn.style.setProperty("visibility", "hidden", "important");
    btn.style.setProperty("pointer-events", "none", "important");
    btn.setAttribute("aria-hidden", "true");
    btn.setAttribute("tabindex", "-1");
  } else {
    btn.style.removeProperty("display");
    btn.style.removeProperty("visibility");
    btn.style.removeProperty("pointer-events");
    btn.setAttribute("aria-hidden", "false");
    btn.removeAttribute("tabindex");
  }
}




/* Bind directly to the actual Place IQ open/close authorities. */
var diqV93PriorOpenAdventureInfoCard = openAdventureInfoCard;
openAdventureInfoCard = function (item, preserveBrowseCamera) {
  var result = diqV93PriorOpenAdventureInfoCard.apply(this, arguments);
  diqV93SyncVoiceOverlay();
  window.setTimeout(diqV93SyncVoiceOverlay, 0);
  window.setTimeout(diqV93SyncVoiceOverlay, 120);
  return result;
};




var diqV93PriorCloseAdventureInfoCard = closeAdventureInfoCard;
closeAdventureInfoCard = function () {
  var result = diqV93PriorCloseAdventureInfoCard.apply(this, arguments);
  window.setTimeout(diqV93SyncVoiceOverlay, 0);
  window.setTimeout(diqV93SyncVoiceOverlay, 120);
  return result;
};




var diqV93PriorRenderDestinationResults = renderDestinationResults;
renderDestinationResults = function (results, query) {
  var result = diqV93PriorRenderDestinationResults.apply(this, arguments);
  diqV93SyncVoiceOverlay();
  return result;
};




var diqV93PriorHideDestinationResults = hideDestinationResults;
hideDestinationResults = function () {
  var result = diqV93PriorHideDestinationResults.apply(this, arguments);
  window.setTimeout(diqV93SyncVoiceOverlay, 0);
  return result;
};




/* V514: retired V93 document-wide MutationObserver and 300ms poll.
   They repeatedly scanned the full DOM while pins/photos/cards were painting,
   which could freeze the post-scan UI in WKWebView. */
window.setTimeout(diqV93SyncVoiceOverlay, 50);
window.setTimeout(diqV93SyncVoiceOverlay, 700);




try {
  console.log("âœ… Drive IQ Adventure V93 verified authority loaded", {
    build:window.DRIVE_IQ_ADVENTURE_MODE_BUILD,
    overlay:"#diqAdventureInfoCard.on",
    foodRule:"chains only by explicit or convenience intent"
  });
} catch (e2) {}








/* =========================================================
   DRIVE IQ V94 â€” CANONICAL FOOD RESULT AUTHORITY




   Surgical live-path fix:
   - Captures the user's real scan intent before provider query expansion.
   - Removes major national food chains before V73 canonical results commit.
   - Therefore V77 canonical pins, the result shelf, Place IQ cards, and the
     SHOW PICKS count all receive the same protected local-first result set.
   - Explicit brand and Quick & Convenient intent remain allowed.
   ES5-safe. No HTML changes.
========================================================= */




window.__DRIVE_IQ_ADVENTURE_MODE_JS_V94_CANONICAL_FOOD_AUTHORITY__ = true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD = "V94_CANONICAL_FOOD_RESULT_AUTHORITY";




var diqV94ScanIntentQuery = "";




function diqV94IntentQuery(query) {
  return clean(
    query ||
    diqV94ScanIntentQuery ||
    activeScanQuery ||
    activeLens ||
    ""
  );
}




function diqV94IsLocalFoodDiscovery(query) {
  var q = normText(diqV94IntentQuery(query));
  var category = categoryFromQuery(q);




  if (
    category === "food iq" ||
    category === "food drinks" ||
    category === "local favorites" ||
    category === "hidden gems" ||
    category === "date night"
  ) {
    return true;
  }




  return !!(
    q === "food" ||
    q === "restaurants" ||
    q.indexOf("food iq") > -1 ||
    q.indexOf("local restaurant") > -1 ||
    q.indexOf("best restaurant") > -1 ||
    q.indexOf("worth the drive") > -1 ||
    q.indexOf("local favorite") > -1 ||
    q.indexOf("hidden gem") > -1 ||
    q.indexOf("date night") > -1
  );
}




function diqV94ChainIsAllowed(item, query) {
  var q = diqV94IntentQuery(query);




  if (!diqV92IsMajorFoodChain(item)) { return true; }
  if (diqV92ExplicitChainIntent(q, item)) { return true; }
  if (diqV92ConvenienceIntent(q)) { return true; }




  if (diqV94IsLocalFoodDiscovery(q)) { return false; }
  if (diqV92ProtectedLocalCategory(q)) { return false; }




  return true;
}




function diqV94FilterCanonicalFood(items, query, stage) {
  var source = items || [];
  var out = [];
  var i;
  var item;
  var q = diqV94IntentQuery(query);




  for (i = 0; i < source.length; i++) {
    item = source[i];
    if (!item) { continue; }




    if (!diqV94ChainIsAllowed(item, q)) {
      try {
        console.warn("[Adventure V94 canonical chain removal]", {
          stage:String(stage || "canonical"),
          query:q,
          label:item.label || item.name || "chain"
        });
      } catch (e0) {}
      continue;
    }




    out.push(item);
  }




  return out;
}




/* Capture the user's category request before any broad-pull/provider query
   replaces activeScanQuery with expanded search vocabulary. */
var diqV94PriorScanAdventureChoices = scanAdventureChoices;
scanAdventureChoices = function (query) {
  diqV94ScanIntentQuery = clean(query || activeLens || "");
  return diqV94PriorScanAdventureChoices.apply(this, arguments);
};




/* This is the real upstream authority. V77 commits canonical map pins from
   this function, so filtering here protects pins, shelves, cards, and counts. */
var diqV94PriorV73SetCanonicalResults = diqV73SetCanonicalResults;
diqV73SetCanonicalResults = function (items, query) {
  var q = diqV94IntentQuery(query);
  var guarded = diqV94FilterCanonicalFood(
    items || [],
    q,
    "before_v73_canonical_commit"
  );




  return diqV94PriorV73SetCanonicalResults(
    guarded,
    q
  );
};




/* Last-resort low-level protection for alternate render paths. This does not
   merely hide a label; it prevents a rejected chain from becoming a map pin. */
var diqV94PriorRenderResultPins = renderResultPins;
renderResultPins = function (items, preferred) {
  var q = diqV94IntentQuery("");
  var guarded = diqV94FilterCanonicalFood(
    items || [],
    q,
    "renderResultPins"
  );
  var safePreferred = preferred;




  if (safePreferred && !diqV94ChainIsAllowed(safePreferred, q)) {
    safePreferred = guarded.length ? guarded[0] : null;
  }




  /* Keep every public/cached authority synchronized before V77 evaluates
     whether the attempted set matches its canonical pin set. */
  adventureResults = guarded.slice(0);
  if (typeof diqV73CanonicalResults !== "undefined") {
    diqV73CanonicalResults = guarded.slice(0);
  }
  try {
    window.DRIVE_IQ_CANONICAL_ADVENTURE_RESULTS = guarded.slice(0);
  } catch (e0) {}




  return diqV94PriorRenderResultPins(
    guarded,
    safePreferred
  );
};




/* Shelf boundary for direct renders that do not pass back through V73. */
var diqV94PriorRenderAdventureScanChoices = renderAdventureScanChoices;
renderAdventureScanChoices = function (items, query) {
  var q = diqV94IntentQuery(query);
  var guarded = diqV94FilterCanonicalFood(
    items || [],
    q,
    "result_shelf"
  );




  adventureResults = guarded.slice(0);
  return diqV94PriorRenderAdventureScanChoices(
    guarded,
    q
  );
};




try {
  console.log("âœ… Drive IQ Adventure V94 canonical food authority loaded", {
    build:window.DRIVE_IQ_ADVENTURE_MODE_BUILD,
    authority:"before V73/V77 canonical commit",
    rule:"generic Food IQ removes national chains; explicit/convenience intent allows them"
  });
} catch (e1) {}












/* =========================================================
   DRIVE IQ V96 â€” PLACE IQ V1 + CATEGORY SCAN AUTHORITY




   Goals:
   - Place IQ card hierarchy:
     Place name -> Worth the Drive -> Google rating evidence -> chips ->
     Why it is worth the drive -> facts -> Route Here.
   - Hide Voice button while Place IQ is open.
   - Add Scan Again Near Me CTA.
   - Strengthen category intent so Food, Coffee, Golf, Shopping, Outdoors,
     Family, Dog Friendly, Nightlife, Local Favorites, etc. do not collapse
     into water-style searches.
   ES5-safe. No HTML changes.
========================================================= */




window.__DRIVE_IQ_ADVENTURE_MODE_JS_V96_PLACEIQ_CATEGORY_AUTHORITY__ = true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD = "V96_PLACEIQ_CATEGORY_AUTHORITY";




var diqV96PriorCategoryFromQuery = categoryFromQuery;
categoryFromQuery = function(query) {
  var q = normText(query);
  var cat = "";




  if (!q) { return ""; }




  /* Brand/category words with high intent must win before broad water/scenic text. */
  if (
    q.indexOf("golf") > -1 ||
    q.indexOf("driving range") > -1 ||
    q.indexOf("country club") > -1 ||
    q.indexOf("links") > -1
  ) { return "golf"; }




  if (
    q.indexOf("dog friendly") > -1 ||
    q.indexOf("pet friendly") > -1 ||
    q.indexOf("dog patio") > -1 ||
    q.indexOf("dog park") > -1 ||
    q.indexOf("pet patio") > -1
  ) { return "dog friendly"; }




  if (
    q.indexOf("family") > -1 ||
    q.indexOf("kids") > -1 ||
    q.indexOf("children") > -1 ||
    q.indexOf("playground") > -1 ||
    q.indexOf("family fun") > -1
  ) { return "family"; }




  if (
    q.indexOf("date night") > -1 ||
    q.indexOf("romantic") > -1 ||
    q.indexOf("cocktail") > -1 ||
    q.indexOf("dinner date") > -1
  ) { return "date night"; }




  if (
    q.indexOf("coffee") > -1 ||
    q.indexOf("cafe") > -1 ||
    q.indexOf("cafÃ©") > -1 ||
    q.indexOf("espresso") > -1 ||
    q.indexOf("latte") > -1 ||
    q.indexOf("roaster") > -1 ||
    q.indexOf("coffee shop") > -1
  ) { return "coffee iq"; }




  if (
    q.indexOf("food iq") > -1 ||
    q.indexOf("food") > -1 ||
    q.indexOf("restaurant") > -1 ||
    q.indexOf("restaurants") > -1 ||
    q.indexOf("local food") > -1 ||
    q.indexOf("must try") > -1 ||
    q.indexOf("must-try") > -1 ||
    q.indexOf("viral food") > -1 ||
    q.indexOf("bbq") > -1 ||
    q.indexOf("barbecue") > -1 ||
    q.indexOf("burger") > -1 ||
    q.indexOf("taco") > -1 ||
    q.indexOf("pizza") > -1 ||
    q.indexOf("seafood") > -1 ||
    q.indexOf("breakfast") > -1 ||
    q.indexOf("brunch") > -1 ||
    q.indexOf("dessert") > -1 ||
    q.indexOf("ice cream") > -1 ||
    q.indexOf("bakery") > -1 ||
    q.indexOf("donut") > -1 ||
    q.indexOf("doughnut") > -1
  ) { return "food iq"; }




  if (
    q.indexOf("local fave") > -1 ||
    q.indexOf("local faves") > -1 ||
    q.indexOf("local favorite") > -1 ||
    q.indexOf("local favorites") > -1 ||
    q.indexOf("locals favorite") > -1 ||
    q.indexOf("locals favorites") > -1 ||
    q.indexOf("local hangout") > -1 ||
    q.indexOf("local hangouts") > -1 ||
    q.indexOf("where locals go") > -1 ||
    q.indexOf("local picks") > -1 ||
    q.indexOf("neighborhood favorite") > -1
  ) { return "local favorites"; }




  if (
    q.indexOf("live music") > -1 ||
    q.indexOf("music venue") > -1 ||
    q.indexOf("concert") > -1 ||
    q.indexOf("band") > -1 ||
    q.indexOf("acoustic") > -1 ||
    q.indexOf("jazz") > -1 ||
    q.indexOf("karaoke") > -1 ||
    q.indexOf("open mic") > -1
  ) { return "live music"; }




  if (
    q.indexOf("nightlife") > -1 ||
    q.indexOf("popular tonight") > -1 ||
    q.indexOf("happening") > -1 ||
    q.indexOf("trending") > -1 ||
    q.indexOf("sports bar") > -1 ||
    q.indexOf("gameday") > -1 ||
    q.indexOf("watch game") > -1
  ) { return "popular tonight"; }




  if (
    q.indexOf("shopping") > -1 ||
    q.indexOf("boutique") > -1 ||
    q.indexOf("local shops") > -1 ||
    q.indexOf("antique") > -1 ||
    q.indexOf("vintage") > -1 ||
    q.indexOf("outlet") > -1 ||
    q.indexOf("home decor") > -1 ||
    q.indexOf("gift shop") > -1 ||
    q.indexOf("bookstore") > -1 ||
    q.indexOf("farmers market") > -1 ||
    q.indexOf("market") > -1
  ) { return "shopping"; }




  if (
    q.indexOf("camp") > -1 ||
    q.indexOf("camping") > -1 ||
    q.indexOf("rv") > -1 ||
    q.indexOf("koa") > -1 ||
    q.indexOf("campground") > -1
  ) { return "camping"; }




  if (
    q.indexOf("trail") > -1 ||
    q.indexOf("hiking") > -1 ||
    q.indexOf("outdoor") > -1 ||
    q.indexOf("outdoors") > -1 ||
    q.indexOf("greenway") > -1 ||
    q.indexOf("nature trail") > -1
  ) { return "trails"; }




  if (
    q.indexOf("park") > -1 ||
    q.indexOf("preserve") > -1 ||
    q.indexOf("recreation area") > -1
  ) { return "parks"; }




  if (
    q.indexOf("scenic") > -1 ||
    q.indexOf("overlook") > -1 ||
    q.indexOf("lookout") > -1 ||
    q.indexOf("viewpoint") > -1 ||
    q.indexOf("sunset view") > -1
  ) { return "scenic"; }




  if (
    q.indexOf("hidden") > -1 ||
    q.indexOf("gem") > -1 ||
    q.indexOf("unique") > -1 ||
    q.indexOf("landmark") > -1
  ) { return "hidden gems"; }




  if (
    q.indexOf("patio") > -1 ||
    q.indexOf("outside dining") > -1 ||
    q.indexOf("outdoor seating") > -1 ||
    q.indexOf("outdoor dining") > -1 ||
    q.indexOf("al fresco") > -1 ||
    q.indexOf("alfresco") > -1 ||
    q.indexOf("terrace") > -1 ||
    q.indexOf("courtyard") > -1 ||
    q.indexOf("beer garden") > -1 ||
    q.indexOf("fire pit") > -1
  ) { return "patio vibes"; }




  /* Water only wins when the request is explicitly water-oriented. */
  if (
    q.indexOf("waterfront") > -1 ||
    q.indexOf("water front") > -1 ||
    q.indexOf("marina") > -1 ||
    q.indexOf("lakefront") > -1 ||
    q.indexOf("riverfront") > -1 ||
    q.indexOf("beach bar") > -1 ||
    q.indexOf("riverwalk") > -1 ||
    q.indexOf("dockside") > -1 ||
    q.indexOf("water view") > -1
  ) { return "waterfront"; }




  if (
    q.indexOf("waterfall") > -1 ||
    q.indexOf("falls") > -1
  ) { return "waterfalls"; }




  if (
    q.indexOf("water access") > -1 ||
    q.indexOf("beach") > -1 ||
    q.indexOf("lake") > -1 ||
    q.indexOf("river") > -1 ||
    q.indexOf("shore") > -1 ||
    q.indexOf("boat") > -1 ||
    q.indexOf("pier") > -1
  ) { return "water"; }




  try { cat = diqV96PriorCategoryFromQuery(query); } catch (e0) { cat = ""; }
  return cat || "";
};




var diqV96PriorGenericAdventureRadius = genericAdventureRadius;
genericAdventureRadius = function(query) {
  var type = categoryFromQuery(query);
  if (type === "golf") { return 45; }
  if (type === "family") { return 22; }
  if (type === "dog friendly") { return 22; }
  if (type === "date night") { return 24; }
  if (type === "shopping") { return 24; }
  try { return diqV96PriorGenericAdventureRadius(query); } catch (e0) {}
  return 24;
};




function diqV96CitySuffix() {
  var city = "";
  try { city = destinationTermSuffix(); } catch (e0) { city = ""; }
  return clean(city || "");
}




function diqV96AddUnique(list, value) {
  var v = clean(value);
  var n = normText(v);
  var i;
  if (!v || !n) { return; }
  for (i = 0; i < list.length; i++) {
    if (normText(list[i]) === n) { return; }
  }
  list.push(v);
}




var diqV96PriorBuildAdventureQueries = buildAdventureQueries;
buildAdventureQueries = function(query) {
  var out = [];
  var base = [];
  var cat = categoryFromQuery(query);
  var city = diqV96CitySuffix();
  var i;




  try { base = diqV96PriorBuildAdventureQueries(query) || []; } catch (e0) { base = []; }
  for (i = 0; i < base.length; i++) { diqV96AddUnique(out, base[i]); }




  function add(v) { diqV96AddUnique(out, v + city); }
  function addRaw(v) { diqV96AddUnique(out, v); }




  if (cat === "golf") {
    add("golf course");
    add("public golf course");
    add("country club");
    add("golf club");
    add("driving range");
    add("indoor golf");
    add("golf simulator");
    add("mini golf");
  } else if (cat === "coffee iq") {
    add("coffee shop");
    add("local coffee shop");
    add("cafe");
    add("espresso bar");
    add("coffee roaster");
    add("bakery cafe");
    add("breakfast cafe");
    add("independent coffee");
  } else if (cat === "food iq" || cat === "food drinks") {
    add("local restaurant");
    add("local favorite restaurant");
    add("best restaurant");
    add("bbq restaurant");
    add("burger restaurant");
    add("taco restaurant");
    add("pizza restaurant");
    add("seafood restaurant");
    add("breakfast restaurant");
    add("brunch restaurant");
    add("dessert");
    add("ice cream");
    add("bakery");
    add("food truck");
    add("hidden gem restaurant");
  } else if (cat === "family") {
    add("family friendly restaurant");
    add("family fun");
    add("kids activities");
    add("ice cream");
    add("park");
    add("playground");
    add("bowling");
    add("arcade");
    add("museum");
    add("family attraction");
  } else if (cat === "dog friendly") {
    add("dog friendly patio");
    add("pet friendly patio");
    add("dog friendly restaurant");
    add("dog park");
    add("pet friendly trail");
    add("dog friendly brewery");
    add("dog friendly coffee");
  } else if (cat === "date night") {
    add("date night restaurant");
    add("romantic restaurant");
    add("cocktail bar");
    add("rooftop restaurant");
    add("wine bar");
    add("dinner restaurant");
    add("dessert");
    add("live music restaurant");
  } else if (cat === "shopping") {
    add("boutique");
    add("local shops");
    add("shopping district");
    add("antique store");
    add("vintage shop");
    add("gift shop");
    add("bookstore");
    add("farmers market");
    add("artisan market");
  } else if (cat === "trails" || cat === "parks" || cat === "scenic" || cat === "hidden gems") {
    add("park");
    add("nature trail");
    add("hiking trail");
    add("scenic overlook");
    add("outdoor recreation area");
    add("nature preserve");
    add("local attraction");
    if (cat === "hidden gems") {
      add("hidden gem");
      add("unique local places");
      add("historic landmark");
    }
  } else if (cat === "popular tonight" || cat === "live music") {
    add("live music tonight");
    add("bar and grill");
    add("brewery");
    add("cocktail bar");
    add("sports bar");
    add("nightlife");
    add("event venue");
    add("restaurant open now");
  } else if (cat === "local favorites") {
    add("local favorite restaurant");
    add("locally owned restaurant");
    add("coffee shop");
    add("brewery");
    add("park");
    add("family fun");
    add("boutique");
    add("local attraction");
    add("town square");
    add("downtown");
  }




  if (out.length < 18) {
    add("local favorite restaurant");
    add("coffee shop");
    add("park");
    add("local attraction");
  }




  /* When scanning a destination, also keep a few un-suffixed category terms.
     Geoapify proximity bias already anchors the search center. */
  if (city) {
    addRaw(clean(query));
  }




  return out.slice(0, 64);
};




function diqV96ItemText(item) {
  return normText(
    String(item && item.label || "") + " " +
    String(item && item.full || "") + " " +
    String(item && item.kind || "") + " " +
    String(item && item.placeCategories || "") + " " +
    String(item && item.placeClass || "") + " " +
    String(item && item.adventureCategory || "") + " " +
    String(item && item.matchLabel || "")
  );
}




function diqV96HasAny(text, arr) {
  var i;
  for (i = 0; i < arr.length; i++) {
    if (text.indexOf(arr[i]) > -1) { return true; }
  }
  return false;
}




var diqV96PriorStrictAdventureCategoryMatch = isStrictAdventureCategoryMatch;
isStrictAdventureCategoryMatch = function(item, query) {
  var cat = categoryFromQuery(query);
  var txt = diqV96ItemText(item);




  if (!cat) {
    try { return diqV96PriorStrictAdventureCategoryMatch(item, query); } catch (e0) {}
    return true;
  }




  if (cat === "golf") {
    return diqV96HasAny(txt, ["golf", "golf course", "country club", "driving range", "links", "mini golf", "simulator"]);
  }




  if (cat === "coffee iq") {
    return diqV96HasAny(txt, ["coffee", "cafe", "cafÃ©", "espresso", "latte", "roaster", "bakery"]) &&
      !diqV96HasAny(txt, ["smoothie", "juice bar", "nutrition club", "gas station"]);
  }




  if (cat === "family") {
    return diqV96HasAny(txt, ["family", "kids", "children", "playground", "park", "museum", "arcade", "bowling", "ice cream", "zoo", "attraction", "restaurant"]);
  }




  if (cat === "dog friendly") {
    return diqV96HasAny(txt, ["dog", "pet", "park", "trail", "patio", "brewery", "restaurant", "coffee", "cafe"]);
  }




  if (cat === "date night") {
    return diqV96HasAny(txt, ["restaurant", "cocktail", "wine", "bar", "rooftop", "romantic", "dinner", "dessert", "live music", "bistro", "steak", "seafood"]);
  }




  if (cat === "shopping") {
    return diqV96HasAny(txt, ["shop", "boutique", "shopping", "market", "antique", "vintage", "gift", "bookstore", "store", "retail", "mall"]);
  }




  if (cat === "trails") {
    return diqV96HasAny(txt, ["trail", "hiking", "greenway", "park", "nature", "recreation", "preserve"]);
  }




  if (cat === "parks") {
    return diqV96HasAny(txt, ["park", "preserve", "recreation", "playground", "nature", "greenway"]);
  }




  if (cat === "scenic" || cat === "hidden gems") {
    return diqV96HasAny(txt, ["scenic", "overlook", "view", "park", "landmark", "historic", "attraction", "museum", "unique", "trail", "nature", "downtown", "district"]);
  }




  try { return diqV96PriorStrictAdventureCategoryMatch(item, query); } catch (e1) {}
  return true;
};




function diqV96InjectPlaceIQStyles() {
  var css;
  var style;
  if (byId("diqV96PlaceIQStyle")) { return; }




  css =
    "#diqAdventureVoiceToggle{display:none!important;visibility:hidden!important;pointer-events:none!important;}" +
    "#diqAdventureInfoCard .diqV96GoogleRating{" +
      "display:flex!important;align-items:center!important;gap:6px!important;" +
      "margin-top:6px!important;padding:6px 9px!important;width:max-content!important;max-width:100%!important;" +
      "border-radius:999px!important;border:1px solid rgba(255,255,255,.14)!important;" +
      "background:rgba(4,12,22,.52)!important;color:rgba(255,255,255,.92)!important;" +
      "font-size:10px!important;line-height:1!important;font-weight:850!important;" +
      "box-shadow:0 8px 22px rgba(0,0,0,.20)!important;" +
    "}" +
    "#diqAdventureInfoCard .diqV96GoogleRating .gStars{color:#ffce69!important;letter-spacing:.5px!important;}" +
    "#diqAdventureInfoCard .diqV96GoogleRating .gCount{color:rgba(255,255,255,.68)!important;font-weight:750!important;}" +
    "#diqAdventureInfoCard .diqV96ScanAgain{" +
      "grid-column:1/-1!important;min-height:42px!important;border-radius:15px!important;" +
      "display:flex!important;align-items:center!important;justify-content:center!important;" +
      "background:linear-gradient(135deg,rgba(0,229,255,.14),rgba(40,255,190,.10),rgba(183,156,255,.10))!important;" +
      "border:1px solid rgba(0,229,255,.32)!important;color:#e9fdff!important;" +
      "font-size:10px!important;font-weight:1000!important;letter-spacing:.9px!important;text-transform:uppercase!important;" +
      "box-shadow:0 0 24px rgba(0,229,255,.10)!important;" +
    "}" +
    "#diqAdventureInfoCard .diqV96QuickProof{" +
      "display:grid!important;grid-template-columns:repeat(3,minmax(0,1fr))!important;gap:7px!important;margin-top:10px!important;" +
    "}" +
    "#diqAdventureInfoCard .diqV96QuickProof div{" +
      "border-radius:14px!important;border:1px solid rgba(255,255,255,.10)!important;background:rgba(255,255,255,.045)!important;" +
      "padding:8px 6px!important;text-align:center!important;min-width:0!important;" +
    "}" +
    "#diqAdventureInfoCard .diqV96QuickProof strong{display:block!important;font-size:10px!important;line-height:1.1!important;color:#fff!important;white-space:nowrap!important;overflow:hidden!important;text-overflow:ellipsis!important;}" +
    "#diqAdventureInfoCard .diqV96QuickProof span{display:block!important;margin-top:3px!important;font-size:7.5px!important;font-weight:900!important;letter-spacing:.8px!important;color:rgba(255,255,255,.58)!important;text-transform:uppercase!important;}";




  style = document.createElement("style");
  style.id = "diqV96PlaceIQStyle";
  style.type = "text/css";
  style.appendChild(document.createTextNode(css));
  try { document.head.appendChild(style); } catch (e0) {}
}




function diqV96Number(v) {
  var n = Number(v);
  return isFinite(n) ? n : null;
}




function diqV96RatingData(item) {
  var raw = item && (item.raw || item.properties || item.datasourceRaw || {});
  var rating = null;
  var count = null;




  rating = diqV96Number(item && (item.googleRating || item.rating || item.stars));
  count = diqV96Number(item && (item.googleReviewCount || item.reviewCount || item.reviews || item.userRatingsTotal || item.userRatingCount));




  if (rating === null && raw) {
    rating = diqV96Number(raw.rating || raw.google_rating || raw.googleRating || raw.stars);
  }
  if (count === null && raw) {
    count = diqV96Number(raw.userRatingCount || raw.user_ratings_total || raw.userRatingsTotal || raw.reviewCount || raw.reviews);
  }




  try {
    if (rating === null && item && item.googleV51AcceptedCandidate && item.googleV51AcceptedCandidate.place) {
      rating = diqV96Number(item.googleV51AcceptedCandidate.place.rating);
      count = diqV96Number(item.googleV51AcceptedCandidate.place.userRatingCount);
    }
  } catch (e0) {}




  return {
    rating:rating,
    count:count
  };
}




function diqV96FormatReviews(n) {
  n = Number(n);
  if (!isFinite(n) || n <= 0) { return ""; }
  if (n >= 1000) {
    return String(Math.round(n / 100) / 10).replace(".0", "") + "k";
  }
  return String(Math.round(n));
}




function diqV96AddGoogleRow(item) {
  var card = byId("diqAdventureInfoCard");
  var title = byId("diqAdvInfoTitle");
  var category = byId("diqAdvInfoCategory");
  var existing;
  var data;
  var row;
  var parent;
  var after;




  if (!card) { return; }




  existing = card.querySelector ? card.querySelector(".diqV96GoogleRating") : null;
  if (existing && existing.parentNode) { existing.parentNode.removeChild(existing); }




  data = diqV96RatingData(item);
  if (!data || data.rating === null || data.rating < 1) { return; }




  row = document.createElement("div");
  row.className = "diqV96GoogleRating";
  row.innerHTML =
    '<span class="gStars">â˜…</span>' +
    '<strong>' + escapeHTML(String(Math.round(data.rating * 10) / 10)) + '</strong>' +
    (data.count ? '<span class="gCount">â€¢ ' + escapeHTML(diqV96FormatReviews(data.count)) + ' Google reviews</span>' : '<span class="gCount">â€¢ Google rating</span>');




  parent = category && category.parentNode ? category.parentNode : (title && title.parentNode ? title.parentNode : null);
  after = category || title;




  if (parent && after && after.nextSibling) {
    try { parent.insertBefore(row, after.nextSibling); } catch (e0) {}
  } else if (parent) {
    try { parent.appendChild(row); } catch (e1) {}
  }
}




function diqV96AddQuickProof(item) {
  var card = byId("diqAdventureInfoCard");
  var why = card && card.querySelector ? card.querySelector(".diqPlaceWhy") : null;
  var existing;
  var wrap;
  var dist = "";
  var rating = "";
  var open = "";
  var data;




  if (!card) { return; }
  existing = card.querySelector ? card.querySelector(".diqV96QuickProof") : null;
  if (existing && existing.parentNode) { existing.parentNode.removeChild(existing); }




  try { dist = destinationDistanceText(item) || itemDistanceText(item) || "Nearby"; } catch (e0) { dist = "Nearby"; }




  data = diqV96RatingData(item);
  if (data && data.rating !== null && data.rating >= 1) {
    rating = String(Math.round(data.rating * 10) / 10);
  } else {
    rating = "Place IQ";
  }




  open = clean(item && (item.openLabel || item.openStatus || item.freshnessLabel || ""));
  if (!open || normText(open) === "place iq") { open = "Open check"; }




  wrap = document.createElement("div");
  wrap.className = "diqV96QuickProof";
  wrap.innerHTML =
    '<div><strong>' + escapeHTML(dist) + '</strong><span>Distance</span></div>' +
    '<div><strong>' + escapeHTML(rating) + '</strong><span>Google</span></div>' +
    '<div><strong>' + escapeHTML(open) + '</strong><span>Freshness</span></div>';




  if (why && why.parentNode) {
    try { why.parentNode.insertBefore(wrap, why.nextSibling); } catch (e1) {}
  }
}




function diqV96ScanAgainQuery() {
  var q = clean(activeScanQuery || activeLens || "");
  var cat = categoryFromQuery(q);
  if (cat === "coffee iq") { return "coffee near me local cafe"; }
  if (cat === "food iq" || cat === "food drinks") { return "local restaurants near me"; }
  if (cat === "golf") { return "golf course near me"; }
  if (cat === "live music") { return "live music near me"; }
  if (cat === "shopping") { return "local shops near me"; }
  if (cat === "family") { return "family fun near me"; }
  if (cat === "dog friendly") { return "dog friendly places near me"; }
  if (cat === "trails" || cat === "parks" || cat === "scenic") { return "parks and trails near me"; }
  return q || "local favorites near me";
}




function diqV96AddScanAgain(item) {
  var card = byId("diqAdventureInfoCard");
  var actions = card && card.querySelector ? card.querySelector(".diqAdvActions") : null;
  var existing;
  var btn;




  if (!actions) { return; }




  existing = actions.querySelector ? actions.querySelector(".diqV96ScanAgain") : null;
  if (existing && existing.parentNode) { existing.parentNode.removeChild(existing); }




  btn = document.createElement("button");
  btn.type = "button";
  btn.className = "diqV96ScanAgain";
  btn.textContent = "ðŸ” Scan Again Near Me";
  btn.onclick = function(ev) {
    if (ev && ev.preventDefault) { ev.preventDefault(); }
    try { closeAdventureInfoCard(); } catch (e0) {}
    adventureSearchScope = "near_me";
    adventureSearchCenter = lastFix && finite(Number(lastFix.lat)) && finite(Number(lastFix.lng)) ? {
      lat:Number(lastFix.lat),
      lng:Number(lastFix.lng),
      label:"near you"
    } : null;
    scanAdventureChoices(diqV96ScanAgainQuery());
    return false;
  };




  try { actions.appendChild(btn); } catch (e1) {}
}




function diqV96PolishPlaceIQ(item) {
  var btn = byId("diqAdventureVoiceToggle");
  var scoreLabel;
  var card = byId("diqAdventureInfoCard");




  diqV96InjectPlaceIQStyles();




  if (btn) {
    btn.style.setProperty("display", "none", "important");
    btn.style.setProperty("visibility", "hidden", "important");
    btn.style.setProperty("pointer-events", "none", "important");
    btn.setAttribute("aria-hidden", "true");
  }




  if (card) {
    try { card.className = String(card.className || "").replace(/\s+diqV96PlaceIQ/g, "") + " diqV96PlaceIQ"; } catch (e0) {}
  }




  try {
    scoreLabel = card && card.querySelector ? card.querySelector(".diqPlaceScoreLabel") : null;
    if (scoreLabel) { scoreLabel.textContent = "Worth the Drive"; }
  } catch (e1) {}




  diqV96AddGoogleRow(item);
  diqV96AddQuickProof(item);
  diqV96AddScanAgain(item);
}




var diqV96PriorOpenAdventureInfoCard = openAdventureInfoCard;
openAdventureInfoCard = function(item, preserveBrowseCamera) {
  var result = diqV96PriorOpenAdventureInfoCard.apply(this, arguments);
  diqV96PolishPlaceIQ(item);
  window.setTimeout(function() { diqV96PolishPlaceIQ(item); }, 80);
  window.setTimeout(function() { diqV96PolishPlaceIQ(item); }, 650);
  return result;
};








/* =========================================================
   DRIVE IQ V97 â€” RECOMMENDATION TRUTH ENGINE
   - Small-town Food IQ: town center / Main Street first.
   - Local-first radius rings before regional fallback.
   - Permanently closed / known closed suppression.
   - Known local anchor rescue for Como and similar towns.
   - Composite recommendation score: category truth + local fit + open/freshness + distance.
   ES5-safe.
========================================================= */
window.DRIVE_IQ_ADVENTURE_MODE_BUILD = "V97_RECOMMENDATION_TRUTH_ENGINE";




var diqV97PriorAdventureRadiusForPass = adventureRadiusForPass;
var diqV97PriorBuildAdventureQueryPass = buildAdventureQueryPass;
var diqV97PriorSortAdventureResults = sortAdventureResults;
var diqV97PriorEnrichAdventureItem = enrichAdventureItem;
var diqV97PriorAdventureWorthScore = adventureWorthScore;




function diqV97Text(item) {
  return normText(
    String(item && item.label || "") + " " +
    String(item && item.full || "") + " " +
    String(item && item.kind || "") + " " +
    String(item && item.category || "") + " " +
    String(item && item.matchLabel || "") + " " +
    String(item && item.sourceQuery || "")
  );
}




function diqV97CityNorm() {
  var label = "";
  try { label = adventureScanCityLabel ? adventureScanCityLabel() : ""; } catch (e0) { label = ""; }
  if (!label || normText(label) === "you" || normText(label) === "near you") {
    try { label = destination && destination.label ? destination.label : ""; } catch (e1) { label = ""; }
  }
  return normText(label);
}




function diqV97IsMajorMarket(cityNorm) {
  cityNorm = normText(cityNorm || diqV97CityNorm());
  return !!(
    cityNorm.indexOf("memphis") > -1 ||
    cityNorm.indexOf("nashville") > -1 ||
    cityNorm.indexOf("dallas") > -1 ||
    cityNorm.indexOf("boston") > -1 ||
    cityNorm.indexOf("orlando") > -1 ||
    cityNorm.indexOf("atlanta") > -1 ||
    cityNorm.indexOf("chattanooga") > -1 ||
    cityNorm.indexOf("destin") > -1 ||
    cityNorm.indexOf("hot springs") > -1 ||
    cityNorm.indexOf("gulf shores") > -1
  );
}




function diqV97SmallTownActive(query) {
  var cat = categoryFromQuery(query);
  var city = diqV97CityNorm();
  if (!(cat === "food iq" || cat === "food drinks" || cat === "local favorites" || cat === "coffee iq")) { return false; }
  if (!city) { return false; }
  if (diqV97IsMajorMarket(city)) { return false; }
  return true;
}




function diqV97KnownComoContext() {
  var city = diqV97CityNorm();
  return city.indexOf("como") > -1 && (city.indexOf("ms") > -1 || city.indexOf("mississippi") > -1 || city === "como");
}




function diqV97LooksClosed(item) {
  var txt = diqV97Text(item);
  if (!txt) { return false; }
  if (txt.indexOf("permanently closed") > -1) { return true; }
  if (txt.indexOf("closed permanently") > -1) { return true; }
  if (txt.indexOf("out of business") > -1) { return true; }
  if (txt.indexOf("temporarily closed") > -1 && txt.indexOf("reopened") < 0) { return true; }




  /* Field-test closed/local stale suppression. Crossroads was surfacing for Como Food IQ even though it is not a valid current Como pick. */
  if (txt.indexOf("crossroads seafood") > -1 || txt.indexOf("crossroads catfish") > -1) { return true; }
  return false;
}




function diqV97IsFoodLike(item) {
  var txt = diqV97Text(item);
  if (!txt) { return false; }
  if (hasAnyTruthSignal(txt, [
    "restaurant", "steakhouse", "steak house", "thai", "barbecue", "bbq", "grill", "cafe", "coffee", "bakery", "diner", "kitchen", "taco", "pizza", "seafood", "burger", "brunch", "dessert", "ice cream", "wings", "chicken", "sandwich", "eatery", "bistro", "bar and grill", "food"
  ])) { return true; }
  return false;
}




function diqV97FoodNoise(item) {
  var txt = diqV97Text(item);
  return hasAnyTruthSignal(txt, [
    "gas station", "convenience store", "grocery", "supermarket", "dollar general", "walmart", "pharmacy", "drugstore", "bank", "atm", "church", "school", "hotel", "motel", "inn", "apartment", "subdivision", "real estate", "insurance", "auto parts", "car dealer", "storage", "warehouse", "medical", "clinic", "dentist", "funeral", "law office", "hardware", "supply"
  ]);
}




function diqV97KnownLocalAnchorScore(item, query) {
  var txt = diqV97Text(item);
  var score = 0;
  if (diqV97KnownComoContext()) {
    if (txt.indexOf("windy city") > -1) { score += 520; }
    if (txt.indexOf("como steakhouse") > -1 || txt.indexOf("como steak house") > -1) { score += 500; }
    if (txt.indexOf("thai hut") > -1) { score += 500; }
    if (txt.indexOf("windy city grille") > -1 || txt.indexOf("windy city grill") > -1) { score += 80; }
  }
  return score;
}




function diqV97LocalityScore(item, query) {
  var txt = diqV97Text(item);
  var city = diqV97CityNorm();
  var d = item && finite(Number(item.distMiles)) ? Number(item.distMiles) : null;
  var score = 0;




  if (city && txt.indexOf(city) > -1) { score += 130; }
  if (diqV97KnownComoContext() && (txt.indexOf("como") > -1 || txt.indexOf("main street") > -1 || txt.indexOf("main st") > -1)) { score += 170; }
  if (txt.indexOf("downtown") > -1 || txt.indexOf("town square") > -1 || txt.indexOf("square") > -1 || txt.indexOf("main street") > -1 || txt.indexOf("main st") > -1 || txt.indexOf("historic") > -1) { score += 115; }
  if (txt.indexOf("locally owned") > -1 || txt.indexOf("family owned") > -1 || txt.indexOf("local favorite") > -1 || txt.indexOf("neighborhood") > -1) { score += 95; }




  if (diqV97SmallTownActive(query) && d !== null) {
    if (d <= 1.5) { score += 220; }
    else if (d <= 3) { score += 180; }
    else if (d <= 5) { score += 125; }
    else if (d <= 8) { score += 55; }
    else if (d <= 12) { score -= 25; }
    else if (d <= 20) { score -= 140; }
    else { score -= 300; }
  } else if (d !== null) {
    if (d <= 2) { score += 80; }
    else if (d <= 6) { score += 55; }
    else if (d <= 12) { score += 25; }
    else if (d > 25) { score -= 55; }
  }




  return score;
}




function diqV97TruthScore(item, query) {
  var cat = categoryFromQuery(query);
  var txt = diqV97Text(item);
  var score = 0;




  if (!item) { return -99999; }
  if (diqV97LooksClosed(item)) { return -99999; }




  if (cat === "food iq" || cat === "food drinks") {
    if (!diqV97IsFoodLike(item)) { score -= 800; }
    if (diqV97FoodNoise(item)) { score -= 900; }
    if (hasAnyTruthSignal(txt, ["restaurant", "steakhouse", "thai", "grill", "barbecue", "bbq", "diner", "kitchen", "cafe", "bakery"])) { score += 180; }
    if (hasAnyTruthSignal(txt, ["mcdonald", "taco bell", "wendy", "burger king", "subway", "sonic", "kfc", "popeyes", "dairy queen"])) { score -= 85; }
  }




  if (cat === "coffee iq") {
    if (!hasAnyTruthSignal(txt, ["coffee", "cafe", "espresso", "roaster", "bakery", "latte"])) { score -= 700; }
    if (hasAnyTruthSignal(txt, ["smoothie", "nutrition", "tea only", "gas station", "mcdonald"])) { score -= 140; }
  }




  score += diqV97KnownLocalAnchorScore(item, query);
  score += diqV97LocalityScore(item, query);




  if (txt.indexOf("open now") > -1 || txt.indexOf("open") > -1) { score += 35; }
  if (txt.indexOf("closed") > -1 && txt.indexOf("enclosed") < 0) { score -= 70; }




  return score;
}




function diqV97AddFoodTruthQueries(out, city, pass) {
  var cityClean = clean(city || destinationTermSuffix()).replace(/^\s+/, "");
  var cityNorm = normText(cityClean);




  if (!cityClean) { cityClean = clean(destinationTermSuffix()).replace(/^\s+/, ""); }




  addUniqueAdventureQuery(out, "restaurants " + cityClean);
  addUniqueAdventureQuery(out, "local restaurants " + cityClean);
  addUniqueAdventureQuery(out, "best restaurants " + cityClean);
  addUniqueAdventureQuery(out, "downtown restaurants " + cityClean);
  addUniqueAdventureQuery(out, "Main Street restaurants " + cityClean);
  addUniqueAdventureQuery(out, "town square restaurants " + cityClean);
  addUniqueAdventureQuery(out, "locally owned restaurant " + cityClean);




  if (cityNorm.indexOf("como") > -1) {
    addUniqueAdventureQuery(out, "Windy City Como MS");
    addUniqueAdventureQuery(out, "Windy City Grille Como MS");
    addUniqueAdventureQuery(out, "Como Steakhouse Como MS");
    addUniqueAdventureQuery(out, "Como Steak House Como MS");
    addUniqueAdventureQuery(out, "Thai Hut Como MS");
    addUniqueAdventureQuery(out, "restaurants Main Street Como Mississippi");
    addUniqueAdventureQuery(out, "restaurants downtown Como Mississippi");
    addUniqueAdventureQuery(out, "food near Como town square Mississippi");
  }




  if (pass >= 1) {
    addUniqueAdventureQuery(out, "diner " + cityClean);
    addUniqueAdventureQuery(out, "steakhouse " + cityClean);
    addUniqueAdventureQuery(out, "thai restaurant " + cityClean);
    addUniqueAdventureQuery(out, "bbq restaurant " + cityClean);
    addUniqueAdventureQuery(out, "bar and grill " + cityClean);
  }




  if (pass >= 2) {
    addUniqueAdventureQuery(out, "classic restaurant " + cityClean);
    addUniqueAdventureQuery(out, "hidden gem restaurant " + cityClean);
    addUniqueAdventureQuery(out, "family restaurant " + cityClean);
  }
}




adventureRadiusForPass = function(query, passIndex) {
  var cat = categoryFromQuery(query);
  var pass = Number(passIndex || 0);




  if (diqV97SmallTownActive(query) && (cat === "food iq" || cat === "food drinks" || cat === "local favorites" || cat === "coffee iq")) {
    if (pass <= 0) { return 4; }
    if (pass === 1) { return 7; }
    if (pass === 2) { return 12; }
    if (pass === 3) { return 20; }
    return 32;
  }




  return diqV97PriorAdventureRadiusForPass(query, passIndex);
};




buildAdventureQueryPass = function(query, originalQuery, passIndex) {
  var out = diqV97PriorBuildAdventureQueryPass(query, originalQuery, passIndex) || [];
  var cat = categoryFromQuery(originalQuery || query);
  var city = destinationTermSuffix();
  var label = "";
  var pass = Number(passIndex || 0);
  var i;




  try { label = adventureScanCityLabel ? adventureScanCityLabel() : ""; } catch (e0) { label = ""; }
  if (label && normText(label) !== "you" && normText(label) !== "near you") { city = " " + clean(label); }




  if (cat === "food iq" || cat === "food drinks") {
    diqV97AddFoodTruthQueries(out, city, pass);
  }




  if (cat === "local favorites" && diqV97SmallTownActive(originalQuery || query)) {
    addUniqueAdventureQuery(out, "downtown " + clean(city));
    addUniqueAdventureQuery(out, "town square " + clean(city));
    addUniqueAdventureQuery(out, "Main Street " + clean(city));
    addUniqueAdventureQuery(out, "local favorites " + clean(city));
    addUniqueAdventureQuery(out, "locally owned restaurant " + clean(city));
  }




  /* Keep launch count sane: highest-trust local queries first, then fallbacks. */
  var prioritized = [];
  if (cat === "food iq" || cat === "food drinks") {
    for (i = 0; i < out.length; i++) {
      if (normText(out[i]).indexOf("windy city") > -1 || normText(out[i]).indexOf("como steak") > -1 || normText(out[i]).indexOf("thai hut") > -1 || normText(out[i]).indexOf("downtown") > -1 || normText(out[i]).indexOf("main street") > -1 || normText(out[i]).indexOf("town square") > -1 || normText(out[i]).indexOf("local restaurants") > -1) {
        addUniqueAdventureQuery(prioritized, out[i]);
      }
    }
    for (i = 0; i < out.length; i++) { addUniqueAdventureQuery(prioritized, out[i]); }
    out = prioritized;
  }




  return out.slice(0, diqV97SmallTownActive(originalQuery || query) ? 18 : 22);
};




function diqV97FilterTruth(items, query) {
  var cat = categoryFromQuery(query);
  var out = [];
  var i;
  var item;




  for (i = 0; i < (items || []).length; i++) {
    item = items[i];
    if (!item) { continue; }
    if (diqV97LooksClosed(item)) { continue; }
    if ((cat === "food iq" || cat === "food drinks") && diqV97FoodNoise(item)) { continue; }
    if ((cat === "food iq" || cat === "food drinks") && !diqV97IsFoodLike(item) && diqV97KnownLocalAnchorScore(item, query) <= 0) { continue; }
    out.push(item);
  }




  return out;
}




sortAdventureResults = function(items, query) {
  var filtered = diqV97FilterTruth(items || [], query);
  filtered = diqV22FilterExperienceResults(filtered || [], query);




  return filtered.sort(function(a, b) {
    var sa = scoreAdventure(a, query) + diqV97TruthScore(a, query);
    var sb = scoreAdventure(b, query) + diqV97TruthScore(b, query);
    var da = finite(Number(a && a.distMiles)) ? Number(a.distMiles) : 99999;
    var db = finite(Number(b && b.distMiles)) ? Number(b.distMiles) : 99999;




    if (Math.abs(sb - sa) > 8) { return sb - sa; }
    return da - db;
  });
};




adventureWorthScore = function(item, query) {
  var base = diqV97PriorAdventureWorthScore(item, query);
  var adj = diqV97TruthScore(item, query);
  if (adj <= -9999) { return 45; }
  base += Math.round(Math.max(-30, Math.min(35, adj / 18)));
  if (base < 45) { base = 45; }
  if (base > 97) { base = 97; }
  return base;
};




enrichAdventureItem = function(item, query) {
  item = diqV97PriorEnrichAdventureItem(item, query);
  if (!item) { return item; }
  item.recommendationTruthScore = diqV97TruthScore(item, query);
  if (diqV97KnownLocalAnchorScore(item, query) > 0) {
    item.matchLabel = "Local Anchor";
    item.whyStop = "Strong local-town match near the scan center.";
    if (!item.localTags) { item.localTags = []; }
    item.localTags.unshift("Local Anchor");
  } else if (diqV97SmallTownActive(query) && diqV97LocalityScore(item, query) > 120) {
    item.matchLabel = item.matchLabel || "Town Center Pick";
    if (!item.whyStop || item.whyStop === "Food worth trying") { item.whyStop = "Local-first pick close to the town center."; }
  }
  return item;
};




try {
  console.log("âœ… Drive IQ Adventure V97 Recommendation Truth Engine loaded", {
    build:window.DRIVE_IQ_ADVENTURE_MODE_BUILD,
    focus:"small-town Food IQ, local-first rings, closed suppression, town-square intelligence",
    como:"Windy City / Como Steakhouse / Thai Hut boosted; Crossroads suppressed"
  });
} catch (e97) {}












try {
  console.log("âœ… Drive IQ Adventure V96 Place IQ + Category Scan Authority loaded", {
    build:window.DRIVE_IQ_ADVENTURE_MODE_BUILD,
    card:"Worth the Drive primary, Google rating evidence, Scan Again Near Me",
    categories:"Food, Coffee, Golf, Shopping, Family, Dog, Outdoors, Nightlife protected"
  });
} catch (e96) {}








/* =========================================================
   DRIVE IQ V98 â€” SMALL TOWN CANDIDATE ACQUISITION ENGINE
   Backend JS only. ES5-safe.
   Fix from Como field test:
   - Food IQ / Local Favorites must acquire true in-town candidates before widening.
   - Exact business/town-center queries run first for small towns.
   - Closed/parking/generic fallback noise is suppressed harder.
   - Wide regional fallback is prevented from hijacking small-town scans.
========================================================= */
window.__DRIVE_IQ_ADVENTURE_MODE_JS_V98_SMALL_TOWN_CANDIDATE_TRUTH__ = true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD = "V98_SMALL_TOWN_CANDIDATE_TRUTH";




var diqV98PriorConfig = diqV27Config;
var diqV98PriorRadiusMiles = diqV273RadiusMiles;
var diqV98PriorTruthMatch = diqV27TruthMatch;
var diqV98PriorScore = diqV27Score;
var diqV98PriorCandidateBucket = diqV27CandidateBucket;
var diqV98PriorRenderBroadPull = diqV27RenderBroadPull;
var diqV98PriorFilterTruth = (typeof diqV97FilterTruth === "function") ? diqV97FilterTruth : null;
var diqV98PriorSortAdventureResults = sortAdventureResults;
var diqV98PriorEnrichAdventureItem = enrichAdventureItem;




function diqV98ScanCenterLabel() {
  var label = "";
  try { if (adventureSearchCenter && adventureSearchCenter.label) { label = clean(adventureSearchCenter.label); } } catch (e1) {}
  if (!label || normText(label) === "you" || normText(label) === "near you") {
    try { if (destination && destination.label) { label = clean(destination.label); } } catch (e2) {}
  }
  if (!label || normText(label) === "you" || normText(label) === "near you") {
    try { if (typeof adventureScanCityLabel === "function") { label = clean(adventureScanCityLabel()); } } catch (e3) {}
  }
  return clean(label || "");
}




function diqV98TownNorm() {
  var label = diqV98ScanCenterLabel();
  var n = normText(label);
  if (n.indexOf("como") > -1) { return "como ms"; }
  if (n.indexOf("sardis") > -1) { return "sardis ms"; }
  if (n.indexOf("coldwater") > -1) { return "coldwater ms"; }
  if (n.indexOf("crenshaw") > -1) { return "crenshaw ms"; }
  if (n.indexOf("hernando") > -1) { return "hernando ms"; }
  if (n.indexOf("tunica") > -1) { return "tunica ms"; }
  return n;
}




function diqV98IsSmallTownScan(query) {
  var t = diqV98TownNorm();
  var q = normText(String(query || activeScanQuery || activeLens || ""));
  if (q.indexOf("nashville") > -1 || q.indexOf("memphis") > -1 || q.indexOf("dallas") > -1 || q.indexOf("boston") > -1) { return false; }
  return !!(
    t.indexOf("como") > -1 ||
    t.indexOf("sardis") > -1 ||
    t.indexOf("coldwater") > -1 ||
    t.indexOf("crenshaw") > -1 ||
    t.indexOf("tunica") > -1 ||
    t.indexOf("moon lake") > -1
  );
}




function diqV98CityText() {
  var t = diqV98TownNorm();
  if (t.indexOf("como") > -1) { return "Como MS"; }
  if (t.indexOf("sardis") > -1) { return "Sardis MS"; }
  if (t.indexOf("coldwater") > -1) { return "Coldwater MS"; }
  if (t.indexOf("crenshaw") > -1) { return "Crenshaw MS"; }
  if (t.indexOf("tunica") > -1) { return "Tunica MS"; }
  return clean(diqV98ScanCenterLabel() || diqV27CitySuffix() || "").replace(/^near\s+/i, "");
}




function diqV98Text(item) {
  try { if (typeof diqV268Text === "function") { return diqV268Text(item); } } catch (e1) {}
  try { if (typeof adventureTruthText === "function") { return adventureTruthText(item); } } catch (e2) {}
  return normText(String(item && item.label || "") + " " + String(item && item.full || "") + " " + String(item && item.kind || "") + " " + String(item && item.category || "") + " " + String(item && item.sourceQuery || ""));
}




function diqV98Has(txt, arr) {
  var i;
  txt = normText(txt);
  for (i = 0; i < (arr || []).length; i++) {
    if (txt.indexOf(normText(arr[i])) > -1) { return true; }
  }
  return false;
}




function diqV98ClosedNoise(item) {
  var txt = diqV98Text(item);
  return diqV98Has(txt, [
    "permanently closed", "closed permanently", "business closed", "closed business",
    "temporarily closed", "no longer open", "closed down", "out of business"
  ]);
}




function diqV98ComoAnchorScore(item) {
  var txt = diqV98Text(item);
  var s = 0;
  if (!item) { return 0; }
  if (diqV98Has(txt, ["windy city", "windy city grille", "windy city cafe"])) { s += 900; }
  if (diqV98Has(txt, ["como steakhouse", "como steak house", "steakhouse como"])) { s += 850; }
  if (diqV98Has(txt, ["thai hut", "thai hut como", "thai food como"])) { s += 850; }
  if (diqV98Has(txt, ["como", "main street como", "downtown como", "como ms", "panola"])) { s += 220; }
  return s;
}




function diqV98TownAnchorScore(item, query) {
  var town = diqV98TownNorm();
  var txt = diqV98Text(item);
  var s = 0;
  if (!item) { return 0; }
  if (town.indexOf("como") > -1) { s += diqV98ComoAnchorScore(item); }
  if (town && diqV98Has(txt, [town.replace(/\s+ms$/, ""), town])) { s += 170; }
  if (diqV98Has(txt, ["downtown", "main street", "town square", "square", "historic district", "local", "family owned", "locally owned"])) { s += 100; }
  return s;
}




function diqV98FoodSignal(item) {
  var txt = diqV98Text(item);
  if (diqV98TownAnchorScore(item, activeScanQuery) > 300) { return true; }
  return diqV98Has(txt, [
    "restaurant", "restaurants", "diner", "grill", "cafe", "cafÃ©", "steakhouse", "steak house",
    "thai", "bbq", "barbecue", "pizza", "burger", "mexican", "taco", "seafood", "breakfast",
    "brunch", "lunch", "dinner", "food", "kitchen", "eatery", "bar and grill"
  ]);
}




function diqV98HardNoise(item) {
  var txt = diqV98Text(item);
  if (diqV98TownAnchorScore(item, activeScanQuery) > 300) { return false; }
  return diqV98Has(txt, [
    "parking", "parking lot", "parking garage", "car park", "restroom", "bathroom", "atm",
    "bank", "insurance", "law office", "lawyer", "real estate", "storage", "school", "church",
    "cemetery", "funeral", "courthouse", "government office", "post office", "city hall",
    "gas station", "fuel", "car wash", "auto parts", "apartment", "apartments"
  ]);
}




function diqV98RegionalHijackPenalty(item, query) {
  var d = null;
  var town = diqV98TownNorm();
  var txt = diqV98Text(item);
  try { d = Number(item.diqV273DistanceMiles || item.distanceFromScanCenter || item.distMiles); } catch (e1) { d = null; }
  if (!finite(Number(d))) { d = null; }
  if (!diqV98IsSmallTownScan(query)) { return 0; }
  if (town.indexOf("como") > -1 && diqV98ComoAnchorScore(item) > 0) { return 0; }
  if (town && diqV98Has(txt, [town.replace(/\s+ms$/, ""), town])) { return 0; }
  if (d !== null && d <= 5) { return 0; }
  if (d !== null && d <= 10) { return -120; }
  if (d !== null && d <= 18) { return -280; }
  return -520;
}




function diqV98Add(out, v) {
  try { return diqV27Add(out, v); } catch (e) {}
}




function diqV98SmallTownFoodPools(out, city) {
  if (!city) { return; }
  if (normText(city).indexOf("como") > -1) {
    diqV98Add(out, "Windy City Como MS");
    diqV98Add(out, "Windy City restaurant Como MS");
    diqV98Add(out, "Como Steakhouse Como MS");
    diqV98Add(out, "Como Steak House Como MS");
    diqV98Add(out, "Thai Hut Como MS");
    diqV98Add(out, "Thai food Como MS");
  }
  diqV98Add(out, "restaurants in " + city);
  diqV98Add(out, "local restaurants " + city);
  diqV98Add(out, "best restaurants " + city);
  diqV98Add(out, "downtown restaurants " + city);
  diqV98Add(out, "Main Street restaurants " + city);
  diqV98Add(out, "town square restaurants " + city);
  diqV98Add(out, "food in " + city);
  diqV98Add(out, "dining " + city);
  diqV98Add(out, "steakhouse " + city);
  diqV98Add(out, "cafe " + city);
  diqV98Add(out, "bbq " + city);
  diqV98Add(out, "pizza " + city);
  diqV98Add(out, "mexican restaurant " + city);
}




function diqV98SmallTownLocalPools(out, city) {
  if (!city) { return; }
  diqV98Add(out, "local restaurants " + city);
  diqV98Add(out, "coffee shops " + city);
  diqV98Add(out, "downtown " + city);
  diqV98Add(out, "Main Street " + city);
  diqV98Add(out, "town square " + city);
  diqV98Add(out, "historic downtown " + city);
  diqV98Add(out, "local favorites " + city);
  diqV98Add(out, "locally owned " + city);
  diqV98Add(out, "things to do " + city);
  if (normText(city).indexOf("como") > -1) {
    diqV98Add(out, "Windy City Como MS");
    diqV98Add(out, "Como Steakhouse Como MS");
    diqV98Add(out, "Thai Hut Como MS");
  }
}




diqV27Config = function(query) {
  var cfg = diqV98PriorConfig(query);
  var key = diqV27CategoryKey(query);
  var city = diqV98CityText();
  var out = [];




  if (!diqV98IsSmallTownScan(query)) { return cfg; }




  if (key === "food_iq") {
    cfg = { key:"food_iq", query:String(query || ""), label:"Food IQ Small Town", pools:out, maxResults:8 };
    diqV98SmallTownFoodPools(out, city);
    diqV98Add(out, diqV27PlacesToken("catering.restaurant,catering.cafe,catering.fast_food,catering.pub,catering.bar", "Small town food category pool"));
    return cfg;
  }




  if (key === "local_hangouts") {
    cfg = { key:"local_hangouts", query:String(query || ""), label:"Local Favorites Small Town", pools:out, maxResults:8 };
    diqV98SmallTownLocalPools(out, city);
    diqV98Add(out, diqV27PlacesToken("catering.restaurant,catering.cafe,catering.bar,catering.pub,tourism,heritage,commercial.marketplace,leisure.park", "Small town local favorites pool"));
    return cfg;
  }




  return cfg;
};




diqV273RadiusMiles = function(cfg) {
  var key = cfg && cfg.key ? String(cfg.key) : "";
  if (cfg && diqV98IsSmallTownScan(cfg.query || activeScanQuery)) {
    if (key === "food_iq") { return 7; }
    if (key === "local_hangouts") { return 9; }
  }
  return diqV98PriorRadiusMiles(cfg);
};




diqV27TruthMatch = function(item, query, key) {
  if (!item) { return false; }
  if (diqV98ClosedNoise(item)) { return false; }
  if (diqV98IsSmallTownScan(query) && (key === "food_iq" || key === "local_hangouts")) {
    if (diqV98HardNoise(item)) { return false; }
    if (key === "food_iq") { return diqV98FoodSignal(item); }
    if (diqV98TownAnchorScore(item, query) > 220) { return true; }
    if (diqV98FoodSignal(item)) { return true; }
    return diqV98PriorTruthMatch(item, query, key);
  }
  return diqV98PriorTruthMatch(item, query, key);
};




diqV27CandidateBucket = function(item, key) {
  if (diqV98IsSmallTownScan(activeScanQuery) && key === "food_iq") {
    if (diqV98TownAnchorScore(item, activeScanQuery) > 300) { return "town_anchor"; }
  }
  return diqV98PriorCandidateBucket(item, key);
};




diqV27Score = function(item, query, key) {
  var score;
  var anchor;
  if (!item) { return -9999; }
  if (diqV98ClosedNoise(item) || diqV98HardNoise(item)) { return -9999; }




  score = diqV98PriorScore(item, query, key);
  if (!finite(Number(score))) { score = 0; }




  if (diqV98IsSmallTownScan(query) && (key === "food_iq" || key === "local_hangouts")) {
    anchor = diqV98TownAnchorScore(item, query);
    score += anchor;
    if (diqV98FoodSignal(item)) { score += 180; }
    score += diqV98RegionalHijackPenalty(item, query);
  }




  return score;
};




function diqV98FilterResults(items, query) {
  var out = [];
  var i;
  var item;
  var cat = categoryFromQuery(query);
  var anchor;




  for (i = 0; i < (items || []).length; i++) {
    item = items[i];
    if (!item) { continue; }
    if (diqV98ClosedNoise(item) || diqV98HardNoise(item)) { continue; }
    if (diqV98IsSmallTownScan(query) && (cat === "food iq" || cat === "local favorites")) {
      anchor = diqV98TownAnchorScore(item, query);
      if (cat === "food iq" && !diqV98FoodSignal(item) && anchor <= 0) { continue; }
    }
    out.push(item);
  }
  return out;
}




if (diqV98PriorFilterTruth) {
  diqV97FilterTruth = function(items, query) {
    return diqV98PriorFilterTruth(diqV98FilterResults(items || [], query), query);
  };
}




sortAdventureResults = function(items, query) {
  var filtered = diqV98FilterResults(items || [], query);
  var sorted = diqV98PriorSortAdventureResults(filtered, query);
  if (!diqV98IsSmallTownScan(query)) { return sorted; }
  sorted.sort(function(a, b) {
    var sa = (scoreAdventure(a, query) || 0) + diqV98TownAnchorScore(a, query) + diqV98RegionalHijackPenalty(a, query);
    var sb = (scoreAdventure(b, query) || 0) + diqV98TownAnchorScore(b, query) + diqV98RegionalHijackPenalty(b, query);
    return sb - sa;
  });
  return sorted;
};




diqV27RenderBroadPull = function(rawItems, query, cfg, token) {
  var filtered = diqV98FilterResults(rawItems || [], query);
  return diqV98PriorRenderBroadPull(filtered, query, cfg, token);
};




enrichAdventureItem = function(item, query) {
  item = diqV98PriorEnrichAdventureItem(item, query);
  if (!item) { return item; }
  if (diqV98TownAnchorScore(item, query) > 300) {
    item.matchLabel = "Town Anchor";
    item.whyStop = "A true local-town match ranked before wider regional fallbacks.";
  }
  return item;
};




try {
  console.log("âœ… Drive IQ Adventure V98 Small Town Candidate Truth loaded", {
    build:window.DRIVE_IQ_ADVENTURE_MODE_BUILD,
    focus:"candidate acquisition before ranking",
    rule:"exact town + Main Street + town square first, widen only after local pool",
    como:"Windy City / Como Steakhouse / Thai Hut exact searches before Hernando/Coldwater fallback"
  });
} catch (e98) {}




/* =========================================================
   DRIVE IQ V99 â€” SCAN LIST THUMBNAIL AUTHORITY
   - Every scan choice gets a visible thumbnail surface.
   - Real photo still wins when available.
   - Missing/failed photos fall back to category art, never a blank gap.
   - Rebinds against the CURRENT rendered list, not stale destination cache.
========================================================= */




window.__DRIVE_IQ_ADVENTURE_MODE_JS_V99_SCAN_THUMBNAILS__ = true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD = "V99_SCAN_LIST_THUMBNAIL_AUTHORITY";




var diqV99ThumbHydrateQueued = {};




function diqV99InjectThumbStyles() {
  var style;
  var css;
  if (byId("diqV99ScanThumbStyles")) { return; }




  css =
    "#diqAdventureDestResults .diqDestItem.hasPhoto{padding-left:92px!important;min-height:92px!important;}" +
    "#diqAdventureDestResults .diqDestThumb{display:block!important;position:absolute!important;left:10px!important;top:10px!important;width:70px!important;height:70px!important;border-radius:15px!important;overflow:hidden!important;background-size:cover!important;background-position:center!important;background-color:rgba(255,255,255,.08)!important;border:1px solid rgba(255,255,255,.14)!important;box-shadow:inset 0 0 0 1px rgba(255,255,255,.04),0 12px 22px rgba(0,0,0,.22)!important;}" +
    "#diqAdventureDestResults .diqDestThumb:before{content:'';position:absolute;inset:0;background:radial-gradient(circle at 28% 22%,rgba(255,255,255,.18),transparent 30%),linear-gradient(135deg,rgba(255,206,105,.18),rgba(40,255,190,.12));pointer-events:none;}" +
    "#diqAdventureDestResults .diqDestThumb.realPhoto:before{display:none!important;}" +
    "#diqAdventureDestResults .diqDestThumb.dining,#diqAdventureDestResults .diqDestThumb.food,#diqAdventureDestResults .diqDestThumb.food_iq{background-image:linear-gradient(135deg,rgba(255,206,105,.45),rgba(255,111,72,.18)),radial-gradient(circle at 75% 22%,rgba(255,255,255,.22),transparent 32%)!important;}" +
    "#diqAdventureDestResults .diqDestThumb.water{background-image:linear-gradient(135deg,rgba(0,229,255,.38),rgba(40,255,190,.16)),radial-gradient(circle at 25% 22%,rgba(255,255,255,.18),transparent 30%)!important;}" +
    "#diqAdventureDestResults .diqDestThumb.outdoor{background-image:linear-gradient(135deg,rgba(40,255,190,.34),rgba(0,229,255,.13)),radial-gradient(circle at 25% 22%,rgba(255,255,255,.14),transparent 32%)!important;}" +
    "#diqAdventureDestResults .diqDestThumb.local{background-image:linear-gradient(135deg,rgba(255,206,105,.30),rgba(40,255,190,.16)),radial-gradient(circle at 75% 20%,rgba(255,255,255,.16),transparent 30%)!important;}" +
    "#diqAdventureDestResults .diqDestThumb.diqV99Fallback:after{content:'DRIVE IQ';position:absolute;left:7px;right:7px;bottom:7px;display:flex;align-items:center;justify-content:center;height:18px;border-radius:999px;background:rgba(2,8,18,.56);color:rgba(255,255,255,.84);font:900 7px/18px -apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;letter-spacing:.8px;}" +
    "#diqAdventureDestResults .diqDestThumb.diqV86Loading:after{content:'';position:absolute;inset:0;background:linear-gradient(110deg,transparent 18%,rgba(255,255,255,.10) 46%,transparent 74%);animation:diqV99ThumbShimmer 1.25s linear infinite;}" +
    "@keyframes diqV99ThumbShimmer{0%{transform:translateX(-100%)}100%{transform:translateX(100%)}}";




  style = document.createElement("style");
  style.id = "diqV99ScanThumbStyles";
  style.type = "text/css";
  style.appendChild(document.createTextNode(css));
  try { document.head.appendChild(style); } catch (e0) {}
}




function diqV99FallbackThumb(node, item, query) {
  var thumb;
  var cls;
  if (!node) { return; }
  thumb = node.querySelector ? node.querySelector(".diqDestThumb") : null;
  if (!thumb) {
    thumb = document.createElement("div");
    thumb.className = "diqDestThumb";
    try { node.insertBefore(thumb, node.firstChild); } catch (e0) {}
  }
  try {
    if (String(node.className || "").indexOf("hasPhoto") < 0) {
      node.className = String(node.className || "") + " hasPhoto";
    }
  } catch (e1) {}
  cls = categoryPhotoClass(item || {}, query || activeLens) || "local";
  if (node.getAttribute("data-photo-loaded") !== "1") {
    thumb.className = "diqDestThumb " + cls + " diqV99Fallback";
    thumb.removeAttribute("style");
    node.setAttribute("data-photo-loaded", "fallback");
  }
}




function diqV99CurrentRenderedItems(items) {
  if (items && items.length) { return items; }
  if (adventureResults && adventureResults.length) { return adventureResults; }
  if (destinationSearchResults && destinationSearchResults.length) { return destinationSearchResults; }
  if (exploreResults && exploreResults.length) { return exploreResults; }
  return [];
}




function diqV99BindScanThumbnails(items, query) {
  var activeItems = diqV99CurrentRenderedItems(items || []);
  var nodes = [];
  var i;
  var node;
  var idx;
  var item;
  var key;
  var candidates;




  diqV99InjectThumbStyles();




  try { nodes = document.querySelectorAll("#diqAdventureDestResults .diqDestItem[data-adv-idx]"); } catch (e0) { nodes = []; }




  for (i = 0; i < nodes.length; i++) {
    node = nodes[i];
    idx = Number(node.getAttribute("data-adv-idx"));
    item = activeItems && activeItems[idx] ? activeItems[idx] : null;
    if (!item) { continue; }




    key = diqV86StablePhotoKey(item);
    node.setAttribute("data-photo-key", key);
    diqV99FallbackThumb(node, item, query || activeLens);




    candidates = [];
    try { candidates = diqV86ThumbCandidates(item, query || activeLens); } catch (e1) { candidates = []; }




    if (candidates && candidates.length) {
      node.setAttribute("data-photo-loaded", "checking");
      diqV86VerifyAndPaintThumb(node, item, candidates, 0, query || activeLens);
    }




    if (key && !diqV99ThumbHydrateQueued[key]) {
      diqV99ThumbHydrateQueued[key] = true;
      (function(candidate, candidateQuery, candidateNode, candidateKey) {
        window.setTimeout(function() {
          try {
            var proven = diqV86CanonicalPhoto(candidate);
            if (proven && proven.url) {
              diqV86VerifyAndPaintThumb(candidateNode, candidate, [proven], 0, candidateQuery);
              return;
            }
            diqHydratePlacePhotos(candidate, candidateQuery || activeLens);
          } catch (e2) {}
        }, 260);




        window.setTimeout(function() {
          try {
            var proven2 = diqV86CanonicalPhoto(candidate);
            if (proven2 && proven2.url) {
              diqV86VerifyAndPaintThumb(candidateNode, candidate, [proven2], 0, candidateQuery);
            } else {
              diqV99FallbackThumb(candidateNode, candidate, candidateQuery);
            }
          } catch (e3) {
            diqV99FallbackThumb(candidateNode, candidate, candidateQuery);
          }
        }, 3600);
      })(item, query || activeLens, node, key);
    }
  }
}




/* Replaces the older thumbnail binder with a current-list authority. */
diqV85BindAndHydrateThumbnails = function(items, query) {
  diqV99BindScanThumbnails(items || [], query || activeLens);
};




var diqV99PriorRenderAdventureScanChoices = renderAdventureScanChoices;
renderAdventureScanChoices = function(items, query) {
  var result = diqV99PriorRenderAdventureScanChoices(items, query);
  window.setTimeout(function(){ diqV99BindScanThumbnails(items || [], query || activeLens); }, 80);
  window.setTimeout(function(){ diqV99BindScanThumbnails(items || [], query || activeLens); }, 850);
  window.setTimeout(function(){ diqV99BindScanThumbnails(items || [], query || activeLens); }, 2200);
  return result;
};




var diqV99PriorRepaintAllPhotoSurfacesForItem = repaintAllPhotoSurfacesForItem;
repaintAllPhotoSurfacesForItem = function(item, query) {
  var result = diqV99PriorRepaintAllPhotoSurfacesForItem(item, query || activeLens);
  window.setTimeout(function(){ diqV99BindScanThumbnails(adventureResults || destinationSearchResults || [], query || activeLens); }, 60);
  return result;
};




try {
  console.log("âœ… Drive IQ Adventure V99 scan list thumbnail authority loaded", {
    build:window.DRIVE_IQ_ADVENTURE_MODE_BUILD,
    rule:"every result gets real photo or category fallback; no blank thumbnail gaps"
  });
} catch (e99) {}












/* =========================================================
   DRIVE IQ V101 â€” FINAL TRUTH GATE / RESULT AUTHORITY




   Core rule:
   - Truth first. Volume second.
   - No raw provider result can become a pin/card/shelf item unless it passes
     the final category truth gate.
   - Food IQ, Coffee IQ, Dessert IQ, Nightlife, Waterfront, and Local Favorites
     share one last display authority.
   - If only 3 true results survive, show 3. Never fill with police/fire/city/
     industrial/service results just to make the scan feel full.
   ES5-safe. No optional chaining. No arrow functions. No template literals.
========================================================= */




window.__DRIVE_IQ_ADVENTURE_MODE_JS_V101_FINAL_TRUTH_GATE__ = true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD = "V101_FINAL_TRUTH_GATE_RESULT_AUTHORITY";




var diqV101LastTruthQuery = "";




function diqV101TruthText(item) {
  if (!item) { return ""; }
  return normText(
    String(item.label || "") + " " +
    String(item.name || "") + " " +
    String(item.full || "") + " " +
    String(item.address || "") + " " +
    String(item.kind || "") + " " +
    String(item.category || "") + " " +
    String(item.matchLabel || "") + " " +
    String(item.resultType || "") + " " +
    String(item.whyStop || "")
  );
}




function diqV101HasAny(txt, words) {
  var i;
  txt = normText(txt);
  for (i = 0; i < words.length; i++) {
    if (txt.indexOf(words[i]) > -1) { return true; }
  }
  return false;
}




function diqV101ActiveQuery(query) {
  return clean(query || diqV101LastTruthQuery || activeScanQuery || activeLens || "");
}




function diqV101ActiveCategory(query) {
  var q = normText(diqV101ActiveQuery(query));
  var cat = "";




  try { cat = categoryFromQuery(q); } catch (e0) { cat = ""; }
  cat = normText(cat || q);




  if (cat.indexOf("food") > -1 || q.indexOf("restaurant") > -1 || q === "eat") { return "food"; }
  if (cat.indexOf("coffee") > -1 || q.indexOf("coffee") > -1 || q.indexOf("cafe") > -1 || q.indexOf("espresso") > -1) { return "coffee"; }
  if (cat.indexOf("dessert") > -1 || q.indexOf("dessert") > -1 || q.indexOf("ice cream") > -1 || q.indexOf("bakery") > -1 || q.indexOf("treat") > -1) { return "dessert"; }
  if (cat.indexOf("waterfront") > -1 || q.indexOf("waterfront") > -1 || q.indexOf("marina") > -1 || q.indexOf("beach") > -1 || q.indexOf("harbor") > -1) { return "waterfront"; }
  if (cat.indexOf("local") > -1 || q.indexOf("local favorite") > -1 || q.indexOf("local hangout") > -1) { return "local"; }
  if (cat.indexOf("night") > -1 || q.indexOf("bar") > -1 || q.indexOf("live music") > -1) { return "nightlife"; }
  if (cat.indexOf("golf") > -1 || q.indexOf("golf") > -1) { return "golf"; }
  if (cat.indexOf("outdoor") > -1 || cat.indexOf("park") > -1 || q.indexOf("trail") > -1 || q.indexOf("outdoor") > -1) { return "outdoors"; }




  return cat || "general";
}




function diqV101IsAlwaysBadExperience(item) {
  var txt = diqV101TruthText(item);




  if (!txt) { return true; }




  return diqV101HasAny(txt, [
    "police", "sheriff", "fire department", "fire station", "fire rescue", "ems", "ambulance",
    "city hall", "town hall", "municipal", "government", "courthouse", "court house", "court", "jail", "detention", "prison",
    "public works", "utility", "utilities", "water department", "wastewater", "sewer", "electric department",
    "industrial", "industrial park", "warehouse", "factory", "plant", "manufacturing",
    "cemetery", "funeral", "mortuary",
    "school", "elementary", "middle school", "high school", "college administrative", "university police",
    "church", "baptist church", "methodist church", "ministries", "worship",
    "hospital", "clinic", "medical", "urgent care", "dentist", "pharmacy",
    "bank", "atm", "credit union", "insurance", "law office", "attorney", "real estate",
    "post office", "dmv", "tag office", "license office",
    "storage", "self storage", "auto repair", "tire", "oil change", "collision", "body shop", "car wash", "dealership",
    "apartment", "apartments", "housing authority", "mobile home park"
  ]);
}




function diqV101IsFoodVenue(item) {
  var txt = diqV101TruthText(item);




  if (diqV101IsAlwaysBadExperience(item)) { return false; }




  return diqV101HasAny(txt, [
    "restaurant", "restaurants", "catering restaurant", "catering", "food", "eatery", "dining",
    "bar and grill", "bar & grill", "grill", "grille", "bistro", "diner", "cafe", "cafÃ©",
    "bakery", "bake shop", "coffee shop", "coffeehouse",
    "seafood", "oyster", "crab", "shrimp", "fish house",
    "bbq", "barbecue", "steakhouse", "steak house", "pizza", "pizzeria", "taco", "taqueria", "mexican restaurant",
    "burger", "sandwich", "deli", "chicken", "wings", "sushi", "hibachi", "thai restaurant", "italian restaurant",
    "breakfast", "brunch", "ice cream", "dessert", "brewery", "brewing", "pub", "tavern"
  ]);
}




function diqV101IsCoffeeVenue(item) {
  var txt = diqV101TruthText(item);




  if (diqV101IsAlwaysBadExperience(item)) { return false; }
  if (txt.indexOf("smoothie") > -1 && txt.indexOf("coffee") < 0 && txt.indexOf("cafe") < 0 && txt.indexOf("cafÃ©") < 0) { return false; }




  return diqV101HasAny(txt, [
    "coffee", "coffee shop", "coffeehouse", "espresso", "latte", "cappuccino", "roaster", "roastery",
    "cafe", "cafÃ©", "tea", "bakery", "bake shop"
  ]);
}




function diqV101IsDessertVenue(item) {
  var txt = diqV101TruthText(item);




  if (diqV101IsAlwaysBadExperience(item)) { return false; }




  return diqV101HasAny(txt, [
    "dessert", "ice cream", "gelato", "custard", "bakery", "donut", "doughnut", "cookie", "cupcake",
    "cake", "candy", "chocolate", "sweet", "treat", "snow cone", "shaved ice", "creamery"
  ]);
}




function diqV101IsNightlifeVenue(item) {
  var txt = diqV101TruthText(item);




  if (diqV101IsAlwaysBadExperience(item)) { return false; }




  return diqV101HasAny(txt, [
    "bar", "pub", "tavern", "lounge", "nightclub", "night club", "brewery", "brewing", "distillery",
    "live music", "music venue", "concert", "karaoke", "sports bar", "beach bar", "rooftop", "wine bar"
  ]) || diqV101IsFoodVenue(item);
}




function diqV101IsWaterfrontCandidate(item) {
  var txt = diqV101TruthText(item);




  if (diqV101IsAlwaysBadExperience(item)) { return false; }




  return diqV101HasAny(txt, [
    "waterfront", "water front", "water view", "beach", "harbor", "harbour", "marina", "pier", "dock", "boardwalk",
    "bay", "gulf", "ocean", "river", "lake", "creek", "sound", "island", "boat", "boating",
    "seafood", "oyster", "crab", "shrimp", "fish house", "beach bar"
  ]);
}




function diqV101IsGolfVenue(item) {
  var txt = diqV101TruthText(item);
  if (diqV101IsAlwaysBadExperience(item)) { return false; }
  return diqV101HasAny(txt, ["golf", "golf course", "country club", "driving range", "links", "clubhouse"]);
}




function diqV101PassesFinalTruth(item, query) {
  var cat = diqV101ActiveCategory(query);




  if (!item) { return false; }
  if (!finite(Number(item.lat)) || !finite(Number(item.lng))) { return false; }




  if (cat === "food") { return diqV101IsFoodVenue(item); }
  if (cat === "coffee") { return diqV101IsCoffeeVenue(item); }
  if (cat === "dessert") { return diqV101IsDessertVenue(item); }
  if (cat === "nightlife") { return diqV101IsNightlifeVenue(item); }
  if (cat === "waterfront") { return diqV101IsWaterfrontCandidate(item); }
  if (cat === "golf") { return diqV101IsGolfVenue(item); }




  /* For Local Favorites / Hidden Gems / Outdoors / general scans, do not force
     a strict allowlist, but always remove civic/service/industrial junk. */
  if (diqV101IsAlwaysBadExperience(item)) { return false; }




  return true;
}




function diqV101FinalTruthGate(items, query, stage) {
  var source = items || [];
  var out = [];
  var seen = {};
  var i;
  var item;
  var key;
  var q = diqV101ActiveQuery(query);




  for (i = 0; i < source.length; i++) {
    item = source[i];
    if (!item) { continue; }




    if (!diqV101PassesFinalTruth(item, q)) {
      try {
        console.warn("[Adventure V101 final truth reject]", {
          stage:String(stage || "final_truth_gate"),
          query:q,
          category:diqV101ActiveCategory(q),
          label:item.label || item.name || "",
          categoryText:item.category || item.kind || item.matchLabel || ""
        });
      } catch (e0) {}
      continue;
    }




    key = normText(String(item.label || item.name || "") + "|" + String(item.full || item.address || "") + "|" + String(item.lat || "") + "," + String(item.lng || ""));
    if (key && seen[key]) { continue; }
    seen[key] = true;
    out.push(item);
  }




  return out;
}




function diqV101PreferredFrom(guarded, preferred, query) {
  if (preferred && diqV101PassesFinalTruth(preferred, query)) { return preferred; }
  return guarded && guarded.length ? guarded[0] : null;
}




var diqV101PriorScanAdventureChoices = scanAdventureChoices;
scanAdventureChoices = function(query) {
  diqV101LastTruthQuery = clean(query || activeLens || "");
  return diqV101PriorScanAdventureChoices.apply(this, arguments);
};




if (typeof diqV73SetCanonicalResults === "function") {
  var diqV101PriorV73SetCanonicalResults = diqV73SetCanonicalResults;
  diqV73SetCanonicalResults = function(items, query) {
    var q = diqV101ActiveQuery(query);
    var guarded = diqV101FinalTruthGate(items || [], q, "before_canonical_commit");
    return diqV101PriorV73SetCanonicalResults(guarded, q);
  };
}




var diqV101PriorRenderResultPins = renderResultPins;
renderResultPins = function(items, preferred) {
  var q = diqV101ActiveQuery("");
  var guarded = diqV101FinalTruthGate(items || [], q, "render_pins");
  var safePreferred = diqV101PreferredFrom(guarded, preferred, q);




  adventureResults = guarded.slice(0);
  adventurePreferred = safePreferred;




  try { window.DRIVE_IQ_FINAL_TRUTH_RESULTS = guarded.slice(0); } catch (e0) {}




  return diqV101PriorRenderResultPins(guarded, safePreferred);
};




var diqV101PriorRenderAdventureScanChoices = renderAdventureScanChoices;
renderAdventureScanChoices = function(items, query) {
  var q = diqV101ActiveQuery(query);
  var guarded = diqV101FinalTruthGate(items || [], q, "render_cards");




  adventureResults = guarded.slice(0);
  adventurePreferred = diqV101PreferredFrom(guarded, adventurePreferred, q);




  return diqV101PriorRenderAdventureScanChoices(guarded, q);
};




var diqV101PriorAfterScanResultsReady = afterScanResultsReady;
afterScanResultsReady = function(items, preferred, reason) {
  var q = diqV101ActiveQuery("");
  var guarded = diqV101FinalTruthGate(items || [], q, "after_scan_ready");
  var safePreferred = diqV101PreferredFrom(guarded, preferred, q);




  adventureResults = guarded.slice(0);
  adventurePreferred = safePreferred;




  return diqV101PriorAfterScanResultsReady(guarded, safePreferred, reason);
};




if (typeof renderAdventureResults === "function") {
  var diqV101PriorRenderAdventureResults = renderAdventureResults;
  renderAdventureResults = function() {
    var q = diqV101ActiveQuery("");
    adventureResults = diqV101FinalTruthGate(adventureResults || [], q, "render_results_boundary");
    adventurePreferred = diqV101PreferredFrom(adventureResults, adventurePreferred, q);
    return diqV101PriorRenderAdventureResults.apply(this, arguments);
  };
}




try {
  console.log("âœ… Drive IQ Adventure V101 Final Truth Gate loaded", {
    build:window.DRIVE_IQ_ADVENTURE_MODE_BUILD,
    rule:"truth first, volume second; pins/cards share the same final verified result set"
  });
} catch (e101) {}








window.DRIVE_IQ_ADVENTURE_MODE_BUILD = "V99_SCAN_LIST_THUMBNAIL_AUTHORITY";




diqV89Boot();










/* =========================================================
   DRIVE IQ ADVENTURE MODE V106
   Card/Pin Sync + No Blank Thumbnails + Better Why Copy
   Passive presentation authority only.
   - Does not change provider pulls.
   - Does not change Scan Engine truth.
   - Does not change route handoff.
========================================================= */


(function(){
  "use strict";


  if(window.__DRIVE_IQ_ADVENTURE_V106_PRESENTATION_TRUST__){ return; }
  window.__DRIVE_IQ_ADVENTURE_V106_PRESENTATION_TRUST__ = true;


  function diqV106Clean(v){
    return String(v || "").replace(/\s+/g," ").trim();
  }


  function diqV106Norm(v){
    return diqV106Clean(v).toLowerCase().replace(/[^a-z0-9]+/g," ").replace(/\s+/g," ").trim();
  }


  function diqV106ItemKey(item){
    if(!item){ return ""; }
    return diqV106Norm(
      String(item.placeId || item.googlePlaceId || item.mapboxId || item.id || "") + "|" +
      String(item.label || item.name || "") + "|" +
      String(item.full || item.address || "") + "|" +
      String(item.lat || "") + "|" +
      String(item.lng || "")
    );
  }


  function diqV106CategoryArt(item, query){
    var txt = diqV106Norm(
      String(query || "") + " " +
      String(item && (item.userFacingCategory || item.category || item.kind || item.type) || "") + " " +
      String(item && (item.label || item.name || item.full) || "")
    );


    if(/\bcoffee|cafe|espresso|latte|roaster\b/.test(txt)){
      return "linear-gradient(135deg,rgba(18,10,4,.88),rgba(255,206,105,.28)),url('https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?auto=format&fit=crop&w=900&q=80')";
    }
    if(/\bpizza|restaurant|food|burger|bbq|barbecue|taco|seafood|grill|grille|diner|kitchen|sushi|wings|chicken|catfish\b/.test(txt)){
      return "linear-gradient(135deg,rgba(10,6,4,.88),rgba(255,206,105,.24)),url('https://images.unsplash.com/photo-1514933651103-005eec06c04b?auto=format&fit=crop&w=900&q=80')";
    }
    if(/\bgolf|course|country club|links\b/.test(txt)){
      return "linear-gradient(135deg,rgba(2,18,12,.88),rgba(40,255,190,.22)),url('https://images.unsplash.com/photo-1535131749006-b7f58c99034b?auto=format&fit=crop&w=900&q=80')";
    }
    if(/\blake|marina|waterfront|beach|river|boat|fishing\b/.test(txt)){
      return "linear-gradient(135deg,rgba(2,11,22,.88),rgba(0,229,255,.25)),url('https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=900&q=80')";
    }
    if(/\bpark|trail|outdoor|scenic|nature|greenway\b/.test(txt)){
      return "linear-gradient(135deg,rgba(2,18,11,.88),rgba(40,255,190,.20)),url('https://images.unsplash.com/photo-1441974231531-c6227db76b6e?auto=format&fit=crop&w=900&q=80')";
    }


    return "linear-gradient(135deg,rgba(6,12,22,.92),rgba(0,229,255,.18)),url('https://images.unsplash.com/photo-1500534314209-a25ddb2bd429?auto=format&fit=crop&w=900&q=80')";
  }


  function diqV106SpecificWhy(item, query){
    var name = diqV106Clean(item && (item.label || item.name) || "This stop");
    var cat = diqV106Norm(String(query || "") + " " + String(item && (item.userFacingCategory || item.category || item.kind || "") || "") + " " + name);
    var dist = item && (item.distMiles || item.distanceMiles);
    var place = "";
    var d = Number(dist);


    if(isFinite(d)){
      place = d < 1 ? "very close by" : (Math.round(d * 10) / 10) + " miles away";
    }


    if(/\bpizza\b/.test(cat)){ return "Pizza pick " + (place ? place + " " : "") + "with strong Food IQ confidence."; }
    if(/\bbbq|barbecue|smokehouse\b/.test(cat)){ return "BBQ stop " + (place ? place + " " : "") + "with strong category confidence."; }
    if(/\btaco|mexican\b/.test(cat)){ return "Mexican food pick " + (place ? place + " " : "") + "worth checking before you route."; }
    if(/\bseafood|catfish|fish\b/.test(cat)){ return "Seafood pick " + (place ? place + " " : "") + "with strong Food IQ fit."; }
    if(/\bcoffee|cafe|espresso|roaster\b/.test(cat)){ return "Coffee stop " + (place ? place + " " : "") + "with strong Coffee IQ fit."; }
    if(/\bgolf|course|country club|links\b/.test(cat)){ return "Golf pick " + (place ? place + " " : "") + "that fits this scan."; }
    if(/\blake|marina|waterfront|beach|river\b/.test(cat)){ return "Waterfront/outdoor pick " + (place ? place + " " : "") + "worth exploring."; }
    if(/\bpark|trail|scenic|nature\b/.test(cat)){ return "Outdoor pick " + (place ? place + " " : "") + "with strong Adventure IQ fit."; }
    if(/\bbar|pub|brewery|nightlife|live music\b/.test(cat)){ return "Nightlife pick " + (place ? place + " " : "") + "with strong local fit."; }


    return name + " matched this scan with strong place and category confidence.";
  }


  function diqV106PatchItem(item, query){
    if(!item){ return item; }


    item.diqV106Key = item.diqV106Key || diqV106ItemKey(item);
    item.recommendedBecause = diqV106SpecificWhy(item, query || item.query || item.sourceQuery || "");
    item.why = item.recommendedBecause;
    item.reason = item.recommendedBecause;


    if(!diqV106Clean(item.photoUrl || item.imageUrl || item.thumbnailUrl || "")){
      item.photoFallback = diqV106CategoryArt(item, query || item.query || "");
      item.photoFallbackSource = "v106_category_art";
    }


    return item;
  }


  function diqV106PatchResultsArray(arr, query){
    var i;
    if(!arr || !arr.length){ return arr; }
    for(i = 0; i < arr.length; i += 1){
      arr[i] = diqV106PatchItem(arr[i], query);
    }
    return arr;
  }


  function diqV106ApplyDomFallbacks(){
    var cards;
    var i;
    var card;
    var imgBox;
    var title;
    var why;
    var fallback;


    try{
      cards = document.querySelectorAll(".diqPlaceCard,.diqAdventureCard,.diqResultCard,.adventurePlaceCard,.diqStopCard,[data-place-idx],[data-result-idx]");
    }catch(e){
      cards = [];
    }


    for(i = 0; i < cards.length; i += 1){
      card = cards[i];


      try{
        card.setAttribute("data-diq-v106-card","1");
        if(!card.getAttribute("data-diq-card-key")){
          title = card.querySelector(".diqPlaceName,.diqCardTitle,.diqStopName,.name,.title,h2,h3");
          card.setAttribute("data-diq-card-key",diqV106Norm(title ? title.textContent : card.textContent).slice(0,80));
        }


        imgBox = card.querySelector(".diqPlaceThumb,.diqPhoto,.diqCardPhoto,.diqHeroPhoto,.diqStopThumb,.thumb,.photo,[data-photo]");
        if(imgBox){
          fallback = "linear-gradient(135deg,rgba(6,12,22,.94),rgba(255,206,105,.24)),url('https://images.unsplash.com/photo-1514933651103-005eec06c04b?auto=format&fit=crop&w=900&q=80')";
          if(!imgBox.style.backgroundImage || imgBox.style.backgroundImage === "none"){
            imgBox.style.backgroundImage = fallback;
            imgBox.style.backgroundSize = "cover";
            imgBox.style.backgroundPosition = "center";
            imgBox.setAttribute("data-diq-photo-fallback","v106");
          }
        }


        why = card.querySelector(".diqWhy,.diqReason,.diqPlaceWhy,.recommendedBecause,.diqCardSub,.sub");
        if(why && /food-first local pick worth considering/i.test(why.textContent || "")){
          title = card.querySelector(".diqPlaceName,.diqCardTitle,.diqStopName,.name,.title,h2,h3");
          why.textContent = diqV106Clean(title ? title.textContent : "This stop") + " matched this scan with strong place and category confidence.";
          why.setAttribute("data-diq-v106-why","1");
        }
      }catch(cardErr){}
    }
  }


  function diqV106HighlightCard(key){
    var cards;
    var pins;
    var i;


    key = diqV106Norm(key);
    if(!key){ return; }


    try{ cards = document.querySelectorAll("[data-diq-card-key],[data-place-idx],[data-result-idx]"); }catch(e1){ cards = []; }
    try{ pins = document.querySelectorAll("[data-diq-pin-key],[data-place-idx],[data-result-idx],.mapboxgl-marker"); }catch(e2){ pins = []; }


    for(i = 0; i < cards.length; i += 1){
      try{ cards[i].classList.remove("diqV106ActiveCard"); }catch(e3){}
      try{
        if(diqV106Norm(cards[i].getAttribute("data-diq-card-key") || cards[i].getAttribute("data-place-idx") || cards[i].getAttribute("data-result-idx") || "").indexOf(key) > -1){
          cards[i].classList.add("diqV106ActiveCard");
          if(cards[i].scrollIntoView){ cards[i].scrollIntoView({behavior:"smooth",block:"nearest",inline:"nearest"}); }
        }
      }catch(e4){}
    }


    for(i = 0; i < pins.length; i += 1){
      try{ pins[i].classList.remove("diqV106ActivePin"); }catch(e5){}
      try{
        if(diqV106Norm(pins[i].getAttribute("data-diq-pin-key") || pins[i].getAttribute("data-place-idx") || pins[i].getAttribute("data-result-idx") || "").indexOf(key) > -1){
          pins[i].classList.add("diqV106ActivePin");
        }
      }catch(e6){}
    }
  }


  function diqV106InstallStyles(){
    var css;
    var style;


    if(document.getElementById("diqV106AdventurePresentationStyles")){ return; }


    css = ""
      + ".diqV106ActiveCard{border-color:rgba(40,255,190,.78)!important;box-shadow:0 0 0 1px rgba(40,255,190,.30),0 0 28px rgba(40,255,190,.20)!important;}"
      + ".diqV106ActivePin{filter:drop-shadow(0 0 10px rgba(40,255,190,.95)) drop-shadow(0 0 24px rgba(0,229,255,.55))!important;transform:scale(1.12)!important;z-index:20!important;}"
      + "[data-diq-photo-fallback='v106']{background-color:#1a1410!important;}";


    style = document.createElement("style");
    style.id = "diqV106AdventurePresentationStyles";
    style.appendChild(document.createTextNode(css));
    try{ document.head.appendChild(style); }catch(e){}
  }


  function diqV106WrapScanEngine(){
    var engine = window.DriveIQScanEngine;
    var oldScan;


    if(!engine || !engine.scan || engine.__diqV106Wrapped){ return false; }


    oldScan = engine.scan;
    engine.scan = function(options){
      var result = oldScan.call(engine, options || {});
      try{
        if(result && result.results){
          result.results = diqV106PatchResultsArray(result.results, (options && (options.query || options.intent || options.category)) || "");
        }
      }catch(e){}
      return result;
    };


    engine.__diqV106Wrapped = true;
    return true;
  }


  function diqV106WrapRenderFunctions(){
    var names = [
      "renderAdventureResults",
      "renderResults",
      "renderPlaceCards",
      "renderAdventureCards",
      "renderScanResults",
      "showAdventureResults"
    ];
    var i;
    var name;
    var oldFn;


    for(i = 0; i < names.length; i += 1){
      name = names[i];


      try{
        oldFn = window[name];
        if(typeof oldFn === "function" && !oldFn.__diqV106Wrapped){
          window[name] = (function(fn){
            var wrapped = function(){
              var result;
              try{
                if(arguments && arguments.length && arguments[0] && arguments[0].length){
                  diqV106PatchResultsArray(arguments[0],"");
                }
              }catch(e1){}


              result = fn.apply(this,arguments);


              try{ window.setTimeout(diqV106ApplyDomFallbacks,80); }catch(e2){}
              try{ window.setTimeout(diqV106ApplyDomFallbacks,450); }catch(e3){}


              return result;
            };
            wrapped.__diqV106Wrapped = true;
            return wrapped;
          })(oldFn);
        }
      }catch(e){}
    }
  }


  function diqV106InstallClickSync(){
    if(window.__DRIVE_IQ_ADVENTURE_V106_CLICK_SYNC__){ return; }
    window.__DRIVE_IQ_ADVENTURE_V106_CLICK_SYNC__ = true;


    document.addEventListener("click",function(ev){
      var el = ev && ev.target ? ev.target : null;
      var steps = 0;
      var key = "";


      while(el && el !== document && steps < 8){
        try{
          key = el.getAttribute && (
            el.getAttribute("data-diq-card-key") ||
            el.getAttribute("data-diq-pin-key") ||
            el.getAttribute("data-place-idx") ||
            el.getAttribute("data-result-idx")
          );
          if(key){
            diqV106HighlightCard(key);
            return;
          }
        }catch(e){}
        el = el.parentNode;
        steps += 1;
      }
    },true);
  }


  function diqV106Boot(){
    diqV106InstallStyles();
    diqV106WrapScanEngine();
    diqV106WrapRenderFunctions();
    diqV106InstallClickSync();
    diqV106ApplyDomFallbacks();


    try{ window.setTimeout(diqV106Boot,700); }catch(e){}
  }


  window.DriveIQAdventureV106PatchResults = diqV106PatchResultsArray;
  window.DriveIQAdventureV106ApplyDomFallbacks = diqV106ApplyDomFallbacks;


  diqV106Boot();


  try{ console.log("âœ… Drive IQ Adventure V106 presentation trust loaded"); }catch(e){}






/* =========================================================
   DRIVE IQ ADVENTURE MODE V107
   Visible Thumbnail Authority + Render-Level Why Copy
   Fixes the real shelf thumbnail surface:
   #diqAdventureDestResults .diqDestItem[data-adv-idx] .diqDestThumb
========================================================= */


(function(){
  "use strict";


  if(window.__DRIVE_IQ_ADVENTURE_V107_VISIBLE_THUMB_AUTHORITY__){ return; }
  window.__DRIVE_IQ_ADVENTURE_V107_VISIBLE_THUMB_AUTHORITY__ = true;


  function v107Clean(v){
    return String(v || "").replace(/\s+/g," ").trim();
  }


  function v107Norm(v){
    return v107Clean(v).toLowerCase().replace(/[^a-z0-9]+/g," ").replace(/\s+/g," ").trim();
  }


  function v107CategoryImage(item, query){
    var txt = v107Norm(
      String(query || "") + " " +
      String(item && (item.label || item.name || item.full || "") || "") + " " +
      String(item && (item.userFacingCategory || item.category || item.kind || item.type || "") || "")
    );


    if(/\bcoffee|cafe|cafÃ©|espresso|latte|roaster|bakery|donut\b/.test(txt)){
      return "https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?auto=format&fit=crop&w=700&q=82";
    }


    if(/\bpizza\b/.test(txt)){
      return "https://images.unsplash.com/photo-1513104890138-7c749659a591?auto=format&fit=crop&w=700&q=82";
    }


    if(/\bbbq|barbecue|smokehouse|ribs|brisket\b/.test(txt)){
      return "https://images.unsplash.com/photo-1529193591184-b1d58069ecdd?auto=format&fit=crop&w=700&q=82";
    }


    if(/\btaco|mexican\b/.test(txt)){
      return "https://images.unsplash.com/photo-1565299585323-38d6b0865b47?auto=format&fit=crop&w=700&q=82";
    }


    if(/\bseafood|fish|catfish|shrimp|oyster\b/.test(txt)){
      return "https://images.unsplash.com/photo-1559737558-2f5a35f4523b?auto=format&fit=crop&w=700&q=82";
    }


    if(/\bburger|sandwich|wings|chicken|grill|grille|restaurant|food|diner|kitchen|bistro|steak|sushi\b/.test(txt)){
      return "https://images.unsplash.com/photo-1514933651103-005eec06c04b?auto=format&fit=crop&w=700&q=82";
    }


    if(/\bgolf|course|country club|links\b/.test(txt)){
      return "https://images.unsplash.com/photo-1535131749006-b7f58c99034b?auto=format&fit=crop&w=700&q=82";
    }


    if(/\blake|marina|waterfront|beach|river|boat|fishing\b/.test(txt)){
      return "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=700&q=82";
    }


    if(/\bpark|trail|outdoor|scenic|nature|greenway\b/.test(txt)){
      return "https://images.unsplash.com/photo-1441974231531-c6227db76b6e?auto=format&fit=crop&w=700&q=82";
    }


    return "https://images.unsplash.com/photo-1500534314209-a25ddb2bd429?auto=format&fit=crop&w=700&q=82";
  }


  function v107BestPhoto(item, query){
    var keys = [
      "photoUrl","photo_url","imageUrl","image_url","thumbnailUrl","thumbnail_url",
      "heroPhoto","hero_photo","officialPhoto","official_photo","googlePhotoUrl","google_photo_url"
    ];
    var i;
    var v;


    for(i = 0; i < keys.length; i += 1){
      v = item && item[keys[i]];
      if(v && String(v).indexOf("http") === 0){ return String(v); }
    }


    return v107CategoryImage(item, query);
  }


  function v107Why(item, query){
    var txt = v107Norm(String(query || "") + " " + String(item && (item.label || item.name || item.full || item.category || item.userFacingCategory || "") || ""));
    var d = item && (item.distMiles || item.distanceMiles);
    var dist = "";
    var n = Number(d);


    if(isFinite(n)){
      dist = n < 1 ? "nearby" : (Math.round(n * 10) / 10) + " miles away";
    }


    if(/\bpizza\b/.test(txt)){ return "Pizza pick " + (dist ? dist + " " : "") + "with strong Food IQ confidence."; }
    if(/\bbbq|barbecue|smokehouse\b/.test(txt)){ return "BBQ stop " + (dist ? dist + " " : "") + "with strong Food IQ confidence."; }
    if(/\btaco|mexican\b/.test(txt)){ return "Mexican food pick " + (dist ? dist + " " : "") + "worth checking before you route."; }
    if(/\bseafood|fish|catfish|shrimp|oyster\b/.test(txt)){ return "Seafood pick " + (dist ? dist + " " : "") + "with strong Food IQ fit."; }
    if(/\bcoffee|cafe|espresso|roaster\b/.test(txt)){ return "Coffee stop " + (dist ? dist + " " : "") + "with strong Coffee IQ fit."; }
    if(/\bbar|pub|brewery|nightlife|live music\b/.test(txt)){ return "Nightlife pick " + (dist ? dist + " " : "") + "with strong local fit."; }


    return "Strong place and category match for this scan.";
  }


  function v107PatchItems(items, query){
    var i;
    var item;
    if(!items || !items.length){ return items; }


    for(i = 0; i < items.length; i += 1){
      item = items[i];
      if(!item){ continue; }


      item.photoUrl = v107BestPhoto(item, query || item.query || item.sourceQuery || "");
      item.thumbnailUrl = item.thumbnailUrl || item.photoUrl;
      item.whyStop = v107Why(item, query || item.query || item.sourceQuery || "");
      item.recommendedBecause = item.whyStop;
      item.reason = item.whyStop;
    }


    return items;
  }


  function v107PaintShelf(items, query){
    var nodes;
    var i;
    var node;
    var idx;
    var item;
    var thumb;
    var sub;
    var url;


    try{
      nodes = document.querySelectorAll("#diqAdventureDestResults .diqDestItem[data-adv-idx]");
    }catch(e0){
      nodes = [];
    }


    for(i = 0; i < nodes.length; i += 1){
      node = nodes[i];
      idx = Number(node.getAttribute("data-adv-idx"));
      item = items && items[idx] ? items[idx] : null;


      try{
        thumb = node.querySelector(".diqDestThumb");
        if(thumb){
          url = v107BestPhoto(item || {}, query || "");
          thumb.className = String(thumb.className || "").replace(/\bdiqV99Fallback\b/g,"") + " diqV107VisibleThumb";
          thumb.style.setProperty("background-image","linear-gradient(135deg,rgba(2,8,18,.18),rgba(2,8,18,.42)),url('" + url.replace(/'/g,"%27") + "')","important");
          thumb.style.setProperty("background-size","cover","important");
          thumb.style.setProperty("background-position","center","important");
          thumb.style.setProperty("background-color","#101a24","important");
          thumb.setAttribute("data-photo-loaded","v107");
          node.setAttribute("data-photo-loaded","v107");
        }


        sub = node.querySelector(".diqDestSub");
        if(sub && item){
          sub.textContent = v107Why(item, query || "");
          sub.setAttribute("data-diq-v107-why","1");
        }else if(sub && /food-first local pick worth considering/i.test(sub.textContent || "")){
          sub.textContent = "Strong place and category match for this Food IQ scan.";
          sub.setAttribute("data-diq-v107-why","1");
        }
      }catch(e1){}
    }
  }


  function v107InstallStyles(){
    var style;
    var css;


    if(document.getElementById("diqV107VisibleThumbStyles")){ return; }


    css =
      "#diqAdventureDestResults .diqDestThumb.diqV107VisibleThumb{display:block!important;background-size:cover!important;background-position:center!important;background-repeat:no-repeat!important;}" +
      "#diqAdventureDestResults .diqDestThumb.diqV107VisibleThumb:before{display:none!important;}" +
      "#diqAdventureDestResults .diqDestThumb.diqV107VisibleThumb:after{content:'PHOTO IQ';position:absolute;left:6px;right:6px;bottom:6px;height:16px;border-radius:999px;background:rgba(2,8,18,.62);color:rgba(255,255,255,.88);font:900 6.8px/16px -apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;letter-spacing:.7px;text-align:center;}" +
      "#diqAdventureDestResults .diqDestSub[data-diq-v107-why='1']{color:rgba(238,248,255,.84)!important;}";


    style = document.createElement("style");
    style.id = "diqV107VisibleThumbStyles";
    style.type = "text/css";
    style.appendChild(document.createTextNode(css));
    try{ document.head.appendChild(style); }catch(e){}
  }


  v107InstallStyles();


  try{
    if(typeof renderAdventureScanChoices === "function" && !renderAdventureScanChoices.__diqV107Wrapped){
      var oldRenderAdventureScanChoices = renderAdventureScanChoices;
      renderAdventureScanChoices = function(items, query){
        var patched = v107PatchItems(items || [], query || activeLens);
        var result = oldRenderAdventureScanChoices(patched, query);
        window.setTimeout(function(){ v107PaintShelf(patched, query || activeLens); }, 40);
        window.setTimeout(function(){ v107PaintShelf(patched, query || activeLens); }, 280);
        window.setTimeout(function(){ v107PaintShelf(patched, query || activeLens); }, 1200);
        return result;
      };
      renderAdventureScanChoices.__diqV107Wrapped = true;
    }
  }catch(e2){}


  try{
    window.DriveIQAdventureV107PaintShelf = v107PaintShelf;
  }catch(e3){}


  try{ console.log("âœ… Drive IQ Adventure V107 visible thumbnail authority loaded"); }catch(e4){}
}());








/* =========================================================
   DRIVE IQ ADVENTURE MODE V108
   ENTITY SEARCH AUTHORITY + DISTRICT IQ PRESENTATION BRIDGE


   What this patch does:
   - Puts known Entity IQ / District IQ records above generic autocomplete.
   - Stops "Village, AR/TX" from outranking "HarborWalk Village".
   - Renders district metadata in destination chooser cards.
   - Carries district entity data into routeDestinationResult.
   - Adds district thumbnail preview data for the next UI expansion pass.
   - ES5-safe. No optional chaining. No arrow functions. No template literals.
========================================================= */


window.__DRIVE_IQ_ADVENTURE_MODE_JS_V108_DISTRICT_IQ_PRESENTATION__ = true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD = "V108_DISTRICT_IQ_ENTITY_SEARCH_PRESENTATION";


var DIQ_V108_DISTRICT_REGISTRY = [
  {
    id:"harborwalk_village_destin",
    label:"HarborWalk Village",
    aliases:["harborwalk village","harbor walk village","destin harborwalk","destin harbor walk","harborwalk destin","harbor walk destin"],
    city:"Destin",
    state:"FL",
    lat:30.3935,
    lng:-86.5104,
    districtType:"adventure",
    districtLabel:"Adventure District",
    experienceCount:18,
    tags:["waterfront","restaurants","nightlife","shopping","live music","activities"],
    summary:"Waterfront restaurants, bars, shopping, live music, and harbor activities in one walkable destination.",
    topPlaceNames:["AJ's Seafood & Oyster Bar","Harry T's","Margaritaville","Coyote Ugly","Tailfins","Dewey Destin's"],
    searchBoost:1200
  },
  {
    id:"destin_commons",
    label:"Destin Commons",
    aliases:["destin commons","the destin commons"],
    city:"Destin",
    state:"FL",
    lat:30.3909,
    lng:-86.4271,
    districtType:"shopping",
    districtLabel:"Shopping District",
    experienceCount:45,
    tags:["shopping","restaurants","movies","family","coffee","retail"],
    summary:"Retail-first shopping district with stores, restaurants, coffee, movies, and family entertainment.",
    topPlaceNames:["Bass Pro Shops","AMC Destin Commons","Belk","H&M","Uncle Buck's FishBowl","Starbucks"],
    searchBoost:1120
  },
  {
    id:"silo_square_southaven",
    label:"Silo Square",
    aliases:["silo square","silo square southaven","silo square ms"],
    city:"Southaven",
    state:"MS",
    lat:34.9619,
    lng:-89.9907,
    districtType:"local",
    districtLabel:"Local District",
    experienceCount:12,
    tags:["restaurants","coffee","events","shops","patios","community"],
    summary:"Walkable local district with restaurants, coffee, events, shops, patios, and community gathering spots.",
    topPlaceNames:["Local restaurants","Coffee","Community events","Boutiques","Patios"],
    searchBoost:1050
  },
  {
    id:"beale_street_memphis",
    label:"Beale Street",
    aliases:["beale street","beale st","beale street memphis"],
    city:"Memphis",
    state:"TN",
    lat:35.1398,
    lng:-90.0524,
    districtType:"entertainment",
    districtLabel:"Entertainment District",
    experienceCount:25,
    tags:["nightlife","live music","bars","restaurants","tourism","walkable"],
    summary:"Iconic entertainment district with live music, bars, restaurants, and Memphis energy.",
    topPlaceNames:["B.B. King's Blues Club","Rum Boogie Cafe","Silky O'Sullivan's","A. Schwab","Handy Park"],
    searchBoost:1150
  },
  {
    id:"broadway_nashville",
    label:"Broadway Nashville",
    aliases:["broadway nashville","lower broadway","broadway downtown nashville","honky tonk highway"],
    city:"Nashville",
    state:"TN",
    lat:36.1611,
    lng:-86.7789,
    districtType:"entertainment",
    districtLabel:"Entertainment District",
    experienceCount:35,
    tags:["nightlife","live music","bars","restaurants","rooftops","walkable"],
    summary:"High-energy entertainment district with honky-tonks, live music, rooftop bars, and downtown Nashville energy.",
    topPlaceNames:["Tootsie's Orchid Lounge","The Stage","Robert's Western World","Acme Feed & Seed","Assembly Food Hall"],
    searchBoost:1160
  },
  {
    id:"the_square_oxford",
    label:"The Square",
    aliases:["the square oxford","oxford square","historic square oxford"],
    city:"Oxford",
    state:"MS",
    lat:34.3668,
    lng:-89.5192,
    districtType:"local",
    districtLabel:"Local District",
    experienceCount:20,
    tags:["restaurants","shopping","coffee","nightlife","books","walkable"],
    summary:"Walkable local district with restaurants, boutiques, coffee, bookstores, nightlife, and Oxford character.",
    topPlaceNames:["City Grocery","Ajax Diner","Square Books","Boure","Proud Larry's"],
    searchBoost:1060
  },
  {
    id:"downtown_gatlinburg",
    label:"Downtown Gatlinburg",
    aliases:["downtown gatlinburg","gatlinburg strip","the strip gatlinburg","gatlinburg downtown"],
    city:"Gatlinburg",
    state:"TN",
    lat:35.7110,
    lng:-83.5186,
    districtType:"adventure",
    districtLabel:"Adventure District",
    experienceCount:40,
    tags:["attractions","food","shopping","family","walkable","mountains"],
    summary:"Walkable mountain-town district with attractions, food, shops, family activities, and Smoky Mountain energy.",
    topPlaceNames:["Anakeesta","Ripley's Aquarium","Ole Smoky","The Village Shops","SkyPark"],
    searchBoost:1120
  },
  {
    id:"disney_springs",
    label:"Disney Springs",
    aliases:["disney springs","downtown disney orlando"],
    city:"Lake Buena Vista",
    state:"FL",
    lat:28.3702,
    lng:-81.5197,
    districtType:"adventure",
    districtLabel:"Adventure District",
    experienceCount:80,
    tags:["shopping","restaurants","entertainment","family","nightlife","walkable"],
    summary:"Large entertainment, dining, and shopping district with restaurants, shops, shows, and family experiences.",
    topPlaceNames:["The Boathouse","World of Disney","Gideon's Bakehouse","Raglan Road","House of Blues"],
    searchBoost:1180
  },
  {
    id:"the_wharf_orange_beach",
    label:"The Wharf",
    aliases:["the wharf orange beach","the wharf","orange beach wharf"],
    city:"Orange Beach",
    state:"AL",
    lat:30.2946,
    lng:-87.6289,
    districtType:"adventure",
    districtLabel:"Adventure District",
    experienceCount:25,
    tags:["waterfront","restaurants","shopping","events","amphitheater","family","nightlife"],
    summary:"Waterfront adventure district with restaurants, shops, events, concerts, activities, and marina energy.",
    topPlaceNames:["The Wharf Amphitheater","Villaggio Grille","YoHo Rum & Tacos","Ferris Wheel","Marina"],
    searchBoost:1125
  }
];


function diqV108Norm(v) { return normText(v || ""); }
function diqV108Clean(v) { return clean(v || ""); }


function diqV108DistanceToFix(lat, lng) {
  var d = null;
  try { d = distanceMilesFromLastFix(lat, lng); } catch (e0) { d = null; }
  return finite(Number(d)) ? Number(d) : null;
}


function diqV108DistrictAliasScore(entity, query) {
  var q = diqV108Norm(query);
  var i;
  var alias;
  var score = 0;
  if (!q || !entity) { return 0; }


  if (diqV108Norm(entity.label) === q) { score = Math.max(score, 1000); }


  for (i = 0; i < (entity.aliases || []).length; i++) {
    alias = diqV108Norm(entity.aliases[i]);
    if (!alias) { continue; }
    if (q === alias) { score = Math.max(score, 1000); }
    else if (alias.indexOf(q) === 0 && q.length >= 4) { score = Math.max(score, 860); }
    else if (q.indexOf(alias) > -1) { score = Math.max(score, 820); }
    else if (alias.indexOf(q) > -1 && q.length >= 6) { score = Math.max(score, 760); }
  }


  return score;
}


function diqV108DistrictForQuery(query) {
  var best = null;
  var bestScore = 0;
  var i;
  var score;
  var d;


  for (i = 0; i < DIQ_V108_DISTRICT_REGISTRY.length; i++) {
    score = diqV108DistrictAliasScore(DIQ_V108_DISTRICT_REGISTRY[i], query);
    if (score > 0) {
      d = diqV108DistanceToFix(DIQ_V108_DISTRICT_REGISTRY[i].lat, DIQ_V108_DISTRICT_REGISTRY[i].lng);
      if (finite(Number(d))) {
        if (d <= 75) { score += 90; }
        else if (d <= 250) { score += 55; }
        else if (d <= 600) { score += 20; }
      }
    }
    if (score > bestScore) {
      bestScore = score;
      best = DIQ_V108_DISTRICT_REGISTRY[i];
    }
  }


  return bestScore >= 740 ? best : null;
}


function diqV108DistrictItem(entity, query) {
  var dist = diqV108DistanceToFix(entity.lat, entity.lng);
  return {
    label:String(entity.label || "District"),
    full:String((entity.city || "") + (entity.state ? ", " + entity.state : "")),
    lat:Number(entity.lat),
    lng:Number(entity.lng),
    kind:"district",
    category:String(entity.districtLabel || "District"),
    resultType:"entity_iq_district",
    matchLabel:String(entity.districtLabel || "District IQ"),
    distMiles:finite(Number(dist)) ? dist : null,
    canonical:true,
    entityType:"district",
    entityClass:"district",
    districtId:String(entity.id || ""),
    districtType:String(entity.districtType || "adventure"),
    districtLabel:String(entity.districtLabel || "Adventure District"),
    districtSummary:String(entity.summary || ""),
    districtTags:entity.tags || [],
    experienceCount:Number(entity.experienceCount || 0),
    topPlaceNames:entity.topPlaceNames || [],
    districtThumbnailCards:diqV108DistrictThumbCards(entity),
    searchBoost:Number(entity.searchBoost || 1000),
    recommendedBecause:String(entity.districtLabel || "District") + " â€¢ " + String(entity.experienceCount || 0) + " experiences inside",
    query:String(query || "")
  };
}


function diqV108DistrictThumbCards(entity) {
  var out = [];
  var names = entity && entity.topPlaceNames ? entity.topPlaceNames : [];
  var i;
  var label;
  for (i = 0; i < names.length && i < 6; i++) {
    label = diqV108Clean(names[i]);
    if (!label) { continue; }
    out.push({
      label:label,
      entityType:"place_preview",
      category:diqV108DistrictThumbCategory(label, entity),
      parentDistrictId:String(entity.id || ""),
      recommendedBecause:"Top experience inside " + String(entity.label || "this district")
    });
  }
  return out;
}


function diqV108DistrictThumbCategory(label, entity) {
  var txt = diqV108Norm(String(label || "") + " " + ((entity && entity.tags) ? entity.tags.join(" ") : ""));
  if (txt.indexOf("coffee") > -1 || txt.indexOf("cafe") > -1 || txt.indexOf("brew") > -1 || txt.indexOf("starbucks") > -1) { return "Coffee"; }
  if (txt.indexOf("bar") > -1 || txt.indexOf("ugly") > -1 || txt.indexOf("tailfins") > -1 || txt.indexOf("pub") > -1 || txt.indexOf("music") > -1 || txt.indexOf("blues") > -1 || txt.indexOf("honky") > -1) { return "Nightlife"; }
  if (txt.indexOf("shop") > -1 || txt.indexOf("belk") > -1 || txt.indexOf("h m") > -1 || txt.indexOf("bass pro") > -1 || txt.indexOf("books") > -1 || txt.indexOf("boutique") > -1) { return "Shopping"; }
  if (txt.indexOf("watersports") > -1 || txt.indexOf("marina") > -1 || txt.indexOf("aquarium") > -1 || txt.indexOf("anakeesta") > -1 || txt.indexOf("skypark") > -1 || txt.indexOf("amphitheater") > -1 || txt.indexOf("ferris") > -1) { return "Activity"; }
  return "Food";
}


function diqV108IsDistrictItem(item) {
  return !!(item && (item.entityType === "district" || item.resultType === "entity_iq_district" || item.kind === "district" || item.districtId));
}


function diqV108EntityMeta(item) {
  if (!diqV108IsDistrictItem(item)) { return ""; }
  return String(item.districtLabel || item.matchLabel || "District IQ") + " â€¢ " + String(item.experienceCount || 0) + " experiences";
}


function diqV108SortEntityResults(items, query) {
  var q = diqV108Norm(query);
  var arr = (items || []).slice(0);
  arr.sort(function(a, b) {
    var sa = 0;
    var sb = 0;
    var al = diqV108Norm(a && a.label || "");
    var bl = diqV108Norm(b && b.label || "");


    if (diqV108IsDistrictItem(a)) { sa += Number(a.searchBoost || 1000); }
    if (diqV108IsDistrictItem(b)) { sb += Number(b.searchBoost || 1000); }


    if (al === q) { sa += 350; }
    if (bl === q) { sb += 350; }
    if (al.indexOf(q) === 0 && q.length >= 4) { sa += 160; }
    if (bl.indexOf(q) === 0 && q.length >= 4) { sb += 160; }


    if (String(a && a.kind || "").toLowerCase().indexOf("street") > -1) { sa -= 260; }
    if (String(b && b.kind || "").toLowerCase().indexOf("street") > -1) { sb -= 260; }
    if (diqV108Norm(a && a.resultType || "").indexOf("admin") > -1) { sa -= 260; }
    if (diqV108Norm(b && b.resultType || "").indexOf("admin") > -1) { sb -= 260; }


    return sb - sa;
  });
  return arr;
}


/* Search IQ must consult Entity IQ before generic autocomplete. */
function diqV108EntityQueryResults(query) {
  var entity = diqV108DistrictForQuery(query);
  if (!entity) { return []; }
  return [diqV108DistrictItem(entity, query)];
}


/* Patch renderDestinationResults so District IQ cards are visibly different
   and known entities remain above generic street/locality matches. */
var diqV108PriorRenderDestinationResults = renderDestinationResults;
renderDestinationResults = function(results, query) {
  var entityResults = diqV108EntityQueryResults(query);
  var merged = [];
  var i;
  var seen = {};
  var key;


  for (i = 0; i < entityResults.length; i++) {
    key = diqV108Norm(entityResults[i].label + " " + entityResults[i].full);
    seen[key] = true;
    merged.push(entityResults[i]);
  }


  for (i = 0; i < (results || []).length; i++) {
    key = diqV108Norm(String(results[i] && results[i].label || "") + " " + String(results[i] && results[i].full || ""));
    if (key && seen[key]) { continue; }
    merged.push(results[i]);
  }


  merged = diqV108SortEntityResults(merged, query);
  diqV108PriorRenderDestinationResults(merged, query);
  window.setTimeout(function(){ diqV108DecorateDestinationCards(query); }, 40);
  window.setTimeout(function(){ diqV108DecorateDestinationCards(query); }, 280);
};


function diqV108DecorateDestinationCards(query) {
  var nodes;
  var i;
  var node;
  var idx;
  var item;
  var meta;
  var sub;
  var name;


  try { nodes = document.querySelectorAll("#diqAdventureDestResults .diqDestItem[data-dest-idx]"); } catch (e0) { nodes = []; }


  for (i = 0; i < nodes.length; i++) {
    node = nodes[i];
    idx = Number(node.getAttribute("data-dest-idx"));
    item = destinationSearchResults && destinationSearchResults[idx] ? destinationSearchResults[idx] : null;
    if (!diqV108IsDistrictItem(item)) { continue; }


    node.className = String(node.className || "") + " diqDistrictDestItem";
    node.setAttribute("data-entity-type", "district");
    node.setAttribute("data-district-type", String(item.districtType || "adventure"));


    try {
      name = node.querySelector(".diqDestName");
      sub = node.querySelector(".diqDestSub");
      meta = node.querySelector(".diqDestMeta");


      if (name) { name.innerHTML = '<span class="diqDistrictBadgeSmall">â˜… ' + escapeHTML(item.districtLabel || "District") + '</span><br>' + escapeHTML(item.label || "District"); }
      if (sub) { sub.textContent = item.districtSummary || (String(item.experienceCount || 0) + " experiences inside"); }
      if (meta) { meta.textContent = diqV108EntityMeta(item); }
    } catch (e1) {}
  }
}


/* Patch scoreDestination so recognized Entity IQ matches outrank generic
   locality/street results before render. */
var diqV108PriorScoreDestination = scoreDestination;
scoreDestination = function(item, query) {
  var score = diqV108PriorScoreDestination(item, query);
  var entity = diqV108DistrictForQuery(query);
  var label = diqV108Norm(item && item.label || "");
  var kind = diqV108Norm(item && item.kind || "");
  var full = diqV108Norm(item && item.full || "");


  if (diqV108IsDistrictItem(item)) { score += Number(item.searchBoost || 1000); }


  if (entity) {
    if (label === diqV108Norm(entity.label)) { score += 1200; }
    if (full.indexOf(diqV108Norm(entity.city)) > -1 && label.indexOf("village") > -1 && label !== diqV108Norm(entity.label)) { score -= 420; }
    if (kind.indexOf("street") > -1 || kind.indexOf("road") > -1 || kind.indexOf("locality") > -1 || kind.indexOf("postcode") > -1) { score -= 600; }
  }


  return score;
};


/* Patch safety gate so District IQ entities can be auto-committed when exact. */
var diqV108PriorIsSafeAutoCommitDestination = isSafeAutoCommitDestination;
isSafeAutoCommitDestination = function(item, query) {
  if (diqV108IsDistrictItem(item)) { return true; }
  return diqV108PriorIsSafeAutoCommitDestination(item, query);
};


/* Patch resolveDestinationAndScan so exact district entities bypass generic
   autocomplete entirely. */
var diqV108PriorResolveDestinationAndScan = resolveDestinationAndScan;
resolveDestinationAndScan = function(query) {
  var q = diqV108Clean(query);
  var entity = diqV108DistrictForQuery(q);
  var item;


  if (entity && diqV108DistrictAliasScore(entity, q) >= 860) {
    item = diqV108DistrictItem(entity, q);
    dismissAdventureKeyboard();
    hideDestinationResults();
    routeDestinationResult(item);
    return;
  }


  return diqV108PriorResolveDestinationAndScan(query);
};


/* Patch route handoff so destination lock and destination payload keep
   district metadata instead of stripping it down to a plain place. */
var diqV108PriorRouteDestinationResult = routeDestinationResult;
routeDestinationResult = function(item) {
  if (diqV108IsDistrictItem(item)) {
    item.matchLabel = item.districtLabel || item.matchLabel || "District IQ";
    item.category = item.districtLabel || item.category || "District";
    item.kind = "district";
    item.full = item.full || item.districtSummary || "";
    try { lsJSON("diq_last_entity_iq_destination_v1", item); } catch (e0) {}
  }
  return diqV108PriorRouteDestinationResult(item);
};


/* Add district visual polish without touching existing card CSS. */
function diqV108InjectStyles() {
  var id = "diqV108DistrictIQStyles";
  var css;
  var style;


  if (byId(id)) { return; }


  css =
    ".diqDistrictDestItem{border-color:rgba(255,211,105,.65)!important;box-shadow:0 0 22px rgba(255,211,105,.13), inset 0 0 18px rgba(0,255,214,.06)!important;}" +
    ".diqDistrictBadgeSmall{display:inline-block;margin-bottom:4px;padding:3px 8px;border-radius:999px;background:linear-gradient(135deg,#ffe78a,#39f2bd);color:#071018;font-size:10px;letter-spacing:.14em;font-weight:900;text-transform:uppercase;}" +
    ".diqDistrictDestItem .diqDestMeta{color:#ffe78a!important;letter-spacing:.12em!important;text-transform:uppercase!important;}";


  style = document.createElement("style");
  style.id = id;
  style.type = "text/css";
  style.appendChild(document.createTextNode(css));
  try { document.head.appendChild(style); } catch (e0) {}
}


try { diqV108InjectStyles(); } catch (eV108Style) {}


try {
  window.DRIVE_IQ_ADVENTURE_V108_ENTITY_IQ = {
    build:"V108_DISTRICT_IQ_ENTITY_SEARCH_PRESENTATION",
    registry:DIQ_V108_DISTRICT_REGISTRY,
    find:diqV108DistrictForQuery,
    item:diqV108DistrictItem
  };
  console.log("âœ… Drive IQ Adventure V108 District IQ Search/Presentation loaded", window.DRIVE_IQ_ADVENTURE_MODE_BUILD);
} catch (eV108Log) {}








/* =========================================================
   DRIVE IQ ADVENTURE MODE V109
   DISTRICT EXPERIENCE CARDS + ENTITY REGISTRY UI BRIDGE


   Purpose:
   - If Scan Engine district payloads arrive, render them beautifully.
   - If Adventure Mode's older scan path bypasses Scan Engine, inject
     nearby known district entities directly into the result shelf.
   - Show top places inside district cards instead of hiding the value.
   - Keep Food/Coffee/Dinner/Dessert/Golf as individual place results.
   ES5 SAFE
========================================================= */


window.__DRIVE_IQ_ADVENTURE_MODE_JS_V109_DISTRICT_EXPERIENCE_CARDS__ = true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD = "V109_DISTRICT_EXPERIENCE_CARDS_ENTITY_UI_BRIDGE";


var DIQ_V109_DISTRICT_REGISTRY = [
  {
    id:"harborwalk_village_destin",
    label:"HarborWalk Village",
    city:"Destin",
    state:"FL",
    lat:30.3935,
    lng:-86.5104,
    radiusMiles:0.35,
    districtType:"adventure",
    districtLabel:"Waterfront Entertainment District",
    summary:"Walkable waterfront destination with restaurants, bars, shops, live music, boat tours, and harbor views.",
    tags:["Restaurants","Nightlife","Shopping","Activities","Waterfront"],
    topPlaceNames:["AJ's Seafood & Oyster Bar","Harry T's","Margaritaville","Coyote Ugly","Tailfins","Harbor Docks"],
    counts:{ restaurants:18, nightlife:12, shopping:11, activities:16, coffee:3 },
    worthScore:99,
    score:1400,
    intent:["general","local_favorites","hidden_gems","nightlife","family_fun"]
  },
  {
    id:"destin_commons",
    label:"Destin Commons",
    city:"Destin",
    state:"FL",
    lat:30.3909,
    lng:-86.4271,
    radiusMiles:0.35,
    districtType:"shopping",
    districtLabel:"Shopping District",
    summary:"Retail-first shopping and entertainment district with stores, restaurants, coffee, movies, and family activities.",
    tags:["Shopping","Restaurants","Coffee","Movies","Family"],
    topPlaceNames:["Bass Pro Shops","AMC Destin Commons","Belk","H&M","Uncle Buck's FishBowl","Starbucks"],
    counts:{ restaurants:14, nightlife:2, shopping:65, activities:5, coffee:6 },
    worthScore:96,
    score:1320,
    intent:["shopping","general","local_favorites","hidden_gems","family_fun"]
  },
  {
    id:"silo_square_southaven",
    label:"Silo Square",
    city:"Southaven",
    state:"MS",
    lat:34.9619,
    lng:-89.9907,
    radiusMiles:0.27,
    districtType:"local",
    districtLabel:"Local District",
    summary:"Walkable local district with restaurants, coffee, events, shops, patios, and community gathering spots.",
    tags:["Restaurants","Coffee","Events","Patios","Shopping"],
    topPlaceNames:["Local restaurants","Coffee","Community events","Boutiques","Patios"],
    counts:{ restaurants:8, nightlife:2, shopping:5, activities:4, coffee:2 },
    worthScore:93,
    score:1180,
    intent:["general","local_favorites","hidden_gems","shopping","family_fun"]
  },
  {
    id:"beale_street_memphis",
    label:"Beale Street",
    city:"Memphis",
    state:"TN",
    lat:35.1398,
    lng:-90.0524,
    radiusMiles:0.32,
    districtType:"entertainment",
    districtLabel:"Entertainment District",
    summary:"Iconic entertainment district with live music, restaurants, bars, and Memphis energy.",
    tags:["Nightlife","Live Music","Food","Bars","Walkable"],
    topPlaceNames:["B.B. King's Blues Club","Rum Boogie Cafe","Silky O'Sullivan's","A. Schwab","Handy Park"],
    counts:{ restaurants:18, nightlife:22, shopping:6, activities:10, coffee:2 },
    worthScore:98,
    score:1375,
    intent:["general","local_favorites","hidden_gems","nightlife"]
  },
  {
    id:"broadway_nashville",
    label:"Broadway Nashville",
    city:"Nashville",
    state:"TN",
    lat:36.1611,
    lng:-86.7789,
    radiusMiles:0.38,
    districtType:"entertainment",
    districtLabel:"Entertainment District",
    summary:"High-energy downtown district with honky-tonks, rooftops, live music, restaurants, and Nashville nightlife.",
    tags:["Nightlife","Live Music","Rooftops","Food","Walkable"],
    topPlaceNames:["Tootsie's Orchid Lounge","The Stage","Robert's Western World","Acme Feed & Seed","Assembly Food Hall"],
    counts:{ restaurants:24, nightlife:35, shopping:8, activities:14, coffee:4 },
    worthScore:99,
    score:1400,
    intent:["general","local_favorites","hidden_gems","nightlife"]
  },
  {
    id:"the_square_oxford",
    label:"The Square",
    city:"Oxford",
    state:"MS",
    lat:34.3668,
    lng:-89.5192,
    radiusMiles:0.28,
    districtType:"local",
    districtLabel:"Local District",
    summary:"Walkable Oxford district with restaurants, boutiques, coffee, bookstores, nightlife, and local character.",
    tags:["Restaurants","Shopping","Coffee","Nightlife","Bookstores"],
    topPlaceNames:["City Grocery","Ajax Diner","Square Books","Boure","Proud Larry's"],
    counts:{ restaurants:14, nightlife:7, shopping:12, activities:5, coffee:4 },
    worthScore:95,
    score:1260,
    intent:["general","local_favorites","hidden_gems","shopping","nightlife"]
  },
  {
    id:"downtown_gatlinburg",
    label:"Downtown Gatlinburg",
    city:"Gatlinburg",
    state:"TN",
    lat:35.7110,
    lng:-83.5186,
    radiusMiles:0.50,
    districtType:"adventure",
    districtLabel:"Mountain Adventure District",
    summary:"Walkable mountain-town district with attractions, food, shopping, family activities, and Smoky Mountain energy.",
    tags:["Attractions","Food","Shopping","Family","Mountain"],
    topPlaceNames:["Anakeesta","Ripley's Aquarium","Ole Smoky","The Village Shops","SkyPark"],
    counts:{ restaurants:28, nightlife:8, shopping:35, activities:40, coffee:6 },
    worthScore:97,
    score:1360,
    intent:["general","local_favorites","hidden_gems","shopping","family_fun"]
  },
  {
    id:"disney_springs",
    label:"Disney Springs",
    city:"Lake Buena Vista",
    state:"FL",
    lat:28.3702,
    lng:-81.5197,
    radiusMiles:0.65,
    districtType:"adventure",
    districtLabel:"Dining & Shopping District",
    summary:"Large dining, entertainment, and shopping district with restaurants, shops, shows, dessert, and family experiences.",
    tags:["Dining","Shopping","Entertainment","Family","Dessert"],
    topPlaceNames:["The Boathouse","World of Disney","Gideon's Bakehouse","Raglan Road","House of Blues"],
    counts:{ restaurants:45, nightlife:10, shopping:80, activities:35, coffee:10 },
    worthScore:99,
    score:1400,
    intent:["general","local_favorites","hidden_gems","shopping","family_fun"]
  },
  {
    id:"the_wharf_orange_beach",
    label:"The Wharf",
    city:"Orange Beach",
    state:"AL",
    lat:30.2946,
    lng:-87.6289,
    radiusMiles:0.42,
    districtType:"adventure",
    districtLabel:"Waterfront Adventure District",
    summary:"Waterfront adventure district with restaurants, shopping, events, concerts, activities, and marina energy.",
    tags:["Waterfront","Restaurants","Shopping","Events","Nightlife"],
    topPlaceNames:["The Wharf Amphitheater","Villaggio Grille","YoHo Rum & Tacos","Ferris Wheel","Marina"],
    counts:{ restaurants:12, nightlife:7, shopping:15, activities:16, coffee:3 },
    worthScore:96,
    score:1300,
    intent:["general","local_favorites","hidden_gems","shopping","nightlife","family_fun"]
  }
];


function diqV109IsDistrict(item){
  return !!(item && (item.entityType === "district" || item.resultType === "entity_registry_district" || item.resultType === "entity_iq_district" || item.districtId));
}


function diqV109IntentId(query){
  var q = normText(String(query || activeLens || ""));
  var cat = "";
  try{ cat = categoryFromQuery ? categoryFromQuery(q) : ""; }catch(e0){ cat = ""; }


  if(cat === "food" || q.indexOf("food") > -1 || q.indexOf("restaurant") > -1 || q.indexOf("dinner") > -1 || q.indexOf("breakfast") > -1){ return "food"; }
  if(cat === "coffee" || q.indexOf("coffee") > -1 || q.indexOf("cafe") > -1){ return "coffee"; }
  if(cat === "golf" || q.indexOf("golf") > -1){ return "golf"; }
  if(cat === "shopping" || q.indexOf("shopping") > -1 || q.indexOf("shop") > -1 || q.indexOf("boutique") > -1){ return "shopping"; }
  if(cat === "nightlife" || q.indexOf("nightlife") > -1 || q.indexOf("live music") > -1 || q.indexOf("bar") > -1){ return "nightlife"; }
  if(q.indexOf("family") > -1 || q.indexOf("kids") > -1){ return "family_fun"; }
  if(q.indexOf("hidden") > -1){ return "hidden_gems"; }
  if(q.indexOf("local") > -1 || q.indexOf("favorite") > -1 || q.indexOf("hangout") > -1){ return "local_favorites"; }


  if(activeLens){
    q = normText(activeLens);
    if(q.indexOf("shopping") > -1){ return "shopping"; }
    if(q.indexOf("night") > -1 || q.indexOf("music") > -1){ return "nightlife"; }
    if(q.indexOf("local") > -1 || q.indexOf("favorite") > -1 || q.indexOf("hangout") > -1){ return "local_favorites"; }
  }


  return "general";
}


function diqV109NarrowIntent(intentId){
  return intentId === "food" || intentId === "coffee" || intentId === "breakfast" || intentId === "dinner" || intentId === "dessert" || intentId === "golf";
}


function diqV109IntentAllowsDistrict(entity,intentId){
  var list = entity && entity.intent ? entity.intent : [];
  var i;


  if(diqV109NarrowIntent(intentId)){ return false; }
  if(!list.length){ return true; }


  for(i=0;i<list.length;i++){
    if(String(list[i]) === String(intentId)){ return true; }
  }


  return false;
}


function diqV109Miles(lat1,lng1,lat2,lng2){
  try{ return miles(Number(lat1),Number(lng1),Number(lat2),Number(lng2)); }catch(e0){}
  var R = 3958.8;
  var dLat = (Number(lat2)-Number(lat1)) * Math.PI / 180;
  var dLng = (Number(lng2)-Number(lng1)) * Math.PI / 180;
  var a1 = Number(lat1) * Math.PI / 180;
  var a2 = Number(lat2) * Math.PI / 180;
  var x;
  if(!finite(Number(lat1)) || !finite(Number(lng1)) || !finite(Number(lat2)) || !finite(Number(lng2))){ return null; }
  x = Math.sin(dLat/2)*Math.sin(dLat/2) + Math.sin(dLng/2)*Math.sin(dLng/2)*Math.cos(a1)*Math.cos(a2);
  return R * 2 * Math.atan2(Math.sqrt(x),Math.sqrt(1-x));
}


function diqV109ScanCenter(){
  if(adventureSearchCenter && finite(Number(adventureSearchCenter.lat)) && finite(Number(adventureSearchCenter.lng))){
    return { lat:Number(adventureSearchCenter.lat), lng:Number(adventureSearchCenter.lng), label:adventureSearchCenter.label || "" };
  }
  if(destination && finite(Number(destination.lat)) && finite(Number(destination.lng))){
    return { lat:Number(destination.lat), lng:Number(destination.lng), label:destination.label || "" };
  }
  if(lastFix && finite(Number(lastFix.lat)) && finite(Number(lastFix.lng))){
    return { lat:Number(lastFix.lat), lng:Number(lastFix.lng), label:"near you" };
  }
  return null;
}


function diqV109CountsText(counts){
  var bits = [];
  counts = counts || {};
  if(Number(counts.restaurants || 0) > 0){ bits.push("ðŸ¤ " + String(counts.restaurants) + " Restaurants"); }
  if(Number(counts.nightlife || 0) > 0){ bits.push("ðŸº " + String(counts.nightlife) + " Nightlife"); }
  if(Number(counts.shopping || 0) > 0){ bits.push("ðŸ› " + String(counts.shopping) + " Shops"); }
  if(Number(counts.activities || 0) > 0){ bits.push("ðŸš¤ " + String(counts.activities) + " Activities"); }
  if(Number(counts.coffee || 0) > 0){ bits.push("â˜• " + String(counts.coffee) + " Coffee"); }
  return bits.slice(0,4).join(" â€¢ ");
}


function diqV109ExperienceCount(entity){
  var c = entity && (entity.counts || entity.districtExperienceCounts) ? (entity.counts || entity.districtExperienceCounts) : {};
  var n = 0;
  n += Number(c.restaurants || 0);
  n += Number(c.nightlife || 0);
  n += Number(c.shopping || 0);
  n += Number(c.activities || 0);
  n += Number(c.coffee || 0);
  if(!n){ n = Number(entity && entity.experienceCount || 0); }
  return n;
}


function diqV109MakeDistrictItem(entity,center,intentId){
  var d = center ? diqV109Miles(center.lat,center.lng,entity.lat,entity.lng) : null;
  var count = diqV109ExperienceCount(entity);
  var top = entity.topPlaceNames || [];


  return {
    label:String(entity.label || "District"),
    full:String((entity.city || "") + (entity.state ? ", " + entity.state : "")),
    lat:Number(entity.lat),
    lng:Number(entity.lng),
    kind:"district",
    category:String(entity.districtLabel || "District"),
    matchLabel:String(entity.districtLabel || "District IQ"),
    resultType:"adventure_district_registry",
    entityType:"district",
    entityClass:"district",
    districtId:String(entity.id || ""),
    districtType:String(entity.districtType || "adventure"),
    districtLabel:String(entity.districtLabel || "Adventure District"),
    districtSummary:String(entity.summary || ""),
    districtTags:entity.tags || [],
    districtExperienceCounts:entity.counts || {},
    districtMemberPlaces:[],
    districtThumbnailCards:(function(){
      var out = [];
      var i;
      for(i=0;i<top.length && i<6;i++){
        out.push({ label:String(top[i]), category:"Top Pick", entityType:"place_preview", parentDistrictId:String(entity.id || "") });
      }
      return out;
    })(),
    topPlaceNames:top.slice ? top.slice(0,6) : top,
    experienceCount:count,
    worthScore:Number(entity.worthScore || 96),
    diqScore:Number(entity.score || 1200),
    distMiles:finite(Number(d)) ? Math.round(Number(d)*10)/10 : null,
    distanceMiles:finite(Number(d)) ? Math.round(Number(d)*10)/10 : null,
    freshnessLabel:"District IQ",
    confidenceLabel:"Destination IQ",
    localTags:["Experience District","Worth Exploring"],
    adventureCategory:String(entity.districtLabel || "District"),
    userFacingCategory:String(entity.districtLabel || "District"),
    whyStop:String(entity.summary || ""),
    recommendedBecause:String(entity.districtLabel || "District") + " â€¢ " + String(count) + " experiences â€¢ " + top.slice(0,3).join(", "),
    v109InjectedDistrict:true,
    v109Intent:intentId
  };
}


function diqV109HasDistrict(items,id){
  var i;
  for(i=0;i<(items || []).length;i++){
    if(diqV109IsDistrict(items[i]) && String(items[i].districtId || "") === String(id)){ return true; }
  }
  return false;
}


function diqV109NearbyDistrictItems(items,query){
  var center = diqV109ScanCenter();
  var intentId = diqV109IntentId(query);
  var out = [];
  var i;
  var entity;
  var d;


  if(!center || diqV109NarrowIntent(intentId)){ return out; }


  for(i=0;i<DIQ_V109_DISTRICT_REGISTRY.length;i++){
    entity = DIQ_V109_DISTRICT_REGISTRY[i];
    if(!diqV109IntentAllowsDistrict(entity,intentId)){ continue; }
    if(diqV109HasDistrict(items,entity.id)){ continue; }


    d = diqV109Miles(center.lat,center.lng,entity.lat,entity.lng);
    if(finite(Number(d)) && Number(d) <= 35){
      out.push(diqV109MakeDistrictItem(entity,center,intentId));
    }
  }


  out.sort(function(a,b){
    var sa = Number(a.diqScore || 0) - (Number(a.distMiles || 0) * 4);
    var sb = Number(b.diqScore || 0) - (Number(b.distMiles || 0) * 4);
    return sb - sa;
  });


  return out.slice(0,3);
}


function diqV109MergeDistricts(items,query){
  var source = (items || []).slice(0);
  var districts = diqV109NearbyDistrictItems(source,query);
  var intentId = diqV109IntentId(query);
  var merged;
  var i;


  if(!districts.length){ return source; }


  /* For shopping, the shopping district deserves the first shot.
     For broad/local/nightlife, district cards should be visible but not
     erase strong individual picks. */
  if(intentId === "shopping" || intentId === "nightlife" || intentId === "general" || intentId === "local_favorites" || intentId === "hidden_gems"){
    merged = districts.concat(source);
  }else{
    merged = source.concat(districts);
  }


  /* Keep result list compact and deduped by district/name. */
  var out = [];
  var seen = {};
  var key;
  for(i=0;i<merged.length;i++){
    key = diqV109IsDistrict(merged[i]) ? ("district:" + String(merged[i].districtId || merged[i].label)) : ("place:" + normText(String(merged[i].label || "") + "|" + String(merged[i].lat || "") + "|" + String(merged[i].lng || "")));
    if(seen[key]){ continue; }
    seen[key] = true;
    out.push(merged[i]);
    if(out.length >= 10){ break; }
  }


  return out;
}


function diqV109DistrictCardHtml(item,index){
  var counts = item.districtExperienceCounts || {};
  var top = item.topPlaceNames || [];
  var chips = item.districtTags || [];
  var i;
  var html = "";


  html += '<div class="diqDestThumb diqV109DistrictThumb ' + escapeHTML(String(item.districtType || "adventure")) + '"><div class="diqV109DistrictIcon">â˜…</div></div>';
  html += '<div class="diqV109DistrictBadge">' + escapeHTML(item.districtLabel || "Adventure District") + '</div>';
  html += '<div class="diqDestName diqV109DistrictName">' + escapeHTML(item.label || "District") + '</div>';
  html += '<div class="diqDestSub diqV109DistrictSub">' + escapeHTML(item.districtSummary || item.whyStop || "Explore the best experiences inside this district.") + '</div>';
  html += '<div class="diqV109Counts">' + escapeHTML(diqV109CountsText(counts) || (String(item.experienceCount || "") + " Experiences")) + '</div>';
  html += '<div class="diqV109TopPicks">';
  for(i=0;i<top.length && i<4;i++){
    html += '<span>â­ ' + escapeHTML(top[i]) + '</span>';
  }
  if(item.experienceCount && Number(item.experienceCount) > top.length){
    html += '<span class="diqV109More">+' + escapeHTML(String(Math.max(0,Number(item.experienceCount || 0) - top.length))) + ' more</span>';
  }
  html += '</div>';
  html += '<div class="diqDestMeta diqV109DistrictMeta">' + escapeHTML(String(item.experienceCount || diqV109ExperienceCount(item)) + ' experiences â€¢ Explore District') + '</div>';
  html += '<div class="diqDestWorth diqV109DistrictActions"><span class="diqDestTag diqDestTopPick">' + (index === 0 ? 'TOP DISTRICT' : 'DISTRICT IQ') + '</span><span class="diqDestTag">Worth the Drive</span><span class="diqDestTag">' + escapeHTML((chips && chips[0]) ? chips[0] : "Experience") + '</span></div>';


  return html;
}


function diqV109DecorateShelf(){
  var nodes;
  var i;
  var idx;
  var item;


  try{ nodes = document.querySelectorAll("#diqDestList .diqDestItem[data-adv-idx]"); }catch(e0){ nodes = []; }


  for(i=0;i<nodes.length;i++){
    idx = Number(nodes[i].getAttribute("data-adv-idx"));
    item = destinationSearchResults && destinationSearchResults[idx] ? destinationSearchResults[idx] : null;
    if(!diqV109IsDistrict(item)){ continue; }


    try{
      nodes[i].className = String(nodes[i].className || "") + " diqV109DistrictItem";
      nodes[i].setAttribute("data-entity-type","district");
      nodes[i].setAttribute("data-district-id",String(item.districtId || ""));
      nodes[i].innerHTML = diqV109DistrictCardHtml(item,idx);
    }catch(e1){}
  }
}


function diqV109DistrictDetailHtml(item){
  var counts = item.districtExperienceCounts || {};
  var top = item.topPlaceNames || [];
  var html = "";
  var i;


  html += '<div class="diqV109Detail">';
  html += '<div class="diqV109DetailBadge">â˜… ' + escapeHTML(item.districtLabel || "Adventure District") + '</div>';
  html += '<div class="diqV109DetailSummary">' + escapeHTML(item.districtSummary || item.whyStop || "") + '</div>';
  html += '<div class="diqV109DetailCounts">';
  html += '<span>ðŸ¤ ' + escapeHTML(String(counts.restaurants || 0)) + ' Restaurants</span>';
  html += '<span>ðŸº ' + escapeHTML(String(counts.nightlife || 0)) + ' Nightlife</span>';
  html += '<span>ðŸ› ' + escapeHTML(String(counts.shopping || 0)) + ' Shops</span>';
  html += '<span>ðŸš¤ ' + escapeHTML(String(counts.activities || 0)) + ' Activities</span>';
  html += '</div>';
  html += '<div class="diqV109DetailTitle">Top picks inside</div>';
  html += '<div class="diqV109DetailPicks">';
  for(i=0;i<top.length && i<6;i++){
    html += '<span>â­ ' + escapeHTML(top[i]) + '</span>';
  }
  html += '</div>';
  html += '</div>';


  return html;
}


function diqV109DecorateInfoCard(item){
  var card;
  var title;
  var category;
  var sub;
  var freshness;
  var confidence;
  var worth;
  var existing;
  var body;
  var route;


  if(!diqV109IsDistrict(item)){ return; }


  card = byId("diqAdventureInfoCard");
  if(!card){ return; }


  try{ card.className = String(card.className || "") + " diqV109DistrictInfo"; }catch(e0){}


  title = byId("diqAdvInfoTitle");
  category = byId("diqAdvInfoCategory");
  sub = byId("diqAdvInfoSub");
  freshness = byId("diqAdvInfoFreshness");
  confidence = byId("diqAdvInfoConfidence");
  worth = byId("diqAdvInfoWorth");
  route = byId("diqAdvInfoRoute");


  if(title){ title.textContent = String(item.label || "District"); }
  if(category){ category.textContent = String(item.districtLabel || "Adventure District"); }
  if(sub){ sub.textContent = String(item.districtSummary || item.whyStop || "Explore the best places inside this district."); }
  if(freshness){ freshness.textContent = "District IQ"; }
  if(confidence){ confidence.textContent = String(item.experienceCount || "") + " Experiences"; }
  if(worth){ worth.textContent = "Worth the Drive"; }
  if(route){ route.textContent = "EXPLORE / ROUTE HERE"; }


  try{
    existing = card.querySelector(".diqV109Detail");
    if(existing && existing.parentNode){ existing.parentNode.removeChild(existing); }
  }catch(e1){}


  try{
    body = card.querySelector(".diqPlaceBody") || card;
    body.insertAdjacentHTML("afterbegin",diqV109DistrictDetailHtml(item));
  }catch(e2){}
}


function diqV109InjectStyles(){
  var style;
  var css;


  if(byId("diqV109DistrictExperienceStyles")){ return; }


  css =
    ".diqV109DistrictItem{position:relative!important;border-color:rgba(255,211,105,.72)!important;background:linear-gradient(180deg,rgba(9,17,29,.98),rgba(4,10,18,.96))!important;box-shadow:0 18px 46px rgba(0,0,0,.44),0 0 34px rgba(255,211,105,.12)!important;overflow:hidden!important;padding-left:94px!important;}" +
    ".diqV109DistrictThumb{position:absolute!important;left:14px!important;top:14px!important;width:64px!important;height:64px!important;border-radius:18px!important;background:radial-gradient(circle at 25% 18%,rgba(255,232,150,.72),transparent 34%),linear-gradient(135deg,#1d2e3c,#123d46 48%,#08111e)!important;border:1px solid rgba(255,211,105,.45)!important;display:flex!important;align-items:center!important;justify-content:center!important;}" +
    ".diqV109DistrictThumb.shopping{background:radial-gradient(circle at 25% 18%,rgba(255,232,150,.72),transparent 34%),linear-gradient(135deg,#2a1838,#392b5e 48%,#08111e)!important;}" +
    ".diqV109DistrictThumb.entertainment{background:radial-gradient(circle at 25% 18%,rgba(255,160,95,.72),transparent 34%),linear-gradient(135deg,#351320,#412844 48%,#08111e)!important;}" +
    ".diqV109DistrictIcon{font-size:28px;color:#ffe58f;text-shadow:0 0 18px rgba(255,211,105,.6);}" +
    ".diqV109DistrictBadge{display:inline-flex!important;margin:0 0 5px 0!important;padding:4px 9px!important;border-radius:999px!important;background:linear-gradient(135deg,#ffe792,#33f5c6)!important;color:#071018!important;font-size:9px!important;font-weight:1000!important;letter-spacing:.13em!important;text-transform:uppercase!important;}" +
    ".diqV109DistrictName{font-size:18px!important;line-height:1.05!important;font-weight:1000!important;color:#fff!important;}" +
    ".diqV109DistrictSub{margin-top:5px!important;color:#d4dee9!important;line-height:1.28!important;display:block!important;}" +
    ".diqV109Counts{margin-top:8px!important;color:#ffe6a6!important;font-size:10px!important;font-weight:900!important;line-height:1.35!important;}" +
    ".diqV109TopPicks{margin-top:8px!important;display:flex!important;flex-wrap:wrap!important;gap:5px!important;}" +
    ".diqV109TopPicks span{display:inline-flex!important;padding:4px 7px!important;border-radius:999px!important;background:rgba(255,255,255,.08)!important;border:1px solid rgba(255,255,255,.12)!important;color:#f4fbff!important;font-size:9px!important;font-weight:850!important;}" +
    ".diqV109TopPicks .diqV109More{color:#9fffe4!important;border-color:rgba(40,255,190,.26)!important;background:rgba(40,255,190,.09)!important;}" +
    ".diqV109DistrictMeta{margin-top:8px!important;color:#7fffe3!important;letter-spacing:.12em!important;text-transform:uppercase!important;}" +
    ".diqV109DistrictActions{margin-top:8px!important;}" +
    "#diqAdventureInfoCard.diqV109DistrictInfo{border-color:rgba(255,211,105,.68)!important;box-shadow:0 28px 80px rgba(0,0,0,.72),0 0 44px rgba(255,211,105,.14)!important;}" +
    "#diqAdventureInfoCard.diqV109DistrictInfo .diqAdvKicker{background:linear-gradient(135deg,#ffe792,#33f5c6)!important;color:#071018!important;border:0!important;}" +
    ".diqV109Detail{margin:0 0 12px 0!important;padding:13px!important;border-radius:18px!important;background:linear-gradient(180deg,rgba(255,211,105,.10),rgba(40,255,190,.05))!important;border:1px solid rgba(255,211,105,.22)!important;}" +
    ".diqV109DetailBadge{display:inline-flex!important;padding:5px 10px!important;border-radius:999px!important;background:rgba(255,211,105,.16)!important;border:1px solid rgba(255,211,105,.28)!important;color:#ffe6a6!important;font-size:10px!important;font-weight:1000!important;letter-spacing:.12em!important;text-transform:uppercase!important;}" +
    ".diqV109DetailSummary{margin-top:9px!important;color:#e7f0f9!important;font-size:12px!important;line-height:1.35!important;font-weight:760!important;}" +
    ".diqV109DetailCounts{margin-top:11px!important;display:grid!important;grid-template-columns:1fr 1fr!important;gap:7px!important;}" +
    ".diqV109DetailCounts span{padding:7px 8px!important;border-radius:12px!important;background:rgba(255,255,255,.07)!important;color:#fff!important;font-size:10px!important;font-weight:900!important;}" +
    ".diqV109DetailTitle{margin-top:12px!important;color:#9fffe4!important;font-size:10px!important;font-weight:1000!important;letter-spacing:.14em!important;text-transform:uppercase!important;}" +
    ".diqV109DetailPicks{margin-top:8px!important;display:flex!important;flex-wrap:wrap!important;gap:6px!important;}" +
    ".diqV109DetailPicks span{padding:6px 8px!important;border-radius:999px!important;background:rgba(255,255,255,.08)!important;color:#f7fbff!important;font-size:10px!important;font-weight:850!important;}";


  style = document.createElement("style");
  style.id = "diqV109DistrictExperienceStyles";
  style.type = "text/css";
  style.appendChild(document.createTextNode(css));
  try{ document.head.appendChild(style); }catch(e0){}
}


diqV109InjectStyles();


/* Render shelf bridge */
var diqV109PriorRenderAdventureScanChoices = renderAdventureScanChoices;
renderAdventureScanChoices = function(items,query){
  var enhanced = items;
  try{ enhanced = diqV109MergeDistricts(items || [], query || activeLens); }catch(e0){ enhanced = items; }
  var result = diqV109PriorRenderAdventureScanChoices(enhanced,query);
  try{ window.setTimeout(diqV109DecorateShelf,30); }catch(e1){}
  try{ window.setTimeout(diqV109DecorateShelf,180); }catch(e2){}
  try{ window.setTimeout(diqV109DecorateShelf,650); }catch(e3){}
  return result;
};


/* Info card bridge */
var diqV109PriorOpenAdventureInfoCard = openAdventureInfoCard;
openAdventureInfoCard = function(item,preserveBrowseCamera){
  var result = diqV109PriorOpenAdventureInfoCard(item,preserveBrowseCamera);
  try{ diqV109DecorateInfoCard(item); }catch(e0){}
  try{ window.setTimeout(function(){ diqV109DecorateInfoCard(item); },90); }catch(e1){}
  try{ window.setTimeout(function(){ diqV109DecorateInfoCard(item); },520); }catch(e2){}
  return result;
};


try{
  window.DRIVE_IQ_ADVENTURE_V109_DISTRICT_CARDS = {
    build:"V109_DISTRICT_EXPERIENCE_CARDS_ENTITY_UI_BRIDGE",
    registry:DIQ_V109_DISTRICT_REGISTRY,
    merge:diqV109MergeDistricts,
    isDistrict:diqV109IsDistrict
  };
  console.log("âœ… Drive IQ Adventure V109 District Experience Cards loaded");
}catch(eV109){}








/* =========================================================
   DRIVE IQ ADVENTURE MODE V110
   RESULT HANDOFF DISTRICT IQ AUTHORITY


   Why V109 could still miss districts:
   - The live scan may be centered by the rendered result cluster/map,
     while the district injector only looked at adventureSearchCenter,
     destination, or last GPS.
   - If last GPS was not the Destin scan center, HarborWalk/Destin Commons
     never became "nearby" and never entered the final handoff.


   V110 fix:
   - Infer scan center from the actual result cluster first.
   - Fallback to current map center, then adventureSearchCenter/destination/GPS.
   - Inject districts BEFORE:
       adventureResults =
       renderResultPins()
       renderAdventureScanChoices()
       afterScanResultsReady()
   - Keep narrow place scans strict.
   ES5 SAFE
========================================================= */


window.__DRIVE_IQ_ADVENTURE_MODE_JS_V110_RESULT_HANDOFF_DISTRICT_IQ__ = true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD = "V110_RESULT_HANDOFF_DISTRICT_IQ_AUTHORITY";


function diqV110IsDistrict(item){
  return !!(item && (item.entityType === "district" || item.resultType === "adventure_district_registry" || item.resultType === "entity_registry_district" || item.resultType === "entity_iq_district" || item.districtId));
}


function diqV110IntentId(query) {
  var q = normText(query || activeScanQuery || activeLens || "");
  var lens = normText(activeLens || "");
  var cat = "";

  try { cat = categoryFromQuery ? categoryFromQuery(q) : ""; } catch (e0) { cat = ""; }

  /* V202 Intent Authority:
     The selected Adventure category is stronger than broad provider query words.
     A Local Favorites pull often contains restaurant/coffee/food terms, but that
     must not silently downgrade the scan into narrow Food IQ and suppress districts. */
  if (cat === "local favorites" || lens === "local favorites" ||
      q.indexOf("local favorite") > -1 || q.indexOf("local favorites") > -1 ||
      q.indexOf("local fave") > -1 || q.indexOf("hangout") > -1) {
    return "local_favorites";
  }

  if (cat === "hidden gems" || lens === "hidden gems" || q.indexOf("hidden gem") > -1) {
    return "hidden_gems";
  }

  if (cat === "shopping" || lens === "shopping" ||
      q.indexOf("shopping district") > -1 || q.indexOf("shopping") > -1 ||
      q.indexOf("boutique") > -1 || q.indexOf("retail") > -1) {
    return "shopping";
  }

  if (cat === "popular tonight" || cat === "live music" ||
      lens === "popular tonight" || lens === "live music" ||
      q.indexOf("live music") > -1 || q.indexOf("nightlife") > -1) {
    return "nightlife";
  }

  if (cat === "coffee iq" || lens === "coffee iq" ||
      q.indexOf("coffee") > -1 || q.indexOf("cafe") > -1) {
    return "coffee";
  }

  if (cat === "golf iq" || lens === "golf iq" || q.indexOf("golf") > -1) {
    return "golf";
  }

  if (cat === "food iq" || cat === "food drinks" ||
      lens === "food iq" || lens === "food drinks" ||
      q.indexOf("food") > -1 || q.indexOf("restaurant") > -1 ||
      q.indexOf("dinner") > -1 || q.indexOf("breakfast") > -1 ||
      q.indexOf("lunch") > -1) {
    return "food";
  }

  if (q.indexOf("family") > -1 || q.indexOf("kids") > -1) {
    return "family_fun";
  }

  return "general";
}


function diqV110IsNarrowIntent(intentId){
  return intentId === "food" || intentId === "coffee" || intentId === "breakfast" || intentId === "dinner" || intentId === "dessert" || intentId === "golf";
}


function diqV110Registry(){
  if(window.DRIVE_IQ_ADVENTURE_V109_DISTRICT_CARDS && window.DRIVE_IQ_ADVENTURE_V109_DISTRICT_CARDS.registry){
    return window.DRIVE_IQ_ADVENTURE_V109_DISTRICT_CARDS.registry;
  }
  if(typeof DIQ_V109_DISTRICT_REGISTRY !== "undefined"){ return DIQ_V109_DISTRICT_REGISTRY; }
  return [];
}


function diqV110Miles(lat1,lng1,lat2,lng2){
  try { return miles(Number(lat1),Number(lng1),Number(lat2),Number(lng2)); } catch(e0) {}
  var R = 3958.8;
  var dLat;
  var dLng;
  var a1;
  var a2;
  var x;


  if(!finite(Number(lat1)) || !finite(Number(lng1)) || !finite(Number(lat2)) || !finite(Number(lng2))){ return null; }


  dLat = (Number(lat2)-Number(lat1)) * Math.PI / 180;
  dLng = (Number(lng2)-Number(lng1)) * Math.PI / 180;
  a1 = Number(lat1) * Math.PI / 180;
  a2 = Number(lat2) * Math.PI / 180;
  x = Math.sin(dLat/2)*Math.sin(dLat/2) + Math.sin(dLng/2)*Math.sin(dLng/2)*Math.cos(a1)*Math.cos(a2);
  return R * 2 * Math.atan2(Math.sqrt(x),Math.sqrt(1-x));
}


function diqV110ClusterCenter(items){
  var latSum = 0;
  var lngSum = 0;
  var count = 0;
  var i;
  var item;


  for(i=0;i<(items || []).length;i++){
    item = items[i];
    if(!item || diqV110IsDistrict(item)){ continue; }
    if(finite(Number(item.lat)) && finite(Number(item.lng))){
      latSum += Number(item.lat);
      lngSum += Number(item.lng);
      count += 1;
    }
  }


  if(count >= 2){
    return {
      lat:latSum / count,
      lng:lngSum / count,
      label:"result cluster",
      source:"result_cluster",
      count:count
    };
  }


  return null;
}


function diqV110MapCenter(){
  var c = null;
  if(!map || !mapLoaded){ return null; }
  try { c = map.getCenter(); } catch(e0) { c = null; }
  if(c && finite(Number(c.lat)) && finite(Number(c.lng))){
    return { lat:Number(c.lat), lng:Number(c.lng), label:"map center", source:"map_center" };
  }
  return null;
}


function diqV110BaseCenter(){
  if(adventureSearchCenter && finite(Number(adventureSearchCenter.lat)) && finite(Number(adventureSearchCenter.lng))){
    return { lat:Number(adventureSearchCenter.lat), lng:Number(adventureSearchCenter.lng), label:adventureSearchCenter.label || "scan center", source:"adventureSearchCenter" };
  }
  if(destination && finite(Number(destination.lat)) && finite(Number(destination.lng))){
    return { lat:Number(destination.lat), lng:Number(destination.lng), label:destination.label || "destination", source:"destination" };
  }
  if(lastFix && finite(Number(lastFix.lat)) && finite(Number(lastFix.lng))){
    return { lat:Number(lastFix.lat), lng:Number(lastFix.lng), label:"gps", source:"lastFix" };
  }
  return null;
}


function diqV110ChooseCenter(items){
  var cluster = diqV110ClusterCenter(items);
  var mapC = diqV110MapCenter();
  var base = diqV110BaseCenter();


  /* The actual returned result cluster is the strongest truth for a scan.
     This fixes Destin showing Destin results while GPS/scan state still points
     somewhere else. */
  if(cluster){ return cluster; }


  /* Map area scans and destination browse should prefer what is on screen. */
  if(mapC && (mapAreaScanActive || adventureSearchScope === "map_area" || adventureSearchScope === "near_destination" || adventureDestinationCameraHold)){ return mapC; }


  if(base){ return base; }
  if(mapC){ return mapC; }
  return null;
}


function diqV110IntentAllowsDistrict(entity,intentId){
  var allowed = entity && entity.intent ? entity.intent : [];
  var i;


  if(diqV110IsNarrowIntent(intentId)){ return false; }
  if(!allowed.length){ return true; }


  for(i=0;i<allowed.length;i++){
    if(String(allowed[i]) === String(intentId)){ return true; }
  }


  return false;
}


function diqV110HasDistrict(items,id){
  var i;
  for(i=0;i<(items || []).length;i++){
    if(diqV110IsDistrict(items[i]) && String(items[i].districtId || "") === String(id)){ return true; }
  }
  return false;
}


function diqV110ExperienceCount(entity){
  var c = entity && (entity.counts || entity.districtExperienceCounts) ? (entity.counts || entity.districtExperienceCounts) : {};
  var n = 0;
  n += Number(c.restaurants || 0);
  n += Number(c.nightlife || 0);
  n += Number(c.shopping || 0);
  n += Number(c.activities || 0);
  n += Number(c.coffee || 0);
  if(!n){ n = Number(entity && entity.experienceCount || 0); }
  return n;
}


function diqV110DistrictItem(entity,center,intentId){
  var d = center ? diqV110Miles(center.lat,center.lng,entity.lat,entity.lng) : null;
  var top = entity.topPlaceNames || [];
  var count = diqV110ExperienceCount(entity);


  return {
    label:String(entity.label || "District"),
    full:String((entity.city || "") + (entity.state ? ", " + entity.state : "")),
    lat:Number(entity.lat),
    lng:Number(entity.lng),
    kind:"district",
    category:String(entity.districtLabel || "District"),
    matchLabel:String(entity.districtLabel || "District IQ"),
    resultType:"adventure_district_registry",
    entityType:"district",
    entityClass:"district",
    districtId:String(entity.id || ""),
    districtType:String(entity.districtType || "adventure"),
    districtLabel:String(entity.districtLabel || "Adventure District"),
    districtSummary:String(entity.summary || ""),
    districtTags:entity.tags || [],
    districtExperienceCounts:entity.counts || entity.districtExperienceCounts || {},
    topPlaceNames:top.slice ? top.slice(0,6) : top,
    districtMemberPlaces:[],
    districtThumbnailCards:(function(){
      var out = [];
      var i;
      for(i=0;i<top.length && i<6;i++){
        out.push({ label:String(top[i]), category:"Top Pick", entityType:"place_preview", parentDistrictId:String(entity.id || "") });
      }
      return out;
    })(),
    experienceCount:count,
    worthScore:Number(entity.worthScore || 97),
    diqScore:Number(entity.score || 1300),
    score:Number(entity.score || 1300),
    distMiles:finite(Number(d)) ? Math.round(Number(d)*10)/10 : null,
    distanceMiles:finite(Number(d)) ? Math.round(Number(d)*10)/10 : null,
    freshnessLabel:"District IQ",
    confidenceLabel:"Destination IQ",
    localTags:["Experience District","Worth Exploring"],
    adventureCategory:String(entity.districtLabel || "District"),
    userFacingCategory:String(entity.districtLabel || "District"),
    whyStop:String(entity.summary || ""),
    recommendedBecause:String(entity.districtLabel || "District") + " â€¢ " + String(count) + " experiences â€¢ " + top.slice(0,3).join(", "),
    v110InjectedDistrict:true,
    v110CenterSource:center ? center.source : "",
    v110Intent:intentId
  };
}


function diqV110InjectDistrictsAtHandoff(items,query){
  var source = (items || []).slice(0);
  var intentId = diqV110IntentId(query || activeScanQuery || activeLens);
  var center;
  var registry;
  var injected = [];
  var merged = [];
  var i;
  var entity;
  var d;
  var maxDistance = 8;


  if(diqV110IsNarrowIntent(intentId)){ return source; }


  center = diqV110ChooseCenter(source);
  registry = diqV110Registry();


  if(!center || !registry.length){ return source; }


  for(i=0;i<registry.length;i++){
    entity = registry[i];
    if(!entity || !diqV110IntentAllowsDistrict(entity,intentId)){ continue; }
    if(diqV110HasDistrict(source,entity.id)){ continue; }


    d = diqV110Miles(center.lat,center.lng,entity.lat,entity.lng);


    /* A district should only be injected if the actual scan/map cluster is in
       the same market. 8 miles is enough for Destin/Okaloosa and downtown
       districts without polluting unrelated towns. */
    if(finite(Number(d)) && Number(d) <= maxDistance){
      injected.push(diqV110DistrictItem(entity,center,intentId));
    }
  }


  injected.sort(function(a,b){
    var sa = Number(a.diqScore || 0) - (Number(a.distMiles || 0) * 20);
    var sb = Number(b.diqScore || 0) - (Number(b.distMiles || 0) * 20);
    return sb - sa;
  });


  if(!injected.length){ return source; }


  if(intentId === "shopping" || intentId === "nightlife" || intentId === "local_favorites" || intentId === "hidden_gems" || intentId === "general"){
    merged = injected.concat(source);
  }else{
    merged = source.concat(injected);
  }


  /* Deduplicate and keep enough for pins + shelf. */
  var out = [];
  var seen = {};
  var key;
  for(i=0;i<merged.length;i++){
    if(!merged[i]){ continue; }
    key = diqV110IsDistrict(merged[i])
      ? "district:" + String(merged[i].districtId || merged[i].label || "")
      : "place:" + normText(String(merged[i].label || "") + "|" + String(merged[i].lat || "") + "|" + String(merged[i].lng || ""));
    if(seen[key]){ continue; }
    seen[key] = true;
    out.push(merged[i]);
    if(out.length >= 12){ break; }
  }


  try{
    window.DRIVE_IQ_ADVENTURE_V110_LAST_INJECTION = {
      build:"V110_RESULT_HANDOFF_DISTRICT_IQ_AUTHORITY",
      query:String(query || activeScanQuery || activeLens || ""),
      intent:intentId,
      center:center,
      injected:(function(){
        var names = [];
        var j;
        for(j=0;j<injected.length;j++){ names.push(injected[j].label); }
        return names;
      })()
    };
    console.log("ðŸ™ï¸ V110 District handoff injection", window.DRIVE_IQ_ADVENTURE_V110_LAST_INJECTION);
  }catch(e0){}


  return out;
}


/* Permit true district entities through the old category/admin gates. */
try{
  var diqV110PriorV256Admin = diqV256IsAdministrativeOrGenericEntity;
  diqV256IsAdministrativeOrGenericEntity = function(item){
    if(diqV110IsDistrict(item)){ return false; }
    return diqV110PriorV256Admin(item);
  };
}catch(eAdmin){}


try{
  var diqV110PriorV256Blacklist = diqV256ExperienceBlacklist;
  diqV256ExperienceBlacklist = function(item,category){
    if(diqV110IsDistrict(item)){ return false; }
    return diqV110PriorV256Blacklist(item,category);
  };
}catch(eBlack){}


try{
  var diqV110PriorStrict = isStrictAdventureCategoryMatch;
  isStrictAdventureCategoryMatch = function(item,query){
    if(diqV110IsDistrict(item)){ return !diqV110IsNarrowIntent(diqV110IntentId(query || activeScanQuery || activeLens)); }
    return diqV110PriorStrict(item,query);
  };
}catch(eStrict){}


try{
  var diqV110PriorScore = scoreAdventure;
  scoreAdventure = function(item,query){
    if(diqV110IsDistrict(item)){ return Number(item.diqScore || item.score || 1300); }
    return diqV110PriorScore(item,query);
  };
}catch(eScore){}


/* Handoff wrappers: this is the important part. */
var diqV110PriorAfterScanResultsReady = afterScanResultsReady;
afterScanResultsReady = function(items,preferred,reason){
  var enhanced = diqV110InjectDistrictsAtHandoff(items || [], activeScanQuery || activeLens);
  var pick = preferred;
  if(enhanced && enhanced.length && (!pick || !diqV110IsDistrict(pick))){
    if(diqV110IsDistrict(enhanced[0])){ pick = enhanced[0]; }
  }
  return diqV110PriorAfterScanResultsReady(enhanced,pick,reason);
};


var diqV110PriorRenderResultPins = renderResultPins;
renderResultPins = function(items,preferred){
  var enhanced = diqV110InjectDistrictsAtHandoff(items || [], activeScanQuery || activeLens);
  var pick = preferred;
  if(enhanced && enhanced.length && diqV110IsDistrict(enhanced[0])){ pick = enhanced[0]; }
  return diqV110PriorRenderResultPins(enhanced,pick);
};


var diqV110PriorRenderAdventureScanChoices = renderAdventureScanChoices;
renderAdventureScanChoices = function(items,query){
  var enhanced = diqV110InjectDistrictsAtHandoff(items || [], query || activeScanQuery || activeLens);
  return diqV110PriorRenderAdventureScanChoices(enhanced,query);
};


/* Ensure the map dock's SHOW PICKS uses the enhanced canonical list. */
try{
  var diqV110PriorSyncAdventureMapDock = syncAdventureMapDock;
  syncAdventureMapDock = function(){
    try{
      if(adventureResults && adventureResults.length){
        adventureResults = diqV110InjectDistrictsAtHandoff(adventureResults, activeScanQuery || activeLens);
      }
    }catch(e0){}
    return diqV110PriorSyncAdventureMapDock();
  };
}catch(eDock){}


/* If V109 card decorator exists, reuse it after V110 render pass. */
try{
  var diqV110PriorOpenInfo = openAdventureInfoCard;
  openAdventureInfoCard = function(item,preserveBrowseCamera){
    var result = diqV110PriorOpenInfo(item,preserveBrowseCamera);
    try{
      if(diqV110IsDistrict(item) && typeof diqV109DecorateInfoCard === "function"){
        diqV109DecorateInfoCard(item);
        window.setTimeout(function(){ diqV109DecorateInfoCard(item); },120);
      }
    }catch(e0){}
    return result;
  };
}catch(eOpen){}


try{
  window.DRIVE_IQ_ADVENTURE_V110_HANDOFF_DISTRICT_IQ = {
    build:"V110_RESULT_HANDOFF_DISTRICT_IQ_AUTHORITY",
    inject:diqV110InjectDistrictsAtHandoff,
    chooseCenter:diqV110ChooseCenter,
    isDistrict:diqV110IsDistrict
  };
  console.log("âœ… Drive IQ Adventure V110 Result Handoff District IQ loaded");
}catch(eV110){}








/* =========================================================
   DRIVE IQ ADVENTURE MODE V111
   PIPELINE AUTHORITY + HOT RELOAD GUARD FIX


   What this fixes:
   - Older Adventure Mode builds set the V24 global guard.
   - When a new asset is loaded into a live WebView/session, the old guard
     can stop the whole file before V109/V110 ever runs.
   - V111 makes the updated asset execute with a version-specific guard.
   - Also adds a final DOM repair pass so if the visible shelf is already
     showing a known district candidate like "The Shores Shopping Center",
     it can promote the correct district card in-place.


   ES5 SAFE
========================================================= */


window.__DRIVE_IQ_ADVENTURE_MODE_JS_V111_PIPELINE_AUTHORITY_LOADED__ = true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD = "V111_PIPELINE_AUTHORITY_HOT_RELOAD_GUARD_FIX";


function diqV111Norm(v){
  try { return normText(v); } catch(e0) {
    return String(v || "").toLowerCase().replace(/[^a-z0-9]+/g," ").replace(/\s+/g," ").trim();
  }
}


function diqV111DistrictRegistry(){
  if(typeof DIQ_V109_DISTRICT_REGISTRY !== "undefined"){ return DIQ_V109_DISTRICT_REGISTRY; }
  if(window.DRIVE_IQ_ADVENTURE_V109_DISTRICT_CARDS && window.DRIVE_IQ_ADVENTURE_V109_DISTRICT_CARDS.registry){
    return window.DRIVE_IQ_ADVENTURE_V109_DISTRICT_CARDS.registry;
  }
  return [
    {
      id:"harborwalk_village_destin",
      label:"HarborWalk Village",
      city:"Destin",
      state:"FL",
      lat:30.3935,
      lng:-86.5104,
      districtType:"adventure",
      districtLabel:"Waterfront Entertainment District",
      summary:"Walkable waterfront destination with restaurants, bars, shops, live music, boat tours, and harbor views.",
      tags:["Restaurants","Nightlife","Shopping","Activities","Waterfront"],
      topPlaceNames:["AJ's Seafood & Oyster Bar","Harry T's","Margaritaville","Coyote Ugly","Tailfins","Harbor Docks"],
      counts:{ restaurants:18, nightlife:12, shopping:11, activities:16, coffee:3 },
      worthScore:99,
      score:1400,
      intent:["general","local_favorites","hidden_gems","nightlife","family_fun"]
    },
    {
      id:"destin_commons",
      label:"Destin Commons",
      city:"Destin",
      state:"FL",
      lat:30.3909,
      lng:-86.4271,
      districtType:"shopping",
      districtLabel:"Shopping District",
      summary:"Retail-first shopping and entertainment district with stores, restaurants, coffee, movies, and family activities.",
      tags:["Shopping","Restaurants","Coffee","Movies","Family"],
      topPlaceNames:["Bass Pro Shops","AMC Destin Commons","Belk","H&M","Uncle Buck's FishBowl","Starbucks"],
      counts:{ restaurants:14, nightlife:2, shopping:65, activities:5, coffee:6 },
      worthScore:96,
      score:1320,
      intent:["shopping","general","local_favorites","hidden_gems","family_fun"]
    }
  ];
}


function diqV111IsDistrict(item){
  return !!(item && (item.entityType === "district" || item.resultType === "adventure_district_registry" || item.resultType === "entity_registry_district" || item.districtId));
}


function diqV111IntentId(query) {
  var q = diqV111Norm(query || activeScanQuery || activeLens || "");
  var lens = diqV111Norm(activeLens || "");
  var cat = "";

  try { cat = categoryFromQuery ? categoryFromQuery(q) : ""; } catch (e0) { cat = ""; }

  /* V202 Intent Authority:
     The selected Adventure category is stronger than broad provider query words.
     A Local Favorites pull often contains restaurant/coffee/food terms, but that
     must not silently downgrade the scan into narrow Food IQ and suppress districts. */
  if (cat === "local favorites" || lens === "local favorites" ||
      q.indexOf("local favorite") > -1 || q.indexOf("local favorites") > -1 ||
      q.indexOf("local fave") > -1 || q.indexOf("hangout") > -1) {
    return "local_favorites";
  }

  if (cat === "hidden gems" || lens === "hidden gems" || q.indexOf("hidden gem") > -1) {
    return "hidden_gems";
  }

  if (cat === "shopping" || lens === "shopping" ||
      q.indexOf("shopping district") > -1 || q.indexOf("shopping") > -1 ||
      q.indexOf("boutique") > -1 || q.indexOf("retail") > -1) {
    return "shopping";
  }

  if (cat === "popular tonight" || cat === "live music" ||
      lens === "popular tonight" || lens === "live music" ||
      q.indexOf("live music") > -1 || q.indexOf("nightlife") > -1) {
    return "nightlife";
  }

  if (cat === "coffee iq" || lens === "coffee iq" ||
      q.indexOf("coffee") > -1 || q.indexOf("cafe") > -1) {
    return "coffee";
  }

  if (cat === "golf iq" || lens === "golf iq" || q.indexOf("golf") > -1) {
    return "golf";
  }

  if (cat === "food iq" || cat === "food drinks" ||
      lens === "food iq" || lens === "food drinks" ||
      q.indexOf("food") > -1 || q.indexOf("restaurant") > -1 ||
      q.indexOf("dinner") > -1 || q.indexOf("breakfast") > -1 ||
      q.indexOf("lunch") > -1) {
    return "food";
  }

  if (q.indexOf("family") > -1 || q.indexOf("kids") > -1) {
    return "family_fun";
  }

  return "general";
}


function diqV111IsNarrowIntent(intentId){
  return intentId === "food" || intentId === "coffee" || intentId === "breakfast" || intentId === "dinner" || intentId === "dessert" || intentId === "golf";
}


function diqV111Miles(lat1,lng1,lat2,lng2){
  var R = 3958.8;
  var dLat;
  var dLng;
  var a1;
  var a2;
  var x;
  if(!finite(Number(lat1)) || !finite(Number(lng1)) || !finite(Number(lat2)) || !finite(Number(lng2))){ return null; }
  dLat = (Number(lat2)-Number(lat1)) * Math.PI / 180;
  dLng = (Number(lng2)-Number(lng1)) * Math.PI / 180;
  a1 = Number(lat1) * Math.PI / 180;
  a2 = Number(lat2) * Math.PI / 180;
  x = Math.sin(dLat/2)*Math.sin(dLat/2) + Math.sin(dLng/2)*Math.sin(dLng/2)*Math.cos(a1)*Math.cos(a2);
  return R * 2 * Math.atan2(Math.sqrt(x),Math.sqrt(1-x));
}


function diqV111ClusterCenter(items){
  var latSum = 0;
  var lngSum = 0;
  var count = 0;
  var i;
  var item;


  for(i=0;i<(items || []).length;i++){
    item = items[i];
    if(!item || diqV111IsDistrict(item)){ continue; }
    if(finite(Number(item.lat)) && finite(Number(item.lng))){
      latSum += Number(item.lat);
      lngSum += Number(item.lng);
      count += 1;
    }
  }


  if(count >= 1){
    return { lat:latSum / count, lng:lngSum / count, source:"result_cluster", count:count };
  }


  return null;
}


function diqV111MapCenter(){
  var c = null;
  if(!map || !mapLoaded){ return null; }
  try { c = map.getCenter(); } catch(e0) { c = null; }
  if(c && finite(Number(c.lat)) && finite(Number(c.lng))){
    return { lat:Number(c.lat), lng:Number(c.lng), source:"map_center" };
  }
  return null;
}


function diqV111BaseCenter(){
  if(adventureSearchCenter && finite(Number(adventureSearchCenter.lat)) && finite(Number(adventureSearchCenter.lng))){
    return { lat:Number(adventureSearchCenter.lat), lng:Number(adventureSearchCenter.lng), source:"adventureSearchCenter" };
  }
  if(destination && finite(Number(destination.lat)) && finite(Number(destination.lng))){
    return { lat:Number(destination.lat), lng:Number(destination.lng), source:"destination" };
  }
  if(lastFix && finite(Number(lastFix.lat)) && finite(Number(lastFix.lng))){
    return { lat:Number(lastFix.lat), lng:Number(lastFix.lng), source:"lastFix" };
  }
  return null;
}


function diqV111BestCenter(items){
  var cluster = diqV111ClusterCenter(items);
  var mapC = diqV111MapCenter();
  var base = diqV111BaseCenter();


  if(cluster){ return cluster; }
  if(mapC){ return mapC; }
  return base;
}


function diqV111ExperienceCount(entity){
  var c = entity && (entity.counts || entity.districtExperienceCounts) ? (entity.counts || entity.districtExperienceCounts) : {};
  var n = 0;
  n += Number(c.restaurants || 0);
  n += Number(c.nightlife || 0);
  n += Number(c.shopping || 0);
  n += Number(c.activities || 0);
  n += Number(c.coffee || 0);
  return n || Number(entity && entity.experienceCount || 0);
}


function diqV111Allowed(entity,intentId){
  var arr = entity && entity.intent ? entity.intent : [];
  var i;
  if(diqV111IsNarrowIntent(intentId)){ return false; }
  if(!arr.length){ return true; }
  for(i=0;i<arr.length;i++){
    if(String(arr[i]) === String(intentId)){ return true; }
  }
  return false;
}


function diqV111DistrictItem(entity,center,intentId){
  var d = center ? diqV111Miles(center.lat,center.lng,entity.lat,entity.lng) : null;
  var top = entity.topPlaceNames || [];
  var count = diqV111ExperienceCount(entity);


  return {
    label:String(entity.label || "District"),
    full:String((entity.city || "") + (entity.state ? ", " + entity.state : "")),
    lat:Number(entity.lat),
    lng:Number(entity.lng),
    kind:"district",
    category:String(entity.districtLabel || "District"),
    matchLabel:String(entity.districtLabel || "District IQ"),
    resultType:"adventure_district_registry",
    entityType:"district",
    entityClass:"district",
    districtId:String(entity.id || ""),
    districtType:String(entity.districtType || "adventure"),
    districtLabel:String(entity.districtLabel || "Adventure District"),
    districtSummary:String(entity.summary || ""),
    districtTags:entity.tags || [],
    districtExperienceCounts:entity.counts || entity.districtExperienceCounts || {},
    topPlaceNames:top.slice ? top.slice(0,6) : top,
    districtMemberPlaces:[],
    districtThumbnailCards:(function(){
      var out = [];
      var i;
      for(i=0;i<top.length && i<6;i++){
        out.push({ label:String(top[i]), category:"Top Pick", entityType:"place_preview", parentDistrictId:String(entity.id || "") });
      }
      return out;
    })(),
    experienceCount:count,
    worthScore:Number(entity.worthScore || 97),
    diqScore:Number(entity.score || 1300),
    score:Number(entity.score || 1300),
    distMiles:finite(Number(d)) ? Math.round(Number(d)*10)/10 : null,
    distanceMiles:finite(Number(d)) ? Math.round(Number(d)*10)/10 : null,
    freshnessLabel:"District IQ",
    confidenceLabel:"Destination IQ",
    localTags:["Experience District","Worth Exploring"],
    adventureCategory:String(entity.districtLabel || "District"),
    userFacingCategory:String(entity.districtLabel || "District"),
    whyStop:String(entity.summary || ""),
    recommendedBecause:String(entity.districtLabel || "District") + " â€¢ " + String(count) + " experiences â€¢ " + top.slice(0,3).join(", "),
    v111InjectedDistrict:true,
    v111CenterSource:center ? center.source : "",
    v111Intent:intentId
  };
}


function diqV111HasDistrict(items,id){
  var i;
  for(i=0;i<(items || []).length;i++){
    if(diqV111IsDistrict(items[i]) && String(items[i].districtId || "") === String(id)){ return true; }
  }
  return false;
}


function diqV111Inject(items,query){
  var source = (items || []).slice(0);
  var intentId = diqV111IntentId(query);
  var center = diqV111BestCenter(source);
  var registry = diqV111DistrictRegistry();
  var injected = [];
  var merged = [];
  var i;
  var entity;
  var d;
  var maxDistance = 10;


  if(diqV111IsNarrowIntent(intentId) || !center || !registry.length){ return source; }


  for(i=0;i<registry.length;i++){
    entity = registry[i];
    if(!entity || !diqV111Allowed(entity,intentId) || diqV111HasDistrict(source,entity.id)){ continue; }
    d = diqV111Miles(center.lat,center.lng,entity.lat,entity.lng);
    if(finite(Number(d)) && Number(d) <= maxDistance){
      injected.push(diqV111DistrictItem(entity,center,intentId));
    }
  }


  injected.sort(function(a,b){
    var sa = Number(a.diqScore || 0) - (Number(a.distMiles || 0) * 18);
    var sb = Number(b.diqScore || 0) - (Number(b.distMiles || 0) * 18);
    return sb - sa;
  });


  if(!injected.length){ return source; }


  merged = injected.concat(source);


  var out = [];
  var seen = {};
  var key;
  for(i=0;i<merged.length;i++){
    if(!merged[i]){ continue; }
    key = diqV111IsDistrict(merged[i])
      ? "district:" + String(merged[i].districtId || merged[i].label || "")
      : "place:" + diqV111Norm(String(merged[i].label || "") + "|" + String(merged[i].lat || "") + "|" + String(merged[i].lng || ""));
    if(seen[key]){ continue; }
    seen[key] = true;
    out.push(merged[i]);
    if(out.length >= 12){ break; }
  }


  try{
    window.DRIVE_IQ_ADVENTURE_V111_LAST_INJECTION = {
      build:"V111_PIPELINE_AUTHORITY_HOT_RELOAD_GUARD_FIX",
      query:String(query || activeScanQuery || activeLens || ""),
      intent:intentId,
      center:center,
      before:source.length,
      after:out.length,
      injected:(function(){
        var names = [];
        var j;
        for(j=0;j<injected.length;j++){ names.push(injected[j].label); }
        return names;
      })()
    };
    console.log("ðŸ™ï¸ V111 District injection", window.DRIVE_IQ_ADVENTURE_V111_LAST_INJECTION);
  }catch(e0){}


  return out;
}


function diqV111CountsText(counts){
  var bits = [];
  counts = counts || {};
  if(Number(counts.restaurants || 0) > 0){ bits.push("ðŸ¤ " + String(counts.restaurants) + " Restaurants"); }
  if(Number(counts.nightlife || 0) > 0){ bits.push("ðŸº " + String(counts.nightlife) + " Nightlife"); }
  if(Number(counts.shopping || 0) > 0){ bits.push("ðŸ› " + String(counts.shopping) + " Shops"); }
  if(Number(counts.activities || 0) > 0){ bits.push("ðŸš¤ " + String(counts.activities) + " Activities"); }
  return bits.slice(0,4).join(" â€¢ ");
}


function diqV111DistrictCardHtml(item,index){
  var top = item.topPlaceNames || [];
  var counts = item.districtExperienceCounts || {};
  var tags = item.districtTags || [];
  var i;
  var html = "";


  html += '<div class="diqDestThumb diqV111DistrictThumb"><div class="diqV111DistrictIcon">â˜…</div></div>';
  html += '<div class="diqV111DistrictBadge">' + escapeHTML(item.districtLabel || "Adventure District") + '</div>';
  html += '<div class="diqDestName diqV111DistrictName">' + escapeHTML(item.label || "District") + '</div>';
  html += '<div class="diqDestSub diqV111DistrictSub">' + escapeHTML(item.districtSummary || item.whyStop || "Explore the best experiences inside this district.") + '</div>';
  html += '<div class="diqV111Counts">' + escapeHTML(diqV111CountsText(counts) || String(item.experienceCount || "") + " Experiences") + '</div>';
  html += '<div class="diqV111TopPicks">';
  for(i=0;i<top.length && i<4;i++){ html += '<span>â­ ' + escapeHTML(top[i]) + '</span>'; }
  html += '</div>';
  html += '<div class="diqDestMeta diqV111Meta">' + escapeHTML(String(item.experienceCount || diqV111ExperienceCount(item)) + " experiences â€¢ Explore District") + '</div>';
  html += '<div class="diqDestWorth"><span class="diqDestTag diqDestTopPick">' + (index === 0 ? "TOP DISTRICT" : "DISTRICT IQ") + '</span><span class="diqDestTag">Worth the Drive</span><span class="diqDestTag">' + escapeHTML((tags && tags[0]) ? tags[0] : "Experience") + '</span></div>';
  return html;
}


function diqV111DecorateShelf(){
  var nodes;
  var i;
  var idx;
  var item;


  try { nodes = document.querySelectorAll("#diqDestList .diqDestItem[data-adv-idx]"); } catch(e0) { nodes = []; }


  for(i=0;i<nodes.length;i++){
    idx = Number(nodes[i].getAttribute("data-adv-idx"));
    item = destinationSearchResults && destinationSearchResults[idx] ? destinationSearchResults[idx] : null;
    if(!diqV111IsDistrict(item)){ continue; }


    try{
      nodes[i].className = String(nodes[i].className || "") + " diqV111DistrictItem";
      nodes[i].setAttribute("data-entity-type","district");
      nodes[i].setAttribute("data-district-id",String(item.districtId || ""));
      nodes[i].innerHTML = diqV111DistrictCardHtml(item,idx);
    }catch(e1){}
  }
}


/* Final wrap layer. These run after all earlier wrappers because V111 is
   appended at the bottom of the file. */
try{
  var diqV111PriorRenderChoices = renderAdventureScanChoices;
  renderAdventureScanChoices = function(items,query){
    var enhanced = diqV111Inject(items || [], query || activeScanQuery || activeLens);
    var result = diqV111PriorRenderChoices(enhanced,query);
    try { window.setTimeout(diqV111DecorateShelf,40); } catch(e0) {}
    try { window.setTimeout(diqV111DecorateShelf,220); } catch(e1) {}
    try { window.setTimeout(diqV111DecorateShelf,800); } catch(e2) {}
    return result;
  };
}catch(eRender){}


try{
  var diqV111PriorPins = renderResultPins;
  renderResultPins = function(items,preferred){
    var enhanced = diqV111Inject(items || [], activeScanQuery || activeLens);
    var pick = preferred;
    if(enhanced && enhanced.length && diqV111IsDistrict(enhanced[0])){ pick = enhanced[0]; }
    return diqV111PriorPins(enhanced,pick);
  };
}catch(ePins){}


try{
  var diqV111PriorReady = afterScanResultsReady;
  afterScanResultsReady = function(items,preferred,reason){
    var enhanced = diqV111Inject(items || [], activeScanQuery || activeLens);
    var pick = preferred;
    if(enhanced && enhanced.length && diqV111IsDistrict(enhanced[0])){ pick = enhanced[0]; }
    return diqV111PriorReady(enhanced,pick,reason);
  };
}catch(eReady){}


try{
  var diqV111PriorSyncDock = syncAdventureMapDock;
  syncAdventureMapDock = function(){
    try{
      if(adventureResults && adventureResults.length){
        adventureResults = diqV111Inject(adventureResults, activeScanQuery || activeLens);
      }
    }catch(e0){}
    return diqV111PriorSyncDock();
  };
}catch(eDock){}


/* Force a visible proof of load in console for field debugging. */
try{
  window.DRIVE_IQ_ADVENTURE_V111_PIPELINE = {
    build:"V111_PIPELINE_AUTHORITY_HOT_RELOAD_GUARD_FIX",
    inject:diqV111Inject,
    decorateShelf:diqV111DecorateShelf,
    bestCenter:diqV111BestCenter,
    registry:diqV111DistrictRegistry()
  };
  console.log("âœ… Drive IQ Adventure V111 Pipeline Authority loaded");
}catch(eV111){}



/* =========================================================
   DRIVE IQ ADVENTURE MODE V200 â€” ENGINE FOUNDATION PASS
   - Single Photo Authority: item.diqPhotoUrl
   - District IQ protected entity lane
   - Generated District IQ from broad-pool clusters
   - Shelf/list thumbnail repaint from the same photo field
   - ES5-safe. No optional chaining. No arrow functions. No template literals.
========================================================= */

window.__DRIVE_IQ_ADVENTURE_MODE_JS_V200_ENGINE_FOUNDATION__ = true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD = "V200_ADVENTURE_ENGINE_FOUNDATION";

function diqV200Norm(v) {
  try { return normText(v); } catch (e0) {}
  return String(v || "").toLowerCase().replace(/[^a-z0-9]+/g, " ").replace(/\s+/g, " ").trim();
}

function diqV200IsDistrict(item) {
  return !!(item && (
    item.entityType === "district" ||
    item.entityClass === "district" ||
    item.resultType === "adventure_district_registry" ||
    item.resultType === "entity_registry_district" ||
    item.resultType === "generated_adventure_district" ||
    item.districtId
  ));
}

function diqV200Distance(lat1, lng1, lat2, lng2) {
  try { return miles(Number(lat1), Number(lng1), Number(lat2), Number(lng2)); } catch (e0) {}
  try { return diqV111Miles(lat1, lng1, lat2, lng2); } catch (e1) {}
  var R = 3958.8;
  var a1;
  var a2;
  var dLat;
  var dLng;
  var x;
  if (!finite(Number(lat1)) || !finite(Number(lng1)) || !finite(Number(lat2)) || !finite(Number(lng2))) { return null; }
  a1 = Number(lat1) * Math.PI / 180;
  a2 = Number(lat2) * Math.PI / 180;
  dLat = (Number(lat2) - Number(lat1)) * Math.PI / 180;
  dLng = (Number(lng2) - Number(lng1)) * Math.PI / 180;
  x = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.sin(dLng / 2) * Math.sin(dLng / 2) * Math.cos(a1) * Math.cos(a2);
  return R * 2 * Math.atan2(Math.sqrt(x), Math.sqrt(1 - x));
}

function diqV200IntentId(query) {
  var q = diqV200Norm(query || activeScanQuery || activeLens || "");
  var lens = diqV200Norm(activeLens || "");
  var cat = "";

  try { cat = categoryFromQuery ? categoryFromQuery(q) : ""; } catch (e0) { cat = ""; }

  /* V202 Intent Authority:
     The selected Adventure category is stronger than broad provider query words.
     A Local Favorites pull often contains restaurant/coffee/food terms, but that
     must not silently downgrade the scan into narrow Food IQ and suppress districts. */
  if (cat === "local favorites" || lens === "local favorites" ||
      q.indexOf("local favorite") > -1 || q.indexOf("local favorites") > -1 ||
      q.indexOf("local fave") > -1 || q.indexOf("hangout") > -1) {
    return "local_favorites";
  }

  if (cat === "hidden gems" || lens === "hidden gems" || q.indexOf("hidden gem") > -1) {
    return "hidden_gems";
  }

  if (cat === "shopping" || lens === "shopping" ||
      q.indexOf("shopping district") > -1 || q.indexOf("shopping") > -1 ||
      q.indexOf("boutique") > -1 || q.indexOf("retail") > -1) {
    return "shopping";
  }

  if (cat === "popular tonight" || cat === "live music" ||
      lens === "popular tonight" || lens === "live music" ||
      q.indexOf("live music") > -1 || q.indexOf("nightlife") > -1) {
    return "nightlife";
  }

  if (cat === "coffee iq" || lens === "coffee iq" ||
      q.indexOf("coffee") > -1 || q.indexOf("cafe") > -1) {
    return "coffee";
  }

  if (cat === "golf iq" || lens === "golf iq" || q.indexOf("golf") > -1) {
    return "golf";
  }

  if (cat === "food iq" || cat === "food drinks" ||
      lens === "food iq" || lens === "food drinks" ||
      q.indexOf("food") > -1 || q.indexOf("restaurant") > -1 ||
      q.indexOf("dinner") > -1 || q.indexOf("breakfast") > -1 ||
      q.indexOf("lunch") > -1) {
    return "food";
  }

  if (q.indexOf("family") > -1 || q.indexOf("kids") > -1) {
    return "family_fun";
  }

  return "general";
}

function diqV200PhotoUrl(item, query) {
  var url = "";
  var gallery;
  var photo;
  if (!item) { return ""; }

  url = clean(
    item.diqPhotoUrl ||
    item.photoUrl ||
    item.workerPhotoUrl ||
    item.photoProxyUrl ||
    item.driveIQPhotoUrl ||
    item.thumbnailUrl ||
    item.imageUrl ||
    item.photo ||
    item.image ||
    item.thumbnail ||
    ""
  );
  if (url && diqLooksLikeImageUrl(url)) { return url; }

  try {
    photo = diqV86CanonicalPhoto(item);
    if (photo && photo.url && diqLooksLikeImageUrl(photo.url)) { return String(photo.url); }
  } catch (e0) {}

  try {
    gallery = diqV200PriorBuildPlaceGallery ? diqV200PriorBuildPlaceGallery(item, query || activeLens) : [];
    if (gallery && gallery.length && gallery[0].url && gallery[0].kind !== "map" && diqLooksLikeImageUrl(gallery[0].url)) { return String(gallery[0].url); }
  } catch (e1) {}

  return "";
}

function diqV200NormalizePhoto(item, query) {
  var url;
  if (!item) { return item; }
  url = diqV200PhotoUrl(item, query || activeScanQuery || activeLens);
  if (url) {
    item.diqPhotoUrl = String(url);
    item.photoUrl = String(url);
    item.thumbnailUrl = String(url);
    item.imageUrl = String(url);
    item.photoLoaded = true;
  }
  return item;
}

function diqV200NormalizeResults(items, query) {
  var out = [];
  var i;
  var item;
  for (i = 0; i < (items || []).length; i++) {
    item = items[i];
    if (!item) { continue; }
    diqV200NormalizePhoto(item, query);
    out.push(item);
  }
  return out;
}

function diqV200Registry() {
  var base = [];
  var extra = [
    { id:"harborwalk_village_destin", label:"HarborWalk Village", city:"Destin", state:"FL", lat:30.3935, lng:-86.5104, districtType:"adventure", districtLabel:"Waterfront Entertainment District", summary:"Walkable waterfront destination with restaurants, bars, shops, live music, boat tours, and harbor views.", tags:["Restaurants","Nightlife","Shopping","Activities","Waterfront"], topPlaceNames:["AJ's Seafood & Oyster Bar","Harry T's","Margaritaville","Coyote Ugly","Tailfins","Harbor Docks"], counts:{restaurants:18,nightlife:12,shopping:11,activities:16,coffee:3}, worthScore:99, score:1500, intent:["general","local_favorites","hidden_gems","nightlife","family_fun","food","coffee"] },
    { id:"destin_commons", label:"Destin Commons", city:"Destin", state:"FL", lat:30.3909, lng:-86.4271, districtType:"shopping", districtLabel:"Shopping District", summary:"Retail-first shopping and entertainment district with stores, restaurants, coffee, movies, and family activities.", tags:["Shopping","Restaurants","Coffee","Movies","Family"], topPlaceNames:["Bass Pro Shops","AMC Destin Commons","Belk","H&M","Uncle Buck's FishBowl","Starbucks"], counts:{restaurants:14,nightlife:2,shopping:65,activities:5,coffee:6}, worthScore:96, score:1425, intent:["shopping","general","local_favorites","hidden_gems","family_fun","food","coffee"] },
    { id:"beale_street_memphis", label:"Beale Street", city:"Memphis", state:"TN", lat:35.1395, lng:-90.0519, districtType:"entertainment", districtLabel:"Entertainment District", summary:"Historic music and nightlife district with blues clubs, restaurants, bars, and walkable downtown energy.", tags:["Live Music","Nightlife","Restaurants","History"], topPlaceNames:["B.B. King's Blues Club","Rum Boogie Cafe","Silky O'Sullivan's","A. Schwab","Handy Park"], counts:{restaurants:16,nightlife:20,shopping:6,activities:8,coffee:2}, worthScore:98, score:1450, intent:["general","local_favorites","hidden_gems","nightlife","food"] },
    { id:"broadway_nashville", label:"Broadway Nashville", city:"Nashville", state:"TN", lat:36.1609, lng:-86.7785, districtType:"entertainment", districtLabel:"Live Music District", summary:"High-energy downtown Nashville district packed with honky-tonks, rooftops, restaurants, and live music.", tags:["Live Music","Nightlife","Rooftops","Restaurants"], topPlaceNames:["Tootsie's Orchid Lounge","Robert's Western World","The Stage","Acme Feed & Seed","Assembly Food Hall"], counts:{restaurants:30,nightlife:35,shopping:10,activities:12,coffee:5}, worthScore:99, score:1500, intent:["general","local_favorites","hidden_gems","nightlife","food"] },
    { id:"disney_springs", label:"Disney Springs", city:"Lake Buena Vista", state:"FL", lat:28.3702, lng:-81.5192, districtType:"shopping", districtLabel:"Shopping & Entertainment District", summary:"Large walkable shopping, dining, entertainment, and family experience district at Walt Disney World Resort.", tags:["Shopping","Dining","Entertainment","Family"], topPlaceNames:["The Boathouse","World of Disney","Gideon's Bakehouse","Raglan Road","AMC Disney Springs"], counts:{restaurants:45,nightlife:10,shopping:90,activities:20,coffee:8}, worthScore:99, score:1500, intent:["general","shopping","family_fun","food","coffee","hidden_gems"] },
    { id:"the_wharf_orange_beach", label:"The Wharf", city:"Orange Beach", state:"AL", lat:30.2936, lng:-87.6282, districtType:"waterfront", districtLabel:"Waterfront Entertainment District", summary:"Marina-side shopping, dining, events, concerts, and family attractions near Orange Beach.", tags:["Waterfront","Restaurants","Shopping","Events"], topPlaceNames:["The Wharf Amphitheater","YoHo Rum & Tacos","Villaggio Grille","The Southern Grind","Ferris Wheel"], counts:{restaurants:12,nightlife:5,shopping:20,activities:10,coffee:2}, worthScore:96, score:1380, intent:["general","shopping","nightlife","family_fun","food","coffee"] },
    { id:"silo_square_southaven", label:"Silo Square", city:"Southaven", state:"MS", lat:34.9386, lng:-89.9966, districtType:"lifestyle", districtLabel:"Lifestyle District", summary:"Local lifestyle district with restaurants, coffee, shops, events, and walkable neighborhood energy.", tags:["Local","Restaurants","Coffee","Shopping"], topPlaceNames:["City Hall Cheesecake","Tekila Modern Mexican","Taco Felix","Silo Square shops"], counts:{restaurants:8,nightlife:2,shopping:12,activities:4,coffee:3}, worthScore:92, score:1260, intent:["general","shopping","local_favorites","hidden_gems","food","coffee"] },
    { id:"oxford_square", label:"Oxford Square", city:"Oxford", state:"MS", lat:34.3668, lng:-89.5191, districtType:"town_square", districtLabel:"Town Square District", summary:"Classic college-town square with restaurants, bars, boutiques, bookstores, events, and local character.", tags:["Restaurants","Shopping","Nightlife","College Town"], topPlaceNames:["Boure","City Grocery","Ajax Diner","Square Books","Proud Larry's"], counts:{restaurants:20,nightlife:10,shopping:22,activities:8,coffee:5}, worthScore:97, score:1400, intent:["general","shopping","nightlife","local_favorites","hidden_gems","food","coffee"] },
    { id:"downtown_hernando", label:"Downtown Hernando", city:"Hernando", state:"MS", lat:34.8239, lng:-89.9937, districtType:"historic", districtLabel:"Historic Town Square", summary:"Small-town historic square with local food, boutiques, events, courthouse views, and community energy.", tags:["Local","Historic","Restaurants","Shopping"], topPlaceNames:["Underground Cafe","Buon Cibo","Hernando Courthouse Square","Local boutiques"], counts:{restaurants:7,nightlife:2,shopping:10,activities:5,coffee:2}, worthScore:91, score:1220, intent:["general","shopping","local_favorites","hidden_gems","food","coffee"] }
  ];
  var out = [];
  var seen = {};
  var i;
  var item;

  try { base = diqV111DistrictRegistry ? diqV111DistrictRegistry() : []; } catch (e0) { base = []; }
  base = (base || []).concat(extra);
  for (i = 0; i < base.length; i++) {
    item = base[i];
    if (!item || !item.id || seen[item.id]) { continue; }
    seen[item.id] = true;
    out.push(item);
  }
  return out;
}

function diqV200BestCenter(items) {
  /* V202 Center Authority:
     Destination/search center wins over a scattered result cluster. District
     discovery must answer "what districts are around the place being explored,"
     not "what district is closest to the average of whichever POIs survived." */
  if (adventureSearchCenter &&
      finite(Number(adventureSearchCenter.lat)) &&
      finite(Number(adventureSearchCenter.lng))) {
    return {
      lat:Number(adventureSearchCenter.lat),
      lng:Number(adventureSearchCenter.lng),
      label:String(adventureSearchCenter.label || "Adventure center"),
      source:"adventure_search_center"
    };
  }

  if (destination &&
      finite(Number(destination.lat)) &&
      finite(Number(destination.lng))) {
    return {
      lat:Number(destination.lat),
      lng:Number(destination.lng),
      label:String(destination.label || "Destination"),
      source:"destination"
    };
  }

  try {
    var mapCenter = diqV111MapCenter();
    if (mapCenter) {
      mapCenter.source = mapCenter.source || "map_center";
      return mapCenter;
    }
  } catch (e0) {}

  try {
    var cluster = diqV111ClusterCenter(items);
    if (cluster) {
      cluster.source = cluster.source || "result_cluster";
      return cluster;
    }
  } catch (e1) {}

  if (lastFix && finite(Number(lastFix.lat)) && finite(Number(lastFix.lng))) {
    return {
      lat:Number(lastFix.lat),
      lng:Number(lastFix.lng),
      label:"Current location",
      source:"last_fix"
    };
  }

  return null;
}

function diqV200ExperienceCount(entity) {
  var c = entity && (entity.counts || entity.districtExperienceCounts) ? (entity.counts || entity.districtExperienceCounts) : {};
  var n = 0;
  n += Number(c.restaurants || 0);
  n += Number(c.nightlife || 0);
  n += Number(c.shopping || 0);
  n += Number(c.activities || 0);
  n += Number(c.coffee || 0);
  return n || Number(entity && entity.experienceCount || 0);
}

function diqV200AllowedForIntent(entity, intentId) {
  var arr = entity && entity.intent ? entity.intent : [];
  var i;
  if (intentId === "golf") { return false; }
  if (!arr.length) { return true; }
  for (i = 0; i < arr.length; i++) {
    if (String(arr[i]) === String(intentId)) { return true; }
  }
  return intentId === "food" || intentId === "coffee";
}

function diqV200HasDistrict(items, id) {
  var i;
  for (i = 0; i < (items || []).length; i++) {
    if (diqV200IsDistrict(items[i]) && String(items[i].districtId || "") === String(id)) { return true; }
  }
  return false;
}

function diqV200NearbyMembers(items, entity, maxMiles) {
  var out = [];
  var i;
  var item;
  var d;
  for (i = 0; i < (items || []).length; i++) {
    item = items[i];
    if (!item || diqV200IsDistrict(item)) { continue; }
    if (!finite(Number(item.lat)) || !finite(Number(item.lng))) { continue; }
    d = diqV200Distance(entity.lat, entity.lng, item.lat, item.lng);
    if (finite(Number(d)) && Number(d) <= Number(maxMiles || 1.35)) { out.push(item); }
  }
  return out;
}

function diqV200DistrictItem(entity, center, intentId, members) {
  var d = center ? diqV200Distance(center.lat, center.lng, entity.lat, entity.lng) : null;
  var top = entity.topPlaceNames || [];
  var count = Math.max(diqV200ExperienceCount(entity), (members || []).length);
  var item = {
    label:String(entity.label || "District"),
    full:String((entity.city || "") + (entity.state ? ", " + entity.state : "")),
    lat:Number(entity.lat),
    lng:Number(entity.lng),
    kind:"district",
    category:String(entity.districtLabel || "District"),
    matchLabel:String(entity.districtLabel || "District IQ"),
    resultType:"adventure_district_registry",
    entityType:"district",
    entityClass:"district",
    districtId:String(entity.id || ""),
    districtType:String(entity.districtType || "adventure"),
    districtLabel:String(entity.districtLabel || "Adventure District"),
    districtSummary:String(entity.summary || ""),
    districtTags:entity.tags || [],
    districtExperienceCounts:entity.counts || entity.districtExperienceCounts || {},
    topPlaceNames:top.slice ? top.slice(0,6) : top,
    districtMemberPlaces:(members || []).slice(0,12),
    children:(members || []).slice(0,12),
    experienceCount:count,
    worthScore:Number(entity.worthScore || 97),
    diqScore:Number(entity.score || 1400),
    score:Number(entity.score || 1400),
    distMiles:finite(Number(d)) ? Math.round(Number(d) * 10) / 10 : null,
    distanceMiles:finite(Number(d)) ? Math.round(Number(d) * 10) / 10 : null,
    freshnessLabel:"District IQ",
    confidenceLabel:"Entity IQ",
    localTags:["Experience District","Worth Exploring"],
    adventureCategory:String(entity.districtLabel || "District"),
    userFacingCategory:String(entity.districtLabel || "District"),
    whyStop:String(entity.summary || "Explore the best experiences in this walkable area."),
    recommendedBecause:String(entity.districtLabel || "District") + " â€¢ " + String(count) + " experiences",
    isProtectedEntity:true,
    categoryTruthPassed:true,
    v200InjectedDistrict:true,
    v200CenterSource:center ? center.source : "",
    v200Intent:intentId
  };
  diqV200NormalizePhoto(item, intentId);
  return item;
}

function diqV200GeneratedDistrict(items, query) {
  var source = items || [];
  var i;
  var item;
  var latSum = 0;
  var lngSum = 0;
  var count = 0;
  var members = [];
  var center;
  var label = "Worth Exploring District";
  var market = "";
  var intentId = diqV200IntentId(query);

  if (source.length < 5 || intentId === "golf") { return null; }

  for (i = 0; i < source.length; i++) {
    item = source[i];
    if (!item || diqV200IsDistrict(item)) { continue; }
    if (!finite(Number(item.lat)) || !finite(Number(item.lng))) { continue; }
    latSum += Number(item.lat);
    lngSum += Number(item.lng);
    count += 1;
    members.push(item);
  }

  if (count < 5) { return null; }
  center = { lat:latSum / count, lng:lngSum / count, source:"generated_cluster" };

  members = members.slice(0,24);
  if (destination && destination.label) { market = clean(destination.label); }
  else if (adventureSearchCenter && adventureSearchCenter.label) { market = clean(adventureSearchCenter.label); }

  if (market) { label = market + " Experience District"; }
  if (intentId === "shopping") { label = market ? market + " Shopping District" : "Shopping District"; }
  if (intentId === "nightlife") { label = market ? market + " Entertainment District" : "Entertainment District"; }
  if (intentId === "food") { label = market ? market + " Food District" : "Food District"; }

  return {
    label:label,
    full:market || "Generated from nearby places",
    lat:center.lat,
    lng:center.lng,
    kind:"district",
    category:"Generated District",
    matchLabel:"Generated District IQ",
    resultType:"generated_adventure_district",
    entityType:"district",
    entityClass:"district",
    districtId:"generated_" + String(Math.round(center.lat * 10000)) + "_" + String(Math.round(center.lng * 10000)),
    districtType:"generated",
    districtLabel:intentId === "shopping" ? "Shopping District" : (intentId === "nightlife" ? "Entertainment District" : (intentId === "food" ? "Food District" : "Adventure District")),
    districtSummary:"Drive IQ found a tight cluster of places worth exploring in this area.",
    districtTags:["Generated","Cluster IQ","Worth Exploring"],
    districtExperienceCounts:{ restaurants:0, nightlife:0, shopping:0, activities:members.length, coffee:0 },
    districtMemberPlaces:members.slice(0,12),
    children:members.slice(0,12),
    experienceCount:members.length,
    worthScore:93,
    diqScore:1180,
    score:1180,
    freshnessLabel:"Cluster IQ",
    confidenceLabel:"Generated District",
    localTags:["Cluster IQ","Worth Exploring"],
    adventureCategory:"Generated District",
    userFacingCategory:"Generated District",
    whyStop:"This area has enough nearby restaurants, shops, activities, or local anchors to explore as a district instead of one isolated stop.",
    recommendedBecause:"Generated from " + String(members.length) + " nearby places",
    isProtectedEntity:true,
    categoryTruthPassed:true,
    isGeneratedDistrict:true,
    v200GeneratedDistrict:true,
    v200Intent:intentId
  };
}

function diqV200InjectDistricts(items, query) {
  var source = diqV200NormalizeResults(items || [], query);
  var intentId = diqV200IntentId(query);
  var center = diqV200BestCenter(source);
  var registry = diqV200Registry();
  var injected = [];
  var generated;
  var merged;
  var out = [];
  var seen = {};
  var i;
  var entity;
  var d;
  var members;
  var maxDistance;
  var key;

  if (!center) { return source; }

  for (i = 0; i < registry.length; i++) {
    entity = registry[i];
    if (!entity || !diqV200AllowedForIntent(entity, intentId) || diqV200HasDistrict(source, entity.id)) { continue; }
    d = diqV200Distance(center.lat, center.lng, entity.lat, entity.lng);
    maxDistance = (intentId === "food" || intentId === "coffee") ? 4.0 : 12.0;
    if (!finite(Number(d)) || Number(d) > maxDistance) { continue; }
    members = diqV200NearbyMembers(source, entity, (intentId === "food" || intentId === "coffee") ? 1.6 : 2.4);
    if ((intentId === "food" || intentId === "coffee") && members.length < 1 && Number(d) > 1.2) { continue; }
    injected.push(diqV200DistrictItem(entity, center, intentId, members));
  }

  injected.sort(function(a, b) {
    var sa = Number(a.diqScore || 0) - (Number(a.distMiles || 0) * 16) + (Number(a.districtMemberPlaces && a.districtMemberPlaces.length || 0) * 8);
    var sb = Number(b.diqScore || 0) - (Number(b.distMiles || 0) * 16) + (Number(b.districtMemberPlaces && b.districtMemberPlaces.length || 0) * 8);
    return sb - sa;
  });

  generated = diqV200GeneratedDistrict(source, query);
  if (generated && !injected.length) { injected.push(generated); }

  if (intentId === "food" || intentId === "coffee") {
    merged = source.slice(0,1).concat(injected.slice(0,1)).concat(source.slice(1));
  } else {
    merged = injected.concat(source);
  }

  for (i = 0; i < merged.length; i++) {
    if (!merged[i]) { continue; }
    key = diqV200IsDistrict(merged[i]) ? "district:" + String(merged[i].districtId || merged[i].label || "") : "place:" + diqV200Norm(String(merged[i].label || "") + "|" + String(merged[i].lat || "") + "|" + String(merged[i].lng || ""));
    if (seen[key]) { continue; }
    seen[key] = true;
    out.push(merged[i]);
    if (out.length >= 18) { break; }
  }

  try {
    window.DRIVE_IQ_ADVENTURE_V200_LAST_PIPELINE = {
      build:"V200_ADVENTURE_ENGINE_FOUNDATION",
      query:String(query || activeScanQuery || activeLens || ""),
      intent:intentId,
      center:center,
      before:source.length,
      after:out.length,
      injected:(function(){ var names = []; var j; for (j = 0; j < injected.length; j++) { names.push(injected[j].label); } return names; }())
    };
    console.log("ðŸ™ï¸ V200 Adventure Engine pipeline", window.DRIVE_IQ_ADVENTURE_V200_LAST_PIPELINE);
  } catch (e0) {}

  return out;
}

function diqV200InjectStyles() {
  var style;
  var css;
  if (byId("diqV200AdventureEngineStyles")) { return; }
  css =
    "#diqDestList .diqDestItem[data-entity-type='district'],#diqAdventureDestResults .diqDestItem[data-entity-type='district']{border:1px solid rgba(255,206,105,.42)!important;background:linear-gradient(145deg,rgba(255,206,105,.16),rgba(40,255,190,.08) 48%,rgba(6,15,28,.96))!important;}" +
    "#diqDestList .diqV200DistrictBadge{display:inline-flex;margin:0 0 6px;padding:4px 8px;border-radius:999px;background:rgba(255,206,105,.16);border:1px solid rgba(255,206,105,.34);color:#ffdf8a;font:900 9px/1 -apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;letter-spacing:.9px;text-transform:uppercase;}" +
    "#diqDestList .diqV200DistrictChildren{display:flex;gap:5px;overflow:hidden;margin-top:7px;}" +
    "#diqDestList .diqV200DistrictChildren span{white-space:nowrap;max-width:112px;overflow:hidden;text-overflow:ellipsis;padding:4px 7px;border-radius:999px;background:rgba(255,255,255,.08);color:rgba(255,255,255,.84);font:800 10px/1 -apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;}" +
    "#diqDestList .diqDestThumb.diqV200RealThumb{background-size:cover!important;background-position:center!important;}" +
    "#diqDestList .diqDestThumb.diqV200FallbackThumb{background-image:radial-gradient(circle at 22% 18%,rgba(255,255,255,.22),transparent 31%),linear-gradient(135deg,rgba(255,206,105,.50),rgba(40,255,190,.22) 55%,rgba(8,18,30,.98))!important;}";
  style = document.createElement("style");
  style.id = "diqV200AdventureEngineStyles";
  style.type = "text/css";
  style.appendChild(document.createTextNode(css));
  try { document.head.appendChild(style); } catch (e0) {}
}

function diqV200DistrictHtml(item, index) {
  var children = item.districtMemberPlaces || item.children || [];
  var i;
  var html = "";
  html += '<div class="diqDestThumb diqV200FallbackThumb"><div class="diqV111DistrictIcon">â˜…</div></div>';
  html += '<div class="diqV200DistrictBadge">' + escapeHTML(item.districtLabel || "District IQ") + '</div>';
  html += '<div class="diqDestName diqV111DistrictName">' + escapeHTML(item.label || "District") + '</div>';
  html += '<div class="diqDestSub diqV111DistrictSub">' + escapeHTML(item.districtSummary || item.whyStop || "Explore the best places inside this area.") + '</div>';
  html += '<div class="diqDestMeta diqV111Meta">' + escapeHTML(String(item.experienceCount || children.length || "") + " experiences â€¢ Explore District") + '</div>';
  html += '<div class="diqV200DistrictChildren">';
  for (i = 0; i < children.length && i < 4; i++) { html += '<span>' + escapeHTML(children[i].label || children[i].name || "Top pick") + '</span>'; }
  html += '</div>';
  html += '<div class="diqDestWorth"><span class="diqDestTag diqDestTopPick">' + (index === 0 ? "TOP DISTRICT" : "DISTRICT IQ") + '</span><span class="diqDestTag">Worth the Drive</span></div>';
  return html;
}

function diqV200DecorateAndRepaint(items, query) {
  var nodes;
  var source = items && items.length ? items : (destinationSearchResults && destinationSearchResults.length ? destinationSearchResults : adventureResults);
  var i;
  var idx;
  var node;
  var item;
  var thumb;
  var url;
  diqV200InjectStyles();
  try { nodes = document.querySelectorAll("#diqDestList .diqDestItem[data-adv-idx],#diqAdventureDestResults .diqDestItem[data-adv-idx]"); } catch (e0) { nodes = []; }
  for (i = 0; i < nodes.length; i++) {
    node = nodes[i];
    idx = Number(node.getAttribute("data-adv-idx"));
    item = source && source[idx] ? source[idx] : null;
    if (!item) { continue; }

    if (diqV200IsDistrict(item)) {
      node.setAttribute("data-entity-type", "district");
      node.setAttribute("data-district-id", String(item.districtId || ""));
      node.className = String(node.className || "") + " diqV200DistrictItem";
      node.innerHTML = diqV200DistrictHtml(item, idx);
      continue;
    }

    diqV200NormalizePhoto(item, query);
    thumb = node.querySelector ? node.querySelector(".diqDestThumb") : null;
    if (!thumb) {
      thumb = document.createElement("div");
      thumb.className = "diqDestThumb";
      try { node.insertBefore(thumb, node.firstChild); } catch (e1) {}
    }
    url = item.diqPhotoUrl || "";
    if (url && diqLooksLikeImageUrl(url)) {
      thumb.className = "diqDestThumb realPhoto diqV200RealThumb";
      thumb.setAttribute("style", "background-image:url('" + diqCssPhotoUrl(url) + "');background-size:cover;background-position:center;");
      node.setAttribute("data-photo-loaded", "1");
      node.setAttribute("data-photo-url", String(url));
    } else {
      thumb.className = "diqDestThumb diqV200FallbackThumb";
      thumb.removeAttribute("style");
      node.setAttribute("data-photo-loaded", "fallback");
    }
  }
}

var diqV200PriorBuildPlaceGallery = null;
try {
  diqV200PriorBuildPlaceGallery = diqBuildPlaceGallery;
  diqBuildPlaceGallery = function(item, query) {
    var gallery = [];
    var prior = [];
    var url;
    var i;
    try { prior = diqV200PriorBuildPlaceGallery(item, query || activeLens) || []; } catch (e0) { prior = []; }
    url = diqV200PhotoUrl(item, query || activeLens);
    if (url) { gallery.push({ url:String(url), label:"Place Photo", kind:"official", v200:true }); }
    for (i = 0; i < prior.length; i++) {
      if (!prior[i] || !prior[i].url) { continue; }
      if (url && String(prior[i].url) === String(url)) { continue; }
      gallery.push(prior[i]);
    }
    return gallery;
  };
} catch (eGallery) {}

try {
  var diqV200PriorPhotoStyleForItem = photoStyleForItem;
  photoStyleForItem = function(item, query) {
    var url = diqV200PhotoUrl(item, query || activeLens);
    if (url) { return "background-image:url('" + diqCssPhotoUrl(url) + "');"; }
    return diqV200PriorPhotoStyleForItem(item, query || activeLens);
  };
} catch (eStyle) {}

try {
  var diqV200PriorEnrichAdventureItem = enrichAdventureItem;
  enrichAdventureItem = function(item, query) {
    var out = diqV200PriorEnrichAdventureItem(item, query || activeLens);
    return diqV200NormalizePhoto(out || item, query || activeLens);
  };
} catch (eEnrich) {}

try {
  var diqV200PriorStrictMatch = isStrictAdventureCategoryMatch;
  isStrictAdventureCategoryMatch = function(item, query) {
    if (diqV200IsDistrict(item)) { return true; }
    return diqV200PriorStrictMatch(item, query);
  };
} catch (eStrict) {}

try {
  var diqV200PriorScoreAdventure = scoreAdventure;
  scoreAdventure = function(item, query) {
    if (diqV200IsDistrict(item)) { return Number(item.diqScore || item.score || 1400); }
    return diqV200PriorScoreAdventure(item, query);
  };
} catch (eScore) {}

try {
  var diqV200PriorRenderChoices = renderAdventureScanChoices;
  renderAdventureScanChoices = function(items, query) {
    var enhanced = diqV200InjectDistricts(items || [], query || activeScanQuery || activeLens);
    var result = diqV200PriorRenderChoices(enhanced, query || activeLens);
    try { destinationSearchResults = enhanced; } catch (e0) {}
    window.setTimeout(function(){ diqV200DecorateAndRepaint(enhanced, query || activeLens); }, 40);
    window.setTimeout(function(){ diqV200DecorateAndRepaint(enhanced, query || activeLens); }, 260);
    window.setTimeout(function(){ diqV200DecorateAndRepaint(enhanced, query || activeLens); }, 900);
    window.setTimeout(function(){ diqV200DecorateAndRepaint(enhanced, query || activeLens); }, 2200);
    return result;
  };
} catch (eRenderV200) {}

try {
  var diqV200PriorRenderPins = renderResultPins;
  renderResultPins = function(items, preferred) {
    var enhanced = diqV200InjectDistricts(items || [], activeScanQuery || activeLens);
    var pick = preferred;
    if (enhanced && enhanced.length && diqV200IsDistrict(enhanced[0])) { pick = enhanced[0]; }
    return diqV200PriorRenderPins(enhanced, pick);
  };
} catch (ePinsV200) {}

try {
  var diqV200PriorAfterReady = afterScanResultsReady;
  afterScanResultsReady = function(items, preferred, reason) {
    var enhanced = diqV200InjectDistricts(items || [], activeScanQuery || activeLens);
    var pick = preferred;
    if (enhanced && enhanced.length && diqV200IsDistrict(enhanced[0])) { pick = enhanced[0]; }
    return diqV200PriorAfterReady(enhanced, pick, reason);
  };
} catch (eReadyV200) {}

try {
  if (typeof repaintAllPhotoSurfacesForItem === "function") {
    var diqV200PriorRepaintAll = repaintAllPhotoSurfacesForItem;
    repaintAllPhotoSurfacesForItem = function(item, query) {
      var result = diqV200PriorRepaintAll(diqV200NormalizePhoto(item, query || activeLens), query || activeLens);
      window.setTimeout(function(){ diqV200DecorateAndRepaint(destinationSearchResults || adventureResults || [], query || activeLens); }, 60);
      return result;
    };
  }
} catch (eRepaintV200) {}

try {
  window.DRIVE_IQ_ADVENTURE_V200_ENGINE = {
    build:"V200_ADVENTURE_ENGINE_FOUNDATION",
    photoUrl:diqV200PhotoUrl,
    normalizePhoto:diqV200NormalizePhoto,
    injectDistricts:diqV200InjectDistricts,
    decorateAndRepaint:diqV200DecorateAndRepaint,
    registry:diqV200Registry()
  };
  console.log("âœ… Drive IQ Adventure V200 Engine Foundation loaded");
} catch (eV200) {}




}());




})();




/* =========================================================
   DRIVE IQ V100 â€” SCAN LIST THUMBNAIL RESCUE
   Goal:
   - Restore visible thumbnails after V99 blanked the scan list.
   - Do not touch scan/ranking/map/arrival logic.
   - Real venue photo still wins when it loads.
   - Until then, every result card gets a premium category fallback surface.
   ES5-safe. No optional chaining. No arrow functions. No template literals.
========================================================= */




window.__DRIVE_IQ_ADVENTURE_MODE_JS_V100_SCAN_THUMBNAIL_RESCUE__ = true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD = "V100_SCAN_LIST_THUMBNAIL_RESCUE";




function diqV100InjectThumbRescueStyles() {
  var style;
  var css;




  if (byId("diqV100ThumbRescueStyles")) { return; }




  css =
    "#diqAdventureDestResults .diqDestItem[data-adv-idx]{" +
      "position:relative!important;" +
      "min-height:108px!important;" +
      "padding:12px 12px 12px 104px!important;" +
      "overflow:hidden!important;" +
    "}" +
    "#diqAdventureDestResults .diqDestItem[data-adv-idx] .diqDestThumb{" +
      "display:block!important;" +
      "position:absolute!important;" +
      "left:12px!important;" +
      "top:12px!important;" +
      "width:80px!important;" +
      "height:80px!important;" +
      "min-width:80px!important;" +
      "min-height:80px!important;" +
      "border-radius:17px!important;" +
      "overflow:hidden!important;" +
      "background-size:cover!important;" +
      "background-position:center!important;" +
      "background-repeat:no-repeat!important;" +
      "background-color:rgba(8,18,30,.96)!important;" +
      "border:1px solid rgba(255,255,255,.14)!important;" +
      "box-shadow:inset 0 0 0 1px rgba(255,255,255,.05),0 14px 24px rgba(0,0,0,.30)!important;" +
      "z-index:1!important;" +
    "}" +
    "#diqAdventureDestResults .diqDestThumb.diqV100Fallback:before{" +
      "content:'';position:absolute;inset:0;pointer-events:none;" +
      "background:radial-gradient(circle at 24% 20%,rgba(255,255,255,.22),transparent 31%),linear-gradient(145deg,rgba(255,206,105,.12),rgba(40,255,190,.10));" +
      "z-index:1;" +
    "}" +
    "#diqAdventureDestResults .diqDestThumb.diqV100Fallback:after{" +
      "content:'DRIVE IQ';position:absolute;left:8px;right:8px;bottom:8px;height:18px;border-radius:999px;" +
      "display:flex;align-items:center;justify-content:center;background:rgba(1,8,16,.58);color:rgba(255,255,255,.82);" +
      "font:900 7px/18px -apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;letter-spacing:.8px;z-index:3;" +
    "}" +
    "#diqAdventureDestResults .diqDestThumb.realPhoto:before," +
    "#diqAdventureDestResults .diqDestThumb.v69ThumbLive:before," +
    "#diqAdventureDestResults .diqDestThumb.v69ThumbLive:after," +
    "#diqAdventureDestResults .diqDestThumb.diqV86Resolved:before," +
    "#diqAdventureDestResults .diqDestThumb.diqV86Resolved:after{" +
      "display:none!important;" +
    "}" +
    "#diqAdventureDestResults .diqDestThumb .diqV69ThumbImage{" +
      "position:absolute!important;inset:0!important;width:100%!important;height:100%!important;" +
      "object-fit:cover!important;object-position:center!important;z-index:4!important;" +
    "}" +
    "#diqAdventureDestResults .diqDestThumb.food," +
    "#diqAdventureDestResults .diqDestThumb.food_iq," +
    "#diqAdventureDestResults .diqDestThumb.dining{" +
      "background-image:radial-gradient(circle at 22% 18%,rgba(255,255,255,.24),transparent 30%),linear-gradient(135deg,rgba(255,206,105,.78),rgba(255,111,72,.30) 48%,rgba(40,255,190,.42))!important;" +
    "}" +
    "#diqAdventureDestResults .diqDestThumb.water{" +
      "background-image:radial-gradient(circle at 22% 18%,rgba(255,255,255,.22),transparent 30%),linear-gradient(135deg,rgba(0,229,255,.68),rgba(40,255,190,.34) 55%,rgba(5,21,38,.98))!important;" +
    "}" +
    "#diqAdventureDestResults .diqDestThumb.outdoor{" +
      "background-image:radial-gradient(circle at 22% 18%,rgba(255,255,255,.20),transparent 30%),linear-gradient(135deg,rgba(40,255,190,.58),rgba(0,229,255,.24) 50%,rgba(6,24,21,.98))!important;" +
    "}" +
    "#diqAdventureDestResults .diqDestThumb.local{" +
      "background-image:radial-gradient(circle at 22% 18%,rgba(255,255,255,.20),transparent 30%),linear-gradient(135deg,rgba(255,206,105,.54),rgba(40,255,190,.26) 55%,rgba(8,18,30,.98))!important;" +
    "}" +
    "@media(max-width:390px){" +
      "#diqAdventureDestResults .diqDestItem[data-adv-idx]{padding-left:96px!important;}" +
      "#diqAdventureDestResults .diqDestItem[data-adv-idx] .diqDestThumb{width:72px!important;height:72px!important;min-width:72px!important;min-height:72px!important;}" +
    "}";




  style = document.createElement("style");
  style.id = "diqV100ThumbRescueStyles";
  style.type = "text/css";
  style.appendChild(document.createTextNode(css));
  try { document.head.appendChild(style); } catch (e0) {}
}




function diqV100CurrentPhoto(item) {
  var photo;
  var url = "";




  if (!item) { return ""; }




  url = clean(
    item.photoUrl ||
    item.workerPhotoUrl ||
    item.photoProxyUrl ||
    item.driveIQPhotoUrl ||
    item.thumbnailUrl ||
    item.imageUrl ||
    item.photo ||
    ""
  );




  if (url && diqLooksLikeImageUrl(url)) { return url; }




  try {
    photo = diqV86CanonicalPhoto(item);
    if (photo && photo.url && diqLooksLikeImageUrl(photo.url)) { return String(photo.url); }
  } catch (e0) {}




  try {
    url = diqV69ExistingPhoto(item);
    if (url && diqLooksLikeImageUrl(url)) { return String(url); }
  } catch (e1) {}




  return "";
}




function diqV100ApplyFallbackThumb(node, item, query) {
  var thumb;
  var cls;




  if (!node) { return; }




  thumb = node.querySelector ? node.querySelector(".diqDestThumb") : null;
  if (!thumb) {
    thumb = document.createElement("div");
    try { node.insertBefore(thumb, node.firstChild); } catch (e0) {}
  }




  cls = categoryPhotoClass(item || {}, query || activeLens) || "local";
  thumb.className = "diqDestThumb " + cls + " diqV100Fallback";
  thumb.removeAttribute("style");
  node.setAttribute("data-photo-loaded", "fallback");
}




function diqV100PaintRealThumb(node, item, url, query) {
  var thumb;
  var cls;




  if (!node || !item || !url) { return false; }




  thumb = node.querySelector ? node.querySelector(".diqDestThumb") : null;
  if (!thumb) { return false; }




  cls = categoryPhotoClass(item || {}, query || activeLens) || "local";
  thumb.className = "diqDestThumb " + cls + " realPhoto v69ThumbLive diqV100Real";
  thumb.setAttribute("style", "background-image:url('" + diqCssPhotoUrl(url) + "');background-size:cover;background-position:center;");
  node.setAttribute("data-photo-loaded", "1");
  node.setAttribute("data-photo-url", String(url));
  item.photoUrl = String(url);
  item.thumbnailUrl = String(url);
  item.photoLoaded = true;
  return true;
}




function diqV100RescueScanThumbnails(items, query) {
  var nodes = [];
  var source = items && items.length ? items : (destinationSearchResults && destinationSearchResults.length ? destinationSearchResults : adventureResults);
  var i;
  var node;
  var idx;
  var item;
  var url;




  diqV100InjectThumbRescueStyles();




  try { nodes = document.querySelectorAll("#diqAdventureDestResults .diqDestItem[data-adv-idx]"); } catch (e0) { nodes = []; }




  for (i = 0; i < nodes.length; i++) {
    node = nodes[i];
    idx = Number(node.getAttribute("data-adv-idx"));
    item = source && source[idx] ? source[idx] : null;
    if (!item) { continue; }




    try { node.setAttribute("data-photo-key", diqV86StablePhotoKey(item)); } catch (e1) {}




    url = diqV100CurrentPhoto(item);
    if (url) {
      diqV100PaintRealThumb(node, item, url, query || activeLens);
    } else {
      diqV100ApplyFallbackThumb(node, item, query || activeLens);
    }
  }
}




var diqV100PriorRenderAdventureScanChoices = renderAdventureScanChoices;
renderAdventureScanChoices = function(items, query) {
  var result = diqV100PriorRenderAdventureScanChoices(items, query);
  window.setTimeout(function(){ diqV100RescueScanThumbnails(items || [], query || activeLens); }, 40);
  window.setTimeout(function(){ diqV100RescueScanThumbnails(items || [], query || activeLens); }, 500);
  window.setTimeout(function(){ diqV100RescueScanThumbnails(items || [], query || activeLens); }, 1600);
  window.setTimeout(function(){ diqV100RescueScanThumbnails(items || [], query || activeLens); }, 3600);
  return result;
};




var diqV100PriorV69PaintThumb = diqV69PaintThumb;
diqV69PaintThumb = function(item, imageUrl) {
  var result = diqV100PriorV69PaintThumb(item, imageUrl);
  window.setTimeout(function(){ diqV100RescueScanThumbnails(destinationSearchResults || adventureResults || [], activeScanQuery || activeLens); }, 80);
  return result;
};




if (typeof repaintAllPhotoSurfacesForItem === "function") {
  var diqV100PriorRepaintAllPhotoSurfacesForItem = repaintAllPhotoSurfacesForItem;
  repaintAllPhotoSurfacesForItem = function(item, query) {
    var result = diqV100PriorRepaintAllPhotoSurfacesForItem(item, query || activeLens);
    window.setTimeout(function(){ diqV100RescueScanThumbnails(destinationSearchResults || adventureResults || [], query || activeLens); }, 80);
    return result;
  };
}




try {
  console.log("âœ… Drive IQ V100 Scan Thumbnail Rescue loaded");
} catch (e100) {}

/* =========================================================
   DRIVE IQ ADVENTURE MODE V201
   DISTRICT VISIBILITY + CANONICAL STATE AUTHORITY

   Purpose:
   - Makes District IQ survive every late Adventure Mode wrapper.
   - Promotes verified/registry districts into the final canonical result list.
   - Keeps pins, SHOW PICKS count, shelf cards, click selection, and info cards
     aligned to the same district-aware array.
   - Re-applies district card rendering after late thumbnail/photo repaint passes.
   - Does not change provider pulls, place ranking, routing, or narrow-category truth.

   ES5 SAFE
========================================================= */
(function(){
"use strict";

if(window.__DRIVE_IQ_ADVENTURE_MODE_V201_DISTRICT_VISIBILITY__){ return; }
window.__DRIVE_IQ_ADVENTURE_MODE_V201_DISTRICT_VISIBILITY__ = true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD = "V201_DISTRICT_VISIBILITY_CANONICAL_AUTHORITY";

var diqV201LastResults = [];
var diqV201LastQuery = "";
var diqV201RenderToken = 0;

function diqV201IsDistrict(item){
  if(!item){ return false; }

  try{
    if(window.DRIVE_IQ_ADVENTURE_V200_ENGINE &&
       window.DRIVE_IQ_ADVENTURE_V200_ENGINE.injectDistricts &&
       (
         item.entityType === "district" ||
         item.entityClass === "district" ||
         item.districtId
       )){
      return true;
    }
  }catch(e0){}

  return !!(
    item.entityType === "district" ||
    item.entityClass === "district" ||
    item.resultType === "adventure_district_registry" ||
    item.resultType === "entity_registry_district" ||
    item.resultType === "entity_iq_district" ||
    item.resultType === "generated_adventure_district" ||
    item.districtId
  );
}

function diqV201Norm(v){
  try{
    return normText(v);
  }catch(e0){
    return String(v || "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g," ")
      .replace(/\s+/g," ")
      .trim();
  }
}

function diqV201Key(item){
  if(diqV201IsDistrict(item)){
    return "district:" + String(
      item.districtId ||
      item.entityId ||
      item.id ||
      diqV201Norm(item.label || item.name || "district")
    );
  }

  return "place:" + diqV201Norm(
    String(item && (item.placeId || item.googlePlaceId || item.mapboxId || "")) +
    "|" + String(item && (item.label || item.name || "")) +
    "|" + String(item && item.lat || "") +
    "|" + String(item && item.lng || "")
  );
}

function diqV201Dedupe(items){
  var out = [];
  var seen = {};
  var i;
  var item;
  var key;

  for(i=0;i<(items || []).length;i++){
    item = items[i];
    if(!item){ continue; }
    key = diqV201Key(item);
    if(seen[key]){ continue; }
    seen[key] = true;
    out.push(item);
  }

  return out;
}

function diqV201Enhance(items,query){
  var source = diqV201Dedupe((items || []).slice(0));
  var enhanced = source;
  var q = String(query || activeScanQuery || activeLens || "");

  try{
    if(window.DRIVE_IQ_ADVENTURE_V200_ENGINE &&
       typeof window.DRIVE_IQ_ADVENTURE_V200_ENGINE.injectDistricts === "function"){
      enhanced = window.DRIVE_IQ_ADVENTURE_V200_ENGINE.injectDistricts(source,q) || source;
    }else if(window.DRIVE_IQ_ADVENTURE_V110_HANDOFF_DISTRICT_IQ &&
             typeof window.DRIVE_IQ_ADVENTURE_V110_HANDOFF_DISTRICT_IQ.inject === "function"){
      enhanced = window.DRIVE_IQ_ADVENTURE_V110_HANDOFF_DISTRICT_IQ.inject(source,q) || source;
    }
  }catch(e0){
    enhanced = source;
  }

  enhanced = diqV201Dedupe(enhanced);

  /* Keep a district near the front for broad discovery scans without
     replacing every individual place. */
  enhanced.sort(function(a,b){
    var ad = diqV201IsDistrict(a);
    var bd = diqV201IsDistrict(b);
    var as = Number(a && (a.diqScore || a.score || a.worthScore) || 0);
    var bs = Number(b && (b.diqScore || b.score || b.worthScore) || 0);

    if(ad && !bd){ return -1; }
    if(!ad && bd){ return 1; }
    return bs - as;
  });

  return enhanced.slice(0,18);
}

function diqV201Commit(items,query){
  var enhanced = diqV201Enhance(items,query);

  diqV201LastResults = enhanced.slice(0);
  diqV201LastQuery = String(query || activeScanQuery || activeLens || "");

  try{ adventureResults = enhanced.slice(0); }catch(e0){}
  try{ destinationSearchResults = enhanced.slice(0); }catch(e1){}
  try{
    if(typeof diqV73CanonicalResults !== "undefined"){
      diqV73CanonicalResults = enhanced.slice(0);
    }
  }catch(e2){}
  try{
    window.DRIVE_IQ_CANONICAL_ADVENTURE_RESULTS = enhanced.slice(0);
  }catch(e3){}

  return enhanced;
}

function diqV201Decorate(items,query){
  var source = items && items.length ? items : diqV201LastResults;

  try{
    if(window.DRIVE_IQ_ADVENTURE_V200_ENGINE &&
       typeof window.DRIVE_IQ_ADVENTURE_V200_ENGINE.decorateAndRepaint === "function"){
      window.DRIVE_IQ_ADVENTURE_V200_ENGINE.decorateAndRepaint(
        source,
        query || diqV201LastQuery || activeLens
      );
    }
  }catch(e0){}
}

function diqV201ScheduleDecorate(items,query){
  var token;
  diqV201RenderToken += 1;
  token = diqV201RenderToken;

  function run(){
    if(token !== diqV201RenderToken){ return; }
    diqV201Decorate(items,query);
  }

  /* These timings intentionally run just after the V100 thumbnail rescues. */
  window.setTimeout(run,80);
  window.setTimeout(run,620);
  window.setTimeout(run,1720);
  window.setTimeout(run,3820);
}

function diqV201DistrictCount(items){
  var count = 0;
  var i;
  for(i=0;i<(items || []).length;i++){
    if(diqV201IsDistrict(items[i])){ count += 1; }
  }
  return count;
}

/* Final result handoff authority. */
try{
  var diqV201PriorAfterReady = afterScanResultsReady;
  afterScanResultsReady = function(items,preferred,reason){
    var enhanced = diqV201Commit(items || [],activeScanQuery || activeLens);
    var pick = preferred;

    if(enhanced.length && diqV201IsDistrict(enhanced[0])){
      pick = enhanced[0];
    }

    var result = diqV201PriorAfterReady(enhanced,pick,reason);
    diqV201ScheduleDecorate(enhanced,activeScanQuery || activeLens);
    return result;
  };
}catch(eReady){}

/* Final pin authority. */
try{
  var diqV201PriorRenderPins = renderResultPins;
  renderResultPins = function(items,preferred){
    var enhanced = diqV201Commit(items || [],activeScanQuery || activeLens);
    var pick = preferred;

    if(enhanced.length && diqV201IsDistrict(enhanced[0])){
      pick = enhanced[0];
    }

    return diqV201PriorRenderPins(enhanced,pick);
  };
}catch(ePins){}

/* Final shelf authority, installed after V100 and every earlier wrapper. */
try{
  var diqV201PriorRenderChoices = renderAdventureScanChoices;
  renderAdventureScanChoices = function(items,query){
    var q = String(query || activeScanQuery || activeLens || "");
    var enhanced = diqV201Commit(items || [],q);
    var result = diqV201PriorRenderChoices(enhanced,q);

    diqV201ScheduleDecorate(enhanced,q);

    try{
      if(typeof diqV73UpdatePickCount === "function"){
        diqV73UpdatePickCount(enhanced.length);
      }
    }catch(e0){}

    return result;
  };
}catch(eChoices){}

/* SHOW PICKS and map dock must use the same canonical list. */
try{
  var diqV201PriorSyncDock = syncAdventureMapDock;
  syncAdventureMapDock = function(){
    if(diqV201LastResults.length){
      try{ adventureResults = diqV201LastResults.slice(0); }catch(e0){}
      try{ destinationSearchResults = diqV201LastResults.slice(0); }catch(e1){}
    }
    return diqV201PriorSyncDock();
  };
}catch(eDock){}

/* Preserve district selection when any later card lookup uses global arrays. */
try{
  var diqV201PriorOpenInfo = openAdventureInfoCard;
  openAdventureInfoCard = function(item,preserveBrowseCamera){
    var result = diqV201PriorOpenInfo(item,preserveBrowseCamera);

    if(diqV201IsDistrict(item)){
      try{
        if(typeof diqV109DecorateInfoCard === "function"){
          diqV109DecorateInfoCard(item);
          window.setTimeout(function(){ diqV109DecorateInfoCard(item); },140);
        }
      }catch(e0){}
    }

    return result;
  };
}catch(eInfo){}

/* Keep late thumbnail repaint from becoming the final visible district state. */
try{
  if(typeof diqV100RescueScanThumbnails === "function"){
    var diqV201PriorThumbRescue = diqV100RescueScanThumbnails;
    diqV100RescueScanThumbnails = function(items,query){
      var result = diqV201PriorThumbRescue(items,query);
      window.setTimeout(function(){
        diqV201Decorate(
          diqV201LastResults.length ? diqV201LastResults : items,
          query || diqV201LastQuery || activeLens
        );
      },30);
      return result;
    };
  }
}catch(eThumb){}

/* Public diagnostics for road testing. */
try{
  window.DRIVE_IQ_ADVENTURE_V201_DISTRICT_VISIBILITY = {
    build:"V201_DISTRICT_VISIBILITY_CANONICAL_AUTHORITY",
    enhance:diqV201Enhance,
    commit:diqV201Commit,
    isDistrict:diqV201IsDistrict,
    state:function(){
      return {
        query:diqV201LastQuery,
        resultCount:diqV201LastResults.length,
        districtCount:diqV201DistrictCount(diqV201LastResults),
        names:(function(){
          var out = [];
          var i;
          for(i=0;i<diqV201LastResults.length;i++){
            out.push(String(diqV201LastResults[i].label || "Result"));
          }
          return out;
        }())
      };
    }
  };

  console.log("âœ… Drive IQ Adventure V201 District Visibility Authority loaded");
}catch(ePublic){}

}());


/* =========================================================
   DRIVE IQ ADVENTURE MODE V203
   LIVE SCAN ENGINE BRIDGE + DISTRICT SURVIVAL AUTHORITY

   Root fix:
   - Adventure Mode's provider candidates now pass through
     window.DriveIQScanEngine.scan() before pins/cards commit.
   - District entities are preserved through the old experience filter.
   - One canonical engine-owned result array powers pins, shelf, Show Picks,
     preferred result, and diagnostics.
   - The bridge is synchronous and ES5-safe.
========================================================= */
(function(){
"use strict";

if(window.__DRIVE_IQ_ADVENTURE_V203_SCAN_ENGINE_BRIDGE__){ return; }
window.__DRIVE_IQ_ADVENTURE_V203_SCAN_ENGINE_BRIDGE__ = true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD = "V203_LIVE_SCAN_ENGINE_BRIDGE";

var diqV203LastResults = [];
var diqV203LastReport = null;
var diqV203LastSignature = "";
var diqV203BridgeBusy = false;

function diqV203IsDistrict(item){
  return !!(
    item &&
    (
      item.entityType === "district" ||
      item.entityClass === "district" ||
      item.poiClass === "district" ||
      item.kind === "district" ||
      item.type === "district" ||
      item.districtId ||
      item.resultType === "entity_registry_district"
    )
  );
}

function diqV203Center(){
  var c = null;

  if(adventureSearchCenter &&
     finite(Number(adventureSearchCenter.lat)) &&
     finite(Number(adventureSearchCenter.lng))){
    c = {
      lat:Number(adventureSearchCenter.lat),
      lng:Number(adventureSearchCenter.lng),
      label:String(adventureSearchCenter.label || "Adventure center")
    };
  }else if(destination &&
           finite(Number(destination.lat)) &&
           finite(Number(destination.lng))){
    c = {
      lat:Number(destination.lat),
      lng:Number(destination.lng),
      label:String(destination.label || "Destination")
    };
  }else if(lastFix &&
           finite(Number(lastFix.lat)) &&
           finite(Number(lastFix.lng))){
    c = {
      lat:Number(lastFix.lat),
      lng:Number(lastFix.lng),
      label:"Current location"
    };
  }

  return c;
}

function diqV203Signature(items,query){
  var parts = [String(query || ""),String(activeLens || "")];
  var i;
  var item;

  for(i=0;i<(items || []).length && i<20;i++){
    item = items[i] || {};
    parts.push(
      String(item.placeId || item.googlePlaceId || item.mapboxId || item.districtId || "") +
      "|" + String(item.label || item.name || "") +
      "|" + String(item.lat || "") +
      "|" + String(item.lng || "")
    );
  }

  return parts.join("::");
}

function diqV203RunEngine(items,query){
  var source = items && items.length ? items.slice(0) : [];
  var q = String(query || activeScanQuery || activeLens || "");
  var sig = diqV203Signature(source,q);
  var center = diqV203Center();
  var response;
  var results;

  if(!source.length){ return source; }

  if(sig === diqV203LastSignature && diqV203LastResults.length){
    return diqV203LastResults.slice(0);
  }

  if(diqV203BridgeBusy){ return source; }

  if(!window.DriveIQScanEngine ||
     typeof window.DriveIQScanEngine.scan !== "function"){
    try{
      console.warn("[Adventure V203] DriveIQScanEngine.scan unavailable");
    }catch(e0){}
    return source;
  }

  diqV203BridgeBusy = true;

  try{
    response = window.DriveIQScanEngine.scan({
      candidates:source,
      query:q,
      sourceQuery:q,
      category:String(activeLens || q),
      intent:String(activeLens || q),
      lens:String(activeLens || ""),
      scope:String(adventureSearchScope || "near_me"),
      location:center,
      center:center,
      destination:destination || null,
      targetResults:Math.max(10,source.length),
      debug:window.DRIVE_IQ_SCAN_DEBUG === true
    });

    results = response && response.results && response.results.length
      ? response.results.slice(0)
      : source;

    diqV203LastResults = results.slice(0);
    diqV203LastReport = response && response.report ? response.report : null;
    diqV203LastSignature = sig;

    try{ adventureResults = results.slice(0); }catch(e1){}
    try{ destinationSearchResults = results.slice(0); }catch(e2){}
    try{ diqV201LastResults = results.slice(0); }catch(e3){}
    try{ diqV73CanonicalResults = results.slice(0); }catch(e4){}
    try{ window.DRIVE_IQ_CANONICAL_ADVENTURE_RESULTS = results.slice(0); }catch(e5){}

    try{
      console.log("[Adventure V203] Scan Engine bridge committed",{
        build:response && response.build ? response.build : "",
        query:q,
        inputCount:source.length,
        outputCount:results.length,
        districtCount:(function(){
          var n = 0;
          var i;
          for(i=0;i<results.length;i++){
            if(diqV203IsDistrict(results[i])){ n += 1; }
          }
          return n;
        }()),
        names:(function(){
          var out = [];
          var i;
          for(i=0;i<results.length;i++){
            out.push(String(results[i].label || "Result"));
          }
          return out;
        }())
      });
    }catch(e6){}

    return results;
  }catch(err){
    try{ console.error("[Adventure V203] Scan Engine bridge failed",err); }catch(e7){}
    return source;
  }finally{
    diqV203BridgeBusy = false;
  }
}

/* District Survival Authority:
   Legacy experience filters may still reject "district" as a non-place.
   Preserve engine-verified districts while letting the old filter govern places. */
try{
  var diqV203PriorExperienceFilter = diqV22FilterExperienceResults;
  diqV22FilterExperienceResults = function(items,query){
    var source = items || [];
    var districts = [];
    var places = [];
    var filteredPlaces;
    var out = [];
    var seen = {};
    var i;
    var item;
    var key;

    for(i=0;i<source.length;i++){
      item = source[i];
      if(diqV203IsDistrict(item)){ districts.push(item); }
      else{ places.push(item); }
    }

    filteredPlaces = diqV203PriorExperienceFilter(places,query) || [];

    source = districts.concat(filteredPlaces);

    for(i=0;i<source.length;i++){
      item = source[i];
      key = diqV203IsDistrict(item)
        ? "district:" + String(item.districtId || item.entityId || item.label || i)
        : "place:" + String(item.placeId || item.googlePlaceId || item.mapboxId || item.label || i) +
          "|" + String(item.lat || "") + "|" + String(item.lng || "");

      if(seen[key]){ continue; }
      seen[key] = true;
      out.push(item);
    }

    return out;
  };
}catch(eFilter){}

/* Final shelf bridge. */
try{
  var diqV203PriorRenderChoices = renderAdventureScanChoices;
  renderAdventureScanChoices = function(items,query){
    var q = String(query || activeScanQuery || activeLens || "");
    var engineResults = diqV203RunEngine(items || [],q);
    var result = diqV203PriorRenderChoices(engineResults,q);

    try{
      if(typeof diqV73UpdatePickCount === "function"){
        diqV73UpdatePickCount(engineResults.length);
      }
    }catch(e0){}

    return result;
  };
}catch(eChoices){}

/* Final pin bridge. */
try{
  var diqV203PriorRenderPins = renderResultPins;
  renderResultPins = function(items,preferred){
    var engineResults = diqV203RunEngine(
      items || [],
      activeScanQuery || activeLens
    );
    var pick = preferred;

    if(engineResults.length && diqV203IsDistrict(engineResults[0])){
      pick = engineResults[0];
    }

    return diqV203PriorRenderPins(engineResults,pick);
  };
}catch(ePins){}

/* Final completion bridge. */
try{
  var diqV203PriorAfterReady = afterScanResultsReady;
  afterScanResultsReady = function(items,preferred,reason){
    var engineResults = diqV203RunEngine(
      items || [],
      activeScanQuery || activeLens
    );
    var pick = preferred;

    if(engineResults.length && diqV203IsDistrict(engineResults[0])){
      pick = engineResults[0];
    }

    return diqV203PriorAfterReady(engineResults,pick,reason);
  };
}catch(eReady){}

/* Show Picks / dock canonical authority. */
try{
  var diqV203PriorSyncDock = syncAdventureMapDock;
  syncAdventureMapDock = function(){
    if(diqV203LastResults.length){
      try{ adventureResults = diqV203LastResults.slice(0); }catch(e0){}
      try{ destinationSearchResults = diqV203LastResults.slice(0); }catch(e1){}
    }
    return diqV203PriorSyncDock();
  };
}catch(eDock){}

/* Public proof-of-life diagnostics. */
window.DRIVE_IQ_ADVENTURE_V203_BRIDGE = {
  build:"V203_LIVE_SCAN_ENGINE_BRIDGE",
  run:diqV203RunEngine,
  isDistrict:diqV203IsDistrict,
  state:function(){
    var districts = [];
    var names = [];
    var i;

    for(i=0;i<diqV203LastResults.length;i++){
      names.push(String(diqV203LastResults[i].label || "Result"));
      if(diqV203IsDistrict(diqV203LastResults[i])){
        districts.push(String(diqV203LastResults[i].label || "District"));
      }
    }

    return {
      adventureBuild:window.DRIVE_IQ_ADVENTURE_MODE_BUILD,
      scanEngineBuild:window.DriveIQScanEngine && window.DriveIQScanEngine.build
        ? window.DriveIQScanEngine.build
        : "",
      resultCount:diqV203LastResults.length,
      districtCount:districts.length,
      districts:districts,
      names:names,
      report:diqV203LastReport
    };
  }
};

try{
  console.log("âœ… Drive IQ Adventure V203 Live Scan Engine Bridge loaded");
}catch(ePublic){}

try{
  console.log("âœ… Drive IQ Adventure V204 Runtime Recovery loaded",{
    build:window.DRIVE_IQ_ADVENTURE_MODE_BUILD,
    renderCompatibility:
      typeof renderAdventureResults === "function",
    scanEngine:
      window.DriveIQScanEngine && window.DriveIQScanEngine.build
        ? window.DriveIQScanEngine.build
        : "NOT_LOADED",
    bridge:
      !!window.DRIVE_IQ_ADVENTURE_V203_BRIDGE
  });
}catch(eV204Proof){}

}());


/* =========================================================
   DRIVE IQ ADVENTURE MODE V205
   REOPEN CURRENT DESTINATION SEARCH AUTHORITY

   Fix:
   - Typing or refocusing the same destination (for example "Destin")
     must reopen destination choices.
   - The older destination-lock suppression remains active for passive
     page refreshes and route-state sync, but not while the user is
     actively editing the search field.
   ES5 SAFE
========================================================= */
(function(){
"use strict";

if(window.__DRIVE_IQ_ADVENTURE_V205_REOPEN_CURRENT_DESTINATION__){ return; }
window.__DRIVE_IQ_ADVENTURE_V205_REOPEN_CURRENT_DESTINATION__ = true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD = "V205_REOPEN_CURRENT_DESTINATION_SEARCH";

var diqV205PriorShouldSuppressDestinationChooser =
  shouldSuppressDestinationChooser;

shouldSuppressDestinationChooser = function(query){
  var input = byId("adventureSearch");
  var q = clean(query);
  var userEditing = false;

  try{
    userEditing =
      !!input &&
      document.activeElement === input &&
      q.length >= 3;
  }catch(e0){
    userEditing = false;
  }

  /* User intent outranks stale destination-lock suppression.
     This allows an already-selected destination such as Destin
     to reopen its chooser when the user taps or types it again. */
  if(userEditing){
    return false;
  }

  return diqV205PriorShouldSuppressDestinationChooser(q);
};

/* Ensure a focused, already-filled query gets a fresh chooser even when
   the text itself did not change after closing the panel. */
function diqV205BindCurrentDestinationReopen(){
  var input = byId("adventureSearch");

  if(!input || input.getAttribute("data-v205-reopen-current") === "1"){
    return;
  }

  input.setAttribute("data-v205-reopen-current","1");

  input.addEventListener("focus",function(){
    var q = clean(input.value);

    if(q.length < 3 || isExplicitExperienceQuery(q)){ return; }

    window.setTimeout(function(){
      try{
        if(document.activeElement !== input){ return; }
        searchDestinations(q);
      }catch(e0){}
    },140);
  },false);
}

if(document.readyState === "loading"){
  document.addEventListener(
    "DOMContentLoaded",
    diqV205BindCurrentDestinationReopen,
    false
  );
}else{
  diqV205BindCurrentDestinationReopen();
}

window.setTimeout(diqV205BindCurrentDestinationReopen,350);
window.setTimeout(diqV205BindCurrentDestinationReopen,1100);

try{
  console.log("âœ… Drive IQ Adventure V205 Reopen Current Destination loaded");
}catch(ePublic){}

}());


/* =========================================================
   DRIVE IQ ADVENTURE MODE V206
   DESTINATION DROPDOWN + RESULTS SHELF SEPARATION AUTHORITY

   Fixes:
   1. Destination choices live INSIDE the Adventure hero directly beneath
      the search row. No viewport math. No status-bar overlap.
   2. Post-scan SHOW PICKS uses its own wide mobile shelf instead of the
      destination dropdown geometry.
   3. Destination Authority cleans broad city searches:
      - canonical destination first
      - verified districts next
      - correct nearby city/region results next
      - hotels, hospitals, amenities, zero-experience districts, and
        far-away international lookalikes suppressed by default
   4. Destination chooser closes automatically when a destination is chosen
      or a scan begins.
   ES5 SAFE
========================================================= */
(function(){
"use strict";

if(window.__DRIVE_IQ_ADVENTURE_V206_PANEL_SEPARATION_AUTHORITY__){ return; }
window.__DRIVE_IQ_ADVENTURE_V206_PANEL_SEPARATION_AUTHORITY__ = true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD =
  "V206_DESTINATION_DROPDOWN_RESULTS_SHELF_AUTHORITY";

function diqV206IsDistrict(item){
  return !!(
    item &&
    (
      item.entityType === "district" ||
      item.entityClass === "district" ||
      item.poiClass === "district" ||
      item.kind === "district" ||
      item.type === "district" ||
      item.districtId ||
      item.resultType === "adventure_district_registry" ||
      item.resultType === "entity_registry_district"
    )
  );
}

function diqV206Panel(){
  return byId("diqAdventureDestResults") || ensureDestinationResultsPanel();
}

function diqV206Head(panel){
  return panel && panel.querySelector
    ? panel.querySelector(".diqDestHead")
    : null;
}

function diqV206MoveDestinationPanel(){
  var panel = diqV206Panel();
  var searchWrap = document.querySelector(".searchWrap");
  var hero = byId("adventureHero");

  if(!panel || !searchWrap || !hero){ return; }

  if(panel.parentNode !== hero || panel.previousSibling !== searchWrap){
    try{
      if(searchWrap.nextSibling){
        hero.insertBefore(panel,searchWrap.nextSibling);
      }else{
        hero.appendChild(panel);
      }
    }catch(e0){}
  }

  panel.className = String(panel.className || "")
    .replace(/\bdiqModeShelf\b/g,"")
    .replace(/\s+/g," ")
    .trim();

  if(String(panel.className || "").indexOf("diqModeDestination") < 0){
    panel.className = clean(String(panel.className || "") + " diqModeDestination");
  }
}

function diqV206MoveShelfPanel(){
  var panel = diqV206Panel();

  if(!panel){ return; }

  if(panel.parentNode !== document.body){
    try{ document.body.appendChild(panel); }catch(e0){}
  }

  panel.className = String(panel.className || "")
    .replace(/\bdiqModeDestination\b/g,"")
    .replace(/\s+/g," ")
    .trim();

  if(String(panel.className || "").indexOf("diqModeShelf") < 0){
    panel.className = clean(String(panel.className || "") + " diqModeShelf");
  }
}

function diqV206CloseChooser(){
  var panel = byId("diqAdventureDestResults");
  if(!panel){ return; }

  if(String(panel.className || "").indexOf("diqModeDestination") > -1){
    panel.className = String(panel.className || "")
      .replace(/\bon\b/g,"")
      .replace(/\s+/g," ")
      .trim();
    destinationResultOpen = false;
  }
}

function diqV206Text(item){
  return normText(
    String(item && item.label || "") + " " +
    String(item && item.full || "") + " " +
    String(item && item.kind || "") + " " +
    String(item && item.category || "") + " " +
    String(item && item.resultType || "")
  );
}

function diqV206QueryWantsAmenity(query){
  var q = normText(query);
  return (
    q.indexOf("hotel") > -1 ||
    q.indexOf("motel") > -1 ||
    q.indexOf("inn") > -1 ||
    q.indexOf("hospital") > -1 ||
    q.indexOf("emergency") > -1 ||
    q.indexOf("restaurant") > -1 ||
    q.indexOf("coffee") > -1 ||
    q.indexOf("store") > -1
  );
}

function diqV206CanonicalDestination(query){
  var indexed;
  try{ indexed = adventureDestinationIndexMatch(query); }catch(e0){ indexed = null; }
  return indexed ? indexedAdventureItem(indexed) : null;
}

function diqV206DestinationAuthority(items,query){
  var q = normText(query);
  var source = (items || []).slice(0);
  var canonical = diqV206CanonicalDestination(query);
  var wantsAmenity = diqV206QueryWantsAmenity(query);
  var explicitFlorida =
    q.indexOf(" florida") > -1 ||
    q.indexOf(" fl") > -1 ||
    q === "destin";
  var out = [];
  var seen = {};
  var i;
  var item;
  var txt;
  var key;
  var d;
  var districtCount;
  var exactLabel;

  function add(candidate){
    var k;
    if(!candidate){ return; }
    k = normText(
      String(candidate.resultType || "") + "|" +
      String(candidate.districtId || candidate.adventureIndexId || "") + "|" +
      String(candidate.label || "") + "|" +
      String(candidate.lat || "") + "|" +
      String(candidate.lng || "")
    );
    if(seen[k]){ return; }
    seen[k] = true;
    out.push(candidate);
  }

  if(canonical){ add(canonical); }

  /* Verified, experience-backed districts outrank generic geocoder records. */
  for(i=0;i<source.length;i++){
    item = source[i];
    if(!diqV206IsDistrict(item)){ continue; }

    districtCount = Number(
      item.experienceCount ||
      item.districtExperienceCount ||
      item.experience_count ||
      0
    );

    if(districtCount <= 0){ continue; }
    add(item);
  }

  for(i=0;i<source.length;i++){
    item = source[i];
    if(!item || diqV206IsDistrict(item)){ continue; }

    txt = diqV206Text(item);
    exactLabel = normText(item.label || "") === q;
    d = finite(Number(item.distMiles)) ? Number(item.distMiles) : null;

    /* Broad destination searches should not become hotel/hospital searches. */
    if(!wantsAmenity){
      if(
        txt.indexOf(" hotel") > -1 ||
        txt.indexOf(" motel") > -1 ||
        txt.indexOf(" inn") > -1 ||
        txt.indexOf(" hospital") > -1 ||
        txt.indexOf(" emergency") > -1 ||
        txt.indexOf(" amenity") > -1
      ){
        continue;
      }
    }

    /* Remove far-away international lookalikes when a strong US authority exists. */
    if(canonical && finite(Number(d)) && Number(d) > 1200 && !exactLabel){
      continue;
    }

    if(explicitFlorida && canonical){
      if(
        txt.indexOf("turkey") > -1 ||
        txt.indexOf("ireland") > -1 ||
        txt.indexOf("county meath") > -1 ||
        txt.indexOf("karakocan") > -1 ||
        txt.indexOf("eastern anatolia") > -1
      ){
        continue;
      }
    }

    add(item);
  }

  out.sort(function(a,b){
    var sa = 0;
    var sb = 0;
    var ta = diqV206Text(a);
    var tb = diqV206Text(b);

    if(a.resultType === "adventure_index" || a.canonical){ sa += 1000; }
    if(b.resultType === "adventure_index" || b.canonical){ sb += 1000; }

    if(diqV206IsDistrict(a)){ sa += 700 + Number(a.experienceCount || 0); }
    if(diqV206IsDistrict(b)){ sb += 700 + Number(b.experienceCount || 0); }

    if(ta.indexOf(q) > -1){ sa += 240; }
    if(tb.indexOf(q) > -1){ sb += 240; }

    if(ta.indexOf("florida") > -1){ sa += 180; }
    if(tb.indexOf("florida") > -1){ sb += 180; }

    try{ sa += scoreDestination(a,query); }catch(e0){}
    try{ sb += scoreDestination(b,query); }catch(e1){}

    return sb - sa;
  });

  return out.slice(0,6);
}

function diqV206EnsureCloseButton(){
  var panel = diqV206Panel();
  var head = diqV206Head(panel);
  var close = byId("diqDestClose");

  if(!panel || !head){ return; }

  if(!close){
    close = document.createElement("button");
    close.id = "diqDestClose";
    close.type = "button";
    close.setAttribute("aria-label","Close destination choices");
    close.innerHTML = "&times;";
    close.onclick = function(event){
      if(event && event.preventDefault){ event.preventDefault(); }
      if(event && event.stopPropagation){ event.stopPropagation(); }
      hideDestinationResults();
      try{
        var input = byId("adventureSearch");
        if(input){ input.focus(); }
      }catch(e0){}
      return false;
    };
  }

  if(close.parentNode !== head){
    try{ head.appendChild(close); }catch(e1){}
  }
}

function diqV206InjectStyles(){
  var style;
  var css;

  if(byId("diqV206PanelSeparationStyles")){ return; }

  css =
    "#adventureHero{position:relative!important;}" +

    /* Destination dropdown: part of the hero flow, directly below search. */
    "#diqAdventureDestResults.diqModeDestination{" +
      "position:relative!important;inset:auto!important;top:auto!important;left:auto!important;right:auto!important;bottom:auto!important;" +
      "width:100%!important;max-width:100%!important;margin:7px 0 0!important;padding:0!important;" +
      "transform:none!important;float:none!important;clear:both!important;z-index:120!important;" +
      "background:transparent!important;display:none!important;overflow:visible!important;" +
    "}" +
    "#diqAdventureDestResults.diqModeDestination.on{display:block!important;}" +
    "#diqAdventureDestResults.diqModeDestination .diqDestHead{" +
      "position:relative!important;min-height:44px!important;padding:0 48px 0 13px!important;" +
      "display:flex!important;align-items:center!important;border-radius:15px 15px 0 0!important;" +
      "background:linear-gradient(180deg,rgba(4,11,20,.99),rgba(4,11,20,.97))!important;" +
      "border:1px solid rgba(40,255,190,.28)!important;border-bottom:0!important;" +
      "color:#b6ffeb!important;font-size:10px!important;font-weight:1000!important;letter-spacing:1.25px!important;" +
    "}" +
    "#diqAdventureDestResults.diqModeDestination #diqDestList{" +
      "max-height:248px!important;overflow-y:auto!important;overflow-x:hidden!important;" +
      "padding:5px 7px 8px!important;margin:0!important;border-radius:0 0 15px 15px!important;" +
      "background:linear-gradient(180deg,rgba(4,11,20,.98),rgba(2,8,16,.99))!important;" +
      "border:1px solid rgba(40,255,190,.28)!important;border-top:0!important;" +
      "box-shadow:0 18px 36px rgba(0,0,0,.48)!important;" +
    "}" +
    "#diqAdventureDestResults.diqModeDestination .diqDestItem{" +
      "width:100%!important;margin:6px 0!important;float:none!important;clear:both!important;" +
    "}" +
    "#diqAdventureDestResults.diqModeDestination #diqDestClose{" +
      "position:absolute!important;top:6px!important;right:6px!important;width:32px!important;height:32px!important;" +
      "min-width:32px!important;border-radius:11px!important;font-size:20px!important;" +
    "}" +

    /* Post-scan shelf: independent wide mobile bottom sheet. */
    "#diqAdventureDestResults.diqModeShelf{" +
      "position:fixed!important;left:12px!important;right:12px!important;bottom:calc(94px + var(--safe-bottom,0px))!important;" +
      "top:auto!important;inset:auto 12px calc(94px + var(--safe-bottom,0px)) 12px!important;" +
      "width:auto!important;max-width:none!important;z-index:96!important;margin:0!important;padding:0!important;" +
      "display:none!important;transform:none!important;float:none!important;clear:both!important;" +
      "background:transparent!important;" +
    "}" +
    "#diqAdventureDestResults.diqModeShelf.on{display:block!important;}" +
    "#diqAdventureDestResults.diqModeShelf .diqDestHead{" +
      "position:relative!important;min-height:46px!important;padding:0 48px 0 15px!important;" +
      "display:flex!important;align-items:center!important;border-radius:18px 18px 0 0!important;" +
      "background:linear-gradient(180deg,rgba(4,11,20,.98),rgba(4,11,20,.95))!important;" +
      "border:1px solid rgba(40,255,190,.28)!important;border-bottom:0!important;" +
      "color:#b6ffeb!important;font-size:10px!important;font-weight:1000!important;letter-spacing:1.2px!important;" +
    "}" +
    "#diqAdventureDestResults.diqModeShelf #diqDestList{" +
      "display:flex!important;gap:10px!important;overflow-x:auto!important;overflow-y:hidden!important;" +
      "max-height:310px!important;padding:8px 9px 11px!important;margin:0!important;" +
      "-webkit-overflow-scrolling:touch!important;scroll-snap-type:x proximity!important;" +
      "border-radius:0 0 18px 18px!important;" +
      "background:linear-gradient(180deg,rgba(4,11,20,.97),rgba(2,8,16,.99))!important;" +
      "border:1px solid rgba(40,255,190,.28)!important;border-top:0!important;" +
      "box-shadow:0 22px 48px rgba(0,0,0,.56)!important;" +
    "}" +
    "#diqAdventureDestResults.diqModeShelf .diqDestItem{" +
      "flex:0 0 min(86vw,360px)!important;width:min(86vw,360px)!important;min-width:min(86vw,360px)!important;" +
      "margin:0!important;float:none!important;clear:none!important;scroll-snap-align:start!important;" +
    "}" +
    "#diqAdventureDestResults.diqModeShelf #diqDestClose{" +
      "position:absolute!important;top:7px!important;right:7px!important;width:32px!important;height:32px!important;" +
      "min-width:32px!important;border-radius:11px!important;font-size:20px!important;" +
    "}" +

    "@media(min-width:700px){" +
      "#diqAdventureDestResults.diqModeShelf{left:24px!important;right:24px!important;}" +
      "#diqAdventureDestResults.diqModeShelf .diqDestItem{flex-basis:380px!important;width:380px!important;min-width:380px!important;}" +
    "}";

  style = document.createElement("style");
  style.id = "diqV206PanelSeparationStyles";
  style.type = "text/css";
  style.appendChild(document.createTextNode(css));
  try{ document.head.appendChild(style); }catch(e0){}
}

/* Rebuild panel location authority whenever the panel is first requested. */
var diqV206PriorEnsureDestinationResultsPanel = ensureDestinationResultsPanel;
ensureDestinationResultsPanel = function(){
  var panel = diqV206PriorEnsureDestinationResultsPanel();
  diqV206EnsureCloseButton();
  return panel;
};

/* Destination render authority. */
var diqV206PriorRenderDestinationResults = renderDestinationResults;
renderDestinationResults = function(results,query){
  var cleanResults = diqV206DestinationAuthority(results || [],query || "");
  var result;

  diqV206MoveDestinationPanel();
  result = diqV206PriorRenderDestinationResults(cleanResults,query);

  try{
    var panel = diqV206Panel();
    if(panel){
      panel.className = "on diqModeDestination";
      panel.setAttribute("aria-hidden","false");
    }
    diqV206EnsureCloseButton();
  }catch(e0){}

  return result;
};

/* SHOW PICKS / post-scan render authority. */
var diqV206PriorRenderAdventureScanChoices = renderAdventureScanChoices;
renderAdventureScanChoices = function(items,query){
  var result;

  diqV206MoveShelfPanel();
  result = diqV206PriorRenderAdventureScanChoices(items,query);

  try{
    var panel = diqV206Panel();
    var head = diqV206Head(panel);
    if(panel){
      panel.className = "on diqModeShelf";
      panel.setAttribute("aria-hidden","false");
    }
    if(head){ head.textContent = "CHOOSE ADVENTURE STOP"; }
    diqV206EnsureCloseButton();
  }catch(e0){}

  return result;
};

/* Destination selection closes chooser before route/scan state changes. */
var diqV206PriorRouteDestinationResult = routeDestinationResult;
routeDestinationResult = function(item){
  diqV206CloseChooser();
  return diqV206PriorRouteDestinationResult(item);
};

/* Starting a scan cannot leave destination dropdown hanging over the map. */
try{
  var diqV206PriorStartAdventure = startAdventure;
  startAdventure = function(){
    diqV206CloseChooser();
    return diqV206PriorStartAdventure.apply(this,arguments);
  };
}catch(eStart){}

try{
  var diqV206PriorSetLens = setLens;
  setLens = function(){
    diqV206CloseChooser();
    return diqV206PriorSetLens.apply(this,arguments);
  };
}catch(eLens){}

diqV206InjectStyles();
diqV206EnsureCloseButton();

try{
  console.log("âœ… Drive IQ Adventure V206 Panel Separation Authority loaded");
}catch(ePublic){}

}());


/* =========================================================
   DRIVE IQ ADVENTURE MODE V207
   CITY-FIRST SEARCH + DISTRICT GEOGRAPHY / VARIETY / PHOTO TRUTH
   + FULL-WIDTH MOBILE RESULTS SHELF
========================================================= */
(function(){
"use strict";
if(window.__DRIVE_IQ_ADVENTURE_V207_CITY_DISTRICT_TRUTH__){ return; }
window.__DRIVE_IQ_ADVENTURE_V207_CITY_DISTRICT_TRUTH__ = true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD = "V207_CITY_FIRST_DISTRICT_GEOGRAPHY_VARIETY_PHOTO_TRUTH";

function diqV207IsDistrict(item){
  return !!(item && (item.entityType === "district" || item.entityClass === "district" || item.poiClass === "district" || item.kind === "district" || item.type === "district" || item.districtId || item.resultType === "adventure_district_registry" || item.resultType === "entity_registry_district"));
}
function diqV207ExplicitDistrictQuery(query){
  var q=normText(query); if(!q){return false;}
  return q.indexOf("district")>-1 || q.indexOf("village")>-1 || q.indexOf("commons")>-1 || q.indexOf("square")>-1 || q.indexOf("downtown")>-1 || q.indexOf("harborwalk")>-1 || q.indexOf("beale street")>-1 || q.indexOf("broadway")>-1 || q.indexOf("silo square")>-1 || q.indexOf("disney springs")>-1 || q.indexOf("the wharf")>-1;
}
function diqV207CityLike(item){
  var txt=normText(String(item&&item.kind||"")+" "+String(item&&item.category||"")+" "+String(item&&item.resultType||"")+" "+String(item&&item.full||""));
  return txt.indexOf("city")>-1 || txt.indexOf("town")>-1 || txt.indexOf("municipality")>-1 || txt.indexOf("locality")>-1 || (item&&item.resultType==="adventure_index") || (item&&item.canonical===true);
}
function diqV207DestinationSearchAuthority(items,query){
  var source=(items||[]).slice(0), q=normText(query), explicitDistrict=diqV207ExplicitDistrictQuery(query), canonical=null, cities=[], districts=[], others=[], seen={}, out=[], i,item,txt;
  try{var indexed=adventureDestinationIndexMatch(query); if(indexed){canonical=indexedAdventureItem(indexed);}}catch(e0){}
  function add(candidate){var k;if(!candidate){return;}k=normText(String(candidate.resultType||"")+"|"+String(candidate.districtId||candidate.adventureIndexId||"")+"|"+String(candidate.label||"")+"|"+String(candidate.lat||"")+"|"+String(candidate.lng||""));if(seen[k]){return;}seen[k]=true;out.push(candidate);}
  if(canonical){add(canonical);}
  for(i=0;i<source.length;i++){
    item=source[i]; if(!item){continue;}
    txt=normText(String(item.label||"")+" "+String(item.full||"")+" "+String(item.kind||"")+" "+String(item.category||""));
    if(txt.indexOf("hotel")>-1||txt.indexOf("motel")>-1||txt.indexOf(" inn")>-1||txt.indexOf("hospital")>-1||txt.indexOf("emergency")>-1||txt.indexOf("restaurant")>-1||txt.indexOf("store")>-1||txt.indexOf("amenity")>-1){continue;}
    if(diqV207IsDistrict(item)){if(explicitDistrict){districts.push(item);}continue;}
    if(diqV207CityLike(item)){cities.push(item);}else{others.push(item);}
  }
  function sortDest(a,b){var sa=0,sb=0,ta=normText(String(a&&a.label||"")+" "+String(a&&a.full||"")),tb=normText(String(b&&b.label||"")+" "+String(b&&b.full||"")),da=finite(Number(a&&a.distMiles))?Number(a.distMiles):99999,db=finite(Number(b&&b.distMiles))?Number(b.distMiles):99999;if(normText(a&&a.label||"")===q){sa+=700;}if(normText(b&&b.label||"")===q){sb+=700;}if(ta.indexOf(q)>-1){sa+=300;}if(tb.indexOf(q)>-1){sb+=300;}if(ta.indexOf("florida")>-1){sa+=180;}if(tb.indexOf("florida")>-1){sb+=180;}if(ta.indexOf("turkey")>-1||ta.indexOf("ireland")>-1){sa-=900;}if(tb.indexOf("turkey")>-1||tb.indexOf("ireland")>-1){sb-=900;}if(da>1200){sa-=500;}if(db>1200){sb-=500;}return sb-sa;}
  cities.sort(sortDest);districts.sort(sortDest);others.sort(sortDest);
  for(i=0;i<cities.length&&out.length<4;i++){add(cities[i]);}
  if(explicitDistrict){for(i=0;i<districts.length&&out.length<5;i++){add(districts[i]);}}
  for(i=0;i<others.length&&out.length<5;i++){add(others[i]);}
  return out.slice(0,5);
}
function diqV207Center(){
  if(adventureSearchCenter&&finite(Number(adventureSearchCenter.lat))&&finite(Number(adventureSearchCenter.lng))){return {lat:Number(adventureSearchCenter.lat),lng:Number(adventureSearchCenter.lng)};}
  if(destination&&finite(Number(destination.lat))&&finite(Number(destination.lng))&&adventureSearchScope==="near_destination"){return {lat:Number(destination.lat),lng:Number(destination.lng)};}
  if(lastFix&&finite(Number(lastFix.lat))&&finite(Number(lastFix.lng))){return {lat:Number(lastFix.lat),lng:Number(lastFix.lng)};}
  return null;
}
function diqV207DistanceMiles(a,b,c,d){var R=3958.7613,p1,p2,dp,dl,x;if(!finite(Number(a))||!finite(Number(b))||!finite(Number(c))||!finite(Number(d))){return null;}p1=Number(a)*Math.PI/180;p2=Number(c)*Math.PI/180;dp=(Number(c)-Number(a))*Math.PI/180;dl=(Number(d)-Number(b))*Math.PI/180;x=Math.sin(dp/2)*Math.sin(dp/2)+Math.cos(p1)*Math.cos(p2)*Math.sin(dl/2)*Math.sin(dl/2);return R*2*Math.atan2(Math.sqrt(x),Math.sqrt(1-x));}
function diqV207DistrictRadius(){var lens=normText(activeLens||activeScanQuery||"");if(lens.indexOf("live music")>-1||lens.indexOf("nightlife")>-1||lens.indexOf("trending")>-1||lens.indexOf("gameday")>-1){return 18;}if(lens.indexOf("shopping")>-1||lens.indexOf("local favorites")>-1||lens.indexOf("local faves")>-1){return 12;}if(lens.indexOf("food")>-1||lens.indexOf("coffee")>-1||lens.indexOf("dessert")>-1){return 8;}return 10;}
function diqV207DistrictFitsCategory(item){var lens=normText(activeLens||activeScanQuery||""),txt=normText(String(item&&item.category||"")+" "+String(item&&item.districtType||"")+" "+String(item&&item.vibe||"")+" "+String(item&&item.why||"")+" "+String(item&&item.description||""));if(!lens){return true;}if(lens.indexOf("food")>-1){return txt.indexOf("food")>-1||txt.indexOf("restaurant")>-1||txt.indexOf("dining")>-1||txt.indexOf("entertainment")>-1||txt.indexOf("nightlife")>-1;}if(lens.indexOf("coffee")>-1){return txt.indexOf("coffee")>-1||txt.indexOf("cafe")>-1;}if(lens.indexOf("shopping")>-1){return txt.indexOf("shopping")>-1||txt.indexOf("retail")>-1;}return true;}
function diqV207DistrictExperienceCount(item){return Number(item&&(item.experienceCount||item.districtExperienceCount||item.experience_count||0)||0);}
function diqV207ScanAuthority(items){
  var source=(items||[]).slice(0),center=diqV207Center(),radius=diqV207DistrictRadius(),districts=[],places=[],out=[],usedPhotos={},i,item,d,photoKey,count;
  for(i=0;i<source.length;i++){
    item=source[i];if(!item){continue;}
    if(diqV207IsDistrict(item)){
      count=diqV207DistrictExperienceCount(item);if(count<=0){continue;}
      if(center){d=diqV207DistanceMiles(center.lat,center.lng,Number(item.lat),Number(item.lng));if(finite(Number(d))){item.distMiles=Number(d);if(Number(d)>radius){continue;}}}
      if(!diqV207DistrictFitsCategory(item)){continue;}
      photoKey=clean(item.canonicalPhotoUrl||item.districtPhotoUrl||item.heroPhotoUrl||item.photoUrl||"");
      if(photoKey&&usedPhotos[photoKey]){item.photoUrl="";item.heroPhotoUrl="";item.districtPhotoUrl="";item.photoSource="district_fallback";}else if(photoKey){usedPhotos[photoKey]=true;}
      districts.push(item);
    }else{places.push(item);}
  }
  districts.sort(function(a,b){var da=finite(Number(a.distMiles))?Number(a.distMiles):99999,db=finite(Number(b.distMiles))?Number(b.distMiles):99999,ca=diqV207DistrictExperienceCount(a),cb=diqV207DistrictExperienceCount(b);if(Math.abs(da-db)>1){return da-db;}return cb-ca;});
  if(districts.length){out.push(districts[0]);}
  for(i=0;i<places.length&&out.length<8;i++){out.push(places[i]);}
  if(districts.length>1&&out.length<10){d=finite(Number(districts[1].distMiles))?Number(districts[1].distMiles):99999;if(d<=Math.min(6,radius)&&diqV207DistrictExperienceCount(districts[1])>=15){out.push(districts[1]);}}
  for(i=8;i<places.length&&out.length<10;i++){out.push(places[i]);}
  return out.slice(0,10);
}
function diqV207InjectStyles(){var style,css;if(byId("diqV207ShelfStyles")){return;}css="#diqAdventureDestResults.diqModeShelf{position:fixed!important;left:12px!important;right:12px!important;bottom:calc(112px + var(--safe-bottom,0px))!important;top:auto!important;width:auto!important;max-width:none!important;z-index:120!important;display:none!important;margin:0!important;padding:0!important;background:transparent!important;transform:none!important;}#diqAdventureDestResults.diqModeShelf.on{display:block!important;}#diqAdventureDestResults.diqModeShelf .diqDestHead{min-height:46px!important;padding:0 50px 0 15px!important;display:flex!important;align-items:center!important;border-radius:18px 18px 0 0!important;background:linear-gradient(180deg,rgba(4,11,20,.985),rgba(4,11,20,.96))!important;border:1px solid rgba(40,255,190,.28)!important;border-bottom:0!important;font-size:10px!important;letter-spacing:1.2px!important;}#diqAdventureDestResults.diqModeShelf #diqDestList{display:flex!important;gap:10px!important;overflow-x:auto!important;overflow-y:hidden!important;max-height:330px!important;padding:9px 9px 12px!important;margin:0!important;-webkit-overflow-scrolling:touch!important;scroll-snap-type:x mandatory!important;border-radius:0 0 18px 18px!important;background:linear-gradient(180deg,rgba(4,11,20,.975),rgba(2,8,16,.995))!important;border:1px solid rgba(40,255,190,.28)!important;border-top:0!important;box-shadow:0 22px 48px rgba(0,0,0,.58)!important;}#diqAdventureDestResults.diqModeShelf .diqDestItem{flex:0 0 calc(100vw - 42px)!important;width:calc(100vw - 42px)!important;min-width:calc(100vw - 42px)!important;max-width:420px!important;margin:0!important;float:none!important;clear:none!important;scroll-snap-align:start!important;}#diqAdventureDestResults.diqModeShelf .diqDestName{white-space:normal!important;overflow:visible!important;text-overflow:clip!important;}#diqAdventureDestResults.diqModeShelf .diqDestSub{display:-webkit-box!important;-webkit-line-clamp:3!important;-webkit-box-orient:vertical!important;overflow:hidden!important;}@media(min-width:700px){#diqAdventureDestResults.diqModeShelf{left:24px!important;right:24px!important;}#diqAdventureDestResults.diqModeShelf .diqDestItem{flex-basis:420px!important;width:420px!important;min-width:420px!important;}}";style=document.createElement("style");style.id="diqV207ShelfStyles";style.type="text/css";style.appendChild(document.createTextNode(css));try{document.head.appendChild(style);}catch(e0){}}
var diqV207PriorRenderDestinationResults=renderDestinationResults;
renderDestinationResults=function(results,query){return diqV207PriorRenderDestinationResults(diqV207DestinationSearchAuthority(results||[],query||""),query);};
var diqV207PriorRenderAdventureScanChoices=renderAdventureScanChoices;
renderAdventureScanChoices=function(items,query){return diqV207PriorRenderAdventureScanChoices(diqV207ScanAuthority(items||[]),query);};
try{var diqV207PriorAfterScanResultsReady=afterScanResultsReady;afterScanResultsReady=function(items,preferred,reason){var curated=diqV207ScanAuthority(items||[]),pick=preferred;if(curated.length&&(!pick||curated.indexOf(pick)<0)){pick=curated[0];}adventureResults=curated.slice(0);destinationSearchResults=curated.slice(0);return diqV207PriorAfterScanResultsReady(curated,pick,reason);};}catch(eReady){}
diqV207InjectStyles();
window.DRIVE_IQ_ADVENTURE_V207={build:"V207_CITY_FIRST_DISTRICT_GEOGRAPHY_VARIETY_PHOTO_TRUTH",destinationAuthority:diqV207DestinationSearchAuthority,scanAuthority:diqV207ScanAuthority,isDistrict:diqV207IsDistrict};
try{console.log("âœ… Drive IQ Adventure V207 City + District Truth loaded");}catch(ePublic){}
}());


/* =========================================================
   DRIVE IQ ADVENTURE MODE V208
   STABLE DESTINATION FINDER + DISCOVERY SHELF POLISH

   Final stabilization pass for the Search â†’ Scan split:
   - Search is a stable finder: canonical city/area first
   - Districts stay out of generic city autocomplete unless explicitly named
   - Scan is discovery: districts, neighborhoods, local favorites, hidden gems
   - Full-width one-card-per-swipe mobile results shelf
   - Simplified district cards and clearer scan-result story
   - Safer Search â†’ Scan handoff with destination lock and map fly-to
   ES5 SAFE
========================================================= */
(function(){
"use strict";

if(window.__DRIVE_IQ_ADVENTURE_V208_STABLE_FINDER_DISCOVERY_SHELF__){ return; }
window.__DRIVE_IQ_ADVENTURE_V208_STABLE_FINDER_DISCOVERY_SHELF__ = true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD =
  "V208_STABLE_DESTINATION_FINDER_DISCOVERY_SHELF";

function diqV208IsDistrict(item){
  return !!(
    item &&
    (
      item.entityType === "district" ||
      item.entityClass === "district" ||
      item.poiClass === "district" ||
      item.kind === "district" ||
      item.type === "district" ||
      item.districtId ||
      item.resultType === "adventure_district_registry" ||
      item.resultType === "entity_registry_district"
    )
  );
}

function diqV208ExplicitDistrictQuery(query){
  var q = normText(query);
  if(!q){ return false; }

  return (
    q.indexOf("district") > -1 ||
    q.indexOf("village") > -1 ||
    q.indexOf("commons") > -1 ||
    q.indexOf("square") > -1 ||
    q.indexOf("downtown") > -1 ||
    q.indexOf("harborwalk") > -1 ||
    q.indexOf("beale street") > -1 ||
    q.indexOf("broadway") > -1 ||
    q.indexOf("silo square") > -1 ||
    q.indexOf("disney springs") > -1 ||
    q.indexOf("the wharf") > -1
  );
}

function diqV208CityLike(item){
  var txt = normText(
    String(item && item.kind || "") + " " +
    String(item && item.category || "") + " " +
    String(item && item.resultType || "") + " " +
    String(item && item.full || "")
  );

  return !!(
    item &&
    (
      item.canonical === true ||
      item.resultType === "adventure_index" ||
      txt.indexOf("city") > -1 ||
      txt.indexOf("town") > -1 ||
      txt.indexOf("locality") > -1 ||
      txt.indexOf("municipality") > -1 ||
      txt.indexOf("village") > -1
    )
  );
}

function diqV208DestinationKey(item){
  return normText(
    String(item && item.resultType || "") + "|" +
    String(item && item.adventureIndexId || item.districtId || "") + "|" +
    String(item && item.label || "") + "|" +
    String(item && item.lat || "") + "|" +
    String(item && item.lng || "")
  );
}

function diqV208DestinationAuthority(items,query){
  var source = (items || []).slice(0);
  var q = normText(query);
  var explicitDistrict = diqV208ExplicitDistrictQuery(query);
  var canonical = null;
  var cities = [];
  var districts = [];
  var others = [];
  var out = [];
  var seen = {};
  var i;
  var item;
  var txt;

  try{
    var indexed = adventureDestinationIndexMatch(query);
    if(indexed){ canonical = indexedAdventureItem(indexed); }
  }catch(e0){}

  function add(candidate){
    var key;
    if(!candidate){ return; }
    key = diqV208DestinationKey(candidate);
    if(seen[key]){ return; }
    seen[key] = true;
    out.push(candidate);
  }

  if(canonical){ add(canonical); }

  for(i=0;i<source.length;i++){
    item = source[i];
    if(!item){ continue; }

    txt = normText(
      String(item.label || "") + " " +
      String(item.full || "") + " " +
      String(item.kind || "") + " " +
      String(item.category || "") + " " +
      String(item.resultType || "")
    );

    /* Generic POIs do not belong in destination autocomplete. */
    if(
      txt.indexOf("hotel") > -1 ||
      txt.indexOf("motel") > -1 ||
      txt.indexOf("inn") > -1 ||
      txt.indexOf("hospital") > -1 ||
      txt.indexOf("emergency") > -1 ||
      txt.indexOf("restaurant") > -1 ||
      txt.indexOf("store") > -1 ||
      txt.indexOf("amenity") > -1
    ){
      continue;
    }

    /* Strong suppression for clearly wrong international lookalikes. */
    if(
      txt.indexOf("turkey") > -1 ||
      txt.indexOf("karakocan") > -1 ||
      txt.indexOf("eastern anatolia") > -1 ||
      txt.indexOf("county meath") > -1 ||
      txt.indexOf("ireland") > -1
    ){
      continue;
    }

    if(finite(Number(item.distMiles)) && Number(item.distMiles) > 1200){
      continue;
    }

    if(diqV208IsDistrict(item)){
      if(explicitDistrict){ districts.push(item); }
      continue;
    }

    if(diqV208CityLike(item)){
      cities.push(item);
    }else{
      others.push(item);
    }
  }

  function rank(a,b){
    var sa = 0;
    var sb = 0;
    var la = normText(a && a.label || "");
    var lb = normText(b && b.label || "");
    var ta = normText(String(a && a.label || "") + " " + String(a && a.full || ""));
    var tb = normText(String(b && b.label || "") + " " + String(b && b.full || ""));
    var da = finite(Number(a && a.distMiles)) ? Number(a.distMiles) : 99999;
    var db = finite(Number(b && b.distMiles)) ? Number(b.distMiles) : 99999;

    if(la === q){ sa += 1000; }
    if(lb === q){ sb += 1000; }
    if(ta.indexOf(q) > -1){ sa += 420; }
    if(tb.indexOf(q) > -1){ sb += 420; }
    if(a && (a.canonical || a.resultType === "adventure_index")){ sa += 900; }
    if(b && (b.canonical || b.resultType === "adventure_index")){ sb += 900; }

    if(da <= 500){ sa += 120; }
    if(db <= 500){ sb += 120; }

    return sb - sa;
  }

  cities.sort(rank);
  districts.sort(rank);
  others.sort(rank);

  /* City/area results stay stable and first. */
  for(i=0;i<cities.length && out.length<4;i++){ add(cities[i]); }

  /* Only explicit district searches may surface district autocomplete. */
  if(explicitDistrict){
    for(i=0;i<districts.length && out.length<5;i++){ add(districts[i]); }
  }

  for(i=0;i<others.length && out.length<5;i++){ add(others[i]); }

  return out.slice(0,5);
}

function diqV208SimplifyDistrictItem(item){
  var type;
  var count;
  var vibe;

  if(!diqV208IsDistrict(item)){ return item; }

  type = clean(
    item.districtType ||
    item.category ||
    item.entitySubtype ||
    "Adventure District"
  );

  count = Number(
    item.experienceCount ||
    item.districtExperienceCount ||
    item.experience_count ||
    0
  );

  vibe = clean(
    item.vibe ||
    item.shortDescription ||
    item.why ||
    item.description ||
    ""
  );

  item.matchLabel = titleCaseWords(type.replace(/_/g," "));
  item.shortDescription = vibe;
  item.experienceCount = count;
  item.districtExperienceCount = count;

  /* Remove repetitive card language. */
  item.topPickLabel = "";
  item.secondaryBadge = "";
  item.tertiaryBadge = "";
  item.cardActionLabel = "EXPLORE";
  item.why = vibe || (count > 0
    ? count + " experiences worth exploring."
    : "A walkable district worth exploring.");

  return item;
}

function diqV208ScanStory(items){
  var source = items || [];
  var districts = 0;
  var places = 0;
  var i;

  for(i=0;i<source.length;i++){
    if(diqV208IsDistrict(source[i])){ districts += 1; }
    else{ places += 1; }
  }

  if(districts && places){
    return "Found " + source.length + " places worth exploring â€¢ " +
      districts + " district" + (districts === 1 ? "" : "s") +
      " â€¢ " + places + " local picks";
  }

  if(districts){
    return "Found " + districts + " district" +
      (districts === 1 ? "" : "s") + " worth exploring";
  }

  return "Found " + source.length + " places worth exploring";
}

function diqV208UpdateScanStory(items){
  var message = diqV208ScanStory(items || []);
  var toastEl = byId("adventureToast");
  var title = byId("scanCompleteTitle");
  var sub = byId("scanCompleteSub");
  var candidates;
  var i;

  if(title){ title.textContent = "PLACES WORTH EXPLORING"; }
  if(sub){ sub.textContent = message; }

  try{
    candidates = document.querySelectorAll(
      ".scanCompleteSub,.scanResultSummary,.adventureResultsSummary,.broadPullMessage"
    );
    for(i=0;i<candidates.length;i++){
      candidates[i].textContent = message;
    }
  }catch(e0){}

  if(toastEl && String(toastEl.textContent || "").indexOf("Broad Pull IQ") > -1){
    toastEl.textContent = message;
  }
}

function diqV208InjectStyles(){
  var style;
  var css;

  if(byId("diqV208StableFinderStyles")){ return; }

  css =
    /* Destination finder stays compact and readable. */
    "#diqAdventureDestResults.diqModeDestination{" +
      "position:relative!important;inset:auto!important;top:auto!important;left:auto!important;" +
      "right:auto!important;bottom:auto!important;width:100%!important;max-width:100%!important;" +
      "margin:7px 0 0!important;transform:none!important;z-index:140!important;" +
    "}" +
    "#diqAdventureDestResults.diqModeDestination #diqDestList{" +
      "max-height:250px!important;overflow-y:auto!important;overflow-x:hidden!important;" +
    "}" +

    /* One full-width card per swipe in the scan shelf. */
    "#diqAdventureDestResults.diqModeShelf{" +
      "position:fixed!important;left:12px!important;right:12px!important;" +
      "bottom:calc(112px + var(--safe-bottom,0px))!important;top:auto!important;" +
      "width:auto!important;max-width:none!important;z-index:120!important;" +
      "display:none!important;margin:0!important;padding:0!important;" +
      "transform:none!important;background:transparent!important;" +
    "}" +
    "#diqAdventureDestResults.diqModeShelf.on{display:block!important;}" +
    "#diqAdventureDestResults.diqModeShelf .diqDestHead{" +
      "min-height:46px!important;padding:0 48px 0 15px!important;" +
      "display:flex!important;align-items:center!important;" +
      "border-radius:18px 18px 0 0!important;" +
      "background:linear-gradient(180deg,rgba(4,11,20,.99),rgba(4,11,20,.96))!important;" +
      "border:1px solid rgba(40,255,190,.28)!important;border-bottom:0!important;" +
      "font-size:10px!important;letter-spacing:1.2px!important;" +
    "}" +
    "#diqAdventureDestResults.diqModeShelf #diqDestList{" +
      "display:flex!important;gap:10px!important;overflow-x:auto!important;overflow-y:hidden!important;" +
      "max-height:340px!important;padding:9px 9px 12px!important;margin:0!important;" +
      "-webkit-overflow-scrolling:touch!important;scroll-snap-type:x mandatory!important;" +
      "border-radius:0 0 18px 18px!important;" +
      "background:linear-gradient(180deg,rgba(4,11,20,.98),rgba(2,8,16,.995))!important;" +
      "border:1px solid rgba(40,255,190,.28)!important;border-top:0!important;" +
      "box-shadow:0 22px 48px rgba(0,0,0,.58)!important;" +
    "}" +
    "#diqAdventureDestResults.diqModeShelf .diqDestItem{" +
      "flex:0 0 calc(100vw - 42px)!important;width:calc(100vw - 42px)!important;" +
      "min-width:calc(100vw - 42px)!important;max-width:430px!important;" +
      "margin:0!important;float:none!important;clear:none!important;" +
      "scroll-snap-align:start!important;" +
    "}" +
    "#diqAdventureDestResults.diqModeShelf .diqDestName{" +
      "white-space:normal!important;overflow:visible!important;text-overflow:clip!important;" +
      "font-size:22px!important;line-height:1.06!important;" +
    "}" +
    "#diqAdventureDestResults.diqModeShelf .diqDestSub{" +
      "display:-webkit-box!important;-webkit-line-clamp:3!important;" +
      "-webkit-box-orient:vertical!important;overflow:hidden!important;" +
    "}" +
    "#diqAdventureDestResults.diqModeShelf .diqDestMeta{" +
      "white-space:normal!important;overflow:visible!important;text-overflow:clip!important;" +
    "}" +

    /* Stronger pin hierarchy where marker classes are available. */
    ".diqDistrictPin,.districtPin,[data-entity-type='district']{" +
      "transform:scale(1.16)!important;transform-origin:center!important;" +
    "}" +
    ".diqFeaturedPin,.featuredPin,[data-featured='true']{" +
      "transform:scale(1.08)!important;transform-origin:center!important;" +
    "}" +

    "@media(min-width:700px){" +
      "#diqAdventureDestResults.diqModeShelf{left:24px!important;right:24px!important;}" +
      "#diqAdventureDestResults.diqModeShelf .diqDestItem{" +
        "flex-basis:430px!important;width:430px!important;min-width:430px!important;" +
      "}" +
    "}";

  style = document.createElement("style");
  style.id = "diqV208StableFinderStyles";
  style.type = "text/css";
  style.appendChild(document.createTextNode(css));
  try{ document.head.appendChild(style); }catch(e0){}
}

/* Final destination search authority. */
var diqV208PriorRenderDestinationResults = renderDestinationResults;
renderDestinationResults = function(results,query){
  var stable = diqV208DestinationAuthority(results || [],query || "");
  return diqV208PriorRenderDestinationResults(stable,query);
};

/* Simplify district cards and improve scan story. */
var diqV208PriorRenderAdventureScanChoices = renderAdventureScanChoices;
renderAdventureScanChoices = function(items,query){
  var source = (items || []).slice(0);
  var cleanItems = [];
  var i;
  var result;

  for(i=0;i<source.length;i++){
    cleanItems.push(diqV208SimplifyDistrictItem(source[i]));
  }

  result = diqV208PriorRenderAdventureScanChoices(cleanItems,query);

  try{
    var panel = byId("diqAdventureDestResults");
    var head = panel && panel.querySelector
      ? panel.querySelector(".diqDestHead")
      : null;

    if(panel){
      panel.className = "on diqModeShelf";
      panel.setAttribute("aria-hidden","false");
    }
    if(head){ head.textContent = "PLACES WORTH EXPLORING"; }
  }catch(e0){}

  diqV208UpdateScanStory(cleanItems);
  return result;
};

/* Preserve selected destination and give the handoff a deliberate fly-to. */
var diqV208PriorRouteDestinationResult = routeDestinationResult;
routeDestinationResult = function(item){
  var result;

  if(item){
    try{ setDestinationLock(item,"v208_destination_selected"); }catch(e0){}
  }

  result = diqV208PriorRouteDestinationResult(item);

  try{
    if(
      map &&
      item &&
      finite(Number(item.lat)) &&
      finite(Number(item.lng))
    ){
      map.flyTo({
        center:[Number(item.lng),Number(item.lat)],
        zoom:11.8,
        duration:1100,
        essential:true
      });
    }
  }catch(e1){}

  return result;
};

/* After scan completion, keep the user-facing story aligned with final results. */
try{
  var diqV208PriorAfterScanResultsReady = afterScanResultsReady;
  afterScanResultsReady = function(items,preferred,reason){
    var result = diqV208PriorAfterScanResultsReady(items,preferred,reason);
    try{ diqV208UpdateScanStory(items || []); }catch(e0){}
    return result;
  };
}catch(eReady){}

diqV208InjectStyles();

window.DRIVE_IQ_ADVENTURE_V208 = {
  build:"V208_STABLE_DESTINATION_FINDER_DISCOVERY_SHELF",
  destinationAuthority:diqV208DestinationAuthority,
  isDistrict:diqV208IsDistrict,
  scanStory:diqV208ScanStory
};

try{
  console.log("âœ… Drive IQ Adventure V208 Stable Finder + Discovery Shelf loaded");
}catch(ePublic){}

}());


/* =========================================================
   DRIVE IQ ADVENTURE MODE V209
   FINAL DESTINATION SEARCH AUTHORITY

   Fixes the remaining double-pipeline issue where the clean city result
   briefly appears and then an older District IQ/provider layer repopulates
   the chooser with HarborWalk, County Meath, or Destin, Turkey.

   Permanent rule:
   - Generic city/area query -> canonical destination first, city/area only
   - Explicit district query -> exact district may appear
   - District discovery belongs in scans, not generic autocomplete
   - Late provider responses cannot overwrite the stable chooser
   ES5 SAFE
========================================================= */
(function(){
"use strict";

if(window.__DRIVE_IQ_ADVENTURE_V209_FINAL_SEARCH_AUTHORITY__){ return; }
window.__DRIVE_IQ_ADVENTURE_V209_FINAL_SEARCH_AUTHORITY__ = true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD =
  "V209_FINAL_DESTINATION_SEARCH_AUTHORITY";

var diqV209LastQuery = "";
var diqV209LastStableResults = [];
var diqV209LastRenderAt = 0;

function diqV209IsDistrict(item){
  return !!(
    item &&
    (
      item.entityType === "district" ||
      item.entityClass === "district" ||
      item.poiClass === "district" ||
      item.kind === "district" ||
      item.type === "district" ||
      item.districtId ||
      item.resultType === "adventure_district_registry" ||
      item.resultType === "entity_registry_district"
    )
  );
}

function diqV209ExplicitDistrictQuery(query){
  var q = normText(query);
  if(!q){ return false; }

  return (
    q.indexOf("district") > -1 ||
    q.indexOf("harborwalk") > -1 ||
    q.indexOf("destin commons") > -1 ||
    q.indexOf("beale street") > -1 ||
    q.indexOf("silo square") > -1 ||
    q.indexOf("disney springs") > -1 ||
    q.indexOf("the wharf") > -1 ||
    q.indexOf("broadway nashville") > -1
  );
}

function diqV209ActiveQuery(query){
  var input = byId("adventureSearch");
  var live = input ? clean(input.value) : "";
  return clean(live || query || "");
}

function diqV209IsBadDestination(item){
  var txt = normText(
    String(item && item.label || "") + " " +
    String(item && item.full || "") + " " +
    String(item && item.kind || "") + " " +
    String(item && item.category || "") + " " +
    String(item && item.resultType || "")
  );

  if(
    txt.indexOf("county meath") > -1 ||
    txt.indexOf("ireland") > -1 ||
    txt.indexOf("karakocan") > -1 ||
    txt.indexOf("eastern anatolia") > -1 ||
    txt.indexOf("turkey") > -1
  ){
    return true;
  }

  if(
    txt.indexOf("hotel") > -1 ||
    txt.indexOf("motel") > -1 ||
    txt.indexOf(" inn ") > -1 ||
    txt.indexOf("hospital") > -1 ||
    txt.indexOf("emergency") > -1 ||
    txt.indexOf("amenity") > -1
  ){
    return true;
  }

  if(finite(Number(item && item.distMiles)) && Number(item.distMiles) > 1200){
    return true;
  }

  return false;
}

function diqV209CityLike(item){
  var txt = normText(
    String(item && item.kind || "") + " " +
    String(item && item.category || "") + " " +
    String(item && item.resultType || "") + " " +
    String(item && item.full || "")
  );

  return !!(
    item &&
    (
      item.canonical === true ||
      item.resultType === "adventure_index" ||
      txt.indexOf("city") > -1 ||
      txt.indexOf("town") > -1 ||
      txt.indexOf("locality") > -1 ||
      txt.indexOf("municipality") > -1 ||
      txt.indexOf("beach") > -1 ||
      txt.indexOf("lake") > -1 ||
      txt.indexOf("park") > -1 ||
      txt.indexOf("region") > -1
    )
  );
}

function diqV209Key(item){
  return normText(
    String(item && item.resultType || "") + "|" +
    String(item && item.adventureIndexId || item.districtId || "") + "|" +
    String(item && item.label || "") + "|" +
    String(item && item.full || "") + "|" +
    String(item && item.lat || "") + "|" +
    String(item && item.lng || "")
  );
}

function diqV209Authority(results,query){
  var q = diqV209ActiveQuery(query);
  var nq = normText(q);
  var explicitDistrict = diqV209ExplicitDistrictQuery(q);
  var source = (results || []).slice(0);
  var canonical = null;
  var cities = [];
  var districts = [];
  var out = [];
  var seen = {};
  var i;
  var item;

  try{
    var indexed = adventureDestinationIndexMatch(q);
    if(indexed){ canonical = indexedAdventureItem(indexed); }
  }catch(e0){}

  function add(candidate){
    var key;
    if(!candidate){ return; }
    key = diqV209Key(candidate);
    if(seen[key]){ return; }
    seen[key] = true;
    out.push(candidate);
  }

  if(canonical){ add(canonical); }

  for(i=0;i<source.length;i++){
    item = source[i];
    if(!item || diqV209IsBadDestination(item)){ continue; }

    if(diqV209IsDistrict(item)){
      if(explicitDistrict){ districts.push(item); }
      continue;
    }

    if(diqV209CityLike(item)){
      cities.push(item);
    }
  }

  function rank(a,b){
    var sa = 0;
    var sb = 0;
    var la = normText(a && a.label || "");
    var lb = normText(b && b.label || "");
    var ta = normText(String(a && a.label || "") + " " + String(a && a.full || ""));
    var tb = normText(String(b && b.label || "") + " " + String(b && b.full || ""));

    if(a && (a.canonical || a.resultType === "adventure_index")){ sa += 1200; }
    if(b && (b.canonical || b.resultType === "adventure_index")){ sb += 1200; }

    if(la === nq){ sa += 1000; }
    if(lb === nq){ sb += 1000; }

    if(ta.indexOf(nq) > -1){ sa += 500; }
    if(tb.indexOf(nq) > -1){ sb += 500; }

    if(ta.indexOf("florida") > -1){ sa += 250; }
    if(tb.indexOf("florida") > -1){ sb += 250; }

    return sb - sa;
  }

  cities.sort(rank);
  districts.sort(rank);

  for(i=0;i<cities.length && out.length<4;i++){ add(cities[i]); }

  if(explicitDistrict){
    for(i=0;i<districts.length && out.length<5;i++){ add(districts[i]); }
  }

  return out.slice(0,5);
}

function diqV209SameQuery(a,b){
  return normText(a) === normText(b);
}

/* Final render authority. Every late result payload passes this gate. */
var diqV209PriorRenderDestinationResults = renderDestinationResults;
renderDestinationResults = function(results,query){
  var liveQuery = diqV209ActiveQuery(query);
  var stable = diqV209Authority(results || [],liveQuery);
  var now = Date.now();

  if(!liveQuery || liveQuery.length < 2){
    return diqV209PriorRenderDestinationResults([],liveQuery);
  }

  /* Never let a late stale response replace a newer typed query. */
  if(
    diqV209LastQuery &&
    !diqV209SameQuery(liveQuery,diqV209LastQuery) &&
    now - diqV209LastRenderAt < 1800
  ){
    return;
  }

  /* If a late legacy layer returns only junk, preserve the last good list. */
  if(
    !stable.length &&
    diqV209SameQuery(liveQuery,diqV209LastQuery) &&
    diqV209LastStableResults.length
  ){
    stable = diqV209LastStableResults.slice(0);
  }

  diqV209LastQuery = liveQuery;
  diqV209LastStableResults = stable.slice(0);
  diqV209LastRenderAt = now;

  return diqV209PriorRenderDestinationResults(stable,liveQuery);
};

/* Provider callbacks may directly mutate destinationSearchResults.
   Reassert the stable authority immediately after each input cycle. */
function diqV209Reassert(){
  var input = byId("adventureSearch");
  var q = input ? clean(input.value) : "";
  var panel = byId("diqAdventureDestResults");

  if(!q || q.length < 2 || !panel || !destinationResultOpen){ return; }

  var stable = diqV209Authority(
    destinationSearchResults || diqV209LastStableResults || [],
    q
  );

  if(stable.length){
    diqV209LastQuery = q;
    diqV209LastStableResults = stable.slice(0);
    diqV209LastRenderAt = Date.now();
    diqV209PriorRenderDestinationResults(stable,q);
  }
}

function diqV209BindInput(){
  var input = byId("adventureSearch");
  if(!input || input.getAttribute("data-v209-search-authority") === "1"){
    return;
  }

  input.setAttribute("data-v209-search-authority","1");

  input.addEventListener("input",function(){
    var q = clean(input.value);

    if(destinationLock && !destinationLockMatchesInput(q)){
      clearDestinationLock();
    }

    window.setTimeout(diqV209Reassert,180);
    window.setTimeout(diqV209Reassert,520);
    window.setTimeout(diqV209Reassert,1100);
  },false);

  input.addEventListener("focus",function(){
    window.setTimeout(diqV209Reassert,220);
  },false);
}

if(document.readyState === "loading"){
  document.addEventListener("DOMContentLoaded",diqV209BindInput,false);
}else{
  diqV209BindInput();
}

window.setTimeout(diqV209BindInput,400);
window.setTimeout(diqV209BindInput,1200);

window.DRIVE_IQ_ADVENTURE_V209 = {
  build:"V209_FINAL_DESTINATION_SEARCH_AUTHORITY",
  authority:diqV209Authority,
  reassert:diqV209Reassert
};

try{
  console.log("âœ… Drive IQ Adventure V209 Final Destination Search Authority loaded");
}catch(ePublic){}

}());


/* =========================================================
   DRIVE IQ ADVENTURE MODE V210
   COMPACT KEYBOARD-SAFE DESTINATION CHOOSER AUTHORITY

   Final autocomplete presentation authority:
   - Compact city/area rows only for generic destination searches
   - District cards never render inside generic city autocomplete
   - Canonical city/area remains first
   - 2â€“4 compact rows maximum
   - Keyboard-safe max height using visualViewport
   - Internal scrolling only
   - Late legacy DOM rewrites are replaced with the compact authority
   ES5 SAFE
========================================================= */
(function(){
"use strict";

if(window.__DRIVE_IQ_ADVENTURE_V210_COMPACT_CHOOSER__){ return; }
window.__DRIVE_IQ_ADVENTURE_V210_COMPACT_CHOOSER__ = true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD =
  "V210_COMPACT_KEYBOARD_SAFE_DESTINATION_CHOOSER";

var diqV210Rendering = false;
var diqV210LastQuery = "";
var diqV210LastResults = [];
var diqV210Observer = null;
var diqV210ResizeTimer = null;

function diqV210IsDistrict(item){
  return !!(
    item &&
    (
      item.entityType === "district" ||
      item.entityClass === "district" ||
      item.poiClass === "district" ||
      item.kind === "district" ||
      item.type === "district" ||
      item.districtId ||
      item.resultType === "adventure_district_registry" ||
      item.resultType === "entity_registry_district"
    )
  );
}

function diqV210ExplicitDistrictQuery(query){
  var q = normText(query);
  if(!q){ return false; }

  return (
    q.indexOf("district") > -1 ||
    q.indexOf("harborwalk") > -1 ||
    q.indexOf("destin commons") > -1 ||
    q.indexOf("beale street") > -1 ||
    q.indexOf("silo square") > -1 ||
    q.indexOf("disney springs") > -1 ||
    q.indexOf("the wharf") > -1 ||
    q.indexOf("broadway nashville") > -1
  );
}

function diqV210BadResult(item){
  var txt = normText(
    String(item && item.label || "") + " " +
    String(item && item.full || "") + " " +
    String(item && item.kind || "") + " " +
    String(item && item.category || "") + " " +
    String(item && item.resultType || "")
  );

  if(
    txt.indexOf("county meath") > -1 ||
    txt.indexOf("ireland") > -1 ||
    txt.indexOf("karakocan") > -1 ||
    txt.indexOf("eastern anatolia") > -1 ||
    txt.indexOf("turkey") > -1 ||
    txt.indexOf("hotel") > -1 ||
    txt.indexOf("motel") > -1 ||
    txt.indexOf("hospital") > -1 ||
    txt.indexOf("emergency") > -1 ||
    txt.indexOf("amenity") > -1
  ){
    return true;
  }

  if(finite(Number(item && item.distMiles)) && Number(item.distMiles) > 1200){
    return true;
  }

  return false;
}

function diqV210CityAreaLike(item){
  var txt = normText(
    String(item && item.kind || "") + " " +
    String(item && item.category || "") + " " +
    String(item && item.resultType || "") + " " +
    String(item && item.full || "")
  );

  return !!(
    item &&
    (
      item.canonical === true ||
      item.resultType === "adventure_index" ||
      txt.indexOf("city") > -1 ||
      txt.indexOf("town") > -1 ||
      txt.indexOf("locality") > -1 ||
      txt.indexOf("municipality") > -1 ||
      txt.indexOf("region") > -1 ||
      txt.indexOf("beach") > -1 ||
      txt.indexOf("lake") > -1 ||
      txt.indexOf("park") > -1 ||
      txt.indexOf("attraction") > -1
    )
  );
}

function diqV210Key(item){
  return normText(
    String(item && item.resultType || "") + "|" +
    String(item && item.adventureIndexId || item.districtId || "") + "|" +
    String(item && item.label || "") + "|" +
    String(item && item.full || "") + "|" +
    String(item && item.lat || "") + "|" +
    String(item && item.lng || "")
  );
}

function diqV210Authority(results,query){
  var q = clean(query);
  var nq = normText(q);
  var explicitDistrict = diqV210ExplicitDistrictQuery(q);
  var source = (results || []).slice(0);
  var canonical = null;
  var cities = [];
  var districts = [];
  var out = [];
  var seen = {};
  var i;
  var item;

  try{
    var indexed = adventureDestinationIndexMatch(q);
    if(indexed){ canonical = indexedAdventureItem(indexed); }
  }catch(e0){}

  function add(candidate){
    var key;
    if(!candidate){ return; }
    key = diqV210Key(candidate);
    if(seen[key]){ return; }
    seen[key] = true;
    out.push(candidate);
  }

  if(canonical){ add(canonical); }

  for(i=0;i<source.length;i++){
    item = source[i];
    if(!item || diqV210BadResult(item)){ continue; }

    if(diqV210IsDistrict(item)){
      if(explicitDistrict){ districts.push(item); }
      continue;
    }

    if(diqV210CityAreaLike(item)){ cities.push(item); }
  }

  function rank(a,b){
    var sa = 0;
    var sb = 0;
    var la = normText(a && a.label || "");
    var lb = normText(b && b.label || "");
    var ta = normText(String(a && a.label || "") + " " + String(a && a.full || ""));
    var tb = normText(String(b && b.label || "") + " " + String(b && b.full || ""));

    if(a && (a.canonical || a.resultType === "adventure_index")){ sa += 1500; }
    if(b && (b.canonical || b.resultType === "adventure_index")){ sb += 1500; }

    if(la === nq){ sa += 1000; }
    if(lb === nq){ sb += 1000; }

    if(ta.indexOf(nq) > -1){ sa += 500; }
    if(tb.indexOf(nq) > -1){ sb += 500; }

    return sb - sa;
  }

  cities.sort(rank);
  districts.sort(rank);

  for(i=0;i<cities.length && out.length<4;i++){ add(cities[i]); }

  if(explicitDistrict){
    for(i=0;i<districts.length && out.length<4;i++){ add(districts[i]); }
  }

  return out.slice(0,4);
}

function diqV210CompactMeta(item){
  var type = "";
  var distance = "";

  if(item && item.resultType === "adventure_index"){
    type = "Adventure Region";
  }else if(diqV210IsDistrict(item)){
    type = "District";
  }else if(item && item.kind){
    type = titleCaseWords(String(item.kind).replace(/_/g," "));
  }else{
    type = "Destination";
  }

  if(item && finite(Number(item.distMiles))){
    distance = itemDistanceText(item);
  }

  return clean(
    String(distance || "") +
    (distance && type ? " â€¢ " : "") +
    String(type || "Destination")
  );
}

function diqV210ApplyKeyboardSafeHeight(){
  var panel = byId("diqAdventureDestResults");
  var list = byId("diqDestList");
  var searchWrap = document.querySelector(".searchWrap");
  var viewport = window.visualViewport;
  var viewportHeight = viewport && finite(Number(viewport.height))
    ? Number(viewport.height)
    : window.innerHeight;
  var top = 0;
  var available;
  var maxHeight;

  if(!panel || !list || !searchWrap){ return; }

  try{
    top = searchWrap.getBoundingClientRect().bottom + 8;
  }catch(e0){
    top = 220;
  }

  available = viewportHeight - top - 12;
  maxHeight = Math.max(118,Math.min(260,available - 48));

  panel.style.setProperty("max-height",Math.max(170,available) + "px","important");
  list.style.setProperty("max-height",maxHeight + "px","important");
}

function diqV210Render(results,query){
  var panel = ensureDestinationResultsPanel();
  var list = byId("diqDestList");
  var head;
  var stable;
  var i;
  var item;
  var btn;
  var name;
  var sub;
  var meta;

  if(!panel || !list){ return; }

  diqV210Rendering = true;

  stable = diqV210Authority(results || [],query || "");
  diqV210LastQuery = clean(query || "");
  diqV210LastResults = stable.slice(0);
  destinationSearchResults = stable.slice(0);

  panel.className = "on diqModeDestination diqCompactDestination";
  panel.setAttribute("aria-hidden","false");
  destinationResultOpen = true;

  head = panel.querySelector ? panel.querySelector(".diqDestHead") : null;
  if(head){
    head.textContent = "CHOOSE DESTINATION";
  }

  list.innerHTML = "";

  if(!stable.length){
    btn = document.createElement("button");
    btn.type = "button";
    btn.className = "diqDestItem diqCompactDestItem";
    btn.innerHTML =
      '<div class="diqDestName">No destination match yet</div>' +
      '<div class="diqDestSub">Try a city, lake, park, beach, attraction, or business.</div>';
    list.appendChild(btn);
  }else{
    for(i=0;i<stable.length;i++){
      item = stable[i];
      btn = document.createElement("button");
      btn.type = "button";
      btn.className = "diqDestItem diqCompactDestItem";
      btn.setAttribute("data-v210-dest-idx",String(i));

      name = clean(item.label || "Destination");
      sub = clean(item.full || "");
      meta = diqV210CompactMeta(item);

      btn.innerHTML =
        '<div class="diqDestName">' + escapeHTML(name) + '</div>' +
        '<div class="diqDestSub">' + escapeHTML(sub || "Tap to explore this destination") + '</div>' +
        '<div class="diqDestMeta">' + escapeHTML(meta || "Destination") + '</div>';

      btn.onclick = function(){
        var idx = Number(this.getAttribute("data-v210-dest-idx"));
        if(idx >= 0 && destinationSearchResults[idx]){
          hideDestinationResults();
          dismissAdventureKeyboard();
          routeDestinationResult(destinationSearchResults[idx]);
        }
      };

      list.appendChild(btn);
    }
  }

  diqV210ApplyKeyboardSafeHeight();

  window.setTimeout(function(){
    diqV210Rendering = false;
  },40);
}

function diqV210InjectStyles(){
  var style;
  var css;

  if(byId("diqV210CompactChooserStyles")){ return; }

  css =
    "#diqAdventureDestResults.diqCompactDestination{" +
      "position:relative!important;inset:auto!important;top:auto!important;left:auto!important;" +
      "right:auto!important;bottom:auto!important;width:100%!important;max-width:100%!important;" +
      "margin:7px 0 0!important;padding:0!important;transform:none!important;" +
      "overflow:hidden!important;z-index:160!important;border-radius:16px!important;" +
      "background:transparent!important;" +
    "}" +
    "#diqAdventureDestResults.diqCompactDestination .diqDestHead{" +
      "position:sticky!important;top:0!important;z-index:4!important;" +
      "min-height:42px!important;padding:0 48px 0 13px!important;" +
      "display:flex!important;align-items:center!important;" +
      "border-radius:16px 16px 0 0!important;" +
      "background:linear-gradient(180deg,rgba(4,11,20,.995),rgba(4,11,20,.98))!important;" +
      "border:1px solid rgba(40,255,190,.28)!important;border-bottom:0!important;" +
      "color:#b6ffeb!important;font-size:10px!important;line-height:1!important;" +
      "font-weight:1000!important;letter-spacing:1.25px!important;" +
    "}" +
    "#diqAdventureDestResults.diqCompactDestination #diqDestList{" +
      "display:block!important;width:100%!important;margin:0!important;padding:5px 6px 8px!important;" +
      "overflow-y:auto!important;overflow-x:hidden!important;-webkit-overflow-scrolling:touch!important;" +
      "background:linear-gradient(180deg,rgba(4,11,20,.985),rgba(2,8,16,.997))!important;" +
      "border:1px solid rgba(40,255,190,.28)!important;border-top:0!important;" +
      "border-radius:0 0 16px 16px!important;box-shadow:0 18px 36px rgba(0,0,0,.48)!important;" +
    "}" +
    "#diqAdventureDestResults.diqCompactDestination .diqCompactDestItem{" +
      "display:block!important;width:100%!important;min-height:76px!important;" +
      "margin:5px 0!important;padding:12px 14px!important;" +
      "float:none!important;clear:both!important;text-align:left!important;" +
      "border-radius:14px!important;border:1px solid rgba(255,255,255,.11)!important;" +
      "background:linear-gradient(180deg,rgba(255,255,255,.055),rgba(255,255,255,.025))!important;" +
      "box-shadow:none!important;overflow:hidden!important;" +
    "}" +
    "#diqAdventureDestResults.diqCompactDestination .diqCompactDestItem .diqDestName{" +
      "margin:0 0 4px!important;font-size:18px!important;line-height:1.08!important;" +
      "font-weight:900!important;color:#fff!important;white-space:nowrap!important;" +
      "overflow:hidden!important;text-overflow:ellipsis!important;" +
    "}" +
    "#diqAdventureDestResults.diqCompactDestination .diqCompactDestItem .diqDestSub{" +
      "margin:0 0 6px!important;font-size:13px!important;line-height:1.22!important;" +
      "font-weight:650!important;color:rgba(255,255,255,.70)!important;" +
      "white-space:nowrap!important;overflow:hidden!important;text-overflow:ellipsis!important;" +
    "}" +
    "#diqAdventureDestResults.diqCompactDestination .diqCompactDestItem .diqDestMeta{" +
      "font-size:10px!important;line-height:1!important;font-weight:1000!important;" +
      "letter-spacing:1.05px!important;text-transform:uppercase!important;" +
      "color:#ffe28b!important;white-space:nowrap!important;" +
      "overflow:hidden!important;text-overflow:ellipsis!important;" +
    "}" +
    "#diqAdventureDestResults.diqCompactDestination .diqDistrictCard," +
    "#diqAdventureDestResults.diqCompactDestination .districtCard," +
    "#diqAdventureDestResults.diqCompactDestination [data-entity-type='district']{" +
      "display:none!important;" +
    "}" +
    "@media(max-height:700px){" +
      "#diqAdventureDestResults.diqCompactDestination .diqCompactDestItem{" +
        "min-height:68px!important;padding:10px 12px!important;" +
      "}" +
      "#diqAdventureDestResults.diqCompactDestination .diqCompactDestItem .diqDestName{" +
        "font-size:17px!important;" +
      "}" +
    "}";

  style = document.createElement("style");
  style.id = "diqV210CompactChooserStyles";
  style.type = "text/css";
  style.appendChild(document.createTextNode(css));
  try{ document.head.appendChild(style); }catch(e0){}
}

/* Hard override: destination autocomplete uses only the compact renderer. */
renderDestinationResults = function(results,query){
  diqV210Render(results || [],query || "");
};

/* Legacy layers sometimes write directly into the chooser DOM.
   Replace those mutations immediately with the compact stable authority. */
function diqV210Observe(){
  var panel = byId("diqAdventureDestResults");

  if(!panel || diqV210Observer){ return; }

  try{
    diqV210Observer = new MutationObserver(function(){
      if(diqV210Rendering || !destinationResultOpen){ return; }

      window.setTimeout(function(){
        var input = byId("adventureSearch");
        var q = input ? clean(input.value) : diqV210LastQuery;

        if(!q || q.length < 2){ return; }

        diqV210Render(
          destinationSearchResults && destinationSearchResults.length
            ? destinationSearchResults
            : diqV210LastResults,
          q
        );
      },30);
    });

    diqV210Observer.observe(panel,{
      childList:true,
      subtree:true
    });
  }catch(e0){}
}

function diqV210Bind(){
  var input = byId("adventureSearch");

  diqV210InjectStyles();
  /* V514: diqV210Observe retired; it rerendered the same panel it observed. */

  if(input && input.getAttribute("data-v210-compact-chooser") !== "1"){
    input.setAttribute("data-v210-compact-chooser","1");

    input.addEventListener("input",function(){
      window.setTimeout(diqV210ApplyKeyboardSafeHeight,80);
      window.setTimeout(diqV210ApplyKeyboardSafeHeight,260);
    },false);

    input.addEventListener("focus",function(){
      window.setTimeout(diqV210ApplyKeyboardSafeHeight,120);
      window.setTimeout(diqV210ApplyKeyboardSafeHeight,360);
    },false);
  }

  if(window.visualViewport && window.visualViewport.addEventListener){
    window.visualViewport.addEventListener("resize",function(){
      if(diqV210ResizeTimer){ window.clearTimeout(diqV210ResizeTimer); }
      diqV210ResizeTimer = window.setTimeout(diqV210ApplyKeyboardSafeHeight,50);
    },false);

    window.visualViewport.addEventListener("scroll",function(){
      if(diqV210ResizeTimer){ window.clearTimeout(diqV210ResizeTimer); }
      diqV210ResizeTimer = window.setTimeout(diqV210ApplyKeyboardSafeHeight,50);
    },false);
  }

  window.addEventListener("orientationchange",function(){
    window.setTimeout(diqV210ApplyKeyboardSafeHeight,180);
  },false);
}

if(document.readyState === "loading"){
  document.addEventListener("DOMContentLoaded",diqV210Bind,false);
}else{
  diqV210Bind();
}

window.setTimeout(diqV210Bind,350);
window.setTimeout(diqV210Bind,1100);

window.DRIVE_IQ_ADVENTURE_V210 = {
  build:"V210_COMPACT_KEYBOARD_SAFE_DESTINATION_CHOOSER",
  authority:diqV210Authority,
  render:diqV210Render,
  resize:diqV210ApplyKeyboardSafeHeight
};

try{
  console.log("âœ… Drive IQ Adventure V210 Compact Keyboard-Safe Chooser loaded");
}catch(ePublic){}

}());


/* =========================================================
   DRIVE IQ ADVENTURE MODE V211
   SAFE-AREA ANCHORED DESTINATION CHOOSER

   Fixes the chooser sitting under the iPhone status bar and cutting off
   against the left edge. The chooser is now positioned from the live search
   box rectangle, then clamped inside safe screen margins.
   ES5 SAFE
========================================================= */
(function(){
"use strict";

if(window.__DRIVE_IQ_ADVENTURE_V211_SAFE_AREA_CHOOSER__){ return; }
window.__DRIVE_IQ_ADVENTURE_V211_SAFE_AREA_CHOOSER__ = true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD =
  "V211_SAFE_AREA_ANCHORED_DESTINATION_CHOOSER";

var diqV211Timer = null;

function diqV211PositionChooser(){
  var panel = byId("diqAdventureDestResults");
  var searchWrap = document.querySelector(".searchWrap");
  var viewport = window.visualViewport;
  var rect;
  var viewportWidth;
  var viewportHeight;
  var viewportOffsetTop;
  var viewportOffsetLeft;
  var left;
  var top;
  var width;
  var maxHeight;
  var safeLeft = 12;
  var safeRight = 12;
  var safeTop = 92;
  var keyboardGap = 12;

  if(!panel || !searchWrap || !destinationResultOpen){ return; }

  rect = searchWrap.getBoundingClientRect();

  viewportWidth = viewport && finite(Number(viewport.width))
    ? Number(viewport.width)
    : window.innerWidth;

  viewportHeight = viewport && finite(Number(viewport.height))
    ? Number(viewport.height)
    : window.innerHeight;

  viewportOffsetTop = viewport && finite(Number(viewport.offsetTop))
    ? Number(viewport.offsetTop)
    : 0;

  viewportOffsetLeft = viewport && finite(Number(viewport.offsetLeft))
    ? Number(viewport.offsetLeft)
    : 0;

  left = Math.max(
    safeLeft + viewportOffsetLeft,
    rect.left + viewportOffsetLeft
  );

  width = Math.min(
    rect.width,
    viewportWidth - safeLeft - safeRight
  );

  if(left + width > viewportOffsetLeft + viewportWidth - safeRight){
    left = viewportOffsetLeft + viewportWidth - safeRight - width;
  }

  if(left < viewportOffsetLeft + safeLeft){
    left = viewportOffsetLeft + safeLeft;
  }

  top = rect.bottom + viewportOffsetTop + 8;

  /* Never allow the chooser under the status bar / Dynamic Island. */
  if(top < viewportOffsetTop + safeTop){
    top = viewportOffsetTop + safeTop;
  }

  maxHeight = viewportOffsetTop + viewportHeight - top - keyboardGap;
  maxHeight = Math.max(170,Math.min(360,maxHeight));

  panel.className = String(panel.className || "")
    .replace(/\bdiqModeShelf\b/g,"")
    .replace(/\s+/g," ")
    .trim();

  if(String(panel.className || "").indexOf("diqModeDestination") < 0){
    panel.className = clean(String(panel.className || "") + " diqModeDestination");
  }

  if(String(panel.className || "").indexOf("diqCompactDestination") < 0){
    panel.className = clean(String(panel.className || "") + " diqCompactDestination");
  }

  panel.style.setProperty("position","fixed","important");
  panel.style.setProperty("top",Math.round(top) + "px","important");
  panel.style.setProperty("left",Math.round(left) + "px","important");
  panel.style.setProperty("right","auto","important");
  panel.style.setProperty("bottom","auto","important");
  panel.style.setProperty("width",Math.round(width) + "px","important");
  panel.style.setProperty("max-width",Math.round(width) + "px","important");
  panel.style.setProperty("max-height",Math.round(maxHeight) + "px","important");
  panel.style.setProperty("inset","auto","important");
  panel.style.setProperty("transform","none","important");
  panel.style.setProperty("margin","0","important");

  var list = byId("diqDestList");
  if(list){
    list.style.setProperty(
      "max-height",
      Math.max(110,Math.round(maxHeight - 44)) + "px",
      "important"
    );
  }
}

function diqV211Schedule(){
  if(diqV211Timer){ window.clearTimeout(diqV211Timer); }
  diqV211Timer = window.setTimeout(diqV211PositionChooser,20);
  window.setTimeout(diqV211PositionChooser,120);
  window.setTimeout(diqV211PositionChooser,320);
}

/* Reposition after every destination render. */
var diqV211PriorRenderDestinationResults = renderDestinationResults;
renderDestinationResults = function(results,query){
  var result = diqV211PriorRenderDestinationResults(results,query);
  diqV211Schedule();
  return result;
};

function diqV211Bind(){
  var input = byId("adventureSearch");

  if(input && input.getAttribute("data-v211-safe-area") !== "1"){
    input.setAttribute("data-v211-safe-area","1");

    input.addEventListener("focus",diqV211Schedule,false);
    input.addEventListener("input",diqV211Schedule,false);
  }

  window.addEventListener("resize",diqV211Schedule,false);
  window.addEventListener("orientationchange",function(){
    window.setTimeout(diqV211Schedule,180);
  },false);

  if(window.visualViewport && window.visualViewport.addEventListener){
    window.visualViewport.addEventListener("resize",diqV211Schedule,false);
    window.visualViewport.addEventListener("scroll",diqV211Schedule,false);
  }
}

if(document.readyState === "loading"){
  document.addEventListener("DOMContentLoaded",diqV211Bind,false);
}else{
  diqV211Bind();
}

window.setTimeout(diqV211Bind,350);
window.setTimeout(diqV211Bind,1000);

window.DRIVE_IQ_ADVENTURE_V211 = {
  build:"V211_SAFE_AREA_ANCHORED_DESTINATION_CHOOSER",
  position:diqV211PositionChooser
};

try{
  console.log("âœ… Drive IQ Adventure V211 Safe-Area Chooser loaded");
}catch(ePublic){}

}());


/* =========================================================
   DRIVE IQ ADVENTURE MODE V212
   SEPARATE SEARCH RESULTS PANEL AUTHORITY

   Structural fix:
   - Destination autocomplete now has its own dedicated panel:
       #diqAdventureSearchResults
   - The legacy #diqAdventureDestResults panel is reserved for scan results
     and district/place discovery only.
   - Generic city searches show compact city/area rows only.
   - Explicit district searches may show the exact district.
   - The chooser is anchored below the live search box with safe margins.
   - Old autocomplete DOM writes can no longer visually replace this panel.
   ES5 SAFE
========================================================= */
(function(){
"use strict";

if(window.__DRIVE_IQ_ADVENTURE_V212_SEPARATE_SEARCH_PANEL__){ return; }
window.__DRIVE_IQ_ADVENTURE_V212_SEPARATE_SEARCH_PANEL__ = true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD =
  "V212_SEPARATE_SEARCH_RESULTS_PANEL_AUTHORITY";

var diqV212Results = [];
var diqV212Query = "";
var diqV212Open = false;
var diqV212PositionTimer = null;

function diqV212IsDistrict(item){
  return !!(
    item &&
    (
      item.entityType === "district" ||
      item.entityClass === "district" ||
      item.poiClass === "district" ||
      item.kind === "district" ||
      item.type === "district" ||
      item.districtId ||
      item.resultType === "adventure_district_registry" ||
      item.resultType === "entity_registry_district"
    )
  );
}

function diqV212ExplicitDistrictQuery(query){
  var q = normText(query);
  if(!q){ return false; }

  return (
    q.indexOf("district") > -1 ||
    q.indexOf("harborwalk") > -1 ||
    q.indexOf("destin commons") > -1 ||
    q.indexOf("beale street") > -1 ||
    q.indexOf("silo square") > -1 ||
    q.indexOf("disney springs") > -1 ||
    q.indexOf("the wharf") > -1 ||
    q.indexOf("broadway nashville") > -1
  );
}

function diqV212BadResult(item){
  var txt = normText(
    String(item && item.label || "") + " " +
    String(item && item.full || "") + " " +
    String(item && item.kind || "") + " " +
    String(item && item.category || "") + " " +
    String(item && item.resultType || "")
  );

  if(
    txt.indexOf("county meath") > -1 ||
    txt.indexOf("ireland") > -1 ||
    txt.indexOf("karakocan") > -1 ||
    txt.indexOf("eastern anatolia") > -1 ||
    txt.indexOf("turkey") > -1 ||
    txt.indexOf("hotel") > -1 ||
    txt.indexOf("motel") > -1 ||
    txt.indexOf("hospital") > -1 ||
    txt.indexOf("emergency") > -1 ||
    txt.indexOf("amenity") > -1
  ){
    return true;
  }

  if(finite(Number(item && item.distMiles)) && Number(item.distMiles) > 1200){
    return true;
  }

  return false;
}

function diqV212CityAreaLike(item){
  var txt = normText(
    String(item && item.kind || "") + " " +
    String(item && item.category || "") + " " +
    String(item && item.resultType || "") + " " +
    String(item && item.full || "")
  );

  return !!(
    item &&
    (
      item.canonical === true ||
      item.resultType === "adventure_index" ||
      txt.indexOf("city") > -1 ||
      txt.indexOf("town") > -1 ||
      txt.indexOf("locality") > -1 ||
      txt.indexOf("municipality") > -1 ||
      txt.indexOf("region") > -1 ||
      txt.indexOf("beach") > -1 ||
      txt.indexOf("lake") > -1 ||
      txt.indexOf("park") > -1 ||
      txt.indexOf("attraction") > -1
    )
  );
}

function diqV212Key(item){
  return normText(
    String(item && item.resultType || "") + "|" +
    String(item && item.adventureIndexId || item.districtId || "") + "|" +
    String(item && item.label || "") + "|" +
    String(item && item.full || "") + "|" +
    String(item && item.lat || "") + "|" +
    String(item && item.lng || "")
  );
}

function diqV212Authority(results,query){
  var q = clean(query);
  var nq = normText(q);
  var explicitDistrict = diqV212ExplicitDistrictQuery(q);
  var source = (results || []).slice(0);
  var canonical = null;
  var cities = [];
  var districts = [];
  var out = [];
  var seen = {};
  var i;
  var item;

  try{
    var indexed = adventureDestinationIndexMatch(q);
    if(indexed){ canonical = indexedAdventureItem(indexed); }
  }catch(e0){}

  function add(candidate){
    var key;
    if(!candidate){ return; }
    key = diqV212Key(candidate);
    if(seen[key]){ return; }
    seen[key] = true;
    out.push(candidate);
  }

  if(canonical){ add(canonical); }

  for(i=0;i<source.length;i++){
    item = source[i];
    if(!item || diqV212BadResult(item)){ continue; }

    if(diqV212IsDistrict(item)){
      if(explicitDistrict){ districts.push(item); }
      continue;
    }

    if(diqV212CityAreaLike(item)){ cities.push(item); }
  }

  function rank(a,b){
    var sa = 0;
    var sb = 0;
    var la = normText(a && a.label || "");
    var lb = normText(b && b.label || "");
    var ta = normText(String(a && a.label || "") + " " + String(a && a.full || ""));
    var tb = normText(String(b && b.label || "") + " " + String(b && b.full || ""));

    if(a && (a.canonical || a.resultType === "adventure_index")){ sa += 1800; }
    if(b && (b.canonical || b.resultType === "adventure_index")){ sb += 1800; }

    if(la === nq){ sa += 1100; }
    if(lb === nq){ sb += 1100; }

    if(ta.indexOf(nq) > -1){ sa += 550; }
    if(tb.indexOf(nq) > -1){ sb += 550; }

    return sb - sa;
  }

  cities.sort(rank);
  districts.sort(rank);

  for(i=0;i<cities.length && out.length<4;i++){ add(cities[i]); }

  if(explicitDistrict){
    for(i=0;i<districts.length && out.length<4;i++){ add(districts[i]); }
  }

  return out.slice(0,4);
}

function diqV212EnsurePanel(){
  var panel = byId("diqAdventureSearchResults");
  var searchWrap = document.querySelector(".searchWrap");
  var hero = byId("adventureHero");

  if(!panel){
    panel = document.createElement("div");
    panel.id = "diqAdventureSearchResults";
    panel.setAttribute("aria-hidden","true");
    panel.innerHTML =
      '<div class="diqSearchResultsHead">' +
        '<span>CHOOSE DESTINATION</span>' +
        '<button type="button" id="diqSearchResultsClose" aria-label="Close destination choices">&times;</button>' +
      '</div>' +
      '<div id="diqAdventureSearchResultsList"></div>';
  }

  if(searchWrap && searchWrap.parentNode){
    try{
      if(searchWrap.nextSibling){
        searchWrap.parentNode.insertBefore(panel,searchWrap.nextSibling);
      }else{
        searchWrap.parentNode.appendChild(panel);
      }
    }catch(e0){}
  }else if(hero){
    try{ hero.appendChild(panel); }catch(e1){}
  }else{
    try{ document.body.appendChild(panel); }catch(e2){}
  }

  var close = byId("diqSearchResultsClose");
  if(close && close.getAttribute("data-v212-bound") !== "1"){
    close.setAttribute("data-v212-bound","1");
    close.onclick = function(event){
      if(event && event.preventDefault){ event.preventDefault(); }
      if(event && event.stopPropagation){ event.stopPropagation(); }
      diqV212Hide();
      try{
        var input = byId("adventureSearch");
        if(input){ input.focus(); }
      }catch(e3){}
      return false;
    };
  }

  return panel;
}

function diqV212HideLegacyAutocomplete(){
  var legacy = byId("diqAdventureDestResults");

  if(!legacy){ return; }

  if(String(legacy.className || "").indexOf("diqModeShelf") < 0){
    legacy.className = "";
    legacy.setAttribute("aria-hidden","true");
  }
}

function diqV212Hide(){
  var panel = byId("diqAdventureSearchResults");

  diqV212Open = false;
  destinationResultOpen = false;

  if(panel){
    panel.className = "";
    panel.setAttribute("aria-hidden","true");
  }

  try{ document.body.classList.remove("diqSearchChooserOpen"); }catch(e0){}
  updateClearAdventureSearchButton();
}

function diqV212Meta(item){
  var type = "";
  var distance = "";

  if(item && item.resultType === "adventure_index"){
    type = "Adventure Region";
  }else if(diqV212IsDistrict(item)){
    type = "District";
  }else if(item && item.kind){
    type = titleCaseWords(String(item.kind).replace(/_/g," "));
  }else{
    type = "Destination";
  }

  if(item && finite(Number(item.distMiles))){
    distance = itemDistanceText(item);
  }

  return clean(
    String(distance || "") +
    (distance && type ? " â€¢ " : "") +
    String(type || "Destination")
  );
}

function diqV212Position(){
  var panel = byId("diqAdventureSearchResults");
  var searchWrap = document.querySelector(".searchWrap");
  var list = byId("diqAdventureSearchResultsList");
  var viewport = window.visualViewport;
  var rect;
  var viewportHeight;
  var available;
  var maxListHeight;

  if(!panel || !searchWrap || !diqV212Open){ return; }

  rect = searchWrap.getBoundingClientRect();

  viewportHeight = viewport && finite(Number(viewport.height))
    ? Number(viewport.height)
    : window.innerHeight;

  available = viewportHeight - rect.bottom - 16;
  maxListHeight = Math.max(104,Math.min(248,available - 44));

  panel.style.setProperty("width",Math.max(240,rect.width) + "px","important");
  panel.style.setProperty("max-width","calc(100vw - 24px)","important");
  panel.style.setProperty("max-height",Math.max(160,available) + "px","important");

  if(list){
    list.style.setProperty("max-height",maxListHeight + "px","important");
  }
}

function diqV212SchedulePosition(){
  if(diqV212PositionTimer){ window.clearTimeout(diqV212PositionTimer); }
  diqV212PositionTimer = window.setTimeout(diqV212Position,20);
  window.setTimeout(diqV212Position,120);
  window.setTimeout(diqV212Position,320);
}

function diqV212Render(results,query){
  var panel = diqV212EnsurePanel();
  var list = byId("diqAdventureSearchResultsList");
  var stable;
  var i;
  var item;
  var btn;
  var name;
  var sub;
  var meta;

  if(!panel || !list){ return; }

  stable = diqV212Authority(results || [],query || "");
  diqV212Results = stable.slice(0);
  diqV212Query = clean(query || "");
  destinationSearchResults = stable.slice(0);

  list.innerHTML = "";

  if(!stable.length){
    btn = document.createElement("button");
    btn.type = "button";
    btn.className = "diqSearchResultRow";
    btn.innerHTML =
      '<div class="diqSearchResultName">No destination match yet</div>' +
      '<div class="diqSearchResultSub">Try a city, lake, park, beach, attraction, or business.</div>';
    list.appendChild(btn);
  }else{
    for(i=0;i<stable.length;i++){
      item = stable[i];
      btn = document.createElement("button");
      btn.type = "button";
      btn.className = "diqSearchResultRow";
      btn.setAttribute("data-v212-index",String(i));

      name = clean(item.label || "Destination");
      sub = clean(item.full || "");
      meta = diqV212Meta(item);

      btn.innerHTML =
        '<div class="diqSearchResultName">' + escapeHTML(name) + '</div>' +
        '<div class="diqSearchResultSub">' + escapeHTML(sub || "Tap to explore this destination") + '</div>' +
        '<div class="diqSearchResultMeta">' + escapeHTML(meta || "Destination") + '</div>';

      btn.onclick = function(){
        var idx = Number(this.getAttribute("data-v212-index"));
        if(idx >= 0 && diqV212Results[idx]){
          diqV212Hide();
          dismissAdventureKeyboard();
          routeDestinationResult(diqV212Results[idx]);
        }
      };

      list.appendChild(btn);
    }
  }

  diqV212HideLegacyAutocomplete();

  panel.className = "on";
  panel.setAttribute("aria-hidden","false");
  diqV212Open = true;
  destinationResultOpen = true;

  try{ document.body.classList.add("diqSearchChooserOpen"); }catch(e0){}

  diqV212SchedulePosition();
  updateClearAdventureSearchButton();
}

function diqV212InjectStyles(){
  var style;
  var css;

  if(byId("diqV212SearchPanelStyles")){ return; }

  css =
    "#diqAdventureSearchResults{" +
      "display:none!important;position:relative!important;" +
      "z-index:220!important;margin:7px 0 0!important;padding:0!important;" +
      "overflow:hidden!important;border-radius:16px!important;" +
      "background:transparent!important;" +
    "}" +
    "#diqAdventureSearchResults.ready.on{display:block!important;}" +

    "#diqAdventureSearchResults .diqSearchResultsHead{" +
      "position:sticky!important;top:0!important;z-index:3!important;" +
      "min-height:42px!important;padding:0 48px 0 13px!important;" +
      "display:flex!important;align-items:center!important;" +
      "border-radius:16px 16px 0 0!important;" +
      "background:linear-gradient(180deg,rgba(4,11,20,.995),rgba(4,11,20,.98))!important;" +
      "border:1px solid rgba(40,255,190,.30)!important;border-bottom:0!important;" +
      "color:#b6ffeb!important;font-size:10px!important;font-weight:1000!important;" +
      "letter-spacing:1.25px!important;" +
    "}" +

    "#diqSearchResultsClose{" +
      "position:absolute!important;top:5px!important;right:6px!important;" +
      "width:32px!important;height:32px!important;min-width:32px!important;" +
      "padding:0!important;border-radius:11px!important;" +
      "border:1px solid rgba(255,255,255,.15)!important;" +
      "background:rgba(255,255,255,.055)!important;" +
      "color:#fff!important;font-size:22px!important;line-height:1!important;" +
    "}" +

    "#diqAdventureSearchResultsList{" +
      "display:block!important;width:100%!important;margin:0!important;" +
      "padding:5px 6px 8px!important;overflow-y:auto!important;overflow-x:hidden!important;" +
      "-webkit-overflow-scrolling:touch!important;" +
      "background:linear-gradient(180deg,rgba(4,11,20,.985),rgba(2,8,16,.997))!important;" +
      "border:1px solid rgba(40,255,190,.30)!important;border-top:0!important;" +
      "border-radius:0 0 16px 16px!important;" +
      "box-shadow:0 18px 36px rgba(0,0,0,.48)!important;" +
    "}" +

    "#diqAdventureSearchResults .diqSearchResultRow{" +
      "display:block!important;width:100%!important;min-height:74px!important;" +
      "margin:5px 0!important;padding:11px 13px!important;" +
      "text-align:left!important;float:none!important;clear:both!important;" +
      "border-radius:14px!important;border:1px solid rgba(255,255,255,.11)!important;" +
      "background:linear-gradient(180deg,rgba(255,255,255,.055),rgba(255,255,255,.025))!important;" +
      "box-shadow:none!important;overflow:hidden!important;" +
    "}" +

    "#diqAdventureSearchResults .diqSearchResultName{" +
      "margin:0 0 4px!important;font-size:18px!important;line-height:1.08!important;" +
      "font-weight:900!important;color:#fff!important;white-space:nowrap!important;" +
      "overflow:hidden!important;text-overflow:ellipsis!important;" +
    "}" +

    "#diqAdventureSearchResults .diqSearchResultSub{" +
      "margin:0 0 6px!important;font-size:13px!important;line-height:1.2!important;" +
      "font-weight:650!important;color:rgba(255,255,255,.70)!important;" +
      "white-space:nowrap!important;overflow:hidden!important;text-overflow:ellipsis!important;" +
    "}" +

    "#diqAdventureSearchResults .diqSearchResultMeta{" +
      "font-size:10px!important;line-height:1!important;font-weight:1000!important;" +
      "letter-spacing:1.05px!important;text-transform:uppercase!important;" +
      "color:#ffe28b!important;white-space:nowrap!important;" +
      "overflow:hidden!important;text-overflow:ellipsis!important;" +
    "}" +

    "body.diqSearchChooserOpen #diqAdventureDestResults:not(.diqModeShelf){" +
      "display:none!important;" +
    "}" +

    "@media(max-height:700px){" +
      "#diqAdventureSearchResults .diqSearchResultRow{" +
        "min-height:66px!important;padding:9px 11px!important;" +
      "}" +
      "#diqAdventureSearchResults .diqSearchResultName{" +
        "font-size:17px!important;" +
      "}" +
    "}";

  style = document.createElement("style");
  style.id = "diqV212SearchPanelStyles";
  style.type = "text/css";
  style.appendChild(document.createTextNode(css));

  try{ document.head.appendChild(style); }catch(e0){}
}

/* Final autocomplete authority: use only the new dedicated panel. */
renderDestinationResults = function(results,query){
  diqV212Render(results || [],query || "");
};

/* Search close authority: do not touch scan shelf unless it is an old
   destination panel rather than an active scan-results shelf. */
hideDestinationResults = function(){
  diqV212Hide();

  var legacy = byId("diqAdventureDestResults");
  if(
    legacy &&
    String(legacy.className || "").indexOf("diqModeShelf") < 0
  ){
    legacy.className = "";
    legacy.setAttribute("aria-hidden","true");
  }

  destinationResultOpen = false;
  updateClearAdventureSearchButton();
};

function diqV212Bind(){
  var input = byId("adventureSearch");

  diqV212InjectStyles();
  diqV212EnsurePanel();

  if(input && input.getAttribute("data-v212-search-panel") !== "1"){
    input.setAttribute("data-v212-search-panel","1");

    input.addEventListener("focus",function(){
      diqV212HideLegacyAutocomplete();
      diqV212SchedulePosition();
    },false);

    input.addEventListener("input",function(){
      diqV212HideLegacyAutocomplete();
      diqV212SchedulePosition();
    },false);
  }

  window.addEventListener("resize",diqV212SchedulePosition,false);
  window.addEventListener("orientationchange",function(){
    window.setTimeout(diqV212SchedulePosition,180);
  },false);

  if(window.visualViewport && window.visualViewport.addEventListener){
    window.visualViewport.addEventListener("resize",diqV212SchedulePosition,false);
    window.visualViewport.addEventListener("scroll",diqV212SchedulePosition,false);
  }
}

if(document.readyState === "loading"){
  document.addEventListener("DOMContentLoaded",diqV212Bind,false);
}else{
  diqV212Bind();
}

window.setTimeout(diqV212Bind,350);
window.setTimeout(diqV212Bind,1000);

window.DRIVE_IQ_ADVENTURE_V212 = {
  build:"V212_SEPARATE_SEARCH_RESULTS_PANEL_AUTHORITY",
  authority:diqV212Authority,
  render:diqV212Render,
  hide:diqV212Hide
};

try{
  console.log("âœ… Drive IQ Adventure V212 Separate Search Panel loaded");
}catch(ePublic){}

}());


/* =========================================================
   DRIVE IQ ADVENTURE SEARCH V300
   SINGLE-OWNER DESTINATION SEARCH CONTROLLER

   This controller intentionally bypasses the accumulated destination-search
   wrapper chain. It owns input, fetching, filtering, rendering, selection,
   panel placement, and close behavior while the search field is active.

   Search = destination finder.
   Scan = district/place discovery.

   ES5 SAFE
========================================================= */
(function(){
"use strict";

if(window.__DRIVE_IQ_ADVENTURE_SEARCH_V300__){ return; }
window.__DRIVE_IQ_ADVENTURE_SEARCH_V300__ = true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD =
  "V300_SINGLE_OWNER_DESTINATION_SEARCH_CONTROLLER";

var V300 = {
  timer:null,
  token:0,
  query:"",
  results:[],
  open:false,
  bound:false
};

function v300Input(){
  return byId("adventureSearch");
}

function v300SearchWrap(){
  return document.querySelector(".searchWrap");
}

function v300Panel(){
  var panel = byId("diqV300SearchResults");
  var wrap = v300SearchWrap();

  if(!panel){
    panel = document.createElement("div");
    panel.id = "diqV300SearchResults";
    panel.setAttribute("aria-hidden","true");
    panel.innerHTML =
      '<div class="v300Head">' +
        '<span>CHOOSE DESTINATION</span>' +
        '<button type="button" id="diqV300SearchClose" aria-label="Close destination results">&times;</button>' +
      '</div>' +
      '<div id="diqV300SearchList"></div>';
  }

  if(wrap && wrap.parentNode){
    try{
      if(wrap.nextSibling !== panel){
        if(wrap.nextSibling){
          wrap.parentNode.insertBefore(panel,wrap.nextSibling);
        }else{
          wrap.parentNode.appendChild(panel);
        }
      }
    }catch(e0){}
  }else if(panel.parentNode !== document.body){
    try{ document.body.appendChild(panel); }catch(e1){}
  }

  var close = byId("diqV300SearchClose");
  if(close && close.getAttribute("data-bound") !== "1"){
    close.setAttribute("data-bound","1");
    close.onclick = function(event){
      if(event && event.preventDefault){ event.preventDefault(); }
      if(event && event.stopPropagation){ event.stopPropagation(); }
      v300Hide();
      try{
        var input = v300Input();
        if(input){ input.focus(); }
      }catch(e2){}
      return false;
    };
  }

  return panel;
}

function v300HideLegacy(){
  var legacy = byId("diqAdventureDestResults");
  var v212 = byId("diqAdventureSearchResults");

  try{ document.body.classList.add("diqV300SearchOwner"); }catch(e0){}

  if(legacy && String(legacy.className || "").indexOf("diqModeShelf") < 0){
    legacy.className = "";
    legacy.setAttribute("aria-hidden","true");
  }

  if(v212){
    v212.className = "";
    v212.setAttribute("aria-hidden","true");
  }
}

function v300Hide(){
  var panel = byId("diqV300SearchResults");

  V300.open = false;
  destinationResultOpen = false;

  if(panel){
    panel.className = "";
    panel.setAttribute("aria-hidden","true");
  }

  try{ document.body.classList.remove("diqV300ChooserOpen"); }catch(e0){}
  updateClearAdventureSearchButton();
}

function v300IsDistrict(item){
  return !!(
    item &&
    (
      item.entityType === "district" ||
      item.entityClass === "district" ||
      item.poiClass === "district" ||
      item.kind === "district" ||
      item.type === "district" ||
      item.districtId ||
      item.resultType === "adventure_district_registry" ||
      item.resultType === "entity_registry_district"
    )
  );
}

function v300ExplicitDistrict(query){
  var q = normText(query);

  return (
    q.indexOf("harborwalk") > -1 ||
    q.indexOf("destin commons") > -1 ||
    q.indexOf("beale street") > -1 ||
    q.indexOf("silo square") > -1 ||
    q.indexOf("disney springs") > -1 ||
    q.indexOf("the wharf") > -1 ||
    q.indexOf("broadway nashville") > -1 ||
    q.indexOf(" district") > -1
  );
}

function v300Bad(item){
  var txt = normText(
    String(item && item.label || "") + " " +
    String(item && item.full || "") + " " +
    String(item && item.kind || "") + " " +
    String(item && item.category || "") + " " +
    String(item && item.resultType || "")
  );

  if(
    txt.indexOf("county meath") > -1 ||
    txt.indexOf("ireland") > -1 ||
    txt.indexOf("karakocan") > -1 ||
    txt.indexOf("eastern anatolia") > -1 ||
    txt.indexOf("turkey") > -1 ||
    txt.indexOf("hotel") > -1 ||
    txt.indexOf("motel") > -1 ||
    txt.indexOf("hospital") > -1 ||
    txt.indexOf("emergency") > -1
  ){
    return true;
  }

  if(finite(Number(item && item.distMiles)) && Number(item.distMiles) > 1200){
    return true;
  }

  return false;
}

function v300CityArea(item){
  var txt = normText(
    String(item && item.kind || "") + " " +
    String(item && item.category || "") + " " +
    String(item && item.resultType || "") + " " +
    String(item && item.full || "")
  );

  return !!(
    item &&
    (
      item.canonical === true ||
      item.resultType === "adventure_index" ||
      txt.indexOf("city") > -1 ||
      txt.indexOf("town") > -1 ||
      txt.indexOf("locality") > -1 ||
      txt.indexOf("municipality") > -1 ||
      txt.indexOf("region") > -1 ||
      txt.indexOf("beach") > -1 ||
      txt.indexOf("lake") > -1 ||
      txt.indexOf("park") > -1 ||
      txt.indexOf("attraction") > -1 ||
      txt.indexOf("business") > -1 ||
      txt.indexOf("commercial") > -1
    )
  );
}

function v300Key(item){
  return normText(
    String(item && item.resultType || "") + "|" +
    String(item && item.adventureIndexId || item.districtId || "") + "|" +
    String(item && item.label || "") + "|" +
    String(item && item.full || "") + "|" +
    String(item && item.lat || "") + "|" +
    String(item && item.lng || "")
  );
}

function v300Rank(a,b,query){
  var q = normText(query);
  var sa = 0;
  var sb = 0;
  var la = normText(a && a.label || "");
  var lb = normText(b && b.label || "");
  var ta = normText(String(a && a.label || "") + " " + String(a && a.full || ""));
  var tb = normText(String(b && b.label || "") + " " + String(b && b.full || ""));

  if(a && (a.canonical || a.resultType === "adventure_index")){ sa += 2000; }
  if(b && (b.canonical || b.resultType === "adventure_index")){ sb += 2000; }

  if(la === q){ sa += 1200; }
  if(lb === q){ sb += 1200; }

  if(ta.indexOf(q) > -1){ sa += 600; }
  if(tb.indexOf(q) > -1){ sb += 600; }

  if(v300IsDistrict(a)){ sa -= 250; }
  if(v300IsDistrict(b)){ sb -= 250; }

  return sb - sa;
}

function v300Authority(items,query){
  var q = clean(query);
  var explicitDistrict = v300ExplicitDistrict(q);
  var source = (items || []).slice(0);
  var canonical = null;
  var out = [];
  var seen = {};
  var cities = [];
  var districts = [];
  var i;
  var item;

  try{
    var indexed = adventureDestinationIndexMatch(q);
    if(indexed){ canonical = indexedAdventureItem(indexed); }
  }catch(e0){}

  function add(candidate){
    var key;
    if(!candidate){ return; }
    key = v300Key(candidate);
    if(seen[key]){ return; }
    seen[key] = true;
    out.push(candidate);
  }

  if(canonical){ add(canonical); }

  if(explicitDistrict && typeof diqV108EntityQueryResults === "function"){
    try{
      source = diqV108EntityQueryResults(q).concat(source);
    }catch(e1){}
  }

  for(i=0;i<source.length;i++){
    item = source[i];
    if(!item || v300Bad(item)){ continue; }

    if(v300IsDistrict(item)){
      if(explicitDistrict){ districts.push(item); }
      continue;
    }

    if(v300CityArea(item)){ cities.push(item); }
  }

  cities.sort(function(a,b){ return v300Rank(a,b,q); });
  districts.sort(function(a,b){ return v300Rank(a,b,q); });

  for(i=0;i<cities.length && out.length<4;i++){ add(cities[i]); }

  if(explicitDistrict){
    for(i=0;i<districts.length && out.length<4;i++){ add(districts[i]); }
  }

  return out.slice(0,4);
}

function v300Meta(item){
  var parts = [];

  if(item && finite(Number(item.distMiles))){
    parts.push(itemDistanceText(item));
  }

  if(item && item.resultType === "adventure_index"){
    parts.push("Adventure Region");
  }else if(v300IsDistrict(item)){
    parts.push("District");
  }else if(item && item.kind){
    parts.push(titleCaseWords(String(item.kind).replace(/_/g," ")));
  }else{
    parts.push("Destination");
  }

  return parts.join(" â€¢ ");
}

function v300Render(items,query){
  var panel = v300Panel();
  var list = byId("diqV300SearchList");
  var stable = v300Authority(items || [],query || "");
  var i;
  var item;
  var btn;

  if(!panel || !list){ return; }

  V300.results = stable.slice(0);
  V300.query = clean(query || "");
  destinationSearchResults = stable.slice(0);

  list.innerHTML = "";

  if(!stable.length){
    btn = document.createElement("button");
    btn.type = "button";
    btn.className = "v300Row";
    btn.innerHTML =
      '<div class="v300Name">No destination match yet</div>' +
      '<div class="v300Sub">Try a city, lake, park, beach, attraction, address, or business.</div>';
    list.appendChild(btn);
  }else{
    for(i=0;i<stable.length;i++){
      item = stable[i];
      btn = document.createElement("button");
      btn.type = "button";
      btn.className = "v300Row";
      btn.setAttribute("data-v300-index",String(i));
      btn.innerHTML =
        '<div class="v300Name">' + escapeHTML(clean(item.label || "Destination")) + '</div>' +
        '<div class="v300Sub">' + escapeHTML(clean(item.full || "Tap to explore this destination")) + '</div>' +
        '<div class="v300Meta">' + escapeHTML(v300Meta(item)) + '</div>';

      btn.onclick = function(){
        var idx = Number(this.getAttribute("data-v300-index"));
        if(idx >= 0 && V300.results[idx]){
          v300Hide();
          dismissAdventureKeyboard();
          routeDestinationResult(V300.results[idx]);
        }
      };

      list.appendChild(btn);
    }
  }

  v300HideLegacy();

  panel.className = "on";
  panel.setAttribute("aria-hidden","false");
  V300.open = true;
  destinationResultOpen = true;

  try{ document.body.classList.add("diqV300ChooserOpen"); }catch(e2){}
  updateClearAdventureSearchButton();
}

function v300Fetch(query){
  var q = clean(query);
  var myToken;
  var urls = [];
  var all = [];
  var pending = 0;

  if(!q || q.length < 2){
    V300.token += 1;
    v300Hide();
    return;
  }

  V300.token += 1;
  myToken = V300.token;

  try{
    var indexed = adventureDestinationIndexMatch(q);
    if(indexed){
      all.push(indexedAdventureItem(indexed));
      v300Render(all,q);
    }
  }catch(e0){}

  if(!GEOAPIFY_KEY){
    v300Render(all,q);
    return;
  }

  try{
    urls.push(geoUrl(q,"autocomplete",10));
    urls.push(geoUrl(q,"search",10));
  }catch(e1){
    v300Render(all,q);
    return;
  }

  function finish(){
    if(pending > 0 || myToken !== V300.token){ return; }

    try{ all = dedupe(all); }catch(e2){}
    v300Render(all,q);
  }

  function fetchOne(url){
    pending += 1;

    try{
      fetch(url)
        .then(function(response){ return response.json(); })
        .then(function(data){
          var features = data && data.features ? data.features : [];
          var i;
          var item;

          for(i=0;i<features.length;i++){
            item = normalizeFeature(features[i],q);
            if(item){ all.push(item); }
          }

          pending -= 1;
          finish();
        })
        .catch(function(){
          pending -= 1;
          finish();
        });
    }catch(e3){
      pending -= 1;
      finish();
    }
  }

  fetchOne(urls[0]);
  fetchOne(urls[1]);
}

function v300Queue(query){
  if(V300.timer){ window.clearTimeout(V300.timer); }

  V300.timer = window.setTimeout(function(){
    v300Fetch(query);
  },160);
}

function v300InjectStyles(){
  var style;
  var css;

  if(byId("diqV300SearchStyles")){ return; }

  css =
    ".searchWrap{position:relative!important;}" +

    "#diqV300SearchResults{" +
      "display:none!important;position:absolute!important;" +
      "left:0!important;right:0!important;top:calc(100% + 8px)!important;" +
      "width:auto!important;max-width:none!important;margin:0!important;" +
      "z-index:10000!important;overflow:hidden!important;border-radius:16px!important;" +
      "background:transparent!important;" +
    "}" +
    "#diqV300SearchResults.on{display:block!important;}" +

    "#diqV300SearchResults .v300Head{" +
      "position:relative!important;min-height:42px!important;padding:0 48px 0 13px!important;" +
      "display:flex!important;align-items:center!important;" +
      "border-radius:16px 16px 0 0!important;" +
      "background:rgba(4,11,20,.995)!important;" +
      "border:1px solid rgba(40,255,190,.32)!important;border-bottom:0!important;" +
      "color:#b6ffeb!important;font-size:10px!important;font-weight:1000!important;" +
      "letter-spacing:1.25px!important;" +
    "}" +

    "#diqV300SearchClose{" +
      "position:absolute!important;right:6px!important;top:5px!important;" +
      "width:32px!important;height:32px!important;min-width:32px!important;" +
      "padding:0!important;border-radius:11px!important;" +
      "border:1px solid rgba(255,255,255,.15)!important;" +
      "background:rgba(255,255,255,.06)!important;color:#fff!important;" +
      "font-size:22px!important;line-height:1!important;" +
    "}" +

    "#diqV300SearchList{" +
      "display:block!important;max-height:min(250px,calc(100dvh - 270px))!important;" +
      "overflow-y:auto!important;overflow-x:hidden!important;" +
      "-webkit-overflow-scrolling:touch!important;" +
      "padding:5px 6px 8px!important;margin:0!important;" +
      "background:rgba(2,8,16,.995)!important;" +
      "border:1px solid rgba(40,255,190,.32)!important;border-top:0!important;" +
      "border-radius:0 0 16px 16px!important;" +
      "box-shadow:0 18px 36px rgba(0,0,0,.52)!important;" +
    "}" +

    "#diqV300SearchResults .v300Row{" +
      "display:block!important;width:100%!important;min-height:70px!important;" +
      "margin:5px 0!important;padding:10px 12px!important;" +
      "text-align:left!important;float:none!important;clear:both!important;" +
      "border-radius:14px!important;border:1px solid rgba(255,255,255,.11)!important;" +
      "background:linear-gradient(180deg,rgba(255,255,255,.055),rgba(255,255,255,.025))!important;" +
      "color:#fff!important;overflow:hidden!important;box-shadow:none!important;" +
    "}" +

    "#diqV300SearchResults .v300Name{" +
      "font-size:18px!important;line-height:1.08!important;font-weight:900!important;" +
      "white-space:nowrap!important;overflow:hidden!important;text-overflow:ellipsis!important;" +
    "}" +

    "#diqV300SearchResults .v300Sub{" +
      "margin-top:4px!important;font-size:13px!important;line-height:1.2!important;" +
      "font-weight:650!important;color:rgba(255,255,255,.70)!important;" +
      "white-space:nowrap!important;overflow:hidden!important;text-overflow:ellipsis!important;" +
    "}" +

    "#diqV300SearchResults .v300Meta{" +
      "margin-top:6px!important;font-size:10px!important;line-height:1!important;" +
      "font-weight:1000!important;letter-spacing:1px!important;text-transform:uppercase!important;" +
      "color:#ffe28b!important;white-space:nowrap!important;" +
      "overflow:hidden!important;text-overflow:ellipsis!important;" +
    "}" +

    "body.diqV300SearchOwner #diqAdventureSearchResults," +
    "body.diqV300SearchOwner #diqAdventureDestResults:not(.diqModeShelf){" +
      "display:none!important;" +
    "}";

  style = document.createElement("style");
  style.id = "diqV300SearchStyles";
  style.type = "text/css";
  style.appendChild(document.createTextNode(css));

  try{ document.head.appendChild(style); }catch(e0){}
}

function v300Bind(){
  var input = v300Input();

  if(!input || V300.bound){ return; }

  V300.bound = true;
  v300InjectStyles();
  v300Panel();
  v300HideLegacy();

  input.addEventListener("input",function(event){
    if(event && event.stopImmediatePropagation){ event.stopImmediatePropagation(); }

    var q = clean(input.value);

    if(destinationLock && !destinationLockMatchesInput(q)){
      clearDestinationLock();
    }

    v300HideLegacy();
    v300Queue(q);
  },true);

  input.addEventListener("focus",function(event){
    if(event && event.stopImmediatePropagation){ event.stopImmediatePropagation(); }

    var q = clean(input.value);
    v300HideLegacy();

    if(q.length >= 2){
      v300Queue(q);
    }
  },true);

  input.addEventListener("keydown",function(event){
    if(!event){ return; }

    if(event.key === "Escape"){
      event.preventDefault();
      event.stopImmediatePropagation();
      v300Hide();
      return;
    }

    if(event.key === "Enter" && V300.open && V300.results.length){
      event.preventDefault();
      event.stopImmediatePropagation();
      v300Hide();
      dismissAdventureKeyboard();
      routeDestinationResult(V300.results[0]);
    }
  },true);

  document.addEventListener("pointerdown",function(event){
    var panel = byId("diqV300SearchResults");
    var wrap = v300SearchWrap();

    if(!V300.open || !panel || !wrap){ return; }

    if(!panel.contains(event.target) && !wrap.contains(event.target)){
      v300Hide();
    }
  },true);
}

if(document.readyState === "loading"){
  document.addEventListener("DOMContentLoaded",v300Bind,false);
}else{
  v300Bind();
}

window.setTimeout(v300Bind,300);
window.setTimeout(v300Bind,900);
window.setTimeout(v300Bind,1800);

window.DRIVE_IQ_ADVENTURE_SEARCH_V300 = {
  build:"V300_SINGLE_OWNER_DESTINATION_SEARCH_CONTROLLER",
  search:v300Fetch,
  hide:v300Hide,
  results:function(){ return V300.results.slice(0); }
};

try{
  console.log("âœ… Drive IQ Adventure Search V300 single-owner controller loaded");
}catch(ePublic){}

}());


/* =========================================================
   DRIVE IQ ADVENTURE SEARCH V301
   LARGE SCROLLABLE COMBINED CHOOSER

   Keeps the current combined result behavior, but makes the active chooser
   large enough to show city and district results together with internal
   scrolling instead of clipping or replacing visible rows.
   ES5 SAFE
========================================================= */
(function(){
"use strict";

if(window.__DRIVE_IQ_ADVENTURE_SEARCH_V301_LARGE_CHOOSER__){ return; }
window.__DRIVE_IQ_ADVENTURE_SEARCH_V301_LARGE_CHOOSER__ = true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD =
  "V301_LARGE_SCROLLABLE_COMBINED_CHOOSER";

var v301Observer = null;
var v301Timer = null;

function v301ActivePanel(){
  var legacy = byId("diqAdventureDestResults");
  var v300 = byId("diqV300SearchResults");

  if(legacy && (
    String(legacy.className || "").indexOf("on") > -1 ||
    legacy.getAttribute("aria-hidden") === "false"
  )){
    return legacy;
  }

  if(v300 && (
    String(v300.className || "").indexOf("on") > -1 ||
    v300.getAttribute("aria-hidden") === "false"
  )){
    return v300;
  }

  return legacy || v300;
}

function v301Position(){
  var panel = v301ActivePanel();
  var list;
  var viewport = window.visualViewport;
  var width;
  var height;
  var offsetTop;
  var safeTop;
  var safeBottom;
  var maxHeight;

  if(!panel){ return; }

  width = viewport && finite(Number(viewport.width))
    ? Number(viewport.width)
    : window.innerWidth;

  height = viewport && finite(Number(viewport.height))
    ? Number(viewport.height)
    : window.innerHeight;

  offsetTop = viewport && finite(Number(viewport.offsetTop))
    ? Number(viewport.offsetTop)
    : 0;

  safeTop = offsetTop + 86;
  safeBottom = 12;
  maxHeight = Math.max(260,height - 98);

  panel.style.setProperty("position","fixed","important");
  panel.style.setProperty("top",Math.round(safeTop) + "px","important");
  panel.style.setProperty("left","12px","important");
  panel.style.setProperty("right","12px","important");
  panel.style.setProperty("bottom","auto","important");
  panel.style.setProperty("width","auto","important");
  panel.style.setProperty("max-width","none","important");
  panel.style.setProperty("height","auto","important");
  panel.style.setProperty("max-height",Math.round(maxHeight) + "px","important");
  panel.style.setProperty("margin","0","important");
  panel.style.setProperty("transform","none","important");
  panel.style.setProperty("overflow","hidden","important");
  panel.style.setProperty("z-index","20000","important");

  list =
    panel.querySelector("#diqDestList") ||
    panel.querySelector("#diqV300SearchList") ||
    panel.querySelector("#diqAdventureSearchResultsList");

  if(list){
    list.style.setProperty(
      "max-height",
      Math.max(190,Math.round(maxHeight - 48)) + "px",
      "important"
    );
    list.style.setProperty("overflow-y","auto","important");
    list.style.setProperty("overflow-x","hidden","important");
    list.style.setProperty("-webkit-overflow-scrolling","touch","important");
  }
}

function v301Schedule(){
  if(v301Timer){ window.clearTimeout(v301Timer); }
  v301Timer = window.setTimeout(v301Position,20);
  window.setTimeout(v301Position,120);
  window.setTimeout(v301Position,320);
}

function v301InjectStyles(){
  var style;
  var css;

  if(byId("diqV301LargeChooserStyles")){ return; }

  css =
    "#diqAdventureDestResults.on," +
    "#diqAdventureDestResults[aria-hidden='false']," +
    "#diqV300SearchResults.on," +
    "#diqV300SearchResults[aria-hidden='false']{" +
      "position:fixed!important;" +
      "top:86px!important;" +
      "left:12px!important;" +
      "right:12px!important;" +
      "bottom:auto!important;" +
      "width:auto!important;" +
      "max-width:none!important;" +
      "height:auto!important;" +
      "max-height:calc(100dvh - 98px)!important;" +
      "margin:0!important;" +
      "transform:none!important;" +
      "overflow:hidden!important;" +
      "z-index:20000!important;" +
      "border-radius:18px!important;" +
      "box-shadow:0 24px 60px rgba(0,0,0,.62)!important;" +
    "}" +

    "#diqAdventureDestResults.on #diqDestList," +
    "#diqAdventureDestResults[aria-hidden='false'] #diqDestList," +
    "#diqV300SearchResults.on #diqV300SearchList," +
    "#diqV300SearchResults[aria-hidden='false'] #diqV300SearchList{" +
      "max-height:calc(100dvh - 146px)!important;" +
      "overflow-y:auto!important;" +
      "overflow-x:hidden!important;" +
      "-webkit-overflow-scrolling:touch!important;" +
      "overscroll-behavior:contain!important;" +
      "padding-bottom:18px!important;" +
    "}" +

    "#diqAdventureDestResults .diqDestHead," +
    "#diqV300SearchResults .v300Head{" +
      "position:sticky!important;" +
      "top:0!important;" +
      "z-index:10!important;" +
    "}" +

    "#diqAdventureDestResults .diqDestItem{" +
      "width:100%!important;" +
      "max-width:none!important;" +
      "margin:8px 0!important;" +
    "}" +

    "@media(max-height:700px){" +
      "#diqAdventureDestResults.on," +
      "#diqAdventureDestResults[aria-hidden='false']," +
      "#diqV300SearchResults.on," +
      "#diqV300SearchResults[aria-hidden='false']{" +
        "top:72px!important;" +
        "max-height:calc(100dvh - 84px)!important;" +
      "}" +
      "#diqAdventureDestResults.on #diqDestList," +
      "#diqAdventureDestResults[aria-hidden='false'] #diqDestList," +
      "#diqV300SearchResults.on #diqV300SearchList," +
      "#diqV300SearchResults[aria-hidden='false'] #diqV300SearchList{" +
        "max-height:calc(100dvh - 132px)!important;" +
      "}" +
    "}";

  style = document.createElement("style");
  style.id = "diqV301LargeChooserStyles";
  style.type = "text/css";
  style.appendChild(document.createTextNode(css));

  try{ document.head.appendChild(style); }catch(e0){}
}

function v301Observe(){
  var targets = [
    byId("diqAdventureDestResults"),
    byId("diqV300SearchResults")
  ];
  var i;

  if(v301Observer){ return; }

  try{
    v301Observer = new MutationObserver(function(){
      v301Schedule();
    });

    for(i=0;i<targets.length;i++){
      if(targets[i]){
        v301Observer.observe(targets[i],{
          attributes:true,
          childList:true,
          subtree:true
        });
      }
    }
  }catch(e0){}
}

function v301Bind(){
  v301InjectStyles();
  /* V514: v301Observe retired to prevent attribute/style feedback loops. */
  v301Schedule();

  window.addEventListener("resize",v301Schedule,false);
  window.addEventListener("orientationchange",function(){
    window.setTimeout(v301Schedule,180);
  },false);

  if(window.visualViewport && window.visualViewport.addEventListener){
    window.visualViewport.addEventListener("resize",v301Schedule,false);
    window.visualViewport.addEventListener("scroll",v301Schedule,false);
  }
}

if(document.readyState === "loading"){
  document.addEventListener("DOMContentLoaded",v301Bind,false);
}else{
  v301Bind();
}

window.setTimeout(v301Bind,350);
window.setTimeout(v301Bind,1000);

window.DRIVE_IQ_ADVENTURE_SEARCH_V301 = {
  build:"V301_LARGE_SCROLLABLE_COMBINED_CHOOSER",
  position:v301Position
};

try{
  console.log("âœ… Drive IQ Adventure Search V301 large scrollable chooser loaded");
}catch(ePublic){}

}());


/* =========================================================
   DRIVE IQ ADVENTURE SEARCH V302
   TRUE SAFE-AREA + FLEX SCROLL CHOOSER

   Fixes V301:
   - Never sits under the iPhone status bar / Dynamic Island
   - Uses the live visual viewport instead of a hard-coded top
   - Panel becomes a flex column
   - Header stays fixed
   - Result list owns scrolling
   - Final row can scroll fully into view above the keyboard
   ES5 SAFE
========================================================= */
(function(){
"use strict";

if(window.__DRIVE_IQ_ADVENTURE_SEARCH_V302_SAFE_FLEX_CHOOSER__){ return; }
window.__DRIVE_IQ_ADVENTURE_SEARCH_V302_SAFE_FLEX_CHOOSER__ = true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD =
  "V302_TRUE_SAFE_AREA_FLEX_SCROLL_CHOOSER";

var v302Timer = null;

function v302ActivePanel(){
  var legacy = byId("diqAdventureDestResults");
  var v300 = byId("diqV300SearchResults");

  if(legacy && (
    String(legacy.className || "").indexOf("on") > -1 ||
    legacy.getAttribute("aria-hidden") === "false"
  )){
    return legacy;
  }

  if(v300 && (
    String(v300.className || "").indexOf("on") > -1 ||
    v300.getAttribute("aria-hidden") === "false"
  )){
    return v300;
  }

  return null;
}

function v302Position(){
  var panel = v302ActivePanel();
  var viewport = window.visualViewport;
  var viewportHeight;
  var viewportTop;
  var top;
  var bottomGap = 12;
  var available;
  var list;
  var header;

  if(!panel){ return; }

  viewportHeight = viewport && finite(Number(viewport.height))
    ? Number(viewport.height)
    : window.innerHeight;

  viewportTop = viewport && finite(Number(viewport.offsetTop))
    ? Number(viewport.offsetTop)
    : 0;

  /*
    112px keeps the chooser below the status bar / Dynamic Island on
    modern iPhones while still leaving enough room above the keyboard.
  */
  top = viewportTop + 112;
  available = Math.max(260, viewportHeight - 124);

  panel.style.setProperty("position","fixed","important");
  panel.style.setProperty("top",Math.round(top) + "px","important");
  panel.style.setProperty("left","12px","important");
  panel.style.setProperty("right","12px","important");
  panel.style.setProperty("bottom","auto","important");
  panel.style.setProperty("width","auto","important");
  panel.style.setProperty("max-width","none","important");
  panel.style.setProperty("height",Math.round(available) + "px","important");
  panel.style.setProperty("max-height",Math.round(available) + "px","important");
  panel.style.setProperty("margin","0","important");
  panel.style.setProperty("transform","none","important");
  panel.style.setProperty("overflow","hidden","important");
  panel.style.setProperty("display","flex","important");
  panel.style.setProperty("flex-direction","column","important");
  panel.style.setProperty("z-index","22000","important");

  header =
    panel.querySelector(".diqDestHead") ||
    panel.querySelector(".v300Head") ||
    panel.querySelector(".diqSearchResultsHead");

  if(header){
    header.style.setProperty("flex","0 0 auto","important");
    header.style.setProperty("position","relative","important");
    header.style.setProperty("top","auto","important");
  }

  list =
    panel.querySelector("#diqDestList") ||
    panel.querySelector("#diqV300SearchList") ||
    panel.querySelector("#diqAdventureSearchResultsList");

  if(list){
    list.style.setProperty("flex","1 1 auto","important");
    list.style.setProperty("min-height","0","important");
    list.style.setProperty("max-height","none","important");
    list.style.setProperty("height","auto","important");
    list.style.setProperty("overflow-y","auto","important");
    list.style.setProperty("overflow-x","hidden","important");
    list.style.setProperty("-webkit-overflow-scrolling","touch","important");
    list.style.setProperty("overscroll-behavior","contain","important");
    list.style.setProperty("padding-bottom","34px","important");
    list.style.setProperty("scroll-padding-bottom","34px","important");
  }
}

function v302Schedule(){
  if(v302Timer){ window.clearTimeout(v302Timer); }
  v302Timer = window.setTimeout(v302Position,20);
  window.setTimeout(v302Position,100);
  window.setTimeout(v302Position,280);
}

function v302InjectStyles(){
  var style;
  var css;

  if(byId("diqV302SafeFlexStyles")){ return; }

  css =
    "#diqAdventureDestResults.on," +
    "#diqAdventureDestResults[aria-hidden='false']," +
    "#diqV300SearchResults.on," +
    "#diqV300SearchResults[aria-hidden='false']{" +
      "position:fixed!important;" +
      "top:112px!important;" +
      "left:12px!important;" +
      "right:12px!important;" +
      "bottom:auto!important;" +
      "width:auto!important;" +
      "max-width:none!important;" +
      "height:calc(100dvh - 124px)!important;" +
      "max-height:calc(100dvh - 124px)!important;" +
      "margin:0!important;" +
      "transform:none!important;" +
      "overflow:hidden!important;" +
      "display:flex!important;" +
      "flex-direction:column!important;" +
      "z-index:22000!important;" +
      "border-radius:18px!important;" +
      "box-shadow:0 24px 60px rgba(0,0,0,.64)!important;" +
    "}" +

    "#diqAdventureDestResults .diqDestHead," +
    "#diqV300SearchResults .v300Head{" +
      "position:relative!important;" +
      "top:auto!important;" +
      "flex:0 0 auto!important;" +
      "z-index:10!important;" +
    "}" +

    "#diqAdventureDestResults #diqDestList," +
    "#diqV300SearchResults #diqV300SearchList{" +
      "flex:1 1 auto!important;" +
      "min-height:0!important;" +
      "height:auto!important;" +
      "max-height:none!important;" +
      "overflow-y:auto!important;" +
      "overflow-x:hidden!important;" +
      "-webkit-overflow-scrolling:touch!important;" +
      "overscroll-behavior:contain!important;" +
      "padding-bottom:34px!important;" +
      "scroll-padding-bottom:34px!important;" +
    "}" +

    "#diqAdventureDestResults .diqDestItem," +
    "#diqV300SearchResults .v300Row{" +
      "width:100%!important;" +
      "max-width:none!important;" +
      "margin:8px 0!important;" +
      "flex:0 0 auto!important;" +
    "}";

  style = document.createElement("style");
  style.id = "diqV302SafeFlexStyles";
  style.type = "text/css";
  style.appendChild(document.createTextNode(css));

  try{ document.head.appendChild(style); }catch(e0){}
}

function v302Bind(){
  v302InjectStyles();
  v302Schedule();

  window.addEventListener("resize",v302Schedule,false);
  window.addEventListener("orientationchange",function(){
    window.setTimeout(v302Schedule,180);
  },false);

  if(window.visualViewport && window.visualViewport.addEventListener){
    window.visualViewport.addEventListener("resize",v302Schedule,false);
    window.visualViewport.addEventListener("scroll",v302Schedule,false);
  }

  /* V514: retired V302 subtree observer. Resize/orientation scheduling remains,
     but result DOM mutations no longer trigger recursive style writes. */
}

if(document.readyState === "loading"){
  document.addEventListener("DOMContentLoaded",v302Bind,false);
}else{
  v302Bind();
}

window.setTimeout(v302Bind,350);
window.setTimeout(v302Bind,1000);

window.DRIVE_IQ_ADVENTURE_SEARCH_V302 = {
  build:"V302_TRUE_SAFE_AREA_FLEX_SCROLL_CHOOSER",
  position:v302Position
};

try{
  console.log("âœ… Drive IQ Adventure Search V302 safe flex chooser loaded");
}catch(ePublic){}

}());


/* =========================================================
   DRIVE IQ ADVENTURE MODE V305
   UI POLISH SPRINT 1 â€” PREMIUM RESULTS SHEET

   Presentation-only authority:
   - Keeps the scan-results drawer centered and full-width
   - Prevents the narrow left-column collapse
   - Uses one vertically scrollable results sheet
   - Gives titles, photos, copy, and chips consistent room
   - Preserves map-first mode, scan logic, ranking, pins, and routing
   ES5 SAFE
========================================================= */
(function(){
"use strict";

if(window.__DRIVE_IQ_ADVENTURE_V305_RESULTS_SHEET_POLISH__){ return; }
window.__DRIVE_IQ_ADVENTURE_V305_RESULTS_SHEET_POLISH__ = true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD =
  "V305_UI_POLISH_PREMIUM_RESULTS_SHEET";

var diqV305Observer = null;
var diqV305Timer = null;

function diqV305Panel(){
  return byId("diqAdventureDestResults");
}

function diqV305IsScanShelf(panel){
  return !!(
    panel &&
    document.body &&
    String(document.body.className || "").indexOf("adventureScanResultsMode") > -1 &&
    String(panel.className || "").indexOf("on") > -1
  );
}

function diqV305Apply(){
  var panel = diqV305Panel();
  var list;
  var head;

  if(!diqV305IsScanShelf(panel)){ return; }

  panel.className = String(panel.className || "")
    .replace(/\bdiqModeDestination\b/g,"")
    .replace(/\s+/g," ")
    .trim();

  if(String(panel.className || "").indexOf("diqModeShelf") < 0){
    panel.className = clean(String(panel.className || "") + " diqModeShelf");
  }

  panel.style.setProperty("position","fixed","important");
  panel.style.setProperty("left","18px","important");
  panel.style.setProperty("right","18px","important");
  panel.style.setProperty("top","auto","important");
  panel.style.setProperty(
    "bottom",
    "calc(112px + env(safe-area-inset-bottom,0px))",
    "important"
  );
  panel.style.setProperty("width","auto","important");
  panel.style.setProperty("max-width","none","important");
  panel.style.setProperty("height","auto","important");
  panel.style.setProperty("max-height","52vh","important");
  panel.style.setProperty("margin","0","important");
  panel.style.setProperty("transform","none","important");
  panel.style.setProperty("overflow","hidden","important");
  panel.style.setProperty("display","flex","important");
  panel.style.setProperty("flex-direction","column","important");
  panel.style.setProperty("z-index","180","important");

  head = panel.querySelector(".diqDestHead");
  if(head){
    head.style.setProperty("flex","0 0 auto","important");
  }

  list = panel.querySelector("#diqDestList");
  if(list){
    list.style.setProperty("display","block","important");
    list.style.setProperty("flex","1 1 auto","important");
    list.style.setProperty("min-height","0","important");
    list.style.setProperty("width","100%","important");
    list.style.setProperty("height","auto","important");
    list.style.setProperty("max-height","calc(52vh - 54px)","important");
    list.style.setProperty("overflow-y","auto","important");
    list.style.setProperty("overflow-x","hidden","important");
    list.style.setProperty("-webkit-overflow-scrolling","touch","important");
    list.style.setProperty("scroll-snap-type","none","important");
    list.style.setProperty("touch-action","pan-y","important");
  }

  panel.setAttribute("data-diq-v305-sheet","1");
}

function diqV305Schedule(){
  if(diqV305Timer){ window.clearTimeout(diqV305Timer); }
  diqV305Timer = window.setTimeout(diqV305Apply,10);
  window.setTimeout(diqV305Apply,80);
  window.setTimeout(diqV305Apply,220);
}

function diqV305InjectStyles(){
  var style;
  var css;

  if(byId("diqV305ResultsSheetStyles")){ return; }

  css =
    "body.adventureScanResultsMode #diqAdventureDestResults.diqModeShelf.on," +
    "body.adventureScanResultsMode #diqAdventureDestResults.on{" +
      "position:fixed!important;" +
      "left:18px!important;" +
      "right:18px!important;" +
      "top:auto!important;" +
      "bottom:calc(112px + env(safe-area-inset-bottom,0px))!important;" +
      "inset:auto 18px calc(112px + env(safe-area-inset-bottom,0px)) 18px!important;" +
      "width:auto!important;" +
      "max-width:none!important;" +
      "height:auto!important;" +
      "max-height:52vh!important;" +
      "margin:0!important;" +
      "padding:0!important;" +
      "display:flex!important;" +
      "flex-direction:column!important;" +
      "transform:none!important;" +
      "overflow:hidden!important;" +
      "border-radius:24px!important;" +
      "background:linear-gradient(180deg,rgba(3,10,19,.985),rgba(2,8,16,.995))!important;" +
      "border:1px solid rgba(40,255,190,.32)!important;" +
      "box-shadow:0 26px 64px rgba(0,0,0,.66),0 0 34px rgba(40,255,190,.08)!important;" +
      "z-index:180!important;" +
    "}" +

    "body.adventureScanResultsMode #diqAdventureDestResults .diqDestHead{" +
      "position:relative!important;" +
      "flex:0 0 auto!important;" +
      "min-height:54px!important;" +
      "padding:0 58px 0 18px!important;" +
      "display:flex!important;" +
      "align-items:center!important;" +
      "border-radius:24px 24px 0 0!important;" +
      "background:linear-gradient(180deg,rgba(5,14,24,.995),rgba(4,11,20,.97))!important;" +
      "border:0!important;" +
      "border-bottom:1px solid rgba(255,255,255,.08)!important;" +
      "font-size:11px!important;" +
      "font-weight:1000!important;" +
      "letter-spacing:1.4px!important;" +
      "line-height:1.1!important;" +
      "color:#b6ffeb!important;" +
    "}" +

    "body.adventureScanResultsMode #diqAdventureDestResults .diqDestHead:after{" +
      "content:'  â€¢  MAP IS THE HERO'!important;" +
      "color:#ffe4a2!important;" +
      "margin-left:8px!important;" +
    "}" +

    "body.adventureScanResultsMode #diqAdventureDestResults #diqDestClose{" +
      "position:absolute!important;" +
      "top:8px!important;" +
      "right:9px!important;" +
      "width:38px!important;" +
      "height:38px!important;" +
      "min-width:38px!important;" +
      "border-radius:13px!important;" +
      "font-size:24px!important;" +
    "}" +

    "body.adventureScanResultsMode #diqAdventureDestResults #diqDestList{" +
      "display:block!important;" +
      "flex:1 1 auto!important;" +
      "min-height:0!important;" +
      "width:100%!important;" +
      "height:auto!important;" +
      "max-height:calc(52vh - 54px)!important;" +
      "overflow-y:auto!important;" +
      "overflow-x:hidden!important;" +
      "-webkit-overflow-scrolling:touch!important;" +
      "overscroll-behavior:contain!important;" +
      "scroll-snap-type:none!important;" +
      "padding:10px 12px 18px!important;" +
      "margin:0!important;" +
      "background:transparent!important;" +
      "border:0!important;" +
      "border-radius:0 0 24px 24px!important;" +
      "box-shadow:none!important;" +
    "}" +

    "body.adventureScanResultsMode #diqAdventureDestResults .diqDestItem{" +
      "position:relative!important;" +
      "display:block!important;" +
      "width:100%!important;" +
      "min-width:0!important;" +
      "max-width:none!important;" +
      "min-height:128px!important;" +
      "margin:0 0 12px!important;" +
      "padding:14px 14px 14px 132px!important;" +
      "float:none!important;" +
      "clear:both!important;" +
      "scroll-snap-align:none!important;" +
      "border-radius:20px!important;" +
      "border:1px solid rgba(255,255,255,.12)!important;" +
      "background:linear-gradient(145deg,rgba(255,255,255,.067),rgba(255,255,255,.028))!important;" +
      "box-shadow:0 10px 24px rgba(0,0,0,.22)!important;" +
      "overflow:hidden!important;" +
      "text-align:left!important;" +
    "}" +

    "body.adventureScanResultsMode #diqAdventureDestResults .diqDestItem:last-child{" +
      "margin-bottom:0!important;" +
    "}" +

    "body.adventureScanResultsMode #diqAdventureDestResults .diqDestThumb{" +
      "position:absolute!important;" +
      "left:14px!important;" +
      "top:14px!important;" +
      "width:102px!important;" +
      "height:100px!important;" +
      "border-radius:18px!important;" +
      "background-size:cover!important;" +
      "background-position:center!important;" +
      "border:1px solid rgba(255,255,255,.16)!important;" +
      "box-shadow:0 8px 22px rgba(0,0,0,.28)!important;" +
    "}" +

    "body.adventureScanResultsMode #diqAdventureDestResults .diqDestName{" +
      "margin:0!important;" +
      "font-size:21px!important;" +
      "font-weight:1000!important;" +
      "line-height:1.05!important;" +
      "letter-spacing:-.35px!important;" +
      "white-space:normal!important;" +
      "display:-webkit-box!important;" +
      "-webkit-line-clamp:2!important;" +
      "-webkit-box-orient:vertical!important;" +
      "overflow:hidden!important;" +
      "text-overflow:ellipsis!important;" +
      "color:#fff!important;" +
    "}" +

    "body.adventureScanResultsMode #diqAdventureDestResults .diqDestSub{" +
      "margin-top:5px!important;" +
      "font-size:13px!important;" +
      "font-weight:760!important;" +
      "line-height:1.2!important;" +
      "color:rgba(255,255,255,.72)!important;" +
      "display:-webkit-box!important;" +
      "-webkit-line-clamp:2!important;" +
      "-webkit-box-orient:vertical!important;" +
      "overflow:hidden!important;" +
    "}" +

    "body.adventureScanResultsMode #diqAdventureDestResults .diqDestMeta{" +
      "margin-top:7px!important;" +
      "font-size:10px!important;" +
      "line-height:1.14!important;" +
      "font-weight:1000!important;" +
      "letter-spacing:.85px!important;" +
      "color:#ffe29a!important;" +
      "display:-webkit-box!important;" +
      "-webkit-line-clamp:2!important;" +
      "-webkit-box-orient:vertical!important;" +
      "overflow:hidden!important;" +
    "}" +

    "body.adventureScanResultsMode #diqAdventureDestResults .diqDestWorth{" +
      "margin-top:9px!important;" +
      "display:flex!important;" +
      "align-items:center!important;" +
      "gap:6px!important;" +
      "flex-wrap:wrap!important;" +
    "}" +

    "body.adventureScanResultsMode #diqAdventureDestResults .diqDestTag{" +
      "min-height:25px!important;" +
      "padding:0 9px!important;" +
      "display:inline-flex!important;" +
      "align-items:center!important;" +
      "font-size:8px!important;" +
      "line-height:1!important;" +
      "letter-spacing:.55px!important;" +
      "white-space:nowrap!important;" +
    "}" +

    "body.adventureScanResultsMode #diqAdventureDestResults .diqDestWorth .diqDestTag:nth-child(n+4){" +
      "display:none!important;" +
    "}" +

    "@media(max-width:430px){" +
      "body.adventureScanResultsMode #diqAdventureDestResults.diqModeShelf.on," +
      "body.adventureScanResultsMode #diqAdventureDestResults.on{" +
        "left:14px!important;" +
        "right:14px!important;" +
        "inset:auto 14px calc(108px + env(safe-area-inset-bottom,0px)) 14px!important;" +
        "bottom:calc(108px + env(safe-area-inset-bottom,0px))!important;" +
        "max-height:48vh!important;" +
      "}" +

      "body.adventureScanResultsMode #diqAdventureDestResults #diqDestList{" +
        "max-height:calc(48vh - 52px)!important;" +
        "padding:9px 10px 15px!important;" +
      "}" +

      "body.adventureScanResultsMode #diqAdventureDestResults .diqDestItem{" +
        "min-height:116px!important;" +
        "padding:12px 12px 12px 116px!important;" +
        "border-radius:18px!important;" +
      "}" +

      "body.adventureScanResultsMode #diqAdventureDestResults .diqDestThumb{" +
        "left:12px!important;" +
        "top:12px!important;" +
        "width:90px!important;" +
        "height:90px!important;" +
        "border-radius:16px!important;" +
      "}" +

      "body.adventureScanResultsMode #diqAdventureDestResults .diqDestName{" +
        "font-size:18px!important;" +
      "}" +

      "body.adventureScanResultsMode #diqAdventureDestResults .diqDestSub{" +
        "font-size:12px!important;" +
      "}" +

      "body.adventureScanResultsMode #diqAdventureDestResults .diqDestMeta{" +
        "font-size:9px!important;" +
      "}" +
    "}" +

    "@media(orientation:landscape){" +
      "body.adventureScanResultsMode #diqAdventureDestResults.diqModeShelf.on," +
      "body.adventureScanResultsMode #diqAdventureDestResults.on{" +
        "left:18px!important;" +
        "right:18px!important;" +
        "width:auto!important;" +
        "max-width:none!important;" +
        "top:auto!important;" +
        "bottom:calc(86px + env(safe-area-inset-bottom,0px))!important;" +
        "max-height:58vh!important;" +
      "}" +

      "body.adventureScanResultsMode #diqAdventureDestResults #diqDestList{" +
        "max-height:calc(58vh - 54px)!important;" +
      "}" +
    "}";

  style = document.createElement("style");
  style.id = "diqV305ResultsSheetStyles";
  style.type = "text/css";
  style.appendChild(document.createTextNode(css));

  try{ document.head.appendChild(style); }catch(e0){}
}

function diqV305Bind(){
  diqV305InjectStyles();
  diqV305Schedule();

  /* V511: body-wide V305 observer retired.
     It watched style mutations while V305 itself wrote inline styles, creating
     a self-triggering render loop that froze Mapbox and every button. */
  diqV305Observer = null;

  window.addEventListener("resize",diqV305Schedule,false);
  window.addEventListener("orientationchange",function(){
    window.setTimeout(diqV305Schedule,160);
  },false);

  if(window.visualViewport && window.visualViewport.addEventListener){
    window.visualViewport.addEventListener("resize",diqV305Schedule,false);
  }
}

if(document.readyState === "loading"){
  document.addEventListener("DOMContentLoaded",diqV305Bind,false);
}else{
  diqV305Bind();
}

window.setTimeout(diqV305Bind,300);
window.setTimeout(diqV305Bind,900);

window.DRIVE_IQ_ADVENTURE_V305 = {
  build:"V305_UI_POLISH_PREMIUM_RESULTS_SHEET",
  apply:diqV305Apply
};

try{
  console.log("âœ… Drive IQ Adventure V305 Premium Results Sheet loaded");
}catch(ePublic){}

}());


/* =========================================================
   DRIVE IQ ADVENTURE MODE V306
   SEARCH IQ â€” CANONICAL DESTINATION AUTHORITY

   Final destination-search owner:
   - Canonical city/region first
   - Nearby districts second
   - Nearby matching places third
   - Foreign/global junk suppressed when a canonical destination is known
   - One stable panel; late legacy renders cannot swap the list
   - Districts remain available without replacing the selected city
   ES5 SAFE
========================================================= */
(function(){
"use strict";

if(window.__DRIVE_IQ_ADVENTURE_V307_SEARCH_IQ__){ return; }
window.__DRIVE_IQ_ADVENTURE_V307_SEARCH_IQ__ = true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD =
  "V307_SEARCH_IQ_NO_TWITCH_ATOMIC_CHOOSER";

var diqV306 = {
  rendering:false,
  query:"",
  results:[],
  observer:null,
  timer:null,
  token:0
};

function diqV306DistanceMiles(aLat,aLng,bLat,bLng){
  var R = 3958.7613;
  var dLat;
  var dLng;
  var lat1;
  var lat2;
  var x;

  if(
    !finite(Number(aLat)) ||
    !finite(Number(aLng)) ||
    !finite(Number(bLat)) ||
    !finite(Number(bLng))
  ){
    return null;
  }

  lat1 = Number(aLat) * Math.PI / 180;
  lat2 = Number(bLat) * Math.PI / 180;
  dLat = (Number(bLat) - Number(aLat)) * Math.PI / 180;
  dLng = (Number(bLng) - Number(aLng)) * Math.PI / 180;

  x =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1) * Math.cos(lat2) *
    Math.sin(dLng / 2) * Math.sin(dLng / 2);

  return R * 2 * Math.atan2(Math.sqrt(x),Math.sqrt(1 - x));
}

function diqV306Text(item){
  return normText(
    String(item && item.label || "") + " " +
    String(item && item.full || "") + " " +
    String(item && item.kind || "") + " " +
    String(item && item.category || "") + " " +
    String(item && item.resultType || "")
  );
}

function diqV306IsDistrict(item){
  return !!(
    item &&
    (
      item.entityType === "district" ||
      item.entityClass === "district" ||
      item.poiClass === "district" ||
      item.kind === "district" ||
      item.type === "district" ||
      item.districtId ||
      item.resultType === "adventure_district_registry" ||
      item.resultType === "entity_registry_district"
    )
  );
}

function diqV306IsCityArea(item){
  var txt = diqV306Text(item);

  return !!(
    item &&
    (
      item.canonical === true ||
      item.resultType === "adventure_index" ||
      txt.indexOf(" city") > -1 ||
      txt.indexOf(" town") > -1 ||
      txt.indexOf(" locality") > -1 ||
      txt.indexOf(" municipality") > -1 ||
      txt.indexOf(" village") > -1 ||
      txt.indexOf(" beach") > -1 ||
      txt.indexOf(" lake") > -1 ||
      txt.indexOf(" park") > -1 ||
      txt.indexOf(" region") > -1
    )
  );
}

function diqV306BadGlobal(item,anchor){
  var txt = diqV306Text(item);
  var d = null;

  if(
    txt.indexOf("county meath") > -1 ||
    txt.indexOf("ireland") > -1 ||
    txt.indexOf("karakocan") > -1 ||
    txt.indexOf("eastern anatolia") > -1 ||
    txt.indexOf("turkey") > -1 ||
    txt.indexOf("destini lakes") > -1 ||
    txt.indexOf("new providence") > -1 ||
    txt.indexOf("bahamas") > -1
  ){
    return true;
  }

  if(anchor){
    d = diqV306DistanceMiles(
      anchor.lat,
      anchor.lng,
      item && item.lat,
      item && item.lng
    );

    if(finite(Number(d)) && Number(d) > 120){
      return true;
    }
  }

  return false;
}

function diqV306ExactQuery(item,query){
  var q = normText(query);
  var label = normText(item && item.label || "");
  var full = normText(item && item.full || "");

  if(!q || !item){ return false; }
  if(label === q || full === q){ return true; }
  if(label.indexOf(q) === 0 && q.length >= 4){ return true; }
  return false;
}

function diqV306Key(item){
  return normText(
    String(item && item.resultType || "") + "|" +
    String(item && item.adventureIndexId || item.districtId || "") + "|" +
    String(item && item.label || "") + "|" +
    String(item && item.full || "") + "|" +
    String(item && item.lat || "") + "|" +
    String(item && item.lng || "")
  );
}

function diqV306Authority(results,query){
  var q = clean(query);
  var source = (results || []).slice(0);
  var anchorEntity = null;
  var anchor = null;
  var out = [];
  var cities = [];
  var districts = [];
  var nearby = [];
  var seen = {};
  var i;
  var item;
  var d;

  try{
    anchorEntity = adventureDestinationIndexMatch(q);
    if(anchorEntity){
      anchor = indexedAdventureItem(anchorEntity);
    }
  }catch(e0){}

  /* Keep known Entity IQ districts available, but only if geographically
     tied to the canonical destination. */
  try{
    if(typeof diqV108EntityQueryResults === "function"){
      source = diqV108EntityQueryResults(q).concat(source);
    }
  }catch(e1){}

  function add(candidate){
    var key;
    if(!candidate){ return; }
    key = diqV306Key(candidate);
    if(!key || seen[key]){ return; }
    seen[key] = true;
    out.push(candidate);
  }

  if(anchor){ add(anchor); }

  for(i=0;i<source.length;i++){
    item = source[i];
    if(!item || diqV306BadGlobal(item,anchor)){ continue; }

    if(anchor){
      d = diqV306DistanceMiles(
        anchor.lat,
        anchor.lng,
        item.lat,
        item.lng
      );

      if(finite(Number(d))){
        item.distFromCanonical = Number(d);
      }
    }

    if(diqV306IsDistrict(item)){
      if(
        !anchor ||
        !finite(Number(item.distFromCanonical)) ||
        Number(item.distFromCanonical) <= 45
      ){
        districts.push(item);
      }
      continue;
    }

    if(diqV306IsCityArea(item)){
      cities.push(item);
      continue;
    }

    if(
      !anchor ||
      !finite(Number(item.distFromCanonical)) ||
      Number(item.distFromCanonical) <= 65
    ){
      nearby.push(item);
    }
  }

  function rank(a,b){
    var sa = 0;
    var sb = 0;
    var da = finite(Number(a && a.distFromCanonical))
      ? Number(a.distFromCanonical)
      : 9999;
    var db = finite(Number(b && b.distFromCanonical))
      ? Number(b.distFromCanonical)
      : 9999;

    if(a && (a.canonical || a.resultType === "adventure_index")){ sa += 4000; }
    if(b && (b.canonical || b.resultType === "adventure_index")){ sb += 4000; }

    if(diqV306ExactQuery(a,q)){ sa += 1800; }
    if(diqV306ExactQuery(b,q)){ sb += 1800; }

    if(diqV306IsDistrict(a)){ sa += 600; }
    if(diqV306IsDistrict(b)){ sb += 600; }

    sa -= Math.min(900,da * 8);
    sb -= Math.min(900,db * 8);

    return sb - sa;
  }

  cities.sort(rank);
  districts.sort(rank);
  nearby.sort(rank);

  for(i=0;i<cities.length && out.length<3;i++){ add(cities[i]); }
  for(i=0;i<districts.length && out.length<6;i++){ add(districts[i]); }
  for(i=0;i<nearby.length && out.length<8;i++){ add(nearby[i]); }

  return out.slice(0,8);
}

function diqV306Panel(){
  var panel = byId("diqAdventureSearchResults");

  if(!panel){
    panel = document.createElement("div");
    panel.id = "diqAdventureSearchResults";
    panel.setAttribute("aria-hidden","true");
    panel.className = "";
    panel.innerHTML =
      '<div class="diqV306Head">' +
        '<span>CHOOSE DESTINATION</span>' +
        '<button type="button" id="diqV306Close" aria-label="Close destination results">&times;</button>' +
      '</div>' +
      '<div id="diqV306List"></div>';

    try{ document.body.appendChild(panel); }catch(e0){}
  }

  return panel;
}

function diqV306HideLegacy(){
  var legacy = byId("diqAdventureDestResults");

  if(
    legacy &&
    String(legacy.className || "").indexOf("diqModeShelf") < 0
  ){
    legacy.className = "";
    legacy.setAttribute("aria-hidden","true");
    legacy.style.setProperty("display","none","important");
  }
}

function diqV306Hide(){
  var panel = byId("diqAdventureSearchResults");

  destinationResultOpen = false;

  if(panel){
    panel.className = "";
    panel.setAttribute("aria-hidden","true");
    panel.style.removeProperty("opacity");
    panel.style.removeProperty("visibility");
    panel.style.removeProperty("pointer-events");
    panel.style.removeProperty("transform");
  }

  updateClearAdventureSearchButton();
}

function diqV306Meta(item,anchor){
  var parts = [];
  var d = null;

  if(anchor){
    d = diqV306DistanceMiles(
      anchor.lat,
      anchor.lng,
      item && item.lat,
      item && item.lng
    );
  }

  if(finite(Number(d))){
    parts.push(
      Number(d) < 0.1
        ? "In destination"
        : Number(d).toFixed(Number(d) < 10 ? 1 : 0) + " mi from center"
    );
  }else if(item && finite(Number(item.distMiles))){
    parts.push(itemDistanceText(item));
  }

  if(item && (item.canonical || item.resultType === "adventure_index")){
    parts.push("Adventure Region");
  }else if(diqV306IsDistrict(item)){
    parts.push("District");
  }else if(item && item.kind){
    parts.push(titleCaseWords(String(item.kind).replace(/_/g," ")));
  }else{
    parts.push("Destination");
  }

  return parts.join(" â€¢ ");
}

function diqV306Render(results,query){
  var panel = diqV306Panel();
  var list = byId("diqV306List");

  /* Atomic chooser swap: hide both panels before replacing rows so the user
     never sees the legacy menu or an intermediate dataset. */
  diqV306HideLegacy();
  if(panel){
    panel.className = "";
    panel.setAttribute("aria-hidden","true");
  }
  var stable = diqV306Authority(results || [],query || "");
  var anchorEntity = null;
  var anchor = null;
  var close;
  var i;
  var item;
  var btn;

  if(!panel || !list){ return; }

  try{
    anchorEntity = adventureDestinationIndexMatch(query);
    if(anchorEntity){ anchor = indexedAdventureItem(anchorEntity); }
  }catch(e0){}

  diqV306.rendering = true;
  diqV306.query = clean(query || "");
  diqV306.results = stable.slice(0);
  destinationSearchResults = stable.slice(0);

  list.innerHTML = "";

  if(!stable.length){
    list.innerHTML =
      '<button type="button" class="diqV306Row">' +
        '<div class="diqV306Name">No trusted destination match yet</div>' +
        '<div class="diqV306Sub">Try a city, lake, beach, park, attraction, or business.</div>' +
      '</button>';
  }else{
    for(i=0;i<stable.length;i++){
      item = stable[i];
      btn = document.createElement("button");
      btn.type = "button";
      btn.className =
        "diqV306Row" +
        (item.canonical || item.resultType === "adventure_index"
          ? " canonical"
          : diqV306IsDistrict(item)
            ? " district"
            : "");
      btn.setAttribute("data-v306-index",String(i));

      btn.innerHTML =
        '<div class="diqV306Name">' +
          escapeHTML(clean(item.label || "Destination")) +
        '</div>' +
        '<div class="diqV306Sub">' +
          escapeHTML(clean(item.full || "Tap to explore")) +
        '</div>' +
        '<div class="diqV306Meta">' +
          escapeHTML(diqV306Meta(item,anchor)) +
        '</div>';

      btn.onclick = function(){
        var idx = Number(this.getAttribute("data-v306-index"));

        if(idx >= 0 && diqV306.results[idx]){
          diqV306Hide();
          dismissAdventureKeyboard();
          routeDestinationResult(diqV306.results[idx]);
        }
      };

      list.appendChild(btn);
    }
  }

  close = byId("diqV306Close");
  if(close && close.getAttribute("data-bound") !== "1"){
    close.setAttribute("data-bound","1");
    close.onclick = function(event){
      if(event && event.preventDefault){ event.preventDefault(); }
      if(event && event.stopPropagation){ event.stopPropagation(); }
      diqV306Hide();
      return false;
    };
  }

  diqV306HideLegacy();

  /* Reveal once, after the final canonical list is complete. */
  window.requestAnimationFrame(function(){
    panel.className = "ready on";
    panel.setAttribute("aria-hidden","false");
  });
  destinationResultOpen = true;
  updateClearAdventureSearchButton();

  window.setTimeout(function(){
    diqV306.rendering = false;
  },30);
}

/* Final authority. No earlier wrapper may decide the visible search list. */
renderDestinationResults = function(results,query){
  diqV306Render(results || [],query || "");
};

hideDestinationResults = function(){
  diqV306Hide();

  var legacy = byId("diqAdventureDestResults");
  if(
    legacy &&
    String(legacy.className || "").indexOf("diqModeShelf") < 0
  ){
    legacy.className = "";
    legacy.setAttribute("aria-hidden","true");
  }
};

function diqV306Reassert(){
  var input = byId("adventureSearch");
  var q = input ? clean(input.value) : diqV306.query;
  var panel = byId("diqAdventureSearchResults");

  if(
    diqV306.rendering ||
    !destinationResultOpen ||
    !q ||
    q.length < 2
  ){
    return;
  }

  if(
    !panel ||
    panel.getAttribute("aria-hidden") === "true" ||
    !byId("diqV306List")
  ){
    diqV306Render(
      destinationSearchResults && destinationSearchResults.length
        ? destinationSearchResults
        : diqV306.results,
      q
    );
  }

  diqV306HideLegacy();
}

function diqV306InjectStyles(){
  var style;
  var css;

  if(byId("diqV306SearchIQStyles")){ return; }

  css =
    "#diqAdventureSearchResults{" +
      "display:none!important;" +
      "position:fixed!important;" +
      "left:14px!important;" +
      "right:14px!important;" +
      "top:calc(env(safe-area-inset-top,0px) + 76px)!important;" +
      "width:auto!important;" +
      "max-width:none!important;" +
      "height:auto!important;" +
      "max-height:calc(100dvh - 116px)!important;" +
      "margin:0!important;" +
      "overflow:hidden!important;" +
      "border-radius:22px!important;" +
      "background:linear-gradient(180deg,rgba(3,10,19,.99),rgba(2,8,16,.995))!important;" +
      "border:1px solid rgba(40,255,190,.34)!important;" +
      "box-shadow:0 24px 60px rgba(0,0,0,.64)!important;" +
      "z-index:32000!important;" +
    "}" +

    "#diqAdventureSearchResults.on{" +
      "display:flex!important;" +
      "flex-direction:column!important;" +
    "}" +

    "#diqAdventureSearchResults .diqV306Head{" +
      "position:relative!important;" +
      "flex:0 0 auto!important;" +
      "min-height:58px!important;" +
      "padding:0 60px 0 18px!important;" +
      "display:flex!important;" +
      "align-items:center!important;" +
      "border-bottom:1px solid rgba(255,255,255,.08)!important;" +
      "color:#b9ffec!important;" +
      "font-size:11px!important;" +
      "font-weight:1000!important;" +
      "letter-spacing:1.5px!important;" +
    "}" +

    "#diqV306Close{" +
      "position:absolute!important;" +
      "right:10px!important;" +
      "top:9px!important;" +
      "width:40px!important;" +
      "height:40px!important;" +
      "min-width:40px!important;" +
      "padding:0!important;" +
      "border-radius:14px!important;" +
      "border:1px solid rgba(255,255,255,.15)!important;" +
      "background:rgba(255,255,255,.06)!important;" +
      "color:#fff!important;" +
      "font-size:25px!important;" +
      "line-height:1!important;" +
    "}" +

    "#diqV306List{" +
      "display:block!important;" +
      "width:100%!important;" +
      "max-height:calc(100dvh - 174px)!important;" +
      "overflow-y:auto!important;" +
      "overflow-x:hidden!important;" +
      "-webkit-overflow-scrolling:touch!important;" +
      "overscroll-behavior:contain!important;" +
      "padding:10px 12px 18px!important;" +
    "}" +

    "#diqAdventureSearchResults .diqV306Row{" +
      "display:block!important;" +
      "width:100%!important;" +
      "min-height:94px!important;" +
      "margin:0 0 10px!important;" +
      "padding:14px 15px!important;" +
      "text-align:left!important;" +
      "border-radius:18px!important;" +
      "border:1px solid rgba(255,255,255,.12)!important;" +
      "background:linear-gradient(145deg,rgba(255,255,255,.06),rgba(255,255,255,.025))!important;" +
      "color:#fff!important;" +
      "overflow:hidden!important;" +
    "}" +

    "#diqAdventureSearchResults .diqV306Row.canonical{" +
      "border-color:rgba(255,217,112,.62)!important;" +
      "background:linear-gradient(145deg,rgba(255,214,102,.11),rgba(40,255,190,.045))!important;" +
    "}" +

    "#diqAdventureSearchResults .diqV306Row.district{" +
      "border-color:rgba(40,255,190,.32)!important;" +
    "}" +

    "#diqAdventureSearchResults .diqV306Name{" +
      "font-size:21px!important;" +
      "line-height:1.08!important;" +
      "font-weight:1000!important;" +
      "white-space:nowrap!important;" +
      "overflow:hidden!important;" +
      "text-overflow:ellipsis!important;" +
    "}" +

    "#diqAdventureSearchResults .diqV306Sub{" +
      "margin-top:5px!important;" +
      "font-size:14px!important;" +
      "line-height:1.2!important;" +
      "font-weight:680!important;" +
      "color:rgba(255,255,255,.72)!important;" +
      "white-space:nowrap!important;" +
      "overflow:hidden!important;" +
      "text-overflow:ellipsis!important;" +
    "}" +

    "#diqAdventureSearchResults .diqV306Meta{" +
      "margin-top:8px!important;" +
      "font-size:10px!important;" +
      "line-height:1!important;" +
      "font-weight:1000!important;" +
      "letter-spacing:1px!important;" +
      "text-transform:uppercase!important;" +
      "color:#ffe29a!important;" +
      "white-space:nowrap!important;" +
      "overflow:hidden!important;" +
      "text-overflow:ellipsis!important;" +
    "}" +

    "body:not(.adventureScanResultsMode) #diqAdventureDestResults{" +
      "display:none!important;" +
    "}";

  style = document.createElement("style");
  style.id = "diqV306SearchIQStyles";
  style.type = "text/css";
  style.appendChild(document.createTextNode(css));

  try{ document.head.appendChild(style); }catch(e0){}
}

function diqV306Bind(){
  var input = byId("adventureSearch");

  diqV306InjectStyles();
  diqV306Panel();

  if(input && input.getAttribute("data-v306-search-iq") !== "1"){
    input.setAttribute("data-v306-search-iq","1");

    input.addEventListener("input",function(){
      var panel = byId("diqAdventureSearchResults");

      diqV306.token += 1;
      diqV306HideLegacy();

      if(panel){
        panel.className = "";
        panel.setAttribute("aria-hidden","true");
      }
    },true);

    input.addEventListener("focus",function(){
      diqV306HideLegacy();
    },true);
  }

  /* V511: V306 body-wide reassert observer retired.
     V500 owns destination search; scan completion must not trigger a second
     search controller across the whole DOM. */
  diqV306.observer = null;
}

if(document.readyState === "loading"){
  document.addEventListener("DOMContentLoaded",diqV306Bind,false);
}else{
  diqV306Bind();
}

window.setTimeout(diqV306Bind,300);
window.setTimeout(diqV306Bind,900);

window.DRIVE_IQ_ADVENTURE_V307 = {
  build:"V307_SEARCH_IQ_NO_TWITCH_ATOMIC_CHOOSER",
  authority:diqV306Authority,
  render:diqV306Render,
  results:function(){ return diqV306.results.slice(0); }
};

try{
  console.log("âœ… Drive IQ Adventure V307 Search IQ No-Twitch loaded");
}catch(ePublic){}



/* =========================================================
   DRIVE IQ V509 RUNTIME BRIDGE
   Exposes only the state/actions required by the dedicated stop-card surface.
   This runs inside the main Adventure closure, where map and result arrays
   actually exist.
========================================================= */
window.DriveIQAdventureRuntime = {
  build:"V511_RUNTIME_BRIDGE",

  getMap:function(){
    return map;
  },

  getResults:function(){
    if(adventureResults && adventureResults.length){
      return adventureResults.slice(0);
    }
    if(exploreResults && exploreResults.length){
      return exploreResults.slice(0);
    }
    return [];
  },

  getQuery:function(){
    return String(activeScanQuery || activeLens || "");
  },

  installResultsRenderer:function(afterRender){
    var prior = renderAdventureScanChoices;

    if (
      renderAdventureScanChoices &&
      renderAdventureScanChoices.__diqV510Wrapped
    ) {
      return;
    }

    renderAdventureScanChoices = function(items,query){
      var result = prior.apply(this,arguments);

      try {
        afterRender(
          adventureResults && adventureResults.length
            ? adventureResults.slice(0)
            : (items || []).slice(0),
          query || activeScanQuery || activeLens || ""
        );
      } catch (e0) {}

      return result;
    };

    renderAdventureScanChoices.__diqV510Wrapped = true;
  },

  openPlace:function(item){
    return openAdventureInfoCard(item,true);
  },

  repaintPhotos:function(items,query){
    try{
      if(typeof diqV86BindThumbnailNodes === "function"){
        diqV86BindThumbnailNodes(items || [],query || "");
      }
    }catch(e0){}

    try{
      if(typeof diqV85BindAndHydrateThumbnails === "function"){
        diqV85BindAndHydrateThumbnails(items || [],query || "");
      }
    }catch(e1){}

    try{
      if(typeof repaintAdventureDestinationThumbnails === "function"){
        repaintAdventureDestinationThumbnails(items || [],query || "");
      }
    }catch(e2){}
  },

  enableMap:function(){
    var node;
    var canvasContainer;
    var canvas;

    try{
      if(map){
        if(map.dragPan){ map.dragPan.enable(); }
        if(map.scrollZoom){ map.scrollZoom.enable(); }
        if(map.touchZoomRotate){ map.touchZoomRotate.enable(); }
        if(map.touchPitch){ map.touchPitch.enable(); }
        if(map.doubleClickZoom){ map.doubleClickZoom.enable(); }
        if(map.boxZoom){ map.boxZoom.enable(); }
        if(map.keyboard){ map.keyboard.enable(); }
        node = map.getContainer ? map.getContainer() : null;
      }
    }catch(e0){}

    if(!node){
      node = byId("adventureMap");
    }

    if(node){
      node.style.setProperty("pointer-events","auto","important");
      node.style.setProperty("touch-action","none","important");

      canvasContainer = node.querySelector
        ? node.querySelector(".mapboxgl-canvas-container")
        : null;
      canvas = node.querySelector
        ? node.querySelector(".mapboxgl-canvas")
        : null;

      if(canvasContainer){
        canvasContainer.style.setProperty("pointer-events","auto","important");
        canvasContainer.style.setProperty("touch-action","none","important");
      }

      if(canvas){
        canvas.style.setProperty("pointer-events","auto","important");
        canvas.style.setProperty("touch-action","none","important");
      }
    }
  }
};

}());



/* =========================================================
   DRIVE IQ ADVENTURE V509
   CLEAN STOP-CARD SURFACE

   One dedicated post-scan sheet.
   It does not reuse the destination chooser and does not install global
   touch/pointer capture handlers.
========================================================= */
(function(){
"use strict";

if(window.__DRIVE_IQ_ADVENTURE_V509_STOP_SURFACE__){ return; }
window.__DRIVE_IQ_ADVENTURE_V509_STOP_SURFACE__ = true;

var runtime = null;
var priorRender = null;
var rows = [];
var query = "";
var pinFallbackBound = false;
var resultPollTimer = null;
var lastResultSignature = "";

function byIdV509(id){
  return document.getElementById(id);
}

function cleanV509(value){
  return String(value || "").replace(/\s+/g," ").trim();
}

function escapeV509(value){
  return String(value || "").replace(/[&<>"']/g,function(ch){
    if(ch === "&"){ return "&amp;"; }
    if(ch === "<"){ return "&lt;"; }
    if(ch === ">"){ return "&gt;"; }
    if(ch === '"'){ return "&quot;"; }
    return "&#39;";
  });
}

function itemNameV509(item){
  return cleanV509(
    item && (
      item.label ||
      item.name ||
      item.title ||
      item.placeName
    ) || "Adventure pick"
  );
}

function itemSubV509(item){
  return cleanV509(
    item && (
      item.reason ||
      item.description ||
      item.subtitle ||
      item.vibe ||
      item.categoryLabel
    ) || "A place worth exploring near this destination."
  );
}

function itemKindV509(item){
  return cleanV509(
    item && (
      item.entityType ||
      item.kind ||
      item.category ||
      item.type
    ) || "place"
  ).toLowerCase();
}

function isDistrictV509(item){
  var kind = itemKindV509(item);

  return !!(
    kind.indexOf("district") > -1 ||
    item && (
      item.districtId ||
      item.entityType === "district" ||
      item.resultType === "adventure_district_registry"
    )
  );
}

function itemMetaV509(item){
  var parts = [];
  var distance = Number(
    item && (
      item.distMiles ||
      item.distanceMiles ||
      item.distance
    )
  );
  var score = Number(
    item && (
      item.worthScore ||
      item.score ||
      item.iqScore
    )
  );
  var kind = itemKindV509(item);

  if(isFinite(distance)){
    parts.push(distance.toFixed(distance < 10 ? 1 : 0) + " mi");
  }

  if(kind){
    parts.push(kind.replace(/_/g," "));
  }

  if(isFinite(score)){
    parts.push(String(Math.round(score)) + " IQ");
  }

  return parts.join(" â€¢ ") || "Worth the Drive";
}

function fallbackV509(item){
  var kind = itemKindV509(item);

  if(
    kind.indexOf("water") > -1 ||
    kind.indexOf("beach") > -1 ||
    kind.indexOf("lake") > -1
  ){
    return "linear-gradient(135deg,rgba(67,183,255,.50),rgba(40,255,190,.20))";
  }

  if(
    kind.indexOf("food") > -1 ||
    kind.indexOf("restaurant") > -1 ||
    kind.indexOf("pizza") > -1
  ){
    return "linear-gradient(135deg,rgba(255,173,78,.48),rgba(255,91,91,.20))";
  }

  if(isDistrictV509(item)){
    return "linear-gradient(135deg,rgba(255,206,105,.44),rgba(40,255,190,.22))";
  }

  return "linear-gradient(135deg,rgba(255,206,105,.30),rgba(40,255,190,.18))";
}

function photoCandidatesV509(item){
  var out = [];
  var list;
  var value;
  var i;

  function add(candidate){
    candidate = cleanV509(candidate);
    if(!candidate || out.indexOf(candidate) > -1){ return; }
    out.push(candidate);
  }

  if(!item){ return out; }

  add(item.photoUrl);
  add(item.imageUrl);
  add(item.thumbnailUrl);
  add(item.photo);
  add(item.image);
  add(item.heroPhoto);
  add(item.heroImage);

  list = item.photos;
  if(list && list.length){
    for(i=0;i<list.length;i++){
      value = list[i];
      if(typeof value === "string"){
        add(value);
      }else if(value){
        add(value.url || value.src || value.photoUrl || value.imageUrl);
      }
    }
  }

  list = item.gallery;
  if(list && list.length){
    for(i=0;i<list.length;i++){
      value = list[i];
      if(typeof value === "string"){
        add(value);
      }else if(value){
        add(value.url || value.src || value.photoUrl || value.imageUrl);
      }
    }
  }

  return out;
}

function paintV509(node,item){
  var urls = photoCandidatesV509(item);
  var index = 0;
  var image;

  if(!node){ return; }

  node.style.backgroundImage = fallbackV509(item);

  function attempt(){
    if(index >= urls.length){ return; }

    image = new Image();
    image.onload = function(){
      node.style.setProperty(
        "background-image",
        'url("' + String(urls[index]).replace(/"/g,"%22") + '")',
        "important"
      );
      node.classList.add("hasPhoto");
    };
    image.onerror = function(){
      index += 1;
      attempt();
    };
    image.src = urls[index];
  }

  attempt();
}

function injectStylesV509(){
  var style;

  if(byIdV509("diqV509StopStyles")){ return; }

  style = document.createElement("style");
  style.id = "diqV509StopStyles";
  style.type = "text/css";
  style.appendChild(document.createTextNode(
    /* The old shared panel can keep serving internal legacy code, but it can
       never paint or intercept input. Destination autocomplete uses V500. */
    "#diqAdventureDestResults{" +
      "display:none!important;" +
      "visibility:hidden!important;" +
      "opacity:0!important;" +
      "pointer-events:none!important;" +
      "width:0!important;height:0!important;" +
      "max-width:0!important;max-height:0!important;" +
      "overflow:hidden!important;" +
    "}" +

    "#adventureApp .adventureShade," +
    "#diqAdventureScanTab," +
    ".adventureToast," +
    "#adventureToast{" +
      "pointer-events:none!important;" +
    "}" +

    "#diqV509StopSheet{" +
      "display:none!important;" +
      "position:fixed!important;" +
      "left:12px!important;right:12px!important;" +
      "bottom:calc(100px + env(safe-area-inset-bottom,0px))!important;" +
      "width:auto!important;max-width:none!important;" +
      "height:auto!important;max-height:46vh!important;" +
      "overflow:hidden!important;" +
      "border-radius:24px!important;" +
      "background:linear-gradient(180deg,rgba(3,10,19,.994),rgba(2,8,16,.998))!important;" +
      "border:1px solid rgba(40,255,190,.34)!important;" +
      "box-shadow:0 26px 64px rgba(0,0,0,.66)!important;" +
      "z-index:240!important;" +
      "opacity:0!important;transform:translateY(10px)!important;" +
      "transition:opacity .18s ease,transform .18s ease!important;" +
      "pointer-events:none!important;" +
    "}" +

    "#diqV509StopSheet.on{" +
      "display:flex!important;flex-direction:column!important;" +
      "opacity:1!important;transform:translateY(0)!important;" +
      "pointer-events:auto!important;" +
    "}" +

    "#diqV509StopSheet .v509Head{" +
      "position:relative!important;min-height:56px!important;" +
      "padding:0 62px 0 18px!important;" +
      "display:flex!important;align-items:center!important;" +
      "border-bottom:1px solid rgba(255,255,255,.08)!important;" +
      "color:#baffed!important;font-size:11px!important;" +
      "font-weight:1000!important;letter-spacing:1.3px!important;" +
    "}" +

    "#diqV509StopSheet .v509Head em{" +
      "margin-left:10px!important;font-style:normal!important;color:#ffe1a0!important;" +
    "}" +

    "#diqV509Close{" +
      "position:absolute!important;right:10px!important;top:8px!important;" +
      "width:40px!important;height:40px!important;min-width:40px!important;" +
      "border-radius:14px!important;" +
      "border:1px solid rgba(255,255,255,.15)!important;" +
      "background:rgba(255,255,255,.06)!important;color:#fff!important;" +
      "font-size:25px!important;line-height:1!important;" +
    "}" +

    "#diqV509StopList{" +
      "display:block!important;flex:1 1 auto!important;min-height:0!important;" +
      "width:100%!important;max-height:calc(46vh - 56px)!important;" +
      "overflow-y:auto!important;overflow-x:hidden!important;" +
      "-webkit-overflow-scrolling:touch!important;" +
      "overscroll-behavior:contain!important;touch-action:pan-y!important;" +
      "padding:10px 10px 16px!important;" +
    "}" +

    "#diqV509StopList .v509Card{" +
      "position:relative!important;display:block!important;width:100%!important;" +
      "min-height:120px!important;margin:0 0 12px!important;" +
      "padding:13px 13px 13px 118px!important;text-align:left!important;" +
      "color:#fff!important;border-radius:19px!important;" +
      "border:1px solid rgba(255,255,255,.12)!important;" +
      "background:linear-gradient(145deg,rgba(255,255,255,.07),rgba(255,255,255,.028))!important;" +
      "overflow:hidden!important;" +
    "}" +

    "#diqV509StopList .v509Card.district{" +
      "border-color:rgba(255,215,112,.58)!important;" +
      "background:linear-gradient(145deg,rgba(255,214,102,.10),rgba(40,255,190,.04))!important;" +
    "}" +

    "#diqV509StopList .v509Thumb{" +
      "position:absolute!important;left:13px!important;top:13px!important;" +
      "width:92px!important;height:92px!important;border-radius:16px!important;" +
      "background-size:cover!important;background-position:center!important;" +
      "background-color:rgba(255,255,255,.08)!important;" +
      "border:1px solid rgba(255,255,255,.14)!important;" +
    "}" +

    "#diqV509StopList .v509Name{" +
      "font-size:19px!important;line-height:1.08!important;font-weight:1000!important;" +
      "display:-webkit-box!important;-webkit-line-clamp:2!important;" +
      "-webkit-box-orient:vertical!important;overflow:hidden!important;" +
    "}" +

    "#diqV509StopList .v509Sub{" +
      "margin-top:5px!important;font-size:12px!important;line-height:1.22!important;" +
      "font-weight:720!important;color:rgba(255,255,255,.72)!important;" +
      "display:-webkit-box!important;-webkit-line-clamp:2!important;" +
      "-webkit-box-orient:vertical!important;overflow:hidden!important;" +
    "}" +

    "#diqV509StopList .v509Meta{" +
      "margin-top:7px!important;font-size:9px!important;line-height:1.18!important;" +
      "font-weight:1000!important;letter-spacing:.75px!important;" +
      "text-transform:uppercase!important;color:#ffe29a!important;" +
      "display:-webkit-box!important;-webkit-line-clamp:2!important;" +
      "-webkit-box-orient:vertical!important;overflow:hidden!important;" +
    "}" +

    "#diqV509StopList .v509Tag{" +
      "margin-top:9px!important;min-height:25px!important;padding:0 9px!important;" +
      "display:inline-flex!important;align-items:center!important;" +
      "border-radius:999px!important;background:rgba(40,255,190,.10)!important;" +
      "border:1px solid rgba(40,255,190,.22)!important;color:#baffed!important;" +
      "font-size:8px!important;font-weight:1000!important;letter-spacing:.55px!important;" +
      "text-transform:uppercase!important;" +
    "}"
  ));

  try{
    (document.head || document.documentElement).appendChild(style);
  }catch(e0){}
}

function ensureSheetV509(){
  var sheet = byIdV509("diqV509StopSheet");
  var close;

  if(sheet){ return sheet; }

  sheet = document.createElement("section");
  sheet.id = "diqV509StopSheet";
  sheet.setAttribute("aria-hidden","true");
  sheet.innerHTML =
    '<div class="v509Head">' +
      '<span>CHOOSE ADVENTURE STOP</span>' +
      '<em>â€¢ MAP IS THE HERO</em>' +
      '<button id="diqV509Close" type="button" aria-label="Close picks">&times;</button>' +
    '</div>' +
    '<div id="diqV509StopList"></div>';

  document.body.appendChild(sheet);

  close = byIdV509("diqV509Close");
  if(close){
    close.onclick = function(){
      sheet.className = "";
      sheet.setAttribute("aria-hidden","true");
      return false;
    };
  }

  return sheet;
}

function renderSheetV509(items,scanQuery){
  var sheet = ensureSheetV509();
  var list = byIdV509("diqV509StopList");
  var displayRows = (items || []).slice(0,12);
  var i;
  var item;
  var card;
  var thumb;

  if(!sheet || !list || !displayRows.length){ return; }

  rows = displayRows.slice(0);
  query = cleanV509(scanQuery);
  list.innerHTML = "";

  for(i=0;i<displayRows.length;i++){
    item = displayRows[i];

    card = document.createElement("button");
    card.type = "button";
    card.className =
      "v509Card" +
      (isDistrictV509(item) ? " district" : "");
    card.setAttribute("data-v509-index",String(i));
    card.innerHTML =
      '<span class="v509Thumb"></span>' +
      '<span class="v509Name">' + escapeV509(itemNameV509(item)) + '</span>' +
      '<span class="v509Sub">' + escapeV509(itemSubV509(item)) + '</span>' +
      '<span class="v509Meta">' + escapeV509(itemMetaV509(item)) + '</span>' +
      '<span class="v509Tag">Worth the Drive</span>';

    card.onclick = function(){
      var index = Number(this.getAttribute("data-v509-index"));
      var selected = rows[index];

      if(selected && runtime && runtime.openPlace){
        runtime.openPlace(selected);
      }
    };

    list.appendChild(card);

    thumb = card.querySelector(".v509Thumb");
    paintV509(thumb,item);
  }

  sheet.className = "on";
  sheet.setAttribute("aria-hidden","false");

  if(runtime && runtime.enableMap){
    runtime.enableMap();
    window.setTimeout(runtime.enableMap,100);
    window.setTimeout(runtime.enableMap,400);
  }

  if(runtime && runtime.repaintPhotos){
    window.setTimeout(function(){
      runtime.repaintPhotos(rows,query);
    },180);
    window.setTimeout(function(){
      runtime.repaintPhotos(rows,query);
    },700);
  }
}

function wrapRenderV509(){
  if(!runtime || !runtime.installResultsRenderer){ return; }

  runtime.installResultsRenderer(function(items,scanQuery){
    window.requestAnimationFrame(function(){
      renderSheetV509(items || [],scanQuery || "");
    });
  });
}

function resultSignatureV511(items){
  var out = [];
  var i;
  var item;

  for(i=0;i<(items || []).length;i++){
    item = items[i] || {};
    out.push(
      itemNameV509(item) + "|" +
      String(item.lat || "") + "|" +
      String(item.lng || "")
    );
  }

  return out.join("||");
}

function syncResultsV511(force){
  var current;
  var signature;
  var tab;

  if(!runtime || !runtime.getResults){ return; }

  current = runtime.getResults() || [];
  if(!current.length){ return; }

  signature = resultSignatureV511(current);

  if(force || signature !== lastResultSignature){
    lastResultSignature = signature;

    /* Scan is complete: spinner cannot remain above the app. */
    tab = byIdV509("diqAdventureScanTab");
    if(tab){
      tab.className = "";
      tab.style.setProperty("display","none","important");
      tab.style.setProperty("pointer-events","none","important");
    }

    renderSheetV509(
      current,
      runtime.getQuery ? runtime.getQuery() : ""
    );
  }

  if((force || signature === lastResultSignature) && runtime.enableMap){
    /* Bounded interaction restore only. Do not resize/repaint on every poll. */
    if(force){ runtime.enableMap(); }
  }
}

function startResultPollingV511(){
  var count = 0;

  if(resultPollTimer){
    window.clearInterval(resultPollTimer);
  }

  resultPollTimer = window.setInterval(function(){
    var current = runtime && runtime.getResults ? (runtime.getResults() || []) : [];
    count += 1;
    syncResultsV511(false);

    /* The committed result set is now available. Stop polling so the map's
       main thread is free for drag, pinch, and pin taps. */
    if(current.length || count >= 24){
      window.clearInterval(resultPollTimer);
      resultPollTimer = null;
    }
  },350);
}

function bindPinFallbackV509(){
  var mapInstance;

  if(pinFallbackBound || !runtime || !runtime.getMap){ return; }

  mapInstance = runtime.getMap();
  if(!mapInstance || !mapInstance.on){ return; }

  pinFallbackBound = true;

  try{
    mapInstance.on("click",function(event){
      var features = [];
      var feature;
      var index = -1;
      var current = runtime.getResults ? runtime.getResults() : [];

      try{
        features = mapInstance.queryRenderedFeatures(event.point,{
          layers:["adventure-result-dot","adventure-result-halo"]
        }) || [];
      }catch(e0){}

      if(!features.length){ return; }

      feature = features[0];
      index = feature && feature.properties
        ? Number(feature.properties.idx)
        : -1;

      if(index >= 0 && current[index] && runtime.openPlace){
        runtime.openPlace(current[index]);
      }
    });
  }catch(e1){}
}

function bindV509(){
  runtime = window.DriveIQAdventureRuntime;

  if(!runtime){
    window.setTimeout(bindV509,100);
    return;
  }

  injectStylesV509();
  ensureSheetV509();
  wrapRenderV509();
  startResultPollingV511();

  document.addEventListener("click",function(event){
    var target = event && event.target;

    if(!target){ return; }

    if(
      target.id === "buildAdventure" ||
      target.id === "lockGps" ||
      target.id === "startAdventure" ||
      target.id === "adventureScanPeekBtn"
    ){
      lastResultSignature = "";
      startResultPollingV511();
    }
  },false);

  if(runtime.enableMap){
    runtime.enableMap();
  }

  bindPinFallbackV509();

  window.setTimeout(function(){
    wrapRenderV509();
    bindPinFallbackV509();
    if(runtime.enableMap){ runtime.enableMap(); }
  },500);

  window.setTimeout(function(){
    wrapRenderV509();
    bindPinFallbackV509();
    if(runtime.enableMap){ runtime.enableMap(); }
  },1400);

  document.addEventListener("visibilitychange",function(){
    if(!document.hidden){
      if(runtime.enableMap){
        window.setTimeout(runtime.enableMap,80);
        window.setTimeout(runtime.enableMap,400);
      }
      window.setTimeout(function(){
        syncResultsV511(false);
      },180);
    }
  },false);

  window.addEventListener("pageshow",function(){
    if(runtime.enableMap){
      window.setTimeout(runtime.enableMap,80);
    }
  },false);

  window.DRIVE_IQ_ADVENTURE_MODE_BUILD =
    "V511_RUNTIME_BRIDGE_STOP_CARDS";

  window.DRIVE_IQ_ADVENTURE_UI_V509 = {
    build:"V511_RUNTIME_BRIDGE_STOP_CARDS",
    render:renderSheetV509,
    enableMap:function(){
      if(runtime && runtime.enableMap){ runtime.enableMap(); }
    }
  };

  try{
    console.log("âœ… Drive IQ V511 clean post-scan authority loaded");
  }catch(ePublic){}
}

if(document.readyState === "loading"){
  document.addEventListener("DOMContentLoaded",bindV509,false);
}else{
  bindV509();
}

}());


/* =========================================================
   DRIVE IQ ADVENTURE V513 â€” HARD INTERACTION AUTHORITY
   This block is intentionally outside the main Adventure closure.
   It installs even when legacy render wrappers are present.
========================================================= */
(function(){
"use strict";

if(window.__DRIVE_IQ_ADVENTURE_V513_HARD_INTERACTION_PATCH__){ return; }
window.__DRIVE_IQ_ADVENTURE_V513_HARD_INTERACTION_PATCH__ = true;
/* V529: retired. Its 300ms interval repeatedly resized Mapbox, scanned the
   hit-test stack, and reopened the results surface while the user was trying
   to drag or tap. The base Mapbox layer handlers and bounded V528/V514 settle
   passes now own interaction. */
return;

var v513LastSignature = "";
var v513Timer = null;
var v513MapBound = false;

function v513ById(id){ return document.getElementById(id); }
function v513Clean(v){ return String(v || "").replace(/\s+/g," ").trim(); }

function v513Runtime(){ return window.DriveIQAdventureRuntime || null; }
function v513Results(){
  var rt = v513Runtime();
  try{ return rt && rt.getResults ? (rt.getResults() || []) : []; }catch(e){ return []; }
}
function v513Signature(items){
  var out=[],i,item;
  for(i=0;i<(items||[]).length;i++){
    item=items[i]||{};
    out.push(v513Clean(item.label||item.name||item.title||"")+"|"+String(item.lat||"")+"|"+String(item.lng||""));
  }
  return out.join("||");
}

function v513InjectStyles(){
  var style;
  if(v513ById("diqV513InteractionStyles")){ return; }
  style=document.createElement("style");
  style.id="diqV513InteractionStyles";
  style.type="text/css";
  style.appendChild(document.createTextNode(
    "#adventureMap,.mapboxgl-map,.mapboxgl-canvas-container,.mapboxgl-canvas{"+
      "pointer-events:auto!important;touch-action:none!important;"+
    "}"+
    "#diqAdventureScanTab:not(.on),#diqAdventureScanTab[style*=\\\"display: none\\\"]{"+
      "pointer-events:none!important;"+
    "}"+
    "#diqV509StopSheet.on{display:flex!important;pointer-events:auto!important;z-index:50010!important;}"+
    "#diqV509StopSheet .v509Card,#diqV509Close{pointer-events:auto!important;touch-action:manipulation!important;}"
  ));
  try{ (document.head||document.documentElement).appendChild(style); }catch(e0){}
}

function v513EnableMap(){
  var rt=v513Runtime(),map,node,canvasContainer,canvas;
  try{ if(rt&&rt.enableMap){ rt.enableMap(); } }catch(e0){}
  try{ map=rt&&rt.getMap?rt.getMap():null; }catch(e1){ map=null; }
  try{
    if(map){
      if(map.dragPan){ map.dragPan.enable(); }
      if(map.scrollZoom){ map.scrollZoom.enable(); }
      if(map.touchZoomRotate){ map.touchZoomRotate.enable(); }
      if(map.touchPitch){ map.touchPitch.enable(); }
      if(map.doubleClickZoom){ map.doubleClickZoom.enable(); }
      if(map.boxZoom){ map.boxZoom.enable(); }
      if(map.keyboard){ map.keyboard.enable(); }
      if(map.resize){ map.resize(); }
      if(map.triggerRepaint){ map.triggerRepaint(); }
      node=map.getContainer?map.getContainer():null;
    }
  }catch(e2){}
  if(!node){ node=v513ById("adventureMap")||document.querySelector(".mapboxgl-map"); }
  if(node){
    node.style.setProperty("pointer-events","auto","important");
    node.style.setProperty("touch-action","none","important");
    canvasContainer=node.querySelector?node.querySelector(".mapboxgl-canvas-container"):null;
    canvas=node.querySelector?node.querySelector(".mapboxgl-canvas"):null;
    if(canvasContainer){ canvasContainer.style.setProperty("pointer-events","auto","important"); canvasContainer.style.setProperty("touch-action","none","important"); }
    if(canvas){ canvas.style.setProperty("pointer-events","auto","important"); canvas.style.setProperty("touch-action","none","important"); }
  }
}

function v513RemoveInvisibleBlockers(){
  var mapNode=v513ById("adventureMap")||document.querySelector(".mapboxgl-map");
  var rect,x,y,stack,i,el,er,cs,tag,id,cls;
  if(!mapNode||!document.elementsFromPoint){ return; }
  rect=mapNode.getBoundingClientRect();
  if(rect.width<40||rect.height<40){ return; }
  x=Math.round(rect.left+rect.width*0.5);
  y=Math.round(rect.top+rect.height*0.52);
  stack=document.elementsFromPoint(x,y)||[];
  for(i=0;i<stack.length;i++){
    el=stack[i];
    if(!el||el===mapNode||mapNode.contains(el)){ break; }
    tag=String(el.tagName||"").toLowerCase();
    id=String(el.id||"");
    cls=String(el.className||"");
    if(tag==="button"||tag==="a"||tag==="input"||tag==="select"||tag==="textarea"){ continue; }
    if(id==="diqV509StopSheet"||cls.indexOf("v509Card")>-1){ continue; }
    try{ er=el.getBoundingClientRect(); cs=window.getComputedStyle(el); }catch(e0){ continue; }
    if(!er||!cs){ continue; }
    if(er.width>=rect.width*0.85&&er.height>=rect.height*0.70&&cs.pointerEvents!=="none"){
      if(Number(cs.opacity||1)<=0.05||cs.visibility==="hidden"||cs.backgroundColor==="rgba(0, 0, 0, 0)"||cls.indexOf("overlay")>-1||cls.indexOf("shade")>-1){
        el.style.setProperty("pointer-events","none","important");
        el.setAttribute("data-diq-v513-unblocked","1");
      }
    }
  }
}

function v513OpenPicks(force){
  var items=v513Results(),ui=window.DRIVE_IQ_ADVENTURE_UI_V509,rt=v513Runtime(),q="";
  if(!items.length){ return false; }
  try{ q=rt&&rt.getQuery?rt.getQuery():""; }catch(e0){}
  if(ui&&typeof ui.render==="function"){
    try{ ui.render(items,q); v513EnableMap(); return true; }catch(e1){}
  }
  return false;
}

function v513Sync(force){
  var items=v513Results(),sig,tab;
  v513EnableMap();
  v513RemoveInvisibleBlockers();
  if(!items.length){ return; }
  sig=v513Signature(items);
  if(force||sig!==v513LastSignature){
    v513LastSignature=sig;
    tab=v513ById("diqAdventureScanTab");
    if(tab){ tab.className=""; tab.style.setProperty("display","none","important"); tab.style.setProperty("pointer-events","none","important"); }
    window.setTimeout(function(){ v513OpenPicks(true); },80);
  }
}

function v513BindMapPins(){
  var rt=v513Runtime(),map;
  if(v513MapBound||!rt||!rt.getMap){ return; }
  try{ map=rt.getMap(); }catch(e0){ map=null; }
  if(!map||!map.on){ return; }
  v513MapBound=true;
  try{
    map.on("click",function(event){
      var features=[],feature,index=-1,items=v513Results();
      try{ features=map.queryRenderedFeatures(event.point,{layers:["adventure-result-dot","adventure-result-halo"]})||[]; }catch(e1){}
      if(!features.length){ return; }
      feature=features[0];
      index=feature&&feature.properties?Number(feature.properties.idx):-1;
      if(index>=0&&items[index]&&rt.openPlace){ try{ rt.openPlace(items[index]); }catch(e2){} }
    });
  }catch(e3){}
}

function v513ClickAuthority(event){
  var target=event&&event.target,button,text,id;
  if(!target){ return; }
  button=target.closest?target.closest("button,a"):target;
  if(!button){ return; }
  id=String(button.id||"");
  text=v513Clean(button.textContent||"").toUpperCase();
  if(id==="diqShowResults"||id==="diqExploreNearbyBtn"||id==="adventureScanPeekBtn"||text.indexOf("SHOW PICKS")===0||text==="EXPLORE"){
    if(v513Results().length){
      event.preventDefault();
      if(event.stopImmediatePropagation){ event.stopImmediatePropagation(); }
      v513OpenPicks(true);
    }
  }
}

function v513Boot(){
  v513InjectStyles();
  document.addEventListener("click",v513ClickAuthority,true);
  document.addEventListener("touchend",v513ClickAuthority,true);
  if(v513Timer){ window.clearInterval(v513Timer); }
  v513Timer=window.setInterval(function(){
    v513Sync(false);
    v513BindMapPins();
  },300);
  window.setTimeout(function(){ v513Sync(true); v513BindMapPins(); },250);
  window.setTimeout(function(){ v513Sync(true); v513BindMapPins(); },900);
  window.addEventListener("pageshow",function(){ window.setTimeout(function(){ v513Sync(true); },100); },false);
  document.addEventListener("visibilitychange",function(){ if(!document.hidden){ window.setTimeout(function(){ v513Sync(true); },100); } },false);
  window.DRIVE_IQ_ADVENTURE_MODE_BUILD="V514_POST_SCAN_FREEZE_KILL_SWITCH";
  window.DriveIQAdventureInteractionV513={
    build:"V514_POST_SCAN_FREEZE_KILL_SWITCH",
    sync:function(){ v513Sync(true); },
    showPicks:function(){ return v513OpenPicks(true); },
    enableMap:v513EnableMap,
    results:v513Results
  };
  try{ console.log("âœ… Drive IQ Adventure V513 hard interaction authority loaded"); }catch(e0){}
}

if(document.readyState==="loading"){
  document.addEventListener("DOMContentLoaded",v513Boot,false);
}else{
  v513Boot();
}



/* =========================================================
   DRIVE IQ V514 â€” POST-SCAN MAIN-THREAD FREEZE KILL SWITCH

   Root cause removed:
   - Legacy V210 observed the results panel, then rerendered that same panel.
   - V301/V302 observed result attributes/children while writing layout styles.
   - V92/V93 watched the entire document during pin/photo/card painting.
   Those feedback loops could saturate WKWebView after scan completion.

   This watchdog is intentionally lightweight. It performs no DOM polling and
   never observes the full document.
========================================================= */
(function(){
"use strict";

if(window.__DRIVE_IQ_ADVENTURE_V514_FREEZE_GUARD__){ return; }
window.__DRIVE_IQ_ADVENTURE_V514_FREEZE_GUARD__ = true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD = "V514_POST_SCAN_FREEZE_KILL_SWITCH";

function diqV514RestoreMap(){
  var canvas;
  var container;

  try{
    container = document.getElementById("adventureMap") ||
      document.getElementById("map") ||
      document.querySelector(".mapboxgl-map");

    if(container){
      container.style.setProperty("pointer-events","auto","important");
      container.style.setProperty("touch-action","pan-x pan-y pinch-zoom","important");
    }

    canvas = document.querySelector(".mapboxgl-canvas");
    if(canvas){
      canvas.style.setProperty("pointer-events","auto","important");
      canvas.style.setProperty("touch-action","none","important");
    }

    if(typeof map !== "undefined" && map){
      try{ if(map.dragPan && map.dragPan.enable){ map.dragPan.enable(); } }catch(e1){}
      try{ if(map.touchZoomRotate && map.touchZoomRotate.enable){ map.touchZoomRotate.enable(); } }catch(e2){}
      try{ if(map.doubleClickZoom && map.doubleClickZoom.enable){ map.doubleClickZoom.enable(); } }catch(e3){}
      try{ if(map.scrollZoom && map.scrollZoom.enable){ map.scrollZoom.enable(); } }catch(e4){}
      try{ if(map.resize){ map.resize(); } }catch(e5){}
    }
  }catch(e0){}
}

function diqV514PostScanSettle(){
  /* One bounded settle pass onlyâ€”no interval, no document observer. */
  window.setTimeout(diqV514RestoreMap,40);
  window.setTimeout(diqV514RestoreMap,260);
  window.setTimeout(diqV514RestoreMap,900);
}

document.addEventListener("click",function(event){
  var target = event && event.target;
  var text = "";

  if(!target){ return; }

  try{
    text = String(target.textContent || "").replace(/\s+/g," ").trim().toUpperCase();
  }catch(e0){ text = ""; }

  if(
    text.indexOf("SCAN AGAIN") > -1 ||
    text.indexOf("SHOW PICKS") > -1 ||
    text === "EXPLORE" ||
    text.indexOf("LOCAL FAVORITES") > -1
  ){
    diqV514PostScanSettle();
  }
},true);

window.addEventListener("driveiq:scan-complete",diqV514PostScanSettle,false);
window.addEventListener("driveiq:adventure-results",diqV514PostScanSettle,false);

window.DriveIQAdventureV514 = {
  build:"V514_POST_SCAN_FREEZE_KILL_SWITCH",
  restoreMap:diqV514RestoreMap,
  settle:diqV514PostScanSettle,
  retiredObservers:[
    "V92 document-wide overlay observer",
    "V93 document-wide voice observer",
    "V210 self-rerender observer",
    "V301 result layout observer",
    "V302 result layout observer"
  ]
};

try{
  console.log("âœ… Drive IQ Adventure V514 post-scan freeze kill switch loaded");
}catch(ePublic){}

}());

}());


/* =========================================================
   DRIVE IQ ADVENTURE MODE V515
   PLACE CARDS RESTORE + USER MAP GESTURE AUTHORITY

   Root regression:
   - #diqAdventureDestResults was used for both the old destination chooser
     and the post-scan "Places Worth Exploring" shelf.
   - V508/HTML permanently forced that element to display:none, width:0,
     height:0 and pointer-events:none.
   - Result: scans and pins succeeded, but destination/place cards vanished.

   Map behavior:
   - A real user touch immediately cancels pending scan camera work.
   - Mapbox animations are stopped so delayed post-scan fit operations do not
     continue fighting pinch/drag input.
   - Gestures are re-enabled in a short bounded recovery burst.
========================================================= */
(function(){
"use strict";

if(window.__DRIVE_IQ_ADVENTURE_V515_PLACE_CARDS_MAP_GESTURE__){ return; }
window.__DRIVE_IQ_ADVENTURE_V515_PLACE_CARDS_MAP_GESTURE__ = true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD =
  "V515_PLACE_CARDS_MAP_GESTURE_AUTHORITY";

var diqV515UserMapUntil = 0;
var diqV515LastResultsKey = "";

function diqV515Now(){
  return Date.now ? Date.now() : (new Date()).getTime();
}

function diqV515RemoveKillStyles(){
  var ids = ["diqV508FirstPaintKill"];
  var i;
  var el;

  for(i = 0; i < ids.length; i++){
    el = document.getElementById(ids[i]);
    if(el && el.parentNode){
      try{ el.parentNode.removeChild(el); }catch(e0){}
    }
  }
}

function diqV515InjectStyles(){
  var style;
  var css;

  if(document.getElementById("diqV515CardsMapStyles")){ return; }

  css =
    "body.adventureScanResultsMode #diqAdventureDestResults.on," +
    "body.adventureScanResultsMode #diqAdventureDestResults.diqModeShelf{" +
      "display:flex!important;visibility:visible!important;opacity:1!important;" +
      "pointer-events:auto!important;width:auto!important;height:auto!important;" +
      "max-width:none!important;max-height:calc(100dvh - 104px)!important;" +
      "overflow:hidden!important;" +
    "}" +
    "body.adventureScanResultsMode #diqAdventureDestResults #diqDestList{" +
      "display:block!important;visibility:visible!important;opacity:1!important;" +
      "pointer-events:auto!important;overflow-y:auto!important;" +
      "-webkit-overflow-scrolling:touch!important;" +
    "}" +
    "#adventureMap,#adventureMap .mapboxgl-canvas-container," +
    "#adventureMap .mapboxgl-canvas{" +
      "pointer-events:auto!important;touch-action:none!important;" +
    "}" +
    ".adventureShade,#diqAdventureScanTab,.adventureToast{" +
      "pointer-events:none!important;" +
    "}";

  style = document.createElement("style");
  style.id = "diqV515CardsMapStyles";
  style.type = "text/css";
  style.appendChild(document.createTextNode(css));

  try{ (document.head || document.documentElement).appendChild(style); }catch(e1){}
}

function diqV515EnableMap(){
  try{
    if(!map){ return; }
    if(map.dragPan){ map.dragPan.enable(); }
    if(map.scrollZoom){ map.scrollZoom.enable(); }
    if(map.touchZoomRotate){ map.touchZoomRotate.enable(); }
    if(map.touchPitch){ map.touchPitch.enable(); }
    if(map.doubleClickZoom){ map.doubleClickZoom.enable(); }
    if(map.boxZoom){ map.boxZoom.enable(); }
    if(map.keyboard){ map.keyboard.enable(); }
    if(map.resize){ map.resize(); }
    if(map.triggerRepaint){ map.triggerRepaint(); }
  }catch(e0){}
}

function diqV515UserMapGesture(){
  diqV515UserMapUntil = diqV515Now() + 15000;

  try{
    if(scanMapFitTimer){
      window.clearTimeout(scanMapFitTimer);
      scanMapFitTimer = null;
    }
  }catch(e0){}

  try{
    if(adventureAutoCollapseTimer){
      window.clearTimeout(adventureAutoCollapseTimer);
      adventureAutoCollapseTimer = null;
    }
  }catch(e1){}

  try{
    if(map && map.stop){ map.stop(); }
  }catch(e2){}

  diqV515EnableMap();
  window.setTimeout(diqV515EnableMap,40);
  window.setTimeout(diqV515EnableMap,180);
  window.setTimeout(diqV515EnableMap,520);
}

function diqV515Results(){
  if(adventureResults && adventureResults.length){
    return adventureResults.slice(0);
  }
  if(destinationSearchResults && destinationSearchResults.length){
    return destinationSearchResults.slice(0);
  }
  if(exploreResults && exploreResults.length){
    return exploreResults.slice(0);
  }
  return [];
}

function diqV515ShowCards(){
  var items = diqV515Results();
  var panel;
  var head;

  if(!items.length){ return false; }

  try{
    document.body.classList.add("adventureScanResultsMode");
  }catch(e0){}

  diqV515RemoveKillStyles();
  diqV515InjectStyles();

  try{
    if(typeof renderAdventureScanChoices === "function"){
      renderAdventureScanChoices(items,activeScanQuery || activeLens || "Adventure");
    }
  }catch(e1){}

  panel = document.getElementById("diqAdventureDestResults");
  if(!panel){ return false; }

  panel.className = "on diqModeShelf";
  panel.setAttribute("aria-hidden","false");
  panel.style.removeProperty("display");
  panel.style.removeProperty("visibility");
  panel.style.removeProperty("opacity");
  panel.style.removeProperty("pointer-events");
  panel.style.removeProperty("width");
  panel.style.removeProperty("height");
  panel.style.removeProperty("max-width");
  panel.style.removeProperty("max-height");

  head = panel.querySelector ? panel.querySelector(".diqDestHead") : null;
  if(head){ head.textContent = "PLACES WORTH EXPLORING"; }

  return true;
}

function diqV515BindButtons(){
  var ids = ["adventureScanPeekBtn","startAdventure"];
  var i;
  var el;

  for(i = 0; i < ids.length; i++){
    el = document.getElementById(ids[i]);
    if(!el || el.__diqV515CardsBound){ continue; }

    el.__diqV515CardsBound = true;
    el.addEventListener("click",function(event){
      if(diqV515Results().length){
        if(event && event.preventDefault){ event.preventDefault(); }
        if(event && event.stopImmediatePropagation){ event.stopImmediatePropagation(); }
        diqV515ShowCards();
      }
    },true);
  }
}

function diqV515BindMap(){
  var node = document.getElementById("adventureMap");

  if(!node || node.__diqV515GestureBound){ return; }
  node.__diqV515GestureBound = true;

  node.addEventListener("touchstart",diqV515UserMapGesture,{passive:true});
  node.addEventListener("pointerdown",diqV515UserMapGesture,true);
  node.addEventListener("wheel",diqV515UserMapGesture,{passive:true});
}

function diqV515AfterResults(){
  var items = diqV515Results();
  var key = String(items.length) + "|" +
    String(items[0] && (items[0].placeId || items[0].label || items[0].name) || "");

  diqV515RemoveKillStyles();
  diqV515InjectStyles();
  diqV515EnableMap();
  diqV515BindButtons();
  diqV515BindMap();

  if(items.length && key !== diqV515LastResultsKey){
    diqV515LastResultsKey = key;
    window.setTimeout(function(){
      diqV515RemoveKillStyles();
      diqV515EnableMap();
    },120);
  }
}

function diqV515Boot(){
  diqV515RemoveKillStyles();
  diqV515InjectStyles();
  diqV515BindButtons();
  diqV515BindMap();
  diqV515EnableMap();

  window.setTimeout(diqV515AfterResults,350);
  window.setTimeout(diqV515AfterResults,1000);
  window.setTimeout(diqV515AfterResults,2200);
}

if(document.readyState === "loading"){
  document.addEventListener("DOMContentLoaded",diqV515Boot,false);
}else{
  diqV515Boot();
}

try{
  if(typeof afterScanResultsReady === "function"){
    var diqV515PriorReady = afterScanResultsReady;
    afterScanResultsReady = function(items,preferred,reason){
      var result = diqV515PriorReady(items,preferred,reason);
      window.setTimeout(diqV515AfterResults,80);
      window.setTimeout(diqV515AfterResults,420);
      return result;
    };
  }
}catch(eReady){}

window.DriveIQAdventureV515 = {
  build:"V515_PLACE_CARDS_MAP_GESTURE_AUTHORITY",
  showCards:diqV515ShowCards,
  restoreMap:diqV515UserMapGesture,
  results:diqV515Results
};

try{
  console.log("âœ… Drive IQ Adventure V515 place cards + map gesture authority loaded");
}catch(ePublic){}

}());


/* =========================================================
   DRIVE IQ ADVENTURE MODE V517
   PLACE PREVIEW IDENTITY-SAFE HANDOFF AUTHORITY

   Tap contract:
   1. Resolve the exact canonical result from the active shelf.
   2. Collapse the shelf and restore the map as the visual hero.
   3. Center/highlight the selected place.
   4. Open the existing Place IQ / District IQ detail card.
   5. Preserve the existing Route Here authority inside that card.

   This is event delegation at the final rendered shelf boundary, so later
   photo/category decorators cannot accidentally remove the selection action.
========================================================= */
(function(){
"use strict";

if(window.__DRIVE_IQ_ADVENTURE_V516_RESULT_SELECTION_HANDOFF__){ return; }
window.__DRIVE_IQ_ADVENTURE_V516_RESULT_SELECTION_HANDOFF__ = true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD =
  "V517_PLACE_PREVIEW_IDENTITY_SAFE_HANDOFF";

var diqV516SelectedItem = null;
var diqV516SelectedAt = 0;

function diqV516Finite(value){
  return typeof value === "number" && isFinite(value);
}

function diqV516Results(){
  if(destinationSearchResults && destinationSearchResults.length){
    return destinationSearchResults;
  }
  if(adventureResults && adventureResults.length){
    return adventureResults;
  }
  if(exploreResults && exploreResults.length){
    return exploreResults;
  }
  return [];
}

function diqV516IsDistrict(item){
  var kind = String(
    item && (
      item.entityType ||
      item.entityClass ||
      item.kind ||
      item.resultType ||
      item.category
    ) || ""
  ).toLowerCase();

  return (
    kind.indexOf("district") > -1 ||
    !!(item && item.districtId) ||
    !!(item && item.isGeneratedDistrict)
  );
}

function diqV516ResolveItem(node){
  var index;
  var items;
  var label;
  var i;

  if(!node){ return null; }

  index = Number(
    node.getAttribute("data-adv-idx") ||
    node.getAttribute("data-dest-idx")
  );

  items = diqV516Results();

  if(isFinite(index) && index >= 0 && items[index]){
    return items[index];
  }

  label = String(
    node.getAttribute("data-place-label") ||
    node.getAttribute("aria-label") ||
    ""
  ).toLowerCase();

  if(!label){
    try{
      var nameNode = node.querySelector(".diqDestName");
      label = String(nameNode && nameNode.textContent || "").toLowerCase();
    }catch(e0){}
  }

  if(label){
    for(i = 0; i < items.length; i++){
      if(
        String(items[i] && (items[i].label || items[i].name) || "")
          .toLowerCase() === label
      ){
        return items[i];
      }
    }
  }

  return null;
}

function diqV516CloseShelf(){
  var panel = document.getElementById("diqAdventureDestResults");
  var list = document.getElementById("diqDestList");

  destinationResultOpen = false;

  if(panel){
    panel.className = "";
    panel.setAttribute("aria-hidden","true");
    panel.style.setProperty("display","none","important");
    panel.style.setProperty("visibility","hidden","important");
    panel.style.setProperty("opacity","0","important");
    panel.style.setProperty("pointer-events","none","important");
  }

  if(list){
    list.style.removeProperty("overflow-y");
    list.style.removeProperty("overflow-x");
    list.style.removeProperty("touch-action");
  }

  try{
    if(typeof resetDestinationChooserInlineLayout === "function"){
      resetDestinationChooserInlineLayout(panel);
    }
  }catch(e0){}

  try{
    if(document.body){
      document.body.classList.add("adventureScanResultsMode");
      document.body.classList.remove("adventurePlacePreviewMode");
    }
  }catch(e1){}
}

function diqV516EnableMap(){
  var node = document.getElementById("adventureMap");

  try{
    if(map){
      if(map.stop){ map.stop(); }
      if(map.dragPan){ map.dragPan.enable(); }
      if(map.scrollZoom){ map.scrollZoom.enable(); }
      if(map.touchZoomRotate){ map.touchZoomRotate.enable(); }
      if(map.touchPitch){ map.touchPitch.enable(); }
      if(map.doubleClickZoom){ map.doubleClickZoom.enable(); }
      if(map.resize){ map.resize(); }
      if(map.triggerRepaint){ map.triggerRepaint(); }
    }
  }catch(e0){}

  if(node){
    node.style.setProperty("pointer-events","auto","important");
    node.style.setProperty("touch-action","none","important");
  }
}

function diqV516CenterSelected(item){
  var lat = Number(item && item.lat);
  var lng = Number(item && item.lng);
  var district = diqV516IsDistrict(item);
  var zoom = district ? 14.2 : 16.4;

  if(!diqV516Finite(lat) || !diqV516Finite(lng)){ return; }

  try{
    adventurePreferred = item;
  }catch(e0){}

  try{
    if(adventureResults && adventureResults.length){
      renderResultPins(adventureResults,item);
    }
  }catch(e1){}

  try{
    if(map && mapLoaded){
      map.stop();
      map.easeTo({
        center:[lng,lat],
        zoom:Math.max(Number(map.getZoom ? map.getZoom() : zoom),zoom),
        duration:520,
        essential:true,
        padding:{
          top:110,
          right:28,
          bottom:district ? 260 : 330,
          left:28
        }
      });
    }
  }catch(e2){
    try{
      if(map && map.jumpTo){
        map.jumpTo({center:[lng,lat],zoom:zoom});
      }
    }catch(e3){}
  }
}

function diqV516OpenDetail(item){
  if(!item){ return false; }

  diqV516SelectedItem = item;
  diqV516SelectedAt = Date.now ? Date.now() : (new Date()).getTime();

  /* V517: A result-card tap previews a business inside the active scan area.
     It must NOT replace the committed city/region destination. Doing so caused
     Destination Identity Lock to restore the Adventure menu instead of opening
     the selected Place IQ card. */
  try{
    window.__driveIQAdventureSelectedPreview = item;
  }catch(e0){}

  try{
    localStorage.setItem(
      "diq_adventure_selected_place_v1",
      JSON.stringify(item)
    );
  }catch(e1){}

  diqV516CloseShelf();
  diqV516EnableMap();

  try{
    closeAdventureInfoCard();
  }catch(e2){}

  window.setTimeout(function(){
    try{
      /* false keeps Place IQ from restoring the broad browse camera. */
      openAdventureInfoCard(item,false);

      if(diqV516IsDistrict(item)){
        try{
          if(typeof diqV109DecorateInfoCard === "function"){
            diqV109DecorateInfoCard(item);
          }
        }catch(eDistrict){}
      }
    }catch(e3){
      try{
        if(window.DriveIQAdventureRuntime &&
           typeof window.DriveIQAdventureRuntime.openPlace === "function"){
          window.DriveIQAdventureRuntime.openPlace(item);
        }
      }catch(e4){}
    }

    /* Run the selected-place camera authority after the existing Place IQ
       opener finishes hiding the shelf and repainting the selected pin. */
    diqV516CenterSelected(item);
    diqV516EnableMap();
    window.setTimeout(function(){
      diqV516CenterSelected(item);
      diqV516EnableMap();
    },220);
  },120);

  try{
    toast(
      (diqV516IsDistrict(item) ? "Exploring " : "Showing ") +
      String(item.label || item.name || "place")
    );
  }catch(e5){}

  return true;
}

function diqV516FindCard(target){
  var node = target;

  while(node && node !== document){
    if(
      node.nodeType === 1 &&
      node.classList &&
      node.classList.contains("diqDestItem") &&
      (
        node.hasAttribute("data-adv-idx") ||
        node.hasAttribute("data-dest-idx")
      )
    ){
      return node;
    }
    node = node.parentNode;
  }

  return null;
}

function diqV516HandleSelection(event){
  var panel = document.getElementById("diqAdventureDestResults");
  var card;
  var item;

  if(!panel || !panel.contains(event.target)){ return; }

  card = diqV516FindCard(event.target);
  if(!card){ return; }

  item = diqV516ResolveItem(card);
  if(!item){ return; }

  if(event.preventDefault){ event.preventDefault(); }
  if(event.stopPropagation){ event.stopPropagation(); }
  if(event.stopImmediatePropagation){ event.stopImmediatePropagation(); }

  diqV516OpenDetail(item);
}

function diqV516Bind(){
  var panel = document.getElementById("diqAdventureDestResults");

  if(!panel || panel.__diqV516SelectionBound){ return; }
  panel.__diqV516SelectionBound = true;

  /* Capture phase guarantees this final handoff runs before stale inline
     onclick handlers or older shelf decorators. */
  panel.addEventListener("click",diqV516HandleSelection,true);
}

function diqV516RebindAfterRender(){
  diqV516Bind();
  diqV516EnableMap();
}

if(document.readyState === "loading"){
  document.addEventListener("DOMContentLoaded",diqV516Bind,false);
}else{
  diqV516Bind();
}

window.setTimeout(diqV516Bind,300);
window.setTimeout(diqV516Bind,900);
window.setTimeout(diqV516Bind,1800);

try{
  if(typeof renderAdventureScanChoices === "function"){
    var diqV516PriorRenderChoices = renderAdventureScanChoices;

    renderAdventureScanChoices = function(items,query){
      var result = diqV516PriorRenderChoices.apply(this,arguments);
      window.setTimeout(diqV516RebindAfterRender,30);
      window.setTimeout(diqV516RebindAfterRender,220);
      return result;
    };
  }
}catch(eRender){}

window.DriveIQAdventureV516 = {
  build:"V517_PLACE_PREVIEW_IDENTITY_SAFE_HANDOFF",
  select:diqV516OpenDetail,
  selected:function(){ return diqV516SelectedItem; },
  bind:diqV516Bind
};

try{
  console.log(
    "âœ… Drive IQ Adventure V516 result selection + Place IQ handoff loaded"
  );
}catch(ePublic){}

}());



/* =========================================================
   DRIVE IQ ADVENTURE MODE V518
   MAP-FIRST RESULTS SHELF + SAFE PLACE SELECTION AUTHORITY

   Fixes verified field issues:
   - Scan results may not become a full-screen blocking modal.
   - The results shelf can be minimized and reopened without rescanning.
   - Map gestures remain available after scan completion.
   - Tapping a result can never follow a stale href or leave the app.
   - One exact result opens the existing Place IQ card, where Route Here owns
     the navigation handoff.
   ES5 SAFE
========================================================= */
(function(){
"use strict";

if(window.__DRIVE_IQ_ADVENTURE_V518_MAP_FIRST_SAFE_SELECTION__){ return; }
window.__DRIVE_IQ_ADVENTURE_V518_MAP_FIRST_SAFE_SELECTION__ = true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD =
  "V518_MAP_FIRST_SAFE_PLACE_SELECTION";

var V518 = {
  minimized:false,
  lastHandledAt:0,
  lastHandledNode:null,
  suppressClickUntil:0
};

function v518ById(id){ return document.getElementById(id); }
function v518Finite(v){ return typeof v === "number" && isFinite(v); }
function v518Now(){ return Date.now ? Date.now() : (new Date()).getTime(); }

function v518Panel(){ return v518ById("diqAdventureDestResults"); }
function v518List(){ return v518ById("diqDestList"); }

function v518IsScanMode(){
  return !!(
    document.body &&
    String(document.body.className || "").indexOf("adventureScanResultsMode") > -1
  );
}

function v518Results(){
  /* Scan cards are rendered from adventureResults. Never let destination
     autocomplete results replace the selected business identity. */
  if(window.DriveIQAdventureV516 &&
     typeof window.DriveIQAdventureV516.selected === "function"){
    /* Presence confirms the final interaction layer is available, but the
       visible shelf still resolves against the active scan arrays below. */
  }
  try{
    if(adventureResults && adventureResults.length){ return adventureResults; }
  }catch(e0){}
  try{
    if(exploreResults && exploreResults.length){ return exploreResults; }
  }catch(e1){}
  try{
    if(destinationSearchResults && destinationSearchResults.length){
      return destinationSearchResults;
    }
  }catch(e2){}
  return [];
}

function v518FindCard(target){
  var node=target;
  while(node && node !== document){
    if(node.nodeType === 1 && node.classList &&
       node.classList.contains("diqDestItem") &&
       (node.hasAttribute("data-adv-idx") ||
        node.hasAttribute("data-dest-idx"))){
      return node;
    }
    node=node.parentNode;
  }
  return null;
}

function v518Resolve(card){
  var items=v518Results();
  var raw;
  var idx;
  var label="";
  var nameNode;
  var i;

  if(!card){ return null; }

  raw=card.getAttribute("data-adv-idx");
  if(raw === null || raw === ""){
    raw=card.getAttribute("data-dest-idx");
  }
  idx=Number(raw);

  if(isFinite(idx) && idx >= 0 && items[idx]){ return items[idx]; }

  try{
    nameNode=card.querySelector(".diqDestName");
    label=String(
      card.getAttribute("data-place-label") ||
      (nameNode && nameNode.textContent) ||
      card.getAttribute("aria-label") ||
      ""
    ).toLowerCase().replace(/\s+/g," ").trim();
  }catch(e0){}

  if(label){
    for(i=0;i<items.length;i++){
      if(String(items[i] && (items[i].label || items[i].name) || "")
        .toLowerCase().replace(/\s+/g," ").trim() === label){
        return items[i];
      }
    }
  }

  return null;
}

function v518EnableMap(){
  var node=v518ById("adventureMap");
  try{
    if(map){
      if(map.stop){ map.stop(); }
      if(map.dragPan){ map.dragPan.enable(); }
      if(map.scrollZoom){ map.scrollZoom.enable(); }
      if(map.touchZoomRotate){ map.touchZoomRotate.enable(); }
      if(map.touchPitch){ map.touchPitch.enable(); }
      if(map.doubleClickZoom){ map.doubleClickZoom.enable(); }
      if(map.keyboard){ map.keyboard.enable(); }
      if(map.resize){ map.resize(); }
      if(map.triggerRepaint){ map.triggerRepaint(); }
    }
  }catch(e0){}

  if(node){
    node.style.setProperty("pointer-events","auto","important");
    node.style.setProperty("touch-action","none","important");
  }
}

function v518CleanCards(){
  var panel=v518Panel();
  var links;
  var buttons;
  var i;
  if(!panel){ return; }

  try{
    links=panel.querySelectorAll(".diqDestItem a[href]");
    for(i=0;i<links.length;i++){
      links[i].setAttribute("data-diq-v518-old-href",links[i].getAttribute("href") || "");
      links[i].removeAttribute("href");
      links[i].removeAttribute("target");
    }
  }catch(e0){}

  try{
    buttons=panel.querySelectorAll(".diqDestItem button");
    for(i=0;i<buttons.length;i++){
      buttons[i].type="button";
    }
  }catch(e1){}
}

function v518Center(item){
  var lat=Number(item && item.lat);
  var lng=Number(item && item.lng);
  if(!v518Finite(lat) || !v518Finite(lng)){ return; }

  try{ adventurePreferred=item; }catch(e0){}
  try{
    if(adventureResults && adventureResults.length){
      renderResultPins(adventureResults,item);
    }
  }catch(e1){}

  try{
    if(map && mapLoaded){
      map.stop();
      map.easeTo({
        center:[lng,lat],
        zoom:Math.max(Number(map.getZoom ? map.getZoom() : 15.8),15.8),
        duration:420,
        essential:true,
        padding:{top:105,right:24,bottom:300,left:24}
      });
    }
  }catch(e2){}
}

function v518Minimize(){
  var panel=v518Panel();
  var reopen=v518ById("diqV518Reopen");
  V518.minimized=true;

  if(panel){
    panel.classList.add("diqV518Minimized");
    panel.setAttribute("aria-hidden","true");
  }
  if(reopen){ reopen.className="on"; }
  v518EnableMap();
}

function v518Show(){
  var panel=v518Panel();
  var reopen=v518ById("diqV518Reopen");
  V518.minimized=false;

  if(panel){
    panel.classList.remove("diqV518Minimized");
    if(String(panel.className || "").indexOf("on") < 0){
      panel.className=(String(panel.className || "") + " on diqModeShelf")
        .replace(/\s+/g," ").trim();
    }
    panel.setAttribute("aria-hidden","false");
    panel.style.removeProperty("display");
    panel.style.removeProperty("visibility");
    panel.style.removeProperty("opacity");
    panel.style.removeProperty("pointer-events");
  }
  if(reopen){ reopen.className=""; }
  v518Apply();
}

function v518EnsureControls(){
  var panel=v518Panel();
  var head;
  var minimize;
  var reopen;
  if(!panel){ return; }

  head=panel.querySelector(".diqDestHead");
  if(head && !v518ById("diqV518Minimize")){
    minimize=document.createElement("button");
    minimize.type="button";
    minimize.id="diqV518Minimize";
    minimize.setAttribute("aria-label","Minimize places and explore map");
    minimize.innerHTML="&#8212;";
    minimize.onclick=function(event){
      if(event && event.preventDefault){ event.preventDefault(); }
      if(event && event.stopPropagation){ event.stopPropagation(); }
      v518Minimize();
      return false;
    };
    head.appendChild(minimize);
  }

  reopen=v518ById("diqV518Reopen");
  if(!reopen){
    reopen=document.createElement("button");
    reopen.type="button";
    reopen.id="diqV518Reopen";
    reopen.textContent="PLACES";
    reopen.setAttribute("aria-label","Show scanned places");
    reopen.onclick=function(event){
      if(event && event.preventDefault){ event.preventDefault(); }
      if(event && event.stopPropagation){ event.stopPropagation(); }
      v518Show();
      return false;
    };
    try{ document.body.appendChild(reopen); }catch(e0){}
  }
}

function v518Open(item){
  if(!item){ return false; }

  try{
    window.__driveIQAdventureSelectedPreview=item;
    localStorage.setItem("diq_adventure_selected_place_v1",JSON.stringify(item));
  }catch(e0){}

  v518Minimize();
  v518Center(item);
  v518EnableMap();

  window.setTimeout(function(){
    var opened=false;
    try{
      if(window.DriveIQAdventureV516 &&
         typeof window.DriveIQAdventureV516.select === "function"){
        opened=window.DriveIQAdventureV516.select(item) !== false;
      }
    }catch(e1){}

    if(!opened){
      try{
        if(typeof openAdventureInfoCard === "function"){
          openAdventureInfoCard(item,false);
          opened=true;
        }
      }catch(e2){}
    }

    if(!opened){
      try{
        if(window.DriveIQAdventureRuntime &&
           typeof window.DriveIQAdventureRuntime.openPlace === "function"){
          window.DriveIQAdventureRuntime.openPlace(item);
        }
      }catch(e3){}
    }

    v518Center(item);
    v518EnableMap();
  },40);

  return true;
}

function v518Handle(event){
  var panel=v518Panel();
  var card;
  var item;
  var now=v518Now();

  if(!panel || !v518IsScanMode() || !panel.contains(event.target)){ return; }
  if(event.target && (
    event.target.id === "diqV518Minimize" ||
    event.target.id === "diqDestClose"
  )){ return; }

  card=v518FindCard(event.target);
  if(!card){ return; }

  item=v518Resolve(card);
  if(!item){ return; }

  if(event.preventDefault){ event.preventDefault(); }
  if(event.stopPropagation){ event.stopPropagation(); }
  if(event.stopImmediatePropagation){ event.stopImmediatePropagation(); }

  /* pointerup is the primary iOS/WKWebView selection event. Suppress the
     synthetic click that follows so no stale inline handler can navigate. */
  if(event.type === "pointerup" || event.type === "touchend"){
    V518.suppressClickUntil=now + 900;
  }else if(event.type === "click" && now < V518.suppressClickUntil){
    return false;
  }

  if(V518.lastHandledNode === card && now - V518.lastHandledAt < 700){
    return false;
  }

  V518.lastHandledNode=card;
  V518.lastHandledAt=now;
  v518Open(item);
  return false;
}

function v518Apply(){
  var panel=v518Panel();
  var list=v518List();
  if(!panel || !v518IsScanMode()){ return; }

  v518EnsureControls();
  v518CleanCards();
  v518EnableMap();

  panel.classList.add("diqModeShelf");
  panel.classList.remove("diqModeDestination");

  if(!V518.minimized){
    panel.classList.remove("diqV518Minimized");
    panel.setAttribute("aria-hidden","false");
  }

  if(list){
    list.style.setProperty("overflow-y","auto","important");
    list.style.setProperty("overflow-x","hidden","important");
    list.style.setProperty("touch-action","pan-y","important");
  }
}

function v518InjectStyles(){
  var style;
  var css;
  if(v518ById("diqV518Styles")){ return; }

  css=
    "body.adventureScanResultsMode #diqAdventureDestResults.on," +
    "body.adventureScanResultsMode #diqAdventureDestResults.diqModeShelf{" +
      "position:fixed!important;" +
      "left:18px!important;right:18px!important;" +
      "top:auto!important;" +
      "bottom:calc(108px + env(safe-area-inset-bottom,0px))!important;" +
      "width:auto!important;height:auto!important;" +
      "max-height:43vh!important;" +
      "display:flex!important;flex-direction:column!important;" +
      "overflow:hidden!important;" +
      "z-index:260!important;" +
      "transform:none!important;" +
    "}" +
    "body.adventureScanResultsMode #diqAdventureDestResults #diqDestList{" +
      "flex:1 1 auto!important;min-height:0!important;" +
      "max-height:calc(43vh - 54px)!important;" +
      "overflow-y:auto!important;overflow-x:hidden!important;" +
      "-webkit-overflow-scrolling:touch!important;" +
      "touch-action:pan-y!important;" +
    "}" +
    "body.adventureScanResultsMode #diqAdventureDestResults.diqV518Minimized{" +
      "display:none!important;visibility:hidden!important;opacity:0!important;" +
      "pointer-events:none!important;" +
    "}" +
    "#diqV518Minimize{" +
      "position:absolute!important;right:52px!important;top:8px!important;" +
      "width:38px!important;height:38px!important;min-width:38px!important;" +
      "padding:0!important;border-radius:13px!important;" +
      "border:1px solid rgba(255,255,255,.15)!important;" +
      "background:rgba(255,255,255,.07)!important;color:#fff!important;" +
      "font-size:22px!important;font-weight:900!important;line-height:1!important;" +
      "z-index:12!important;" +
    "}" +
    "#diqV518Reopen{" +
      "display:none!important;position:fixed!important;" +
      "right:18px!important;bottom:calc(116px + env(safe-area-inset-bottom,0px))!important;" +
      "z-index:265!important;padding:12px 18px!important;border-radius:999px!important;" +
      "border:1px solid rgba(40,255,190,.40)!important;" +
      "background:linear-gradient(135deg,#ffe07a,#28ffbe)!important;" +
      "color:#071018!important;font:1000 13px/1 -apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif!important;" +
      "letter-spacing:.9px!important;box-shadow:0 14px 34px rgba(0,0,0,.45)!important;" +
    "}" +
    "#diqV518Reopen.on{display:block!important;}" +
    "@media(max-height:720px){" +
      "body.adventureScanResultsMode #diqAdventureDestResults.on," +
      "body.adventureScanResultsMode #diqAdventureDestResults.diqModeShelf{" +
        "max-height:38vh!important;" +
      "}" +
      "body.adventureScanResultsMode #diqAdventureDestResults #diqDestList{" +
        "max-height:calc(38vh - 50px)!important;" +
      "}" +
    "}";

  style=document.createElement("style");
  style.id="diqV518Styles";
  style.type="text/css";
  style.appendChild(document.createTextNode(css));
  try{ (document.head || document.documentElement).appendChild(style); }catch(e0){}
}

function v518Bind(){
  v518InjectStyles();
  v518EnsureControls();
  v518Apply();

  /* Document capture survives complete shelf rerenders. */
  if(!document.__diqV518SelectionBound){
    document.__diqV518SelectionBound=true;
    if(window.PointerEvent){
      document.addEventListener("pointerup",v518Handle,true);
    }else{
      document.addEventListener("touchend",v518Handle,true);
    }
    document.addEventListener("click",v518Handle,true);
  }
}

if(document.readyState === "loading"){
  document.addEventListener("DOMContentLoaded",v518Bind,false);
}else{
  v518Bind();
}

window.setTimeout(v518Bind,250);
window.setTimeout(v518Bind,800);
window.setTimeout(v518Bind,1600);

try{
  if(typeof afterScanResultsReady === "function"){
    var v518PriorAfterReady=afterScanResultsReady;
    afterScanResultsReady=function(items,preferred,reason){
      var result=v518PriorAfterReady.apply(this,arguments);
      V518.minimized=false;
      window.setTimeout(v518Apply,30);
      window.setTimeout(v518Apply,180);
      window.setTimeout(v518Apply,500);
      return result;
    };
  }
}catch(eReady){}

try{
  if(typeof renderAdventureScanChoices === "function"){
    var v518PriorRender=renderAdventureScanChoices;
    renderAdventureScanChoices=function(items,query){
      var result=v518PriorRender.apply(this,arguments);
      V518.minimized=false;
      window.setTimeout(v518Apply,20);
      window.setTimeout(v518Apply,160);
      return result;
    };
  }
}catch(eRender){}

window.DriveIQAdventureV518={
  build:"V518_MAP_FIRST_SAFE_PLACE_SELECTION",
  minimize:v518Minimize,
  show:v518Show,
  open:v518Open,
  apply:v518Apply
};

try{
  console.log("âœ… Drive IQ Adventure V518 map-first safe selection loaded");
}catch(ePublic){}

}());


/* =========================================================
   DRIVE IQ ADVENTURE MODE V519
   SINGLE RESULTS SHELF AUTHORITY

   Final cleanup:
   - The legacy #diqAdventureDestResults panel is never presented after scans.
   - One dedicated compact horizontal shelf owns post-scan browsing.
   - The map remains exposed and interactive.
   - Card taps are forwarded to the proven V518 safe place-selection path.
   - No card tap can navigate away from the app.
   ES5 SAFE
========================================================= */
(function(){
"use strict";

if(window.__DRIVE_IQ_ADVENTURE_V519_SINGLE_RESULTS_SHELF__){ return; }
window.__DRIVE_IQ_ADVENTURE_V519_SINGLE_RESULTS_SHELF__ = true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD = "V519_SINGLE_RESULTS_SHELF_AUTHORITY";

var V519 = {
  open:false,
  minimized:false,
  signature:"",
  syncTimer:null,
  observer:null,
  lastSelectAt:0
};

function v519ById(id){ return document.getElementById(id); }
function v519Now(){ return Date.now ? Date.now() : (new Date()).getTime(); }

function v519LegacyPanel(){
  return v519ById("diqAdventureDestResults");
}

function v519LegacyList(){
  return v519ById("diqDestList");
}

function v519IsScanResults(){
  var body=document.body;
  var panel=v519LegacyPanel();
  var head;
  var cards;

  if(body && String(body.className || "").indexOf("adventureScanResultsMode") > -1){
    return true;
  }

  if(panel){
    try{
      head=panel.querySelector(".diqDestHead");
      cards=panel.querySelectorAll(".diqDestItem[data-adv-idx],.diqDestItem[data-dest-idx]");
      if(
        cards && cards.length &&
        head &&
        String(head.textContent || "").toUpperCase().indexOf("CHOOSE ADVENTURE STOP") > -1
      ){
        return true;
      }
    }catch(e0){}
  }

  return false;
}

function v519InjectStyles(){
  var style;
  var css;

  if(v519ById("diqV519Styles")){ return; }

  css=
    /* Permanently retire the shared legacy post-scan panel. Destination search
       remains separate in #diqV500SearchPanel. */
    "body.diqV519ResultsActive #diqAdventureDestResults{" +
      "display:none!important;visibility:hidden!important;opacity:0!important;" +
      "pointer-events:none!important;position:fixed!important;" +
      "left:-10000px!important;top:-10000px!important;" +
      "width:1px!important;height:1px!important;max-width:1px!important;" +
      "max-height:1px!important;overflow:hidden!important;transform:none!important;" +
    "}" +

    "#diqV519Shelf{" +
      "display:none!important;position:fixed!important;" +
      "left:12px!important;right:12px!important;" +
      "bottom:calc(104px + env(safe-area-inset-bottom,0px))!important;" +
      "height:auto!important;max-height:34vh!important;" +
      "overflow:hidden!important;border-radius:24px!important;" +
      "background:linear-gradient(180deg,rgba(3,10,19,.985),rgba(2,8,16,.995))!important;" +
      "border:1px solid rgba(40,255,190,.34)!important;" +
      "box-shadow:0 24px 58px rgba(0,0,0,.62)!important;" +
      "z-index:420!important;pointer-events:none!important;" +
      "opacity:0!important;transform:translateY(12px)!important;" +
      "transition:opacity .18s ease,transform .18s ease!important;" +
    "}" +

    "#diqV519Shelf.on{" +
      "display:flex!important;flex-direction:column!important;" +
      "pointer-events:auto!important;opacity:1!important;transform:translateY(0)!important;" +
    "}" +

    "#diqV519Shelf.minimized{" +
      "display:none!important;visibility:hidden!important;opacity:0!important;" +
      "pointer-events:none!important;" +
    "}" +

    "#diqV519ShelfHead{" +
      "position:relative!important;display:flex!important;align-items:center!important;" +
      "min-height:50px!important;padding:0 96px 0 16px!important;" +
      "border-bottom:1px solid rgba(255,255,255,.08)!important;" +
      "color:#baffed!important;font-size:10px!important;font-weight:1000!important;" +
      "letter-spacing:1.15px!important;white-space:nowrap!important;" +
    "}" +

    "#diqV519ShelfHead em{" +
      "margin-left:8px!important;font-style:normal!important;color:#ffe1a0!important;" +
    "}" +

    "#diqV519Min,#diqV519Close{" +
      "position:absolute!important;top:7px!important;width:36px!important;height:36px!important;" +
      "min-width:36px!important;padding:0!important;border-radius:12px!important;" +
      "border:1px solid rgba(255,255,255,.15)!important;" +
      "background:rgba(255,255,255,.07)!important;color:#fff!important;" +
      "font-size:20px!important;font-weight:900!important;line-height:1!important;" +
    "}" +
    "#diqV519Min{right:50px!important;}" +
    "#diqV519Close{right:8px!important;font-size:24px!important;}" +

    "#diqV519Track{" +
      "display:flex!important;gap:10px!important;width:100%!important;" +
      "overflow-x:auto!important;overflow-y:hidden!important;" +
      "-webkit-overflow-scrolling:touch!important;overscroll-behavior-x:contain!important;" +
      "scroll-snap-type:x proximity!important;touch-action:pan-x!important;" +
      "padding:10px 10px 14px!important;" +
    "}" +

    "#diqV519Track .diqV519Card{" +
      "position:relative!important;display:block!important;flex:0 0 min(82vw,360px)!important;" +
      "width:min(82vw,360px)!important;min-height:132px!important;" +
      "margin:0!important;padding:13px 13px 13px 112px!important;" +
      "text-align:left!important;color:#fff!important;border-radius:18px!important;" +
      "border:1px solid rgba(255,255,255,.13)!important;" +
      "background:linear-gradient(145deg,rgba(255,255,255,.075),rgba(255,255,255,.028))!important;" +
      "overflow:hidden!important;scroll-snap-align:start!important;" +
    "}" +

    "#diqV519Track .diqDestThumb{" +
      "position:absolute!important;left:12px!important;top:12px!important;" +
      "width:88px!important;height:88px!important;border-radius:15px!important;" +
      "overflow:hidden!important;background-size:cover!important;background-position:center!important;" +
    "}" +

    "#diqV519Track .diqDestName{" +
      "font-size:18px!important;line-height:1.08!important;font-weight:1000!important;" +
      "display:-webkit-box!important;-webkit-line-clamp:2!important;" +
      "-webkit-box-orient:vertical!important;overflow:hidden!important;" +
    "}" +

    "#diqV519Track .diqDestSub{" +
      "margin-top:5px!important;font-size:12px!important;line-height:1.2!important;" +
      "font-weight:700!important;color:rgba(255,255,255,.72)!important;" +
      "display:-webkit-box!important;-webkit-line-clamp:2!important;" +
      "-webkit-box-orient:vertical!important;overflow:hidden!important;" +
    "}" +

    "#diqV519Track .diqDestMeta{" +
      "margin-top:7px!important;font-size:9px!important;line-height:1.15!important;" +
      "font-weight:1000!important;letter-spacing:.7px!important;text-transform:uppercase!important;" +
      "color:#ffe29a!important;display:-webkit-box!important;-webkit-line-clamp:2!important;" +
      "-webkit-box-orient:vertical!important;overflow:hidden!important;" +
    "}" +

    "#diqV519Reopen{" +
      "display:none!important;position:fixed!important;right:16px!important;" +
      "bottom:calc(112px + env(safe-area-inset-bottom,0px))!important;" +
      "z-index:425!important;padding:12px 17px!important;border-radius:999px!important;" +
      "border:1px solid rgba(40,255,190,.38)!important;" +
      "background:linear-gradient(135deg,#ffe07a,#28ffbe)!important;" +
      "color:#071018!important;font:1000 12px/1 -apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif!important;" +
      "letter-spacing:.85px!important;box-shadow:0 12px 30px rgba(0,0,0,.42)!important;" +
    "}" +
    "#diqV519Reopen.on{display:block!important;}" +

    "@media(max-height:720px){" +
      "#diqV519Shelf{max-height:30vh!important;}" +
      "#diqV519Track .diqV519Card{min-height:118px!important;}" +
    "}";

  style=document.createElement("style");
  style.id="diqV519Styles";
  style.type="text/css";
  style.appendChild(document.createTextNode(css));
  try{ (document.head || document.documentElement).appendChild(style); }catch(e0){}
}

function v519Ensure(){
  var shelf=v519ById("diqV519Shelf");
  var min;
  var close;
  var reopen;

  if(!shelf){
    shelf=document.createElement("section");
    shelf.id="diqV519Shelf";
    shelf.setAttribute("aria-hidden","true");
    shelf.innerHTML=
      '<div id="diqV519ShelfHead">' +
        '<span>PLACES WORTH EXPLORING</span><em>â€¢ MAP FIRST</em>' +
        '<button id="diqV519Min" type="button" aria-label="Minimize places">&#8212;</button>' +
        '<button id="diqV519Close" type="button" aria-label="Close places">&times;</button>' +
      '</div>' +
      '<div id="diqV519Track"></div>';
    try{ document.body.appendChild(shelf); }catch(e0){}
  }

  reopen=v519ById("diqV519Reopen");
  if(!reopen){
    reopen=document.createElement("button");
    reopen.type="button";
    reopen.id="diqV519Reopen";
    reopen.textContent="PLACES";
    reopen.setAttribute("aria-label","Show scanned places");
    try{ document.body.appendChild(reopen); }catch(e1){}
  }

  min=v519ById("diqV519Min");
  if(min && !min.__diqV519Bound){
    min.__diqV519Bound=true;
    min.onclick=function(event){
      if(event && event.preventDefault){ event.preventDefault(); }
      if(event && event.stopPropagation){ event.stopPropagation(); }
      v519Minimize();
      return false;
    };
  }

  close=v519ById("diqV519Close");
  if(close && !close.__diqV519Bound){
    close.__diqV519Bound=true;
    close.onclick=function(event){
      if(event && event.preventDefault){ event.preventDefault(); }
      if(event && event.stopPropagation){ event.stopPropagation(); }
      v519Close();
      return false;
    };
  }

  if(reopen && !reopen.__diqV519Bound){
    reopen.__diqV519Bound=true;
    reopen.onclick=function(event){
      if(event && event.preventDefault){ event.preventDefault(); }
      if(event && event.stopPropagation){ event.stopPropagation(); }
      v519Open();
      return false;
    };
  }

  return shelf;
}

function v519EnableMap(){
  var mapNode=v519ById("adventureMap");

  try{
    if(window.map){
      if(window.map.dragPan){ window.map.dragPan.enable(); }
      if(window.map.scrollZoom){ window.map.scrollZoom.enable(); }
      if(window.map.touchZoomRotate){ window.map.touchZoomRotate.enable(); }
      if(window.map.touchPitch){ window.map.touchPitch.enable(); }
      if(window.map.doubleClickZoom){ window.map.doubleClickZoom.enable(); }
      if(window.map.resize){ window.map.resize(); }
      if(window.map.triggerRepaint){ window.map.triggerRepaint(); }
    }
  }catch(e0){}

  if(mapNode){
    mapNode.style.setProperty("pointer-events","auto","important");
    mapNode.style.setProperty("touch-action","none","important");
  }
}

function v519CardSignature(cards){
  var out=[];
  var i;
  var node;

  for(i=0;i<cards.length;i++){
    node=cards[i];
    out.push(
      String(node.getAttribute("data-adv-idx") || node.getAttribute("data-dest-idx") || i) +
      "|" + String(node.textContent || "").replace(/\s+/g," ").trim()
    );
  }

  return out.join("||");
}

function v519ForwardSelection(sourceCard,event){
  var panel=v519LegacyPanel();
  var selector;
  var original;
  var adv;
  var dest;
  var now=v519Now();

  if(now - V519.lastSelectAt < 550){ return false; }
  V519.lastSelectAt=now;

  if(event && event.preventDefault){ event.preventDefault(); }
  if(event && event.stopPropagation){ event.stopPropagation(); }
  if(event && event.stopImmediatePropagation){ event.stopImmediatePropagation(); }

  adv=sourceCard.getAttribute("data-adv-idx");
  dest=sourceCard.getAttribute("data-dest-idx");

  if(panel){
    if(adv !== null && adv !== ""){
      selector='.diqDestItem[data-adv-idx="' + String(adv).replace(/"/g,'\\"') + '"]';
    }else{
      selector='.diqDestItem[data-dest-idx="' + String(dest).replace(/"/g,'\\"') + '"]';
    }

    try{ original=panel.querySelector(selector); }catch(e0){ original=null; }
  }

  v519Minimize();
  v519EnableMap();

  if(original){
    try{
      if(window.PointerEvent){
        original.dispatchEvent(new PointerEvent("pointerup",{
          bubbles:true,
          cancelable:true,
          pointerType:"touch",
          isPrimary:true
        }));
      }else{
        original.dispatchEvent(new MouseEvent("click",{
          bubbles:true,
          cancelable:true,
          view:window
        }));
      }
      return false;
    }catch(e1){}
  }

  /* Last-resort fallback: ask V518 to re-apply its resolver, then click the
     original card. Routing is still never called directly here. */
  try{
    if(window.DriveIQAdventureV518 &&
       typeof window.DriveIQAdventureV518.apply === "function"){
      window.DriveIQAdventureV518.apply();
    }
  }catch(e2){}

  return false;
}

function v519RenderFromLegacy(){
  var list=v519LegacyList();
  var track=v519ById("diqV519Track");
  var cards;
  var signature;
  var i;
  var original;
  var clone;
  var links;

  if(!list || !track || !v519IsScanResults()){ return false; }

  try{
    cards=list.querySelectorAll(".diqDestItem[data-adv-idx],.diqDestItem[data-dest-idx]");
  }catch(e0){
    cards=[];
  }

  if(!cards || !cards.length){ return false; }

  signature=v519CardSignature(cards);
  if(signature === V519.signature && track.children.length){
    return true;
  }

  V519.signature=signature;
  track.innerHTML="";

  for(i=0;i<cards.length;i++){
    original=cards[i];
    clone=original.cloneNode(true);
    clone.className=(String(clone.className || "") + " diqV519Card")
      .replace(/\s+/g," ").trim();

    clone.removeAttribute("href");
    clone.removeAttribute("target");
    clone.removeAttribute("onclick");
    clone.setAttribute("role","button");
    clone.setAttribute("tabindex","0");

    try{
      links=clone.querySelectorAll("a[href]");
      for(var j=0;j<links.length;j++){
        links[j].removeAttribute("href");
        links[j].removeAttribute("target");
      }
    }catch(e1){}

    clone.onclick=function(event){
      return v519ForwardSelection(this,event);
    };
    clone.onkeydown=function(event){
      var key=event && (event.key || event.keyCode);
      if(key === "Enter" || key === " " || key === 13 || key === 32){
        return v519ForwardSelection(this,event);
      }
    };

    track.appendChild(clone);
  }

  v519Open();
  return true;
}

function v519Open(){
  var shelf=v519Ensure();
  var reopen=v519ById("diqV519Reopen");

  V519.open=true;
  V519.minimized=false;

  if(document.body){ document.body.classList.add("diqV519ResultsActive"); }
  if(shelf){
    shelf.className="on";
    shelf.setAttribute("aria-hidden","false");
  }
  if(reopen){ reopen.className=""; }

  v519EnableMap();
}

function v519Minimize(){
  var shelf=v519Ensure();
  var reopen=v519ById("diqV519Reopen");

  V519.open=false;
  V519.minimized=true;

  if(document.body){ document.body.classList.add("diqV519ResultsActive"); }
  if(shelf){
    shelf.className="minimized";
    shelf.setAttribute("aria-hidden","true");
  }
  if(reopen){ reopen.className="on"; }

  v519EnableMap();
}

function v519Close(){
  var shelf=v519Ensure();
  var reopen=v519ById("diqV519Reopen");

  V519.open=false;
  V519.minimized=false;

  if(shelf){
    shelf.className="";
    shelf.setAttribute("aria-hidden","true");
  }
  if(reopen){ reopen.className=""; }

  v519EnableMap();
}

function v519Sync(){
  if(!v519IsScanResults()){ return; }

  if(document.body){ document.body.classList.add("diqV519ResultsActive"); }

  /* Keep the old panel available only as hidden data/selection authority. */
  v519RenderFromLegacy();
  v519EnableMap();
}

function v519Schedule(){
  if(V519.syncTimer){ window.clearTimeout(V519.syncTimer); }
  V519.syncTimer=window.setTimeout(v519Sync,20);
  window.setTimeout(v519Sync,120);
  window.setTimeout(v519Sync,320);
}

function v519Bind(){
  var panel=v519LegacyPanel();

  v519InjectStyles();
  v519Ensure();
  v519Schedule();

  if(window.MutationObserver && panel && !V519.observer){
    try{
      V519.observer=new MutationObserver(function(){
        v519Schedule();
      });
      V519.observer.observe(panel,{
        childList:true,
        subtree:true,
        characterData:true,
        attributes:true,
        attributeFilter:["class","aria-hidden"]
      });
    }catch(e0){}
  }

  document.addEventListener("driveiq:adventureScanStarted",function(){
    V519.signature="";
    v519Close();
  },false);

  document.addEventListener("driveiq:adventureScanComplete",v519Schedule,false);
  document.addEventListener("driveiq:adventureResultsShown",v519Schedule,false);

  document.addEventListener("visibilitychange",function(){
    if(!document.hidden){ v519Schedule(); }
  },false);
}

if(document.readyState === "loading"){
  document.addEventListener("DOMContentLoaded",v519Bind,false);
}else{
  v519Bind();
}

window.setTimeout(v519Bind,300);
window.setTimeout(v519Bind,900);
window.setTimeout(v519Bind,1800);

window.DriveIQAdventureV519={
  build:"V519_SINGLE_RESULTS_SHELF_AUTHORITY",
  sync:v519Sync,
  open:v519Open,
  minimize:v519Minimize,
  close:v519Close
};

try{
  console.log("âœ… Drive IQ Adventure V519 single results shelf authority loaded");
}catch(ePublic){}

}());


/* =========================================================
   DRIVE IQ ADVENTURE MODE V520
   RESULTS CARD TAP AUTHORITY â€” DIRECT PLACE IQ HANDOFF

   Fixes the iPhone/WKWebView issue where tapping a scanned-place card
   bubbled into legacy destination-menu close handlers and kicked the user
   back to the menu instead of opening Place IQ.

   Rules:
   - The visible V519 results shelf owns all card pointer/touch/click events.
   - No synthetic event is forwarded to the hidden legacy destination panel.
   - The selected scan item is resolved directly and handed to V516 Place IQ.
   - Legacy document/backdrop handlers never see the card tap.
   ES5 SAFE
========================================================= */
(function(){
"use strict";

if(window.__DRIVE_IQ_ADVENTURE_V520_DIRECT_CARD_HANDOFF__){ return; }
window.__DRIVE_IQ_ADVENTURE_V520_DIRECT_CARD_HANDOFF__ = true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD =
  "V520_DIRECT_RESULTS_CARD_HANDOFF";

var V520 = {
  lastAt:0,
  lastCard:null,
  bound:false
};

function v520ById(id){ return document.getElementById(id); }
function v520Now(){ return Date.now ? Date.now() : (new Date()).getTime(); }

function v520FindCard(target){
  var node=target;

  while(node && node !== document){
    if(
      node.nodeType === 1 &&
      node.classList &&
      node.classList.contains("diqV519Card") &&
      (
        node.hasAttribute("data-adv-idx") ||
        node.hasAttribute("data-dest-idx")
      )
    ){
      return node;
    }
    node=node.parentNode;
  }

  return null;
}

function v520Results(){
  try{
    if(adventureResults && adventureResults.length){
      return adventureResults;
    }
  }catch(e0){}

  try{
    if(exploreResults && exploreResults.length){
      return exploreResults;
    }
  }catch(e1){}

  try{
    if(destinationSearchResults && destinationSearchResults.length){
      return destinationSearchResults;
    }
  }catch(e2){}

  return [];
}

function v520Resolve(card){
  var items=v520Results();
  var raw;
  var idx;
  var label="";
  var nameNode;
  var i;
  var itemName;

  if(!card){ return null; }

  raw=card.getAttribute("data-adv-idx");
  if(raw === null || raw === ""){
    raw=card.getAttribute("data-dest-idx");
  }

  idx=Number(raw);
  if(isFinite(idx) && idx >= 0 && items[idx]){
    return items[idx];
  }

  try{
    nameNode=card.querySelector(".diqDestName");
    label=String(
      card.getAttribute("data-place-label") ||
      (nameNode && nameNode.textContent) ||
      card.getAttribute("aria-label") ||
      ""
    ).toLowerCase().replace(/\s+/g," ").trim();
  }catch(e0){}

  if(!label){ return null; }

  for(i=0;i<items.length;i++){
    itemName=String(
      items[i] && (items[i].label || items[i].name) || ""
    ).toLowerCase().replace(/\s+/g," ").trim();

    if(itemName === label){ return items[i]; }
  }

  return null;
}

function v520Stop(event){
  if(!event){ return; }
  if(event.preventDefault){ event.preventDefault(); }
  if(event.stopPropagation){ event.stopPropagation(); }
  if(event.stopImmediatePropagation){ event.stopImmediatePropagation(); }
}

function v520Open(item){
  var opened=false;

  if(!item){ return false; }

  try{
    window.__driveIQAdventureSelectedPreview=item;
    localStorage.setItem(
      "diq_adventure_selected_place_v1",
      JSON.stringify(item)
    );
  }catch(e0){}

  /* Hide only the visible scan shelf. Never invoke destination-menu close
     authority, because that layer can restore the Adventure chooser. */
  try{
    if(window.DriveIQAdventureV519 &&
       typeof window.DriveIQAdventureV519.minimize === "function"){
      window.DriveIQAdventureV519.minimize();
    }
  }catch(e1){}

  try{
    if(window.DriveIQAdventureV516 &&
       typeof window.DriveIQAdventureV516.select === "function"){
      opened=window.DriveIQAdventureV516.select(item) !== false;
    }
  }catch(e2){}

  if(!opened){
    try{
      if(typeof openAdventureInfoCard === "function"){
        openAdventureInfoCard(item,false);
        opened=true;
      }
    }catch(e3){}
  }

  if(!opened){
    try{
      if(window.DriveIQAdventureRuntime &&
         typeof window.DriveIQAdventureRuntime.openPlace === "function"){
        window.DriveIQAdventureRuntime.openPlace(item);
        opened=true;
      }
    }catch(e4){}
  }

  return opened;
}

function v520Handle(event){
  var shelf=v520ById("diqV519Shelf");
  var card;
  var item;
  var now;

  if(!shelf || !shelf.contains(event.target)){ return; }

  /* Shelf controls keep their own handlers. */
  if(event.target && (
    event.target.id === "diqV519Min" ||
    event.target.id === "diqV519Close"
  )){
    return;
  }

  card=v520FindCard(event.target);
  if(!card){
    /* Still prevent taps inside the shelf from reaching old outside-click
       destination handlers. Scrolling remains available because pointermove
       is not cancelled. */
    if(event.type === "click"){
      if(event.stopPropagation){ event.stopPropagation(); }
      if(event.stopImmediatePropagation){ event.stopImmediatePropagation(); }
    }
    return;
  }

  /* pointerdown is intercepted early so document-level capture handlers can
     never treat this as an outside-menu tap. Selection happens on pointerup,
     touchend, click, or keyboard activation. */
  if(event.type === "pointerdown" || event.type === "touchstart"){
    if(event.stopPropagation){ event.stopPropagation(); }
    if(event.stopImmediatePropagation){ event.stopImmediatePropagation(); }
    return;
  }

  if(event.type === "keydown"){
    if(!(
      event.key === "Enter" ||
      event.key === " " ||
      event.keyCode === 13 ||
      event.keyCode === 32
    )){
      return;
    }
  }

  item=v520Resolve(card);
  v520Stop(event);
  if(!item){ return false; }

  now=v520Now();
  if(V520.lastCard === card && now - V520.lastAt < 800){
    return false;
  }

  V520.lastCard=card;
  V520.lastAt=now;
  v520Open(item);
  return false;
}

function v520NeutralizeCloneHandlers(){
  var track=v520ById("diqV519Track");
  var cards;
  var i;

  if(!track){ return; }

  try{
    cards=track.querySelectorAll(".diqV519Card");
  }catch(e0){
    cards=[];
  }

  for(i=0;i<cards.length;i++){
    cards[i].onclick=null;
    cards[i].onpointerup=null;
    cards[i].ontouchend=null;
    cards[i].onkeydown=null;
    cards[i].removeAttribute("onclick");
    cards[i].removeAttribute("href");
    cards[i].removeAttribute("target");
    cards[i].setAttribute("role","button");
    cards[i].setAttribute("tabindex","0");
  }
}

function v520Bind(){
  var shelf=v520ById("diqV519Shelf");

  v520NeutralizeCloneHandlers();

  if(!shelf || shelf.__diqV520Bound){ return; }
  shelf.__diqV520Bound=true;

  /* Capture on the shelf itself runs before the event reaches document-level
     legacy menu authority. */
  shelf.addEventListener("pointerdown",v520Handle,true);
  shelf.addEventListener("pointerup",v520Handle,true);
  shelf.addEventListener("touchstart",v520Handle,true);
  shelf.addEventListener("touchend",v520Handle,true);
  shelf.addEventListener("click",v520Handle,true);
  shelf.addEventListener("keydown",v520Handle,true);

  if(window.MutationObserver && !V520.observer){
    try{
      V520.observer=new MutationObserver(function(){
        v520NeutralizeCloneHandlers();
      });
      V520.observer.observe(shelf,{childList:true,subtree:true});
    }catch(e0){}
  }
}

if(document.readyState === "loading"){
  document.addEventListener("DOMContentLoaded",v520Bind,false);
}else{
  v520Bind();
}

window.setTimeout(v520Bind,100);
window.setTimeout(v520Bind,400);
window.setTimeout(v520Bind,1000);
window.setTimeout(v520Bind,2200);

document.addEventListener("driveiq:adventureScanComplete",function(){
  window.setTimeout(v520Bind,40);
  window.setTimeout(v520NeutralizeCloneHandlers,180);
},false);

document.addEventListener("driveiq:adventureResultsShown",function(){
  window.setTimeout(v520Bind,40);
  window.setTimeout(v520NeutralizeCloneHandlers,180);
},false);

window.DriveIQAdventureV520={
  build:"V520_DIRECT_RESULTS_CARD_HANDOFF",
  bind:v520Bind,
  open:v520Open
};

try{
  console.log("âœ… Drive IQ Adventure V520 direct results-card handoff loaded");
}catch(ePublic){}

}());

/* =========================================================
   DRIVE IQ ADVENTURE MODE V521
   POST-SCAN MENU EJECT + RESULTS UNLOCK AUTHORITY

   Fixes the remaining iPhone/WKWebView dead-end where a completed scan
   reopens the destination chooser and traps the user inside a noninteractive
   menu. Post-scan results now always transition to the dedicated results
   shelf, with direct Place IQ selection and working minimize/reopen controls.
   ES5 SAFE
========================================================= */
(function(){
"use strict";

if(window.__DRIVE_IQ_ADVENTURE_V521_SCAN_UNLOCK__){ return; }
window.__DRIVE_IQ_ADVENTURE_V521_SCAN_UNLOCK__=true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD="V534_DESTINATION_SAFE_POST_SCAN_UNLOCK";

var V521={
  active:false,
  timer:null,
  observer:null,
  lastTapAt:0,
  lastTapNode:null
};

function v521ById(id){ return document.getElementById(id); }
function v521Now(){ return Date.now ? Date.now() : (new Date()).getTime(); }
function v521Text(v){ return String(v || "").replace(/\s+/g," ").trim(); }
function v521Esc(v){
  return String(v || "").replace(/[&<>"']/g,function(ch){
    if(ch === "&"){ return "&amp;"; }
    if(ch === "<"){ return "&lt;"; }
    if(ch === ">"){ return "&gt;"; }
    if(ch === '"'){ return "&quot;"; }
    return "&#39;";
  });
}

function v521Items(){
  try{
    if(adventureResults && adventureResults.length){ return adventureResults; }
  }catch(e0){}
  try{
    if(exploreResults && exploreResults.length){ return exploreResults; }
  }catch(e1){}
  return [];
}

function v521HasResults(){ return v521Items().length > 0; }

/* V534: Destination Search owns the screen while its dedicated V500 panel is
   open. Post-scan shelf recovery may not close or overwrite an intentional
   destination interaction. */
function v521DestinationSearchOwnsUI(){
  var panel=v521ById("diqV500SearchPanel");
  try{
    if(typeof diqV500Search !== "undefined" && diqV500Search && diqV500Search.open){
      return true;
    }
  }catch(e0){}
  return !!(
    panel &&
    String(panel.className || "").indexOf("on") > -1 &&
    panel.getAttribute("aria-hidden") !== "true"
  );
}

function v521CloseDestinationSearch(force){
  if(!force && v521DestinationSearchOwnsUI()){ return false; }
  var panel=v521ById("diqV500SearchPanel");
  var old=v521ById("diqAdventureSearchResults");

  try{
    if(typeof diqV500Close === "function"){ diqV500Close(); }
  }catch(e0){}

  if(panel){
    panel.className="";
    panel.setAttribute("aria-hidden","true");
    panel.style.setProperty("display","none","important");
    panel.style.setProperty("pointer-events","none","important");
  }

  if(old){
    old.classList.remove("on");
    old.classList.remove("ready");
    old.setAttribute("aria-hidden","true");
    old.style.setProperty("display","none","important");
    old.style.setProperty("pointer-events","none","important");
  }

  try{ destinationResultOpen=false; }catch(e1){}
}

function v521HideLegacyChooser(){
  var panel=v521ById("diqAdventureDestResults");
  if(!panel){ return; }

  panel.classList.remove("on");
  panel.classList.remove("diqModeDestination");
  panel.setAttribute("aria-hidden","true");
  panel.style.setProperty("display","none","important");
  panel.style.setProperty("visibility","hidden","important");
  panel.style.setProperty("opacity","0","important");
  panel.style.setProperty("pointer-events","none","important");
  panel.style.setProperty("left","-10000px","important");
  panel.style.setProperty("top","-10000px","important");
  panel.style.setProperty("width","1px","important");
  panel.style.setProperty("height","1px","important");
  panel.style.setProperty("max-height","1px","important");
}

function v521EnsureShelf(){
  var shelf=v521ById("diqV519Shelf");
  var reopen;

  try{
    if(window.DriveIQAdventureV519 &&
       typeof window.DriveIQAdventureV519.sync === "function"){
      window.DriveIQAdventureV519.sync();
    }
  }catch(e0){}

  shelf=v521ById("diqV519Shelf");
  if(!shelf){
    shelf=document.createElement("section");
    shelf.id="diqV519Shelf";
    shelf.setAttribute("aria-hidden","true");
    shelf.innerHTML=
      '<div id="diqV519ShelfHead">' +
        '<span>PLACES WORTH EXPLORING</span><em> â€¢ MAP FIRST</em>' +
        '<button id="diqV519Min" type="button" aria-label="Minimize places">&#8212;</button>' +
        '<button id="diqV519Close" type="button" aria-label="Close places">&times;</button>' +
      '</div>' +
      '<div id="diqV519Track"></div>';
    try{ document.body.appendChild(shelf); }catch(e1){}
  }

  reopen=v521ById("diqV519Reopen");
  if(!reopen){
    reopen=document.createElement("button");
    reopen.id="diqV519Reopen";
    reopen.type="button";
    reopen.textContent="PLACES";
    reopen.setAttribute("aria-label","Show scanned places");
    try{ document.body.appendChild(reopen); }catch(e2){}
  }

  return shelf;
}

function v521ItemName(item){
  return v521Text(item && (item.label || item.name || item.title) || "Place worth exploring");
}

function v521ItemSub(item){
  return v521Text(item && (
    item.full || item.address || item.formatted || item.categoryLabel ||
    item.category || item.kind || item.city || "Tap to view Place IQ"
  ) || "Tap to view Place IQ");
}

function v521ItemMeta(item){
  var parts=[];
  var score;
  var rating;
  var distance;

  if(!item){ return "VIEW PLACE IQ"; }
  score=item.worthScore || item.worthTheDrive || item.score;
  rating=item.rating || item.googleRating;
  distance=item.distMiles || item.distanceMiles || item.distance;

  if(score !== undefined && score !== null && score !== ""){
    parts.push("WORTH THE DRIVE " + String(Math.round(Number(score) || 0)));
  }
  if(rating !== undefined && rating !== null && rating !== ""){
    parts.push(String(rating) + " â˜…");
  }
  if(distance !== undefined && distance !== null && distance !== ""){
    parts.push(String(distance).indexOf("mi") > -1 ? String(distance) : String(distance) + " mi");
  }
  if(!parts.length){ parts.push("VIEW PLACE IQ"); }
  return parts.join(" â€¢ ");
}

function v521RenderDirect(){
  var items=v521Items();
  var shelf=v521EnsureShelf();
  var track=v521ById("diqV519Track");
  var i;
  var item;
  var card;

  if(!shelf || !track || !items.length){ return false; }

  track.innerHTML="";
  for(i=0;i<items.length;i++){
    item=items[i];
    card=document.createElement("button");
    card.type="button";
    card.className="diqV519Card diqV521DirectCard";
    card.setAttribute("data-adv-idx",String(i));
    card.setAttribute("aria-label","Open " + v521ItemName(item));
    card.innerHTML=
      '<div class="diqDestName">' + v521Esc(v521ItemName(item)) + '</div>' +
      '<div class="diqDestSub">' + v521Esc(v521ItemSub(item)) + '</div>' +
      '<div class="diqDestMeta">' + v521Esc(v521ItemMeta(item)) + '</div>';
    track.appendChild(card);
  }

  shelf.className="on";
  shelf.setAttribute("aria-hidden","false");
  return true;
}

function v521ShowResults(){
  var shelf;
  var track;

  /* Never let delayed scan-complete timers or the legacy shelf observer fight
     a destination menu the user intentionally opened after a scan. */
  if(v521DestinationSearchOwnsUI()){ return false; }
  if(!v521HasResults()){ return false; }
  V521.active=true;

  if(document.body){
    document.body.classList.add("adventureScanResultsMode");
    document.body.classList.add("diqV519ResultsActive");
    document.body.classList.add("diqV521ScanUnlocked");
  }

  v521CloseDestinationSearch();
  shelf=v521EnsureShelf();
  track=v521ById("diqV519Track");

  /* Use V519's clone when it exists; otherwise build directly from the real
     Adventure results array so a stale CHOOSE DESTINATION heading can never
     block post-scan browsing. */
  if(!track || !track.children || !track.children.length){
    v521RenderDirect();
  }

  shelf=v521ById("diqV519Shelf");
  if(shelf){
    shelf.className="on";
    shelf.setAttribute("aria-hidden","false");
  }

  v521HideLegacyChooser();
  return true;
}

function v521Minimize(){
  var shelf=v521EnsureShelf();
  var reopen=v521ById("diqV519Reopen");
  if(shelf){ shelf.className="minimized"; shelf.setAttribute("aria-hidden","true"); }
  if(reopen){ reopen.className="on"; }
}

function v521Reopen(){
  var shelf=v521EnsureShelf();
  var reopen=v521ById("diqV519Reopen");
  v521CloseDestinationSearch(true);
  v521HideLegacyChooser();
  if(shelf){ shelf.className="on"; shelf.setAttribute("aria-hidden","false"); }
  if(reopen){ reopen.className=""; }
}

function v521OpenItem(item){
  var opened=false;
  if(!item){ return false; }

  v521CloseDestinationSearch(true);
  v521HideLegacyChooser();
  v521Minimize();

  try{
    if(window.DriveIQAdventureV520 &&
       typeof window.DriveIQAdventureV520.open === "function"){
      opened=window.DriveIQAdventureV520.open(item) !== false;
    }
  }catch(e0){}

  if(!opened){
    try{
      if(window.DriveIQAdventureV516 &&
         typeof window.DriveIQAdventureV516.select === "function"){
        opened=window.DriveIQAdventureV516.select(item) !== false;
      }
    }catch(e1){}
  }

  if(!opened){
    try{
      if(typeof openAdventureInfoCard === "function"){
        openAdventureInfoCard(item,false);
        opened=true;
      }
    }catch(e2){}
  }

  return opened;
}

function v521FindCard(target){
  var node=target;
  while(node && node !== document){
    if(node.nodeType === 1 && node.classList &&
       node.classList.contains("diqV519Card")){
      return node;
    }
    node=node.parentNode;
  }
  return null;
}

function v521Capture(event){
  var shelf=v521ById("diqV519Shelf");
  var card;
  var idx;
  var item;
  var now;

  if(!shelf || !shelf.contains(event.target)){ return; }

  if(event.target && event.target.id === "diqV519Min"){
    if(event.preventDefault){ event.preventDefault(); }
    if(event.stopPropagation){ event.stopPropagation(); }
    if(event.stopImmediatePropagation){ event.stopImmediatePropagation(); }
    if(event.type === "pointerup" || event.type === "touchend" || event.type === "click"){
      v521Minimize();
    }
    return false;
  }

  if(event.target && event.target.id === "diqV519Close"){
    if(event.preventDefault){ event.preventDefault(); }
    if(event.stopPropagation){ event.stopPropagation(); }
    if(event.stopImmediatePropagation){ event.stopImmediatePropagation(); }
    if(event.type === "pointerup" || event.type === "touchend" || event.type === "click"){
      v521Minimize();
    }
    return false;
  }

  card=v521FindCard(event.target);
  if(!card){
    if(event.stopPropagation){ event.stopPropagation(); }
    if(event.stopImmediatePropagation){ event.stopImmediatePropagation(); }
    return;
  }

  if(event.type === "pointerdown" || event.type === "touchstart"){
    if(event.stopPropagation){ event.stopPropagation(); }
    if(event.stopImmediatePropagation){ event.stopImmediatePropagation(); }
    return;
  }

  if(event.type === "keydown"){
    if(!(event.key === "Enter" || event.key === " " || event.keyCode === 13 || event.keyCode === 32)){
      return;
    }
  }

  if(event.preventDefault){ event.preventDefault(); }
  if(event.stopPropagation){ event.stopPropagation(); }
  if(event.stopImmediatePropagation){ event.stopImmediatePropagation(); }

  idx=Number(card.getAttribute("data-adv-idx"));
  item=v521Items()[idx];
  if(!item){ return false; }

  now=v521Now();
  if(V521.lastTapNode === card && now - V521.lastTapAt < 800){ return false; }
  V521.lastTapNode=card;
  V521.lastTapAt=now;
  v521OpenItem(item);
  return false;
}

function v521Bind(){
  var shelf=v521EnsureShelf();
  var reopen=v521ById("diqV519Reopen");
  var legacy=v521ById("diqAdventureDestResults");

  if(shelf && !shelf.__diqV521Bound){
    shelf.__diqV521Bound=true;
    shelf.addEventListener("pointerdown",v521Capture,true);
    shelf.addEventListener("pointerup",v521Capture,true);
    shelf.addEventListener("touchstart",v521Capture,true);
    shelf.addEventListener("touchend",v521Capture,true);
    shelf.addEventListener("click",v521Capture,true);
    shelf.addEventListener("keydown",v521Capture,true);
  }

  if(reopen && !reopen.__diqV521Bound){
    reopen.__diqV521Bound=true;
    reopen.addEventListener("click",function(event){
      if(event && event.preventDefault){ event.preventDefault(); }
      if(event && event.stopPropagation){ event.stopPropagation(); }
      v521Reopen();
    },true);
  }

  if(window.MutationObserver && legacy && !V521.observer){
    try{
      V521.observer=new MutationObserver(function(){
        if(v521HasResults()){
          window.setTimeout(v521ShowResults,0);
        }
      });
      V521.observer.observe(legacy,{childList:true,subtree:true,attributes:true});
    }catch(e0){}
  }

  if(v521HasResults()){ v521ShowResults(); }
}

function v521Schedule(){
  if(v521DestinationSearchOwnsUI()){ return; }
  if(V521.timer){ window.clearTimeout(V521.timer); }
  V521.timer=window.setTimeout(v521ShowResults,20);
  window.setTimeout(v521ShowResults,100);
  window.setTimeout(v521ShowResults,300);
  window.setTimeout(v521ShowResults,700);
  window.setTimeout(v521ShowResults,1400);
}

document.addEventListener("driveiq:adventureScanStarted",function(){
  V521.active=false;
  v521CloseDestinationSearch(true);
},false);

document.addEventListener("driveiq:adventureScanComplete",v521Schedule,false);
document.addEventListener("driveiq:adventureResultsShown",v521Schedule,false);

if(document.readyState === "loading"){
  document.addEventListener("DOMContentLoaded",v521Bind,false);
}else{
  v521Bind();
}

window.setTimeout(v521Bind,150);
window.setTimeout(v521Bind,500);
window.setTimeout(v521Bind,1200);
window.setTimeout(v521Bind,2400);

window.DriveIQAdventureV521={
  build:"V534_DESTINATION_SAFE_POST_SCAN_UNLOCK",
  show:v521ShowResults,
  minimize:v521Minimize,
  reopen:v521Reopen,
  open:v521OpenItem
};

try{
  console.log("âœ… Drive IQ Adventure V521 post-scan menu eject + results unlock loaded");
}catch(ePublic){}

}());

/* =========================================================
   DRIVE IQ ADVENTURE MODE V522
   LONG-LIST CARD TAP + MAP-FIRST MINIMIZE AUTHORITY

   Fixes:
   - Card taps in 8â€“24 item result lists open Place IQ instead of dismissing.
   - Scroll gestures never count as card taps.
   - Selected items resolve from one committed result set, not a stale index.
   - Results only minimize after Place IQ successfully opens.
   - Both the modern shelf and legacy post-scan panel can be minimized.
   - A persistent SHOW PICKS control restores the exact result set.
   ES5 SAFE.
========================================================= */
(function(){
"use strict";

if(window.__DRIVE_IQ_ADVENTURE_V522_CARD_MAP_AUTHORITY__){ return; }
window.__DRIVE_IQ_ADVENTURE_V522_CARD_MAP_AUTHORITY__=true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD="V522_LONG_LIST_CARD_MAP_AUTHORITY";

var V522={
  committed:[],
  down:null,
  lastOpenAt:0,
  lastKey:"",
  scrollTop:0,
  scrollLeft:0
};

function v522Id(id){ return document.getElementById(id); }
function v522Now(){ return Date.now ? Date.now() : (new Date()).getTime(); }
function v522Norm(v){ return String(v || "").toLowerCase().replace(/[^a-z0-9]+/g," ").replace(/\s+/g," ").trim(); }
function v522Num(v){ var n=Number(v); return isFinite(n) ? n : null; }

function v522Key(item,index){
  var id="";
  var lat;
  var lng;
  if(!item){ return "idx:"+String(index); }
  try{id=item.place_id||item.placeId||item.google_place_id||item.googlePlaceId||item.providerId||item.id||"";}catch(e0){}
  if(id){ return "id:"+String(id); }
  lat=v522Num(item.lat!==undefined?item.lat:item.latitude);
  lng=v522Num(item.lng!==undefined?item.lng:(item.lon!==undefined?item.lon:item.longitude));
  return "name:"+v522Norm(item.label||item.name||item.title||"")+"|"+
    (lat===null?"":lat.toFixed(5))+"|"+(lng===null?"":lng.toFixed(5));
}

function v522SourceResults(){
  var candidates=[];
  try{ if(adventureResults && adventureResults.length){ candidates=adventureResults; } }catch(e0){}
  if(!candidates.length){ try{ if(exploreResults && exploreResults.length){ candidates=exploreResults; } }catch(e1){} }
  if(!candidates.length){ try{ if(destinationSearchResults && destinationSearchResults.length){ candidates=destinationSearchResults; } }catch(e2){} }
  return candidates || [];
}

function v522Commit(items){
  var src=items && items.length ? items : v522SourceResults();
  var out=[];
  var seen={};
  var i;
  var item;
  var key;
  for(i=0;i<src.length;i++){
    item=src[i];
    if(!item){ continue; }
    key=v522Key(item,i);
    if(seen[key]){ continue; }
    seen[key]=1;
    try{ item.__diqV522Key=key; }catch(e0){}
    out.push(item);
  }
  if(out.length){ V522.committed=out.slice(0); }
  try{ window.__driveIQAdventureCommittedResults=V522.committed; }catch(e1){}
  return V522.committed;
}

function v522Results(){
  if(V522.committed && V522.committed.length){ return V522.committed; }
  return v522Commit(v522SourceResults());
}

function v522FindCard(target){
  var node=target;
  while(node && node!==document){
    if(node.nodeType===1 && node.classList &&
      (node.classList.contains("diqV519Card") || node.classList.contains("diqDestItem"))){
      return node;
    }
    node=node.parentNode;
  }
  return null;
}

function v522IsResultsSurface(node){
  var shelf=v522Id("diqV519Shelf");
  var legacy=v522Id("diqAdventureDestResults");
  if(shelf && shelf.contains(node)){ return true; }
  if(legacy && legacy.contains(node) && document.body && document.body.classList.contains("adventureScanResultsMode")){ return true; }
  return false;
}

function v522Resolve(card){
  var items=v522Results();
  var raw;
  var idx;
  var key;
  var name="";
  var nameNode;
  var i;
  if(!card){ return null; }

  key=card.getAttribute("data-v522-key") || card.getAttribute("data-place-key") || "";
  if(key){
    for(i=0;i<items.length;i++){
      if(v522Key(items[i],i)===key){ return items[i]; }
    }
  }

  raw=card.getAttribute("data-adv-idx");
  if(raw===null || raw===""){ raw=card.getAttribute("data-dest-idx"); }
  if(raw===null || raw===""){ raw=card.getAttribute("data-index"); }
  idx=Number(raw);
  if(isFinite(idx) && idx>=0 && items[idx]){ return items[idx]; }

  try{
    nameNode=card.querySelector(".diqDestName,.diqResultTitle,.v500Name");
    name=v522Norm(card.getAttribute("data-place-label") || (nameNode&&nameNode.textContent) || card.getAttribute("aria-label") || "");
    name=name.replace(/^open\s+/,"");
  }catch(e0){}
  if(!name){ return null; }
  for(i=0;i<items.length;i++){
    if(v522Norm(items[i]&&(items[i].label||items[i].name||items[i].title)||"")===name){ return items[i]; }
  }
  return null;
}

function v522Stop(event,prevent){
  if(!event){ return; }
  if(prevent && event.preventDefault){ event.preventDefault(); }
  if(event.stopPropagation){ event.stopPropagation(); }
  if(event.stopImmediatePropagation){ event.stopImmediatePropagation(); }
}

function v522EnableMap(){
  var mapNode=v522Id("adventureMap");
  try{
    if(map){
      if(map.dragPan){ map.dragPan.enable(); }
      if(map.scrollZoom){ map.scrollZoom.enable(); }
      if(map.touchZoomRotate){ map.touchZoomRotate.enable(); }
      if(map.touchPitch){ map.touchPitch.enable(); }
      if(map.doubleClickZoom){ map.doubleClickZoom.enable(); }
      if(map.resize){ map.resize(); }
    }
  }catch(e0){}
  if(mapNode){
    mapNode.style.setProperty("pointer-events","auto","important");
    mapNode.style.setProperty("touch-action","none","important");
  }
}

function v522EnsureReopen(){
  var btn=v522Id("diqV522Reopen") || v522Id("diqV519Reopen");
  if(!btn){
    btn=document.createElement("button");
    btn.id="diqV522Reopen";
    btn.type="button";
    btn.textContent="SHOW PICKS";
    btn.setAttribute("aria-label","Show scanned places");
    try{ document.body.appendChild(btn); }catch(e0){}
  }
  if(!v522Id("diqV522Styles")){
    var style=document.createElement("style");
    style.id="diqV522Styles";
    style.type="text/css";
    style.appendChild(document.createTextNode(
      "#diqV522Reopen{display:none!important;position:fixed!important;right:16px!important;top:calc(env(safe-area-inset-top,0px) + 180px)!important;z-index:700!important;padding:12px 18px!important;border:1px solid rgba(40,255,190,.42)!important;border-radius:999px!important;background:linear-gradient(135deg,#ffe27a,#27f5bd)!important;color:#071018!important;font:900 13px/1 -apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif!important;letter-spacing:.7px!important;box-shadow:0 14px 34px rgba(0,0,0,.44)!important;}"+
      "#diqV522Reopen.on{display:block!important;}"+
      "body.diqV522MapBrowse #diqAdventureDestResults{display:none!important;visibility:hidden!important;pointer-events:none!important;}"+
      "body.diqV522MapBrowse #diqV519Shelf{display:none!important;visibility:hidden!important;pointer-events:none!important;}"
    ));
    try{ (document.head||document.documentElement).appendChild(style); }catch(e1){}
  }
  if(btn && !btn.__diqV522Bound){
    btn.__diqV522Bound=true;
    btn.addEventListener("click",function(event){
      v522Stop(event,true);
      v522Reopen();
    },true);
  }
  return btn;
}

function v522RememberScroll(){
  var legacyList=v522Id("diqDestList");
  var track=v522Id("diqV519Track");
  try{ V522.scrollTop=legacyList ? Number(legacyList.scrollTop||0) : 0; }catch(e0){}
  try{ V522.scrollLeft=track ? Number(track.scrollLeft||0) : 0; }catch(e1){}
}

function v522Minimize(){
  var shelf=v522Id("diqV519Shelf");
  var legacy=v522Id("diqAdventureDestResults");
  var reopen=v522EnsureReopen();
  v522RememberScroll();
  if(document.body){ document.body.classList.add("diqV522MapBrowse"); }
  if(shelf){ shelf.className="minimized"; shelf.setAttribute("aria-hidden","true"); }
  if(legacy){ legacy.classList.remove("on"); legacy.setAttribute("aria-hidden","true"); }
  if(reopen){ reopen.className="on"; reopen.textContent="SHOW PICKS  "+String(v522Results().length||""); }
  v522EnableMap();
}

function v522Reopen(){
  var shelf=v522Id("diqV519Shelf");
  var legacy=v522Id("diqAdventureDestResults");
  var reopen=v522EnsureReopen();
  var legacyList=v522Id("diqDestList");
  var track=v522Id("diqV519Track");
  if(document.body){
    document.body.classList.remove("diqV522MapBrowse");
    document.body.classList.add("adventureScanResultsMode");
  }
  if(shelf && shelf.querySelector && shelf.querySelector(".diqV519Card")){
    shelf.className="on";
    shelf.setAttribute("aria-hidden","false");
  }else if(legacy){
    legacy.classList.add("on");
    legacy.setAttribute("aria-hidden","false");
  }
  if(reopen){ reopen.className=""; }
  window.setTimeout(function(){
    try{ if(legacyList){ legacyList.scrollTop=V522.scrollTop; } }catch(e0){}
    try{ if(track){ track.scrollLeft=V522.scrollLeft; } }catch(e1){}
  },30);
}

function v522Open(item){
  var opened=false;
  var key=v522Key(item,0);
  var now=v522Now();
  if(!item){ return false; }
  if(key===V522.lastKey && now-V522.lastOpenAt<900){ return true; }

  try{
    window.__driveIQAdventureSelectedPreview=item;
    localStorage.setItem("diq_adventure_selected_place_v1",JSON.stringify(item));
  }catch(e0){}

  try{
    if(window.DriveIQAdventureV516 && typeof window.DriveIQAdventureV516.select==="function"){
      opened=window.DriveIQAdventureV516.select(item)!==false;
    }
  }catch(e1){}
  if(!opened){
    try{ if(typeof openAdventureInfoCard==="function"){ openAdventureInfoCard(item,false); opened=true; } }catch(e2){}
  }
  if(!opened){
    try{
      if(window.DriveIQAdventureRuntime && typeof window.DriveIQAdventureRuntime.openPlace==="function"){
        window.DriveIQAdventureRuntime.openPlace(item); opened=true;
      }
    }catch(e3){}
  }

  if(opened){
    V522.lastKey=key;
    V522.lastOpenAt=now;
    v522Minimize();
  }
  return opened;
}

function v522IsMinControl(target){
  var node=target;
  var txt;
  while(node && node!==document){
    if(node.nodeType===1){
      txt=String(node.textContent||"").replace(/\s+/g," ").trim();
      if(node.id==="diqV519Min" || node.id==="diqV519Close" ||
         /minimize places|close places|browse map/i.test(node.getAttribute("aria-label")||"") ||
         (node.tagName==="BUTTON" && (txt==="âˆ’" || txt==="â€”" || txt==="-"))){
        return node;
      }
    }
    node=node.parentNode;
  }
  return null;
}

function v522Point(event){
  var t=event;
  if(event.touches&&event.touches.length){ t=event.touches[0]; }
  else if(event.changedTouches&&event.changedTouches.length){ t=event.changedTouches[0]; }
  return {x:Number(t.clientX||0),y:Number(t.clientY||0)};
}

function v522Capture(event){
  var card;
  var min;
  var p;
  var dx;
  var dy;
  var moved;
  var item;

  if(!event || !v522IsResultsSurface(event.target)){ return; }

  min=v522IsMinControl(event.target);
  if(min){
    v522Stop(event,true);
    if(event.type==="pointerup" || event.type==="touchend" || event.type==="click"){
      v522Minimize();
    }
    return false;
  }

  card=v522FindCard(event.target);
  if(!card){
    if(event.type==="click"){ v522Stop(event,false); }
    return;
  }

  if(event.type==="pointerdown" || event.type==="touchstart"){
    p=v522Point(event);
    V522.down={card:card,x:p.x,y:p.y,at:v522Now(),moved:false};
    v522Stop(event,false);
    return;
  }

  if(event.type==="pointermove" || event.type==="touchmove"){
    if(V522.down){
      p=v522Point(event);
      dx=Math.abs(p.x-V522.down.x);
      dy=Math.abs(p.y-V522.down.y);
      if(dx>9 || dy>9){ V522.down.moved=true; }
    }
    return;
  }

  if(event.type==="keydown"){
    if(!(event.key==="Enter" || event.key===" " || event.keyCode===13 || event.keyCode===32)){ return; }
    item=v522Resolve(card);
    v522Stop(event,true);
    if(item){ v522Open(item); }
    return false;
  }

  if(event.type==="pointerup" || event.type==="touchend"){
    moved=!!(V522.down && (V522.down.card!==card || V522.down.moved));
    V522.down=null;
    v522Stop(event,true);
    if(moved){ return false; }
    item=v522Resolve(card);
    if(item){ v522Open(item); }
    return false;
  }

  if(event.type==="click"){
    v522Stop(event,true);
    return false;
  }
}

function v522StampCards(){
  var items=v522Results();
  var cards=document.querySelectorAll("#diqV519Shelf .diqV519Card, body.adventureScanResultsMode #diqAdventureDestResults .diqDestItem");
  var i;
  var idx;
  var item;
  for(i=0;i<cards.length;i++){
    idx=Number(cards[i].getAttribute("data-adv-idx"));
    if(!isFinite(idx)){ idx=Number(cards[i].getAttribute("data-dest-idx")); }
    if(!isFinite(idx)){ idx=i; }
    item=items[idx];
    if(item){ cards[i].setAttribute("data-v522-key",v522Key(item,idx)); }
    cards[i].setAttribute("role","button");
    cards[i].setAttribute("tabindex","0");
  }
}

function v522Bind(){
  v522Commit(v522SourceResults());
  v522EnsureReopen();
  v522StampCards();
}

/* Window capture runs before older shelf/document handlers. */
window.addEventListener("pointerdown",v522Capture,true);
window.addEventListener("pointermove",v522Capture,true);
window.addEventListener("pointerup",v522Capture,true);
window.addEventListener("touchstart",v522Capture,true);
window.addEventListener("touchmove",v522Capture,true);
window.addEventListener("touchend",v522Capture,true);
window.addEventListener("click",v522Capture,true);
window.addEventListener("keydown",v522Capture,true);

document.addEventListener("driveiq:adventureScanStarted",function(){
  V522.committed=[];
  V522.down=null;
},false);

document.addEventListener("driveiq:adventureScanComplete",function(){
  v522Commit(v522SourceResults());
  window.setTimeout(v522Bind,40);
  window.setTimeout(v522Bind,220);
  window.setTimeout(v522Bind,900);
},false);

document.addEventListener("driveiq:adventureResultsShown",function(){
  v522Commit(v522SourceResults());
  window.setTimeout(v522Bind,30);
  window.setTimeout(v522Bind,300);
},false);

if(document.readyState==="loading"){
  document.addEventListener("DOMContentLoaded",v522Bind,false);
}else{
  v522Bind();
}
window.setTimeout(v522Bind,250);
window.setTimeout(v522Bind,900);
window.setTimeout(v522Bind,2200);

window.DriveIQAdventureV522={
  build:"V522_LONG_LIST_CARD_MAP_AUTHORITY",
  commit:v522Commit,
  minimize:v522Minimize,
  reopen:v522Reopen,
  open:v522Open,
  results:v522Results
};

try{ console.log("âœ… Drive IQ Adventure V522 long-list card + map-first authority loaded"); }catch(ePublic){}

}());

/* =========================================================
   DRIVE IQ ADVENTURE MODE V523
   ALWAYS-VISIBLE RESULTS MINIMIZE BUTTON

   Product rule:
   - Post-scan results are optional browsing UI, never a blocking modal.
   - A visible minimize control must always be present in the results header.
   - Minimize preserves the committed result set and current scroll position.
   - SHOW PICKS restores the same results without rescanning.
   ES5 SAFE.
========================================================= */
(function(){
"use strict";

if(window.__DRIVE_IQ_ADVENTURE_V523_ALWAYS_VISIBLE_MINIMIZE__){ return; }
window.__DRIVE_IQ_ADVENTURE_V523_ALWAYS_VISIBLE_MINIMIZE__=true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD="V523_ALWAYS_VISIBLE_RESULTS_MINIMIZE";

var V523={observer:null,timer:null};

function v523Id(id){ return document.getElementById(id); }

function v523Stop(event){
  if(!event){ return; }
  if(event.preventDefault){ event.preventDefault(); }
  if(event.stopPropagation){ event.stopPropagation(); }
  if(event.stopImmediatePropagation){ event.stopImmediatePropagation(); }
}

function v523Minimize(){
  try{
    if(window.DriveIQAdventureV522 && typeof window.DriveIQAdventureV522.minimize==="function"){
      window.DriveIQAdventureV522.minimize();
      return true;
    }
  }catch(e0){}
  try{
    if(window.DriveIQAdventureV521 && typeof window.DriveIQAdventureV521.minimize==="function"){
      window.DriveIQAdventureV521.minimize();
      return true;
    }
  }catch(e1){}
  return false;
}

function v523InjectStyles(){
  var style;
  if(v523Id("diqV523MinimizeStyles")){ return; }
  style=document.createElement("style");
  style.id="diqV523MinimizeStyles";
  style.type="text/css";
  style.appendChild(document.createTextNode(
    "body.adventureScanResultsMode #diqAdventureDestResults .diqDestHead{"+
      "position:relative!important;min-height:92px!important;"+
      "padding-right:76px!important;"+
    "}"+
    "#diqV523Minimize{"+
      "display:flex!important;position:absolute!important;right:14px!important;top:50%!important;"+
      "transform:translateY(-50%)!important;width:48px!important;height:48px!important;"+
      "min-width:48px!important;align-items:center!important;justify-content:center!important;"+
      "padding:0!important;margin:0!important;border-radius:16px!important;"+
      "border:1px solid rgba(255,255,255,.18)!important;"+
      "background:rgba(255,255,255,.08)!important;color:#fff!important;"+
      "font:900 28px/1 -apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif!important;"+
      "box-shadow:0 10px 26px rgba(0,0,0,.34)!important;z-index:40!important;"+
      "pointer-events:auto!important;touch-action:manipulation!important;"+
      "-webkit-tap-highlight-color:transparent!important;"+
    "}"+
    "#diqV523Minimize:active{transform:translateY(-50%) scale(.94)!important;}"
  ));
  try{ (document.head||document.documentElement).appendChild(style); }catch(e0){}
}

function v523EnsureButton(){
  var panel=v523Id("diqAdventureDestResults");
  var head;
  var button;
  if(!panel || !document.body || !document.body.classList.contains("adventureScanResultsMode")){ return null; }
  head=panel.querySelector ? panel.querySelector(".diqDestHead") : null;
  if(!head){ return null; }

  button=v523Id("diqV523Minimize");
  if(!button){
    button=document.createElement("button");
    button.type="button";
    button.id="diqV523Minimize";
    button.setAttribute("aria-label","Minimize places and browse the map");
    button.setAttribute("title","Minimize places");
    button.innerHTML="&#8722;";
    try{ head.appendChild(button); }catch(e0){ return null; }
  }else if(button.parentNode!==head){
    try{ head.appendChild(button); }catch(e1){}
  }

  if(!button.__diqV523Bound){
    button.__diqV523Bound=true;
    button.addEventListener("pointerdown",function(event){ v523Stop(event); },true);
    button.addEventListener("touchstart",function(event){ v523Stop(event); },true);
    button.addEventListener("click",function(event){
      v523Stop(event);
      v523Minimize();
      return false;
    },true);
  }
  return button;
}

function v523Schedule(){
  if(V523.timer){ try{ window.clearTimeout(V523.timer); }catch(e0){} }
  V523.timer=window.setTimeout(function(){
    v523InjectStyles();
    v523EnsureButton();
  },20);
}

function v523Bind(){
  v523InjectStyles();
  v523EnsureButton();

  if(!V523.observer && window.MutationObserver && document.body){
    try{
      V523.observer=new MutationObserver(function(){ v523Schedule(); });
      V523.observer.observe(document.body,{
        childList:true,
        subtree:true,
        attributes:true,
        attributeFilter:["class","aria-hidden"]
      });
    }catch(e0){}
  }
}

document.addEventListener("driveiq:adventureScanComplete",function(){
  window.setTimeout(v523EnsureButton,40);
  window.setTimeout(v523EnsureButton,220);
  window.setTimeout(v523EnsureButton,900);
},false);

document.addEventListener("driveiq:adventureResultsShown",function(){
  window.setTimeout(v523EnsureButton,30);
  window.setTimeout(v523EnsureButton,300);
},false);

if(document.readyState==="loading"){
  document.addEventListener("DOMContentLoaded",v523Bind,false);
}else{
  v523Bind();
}
window.setTimeout(v523Bind,300);
window.setTimeout(v523Bind,1200);

window.DriveIQAdventureV523={
  build:"V523_ALWAYS_VISIBLE_RESULTS_MINIMIZE",
  ensure:v523EnsureButton,
  minimize:v523Minimize
};

try{ console.log("âœ… Drive IQ Adventure V523 always-visible results minimize loaded"); }catch(ePublic){}

}());

/* =========================================================
   DRIVE IQ ADVENTURE MODE V524
   HARD RESULTS MINIMIZE AUTHORITY

   Fixes the case where the post-scan panel is visible without the expected
   scan-results body class or header node. The minimize button is mounted
   directly to the visible results panel and has its own DOM fallback.
   ES5 SAFE.
========================================================= */
(function(){
"use strict";

if(window.__DRIVE_IQ_ADVENTURE_V524_HARD_MINIMIZE_AUTHORITY__){ return; }
window.__DRIVE_IQ_ADVENTURE_V524_HARD_MINIMIZE_AUTHORITY__=true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD="V524_HARD_RESULTS_MINIMIZE_AUTHORITY";

var V524={observer:null,timer:null,scrollTop:0};

function v524Id(id){ return document.getElementById(id); }
function v524Visible(el){
  var cs;
  if(!el){ return false; }
  try{
    cs=window.getComputedStyle ? window.getComputedStyle(el) : null;
    if(cs && (cs.display==="none" || cs.visibility==="hidden" || Number(cs.opacity)===0)){ return false; }
    return el.getBoundingClientRect().height>40;
  }catch(e){ return true; }
}
function v524Stop(event){
  if(!event){ return; }
  if(event.preventDefault){ event.preventDefault(); }
  if(event.stopPropagation){ event.stopPropagation(); }
  if(event.stopImmediatePropagation){ event.stopImmediatePropagation(); }
}
function v524Panel(){
  var legacy=v524Id("diqAdventureDestResults");
  var shelf=v524Id("diqV519Shelf");
  if(legacy && v524Visible(legacy)){ return legacy; }
  if(shelf && v524Visible(shelf)){ return shelf; }
  return legacy || shelf || null;
}
function v524List(){
  return v524Id("diqDestList") || v524Id("diqV519Track");
}
function v524Count(){
  var n=0;
  try{
    if(window.DriveIQAdventureV522 && typeof window.DriveIQAdventureV522.results==="function"){
      n=window.DriveIQAdventureV522.results().length||0;
    }
  }catch(e0){}
  if(!n){
    try{ n=document.querySelectorAll("#diqAdventureDestResults .diqDestItem,#diqV519Shelf .diqV519Card").length||0; }catch(e1){}
  }
  return n;
}
function v524InjectStyles(){
  var style;
  if(v524Id("diqV524Styles")){ return; }
  style=document.createElement("style");
  style.id="diqV524Styles";
  style.type="text/css";
  style.appendChild(document.createTextNode(
    "#diqAdventureDestResults,#diqV519Shelf{position:relative!important;}"+
    "#diqV524Minimize{"+
      "display:flex!important;position:absolute!important;right:16px!important;top:16px!important;"+
      "width:52px!important;height:52px!important;min-width:52px!important;"+
      "align-items:center!important;justify-content:center!important;padding:0!important;margin:0!important;"+
      "border-radius:17px!important;border:1px solid rgba(255,255,255,.24)!important;"+
      "background:rgba(9,16,26,.92)!important;color:#fff!important;"+
      "font:900 30px/1 -apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif!important;"+
      "box-shadow:0 12px 32px rgba(0,0,0,.55)!important;z-index:2147483000!important;"+
      "pointer-events:auto!important;touch-action:manipulation!important;-webkit-tap-highlight-color:transparent!important;"+
    "}"+
    "#diqV524Minimize:active{transform:scale(.94)!important;}"+
    "body.diqV524MapBrowse #diqAdventureDestResults,body.diqV524MapBrowse #diqV519Shelf{"+
      "display:none!important;visibility:hidden!important;opacity:0!important;pointer-events:none!important;"+
    "}"+
    "#diqV524ShowPicks{"+
      "display:none!important;position:fixed!important;right:16px!important;top:calc(env(safe-area-inset-top,0px) + 174px)!important;"+
      "z-index:2147483000!important;padding:13px 19px!important;border:1px solid rgba(40,255,190,.48)!important;"+
      "border-radius:999px!important;background:linear-gradient(135deg,#ffe27a,#27f5bd)!important;color:#071018!important;"+
      "font:900 13px/1 -apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif!important;letter-spacing:.7px!important;"+
      "box-shadow:0 14px 34px rgba(0,0,0,.48)!important;pointer-events:auto!important;touch-action:manipulation!important;"+
    "}"+
    "#diqV524ShowPicks.on{display:block!important;}"
  ));
  try{ (document.head||document.documentElement).appendChild(style); }catch(e0){}
}
function v524EnableMap(){
  var mapNode=v524Id("adventureMap");
  try{
    if(map){
      if(map.dragPan){ map.dragPan.enable(); }
      if(map.scrollZoom){ map.scrollZoom.enable(); }
      if(map.touchZoomRotate){ map.touchZoomRotate.enable(); }
      if(map.touchPitch){ map.touchPitch.enable(); }
      if(map.doubleClickZoom){ map.doubleClickZoom.enable(); }
      if(map.resize){ map.resize(); }
    }
  }catch(e0){}
  if(mapNode){
    mapNode.style.setProperty("pointer-events","auto","important");
    mapNode.style.setProperty("touch-action","none","important");
  }
}
function v524EnsureShowPicks(){
  var btn=v524Id("diqV524ShowPicks");
  if(!btn){
    btn=document.createElement("button");
    btn.id="diqV524ShowPicks";
    btn.type="button";
    btn.setAttribute("aria-label","Show scanned places");
    try{ document.body.appendChild(btn); }catch(e0){}
  }
  btn.textContent="SHOW PICKS  "+String(v524Count()||"");
  if(!btn.__diqV524Bound){
    btn.__diqV524Bound=true;
    btn.addEventListener("pointerdown",v524Stop,true);
    btn.addEventListener("touchstart",v524Stop,true);
    btn.addEventListener("click",function(event){ v524Stop(event); v524Restore(); return false; },true);
  }
  return btn;
}
function v524Minimize(){
  var panel=v524Panel();
  var list=v524List();
  var show=v524EnsureShowPicks();
  try{ V524.scrollTop=list ? Number(list.scrollTop||list.scrollLeft||0) : 0; }catch(e0){}
  try{
    if(window.DriveIQAdventureV522 && typeof window.DriveIQAdventureV522.minimize==="function"){
      window.DriveIQAdventureV522.minimize();
    }
  }catch(e1){}
  if(document.body){ document.body.classList.add("diqV524MapBrowse"); }
  if(panel){
    panel.setAttribute("aria-hidden","true");
    panel.style.setProperty("display","none","important");
    panel.style.setProperty("visibility","hidden","important");
    panel.style.setProperty("pointer-events","none","important");
  }
  if(show){ show.className="on"; }
  v524EnableMap();
  return true;
}
function v524Restore(){
  var legacy=v524Id("diqAdventureDestResults");
  var shelf=v524Id("diqV519Shelf");
  var panel=legacy||shelf;
  var list;
  var show=v524EnsureShowPicks();
  if(document.body){
    document.body.classList.remove("diqV524MapBrowse");
    document.body.classList.add("adventureScanResultsMode");
  }
  try{
    if(window.DriveIQAdventureV522 && typeof window.DriveIQAdventureV522.reopen==="function"){
      window.DriveIQAdventureV522.reopen();
    }
  }catch(e0){}
  panel=legacy||shelf;
  if(panel){
    panel.style.removeProperty("display");
    panel.style.removeProperty("visibility");
    panel.style.removeProperty("pointer-events");
    panel.setAttribute("aria-hidden","false");
    panel.classList.add("on");
  }
  if(show){ show.className=""; }
  window.setTimeout(function(){
    list=v524List();
    try{
      if(list){
        if(list.scrollHeight>list.clientHeight){ list.scrollTop=V524.scrollTop; }
        else{ list.scrollLeft=V524.scrollTop; }
      }
    }catch(e1){}
    v524EnsureButton();
  },40);
}
function v524EnsureButton(){
  var panel=v524Panel();
  var button;
  if(!panel || (document.body && document.body.classList.contains("diqV524MapBrowse"))){ return null; }
  button=v524Id("diqV524Minimize");
  if(!button){
    button=document.createElement("button");
    button.id="diqV524Minimize";
    button.type="button";
    button.setAttribute("aria-label","Minimize results and browse the map");
    button.setAttribute("title","Minimize results");
    button.innerHTML="&#8722;";
  }
  if(button.parentNode!==panel){
    try{ panel.appendChild(button); }catch(e0){ return null; }
  }
  if(!button.__diqV524Bound){
    button.__diqV524Bound=true;
    button.addEventListener("pointerdown",v524Stop,true);
    button.addEventListener("touchstart",v524Stop,true);
    button.addEventListener("pointerup",function(event){ v524Stop(event); v524Minimize(); return false; },true);
    button.addEventListener("touchend",function(event){ v524Stop(event); v524Minimize(); return false; },true);
    button.addEventListener("click",function(event){ v524Stop(event); return false; },true);
  }
  return button;
}
function v524Schedule(){
  if(V524.timer){ try{ window.clearTimeout(V524.timer); }catch(e0){} }
  V524.timer=window.setTimeout(function(){
    v524InjectStyles();
    v524EnsureShowPicks();
    v524EnsureButton();
  },15);
}
function v524Bind(){
  v524InjectStyles();
  v524EnsureShowPicks();
  v524EnsureButton();
  if(!V524.observer && window.MutationObserver && document.body){
    try{
      V524.observer=new MutationObserver(function(){ v524Schedule(); });
      V524.observer.observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:["class","aria-hidden","style"]});
    }catch(e0){}
  }
}

document.addEventListener("driveiq:adventureScanComplete",function(){
  window.setTimeout(v524EnsureButton,20);
  window.setTimeout(v524EnsureButton,120);
  window.setTimeout(v524EnsureButton,500);
  window.setTimeout(v524EnsureButton,1200);
},false);
document.addEventListener("driveiq:adventureResultsShown",function(){
  window.setTimeout(v524EnsureButton,20);
  window.setTimeout(v524EnsureButton,200);
  window.setTimeout(v524EnsureButton,700);
},false);

if(document.readyState==="loading"){
  document.addEventListener("DOMContentLoaded",v524Bind,false);
}else{
  v524Bind();
}
window.setTimeout(v524Bind,150);
window.setTimeout(v524Bind,700);
window.setTimeout(v524Bind,1800);

window.DriveIQAdventureV524={
  build:"V524_HARD_RESULTS_MINIMIZE_AUTHORITY",
  ensure:v524EnsureButton,
  minimize:v524Minimize,
  restore:v524Restore
};

try{ console.log("âœ… Drive IQ Adventure V524 hard results minimize authority loaded"); }catch(ePublic){}

}());


/* =========================================================
   DRIVE IQ ADVENTURE MODE V525
   MAP-FIRST COMPACT RESULTS SHELF AUTHORITY

   Restores the original post-scan interaction:
   - Results remain in a compact bottom thumbnail shelf.
   - Cards scroll horizontally.
   - Map remains fully pannable and zoomable.
   - Shelf can collapse to a small bottom handle.
   - User collapse is respected until explicitly reopened.
   - Scan, ranking, pins, Photo IQ, and Place IQ are untouched.

   ES5 SAFE.
========================================================= */
(function(){
"use strict";

if(window.__DRIVE_IQ_ADVENTURE_V525_COMPACT_SHELF__){ return; }
window.__DRIVE_IQ_ADVENTURE_V525_COMPACT_SHELF__ = true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD = "V525_MAP_FIRST_COMPACT_RESULTS_SHELF";

var V525 = {
  collapsed:false,
  timer:null,
  observer:null
};

function v525Id(id){
  return document.getElementById(id);
}

function v525Panel(){
  var legacy = v525Id("diqAdventureDestResults");
  var modern = v525Id("diqV519Shelf");

  if(legacy && legacy.querySelector && legacy.querySelector(".diqDestItem")){
    return legacy;
  }

  if(modern){
    return modern;
  }

  return legacy || modern || null;
}

function v525Track(panel){
  if(!panel){ return null; }

  return (
    panel.querySelector("#diqDestList") ||
    panel.querySelector("#diqV519Track") ||
    panel.querySelector(".diqV519Track") ||
    null
  );
}

function v525ResultCount(){
  var total = 0;

  try{
    total = document.querySelectorAll(
      "#diqAdventureDestResults .diqDestItem," +
      "#diqV519Shelf .diqV519Card"
    ).length;
  }catch(e0){ total = 0; }

  if(!total){
    try{
      if(window.DriveIQAdventureV522 &&
         typeof window.DriveIQAdventureV522.results === "function"){
        total = window.DriveIQAdventureV522.results().length || 0;
      }
    }catch(e1){}
  }

  return total;
}

function v525EnableMap(){
  var mapNode = v525Id("adventureMap") ||
    v525Id("map") ||
    document.querySelector(".mapboxgl-map");
  var canvas = document.querySelector(".mapboxgl-canvas");

  try{
    if(typeof map !== "undefined" && map){
      if(map.stop){ map.stop(); }
      if(map.dragPan && map.dragPan.enable){ map.dragPan.enable(); }
      if(map.scrollZoom && map.scrollZoom.enable){ map.scrollZoom.enable(); }
      if(map.touchZoomRotate && map.touchZoomRotate.enable){
        map.touchZoomRotate.enable();
      }
      if(map.touchPitch && map.touchPitch.enable){ map.touchPitch.enable(); }
      if(map.doubleClickZoom && map.doubleClickZoom.enable){
        map.doubleClickZoom.enable();
      }
      if(map.boxZoom && map.boxZoom.enable){ map.boxZoom.enable(); }
      if(map.resize){ map.resize(); }
      if(map.triggerRepaint){ map.triggerRepaint(); }
    }
  }catch(e0){}

  if(mapNode){
    mapNode.style.setProperty("pointer-events","auto","important");
    mapNode.style.setProperty("touch-action","none","important");
  }

  if(canvas){
    canvas.style.setProperty("pointer-events","auto","important");
    canvas.style.setProperty("touch-action","none","important");
  }
}

function v525InjectStyles(){
  var style;
  var css;

  if(v525Id("diqV525CompactShelfStyles")){ return; }

  css =
    "body.adventureScanResultsMode #diqAdventureDestResults," +
    "body.adventureScanResultsMode #diqV519Shelf{" +
      "position:fixed!important;" +
      "left:10px!important;right:10px!important;" +
      "bottom:calc(10px + env(safe-area-inset-bottom,0px))!important;" +
      "top:auto!important;" +
      "width:auto!important;max-width:none!important;" +
      "height:188px!important;min-height:0!important;max-height:188px!important;" +
      "display:flex!important;flex-direction:column!important;" +
      "visibility:visible!important;opacity:1!important;" +
      "overflow:hidden!important;" +
      "pointer-events:auto!important;" +
      "z-index:2147482000!important;" +
      "margin:0!important;padding:0!important;" +
      "border-radius:20px!important;" +
      "border:1px solid rgba(40,255,190,.30)!important;" +
      "background:linear-gradient(180deg,rgba(5,13,23,.975),rgba(2,8,15,.995))!important;" +
      "box-shadow:0 18px 48px rgba(0,0,0,.58)!important;" +
      "transform:none!important;" +
    "}" +

    "body.diqV525ShelfCollapsed #diqAdventureDestResults," +
    "body.diqV525ShelfCollapsed #diqV519Shelf{" +
      "height:48px!important;max-height:48px!important;" +
    "}" +

    "body.adventureScanResultsMode #diqAdventureDestResults .diqDestHead," +
    "body.adventureScanResultsMode #diqV519Shelf .diqV519Head{" +
      "position:relative!important;" +
      "display:flex!important;align-items:center!important;" +
      "flex:0 0 48px!important;" +
      "height:48px!important;min-height:48px!important;" +
      "padding:0 58px 0 16px!important;" +
      "margin:0!important;" +
      "border:0!important;border-bottom:1px solid rgba(255,255,255,.08)!important;" +
      "background:rgba(5,13,23,.98)!important;" +
      "color:#dffcff!important;" +
      "font:900 10px/1 -apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif!important;" +
      "letter-spacing:1.15px!important;" +
      "text-transform:uppercase!important;" +
      "white-space:nowrap!important;overflow:hidden!important;text-overflow:ellipsis!important;" +
      "pointer-events:auto!important;" +
      "cursor:pointer!important;" +
    "}" +

    "body.adventureScanResultsMode #diqAdventureDestResults .diqDestHead:before," +
    "body.adventureScanResultsMode #diqV519Shelf .diqV519Head:before{" +
      "content:''!important;" +
      "position:absolute!important;left:50%!important;top:6px!important;" +
      "width:38px!important;height:4px!important;" +
      "margin-left:-19px!important;border-radius:999px!important;" +
      "background:rgba(255,255,255,.30)!important;" +
    "}" +

    "body.adventureScanResultsMode #diqAdventureDestResults #diqDestList," +
    "body.adventureScanResultsMode #diqV519Shelf #diqV519Track," +
    "body.adventureScanResultsMode #diqV519Shelf .diqV519Track{" +
      "display:flex!important;" +
      "flex:1 1 auto!important;" +
      "gap:10px!important;" +
      "width:100%!important;" +
      "height:140px!important;min-height:0!important;max-height:140px!important;" +
      "padding:9px 10px 11px!important;" +
      "margin:0!important;" +
      "overflow-x:auto!important;overflow-y:hidden!important;" +
      "-webkit-overflow-scrolling:touch!important;" +
      "scroll-snap-type:x proximity!important;" +
      "overscroll-behavior-x:contain!important;" +
      "touch-action:pan-x!important;" +
      "pointer-events:auto!important;" +
      "background:transparent!important;" +
    "}" +

    "body.diqV525ShelfCollapsed #diqAdventureDestResults #diqDestList," +
    "body.diqV525ShelfCollapsed #diqV519Shelf #diqV519Track," +
    "body.diqV525ShelfCollapsed #diqV519Shelf .diqV519Track{" +
      "display:none!important;" +
    "}" +

    "body.adventureScanResultsMode #diqAdventureDestResults .diqDestItem," +
    "body.adventureScanResultsMode #diqV519Shelf .diqV519Card{" +
      "position:relative!important;" +
      "display:grid!important;" +
      "grid-template-columns:100px minmax(0,1fr)!important;" +
      "grid-template-rows:auto 1fr!important;" +
      "flex:0 0 min(78vw,310px)!important;" +
      "width:min(78vw,310px)!important;" +
      "min-width:min(78vw,310px)!important;" +
      "max-width:310px!important;" +
      "height:118px!important;min-height:118px!important;max-height:118px!important;" +
      "margin:0!important;padding:8px!important;" +
      "overflow:hidden!important;" +
      "border-radius:16px!important;" +
      "border:1px solid rgba(255,255,255,.12)!important;" +
      "background:linear-gradient(145deg,rgba(255,255,255,.07),rgba(255,255,255,.025))!important;" +
      "box-shadow:none!important;" +
      "scroll-snap-align:start!important;" +
      "pointer-events:auto!important;" +
      "touch-action:manipulation!important;" +
    "}" +

    "body.adventureScanResultsMode #diqAdventureDestResults .diqDestThumb{" +
      "grid-column:1!important;grid-row:1 / span 2!important;" +
      "width:92px!important;height:102px!important;min-height:102px!important;" +
      "margin:0 8px 0 0!important;border-radius:12px!important;" +
      "background-size:cover!important;background-position:center!important;" +
    "}" +

    "body.adventureScanResultsMode #diqAdventureDestResults .diqDestName{" +
      "grid-column:2!important;grid-row:1!important;" +
      "margin:2px 0 0!important;" +
      "font-size:15px!important;line-height:1.12!important;font-weight:950!important;" +
      "white-space:nowrap!important;overflow:hidden!important;text-overflow:ellipsis!important;" +
    "}" +

    "body.adventureScanResultsMode #diqAdventureDestResults .diqDestSub{" +
      "grid-column:2!important;grid-row:2!important;" +
      "margin:5px 0 0!important;" +
      "font-size:11px!important;line-height:1.25!important;" +
      "display:-webkit-box!important;-webkit-box-orient:vertical!important;" +
      "-webkit-line-clamp:3!important;overflow:hidden!important;" +
    "}" +

    "#diqV525Minimize{" +
      "position:absolute!important;right:8px!important;top:7px!important;" +
      "display:flex!important;align-items:center!important;justify-content:center!important;" +
      "width:36px!important;height:34px!important;min-width:36px!important;" +
      "padding:0!important;margin:0!important;" +
      "border-radius:11px!important;" +
      "border:1px solid rgba(255,255,255,.18)!important;" +
      "background:rgba(255,255,255,.07)!important;" +
      "color:#fff!important;" +
      "font:900 22px/1 -apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif!important;" +
      "pointer-events:auto!important;touch-action:manipulation!important;" +
      "z-index:20!important;" +
    "}" +

    "#diqV524Minimize,#diqV524ShowPicks{" +
      "display:none!important;visibility:hidden!important;pointer-events:none!important;" +
    "}" +

    "#adventureMap,#adventureMap .mapboxgl-canvas-container," +
    "#adventureMap .mapboxgl-canvas{" +
      "pointer-events:auto!important;touch-action:none!important;" +
    "}" +

    ".adventureShade,#diqAdventureScanTab,.adventureToast{" +
      "pointer-events:none!important;" +
    "}" +

    "@media(min-width:700px){" +
      "body.adventureScanResultsMode #diqAdventureDestResults," +
      "body.adventureScanResultsMode #diqV519Shelf{" +
        "left:18px!important;right:18px!important;height:198px!important;max-height:198px!important;" +
      "}" +
      "body.adventureScanResultsMode #diqAdventureDestResults #diqDestList," +
      "body.adventureScanResultsMode #diqV519Shelf #diqV519Track{" +
        "height:150px!important;max-height:150px!important;" +
      "}" +
      "body.adventureScanResultsMode #diqAdventureDestResults .diqDestItem," +
      "body.adventureScanResultsMode #diqV519Shelf .diqV519Card{" +
        "flex-basis:330px!important;width:330px!important;min-width:330px!important;max-width:330px!important;" +
      "}" +
    "}";

  style = document.createElement("style");
  style.id = "diqV525CompactShelfStyles";
  style.type = "text/css";
  style.appendChild(document.createTextNode(css));

  try{
    (document.head || document.documentElement).appendChild(style);
  }catch(e0){}
}

function v525Stop(event){
  if(!event){ return; }
  if(event.preventDefault){ event.preventDefault(); }
  if(event.stopPropagation){ event.stopPropagation(); }
  if(event.stopImmediatePropagation){ event.stopImmediatePropagation(); }
}

function v525Apply(){
  var panel = v525Panel();
  var head;
  var button;
  var count = v525ResultCount();

  v525InjectStyles();
  v525EnableMap();

  if(!panel || !count){ return false; }

  try{
    document.body.classList.add("adventureScanResultsMode");
    document.body.classList.remove("diqV524MapBrowse");
    if(V525.collapsed){
      document.body.classList.add("diqV525ShelfCollapsed");
    }else{
      document.body.classList.remove("diqV525ShelfCollapsed");
    }
  }catch(e0){}

  panel.classList.add("on");
  panel.setAttribute("aria-hidden","false");

  panel.style.removeProperty("top");
  panel.style.removeProperty("left");
  panel.style.removeProperty("right");
  panel.style.removeProperty("bottom");
  panel.style.removeProperty("width");
  panel.style.removeProperty("height");
  panel.style.removeProperty("max-height");
  panel.style.removeProperty("display");
  panel.style.removeProperty("visibility");
  panel.style.removeProperty("opacity");
  panel.style.removeProperty("pointer-events");
  panel.style.removeProperty("transform");

  head = panel.querySelector(".diqDestHead") ||
    panel.querySelector(".diqV519Head");

  if(!head){
    head = document.createElement("div");
    head.className = "diqDestHead";
    try{ panel.insertBefore(head,panel.firstChild); }catch(e1){}
  }

  head.textContent =
    String(count) + " PLACE" + (count === 1 ? "" : "S") + " WORTH EXPLORING";

  button = v525Id("diqV525Minimize");

  if(!button){
    button = document.createElement("button");
    button.id = "diqV525Minimize";
    button.type = "button";
    button.setAttribute("aria-label","Minimize results shelf");
  }

  button.innerHTML = V525.collapsed ? "&#8963;" : "&#8722;";

  if(button.parentNode !== head){
    try{ head.appendChild(button); }catch(e2){}
  }

  if(!button.__diqV525Bound){
    button.__diqV525Bound = true;

    button.addEventListener("pointerdown",v525Stop,true);
    button.addEventListener("touchstart",v525Stop,true);

    button.addEventListener("click",function(event){
      v525Stop(event);
      V525.collapsed = !V525.collapsed;

      if(document.body){
        document.body.classList.toggle(
          "diqV525ShelfCollapsed",
          V525.collapsed
        );
      }

      button.innerHTML = V525.collapsed ? "&#8963;" : "&#8722;";
      button.setAttribute(
        "aria-label",
        V525.collapsed ? "Show results shelf" : "Minimize results shelf"
      );

      v525EnableMap();
      window.setTimeout(v525EnableMap,80);
      return false;
    },true);
  }

  if(!head.__diqV525Bound){
    head.__diqV525Bound = true;
    head.addEventListener("click",function(event){
      if(event && event.target === button){ return; }
      if(!V525.collapsed){ return; }

      V525.collapsed = false;
      if(document.body){
        document.body.classList.remove("diqV525ShelfCollapsed");
      }
      button.innerHTML = "&#8722;";
      button.setAttribute("aria-label","Minimize results shelf");
      v525EnableMap();
    },false);
  }

  return true;
}

function v525Schedule(){
  if(V525.timer){
    try{ window.clearTimeout(V525.timer); }catch(e0){}
  }

  V525.timer = window.setTimeout(function(){
    v525Apply();
  },40);
}

function v525MapGesture(){
  v525EnableMap();
}

function v525Bind(){
  var mapNode;

  v525InjectStyles();
  v525Apply();

  mapNode = v525Id("adventureMap") ||
    v525Id("map") ||
    document.querySelector(".mapboxgl-map");

  if(mapNode && !mapNode.__diqV525Bound){
    mapNode.__diqV525Bound = true;
    mapNode.addEventListener("touchstart",v525MapGesture,{passive:true});
    mapNode.addEventListener("pointerdown",v525MapGesture,true);
    mapNode.addEventListener("wheel",v525MapGesture,{passive:true});
  }

  if(!V525.observer && window.MutationObserver){
    try{
      V525.observer = new MutationObserver(function(mutations){
        var i;
        var target;

        for(i = 0; i < mutations.length; i++){
          target = mutations[i].target;

          if(
            target &&
            (
              target.id === "diqAdventureDestResults" ||
              target.id === "diqV519Shelf" ||
              target.id === "diqDestList" ||
              target.id === "diqV519Track" ||
              (
                target.closest &&
                (
                  target.closest("#diqAdventureDestResults") ||
                  target.closest("#diqV519Shelf")
                )
              )
            )
          ){
            v525Schedule();
            break;
          }
        }
      });

      if(document.body){
        V525.observer.observe(document.body,{
          childList:true,
          subtree:true
        });
      }
    }catch(e0){}
  }
}

document.addEventListener("driveiq:adventureScanComplete",function(){
  V525.collapsed = false;
  window.setTimeout(v525Apply,30);
  window.setTimeout(v525Apply,180);
  window.setTimeout(v525Apply,700);
},false);

document.addEventListener("driveiq:adventureResultsShown",function(){
  V525.collapsed = false;
  window.setTimeout(v525Apply,30);
  window.setTimeout(v525Apply,220);
},false);

window.addEventListener("driveiq:scan-complete",function(){
  V525.collapsed = false;
  window.setTimeout(v525Apply,60);
  window.setTimeout(v525Apply,400);
},false);

if(document.readyState === "loading"){
  document.addEventListener("DOMContentLoaded",v525Bind,false);
}else{
  v525Bind();
}

window.setTimeout(v525Bind,250);
window.setTimeout(v525Apply,900);
window.setTimeout(v525Apply,1800);

window.DriveIQAdventureV525 = {
  build:"V525_MAP_FIRST_COMPACT_RESULTS_SHELF",
  apply:v525Apply,
  collapse:function(){
    V525.collapsed = true;
    return v525Apply();
  },
  expand:function(){
    V525.collapsed = false;
    return v525Apply();
  },
  enableMap:v525EnableMap
};

try{
  console.log("âœ… Drive IQ Adventure V525 compact bottom results shelf loaded");
}catch(ePublic){}

}());



/* =========================================================
   DRIVE IQ V515
   SINGLE POST-SCAN UI AUTHORITY

   Purpose:
   - Disable the legacy Adventure results shelf after scan completion.
   - Hand all post-scan rendering to StopCards.js.
   - Preserve scan engine, pins, Place IQ, Photo IQ, ranking, routing.

========================================================= */
(function(){
"use strict";

if(window.__DRIVE_IQ_V515_SINGLE_UI_AUTHORITY__){return;}
window.__DRIVE_IQ_V515_SINGLE_UI_AUTHORITY__=true;

function legacyPanel(){
  return document.getElementById("diqAdventureDestResults");
}

function hideLegacyShelf(){
  var p=legacyPanel();
  if(!p){return;}
  if(document.body &&
     document.body.classList.contains("adventureScanResultsMode")){
    p.style.setProperty("display","none","important");
    p.style.setProperty("visibility","hidden","important");
    p.style.setProperty("pointer-events","none","important");
    p.setAttribute("aria-hidden","true");
  }
}

function publishResults(){
  try{
    window.adventureResults=(window.adventureResults||adventureResults||[]).slice(0);
  }catch(e){
    window.adventureResults=[];
  }

  try{
    document.dispatchEvent(new CustomEvent(
      "driveiq:adventureScanComplete",
      {detail:{results:window.adventureResults}}
    ));
  }catch(e2){}
}

var original=window.renderAdventureScanChoices;
if(typeof original==="function"){
  window.renderAdventureScanChoices=function(){
    var r=original.apply(this,arguments);
    window.setTimeout(function(){
      try{
        document.body.classList.add("adventureScanResultsMode");
      }catch(e){}
      hideLegacyShelf();
      publishResults();
    },0);
    return r;
  };
}

document.addEventListener("driveiq:adventureScanComplete",function(){
  hideLegacyShelf();
},true);

window.addEventListener("load",function(){
  hideLegacyShelf();
});

console.log("Drive IQ V515 Single UI Authority loaded");
})();

/* =========================================================
   DRIVE IQ ADVENTURE MODE V526
   ROUTE-HERE + MAP-VISIBILITY FINAL AUTHORITY

   Narrow repair only:
   - Route Here uses the Place IQ item currently open.
   - A successful route immediately creates the Drive Mode payload and opens
     Drive Mode.
   - The post-scan results shelf always has working minimize and close controls.
   - A compact PLACES button restores the shelf without rescanning.
   - No scan, ranking, photo, destination-search, or boot logic is replaced.
   ES5 SAFE.
========================================================= */
(function(){
"use strict";

if(window.__DRIVE_IQ_ADVENTURE_V526_ROUTE_MAP_FIX__){ return; }
window.__DRIVE_IQ_ADVENTURE_V526_ROUTE_MAP_FIX__=true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD="V526_ROUTE_HERE_MAP_VISIBILITY";

var V526={
  routing:false,
  lastRouteTapAt:0
};

function v526ById(id){ return document.getElementById(id); }
function v526Finite(v){ return typeof v === "number" && isFinite(v); }
function v526Now(){ return Date.now ? Date.now() : (new Date()).getTime(); }
function v526Text(v){ return String(v || "").replace(/\s+/g," ").trim(); }
function v526Norm(v){
  return String(v || "").toLowerCase().replace(/[^a-z0-9]+/g," ").replace(/\s+/g," ").trim();
}

function v526Items(){
  try{ if(adventureResults && adventureResults.length){ return adventureResults; } }catch(e0){}
  try{ if(exploreResults && exploreResults.length){ return exploreResults; } }catch(e1){}
  try{ if(window.adventureResults && window.adventureResults.length){ return window.adventureResults; } }catch(e2){}
  return [];
}

function v526OpenItem(){
  var card=v526ById("diqAdventureInfoCard");
  var title=v526ById("diqAdvInfoTitle");
  var wanted=v526Norm(title ? title.textContent : "");
  var items=v526Items();
  var i;
  var item;

  try{
    if(adventurePreferred &&
       v526Finite(Number(adventurePreferred.lat)) &&
       v526Finite(Number(adventurePreferred.lng))){
      if(!wanted || v526Norm(adventurePreferred.label || adventurePreferred.name) === wanted){
        return adventurePreferred;
      }
    }
  }catch(e0){}

  try{
    if(card && card.__diqPlaceItem &&
       v526Finite(Number(card.__diqPlaceItem.lat)) &&
       v526Finite(Number(card.__diqPlaceItem.lng))){
      return card.__diqPlaceItem;
    }
  }catch(e1){}

  for(i=0;i<items.length;i++){
    item=items[i];
    if(!item){ continue; }
    if(wanted && v526Norm(item.label || item.name || item.title) === wanted){
      return item;
    }
  }

  try{
    if(destination &&
       v526Finite(Number(destination.lat)) &&
       v526Finite(Number(destination.lng))){
      return destination;
    }
  }catch(e2){}

  return null;
}

function v526DrivePayloadAndOpen(item){
  /*
   * V535 FIX â€” ONE ADVENTURE HANDOFF AUTHORITY
   * Legacy V526 must never open Drive Mode directly. Route Here now hands the
   * selected place to the V600 Adventure route authority, which persists the
   * destination and opens Start Drive through the proven Home-matched path.
   */
  if(
    item &&
    window.DriveIQAdventureRoute &&
    typeof window.DriveIQAdventureRoute.startRouteTo === "function"
  ){
    return window.DriveIQAdventureRoute.startRouteTo(item) === true;
  }

  try{ toast("Route handoff is not ready yet"); }catch(e0){}
  return false;
}

/*
 * Retained only as unreachable historical code marker.
 */
function v526DrivePayloadAndOpen_LEGACY_RETIRED(item){
  /*
   * V536 HARD RETIREMENT
   * This historical direct-to-Drive-Mode lane is intentionally inert.
   * It must never write drive state or change pages.
   */
  return false;
}

function v526Route(item){
  var url;

  /*
   * V535 FIX â€” BOOT CLICK-THROUGH SHIELD
   * The tap that opens Adventure from Home must not be reused by a legacy
   * Route Here listener during the first moment of the new page.
   */
  if(
    !window.__DIQ_ADVENTURE_PAGE_READY_AT_V535
  ){
    window.__DIQ_ADVENTURE_PAGE_READY_AT_V535 = Date.now();
  }

  if(
    Date.now() -
      Number(window.__DIQ_ADVENTURE_PAGE_READY_AT_V535 || 0) <
      1400
  ){
    return false;
  }

  if(V526.routing){ return false; }
  if(!item || !v526Finite(Number(item.lat)) || !v526Finite(Number(item.lng))){
    try{ toast("This place is missing route coordinates"); }catch(e0){}
    return false;
  }

  if(!lastFix || !v526Finite(Number(lastFix.lat)) || !v526Finite(Number(lastFix.lng))){
    try{
      waitingForGpsQuery=String(item.label || "adventure");
      requestGPS(true);
      toast("Locking GPS first â€” tap Route Here again when location is ready");
    }catch(e1){}
    return false;
  }

  V526.routing=true;
  try{ setStatus("adventureRouteStatus","BUILDING ROUTE","gold"); }catch(e2){}
  try{ toast("Building route to " + String(item.label || item.name || "place")); }catch(e3){}

  try{ url=routeUrlFor(item); }catch(e4){ url=""; }
  if(!url){
    V526.routing=false;
    try{ toast("Route could not be created"); }catch(e5){}
    return false;
  }

  fetch(url)
    .then(function(res){
      if(!res || !res.ok){ throw new Error("route_http"); }
      return res.json();
    })
    .then(function(data){
      var accepted=false;
      var routeItem=item;

      try{
        /* Preserve the exact selected identity. Do not substitute a category
           fallback or another result before accepting the route. */
        accepted=acceptRouteCandidate(routeItem,data,false) === true;
      }catch(e0){ accepted=false; }

      V526.routing=false;
      if(!accepted){
        try{ setStatus("adventureRouteStatus","ROUTE FAILED","red"); }catch(e1){}
        try{ toast("Route failed for this place"); }catch(e2){}
        return;
      }

      try{ recordAdventureHistory(item,"route"); }catch(e3){}
      v526DrivePayloadAndOpen(item);
    })
    .catch(function(){
      V526.routing=false;
      try{ setStatus("adventureRouteStatus","ROUTE FAILED","red"); }catch(e0){}
      try{ toast("Route failed â€” check your connection"); }catch(e1){}
    });

  return true;
}

function v526Shelf(){
  return v526ById("diqV519Shelf") || v526ById("diqAdventureDestResults");
}

function v526ReopenButton(){
  var btn=v526ById("diqV526PlacesReopen");
  if(btn){ return btn; }
  btn=document.createElement("button");
  btn.id="diqV526PlacesReopen";
  btn.type="button";
  btn.textContent="PLACES";
  btn.setAttribute("aria-label","Show scanned places");
  try{ document.body.appendChild(btn); }catch(e0){}
  return btn;
}

function v526MinimizeShelf(){
  var shelf=v526Shelf();
  var reopen=v526ReopenButton();
  if(shelf){
    shelf.classList.add("diqV526Hidden");
    shelf.classList.add("minimized");
    shelf.setAttribute("aria-hidden","true");
  }
  if(reopen){ reopen.className="on"; }
  try{ if(map && map.resize){ window.setTimeout(function(){ map.resize(); },80); } }catch(e0){}
}

function v526CloseShelf(){
  v526MinimizeShelf();
}

function v526RestoreShelf(){
  var shelf=v526Shelf();
  var reopen=v526ReopenButton();
  if(shelf){
    shelf.classList.remove("diqV526Hidden");
    shelf.classList.remove("minimized");
    shelf.classList.add("on");
    shelf.setAttribute("aria-hidden","false");
  }
  if(reopen){ reopen.className=""; }
}

function v526EnsureShelfButtons(){
  var shelf=v526Shelf();
  var head;
  var min;
  var close;

  if(!shelf){ return; }
  head=v526ById("diqV519ShelfHead") || shelf.querySelector(".diqDestHead");
  if(!head){ return; }

  min=v526ById("diqV526Minimize");
  if(!min){
    min=document.createElement("button");
    min.id="diqV526Minimize";
    min.type="button";
    min.innerHTML="&#8212;";
    min.setAttribute("aria-label","Minimize places and show map");
    head.appendChild(min);
  }

  close=v526ById("diqV526Close");
  if(!close){
    close=document.createElement("button");
    close.id="diqV526Close";
    close.type="button";
    close.innerHTML="&times;";
    close.setAttribute("aria-label","Close places and show map");
    head.appendChild(close);
  }
}

function v526InjectStyles(){
  var style;
  if(v526ById("diqV526Styles")){ return; }
  style=document.createElement("style");
  style.id="diqV526Styles";
  style.type="text/css";
  style.appendChild(document.createTextNode(
    "#diqV526Minimize,#diqV526Close{"+
      "position:absolute!important;top:8px!important;width:38px!important;height:38px!important;"+
      "padding:0!important;border-radius:13px!important;border:1px solid rgba(255,255,255,.17)!important;"+
      "background:rgba(2,10,18,.88)!important;color:#fff!important;font-size:23px!important;line-height:1!important;"+
      "z-index:25!important;pointer-events:auto!important;touch-action:manipulation!important;"+
    "}"+
    "#diqV526Minimize{right:54px!important;}"+
    "#diqV526Close{right:10px!important;font-size:27px!important;}"+
    "#diqV519ShelfHead,.diqDestHead{position:relative!important;padding-right:102px!important;}"+
    "#diqV519Shelf.diqV526Hidden,#diqAdventureDestResults.diqV526Hidden{"+
      "display:none!important;visibility:hidden!important;opacity:0!important;pointer-events:none!important;"+
    "}"+
    "#diqV526PlacesReopen{"+
      "display:none!important;position:fixed!important;left:50%!important;transform:translateX(-50%)!important;"+
      "bottom:calc(18px + env(safe-area-inset-bottom,0px))!important;z-index:65000!important;"+
      "min-width:116px!important;height:46px!important;padding:0 20px!important;border-radius:999px!important;"+
      "border:1px solid rgba(40,255,190,.55)!important;background:rgba(3,12,21,.96)!important;"+
      "box-shadow:0 12px 34px rgba(0,0,0,.48)!important;color:#caffef!important;"+
      "font-size:11px!important;font-weight:1000!important;letter-spacing:1.25px!important;"+
      "pointer-events:auto!important;touch-action:manipulation!important;"+
    "}"+
    "#diqV526PlacesReopen.on{display:block!important;}"+
    "#diqAdvInfoRoute{pointer-events:auto!important;touch-action:manipulation!important;position:relative!important;z-index:15!important;}"
  ));
  try{ (document.head || document.documentElement).appendChild(style); }catch(e0){}
}

function v526Capture(event){
  var target=event && event.target;
  var now;
  var item;
  if(!target){ return; }

  if(target.id === "diqV526Minimize" || target.id === "diqV519Min" || target.id === "diqV518Minimize"){
    if(event.preventDefault){ event.preventDefault(); }
    if(event.stopPropagation){ event.stopPropagation(); }
    if(event.stopImmediatePropagation){ event.stopImmediatePropagation(); }
    v526MinimizeShelf();
    return;
  }

  if(target.id === "diqV526Close" || target.id === "diqV519Close"){
    if(event.preventDefault){ event.preventDefault(); }
    if(event.stopPropagation){ event.stopPropagation(); }
    if(event.stopImmediatePropagation){ event.stopImmediatePropagation(); }
    v526CloseShelf();
    return;
  }

  if(target.id === "diqV526PlacesReopen" || target.id === "diqV519Reopen" || target.id === "diqV518Reopen"){
    if(event.preventDefault){ event.preventDefault(); }
    if(event.stopPropagation){ event.stopPropagation(); }
    if(event.stopImmediatePropagation){ event.stopImmediatePropagation(); }
    v526RestoreShelf();
    return;
  }

  if(target.id !== "diqAdvInfoRoute"){ return; }

  now=v526Now();
  if(now - V526.lastRouteTapAt < 700){
    if(event.preventDefault){ event.preventDefault(); }
    if(event.stopPropagation){ event.stopPropagation(); }
    if(event.stopImmediatePropagation){ event.stopImmediatePropagation(); }
    return;
  }
  V526.lastRouteTapAt=now;

  if(event.preventDefault){ event.preventDefault(); }
  if(event.stopPropagation){ event.stopPropagation(); }
  if(event.stopImmediatePropagation){ event.stopImmediatePropagation(); }

  item=v526OpenItem();
  if(!item){
    try{ toast("Please choose the place again"); }catch(e0){}
    return;
  }
  v526Route(item);
}

function v526Apply(){
  v526InjectStyles();
  v526EnsureShelfButtons();
  v526ReopenButton();

  /* Store the exact item on the Place IQ card whenever its legacy opener runs.
     This does not replace the opener; it only creates a stable Route Here
     identity fallback. */
  try{
    if(typeof openAdventureInfoCard === "function" && !openAdventureInfoCard.__diqV526Wrapped){
      (function(original){
        var wrapped=function(item,preserveBrowseCamera){
          var result=original.apply(this,arguments);
          var card=v526ById("diqAdventureInfoCard");
          if(card && item){ card.__diqPlaceItem=item; }
          return result;
        };
        wrapped.__diqV526Wrapped=true;
        openAdventureInfoCard=wrapped;
      }(openAdventureInfoCard));
    }
  }catch(e0){}
}

if(!document.__diqV526CaptureBound){
  document.__diqV526CaptureBound=true;
  document.addEventListener("click",v526Capture,true);
}

if(document.readyState === "loading"){
  document.addEventListener("DOMContentLoaded",v526Apply,false);
}else{
  v526Apply();
}

window.setTimeout(v526Apply,120);
window.setTimeout(v526Apply,600);
window.setTimeout(v526Apply,1600);

document.addEventListener("driveiq:adventureScanComplete",function(){
  window.setTimeout(v526Apply,40);
  window.setTimeout(v526Apply,260);
},false);

document.addEventListener("driveiq:adventureResultsShown",function(){
  window.setTimeout(v526Apply,40);
},false);

window.DriveIQAdventureV526={
  build:"V526_ROUTE_HERE_MAP_VISIBILITY",
  route:v526Route,
  minimize:v526MinimizeShelf,
  close:v526CloseShelf,
  restore:v526RestoreShelf,
  apply:v526Apply
};

try{ console.log("âœ… Drive IQ Adventure V526 Route Here + map visibility loaded"); }catch(ePublic){}

}());

/* =========================================================
   DRIVE IQ ADVENTURE MODE V527
   TRUE MAP-FIRST POST-SCAN AUTHORITY

   Product rule:
   Scan -> intelligent pins -> tap a pin -> Place IQ -> Route Here.

   This layer removes the dominant post-scan results shelf from the default
   experience while preserving scan, pins, Place IQ, Route Here, destination
   search, and the main SHOW MENU control.
   ES5 SAFE.
========================================================= */
(function(){
"use strict";

if(window.__DRIVE_IQ_ADVENTURE_V527_TRUE_MAP_FIRST__){ return; }
window.__DRIVE_IQ_ADVENTURE_V527_TRUE_MAP_FIRST__=true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD="V527_TRUE_MAP_FIRST";

function v527Id(id){ return document.getElementById(id); }
function v527Count(){
  var n=0;
  try{ if(adventureResults && adventureResults.length){ n=adventureResults.length; } }catch(e0){}
  try{ if(!n && exploreResults && exploreResults.length){ n=exploreResults.length; } }catch(e1){}
  try{ if(!n && window.adventureResults && window.adventureResults.length){ n=window.adventureResults.length; } }catch(e2){}
  try{
    if(!n){ n=document.querySelectorAll("#diqAdventureDestResults .diqDestItem,#diqV519Shelf .diqV519Card").length || 0; }
  }catch(e3){}
  return n;
}

function v527EnsurePill(){
  var pill=v527Id("diqV527MapResultsPill");
  if(pill){ return pill; }
  pill=document.createElement("div");
  pill.id="diqV527MapResultsPill";
  pill.setAttribute("aria-live","polite");
  pill.setAttribute("aria-hidden","true");
  pill.innerHTML='<span class="v527Dot"></span><span id="diqV527MapResultsText">PLACES FOUND</span>';
  try{ document.body.appendChild(pill); }catch(e0){}
  return pill;
}

function v527InfoOpen(){
  var card=v527Id("diqAdventureInfoCard");
  if(!card){ return false; }
  return (
    String(card.className || "").indexOf("on") > -1 ||
    card.getAttribute("aria-hidden") === "false"
  );
}

function v527HideResultsShelves(){
  var shelf=v527Id("diqV519Shelf");
  var legacy=v527Id("diqAdventureDestResults");
  var reopen=v527Id("diqV526PlacesReopen");
  var olderReopen=v527Id("diqV519Reopen") || v527Id("diqV518Reopen");

  if(shelf){
    shelf.classList.add("diqV527MapOnlyHidden");
    shelf.setAttribute("aria-hidden","true");
  }
  if(legacy){
    legacy.classList.add("diqV527MapOnlyHidden");
    legacy.setAttribute("aria-hidden","true");
  }
  if(reopen){ reopen.className=""; reopen.setAttribute("aria-hidden","true"); }
  if(olderReopen){ olderReopen.className=""; olderReopen.setAttribute("aria-hidden","true"); }

  try{ if(map && map.resize){ window.setTimeout(function(){ map.resize(); },60); } }catch(e0){}
}

function v527UpdatePill(){
  var pill=v527EnsurePill();
  var text=v527Id("diqV527MapResultsText");
  var active=false;
  var count=0;

  try{
    active=!!(
      document.body &&
      String(document.body.className || "").indexOf("adventureScanResultsMode") > -1
    );
  }catch(e0){ active=false; }

  if(!active || v527InfoOpen()){
    pill.className="";
    pill.setAttribute("aria-hidden","true");
    return;
  }

  count=v527Count();
  if(text){
    text.textContent=count > 0
      ? String(count) + (count === 1 ? " PLACE FOUND" : " PLACES FOUND")
      : "PLACES FOUND";
  }
  pill.className="on";
  pill.setAttribute("aria-hidden","false");
}

function v527Apply(){
  var active=false;
  try{
    active=!!(
      document.body &&
      String(document.body.className || "").indexOf("adventureScanResultsMode") > -1
    );
  }catch(e0){ active=false; }

  if(active){ v527HideResultsShelves(); }
  v527UpdatePill();
}

function v527InjectStyles(){
  var style;
  if(v527Id("diqV527Styles")){ return; }
  style=document.createElement("style");
  style.id="diqV527Styles";
  style.type="text/css";
  style.appendChild(document.createTextNode(
    "body.adventureScanResultsMode #diqAdventureDestResults,"+
    "body.adventureScanResultsMode #diqV519Shelf,"+
    "#diqAdventureDestResults.diqV527MapOnlyHidden,"+
    "#diqV519Shelf.diqV527MapOnlyHidden{"+
      "display:none!important;visibility:hidden!important;opacity:0!important;"+
      "pointer-events:none!important;transform:none!important;"+
    "}"+
    "body.adventureScanResultsMode #diqV526PlacesReopen,"+
    "body.adventureScanResultsMode #diqV519Reopen,"+
    "body.adventureScanResultsMode #diqV518Reopen{"+
      "display:none!important;visibility:hidden!important;pointer-events:none!important;"+
    "}"+
    "#diqV527MapResultsPill{"+
      "display:none!important;position:fixed!important;left:50%!important;"+
      "bottom:calc(18px + env(safe-area-inset-bottom,0px))!important;"+
      "transform:translateX(-50%)!important;z-index:31000!important;"+
      "min-height:38px!important;padding:0 15px!important;border-radius:999px!important;"+
      "align-items:center!important;gap:8px!important;white-space:nowrap!important;"+
      "background:rgba(2,10,18,.91)!important;border:1px solid rgba(40,255,190,.38)!important;"+
      "box-shadow:0 10px 28px rgba(0,0,0,.42)!important;backdrop-filter:blur(12px)!important;"+
      "-webkit-backdrop-filter:blur(12px)!important;color:#d9fff3!important;"+
      "font-size:10px!important;font-weight:1000!important;letter-spacing:1.15px!important;"+
      "pointer-events:none!important;"+
    "}"+
    "#diqV527MapResultsPill.on{display:flex!important;}"+
    "#diqV527MapResultsPill .v527Dot{"+
      "display:block!important;width:8px!important;height:8px!important;border-radius:50%!important;"+
      "background:#32ffc3!important;box-shadow:0 0 12px rgba(50,255,195,.72)!important;"+
    "}"
  ));
  try{ (document.head || document.documentElement).appendChild(style); }catch(e0){}
}

function v527Boot(){
  v527InjectStyles();
  v527EnsurePill();
  v527Apply();

  if(window.MutationObserver && document.body && !document.body.__diqV527Observed){
    document.body.__diqV527Observed=true;
    try{
      (new MutationObserver(function(){
        window.setTimeout(v527Apply,0);
      })).observe(document.body,{attributes:true,attributeFilter:["class"]});
    }catch(e0){}
  }

  var info=v527Id("diqAdventureInfoCard");
  if(window.MutationObserver && info && !info.__diqV527Observed){
    info.__diqV527Observed=true;
    try{
      (new MutationObserver(function(){
        window.setTimeout(v527UpdatePill,0);
      })).observe(info,{attributes:true,attributeFilter:["class","aria-hidden"]});
    }catch(e1){}
  }
}

if(document.readyState === "loading"){
  document.addEventListener("DOMContentLoaded",v527Boot,false);
}else{
  v527Boot();
}

window.setTimeout(v527Boot,120);
window.setTimeout(v527Apply,500);
window.setTimeout(v527Apply,1400);

document.addEventListener("driveiq:adventureScanComplete",function(){
  window.setTimeout(v527Apply,20);
  window.setTimeout(v527Apply,180);
  window.setTimeout(v527Apply,650);
},false);

document.addEventListener("driveiq:adventureResultsShown",function(){
  window.setTimeout(v527Apply,20);
},false);

window.DriveIQAdventureV527={
  build:"V527_TRUE_MAP_FIRST",
  apply:v527Apply,
  hideResults:v527HideResultsShelves,
  updatePill:v527UpdatePill
};

try{ console.log("âœ… Drive IQ Adventure V527 true map-first loaded"); }catch(ePublic){}

}());


/* =========================================================
   DRIVE IQ ADVENTURE MODE V531
   V600 TERMINAL AUTHORITY CLEANUP

   The legacy file remains responsible for the working map, destination
   search, provider logic, photos, routing, and Place IQ renderer.

   V600 modules exclusively own:
   - scanning/results visual state
   - results shelf and restore pill
   - pin/result selection handoff
   - focused Place IQ mode
========================================================= */
(function(window,document){
"use strict";

if(window.__DRIVE_IQ_ADVENTURE_V532_REOPEN_HERO_VISUAL_AUTHORITY__){return;}
window.__DRIVE_IQ_ADVENTURE_V532_REOPEN_HERO_VISUAL_AUTHORITY__=true;
window.DRIVE_IQ_ADVENTURE_MODE_BUILD="V532_REOPEN_HERO_VISUAL_AUTHORITY";

var STYLE_ID="diqV531V600AuthorityStyles";
var LEGACY_CONTROL_IDS=[
  "diqV528ResultsPill",
  "diqV527MapResultsPill",
  "diqV526PlacesReopen",
  "diqV519Reopen",
  "diqV518Reopen",
  "diqV525Minimize"
];

function id(value){return document.getElementById(value);}

function hideNode(node){
  if(!node){return;}
  try{
    node.className="";
    node.style.setProperty("display","none","important");
    node.style.setProperty("visibility","hidden","important");
    node.style.setProperty("opacity","0","important");
    node.style.setProperty("pointer-events","none","important");
    node.setAttribute("aria-hidden","true");
  }catch(error){}
}

function releaseLegacyScanBanner(){
  var tab=id("diqAdventureScanTab");

  try{
    if(typeof stopScanTab==="function"){
      stopScanTab();
    }
  }catch(error){}

  if(tab){
    try{
      tab.className="";
      tab.style.setProperty("display","none","important");
      tab.style.setProperty("visibility","hidden","important");
      tab.style.setProperty("pointer-events","none","important");
      tab.setAttribute("aria-hidden","true");
    }catch(error){}
  }
}

function releaseMapInteraction(){
  var container=id("adventureMap");
  var canvasContainer;
  var canvas;

  try{
    if(typeof map!=="undefined"&&map){
      if(map.dragPan){map.dragPan.enable();}
      if(map.scrollZoom){map.scrollZoom.enable();}
      if(map.touchZoomRotate){map.touchZoomRotate.enable();}
      if(map.doubleClickZoom){map.doubleClickZoom.enable();}
      container=map.getContainer?map.getContainer():container;
    }
  }catch(error){}

  if(!container){return;}

  try{
    container.style.setProperty("pointer-events","auto","important");
    container.style.setProperty("touch-action","none","important");
    canvasContainer=container.querySelector(".mapboxgl-canvas-container");
    canvas=container.querySelector(".mapboxgl-canvas");

    if(canvasContainer){
      canvasContainer.style.setProperty("pointer-events","auto","important");
      canvasContainer.style.setProperty("touch-action","none","important");
    }

    if(canvas){
      canvas.style.setProperty("pointer-events","auto","important");
      canvas.style.setProperty("touch-action","none","important");
    }
  }catch(error){}
}

function retireLegacyControls(){
  var index;

  for(index=0;index<LEGACY_CONTROL_IDS.length;index+=1){
    hideNode(id(LEGACY_CONTROL_IDS[index]));
  }
}

function updateRestoreControl(){
  var button=id("adventureMenuRestore");

  if(!button){return;}

  button.textContent="Show Places";
  button.setAttribute("aria-label","Show places found");

  if(button.__diqV531Bound){return;}

  button.onclick=function(event){
    if(event&&event.preventDefault){event.preventDefault();}
    if(event&&event.stopPropagation){event.stopPropagation();}

    try{
      if(window.DriveIQAdventureUI&&
         typeof window.DriveIQAdventureUI.reopenResultsShelf==="function"&&
         window.DriveIQAdventureUI.reopenResultsShelf()){
        return false;
      }
    }catch(error){}

    try{
      if(window.DriveIQAdventureScan&&
         typeof window.DriveIQAdventureScan.showResultShelf==="function"){
        window.DriveIQAdventureScan.showResultShelf();
      }
    }catch(error){}

    return false;
  };

  button.__diqV531Bound=true;
}

function injectStyles(){
  var style;

  if(id(STYLE_ID)){return;}

  style=document.createElement("style");
  style.id=STYLE_ID;
  style.type="text/css";
  style.textContent=[
    "#diqV528ResultsPill,#diqV527MapResultsPill,",
    "#diqV526PlacesReopen,#diqV519Reopen,#diqV518Reopen,#diqV525Minimize{",
      "display:none!important;visibility:hidden!important;opacity:0!important;pointer-events:none!important;",
    "}",
    "#adventureMenuRestore{",
      "bottom:calc(104px + env(safe-area-inset-bottom,0px))!important;",
      "z-index:17000!important;pointer-events:auto!important;touch-action:manipulation!important;",
    "}",
    "#diqAdventureScanTab:not(.on){",
      "display:none!important;visibility:hidden!important;pointer-events:none!important;",
    "}",
    "body.diq-v600-map #diqAdventureMenu,body.diq-v600-place #diqAdventureMenu,",
    "body.diq-v600-map #diqAdventureSearchResults,body.diq-v600-place #diqAdventureSearchResults{",
      "pointer-events:none!important;",
    "}",
    "body.diq-v600-map #adventureMap,body.diq-v600-place #adventureMap,",
    "body.diq-v600-map #adventureMap .mapboxgl-canvas-container,",
    "body.diq-v600-place #adventureMap .mapboxgl-canvas-container,",
    "body.diq-v600-map #adventureMap .mapboxgl-canvas,",
    "body.diq-v600-place #adventureMap .mapboxgl-canvas{",
      "pointer-events:auto!important;touch-action:none!important;",
    "}"
  ].join("");

  try{(document.head||document.documentElement).appendChild(style);}catch(error){}
}

function completed(){
  releaseLegacyScanBanner();
  retireLegacyControls();
  updateRestoreControl();
  releaseMapInteraction();

  window.setTimeout(function(){
    releaseLegacyScanBanner();
    retireLegacyControls();
    updateRestoreControl();
    releaseMapInteraction();
  },80);

  window.setTimeout(function(){
    releaseLegacyScanBanner();
    retireLegacyControls();
    updateRestoreControl();
    releaseMapInteraction();
  },320);
}

function bindV600Events(){
  var bus=window.DriveIQAdventureEvents;

  if(!bus||typeof bus.on!=="function"){return false;}
  if(bus.__diqV531AuthorityBound){return true;}

  bus.__diqV531AuthorityBound=true;

  bus.on("scan:started",function(){
    retireLegacyControls();
    updateRestoreControl();
  });

  bus.on("scan:completed",completed);
  bus.on("scan:failed",releaseLegacyScanBanner);
  bus.on("scan:cancelled",releaseLegacyScanBanner);
  bus.on("pin:selected",function(){
    try{
      if(window.DriveIQAdventureScan&&
         typeof window.DriveIQAdventureScan.hideResultShelf==="function"){
        window.DriveIQAdventureScan.hideResultShelf("pin-selected");
      }
    }catch(error){}
    releaseMapInteraction();
  });

  return true;
}

function boot(){
  injectStyles();
  retireLegacyControls();
  updateRestoreControl();
  releaseMapInteraction();
  bindV600Events();
}

document.addEventListener("driveiq:adventureScanComplete",completed,false);
document.addEventListener("driveiq:adventureResultsShown",completed,false);
window.addEventListener("driveiq:scan-complete",completed,false);
window.addEventListener("driveiq:adventure-results",completed,false);
window.addEventListener("pageshow",boot,false);

if(document.readyState==="loading"){
  document.addEventListener("DOMContentLoaded",boot,false);
}else{
  boot();
}

window.setTimeout(boot,100);
window.setTimeout(boot,500);
window.setTimeout(boot,1400);

window.DriveIQAdventureV531={
  build:"V532_REOPEN_HERO_VISUAL_AUTHORITY",
  apply:boot,
  completed:completed,
  releaseMapInteraction:releaseMapInteraction
};

try{console.log("âœ… Drive IQ Adventure V531 V600 authority cleanup loaded");}catch(error){}

}(window,document));
/* =========================================================
   DRIVE IQ ADVENTURE V533 â€” ARRIVAL HANDOFF CONSUMER AUTHORITY

   Receives the V210 Drive Mode arrival handoff before stale Adventure
   destination, market, camera, result, and pin state can regain authority.

   Rules:
   - Fresh handoff wins over every prior Adventure session.
   - Arrival/current GPS coordinate becomes the scan center immediately.
   - Old city searches such as Detroit are cleared before restore callbacks.
   - The arrival scan launches once after the map is ready.
   - The handoff is marked consumed and cannot replay.
   - ES5-safe. Append-only authority.
========================================================= */
(function(window,document){
  "use strict";

  if(window.__DRIVE_IQ_ADVENTURE_V533_ARRIVAL_HANDOFF__){ return; }
  window.__DRIVE_IQ_ADVENTURE_V533_ARRIVAL_HANDOFF__=true;

  var V533={
    version:"v533_arrival_handoff_consumer",
    payload:null,
    active:false,
    consumed:false,
    launched:false,
    launchAttempts:0,
    timer:null,
    handoffId:"",
    acceptedAt:0
  };

  function now(){
    return Date.now ? Date.now() : (new Date()).getTime();
  }

  function parse(value){
    try{ return JSON.parse(String(value || "")); }
    catch(error){ return null; }
  }

  function readStorage(key){
    var value=null;

    try{ value=window.sessionStorage.getItem(key); }catch(error0){}
    if(!value){
      try{ value=window.localStorage.getItem(key); }catch(error1){}
    }

    return parse(value);
  }

  function removeStorage(key){
    try{ window.sessionStorage.removeItem(key); }catch(error0){}
    try{ window.localStorage.removeItem(key); }catch(error1){}
  }

  function writeStorage(key,value){
    var encoded="";

    try{ encoded=JSON.stringify(value); }
    catch(error0){ return false; }

    try{ window.sessionStorage.setItem(key,encoded); }catch(error1){}
    try{ window.localStorage.setItem(key,encoded); }catch(error2){}

    return true;
  }

  function number(value){
    var parsed=Number(value);
    return isFinite(parsed) ? parsed : null;
  }

  function timestamp(value){
    var parsed=number(value);

    if(parsed !== null){ return parsed; }
    if(!value){ return null; }

    parsed=Date.parse(String(value));
    return isFinite(parsed) ? parsed : null;
  }

  function text(value){
    return String(value == null ? "" : value)
      .replace(/\s+/g," ")
      .trim();
  }

  function queryParams(){
    try{ return new URLSearchParams(window.location.search); }
    catch(error){ return null; }
  }

  function coordinateFrom(payload){
    var candidates=[
      payload && payload.currentLocation,
      payload && payload.arrivalCoordinate,
      payload && payload.center,
      payload && (
        payload.lat != null ||
        payload.latitude != null
      ) ? payload : null,
      payload && payload.placeIdentity,
      payload && payload.destination
    ];
    var params=queryParams();
    var i;
    var item;
    var lat;
    var lng;

    for(i=0;i<candidates.length;i++){
      item=candidates[i];

      if(!item){ continue; }

      lat=number(
        item.lat != null
          ? item.lat
          : item.latitude
      );
      lng=number(
        item.lng != null
          ? item.lng
          : item.longitude
      );

      if(
        lat !== null &&
        lng !== null &&
        Math.abs(lat) <= 90 &&
        Math.abs(lng) <= 180
      ){
        return {
          lat:lat,
          lng:lng,
          accuracyMeters:number(
            item.accuracyMeters != null
              ? item.accuracyMeters
              : item.accuracy
          ),
          capturedAt:number(
            item.capturedAt ||
            item.timestamp ||
            item.ts
          ) || now()
        };
      }
    }

    if(params){
      lat=number(params.get("lat"));
      lng=number(params.get("lng"));

      if(
        lat !== null &&
        lng !== null &&
        Math.abs(lat) <= 90 &&
        Math.abs(lng) <= 180
      ){
        return {
          lat:lat,
          lng:lng,
          capturedAt:now()
        };
      }
    }

    return null;
  }

  function readPayload(){
    var params=queryParams();
    var keys=[
      "diq_adventure_arrival_handoff_v2",
      "driveiq.adventure.arrivalHandoff",
      "diq_since_here_handoff_v1",
      "diq_adventure_arrival_handoff_v1"
    ];
    var payload=null;
    var handoffId=params ? text(params.get("handoff_id")) : "";
    var i;
    var candidate;
    var candidateCreatedAt;
    var payloadCreatedAt;

    try{
      if(
        window.DRIVE_IQ_ADVENTURE_ARRIVAL_HANDOFF &&
        typeof window.DRIVE_IQ_ADVENTURE_ARRIVAL_HANDOFF === "object"
      ){
        payload=window.DRIVE_IQ_ADVENTURE_ARRIVAL_HANDOFF;
      }
    }catch(error0){}

    if(!payload){
      for(i=0;i<keys.length;i++){
        candidate=readStorage(keys[i]);

        if(!candidate){ continue; }

        if(
          handoffId &&
          candidate.handoffId &&
          text(candidate.handoffId) !== handoffId
        ){
          continue;
        }

        /*
          Drive has shipped more than one arrival contract. Do not let an
          abandoned/stale value in an older slot hide the fresh V119 value.
        */
        candidateCreatedAt=timestamp(candidate.createdAt) || 0;
        payloadCreatedAt=timestamp(payload && payload.createdAt) || 0;

        if(
          !payload ||
          candidateCreatedAt >= payloadCreatedAt
        ){
          payload=candidate;
        }
      }
    }

    if(!payload && params && params.get("since_here")==="1"){
      payload={
        schema:"drive-iq-arrival-handoff-url-fallback",
        handoffId:handoffId || ("arrival-"+String(now())),
        source:"drive-mode-arrival-url",
        createdAt:number(params.get("_t")) || now(),
        expiresAt:now()+5*60*1000,
        consumed:false,
        forceCurrentContext:true,
        clearPreviousAdventureContext:true,
        scanMode:text(params.get("scan_mode")) || "around-arrival",
        scope:"near_me",
        autoScan:true,
        destinationName:text(params.get("place"))
      };
    }

    return payload;
  }

  function isFresh(payload){
    var params=queryParams();
    var createdAt;
    var expiresAt;
    var age;
    var urlArrival=!!(
      params &&
      params.get("since_here")==="1"
    );

    if(!payload){ return false; }
    if(payload.consumed === true){ return false; }

    createdAt=timestamp(payload.createdAt);
    expiresAt=timestamp(payload.expiresAt);

    if(expiresAt !== null && now() > expiresAt){
      return false;
    }

    if(createdAt !== null){
      age=now()-createdAt;

      if(age < -60000 || age > 10*60*1000){
        return false;
      }
    }

    return !!(
      payload.forceCurrentContext === true ||
      payload.scanMode === "around-arrival" ||
      payload.mode === "scan_around_me" ||
      payload.source === "drive-mode-v210-arrival" ||
      urlArrival
    );
  }

  function clearStaleAdventureState(){
    var keys=[
      "diq_adventure_destination_v1",
      "diq_adventure_search_v1",
      "diq_adventure_query_v1",
      "diq_adventure_market_v1",
      "diq_adventure_city_v1",
      "diq_adventure_camera_v1",
      "diq_adventure_map_center_v1",
      "diq_adventure_last_center_v1",
      "diq_adventure_last_scan_v1",
      "diq_adventure_results_v1",
      "diq_adventure_pins_v1",
      "diq_adventure_selected_place_v1",
      "diq_adventure_scan_state_v1",
      "diq_adventure_resume_state_v1",
      "driveiq.adventure.destination",
      "driveiq.adventure.search",
      "driveiq.adventure.market",
      "driveiq.adventure.camera",
      "driveiq.adventure.results",
      "driveiq.adventure.state"
    ];
    var i;

    for(i=0;i<keys.length;i++){
      removeStorage(keys[i]);
    }

    /*
      Stop the older V63 autorun reader from launching a second scan.
      V533 owns this specific arrival handoff.
    */
    removeStorage("diq_adventure_scan_autorun_v1");
    removeStorage("diq_adventure_auto_scan_v1");
    removeStorage("diq_adventure_scope_v1");
    removeStorage("diq_adventure_scan_query_v1");
    removeStorage("diq_adventure_since_here_v1");
    removeStorage("diq_adventure_force_current_context_v1");

    try{
      destination=null;
      committedAdventureDestination=null;
      committedAdventureDestinationReason="";
      destinationLock=null;
      destinationLockInputNorm="";
      destinationSearchResults=[];
      destinationResultOpen=false;
      routeGeo=null;
      adventureResults=[];
      adventurePreferred=null;
      exploreResults=[];
      adventureSearchCenter=null;
      adventureSearchScope="near_me";
      destinationPreviewScan=false;
      adventureScanOnly=true;
      adventureDestinationCameraHold=false;
      mapAreaScanActive=false;
      activeDropItem=null;
    }catch(error0){}

    try{
      if(typeof hideDestinationResults === "function"){
        hideDestinationResults();
      }
    }catch(error1){}

    try{
      if(typeof closeAdventureInfoCard === "function"){
        closeAdventureInfoCard();
      }
    }catch(error2){}

    try{
      if(typeof clearRouteLine === "function"){
        clearRouteLine();
      }
    }catch(error3){}

    try{
      if(typeof clearAdventurePins === "function"){
        clearAdventurePins();
      }
    }catch(error4){}

    try{
      var input=document.getElementById("adventureSearch");
      if(input){ input.value=""; }
    }catch(error5){}

    try{
      document.body.classList.remove(
        "adventureScanResultsMode"
      );
    }catch(error6){}
  }

  function applyCoordinate(payload){
    var point=coordinateFrom(payload);
    var place=payload && (
      payload.placeIdentity ||
      payload.destination
    ) || {};
    var label=text(
      payload && payload.destinationName ||
      place.name ||
      place.label ||
      "your arrival"
    );

    if(!point){ return false; }

    try{
      lastFix={
        lat:point.lat,
        lng:point.lng,
        accuracy:point.accuracyMeters,
        capturedAt:point.capturedAt,
        source:"drive-arrival-handoff"
      };

      adventureSearchCenter={
        lat:point.lat,
        lng:point.lng,
        label:label
      };

      adventureSearchScope="near_me";
      destinationPreviewScan=false;
      adventureScanOnly=true;
      adventureDestinationCameraHold=false;
      waitingForGpsQuery="";
    }catch(error0){}

    try{
      lsJSON(LS.LAST_FIX,lastFix);
    }catch(error1){}

    try{
      writeStorage(
        "diq_adventure_scan_center_v1",
        adventureSearchCenter
      );
    }catch(error2){}

    return point;
  }

  function markConsumed(payload){
    var consumed={};
    var key;

    for(key in payload){
      if(Object.prototype.hasOwnProperty.call(payload,key)){
        consumed[key]=payload[key];
      }
    }

    consumed.consumed=true;
    consumed.consumedAt=now();
    consumed.consumer="adventure-mode-v533";

    writeStorage(
      "diq_adventure_arrival_handoff_consumed_v1",
      consumed
    );

    removeStorage("diq_adventure_arrival_handoff_v2");
    removeStorage("driveiq.adventure.arrivalHandoff");
    removeStorage("diq_since_here_handoff_v1");
    removeStorage("diq_adventure_arrival_handoff_v1");
    removeStorage("diq_adventure_handoff_id_v1");

    try{
      window.DRIVE_IQ_ADVENTURE_ARRIVAL_HANDOFF=null;
    }catch(error0){}

    V533.consumed=true;
    return true;
  }

  function centerMap(point){
    if(!point){ return false; }

    try{
      if(typeof flyTo === "function"){
        flyTo(point.lng,point.lat,14.6);
        return true;
      }
    }catch(error0){}

    try{
      if(map && typeof map.easeTo === "function"){
        map.easeTo({
          center:[point.lng,point.lat],
          zoom:14.6,
          duration:450,
          essential:true
        });
        return true;
      }
    }catch(error1){}

    return false;
  }

  function launch(){
    var payload=V533.payload;
    var point;

    if(!V533.active || V533.launched){ return false; }
    if(!mapLoaded){ return false; }

    V533.launched=true;
    point=applyCoordinate(payload);
    centerMap(point);

    try{
      if(typeof setStatus === "function"){
        setStatus(
          "adventureGpsStatus",
          "ARRIVAL LOCATION",
          "green"
        );
        setStatus(
          "adventureRouteStatus",
          "SCANNING HERE",
          "green"
        );
      }
    }catch(error0){}

    try{
      if(typeof toast === "function"){
        toast(
          "Scanning around "+
          text(
            payload.destinationName ||
            payload.placeIdentity &&
            payload.placeIdentity.name ||
            "your arrival"
          )
        );
      }
    }catch(error1){}

    var scanPayload={
      source:"drive-arrival-v533",
      intent:"arrival_discovery",
      scope:"near_me",
      query:"popular local favorites",
      category:"local_favorites",
      autoRun:true,
      forceCurrentContext:true,
      handoffId:text(payload.handoffId),
      lat:point ? point.lat : null,
      lng:point ? point.lng : null,
      destinationLabel:text(
        payload.destinationName ||
        payload.placeIdentity &&
        payload.placeIdentity.name ||
        "Arrival"
      )
    };

    try{
      if(typeof diqPublicScanRunCurrentCenter === "function"){
        diqPublicScanRunCurrentCenter(scanPayload);
      }else if(typeof scanAdventureChoices === "function"){
        startScanTab(
          "SCANNING",
          "Finding what is worth exploring here..."
        );
        scanAdventureChoices(
          "popular local favorites"
        );
      }else{
        V533.launched=false;
        return false;
      }
    }catch(error2){
      V533.launched=false;
      try{
        console.error(
          "Drive IQ V533 arrival scan failed",
          error2
        );
      }catch(error3){}
      return false;
    }

    markConsumed(payload);

    try{
      window.dispatchEvent(
        new CustomEvent(
          "driveiq:arrival-handoff-consumed",
          {
            detail:{
              handoffId:text(payload.handoffId),
              center:point,
              destinationName:text(
                payload.destinationName || ""
              )
            }
          }
        )
      );
    }catch(error4){}

    return true;
  }

  function schedule(){
    if(V533.timer){
      window.clearInterval(V533.timer);
    }

    V533.timer=window.setInterval(function(){
      V533.launchAttempts+=1;

      if(launch()){
        window.clearInterval(V533.timer);
        V533.timer=null;
        return;
      }

      if(V533.launchAttempts>=120){
        window.clearInterval(V533.timer);
        V533.timer=null;

        try{
          console.warn(
            "Drive IQ V533 arrival handoff timed out waiting for map"
          );
        }catch(error0){}
      }
    },100);
  }

  function bootstrap(){
    var payload=readPayload();
    var point;

    if(!isFresh(payload)){ return false; }

    V533.payload=payload;
    V533.active=true;
    V533.handoffId=text(
      payload.handoffId ||
      "arrival-"+String(now())
    );
    V533.acceptedAt=now();

    clearStaleAdventureState();
    point=applyCoordinate(payload);

    /*
      This is intentionally done during script evaluation, before the normal
      DOMContentLoaded restore callbacks can read an old city or camera.
    */
    centerMap(point);
    schedule();

    try{
      window.DRIVE_IQ_ADVENTURE_MODE_BUILD=
        "V533_ARRIVAL_HANDOFF_CONSUMER_AUTHORITY";
      console.log(
        "âœ… Drive IQ V533 Arrival Handoff Consumer accepted",
        {
          handoffId:V533.handoffId,
          center:point,
          destinationName:text(
            payload.destinationName || ""
          )
        }
      );
    }catch(error0){}

    return true;
  }

  bootstrap();

  window.DriveIQAdventureArrivalHandoff={
    version:V533.version,
    state:function(){
      return {
        version:V533.version,
        active:V533.active,
        consumed:V533.consumed,
        launched:V533.launched,
        handoffId:V533.handoffId,
        acceptedAt:V533.acceptedAt,
        launchAttempts:V533.launchAttempts
      };
    },
    consume:bootstrap,
    launch:launch
  };

})(window,document);